/* tslint:disable */
/* eslint-disable */
//  This file was automatically generated and should not be edited.

export type CreateClientAccountInput = {
  companyName: string,
  vat?: string | null,
  businessNumber?: string | null,
  address?: CreateClientAddressInput | null,
  firstName?: string | null,
  lastName?: string | null,
  email?: string | null,
  phoneNumber?: string | null,
  provider?: string | null,
  language?: string | null,
  ipiNumber?: string | null,
  judicialDistrict?: string | null,
  GDPRAcceptedVersion: string,
  generalConditionsAcceptedVersion: string,
  accountType: AccountType,
};

export type CreateClientAddressInput = {
  street?: string | null,
  number?: string | null,
  box?: string | null,
  postalCode?: string | null,
  city?: string | null,
  country?: string | null,
};

export enum AccountType {
  OWNER = "OWNER",
  AGENCY = "AGENCY",
  FUND = "FUND",
}

export type MutationStatusDTO = {
  __typename: "MutationStatus",
  status?: boolean | null,
  id: string,
};

export type InviteUserToClientAccountInput = {
  email: string,
  teamId: string,
  roleId: string,
  accountType?: AccountType | null,
  hash: string,
  language?: string | null,
  clientId: string,
};

export type InviteContactToClientAccountInput = {
  email: string,
  invitationType: InviteContactToClientAccountType,
  contactId: string,
  accountType?: AccountType | null,
  hash: string,
  language?: string | null,
  clientId: string,
};

export enum InviteContactToClientAccountType {
  SIGN_LEASE = "SIGN_LEASE",
  SIGN_DOCUMENT = "SIGN_DOCUMENT",
  INVITE_TENANT = "INVITE_TENANT",
  INVITE_OWNER = "INVITE_OWNER",
}

export type IsEmailAlreadyTakenInput = {
  email: string,
};

export type StatusResult = {
  __typename: "StatusResult",
  success: boolean,
  message?: string | null,
};

export type RevokePontoIntegrationInput = {
  userId: string,
  clientId: string,
};

export type VerifyPontoIntegrationInput = {
  authorizationCode: string,
  codeVerifier: string,
  clientId: string,
};

export type ProcessOcrInput = {
  chargeId: string,
  userId: string,
  clientId: string,
};

export type AdvertisementPublishingInput = {
  platforms?: Array< AdvertisementPublishingPlatform > | null,
  unitId: string,
};

export type AdvertisementPublishingPlatform = {
  name: PublishingPlatform,
  params: AdvertisementPublishingPlatformParams,
};

export enum PublishingPlatform {
  LOGIC_IMMO = "LOGIC_IMMO",
}

export type AdvertisementPublishingPlatformParams = {
  action: AdvertisementPublishingPlatformActions,
  durationInMonths?: number | null,
};

export enum AdvertisementPublishingPlatformActions {
  PUBLISH = "PUBLISH",
  DELETE = "DELETE",
  UPDATE = "UPDATE",
}

export type AdvertisementPostingMutationStatusDTO = {
  __typename: "AdvertisementPostingMutationStatus",
  id: string,
  statusList?:  Array<AdvertisementPostingStatus > | null,
  errorMessage?: string | null,
};

export type AdvertisementPostingStatus = {
  __typename: "AdvertisementPostingStatus",
  publishingPlatform: PublishingPlatform,
  status: boolean,
  successCode: number,
};

export type GenerateReportInput = {
  type: GenerateReportType,
  outputFormat: GenerateReportOutputFormat,
  outputResults: Array< GenerateReportOutputResult >,
  periodFrom?: string | null,
  periodTo?: string | null,
  ownersDetailsFilters?: Array< OwnersDetailsFiltersInput > | null,
  feesOwnerIdsFilters?: Array< string > | null,
  supplierDebtsContractorIdsFilters?: Array< string > | null,
  operationalPerformanceOptions?: OperationalPerformanceReportOptionsInput | null,
  chargesOptions?: ChargesReportOptionsInput | null,
  language: string,
  userId: string,
  clientId: string,
};

export enum GenerateReportType {
  OPERATIONAL_PERFORMANCE = "OPERATIONAL_PERFORMANCE",
  CHARGES = "CHARGES",
  TURNOVER = "TURNOVER",
  FEES = "FEES",
  TENANTS_AGING_BALANCE = "TENANTS_AGING_BALANCE",
  SUPPLIER_DEBTS = "SUPPLIER_DEBTS",
}

export enum GenerateReportOutputFormat {
  PDF = "PDF",
  CSV = "CSV",
}

export enum GenerateReportOutputResult {
  CUSTOM_SUBSCRIPTION = "CUSTOM_SUBSCRIPTION",
  EMAIL = "EMAIL",
}

export type OwnersDetailsFiltersInput = {
  ownerId: string,
  buildingIds?: Array< string | null > | null,
  unitIds?: Array< string | null > | null,
  leaseIds?: Array< string | null > | null,
};

export type OperationalPerformanceReportOptionsInput = {
  comparisonPeriodFrom?: string | null,
  comparisonPeriodTo?: string | null,
  amountVatExcluded?: boolean | null,
};

export type ChargesReportOptionsInput = {
  tenantRepartitionColumn?: boolean | null,
  ownerRepartitionColumn?: boolean | null,
  totalColumn?: boolean | null,
};

export type GenerateReportResult = {
  __typename: "GenerateReportResult",
  errorCode?: GenerateReportErrorCode | null,
  status: boolean,
};

export enum GenerateReportErrorCode {
  WRONG_PARAMS = "WRONG_PARAMS",
  WRONG_FORMAT = "WRONG_FORMAT",
  UNAUTHORIZED = "UNAUTHORIZED",
  GENERATION_ERROR = "GENERATION_ERROR",
}

export type CreatePeppolDocumentInput = {
  peppolInvoiceData: string,
  s3Target: string,
};

export type CreatePeppolDocumentResponseDTO = {
  __typename: "CreatePeppolDocumentResponse",
  size: number,
  status: string,
};

export type ResendInvoiceToPeppolInput = {
  invoiceId: string,
};

export type SendInvoiceToPeppolInput = {
  invoiceId: string,
  type?: string | null,
};

export type VerifyPeppolContactInput = {
  contactId: string,
};

export type VerifyPeppolContactResponseDTO = {
  __typename: "VerifyPeppolContactResponse",
  contactId: string,
  isContactVerified: boolean,
};

export type BatchChangeCommunicationsInput = {
  communications: Array< BatchChangeIdVersion >,
  action: BatchChangeCommunicationsAction,
  userId: string,
  clientId: string,
};

export type BatchChangeIdVersion = {
  id: string,
  _version: number,
};

export type DecideLeasePriceHistoriesInput = {
  clientId: string,
  comment?: string | null,
  decision: LeasePriceHistoryDecision,
  leasePriceHistories: Array< BatchChangeIdVersion >,
};

export enum LeasePriceHistoryDecision {
  ACCEPT = "ACCEPT",
  REFUSE = "REFUSE",
}

export enum DecideLeasePriceHistoryFailureReason {
  ERROR = "ERROR",
  LEASE_NOT_ACTIVE = "LEASE_NOT_ACTIVE",
  NOT_DRAFT = "NOT_DRAFT",
  NOT_FOUND = "NOT_FOUND",
  VERSION_CONFLICT = "VERSION_CONFLICT",
}

export type DecideLeasePriceHistoryFailure = {
  __typename: "DecideLeasePriceHistoryFailure",
  id: string,
  reason: DecideLeasePriceHistoryFailureReason,
};

export type DecideLeasePriceHistoriesResult = {
  __typename: "DecideLeasePriceHistoriesResult",
  failed: Array< DecideLeasePriceHistoryFailure >,
  succeededIds: Array< string >,
};

export enum BatchChangeCommunicationsAction {
  SEND = "SEND",
  RESEND = "RESEND",
  DELETE = "DELETE",
}

export type DownloadCommunicationsInput = {
  clientId: string,
  communicationIds: Array< string >,
  language: Language,
  userId: string,
};

export enum Language {
  FR = "FR",
  NL = "NL",
  EN = "EN",
  DE = "DE",
}

export type DownloadCommunicationsResult = {
  __typename: "DownloadCommunicationsResult",
  key?: string | null,
  success: boolean,
  zipUrl?: string | null,
};

export type SubmitCommunicationDialogInput = {
  clientId: string,
  communication: SubmitCommunicationDialogCommunicationInput,
  recipientGroups: Array< CommunicationRecipientGroupInput >,
  newAttachments?: Array< CommunicationNewAttachmentInput > | null,
  existingAttachmentFileIds?: Array< string > | null,
  linkedAttachmentFileIds?: Array< string > | null,
  draft?: BatchChangeIdVersion | null,
  draftProperties?: CommunicationDraftPropertiesInput | null,
  preserveDocumentLinkage?: boolean | null,
};

export type SubmitCommunicationDialogCommunicationInput = {
  body: string,
  subject: string,
  channel: CommunicationChannel,
  type: CommunicationType,
  status: CommunicationStatus,
  toSend: boolean,
  scheduledAt?: string | null,
  sentAt?: string | null,
  recipientInCc?: string | null,
  recipientInBcc?: string | null,
  recipientContactIdsInCc?: Array< string > | null,
  recipientContactIdsInBcc?: Array< string > | null,
  communicationTemplateId?: string | null,
};

export type CommunicationRecipientGroupInput = {
  leaseId?: string | null,
  unitId?: string | null,
  buildingId?: string | null,
  contactIds: Array< string >,
  concernedContactIds?: Array< string > | null,
};

export type CommunicationNewAttachmentInput = {
  fileKey: string,
  name: string,
  size: number,
  mimeType?: string | null,
};

export type SubmitCommunicationDialogResult = {
  __typename: "SubmitCommunicationDialogResult",
  communicationIds: Array< string >,
  createdCount: number,
  success: boolean,
};

export type ConvertHeicToJpegInput = {
  s3FileKey: string,
};

export type ConvertHeicToJpegResult = {
  __typename: "ConvertHeicToJpegResult",
  fileUrl: string,
  fileKey: string,
};

export type TranslateTextInput = {
  text: string,
  sourceLanguage: string,
  destinationLanguage: string,
  tagHandling?: TranslateTagHandling | null,
};

export type TranslateTextResult = {
  __typename: "TranslateTextResult",
  success: boolean,
  result?: string | null,
};

export enum TranslateTagHandling {
  HTML = "HTML",
  XML = "XML",
}


export type GenerateDocumentInput = {
  id: string,
  type: DocumentType,
};

export enum DocumentType {
  Invoice = "Invoice",
  Lease = "Lease",
  StatementDetail = "StatementDetail",
  StatementReceipt = "StatementReceipt",
  LeasePriceHistoryIndexationAccepted = "LeasePriceHistoryIndexationAccepted",
  LeaseTerminationFromLessor = "LeaseTerminationFromLessor",
  Receipt = "Receipt",
  Letter = "Letter",
  LeaseConsolidatedPaymentRequest = "LeaseConsolidatedPaymentRequest",
  LeasePaymentRequest = "LeasePaymentRequest",
  LeaseFirstReminder = "LeaseFirstReminder",
  LeaseSecondReminder = "LeaseSecondReminder",
  LeaseThirdReminder = "LeaseThirdReminder",
  LeaseFormalNotice = "LeaseFormalNotice",
}

export type RejectDocumentInput = {
  id: string,
  type: DocumentType,
  contactId: string,
  rejectReason?: string | null,
};

export type RemindSignatureDocumentInput = {
  clientId: string,
  contactIds?: Array< string > | null,
  signatureDocumentId: string,
};

export type SignatureFilesInput = {
  fileIds: Array< string >,
};

export type DownloadFoldersInput = {
  selectedFolders: Array< SelectedFoldersParamsInput >,
  clientId: string,
  userId: string,
  language: string,
  onPage: boolean,
  entityId?: string | null,
  entityType?: string | null,
  isSearching?: boolean | null,
  isOnlyDownloadingInvoices?: boolean | null,
  createCsv?: boolean | null,
  csvToCreates?: Array< CsvTableType > | null,
};

export type SelectedFoldersParamsInput = {
  translatedName: string,
  folderDepth: string,
};

export enum CsvTableType {
  Communications = "Communications",
  Contacts = "Contacts",
  Issues = "Issues",
  PropertyFinancial = "PropertyFinancial",
  Technics = "Technics",
  Transactions = "Transactions",
  Units = "Units",
  LeasePriceHistories = "LeasePriceHistories",
  LeaseVariousOperations = "LeaseVariousOperations",
  Leases = "Leases",
  Charges = "Charges",
  Invoices = "Invoices",
  Documents = "Documents",
  Buildings = "Buildings",
}

export type ChangeProfessionalActivityForLeaseInput = {
  leaseId: string,
  unitIds: Array< string >,
  userId: string,
  clientId: string,
};

export type RecordEarlyDepartureInput = {
  leaseId: string,
  departureDate: string,
  comment?: string | null,
};

export type VerifyPendingSendingSourceInput = {
  id: string,
  userId: string,
  clientId: string,
};

export type RecalculateStatementInput = {
  statementId: string,
  userId: string,
  clientId: string,
};

export type DeleteEntityByIdInput = {
  entityId: string,
  entity: DeepDeletableEntityType,
};

export enum DeepDeletableEntityType {
  BUILDING = "BUILDING",
  COMMUNICATION = "COMMUNICATION",
  CONTACT = "CONTACT",
  LEASE = "LEASE",
  TECHNIC_LIBRARY = "TECHNIC_LIBRARY",
  TRANSACTION = "TRANSACTION",
  UNIT = "UNIT",
}

export type ArchiveEntityInput = {
  entity: ArchivableEntityType,
  entityId: string,
};

export enum ArchivableEntityType {
  UNIT = "UNIT",
}

export type UserRightsChangeInput = {
  userId: string,
  event: UserRightChangeEvent,
  clientId: string,
  leaseId?: string | null,
  unitId?: string | null,
  buildingId?: string | null,
};

export enum UserRightChangeEvent {
  DELETE_TENANT_LEASE_ACCESS = "DELETE_TENANT_LEASE_ACCESS",
  DELETE_OWNER_UNIT_ACCESS = "DELETE_OWNER_UNIT_ACCESS",
  DELETE_OWNER_BUILDING_ACCESS = "DELETE_OWNER_BUILDING_ACCESS",
}

export type MutationUserInput = {
  id: string,
  firstName?: string | null,
  lastName?: string | null,
  email?: string | null,
  language?: string | null,
  updatedBy?: MutationUserInputUpdatedBy | null,
};

export enum MutationUserInputUpdatedBy {
  OWNER = "OWNER",
}

export type CreateCompanyInvoiceInput = {
  issuerContactId: string,
  customerContactId: string,
  bankAccountId: string,
  invoiceDate: string,
  dueDate: string,
  billingItems: Array< CompanyInvoiceBillingItemInput >,
  note?: string | null,
  invoiceNumber?: string | null,
  purchaseOrderNumber?: string | null,
  creditNote?: boolean | null,
  reversedInvoiceId?: string | null,
  readId: string,
  validate?: boolean | null,
};

export type CompanyInvoiceBillingItemInput = {
  id?: string | null,
  label: string,
  amount: number,
  vatRate?: number | null,
  vatRateId?: string | null,
  billingType?: InvoiceBillingType | null,
  amountCalculationType?: InvoiceAmountCalculationType | null,
  quantity?: number | null,
  percentage?: number | null,
  percentageBase?: InvoicePercentageBase | null,
  period?: LeasePaymentFrequency | null,
  allocationOption?: BillingItemAllocationOption | null,
  leaseIds?: Array< string | null > | null,
  unitIds?: Array< string | null > | null,
  buildingIds?: Array< string | null > | null,
  accountLabelId?: string | null,
};

export enum InvoiceBillingType {
  MANAGEMENT_FEES = "MANAGEMENT_FEES",
  LETTING_FEE = "LETTING_FEE",
  RENT_GUARANTEE_INSURANCE = "RENT_GUARANTEE_INSURANCE",
  SERVICE_CLEANING = "SERVICE_CLEANING",
  SALES_COMMISSION = "SALES_COMMISSION",
  CUSTOM_LINE = "CUSTOM_LINE",
}

export enum InvoiceAmountCalculationType {
  PERCENTAGE_OF_BASE = "PERCENTAGE_OF_BASE",
  FIXED_AMOUNT = "FIXED_AMOUNT",
  NUMBER_OF_RENTS = "NUMBER_OF_RENTS",
  PERCENTAGE_OF_TRANSACTION = "PERCENTAGE_OF_TRANSACTION",
}

export enum InvoicePercentageBase {
  BASE_RENT = "BASE_RENT",
  INDEXED_RENT = "INDEXED_RENT",
  INCLUDE_CHARGES = "INCLUDE_CHARGES",
}

export enum LeasePaymentFrequency {
  MONTHLY = "MONTHLY",
  BI_MONTHLY = "BI_MONTHLY",
  QUARTERLY = "QUARTERLY",
  BI_ANNUAL = "BI_ANNUAL",
  YEARLY = "YEARLY",
}

export enum BillingItemAllocationOption {
  NONE = "NONE",
  OWNER_ONLY = "OWNER_ONLY",
  ONE_RENTAL_UNIT = "ONE_RENTAL_UNIT",
  MULTIPLE_UNITS = "MULTIPLE_UNITS",
}

export type UpdateCompanyInvoiceInput = {
  invoiceId: string,
  issuerContactId: string,
  customerContactId: string,
  bankAccountId: string,
  invoiceDate: string,
  dueDate: string,
  billingItems: Array< CompanyInvoiceBillingItemInput >,
  note?: string | null,
  invoiceNumber?: string | null,
  purchaseOrderNumber?: string | null,
  readId: string,
};

export type DuplicateCompanyInvoiceInput = {
  invoiceId: string,
};

export type ReverseCompanyInvoiceInput = {
  invoiceId: string,
  readId: string,
  clientId: string,
};

export enum CompanyInvoiceSendMethod {
  EMAIL = "EMAIL",
  PEPPOL = "PEPPOL",
}


export enum InvoiceDeliveryChannel {
  EMAIL = "EMAIL",
  LETTER = "LETTER",
  REGISTERED_LETTER = "REGISTERED_LETTER",
  PEPPOL = "PEPPOL",
}


export type ValidateInvoiceInput = {
  invoiceId: string,
  invoiceNumber?: string | null,
  renumber?: boolean | null,
};

export type ResetInvoiceToDraftInput = {
  invoiceId: string,
  reason?: string | null,
};

export type SendInvoiceInput = {
  invoiceId: string,
  note?: string | null,
  sendMethods?: Array< CompanyInvoiceSendMethod > | null,
};

export type UpdateLeaseBillingItemInput = {
  line: UpdateLeaseVariousOperationInput,
  appliesFrom?: string | null,
  invoiceChoice: LeaseBillingItemCorrectionChoice,
  creditNoteChoice: LeaseBillingItemCorrectionChoice,
  expectedInvoiceAmount: number,
  expectedCreditAmount: number,
};

export type UpdateLeaseBillingItemResultDTO = {
  __typename: "UpdateLeaseBillingItemResult",
  id: string,
  status: UpdateLeaseBillingItemStatus,
  invoiceId?: string | null,
  creditNoteId?: string | null,
};

export type DeleteDraftInvoiceInput = {
  invoiceId: string,
};


export type ChangeTransactionLinksInput = {
  clientContactId: string,
  clientId?: string | null,
  decisionId?: string | null,
  decisionTrigger?: ReconciliationDecisionTrigger | null,
  exclusionComment?: string | null,
  exclusionReason?: TransactionExclusionReason | null,
  expectedVersion?: number | null,
  newStatus?: TransactionStatus | null,
  newTransactionLinks: string,
  rememberExclusion?: boolean | null,
  transactionId: string,
};

export type TransactionsUpdatedStatusDTO = {
  __typename: "TransactionsUpdatedStatus",
  id: string,
  status?: boolean | null,
  transactionIdsUpdated?: Array< string > | null,
};

export type ReconcileTransactionWithTransactionInput = {
  clientContactId: string,
  decisionId?: string | null,
  decisionTrigger?: ReconciliationDecisionTrigger | null,
  invoiceSenderId: string,
  leaseId: string,
  negativeTransaction: string,
  positiveTransaction: string,
};

export type ReconcileTransactionWithInvoicesInput = {
  amountToPutInPendingBalance?: number | null,
  clientContactId: string,
  decisionId?: string | null,
  decisionTrigger?: ReconciliationDecisionTrigger | null,
  invoicesToReconcile: Array< string >,
  postingsSelected: Array< string | null >,
  transactionSelected: string,
  clientId?: string | null,
};

export type ReconcileInvoicesWithCreditNotesInput = {
  bankAccountId: string,
  clientContactId: string,
  invoicesToReconcile: Array< string >,
  leaseId: string,
  postingsSelected: string,
};

export type ReconcilePendingBalanceWithInvoicesInput = {
  allTransactionsOfLease: string,
  clientContactId: string,
  decisionId?: string | null,
  decisionTrigger?: ReconciliationDecisionTrigger | null,
  invoicesToReconcile: Array< string >,
  leaseId: string,
  postingsSelected: string,
};

export type UnreconcileTransactionOrInvoicesInput = {
  decisionId?: string | null,
  decisionTrigger?: ReconciliationDecisionTrigger | null,
  leaseId?: string | null,
  originalTransactions: string,
  transaction: string,
  transactionInvoices?: string | null,
};

export type ReverseTransactionInput = {
  decisionId?: string | null,
  decisionTrigger?: ReconciliationDecisionTrigger | null,
  transactionId: string,
};

export type SnoozeTransactionInput = {
  decisionId?: string | null,
  decisionTrigger?: ReconciliationDecisionTrigger | null,
  snoozedUntil?: string | null,
  transactionId: string,
};

export type WriteOffPendingBalanceInput = {
  clientContactId: string,
  leaseId: string,
};

export type OpenInvoiceDisputeInput = {
  comment?: string | null,
  decisionId: string,
  disputedOn?: string | null,
  invoiceId: string,
  lines?: Array< InvoiceDisputeLineInput > | null,
  reason: string,
};

export type InvoiceDisputeLineInput = {
  label?: string | null,
  postingId: string,
};

export type LiftInvoiceDisputeInput = {
  decisionId: string,
  disputeIds?: Array< string > | null,
  invoiceId: string,
};

export type EditPrivateAccountTransactionAmountInput = {
  amount: number,
  invoiceId: string,
  transactionId: string,
};

export type CreatePaymentProviderAccountInput = {
  contactId: string,
  returnUrl?: string | null,
};

export type CreatePaymentProviderAccountResult = {
  __typename: "CreatePaymentProviderAccountResult",
  url?: string | null,
};

export type CreateMandateLinkInput = {
  clientId: string,
  leaseId?: string | null,
};

export type CreatePaymentLinkInput = {
  clientId: string,
  invoiceId: string,
};

export type ChargeInvoiceByMandateInput = {
  clientId: string,
  invoiceId: string,
};

export type AutoReconcilePaymentProviderPayoutInput = {
  clientId: string,
  decisionId?: string | null,
  transactionId: string,
  payoutId: string,
};

export type CreateU2REntitiesFromExactOnlineInput = {
  division: string,
  entity: string,
  exactOnlineIds: string,
  integrationId: string,
  ownerId: string,
};

export type GetExactOnlineClientIdInput = {
  placeholder?: string | null,
};

export type GetExactOnlineEntitiesInput = {
  accountId?: string | null,
  avoidCalculateMinDate?: boolean | null,
  division?: string | null,
  divisions?: string | null,
  entity: string,
  integrationId: string,
  maxDate?: string | null,
  minDate?: string | null,
};

export type SynchronizeExactOnlineInput = {
  entityToSynchronize?: string | null,
  integrationId: string,
};

export type SaveExactOnlineEntitiesMatchingInput = {
  entity: string,
  integrationId: string,
  matching: string,
};

export type VerifyExactOnlineIntegrationInput = {
  code: string,
  integrationId: string,
};

export type CreateAccountLabelInput = {
  id?: string | null,
  labels?: Array< CustomLabelInput > | null,
  bankAccountId?: string | null,
  contactId?: string | null,
  class: number,
  customUsage?: AccountLabelCustomUsage | null,
  customValues?: Array< CustomValueInput > | null,
  disabled?: boolean | null,
  hoaFundId?: string | null,
  ownerId?: string | null,
  topClass: number,
  vatNonDeductiblePercentage?: number | null,
  readId: string,
  clientId: string,
  _version?: number | null,
};

export type CustomLabelInput = {
  language: string,
  label: string,
};

export enum AccountLabelCustomUsage {
  INDEXATION_REGULARIZATION = "INDEXATION_REGULARIZATION",
  OWNER_REQUEST_FOR_FUNDS = "OWNER_REQUEST_FOR_FUNDS",
}

export type CustomValueInput = {
  name: string,
  value: string,
};

export type ModelAccountLabelConditionInput = {
  bankAccountId?: ModelIDInput | null,
  contactId?: ModelIDInput | null,
  class?: ModelIntInput | null,
  customUsage?: ModelAccountLabelCustomUsageInput | null,
  disabled?: ModelBooleanInput | null,
  hoaFundId?: ModelIDInput | null,
  ownerId?: ModelIDInput | null,
  topClass?: ModelIntInput | null,
  readId?: ModelIDInput | null,
  clientId?: ModelIDInput | null,
  vatNonDeductiblePercentage?: ModelFloatInput | null,
  and?: Array< ModelAccountLabelConditionInput | null > | null,
  or?: Array< ModelAccountLabelConditionInput | null > | null,
  not?: ModelAccountLabelConditionInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelIDInput = {
  ne?: string | null,
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  contains?: string | null,
  notContains?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
  size?: ModelSizeInput | null,
};

export enum ModelAttributeTypes {
  binary = "binary",
  binarySet = "binarySet",
  bool = "bool",
  list = "list",
  map = "map",
  number = "number",
  numberSet = "numberSet",
  string = "string",
  stringSet = "stringSet",
  _null = "_null",
}

export type ModelSizeInput = {
  ne?: number | null,
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
};

export type ModelIntInput = {
  ne?: number | null,
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
};

export type ModelAccountLabelCustomUsageInput = {
  eq?: AccountLabelCustomUsage | null,
  ne?: AccountLabelCustomUsage | null,
};

export type ModelBooleanInput = {
  ne?: boolean | null,
  eq?: boolean | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
};

export type AccountLabelDTO = {
  __typename: "AccountLabel",
  id: string,
  labels?:  Array<CustomLabelDTO > | null,
  bankAccountId?: string | null,
  bankAccount?: BankAccountDTO | null,
  contactId?: string | null,
  contact?: ContactDTO | null,
  class: number,
  customUsage?: AccountLabelCustomUsage | null,
  customValues?:  Array<CustomValueDTO > | null,
  disabled?: boolean | null,
  hoaFundId?: string | null,
  ownerId?: string | null,
  owner?: ContactDTO | null,
  topClass: number,
  vatNonDeductiblePercentage?: number | null,
  readId: string,
  clientId: string,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type CustomLabelDTO = {
  __typename: "CustomLabel",
  language: string,
  label: string,
};

export type BankAccountDTO = {
  __typename: "BankAccount",
  id: string,
  contactId: string,
  contact?: ContactDTO | null,
  number: string,
  bicNumber?: string | null,
  bankName?: string | null,
  contactIds?: Array< string > | null,
  buildingIds?: Array< string > | null,
  holderName?: string | null,
  label?: string | null,
  customValues?:  Array<CustomValueDTO > | null,
  disabled?: boolean | null,
  integrations?: Array< IntegrationName > | null,
  matchingRule?: BankAccountMatchingRule | null,
  initiationChannel?: PaymentInitiationChannel | null,
  retainedBalanceThreshold?: number | null,
  balance?: number | null,
  balanceDate?: string | null,
  type: BankAccountType,
  ibanStatus?: IbanStatus | null,
  ibanVerifiedAt?: string | null,
  ibanVerifiedBy?: string | null,
  ibanVerifiedNumber?: string | null,
  ibanVerifiedSourceDocumentId?: string | null,
  ibanRole?: BankAccountIbanRole | null,
  ibanRoleLabel?: string | null,
  isDefault?: boolean | null,
  note?: string | null,
  paymentRunPriorityOrderIds?: Array< string > | null,
  paymentRunPriorityUpdatedAt?: string | null,
  paymentRunPriorityUpdatedBy?: string | null,
  readers?: Array< string > | null,
  readId: string,
  clientId: string,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export enum IbanStatus {
  KNOWN = "KNOWN",
  OBSERVED = "OBSERVED",
  SAFE = "SAFE",
}

export type ContactDTO = {
  __typename: "Contact",
  id: string,
  createdAt?: string | null,
  firstName?: string | null,
  lastName?: string | null,
  companyName?: string | null,
  commercialName?: string | null,
  communicationSettingsProfileId?: string | null,
  customValues?:  Array<CustomValueDTO > | null,
  businessNumber?: string | null,
  types: Array< ContactType >,
  vat?: string | null,
  emails?:  Array<EmailDTO > | null,
  email?: string | null,
  birthDate?: string | null,
  birthPlace?: string | null,
  nationalRegister?: string | null,
  ipiNumber?: string | null,
  insuranceCompany?: string | null,
  insuranceContractNumber?: string | null,
  judicialDistrict?: string | null,
  civility?: CivilityType | null,
  addressId?: string | null,
  address?: AddressDTO | null,
  phoneNumbers?:  Array<PhoneNumberDTO > | null,
  language?: string | null,
  notes?: string | null,
  profileType: ContactProfileType,
  jointOwners?:  Array<JointOwnerDTO > | null,
  hoaFunds?:  Array<ContactHoaFundDTO > | null,
  paymentTermDays?: number | null,
  acpSyndicEras?: Array< AcpSyndicEraDTO > | null,
  acpSyndicHistory?: Array< AcpSyndicChangeDTO > | null,
  defaultBankAccountId?: string | null,
  supplierPaymentMode?: SupplierPaymentMode | null,
  supplierPaymentModeExceptions?:  Array<SupplierPaymentModeExceptionDTO > | null,
  supplierPaymentModeHistory?:  Array<SupplierPaymentModeChangeDTO > | null,
  agencyRateDisabled?: boolean | null,
  attachStatementSupportingDocuments?: boolean | null,
  status?: ContactStatus | null,
  leases?: ModelLeaseContactConnection | null,
  buildings?: ModelBuildingOwnerConnection | null,
  units?: ModelUnitOwnerConnection | null,
  sendInvitation: boolean,
  peppolProperties?: ContactPeppolPropertiesDTO | null,
  integrations?: ContactIntegrationsDTO | null,
  readers?: Array< string > | null,
  readId: string,
  clientId: string,
  sourceEntityRelations?: ModelEntityRelationConnection | null,
  foreignEntityRelations?: ModelEntityRelationConnection | null,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type CustomValueDTO = {
  __typename: "CustomValue",
  name: string,
  value: string,
};

export enum ContactType {
  OWNER = "OWNER",
  TENANT = "TENANT",
  GUARANTOR = "GUARANTOR",
  MEMBER = "MEMBER",
  CONTRACTOR = "CONTRACTOR",
  JOINT_OWNERSHIP = "JOINT_OWNERSHIP",
  CLIENT = "CLIENT",
  HOA = "HOA",
  OTHER = "OTHER",
}

export type EmailDTO = {
  __typename: "Email",
  address: string,
  isPrimary: boolean,
  label?: string | null,
};

export enum CivilityType {
  MAN = "MAN",
  WOMAN = "WOMAN",
  OTHER = "OTHER",
}

export type AddressDTO = {
  __typename: "Address",
  id: string,
  status?: AddressStatus | null,
  street: string,
  number?: string | null,
  box?: string | null,
  postalCode?: string | null,
  city?: string | null,
  region?: string | null,
  country?: string | null,
  customValues?:  Array<CustomValueDTO > | null,
  latitude?: number | null,
  longitude?: number | null,
  readers?: Array< string > | null,
  readId: string,
  clientId: string,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export enum AddressStatus {
  NEW = "NEW",
  DRAFT_OCR = "DRAFT_OCR",
  ACTIVE_GEOCODED = "ACTIVE_GEOCODED",
  ERROR = "ERROR",
}

export type PhoneNumberDTO = {
  __typename: "PhoneNumber",
  countryCode: string,
  isPrimary: boolean,
  label?: string | null,
  number: string,
};

export enum ContactProfileType {
  COMPANY = "COMPANY",
  INDIVIDUAL = "INDIVIDUAL",
}

export type JointOwnerDTO = {
  __typename: "JointOwner",
  contactId: string,
  contactPerson?: boolean | null,
};

export type ContactHoaFundDTO = {
  __typename: "ContactHoaFund",
  archivedAt?: string | null,
  id: string,
  kind: HoaFundKind,
  name: string,
};

export enum ContactStatus {
  DRAFT_OCR = "DRAFT_OCR",
  ARCHIVED = "ARCHIVED",
  ERROR = "ERROR",
  VALID = "VALID",
}

export type ModelLeaseContactConnection = {
  __typename: "ModelLeaseContactConnection",
  items:  Array<LeaseContactDTO | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type LeaseContactDTO = {
  __typename: "LeaseContact",
  id: string,
  leaseId: string,
  contactId: string,
  lease?: LeaseDTO | null,
  contact?: ContactDTO | null,
  contactRole: ContactType,
  readers?: Array< string > | null,
  readId: string,
  clientId: string,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type LeaseDTO = {
  __typename: "Lease",
  id: string,
  advancedChargesInvoices?: LeaseAdvancedChargesInvoiceDTO | null,
  balance?: number | null,
  canBeExtended?: boolean | null,
  communicationSettingsProfileId: string,
  createdAt?: string | null,
  customValues?:  Array<CustomValueDTO > | null,
  endDate: string,
  includeRealEstateInLeaseContract?: boolean | null,
  attachStatementSupportingDocuments?: boolean | null,
  invoiceSenderId: string,
  invoiceSender?: ContactDTO | null,
  inventoryOfFixturesExpert?: string | null,
  inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
  inventoryOfFixturesType?: InventoryOfFixturesType | null,
  ipiNumber?: string | null,
  language: Language,
  lastDraftInvoiceDate?: string | null,
  lastIndexationProcessDate?: string | null,
  lastInvoiceDate?: string | null,
  legalCompetentAuthority?: string | null,
  name: string,
  notes?: string | null,
  paymentFrequency: LeasePaymentFrequency,
  paymentInvoicePeriod: LeasePaymentInvoicePeriod,
  paymentInvoicePeriodCustomDay?: number | null,
  paymentOption?: LeasePaymentOptionDTO | null,
  purchaseOrderNumber?: string | null,
  realEstateAgency?: string | null,
  realEstateTax?: number | null,
  remittanceInformation?: string | null,
  remittanceInformationType?: LeaseRemittanceType | null,
  rentalGuaranty?: LeaseRentalGuarantyDTO | null,
  signatureDate?: string | null,
  startDate: string,
  nextIndexationMonth?: string | null,
  nextIndexation?: boolean | null,
  status: LeaseStatus,
  technicCommunicationSettingsProfileId: string,
  totalInitialRentalPrice: number,
  totalRentalPrice: number,
  type: LeaseType,
  subletting?: boolean | null,
  vatRateRentId?: string | null,
  vatRateRent?: VatRateDTO | null,
  additionalClauses?: ModelLeaseAdditionalClauseConnection | null,
  bankAccountId?: string | null,
  bankAccount?: BankAccountDTO | null,
  contacts?: ModelLeaseContactConnection | null,
  files?: ModelFileConnection | null,
  leaseActionHistories?: ModelLeaseActionHistoryConnection | null,
  leasePriceHistories?: ModelLeasePriceHistoryConnection | null,
  signatureDocuments?: ModelSignatureDocumentConnection | null,
  units?: ModelUnitLeaseConnection | null,
  variousOperations?: ModelLeaseVariousOperationConnection | null,
  readers?: Array< string > | null,
  readId: string,
  clientId: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type LeaseAdvancedChargesInvoiceDTO = {
  __typename: "LeaseAdvancedChargesInvoice",
  communicationSettingsProfileId: string,
  invoiceSenderId: string,
  lastDraftInvoiceDate?: string | null,
  lastInvoiceDate?: string | null,
  paymentFrequency: LeasePaymentFrequency,
  paymentInvoicePeriod: LeasePaymentInvoicePeriod,
  paymentInvoicePeriodCustomDay?: number | null,
  remittanceInformation?: string | null,
  remittanceInformationType?: LeaseRemittanceType | null,
  bankAccountId?: string | null,
};

export enum LeasePaymentInvoicePeriod {
  CONTRACT_PERIOD = "CONTRACT_PERIOD",
  CALENDAR_PERIOD = "CALENDAR_PERIOD",
  CUSTOM_PERIOD = "CUSTOM_PERIOD",
}

export enum LeaseRemittanceType {
  STRUCTURED_FIXED = "STRUCTURED_FIXED",
  STRUCTURED_BY_INVOICE = "STRUCTURED_BY_INVOICE",
  UNSTRUCTURED = "UNSTRUCTURED",
}

export enum InventoryOfFixturesMethod {
  EXPERT = "EXPERT",
  BETWEEN_PARTIES = "BETWEEN_PARTIES",
}

export enum InventoryOfFixturesType {
  FIRST_MONTH = "FIRST_MONTH",
  BEFORE_OCCUPATION = "BEFORE_OCCUPATION",
}

export type LeasePaymentOptionDTO = {
  __typename: "LeasePaymentOption",
  customerId?: string | null,
  enabled: boolean,
  mandateActivatedAt?: string | null,
  mandateStatus?: PaymentProviderMandateStatus | null,
  paymentMethodId?: string | null,
  qrType?: LeaseQrType | null,
};

export enum PaymentProviderMandateStatus {
  PENDING = "PENDING",
  ACTIVE = "ACTIVE",
  FAILED = "FAILED",
}

export enum LeaseQrType {
  BANK_TRANSFER = "BANK_TRANSFER",
  NONE = "NONE",
  PAYMENT_LINK = "PAYMENT_LINK",
}

export type LeaseRentalGuarantyDTO = {
  __typename: "LeaseRentalGuaranty",
  amount: number,
  blockedAmount?: number | null,
  releasedAmount?: number | null,
  type: LeaseRentalGuarantyType,
  financialInstitution?: string | null,
};

export enum LeaseRentalGuarantyType {
  BANK = "BANK",
  BANK_BLOCKED = "BANK_BLOCKED",
  CASH = "CASH",
  CPAS = "CPAS",
  INVOICED_CASH = "INVOICED_CASH",
}

export enum LeaseStatus {
  Draft = "Draft",
  OutForSignature = "OutForSignature",
  Active = "Active",
  Rejected = "Rejected",
  Ended = "Ended",
  Cancelled = "Cancelled",
}

export enum LeaseType {
  COMMERCIAL = "COMMERCIAL",
  COMMON_LAW = "COMMON_LAW",
  FLATSHARING = "FLATSHARING",
  MAIN_RESIDENCE_9_YEARS = "MAIN_RESIDENCE_9_YEARS",
  MAIN_RESIDENCE_INFINITE = "MAIN_RESIDENCE_INFINITE",
  MAIN_RESIDENCE_LONG = "MAIN_RESIDENCE_LONG",
  MAIN_RESIDENCE_SHORT = "MAIN_RESIDENCE_SHORT",
  OFFICE = "OFFICE",
  PARKING = "PARKING",
  STUDENT = "STUDENT",
  WAREHOUSE = "WAREHOUSE",
}

export type VatRateDTO = {
  __typename: "VatRate",
  id: string,
  country: string,
  label: string,
  value?: number | null,
  vatKind?: VatRateKind | null,
  customValues?:  Array<CustomValueDTO > | null,
  ownerId?: string | null,
  owner?: ContactDTO | null,
  readId: string,
  clientId: string,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type ModelLeaseAdditionalClauseConnection = {
  __typename: "ModelLeaseAdditionalClauseConnection",
  items:  Array<LeaseAdditionalClauseDTO | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type LeaseAdditionalClauseDTO = {
  __typename: "LeaseAdditionalClause",
  id: string,
  leaseId: string,
  lease?: LeaseDTO | null,
  title?: string | null,
  body: string,
  readId: string,
  clientId: string,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type ModelFileConnection = {
  __typename: "ModelFileConnection",
  items:  Array<FileDTO | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type FileDTO = {
  __typename: "File",
  id: string,
  bucket: string,
  createdAt?: string | null,
  category?: DocumentCategoryDTO | null,
  categoryId: string,
  foreignKey: string,
  foreignTableName: string,
  key: string,
  mimeType?: string | null,
  region: string,
  signaturePositions?:  Array<SignaturePositionDTO > | null,
  size?: number | null,
  readers?: Array< string > | null,
  readId: string,
  clientId: string,
  _ttl?: number | null,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type DocumentCategoryDTO = {
  __typename: "DocumentCategory",
  id: string,
  entity?: string | null,
  fileCategory: FileCategory,
  labels:  Array<CustomLabelDTO >,
  parentId?: string | null,
  readers?: Array< string > | null,
  readId: string,
  clientId: string,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export enum FileCategory {
  INTERNAL_COMMENT = "INTERNAL_COMMENT",
  LEASE_CONTRACT = "LEASE_CONTRACT",
  LEASE_CONTRACT_END = "LEASE_CONTRACT_END",
  LEASE_INVENTORY_CONTRACT = "LEASE_INVENTORY_CONTRACT",
  CHARGE_INVOICE = "CHARGE_INVOICE",
  INVOICE = "INVOICE",
  PEB = "PEB",
  CO_OWNERSHIP_REGULATIONS = "CO_OWNERSHIP_REGULATIONS",
  RULES_OF_PROCEDURE = "RULES_OF_PROCEDURE",
  HYDROCARBONTANK_CERTIFICATE = "HYDROCARBONTANK_CERTIFICATE",
  FURNITURE_INVENTORY = "FURNITURE_INVENTORY",
  HEATING = "HEATING",
  CHIMNEY = "CHIMNEY",
  UTILITY = "UTILITY",
  DETECTOR = "DETECTOR",
  INVENTORY_OF_FIXTURES = "INVENTORY_OF_FIXTURES",
  COMMUNICATION = "COMMUNICATION",
  ADVERTISEMENT_PICTURE = "ADVERTISEMENT_PICTURE",
  CLIENT_LOGO = "CLIENT_LOGO",
  BASIC_DEED = "BASIC_DEED",
  CONTRACT = "CONTRACT",
  STATEMENT_DETAIL = "STATEMENT_DETAIL",
  STATEMENT_RECEIPT = "STATEMENT_RECEIPT",
  CONTRACT_AMENDMENT = "CONTRACT_AMENDMENT",
  LEASE_PRICE_HISTORY_DETAIL = "LEASE_PRICE_HISTORY_DETAIL",
  CUSTOM = "CUSTOM",
  INVOICE_RECEIPT = "INVOICE_RECEIPT",
  TICKET = "TICKET",
  LEASE_INVENTORY_ENCODING = "LEASE_INVENTORY_ENCODING",
  LETTER = "LETTER",
  TEMPORARY = "TEMPORARY",
  RENTAL_DEPOSIT = "RENTAL_DEPOSIT",
  CONTRACTUAL_INFORMATION = "CONTRACTUAL_INFORMATION",
}

export type SignaturePositionDTO = {
  __typename: "SignaturePosition",
  top: number,
  left: number,
  page: number,
  width?: number | null,
  height?: number | null,
  contactId: string,
};

export type ModelLeaseActionHistoryConnection = {
  __typename: "ModelLeaseActionHistoryConnection",
  items:  Array<LeaseActionHistoryDTO | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type LeaseActionHistoryDTO = {
  __typename: "LeaseActionHistory",
  id: string,
  action: LeaseAction,
  comment?: string | null,
  contactId: string,
  createdAt?: string | null,
  createdBy?: ContactDTO | null,
  historyDetails:  Array<LeaseActionHistoryDetailDTO >,
  leaseId: string,
  lease?: LeaseDTO | null,
  communicationId?: string | null,
  communication?: CommunicationDTO | null,
  signatureDocumentId?: string | null,
  signatureDocument?: SignatureDocumentDTO | null,
  status?: LeaseActionHistoryStatus | null,
  communicationChannel?: CommunicationChannel | null,
  communicationSendDate?: string | null,
  communicationByPlatform?: boolean | null,
  endReason?: LeaseActionEndReason | null,
  endReasonOwnUseRelation?: string | null,
  endReasonOwnUseName?: string | null,
  initiator?: LeaseActionEndInitiator | null,
  totalAmount?: number | null,
  totalAmountLabel?: string | null,
  automatic?: boolean | null,
  hasLeaseTypeChanged?: boolean | null,
  jiraId?: string | null,
  readers?: Array< string > | null,
  readId: string,
  clientId: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export enum LeaseAction {
  EXTEND_LEASE = "EXTEND_LEASE",
  END_LEASE = "END_LEASE",
  ADD_UNIT = "ADD_UNIT",
  CANCELED_END_LEASE = "CANCELED_END_LEASE",
  QUICK_EDIT = "QUICK_EDIT",
  REMOVE_UNIT = "REMOVE_UNIT",
  INITIAL_DATE = "INITIAL_DATE",
  CUSTOM = "CUSTOM",
  EARLY_DEPARTURE = "EARLY_DEPARTURE",
  CANCELED_EARLY_DEPARTURE = "CANCELED_EARLY_DEPARTURE",
}

export type LeaseActionHistoryDetailDTO = {
  __typename: "LeaseActionHistoryDetail",
  unitId: string,
  newEndDate?: string | null,
  newSignatureDate?: string | null,
  newStartDate?: string | null,
  previousEndDate?: string | null,
  previousSignatureDate?: string | null,
  previousStartDate?: string | null,
};

export type CommunicationDTO = {
  __typename: "Communication",
  id: string,
  addressId?: string | null,
  address?: AddressDTO | null,
  blockedRecipients?:  Array<CommunicationBlockedRecipientDTO > | null,
  body: string,
  buildingId?: string | null,
  channel: CommunicationChannel,
  communicationTemplateId?: string | null,
  concernedContactIds?: Array< string > | null,
  contactId?: string | null,
  contactIds?: Array< string > | null,
  createdAt?: string | null,
  draftProperties?: CommunicationDraftPropertiesDTO | null,
  expirationDate?: string | null,
  files?: ModelFileConnection | null,
  invoice?: InvoiceDTO | null,
  invoiceId?: string | null,
  lease?: LeaseDTO | null,
  leaseId?: string | null,
  leasePriceHistoryId?: string | null,
  leasePriceHistory?: LeasePriceHistoryDTO | null,
  letterTrackingCode?: string | null,
  letterTrackingProvider?: TrackingProvider | null,
  linkedCommunicationsIds?: Array< string > | null,
  supportingDocumentFileIds?: Array< string > | null,
  recipient?: string | null,
  recipientContactIdsInBcc?: Array< string > | null,
  recipientContactIdsInCc?: Array< string > | null,
  recipientInBcc?: string | null,
  recipientInCc?: string | null,
  scheduledAt?: string | null,
  deliveredAt?: string | null,
  errorCode?: CommunicationErrorCode | null,
  nextRetryAt?: string | null,
  sendRetryCount?: number | null,
  sender?: string | null,
  sentAt?: string | null,
  externalId?: string | null,
  externalStatus?: string | null,
  signatureDocumentId?: string | null,
  signatureDocument?: SignatureDocumentDTO | null,
  snoozedDate?: string | null,
  statement?: StatementDTO | null,
  statementId?: string | null,
  status: CommunicationStatus,
  subject: string,
  toSend: boolean,
  hideLogo?: boolean | null,
  type: CommunicationType,
  _ttl?: number | null,
  unit?: UnitDTO | null,
  unitId?: string | null,
  readId: string,
  readers?: Array< string > | null,
  clientId: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type CommunicationBlockedRecipientDTO = {
  __typename: "CommunicationBlockedRecipient",
  recipient: string,
  bounceType: BounceType,
};

export enum BounceType {
  BLOCKED_BY_RECIPIENT = "BLOCKED_BY_RECIPIENT",
  CONTENT_NOT_ACCEPTED = "CONTENT_NOT_ACCEPTED",
  INVALID_NUMBER = "INVALID_NUMBER",
  MAILBOX_DOES_NOT_EXIST = "MAILBOX_DOES_NOT_EXIST",
  MAILBOX_FULL = "MAILBOX_FULL",
  MESSAGE_TOO_LARGE = "MESSAGE_TOO_LARGE",
  RATE_LIMITED = "RATE_LIMITED",
  SENDER_NOT_AUTHORIZED = "SENDER_NOT_AUTHORIZED",
  TEMPORARY_FAILURE = "TEMPORARY_FAILURE",
  TWILIO_UNREACHABLE_DESTINATION = "TWILIO_UNREACHABLE_DESTINATION",
  UNKNOWN = "UNKNOWN",
}

export enum CommunicationChannel {
  EMAIL = "EMAIL",
  IN_APP = "IN_APP",
  LETTER = "LETTER",
  REGISTERED_LETTER = "REGISTERED_LETTER",
  SMS = "SMS",
  WHATSAPP = "WHATSAPP",
}

export type CommunicationDraftPropertiesDTO = {
  __typename: "CommunicationDraftProperties",
  allowRecipientsToSeeEachOther?: boolean | null,
  bcc?: Array< string > | null,
  buildingIds?: Array< string > | null,
  cc?: Array< string > | null,
  contactIds?: Array< string > | null,
  contactTypes?: Array< ContactType > | null,
  entityType: string,
  leaseIds?: Array< string > | null,
  sendInBcc?: boolean | null,
  unitIds?: Array< string > | null,
  unitTypeFilter?: string | null,
};

export type InvoiceDTO = {
  __typename: "Invoice",
  id: string,
  amount: number,
  bankAccountId: string,
  bankAccount?: BankAccountDTO | null,
  communicationId?: string | null,
  communication?: CommunicationDTO | null,
  createdAt: string,
  creditNote?: boolean | null,
  creditNoteLabel?: string | null,
  customValues?:  Array<CustomValueDTO > | null,
  disputedPostingIds?: Array< string > | null,
  disputes?:  Array<InvoiceDisputeDTO > | null,
  disputeStatus?: InvoiceDisputeStatus | null,
  dueDate?: string | null,
  invoiceDate: string,
  invoiceNumber?: string | null,
  ownerId?: string | null,
  owner?: ContactDTO | null,
  invoiceSenderId: string,
  invoiceSender?: ContactDTO | null,
  leaseId?: string | null,
  lease?: LeaseDTO | null,
  paid: boolean,
  integrations?: InvoiceIntegrationsDTO | null,
  postedDate?: string | null,
  purchaseOrderNumber?: string | null,
  receiptNumber?: string | null,
  reminderDates?: Array< string > | null,
  note?: string | null,
  remittanceInformation?: string | null,
  statementId?: string | null,
  statement?: StatementDTO | null,
  status: InvoiceStatus,
  type: InvoiceType,
  unitId?: string | null,
  unit?: UnitDTO | null,
  reversedInvoiceId?: string | null,
  sentVersions?:  Array<InvoiceSentVersionDTO > | null,
  readers?: Array< string > | null,
  readId: string,
  clientId: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type InvoiceDisputeDTO = {
  __typename: "InvoiceDispute",
  id: string,
  scope: InvoiceDisputeScope,
  postingId?: string | null,
  postingLabel?: string | null,
  reason: string,
  comment?: string | null,
  disputedOn: string,
  openedAt: string,
  openedById?: string | null,
  openDecisionId: string,
  liftedAt?: string | null,
  liftedById?: string | null,
  liftCause?: InvoiceDisputeLiftCause | null,
  liftDecisionId?: string | null,
};

export type InvoiceIntegrationsDTO = {
  __typename: "InvoiceIntegrations",
  paymentProperties?: InvoicePaymentProviderPropertiesDTO | null,
};

export type InvoicePaymentProviderPropertiesDTO = {
  __typename: "InvoicePaymentProviderProperties",
  availableOn?: string | null,
  error?: string | null,
  feeAmount?: number | null,
  paymentIntentId?: string | null,
  paymentLinkAmount?: number | null,
  paymentLinkUrl?: string | null,
  payoutId?: string | null,
  statementDescriptor?: string | null,
};

export type InvoiceSentVersionDTO = {
  __typename: "InvoiceSentVersion",
  version: number,
  sentAt?: string | null,
  invoiceNumber?: string | null,
  invoiceSenderId?: string | null,
  channels:  Array<InvoiceSentChannelDTO >,
  pdfFileId?: string | null,
  xmlFileId?: string | null,
  resetAt: string,
  resetBy?: string | null,
  reason?: string | null,
};

export type InvoiceSentChannelDTO = {
  __typename: "InvoiceSentChannel",
  channel: InvoiceDeliveryChannel,
  status?: string | null,
  communicationId?: string | null,
  peppolId?: string | null,
};

export type StatementDTO = {
  __typename: "Statement",
  id: string,
  amounts?:  Array<CustomValueDTO > | null,
  chargeStatements?: ModelChargeStatementConnection | null,
  closingStatement: boolean,
  periodFrom: string,
  periodTo: string,
  attachSupportingDocuments?: boolean | null,
  selectedPocketKeys?: Array< string > | null,
  source: StatementSource,
  status: StatementStatus,
  sentDate?: string | null,
  leaseId?: string | null,
  lease?: LeaseDTO | null,
  agencyRateStatements?: ModelAgencyRateStatementConnection | null,
  ownerId?: string | null,
  owner?: ContactDTO | null,
  repaymentStatements?: ModelRepaymentStatementConnection | null,
  types?: Array< StatementType > | null,
  viewType: StatementViewType,
  unitIds?: Array< string > | null,
  readId: string,
  clientId: string,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type ModelChargeStatementConnection = {
  __typename: "ModelChargeStatementConnection",
  items:  Array<ChargeStatementDTO | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ChargeStatementDTO = {
  __typename: "ChargeStatement",
  id: string,
  charge?: ChargeDTO | null,
  chargeId: string,
  statement?: StatementDTO | null,
  statementId: string,
  readId: string,
  clientId: string,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type ChargeDTO = {
  __typename: "Charge",
  id: string,
  status: ChargeStatus,
  invoiceDate?: string | null,
  paymentDueDate?: string | null,
  archivedDate?: string | null,
  periodFrom?: string | null,
  periodTo?: string | null,
  totalAmount?: number | null,
  payableAmount?: number | null,
  source: ChargeSource,
  draftFromOcr?: boolean | null,
  accountingDocumentId?: string | null,
  paid: boolean,
  settlement?: ChargeSettlementDTO | null,
  remittanceInformation?: string | null,
  note?: string | null,
  createdAt: string,
  creatorEmail?: string | null,
  createdById?: string | null,
  createdBy?: ContactDTO | null,
  contractorId?: string | null,
  contractor?: ContactDTO | null,
  proposedContractors?:  Array<ProposedValueDTO > | null,
  recipientId?: string | null,
  recipient?: ContactDTO | null,
  proposedRecipients?:  Array<ProposedValueDTO > | null,
  customValues?:  Array<CustomValueDTO > | null,
  documentId: string,
  sectionId?: string | null,
  document?: FileDTO | null,
  postings?: ModelPostingConnection | null,
  readId: string,
  clientId: string,
  openChargeClientId?: string | null,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export enum ChargeStatus {
  TO_CHECK = "TO_CHECK",
  TO_AFFECT = "TO_AFFECT",
  AFFECTED = "AFFECTED",
}

export enum ChargeSource {
  MAIL = "MAIL",
  WEB = "WEB",
  MANUAL = "MANUAL",
}

export type ProposedValueDTO = {
  __typename: "ProposedValue",
  id: string,
  confidence?: number | null,
};

export type ModelPostingConnection = {
  __typename: "ModelPostingConnection",
  items:  Array<PostingDTO | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type PostingDTO = {
  __typename: "Posting",
  id: string,
  createdAt?: string | null,
  class: number,
  customLabel?: string | null,
  customValues?:  Array<CustomValueDTO > | null,
  topClass: number,
  type: PostingType,
  totalAmount: number,
  periodFrom: string,
  periodTo: string,
  buildingId?: string | null,
  building?: BuildingDTO | null,
  unitId?: string | null,
  unit?: UnitDTO | null,
  invoiceId?: string | null,
  invoice?: InvoiceDTO | null,
  chargeId?: string | null,
  charge?: ChargeDTO | null,
  transactionId?: string | null,
  transaction?: TransactionDTO | null,
  leaseId?: string | null,
  lease?: LeaseDTO | null,
  bankAccountId?: string | null,
  bankAccount?: BankAccountDTO | null,
  accountLabelId?: string | null,
  accountLabel?: AccountLabelDTO | null,
  contactId?: string | null,
  contact?: ContactDTO | null,
  leaseVariousOperationId?: string | null,
  leaseVariousOperation?: LeaseVariousOperationDTO | null,
  statementId?: string | null,
  amountVatExcluded?: number | null,
  vatAmount?: number | null,
  vatRate?: VatRateDTO | null,
  vatRateId?: string | null,
  vatRateValue?: number | null,
  foreignId?: string | null,
  foreignType?: PostingForeignType | null,
  invoicePostingId?: string | null,
  reconciledAt?: string | null,
  decisionId?: string | null,
  status?: PostingStatus | null,
  chargeOwnerRepartition?: number | null,
  chargeRepartitionMetric?: string | null,
  chargeRepartitionValue?: number | null,
  chargeSplitNumber?: number | null,
  chargeType?: PostingChargeType | null,
  tenantShare?: PostingTenantShareDTO | null,
  provisional?: boolean | null,
  flaggedAt?: string | null,
  carriedForward?: boolean | null,
  tenantLandings?: Array< PostingTenantLandingDTO > | null,
  readers?: Array< string > | null,
  readId: string,
  clientId: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export enum PostingType {
  CREDIT = "CREDIT",
  DEBIT = "DEBIT",
}

export type BuildingDTO = {
  __typename: "Building",
  id: string,
  name: string,
  addressId?: string | null,
  address?: AddressDTO | null,
  acquisitionValue?: number | null,
  acquisitionAdditionalCostsValue?: number | null,
  acquisitionAdvertisedValue?: number | null,
  amountOfFacades?: number | null,
  amountOfFloors?: number | null,
  amountOfHousings?: number | null,
  buildingState?: BuildingState | null,
  cadastralIncome?: number | null,
  constructionYear?: string | null,
  customValues?:  Array<CustomValueDTO > | null,
  janitor?: boolean | null,
  jointOwnershipId?: string | null,
  notes?: string | null,
  owners?: ModelBuildingOwnerConnection | null,
  propertyTax?: number | null,
  residenceName?: string | null,
  buildingSiteId?: string | null,
  buildingSite?: BuildingSiteDTO | null,
  units?: ModelUnitConnection | null,
  events?: ModelBuildingEventConnection | null,
  readers?: Array< string > | null,
  teams?: Array< string > | null,
  readId: string,
  clientId: string,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export enum BuildingState {
  VERY_GOOD = "VERY_GOOD",
  GOOD = "GOOD",
  BAD = "BAD",
  VERY_BAD = "VERY_BAD",
}

export type ModelBuildingOwnerConnection = {
  __typename: "ModelBuildingOwnerConnection",
  items:  Array<BuildingOwnerDTO | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type BuildingOwnerDTO = {
  __typename: "BuildingOwner",
  id: string,
  buildingId: string,
  building?: BuildingDTO | null,
  contactId: string,
  disabled?: boolean | null,
  owner?: ContactDTO | null,
  periodFrom?: string | null,
  periodTo?: string | null,
  stake: number,
  readers?: Array< string > | null,
  readId: string,
  clientId: string,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type BuildingSiteDTO = {
  __typename: "BuildingSite",
  id: string,
  name: string,
  buildings?: ModelBuildingConnection | null,
  readers?: Array< string > | null,
  teams?: Array< string > | null,
  readId: string,
  clientId: string,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type ModelBuildingConnection = {
  __typename: "ModelBuildingConnection",
  items:  Array<BuildingDTO | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelUnitConnection = {
  __typename: "ModelUnitConnection",
  items:  Array<UnitDTO | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type UnitDTO = {
  __typename: "Unit",
  id: string,
  acquisitionAdditionalCostsValue?: number | null,
  acquisitionAdvertisedValue?: number | null,
  acquisitionValue?: number | null,
  advertisedMonthlyCharges?: number | null,
  advertisedRentalPrice?: number | null,
  cadastralIncome?: number | null,
  createdAt?: string | null,
  customValues?:  Array<CustomValueDTO > | null,
  floor?: number | null,
  jointOwnershipId?: string | null,
  managementDate: string,
  name: string,
  notes?: string | null,
  predictedPrice?: string | null,
  propertyTax?: number | null,
  publishAddress?: boolean | null,
  surface?: number | null,
  type: UnitType,
  buildingId: string,
  building?: BuildingDTO | null,
  owners?: ModelUnitOwnerConnection | null,
  leases?: ModelUnitLeaseConnection | null,
  events?: ModelUnitEventConnection | null,
  unitAdvertisementId?: string | null,
  unitInventories?: ModelUnitInventoryConnection | null,
  readers?: Array< string > | null,
  readId: string,
  clientId: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export enum UnitType {
  RESIDENTIAL = "RESIDENTIAL",
  STUDENT = "STUDENT",
  COMMERCIAL = "COMMERCIAL",
  WAREHOUSE = "WAREHOUSE",
  OFFICE = "OFFICE",
  PARKING = "PARKING",
  OTHER = "OTHER",
}

export type ModelUnitOwnerConnection = {
  __typename: "ModelUnitOwnerConnection",
  items:  Array<UnitOwnerDTO | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type UnitOwnerDTO = {
  __typename: "UnitOwner",
  id: string,
  disabled?: boolean | null,
  owner?: ContactDTO | null,
  ownerId: string,
  periodFrom?: string | null,
  periodTo?: string | null,
  stake: number,
  unit?: UnitDTO | null,
  unitId: string,
  readers?: Array< string > | null,
  readId: string,
  clientId: string,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type ModelUnitLeaseConnection = {
  __typename: "ModelUnitLeaseConnection",
  items:  Array<UnitLeaseDTO | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type UnitLeaseDTO = {
  __typename: "UnitLease",
  id: string,
  allowChargeAdjustment?: boolean | null,
  authorizeProfessionalActivity?: boolean | null,
  chargesIndexation?: boolean | null,
  createdAt?: string | null,
  endDate: string,
  furnishedRental?: boolean | null,
  furnishedRentalInsuranceByTenant?: boolean | null,
  furnishedRentalRentalPricePercentage?: number | null,
  initialRentalPrice: number,
  indexation?: boolean | null,
  advancedIndexation?: boolean | null,
  indexType?: IndexType | null,
  baseYear?: number | null,
  baseIndexType?: BaseIndexType | null,
  baseIndexDate?: string | null,
  nextIndexationMonth?: string | null,
  nextIndexation?: boolean | null,
  leaseId: string,
  mainUnit: boolean,
  rentalPrice: number,
  signatureDate?: string | null,
  startDate: string,
  unitId: string,
  unit?: UnitDTO | null,
  lease?: LeaseDTO | null,
  readers?: Array< string > | null,
  readId: string,
  clientId: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export enum IndexType {
  HEALTH = "HEALTH",
  CONSUMER_PRICE = "CONSUMER_PRICE",
  CONSUMER_PRICE_NO_ENERGY = "CONSUMER_PRICE_NO_ENERGY",
}

export enum BaseIndexType {
  MONTH_BEFORE_SIGNATURE_DATE = "MONTH_BEFORE_SIGNATURE_DATE",
  MONTH_BEFORE_START_DATE = "MONTH_BEFORE_START_DATE",
  CUSTOM_DATE = "CUSTOM_DATE",
}

export type ModelUnitEventConnection = {
  __typename: "ModelUnitEventConnection",
  items:  Array<UnitEventDTO | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type UnitEventDTO = {
  __typename: "UnitEvent",
  id: string,
  unitId: string,
  type: UnitEventType,
  startDate: string,
  endDate: string,
  totalCost?: number | null,
  note?: string | null,
  writers?: Array< string > | null,
  readId: string,
  clientId: string,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export enum UnitEventType {
  OWN_USE = "OWN_USE",
  WORK = "WORK",
}

export type ModelUnitInventoryConnection = {
  __typename: "ModelUnitInventoryConnection",
  items:  Array<UnitInventoryDTO | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type UnitInventoryDTO = {
  __typename: "UnitInventory",
  id: string,
  privateBatthRoom?: boolean | null,
  createdAt?: string | null,
  deletedAt?: string | null,
  kitchenEquipment?: KitchenEquipment | null,
  roomName?: string | null,
  roomType: UnitInventoryRoomType,
  surface?: number | null,
  showSurface?: boolean | null,
  unitId: string,
  inside: boolean,
  readId: string,
  clientId: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export enum KitchenEquipment {
  FULLY_EQUIPPED = "FULLY_EQUIPPED",
  EQUIPPED = "EQUIPPED",
  PARTIALLY_EQUIPPED = "PARTIALLY_EQUIPPED",
  UNEQUIPPED = "UNEQUIPPED",
  AMERICAN_FULLY_EQUIPPED = "AMERICAN_FULLY_EQUIPPED",
  AMERICAN_EQUIPPED = "AMERICAN_EQUIPPED",
  AMERICAN_PARTIALLY_EQUIPPED = "AMERICAN_PARTIALLY_EQUIPPED",
  AMERICAN_UNEQUIPPED = "AMERICAN_UNEQUIPPED",
}

export enum UnitInventoryRoomType {
  ENTRANCE = "ENTRANCE",
  LIVING = "LIVING",
  DINING = "DINING",
  KITCHEN = "KITCHEN",
  LIVING_WITH_OPEN_KITCHEN = "LIVING_WITH_OPEN_KITCHEN",
  OFFICE = "OFFICE",
  BEDROOM = "BEDROOM",
  BATHROOM = "BATHROOM",
  BALCONY = "BALCONY",
  SHOWER = "SHOWER",
  TOILET = "TOILET",
  CELLAR = "CELLAR",
  ATTIC = "ATTIC",
  GARDEN = "GARDEN",
  TERRACE = "TERRACE",
  PATIO = "PATIO",
  GARAGE = "GARAGE",
  PARKING = "PARKING",
  OTHER = "OTHER",
  REUNION = "REUNION",
  TECHNICAL = "TECHNICAL",
  INDIVIDUAL_OFFICE = "INDIVIDUAL_OFFICE",
  OPENSPACE = "OPENSPACE",
  WAREHOUSE = "WAREHOUSE",
}

export type ModelBuildingEventConnection = {
  __typename: "ModelBuildingEventConnection",
  items:  Array<BuildingEventDTO | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type BuildingEventDTO = {
  __typename: "BuildingEvent",
  id: string,
  buildingId: string,
  type: string,
  startDate: string,
  endDate: string,
  totalCost?: number | null,
  note?: string | null,
  writers?: Array< string > | null,
  readId: string,
  clientId: string,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type TransactionDTO = {
  __typename: "Transaction",
  id: string,
  status: TransactionStatus,
  snoozedUntil?: string | null,
  sequence?: number | null,
  statementDate: string,
  operationDate?: string | null,
  createdAt?: string | null,
  customValues?:  Array<CustomValueDTO > | null,
  remittanceInformationType?: RemittanceType | null,
  remittanceInformation?: string | null,
  remittanceInformationRaw?: string | null,
  additionalInformation?: string | null,
  structuredCommunication?: string | null,
  bankTransactionCode?: string | null,
  proprietaryBankTransactionCode?: string | null,
  endToEndId?: string | null,
  mandateId?: string | null,
  creditorId?: string | null,
  purposeCode?: string | null,
  internalReference?: string | null,
  comment?: string | null,
  exclusionReason?: TransactionExclusionReason | null,
  exclusionComment?: string | null,
  excludedAt?: string | null,
  excludedBy?: string | null,
  amount: number,
  bankAccountId: string,
  bankAccount?: BankAccountDTO | null,
  counterpartName?: string | null,
  counterpartDisplayName?: string | null,
  counterpartAccountNumber?: string | null,
  origin: TransactionOrigin,
  sourceChannel?: TransactionSourceChannel | null,
  nativeTransactionId?: string | null,
  fingerprint?: string | null,
  linkedSourceChannels?: Array< TransactionSourceChannel > | null,
  proposedLeaseId?: string | null,
  proposedUnitId?: string | null,
  proposedContractorId?: string | null,
  proposedOwnerId?: string | null,
  proposedMatch?: number | null,
  proposedAllocation?: string | null,
  classification?: TransactionFlowType | null,
  classificationConfidence?: number | null,
  classificationReason?: TransactionClassificationReason | null,
  recurrence?: string | null,
  links?:  Array<TransactionLinkDTO > | null,
  postings?: ModelPostingConnection | null,
  updatedAt: string,
  readers?: Array< string > | null,
  readId: string,
  clientId: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export enum TransactionStatus {
  TO_RECONCILE = "TO_RECONCILE",
  PARTIALLY_RECONCILED = "PARTIALLY_RECONCILED",
  RECONCILED = "RECONCILED",
  EXCLUDED = "EXCLUDED",
  IGNORE = "IGNORE",
  SNOOZED = "SNOOZED",
}

export enum TransactionExclusionReason {
  PRIVATE_MOVEMENT = "PRIVATE_MOVEMENT",
  INTERNAL_TRANSFER = "INTERNAL_TRANSFER",
  DUPLICATE = "DUPLICATE",
  HANDLED_OUTSIDE = "HANDLED_OUTSIDE",
  OTHER = "OTHER",
}

export enum RemittanceType {
  structured = "structured",
  unstructured = "unstructured",
}

export enum TransactionFlowType {
  RENT = "RENT",
  SUPPLIER = "SUPPLIER",
  BANK_FEE = "BANK_FEE",
  CREDIT = "CREDIT",
  INTERNAL_TRANSFER = "INTERNAL_TRANSFER",
  OWNER = "OWNER",
  FEES = "FEES",
  CALL_FOR_FUNDS = "CALL_FOR_FUNDS",
  DEPOSIT = "DEPOSIT",
  MISC_OPERATION = "MISC_OPERATION",
  UNKNOWN = "UNKNOWN",
}


export enum TransactionClassificationReason {
  INTERNAL_ACCOUNT = "INTERNAL_ACCOUNT",
  OWNER_ACCOUNT = "OWNER_ACCOUNT",
  AGENCY_ACCOUNT = "AGENCY_ACCOUNT",
  COUNTERPARTY_IDENTITY = "COUNTERPARTY_IDENTITY",
  BANK_FEE_CODE = "BANK_FEE_CODE",
  INTEREST_CODE = "INTEREST_CODE",
  LOAN_CODE = "LOAN_CODE",
  CARD_OR_CASH_CODE = "CARD_OR_CASH_CODE",
  TAX_CODE = "TAX_CODE",
  RETURN_CODE = "RETURN_CODE",
  MATCHED_TARGET = "MATCHED_TARGET",
  MANUAL = "MANUAL",
  NO_SIGNAL = "NO_SIGNAL",
  COUNTERPARTY_ROLE_DIRECTION = "COUNTERPARTY_ROLE_DIRECTION",
}

export enum TransactionSourceChannel {
  PONTO = "PONTO",
  MYBANX = "MYBANX",
  CODA = "CODA",
  MANUAL = "MANUAL",
  EXACT_ONLINE = "EXACT_ONLINE",
}

export enum TransactionOrigin {
  MANUAL = "MANUAL",
  BANK = "BANK",
  ASSUMED = "ASSUMED",
}

export type TransactionLinkDTO = {
  __typename: "TransactionLink",
  amount: number,
  linkId: string,
  linkType: TransactionLinkType,
};

export enum TransactionLinkType {
  CONTACT = "CONTACT",
  LEASE = "LEASE",
  OWNER = "OWNER",
}

export type LeaseVariousOperationDTO = {
  __typename: "LeaseVariousOperation",
  id: string,
  accountLabelIds?: Array< string > | null,
  amount: number,
  billingMode?: LeaseVariousOperationBillingMode | null,
  contactId: string,
  createdAt: string,
  createdBy?: ContactDTO | null,
  dueDateDaysAfterPeriodStart?: number | null,
  endDate: string,
  indexationBaseAmount?: number | null,
  indexationBaseIndexDate?: string | null,
  indexationFrozen?: boolean | null,
  invoiceSenderId?: string | null,
  invoiceSender?: ContactDTO | null,
  issueLeadDays?: number | null,
  label?: string | null,
  lastInvoiceDate?: string | null,
  leaseId: string,
  lease?: LeaseDTO | null,
  leaseVariousOperationHistories?:  Array<LeaseVariousOperationHistoryDTO > | null,
  operationType: LeaseVariousOperationType,
  paymentFrequency: LeasePaymentFrequency,
  paymentInvoicePeriod: LeasePaymentInvoicePeriod,
  paymentInvoicePeriodCustomDay?: number | null,
  periodNature?: LeaseVariousOperationPeriodNature | null,
  reason?: string | null,
  separateInvoice: boolean,
  startDate: string,
  type: VariousOperationType,
  unit?: UnitDTO | null,
  unitId: string,
  vatRateId?: string | null,
  vatRate?: VatRateDTO | null,
  readId: string,
  readers?: Array< string > | null,
  clientId: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type LeaseVariousOperationHistoryDTO = {
  __typename: "LeaseVariousOperationHistory",
  periodFrom: string,
  periodTo: string,
  amount: number,
};

export enum LeaseVariousOperationBillingMode {
  IMMEDIATE = "IMMEDIATE",
  OWN_SCHEDULE = "OWN_SCHEDULE",
  WITH_RENT = "WITH_RENT",
}

export enum LeaseVariousOperationPeriodNature {
  EVENT = "EVENT",
  OWN_PERIOD = "OWN_PERIOD",
  RENT_ALIGNED = "RENT_ALIGNED",
}

export enum LeaseVariousOperationType {
  DISCOUNT = "DISCOUNT",
  CHARGE = "CHARGE",
  FIXED_CHARGE = "FIXED_CHARGE",
  PROVISIONED_CHARGE = "PROVISIONED_CHARGE",
  SERVICE = "SERVICE",
}

export enum VariousOperationType {
  ONE_TIME = "ONE_TIME",
  END_WITH_LEASE = "END_WITH_LEASE",
  RECURRING = "RECURRING",
}

export enum PostingForeignType {
  TRANSACTION_PENDING_BALANCE = "TRANSACTION_PENDING_BALANCE",
  TRANSACTION_RECONCILIATION = "TRANSACTION_RECONCILIATION",
  BILLING_ITEM = "BILLING_ITEM",
}

export enum PostingTenantShareMode {
  OWNER = "OWNER",
  SPLIT = "SPLIT",
  TENANT = "TENANT",
}

export enum PostingTenantShareBasis {
  BY_NATURE = "BY_NATURE",
  DECIDED = "DECIDED",
  LEARNED = "LEARNED",
  LEASE = "LEASE",
  LEGAL_GRID = "LEGAL_GRID",
}

export type PostingTenantShareDTO = {
  __typename: "PostingTenantShare",
  basis: PostingTenantShareBasis,
  mode: PostingTenantShareMode,
  percentage?: number | null,
};

export type PostingTenantLandingDTO = {
  __typename: "PostingTenantLanding",
  amount: number,
  amountVatExcluded?: number | null,
  days: number,
  leaseId: string,
  periodFrom: string,
  periodTo: string,
  statementId?: string | null,
  vatAmount?: number | null,
};

export type PostingTenantLandingInput = {
  amount: number,
  amountVatExcluded?: number | null,
  days: number,
  leaseId: string,
  periodFrom: string,
  periodTo: string,
  statementId?: string | null,
  vatAmount?: number | null,
};

export type PostingTenantShareInput = {
  basis: PostingTenantShareBasis,
  mode: PostingTenantShareMode,
  percentage?: number | null,
};

export enum VatRateKind {
  EXEMPT = "EXEMPT",
  INTRA_EU = "INTRA_EU",
  REVERSE_CHARGE = "REVERSE_CHARGE",
  STANDARD = "STANDARD",
}

export enum BankCheckResult {
  EXACT = "EXACT",
  MAYBE = "MAYBE",
  NONE = "NONE",
}

export enum ChargeCheckpointState {
  BLOCKED = "BLOCKED",
  NA = "NA",
  PASSED = "PASSED",
  TO_CONFIRM = "TO_CONFIRM",
}

export enum ChargeSettlementIssue {
  BANK_CHECK_UNRESOLVED = "BANK_CHECK_UNRESOLVED",
  CREDIT_NOTE_WITHOUT_REFERENCE = "CREDIT_NOTE_WITHOUT_REFERENCE",
  DIRECT_DEBIT_NOT_CONFIRMED = "DIRECT_DEBIT_NOT_CONFIRMED",
  MORE_THAN_ONE_ORDER = "MORE_THAN_ONE_ORDER",
  NO_PAYMENT_MODE = "NO_PAYMENT_MODE",
  ORDER_AGAINST_PAYMENT_MODE = "ORDER_AGAINST_PAYMENT_MODE",
  OWNER_PAYS_MIXED = "OWNER_PAYS_MIXED",
  PAID_BY_TENANT_UNSUPPORTED = "PAID_BY_TENANT_UNSUPPORTED",
  PARTS_DO_NOT_COVER_TOTAL = "PARTS_DO_NOT_COVER_TOTAL",
  PART_AMOUNT_INVALID = "PART_AMOUNT_INVALID",
  PAYMENT_MODE_CHANGED = "PAYMENT_MODE_CHANGED",
  PORTAL_WITHOUT_REFERENCE = "PORTAL_WITHOUT_REFERENCE",
  RESERVED_PART_KIND = "RESERVED_PART_KIND",
}

export enum PaymentModeSource {
  OWNER_EXCEPTION = "OWNER_EXCEPTION",
  SUPPLIER_DEFAULT = "SUPPLIER_DEFAULT",
  USER = "USER",
}

export enum SettlementPartKind {
  ALREADY_PAID = "ALREADY_PAID",
  CREDIT_NOTE = "CREDIT_NOTE",
  EXPECTED_DEBIT = "EXPECTED_DEBIT",
  ORDER = "ORDER",
  OWNER_PAYS = "OWNER_PAYS",
  WITHHELD = "WITHHELD",
}

export enum SupplierPaymentMode {
  DIRECT_DEBIT = "DIRECT_DEBIT",
  PAID_BY_OWNER = "PAID_BY_OWNER",
  PAID_BY_TENANT = "PAID_BY_TENANT",
  PORTAL = "PORTAL",
  TRANSFER = "TRANSFER",
}

export type ChargeSettlementPartDTO = {
  __typename: "ChargeSettlementPart",
  amount: number,
  executeOn?: string | null,
  kind: SettlementPartKind,
  reference?: string | null,
};

export type ChargeSettlementPartInput = {
  amount: number,
  executeOn?: string | null,
  kind: SettlementPartKind,
  reference?: string | null,
};

export type ChargeSettlementDTO = {
  __typename: "ChargeSettlement",
  bankCheck?: BankCheckResult | null,
  modeResolved?: SupplierPaymentMode | null,
  modeSource?: PaymentModeSource | null,
  parts:  Array<ChargeSettlementPartDTO >,
};

export type ChargeSettlementInput = {
  bankCheck?: BankCheckResult | null,
  modeResolved?: SupplierPaymentMode | null,
  modeSource?: PaymentModeSource | null,
  parts: Array< ChargeSettlementPartInput >,
};

export type SupplierPaymentModeExceptionDTO = {
  __typename: "SupplierPaymentModeException",
  confirmedAt: string,
  confirmedBy: string,
  mode: SupplierPaymentMode,
  ownerId: string,
};

export type SupplierPaymentModeExceptionInput = {
  confirmedAt: string,
  confirmedBy: string,
  mode: SupplierPaymentMode,
  ownerId: string,
};

export type SupplierPaymentModeChangeDTO = {
  __typename: "SupplierPaymentModeChange",
  changedAt: string,
  changedBy: string,
  mode?: SupplierPaymentMode | null,
  ownerId?: string | null,
  previousMode?: SupplierPaymentMode | null,
};

export type SupplierPaymentModeChangeInput = {
  changedAt: string,
  changedBy: string,
  mode?: SupplierPaymentMode | null,
  ownerId?: string | null,
  previousMode?: SupplierPaymentMode | null,
};

export enum PostingStatus {
  DRAFT = "DRAFT",
  PAID_BY_OWNER = "PAID_BY_OWNER",
  TO_BE_PAID_BY_TENANT = "TO_BE_PAID_BY_TENANT",
  TO_BE_PAID_BY_OWNER = "TO_BE_PAID_BY_OWNER",
  CANCELLED_BY_REVERSAL = "CANCELLED_BY_REVERSAL",
  REVERSAL = "REVERSAL",
}

export enum PostingChargeType {
  OWNER = "OWNER",
  TENANT = "TENANT",
  OWNER_VACANCY = "OWNER_VACANCY",
}

export enum StatementSource {
  AUTOMATIC = "AUTOMATIC",
  MANUAL = "MANUAL",
}

export enum StatementStatus {
  TO_VALIDATE = "TO_VALIDATE",
  DONE = "DONE",
}

export type ModelAgencyRateStatementConnection = {
  __typename: "ModelAgencyRateStatementConnection",
  items:  Array<AgencyRateStatementDTO | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type AgencyRateStatementDTO = {
  __typename: "AgencyRateStatement",
  id: string,
  agencyRate?: AgencyRateDTO | null,
  agencyRateId: string,
  statement?: StatementDTO | null,
  statementId: string,
  unitAmounts?:  Array<AgencyRateStatementAmountDTO > | null,
  totalAmountRateable: number,
  totalFixedAmount: number,
  readId: string,
  clientId: string,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type AgencyRateDTO = {
  __typename: "AgencyRate",
  id: string,
  amountDetails:  Array<AgencyRateAmountDetailDTO >,
  rateWhenVacant?: AgencyRateWhenVacantDTO | null,
  amountMinimumFees?: number | null,
  custom: boolean,
  feesAppliedTo: AgencyRateFeesType,
  includedInAmount?: Array< AgencyRateIncludedAmount > | null,
  name: string,
  owners?: ModelAgencyRateOwnerConnection | null,
  repartitionType: AgencyRateRepartitionType,
  type: AgencyRateType,
  unitType: Array< UnitType >,
  vatRateId?: string | null,
  unitIds?: Array< string | null > | null,
  vatRate?: VatRateDTO | null,
  readId: string,
  clientId: string,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type AgencyRateAmountDetailDTO = {
  __typename: "AgencyRateAmountDetail",
  amountType: AgencyRateAmountDetailType,
  endAmount?: number | null,
  feeApplied: number,
  startAmount: number,
};

export enum AgencyRateAmountDetailType {
  PRICE = "PRICE",
  PERCENTAGE = "PERCENTAGE",
}

export type AgencyRateWhenVacantDTO = {
  __typename: "AgencyRateWhenVacant",
  amount: number,
  type: AgencyRateAmountDetailType,
};

export enum AgencyRateFeesType {
  AMOUNT_COLLECTED = "AMOUNT_COLLECTED",
  EXPECTED_RENT = "EXPECTED_RENT",
}

export enum AgencyRateIncludedAmount {
  RENT_WITHOUT_CHARGES = "RENT_WITHOUT_CHARGES",
  PROVISIONED_CHARGES = "PROVISIONED_CHARGES",
  FIXED_CHARGES = "FIXED_CHARGES",
  RENTAL_DISCOUNT = "RENTAL_DISCOUNT",
  INDEXED_PRICE = "INDEXED_PRICE",
  VARIOUS_OPERATION_CHARGE = "VARIOUS_OPERATION_CHARGE",
  VARIOUS_OPERATION_SERVICE = "VARIOUS_OPERATION_SERVICE",
}

export type ModelAgencyRateOwnerConnection = {
  __typename: "ModelAgencyRateOwnerConnection",
  items:  Array<AgencyRateOwnerDTO | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type AgencyRateOwnerDTO = {
  __typename: "AgencyRateOwner",
  id: string,
  agencyRateId: string,
  contactId: string,
  agencyRate?: AgencyRateDTO | null,
  owner?: ContactDTO | null,
  readId: string,
  clientId: string,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export enum AgencyRateRepartitionType {
  BY_UNIT = "BY_UNIT",
  ON_PROPERTY = "ON_PROPERTY",
}

export enum AgencyRateType {
  FIXED = "FIXED",
  DECREASING = "DECREASING",
}

export type AgencyRateStatementAmountDTO = {
  __typename: "AgencyRateStatementAmount",
  unitId?: string | null,
  amountRateable: number,
  fixedAmount: number,
};

export type ModelRepaymentStatementConnection = {
  __typename: "ModelRepaymentStatementConnection",
  items:  Array<RepaymentStatementDTO | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type RepaymentStatementDTO = {
  __typename: "RepaymentStatement",
  id: string,
  accountOwnership: RepaymentStatementAccountOwnership,
  delaysCleared: number,
  expectedRent: number,
  lease?: LeaseDTO | null,
  leaseId: string,
  rentsCollected: number,
  repaymentStatementDetails:  Array<RepaymentStatementDetail >,
  statement?: StatementDTO | null,
  statementId: string,
  totalReceivedInJointAccount: number,
  totalExpectedInOwnerAccount: number,
  unpaidRents: number,
  readId: string,
  clientId: string,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export enum RepaymentStatementAccountOwnership {
  OWNER_ACCOUNT = "OWNER_ACCOUNT",
  JOINT_ACCOUNT = "JOINT_ACCOUNT",
}

export type RepaymentStatementDetail = {
  __typename: "RepaymentStatementDetail",
  class: number,
  customLabel?: string | null,
  invoiceId: string,
  invoicePostingId: string,
  originalTotalAmount: number,
  periodFrom: string,
  periodTo: string,
  totalAmount: number,
  transactionId?: string | null,
  type: RepaymentStatementDetailType,
};

export enum RepaymentStatementDetailType {
  EXPECTED = "EXPECTED",
  RECEIVED = "RECEIVED",
  UNPAID = "UNPAID",
}

export enum StatementType {
  CHARGES = "CHARGES",
  FEES = "FEES",
  RE_PAYMENT = "RE_PAYMENT",
}

export enum StatementViewType {
  DETAILED = "DETAILED",
  SIMPLIFIED = "SIMPLIFIED",
}

export enum PaymentInitiationChannel {
  API_PUSH = "API_PUSH",
  MANUAL = "MANUAL",
  SEPA_FILE = "SEPA_FILE",
}

export enum PaymentOrderStatus {
  SUGGESTED = "SUGGESTED",
  TO_VALIDATE = "TO_VALIDATE",
  APPROVED = "APPROVED",
  ISSUED = "ISSUED",
  EXECUTED = "EXECUTED",
  RECONCILED = "RECONCILED",
  REJECTED = "REJECTED",
  BLOCKED = "BLOCKED",
  CANCELLED = "CANCELLED",
}

export enum PaymentOrderType {
  FEE = "FEE",
  PAYOUT = "PAYOUT",
  REFUND = "REFUND",
  SUPPLIER = "SUPPLIER",
}

export enum PaymentBatchStatus {
  IN_PREPARATION = "IN_PREPARATION",
  SENT = "SENT",
  CANCELLED = "CANCELLED",
}

export enum PaymentOrderAnomaly {
  AMOUNT_OUTLIER = "AMOUNT_OUTLIER",
  IBAN_CHANGED = "IBAN_CHANGED",
}

export enum PaymentOrderFixField {
  ACCOUNT = "ACCOUNT",
  AMOUNT = "AMOUNT",
  DUE_DATE = "DUE_DATE",
}

export enum SepaBatchFailureReason {
  ACCOUNT_MISMATCH = "ACCOUNT_MISMATCH",
  ACCOUNT_NOT_ELIGIBLE = "ACCOUNT_NOT_ELIGIBLE",
  ALREADY_IN_A_SENT_BATCH = "ALREADY_IN_A_SENT_BATCH",
  ALREADY_ISSUED = "ALREADY_ISSUED",
  BATCH_ALREADY_SENT = "BATCH_ALREADY_SENT",
  BATCH_NOT_FOUND = "BATCH_NOT_FOUND",
  CATCH_UP_TO_VALIDATE = "CATCH_UP_TO_VALIDATE",
  FEE_NOT_FUNDED = "FEE_NOT_FUNDED",
  FILE_OUTDATED = "FILE_OUTDATED",
  NOTHING_GENERATED = "NOTHING_GENERATED",
  NOT_APPROVED = "NOT_APPROVED",
  NOT_FOUND = "NOT_FOUND",
  NOT_FUNDED = "NOT_FUNDED",
  ORDERS_CHANGED = "ORDERS_CHANGED",
}

export enum PaymentOrderActionFailureReason {
  ACCOUNT_NOT_ELIGIBLE = "ACCOUNT_NOT_ELIGIBLE",
  AMOUNT_NOT_POSITIVE = "AMOUNT_NOT_POSITIVE",
  ANOMALY_NOT_ACKNOWLEDGED = "ANOMALY_NOT_ACKNOWLEDGED",
  CHANNEL_NOT_AVAILABLE = "CHANNEL_NOT_AVAILABLE",
  FEE_COLLECTED = "FEE_COLLECTED",
  FEE_NOT_FUNDED = "FEE_NOT_FUNDED",
  IBAN_NOT_VERIFIED = "IBAN_NOT_VERIFIED",
  IN_SEPA_FILE = "IN_SEPA_FILE",
  NO_BENEFICIARY_ACCOUNT = "NO_BENEFICIARY_ACCOUNT",
  INVALID_DEADLINE = "INVALID_DEADLINE",
  INVALID_FIX = "INVALID_FIX",
  INVALID_STATUS = "INVALID_STATUS",
  NOT_FOUND = "NOT_FOUND",
  NOT_FUNDED = "NOT_FUNDED",
  NOT_PREPARER = "NOT_PREPARER",
  NOT_REISSUABLE = "NOT_REISSUABLE",
  RECONCILIATION_COVERED = "RECONCILIATION_COVERED",
  SELF_APPROVAL_FORBIDDEN = "SELF_APPROVAL_FORBIDDEN",
  SUGGESTION_NOT_RESOLVED = "SUGGESTION_NOT_RESOLVED",
  VERSION_CONFLICT = "VERSION_CONFLICT",
}

export enum OpenInvoiceType {
  FEE = "FEE",
  SUPPLIER = "SUPPLIER",
}

export enum OpenInvoiceIbanState {
  MISSING = "MISSING",
  OWN = "OWN",
  TO_VERIFY = "TO_VERIFY",
  VERIFIED = "VERIFIED",
}

export enum OpenInvoiceAllocationState {
  ALLOCATED = "ALLOCATED",
  PENDING = "PENDING",
}

export enum OpenInvoiceAllocationBasis {
  CONSUMPTION = "CONSUMPTION",
  KEY = "KEY",
  OTHER = "OTHER",
  OWNER = "OWNER",
}

export enum OpenInvoiceListLens {
  ALL = "ALL",
  ALLOC = "ALLOC",
  IBAN = "IBAN",
  READY = "READY",
}

export enum OpenInvoiceGrouping {
  ACCOUNT = "ACCOUNT",
  OWNER = "OWNER",
  STATE = "STATE",
  TYPE = "TYPE",
}

export enum CreateOrderFailureReason {
  ACCOUNT_NOT_ELIGIBLE = "ACCOUNT_NOT_ELIGIBLE",
  ALREADY_HAS_ORDER = "ALREADY_HAS_ORDER",
  AMOUNT_NOT_POSITIVE = "AMOUNT_NOT_POSITIVE",
  IBAN_MISSING = "IBAN_MISSING",
  NOT_ALLOCATED = "NOT_ALLOCATED",
  NOT_FOUND = "NOT_FOUND",
  NOT_OPEN = "NOT_OPEN",
  PAY_DATE_IN_PAST = "PAY_DATE_IN_PAST",
}


export enum RentCellStatus {
  PAID = "PAID",
  PARTIAL = "PARTIAL",
  LATE = "LATE",
  VACANT = "VACANT",
  EMPTY = "EMPTY",
  FUTURE = "FUTURE",
  NONE = "NONE",
  COVERED = "COVERED",
}


export enum RentValueMode {
  COLLECTED = "COLLECTED",
  EXPECTED = "EXPECTED",
  OUTSTANDING = "OUTSTANDING",
}


export enum RentGroupBy {
  BUILDING = "BUILDING",
  OWNER = "OWNER",
}


export enum RentExportLayout {
  MATRIX = "MATRIX",
  MATRIX_BY_CATEGORY = "MATRIX_BY_CATEGORY",
  OWNER_SUMMARY = "OWNER_SUMMARY",
}


export enum RentExportStatus {
  PREPARING = "PREPARING",
  READY = "READY",
  TOO_LARGE = "TOO_LARGE",
}


export enum RentSortField {
  UNPAID_FIRST = "UNPAID_FIRST",
  LEASE_REF = "LEASE_REF",
  MONTH = "MONTH",
  ROW_TOTAL = "ROW_TOTAL",
  TENANT_UNIT = "TENANT_UNIT",
  UNIT = "UNIT",
}


export enum RentRowKind {
  LEASE = "LEASE",
  UNIT = "UNIT",
}


export enum SortDirection {
  ASC = "ASC",
  DESC = "DESC",
}


export type PaymentOrderDTO = {
  __typename: "PaymentOrder",
  id: string,
  amount: number,
  anomalies?: Array< PaymentOrderAnomaly > | null,
  anomalyAcknowledgedAt?: string | null,
  anomalyAcknowledgedBy?: string | null,
  anomalyPreviousIban?: string | null,
  anomalyReferenceAmount?: number | null,
  approvedAt?: string | null,
  approvedBy?: string | null,
  bankAccountId: string,
  bankAccount?: BankAccountDTO | null,
  buildingId?: string | null,
  cancelledAt?: string | null,
  cancelledBy?: string | null,
  cancelReasonCode?: string | null,
  channel?: PaymentInitiationChannel | null,
  confirmationDeadlineDate?: string | null,
  counterpartAccountNumber: string,
  counterpartAccountUpdatedAt?: string | null,
  counterpartAccountUpdatedBy?: string | null,
  counterpartContactId?: string | null,
  counterpartContact?: ContactDTO | null,
  counterpartName: string,
  counterpartRemittanceInformation?: string | null,
  createdBy?: string | null,
  dueDate: string,
  executedAt?: string | null,
  executedBy?: string | null,
  executedDate?: string | null,
  executedTransactionId?: string | null,
  feeArrearsId?: string | null,
  fixedAt?: string | null,
  fixedBy?: string | null,
  fundAllocations?:  Array<PaymentOrderFundAllocationDTO > | null,
  fundAmounts?: PaymentOrderFundAmountsDTO | null,
  invoiceId?: string | null,
  invoice?: InvoiceDTO | null,
  issuedAt?: string | null,
  issuedBy?: string | null,
  ownerContactId?: string | null,
  paymentBatchId?: string | null,
  paymentBatch?: PaymentBatchDTO | null,
  periodFrom?: string | null,
  reconciledAt?: string | null,
  recurringPaymentTemplateId?: string | null,
  reference: string,
  reissuedFromOrderId?: string | null,
  reissuedOrderId?: string | null,
  rejectedAt?: string | null,
  rejectedBy?: string | null,
  rejectedField?: PaymentOrderFixField | null,
  rejectedReason?: string | null,
  requestedAmount?: number | null,
  reroutedAt?: string | null,
  reroutedBy?: string | null,
  reroutedFromBankAccountId?: string | null,
  status: PaymentOrderStatus,
  submittedAt?: string | null,
  submittedBy?: string | null,
  suggestion?: PaymentOrderSuggestionDTO | null,
  suggestionDeclinedReason?: string | null,
  suggestionResolved?: boolean | null,
  tenantRechargeableRatio?: number | null,
  type: PaymentOrderType,
  unitId?: string | null,
  readId: string,
  clientId: string,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type PaymentOrderSuggestionDTO = {
  __typename: "PaymentOrderSuggestion",
  original: number,
  suggested: number,
  reason: string,
};

export type PaymentOrderSuggestionInput = {
  original: number,
  suggested: number,
  reason: string,
};

export type PaymentOrderFundAllocationDTO = {
  __typename: "PaymentOrderFundAllocation",
  accountLabelId?: string | null,
  amount: number,
  fundId: string,
  kind: HoaFundKind,
};

export type PaymentOrderFundAllocationInput = {
  accountLabelId?: string | null,
  amount: number,
  fundId: string,
  kind: HoaFundKind,
};

export type PaymentOrderFundAmountsDTO = {
  __typename: "PaymentOrderFundAmounts",
  reserveFundAmount: number,
  workingCapitalAmount: number,
};

export type PaymentOrderFundAmountsInput = {
  reserveFundAmount: number,
  workingCapitalAmount: number,
};

export type CreatePaymentOrderInput = {
  id?: string | null,
  amount: number,
  anomalies?: Array< PaymentOrderAnomaly > | null,
  anomalyAcknowledgedAt?: string | null,
  anomalyAcknowledgedBy?: string | null,
  anomalyPreviousIban?: string | null,
  anomalyReferenceAmount?: number | null,
  approvedAt?: string | null,
  approvedBy?: string | null,
  bankAccountId: string,
  buildingId?: string | null,
  cancelledAt?: string | null,
  cancelledBy?: string | null,
  cancelReasonCode?: string | null,
  channel?: PaymentInitiationChannel | null,
  confirmationDeadlineDate?: string | null,
  counterpartAccountNumber: string,
  counterpartAccountUpdatedAt?: string | null,
  counterpartAccountUpdatedBy?: string | null,
  counterpartContactId?: string | null,
  counterpartName: string,
  counterpartRemittanceInformation?: string | null,
  createdBy?: string | null,
  dueDate: string,
  executedAt?: string | null,
  executedBy?: string | null,
  executedDate?: string | null,
  executedTransactionId?: string | null,
  feeArrearsId?: string | null,
  fixedAt?: string | null,
  fixedBy?: string | null,
  fundAllocations?: Array< PaymentOrderFundAllocationInput > | null,
  fundAmounts?: PaymentOrderFundAmountsInput | null,
  invoiceId?: string | null,
  issuedAt?: string | null,
  issuedBy?: string | null,
  ownerContactId?: string | null,
  paymentBatchId?: string | null,
  periodFrom?: string | null,
  reconciledAt?: string | null,
  recurringPaymentTemplateId?: string | null,
  reference: string,
  reissuedFromOrderId?: string | null,
  reissuedOrderId?: string | null,
  rejectedAt?: string | null,
  rejectedBy?: string | null,
  rejectedField?: PaymentOrderFixField | null,
  rejectedReason?: string | null,
  requestedAmount?: number | null,
  reroutedAt?: string | null,
  reroutedBy?: string | null,
  reroutedFromBankAccountId?: string | null,
  status: PaymentOrderStatus,
  submittedAt?: string | null,
  submittedBy?: string | null,
  suggestion?: PaymentOrderSuggestionInput | null,
  suggestionDeclinedReason?: string | null,
  suggestionResolved?: boolean | null,
  tenantRechargeableRatio?: number | null,
  type: PaymentOrderType,
  unitId?: string | null,
  readId: string,
  clientId: string,
  _version?: number | null,
};

export type ModelPaymentOrderConditionInput = {
  status?: { eq?: PaymentOrderStatus | null, ne?: PaymentOrderStatus | null } | null,
  and?: Array< ModelPaymentOrderConditionInput | null > | null,
  or?: Array< ModelPaymentOrderConditionInput | null > | null,
  not?: ModelPaymentOrderConditionInput | null,
};

export type CreatePaymentOrderMutationVariables = {
  input: CreatePaymentOrderInput,
  condition?: ModelPaymentOrderConditionInput | null,
};

export type CreatePaymentOrderMutation = {
  createPaymentOrder?: PaymentOrderDTO | null,
};

export type UpdatePaymentOrderInput = {
  id: string,
  amount?: number | null,
  anomalies?: Array< PaymentOrderAnomaly > | null,
  anomalyAcknowledgedAt?: string | null,
  anomalyAcknowledgedBy?: string | null,
  anomalyPreviousIban?: string | null,
  anomalyReferenceAmount?: number | null,
  approvedAt?: string | null,
  approvedBy?: string | null,
  bankAccountId?: string | null,
  buildingId?: string | null,
  cancelledAt?: string | null,
  cancelledBy?: string | null,
  cancelReasonCode?: string | null,
  channel?: PaymentInitiationChannel | null,
  confirmationDeadlineDate?: string | null,
  counterpartAccountNumber?: string | null,
  counterpartAccountUpdatedAt?: string | null,
  counterpartAccountUpdatedBy?: string | null,
  counterpartContactId?: string | null,
  counterpartName?: string | null,
  counterpartRemittanceInformation?: string | null,
  createdBy?: string | null,
  dueDate?: string | null,
  executedAt?: string | null,
  executedBy?: string | null,
  executedDate?: string | null,
  executedTransactionId?: string | null,
  feeArrearsId?: string | null,
  fundAllocations?: Array< PaymentOrderFundAllocationInput > | null,
  fundAmounts?: PaymentOrderFundAmountsInput | null,
  invoiceId?: string | null,
  fixedAt?: string | null,
  fixedBy?: string | null,
  issuedAt?: string | null,
  issuedBy?: string | null,
  ownerContactId?: string | null,
  paymentBatchId?: string | null,
  periodFrom?: string | null,
  reconciledAt?: string | null,
  recurringPaymentTemplateId?: string | null,
  reference?: string | null,
  reissuedFromOrderId?: string | null,
  reissuedOrderId?: string | null,
  rejectedAt?: string | null,
  rejectedBy?: string | null,
  rejectedReason?: string | null,
  requestedAmount?: number | null,
  rejectedField?: PaymentOrderFixField | null,
  reroutedAt?: string | null,
  reroutedBy?: string | null,
  reroutedFromBankAccountId?: string | null,
  status?: PaymentOrderStatus | null,
  submittedAt?: string | null,
  submittedBy?: string | null,
  suggestion?: PaymentOrderSuggestionInput | null,
  suggestionDeclinedReason?: string | null,
  suggestionResolved?: boolean | null,
  tenantRechargeableRatio?: number | null,
  type?: PaymentOrderType | null,
  unitId?: string | null,
  readId?: string | null,
  clientId?: string | null,
  _version?: number | null,
};

export type UpdatePaymentOrderMutationVariables = {
  input: UpdatePaymentOrderInput,
  condition?: ModelPaymentOrderConditionInput | null,
};

export type UpdatePaymentOrderMutation = {
  updatePaymentOrder?: PaymentOrderDTO | null,
};

export type PaymentBatchDTO = {
  __typename: "PaymentBatch",
  id: string,
  bankAccountId: string,
  bankAccount?: BankAccountDTO | null,
  clientStatusKey?: string | null,
  currentVersion?: number | null,
  number: string,
  outdated?: boolean | null,
  sentAt?: string | null,
  sentBy?: string | null,
  status: PaymentBatchStatus,
  versions?: Array<PaymentBatchVersionDTO | null> | null,
  readId: string,
  clientId: string,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type PaymentBatchExclusionDTO = {
  __typename: "PaymentBatchExclusion",
  orderId: string,
  reason: SepaBatchFailureReason,
};

export type PaymentBatchExclusionInput = {
  orderId: string,
  reason: SepaBatchFailureReason,
};

export type PaymentBatchVersionDTO = {
  __typename: "PaymentBatchVersion",
  version: number,
  exclusions?: Array<PaymentBatchExclusionDTO | null> | null,
  fileKey: string,
  fingerprint?: string | null,
  generatedAt: string,
  generatedBy?: string | null,
  orderCount: number,
  totalAmount: number,
};

export type PaymentBatchVersionInput = {
  version: number,
  exclusions?: Array<PaymentBatchExclusionInput | null> | null,
  fileKey: string,
  fingerprint?: string | null,
  generatedAt: string,
  generatedBy?: string | null,
  orderCount: number,
  totalAmount: number,
};

export type CreatePaymentBatchInput = {
  id?: string | null,
  bankAccountId: string,
  clientStatusKey?: string | null,
  currentVersion?: number | null,
  number: string,
  outdated?: boolean | null,
  sentAt?: string | null,
  sentBy?: string | null,
  status: PaymentBatchStatus,
  versions?: Array<PaymentBatchVersionInput | null> | null,
  readId: string,
  clientId: string,
  _version?: number | null,
};

export type UpdatePaymentBatchInput = {
  id: string,
  bankAccountId?: string | null,
  clientStatusKey?: string | null,
  currentVersion?: number | null,
  number?: string | null,
  outdated?: boolean | null,
  sentAt?: string | null,
  sentBy?: string | null,
  status?: PaymentBatchStatus | null,
  versions?: Array<PaymentBatchVersionInput | null> | null,
  readId?: string | null,
  clientId?: string | null,
  _version?: number | null,
};

export type ModelPaymentBatchConditionInput = {
  status?: { eq?: PaymentBatchStatus | null, ne?: PaymentBatchStatus | null } | null,
  currentVersion?: { eq?: number | null, ne?: number | null } | null,
  and?: Array< ModelPaymentBatchConditionInput | null > | null,
  or?: Array< ModelPaymentBatchConditionInput | null > | null,
  not?: ModelPaymentBatchConditionInput | null,
};

export type CreatePaymentBatchMutationVariables = {
  input: CreatePaymentBatchInput,
  condition?: ModelPaymentBatchConditionInput | null,
};

export type CreatePaymentBatchMutation = {
  createPaymentBatch?: PaymentBatchDTO | null,
};

export type UpdatePaymentBatchMutationVariables = {
  input: UpdatePaymentBatchInput,
  condition?: ModelPaymentBatchConditionInput | null,
};

export type UpdatePaymentBatchMutation = {
  updatePaymentBatch?: PaymentBatchDTO | null,
};

export enum InvoiceStatus {
  DRAFT = "DRAFT",
  INVOICED = "INVOICED",
  PAYMENT_FAILED = "PAYMENT_FAILED",
  POSTED = "POSTED",
  REVERSED = "REVERSED",
}


export enum InvoiceDisputeStatus {
  DOCUMENT = "DOCUMENT",
  LINES = "LINES",
}


export enum InvoiceDisputeScope {
  DOCUMENT = "DOCUMENT",
  LINE = "LINE",
}


export enum InvoiceDisputeLiftCause {
  MANUAL = "MANUAL",
  RECONCILED = "RECONCILED",
}


export enum InvoiceType {
  RENT = "RENT",
  STATEMENT = "STATEMENT",
  LEASE_VARIOUS_OPERATION = "LEASE_VARIOUS_OPERATION",
  VARIOUS_EXCEPTIONAL_REVENUE = "VARIOUS_EXCEPTIONAL_REVENUE",
  VARIOUS_OPERATION = "VARIOUS_OPERATION",
  VARIOUS_OPERATION_GUARANTY_CREATION = "VARIOUS_OPERATION_GUARANTY_CREATION",
  VARIOUS_OPERATION_GUARANTY_RELEASE = "VARIOUS_OPERATION_GUARANTY_RELEASE",
  COMPANY = "COMPANY",
}

export type LeasePriceHistoryDTO = {
  __typename: "LeasePriceHistory",
  id: string,
  previousTotalRentalPrice: number,
  totalRentalPrice: number,
  optimalTotalRentalPrice?: number | null,
  optimalTotalMonthlyCharges?: number | null,
  applicationDate: string,
  status: LeaseAmountUpdateStatus,
  comment?: string | null,
  amountDetails:  Array<LeasePriceHistoryDetailDTO >,
  type: LeasePriceHistoryType,
  communicationId?: string | null,
  communication?: CommunicationDTO | null,
  leaseId: string,
  lease?: LeaseDTO | null,
  createdAt?: string | null,
  readers?: Array< string > | null,
  readId: string,
  clientId: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export enum LeaseAmountUpdateStatus {
  DRAFT = "DRAFT",
  TO_PROCESS_CLIENT_ACCEPTED = "TO_PROCESS_CLIENT_ACCEPTED",
  TO_PROCESS_CLIENT_REFUSED = "TO_PROCESS_CLIENT_REFUSED",
  ACCEPTED_PROCESSED_NEED_TO_APPLY = "ACCEPTED_PROCESSED_NEED_TO_APPLY",
  APPLIED = "APPLIED",
  REFUSED = "REFUSED",
  OUTDATED = "OUTDATED",
  ERROR = "ERROR",
}

export type LeasePriceHistoryDetailDTO = {
  __typename: "LeasePriceHistoryDetail",
  unitId: string,
  indexationBaseIndex?: number | null,
  indexationNewIndex?: number | null,
  previousRentalPrice: number,
  newRentalPrice: number,
  rentalStatus: LeasePriceHistoryStatus,
  monthlyChargesStatus: LeasePriceHistoryStatus,
  optimalNewRentalPrice?: number | null,
  optimalNewMonthlyChargesPrice?: number | null,
  epb?: string | null,
  epbIssueDate?: string | null,
  oldestIndexForCorrectionFactorCalculation?: number | null,
  newestIndexForCorrectionFactorCalculation?: number | null,
  rentIndexedPriceAfterNewEpbReduction?: number | null,
  chargesIndexedPriceAfterNewEpbReduction?: number | null,
  correctionFactor?: number | null,
  chargesAmountsDetails?:  Array<LeasePriceHistoryChargeAmountsDetailsDTO > | null,
  reductionPercentage?: number | null,
  rentDifference?: number | null,
  rentReduction?: number | null,
  indexedRentAfterReduction?: number | null,
  chargesDifference?: number | null,
  chargesReduction?: number | null,
  indexedChargesAfterReduction?: number | null,
  previousYearIndexationNewIndex?: number | null,
  previousYearIndexedRent?: number | null,
  previousYearIndexedCharges?: number | null,
};

export enum LeasePriceHistoryStatus {
  INDEXED = "INDEXED",
  NON_INDEXED = "NON_INDEXED",
  INDEXED_WITH_CUSTOM_AMOUNT = "INDEXED_WITH_CUSTOM_AMOUNT",
  NOT_APPLICABLE = "NOT_APPLICABLE",
}

export type LeasePriceHistoryChargeAmountsDetailsDTO = {
  __typename: "LeasePriceHistoryChargeAmountsDetails",
  leaseVariousOperationId: string,
  previousMonthlyAmount: number,
  newMonthlyAmount: number,
  indexationBaseIndex?: number | null,
  indexationBaseAmount?: number | null,
  indexationBaseIndexDate?: string | null,
  indexed?: boolean | null,
};

export enum LeasePriceHistoryType {
  INDEXATION = "INDEXATION",
  ADJUSTMENT = "ADJUSTMENT",
  INITIAL_PRICE = "INITIAL_PRICE",
  TERMS_CHANGE = "TERMS_CHANGE",
}

export enum TrackingProvider {
  BPOST = "BPOST",
}

export type SignatureDocumentDTO = {
  __typename: "SignatureDocument",
  id: string,
  additionalMessage?: string | null,
  automaticRemindersDisabled?: boolean | null,
  communicationBody?: string | null,
  createdAt?: string | null,
  expirationDate?: string | null,
  fileIds?: Array< string > | null,
  foreignKey: string,
  foreignTableName: string,
  sentAt?: string | null,
  signatureMethods: Array< SignatureType >,
  signatureResults:  Array<SignatureDocumentResult >,
  status: SignatureDocumentStatus,
  externalStatus?: string | null,
  type: SignatureDocumentType,
  readers?: Array< string > | null,
  readId: string,
  clientId: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export enum SignatureType {
  EID = "EID",
  ITSME = "ITSME",
  SMSOTP = "SMSOTP",
  EMAILOTP = "EMAILOTP",
  MANUAL = "MANUAL",
}

export type SignatureDocumentResult = {
  __typename: "SignatureDocumentResult",
  openedDate?: string | null,
  signedDate?: string | null,
  signed?: boolean | null,
  signatureLink?: string | null,
  rejectReason?: string | null,
  lastSignInviteSentDate?: string | null,
  reminderDates?: Array< string > | null,
  trackingProvider?: TrackingProvider | null,
  trackingCode?: string | null,
  contactId: string,
};

export enum SignatureDocumentStatus {
  DRAFT = "DRAFT",
  PENDING = "PENDING",
  REJECTED = "REJECTED",
  SIGNED = "SIGNED",
  ERROR = "ERROR",
}

export enum SignatureDocumentType {
  DOCUMENT_TO_SIGN = "DOCUMENT_TO_SIGN",
  REGISTERED_LETTER = "REGISTERED_LETTER",
  LETTER = "LETTER",
}

export enum CommunicationErrorCode {
  BOUNCED = "BOUNCED",
  DOCUMENT_GENERATION_FAILED = "DOCUMENT_GENERATION_FAILED",
  INSUFFICIENT_CREDITS = "INSUFFICIENT_CREDITS",
  INVALID_ADDRESS = "INVALID_ADDRESS",
  LETTER_PROVIDER_FAILED = "LETTER_PROVIDER_FAILED",
  MAILBOX_FULL = "MAILBOX_FULL",
  MISSING_EMAIL_ADDRESS = "MISSING_EMAIL_ADDRESS",
  MISSING_PHONE_NUMBER = "MISSING_PHONE_NUMBER",
  REJECTED = "REJECTED",
  SENDER_NOT_CONFIGURED = "SENDER_NOT_CONFIGURED",
  SMS_INVALID_NUMBER = "SMS_INVALID_NUMBER",
  SMS_OPTED_OUT = "SMS_OPTED_OUT",
  SMS_REJECTED = "SMS_REJECTED",
  SMS_UNDELIVERED = "SMS_UNDELIVERED",
}

export enum CommunicationStatus {
  ERROR = "ERROR",
  DOWNLOADED = "DOWNLOADED",
  DRAFT = "DRAFT",
  IGNORED = "IGNORED",
  OUTDATED = "OUTDATED",
  SCHEDULED = "SCHEDULED",
  SENDING = "SENDING",
  SENT = "SENT",
  SENT_MANUALLY = "SENT_MANUALLY",
  SNOOZED = "SNOOZED",
  TO_SEND = "TO_SEND",
}

export enum CommunicationType {
  CUSTOM = "CUSTOM",
  CERTIFICATE_EXPIRED = "CERTIFICATE_EXPIRED",
  CERTIFICATE_UPCOMING_EXPIRATION = "CERTIFICATE_UPCOMING_EXPIRATION",
  DOCUMENT_SIGNATURE = "DOCUMENT_SIGNATURE",
  DOCUMENT_SIGNATURE_REMINDER = "DOCUMENT_SIGNATURE_REMINDER",
  DOCUMENT_SIGNED = "DOCUMENT_SIGNED",
  LEASE_ALLOW_PROFESSIONAL_ACTIVITY_ON = "LEASE_ALLOW_PROFESSIONAL_ACTIVITY_ON",
  LEASE_BANKING_INFO_UPDATE = "LEASE_BANKING_INFO_UPDATE",
  LEASE_CHARGES_ADJUSTMENT = "LEASE_CHARGES_ADJUSTMENT",
  LEASE_CONTRACT_EXTENDED = "LEASE_CONTRACT_EXTENDED",
  LEASE_CONTRACT_REJECTED = "LEASE_CONTRACT_REJECTED",
  LEASE_CONTRACT_RETRACTED = "LEASE_CONTRACT_RETRACTED",
  LEASE_CONTRACT_REVOKED = "LEASE_CONTRACT_REVOKED",
  LEASE_CONTRACT_SIGNATURE_REMINDER = "LEASE_CONTRACT_SIGNATURE_REMINDER",
  LEASE_CONTRACT_SIGNED = "LEASE_CONTRACT_SIGNED",
  LEASE_CREDIT_NOTE = "LEASE_CREDIT_NOTE",
  LEASE_DISCOUNT_CREATED = "LEASE_DISCOUNT_CREATED",
  LEASE_DISCOUNT_DELETED = "LEASE_DISCOUNT_DELETED",
  LEASE_DISCOUNT_UPDATED = "LEASE_DISCOUNT_UPDATED",
  LEASE_OPERATION_CREATED = "LEASE_OPERATION_CREATED",
  LEASE_OPERATION_DELETED = "LEASE_OPERATION_DELETED",
  LEASE_OPERATION_PAYMENT_REQUEST = "LEASE_OPERATION_PAYMENT_REQUEST",
  LEASE_OPERATION_UPDATED = "LEASE_OPERATION_UPDATED",
  LEASE_PAYMENT_PROVIDER_MANDATE_REQUEST = "LEASE_PAYMENT_PROVIDER_MANDATE_REQUEST",
  LEASE_PAYMENT_RECEIPT = "LEASE_PAYMENT_RECEIPT",
  LEASE_PAYMENT_REQUEST = "LEASE_PAYMENT_REQUEST",
  LEASE_RENT_INDEXATION = "LEASE_RENT_INDEXATION",
  LEASE_RENT_INDEXATION_SKIPPED = "LEASE_RENT_INDEXATION_SKIPPED",
  LEASE_RENTAL_ADAPTATION = "LEASE_RENTAL_ADAPTATION",
  LEASE_TENANT_STATEMENT = "LEASE_TENANT_STATEMENT",
  LEASE_TERMINATION = "LEASE_TERMINATION",
  LEASE_UNPAID_AMOUNT_FORMAL_NOTICE = "LEASE_UNPAID_AMOUNT_FORMAL_NOTICE",
  LEASE_UNPAID_AMOUNT_REMINDER = "LEASE_UNPAID_AMOUNT_REMINDER",
  LEASE_UNPAID_AMOUNT_SECOND_REMINDER = "LEASE_UNPAID_AMOUNT_SECOND_REMINDER",
  LEASE_UNPAID_AMOUNT_THIRD_REMINDER = "LEASE_UNPAID_AMOUNT_THIRD_REMINDER",
  LEASE_UNPAID_CONSOLIDATED_PAYMENT_REMINDER = "LEASE_UNPAID_CONSOLIDATED_PAYMENT_REMINDER",
  LEASE_SEPA_PREDEBIT_NOTICE = "LEASE_SEPA_PREDEBIT_NOTICE",
  LEASE_SEPA_PAYMENT_FAILED = "LEASE_SEPA_PAYMENT_FAILED",
  LEASE_SEPA_MANDATE_FAILED = "LEASE_SEPA_MANDATE_FAILED",
  OWNER_STATEMENT = "OWNER_STATEMENT",
  COMPANY_INVOICE = "COMPANY_INVOICE",
  SYSTEM = "SYSTEM",
}

export enum LeaseActionHistoryStatus {
  TO_PROCESS = "TO_PROCESS",
  PROCESSED = "PROCESSED",
}

export enum LeaseActionEndReason {
  OWN_USE = "OWN_USE",
  RENOVATION = "RENOVATION",
  NONE = "NONE",
}

export enum LeaseActionEndInitiator {
  LESSOR = "LESSOR",
  TENANT = "TENANT",
  MUTUAL = "MUTUAL",
  COURT_DECISION = "COURT_DECISION",
  NOTARIAL_ACT = "NOTARIAL_ACT",
}

export type ModelLeasePriceHistoryConnection = {
  __typename: "ModelLeasePriceHistoryConnection",
  items:  Array<LeasePriceHistoryDTO | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelSignatureDocumentConnection = {
  __typename: "ModelSignatureDocumentConnection",
  items:  Array<SignatureDocumentDTO | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelLeaseVariousOperationConnection = {
  __typename: "ModelLeaseVariousOperationConnection",
  items:  Array<LeaseVariousOperationDTO | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ContactPeppolPropertiesDTO = {
  __typename: "ContactPeppolProperties",
  isRegistered: boolean,
  mustSend: boolean,
};

export type ContactIntegrationsDTO = {
  __typename: "ContactIntegrations",
  paymentProperties?: PaymentProviderPropertiesDTO | null,
};

export type PaymentProviderPropertiesDTO = {
  __typename: "PaymentProviderProperties",
  accountId: string,
};

export type ModelEntityRelationConnection = {
  __typename: "ModelEntityRelationConnection",
  items:  Array<EntityRelationDTO | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type EntityRelationDTO = {
  __typename: "EntityRelation",
  id: string,
  sourceId: string,
  sourceTableName: string,
  foreignId: string,
  foreignTableName: string,
  linkDescription?: string | null,
  linkProperties?: RelationLinkPropertiesDTO | null,
  clientId: string,
  readers?: Array< string > | null,
  readId: string,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type RelationLinkPropertiesDTO = {
  __typename: "RelationLinkProperties",
  contact?: ContactRelationLinkPropertiesDTO | null,
};

export type ContactRelationLinkPropertiesDTO = {
  __typename: "ContactRelationLinkProperties",
  communicationSubscriptions?: Array< ContactCommunicationSubscriptionTypes > | null,
};

export enum ContactCommunicationSubscriptionTypes {
  INVOICE = "INVOICE",
  CONTRACT_CHANGE = "CONTRACT_CHANGE",
  STATEMENTS = "STATEMENTS",
  RENEWAL_NOTICE = "RENEWAL_NOTICE",
  MAINTENANCE_REQUEST = "MAINTENANCE_REQUEST",
  GENERAL_COMMUNICATION = "GENERAL_COMMUNICATION",
}

export enum IntegrationName {
  CODA = "CODA",
  EXACT_ONLINE = "EXACT_ONLINE",
  GOOGLE = "GOOGLE",
  ICLOUD = "ICLOUD",
  MICROSOFT = "MICROSOFT",
  MYBANX = "MYBANX",
  OCR = "OCR",
  ODOO = "ODOO",
  PAYMENT_PROVIDER = "PAYMENT_PROVIDER",
  PEPPOL = "PEPPOL",
  PONTO = "PONTO",
  SAGE_BOB50 = "SAGE_BOB50",
}

export enum BankAccountMatchingRule {
  AUTOMATIC = "AUTOMATIC",
  MANUAL = "MANUAL",
}

export enum BankAccountType {
  AGENCY_ACCOUNT = "AGENCY_ACCOUNT",
  OWNER_PRIVATE_ACCOUNT = "OWNER_PRIVATE_ACCOUNT",
  SUPPLIER_ACCOUNT = "SUPPLIER_ACCOUNT",
  THIRD_PARTY_BUILDING = "THIRD_PARTY_BUILDING",
  THIRD_PARTY_MULTI_OWNER = "THIRD_PARTY_MULTI_OWNER",
  THIRD_PARTY_OWNER = "THIRD_PARTY_OWNER",
}

export type UpdateAccountLabelInput = {
  id: string,
  labels?: Array< CustomLabelInput > | null,
  bankAccountId?: string | null,
  contactId?: string | null,
  class?: number | null,
  customUsage?: AccountLabelCustomUsage | null,
  customValues?: Array< CustomValueInput > | null,
  disabled?: boolean | null,
  hoaFundId?: string | null,
  ownerId?: string | null,
  topClass?: number | null,
  vatNonDeductiblePercentage?: number | null,
  readId?: string | null,
  clientId?: string | null,
  _version?: number | null,
};

export type DeleteAccountLabelInput = {
  id: string,
  _version?: number | null,
};

export type CreatePostingInput = {
  id?: string | null,
  createdAt?: string | null,
  class: number,
  customLabel?: string | null,
  customValues?: Array< CustomValueInput > | null,
  topClass: number,
  type: PostingType,
  totalAmount: number,
  periodFrom: string,
  periodTo: string,
  buildingId?: string | null,
  unitId?: string | null,
  invoiceId?: string | null,
  chargeId?: string | null,
  transactionId?: string | null,
  leaseId?: string | null,
  bankAccountId?: string | null,
  accountLabelId?: string | null,
  contactId?: string | null,
  leaseVariousOperationId?: string | null,
  statementId?: string | null,
  amountVatExcluded?: number | null,
  vatAmount?: number | null,
  vatRateId?: string | null,
  vatRateValue?: number | null,
  foreignId?: string | null,
  foreignType?: PostingForeignType | null,
  invoicePostingId?: string | null,
  reconciledAt?: string | null,
  decisionId?: string | null,
  status?: PostingStatus | null,
  chargeOwnerRepartition?: number | null,
  chargeRepartitionMetric?: string | null,
  chargeRepartitionValue?: number | null,
  chargeSplitNumber?: number | null,
  chargeType?: PostingChargeType | null,
  tenantShare?: PostingTenantShareInput | null,
  provisional?: boolean | null,
  flaggedAt?: string | null,
  carriedForward?: boolean | null,
  tenantLandings?: Array< PostingTenantLandingInput > | null,
  readers?: Array< string > | null,
  readId: string,
  clientId: string,
  _version?: number | null,
};

export type ModelPostingConditionInput = {
  createdAt?: ModelStringInput | null,
  class?: ModelIntInput | null,
  customLabel?: ModelStringInput | null,
  topClass?: ModelIntInput | null,
  type?: ModelPostingTypeInput | null,
  totalAmount?: ModelFloatInput | null,
  periodFrom?: ModelStringInput | null,
  periodTo?: ModelStringInput | null,
  buildingId?: ModelIDInput | null,
  unitId?: ModelIDInput | null,
  invoiceId?: ModelIDInput | null,
  chargeId?: ModelIDInput | null,
  transactionId?: ModelIDInput | null,
  leaseId?: ModelIDInput | null,
  bankAccountId?: ModelIDInput | null,
  accountLabelId?: ModelIDInput | null,
  contactId?: ModelIDInput | null,
  leaseVariousOperationId?: ModelIDInput | null,
  statementId?: ModelIDInput | null,
  amountVatExcluded?: ModelFloatInput | null,
  vatAmount?: ModelFloatInput | null,
  vatRateId?: ModelIDInput | null,
  vatRateValue?: ModelFloatInput | null,
  foreignId?: ModelIDInput | null,
  foreignType?: ModelPostingForeignTypeInput | null,
  invoicePostingId?: ModelIDInput | null,
  reconciledAt?: ModelStringInput | null,
  status?: ModelPostingStatusInput | null,
  chargeOwnerRepartition?: ModelFloatInput | null,
  chargeRepartitionMetric?: ModelStringInput | null,
  chargeRepartitionValue?: ModelFloatInput | null,
  chargeSplitNumber?: ModelIntInput | null,
  chargeType?: ModelPostingChargeTypeInput | null,
  readers?: ModelIDInput | null,
  readId?: ModelIDInput | null,
  clientId?: ModelIDInput | null,
  provisional?: ModelBooleanInput | null,
  flaggedAt?: ModelStringInput | null,
  carriedForward?: ModelBooleanInput | null,
  and?: Array< ModelPostingConditionInput | null > | null,
  or?: Array< ModelPostingConditionInput | null > | null,
  not?: ModelPostingConditionInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelStringInput = {
  ne?: string | null,
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  contains?: string | null,
  notContains?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
  size?: ModelSizeInput | null,
};

export type ModelPostingTypeInput = {
  eq?: PostingType | null,
  ne?: PostingType | null,
};

export type ModelFloatInput = {
  ne?: number | null,
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
};

export type ModelPostingForeignTypeInput = {
  eq?: PostingForeignType | null,
  ne?: PostingForeignType | null,
};

export type ModelPostingStatusInput = {
  eq?: PostingStatus | null,
  ne?: PostingStatus | null,
};

export type ModelPostingChargeTypeInput = {
  eq?: PostingChargeType | null,
  ne?: PostingChargeType | null,
};

export type UpdatePostingInput = {
  id: string,
  createdAt?: string | null,
  class?: number | null,
  customLabel?: string | null,
  customValues?: Array< CustomValueInput > | null,
  topClass?: number | null,
  type?: PostingType | null,
  totalAmount?: number | null,
  periodFrom?: string | null,
  periodTo?: string | null,
  buildingId?: string | null,
  unitId?: string | null,
  invoiceId?: string | null,
  chargeId?: string | null,
  transactionId?: string | null,
  leaseId?: string | null,
  bankAccountId?: string | null,
  accountLabelId?: string | null,
  contactId?: string | null,
  leaseVariousOperationId?: string | null,
  statementId?: string | null,
  amountVatExcluded?: number | null,
  vatAmount?: number | null,
  vatRateId?: string | null,
  vatRateValue?: number | null,
  foreignId?: string | null,
  foreignType?: PostingForeignType | null,
  invoicePostingId?: string | null,
  reconciledAt?: string | null,
  decisionId?: string | null,
  status?: PostingStatus | null,
  chargeOwnerRepartition?: number | null,
  chargeRepartitionMetric?: string | null,
  chargeRepartitionValue?: number | null,
  chargeSplitNumber?: number | null,
  chargeType?: PostingChargeType | null,
  tenantShare?: PostingTenantShareInput | null,
  provisional?: boolean | null,
  flaggedAt?: string | null,
  carriedForward?: boolean | null,
  tenantLandings?: Array< PostingTenantLandingInput > | null,
  readers?: Array< string > | null,
  readId?: string | null,
  clientId?: string | null,
  _version?: number | null,
};

export type DeletePostingInput = {
  id: string,
  _version?: number | null,
};

export type CreateBankAccountInput = {
  id?: string | null,
  contactId: string,
  number: string,
  bicNumber?: string | null,
  bankName?: string | null,
  contactIds?: Array< string > | null,
  buildingIds?: Array< string > | null,
  holderName?: string | null,
  label?: string | null,
  customValues?: Array< CustomValueInput > | null,
  disabled?: boolean | null,
  integrations?: Array< IntegrationName > | null,
  matchingRule?: BankAccountMatchingRule | null,
  initiationChannel?: PaymentInitiationChannel | null,
  retainedBalanceThreshold?: number | null,
  balance?: number | null,
  balanceDate?: string | null,
  type: BankAccountType,
  ibanStatus?: IbanStatus | null,
  ibanVerifiedAt?: string | null,
  ibanVerifiedBy?: string | null,
  ibanVerifiedNumber?: string | null,
  ibanVerifiedSourceDocumentId?: string | null,
  ibanRole?: BankAccountIbanRole | null,
  ibanRoleLabel?: string | null,
  isDefault?: boolean | null,
  note?: string | null,
  paymentRunPriorityOrderIds?: Array< string > | null,
  paymentRunPriorityUpdatedAt?: string | null,
  paymentRunPriorityUpdatedBy?: string | null,
  readers?: Array< string > | null,
  readId: string,
  clientId: string,
  _version?: number | null,
};

export type ModelBankAccountConditionInput = {
  contactId?: ModelIDInput | null,
  number?: ModelStringInput | null,
  bicNumber?: ModelStringInput | null,
  bankName?: ModelStringInput | null,
  contactIds?: ModelIDInput | null,
  buildingIds?: ModelIDInput | null,
  holderName?: ModelStringInput | null,
  label?: ModelStringInput | null,
  disabled?: ModelBooleanInput | null,
  integrations?: ModelIntegrationNameListInput | null,
  matchingRule?: ModelBankAccountMatchingRuleInput | null,
  balance?: ModelFloatInput | null,
  balanceDate?: ModelStringInput | null,
  type?: ModelBankAccountTypeInput | null,
  readers?: ModelIDInput | null,
  readId?: ModelIDInput | null,
  clientId?: ModelIDInput | null,
  and?: Array< ModelBankAccountConditionInput | null > | null,
  or?: Array< ModelBankAccountConditionInput | null > | null,
  not?: ModelBankAccountConditionInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelIntegrationNameListInput = {
  eq?: Array< IntegrationName | null > | null,
  ne?: Array< IntegrationName | null > | null,
  contains?: IntegrationName | null,
  notContains?: IntegrationName | null,
};

export type ModelBankAccountMatchingRuleInput = {
  eq?: BankAccountMatchingRule | null,
  ne?: BankAccountMatchingRule | null,
};

export type ModelBankAccountTypeInput = {
  eq?: BankAccountType | null,
  ne?: BankAccountType | null,
};

export type UpdateBankAccountInput = {
  id: string,
  contactId?: string | null,
  number?: string | null,
  bicNumber?: string | null,
  bankName?: string | null,
  contactIds?: Array< string > | null,
  buildingIds?: Array< string > | null,
  holderName?: string | null,
  label?: string | null,
  customValues?: Array< CustomValueInput > | null,
  disabled?: boolean | null,
  integrations?: Array< IntegrationName > | null,
  matchingRule?: BankAccountMatchingRule | null,
  initiationChannel?: PaymentInitiationChannel | null,
  retainedBalanceThreshold?: number | null,
  balance?: number | null,
  balanceDate?: string | null,
  type?: BankAccountType | null,
  ibanStatus?: IbanStatus | null,
  ibanVerifiedAt?: string | null,
  ibanVerifiedBy?: string | null,
  ibanVerifiedNumber?: string | null,
  ibanVerifiedSourceDocumentId?: string | null,
  ibanRole?: BankAccountIbanRole | null,
  ibanRoleLabel?: string | null,
  isDefault?: boolean | null,
  note?: string | null,
  paymentRunPriorityOrderIds?: Array< string > | null,
  paymentRunPriorityUpdatedAt?: string | null,
  paymentRunPriorityUpdatedBy?: string | null,
  readers?: Array< string > | null,
  readId?: string | null,
  clientId?: string | null,
  _version?: number | null,
};

export type DeleteBankAccountInput = {
  id: string,
  _version?: number | null,
};

export type CreateTransactionInput = {
  id?: string | null,
  status: TransactionStatus,
  snoozedUntil?: string | null,
  sequence?: number | null,
  statementDate: string,
  operationDate?: string | null,
  createdAt?: string | null,
  customValues?: Array< CustomValueInput > | null,
  remittanceInformationType?: RemittanceType | null,
  remittanceInformation?: string | null,
  remittanceInformationRaw?: string | null,
  additionalInformation?: string | null,
  structuredCommunication?: string | null,
  bankTransactionCode?: string | null,
  proprietaryBankTransactionCode?: string | null,
  endToEndId?: string | null,
  mandateId?: string | null,
  creditorId?: string | null,
  purposeCode?: string | null,
  internalReference?: string | null,
  comment?: string | null,
  exclusionReason?: TransactionExclusionReason | null,
  exclusionComment?: string | null,
  excludedAt?: string | null,
  excludedBy?: string | null,
  amount: number,
  bankAccountId: string,
  counterpartName?: string | null,
  counterpartDisplayName?: string | null,
  counterpartAccountNumber?: string | null,
  origin: TransactionOrigin,
  sourceChannel?: TransactionSourceChannel | null,
  nativeTransactionId?: string | null,
  fingerprint?: string | null,
  linkedSourceChannels?: Array< TransactionSourceChannel > | null,
  proposedLeaseId?: string | null,
  proposedUnitId?: string | null,
  proposedContractorId?: string | null,
  proposedOwnerId?: string | null,
  proposedMatch?: number | null,
  proposedAllocation?: string | null,
  classification?: TransactionFlowType | null,
  classificationConfidence?: number | null,
  classificationReason?: TransactionClassificationReason | null,
  recurrence?: string | null,
  links?: Array< TransactionLinkInput > | null,
  updatedAt?: string | null,
  readers?: Array< string > | null,
  readId: string,
  clientId: string,
  _version?: number | null,
};

export type TransactionLinkInput = {
  amount: number,
  linkId: string,
  linkType: TransactionLinkType,
};

export type ModelTransactionConditionInput = {
  status?: ModelTransactionStatusInput | null,
  sequence?: ModelFloatInput | null,
  statementDate?: ModelStringInput | null,
  operationDate?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  remittanceInformationType?: ModelRemittanceTypeInput | null,
  remittanceInformation?: ModelStringInput | null,
  comment?: ModelStringInput | null,
  amount?: ModelFloatInput | null,
  bankAccountId?: ModelIDInput | null,
  counterpartName?: ModelStringInput | null,
  counterpartAccountNumber?: ModelStringInput | null,
  origin?: ModelTransactionOriginInput | null,
  proposedLeaseId?: ModelIDInput | null,
  proposedUnitId?: ModelIDInput | null,
  proposedContractorId?: ModelIDInput | null,
  proposedOwnerId?: ModelIDInput | null,
  proposedMatch?: ModelIntInput | null,
  updatedAt?: ModelStringInput | null,
  readers?: ModelIDInput | null,
  readId?: ModelIDInput | null,
  clientId?: ModelIDInput | null,
  and?: Array< ModelTransactionConditionInput | null > | null,
  or?: Array< ModelTransactionConditionInput | null > | null,
  not?: ModelTransactionConditionInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelTransactionStatusInput = {
  eq?: TransactionStatus | null,
  ne?: TransactionStatus | null,
};

export type ModelRemittanceTypeInput = {
  eq?: RemittanceType | null,
  ne?: RemittanceType | null,
};

export type ModelTransactionOriginInput = {
  eq?: TransactionOrigin | null,
  ne?: TransactionOrigin | null,
};

export type ModelTransactionFlowTypeInput = {
  eq?: TransactionFlowType | null,
  ne?: TransactionFlowType | null,
};

export type ModelTransactionClassificationReasonInput = {
  eq?: TransactionClassificationReason | null,
  ne?: TransactionClassificationReason | null,
};

export type ModelTransactionSourceChannelInput = {
  eq?: TransactionSourceChannel | null,
  ne?: TransactionSourceChannel | null,
};

export type ModelTransactionExclusionReasonInput = {
  eq?: TransactionExclusionReason | null,
  ne?: TransactionExclusionReason | null,
};

export type UpdateTransactionInput = {
  id: string,
  status?: TransactionStatus | null,
  snoozedUntil?: string | null,
  sequence?: number | null,
  statementDate?: string | null,
  operationDate?: string | null,
  createdAt?: string | null,
  customValues?: Array< CustomValueInput > | null,
  remittanceInformationType?: RemittanceType | null,
  remittanceInformation?: string | null,
  remittanceInformationRaw?: string | null,
  additionalInformation?: string | null,
  structuredCommunication?: string | null,
  bankTransactionCode?: string | null,
  proprietaryBankTransactionCode?: string | null,
  endToEndId?: string | null,
  mandateId?: string | null,
  creditorId?: string | null,
  purposeCode?: string | null,
  internalReference?: string | null,
  comment?: string | null,
  exclusionReason?: TransactionExclusionReason | null,
  exclusionComment?: string | null,
  excludedAt?: string | null,
  excludedBy?: string | null,
  amount?: number | null,
  bankAccountId?: string | null,
  counterpartName?: string | null,
  counterpartDisplayName?: string | null,
  counterpartAccountNumber?: string | null,
  origin?: TransactionOrigin | null,
  sourceChannel?: TransactionSourceChannel | null,
  nativeTransactionId?: string | null,
  fingerprint?: string | null,
  linkedSourceChannels?: Array< TransactionSourceChannel > | null,
  proposedLeaseId?: string | null,
  proposedUnitId?: string | null,
  proposedContractorId?: string | null,
  proposedOwnerId?: string | null,
  proposedMatch?: number | null,
  proposedAllocation?: string | null,
  classification?: TransactionFlowType | null,
  classificationConfidence?: number | null,
  classificationReason?: TransactionClassificationReason | null,
  recurrence?: string | null,
  links?: Array< TransactionLinkInput > | null,
  updatedAt?: string | null,
  readers?: Array< string > | null,
  readId?: string | null,
  clientId?: string | null,
  _version?: number | null,
};

export type DeleteTransactionInput = {
  id: string,
  _version?: number | null,
};

export enum CounterpartyIdentityKeyType {
  IBAN = "IBAN",
  MANDATE_ID = "MANDATE_ID",
  CREDITOR_ID = "CREDITOR_ID",
  COMMUNICATION = "COMMUNICATION",
  NAME = "NAME",
}

export type ModelCounterpartyIdentityKeyTypeInput = {
  eq?: CounterpartyIdentityKeyType | null,
  ne?: CounterpartyIdentityKeyType | null,
};

export enum CounterpartyIdentityKind {
  TENANT_PAYER = "TENANT_PAYER",
  SUPPLIER = "SUPPLIER",
  OWNER_ACCOUNT = "OWNER_ACCOUNT",
  INTERNAL_ACCOUNT = "INTERNAL_ACCOUNT",
  BANK_FEES = "BANK_FEES",
  CREDIT_CONTRACT = "CREDIT_CONTRACT",
  SYNDIC_ACP = "SYNDIC_ACP",
  AGENCY_ACCOUNT = "AGENCY_ACCOUNT",
  OTHER = "OTHER",
  UNKNOWN = "UNKNOWN",
}

export type ModelCounterpartyIdentityKindInput = {
  eq?: CounterpartyIdentityKind | null,
  ne?: CounterpartyIdentityKind | null,
};

export enum CounterpartyIdentitySource {
  LEARNED = "LEARNED",
  MANUAL = "MANUAL",
  RULE_MIGRATION = "RULE_MIGRATION",
  AI_SUGGESTED = "AI_SUGGESTED",
}

export type ModelCounterpartyIdentitySourceInput = {
  eq?: CounterpartyIdentitySource | null,
  ne?: CounterpartyIdentitySource | null,
};

export enum CounterpartyIdentityStatus {
  ACTIVE = "ACTIVE",
  SUSPENDED = "SUSPENDED",
  PENDING = "PENDING",
}

export type ModelCounterpartyIdentityStatusInput = {
  eq?: CounterpartyIdentityStatus | null,
  ne?: CounterpartyIdentityStatus | null,
};

export enum ReconciliationReasonCode {
  DOCUMENT_REFERENCE_CITED = "DOCUMENT_REFERENCE_CITED",
  EXACT_DOCUMENTS = "EXACT_DOCUMENTS",
  EXACT_SUBSET = "EXACT_SUBSET",
  MONTH_CITED = "MONTH_CITED",
  FIFO_PROVISIONS_FIRST = "FIFO_PROVISIONS_FIRST",
  PENDING_BALANCE = "PENDING_BALANCE",
  AMBIGUOUS_EXACT_SUBSET = "AMBIGUOUS_EXACT_SUBSET",
  AMBIGUOUS_MONTH_CITED = "AMBIGUOUS_MONTH_CITED",
  AWAITING_POSTING = "AWAITING_POSTING",
  ABNORMAL_OVERPAYMENT = "ABNORMAL_OVERPAYMENT",
  LEASE_DISPUTED = "LEASE_DISPUTED",
  MULTIPLE_CANDIDATE_LEASES = "MULTIPLE_CANDIDATE_LEASES",
  COUNTERPARTY_IDENTITY = "COUNTERPARTY_IDENTITY",
  MULTIPLE_CANDIDATE_COUNTERPARTIES = "MULTIPLE_CANDIDATE_COUNTERPARTIES",
  MULTIPLE_CANDIDATE_ROLES = "MULTIPLE_CANDIDATE_ROLES",
  COUNTERPARTY_ROLE_DOCUMENT = "COUNTERPARTY_ROLE_DOCUMENT",
}

export enum ReconciliationDecisionKind {
  RECONCILE = "RECONCILE",
  UNRECONCILE = "UNRECONCILE",
  LINK = "LINK",
  UNLINK = "UNLINK",
  EXCLUDE = "EXCLUDE",
  RESTORE = "RESTORE",
  SNOOZE = "SNOOZE",
  WAKE = "WAKE",
  REVERSE = "REVERSE",
  SUGGEST = "SUGGEST",
  POSTING_APPLIED = "POSTING_APPLIED",
  LEGACY = "LEGACY",
}

export enum ReconciliationDecisionStatus {
  APPLIED = "APPLIED",
  PENDING_POSTING = "PENDING_POSTING",
  PROPOSED = "PROPOSED",
}

export enum ReconciliationDecisionSource {
  ENGINE = "ENGINE",
  RULE = "RULE",
  AI = "AI",
  HUMAN = "HUMAN",
  LEGACY = "LEGACY",
}

export enum ReconciliationDecisionTrigger {
  USER = "USER",
  INGESTION = "INGESTION",
  DOCUMENT_WATCH = "DOCUMENT_WATCH",
  EXACT_ONLINE = "EXACT_ONLINE",
  PAYMENT_ORDER = "PAYMENT_ORDER",
  PAYMENT_PROVIDER = "PAYMENT_PROVIDER",
  INVOICE_STREAM = "INVOICE_STREAM",
  DOCUMENT_POSTING = "DOCUMENT_POSTING",
  MIGRATION = "MIGRATION",
}

export enum ReconciliationDecisionOutcome {
  AUTO = "AUTO",
  SUGGESTED = "SUGGESTED",
  NEEDS_ACTION = "NEEDS_ACTION",
}

export type ReconciliationDecisionAllocationDTO = {
  __typename: "ReconciliationDecisionAllocation",
  invoiceId?: string | null,
  postingId?: string | null,
  amount: number,
  awaitingPosting?: boolean | null,
};

export type ReconciliationDecisionDTO = {
  __typename: "ReconciliationDecision",
  id: string,
  decisionId: string,
  transactionId: string,
  relatedTransactionIds?: Array< string > | null,
  kind: ReconciliationDecisionKind,
  status: ReconciliationDecisionStatus,
  source: ReconciliationDecisionSource,
  trigger: ReconciliationDecisionTrigger,
  actorId?: string | null,
  outcome?: ReconciliationDecisionOutcome | null,
  score?: number | null,
  reasonCodes?: Array< ReconciliationReasonCode > | null,
  flowType?: TransactionFlowType | null,
  amount?: number | null,
  links?:  Array<TransactionLinkDTO > | null,
  allocations?:  Array<ReconciliationDecisionAllocationDTO > | null,
  exclusionReason?: TransactionExclusionReason | null,
  comment?: string | null,
  snoozedUntil?: string | null,
  reversesDecisionId?: string | null,
  appliesDecisionId?: string | null,
  decidedAt: string,
  backfilled?: boolean | null,
  readId: string,
  clientId: string,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export enum CashExpectationSourceType {
  INVOICE = "INVOICE",
  PAYMENT_ORDER = "PAYMENT_ORDER",
}

export enum CashExpectationDirection {
  IN = "IN",
  OUT = "OUT",
}

export enum CashExpectationStatus {
  OPEN = "OPEN",
  PARTIALLY_MATCHED = "PARTIALLY_MATCHED",
  MATCHED = "MATCHED",
  CANCELLED = "CANCELLED",
}

export type CashExpectationLineDTO = {
  __typename: "CashExpectationLine",
  postingId: string,
  accountClass: number,
  originalAmount: number,
  openAmount: number,
  disputed: boolean,
  periodFrom?: string | null,
  periodTo?: string | null,
};

export type CashExpectationDTO = {
  __typename: "CashExpectation",
  id: string,
  sourceType: CashExpectationSourceType,
  sourceId: string,
  direction: CashExpectationDirection,
  flowType: TransactionFlowType,
  status: CashExpectationStatus,
  accountIds: Array< string >,
  originalAmount: number,
  openAmount: number,
  disputedAmount: number,
  expectedAmount: number,
  issueDate?: string | null,
  dueDate: string,
  confirmationDeadline?: string | null,
  structuredCommunication?: string | null,
  invoiceNumber?: string | null,
  reference?: string | null,
  counterpartyIban?: string | null,
  leaseId?: string | null,
  unitId?: string | null,
  ownerId?: string | null,
  contractorId?: string | null,
  isOffLedgerReceivable: boolean,
  awaitingPosting: boolean,
  lines:  Array<CashExpectationLineDTO >,
  readId: string,
  clientId: string,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export enum CounterpartyRoleTargetType {
  LEASE = "LEASE",
  UNIT = "UNIT",
  SUPPLIER = "SUPPLIER",
  OWNER = "OWNER",
}

export type ModelCounterpartyRoleTargetTypeInput = {
  eq?: CounterpartyRoleTargetType | null,
  ne?: CounterpartyRoleTargetType | null,
};

export type CreateCounterpartyIdentityInput = {
  id?: string | null,
  keyType: CounterpartyIdentityKeyType,
  key: string,
  isFullRemittance?: boolean | null,
  kind: CounterpartyIdentityKind,
  contactId?: string | null,
  source: CounterpartyIdentitySource,
  status: CounterpartyIdentityStatus,
  evidenceCount: number,
  firstSeenAt?: string | null,
  lastSeenAt?: string | null,
  lastCounterpartName?: string | null,
  lastDecisionId?: string | null,
  evidenceTransactionIds?: Array< string > | null,
  exclusionReason?: TransactionExclusionReason | null,
  exclusionComment?: string | null,
  readId: string,
  clientId: string,
  _version?: number | null,
};

export type ModelCounterpartyIdentityConditionInput = {
  keyType?: ModelCounterpartyIdentityKeyTypeInput | null,
  key?: ModelStringInput | null,
  isFullRemittance?: ModelBooleanInput | null,
  kind?: ModelCounterpartyIdentityKindInput | null,
  contactId?: ModelIDInput | null,
  source?: ModelCounterpartyIdentitySourceInput | null,
  status?: ModelCounterpartyIdentityStatusInput | null,
  evidenceCount?: ModelIntInput | null,
  firstSeenAt?: ModelStringInput | null,
  lastSeenAt?: ModelStringInput | null,
  lastCounterpartName?: ModelStringInput | null,
  lastDecisionId?: ModelStringInput | null,
  evidenceTransactionIds?: ModelIDInput | null,
  exclusionReason?: ModelTransactionExclusionReasonInput | null,
  exclusionComment?: ModelStringInput | null,
  readId?: ModelIDInput | null,
  clientId?: ModelIDInput | null,
  and?: Array< ModelCounterpartyIdentityConditionInput | null > | null,
  or?: Array< ModelCounterpartyIdentityConditionInput | null > | null,
  not?: ModelCounterpartyIdentityConditionInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type CounterpartyIdentityDTO = {
  __typename: "CounterpartyIdentity",
  id: string,
  keyType: CounterpartyIdentityKeyType,
  key: string,
  isFullRemittance?: boolean | null,
  kind: CounterpartyIdentityKind,
  contactId?: string | null,
  source: CounterpartyIdentitySource,
  status: CounterpartyIdentityStatus,
  evidenceCount: number,
  firstSeenAt?: string | null,
  lastSeenAt?: string | null,
  lastCounterpartName?: string | null,
  lastDecisionId?: string | null,
  evidenceTransactionIds?: Array< string > | null,
  exclusionReason?: TransactionExclusionReason | null,
  exclusionComment?: string | null,
  readId: string,
  clientId: string,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type UpdateCounterpartyIdentityInput = {
  id: string,
  keyType?: CounterpartyIdentityKeyType | null,
  key?: string | null,
  isFullRemittance?: boolean | null,
  kind?: CounterpartyIdentityKind | null,
  contactId?: string | null,
  source?: CounterpartyIdentitySource | null,
  status?: CounterpartyIdentityStatus | null,
  evidenceCount?: number | null,
  firstSeenAt?: string | null,
  lastSeenAt?: string | null,
  lastCounterpartName?: string | null,
  lastDecisionId?: string | null,
  evidenceTransactionIds?: Array< string > | null,
  exclusionReason?: TransactionExclusionReason | null,
  exclusionComment?: string | null,
  readId?: string | null,
  clientId?: string | null,
  _version?: number | null,
};

export type DeleteCounterpartyIdentityInput = {
  id: string,
  _version?: number | null,
};

export type ModelCounterpartyIdentityFilterInput = {
  id?: ModelIDInput | null,
  keyType?: ModelCounterpartyIdentityKeyTypeInput | null,
  key?: ModelStringInput | null,
  isFullRemittance?: ModelBooleanInput | null,
  kind?: ModelCounterpartyIdentityKindInput | null,
  contactId?: ModelIDInput | null,
  source?: ModelCounterpartyIdentitySourceInput | null,
  status?: ModelCounterpartyIdentityStatusInput | null,
  evidenceCount?: ModelIntInput | null,
  firstSeenAt?: ModelStringInput | null,
  lastSeenAt?: ModelStringInput | null,
  lastCounterpartName?: ModelStringInput | null,
  lastDecisionId?: ModelStringInput | null,
  evidenceTransactionIds?: ModelIDInput | null,
  exclusionReason?: ModelTransactionExclusionReasonInput | null,
  exclusionComment?: ModelStringInput | null,
  readId?: ModelIDInput | null,
  clientId?: ModelIDInput | null,
  and?: Array< ModelCounterpartyIdentityFilterInput | null > | null,
  or?: Array< ModelCounterpartyIdentityFilterInput | null > | null,
  not?: ModelCounterpartyIdentityFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelCounterpartyIdentityConnection = {
  __typename: "ModelCounterpartyIdentityConnection",
  items:  Array<CounterpartyIdentityDTO | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type CreateCounterpartyRoleInput = {
  id?: string | null,
  subjectId: string,
  targetType: CounterpartyRoleTargetType,
  targetId: string,
  source: CounterpartyIdentitySource,
  status: CounterpartyIdentityStatus,
  evidenceCount: number,
  lastSeenAt?: string | null,
  lastDecisionId?: string | null,
  evidenceTransactionIds?: Array< string > | null,
  readId: string,
  clientId: string,
  _version?: number | null,
};

export type ModelCounterpartyRoleConditionInput = {
  subjectId?: ModelIDInput | null,
  targetType?: ModelCounterpartyRoleTargetTypeInput | null,
  targetId?: ModelIDInput | null,
  source?: ModelCounterpartyIdentitySourceInput | null,
  status?: ModelCounterpartyIdentityStatusInput | null,
  evidenceCount?: ModelIntInput | null,
  lastSeenAt?: ModelStringInput | null,
  lastDecisionId?: ModelStringInput | null,
  evidenceTransactionIds?: ModelIDInput | null,
  readId?: ModelIDInput | null,
  clientId?: ModelIDInput | null,
  and?: Array< ModelCounterpartyRoleConditionInput | null > | null,
  or?: Array< ModelCounterpartyRoleConditionInput | null > | null,
  not?: ModelCounterpartyRoleConditionInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type CounterpartyRoleDTO = {
  __typename: "CounterpartyRole",
  id: string,
  subjectId: string,
  targetType: CounterpartyRoleTargetType,
  targetId: string,
  source: CounterpartyIdentitySource,
  status: CounterpartyIdentityStatus,
  evidenceCount: number,
  lastSeenAt?: string | null,
  lastDecisionId?: string | null,
  evidenceTransactionIds?: Array< string > | null,
  readId: string,
  clientId: string,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type UpdateCounterpartyRoleInput = {
  id: string,
  subjectId?: string | null,
  targetType?: CounterpartyRoleTargetType | null,
  targetId?: string | null,
  source?: CounterpartyIdentitySource | null,
  status?: CounterpartyIdentityStatus | null,
  evidenceCount?: number | null,
  lastSeenAt?: string | null,
  lastDecisionId?: string | null,
  evidenceTransactionIds?: Array< string > | null,
  readId?: string | null,
  clientId?: string | null,
  _version?: number | null,
};

export type DeleteCounterpartyRoleInput = {
  id: string,
  _version?: number | null,
};

export type ModelCounterpartyRoleFilterInput = {
  id?: ModelIDInput | null,
  subjectId?: ModelIDInput | null,
  targetType?: ModelCounterpartyRoleTargetTypeInput | null,
  targetId?: ModelIDInput | null,
  source?: ModelCounterpartyIdentitySourceInput | null,
  status?: ModelCounterpartyIdentityStatusInput | null,
  evidenceCount?: ModelIntInput | null,
  lastSeenAt?: ModelStringInput | null,
  lastDecisionId?: ModelStringInput | null,
  evidenceTransactionIds?: ModelIDInput | null,
  readId?: ModelIDInput | null,
  clientId?: ModelIDInput | null,
  and?: Array< ModelCounterpartyRoleFilterInput | null > | null,
  or?: Array< ModelCounterpartyRoleFilterInput | null > | null,
  not?: ModelCounterpartyRoleFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelCounterpartyRoleConnection = {
  __typename: "ModelCounterpartyRoleConnection",
  items:  Array<CounterpartyRoleDTO | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type CreateTransactionRuleInput = {
  id?: string | null,
  isFullRemittance?: boolean | null,
  remittanceInformation?: string | null,
  counterpartName?: string | null,
  counterpartAccountNumber?: string | null,
  usedFields: string,
  exclude: boolean,
  exclusionReason?: TransactionExclusionReason | null,
  exclusionComment?: string | null,
  leaseId?: string | null,
  unitId?: string | null,
  contractorId?: string | null,
  ownerId?: string | null,
  readId: string,
  clientId: string,
  _version?: number | null,
};

export type ModelTransactionRuleConditionInput = {
  isFullRemittance?: ModelBooleanInput | null,
  remittanceInformation?: ModelStringInput | null,
  counterpartName?: ModelStringInput | null,
  counterpartAccountNumber?: ModelStringInput | null,
  usedFields?: ModelStringInput | null,
  exclude?: ModelBooleanInput | null,
  leaseId?: ModelIDInput | null,
  unitId?: ModelIDInput | null,
  contractorId?: ModelIDInput | null,
  ownerId?: ModelIDInput | null,
  readId?: ModelIDInput | null,
  clientId?: ModelIDInput | null,
  and?: Array< ModelTransactionRuleConditionInput | null > | null,
  or?: Array< ModelTransactionRuleConditionInput | null > | null,
  not?: ModelTransactionRuleConditionInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type TransactionRuleDTO = {
  __typename: "TransactionRule",
  id: string,
  isFullRemittance?: boolean | null,
  remittanceInformation?: string | null,
  counterpartName?: string | null,
  counterpartAccountNumber?: string | null,
  usedFields: string,
  exclude: boolean,
  exclusionReason?: TransactionExclusionReason | null,
  exclusionComment?: string | null,
  leaseId?: string | null,
  lease?: LeaseDTO | null,
  unitId?: string | null,
  unit?: UnitDTO | null,
  contractorId?: string | null,
  contractor?: ContactDTO | null,
  ownerId?: string | null,
  owner?: ContactDTO | null,
  readId: string,
  clientId: string,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type UpdateTransactionRuleInput = {
  id: string,
  isFullRemittance?: boolean | null,
  remittanceInformation?: string | null,
  counterpartName?: string | null,
  counterpartAccountNumber?: string | null,
  usedFields?: string | null,
  exclude?: boolean | null,
  exclusionReason?: TransactionExclusionReason | null,
  exclusionComment?: string | null,
  leaseId?: string | null,
  unitId?: string | null,
  contractorId?: string | null,
  ownerId?: string | null,
  readId?: string | null,
  clientId?: string | null,
  _version?: number | null,
};

export type DeleteTransactionRuleInput = {
  id: string,
  _version?: number | null,
};

export type CreateVatRateInput = {
  id?: string | null,
  country: string,
  label: string,
  value?: number | null,
  vatKind?: VatRateKind | null,
  customValues?: Array< CustomValueInput > | null,
  ownerId?: string | null,
  readId: string,
  clientId: string,
  _version?: number | null,
};

export type ModelVatRateConditionInput = {
  country?: ModelStringInput | null,
  label?: ModelStringInput | null,
  value?: ModelFloatInput | null,
  ownerId?: ModelIDInput | null,
  readId?: ModelIDInput | null,
  clientId?: ModelIDInput | null,
  vatKind?: ModelVatRateKindInput | null,
  and?: Array< ModelVatRateConditionInput | null > | null,
  or?: Array< ModelVatRateConditionInput | null > | null,
  not?: ModelVatRateConditionInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type UpdateVatRateInput = {
  id: string,
  country?: string | null,
  label?: string | null,
  value?: number | null,
  vatKind?: VatRateKind | null,
  customValues?: Array< CustomValueInput > | null,
  ownerId?: string | null,
  readId?: string | null,
  clientId?: string | null,
  _version?: number | null,
};

export type DeleteVatRateInput = {
  id: string,
  _version?: number | null,
};

export type CreateAdvertisementInput = {
  id?: string | null,
  type?: AdvertisementUnitType | null,
  subType?: AdvertisementUnitSubType | null,
  amenities?: Array< AmenitiesType > | null,
  amountOfFacades?: number | null,
  availabilityDate?: string | null,
  certificateOfConformity?: CertificateOfConformityType | null,
  citationForPlanningOffence?: boolean | null,
  descriptions?: Array< AdvertisementDescriptionInput > | null,
  delimitedZone?: DelimitedZoneType | null,
  floodProneArea?: FloodProneAreaType | null,
  furnished?: boolean | null,
  firstOccupancy?: boolean | null,
  gardenSurface?: number | null,
  heatingAmenities?: Array< HeatingAmenities > | null,
  heatingType?: HeatingType | null,
  landTerrain?: Array< LandTerrainType > | null,
  landArea?: number | null,
  length?: number | null,
  nearbyComodities?: Array< NearbyComodityInput > | null,
  publishedPlatforms?: Array< PublishedPlatformInput > | null,
  planningPermission?: boolean | null,
  publishCadastralIncome?: boolean | null,
  resort?: boolean | null,
  rightOfPreemption?: boolean | null,
  subdivisionAuthorization?: boolean | null,
  wheelChairAccessible?: boolean | null,
  width?: number | null,
  terraceSurface?: number | null,
  readId: string,
  clientId: string,
  _version?: number | null,
};

export enum AdvertisementUnitType {
  APARTMENT = "APARTMENT",
  HOUSE = "HOUSE",
  LAND = "LAND",
  COMMERCIAL = "COMMERCIAL",
  GARAGEPARKING = "GARAGEPARKING",
  SPECIAL = "SPECIAL",
}

export enum AdvertisementUnitSubType {
  STUDIO = "STUDIO",
  DUPLEX = "DUPLEX",
  TRIPLEX = "TRIPLEX",
  PENTHOUSE = "PENTHOUSE",
  GROUNDFLOORFLAT = "GROUNDFLOORFLAT",
  LOFT = "LOFT",
  STUDENTFLAT = "STUDENTFLAT",
  BUILDING = "BUILDING",
  FLAT = "FLAT",
  APARTMENTSTANDARD = "APARTMENTSTANDARD",
  VILLA = "VILLA",
  TERRACED = "TERRACED",
  FARM = "FARM",
  MANSION = "MANSION",
  COTTAGE = "COTTAGE",
  BUNGALOW = "BUNGALOW",
  CASTLE = "CASTLE",
  DETACHED = "DETACHED",
  SEMIDETACHED = "SEMIDETACHED",
  KANGAROOHOUSE = "KANGAROOHOUSE",
  PILEHOUSE = "PILEHOUSE",
  HOUSEBOAT = "HOUSEBOAT",
  MOBILEHOME = "MOBILEHOME",
  MIXED = "MIXED",
  BUILDINGLAND = "BUILDINGLAND",
  MEADOW = "MEADOW",
  WOOD = "WOOD",
  INDUSTRIALLAND = "INDUSTRIALLAND",
  FARMLAND = "FARMLAND",
  OFFICE = "OFFICE",
  OFFICEBUILDING = "OFFICEBUILDING",
  WAREHOUSE = "WAREHOUSE",
  SHOP = "SHOP",
  RESTAURANT = "RESTAURANT",
  BAR = "BAR",
  HOTEL = "HOTEL",
  RETAILSPACE = "RETAILSPACE",
  INDUSTRIAL = "INDUSTRIAL",
  BUSINESS = "BUSINESS",
  OPENAIRSPACE = "OPENAIRSPACE",
  OUTSIDEBOX = "OUTSIDEBOX",
  INSIDEBOX = "INSIDEBOX",
  COVEREDSPACE = "COVEREDSPACE",
  CARPARK = "CARPARK",
  INDOORSPACE = "INDOORSPACE",
}

export enum AmenitiesType {
  ALARM = "ALARM",
  ARMOURED_DOOR = "ARMOURED_DOOR",
  DOOR_PHONE = "DOOR_PHONE",
  FIRE_PLACE = "FIRE_PLACE",
  JACUZZI = "JACUZZI",
  LARGE_PETS_ALLOWED = "LARGE_PETS_ALLOWED",
  SAUNA = "SAUNA",
  SMALL_PETS_ALLOWED = "SMALL_PETS_ALLOWED",
  TV_CONNECTION = "TV_CONNECTION",
}

export enum CertificateOfConformityType {
  YES_CONFORM = "YES_CONFORM",
  YES_NOT_CONFORM = "YES_NOT_CONFORM",
  NO = "NO",
}

export type AdvertisementDescriptionInput = {
  language: string,
  description?: string | null,
};

export enum DelimitedZoneType {
  DELIMITED_FLOOD_ZONE = "DELIMITED_FLOOD_ZONE",
  DELIMITED_REPARIAN_ZONE = "DELIMITED_REPARIAN_ZONE",
  NOT_COMMUNICATED = "NOT_COMMUNICATED",
}

export enum FloodProneAreaType {
  RECOGNIZED_FLOOD_ZONE = "RECOGNIZED_FLOOD_ZONE",
  POTENTIAL_FLOOD_ZONE = "POTENTIAL_FLOOD_ZONE",
  NON_FLOODABLE_ZONE = "NON_FLOODABLE_ZONE",
  NOT_COMMUNICATED = "NOT_COMMUNICATED",
}

export enum HeatingAmenities {
  COLLECTIVE_HEATING = "COLLECTIVE_HEATING",
  COLLECTIVE_WATER = "COLLECTIVE_WATER",
  SIMPLE_GLAZING = "SIMPLE_GLAZING",
  DOUBLE_GLAZING = "DOUBLE_GLAZING",
  TRIPLE_GLAZING = "TRIPLE_GLAZING",
  QUADRUPLE_GLAZING = "QUADRUPLE_GLAZING",
  AIR_CONDITIONNING = "AIR_CONDITIONNING",
}

export enum HeatingType {
  GAS = "GAS",
  FUEL_OIL = "FUEL_OIL",
  ELECTRICITY = "ELECTRICITY",
  HEATING_PUMP = "HEATING_PUMP",
  WOOD = "WOOD",
  GEOTHERMAL = "GEOTHERMAL",
  SOLAR = "SOLAR",
  WIND = "WIND",
}

export enum LandTerrainType {
  STREET_FRONT_LAND = "STREET_FRONT_LAND",
  STREET_BACK_LAND = "STREET_BACK_LAND",
  FLAT_LAND = "FLAT_LAND",
}

export type NearbyComodityInput = {
  type: NearbyCommoditiesTypes,
  name: string,
  distance: number,
};

export enum NearbyCommoditiesTypes {
  RESTAURANT = "RESTAURANT",
  SUPERMARKET = "SUPERMARKET",
  TRANSPORTS = "TRANSPORTS",
  SCHOOL = "SCHOOL",
  HEALTHCARE = "HEALTHCARE",
}

export type PublishedPlatformInput = {
  name: PublishingPlatform,
  publishedDate: string,
  id: string,
};

export type ModelAdvertisementConditionInput = {
  type?: ModelAdvertisementUnitTypeInput | null,
  subType?: ModelAdvertisementUnitSubTypeInput | null,
  amenities?: ModelAmenitiesTypeListInput | null,
  amountOfFacades?: ModelIntInput | null,
  availabilityDate?: ModelStringInput | null,
  certificateOfConformity?: ModelCertificateOfConformityTypeInput | null,
  citationForPlanningOffence?: ModelBooleanInput | null,
  delimitedZone?: ModelDelimitedZoneTypeInput | null,
  floodProneArea?: ModelFloodProneAreaTypeInput | null,
  furnished?: ModelBooleanInput | null,
  firstOccupancy?: ModelBooleanInput | null,
  gardenSurface?: ModelFloatInput | null,
  heatingAmenities?: ModelHeatingAmenitiesListInput | null,
  heatingType?: ModelHeatingTypeInput | null,
  landTerrain?: ModelLandTerrainTypeListInput | null,
  landArea?: ModelFloatInput | null,
  length?: ModelFloatInput | null,
  planningPermission?: ModelBooleanInput | null,
  publishCadastralIncome?: ModelBooleanInput | null,
  resort?: ModelBooleanInput | null,
  rightOfPreemption?: ModelBooleanInput | null,
  subdivisionAuthorization?: ModelBooleanInput | null,
  wheelChairAccessible?: ModelBooleanInput | null,
  width?: ModelFloatInput | null,
  terraceSurface?: ModelFloatInput | null,
  readId?: ModelIDInput | null,
  clientId?: ModelIDInput | null,
  and?: Array< ModelAdvertisementConditionInput | null > | null,
  or?: Array< ModelAdvertisementConditionInput | null > | null,
  not?: ModelAdvertisementConditionInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelAdvertisementUnitTypeInput = {
  eq?: AdvertisementUnitType | null,
  ne?: AdvertisementUnitType | null,
};

export type ModelAdvertisementUnitSubTypeInput = {
  eq?: AdvertisementUnitSubType | null,
  ne?: AdvertisementUnitSubType | null,
};

export type ModelAmenitiesTypeListInput = {
  eq?: Array< AmenitiesType | null > | null,
  ne?: Array< AmenitiesType | null > | null,
  contains?: AmenitiesType | null,
  notContains?: AmenitiesType | null,
};

export type ModelCertificateOfConformityTypeInput = {
  eq?: CertificateOfConformityType | null,
  ne?: CertificateOfConformityType | null,
};

export type ModelDelimitedZoneTypeInput = {
  eq?: DelimitedZoneType | null,
  ne?: DelimitedZoneType | null,
};

export type ModelFloodProneAreaTypeInput = {
  eq?: FloodProneAreaType | null,
  ne?: FloodProneAreaType | null,
};

export type ModelHeatingAmenitiesListInput = {
  eq?: Array< HeatingAmenities | null > | null,
  ne?: Array< HeatingAmenities | null > | null,
  contains?: HeatingAmenities | null,
  notContains?: HeatingAmenities | null,
};

export type ModelHeatingTypeInput = {
  eq?: HeatingType | null,
  ne?: HeatingType | null,
};

export type ModelLandTerrainTypeListInput = {
  eq?: Array< LandTerrainType | null > | null,
  ne?: Array< LandTerrainType | null > | null,
  contains?: LandTerrainType | null,
  notContains?: LandTerrainType | null,
};

export type AdvertisementDTO = {
  __typename: "Advertisement",
  id: string,
  type?: AdvertisementUnitType | null,
  subType?: AdvertisementUnitSubType | null,
  amenities?: Array< AmenitiesType > | null,
  amountOfFacades?: number | null,
  availabilityDate?: string | null,
  certificateOfConformity?: CertificateOfConformityType | null,
  citationForPlanningOffence?: boolean | null,
  descriptions?:  Array<AdvertisementDescriptionDTO > | null,
  delimitedZone?: DelimitedZoneType | null,
  floodProneArea?: FloodProneAreaType | null,
  furnished?: boolean | null,
  firstOccupancy?: boolean | null,
  gardenSurface?: number | null,
  heatingAmenities?: Array< HeatingAmenities > | null,
  heatingType?: HeatingType | null,
  landTerrain?: Array< LandTerrainType > | null,
  landArea?: number | null,
  length?: number | null,
  nearbyComodities?:  Array<NearbyComodityDTO > | null,
  publishedPlatforms?:  Array<PublishedPlatformDTO > | null,
  planningPermission?: boolean | null,
  publishCadastralIncome?: boolean | null,
  resort?: boolean | null,
  rightOfPreemption?: boolean | null,
  subdivisionAuthorization?: boolean | null,
  wheelChairAccessible?: boolean | null,
  width?: number | null,
  terraceSurface?: number | null,
  readId: string,
  clientId: string,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type AdvertisementDescriptionDTO = {
  __typename: "AdvertisementDescription",
  language: string,
  description?: string | null,
};

export type NearbyComodityDTO = {
  __typename: "NearbyComodity",
  type: NearbyCommoditiesTypes,
  name: string,
  distance: number,
};

export type PublishedPlatformDTO = {
  __typename: "PublishedPlatform",
  name: PublishingPlatform,
  publishedDate: string,
  id: string,
};

export type UpdateAdvertisementInput = {
  id: string,
  type?: AdvertisementUnitType | null,
  subType?: AdvertisementUnitSubType | null,
  amenities?: Array< AmenitiesType > | null,
  amountOfFacades?: number | null,
  availabilityDate?: string | null,
  certificateOfConformity?: CertificateOfConformityType | null,
  citationForPlanningOffence?: boolean | null,
  descriptions?: Array< AdvertisementDescriptionInput > | null,
  delimitedZone?: DelimitedZoneType | null,
  floodProneArea?: FloodProneAreaType | null,
  furnished?: boolean | null,
  firstOccupancy?: boolean | null,
  gardenSurface?: number | null,
  heatingAmenities?: Array< HeatingAmenities > | null,
  heatingType?: HeatingType | null,
  landTerrain?: Array< LandTerrainType > | null,
  landArea?: number | null,
  length?: number | null,
  nearbyComodities?: Array< NearbyComodityInput > | null,
  publishedPlatforms?: Array< PublishedPlatformInput > | null,
  planningPermission?: boolean | null,
  publishCadastralIncome?: boolean | null,
  resort?: boolean | null,
  rightOfPreemption?: boolean | null,
  subdivisionAuthorization?: boolean | null,
  wheelChairAccessible?: boolean | null,
  width?: number | null,
  terraceSurface?: number | null,
  readId?: string | null,
  clientId?: string | null,
  _version?: number | null,
};

export type DeleteAdvertisementInput = {
  id: string,
  _version?: number | null,
};

export type CreateAgencyRateInput = {
  id?: string | null,
  amountDetails: Array< AgencyRateAmountDetailInput >,
  rateWhenVacant?: AgencyRateWhenVacantInput | null,
  amountMinimumFees?: number | null,
  custom: boolean,
  feesAppliedTo: AgencyRateFeesType,
  includedInAmount?: Array< AgencyRateIncludedAmount > | null,
  name: string,
  repartitionType: AgencyRateRepartitionType,
  type: AgencyRateType,
  unitType: Array< UnitType >,
  vatRateId?: string | null,
  unitIds?: Array< string | null > | null,
  readId: string,
  clientId: string,
  _version?: number | null,
};

export type AgencyRateAmountDetailInput = {
  amountType: AgencyRateAmountDetailType,
  endAmount?: number | null,
  feeApplied: number,
  startAmount: number,
};

export type AgencyRateWhenVacantInput = {
  amount: number,
  type: AgencyRateAmountDetailType,
};

export type ModelAgencyRateConditionInput = {
  amountMinimumFees?: ModelFloatInput | null,
  custom?: ModelBooleanInput | null,
  feesAppliedTo?: ModelAgencyRateFeesTypeInput | null,
  includedInAmount?: ModelAgencyRateIncludedAmountListInput | null,
  name?: ModelStringInput | null,
  repartitionType?: ModelAgencyRateRepartitionTypeInput | null,
  type?: ModelAgencyRateTypeInput | null,
  unitType?: ModelUnitTypeInput | null,
  vatRateId?: ModelIDInput | null,
  unitIds?: ModelIDInput | null,
  readId?: ModelIDInput | null,
  clientId?: ModelIDInput | null,
  and?: Array< ModelAgencyRateConditionInput | null > | null,
  or?: Array< ModelAgencyRateConditionInput | null > | null,
  not?: ModelAgencyRateConditionInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelAgencyRateFeesTypeInput = {
  eq?: AgencyRateFeesType | null,
  ne?: AgencyRateFeesType | null,
};

export type ModelAgencyRateIncludedAmountListInput = {
  eq?: Array< AgencyRateIncludedAmount | null > | null,
  ne?: Array< AgencyRateIncludedAmount | null > | null,
  contains?: AgencyRateIncludedAmount | null,
  notContains?: AgencyRateIncludedAmount | null,
};

export type ModelAgencyRateRepartitionTypeInput = {
  eq?: AgencyRateRepartitionType | null,
  ne?: AgencyRateRepartitionType | null,
};

export type ModelAgencyRateTypeInput = {
  eq?: AgencyRateType | null,
  ne?: AgencyRateType | null,
};

export type ModelUnitTypeInput = {
  eq?: UnitType | null,
  ne?: UnitType | null,
};

export type UpdateAgencyRateInput = {
  id: string,
  amountDetails?: Array< AgencyRateAmountDetailInput > | null,
  rateWhenVacant?: AgencyRateWhenVacantInput | null,
  amountMinimumFees?: number | null,
  custom?: boolean | null,
  feesAppliedTo?: AgencyRateFeesType | null,
  includedInAmount?: Array< AgencyRateIncludedAmount > | null,
  name?: string | null,
  repartitionType?: AgencyRateRepartitionType | null,
  type?: AgencyRateType | null,
  unitType?: Array< UnitType > | null,
  vatRateId?: string | null,
  unitIds?: Array< string | null > | null,
  readId?: string | null,
  clientId?: string | null,
  _version?: number | null,
};

export type DeleteAgencyRateInput = {
  id: string,
  _version?: number | null,
};

export type CreateAgencyRateOwnerInput = {
  id?: string | null,
  agencyRateId: string,
  contactId: string,
  readId: string,
  clientId: string,
  _version?: number | null,
};

export type ModelAgencyRateOwnerConditionInput = {
  agencyRateId?: ModelIDInput | null,
  contactId?: ModelIDInput | null,
  readId?: ModelIDInput | null,
  clientId?: ModelIDInput | null,
  and?: Array< ModelAgencyRateOwnerConditionInput | null > | null,
  or?: Array< ModelAgencyRateOwnerConditionInput | null > | null,
  not?: ModelAgencyRateOwnerConditionInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type UpdateAgencyRateOwnerInput = {
  id: string,
  agencyRateId?: string | null,
  contactId?: string | null,
  readId?: string | null,
  clientId?: string | null,
  _version?: number | null,
};

export type DeleteAgencyRateOwnerInput = {
  id: string,
  _version?: number | null,
};

export type CreateAgencyRateStatementInput = {
  id?: string | null,
  agencyRateId: string,
  statementId: string,
  unitAmounts?: Array< AgencyRateStatementAmountInput > | null,
  totalAmountRateable: number,
  totalFixedAmount: number,
  readId: string,
  clientId: string,
  _version?: number | null,
};

export type AgencyRateStatementAmountInput = {
  unitId?: string | null,
  amountRateable: number,
  fixedAmount: number,
};

export type ModelAgencyRateStatementConditionInput = {
  agencyRateId?: ModelIDInput | null,
  statementId?: ModelIDInput | null,
  totalAmountRateable?: ModelFloatInput | null,
  totalFixedAmount?: ModelFloatInput | null,
  readId?: ModelIDInput | null,
  clientId?: ModelIDInput | null,
  and?: Array< ModelAgencyRateStatementConditionInput | null > | null,
  or?: Array< ModelAgencyRateStatementConditionInput | null > | null,
  not?: ModelAgencyRateStatementConditionInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type UpdateAgencyRateStatementInput = {
  id: string,
  agencyRateId?: string | null,
  statementId?: string | null,
  unitAmounts?: Array< AgencyRateStatementAmountInput > | null,
  totalAmountRateable?: number | null,
  totalFixedAmount?: number | null,
  readId?: string | null,
  clientId?: string | null,
  _version?: number | null,
};

export type DeleteAgencyRateStatementInput = {
  id: string,
  _version?: number | null,
};

export type CreateBillingItemInput = {
  id?: string | null,
  name: string,
  baseAmount?: number | null,
  billingType?: InvoiceBillingType | null,
  amountCalculationType?: InvoiceAmountCalculationType | null,
  percentageBase?: InvoicePercentageBase | null,
  period?: LeasePaymentFrequency | null,
  vatRateId?: string | null,
  invoiceId?: string | null,
  quantity?: number | null,
  percentage?: number | null,
  allocationOption: BillingItemAllocationOption,
  multipleUnitsSplit?: BillingItemMultipleUnitsSplitOption | null,
  leaseIds?: Array< string | null > | null,
  unitIds?: Array< string | null > | null,
  buildingIds?: Array< string | null > | null,
  accountLabelId?: string | null,
  readId: string,
  clientId: string,
  _version?: number | null,
};

export enum BillingItemMultipleUnitsSplitOption {
  SPLIT_BY_RENTAL_VALUE = "SPLIT_BY_RENTAL_VALUE",
  SPLIT_BY_SURFACE = "SPLIT_BY_SURFACE",
}

export type ModelBillingItemConditionInput = {
  name?: ModelStringInput | null,
  baseAmount?: ModelIntInput | null,
  billingType?: ModelInvoiceBillingTypeInput | null,
  amountCalculationType?: ModelInvoiceAmountCalculationTypeInput | null,
  percentageBase?: ModelInvoicePercentageBaseInput | null,
  period?: ModelLeasePaymentFrequencyInput | null,
  vatRateId?: ModelIDInput | null,
  invoiceId?: ModelIDInput | null,
  quantity?: ModelFloatInput | null,
  percentage?: ModelFloatInput | null,
  allocationOption?: ModelBillingItemAllocationOptionInput | null,
  multipleUnitsSplit?: ModelBillingItemMultipleUnitsSplitOptionInput | null,
  leaseIds?: ModelIDInput | null,
  unitIds?: ModelIDInput | null,
  buildingIds?: ModelIDInput | null,
  accountLabelId?: ModelIDInput | null,
  readId?: ModelIDInput | null,
  clientId?: ModelIDInput | null,
  and?: Array< ModelBillingItemConditionInput | null > | null,
  or?: Array< ModelBillingItemConditionInput | null > | null,
  not?: ModelBillingItemConditionInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelInvoiceBillingTypeInput = {
  eq?: InvoiceBillingType | null,
  ne?: InvoiceBillingType | null,
};

export type ModelInvoiceAmountCalculationTypeInput = {
  eq?: InvoiceAmountCalculationType | null,
  ne?: InvoiceAmountCalculationType | null,
};

export type ModelInvoicePercentageBaseInput = {
  eq?: InvoicePercentageBase | null,
  ne?: InvoicePercentageBase | null,
};

export type ModelLeasePaymentFrequencyInput = {
  eq?: LeasePaymentFrequency | null,
  ne?: LeasePaymentFrequency | null,
};

export type ModelBillingItemAllocationOptionInput = {
  eq?: BillingItemAllocationOption | null,
  ne?: BillingItemAllocationOption | null,
};

export type ModelBillingItemMultipleUnitsSplitOptionInput = {
  eq?: BillingItemMultipleUnitsSplitOption | null,
  ne?: BillingItemMultipleUnitsSplitOption | null,
};

export enum ReleaseNoteStatus {
  DRAFT = "DRAFT",
  PUBLISHED = "PUBLISHED",
}


export type ReleaseNoteContentDTO = {
  __typename: "ReleaseNoteContent",
  language: Language,
  title: string,
  body: string,
};

export type ReleaseNoteDTO = {
  __typename: "ReleaseNote",
  id: string,
  status: ReleaseNoteStatus,
  publishedAt?: string | null,
  visibleToOwners: boolean,
  contents:  Array<ReleaseNoteContentDTO >,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type ReleaseNoteContentInput = {
  language: Language,
  title: string,
  body: string,
};

export type CreateReleaseNoteInput = {
  id?: string | null,
  status: ReleaseNoteStatus,
  publishedAt?: string | null,
  visibleToOwners: boolean,
  contents: Array< ReleaseNoteContentInput >,
  _version?: number | null,
};

export type UpdateReleaseNoteInput = {
  id: string,
  status?: ReleaseNoteStatus | null,
  publishedAt?: string | null,
  visibleToOwners?: boolean | null,
  contents?: Array< ReleaseNoteContentInput > | null,
  _version?: number | null,
};

export type UpsertReleaseNoteInput = {
  id?: string | null,
  visibleToOwners: boolean,
  contents: Array< ReleaseNoteContentInput >,
};

export type PublishReleaseNoteInput = {
  id: string,
};

export type BillingItemDTO = {
  __typename: "BillingItem",
  id: string,
  name: string,
  baseAmount?: number | null,
  billingType?: InvoiceBillingType | null,
  amountCalculationType?: InvoiceAmountCalculationType | null,
  percentageBase?: InvoicePercentageBase | null,
  period?: LeasePaymentFrequency | null,
  vatRateId?: string | null,
  vatRate?: VatRateDTO | null,
  invoiceId?: string | null,
  quantity?: number | null,
  percentage?: number | null,
  allocationOption: BillingItemAllocationOption,
  multipleUnitsSplit?: BillingItemMultipleUnitsSplitOption | null,
  leaseIds?: Array< string | null > | null,
  unitIds?: Array< string | null > | null,
  buildingIds?: Array< string | null > | null,
  accountLabelId?: string | null,
  readId: string,
  clientId: string,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type UpdateBillingItemInput = {
  id: string,
  name?: string | null,
  baseAmount?: number | null,
  billingType?: InvoiceBillingType | null,
  amountCalculationType?: InvoiceAmountCalculationType | null,
  percentageBase?: InvoicePercentageBase | null,
  period?: LeasePaymentFrequency | null,
  vatRateId?: string | null,
  invoiceId?: string | null,
  quantity?: number | null,
  percentage?: number | null,
  allocationOption?: BillingItemAllocationOption | null,
  multipleUnitsSplit?: BillingItemMultipleUnitsSplitOption | null,
  leaseIds?: Array< string | null > | null,
  unitIds?: Array< string | null > | null,
  buildingIds?: Array< string | null > | null,
  accountLabelId?: string | null,
  readId?: string | null,
  clientId?: string | null,
  _version?: number | null,
};

export type DeleteBillingItemInput = {
  id: string,
  _version?: number | null,
};

export type CreateBuildingInput = {
  id?: string | null,
  name: string,
  addressId?: string | null,
  acquisitionValue?: number | null,
  acquisitionAdditionalCostsValue?: number | null,
  acquisitionAdvertisedValue?: number | null,
  amountOfFacades?: number | null,
  amountOfFloors?: number | null,
  amountOfHousings?: number | null,
  buildingState?: BuildingState | null,
  cadastralIncome?: number | null,
  constructionYear?: string | null,
  customValues?: Array< CustomValueInput > | null,
  janitor?: boolean | null,
  jointOwnershipId?: string | null,
  notes?: string | null,
  propertyTax?: number | null,
  residenceName?: string | null,
  buildingSiteId?: string | null,
  readers?: Array< string > | null,
  teams?: Array< string > | null,
  readId: string,
  clientId: string,
  _version?: number | null,
};

export type ModelBuildingConditionInput = {
  name?: ModelStringInput | null,
  addressId?: ModelIDInput | null,
  acquisitionValue?: ModelFloatInput | null,
  acquisitionAdditionalCostsValue?: ModelFloatInput | null,
  acquisitionAdvertisedValue?: ModelFloatInput | null,
  amountOfFacades?: ModelIntInput | null,
  amountOfFloors?: ModelIntInput | null,
  amountOfHousings?: ModelIntInput | null,
  buildingState?: ModelBuildingStateInput | null,
  cadastralIncome?: ModelFloatInput | null,
  constructionYear?: ModelStringInput | null,
  janitor?: ModelBooleanInput | null,
  jointOwnershipId?: ModelIDInput | null,
  notes?: ModelStringInput | null,
  propertyTax?: ModelFloatInput | null,
  residenceName?: ModelStringInput | null,
  buildingSiteId?: ModelIDInput | null,
  readers?: ModelIDInput | null,
  teams?: ModelIDInput | null,
  readId?: ModelIDInput | null,
  clientId?: ModelIDInput | null,
  and?: Array< ModelBuildingConditionInput | null > | null,
  or?: Array< ModelBuildingConditionInput | null > | null,
  not?: ModelBuildingConditionInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelBuildingStateInput = {
  eq?: BuildingState | null,
  ne?: BuildingState | null,
};

export type UpdateBuildingInput = {
  id: string,
  name?: string | null,
  addressId?: string | null,
  acquisitionValue?: number | null,
  acquisitionAdditionalCostsValue?: number | null,
  acquisitionAdvertisedValue?: number | null,
  amountOfFacades?: number | null,
  amountOfFloors?: number | null,
  amountOfHousings?: number | null,
  buildingState?: BuildingState | null,
  cadastralIncome?: number | null,
  constructionYear?: string | null,
  customValues?: Array< CustomValueInput > | null,
  janitor?: boolean | null,
  jointOwnershipId?: string | null,
  notes?: string | null,
  propertyTax?: number | null,
  residenceName?: string | null,
  buildingSiteId?: string | null,
  readers?: Array< string > | null,
  teams?: Array< string > | null,
  readId?: string | null,
  clientId?: string | null,
  _version?: number | null,
};

export type DeleteBuildingInput = {
  id: string,
  _version?: number | null,
};

export type CreateBuildingEventInput = {
  id?: string | null,
  buildingId: string,
  type: string,
  startDate: string,
  endDate: string,
  totalCost?: number | null,
  note?: string | null,
  writers?: Array< string > | null,
  readId: string,
  clientId: string,
  _version?: number | null,
};

export type ModelBuildingEventConditionInput = {
  buildingId?: ModelIDInput | null,
  type?: ModelStringInput | null,
  startDate?: ModelStringInput | null,
  endDate?: ModelStringInput | null,
  totalCost?: ModelFloatInput | null,
  note?: ModelStringInput | null,
  writers?: ModelIDInput | null,
  readId?: ModelIDInput | null,
  clientId?: ModelIDInput | null,
  and?: Array< ModelBuildingEventConditionInput | null > | null,
  or?: Array< ModelBuildingEventConditionInput | null > | null,
  not?: ModelBuildingEventConditionInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type UpdateBuildingEventInput = {
  id: string,
  buildingId?: string | null,
  type?: string | null,
  startDate?: string | null,
  endDate?: string | null,
  totalCost?: number | null,
  note?: string | null,
  writers?: Array< string > | null,
  readId?: string | null,
  clientId?: string | null,
  _version?: number | null,
};

export type DeleteBuildingEventInput = {
  id: string,
  _version?: number | null,
};

export type CreateBuildingOwnerInput = {
  id?: string | null,
  buildingId: string,
  contactId: string,
  disabled?: boolean | null,
  periodFrom?: string | null,
  periodTo?: string | null,
  stake: number,
  readers?: Array< string > | null,
  readId: string,
  clientId: string,
  _version?: number | null,
};

export type ModelBuildingOwnerConditionInput = {
  buildingId?: ModelIDInput | null,
  contactId?: ModelIDInput | null,
  disabled?: ModelBooleanInput | null,
  periodFrom?: ModelStringInput | null,
  periodTo?: ModelStringInput | null,
  stake?: ModelFloatInput | null,
  readers?: ModelIDInput | null,
  readId?: ModelIDInput | null,
  clientId?: ModelIDInput | null,
  and?: Array< ModelBuildingOwnerConditionInput | null > | null,
  or?: Array< ModelBuildingOwnerConditionInput | null > | null,
  not?: ModelBuildingOwnerConditionInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type UpdateBuildingOwnerInput = {
  id: string,
  buildingId?: string | null,
  contactId?: string | null,
  disabled?: boolean | null,
  periodFrom?: string | null,
  periodTo?: string | null,
  stake?: number | null,
  readers?: Array< string > | null,
  readId?: string | null,
  clientId?: string | null,
  _version?: number | null,
};

export type DeleteBuildingOwnerInput = {
  id: string,
  _version?: number | null,
};

export type CreateBuildingSiteInput = {
  id?: string | null,
  name: string,
  readers?: Array< string > | null,
  teams?: Array< string > | null,
  readId: string,
  clientId: string,
  _version?: number | null,
};

export type ModelBuildingSiteConditionInput = {
  name?: ModelStringInput | null,
  readers?: ModelIDInput | null,
  teams?: ModelIDInput | null,
  readId?: ModelIDInput | null,
  clientId?: ModelIDInput | null,
  and?: Array< ModelBuildingSiteConditionInput | null > | null,
  or?: Array< ModelBuildingSiteConditionInput | null > | null,
  not?: ModelBuildingSiteConditionInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type UpdateBuildingSiteInput = {
  id: string,
  name?: string | null,
  readers?: Array< string > | null,
  teams?: Array< string > | null,
  readId?: string | null,
  clientId?: string | null,
  _version?: number | null,
};

export type DeleteBuildingSiteInput = {
  id: string,
  _version?: number | null,
};

export type CreateChargeInput = {
  id?: string | null,
  status: ChargeStatus,
  invoiceDate?: string | null,
  paymentDueDate?: string | null,
  archivedDate?: string | null,
  periodFrom?: string | null,
  periodTo?: string | null,
  totalAmount?: number | null,
  payableAmount?: number | null,
  source: ChargeSource,
  draftFromOcr?: boolean | null,
  accountingDocumentId?: string | null,
  paid: boolean,
  settlement?: ChargeSettlementInput | null,
  remittanceInformation?: string | null,
  note?: string | null,
  creatorEmail?: string | null,
  createdById?: string | null,
  contractorId?: string | null,
  proposedContractors?: Array< ProposedValueInput > | null,
  recipientId?: string | null,
  proposedRecipients?: Array< ProposedValueInput > | null,
  customValues?: Array< CustomValueInput > | null,
  documentId: string,
  sectionId?: string | null,
  readId: string,
  clientId: string,
  openChargeClientId?: string | null,
  _version?: number | null,
};

export type ProposedValueInput = {
  id: string,
  confidence?: number | null,
};

export type ModelChargeConditionInput = {
  status?: ModelChargeStatusInput | null,
  invoiceDate?: ModelStringInput | null,
  paymentDueDate?: ModelStringInput | null,
  archivedDate?: ModelStringInput | null,
  periodFrom?: ModelStringInput | null,
  periodTo?: ModelStringInput | null,
  totalAmount?: ModelFloatInput | null,
  payableAmount?: ModelFloatInput | null,
  source?: ModelChargeSourceInput | null,
  draftFromOcr?: ModelBooleanInput | null,
  accountingDocumentId?: ModelIDInput | null,
  paid?: ModelBooleanInput | null,
  remittanceInformation?: ModelStringInput | null,
  note?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  creatorEmail?: ModelStringInput | null,
  createdById?: ModelIDInput | null,
  contractorId?: ModelIDInput | null,
  recipientId?: ModelIDInput | null,
  documentId?: ModelIDInput | null,
  readId?: ModelIDInput | null,
  clientId?: ModelIDInput | null,
  and?: Array< ModelChargeConditionInput | null > | null,
  or?: Array< ModelChargeConditionInput | null > | null,
  not?: ModelChargeConditionInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelChargeStatusInput = {
  eq?: ChargeStatus | null,
  ne?: ChargeStatus | null,
};

export type ModelChargeSourceInput = {
  eq?: ChargeSource | null,
  ne?: ChargeSource | null,
};

export type UpdateChargeInput = {
  id: string,
  status?: ChargeStatus | null,
  invoiceDate?: string | null,
  paymentDueDate?: string | null,
  archivedDate?: string | null,
  periodFrom?: string | null,
  periodTo?: string | null,
  totalAmount?: number | null,
  payableAmount?: number | null,
  source?: ChargeSource | null,
  draftFromOcr?: boolean | null,
  accountingDocumentId?: string | null,
  paid?: boolean | null,
  settlement?: ChargeSettlementInput | null,
  remittanceInformation?: string | null,
  note?: string | null,
  createdAt?: string | null,
  creatorEmail?: string | null,
  createdById?: string | null,
  contractorId?: string | null,
  proposedContractors?: Array< ProposedValueInput > | null,
  recipientId?: string | null,
  proposedRecipients?: Array< ProposedValueInput > | null,
  customValues?: Array< CustomValueInput > | null,
  documentId?: string | null,
  sectionId?: string | null,
  readId?: string | null,
  clientId?: string | null,
  openChargeClientId?: string | null,
  _version?: number | null,
};

export type DeleteChargeInput = {
  id: string,
  _version?: number | null,
};

export type CreateChargeStatementInput = {
  id?: string | null,
  chargeId: string,
  statementId: string,
  readId: string,
  clientId: string,
  _version?: number | null,
};

export type ModelChargeStatementConditionInput = {
  chargeId?: ModelIDInput | null,
  statementId?: ModelIDInput | null,
  readId?: ModelIDInput | null,
  clientId?: ModelIDInput | null,
  and?: Array< ModelChargeStatementConditionInput | null > | null,
  or?: Array< ModelChargeStatementConditionInput | null > | null,
  not?: ModelChargeStatementConditionInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type UpdateChargeStatementInput = {
  id: string,
  chargeId?: string | null,
  statementId?: string | null,
  readId?: string | null,
  clientId?: string | null,
  _version?: number | null,
};

export type DeleteChargeStatementInput = {
  id: string,
  _version?: number | null,
};

export type CreateRepartitionKeyInput = {
  id?: string | null,
  name: string,
  type: RepartitionKeyType,
  accountLabelId?: string | null,
  buildingId?: string | null,
  buildingSiteId?: string | null,
  unitRepartition?: Array< RepartitionValuesInput > | null,
  ownerRepartition: number,
  tenantRepartition: number,
  repartitionMetric: string,
  technics?: Array< string > | null,
  readId: string,
  clientId: string,
  _version?: number | null,
};

export enum RepartitionKeyType {
  AMOUNT = "AMOUNT",
  CONSUMPTION_BASED_ON_SHARES = "CONSUMPTION_BASED_ON_SHARES",
  CONSUMPTION_BASED_ON_USAGE = "CONSUMPTION_BASED_ON_USAGE",
  SHARES = "SHARES",
  SURFACE = "SURFACE",
  CUSTOM = "CUSTOM",
}

export type RepartitionValuesInput = {
  unitId: string,
  value: number,
};

export type ModelRepartitionKeyConditionInput = {
  name?: ModelStringInput | null,
  type?: ModelRepartitionKeyTypeInput | null,
  accountLabelId?: ModelIDInput | null,
  buildingId?: ModelIDInput | null,
  buildingSiteId?: ModelIDInput | null,
  ownerRepartition?: ModelFloatInput | null,
  tenantRepartition?: ModelFloatInput | null,
  repartitionMetric?: ModelStringInput | null,
  technics?: ModelIDInput | null,
  readId?: ModelIDInput | null,
  clientId?: ModelIDInput | null,
  and?: Array< ModelRepartitionKeyConditionInput | null > | null,
  or?: Array< ModelRepartitionKeyConditionInput | null > | null,
  not?: ModelRepartitionKeyConditionInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelRepartitionKeyTypeInput = {
  eq?: RepartitionKeyType | null,
  ne?: RepartitionKeyType | null,
};

export type RepartitionKeyDTO = {
  __typename: "RepartitionKey",
  id: string,
  name: string,
  type: RepartitionKeyType,
  accountLabelId?: string | null,
  accountLabel?: AccountLabelDTO | null,
  buildingId?: string | null,
  building?: BuildingDTO | null,
  buildingSiteId?: string | null,
  buildingSite?: BuildingSiteDTO | null,
  unitRepartition?:  Array<RepartitionValuesDTO > | null,
  ownerRepartition: number,
  tenantRepartition: number,
  repartitionMetric: string,
  technics?: Array< string > | null,
  readId: string,
  clientId: string,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type RepartitionValuesDTO = {
  __typename: "RepartitionValues",
  unitId: string,
  value: number,
};

export type UpdateRepartitionKeyInput = {
  id: string,
  name?: string | null,
  type?: RepartitionKeyType | null,
  accountLabelId?: string | null,
  buildingId?: string | null,
  buildingSiteId?: string | null,
  unitRepartition?: Array< RepartitionValuesInput > | null,
  ownerRepartition?: number | null,
  tenantRepartition?: number | null,
  repartitionMetric?: string | null,
  technics?: Array< string > | null,
  readId?: string | null,
  clientId?: string | null,
  _version?: number | null,
};

export type DeleteRepartitionKeyInput = {
  id: string,
  _version?: number | null,
};

export type CreateClientInput = {
  id?: string | null,
  accountType: AccountType,
  contactId: string,
  generalConditionsAcceptDate: string,
  lastGeneralConditionsAcceptedVersion: string,
  GDPRAcceptDate: string,
  lastGDPRAcceptedVersion: string,
  _version?: number | null,
};

export type ModelClientConditionInput = {
  accountType?: ModelAccountTypeInput | null,
  contactId?: ModelIDInput | null,
  generalConditionsAcceptDate?: ModelStringInput | null,
  lastGeneralConditionsAcceptedVersion?: ModelStringInput | null,
  GDPRAcceptDate?: ModelStringInput | null,
  lastGDPRAcceptedVersion?: ModelStringInput | null,
  and?: Array< ModelClientConditionInput | null > | null,
  or?: Array< ModelClientConditionInput | null > | null,
  not?: ModelClientConditionInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelAccountTypeInput = {
  eq?: AccountType | null,
  ne?: AccountType | null,
};

export type ClientDTO = {
  __typename: "Client",
  id: string,
  accountType: AccountType,
  contactId: string,
  contact?: ContactDTO | null,
  generalConditionsAcceptDate: string,
  lastGeneralConditionsAcceptedVersion: string,
  GDPRAcceptDate: string,
  lastGDPRAcceptedVersion: string,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type UpdateClientInput = {
  id: string,
  accountType?: AccountType | null,
  contactId?: string | null,
  generalConditionsAcceptDate?: string | null,
  lastGeneralConditionsAcceptedVersion?: string | null,
  GDPRAcceptDate?: string | null,
  lastGDPRAcceptedVersion?: string | null,
  _version?: number | null,
};

export type DeleteClientInput = {
  id: string,
  _version?: number | null,
};

export type CreateCommunicationInput = {
  id?: string | null,
  addressId?: string | null,
  blockedRecipients?: Array< CommunicationBlockedRecipientInput > | null,
  body: string,
  buildingId?: string | null,
  channel: CommunicationChannel,
  communicationTemplateId?: string | null,
  concernedContactIds?: Array< string > | null,
  contactId?: string | null,
  contactIds?: Array< string > | null,
  createdAt?: string | null,
  draftProperties?: CommunicationDraftPropertiesInput | null,
  expirationDate?: string | null,
  invoiceId?: string | null,
  leaseId?: string | null,
  leasePriceHistoryId?: string | null,
  letterTrackingCode?: string | null,
  letterTrackingProvider?: TrackingProvider | null,
  linkedCommunicationsIds?: Array< string > | null,
  supportingDocumentFileIds?: Array< string > | null,
  recipient?: string | null,
  recipientContactIdsInBcc?: Array< string > | null,
  recipientContactIdsInCc?: Array< string > | null,
  recipientInBcc?: string | null,
  recipientInCc?: string | null,
  scheduledAt?: string | null,
  deliveredAt?: string | null,
  errorCode?: CommunicationErrorCode | null,
  nextRetryAt?: string | null,
  sendRetryCount?: number | null,
  sender?: string | null,
  sentAt?: string | null,
  externalId?: string | null,
  externalStatus?: string | null,
  signatureDocumentId?: string | null,
  snoozedDate?: string | null,
  statementId?: string | null,
  status: CommunicationStatus,
  subject: string,
  toSend: boolean,
  hideLogo?: boolean | null,
  type: CommunicationType,
  _ttl?: number | null,
  unitId?: string | null,
  readId: string,
  readers?: Array< string > | null,
  clientId: string,
  _version?: number | null,
};

export type CommunicationBlockedRecipientInput = {
  recipient: string,
  bounceType: BounceType,
};

export type CommunicationDraftPropertiesInput = {
  allowRecipientsToSeeEachOther?: boolean | null,
  bcc?: Array< string > | null,
  buildingIds?: Array< string > | null,
  cc?: Array< string > | null,
  contactIds?: Array< string > | null,
  contactTypes?: Array< ContactType > | null,
  entityType: string,
  leaseIds?: Array< string > | null,
  sendInBcc?: boolean | null,
  unitIds?: Array< string > | null,
  unitTypeFilter?: string | null,
};

export type ModelCommunicationConditionInput = {
  addressId?: ModelIDInput | null,
  body?: ModelStringInput | null,
  buildingId?: ModelStringInput | null,
  channel?: ModelCommunicationChannelInput | null,
  communicationTemplateId?: ModelIDInput | null,
  concernedContactIds?: ModelIDInput | null,
  contactId?: ModelIDInput | null,
  contactIds?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  expirationDate?: ModelStringInput | null,
  invoiceId?: ModelIDInput | null,
  leaseId?: ModelIDInput | null,
  leasePriceHistoryId?: ModelIDInput | null,
  letterTrackingCode?: ModelStringInput | null,
  letterTrackingProvider?: ModelTrackingProviderInput | null,
  linkedCommunicationsIds?: ModelIDInput | null,
  supportingDocumentFileIds?: ModelIDInput | null,
  recipient?: ModelStringInput | null,
  recipientContactIdsInBcc?: ModelIDInput | null,
  recipientContactIdsInCc?: ModelIDInput | null,
  recipientInBcc?: ModelStringInput | null,
  recipientInCc?: ModelStringInput | null,
  scheduledAt?: ModelStringInput | null,
  deliveredAt?: ModelStringInput | null,
  errorCode?: ModelCommunicationErrorCodeInput | null,
  nextRetryAt?: ModelStringInput | null,
  sendRetryCount?: ModelIntInput | null,
  sender?: ModelStringInput | null,
  sentAt?: ModelStringInput | null,
  externalId?: ModelIDInput | null,
  externalStatus?: ModelStringInput | null,
  signatureDocumentId?: ModelIDInput | null,
  snoozedDate?: ModelStringInput | null,
  statementId?: ModelIDInput | null,
  status?: ModelCommunicationStatusInput | null,
  subject?: ModelStringInput | null,
  toSend?: ModelBooleanInput | null,
  hideLogo?: ModelBooleanInput | null,
  type?: ModelCommunicationTypeInput | null,
  _ttl?: ModelIntInput | null,
  unitId?: ModelIDInput | null,
  readId?: ModelIDInput | null,
  readers?: ModelIDInput | null,
  clientId?: ModelIDInput | null,
  and?: Array< ModelCommunicationConditionInput | null > | null,
  or?: Array< ModelCommunicationConditionInput | null > | null,
  not?: ModelCommunicationConditionInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelCommunicationChannelInput = {
  eq?: CommunicationChannel | null,
  ne?: CommunicationChannel | null,
};

export type ModelTrackingProviderInput = {
  eq?: TrackingProvider | null,
  ne?: TrackingProvider | null,
};

export type ModelCommunicationErrorCodeInput = {
  eq?: CommunicationErrorCode | null,
  ne?: CommunicationErrorCode | null,
};

export type ModelCommunicationStatusInput = {
  eq?: CommunicationStatus | null,
  ne?: CommunicationStatus | null,
};

export type ModelCommunicationTypeInput = {
  eq?: CommunicationType | null,
  ne?: CommunicationType | null,
};

export type UpdateCommunicationInput = {
  id: string,
  addressId?: string | null,
  blockedRecipients?: Array< CommunicationBlockedRecipientInput > | null,
  body?: string | null,
  buildingId?: string | null,
  channel?: CommunicationChannel | null,
  communicationTemplateId?: string | null,
  concernedContactIds?: Array< string > | null,
  contactId?: string | null,
  contactIds?: Array< string > | null,
  createdAt?: string | null,
  draftProperties?: CommunicationDraftPropertiesInput | null,
  expirationDate?: string | null,
  invoiceId?: string | null,
  leaseId?: string | null,
  leasePriceHistoryId?: string | null,
  letterTrackingCode?: string | null,
  letterTrackingProvider?: TrackingProvider | null,
  linkedCommunicationsIds?: Array< string > | null,
  supportingDocumentFileIds?: Array< string > | null,
  recipient?: string | null,
  recipientContactIdsInBcc?: Array< string > | null,
  recipientContactIdsInCc?: Array< string > | null,
  recipientInBcc?: string | null,
  recipientInCc?: string | null,
  scheduledAt?: string | null,
  deliveredAt?: string | null,
  errorCode?: CommunicationErrorCode | null,
  nextRetryAt?: string | null,
  sendRetryCount?: number | null,
  sender?: string | null,
  sentAt?: string | null,
  externalId?: string | null,
  externalStatus?: string | null,
  signatureDocumentId?: string | null,
  snoozedDate?: string | null,
  statementId?: string | null,
  status?: CommunicationStatus | null,
  subject?: string | null,
  toSend?: boolean | null,
  hideLogo?: boolean | null,
  type?: CommunicationType | null,
  _ttl?: number | null,
  unitId?: string | null,
  readId?: string | null,
  readers?: Array< string > | null,
  clientId?: string | null,
  _version?: number | null,
};

export type DeleteCommunicationInput = {
  id: string,
  _version?: number | null,
};

export type CreateCommunicationSettingsProfileInput = {
  id?: string | null,
  communicationsSettings: Array< CommunicationSettingsInput >,
  createdAt?: string | null,
  defaultName?: string | null,
  isDefaultSetting: boolean,
  referent: CommunicationSettingsProfileReferent,
  replacementId?: string | null,
  displayLogo: boolean,
  tenantStatementView: StatementViewType,
  readId: string,
  readers?: Array< string > | null,
  clientId: string,
  _version?: number | null,
};

export type CommunicationSettingsInput = {
  channels: Array< CommunicationChannel >,
  communicationType: CommunicationType,
  daysBeforeDueDate?: number | null,
  daysOverdue?: number | null,
  frequency?: CommunicationFrequencySettingInput | null,
  invoiceDaysAfterPeriodStart?: number | null,
  sendingRule: CommunicationSendingRule,
  recipients: Array< CommunicationSettingRecipient >,
  recipientsInBcc: Array< CommunicationSettingRecipient >,
  recipientsInCopy: Array< string >,
  displayOpenBalance?: boolean | null,
};

export type CommunicationFrequencySettingInput = {
  dateFrom?: CommunicationFrequencySettingPeriodDateFrom | null,
  periodInterval: number,
  periodType: CommunicationFrequencySettingPeriodType,
};

export enum CommunicationFrequencySettingPeriodDateFrom {
  ANNIVERSARY = "ANNIVERSARY",
  MAINTENANCE_DAY = "MAINTENANCE_DAY",
}

export enum CommunicationFrequencySettingPeriodType {
  DAYS = "DAYS",
  WEEKS = "WEEKS",
  MONTHS = "MONTHS",
  YEARS = "YEARS",
}

export enum CommunicationSendingRule {
  AUTOMATIC = "AUTOMATIC",
  DISABLE = "DISABLE",
  MANUAL = "MANUAL",
}

export enum CommunicationSettingRecipient {
  GUARANTOR = "GUARANTOR",
  OWNER = "OWNER",
  TENANT = "TENANT",
  MEMBER = "MEMBER",
}

export enum CommunicationSettingsProfileReferent {
  LEASE = "LEASE",
  OWNER = "OWNER",
  TECHNIC = "TECHNIC",
}

export type ModelCommunicationSettingsProfileConditionInput = {
  createdAt?: ModelStringInput | null,
  defaultName?: ModelStringInput | null,
  isDefaultSetting?: ModelBooleanInput | null,
  referent?: ModelCommunicationSettingsProfileReferentInput | null,
  replacementId?: ModelIDInput | null,
  displayLogo?: ModelBooleanInput | null,
  tenantStatementView?: ModelStatementViewTypeInput | null,
  readId?: ModelIDInput | null,
  readers?: ModelIDInput | null,
  clientId?: ModelIDInput | null,
  and?: Array< ModelCommunicationSettingsProfileConditionInput | null > | null,
  or?: Array< ModelCommunicationSettingsProfileConditionInput | null > | null,
  not?: ModelCommunicationSettingsProfileConditionInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelCommunicationSettingsProfileReferentInput = {
  eq?: CommunicationSettingsProfileReferent | null,
  ne?: CommunicationSettingsProfileReferent | null,
};

export type ModelStatementViewTypeInput = {
  eq?: StatementViewType | null,
  ne?: StatementViewType | null,
};

export type CommunicationSettingsProfileDTO = {
  __typename: "CommunicationSettingsProfile",
  id: string,
  communicationsSettings:  Array<CommunicationSettingsDTO >,
  createdAt?: string | null,
  defaultName?: string | null,
  isDefaultSetting: boolean,
  referent: CommunicationSettingsProfileReferent,
  replacementId?: string | null,
  displayLogo: boolean,
  tenantStatementView: StatementViewType,
  readId: string,
  readers?: Array< string > | null,
  clientId: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type CommunicationSettingsDTO = {
  __typename: "CommunicationSettings",
  channels: Array< CommunicationChannel >,
  communicationType: CommunicationType,
  daysBeforeDueDate?: number | null,
  daysOverdue?: number | null,
  frequency?: CommunicationFrequencySettingDTO | null,
  invoiceDaysAfterPeriodStart?: number | null,
  sendingRule: CommunicationSendingRule,
  recipients: Array< CommunicationSettingRecipient >,
  recipientsInBcc: Array< CommunicationSettingRecipient >,
  recipientsInCopy: Array< string >,
  displayOpenBalance?: boolean | null,
};

export type CommunicationFrequencySettingDTO = {
  __typename: "CommunicationFrequencySetting",
  dateFrom?: CommunicationFrequencySettingPeriodDateFrom | null,
  periodInterval: number,
  periodType: CommunicationFrequencySettingPeriodType,
};

export type UpdateCommunicationSettingsProfileInput = {
  id: string,
  communicationsSettings?: Array< CommunicationSettingsInput > | null,
  createdAt?: string | null,
  defaultName?: string | null,
  isDefaultSetting?: boolean | null,
  referent?: CommunicationSettingsProfileReferent | null,
  replacementId?: string | null,
  displayLogo?: boolean | null,
  tenantStatementView?: StatementViewType | null,
  readId?: string | null,
  readers?: Array< string > | null,
  clientId?: string | null,
  _version?: number | null,
};

export type DeleteCommunicationSettingsProfileInput = {
  id: string,
  _version?: number | null,
};

export type CreateTemplateInput = {
  id?: string | null,
  language: string,
  name?: string | null,
  subject?: string | null,
  subjectRawFormat?: string | null,
  body: string,
  bodyRawFormat?: string | null,
  type: TemplateType,
  subType: TemplateSubType,
  readId: string,
  clientId: string,
  _version?: number | null,
};

export enum TemplateType {
  MAIL = "MAIL",
  CONTRACT = "CONTRACT",
  CONTRACT_DOCUMENT = "CONTRACT_DOCUMENT",
  SMS = "SMS",
  WHATSAPP = "WHATSAPP",
}

export enum TemplateSubType {
  CUSTOM = "CUSTOM",
  ACCOUNTING_EXPORT = "ACCOUNTING_EXPORT",
  FOOTER = "FOOTER",
  HEADER = "HEADER",
  MAIN_RESIDENCE_9_YEARS = "MAIN_RESIDENCE_9_YEARS",
  REPORT = "REPORT",
  DOCUMENT_SIGNATURE_REMINDER = "DOCUMENT_SIGNATURE_REMINDER",
  DOCUMENT_SIGNED = "DOCUMENT_SIGNED",
  LEASE_ALLOW_PROFESSIONAL_ACTIVITY_ON = "LEASE_ALLOW_PROFESSIONAL_ACTIVITY_ON",
  LEASE_BANKING_INFO_UPDATE = "LEASE_BANKING_INFO_UPDATE",
  LEASE_CHARGES_ADJUSTMENT = "LEASE_CHARGES_ADJUSTMENT",
  LEASE_CONTRACT_EXTENDED = "LEASE_CONTRACT_EXTENDED",
  LEASE_CONTRACT_REJECTED = "LEASE_CONTRACT_REJECTED",
  LEASE_CONTRACT_RETRACTED = "LEASE_CONTRACT_RETRACTED",
  LEASE_CONTRACT_REVOKED = "LEASE_CONTRACT_REVOKED",
  LEASE_CONTRACT_SIGNATURE_REMINDER = "LEASE_CONTRACT_SIGNATURE_REMINDER",
  LEASE_CONTRACT_SIGNED = "LEASE_CONTRACT_SIGNED",
  LEASE_CREDIT_NOTE = "LEASE_CREDIT_NOTE",
  LEASE_DISCOUNT_CREATED = "LEASE_DISCOUNT_CREATED",
  LEASE_DISCOUNT_DELETED = "LEASE_DISCOUNT_DELETED",
  LEASE_DISCOUNT_UPDATED = "LEASE_DISCOUNT_UPDATED",
  LEASE_OPERATION_CREATED = "LEASE_OPERATION_CREATED",
  LEASE_OPERATION_DELETED = "LEASE_OPERATION_DELETED",
  LEASE_OPERATION_PAYMENT_REQUEST = "LEASE_OPERATION_PAYMENT_REQUEST",
  LEASE_OPERATION_UPDATED = "LEASE_OPERATION_UPDATED",
  LEASE_PAYMENT_PROVIDER_MANDATE_REQUEST = "LEASE_PAYMENT_PROVIDER_MANDATE_REQUEST",
  LEASE_PAYMENT_RECEIPT = "LEASE_PAYMENT_RECEIPT",
  LEASE_PAYMENT_REQUEST = "LEASE_PAYMENT_REQUEST",
  LEASE_RENT_INDEXATION = "LEASE_RENT_INDEXATION",
  LEASE_RENT_INDEXATION_SKIPPED = "LEASE_RENT_INDEXATION_SKIPPED",
  LEASE_RENTAL_ADAPTATION = "LEASE_RENTAL_ADAPTATION",
  LEASE_TENANT_STATEMENT = "LEASE_TENANT_STATEMENT",
  LEASE_TERMINATION = "LEASE_TERMINATION",
  LEASE_UNPAID_AMOUNT_FORMAL_NOTICE = "LEASE_UNPAID_AMOUNT_FORMAL_NOTICE",
  LEASE_UNPAID_AMOUNT_REMINDER = "LEASE_UNPAID_AMOUNT_REMINDER",
  LEASE_UNPAID_AMOUNT_SECOND_REMINDER = "LEASE_UNPAID_AMOUNT_SECOND_REMINDER",
  LEASE_UNPAID_AMOUNT_THIRD_REMINDER = "LEASE_UNPAID_AMOUNT_THIRD_REMINDER",
  LEASE_UNPAID_CONSOLIDATED_PAYMENT_REMINDER = "LEASE_UNPAID_CONSOLIDATED_PAYMENT_REMINDER",
  LEASE_SEPA_PREDEBIT_NOTICE = "LEASE_SEPA_PREDEBIT_NOTICE",
  LEASE_SEPA_PAYMENT_FAILED = "LEASE_SEPA_PAYMENT_FAILED",
  LEASE_SEPA_MANDATE_FAILED = "LEASE_SEPA_MANDATE_FAILED",
  OWNER_STATEMENT = "OWNER_STATEMENT",
  COMPANY_INVOICE = "COMPANY_INVOICE",
  CERTIFICATE_EXPIRED = "CERTIFICATE_EXPIRED",
  CERTIFICATE_UPCOMING_EXPIRATION = "CERTIFICATE_UPCOMING_EXPIRATION",
}

export type ModelTemplateConditionInput = {
  language?: ModelStringInput | null,
  name?: ModelStringInput | null,
  subject?: ModelStringInput | null,
  subjectRawFormat?: ModelStringInput | null,
  body?: ModelStringInput | null,
  bodyRawFormat?: ModelStringInput | null,
  type?: ModelTemplateTypeInput | null,
  subType?: ModelTemplateSubTypeInput | null,
  readId?: ModelIDInput | null,
  clientId?: ModelIDInput | null,
  and?: Array< ModelTemplateConditionInput | null > | null,
  or?: Array< ModelTemplateConditionInput | null > | null,
  not?: ModelTemplateConditionInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelTemplateTypeInput = {
  eq?: TemplateType | null,
  ne?: TemplateType | null,
};

export type ModelTemplateSubTypeInput = {
  eq?: TemplateSubType | null,
  ne?: TemplateSubType | null,
};

export type TemplateDTO = {
  __typename: "Template",
  id: string,
  language: string,
  name?: string | null,
  subject?: string | null,
  subjectRawFormat?: string | null,
  body: string,
  bodyRawFormat?: string | null,
  type: TemplateType,
  subType: TemplateSubType,
  readId: string,
  clientId: string,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type UpdateTemplateInput = {
  id: string,
  language?: string | null,
  name?: string | null,
  subject?: string | null,
  subjectRawFormat?: string | null,
  body?: string | null,
  bodyRawFormat?: string | null,
  type?: TemplateType | null,
  subType?: TemplateSubType | null,
  readId?: string | null,
  clientId?: string | null,
  _version?: number | null,
};

export type DeleteTemplateInput = {
  id: string,
  _version?: number | null,
};

export type CreateContactInput = {
  id?: string | null,
  createdAt?: string | null,
  firstName?: string | null,
  lastName?: string | null,
  companyName?: string | null,
  commercialName?: string | null,
  communicationSettingsProfileId?: string | null,
  customValues?: Array< CustomValueInput > | null,
  businessNumber?: string | null,
  types: Array< ContactType >,
  vat?: string | null,
  emails?: Array< EmailInput > | null,
  email?: string | null,
  birthDate?: string | null,
  birthPlace?: string | null,
  nationalRegister?: string | null,
  ipiNumber?: string | null,
  insuranceCompany?: string | null,
  insuranceContractNumber?: string | null,
  judicialDistrict?: string | null,
  civility?: CivilityType | null,
  addressId?: string | null,
  phoneNumbers?: Array< PhoneNumberInput > | null,
  language?: string | null,
  notes?: string | null,
  profileType: ContactProfileType,
  jointOwners?: Array< JointOwnerInput > | null,
  hoaFunds?: Array< ContactHoaFundInput > | null,
  paymentTermDays?: number | null,
  acpSyndicEras?: Array< AcpSyndicEraInput > | null,
  acpSyndicHistory?: Array< AcpSyndicChangeInput > | null,
  defaultBankAccountId?: string | null,
  supplierPaymentMode?: SupplierPaymentMode | null,
  supplierPaymentModeExceptions?: Array< SupplierPaymentModeExceptionInput > | null,
  supplierPaymentModeHistory?: Array< SupplierPaymentModeChangeInput > | null,
  agencyRateDisabled?: boolean | null,
  attachStatementSupportingDocuments?: boolean | null,
  status?: ContactStatus | null,
  sendInvitation: boolean,
  peppolProperties?: ContactPeppolPropertiesInput | null,
  integrations?: ContactIntegrationsInput | null,
  readers?: Array< string > | null,
  readId: string,
  clientId: string,
  _version?: number | null,
};

export type EmailInput = {
  address: string,
  isPrimary: boolean,
  label?: string | null,
};

export type PhoneNumberInput = {
  countryCode: string,
  isPrimary: boolean,
  label?: string | null,
  number: string,
};

export type JointOwnerInput = {
  contactId: string,
  contactPerson?: boolean | null,
};

export type ContactHoaFundInput = {
  archivedAt?: string | null,
  id: string,
  kind: HoaFundKind,
  name: string,
};

export type ContactPeppolPropertiesInput = {
  isRegistered: boolean,
  mustSend: boolean,
};

export type ContactIntegrationsInput = {
  paymentProperties?: PaymentProviderPropertiesInput | null,
};

export type PaymentProviderPropertiesInput = {
  accountId: string,
};

export type ModelContactConditionInput = {
  createdAt?: ModelStringInput | null,
  firstName?: ModelStringInput | null,
  lastName?: ModelStringInput | null,
  companyName?: ModelStringInput | null,
  commercialName?: ModelStringInput | null,
  communicationSettingsProfileId?: ModelIDInput | null,
  businessNumber?: ModelStringInput | null,
  types?: ModelContactTypeInput | null,
  vat?: ModelStringInput | null,
  email?: ModelStringInput | null,
  birthDate?: ModelStringInput | null,
  birthPlace?: ModelStringInput | null,
  nationalRegister?: ModelStringInput | null,
  ipiNumber?: ModelStringInput | null,
  insuranceCompany?: ModelStringInput | null,
  insuranceContractNumber?: ModelStringInput | null,
  judicialDistrict?: ModelStringInput | null,
  civility?: ModelCivilityTypeInput | null,
  addressId?: ModelIDInput | null,
  language?: ModelStringInput | null,
  notes?: ModelStringInput | null,
  profileType?: ModelContactProfileTypeInput | null,
  agencyRateDisabled?: ModelBooleanInput | null,
  attachStatementSupportingDocuments?: ModelBooleanInput | null,
  supplierPaymentMode?: ModelSupplierPaymentModeInput | null,
  status?: ModelContactStatusInput | null,
  sendInvitation?: ModelBooleanInput | null,
  readers?: ModelIDInput | null,
  readId?: ModelIDInput | null,
  clientId?: ModelIDInput | null,
  and?: Array< ModelContactConditionInput | null > | null,
  or?: Array< ModelContactConditionInput | null > | null,
  not?: ModelContactConditionInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelContactTypeInput = {
  eq?: ContactType | null,
  ne?: ContactType | null,
};

export type ModelCivilityTypeInput = {
  eq?: CivilityType | null,
  ne?: CivilityType | null,
};

export type ModelContactProfileTypeInput = {
  eq?: ContactProfileType | null,
  ne?: ContactProfileType | null,
};

export type ModelContactStatusInput = {
  eq?: ContactStatus | null,
  ne?: ContactStatus | null,
};

export type UpdateContactInput = {
  id: string,
  createdAt?: string | null,
  firstName?: string | null,
  lastName?: string | null,
  companyName?: string | null,
  commercialName?: string | null,
  communicationSettingsProfileId?: string | null,
  customValues?: Array< CustomValueInput > | null,
  businessNumber?: string | null,
  types?: Array< ContactType > | null,
  vat?: string | null,
  emails?: Array< EmailInput > | null,
  email?: string | null,
  birthDate?: string | null,
  birthPlace?: string | null,
  nationalRegister?: string | null,
  ipiNumber?: string | null,
  insuranceCompany?: string | null,
  insuranceContractNumber?: string | null,
  judicialDistrict?: string | null,
  civility?: CivilityType | null,
  addressId?: string | null,
  phoneNumbers?: Array< PhoneNumberInput > | null,
  language?: string | null,
  notes?: string | null,
  profileType?: ContactProfileType | null,
  jointOwners?: Array< JointOwnerInput > | null,
  hoaFunds?: Array< ContactHoaFundInput > | null,
  paymentTermDays?: number | null,
  acpSyndicEras?: Array< AcpSyndicEraInput > | null,
  acpSyndicHistory?: Array< AcpSyndicChangeInput > | null,
  defaultBankAccountId?: string | null,
  supplierPaymentMode?: SupplierPaymentMode | null,
  supplierPaymentModeExceptions?: Array< SupplierPaymentModeExceptionInput > | null,
  supplierPaymentModeHistory?: Array< SupplierPaymentModeChangeInput > | null,
  agencyRateDisabled?: boolean | null,
  attachStatementSupportingDocuments?: boolean | null,
  status?: ContactStatus | null,
  sendInvitation?: boolean | null,
  peppolProperties?: ContactPeppolPropertiesInput | null,
  integrations?: ContactIntegrationsInput | null,
  readers?: Array< string > | null,
  readId?: string | null,
  clientId?: string | null,
  _version?: number | null,
};

export type DeleteContactInput = {
  id: string,
  _version?: number | null,
};

export type CreateAddressInput = {
  id?: string | null,
  status?: AddressStatus | null,
  street: string,
  number?: string | null,
  box?: string | null,
  postalCode?: string | null,
  city?: string | null,
  region?: string | null,
  country?: string | null,
  customValues?: Array< CustomValueInput > | null,
  latitude?: number | null,
  longitude?: number | null,
  readers?: Array< string > | null,
  readId: string,
  clientId: string,
  _version?: number | null,
};

export type ModelAddressConditionInput = {
  status?: ModelAddressStatusInput | null,
  street?: ModelStringInput | null,
  number?: ModelStringInput | null,
  box?: ModelStringInput | null,
  postalCode?: ModelStringInput | null,
  city?: ModelStringInput | null,
  region?: ModelStringInput | null,
  country?: ModelStringInput | null,
  latitude?: ModelFloatInput | null,
  longitude?: ModelFloatInput | null,
  readers?: ModelIDInput | null,
  readId?: ModelIDInput | null,
  clientId?: ModelIDInput | null,
  and?: Array< ModelAddressConditionInput | null > | null,
  or?: Array< ModelAddressConditionInput | null > | null,
  not?: ModelAddressConditionInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelAddressStatusInput = {
  eq?: AddressStatus | null,
  ne?: AddressStatus | null,
};

export type UpdateAddressInput = {
  id: string,
  status?: AddressStatus | null,
  street?: string | null,
  number?: string | null,
  box?: string | null,
  postalCode?: string | null,
  city?: string | null,
  region?: string | null,
  country?: string | null,
  customValues?: Array< CustomValueInput > | null,
  latitude?: number | null,
  longitude?: number | null,
  readers?: Array< string > | null,
  readId?: string | null,
  clientId?: string | null,
  _version?: number | null,
};

export type DeleteAddressInput = {
  id: string,
  _version?: number | null,
};

export type CreateCustomFieldInput = {
  id?: string | null,
  fieldName: string,
  fieldType: CustomFieldType,
  foreignKey: string,
  foreignTableName: string,
  labels: Array< CustomLabelInput >,
  customFieldProperties?: CustomFieldPropertiesInput | null,
  order?: number | null,
  readId: string,
  clientId: string,
  _version?: number | null,
};

export enum CustomFieldType {
  BOOLEAN = "BOOLEAN",
  CHECKBOX = "CHECKBOX",
  DATE = "DATE",
  DROPDOWN = "DROPDOWN",
  FILE = "FILE",
  FLOAT = "FLOAT",
  NUMBER = "NUMBER",
  STRING = "STRING",
  UNIT_INVENTORY = "UNIT_INVENTORY",
}

export type CustomFieldPropertiesInput = {
  isRequired?: boolean | null,
  isDefault?: boolean | null,
  defaultValue?: string | null,
  options?: Array< CustomFieldOptionInput > | null,
};

export type CustomFieldOptionInput = {
  id: string,
  labels: Array< CustomLabelInput >,
};

export type ModelCustomFieldConditionInput = {
  fieldName?: ModelStringInput | null,
  fieldType?: ModelCustomFieldTypeInput | null,
  foreignKey?: ModelIDInput | null,
  foreignTableName?: ModelStringInput | null,
  order?: ModelIntInput | null,
  readId?: ModelIDInput | null,
  clientId?: ModelIDInput | null,
  and?: Array< ModelCustomFieldConditionInput | null > | null,
  or?: Array< ModelCustomFieldConditionInput | null > | null,
  not?: ModelCustomFieldConditionInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelCustomFieldTypeInput = {
  eq?: CustomFieldType | null,
  ne?: CustomFieldType | null,
};

export type CustomFieldDTO = {
  __typename: "CustomField",
  id: string,
  fieldName: string,
  fieldType: CustomFieldType,
  foreignKey: string,
  foreignTableName: string,
  labels:  Array<CustomLabelDTO >,
  customFieldProperties?: CustomFieldPropertiesDTO | null,
  order?: number | null,
  readId: string,
  clientId: string,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type CustomFieldPropertiesDTO = {
  __typename: "CustomFieldProperties",
  isRequired?: boolean | null,
  isDefault?: boolean | null,
  defaultValue?: string | null,
  options?:  Array<CustomFieldOptionDTO > | null,
};

export type CustomFieldOptionDTO = {
  __typename: "CustomFieldOption",
  id: string,
  labels:  Array<CustomLabelDTO >,
};

export type UpdateCustomFieldInput = {
  id: string,
  fieldName?: string | null,
  fieldType?: CustomFieldType | null,
  foreignKey?: string | null,
  foreignTableName?: string | null,
  labels?: Array< CustomLabelInput > | null,
  customFieldProperties?: CustomFieldPropertiesInput | null,
  order?: number | null,
  readId?: string | null,
  clientId?: string | null,
  _version?: number | null,
};

export type DeleteCustomFieldInput = {
  id: string,
  _version?: number | null,
};

export type CreateCustomSubscriptionInput = {
  id?: string | null,
  name: CustomSubscriptionType,
  value: string,
  createdAt?: string | null,
  userId?: string | null,
  _ttl: number,
  updatedAt?: string | null,
  clientId: string,
  _version?: number | null,
};

export enum CustomSubscriptionType {
  BLOCKED_COMMUNICATIONS = "BLOCKED_COMMUNICATIONS",
  CREDITS = "CREDITS",
  ENTITY_DELETION = "ENTITY_DELETION",
  FEATURE_ANNOUNCEMENT = "FEATURE_ANNOUNCEMENT",
  INDEXATION = "INDEXATION",
  INTEGRATION = "INTEGRATION",
  INTERNAL_COMMENT = "INTERNAL_COMMENT",
  OCR_SUCCESS = "OCR_SUCCESS",
  OCR_FAILURE = "OCR_FAILURE",
  PEPPOL = "PEPPOL",
  REFETCH = "REFETCH",
  REPORT = "REPORT",
  SENDING_SOURCE = "SENDING_SOURCE",
  SEPA_PAYMENT_FAILED = "SEPA_PAYMENT_FAILED",
  SIGNATURE_DOCUMENT = "SIGNATURE_DOCUMENT",
  SUBSCRIPTION = "SUBSCRIPTION",
  TACIT_RENEWAL = "TACIT_RENEWAL",
  TACIT_WARNING = "TACIT_WARNING",
  ZIP = "ZIP",
}

export type ModelCustomSubscriptionConditionInput = {
  name?: ModelCustomSubscriptionTypeInput | null,
  value?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  userId?: ModelIDInput | null,
  _ttl?: ModelIntInput | null,
  updatedAt?: ModelStringInput | null,
  clientId?: ModelIDInput | null,
  and?: Array< ModelCustomSubscriptionConditionInput | null > | null,
  or?: Array< ModelCustomSubscriptionConditionInput | null > | null,
  not?: ModelCustomSubscriptionConditionInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelCustomSubscriptionTypeInput = {
  eq?: CustomSubscriptionType | null,
  ne?: CustomSubscriptionType | null,
};

export type CustomSubscriptionDTO = {
  __typename: "CustomSubscription",
  id: string,
  name: CustomSubscriptionType,
  value: string,
  createdAt?: string | null,
  userId?: string | null,
  _ttl: number,
  updatedAt: string,
  clientId: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type UpdateCustomSubscriptionInput = {
  id: string,
  name?: CustomSubscriptionType | null,
  value?: string | null,
  createdAt?: string | null,
  userId?: string | null,
  _ttl?: number | null,
  updatedAt?: string | null,
  clientId?: string | null,
  _version?: number | null,
};

export type DeleteCustomSubscriptionInput = {
  id: string,
  _version?: number | null,
};

export type CreateEntityRelationInput = {
  id?: string | null,
  sourceId: string,
  sourceTableName: string,
  foreignId: string,
  foreignTableName: string,
  linkDescription?: string | null,
  linkProperties?: RelationLinkPropertiesInput | null,
  clientId: string,
  readers?: Array< string > | null,
  readId: string,
  _version?: number | null,
};

export type RelationLinkPropertiesInput = {
  contact?: ContactRelationLinkPropertiesInput | null,
};

export type ContactRelationLinkPropertiesInput = {
  communicationSubscriptions?: Array< ContactCommunicationSubscriptionTypes > | null,
};

export type ModelEntityRelationConditionInput = {
  sourceId?: ModelIDInput | null,
  sourceTableName?: ModelStringInput | null,
  foreignId?: ModelIDInput | null,
  foreignTableName?: ModelStringInput | null,
  linkDescription?: ModelStringInput | null,
  clientId?: ModelIDInput | null,
  readers?: ModelIDInput | null,
  readId?: ModelIDInput | null,
  and?: Array< ModelEntityRelationConditionInput | null > | null,
  or?: Array< ModelEntityRelationConditionInput | null > | null,
  not?: ModelEntityRelationConditionInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type UpdateEntityRelationInput = {
  id: string,
  sourceId?: string | null,
  sourceTableName?: string | null,
  foreignId?: string | null,
  foreignTableName?: string | null,
  linkDescription?: string | null,
  linkProperties?: RelationLinkPropertiesInput | null,
  clientId?: string | null,
  readers?: Array< string > | null,
  readId?: string | null,
  _version?: number | null,
};

export type DeleteEntityRelationInput = {
  id: string,
  _version?: number | null,
};

export type CreateFileInput = {
  id?: string | null,
  bucket: string,
  createdAt?: string | null,
  categoryId: string,
  foreignKey: string,
  foreignTableName: string,
  key: string,
  mimeType?: string | null,
  region: string,
  signaturePositions?: Array< SignaturePositionInput > | null,
  size?: number | null,
  readers?: Array< string > | null,
  readId: string,
  clientId: string,
  _ttl?: number | null,
  _version?: number | null,
};

export type SignaturePositionInput = {
  top: number,
  left: number,
  page: number,
  width?: number | null,
  height?: number | null,
  contactId: string,
};

export type ModelFileConditionInput = {
  bucket?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  categoryId?: ModelIDInput | null,
  foreignKey?: ModelIDInput | null,
  foreignTableName?: ModelStringInput | null,
  key?: ModelStringInput | null,
  mimeType?: ModelStringInput | null,
  region?: ModelStringInput | null,
  size?: ModelIntInput | null,
  readers?: ModelIDInput | null,
  readId?: ModelIDInput | null,
  clientId?: ModelIDInput | null,
  _ttl?: ModelIntInput | null,
  and?: Array< ModelFileConditionInput | null > | null,
  or?: Array< ModelFileConditionInput | null > | null,
  not?: ModelFileConditionInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type UpdateFileInput = {
  id: string,
  bucket?: string | null,
  createdAt?: string | null,
  categoryId?: string | null,
  foreignKey?: string | null,
  foreignTableName?: string | null,
  key?: string | null,
  mimeType?: string | null,
  region?: string | null,
  signaturePositions?: Array< SignaturePositionInput > | null,
  size?: number | null,
  readers?: Array< string > | null,
  readId?: string | null,
  clientId?: string | null,
  _ttl?: number | null,
  _version?: number | null,
};

export type DeleteFileInput = {
  id: string,
  _version?: number | null,
};

export type CreateDocumentCategoryInput = {
  id?: string | null,
  entity?: string | null,
  fileCategory: FileCategory,
  labels: Array< CustomLabelInput >,
  parentId?: string | null,
  readers?: Array< string > | null,
  readId: string,
  clientId: string,
  _version?: number | null,
};

export type ModelDocumentCategoryConditionInput = {
  entity?: ModelStringInput | null,
  fileCategory?: ModelFileCategoryInput | null,
  parentId?: ModelIDInput | null,
  readers?: ModelIDInput | null,
  readId?: ModelIDInput | null,
  clientId?: ModelIDInput | null,
  and?: Array< ModelDocumentCategoryConditionInput | null > | null,
  or?: Array< ModelDocumentCategoryConditionInput | null > | null,
  not?: ModelDocumentCategoryConditionInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelFileCategoryInput = {
  eq?: FileCategory | null,
  ne?: FileCategory | null,
};

export type UpdateDocumentCategoryInput = {
  id: string,
  entity?: string | null,
  fileCategory?: FileCategory | null,
  labels?: Array< CustomLabelInput > | null,
  parentId?: string | null,
  readers?: Array< string > | null,
  readId?: string | null,
  clientId?: string | null,
  _version?: number | null,
};

export type DeleteDocumentCategoryInput = {
  id: string,
  _version?: number | null,
};

export type CreateSignatureDocumentInput = {
  id?: string | null,
  additionalMessage?: string | null,
  automaticRemindersDisabled?: boolean | null,
  communicationBody?: string | null,
  createdAt?: string | null,
  expirationDate?: string | null,
  fileIds?: Array< string > | null,
  foreignKey: string,
  foreignTableName: string,
  sentAt?: string | null,
  signatureMethods: Array< SignatureType >,
  signatureResults: Array< SignatureDocumentResultInput >,
  status: SignatureDocumentStatus,
  externalStatus?: string | null,
  type: SignatureDocumentType,
  readers?: Array< string > | null,
  readId: string,
  clientId: string,
  _version?: number | null,
};

export type SignatureDocumentResultInput = {
  openedDate?: string | null,
  signedDate?: string | null,
  signed?: boolean | null,
  signatureLink?: string | null,
  rejectReason?: string | null,
  lastSignInviteSentDate?: string | null,
  reminderDates?: Array< string > | null,
  trackingProvider?: TrackingProvider | null,
  trackingCode?: string | null,
  contactId: string,
};

export type ModelSignatureDocumentConditionInput = {
  additionalMessage?: ModelStringInput | null,
  automaticRemindersDisabled?: ModelBooleanInput | null,
  communicationBody?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  expirationDate?: ModelStringInput | null,
  fileIds?: ModelIDInput | null,
  foreignKey?: ModelIDInput | null,
  foreignTableName?: ModelStringInput | null,
  sentAt?: ModelStringInput | null,
  signatureMethods?: ModelSignatureTypeInput | null,
  status?: ModelSignatureDocumentStatusInput | null,
  externalStatus?: ModelStringInput | null,
  type?: ModelSignatureDocumentTypeInput | null,
  readers?: ModelIDInput | null,
  readId?: ModelIDInput | null,
  clientId?: ModelIDInput | null,
  and?: Array< ModelSignatureDocumentConditionInput | null > | null,
  or?: Array< ModelSignatureDocumentConditionInput | null > | null,
  not?: ModelSignatureDocumentConditionInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSignatureTypeInput = {
  eq?: SignatureType | null,
  ne?: SignatureType | null,
};

export type ModelSignatureDocumentStatusInput = {
  eq?: SignatureDocumentStatus | null,
  ne?: SignatureDocumentStatus | null,
};

export type ModelSignatureDocumentTypeInput = {
  eq?: SignatureDocumentType | null,
  ne?: SignatureDocumentType | null,
};

export type UpdateSignatureDocumentInput = {
  id: string,
  additionalMessage?: string | null,
  automaticRemindersDisabled?: boolean | null,
  communicationBody?: string | null,
  createdAt?: string | null,
  expirationDate?: string | null,
  fileIds?: Array< string > | null,
  foreignKey?: string | null,
  foreignTableName?: string | null,
  sentAt?: string | null,
  signatureMethods?: Array< SignatureType > | null,
  signatureResults?: Array< SignatureDocumentResultInput > | null,
  status?: SignatureDocumentStatus | null,
  externalStatus?: string | null,
  type?: SignatureDocumentType | null,
  readers?: Array< string > | null,
  readId?: string | null,
  clientId?: string | null,
  _version?: number | null,
};

export type DeleteSignatureDocumentInput = {
  id: string,
  _version?: number | null,
};

export type CreateFilterGroupInput = {
  id?: string | null,
  filterGroupDetails: Array< FilterGroupDetailsInput >,
  name?: string | null,
  screenName?: ScreenName | null,
  type: FilterGroupType,
  userId?: string | null,
  readId: string,
  clientId: string,
  _version?: number | null,
};

export type FilterGroupDetailsInput = {
  filterEntityType: FilterEntityType,
  filterEntityField?: string | null,
  filterEntityValues?: Array< string > | null,
  filterEntityNumber?: number | null,
  filterEntityDate?: string | null,
};

export enum FilterEntityType {
  BUILDING = "BUILDING",
  LEASE = "LEASE",
  OWNER = "OWNER",
  UNIT = "UNIT",
}

export enum ScreenName {
  COMMUNICATIONS = "COMMUNICATIONS",
  CONTACTS = "CONTACTS",
  DASHBOARD = "DASHBOARD",
  LEASES = "LEASES",
  BUILDINGS = "BUILDINGS",
}

export enum FilterGroupType {
  MANAGEMENT = "MANAGEMENT",
}

export type ModelFilterGroupConditionInput = {
  name?: ModelStringInput | null,
  screenName?: ModelScreenNameInput | null,
  type?: ModelFilterGroupTypeInput | null,
  userId?: ModelIDInput | null,
  readId?: ModelIDInput | null,
  clientId?: ModelIDInput | null,
  and?: Array< ModelFilterGroupConditionInput | null > | null,
  or?: Array< ModelFilterGroupConditionInput | null > | null,
  not?: ModelFilterGroupConditionInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelScreenNameInput = {
  eq?: ScreenName | null,
  ne?: ScreenName | null,
};

export type ModelFilterGroupTypeInput = {
  eq?: FilterGroupType | null,
  ne?: FilterGroupType | null,
};

export type FilterGroupDTO = {
  __typename: "FilterGroup",
  id: string,
  filterGroupDetails:  Array<FilterGroupDetailsDTO >,
  name?: string | null,
  screenName?: ScreenName | null,
  type: FilterGroupType,
  userId?: string | null,
  user?: UserDTO | null,
  readId: string,
  clientId: string,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type FilterGroupDetailsDTO = {
  __typename: "FilterGroupDetails",
  filterEntityType: FilterEntityType,
  filterEntityField?: string | null,
  filterEntityValues?: Array< string > | null,
  filterEntityNumber?: number | null,
  filterEntityDate?: string | null,
};

export type UserDTO = {
  __typename: "User",
  id: string,
  email: string,
  firstName?: string | null,
  lastName?: string | null,
  cognitoSub?: string | null,
  googleSub?: string | null,
  facebookSub?: string | null,
  rootUser?: boolean | null,
  pendingDeletion?: boolean | null,
  refreshToken?: boolean | null,
  teams?: ModelUserTeamConnection | null,
  userRoleId?: string | null,
  userRole?: UserRoleDTO | null,
  contactId?: string | null,
  contact?: ContactDTO | null,
  status: UserStatus,
  readId: string,
  clientId: string,
  _ttl?: number | null,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type ModelUserTeamConnection = {
  __typename: "ModelUserTeamConnection",
  items:  Array<UserTeamDTO | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type UserTeamDTO = {
  __typename: "UserTeam",
  id: string,
  userId: string,
  teamId: string,
  team?: TeamDTO | null,
  user?: UserDTO | null,
  readId: string,
  clientId: string,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type TeamDTO = {
  __typename: "Team",
  id: string,
  name: string,
  parentId?: string | null,
  children?: ModelTeamConnection | null,
  users?: ModelUserTeamConnection | null,
  readId: string,
  clientId: string,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type ModelTeamConnection = {
  __typename: "ModelTeamConnection",
  items:  Array<TeamDTO | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type UserRoleDTO = {
  __typename: "UserRole",
  id: string,
  name: string,
  userRights?:  Array<UserRightDTO > | null,
  readId: string,
  clientId: string,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type UserRightDTO = {
  __typename: "UserRight",
  access?: Array< UserRightAccessType > | null,
  section: UserRightSection,
};

export enum UserRightAccessType {
  READ = "READ",
  WRITE = "WRITE",
  DELETE = "DELETE",
}

export enum UserRightSection {
  NOTIFICATIONS_DETAILS = "NOTIFICATIONS_DETAILS",
  COMMUNICATIONS_DETAILS = "COMMUNICATIONS_DETAILS",
  CONTACTS_DETAILS = "CONTACTS_DETAILS",
  TICKETS_DETAILS = "TICKETS_DETAILS",
  ADVERTISEMENTS_DETAILS = "ADVERTISEMENTS_DETAILS",
  TEMPLATES_CONTRACTS = "TEMPLATES_CONTRACTS",
  TEMPLATES_COMMUNICATIONS = "TEMPLATES_COMMUNICATIONS",
  FINANCIAL_TRANSACTIONS = "FINANCIAL_TRANSACTIONS",
  FINANCIAL_OCR = "FINANCIAL_OCR",
  FINANCIAL_MORTGAGES = "FINANCIAL_MORTGAGES",
  FINANCIAL_VALUATIONS_AND_COSTS = "FINANCIAL_VALUATIONS_AND_COSTS",
  FINANCIAL_BALANCES = "FINANCIAL_BALANCES",
  FINANCIAL_PAYMENTS = "FINANCIAL_PAYMENTS",
  FINANCIAL_PAYMENTS_EXECUTION = "FINANCIAL_PAYMENTS_EXECUTION",
  LEASES_CREATION = "LEASES_CREATION",
  LEASES_SIGNATURE = "LEASES_SIGNATURE",
  LEASES_DETAILS = "LEASES_DETAILS",
  BUILDINGS_UNITS_DETAILS = "BUILDINGS_UNITS_DETAILS",
  BUILDINGS_UNITS_UTILITY_PROVIDERS = "BUILDINGS_UNITS_UTILITY_PROVIDERS",
  BUILDINGS_UNITS_TECHNICS = "BUILDINGS_UNITS_TECHNICS",
  AGENCY_RATE = "AGENCY_RATE",
  SETTINGS_AUTOMATION = "SETTINGS_AUTOMATION",
  SETTINGS_MANAGEMENT = "SETTINGS_MANAGEMENT",
}

export enum UserStatus {
  DISABLED = "DISABLED",
  JOINED = "JOINED",
  NOT_INVITED = "NOT_INVITED",
  PENDING = "PENDING",
}

export type UpdateFilterGroupInput = {
  id: string,
  filterGroupDetails?: Array< FilterGroupDetailsInput > | null,
  name?: string | null,
  screenName?: ScreenName | null,
  type?: FilterGroupType | null,
  userId?: string | null,
  readId?: string | null,
  clientId?: string | null,
  _version?: number | null,
};

export type DeleteFilterGroupInput = {
  id: string,
  _version?: number | null,
};

export type CreateIntegrationInput = {
  id?: string | null,
  configurations?: Array< IntegrationConfigurationInput > | null,
  error?: string | null,
  lastRun?: string | null,
  name: IntegrationName,
  status: IntegrationStatus,
  readId: string,
  clientId: string,
  _version?: number | null,
};

export type IntegrationConfigurationInput = {
  name: string,
  value: string,
};

export enum IntegrationStatus {
  ACTIVE = "ACTIVE",
  INITIALIZING = "INITIALIZING",
  ERROR = "ERROR",
  INACTIVE = "INACTIVE",
  SYNCING_IN_PROGRESS = "SYNCING_IN_PROGRESS",
}

export type ModelIntegrationConditionInput = {
  error?: ModelStringInput | null,
  lastRun?: ModelStringInput | null,
  name?: ModelIntegrationNameInput | null,
  status?: ModelIntegrationStatusInput | null,
  readId?: ModelIDInput | null,
  clientId?: ModelIDInput | null,
  and?: Array< ModelIntegrationConditionInput | null > | null,
  or?: Array< ModelIntegrationConditionInput | null > | null,
  not?: ModelIntegrationConditionInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelIntegrationNameInput = {
  eq?: IntegrationName | null,
  ne?: IntegrationName | null,
};

export type ModelIntegrationStatusInput = {
  eq?: IntegrationStatus | null,
  ne?: IntegrationStatus | null,
};

export type IntegrationDTO = {
  __typename: "Integration",
  id: string,
  configurations?:  Array<IntegrationConfigurationDTO > | null,
  error?: string | null,
  lastRun?: string | null,
  name: IntegrationName,
  status: IntegrationStatus,
  readId: string,
  clientId: string,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type IntegrationConfigurationDTO = {
  __typename: "IntegrationConfiguration",
  name: string,
  value: string,
};

export type UpdateIntegrationInput = {
  id: string,
  configurations?: Array< IntegrationConfigurationInput > | null,
  error?: string | null,
  lastRun?: string | null,
  name?: IntegrationName | null,
  status?: IntegrationStatus | null,
  readId?: string | null,
  clientId?: string | null,
  _version?: number | null,
};

export type DeleteIntegrationInput = {
  id: string,
  _version?: number | null,
};

export type CreateInvoiceInput = {
  id?: string | null,
  amount: number,
  bankAccountId: string,
  communicationId?: string | null,
  createdAt?: string | null,
  creditNote?: boolean | null,
  creditNoteLabel?: string | null,
  customValues?: Array< CustomValueInput > | null,
  disputedPostingIds?: Array< string > | null,
  disputes?: Array< InvoiceDisputeInput > | null,
  disputeStatus?: InvoiceDisputeStatus | null,
  dueDate?: string | null,
  invoiceDate: string,
  invoiceNumber?: string | null,
  ownerId?: string | null,
  invoiceSenderId: string,
  leaseId?: string | null,
  paid: boolean,
  integrations?: InvoiceIntegrationsInput | null,
  postedDate?: string | null,
  purchaseOrderNumber?: string | null,
  receiptNumber?: string | null,
  reminderDates?: Array< string > | null,
  note?: string | null,
  remittanceInformation?: string | null,
  statementId?: string | null,
  status: InvoiceStatus,
  type: InvoiceType,
  unitId?: string | null,
  reversedInvoiceId?: string | null,
  sentVersions?: Array< InvoiceSentVersionInput > | null,
  readers?: Array< string > | null,
  readId: string,
  clientId: string,
  _version?: number | null,
};

export type InvoiceDisputeInput = {
  id: string,
  scope: InvoiceDisputeScope,
  postingId?: string | null,
  postingLabel?: string | null,
  reason: string,
  comment?: string | null,
  disputedOn: string,
  openedAt: string,
  openedById?: string | null,
  openDecisionId: string,
  liftedAt?: string | null,
  liftedById?: string | null,
  liftCause?: InvoiceDisputeLiftCause | null,
  liftDecisionId?: string | null,
};

export type InvoiceIntegrationsInput = {
  paymentProperties?: InvoicePaymentProviderPropertiesInput | null,
};

export type InvoicePaymentProviderPropertiesInput = {
  availableOn?: string | null,
  error?: string | null,
  feeAmount?: number | null,
  paymentIntentId?: string | null,
  paymentLinkAmount?: number | null,
  paymentLinkUrl?: string | null,
  payoutId?: string | null,
  statementDescriptor?: string | null,
};

export type InvoiceSentVersionInput = {
  version: number,
  sentAt?: string | null,
  invoiceNumber?: string | null,
  invoiceSenderId?: string | null,
  channels: Array< InvoiceSentChannelInput >,
  pdfFileId?: string | null,
  xmlFileId?: string | null,
  resetAt: string,
  resetBy?: string | null,
  reason?: string | null,
};

export type InvoiceSentChannelInput = {
  channel: InvoiceDeliveryChannel,
  status?: string | null,
  communicationId?: string | null,
  peppolId?: string | null,
};

export type ModelInvoiceConditionInput = {
  amount?: ModelFloatInput | null,
  bankAccountId?: ModelIDInput | null,
  communicationId?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  creditNote?: ModelBooleanInput | null,
  creditNoteLabel?: ModelStringInput | null,
  disputedPostingIds?: ModelIDInput | null,
  disputeStatus?: ModelInvoiceDisputeStatusInput | null,
  dueDate?: ModelStringInput | null,
  invoiceDate?: ModelStringInput | null,
  invoiceNumber?: ModelStringInput | null,
  ownerId?: ModelIDInput | null,
  invoiceSenderId?: ModelIDInput | null,
  leaseId?: ModelIDInput | null,
  paid?: ModelBooleanInput | null,
  postedDate?: ModelStringInput | null,
  purchaseOrderNumber?: ModelStringInput | null,
  receiptNumber?: ModelStringInput | null,
  reminderDates?: ModelStringInput | null,
  note?: ModelStringInput | null,
  remittanceInformation?: ModelStringInput | null,
  statementId?: ModelIDInput | null,
  status?: ModelInvoiceStatusInput | null,
  type?: ModelInvoiceTypeInput | null,
  unitId?: ModelIDInput | null,
  reversedInvoiceId?: ModelIDInput | null,
  readers?: ModelIDInput | null,
  readId?: ModelIDInput | null,
  clientId?: ModelIDInput | null,
  and?: Array< ModelInvoiceConditionInput | null > | null,
  or?: Array< ModelInvoiceConditionInput | null > | null,
  not?: ModelInvoiceConditionInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelInvoiceStatusInput = {
  eq?: InvoiceStatus | null,
  ne?: InvoiceStatus | null,
};

export type ModelInvoiceDisputeStatusInput = {
  eq?: InvoiceDisputeStatus | null,
  ne?: InvoiceDisputeStatus | null,
};

export type ModelInvoiceTypeInput = {
  eq?: InvoiceType | null,
  ne?: InvoiceType | null,
};

export type UpdateInvoiceInput = {
  id: string,
  amount?: number | null,
  bankAccountId?: string | null,
  communicationId?: string | null,
  createdAt?: string | null,
  creditNote?: boolean | null,
  creditNoteLabel?: string | null,
  customValues?: Array< CustomValueInput > | null,
  disputedPostingIds?: Array< string > | null,
  disputes?: Array< InvoiceDisputeInput > | null,
  disputeStatus?: InvoiceDisputeStatus | null,
  dueDate?: string | null,
  invoiceDate?: string | null,
  invoiceNumber?: string | null,
  ownerId?: string | null,
  invoiceSenderId?: string | null,
  leaseId?: string | null,
  paid?: boolean | null,
  integrations?: InvoiceIntegrationsInput | null,
  postedDate?: string | null,
  purchaseOrderNumber?: string | null,
  receiptNumber?: string | null,
  reminderDates?: Array< string > | null,
  note?: string | null,
  remittanceInformation?: string | null,
  statementId?: string | null,
  status?: InvoiceStatus | null,
  type?: InvoiceType | null,
  unitId?: string | null,
  reversedInvoiceId?: string | null,
  sentVersions?: Array< InvoiceSentVersionInput > | null,
  readers?: Array< string > | null,
  readId?: string | null,
  clientId?: string | null,
  _version?: number | null,
};

export type DeleteInvoiceInput = {
  id: string,
  _version?: number | null,
};

export type CreateInvoiceSettingInput = {
  id?: string | null,
  creditNoteFormat: string,
  creditNoteLastUpdate: string,
  creditNoteIncrementNumber: number,
  invoiceFormat: string,
  invoiceLastUpdate: string,
  invoiceIncrementNumber: number,
  paymentRequestFormat: string,
  paymentRequestLastUpdate: string,
  paymentRequestIncrementNumber: number,
  receiptFormat: string,
  receiptLastUpdate: string,
  receiptIncrementNumber: number,
  variousOperationFormat: string,
  variousOperationLastUpdate: string,
  variousOperationIncrementNumber: number,
  customInvoicingConfiguration?: boolean | null,
  defaultVatRateId?: string | null,
  fiscalYearStart?: string | null,
  allPurposeInvoiceIssuer?: boolean | null,
  paymentBankAccountId?: string | null,
  ownerId: string,
  readId: string,
  clientId: string,
  _version?: number | null,
};

export type ModelInvoiceSettingConditionInput = {
  creditNoteFormat?: ModelStringInput | null,
  creditNoteLastUpdate?: ModelStringInput | null,
  creditNoteIncrementNumber?: ModelIntInput | null,
  invoiceFormat?: ModelStringInput | null,
  invoiceLastUpdate?: ModelStringInput | null,
  invoiceIncrementNumber?: ModelIntInput | null,
  paymentRequestFormat?: ModelStringInput | null,
  paymentRequestLastUpdate?: ModelStringInput | null,
  paymentRequestIncrementNumber?: ModelIntInput | null,
  receiptFormat?: ModelStringInput | null,
  receiptLastUpdate?: ModelStringInput | null,
  receiptIncrementNumber?: ModelIntInput | null,
  variousOperationFormat?: ModelStringInput | null,
  variousOperationLastUpdate?: ModelStringInput | null,
  variousOperationIncrementNumber?: ModelIntInput | null,
  customInvoicingConfiguration?: ModelBooleanInput | null,
  defaultVatRateId?: ModelIDInput | null,
  fiscalYearStart?: ModelStringInput | null,
  allPurposeInvoiceIssuer?: ModelBooleanInput | null,
  paymentBankAccountId?: ModelIDInput | null,
  ownerId?: ModelIDInput | null,
  readId?: ModelIDInput | null,
  clientId?: ModelIDInput | null,
  and?: Array< ModelInvoiceSettingConditionInput | null > | null,
  or?: Array< ModelInvoiceSettingConditionInput | null > | null,
  not?: ModelInvoiceSettingConditionInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type InvoiceSettingDTO = {
  __typename: "InvoiceSetting",
  id: string,
  creditNoteFormat: string,
  creditNoteLastUpdate: string,
  creditNoteIncrementNumber: number,
  invoiceFormat: string,
  invoiceLastUpdate: string,
  invoiceIncrementNumber: number,
  paymentRequestFormat: string,
  paymentRequestLastUpdate: string,
  paymentRequestIncrementNumber: number,
  receiptFormat: string,
  receiptLastUpdate: string,
  receiptIncrementNumber: number,
  variousOperationFormat: string,
  variousOperationLastUpdate: string,
  variousOperationIncrementNumber: number,
  customInvoicingConfiguration?: boolean | null,
  defaultVatRateId?: string | null,
  fiscalYearStart?: string | null,
  allPurposeInvoiceIssuer?: boolean | null,
  paymentBankAccountId?: string | null,
  ownerId: string,
  owner?: ContactDTO | null,
  readId: string,
  clientId: string,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type UpdateInvoiceSettingInput = {
  id: string,
  creditNoteFormat?: string | null,
  creditNoteLastUpdate?: string | null,
  creditNoteIncrementNumber?: number | null,
  invoiceFormat?: string | null,
  invoiceLastUpdate?: string | null,
  invoiceIncrementNumber?: number | null,
  paymentRequestFormat?: string | null,
  paymentRequestLastUpdate?: string | null,
  paymentRequestIncrementNumber?: number | null,
  receiptFormat?: string | null,
  receiptLastUpdate?: string | null,
  receiptIncrementNumber?: number | null,
  variousOperationFormat?: string | null,
  variousOperationLastUpdate?: string | null,
  variousOperationIncrementNumber?: number | null,
  customInvoicingConfiguration?: boolean | null,
  defaultVatRateId?: string | null,
  fiscalYearStart?: string | null,
  allPurposeInvoiceIssuer?: boolean | null,
  paymentBankAccountId?: string | null,
  ownerId?: string | null,
  readId?: string | null,
  clientId?: string | null,
  _version?: number | null,
};

export type DeleteInvoiceSettingInput = {
  id: string,
  _version?: number | null,
};

export type CreateLeaseInput = {
  id?: string | null,
  advancedChargesInvoices?: LeaseAdvancedChargesInvoiceInput | null,
  balance?: number | null,
  canBeExtended?: boolean | null,
  communicationSettingsProfileId: string,
  createdAt?: string | null,
  customValues?: Array< CustomValueInput > | null,
  endDate: string,
  includeRealEstateInLeaseContract?: boolean | null,
  attachStatementSupportingDocuments?: boolean | null,
  invoiceSenderId: string,
  inventoryOfFixturesExpert?: string | null,
  inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
  inventoryOfFixturesType?: InventoryOfFixturesType | null,
  ipiNumber?: string | null,
  language: Language,
  lastDraftInvoiceDate?: string | null,
  lastIndexationProcessDate?: string | null,
  lastInvoiceDate?: string | null,
  legalCompetentAuthority?: string | null,
  name: string,
  notes?: string | null,
  paymentFrequency: LeasePaymentFrequency,
  paymentInvoicePeriod: LeasePaymentInvoicePeriod,
  paymentInvoicePeriodCustomDay?: number | null,
  paymentOption?: LeasePaymentOptionInput | null,
  purchaseOrderNumber?: string | null,
  realEstateAgency?: string | null,
  realEstateTax?: number | null,
  remittanceInformation?: string | null,
  remittanceInformationType?: LeaseRemittanceType | null,
  rentalGuaranty?: LeaseRentalGuarantyInput | null,
  signatureDate?: string | null,
  startDate: string,
  nextIndexationMonth?: string | null,
  nextIndexation?: boolean | null,
  status: LeaseStatus,
  technicCommunicationSettingsProfileId: string,
  totalInitialRentalPrice: number,
  totalRentalPrice: number,
  type: LeaseType,
  subletting?: boolean | null,
  vatRateRentId?: string | null,
  bankAccountId?: string | null,
  readers?: Array< string > | null,
  readId: string,
  clientId: string,
  _version?: number | null,
};

export type LeaseAdvancedChargesInvoiceInput = {
  communicationSettingsProfileId: string,
  invoiceSenderId: string,
  lastDraftInvoiceDate?: string | null,
  lastInvoiceDate?: string | null,
  paymentFrequency: LeasePaymentFrequency,
  paymentInvoicePeriod: LeasePaymentInvoicePeriod,
  paymentInvoicePeriodCustomDay?: number | null,
  remittanceInformation?: string | null,
  remittanceInformationType?: LeaseRemittanceType | null,
  bankAccountId?: string | null,
};

export type LeasePaymentOptionInput = {
  customerId?: string | null,
  enabled: boolean,
  mandateActivatedAt?: string | null,
  mandateStatus?: PaymentProviderMandateStatus | null,
  paymentMethodId?: string | null,
  qrType?: LeaseQrType | null,
};

export type LeaseRentalGuarantyInput = {
  amount: number,
  blockedAmount?: number | null,
  releasedAmount?: number | null,
  type: LeaseRentalGuarantyType,
  financialInstitution?: string | null,
};

export type ModelLeaseConditionInput = {
  balance?: ModelFloatInput | null,
  canBeExtended?: ModelBooleanInput | null,
  communicationSettingsProfileId?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  endDate?: ModelStringInput | null,
  includeRealEstateInLeaseContract?: ModelBooleanInput | null,
  attachStatementSupportingDocuments?: ModelBooleanInput | null,
  invoiceSenderId?: ModelIDInput | null,
  inventoryOfFixturesExpert?: ModelStringInput | null,
  inventoryOfFixturesMethod?: ModelInventoryOfFixturesMethodInput | null,
  inventoryOfFixturesType?: ModelInventoryOfFixturesTypeInput | null,
  ipiNumber?: ModelStringInput | null,
  language?: ModelLanguageInput | null,
  lastDraftInvoiceDate?: ModelStringInput | null,
  lastIndexationProcessDate?: ModelStringInput | null,
  lastInvoiceDate?: ModelStringInput | null,
  legalCompetentAuthority?: ModelStringInput | null,
  name?: ModelStringInput | null,
  notes?: ModelStringInput | null,
  paymentFrequency?: ModelLeasePaymentFrequencyInput | null,
  paymentInvoicePeriod?: ModelLeasePaymentInvoicePeriodInput | null,
  paymentInvoicePeriodCustomDay?: ModelIntInput | null,
  purchaseOrderNumber?: ModelStringInput | null,
  realEstateAgency?: ModelStringInput | null,
  realEstateTax?: ModelIntInput | null,
  remittanceInformation?: ModelStringInput | null,
  remittanceInformationType?: ModelLeaseRemittanceTypeInput | null,
  signatureDate?: ModelStringInput | null,
  startDate?: ModelStringInput | null,
  nextIndexationMonth?: ModelStringInput | null,
  nextIndexation?: ModelBooleanInput | null,
  status?: ModelLeaseStatusInput | null,
  technicCommunicationSettingsProfileId?: ModelIDInput | null,
  totalInitialRentalPrice?: ModelFloatInput | null,
  totalRentalPrice?: ModelFloatInput | null,
  type?: ModelLeaseTypeInput | null,
  subletting?: ModelBooleanInput | null,
  vatRateRentId?: ModelIDInput | null,
  bankAccountId?: ModelIDInput | null,
  readers?: ModelIDInput | null,
  readId?: ModelIDInput | null,
  clientId?: ModelIDInput | null,
  and?: Array< ModelLeaseConditionInput | null > | null,
  or?: Array< ModelLeaseConditionInput | null > | null,
  not?: ModelLeaseConditionInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelInventoryOfFixturesMethodInput = {
  eq?: InventoryOfFixturesMethod | null,
  ne?: InventoryOfFixturesMethod | null,
};

export type ModelInventoryOfFixturesTypeInput = {
  eq?: InventoryOfFixturesType | null,
  ne?: InventoryOfFixturesType | null,
};

export type ModelLanguageInput = {
  eq?: Language | null,
  ne?: Language | null,
};

export type ModelLeasePaymentInvoicePeriodInput = {
  eq?: LeasePaymentInvoicePeriod | null,
  ne?: LeasePaymentInvoicePeriod | null,
};

export type ModelLeaseRemittanceTypeInput = {
  eq?: LeaseRemittanceType | null,
  ne?: LeaseRemittanceType | null,
};

export type ModelLeaseStatusInput = {
  eq?: LeaseStatus | null,
  ne?: LeaseStatus | null,
};

export type ModelLeaseTypeInput = {
  eq?: LeaseType | null,
  ne?: LeaseType | null,
};

export type UpdateLeaseInput = {
  id: string,
  advancedChargesInvoices?: LeaseAdvancedChargesInvoiceInput | null,
  balance?: number | null,
  canBeExtended?: boolean | null,
  communicationSettingsProfileId?: string | null,
  createdAt?: string | null,
  customValues?: Array< CustomValueInput > | null,
  endDate?: string | null,
  includeRealEstateInLeaseContract?: boolean | null,
  attachStatementSupportingDocuments?: boolean | null,
  invoiceSenderId?: string | null,
  inventoryOfFixturesExpert?: string | null,
  inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
  inventoryOfFixturesType?: InventoryOfFixturesType | null,
  ipiNumber?: string | null,
  language?: Language | null,
  lastDraftInvoiceDate?: string | null,
  lastIndexationProcessDate?: string | null,
  lastInvoiceDate?: string | null,
  legalCompetentAuthority?: string | null,
  name?: string | null,
  notes?: string | null,
  paymentFrequency?: LeasePaymentFrequency | null,
  paymentInvoicePeriod?: LeasePaymentInvoicePeriod | null,
  paymentInvoicePeriodCustomDay?: number | null,
  paymentOption?: LeasePaymentOptionInput | null,
  purchaseOrderNumber?: string | null,
  realEstateAgency?: string | null,
  realEstateTax?: number | null,
  remittanceInformation?: string | null,
  remittanceInformationType?: LeaseRemittanceType | null,
  rentalGuaranty?: LeaseRentalGuarantyInput | null,
  signatureDate?: string | null,
  startDate?: string | null,
  nextIndexationMonth?: string | null,
  nextIndexation?: boolean | null,
  status?: LeaseStatus | null,
  technicCommunicationSettingsProfileId?: string | null,
  totalInitialRentalPrice?: number | null,
  totalRentalPrice?: number | null,
  type?: LeaseType | null,
  subletting?: boolean | null,
  vatRateRentId?: string | null,
  bankAccountId?: string | null,
  readers?: Array< string > | null,
  readId?: string | null,
  clientId?: string | null,
  _version?: number | null,
};

export type DeleteLeaseInput = {
  id: string,
  _version?: number | null,
};

export type CreateLeaseActionHistoryInput = {
  id?: string | null,
  action: LeaseAction,
  comment?: string | null,
  contactId: string,
  createdAt?: string | null,
  historyDetails: Array< LeaseActionHistoryDetailInput >,
  leaseId: string,
  communicationId?: string | null,
  signatureDocumentId?: string | null,
  status?: LeaseActionHistoryStatus | null,
  communicationChannel?: CommunicationChannel | null,
  communicationSendDate?: string | null,
  communicationByPlatform?: boolean | null,
  endReason?: LeaseActionEndReason | null,
  endReasonOwnUseRelation?: string | null,
  endReasonOwnUseName?: string | null,
  initiator?: LeaseActionEndInitiator | null,
  totalAmount?: number | null,
  totalAmountLabel?: string | null,
  automatic?: boolean | null,
  hasLeaseTypeChanged?: boolean | null,
  jiraId?: string | null,
  readers?: Array< string > | null,
  readId: string,
  clientId: string,
  _version?: number | null,
};

export type LeaseActionHistoryDetailInput = {
  unitId: string,
  newEndDate?: string | null,
  newSignatureDate?: string | null,
  newStartDate?: string | null,
  previousEndDate?: string | null,
  previousSignatureDate?: string | null,
  previousStartDate?: string | null,
};

export type ModelLeaseActionHistoryConditionInput = {
  action?: ModelLeaseActionInput | null,
  comment?: ModelStringInput | null,
  contactId?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  leaseId?: ModelIDInput | null,
  communicationId?: ModelIDInput | null,
  signatureDocumentId?: ModelIDInput | null,
  status?: ModelLeaseActionHistoryStatusInput | null,
  communicationChannel?: ModelCommunicationChannelInput | null,
  communicationSendDate?: ModelStringInput | null,
  communicationByPlatform?: ModelBooleanInput | null,
  endReason?: ModelLeaseActionEndReasonInput | null,
  endReasonOwnUseRelation?: ModelStringInput | null,
  endReasonOwnUseName?: ModelStringInput | null,
  initiator?: ModelLeaseActionEndInitiatorInput | null,
  totalAmount?: ModelFloatInput | null,
  totalAmountLabel?: ModelStringInput | null,
  automatic?: ModelBooleanInput | null,
  hasLeaseTypeChanged?: ModelBooleanInput | null,
  jiraId?: ModelStringInput | null,
  readers?: ModelIDInput | null,
  readId?: ModelIDInput | null,
  clientId?: ModelIDInput | null,
  and?: Array< ModelLeaseActionHistoryConditionInput | null > | null,
  or?: Array< ModelLeaseActionHistoryConditionInput | null > | null,
  not?: ModelLeaseActionHistoryConditionInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelLeaseActionInput = {
  eq?: LeaseAction | null,
  ne?: LeaseAction | null,
};

export type ModelLeaseActionHistoryStatusInput = {
  eq?: LeaseActionHistoryStatus | null,
  ne?: LeaseActionHistoryStatus | null,
};

export type ModelLeaseActionEndReasonInput = {
  eq?: LeaseActionEndReason | null,
  ne?: LeaseActionEndReason | null,
};

export type ModelLeaseActionEndInitiatorInput = {
  eq?: LeaseActionEndInitiator | null,
  ne?: LeaseActionEndInitiator | null,
};

export type UpdateLeaseActionHistoryInput = {
  id: string,
  action?: LeaseAction | null,
  comment?: string | null,
  contactId?: string | null,
  createdAt?: string | null,
  historyDetails?: Array< LeaseActionHistoryDetailInput > | null,
  leaseId?: string | null,
  communicationId?: string | null,
  signatureDocumentId?: string | null,
  status?: LeaseActionHistoryStatus | null,
  communicationChannel?: CommunicationChannel | null,
  communicationSendDate?: string | null,
  communicationByPlatform?: boolean | null,
  endReason?: LeaseActionEndReason | null,
  endReasonOwnUseRelation?: string | null,
  endReasonOwnUseName?: string | null,
  initiator?: LeaseActionEndInitiator | null,
  totalAmount?: number | null,
  totalAmountLabel?: string | null,
  automatic?: boolean | null,
  hasLeaseTypeChanged?: boolean | null,
  jiraId?: string | null,
  readers?: Array< string > | null,
  readId?: string | null,
  clientId?: string | null,
  _version?: number | null,
};

export type DeleteLeaseActionHistoryInput = {
  id: string,
  _version?: number | null,
};

export type CreateLeaseAdditionalClauseInput = {
  id?: string | null,
  leaseId: string,
  title?: string | null,
  body: string,
  readId: string,
  clientId: string,
  _version?: number | null,
};

export type ModelLeaseAdditionalClauseConditionInput = {
  leaseId?: ModelIDInput | null,
  title?: ModelStringInput | null,
  body?: ModelStringInput | null,
  readId?: ModelIDInput | null,
  clientId?: ModelIDInput | null,
  and?: Array< ModelLeaseAdditionalClauseConditionInput | null > | null,
  or?: Array< ModelLeaseAdditionalClauseConditionInput | null > | null,
  not?: ModelLeaseAdditionalClauseConditionInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type UpdateLeaseAdditionalClauseInput = {
  id: string,
  leaseId?: string | null,
  title?: string | null,
  body?: string | null,
  readId?: string | null,
  clientId?: string | null,
  _version?: number | null,
};

export type DeleteLeaseAdditionalClauseInput = {
  id: string,
  _version?: number | null,
};

export type CreateLeaseContactInput = {
  id?: string | null,
  leaseId: string,
  contactId: string,
  contactRole: ContactType,
  readers?: Array< string > | null,
  readId: string,
  clientId: string,
  _version?: number | null,
};

export type ModelLeaseContactConditionInput = {
  leaseId?: ModelIDInput | null,
  contactId?: ModelIDInput | null,
  contactRole?: ModelContactTypeInput | null,
  readers?: ModelIDInput | null,
  readId?: ModelIDInput | null,
  clientId?: ModelIDInput | null,
  and?: Array< ModelLeaseContactConditionInput | null > | null,
  or?: Array< ModelLeaseContactConditionInput | null > | null,
  not?: ModelLeaseContactConditionInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type UpdateLeaseContactInput = {
  id: string,
  leaseId?: string | null,
  contactId?: string | null,
  contactRole?: ContactType | null,
  readers?: Array< string > | null,
  readId?: string | null,
  clientId?: string | null,
  _version?: number | null,
};

export type DeleteLeaseContactInput = {
  id: string,
  _version?: number | null,
};

export type CreateLeasePriceHistoryInput = {
  id?: string | null,
  previousTotalRentalPrice: number,
  totalRentalPrice: number,
  optimalTotalRentalPrice?: number | null,
  optimalTotalMonthlyCharges?: number | null,
  applicationDate: string,
  status: LeaseAmountUpdateStatus,
  comment?: string | null,
  amountDetails: Array< LeasePriceHistoryDetailInput >,
  type: LeasePriceHistoryType,
  communicationId?: string | null,
  leaseId: string,
  createdAt?: string | null,
  readers?: Array< string > | null,
  readId: string,
  clientId: string,
  _version?: number | null,
};

export type LeasePriceHistoryDetailInput = {
  unitId: string,
  indexationBaseIndex?: number | null,
  indexationNewIndex?: number | null,
  previousRentalPrice: number,
  newRentalPrice: number,
  rentalStatus: LeasePriceHistoryStatus,
  monthlyChargesStatus: LeasePriceHistoryStatus,
  optimalNewRentalPrice?: number | null,
  optimalNewMonthlyChargesPrice?: number | null,
  epb?: string | null,
  epbIssueDate?: string | null,
  oldestIndexForCorrectionFactorCalculation?: number | null,
  newestIndexForCorrectionFactorCalculation?: number | null,
  rentIndexedPriceAfterNewEpbReduction?: number | null,
  chargesIndexedPriceAfterNewEpbReduction?: number | null,
  correctionFactor?: number | null,
  chargesAmountsDetails?: Array< LeasePriceHistoryChargeAmountsDetailsInput > | null,
  reductionPercentage?: number | null,
  rentDifference?: number | null,
  rentReduction?: number | null,
  indexedRentAfterReduction?: number | null,
  chargesDifference?: number | null,
  chargesReduction?: number | null,
  indexedChargesAfterReduction?: number | null,
  previousYearIndexationNewIndex?: number | null,
  previousYearIndexedRent?: number | null,
  previousYearIndexedCharges?: number | null,
};

export type LeasePriceHistoryChargeAmountsDetailsInput = {
  leaseVariousOperationId: string,
  previousMonthlyAmount: number,
  newMonthlyAmount: number,
  indexationBaseIndex?: number | null,
  indexationBaseAmount?: number | null,
  indexationBaseIndexDate?: string | null,
  indexed?: boolean | null,
};

export type ModelLeasePriceHistoryConditionInput = {
  previousTotalRentalPrice?: ModelFloatInput | null,
  totalRentalPrice?: ModelFloatInput | null,
  optimalTotalRentalPrice?: ModelFloatInput | null,
  optimalTotalMonthlyCharges?: ModelFloatInput | null,
  applicationDate?: ModelStringInput | null,
  status?: ModelLeaseAmountUpdateStatusInput | null,
  comment?: ModelStringInput | null,
  type?: ModelLeasePriceHistoryTypeInput | null,
  communicationId?: ModelIDInput | null,
  leaseId?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  readers?: ModelIDInput | null,
  readId?: ModelIDInput | null,
  clientId?: ModelIDInput | null,
  and?: Array< ModelLeasePriceHistoryConditionInput | null > | null,
  or?: Array< ModelLeasePriceHistoryConditionInput | null > | null,
  not?: ModelLeasePriceHistoryConditionInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelLeaseAmountUpdateStatusInput = {
  eq?: LeaseAmountUpdateStatus | null,
  ne?: LeaseAmountUpdateStatus | null,
};

export type ModelLeasePriceHistoryTypeInput = {
  eq?: LeasePriceHistoryType | null,
  ne?: LeasePriceHistoryType | null,
};

export type UpdateLeasePriceHistoryInput = {
  id: string,
  previousTotalRentalPrice?: number | null,
  totalRentalPrice?: number | null,
  optimalTotalRentalPrice?: number | null,
  optimalTotalMonthlyCharges?: number | null,
  applicationDate?: string | null,
  status?: LeaseAmountUpdateStatus | null,
  comment?: string | null,
  amountDetails?: Array< LeasePriceHistoryDetailInput > | null,
  type?: LeasePriceHistoryType | null,
  communicationId?: string | null,
  leaseId?: string | null,
  readers?: Array< string > | null,
  readId?: string | null,
  clientId?: string | null,
  _version?: number | null,
};

export type DeleteLeasePriceHistoryInput = {
  id: string,
  _version?: number | null,
};

export type ModelSignatureTypeListInput = {
  eq?: Array< SignatureType | null > | null,
  ne?: Array< SignatureType | null > | null,
  contains?: SignatureType | null,
  notContains?: SignatureType | null,
};

export type CreateLeaseVariousOperationInput = {
  id?: string | null,
  accountLabelIds?: Array< string > | null,
  amount: number,
  billingMode?: LeaseVariousOperationBillingMode | null,
  contactId: string,
  createdAt?: string | null,
  dueDateDaysAfterPeriodStart?: number | null,
  endDate: string,
  indexationBaseAmount?: number | null,
  indexationBaseIndexDate?: string | null,
  indexationFrozen?: boolean | null,
  invoiceSenderId?: string | null,
  issueLeadDays?: number | null,
  label?: string | null,
  lastInvoiceDate?: string | null,
  leaseId: string,
  leaseVariousOperationHistories?: Array< LeaseVariousOperationHistoryInput > | null,
  operationType: LeaseVariousOperationType,
  paymentFrequency: LeasePaymentFrequency,
  paymentInvoicePeriod: LeasePaymentInvoicePeriod,
  paymentInvoicePeriodCustomDay?: number | null,
  periodNature?: LeaseVariousOperationPeriodNature | null,
  reason?: string | null,
  separateInvoice: boolean,
  startDate: string,
  type: VariousOperationType,
  unitId: string,
  vatRateId?: string | null,
  readId: string,
  readers?: Array< string > | null,
  clientId: string,
  _version?: number | null,
};

export type LeaseVariousOperationHistoryInput = {
  periodFrom: string,
  periodTo: string,
  amount: number,
};

export type ModelLeaseVariousOperationConditionInput = {
  accountLabelIds?: ModelIDInput | null,
  amount?: ModelFloatInput | null,
  billingMode?: ModelLeaseVariousOperationBillingModeInput | null,
  contactId?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  dueDateDaysAfterPeriodStart?: ModelIntInput | null,
  endDate?: ModelStringInput | null,
  indexationBaseAmount?: ModelFloatInput | null,
  indexationBaseIndexDate?: ModelStringInput | null,
  indexationFrozen?: ModelBooleanInput | null,
  invoiceSenderId?: ModelIDInput | null,
  issueLeadDays?: ModelIntInput | null,
  label?: ModelStringInput | null,
  lastInvoiceDate?: ModelStringInput | null,
  leaseId?: ModelIDInput | null,
  operationType?: ModelLeaseVariousOperationTypeInput | null,
  paymentFrequency?: ModelLeasePaymentFrequencyInput | null,
  paymentInvoicePeriod?: ModelLeasePaymentInvoicePeriodInput | null,
  paymentInvoicePeriodCustomDay?: ModelIntInput | null,
  periodNature?: ModelLeaseVariousOperationPeriodNatureInput | null,
  reason?: ModelStringInput | null,
  separateInvoice?: ModelBooleanInput | null,
  startDate?: ModelStringInput | null,
  type?: ModelVariousOperationTypeInput | null,
  unitId?: ModelIDInput | null,
  vatRateId?: ModelIDInput | null,
  readId?: ModelIDInput | null,
  readers?: ModelIDInput | null,
  clientId?: ModelIDInput | null,
  and?: Array< ModelLeaseVariousOperationConditionInput | null > | null,
  or?: Array< ModelLeaseVariousOperationConditionInput | null > | null,
  not?: ModelLeaseVariousOperationConditionInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelLeaseVariousOperationBillingModeInput = {
  eq?: LeaseVariousOperationBillingMode | null,
  ne?: LeaseVariousOperationBillingMode | null,
};

export type ModelLeaseVariousOperationPeriodNatureInput = {
  eq?: LeaseVariousOperationPeriodNature | null,
  ne?: LeaseVariousOperationPeriodNature | null,
};

export type ModelLeaseVariousOperationTypeInput = {
  eq?: LeaseVariousOperationType | null,
  ne?: LeaseVariousOperationType | null,
};

export type ModelVariousOperationTypeInput = {
  eq?: VariousOperationType | null,
  ne?: VariousOperationType | null,
};

export type UpdateLeaseVariousOperationInput = {
  id: string,
  accountLabelIds?: Array< string > | null,
  amount?: number | null,
  billingMode?: LeaseVariousOperationBillingMode | null,
  contactId?: string | null,
  createdAt?: string | null,
  dueDateDaysAfterPeriodStart?: number | null,
  endDate?: string | null,
  indexationBaseAmount?: number | null,
  indexationBaseIndexDate?: string | null,
  indexationFrozen?: boolean | null,
  invoiceSenderId?: string | null,
  issueLeadDays?: number | null,
  label?: string | null,
  lastInvoiceDate?: string | null,
  leaseId?: string | null,
  leaseVariousOperationHistories?: Array< LeaseVariousOperationHistoryInput > | null,
  operationType?: LeaseVariousOperationType | null,
  paymentFrequency?: LeasePaymentFrequency | null,
  paymentInvoicePeriod?: LeasePaymentInvoicePeriod | null,
  paymentInvoicePeriodCustomDay?: number | null,
  periodNature?: LeaseVariousOperationPeriodNature | null,
  reason?: string | null,
  separateInvoice?: boolean | null,
  startDate?: string | null,
  type?: VariousOperationType | null,
  unitId?: string | null,
  vatRateId?: string | null,
  readId?: string | null,
  readers?: Array< string > | null,
  clientId?: string | null,
  _version?: number | null,
};

export type DeleteLeaseVariousOperationInput = {
  id: string,
  _version?: number | null,
};

export type CreateMortgageInput = {
  id?: string | null,
  lender: string,
  durationInYears: number,
  rateType: MortgageRateType,
  interestRate: number,
  aprRate: number,
  startDate: string,
  amount: number,
  monthlyPayment: number,
  unitId?: string | null,
  buildingId?: string | null,
  writers?: Array< string > | null,
  readId: string,
  clientId: string,
  _version?: number | null,
};

export enum MortgageRateType {
  Fixed = "Fixed",
  Variable = "Variable",
}

export type ModelMortgageConditionInput = {
  lender?: ModelStringInput | null,
  durationInYears?: ModelIntInput | null,
  rateType?: ModelMortgageRateTypeInput | null,
  interestRate?: ModelFloatInput | null,
  aprRate?: ModelFloatInput | null,
  startDate?: ModelStringInput | null,
  amount?: ModelFloatInput | null,
  monthlyPayment?: ModelFloatInput | null,
  unitId?: ModelIDInput | null,
  buildingId?: ModelIDInput | null,
  writers?: ModelIDInput | null,
  readId?: ModelIDInput | null,
  clientId?: ModelIDInput | null,
  and?: Array< ModelMortgageConditionInput | null > | null,
  or?: Array< ModelMortgageConditionInput | null > | null,
  not?: ModelMortgageConditionInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelMortgageRateTypeInput = {
  eq?: MortgageRateType | null,
  ne?: MortgageRateType | null,
};

export type MortgageDTO = {
  __typename: "Mortgage",
  id: string,
  lender: string,
  durationInYears: number,
  rateType: MortgageRateType,
  interestRate: number,
  aprRate: number,
  startDate: string,
  amount: number,
  monthlyPayment: number,
  unitId?: string | null,
  unit?: UnitDTO | null,
  buildingId?: string | null,
  building?: BuildingDTO | null,
  writers?: Array< string > | null,
  readId: string,
  clientId: string,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type UpdateMortgageInput = {
  id: string,
  lender?: string | null,
  durationInYears?: number | null,
  rateType?: MortgageRateType | null,
  interestRate?: number | null,
  aprRate?: number | null,
  startDate?: string | null,
  amount?: number | null,
  monthlyPayment?: number | null,
  unitId?: string | null,
  buildingId?: string | null,
  writers?: Array< string > | null,
  readId?: string | null,
  clientId?: string | null,
  _version?: number | null,
};

export type DeleteMortgageInput = {
  id: string,
  _version?: number | null,
};

export type CreateNotificationInput = {
  id?: string | null,
  createdBy: NotificationCreation,
  type?: NotificationType | null,
  message?: string | null,
  popupDate: string,
  expirationDate?: string | null,
  status: NotificationStatus,
  createdAt?: string | null,
  buildingId?: string | null,
  unitId?: string | null,
  leaseId?: string | null,
  technicId?: string | null,
  ticketId?: string | null,
  readId: string,
  clientId: string,
  _version?: number | null,
};

export enum NotificationCreation {
  Automatic = "Automatic",
  Manual = "Manual",
}

export enum NotificationType {
  PebCertificate = "PebCertificate",
  SmokeDetectorBattery = "SmokeDetectorBattery",
  FuelTankCertificate = "FuelTankCertificate",
  HeatingCertificate = "HeatingCertificate",
  ChimneySweeping = "ChimneySweeping",
  Technic = "Technic",
  Custom = "Custom",
}

export enum NotificationStatus {
  Active = "Active",
  Snoozed = "Snoozed",
  Ignored = "Ignored",
  Done = "Done",
}

export type ModelNotificationConditionInput = {
  createdBy?: ModelNotificationCreationInput | null,
  type?: ModelNotificationTypeInput | null,
  message?: ModelStringInput | null,
  popupDate?: ModelStringInput | null,
  expirationDate?: ModelStringInput | null,
  status?: ModelNotificationStatusInput | null,
  createdAt?: ModelStringInput | null,
  buildingId?: ModelIDInput | null,
  unitId?: ModelIDInput | null,
  leaseId?: ModelIDInput | null,
  technicId?: ModelIDInput | null,
  ticketId?: ModelIDInput | null,
  readId?: ModelIDInput | null,
  clientId?: ModelIDInput | null,
  and?: Array< ModelNotificationConditionInput | null > | null,
  or?: Array< ModelNotificationConditionInput | null > | null,
  not?: ModelNotificationConditionInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelNotificationCreationInput = {
  eq?: NotificationCreation | null,
  ne?: NotificationCreation | null,
};

export type ModelNotificationTypeInput = {
  eq?: NotificationType | null,
  ne?: NotificationType | null,
};

export type ModelNotificationStatusInput = {
  eq?: NotificationStatus | null,
  ne?: NotificationStatus | null,
};

export type NotificationDTO = {
  __typename: "Notification",
  id: string,
  createdBy: NotificationCreation,
  type?: NotificationType | null,
  message?: string | null,
  popupDate: string,
  expirationDate?: string | null,
  status: NotificationStatus,
  createdAt?: string | null,
  buildingId?: string | null,
  building?: BuildingDTO | null,
  unitId?: string | null,
  unit?: UnitDTO | null,
  leaseId?: string | null,
  lease?: LeaseDTO | null,
  technicId?: string | null,
  technic?: TechnicDTO | null,
  ticketId?: string | null,
  ticket?: TicketDTO | null,
  readId: string,
  clientId: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type TechnicDTO = {
  __typename: "Technic",
  id: string,
  type: TechnicType,
  contractNumber?: string | null,
  communicationSettingsProfileId: string,
  maintenanceHistory?:  Array<TechnicMaintenanceHistoryDTO > | null,
  technicLibraryId?: string | null,
  technicLibrary?: TechnicLibraryDTO | null,
  technicName?: string | null,
  lastControlDate?: string | null,
  status?: TechnicStatus | null,
  utilityType?: UtilityType | null,
  utilityEanCode?: string | null,
  utilityMeterNumber?: string | null,
  utilityDistributorId?: string | null,
  utilityDistributor?: ContactDTO | null,
  utilityHistory?:  Array<UtilityHistoryDTO > | null,
  files?: ModelFileConnection | null,
  buildingId?: string | null,
  building?: BuildingDTO | null,
  unitId?: string | null,
  unit?: UnitDTO | null,
  leaseId?: string | null,
  lease?: LeaseDTO | null,
  contactId?: string | null,
  contact?: ContactDTO | null,
  customValues?:  Array<CustomValueDTO > | null,
  originalTechnicId?: string | null,
  replacedTechnicId?: string | null,
  certificateIds?: Array< string > | null,
  readers?: Array< string > | null,
  writers?: Array< string > | null,
  readId: string,
  clientId: string,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export enum TechnicType {
  UTILITY_PROVIDER = "UTILITY_PROVIDER",
  PEB = "PEB",
  DETECTOR = "DETECTOR",
  HEATING = "HEATING",
  CHIMNEY = "CHIMNEY",
  FUELTANK = "FUELTANK",
  LIFT = "LIFT",
}

export type TechnicMaintenanceHistoryDTO = {
  __typename: "TechnicMaintenanceHistory",
  date: string,
  contactId?: string | null,
  fileId?: string | null,
};

export type TechnicLibraryDTO = {
  __typename: "TechnicLibrary",
  id: string,
  certificateValidity?: CertificateLibraryValidityDTO | null,
  communicationSettingsProfileId?: string | null,
  criticality: TechnicLibraryCriticality,
  customFields?: ModelCustomFieldConnection | null,
  descriptions?:  Array<CustomLabelDTO > | null,
  isDefault?: boolean | null,
  issuingAuthority?: string | null,
  linkedCertificateIds?: Array< string > | null,
  locationScope?: TechnicLibraryLocationScope | null,
  maintenanceSchemas?:  Array<TechnicLibraryMaintenanceSchemaDTO > | null,
  names:  Array<CustomLabelDTO >,
  status: TechnicLibraryStatus,
  tagIds?: Array< string > | null,
  technicLibraryFormat?: string | null,
  type: TechnicLibraryType,
  utilityTypes?: Array< UtilityType > | null,
  validity?: TechnicLibraryValidityDTO | null,
  readId: string,
  clientId: string,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type CertificateLibraryValidityDTO = {
  __typename: "CertificateLibraryValidity",
  gracePeriod?: TechnicLibraryValidityDTO | null,
  nonCompliant?: boolean | null,
  overlapping?: boolean | null,
  riskLevel?: RiskLevelExpiration | null,
};

export type TechnicLibraryValidityDTO = {
  __typename: "TechnicLibraryValidity",
  value: number,
  validityUnit: TechnicLibraryValidityUnit,
};

export enum TechnicLibraryValidityUnit {
  DAY = "DAY",
  MONTH = "MONTH",
  YEAR = "YEAR",
}

export enum RiskLevelExpiration {
  CRITICAL = "CRITICAL",
  HIGH = "HIGH",
  LOW = "LOW",
  MEDIUM = "MEDIUM",
  NO_OVERRIDE = "NO_OVERRIDE",
}

export enum TechnicLibraryCriticality {
  CRITICAL = "CRITICAL",
  HIGH = "HIGH",
  LOW = "LOW",
  MEDIUM = "MEDIUM",
}

export type ModelCustomFieldConnection = {
  __typename: "ModelCustomFieldConnection",
  items:  Array<CustomFieldDTO | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export enum TechnicLibraryLocationScope {
  BOTH = "BOTH",
  BUILDING = "BUILDING",
  UNIT = "UNIT",
}

export type TechnicLibraryMaintenanceSchemaDTO = {
  __typename: "TechnicLibraryMaintenanceSchema",
  id: string,
  criticality: TechnicLibraryCriticality,
  deadline?: string | null,
  descriptions?:  Array<CustomLabelDTO > | null,
  interval?: TechnicLibraryValidityDTO | null,
  maintenanceType: TechnicLibraryMaintenanceType,
  names:  Array<CustomLabelDTO >,
  notificationsEnabled?: boolean | null,
  notificationType?: NotificationType | null,
  proofType?: Array< TechnicLibraryProofType > | null,
  proofTypeName?:  Array<CustomLabelDTO > | null,
  recurrence?: TechnicLibraryRecurrence | null,
  responsibleParty: TechnicLibraryResponsibleParty,
  triggerType?: TechnicLibraryTriggerType | null,
};

export enum TechnicLibraryMaintenanceType {
  INSPECTION = "INSPECTION",
  LEGAL_MAINTENANCE = "LEGAL_MAINTENANCE",
  MAINTENANCE = "MAINTENANCE",
}

export enum TechnicLibraryProofType {
  CERTIFICATE = "CERTIFICATE",
  INVOICE = "INVOICE",
  PICTURES = "PICTURES",
  REPORT = "REPORT",
  SIGNATURE = "SIGNATURE",
}

export enum TechnicLibraryRecurrence {
  ONETIME = "ONETIME",
  PERIODIC = "PERIODIC",
}

export enum TechnicLibraryResponsibleParty {
  GUARANTOR = "GUARANTOR",
  OWNER = "OWNER",
  TENANT = "TENANT",
}

export enum TechnicLibraryTriggerType {
  DEADLINE = "DEADLINE",
  TIMEBASED = "TIMEBASED",
}

export enum TechnicLibraryStatus {
  ACTIVE = "ACTIVE",
  DISABLED = "DISABLED",
}

export enum TechnicLibraryType {
  CERTIFICATE = "CERTIFICATE",
  CERTIFICATE_EPB = "CERTIFICATE_EPB",
  TECHNIC = "TECHNIC",
  TECHNIC_TANK = "TECHNIC_TANK",
  UTILITY_PROVIDER = "UTILITY_PROVIDER",
}

export enum TechnicStatus {
  ACTIVE = "ACTIVE",
  ARCHIVED = "ARCHIVED",
}

export enum UtilityType {
  ELECTRICITY = "ELECTRICITY",
  ELECTRICITY_DAY_NIGHT = "ELECTRICITY_DAY_NIGHT",
  GAS = "GAS",
  WATER = "WATER",
}

export type UtilityHistoryDTO = {
  __typename: "UtilityHistory",
  date: string,
  reason?: UtilityReadingReason | null,
  reading: number,
  secondReading?: number | null,
};

export enum UtilityReadingReason {
  LEASE_START = "LEASE_START",
  LEASE_END = "LEASE_END",
  NEW_SUPPLIER = "NEW_SUPPLIER",
  CONSUMPTION_TRACKING = "CONSUMPTION_TRACKING",
  MONTHLY_READING = "MONTHLY_READING",
  QUARTERLY_READING = "QUARTERLY_READING",
  YEARLY_READING = "YEARLY_READING",
  RENOVATION = "RENOVATION",
  OWN_USE_START = "OWN_USE_START",
  OWN_USE_END = "OWN_USE_END",
  OTHER = "OTHER",
  METER_REPLACEMENT = "METER_REPLACEMENT",
}

export type TicketDTO = {
  __typename: "Ticket",
  id: string,
  assignedAt?: string | null,
  assignedTo?: ContactDTO | null,
  assignedToId?: string | null,
  attachment?: ModelFileConnection | null,
  building?: BuildingDTO | null,
  buildingId?: string | null,
  closedAt?: string | null,
  contact?: ContactDTO | null,
  contactId: string,
  content: string,
  conversations?: ModelTicketConnection | null,
  createdAt: string,
  emailMessageId?: string | null,
  emailReferences?: Array< string | null > | null,
  parentId?: string | null,
  plannedAt?: string | null,
  referenceCode?: string | null,
  sourceType: TicketSourceType,
  status?: TicketStatus | null,
  subject: string,
  unit?: UnitDTO | null,
  unitId?: string | null,
  unread: boolean,
  updatedAt?: string | null,
  readers?: Array< string > | null,
  readId: string,
  clientId: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type ModelTicketConnection = {
  __typename: "ModelTicketConnection",
  items:  Array<TicketDTO | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export enum TicketSourceType {
  APP = "APP",
  MOBILE = "MOBILE",
  MAIL = "MAIL",
  WEB = "WEB",
}

export enum TicketStatus {
  URGENT = "URGENT",
  PENDING = "PENDING",
  RESOLVED = "RESOLVED",
  ARCHIVED = "ARCHIVED",
}

export type UpdateNotificationInput = {
  id: string,
  createdBy?: NotificationCreation | null,
  type?: NotificationType | null,
  message?: string | null,
  popupDate?: string | null,
  expirationDate?: string | null,
  status?: NotificationStatus | null,
  createdAt?: string | null,
  buildingId?: string | null,
  unitId?: string | null,
  leaseId?: string | null,
  technicId?: string | null,
  ticketId?: string | null,
  readId?: string | null,
  clientId?: string | null,
  _version?: number | null,
};

export type DeleteNotificationInput = {
  id: string,
  _version?: number | null,
};

export type CreateScheduleRuleInput = {
  id?: string | null,
  conditions: Array< RuleConditionInput >,
  conditionsOperator?: RuleConditionsOperator | null,
  foreignKey: string,
  foreignTableName: string,
  name?: Array< CustomLabelInput > | null,
  order?: number | null,
  outcome: RuleOutcomeInput,
  readId: string,
  clientId: string,
  _version?: number | null,
};

export type RuleConditionInput = {
  attribute: RuleAttributeRefInput,
  comparisonMode?: RuleComparisonMode | null,
  operator: RuleConditionOperator,
  values?: Array< string > | null,
  valueKind: RuleValueKind,
};

export type RuleAttributeRefInput = {
  attributeName: string,
};

export enum RuleComparisonMode {
  AGE_IN_DAYS = "AGE_IN_DAYS",
  AGE_IN_MONTHS = "AGE_IN_MONTHS",
  AGE_IN_YEARS = "AGE_IN_YEARS",
  VALUE = "VALUE",
}

export enum RuleConditionOperator {
  EQUALS = "EQUALS",
  GREATER_THAN = "GREATER_THAN",
  GREATER_THAN_OR_EQUAL = "GREATER_THAN_OR_EQUAL",
  IN = "IN",
  IS_NOT_NULL = "IS_NOT_NULL",
  IS_NULL = "IS_NULL",
  LESS_THAN = "LESS_THAN",
  LESS_THAN_OR_EQUAL = "LESS_THAN_OR_EQUAL",
  NOT_EQUALS = "NOT_EQUALS",
  NOT_IN = "NOT_IN",
}

export enum RuleValueKind {
  BOOLEAN = "BOOLEAN",
  DATE = "DATE",
  NUMBER = "NUMBER",
  STRING = "STRING",
}

export enum RuleConditionsOperator {
  AND = "AND",
  OR = "OR",
}

export type RuleOutcomeInput = {
  interval?: RuleIntervalOutcomeInput | null,
  type: RuleOutcomeType,
};

export type RuleIntervalOutcomeInput = {
  interval: RuleDurationInput,
  notifyLeadTime: RuleDurationInput,
  referenceAttribute: RuleAttributeRefInput,
  referenceFallbackAttribute?: RuleAttributeRefInput | null,
};

export type RuleDurationInput = {
  unit: RuleDurationUnit,
  value: number,
};

export enum RuleDurationUnit {
  DAY = "DAY",
  MONTH = "MONTH",
  YEAR = "YEAR",
}

export enum RuleOutcomeType {
  IMMEDIATE_NOTIFY = "IMMEDIATE_NOTIFY",
  INTERVAL = "INTERVAL",
  NOT_APPLICABLE = "NOT_APPLICABLE",
}

export type ModelScheduleRuleConditionInput = {
  conditionsOperator?: ModelRuleConditionsOperatorInput | null,
  foreignKey?: ModelIDInput | null,
  foreignTableName?: ModelStringInput | null,
  order?: ModelIntInput | null,
  readId?: ModelIDInput | null,
  clientId?: ModelIDInput | null,
  and?: Array< ModelScheduleRuleConditionInput | null > | null,
  or?: Array< ModelScheduleRuleConditionInput | null > | null,
  not?: ModelScheduleRuleConditionInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelRuleConditionsOperatorInput = {
  eq?: RuleConditionsOperator | null,
  ne?: RuleConditionsOperator | null,
};

export type ScheduleRuleDTO = {
  __typename: "ScheduleRule",
  id: string,
  conditions:  Array<RuleConditionDTO >,
  conditionsOperator?: RuleConditionsOperator | null,
  foreignKey: string,
  foreignTableName: string,
  name?:  Array<CustomLabelDTO > | null,
  order?: number | null,
  outcome: RuleOutcomeDTO,
  readId: string,
  clientId: string,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type RuleConditionDTO = {
  __typename: "RuleCondition",
  attribute: RuleAttributeRefDTO,
  comparisonMode?: RuleComparisonMode | null,
  operator: RuleConditionOperator,
  values?: Array< string > | null,
  valueKind: RuleValueKind,
};

export type RuleAttributeRefDTO = {
  __typename: "RuleAttributeRef",
  attributeName: string,
};

export type RuleOutcomeDTO = {
  __typename: "RuleOutcome",
  interval?: RuleIntervalOutcomeDTO | null,
  type: RuleOutcomeType,
};

export type RuleIntervalOutcomeDTO = {
  __typename: "RuleIntervalOutcome",
  interval: RuleDurationDTO,
  notifyLeadTime: RuleDurationDTO,
  referenceAttribute: RuleAttributeRefDTO,
  referenceFallbackAttribute?: RuleAttributeRefDTO | null,
};

export type RuleDurationDTO = {
  __typename: "RuleDuration",
  unit: RuleDurationUnit,
  value: number,
};

export type UpdateScheduleRuleInput = {
  id: string,
  conditions?: Array< RuleConditionInput > | null,
  conditionsOperator?: RuleConditionsOperator | null,
  foreignKey?: string | null,
  foreignTableName?: string | null,
  name?: Array< CustomLabelInput > | null,
  order?: number | null,
  outcome?: RuleOutcomeInput | null,
  readId?: string | null,
  clientId?: string | null,
  _version?: number | null,
};

export type DeleteScheduleRuleInput = {
  id: string,
  _version?: number | null,
};

export type CreateSendingSourceInput = {
  id?: string | null,
  createdAt?: string | null,
  createdById?: string | null,
  dnsRecords?: Array< DNSRecordInput > | null,
  emailAddress: string,
  issuesEmail: string,
  chargesEmail: string,
  errorMessage?: SendingSourceErrorType | null,
  name: string,
  lastReminderDate?: string | null,
  status: SendingSourceStatus,
  statusLastVerification?: string | null,
  verifiedType: SendingSourceVerifiedType,
  readId: string,
  clientId: string,
  _version?: number | null,
};

export type DNSRecordInput = {
  name: string,
  type: string,
  value: string,
};

export enum SendingSourceErrorType {
  ALREADY_EXISTS = "ALREADY_EXISTS",
  CRASH = "CRASH",
  TIME = "TIME",
  SES = "SES",
  OTHER = "OTHER",
}

export enum SendingSourceStatus {
  ERROR = "ERROR",
  NONE = "NONE",
  PENDING = "PENDING",
  VERIFIED = "VERIFIED",
}

export enum SendingSourceVerifiedType {
  DEFAULT = "DEFAULT",
  NONE = "NONE",
  PLATFORM = "PLATFORM",
}

export type ModelSendingSourceConditionInput = {
  createdAt?: ModelStringInput | null,
  createdById?: ModelIDInput | null,
  emailAddress?: ModelStringInput | null,
  issuesEmail?: ModelStringInput | null,
  chargesEmail?: ModelStringInput | null,
  errorMessage?: ModelSendingSourceErrorTypeInput | null,
  name?: ModelStringInput | null,
  lastReminderDate?: ModelStringInput | null,
  status?: ModelSendingSourceStatusInput | null,
  statusLastVerification?: ModelStringInput | null,
  verifiedType?: ModelSendingSourceVerifiedTypeInput | null,
  readId?: ModelIDInput | null,
  clientId?: ModelIDInput | null,
  and?: Array< ModelSendingSourceConditionInput | null > | null,
  or?: Array< ModelSendingSourceConditionInput | null > | null,
  not?: ModelSendingSourceConditionInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSendingSourceErrorTypeInput = {
  eq?: SendingSourceErrorType | null,
  ne?: SendingSourceErrorType | null,
};

export type ModelSendingSourceStatusInput = {
  eq?: SendingSourceStatus | null,
  ne?: SendingSourceStatus | null,
};

export type ModelSendingSourceVerifiedTypeInput = {
  eq?: SendingSourceVerifiedType | null,
  ne?: SendingSourceVerifiedType | null,
};

export type SendingSourceDTO = {
  __typename: "SendingSource",
  id: string,
  createdAt?: string | null,
  createdById?: string | null,
  createdBy?: ContactDTO | null,
  dnsRecords?:  Array<DNSRecordDTO > | null,
  emailAddress: string,
  issuesEmail: string,
  chargesEmail: string,
  errorMessage?: SendingSourceErrorType | null,
  name: string,
  lastReminderDate?: string | null,
  status: SendingSourceStatus,
  statusLastVerification?: string | null,
  verifiedType: SendingSourceVerifiedType,
  readId: string,
  clientId: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type DNSRecordDTO = {
  __typename: "DNSRecord",
  name: string,
  type: string,
  value: string,
};

export type UpdateSendingSourceInput = {
  id: string,
  createdAt?: string | null,
  createdById?: string | null,
  dnsRecords?: Array< DNSRecordInput > | null,
  emailAddress?: string | null,
  issuesEmail?: string | null,
  chargesEmail?: string | null,
  errorMessage?: SendingSourceErrorType | null,
  name?: string | null,
  lastReminderDate?: string | null,
  status?: SendingSourceStatus | null,
  statusLastVerification?: string | null,
  verifiedType?: SendingSourceVerifiedType | null,
  readId?: string | null,
  clientId?: string | null,
  _version?: number | null,
};

export type DeleteSendingSourceInput = {
  id: string,
  _version?: number | null,
};

export type CreateSettingInput = {
  id?: string | null,
  name: SettingType,
  value: string,
  readId: string,
  clientId: string,
  _version?: number | null,
};

export enum SettingType {
  ADVANCED_LEASE_CHARGES_INVOICE = "ADVANCED_LEASE_CHARGES_INVOICE",
  AUTOMATIC_INDEXATION = "AUTOMATIC_INDEXATION",
  CHARGE_ADJUSTMENT_PERCENTAGE_VARIATION = "CHARGE_ADJUSTMENT_PERCENTAGE_VARIATION",
  COMMUNICATION_TIME_FRAME = "COMMUNICATION_TIME_FRAME",
  SHOW_INVOICE_SENDER_ADDRESS_WHEN_AGENCY = "SHOW_INVOICE_SENDER_ADDRESS_WHEN_AGENCY",
  SHOW_BUILDING_SITE = "SHOW_BUILDING_SITE",
  AGENCY_RATES_ENABLED = "AGENCY_RATES_ENABLED",
  OWNER_STATEMENTS_ENABLED = "OWNER_STATEMENTS_ENABLED",
  STATEMENT_SUPPORTING_DOCUMENTS_ATTACHED = "STATEMENT_SUPPORTING_DOCUMENTS_ATTACHED",
  RECONCILIATION_ALLOCATION_MODE = "RECONCILIATION_ALLOCATION_MODE",
  RECONCILIATION_OVERPAYMENT_CAP_MONTHS = "RECONCILIATION_OVERPAYMENT_CAP_MONTHS",
  RECONCILIATION_DRAFT_EARLY_POSTING = "RECONCILIATION_DRAFT_EARLY_POSTING",
  TICKET_NOTIFICATION_ENABLED = "TICKET_NOTIFICATION_ENABLED",
  TICKET_NOTIFICATION_RECIPIENTS = "TICKET_NOTIFICATION_RECIPIENTS",
  LEASE_REMITTANCE_TYPE_RESIDENTIAL = "LEASE_REMITTANCE_TYPE_RESIDENTIAL",
  LEASE_REMITTANCE_TYPE_COMMERCIAL = "LEASE_REMITTANCE_TYPE_COMMERCIAL",
  MF_ENABLED = "MF_ENABLED",
  MF_DEFAULT_LEGAL_CONTACT_ID = "MF_DEFAULT_LEGAL_CONTACT_ID",
  MF_DEFAULT_VAT_RATE_ID = "MF_DEFAULT_VAT_RATE_ID",
  MF_START_FISCAL_YEAR = "MF_START_FISCAL_YEAR",
  MF_END_FISCAL_YEAR = "MF_END_FISCAL_YEAR",
  MF_INVOICE_DETAIL_LEVEL = "MF_INVOICE_DETAIL_LEVEL",
  MF_IBAN_FOR_MANAGEMENT_FEES = "MF_IBAN_FOR_MANAGEMENT_FEES",
  MF_INVOICE_SCHEDULE_FREQUENCY = "MF_INVOICE_SCHEDULE_FREQUENCY",
  MF_INVOICE_SCHEDULE_CREATE_DATE = "MF_INVOICE_SCHEDULE_CREATE_DATE",
  MF_INVOICE_SCHEDULE_POST_DATE = "MF_INVOICE_SCHEDULE_POST_DATE",
  MF_INVOICE_SCHEDULE_ENABLED = "MF_INVOICE_SCHEDULE_ENABLED",
  MF_INVOICE_SCHEDULE_AUTO_SEND = "MF_INVOICE_SCHEDULE_AUTO_SEND",
  MF_INVOICE_SCHEDULE_DUE_DATE = "MF_INVOICE_SCHEDULE_DUE_DATE",
  MF_DEFAULT_SEND_CHANNELS = "MF_DEFAULT_SEND_CHANNELS",
  PAYMENTS_DOUBLE_CHECKS_ENABLED = "PAYMENTS_DOUBLE_CHECKS_ENABLED",
  PAYMENTS_FEE_ARREARS_ALERT_DAYS = "PAYMENTS_FEE_ARREARS_ALERT_DAYS",
}

export type ModelSettingConditionInput = {
  name?: ModelSettingTypeInput | null,
  value?: ModelStringInput | null,
  readId?: ModelIDInput | null,
  clientId?: ModelIDInput | null,
  and?: Array< ModelSettingConditionInput | null > | null,
  or?: Array< ModelSettingConditionInput | null > | null,
  not?: ModelSettingConditionInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSettingTypeInput = {
  eq?: SettingType | null,
  ne?: SettingType | null,
};

export type SettingDTO = {
  __typename: "Setting",
  id: string,
  name: SettingType,
  value: string,
  readId: string,
  clientId: string,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type UpdateSettingInput = {
  id: string,
  name?: SettingType | null,
  value?: string | null,
  readId?: string | null,
  clientId?: string | null,
  _version?: number | null,
};

export type DeleteSettingInput = {
  id: string,
  _version?: number | null,
};

export type CreateReconciliationSettingInput = {
  id?: string | null,
  type: ReconciliationSettingType,
  allocationMode: ReconciliationAllocationMode,
  leaseId?: string | null,
  ownerId?: string | null,
  readId: string,
  clientId: string,
  _version?: number | null,
};

export enum ReconciliationSettingType {
  LEASE = "LEASE",
  OWNER = "OWNER",
}

export enum ReconciliationAllocationMode {
  AUTOMATIC = "AUTOMATIC",
  DETAILED = "DETAILED",
}

export type ModelReconciliationSettingConditionInput = {
  type?: ModelReconciliationSettingTypeInput | null,
  allocationMode?: ModelReconciliationAllocationModeInput | null,
  leaseId?: ModelIDInput | null,
  ownerId?: ModelIDInput | null,
  readId?: ModelIDInput | null,
  clientId?: ModelIDInput | null,
  and?: Array< ModelReconciliationSettingConditionInput | null > | null,
  or?: Array< ModelReconciliationSettingConditionInput | null > | null,
  not?: ModelReconciliationSettingConditionInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelReconciliationSettingTypeInput = {
  eq?: ReconciliationSettingType | null,
  ne?: ReconciliationSettingType | null,
};

export type ModelReconciliationAllocationModeInput = {
  eq?: ReconciliationAllocationMode | null,
  ne?: ReconciliationAllocationMode | null,
};

export type ReconciliationSettingDTO = {
  __typename: "ReconciliationSetting",
  id: string,
  type: ReconciliationSettingType,
  allocationMode: ReconciliationAllocationMode,
  leaseId?: string | null,
  ownerId?: string | null,
  readId: string,
  clientId: string,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type UpdateReconciliationSettingInput = {
  id: string,
  type?: ReconciliationSettingType | null,
  allocationMode?: ReconciliationAllocationMode | null,
  leaseId?: string | null,
  ownerId?: string | null,
  readId?: string | null,
  clientId?: string | null,
  _version?: number | null,
};

export type DeleteReconciliationSettingInput = {
  id: string,
  _version?: number | null,
};

export type CreateRepaymentStatementInput = {
  id?: string | null,
  accountOwnership: RepaymentStatementAccountOwnership,
  delaysCleared: number,
  expectedRent: number,
  leaseId: string,
  rentsCollected: number,
  repaymentStatementDetails: Array< RepaymentStatementDetailInput >,
  statementId: string,
  totalReceivedInJointAccount: number,
  totalExpectedInOwnerAccount: number,
  unpaidRents: number,
  readId: string,
  clientId: string,
  _version?: number | null,
};

export type RepaymentStatementDetailInput = {
  class: number,
  customLabel?: string | null,
  invoiceId: string,
  invoicePostingId: string,
  originalTotalAmount: number,
  periodFrom: string,
  periodTo: string,
  totalAmount: number,
  transactionId?: string | null,
  type: RepaymentStatementDetailType,
};

export type ModelRepaymentStatementConditionInput = {
  accountOwnership?: ModelRepaymentStatementAccountOwnershipInput | null,
  delaysCleared?: ModelFloatInput | null,
  expectedRent?: ModelFloatInput | null,
  leaseId?: ModelIDInput | null,
  rentsCollected?: ModelFloatInput | null,
  statementId?: ModelIDInput | null,
  totalReceivedInJointAccount?: ModelFloatInput | null,
  totalExpectedInOwnerAccount?: ModelFloatInput | null,
  unpaidRents?: ModelFloatInput | null,
  readId?: ModelIDInput | null,
  clientId?: ModelIDInput | null,
  and?: Array< ModelRepaymentStatementConditionInput | null > | null,
  or?: Array< ModelRepaymentStatementConditionInput | null > | null,
  not?: ModelRepaymentStatementConditionInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelRepaymentStatementAccountOwnershipInput = {
  eq?: RepaymentStatementAccountOwnership | null,
  ne?: RepaymentStatementAccountOwnership | null,
};

export type UpdateRepaymentStatementInput = {
  id: string,
  accountOwnership?: RepaymentStatementAccountOwnership | null,
  delaysCleared?: number | null,
  expectedRent?: number | null,
  leaseId?: string | null,
  rentsCollected?: number | null,
  repaymentStatementDetails?: Array< RepaymentStatementDetailInput > | null,
  statementId?: string | null,
  totalReceivedInJointAccount?: number | null,
  totalExpectedInOwnerAccount?: number | null,
  unpaidRents?: number | null,
  readId?: string | null,
  clientId?: string | null,
  _version?: number | null,
};

export type DeleteRepaymentStatementInput = {
  id: string,
  _version?: number | null,
};

export type CreateStatementInput = {
  id?: string | null,
  amounts?: Array< CustomValueInput > | null,
  closingStatement: boolean,
  periodFrom: string,
  periodTo: string,
  attachSupportingDocuments?: boolean | null,
  selectedPocketKeys?: Array< string > | null,
  source: StatementSource,
  status: StatementStatus,
  sentDate?: string | null,
  leaseId?: string | null,
  ownerId?: string | null,
  types?: Array< StatementType > | null,
  viewType: StatementViewType,
  unitIds?: Array< string > | null,
  readId: string,
  clientId: string,
  _version?: number | null,
};

export type ModelStatementConditionInput = {
  closingStatement?: ModelBooleanInput | null,
  periodFrom?: ModelStringInput | null,
  periodTo?: ModelStringInput | null,
  attachSupportingDocuments?: ModelBooleanInput | null,
  selectedPocketKeys?: ModelStringInput | null,
  source?: ModelStatementSourceInput | null,
  status?: ModelStatementStatusInput | null,
  sentDate?: ModelStringInput | null,
  leaseId?: ModelIDInput | null,
  ownerId?: ModelIDInput | null,
  types?: ModelStatementTypeListInput | null,
  viewType?: ModelStatementViewTypeInput | null,
  unitIds?: ModelIDInput | null,
  readId?: ModelIDInput | null,
  clientId?: ModelIDInput | null,
  and?: Array< ModelStatementConditionInput | null > | null,
  or?: Array< ModelStatementConditionInput | null > | null,
  not?: ModelStatementConditionInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelStatementSourceInput = {
  eq?: StatementSource | null,
  ne?: StatementSource | null,
};

export type ModelStatementStatusInput = {
  eq?: StatementStatus | null,
  ne?: StatementStatus | null,
};

export type ModelStatementTypeListInput = {
  eq?: Array< StatementType | null > | null,
  ne?: Array< StatementType | null > | null,
  contains?: StatementType | null,
  notContains?: StatementType | null,
};

export type UpdateStatementInput = {
  id: string,
  amounts?: Array< CustomValueInput > | null,
  closingStatement?: boolean | null,
  periodFrom?: string | null,
  periodTo?: string | null,
  attachSupportingDocuments?: boolean | null,
  selectedPocketKeys?: Array< string > | null,
  source?: StatementSource | null,
  status?: StatementStatus | null,
  sentDate?: string | null,
  leaseId?: string | null,
  ownerId?: string | null,
  types?: Array< StatementType > | null,
  viewType?: StatementViewType | null,
  unitIds?: Array< string > | null,
  readId?: string | null,
  clientId?: string | null,
  _version?: number | null,
};

export type DeleteStatementInput = {
  id: string,
  _version?: number | null,
};

export type CreateStatementSettingInput = {
  id?: string | null,
  type: StatementSettingType,
  custom: boolean,
  disabled?: boolean | null,
  monthFrequency: number,
  startMonth?: string | null,
  generationDay?: number | null,
  leaseId?: string | null,
  ownerId?: string | null,
  readId: string,
  clientId: string,
  _version?: number | null,
};

export enum StatementSettingType {
  OWNER = "OWNER",
  LEASE = "LEASE",
}

export type ModelStatementSettingConditionInput = {
  type?: ModelStatementSettingTypeInput | null,
  custom?: ModelBooleanInput | null,
  disabled?: ModelBooleanInput | null,
  monthFrequency?: ModelIntInput | null,
  startMonth?: ModelStringInput | null,
  generationDay?: ModelIntInput | null,
  leaseId?: ModelIDInput | null,
  ownerId?: ModelIDInput | null,
  readId?: ModelIDInput | null,
  clientId?: ModelIDInput | null,
  and?: Array< ModelStatementSettingConditionInput | null > | null,
  or?: Array< ModelStatementSettingConditionInput | null > | null,
  not?: ModelStatementSettingConditionInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelStatementSettingTypeInput = {
  eq?: StatementSettingType | null,
  ne?: StatementSettingType | null,
};

export type StatementSettingDTO = {
  __typename: "StatementSetting",
  id: string,
  type: StatementSettingType,
  custom: boolean,
  disabled?: boolean | null,
  monthFrequency: number,
  startMonth?: string | null,
  generationDay?: number | null,
  leaseId?: string | null,
  lease?: LeaseDTO | null,
  ownerId?: string | null,
  owner?: ContactDTO | null,
  readId: string,
  clientId: string,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type UpdateStatementSettingInput = {
  id: string,
  type?: StatementSettingType | null,
  custom?: boolean | null,
  disabled?: boolean | null,
  monthFrequency?: number | null,
  startMonth?: string | null,
  generationDay?: number | null,
  leaseId?: string | null,
  ownerId?: string | null,
  readId?: string | null,
  clientId?: string | null,
  _version?: number | null,
};

export type DeleteStatementSettingInput = {
  id: string,
  _version?: number | null,
};

export type CreateTagInput = {
  id?: string | null,
  color?: string | null,
  foreignTableName: string,
  labels: Array< CustomLabelInput >,
  readId: string,
  clientId: string,
  _version?: number | null,
};

export type ModelTagConditionInput = {
  color?: ModelStringInput | null,
  foreignTableName?: ModelStringInput | null,
  readId?: ModelIDInput | null,
  clientId?: ModelIDInput | null,
  and?: Array< ModelTagConditionInput | null > | null,
  or?: Array< ModelTagConditionInput | null > | null,
  not?: ModelTagConditionInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type TagDTO = {
  __typename: "Tag",
  id: string,
  color?: string | null,
  foreignTableName: string,
  labels:  Array<CustomLabelDTO >,
  readId: string,
  clientId: string,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type UpdateTagInput = {
  id: string,
  color?: string | null,
  foreignTableName?: string | null,
  labels?: Array< CustomLabelInput > | null,
  readId?: string | null,
  clientId?: string | null,
  _version?: number | null,
};

export type DeleteTagInput = {
  id: string,
  _version?: number | null,
};

export type CreateTechnicInput = {
  id?: string | null,
  type: TechnicType,
  contractNumber?: string | null,
  communicationSettingsProfileId: string,
  maintenanceHistory?: Array< TechnicMaintenanceHistoryInput > | null,
  technicLibraryId?: string | null,
  technicName?: string | null,
  lastControlDate?: string | null,
  status?: TechnicStatus | null,
  utilityType?: UtilityType | null,
  utilityEanCode?: string | null,
  utilityMeterNumber?: string | null,
  utilityDistributorId?: string | null,
  utilityHistory?: Array< UtilityHistoryInput > | null,
  buildingId?: string | null,
  unitId?: string | null,
  leaseId?: string | null,
  contactId?: string | null,
  customValues?: Array< CustomValueInput > | null,
  originalTechnicId?: string | null,
  replacedTechnicId?: string | null,
  certificateIds?: Array< string > | null,
  readers?: Array< string > | null,
  writers?: Array< string > | null,
  readId: string,
  clientId: string,
  _version?: number | null,
};

export type TechnicMaintenanceHistoryInput = {
  date: string,
  contactId?: string | null,
  fileId?: string | null,
};

export type UtilityHistoryInput = {
  date: string,
  reason?: UtilityReadingReason | null,
  reading: number,
  secondReading?: number | null,
};

export type ModelTechnicConditionInput = {
  type?: ModelTechnicTypeInput | null,
  contractNumber?: ModelStringInput | null,
  communicationSettingsProfileId?: ModelIDInput | null,
  technicLibraryId?: ModelIDInput | null,
  technicName?: ModelStringInput | null,
  lastControlDate?: ModelStringInput | null,
  status?: ModelTechnicStatusInput | null,
  utilityType?: ModelUtilityTypeInput | null,
  utilityEanCode?: ModelStringInput | null,
  utilityMeterNumber?: ModelStringInput | null,
  utilityDistributorId?: ModelIDInput | null,
  buildingId?: ModelIDInput | null,
  unitId?: ModelIDInput | null,
  leaseId?: ModelIDInput | null,
  contactId?: ModelIDInput | null,
  originalTechnicId?: ModelIDInput | null,
  replacedTechnicId?: ModelIDInput | null,
  certificateIds?: ModelIDInput | null,
  readers?: ModelIDInput | null,
  writers?: ModelIDInput | null,
  readId?: ModelIDInput | null,
  clientId?: ModelIDInput | null,
  and?: Array< ModelTechnicConditionInput | null > | null,
  or?: Array< ModelTechnicConditionInput | null > | null,
  not?: ModelTechnicConditionInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelTechnicTypeInput = {
  eq?: TechnicType | null,
  ne?: TechnicType | null,
};

export type ModelTechnicStatusInput = {
  eq?: TechnicStatus | null,
  ne?: TechnicStatus | null,
};

export type ModelUtilityTypeInput = {
  eq?: UtilityType | null,
  ne?: UtilityType | null,
};

export type UpdateTechnicInput = {
  id: string,
  type?: TechnicType | null,
  contractNumber?: string | null,
  communicationSettingsProfileId?: string | null,
  maintenanceHistory?: Array< TechnicMaintenanceHistoryInput > | null,
  technicLibraryId?: string | null,
  technicName?: string | null,
  lastControlDate?: string | null,
  status?: TechnicStatus | null,
  utilityType?: UtilityType | null,
  utilityEanCode?: string | null,
  utilityMeterNumber?: string | null,
  utilityDistributorId?: string | null,
  utilityHistory?: Array< UtilityHistoryInput > | null,
  buildingId?: string | null,
  unitId?: string | null,
  leaseId?: string | null,
  contactId?: string | null,
  customValues?: Array< CustomValueInput > | null,
  originalTechnicId?: string | null,
  replacedTechnicId?: string | null,
  certificateIds?: Array< string > | null,
  readers?: Array< string > | null,
  writers?: Array< string > | null,
  readId?: string | null,
  clientId?: string | null,
  _version?: number | null,
};

export type DeleteTechnicInput = {
  id: string,
  _version?: number | null,
};

export type CreateTechnicLibraryInput = {
  id?: string | null,
  certificateValidity?: CertificateLibraryValidityInput | null,
  communicationSettingsProfileId?: string | null,
  criticality: TechnicLibraryCriticality,
  descriptions?: Array< CustomLabelInput > | null,
  isDefault?: boolean | null,
  issuingAuthority?: string | null,
  linkedCertificateIds?: Array< string > | null,
  locationScope?: TechnicLibraryLocationScope | null,
  maintenanceSchemas?: Array< TechnicLibraryMaintenanceSchemaInput > | null,
  names: Array< CustomLabelInput >,
  status: TechnicLibraryStatus,
  tagIds?: Array< string > | null,
  technicLibraryFormat?: string | null,
  type: TechnicLibraryType,
  utilityTypes?: Array< UtilityType > | null,
  validity?: TechnicLibraryValidityInput | null,
  readId: string,
  clientId: string,
  _version?: number | null,
};

export type CertificateLibraryValidityInput = {
  gracePeriod?: TechnicLibraryValidityInput | null,
  nonCompliant?: boolean | null,
  overlapping?: boolean | null,
  riskLevel?: RiskLevelExpiration | null,
};

export type TechnicLibraryValidityInput = {
  value: number,
  validityUnit: TechnicLibraryValidityUnit,
};

export type TechnicLibraryMaintenanceSchemaInput = {
  id: string,
  criticality: TechnicLibraryCriticality,
  deadline?: string | null,
  descriptions?: Array< CustomLabelInput > | null,
  interval?: TechnicLibraryValidityInput | null,
  maintenanceType: TechnicLibraryMaintenanceType,
  names: Array< CustomLabelInput >,
  notificationsEnabled?: boolean | null,
  notificationType?: NotificationType | null,
  proofType?: Array< TechnicLibraryProofType > | null,
  proofTypeName?: Array< CustomLabelInput > | null,
  recurrence?: TechnicLibraryRecurrence | null,
  responsibleParty: TechnicLibraryResponsibleParty,
  triggerType?: TechnicLibraryTriggerType | null,
};

export type ModelTechnicLibraryConditionInput = {
  communicationSettingsProfileId?: ModelIDInput | null,
  criticality?: ModelTechnicLibraryCriticalityInput | null,
  isDefault?: ModelBooleanInput | null,
  issuingAuthority?: ModelStringInput | null,
  linkedCertificateIds?: ModelIDInput | null,
  locationScope?: ModelTechnicLibraryLocationScopeInput | null,
  status?: ModelTechnicLibraryStatusInput | null,
  tagIds?: ModelIDInput | null,
  technicLibraryFormat?: ModelStringInput | null,
  type?: ModelTechnicLibraryTypeInput | null,
  utilityTypes?: ModelUtilityTypeInput | null,
  readId?: ModelIDInput | null,
  clientId?: ModelIDInput | null,
  and?: Array< ModelTechnicLibraryConditionInput | null > | null,
  or?: Array< ModelTechnicLibraryConditionInput | null > | null,
  not?: ModelTechnicLibraryConditionInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelTechnicLibraryCriticalityInput = {
  eq?: TechnicLibraryCriticality | null,
  ne?: TechnicLibraryCriticality | null,
};

export type ModelTechnicLibraryLocationScopeInput = {
  eq?: TechnicLibraryLocationScope | null,
  ne?: TechnicLibraryLocationScope | null,
};

export type ModelTechnicLibraryStatusInput = {
  eq?: TechnicLibraryStatus | null,
  ne?: TechnicLibraryStatus | null,
};

export type ModelTechnicLibraryTypeInput = {
  eq?: TechnicLibraryType | null,
  ne?: TechnicLibraryType | null,
};

export type UpdateTechnicLibraryInput = {
  id: string,
  certificateValidity?: CertificateLibraryValidityInput | null,
  communicationSettingsProfileId?: string | null,
  criticality?: TechnicLibraryCriticality | null,
  descriptions?: Array< CustomLabelInput > | null,
  isDefault?: boolean | null,
  issuingAuthority?: string | null,
  linkedCertificateIds?: Array< string > | null,
  locationScope?: TechnicLibraryLocationScope | null,
  maintenanceSchemas?: Array< TechnicLibraryMaintenanceSchemaInput > | null,
  names?: Array< CustomLabelInput > | null,
  status?: TechnicLibraryStatus | null,
  tagIds?: Array< string > | null,
  technicLibraryFormat?: string | null,
  type?: TechnicLibraryType | null,
  utilityTypes?: Array< UtilityType > | null,
  validity?: TechnicLibraryValidityInput | null,
  readId?: string | null,
  clientId?: string | null,
  _version?: number | null,
};

export type DeleteTechnicLibraryInput = {
  id: string,
  _version?: number | null,
};

export type CreateTicketInput = {
  id?: string | null,
  assignedAt?: string | null,
  assignedToId?: string | null,
  buildingId?: string | null,
  closedAt?: string | null,
  contactId: string,
  content: string,
  createdAt?: string | null,
  emailMessageId?: string | null,
  emailReferences?: Array< string | null > | null,
  parentId?: string | null,
  plannedAt?: string | null,
  referenceCode?: string | null,
  sourceType: TicketSourceType,
  status?: TicketStatus | null,
  subject: string,
  unitId?: string | null,
  unread: boolean,
  updatedAt?: string | null,
  readers?: Array< string > | null,
  readId: string,
  clientId: string,
  _version?: number | null,
};

export type ModelTicketConditionInput = {
  assignedAt?: ModelStringInput | null,
  assignedToId?: ModelIDInput | null,
  buildingId?: ModelIDInput | null,
  closedAt?: ModelStringInput | null,
  contactId?: ModelIDInput | null,
  content?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  emailMessageId?: ModelStringInput | null,
  emailReferences?: ModelStringInput | null,
  parentId?: ModelIDInput | null,
  plannedAt?: ModelStringInput | null,
  referenceCode?: ModelStringInput | null,
  sourceType?: ModelTicketSourceTypeInput | null,
  status?: ModelTicketStatusInput | null,
  subject?: ModelStringInput | null,
  unitId?: ModelIDInput | null,
  unread?: ModelBooleanInput | null,
  updatedAt?: ModelStringInput | null,
  readers?: ModelIDInput | null,
  readId?: ModelIDInput | null,
  clientId?: ModelIDInput | null,
  and?: Array< ModelTicketConditionInput | null > | null,
  or?: Array< ModelTicketConditionInput | null > | null,
  not?: ModelTicketConditionInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelTicketSourceTypeInput = {
  eq?: TicketSourceType | null,
  ne?: TicketSourceType | null,
};

export type ModelTicketStatusInput = {
  eq?: TicketStatus | null,
  ne?: TicketStatus | null,
};

export type UpdateTicketInput = {
  id: string,
  assignedAt?: string | null,
  assignedToId?: string | null,
  buildingId?: string | null,
  closedAt?: string | null,
  contactId?: string | null,
  content?: string | null,
  createdAt?: string | null,
  emailMessageId?: string | null,
  emailReferences?: Array< string | null > | null,
  parentId?: string | null,
  plannedAt?: string | null,
  referenceCode?: string | null,
  sourceType?: TicketSourceType | null,
  status?: TicketStatus | null,
  subject?: string | null,
  unitId?: string | null,
  unread?: boolean | null,
  updatedAt?: string | null,
  readers?: Array< string > | null,
  readId?: string | null,
  clientId?: string | null,
  _version?: number | null,
};

export type DeleteTicketInput = {
  id: string,
  _version?: number | null,
};

export type CreateUnitInput = {
  id?: string | null,
  acquisitionAdditionalCostsValue?: number | null,
  acquisitionAdvertisedValue?: number | null,
  acquisitionValue?: number | null,
  advertisedMonthlyCharges?: number | null,
  advertisedRentalPrice?: number | null,
  cadastralIncome?: number | null,
  createdAt?: string | null,
  customValues?: Array< CustomValueInput > | null,
  floor?: number | null,
  jointOwnershipId?: string | null,
  managementDate: string,
  name: string,
  notes?: string | null,
  predictedPrice?: string | null,
  propertyTax?: number | null,
  publishAddress?: boolean | null,
  surface?: number | null,
  type: UnitType,
  buildingId: string,
  unitAdvertisementId?: string | null,
  readers?: Array< string > | null,
  readId: string,
  clientId: string,
  _version?: number | null,
};

export type ModelUnitConditionInput = {
  acquisitionAdditionalCostsValue?: ModelFloatInput | null,
  acquisitionAdvertisedValue?: ModelFloatInput | null,
  acquisitionValue?: ModelFloatInput | null,
  advertisedMonthlyCharges?: ModelFloatInput | null,
  advertisedRentalPrice?: ModelFloatInput | null,
  cadastralIncome?: ModelFloatInput | null,
  createdAt?: ModelStringInput | null,
  floor?: ModelIntInput | null,
  jointOwnershipId?: ModelIDInput | null,
  managementDate?: ModelStringInput | null,
  name?: ModelStringInput | null,
  notes?: ModelStringInput | null,
  predictedPrice?: ModelStringInput | null,
  propertyTax?: ModelFloatInput | null,
  publishAddress?: ModelBooleanInput | null,
  surface?: ModelFloatInput | null,
  type?: ModelUnitTypeInput | null,
  buildingId?: ModelIDInput | null,
  unitAdvertisementId?: ModelIDInput | null,
  readers?: ModelIDInput | null,
  readId?: ModelIDInput | null,
  clientId?: ModelIDInput | null,
  and?: Array< ModelUnitConditionInput | null > | null,
  or?: Array< ModelUnitConditionInput | null > | null,
  not?: ModelUnitConditionInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type UpdateUnitInput = {
  id: string,
  acquisitionAdditionalCostsValue?: number | null,
  acquisitionAdvertisedValue?: number | null,
  acquisitionValue?: number | null,
  advertisedMonthlyCharges?: number | null,
  advertisedRentalPrice?: number | null,
  cadastralIncome?: number | null,
  createdAt?: string | null,
  customValues?: Array< CustomValueInput > | null,
  floor?: number | null,
  jointOwnershipId?: string | null,
  managementDate?: string | null,
  name?: string | null,
  notes?: string | null,
  predictedPrice?: string | null,
  propertyTax?: number | null,
  publishAddress?: boolean | null,
  surface?: number | null,
  type?: UnitType | null,
  buildingId?: string | null,
  unitAdvertisementId?: string | null,
  readers?: Array< string > | null,
  readId?: string | null,
  clientId?: string | null,
  _version?: number | null,
};

export type DeleteUnitInput = {
  id: string,
  _version?: number | null,
};

export type CreateUnitEventInput = {
  id?: string | null,
  unitId: string,
  type: UnitEventType,
  startDate: string,
  endDate: string,
  totalCost?: number | null,
  note?: string | null,
  writers?: Array< string > | null,
  readId: string,
  clientId: string,
  _version?: number | null,
};

export type ModelUnitEventConditionInput = {
  unitId?: ModelIDInput | null,
  type?: ModelUnitEventTypeInput | null,
  startDate?: ModelStringInput | null,
  endDate?: ModelStringInput | null,
  totalCost?: ModelFloatInput | null,
  note?: ModelStringInput | null,
  writers?: ModelIDInput | null,
  readId?: ModelIDInput | null,
  clientId?: ModelIDInput | null,
  and?: Array< ModelUnitEventConditionInput | null > | null,
  or?: Array< ModelUnitEventConditionInput | null > | null,
  not?: ModelUnitEventConditionInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelUnitEventTypeInput = {
  eq?: UnitEventType | null,
  ne?: UnitEventType | null,
};

export type UpdateUnitEventInput = {
  id: string,
  unitId?: string | null,
  type?: UnitEventType | null,
  startDate?: string | null,
  endDate?: string | null,
  totalCost?: number | null,
  note?: string | null,
  writers?: Array< string > | null,
  readId?: string | null,
  clientId?: string | null,
  _version?: number | null,
};

export type DeleteUnitEventInput = {
  id: string,
  _version?: number | null,
};

export type CreateUnitInventoryInput = {
  id?: string | null,
  privateBatthRoom?: boolean | null,
  createdAt?: string | null,
  deletedAt?: string | null,
  kitchenEquipment?: KitchenEquipment | null,
  roomName?: string | null,
  roomType: UnitInventoryRoomType,
  surface?: number | null,
  showSurface?: boolean | null,
  unitId: string,
  inside: boolean,
  readId: string,
  clientId: string,
  _version?: number | null,
};

export type ModelUnitInventoryConditionInput = {
  privateBatthRoom?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  deletedAt?: ModelStringInput | null,
  kitchenEquipment?: ModelKitchenEquipmentInput | null,
  roomName?: ModelStringInput | null,
  roomType?: ModelUnitInventoryRoomTypeInput | null,
  surface?: ModelFloatInput | null,
  showSurface?: ModelBooleanInput | null,
  unitId?: ModelIDInput | null,
  inside?: ModelBooleanInput | null,
  readId?: ModelIDInput | null,
  clientId?: ModelIDInput | null,
  and?: Array< ModelUnitInventoryConditionInput | null > | null,
  or?: Array< ModelUnitInventoryConditionInput | null > | null,
  not?: ModelUnitInventoryConditionInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelKitchenEquipmentInput = {
  eq?: KitchenEquipment | null,
  ne?: KitchenEquipment | null,
};

export type ModelUnitInventoryRoomTypeInput = {
  eq?: UnitInventoryRoomType | null,
  ne?: UnitInventoryRoomType | null,
};

export type UpdateUnitInventoryInput = {
  id: string,
  privateBatthRoom?: boolean | null,
  createdAt?: string | null,
  deletedAt?: string | null,
  kitchenEquipment?: KitchenEquipment | null,
  roomName?: string | null,
  roomType?: UnitInventoryRoomType | null,
  surface?: number | null,
  showSurface?: boolean | null,
  unitId?: string | null,
  inside?: boolean | null,
  readId?: string | null,
  clientId?: string | null,
  _version?: number | null,
};

export type DeleteUnitInventoryInput = {
  id: string,
  _version?: number | null,
};

export type CreateUnitLeaseInput = {
  id?: string | null,
  allowChargeAdjustment?: boolean | null,
  authorizeProfessionalActivity?: boolean | null,
  chargesIndexation?: boolean | null,
  createdAt?: string | null,
  endDate: string,
  furnishedRental?: boolean | null,
  furnishedRentalInsuranceByTenant?: boolean | null,
  furnishedRentalRentalPricePercentage?: number | null,
  initialRentalPrice: number,
  indexation?: boolean | null,
  advancedIndexation?: boolean | null,
  indexType?: IndexType | null,
  baseYear?: number | null,
  baseIndexType?: BaseIndexType | null,
  baseIndexDate?: string | null,
  nextIndexationMonth?: string | null,
  nextIndexation?: boolean | null,
  leaseId: string,
  mainUnit: boolean,
  rentalPrice: number,
  signatureDate?: string | null,
  startDate: string,
  unitId: string,
  readers?: Array< string > | null,
  readId: string,
  clientId: string,
  _version?: number | null,
};

export type ModelUnitLeaseConditionInput = {
  allowChargeAdjustment?: ModelBooleanInput | null,
  authorizeProfessionalActivity?: ModelBooleanInput | null,
  chargesIndexation?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  endDate?: ModelStringInput | null,
  furnishedRental?: ModelBooleanInput | null,
  furnishedRentalInsuranceByTenant?: ModelBooleanInput | null,
  furnishedRentalRentalPricePercentage?: ModelFloatInput | null,
  initialRentalPrice?: ModelFloatInput | null,
  indexation?: ModelBooleanInput | null,
  advancedIndexation?: ModelBooleanInput | null,
  indexType?: ModelIndexTypeInput | null,
  baseYear?: ModelFloatInput | null,
  baseIndexType?: ModelBaseIndexTypeInput | null,
  baseIndexDate?: ModelStringInput | null,
  nextIndexationMonth?: ModelStringInput | null,
  nextIndexation?: ModelBooleanInput | null,
  leaseId?: ModelIDInput | null,
  mainUnit?: ModelBooleanInput | null,
  rentalPrice?: ModelFloatInput | null,
  signatureDate?: ModelStringInput | null,
  startDate?: ModelStringInput | null,
  unitId?: ModelIDInput | null,
  readers?: ModelIDInput | null,
  readId?: ModelIDInput | null,
  clientId?: ModelIDInput | null,
  and?: Array< ModelUnitLeaseConditionInput | null > | null,
  or?: Array< ModelUnitLeaseConditionInput | null > | null,
  not?: ModelUnitLeaseConditionInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelIndexTypeInput = {
  eq?: IndexType | null,
  ne?: IndexType | null,
};

export type ModelBaseIndexTypeInput = {
  eq?: BaseIndexType | null,
  ne?: BaseIndexType | null,
};

export type UpdateUnitLeaseInput = {
  id: string,
  allowChargeAdjustment?: boolean | null,
  authorizeProfessionalActivity?: boolean | null,
  chargesIndexation?: boolean | null,
  createdAt?: string | null,
  endDate?: string | null,
  furnishedRental?: boolean | null,
  furnishedRentalInsuranceByTenant?: boolean | null,
  furnishedRentalRentalPricePercentage?: number | null,
  initialRentalPrice?: number | null,
  indexation?: boolean | null,
  advancedIndexation?: boolean | null,
  indexType?: IndexType | null,
  baseYear?: number | null,
  baseIndexType?: BaseIndexType | null,
  baseIndexDate?: string | null,
  nextIndexationMonth?: string | null,
  nextIndexation?: boolean | null,
  leaseId?: string | null,
  mainUnit?: boolean | null,
  rentalPrice?: number | null,
  signatureDate?: string | null,
  startDate?: string | null,
  unitId?: string | null,
  readers?: Array< string > | null,
  readId?: string | null,
  clientId?: string | null,
  _version?: number | null,
};

export type DeleteUnitLeaseInput = {
  id: string,
  _version?: number | null,
};

export type CreateUnitOwnerInput = {
  id?: string | null,
  disabled?: boolean | null,
  ownerId: string,
  periodFrom?: string | null,
  periodTo?: string | null,
  stake: number,
  unitId: string,
  readers?: Array< string > | null,
  readId: string,
  clientId: string,
  _version?: number | null,
};

export type ModelUnitOwnerConditionInput = {
  disabled?: ModelBooleanInput | null,
  ownerId?: ModelIDInput | null,
  periodFrom?: ModelStringInput | null,
  periodTo?: ModelStringInput | null,
  stake?: ModelFloatInput | null,
  unitId?: ModelIDInput | null,
  readers?: ModelIDInput | null,
  readId?: ModelIDInput | null,
  clientId?: ModelIDInput | null,
  and?: Array< ModelUnitOwnerConditionInput | null > | null,
  or?: Array< ModelUnitOwnerConditionInput | null > | null,
  not?: ModelUnitOwnerConditionInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type UpdateUnitOwnerInput = {
  id: string,
  disabled?: boolean | null,
  ownerId?: string | null,
  periodFrom?: string | null,
  periodTo?: string | null,
  stake?: number | null,
  unitId?: string | null,
  readers?: Array< string > | null,
  readId?: string | null,
  clientId?: string | null,
  _version?: number | null,
};

export type DeleteUnitOwnerInput = {
  id: string,
  _version?: number | null,
};

export type CreateTeamInput = {
  id?: string | null,
  name: string,
  parentId?: string | null,
  readId: string,
  clientId: string,
  _version?: number | null,
};

export type ModelTeamConditionInput = {
  name?: ModelStringInput | null,
  parentId?: ModelIDInput | null,
  readId?: ModelIDInput | null,
  clientId?: ModelIDInput | null,
  and?: Array< ModelTeamConditionInput | null > | null,
  or?: Array< ModelTeamConditionInput | null > | null,
  not?: ModelTeamConditionInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type UpdateTeamInput = {
  id: string,
  name?: string | null,
  parentId?: string | null,
  readId?: string | null,
  clientId?: string | null,
  _version?: number | null,
};

export type DeleteTeamInput = {
  id: string,
  _version?: number | null,
};

export type CreateUserInput = {
  id?: string | null,
  email: string,
  firstName?: string | null,
  lastName?: string | null,
  cognitoSub?: string | null,
  googleSub?: string | null,
  facebookSub?: string | null,
  rootUser?: boolean | null,
  refreshToken?: boolean | null,
  userRoleId?: string | null,
  contactId?: string | null,
  status: UserStatus,
  readId: string,
  clientId: string,
  _ttl?: number | null,
  _version?: number | null,
};

export type ModelUserConditionInput = {
  email?: ModelStringInput | null,
  firstName?: ModelStringInput | null,
  lastName?: ModelStringInput | null,
  cognitoSub?: ModelIDInput | null,
  googleSub?: ModelIDInput | null,
  facebookSub?: ModelIDInput | null,
  rootUser?: ModelBooleanInput | null,
  refreshToken?: ModelBooleanInput | null,
  userRoleId?: ModelIDInput | null,
  contactId?: ModelIDInput | null,
  status?: ModelUserStatusInput | null,
  readId?: ModelIDInput | null,
  clientId?: ModelIDInput | null,
  _ttl?: ModelIntInput | null,
  and?: Array< ModelUserConditionInput | null > | null,
  or?: Array< ModelUserConditionInput | null > | null,
  not?: ModelUserConditionInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelUserStatusInput = {
  eq?: UserStatus | null,
  ne?: UserStatus | null,
};

export type UpdateUserInput = {
  id: string,
  email?: string | null,
  firstName?: string | null,
  lastName?: string | null,
  cognitoSub?: string | null,
  googleSub?: string | null,
  facebookSub?: string | null,
  rootUser?: boolean | null,
  refreshToken?: boolean | null,
  userRoleId?: string | null,
  contactId?: string | null,
  status?: UserStatus | null,
  readId?: string | null,
  clientId?: string | null,
  _ttl?: number | null,
  _version?: number | null,
};

export type DeleteUserInput = {
  id: string,
  _version?: number | null,
};

export type CreateUserRoleInput = {
  id?: string | null,
  name: string,
  userRights?: Array< UserRightInput > | null,
  readId: string,
  clientId: string,
  _version?: number | null,
};

export type UserRightInput = {
  access?: Array< UserRightAccessType > | null,
  section: UserRightSection,
};

export type ModelUserRoleConditionInput = {
  name?: ModelStringInput | null,
  readId?: ModelIDInput | null,
  clientId?: ModelIDInput | null,
  and?: Array< ModelUserRoleConditionInput | null > | null,
  or?: Array< ModelUserRoleConditionInput | null > | null,
  not?: ModelUserRoleConditionInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type UpdateUserRoleInput = {
  id: string,
  name?: string | null,
  userRights?: Array< UserRightInput > | null,
  readId?: string | null,
  clientId?: string | null,
  _version?: number | null,
};

export type DeleteUserRoleInput = {
  id: string,
  _version?: number | null,
};

export type CreateUserTeamInput = {
  id?: string | null,
  userId: string,
  teamId: string,
  readId: string,
  clientId: string,
  _version?: number | null,
};

export type ModelUserTeamConditionInput = {
  userId?: ModelIDInput | null,
  teamId?: ModelIDInput | null,
  readId?: ModelIDInput | null,
  clientId?: ModelIDInput | null,
  and?: Array< ModelUserTeamConditionInput | null > | null,
  or?: Array< ModelUserTeamConditionInput | null > | null,
  not?: ModelUserTeamConditionInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type UpdateUserTeamInput = {
  id: string,
  userId?: string | null,
  teamId?: string | null,
  readId?: string | null,
  clientId?: string | null,
  _version?: number | null,
};

export type DeleteUserTeamInput = {
  id: string,
  _version?: number | null,
};

export type CreateValuationInput = {
  id?: string | null,
  sourceType?: ValuationSourceType | null,
  valorization: number,
  date: string,
  unitId?: string | null,
  buildingId?: string | null,
  writers?: Array< string > | null,
  readId: string,
  clientId: string,
  _version?: number | null,
};

export enum ValuationSourceType {
  MANUAL = "MANUAL",
  PROFESSIONAL = "PROFESSIONAL",
}

export type ModelValuationConditionInput = {
  sourceType?: ModelValuationSourceTypeInput | null,
  valorization?: ModelFloatInput | null,
  date?: ModelStringInput | null,
  unitId?: ModelIDInput | null,
  buildingId?: ModelIDInput | null,
  writers?: ModelIDInput | null,
  readId?: ModelIDInput | null,
  clientId?: ModelIDInput | null,
  and?: Array< ModelValuationConditionInput | null > | null,
  or?: Array< ModelValuationConditionInput | null > | null,
  not?: ModelValuationConditionInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelValuationSourceTypeInput = {
  eq?: ValuationSourceType | null,
  ne?: ValuationSourceType | null,
};

export type ValuationDTO = {
  __typename: "Valuation",
  id: string,
  sourceType?: ValuationSourceType | null,
  valorization: number,
  date: string,
  unitId?: string | null,
  unit?: UnitDTO | null,
  buildingId?: string | null,
  building?: BuildingDTO | null,
  writers?: Array< string > | null,
  readId: string,
  clientId: string,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type UpdateValuationInput = {
  id: string,
  sourceType?: ValuationSourceType | null,
  valorization?: number | null,
  date?: string | null,
  unitId?: string | null,
  buildingId?: string | null,
  writers?: Array< string > | null,
  readId?: string | null,
  clientId?: string | null,
  _version?: number | null,
};

export type DeleteValuationInput = {
  id: string,
  _version?: number | null,
};

export type CreateVariousOperationInput = {
  id?: string | null,
  amount: number,
  labels?: Array< CustomLabelInput > | null,
  numberOfMonths?: number | null,
  operationType: LeaseVariousOperationType,
  paymentFrequency: LeasePaymentFrequency,
  type: VariousOperationType,
  readId: string,
  clientId: string,
  _version?: number | null,
};

export type ModelVariousOperationConditionInput = {
  amount?: ModelFloatInput | null,
  numberOfMonths?: ModelIntInput | null,
  operationType?: ModelLeaseVariousOperationTypeInput | null,
  paymentFrequency?: ModelLeasePaymentFrequencyInput | null,
  type?: ModelVariousOperationTypeInput | null,
  readId?: ModelIDInput | null,
  clientId?: ModelIDInput | null,
  and?: Array< ModelVariousOperationConditionInput | null > | null,
  or?: Array< ModelVariousOperationConditionInput | null > | null,
  not?: ModelVariousOperationConditionInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type VariousOperationDTO = {
  __typename: "VariousOperation",
  id: string,
  amount: number,
  labels?:  Array<CustomLabelDTO > | null,
  numberOfMonths?: number | null,
  operationType: LeaseVariousOperationType,
  paymentFrequency: LeasePaymentFrequency,
  type: VariousOperationType,
  readId: string,
  clientId: string,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type UpdateVariousOperationInput = {
  id: string,
  amount?: number | null,
  labels?: Array< CustomLabelInput > | null,
  numberOfMonths?: number | null,
  operationType?: LeaseVariousOperationType | null,
  paymentFrequency?: LeasePaymentFrequency | null,
  type?: VariousOperationType | null,
  readId?: string | null,
  clientId?: string | null,
  _version?: number | null,
};

export type DeleteVariousOperationInput = {
  id: string,
  _version?: number | null,
};

export type ModelAccountLabelFilterInput = {
  id?: ModelIDInput | null,
  bankAccountId?: ModelIDInput | null,
  contactId?: ModelIDInput | null,
  class?: ModelIntInput | null,
  customUsage?: ModelAccountLabelCustomUsageInput | null,
  disabled?: ModelBooleanInput | null,
  hoaFundId?: ModelIDInput | null,
  ownerId?: ModelIDInput | null,
  topClass?: ModelIntInput | null,
  readId?: ModelIDInput | null,
  clientId?: ModelIDInput | null,
  vatNonDeductiblePercentage?: ModelFloatInput | null,
  and?: Array< ModelAccountLabelFilterInput | null > | null,
  or?: Array< ModelAccountLabelFilterInput | null > | null,
  not?: ModelAccountLabelFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelAccountLabelConnection = {
  __typename: "ModelAccountLabelConnection",
  items:  Array<AccountLabelDTO | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelPostingFilterInput = {
  id?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  class?: ModelIntInput | null,
  customLabel?: ModelStringInput | null,
  topClass?: ModelIntInput | null,
  type?: ModelPostingTypeInput | null,
  totalAmount?: ModelFloatInput | null,
  periodFrom?: ModelStringInput | null,
  periodTo?: ModelStringInput | null,
  buildingId?: ModelIDInput | null,
  unitId?: ModelIDInput | null,
  invoiceId?: ModelIDInput | null,
  chargeId?: ModelIDInput | null,
  transactionId?: ModelIDInput | null,
  leaseId?: ModelIDInput | null,
  bankAccountId?: ModelIDInput | null,
  accountLabelId?: ModelIDInput | null,
  contactId?: ModelIDInput | null,
  leaseVariousOperationId?: ModelIDInput | null,
  statementId?: ModelIDInput | null,
  amountVatExcluded?: ModelFloatInput | null,
  vatAmount?: ModelFloatInput | null,
  vatRateId?: ModelIDInput | null,
  vatRateValue?: ModelFloatInput | null,
  foreignId?: ModelIDInput | null,
  foreignType?: ModelPostingForeignTypeInput | null,
  invoicePostingId?: ModelIDInput | null,
  reconciledAt?: ModelStringInput | null,
  status?: ModelPostingStatusInput | null,
  chargeOwnerRepartition?: ModelFloatInput | null,
  chargeRepartitionMetric?: ModelStringInput | null,
  chargeRepartitionValue?: ModelFloatInput | null,
  chargeSplitNumber?: ModelIntInput | null,
  chargeType?: ModelPostingChargeTypeInput | null,
  provisional?: ModelBooleanInput | null,
  flaggedAt?: ModelStringInput | null,
  carriedForward?: ModelBooleanInput | null,
  readers?: ModelIDInput | null,
  readId?: ModelIDInput | null,
  clientId?: ModelIDInput | null,
  and?: Array< ModelPostingFilterInput | null > | null,
  or?: Array< ModelPostingFilterInput | null > | null,
  not?: ModelPostingFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelBankAccountFilterInput = {
  id?: ModelIDInput | null,
  contactId?: ModelIDInput | null,
  number?: ModelStringInput | null,
  bicNumber?: ModelStringInput | null,
  bankName?: ModelStringInput | null,
  contactIds?: ModelIDInput | null,
  buildingIds?: ModelIDInput | null,
  holderName?: ModelStringInput | null,
  label?: ModelStringInput | null,
  disabled?: ModelBooleanInput | null,
  integrations?: ModelIntegrationNameListInput | null,
  matchingRule?: ModelBankAccountMatchingRuleInput | null,
  balance?: ModelFloatInput | null,
  balanceDate?: ModelStringInput | null,
  type?: ModelBankAccountTypeInput | null,
  readers?: ModelIDInput | null,
  readId?: ModelIDInput | null,
  clientId?: ModelIDInput | null,
  and?: Array< ModelBankAccountFilterInput | null > | null,
  or?: Array< ModelBankAccountFilterInput | null > | null,
  not?: ModelBankAccountFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelBankAccountConnection = {
  __typename: "ModelBankAccountConnection",
  items:  Array<BankAccountDTO | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelTransactionFilterInput = {
  id?: ModelIDInput | null,
  status?: ModelTransactionStatusInput | null,
  snoozedUntil?: ModelStringInput | null,
  sequence?: ModelFloatInput | null,
  statementDate?: ModelStringInput | null,
  operationDate?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  remittanceInformationType?: ModelRemittanceTypeInput | null,
  remittanceInformation?: ModelStringInput | null,
  remittanceInformationRaw?: ModelStringInput | null,
  additionalInformation?: ModelStringInput | null,
  structuredCommunication?: ModelStringInput | null,
  bankTransactionCode?: ModelStringInput | null,
  proprietaryBankTransactionCode?: ModelStringInput | null,
  endToEndId?: ModelStringInput | null,
  mandateId?: ModelStringInput | null,
  creditorId?: ModelStringInput | null,
  purposeCode?: ModelStringInput | null,
  internalReference?: ModelStringInput | null,
  comment?: ModelStringInput | null,
  exclusionReason?: ModelTransactionExclusionReasonInput | null,
  exclusionComment?: ModelStringInput | null,
  excludedAt?: ModelStringInput | null,
  excludedBy?: ModelIDInput | null,
  amount?: ModelFloatInput | null,
  bankAccountId?: ModelIDInput | null,
  counterpartName?: ModelStringInput | null,
  counterpartDisplayName?: ModelStringInput | null,
  counterpartAccountNumber?: ModelStringInput | null,
  origin?: ModelTransactionOriginInput | null,
  sourceChannel?: ModelTransactionSourceChannelInput | null,
  nativeTransactionId?: ModelStringInput | null,
  fingerprint?: ModelStringInput | null,
  linkedSourceChannels?: ModelTransactionSourceChannelInput | null,
  proposedLeaseId?: ModelIDInput | null,
  proposedUnitId?: ModelIDInput | null,
  proposedContractorId?: ModelIDInput | null,
  proposedOwnerId?: ModelIDInput | null,
  proposedMatch?: ModelIntInput | null,
  classification?: ModelTransactionFlowTypeInput | null,
  classificationConfidence?: ModelIntInput | null,
  classificationReason?: ModelTransactionClassificationReasonInput | null,
  updatedAt?: ModelStringInput | null,
  readers?: ModelIDInput | null,
  readId?: ModelIDInput | null,
  clientId?: ModelIDInput | null,
  and?: Array< ModelTransactionFilterInput | null > | null,
  or?: Array< ModelTransactionFilterInput | null > | null,
  not?: ModelTransactionFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelTransactionConnection = {
  __typename: "ModelTransactionConnection",
  items:  Array<TransactionDTO | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelTransactionRuleFilterInput = {
  id?: ModelIDInput | null,
  isFullRemittance?: ModelBooleanInput | null,
  remittanceInformation?: ModelStringInput | null,
  counterpartName?: ModelStringInput | null,
  counterpartAccountNumber?: ModelStringInput | null,
  usedFields?: ModelStringInput | null,
  exclude?: ModelBooleanInput | null,
  leaseId?: ModelIDInput | null,
  unitId?: ModelIDInput | null,
  contractorId?: ModelIDInput | null,
  ownerId?: ModelIDInput | null,
  readId?: ModelIDInput | null,
  clientId?: ModelIDInput | null,
  and?: Array< ModelTransactionRuleFilterInput | null > | null,
  or?: Array< ModelTransactionRuleFilterInput | null > | null,
  not?: ModelTransactionRuleFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelTransactionRuleConnection = {
  __typename: "ModelTransactionRuleConnection",
  items:  Array<TransactionRuleDTO | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelVatRateKindInput = {
  eq?: VatRateKind | null,
  ne?: VatRateKind | null,
};

export type ModelSupplierPaymentModeInput = {
  eq?: SupplierPaymentMode | null,
  ne?: SupplierPaymentMode | null,
};

export type ModelVatRateFilterInput = {
  id?: ModelIDInput | null,
  country?: ModelStringInput | null,
  label?: ModelStringInput | null,
  value?: ModelFloatInput | null,
  ownerId?: ModelIDInput | null,
  readId?: ModelIDInput | null,
  clientId?: ModelIDInput | null,
  vatKind?: ModelVatRateKindInput | null,
  and?: Array< ModelVatRateFilterInput | null > | null,
  or?: Array< ModelVatRateFilterInput | null > | null,
  not?: ModelVatRateFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelVatRateConnection = {
  __typename: "ModelVatRateConnection",
  items:  Array<VatRateDTO | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelAdvertisementFilterInput = {
  id?: ModelIDInput | null,
  type?: ModelAdvertisementUnitTypeInput | null,
  subType?: ModelAdvertisementUnitSubTypeInput | null,
  amenities?: ModelAmenitiesTypeListInput | null,
  amountOfFacades?: ModelIntInput | null,
  availabilityDate?: ModelStringInput | null,
  certificateOfConformity?: ModelCertificateOfConformityTypeInput | null,
  citationForPlanningOffence?: ModelBooleanInput | null,
  delimitedZone?: ModelDelimitedZoneTypeInput | null,
  floodProneArea?: ModelFloodProneAreaTypeInput | null,
  furnished?: ModelBooleanInput | null,
  firstOccupancy?: ModelBooleanInput | null,
  gardenSurface?: ModelFloatInput | null,
  heatingAmenities?: ModelHeatingAmenitiesListInput | null,
  heatingType?: ModelHeatingTypeInput | null,
  landTerrain?: ModelLandTerrainTypeListInput | null,
  landArea?: ModelFloatInput | null,
  length?: ModelFloatInput | null,
  planningPermission?: ModelBooleanInput | null,
  publishCadastralIncome?: ModelBooleanInput | null,
  resort?: ModelBooleanInput | null,
  rightOfPreemption?: ModelBooleanInput | null,
  subdivisionAuthorization?: ModelBooleanInput | null,
  wheelChairAccessible?: ModelBooleanInput | null,
  width?: ModelFloatInput | null,
  terraceSurface?: ModelFloatInput | null,
  readId?: ModelIDInput | null,
  clientId?: ModelIDInput | null,
  and?: Array< ModelAdvertisementFilterInput | null > | null,
  or?: Array< ModelAdvertisementFilterInput | null > | null,
  not?: ModelAdvertisementFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelAdvertisementConnection = {
  __typename: "ModelAdvertisementConnection",
  items:  Array<AdvertisementDTO | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelAgencyRateFilterInput = {
  id?: ModelIDInput | null,
  amountMinimumFees?: ModelFloatInput | null,
  custom?: ModelBooleanInput | null,
  feesAppliedTo?: ModelAgencyRateFeesTypeInput | null,
  includedInAmount?: ModelAgencyRateIncludedAmountListInput | null,
  name?: ModelStringInput | null,
  repartitionType?: ModelAgencyRateRepartitionTypeInput | null,
  type?: ModelAgencyRateTypeInput | null,
  unitType?: ModelUnitTypeInput | null,
  vatRateId?: ModelIDInput | null,
  unitIds?: ModelIDInput | null,
  readId?: ModelIDInput | null,
  clientId?: ModelIDInput | null,
  and?: Array< ModelAgencyRateFilterInput | null > | null,
  or?: Array< ModelAgencyRateFilterInput | null > | null,
  not?: ModelAgencyRateFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelAgencyRateConnection = {
  __typename: "ModelAgencyRateConnection",
  items:  Array<AgencyRateDTO | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelAgencyRateOwnerFilterInput = {
  id?: ModelIDInput | null,
  agencyRateId?: ModelIDInput | null,
  contactId?: ModelIDInput | null,
  readId?: ModelIDInput | null,
  clientId?: ModelIDInput | null,
  and?: Array< ModelAgencyRateOwnerFilterInput | null > | null,
  or?: Array< ModelAgencyRateOwnerFilterInput | null > | null,
  not?: ModelAgencyRateOwnerFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelAgencyRateStatementFilterInput = {
  id?: ModelIDInput | null,
  agencyRateId?: ModelIDInput | null,
  statementId?: ModelIDInput | null,
  totalAmountRateable?: ModelFloatInput | null,
  totalFixedAmount?: ModelFloatInput | null,
  readId?: ModelIDInput | null,
  clientId?: ModelIDInput | null,
  and?: Array< ModelAgencyRateStatementFilterInput | null > | null,
  or?: Array< ModelAgencyRateStatementFilterInput | null > | null,
  not?: ModelAgencyRateStatementFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelBillingItemFilterInput = {
  id?: ModelIDInput | null,
  name?: ModelStringInput | null,
  baseAmount?: ModelIntInput | null,
  billingType?: ModelInvoiceBillingTypeInput | null,
  amountCalculationType?: ModelInvoiceAmountCalculationTypeInput | null,
  percentageBase?: ModelInvoicePercentageBaseInput | null,
  period?: ModelLeasePaymentFrequencyInput | null,
  vatRateId?: ModelIDInput | null,
  invoiceId?: ModelIDInput | null,
  quantity?: ModelFloatInput | null,
  percentage?: ModelFloatInput | null,
  allocationOption?: ModelBillingItemAllocationOptionInput | null,
  multipleUnitsSplit?: ModelBillingItemMultipleUnitsSplitOptionInput | null,
  leaseIds?: ModelIDInput | null,
  unitIds?: ModelIDInput | null,
  buildingIds?: ModelIDInput | null,
  accountLabelId?: ModelIDInput | null,
  readId?: ModelIDInput | null,
  clientId?: ModelIDInput | null,
  and?: Array< ModelBillingItemFilterInput | null > | null,
  or?: Array< ModelBillingItemFilterInput | null > | null,
  not?: ModelBillingItemFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelBillingItemConnection = {
  __typename: "ModelBillingItemConnection",
  items:  Array<BillingItemDTO | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelBuildingFilterInput = {
  id?: ModelIDInput | null,
  name?: ModelStringInput | null,
  addressId?: ModelIDInput | null,
  acquisitionValue?: ModelFloatInput | null,
  acquisitionAdditionalCostsValue?: ModelFloatInput | null,
  acquisitionAdvertisedValue?: ModelFloatInput | null,
  amountOfFacades?: ModelIntInput | null,
  amountOfFloors?: ModelIntInput | null,
  amountOfHousings?: ModelIntInput | null,
  buildingState?: ModelBuildingStateInput | null,
  cadastralIncome?: ModelFloatInput | null,
  constructionYear?: ModelStringInput | null,
  janitor?: ModelBooleanInput | null,
  jointOwnershipId?: ModelIDInput | null,
  notes?: ModelStringInput | null,
  propertyTax?: ModelFloatInput | null,
  residenceName?: ModelStringInput | null,
  buildingSiteId?: ModelIDInput | null,
  readers?: ModelIDInput | null,
  teams?: ModelIDInput | null,
  readId?: ModelIDInput | null,
  clientId?: ModelIDInput | null,
  and?: Array< ModelBuildingFilterInput | null > | null,
  or?: Array< ModelBuildingFilterInput | null > | null,
  not?: ModelBuildingFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelBuildingEventFilterInput = {
  id?: ModelIDInput | null,
  buildingId?: ModelIDInput | null,
  type?: ModelStringInput | null,
  startDate?: ModelStringInput | null,
  endDate?: ModelStringInput | null,
  totalCost?: ModelFloatInput | null,
  note?: ModelStringInput | null,
  writers?: ModelIDInput | null,
  readId?: ModelIDInput | null,
  clientId?: ModelIDInput | null,
  and?: Array< ModelBuildingEventFilterInput | null > | null,
  or?: Array< ModelBuildingEventFilterInput | null > | null,
  not?: ModelBuildingEventFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelBuildingOwnerFilterInput = {
  id?: ModelIDInput | null,
  buildingId?: ModelIDInput | null,
  contactId?: ModelIDInput | null,
  disabled?: ModelBooleanInput | null,
  periodFrom?: ModelStringInput | null,
  periodTo?: ModelStringInput | null,
  stake?: ModelFloatInput | null,
  readers?: ModelIDInput | null,
  readId?: ModelIDInput | null,
  clientId?: ModelIDInput | null,
  and?: Array< ModelBuildingOwnerFilterInput | null > | null,
  or?: Array< ModelBuildingOwnerFilterInput | null > | null,
  not?: ModelBuildingOwnerFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelBuildingSiteFilterInput = {
  id?: ModelIDInput | null,
  name?: ModelStringInput | null,
  readers?: ModelIDInput | null,
  teams?: ModelIDInput | null,
  readId?: ModelIDInput | null,
  clientId?: ModelIDInput | null,
  and?: Array< ModelBuildingSiteFilterInput | null > | null,
  or?: Array< ModelBuildingSiteFilterInput | null > | null,
  not?: ModelBuildingSiteFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelBuildingSiteConnection = {
  __typename: "ModelBuildingSiteConnection",
  items:  Array<BuildingSiteDTO | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelChargeFilterInput = {
  id?: ModelIDInput | null,
  status?: ModelChargeStatusInput | null,
  invoiceDate?: ModelStringInput | null,
  paymentDueDate?: ModelStringInput | null,
  archivedDate?: ModelStringInput | null,
  periodFrom?: ModelStringInput | null,
  periodTo?: ModelStringInput | null,
  totalAmount?: ModelFloatInput | null,
  payableAmount?: ModelFloatInput | null,
  source?: ModelChargeSourceInput | null,
  draftFromOcr?: ModelBooleanInput | null,
  accountingDocumentId?: ModelIDInput | null,
  paid?: ModelBooleanInput | null,
  remittanceInformation?: ModelStringInput | null,
  note?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  creatorEmail?: ModelStringInput | null,
  createdById?: ModelIDInput | null,
  contractorId?: ModelIDInput | null,
  recipientId?: ModelIDInput | null,
  documentId?: ModelIDInput | null,
  readId?: ModelIDInput | null,
  clientId?: ModelIDInput | null,
  openChargeClientId?: ModelIDInput | null,
  and?: Array< ModelChargeFilterInput | null > | null,
  or?: Array< ModelChargeFilterInput | null > | null,
  not?: ModelChargeFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelChargeConnection = {
  __typename: "ModelChargeConnection",
  items:  Array<ChargeDTO | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelChargeStatementFilterInput = {
  id?: ModelIDInput | null,
  chargeId?: ModelIDInput | null,
  statementId?: ModelIDInput | null,
  readId?: ModelIDInput | null,
  clientId?: ModelIDInput | null,
  and?: Array< ModelChargeStatementFilterInput | null > | null,
  or?: Array< ModelChargeStatementFilterInput | null > | null,
  not?: ModelChargeStatementFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelRepartitionKeyFilterInput = {
  id?: ModelIDInput | null,
  name?: ModelStringInput | null,
  type?: ModelRepartitionKeyTypeInput | null,
  accountLabelId?: ModelIDInput | null,
  buildingId?: ModelIDInput | null,
  buildingSiteId?: ModelIDInput | null,
  ownerRepartition?: ModelFloatInput | null,
  tenantRepartition?: ModelFloatInput | null,
  repartitionMetric?: ModelStringInput | null,
  technics?: ModelIDInput | null,
  readId?: ModelIDInput | null,
  clientId?: ModelIDInput | null,
  and?: Array< ModelRepartitionKeyFilterInput | null > | null,
  or?: Array< ModelRepartitionKeyFilterInput | null > | null,
  not?: ModelRepartitionKeyFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelRepartitionKeyConnection = {
  __typename: "ModelRepartitionKeyConnection",
  items:  Array<RepartitionKeyDTO | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelClientFilterInput = {
  id?: ModelIDInput | null,
  accountType?: ModelAccountTypeInput | null,
  contactId?: ModelIDInput | null,
  generalConditionsAcceptDate?: ModelStringInput | null,
  lastGeneralConditionsAcceptedVersion?: ModelStringInput | null,
  GDPRAcceptDate?: ModelStringInput | null,
  lastGDPRAcceptedVersion?: ModelStringInput | null,
  and?: Array< ModelClientFilterInput | null > | null,
  or?: Array< ModelClientFilterInput | null > | null,
  not?: ModelClientFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelClientConnection = {
  __typename: "ModelClientConnection",
  items:  Array<ClientDTO | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelCommunicationFilterInput = {
  id?: ModelIDInput | null,
  addressId?: ModelIDInput | null,
  body?: ModelStringInput | null,
  buildingId?: ModelStringInput | null,
  channel?: ModelCommunicationChannelInput | null,
  communicationTemplateId?: ModelIDInput | null,
  concernedContactIds?: ModelIDInput | null,
  contactId?: ModelIDInput | null,
  contactIds?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  expirationDate?: ModelStringInput | null,
  invoiceId?: ModelIDInput | null,
  leaseId?: ModelIDInput | null,
  leasePriceHistoryId?: ModelIDInput | null,
  letterTrackingCode?: ModelStringInput | null,
  letterTrackingProvider?: ModelTrackingProviderInput | null,
  linkedCommunicationsIds?: ModelIDInput | null,
  supportingDocumentFileIds?: ModelIDInput | null,
  recipient?: ModelStringInput | null,
  recipientContactIdsInBcc?: ModelIDInput | null,
  recipientContactIdsInCc?: ModelIDInput | null,
  recipientInBcc?: ModelStringInput | null,
  recipientInCc?: ModelStringInput | null,
  scheduledAt?: ModelStringInput | null,
  deliveredAt?: ModelStringInput | null,
  errorCode?: ModelCommunicationErrorCodeInput | null,
  nextRetryAt?: ModelStringInput | null,
  sendRetryCount?: ModelIntInput | null,
  sender?: ModelStringInput | null,
  sentAt?: ModelStringInput | null,
  externalId?: ModelIDInput | null,
  externalStatus?: ModelStringInput | null,
  signatureDocumentId?: ModelIDInput | null,
  snoozedDate?: ModelStringInput | null,
  statementId?: ModelIDInput | null,
  status?: ModelCommunicationStatusInput | null,
  subject?: ModelStringInput | null,
  toSend?: ModelBooleanInput | null,
  hideLogo?: ModelBooleanInput | null,
  type?: ModelCommunicationTypeInput | null,
  _ttl?: ModelIntInput | null,
  unitId?: ModelIDInput | null,
  readId?: ModelIDInput | null,
  readers?: ModelIDInput | null,
  clientId?: ModelIDInput | null,
  and?: Array< ModelCommunicationFilterInput | null > | null,
  or?: Array< ModelCommunicationFilterInput | null > | null,
  not?: ModelCommunicationFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelCommunicationConnection = {
  __typename: "ModelCommunicationConnection",
  items:  Array<CommunicationDTO | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelCommunicationSettingsProfileFilterInput = {
  id?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  defaultName?: ModelStringInput | null,
  isDefaultSetting?: ModelBooleanInput | null,
  referent?: ModelCommunicationSettingsProfileReferentInput | null,
  replacementId?: ModelIDInput | null,
  displayLogo?: ModelBooleanInput | null,
  tenantStatementView?: ModelStatementViewTypeInput | null,
  readId?: ModelIDInput | null,
  readers?: ModelIDInput | null,
  clientId?: ModelIDInput | null,
  and?: Array< ModelCommunicationSettingsProfileFilterInput | null > | null,
  or?: Array< ModelCommunicationSettingsProfileFilterInput | null > | null,
  not?: ModelCommunicationSettingsProfileFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelCommunicationSettingsProfileConnection = {
  __typename: "ModelCommunicationSettingsProfileConnection",
  items:  Array<CommunicationSettingsProfileDTO | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelTemplateFilterInput = {
  id?: ModelIDInput | null,
  language?: ModelStringInput | null,
  name?: ModelStringInput | null,
  subject?: ModelStringInput | null,
  subjectRawFormat?: ModelStringInput | null,
  body?: ModelStringInput | null,
  bodyRawFormat?: ModelStringInput | null,
  type?: ModelTemplateTypeInput | null,
  subType?: ModelTemplateSubTypeInput | null,
  readId?: ModelIDInput | null,
  clientId?: ModelIDInput | null,
  and?: Array< ModelTemplateFilterInput | null > | null,
  or?: Array< ModelTemplateFilterInput | null > | null,
  not?: ModelTemplateFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelTemplateConnection = {
  __typename: "ModelTemplateConnection",
  items:  Array<TemplateDTO | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelContactFilterInput = {
  id?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  firstName?: ModelStringInput | null,
  lastName?: ModelStringInput | null,
  companyName?: ModelStringInput | null,
  commercialName?: ModelStringInput | null,
  communicationSettingsProfileId?: ModelIDInput | null,
  businessNumber?: ModelStringInput | null,
  types?: ModelContactTypeInput | null,
  vat?: ModelStringInput | null,
  email?: ModelStringInput | null,
  birthDate?: ModelStringInput | null,
  birthPlace?: ModelStringInput | null,
  nationalRegister?: ModelStringInput | null,
  ipiNumber?: ModelStringInput | null,
  insuranceCompany?: ModelStringInput | null,
  insuranceContractNumber?: ModelStringInput | null,
  judicialDistrict?: ModelStringInput | null,
  civility?: ModelCivilityTypeInput | null,
  addressId?: ModelIDInput | null,
  language?: ModelStringInput | null,
  notes?: ModelStringInput | null,
  profileType?: ModelContactProfileTypeInput | null,
  agencyRateDisabled?: ModelBooleanInput | null,
  attachStatementSupportingDocuments?: ModelBooleanInput | null,
  supplierPaymentMode?: ModelSupplierPaymentModeInput | null,
  status?: ModelContactStatusInput | null,
  sendInvitation?: ModelBooleanInput | null,
  readers?: ModelIDInput | null,
  readId?: ModelIDInput | null,
  clientId?: ModelIDInput | null,
  and?: Array< ModelContactFilterInput | null > | null,
  or?: Array< ModelContactFilterInput | null > | null,
  not?: ModelContactFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelContactConnection = {
  __typename: "ModelContactConnection",
  items:  Array<ContactDTO | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelAddressFilterInput = {
  id?: ModelIDInput | null,
  status?: ModelAddressStatusInput | null,
  street?: ModelStringInput | null,
  number?: ModelStringInput | null,
  box?: ModelStringInput | null,
  postalCode?: ModelStringInput | null,
  city?: ModelStringInput | null,
  region?: ModelStringInput | null,
  country?: ModelStringInput | null,
  latitude?: ModelFloatInput | null,
  longitude?: ModelFloatInput | null,
  readers?: ModelIDInput | null,
  readId?: ModelIDInput | null,
  clientId?: ModelIDInput | null,
  and?: Array< ModelAddressFilterInput | null > | null,
  or?: Array< ModelAddressFilterInput | null > | null,
  not?: ModelAddressFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelAddressConnection = {
  __typename: "ModelAddressConnection",
  items:  Array<AddressDTO | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelCustomFieldFilterInput = {
  id?: ModelIDInput | null,
  fieldName?: ModelStringInput | null,
  fieldType?: ModelCustomFieldTypeInput | null,
  foreignKey?: ModelIDInput | null,
  foreignTableName?: ModelStringInput | null,
  order?: ModelIntInput | null,
  readId?: ModelIDInput | null,
  clientId?: ModelIDInput | null,
  and?: Array< ModelCustomFieldFilterInput | null > | null,
  or?: Array< ModelCustomFieldFilterInput | null > | null,
  not?: ModelCustomFieldFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelCustomSubscriptionFilterInput = {
  id?: ModelIDInput | null,
  name?: ModelCustomSubscriptionTypeInput | null,
  value?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  userId?: ModelIDInput | null,
  _ttl?: ModelIntInput | null,
  updatedAt?: ModelStringInput | null,
  clientId?: ModelIDInput | null,
  and?: Array< ModelCustomSubscriptionFilterInput | null > | null,
  or?: Array< ModelCustomSubscriptionFilterInput | null > | null,
  not?: ModelCustomSubscriptionFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelCustomSubscriptionConnection = {
  __typename: "ModelCustomSubscriptionConnection",
  items:  Array<CustomSubscriptionDTO | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelEntityRelationFilterInput = {
  id?: ModelIDInput | null,
  sourceId?: ModelIDInput | null,
  sourceTableName?: ModelStringInput | null,
  foreignId?: ModelIDInput | null,
  foreignTableName?: ModelStringInput | null,
  linkDescription?: ModelStringInput | null,
  clientId?: ModelIDInput | null,
  readers?: ModelIDInput | null,
  readId?: ModelIDInput | null,
  and?: Array< ModelEntityRelationFilterInput | null > | null,
  or?: Array< ModelEntityRelationFilterInput | null > | null,
  not?: ModelEntityRelationFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export enum ModelSortDirection {
  ASC = "ASC",
  DESC = "DESC",
}

export type ModelFileFilterInput = {
  id?: ModelIDInput | null,
  bucket?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  categoryId?: ModelIDInput | null,
  foreignKey?: ModelIDInput | null,
  foreignTableName?: ModelStringInput | null,
  key?: ModelStringInput | null,
  mimeType?: ModelStringInput | null,
  region?: ModelStringInput | null,
  size?: ModelIntInput | null,
  readers?: ModelIDInput | null,
  readId?: ModelIDInput | null,
  clientId?: ModelIDInput | null,
  _ttl?: ModelIntInput | null,
  and?: Array< ModelFileFilterInput | null > | null,
  or?: Array< ModelFileFilterInput | null > | null,
  not?: ModelFileFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelDocumentCategoryFilterInput = {
  id?: ModelIDInput | null,
  entity?: ModelStringInput | null,
  fileCategory?: ModelFileCategoryInput | null,
  parentId?: ModelIDInput | null,
  readers?: ModelIDInput | null,
  readId?: ModelIDInput | null,
  clientId?: ModelIDInput | null,
  and?: Array< ModelDocumentCategoryFilterInput | null > | null,
  or?: Array< ModelDocumentCategoryFilterInput | null > | null,
  not?: ModelDocumentCategoryFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelDocumentCategoryConnection = {
  __typename: "ModelDocumentCategoryConnection",
  items:  Array<DocumentCategoryDTO | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelSignatureDocumentFilterInput = {
  id?: ModelIDInput | null,
  additionalMessage?: ModelStringInput | null,
  automaticRemindersDisabled?: ModelBooleanInput | null,
  communicationBody?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  expirationDate?: ModelStringInput | null,
  fileIds?: ModelIDInput | null,
  foreignKey?: ModelIDInput | null,
  foreignTableName?: ModelStringInput | null,
  sentAt?: ModelStringInput | null,
  signatureMethods?: ModelSignatureTypeInput | null,
  status?: ModelSignatureDocumentStatusInput | null,
  externalStatus?: ModelStringInput | null,
  type?: ModelSignatureDocumentTypeInput | null,
  readers?: ModelIDInput | null,
  readId?: ModelIDInput | null,
  clientId?: ModelIDInput | null,
  and?: Array< ModelSignatureDocumentFilterInput | null > | null,
  or?: Array< ModelSignatureDocumentFilterInput | null > | null,
  not?: ModelSignatureDocumentFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelFilterGroupFilterInput = {
  id?: ModelIDInput | null,
  name?: ModelStringInput | null,
  screenName?: ModelScreenNameInput | null,
  type?: ModelFilterGroupTypeInput | null,
  userId?: ModelIDInput | null,
  readId?: ModelIDInput | null,
  clientId?: ModelIDInput | null,
  and?: Array< ModelFilterGroupFilterInput | null > | null,
  or?: Array< ModelFilterGroupFilterInput | null > | null,
  not?: ModelFilterGroupFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelFilterGroupConnection = {
  __typename: "ModelFilterGroupConnection",
  items:  Array<FilterGroupDTO | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelIntegrationFilterInput = {
  id?: ModelIDInput | null,
  error?: ModelStringInput | null,
  lastRun?: ModelStringInput | null,
  name?: ModelIntegrationNameInput | null,
  status?: ModelIntegrationStatusInput | null,
  readId?: ModelIDInput | null,
  clientId?: ModelIDInput | null,
  and?: Array< ModelIntegrationFilterInput | null > | null,
  or?: Array< ModelIntegrationFilterInput | null > | null,
  not?: ModelIntegrationFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelIntegrationConnection = {
  __typename: "ModelIntegrationConnection",
  items:  Array<IntegrationDTO | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelInvoiceFilterInput = {
  id?: ModelIDInput | null,
  amount?: ModelFloatInput | null,
  bankAccountId?: ModelIDInput | null,
  communicationId?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  creditNote?: ModelBooleanInput | null,
  creditNoteLabel?: ModelStringInput | null,
  disputedPostingIds?: ModelIDInput | null,
  disputeStatus?: ModelInvoiceDisputeStatusInput | null,
  dueDate?: ModelStringInput | null,
  invoiceDate?: ModelStringInput | null,
  invoiceNumber?: ModelStringInput | null,
  ownerId?: ModelIDInput | null,
  invoiceSenderId?: ModelIDInput | null,
  leaseId?: ModelIDInput | null,
  paid?: ModelBooleanInput | null,
  postedDate?: ModelStringInput | null,
  purchaseOrderNumber?: ModelStringInput | null,
  receiptNumber?: ModelStringInput | null,
  reminderDates?: ModelStringInput | null,
  note?: ModelStringInput | null,
  remittanceInformation?: ModelStringInput | null,
  statementId?: ModelIDInput | null,
  status?: ModelInvoiceStatusInput | null,
  type?: ModelInvoiceTypeInput | null,
  unitId?: ModelIDInput | null,
  reversedInvoiceId?: ModelIDInput | null,
  readers?: ModelIDInput | null,
  readId?: ModelIDInput | null,
  clientId?: ModelIDInput | null,
  and?: Array< ModelInvoiceFilterInput | null > | null,
  or?: Array< ModelInvoiceFilterInput | null > | null,
  not?: ModelInvoiceFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelInvoiceConnection = {
  __typename: "ModelInvoiceConnection",
  items:  Array<InvoiceDTO | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelInvoiceSettingFilterInput = {
  id?: ModelIDInput | null,
  creditNoteFormat?: ModelStringInput | null,
  creditNoteLastUpdate?: ModelStringInput | null,
  creditNoteIncrementNumber?: ModelIntInput | null,
  invoiceFormat?: ModelStringInput | null,
  invoiceLastUpdate?: ModelStringInput | null,
  invoiceIncrementNumber?: ModelIntInput | null,
  paymentRequestFormat?: ModelStringInput | null,
  paymentRequestLastUpdate?: ModelStringInput | null,
  paymentRequestIncrementNumber?: ModelIntInput | null,
  receiptFormat?: ModelStringInput | null,
  receiptLastUpdate?: ModelStringInput | null,
  receiptIncrementNumber?: ModelIntInput | null,
  variousOperationFormat?: ModelStringInput | null,
  variousOperationLastUpdate?: ModelStringInput | null,
  variousOperationIncrementNumber?: ModelIntInput | null,
  customInvoicingConfiguration?: ModelBooleanInput | null,
  defaultVatRateId?: ModelIDInput | null,
  fiscalYearStart?: ModelStringInput | null,
  allPurposeInvoiceIssuer?: ModelBooleanInput | null,
  paymentBankAccountId?: ModelIDInput | null,
  ownerId?: ModelIDInput | null,
  readId?: ModelIDInput | null,
  clientId?: ModelIDInput | null,
  and?: Array< ModelInvoiceSettingFilterInput | null > | null,
  or?: Array< ModelInvoiceSettingFilterInput | null > | null,
  not?: ModelInvoiceSettingFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelInvoiceSettingConnection = {
  __typename: "ModelInvoiceSettingConnection",
  items:  Array<InvoiceSettingDTO | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelLeaseFilterInput = {
  id?: ModelIDInput | null,
  balance?: ModelFloatInput | null,
  canBeExtended?: ModelBooleanInput | null,
  communicationSettingsProfileId?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  endDate?: ModelStringInput | null,
  includeRealEstateInLeaseContract?: ModelBooleanInput | null,
  attachStatementSupportingDocuments?: ModelBooleanInput | null,
  invoiceSenderId?: ModelIDInput | null,
  inventoryOfFixturesExpert?: ModelStringInput | null,
  inventoryOfFixturesMethod?: ModelInventoryOfFixturesMethodInput | null,
  inventoryOfFixturesType?: ModelInventoryOfFixturesTypeInput | null,
  ipiNumber?: ModelStringInput | null,
  language?: ModelLanguageInput | null,
  lastDraftInvoiceDate?: ModelStringInput | null,
  lastIndexationProcessDate?: ModelStringInput | null,
  lastInvoiceDate?: ModelStringInput | null,
  legalCompetentAuthority?: ModelStringInput | null,
  name?: ModelStringInput | null,
  notes?: ModelStringInput | null,
  paymentFrequency?: ModelLeasePaymentFrequencyInput | null,
  paymentInvoicePeriod?: ModelLeasePaymentInvoicePeriodInput | null,
  paymentInvoicePeriodCustomDay?: ModelIntInput | null,
  purchaseOrderNumber?: ModelStringInput | null,
  realEstateAgency?: ModelStringInput | null,
  realEstateTax?: ModelIntInput | null,
  remittanceInformation?: ModelStringInput | null,
  remittanceInformationType?: ModelLeaseRemittanceTypeInput | null,
  signatureDate?: ModelStringInput | null,
  startDate?: ModelStringInput | null,
  nextIndexationMonth?: ModelStringInput | null,
  nextIndexation?: ModelBooleanInput | null,
  status?: ModelLeaseStatusInput | null,
  technicCommunicationSettingsProfileId?: ModelIDInput | null,
  totalInitialRentalPrice?: ModelFloatInput | null,
  totalRentalPrice?: ModelFloatInput | null,
  type?: ModelLeaseTypeInput | null,
  subletting?: ModelBooleanInput | null,
  vatRateRentId?: ModelIDInput | null,
  bankAccountId?: ModelIDInput | null,
  readers?: ModelIDInput | null,
  readId?: ModelIDInput | null,
  clientId?: ModelIDInput | null,
  and?: Array< ModelLeaseFilterInput | null > | null,
  or?: Array< ModelLeaseFilterInput | null > | null,
  not?: ModelLeaseFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelLeaseConnection = {
  __typename: "ModelLeaseConnection",
  items:  Array<LeaseDTO | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelLeaseActionHistoryFilterInput = {
  id?: ModelIDInput | null,
  action?: ModelLeaseActionInput | null,
  comment?: ModelStringInput | null,
  contactId?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  leaseId?: ModelIDInput | null,
  communicationId?: ModelIDInput | null,
  signatureDocumentId?: ModelIDInput | null,
  status?: ModelLeaseActionHistoryStatusInput | null,
  communicationChannel?: ModelCommunicationChannelInput | null,
  communicationSendDate?: ModelStringInput | null,
  communicationByPlatform?: ModelBooleanInput | null,
  endReason?: ModelLeaseActionEndReasonInput | null,
  endReasonOwnUseRelation?: ModelStringInput | null,
  endReasonOwnUseName?: ModelStringInput | null,
  initiator?: ModelLeaseActionEndInitiatorInput | null,
  totalAmount?: ModelFloatInput | null,
  totalAmountLabel?: ModelStringInput | null,
  automatic?: ModelBooleanInput | null,
  hasLeaseTypeChanged?: ModelBooleanInput | null,
  jiraId?: ModelStringInput | null,
  readers?: ModelIDInput | null,
  readId?: ModelIDInput | null,
  clientId?: ModelIDInput | null,
  and?: Array< ModelLeaseActionHistoryFilterInput | null > | null,
  or?: Array< ModelLeaseActionHistoryFilterInput | null > | null,
  not?: ModelLeaseActionHistoryFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelLeaseAdditionalClauseFilterInput = {
  id?: ModelIDInput | null,
  leaseId?: ModelIDInput | null,
  title?: ModelStringInput | null,
  body?: ModelStringInput | null,
  readId?: ModelIDInput | null,
  clientId?: ModelIDInput | null,
  and?: Array< ModelLeaseAdditionalClauseFilterInput | null > | null,
  or?: Array< ModelLeaseAdditionalClauseFilterInput | null > | null,
  not?: ModelLeaseAdditionalClauseFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelLeaseContactFilterInput = {
  id?: ModelIDInput | null,
  leaseId?: ModelIDInput | null,
  contactId?: ModelIDInput | null,
  contactRole?: ModelContactTypeInput | null,
  readers?: ModelIDInput | null,
  readId?: ModelIDInput | null,
  clientId?: ModelIDInput | null,
  and?: Array< ModelLeaseContactFilterInput | null > | null,
  or?: Array< ModelLeaseContactFilterInput | null > | null,
  not?: ModelLeaseContactFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelLeasePriceHistoryFilterInput = {
  id?: ModelIDInput | null,
  previousTotalRentalPrice?: ModelFloatInput | null,
  totalRentalPrice?: ModelFloatInput | null,
  optimalTotalRentalPrice?: ModelFloatInput | null,
  optimalTotalMonthlyCharges?: ModelFloatInput | null,
  applicationDate?: ModelStringInput | null,
  status?: ModelLeaseAmountUpdateStatusInput | null,
  comment?: ModelStringInput | null,
  type?: ModelLeasePriceHistoryTypeInput | null,
  communicationId?: ModelIDInput | null,
  leaseId?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  readers?: ModelIDInput | null,
  readId?: ModelIDInput | null,
  clientId?: ModelIDInput | null,
  and?: Array< ModelLeasePriceHistoryFilterInput | null > | null,
  or?: Array< ModelLeasePriceHistoryFilterInput | null > | null,
  not?: ModelLeasePriceHistoryFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelLeaseVariousOperationFilterInput = {
  id?: ModelIDInput | null,
  accountLabelIds?: ModelIDInput | null,
  amount?: ModelFloatInput | null,
  billingMode?: ModelLeaseVariousOperationBillingModeInput | null,
  contactId?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  dueDateDaysAfterPeriodStart?: ModelIntInput | null,
  endDate?: ModelStringInput | null,
  indexationBaseAmount?: ModelFloatInput | null,
  indexationBaseIndexDate?: ModelStringInput | null,
  indexationFrozen?: ModelBooleanInput | null,
  invoiceSenderId?: ModelIDInput | null,
  issueLeadDays?: ModelIntInput | null,
  label?: ModelStringInput | null,
  lastInvoiceDate?: ModelStringInput | null,
  leaseId?: ModelIDInput | null,
  operationType?: ModelLeaseVariousOperationTypeInput | null,
  paymentFrequency?: ModelLeasePaymentFrequencyInput | null,
  paymentInvoicePeriod?: ModelLeasePaymentInvoicePeriodInput | null,
  paymentInvoicePeriodCustomDay?: ModelIntInput | null,
  periodNature?: ModelLeaseVariousOperationPeriodNatureInput | null,
  reason?: ModelStringInput | null,
  separateInvoice?: ModelBooleanInput | null,
  startDate?: ModelStringInput | null,
  type?: ModelVariousOperationTypeInput | null,
  unitId?: ModelIDInput | null,
  vatRateId?: ModelIDInput | null,
  readId?: ModelIDInput | null,
  readers?: ModelIDInput | null,
  clientId?: ModelIDInput | null,
  and?: Array< ModelLeaseVariousOperationFilterInput | null > | null,
  or?: Array< ModelLeaseVariousOperationFilterInput | null > | null,
  not?: ModelLeaseVariousOperationFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelMortgageFilterInput = {
  id?: ModelIDInput | null,
  lender?: ModelStringInput | null,
  durationInYears?: ModelIntInput | null,
  rateType?: ModelMortgageRateTypeInput | null,
  interestRate?: ModelFloatInput | null,
  aprRate?: ModelFloatInput | null,
  startDate?: ModelStringInput | null,
  amount?: ModelFloatInput | null,
  monthlyPayment?: ModelFloatInput | null,
  unitId?: ModelIDInput | null,
  buildingId?: ModelIDInput | null,
  writers?: ModelIDInput | null,
  readId?: ModelIDInput | null,
  clientId?: ModelIDInput | null,
  and?: Array< ModelMortgageFilterInput | null > | null,
  or?: Array< ModelMortgageFilterInput | null > | null,
  not?: ModelMortgageFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelMortgageConnection = {
  __typename: "ModelMortgageConnection",
  items:  Array<MortgageDTO | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelNotificationFilterInput = {
  id?: ModelIDInput | null,
  createdBy?: ModelNotificationCreationInput | null,
  type?: ModelNotificationTypeInput | null,
  message?: ModelStringInput | null,
  popupDate?: ModelStringInput | null,
  expirationDate?: ModelStringInput | null,
  status?: ModelNotificationStatusInput | null,
  createdAt?: ModelStringInput | null,
  buildingId?: ModelIDInput | null,
  unitId?: ModelIDInput | null,
  leaseId?: ModelIDInput | null,
  technicId?: ModelIDInput | null,
  ticketId?: ModelIDInput | null,
  readId?: ModelIDInput | null,
  clientId?: ModelIDInput | null,
  and?: Array< ModelNotificationFilterInput | null > | null,
  or?: Array< ModelNotificationFilterInput | null > | null,
  not?: ModelNotificationFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelNotificationConnection = {
  __typename: "ModelNotificationConnection",
  items:  Array<NotificationDTO | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelScheduleRuleFilterInput = {
  id?: ModelIDInput | null,
  conditionsOperator?: ModelRuleConditionsOperatorInput | null,
  foreignKey?: ModelIDInput | null,
  foreignTableName?: ModelStringInput | null,
  order?: ModelIntInput | null,
  readId?: ModelIDInput | null,
  clientId?: ModelIDInput | null,
  and?: Array< ModelScheduleRuleFilterInput | null > | null,
  or?: Array< ModelScheduleRuleFilterInput | null > | null,
  not?: ModelScheduleRuleFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelScheduleRuleConnection = {
  __typename: "ModelScheduleRuleConnection",
  items:  Array<ScheduleRuleDTO | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelSendingSourceFilterInput = {
  id?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  createdById?: ModelIDInput | null,
  emailAddress?: ModelStringInput | null,
  issuesEmail?: ModelStringInput | null,
  chargesEmail?: ModelStringInput | null,
  errorMessage?: ModelSendingSourceErrorTypeInput | null,
  name?: ModelStringInput | null,
  lastReminderDate?: ModelStringInput | null,
  status?: ModelSendingSourceStatusInput | null,
  statusLastVerification?: ModelStringInput | null,
  verifiedType?: ModelSendingSourceVerifiedTypeInput | null,
  readId?: ModelIDInput | null,
  clientId?: ModelIDInput | null,
  and?: Array< ModelSendingSourceFilterInput | null > | null,
  or?: Array< ModelSendingSourceFilterInput | null > | null,
  not?: ModelSendingSourceFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSendingSourceConnection = {
  __typename: "ModelSendingSourceConnection",
  items:  Array<SendingSourceDTO | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelSettingFilterInput = {
  id?: ModelIDInput | null,
  name?: ModelSettingTypeInput | null,
  value?: ModelStringInput | null,
  readId?: ModelIDInput | null,
  clientId?: ModelIDInput | null,
  and?: Array< ModelSettingFilterInput | null > | null,
  or?: Array< ModelSettingFilterInput | null > | null,
  not?: ModelSettingFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSettingConnection = {
  __typename: "ModelSettingConnection",
  items:  Array<SettingDTO | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelReconciliationSettingFilterInput = {
  id?: ModelIDInput | null,
  type?: ModelReconciliationSettingTypeInput | null,
  allocationMode?: ModelReconciliationAllocationModeInput | null,
  leaseId?: ModelIDInput | null,
  ownerId?: ModelIDInput | null,
  readId?: ModelIDInput | null,
  clientId?: ModelIDInput | null,
  and?: Array< ModelReconciliationSettingFilterInput | null > | null,
  or?: Array< ModelReconciliationSettingFilterInput | null > | null,
  not?: ModelReconciliationSettingFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelReconciliationSettingConnection = {
  __typename: "ModelReconciliationSettingConnection",
  items:  Array<ReconciliationSettingDTO | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelRepaymentStatementFilterInput = {
  id?: ModelIDInput | null,
  accountOwnership?: ModelRepaymentStatementAccountOwnershipInput | null,
  delaysCleared?: ModelFloatInput | null,
  expectedRent?: ModelFloatInput | null,
  leaseId?: ModelIDInput | null,
  rentsCollected?: ModelFloatInput | null,
  statementId?: ModelIDInput | null,
  totalReceivedInJointAccount?: ModelFloatInput | null,
  totalExpectedInOwnerAccount?: ModelFloatInput | null,
  unpaidRents?: ModelFloatInput | null,
  readId?: ModelIDInput | null,
  clientId?: ModelIDInput | null,
  and?: Array< ModelRepaymentStatementFilterInput | null > | null,
  or?: Array< ModelRepaymentStatementFilterInput | null > | null,
  not?: ModelRepaymentStatementFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelStatementFilterInput = {
  id?: ModelIDInput | null,
  closingStatement?: ModelBooleanInput | null,
  periodFrom?: ModelStringInput | null,
  periodTo?: ModelStringInput | null,
  attachSupportingDocuments?: ModelBooleanInput | null,
  selectedPocketKeys?: ModelStringInput | null,
  source?: ModelStatementSourceInput | null,
  status?: ModelStatementStatusInput | null,
  sentDate?: ModelStringInput | null,
  leaseId?: ModelIDInput | null,
  ownerId?: ModelIDInput | null,
  types?: ModelStatementTypeListInput | null,
  viewType?: ModelStatementViewTypeInput | null,
  unitIds?: ModelIDInput | null,
  readId?: ModelIDInput | null,
  clientId?: ModelIDInput | null,
  and?: Array< ModelStatementFilterInput | null > | null,
  or?: Array< ModelStatementFilterInput | null > | null,
  not?: ModelStatementFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelStatementConnection = {
  __typename: "ModelStatementConnection",
  items:  Array<StatementDTO | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelStatementSettingFilterInput = {
  id?: ModelIDInput | null,
  type?: ModelStatementSettingTypeInput | null,
  custom?: ModelBooleanInput | null,
  disabled?: ModelBooleanInput | null,
  monthFrequency?: ModelIntInput | null,
  startMonth?: ModelStringInput | null,
  generationDay?: ModelIntInput | null,
  leaseId?: ModelIDInput | null,
  ownerId?: ModelIDInput | null,
  readId?: ModelIDInput | null,
  clientId?: ModelIDInput | null,
  and?: Array< ModelStatementSettingFilterInput | null > | null,
  or?: Array< ModelStatementSettingFilterInput | null > | null,
  not?: ModelStatementSettingFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelStatementSettingConnection = {
  __typename: "ModelStatementSettingConnection",
  items:  Array<StatementSettingDTO | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelTagFilterInput = {
  id?: ModelIDInput | null,
  color?: ModelStringInput | null,
  foreignTableName?: ModelStringInput | null,
  readId?: ModelIDInput | null,
  clientId?: ModelIDInput | null,
  and?: Array< ModelTagFilterInput | null > | null,
  or?: Array< ModelTagFilterInput | null > | null,
  not?: ModelTagFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelTagConnection = {
  __typename: "ModelTagConnection",
  items:  Array<TagDTO | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelTechnicFilterInput = {
  id?: ModelIDInput | null,
  type?: ModelTechnicTypeInput | null,
  contractNumber?: ModelStringInput | null,
  communicationSettingsProfileId?: ModelIDInput | null,
  technicLibraryId?: ModelIDInput | null,
  technicName?: ModelStringInput | null,
  lastControlDate?: ModelStringInput | null,
  status?: ModelTechnicStatusInput | null,
  utilityType?: ModelUtilityTypeInput | null,
  utilityEanCode?: ModelStringInput | null,
  utilityMeterNumber?: ModelStringInput | null,
  utilityDistributorId?: ModelIDInput | null,
  buildingId?: ModelIDInput | null,
  unitId?: ModelIDInput | null,
  leaseId?: ModelIDInput | null,
  contactId?: ModelIDInput | null,
  originalTechnicId?: ModelIDInput | null,
  replacedTechnicId?: ModelIDInput | null,
  certificateIds?: ModelIDInput | null,
  readers?: ModelIDInput | null,
  writers?: ModelIDInput | null,
  readId?: ModelIDInput | null,
  clientId?: ModelIDInput | null,
  and?: Array< ModelTechnicFilterInput | null > | null,
  or?: Array< ModelTechnicFilterInput | null > | null,
  not?: ModelTechnicFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelTechnicConnection = {
  __typename: "ModelTechnicConnection",
  items:  Array<TechnicDTO | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelTechnicLibraryFilterInput = {
  id?: ModelIDInput | null,
  communicationSettingsProfileId?: ModelIDInput | null,
  criticality?: ModelTechnicLibraryCriticalityInput | null,
  isDefault?: ModelBooleanInput | null,
  issuingAuthority?: ModelStringInput | null,
  linkedCertificateIds?: ModelIDInput | null,
  locationScope?: ModelTechnicLibraryLocationScopeInput | null,
  status?: ModelTechnicLibraryStatusInput | null,
  tagIds?: ModelIDInput | null,
  technicLibraryFormat?: ModelStringInput | null,
  type?: ModelTechnicLibraryTypeInput | null,
  utilityTypes?: ModelUtilityTypeInput | null,
  readId?: ModelIDInput | null,
  clientId?: ModelIDInput | null,
  and?: Array< ModelTechnicLibraryFilterInput | null > | null,
  or?: Array< ModelTechnicLibraryFilterInput | null > | null,
  not?: ModelTechnicLibraryFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelTechnicLibraryConnection = {
  __typename: "ModelTechnicLibraryConnection",
  items:  Array<TechnicLibraryDTO | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelTicketFilterInput = {
  id?: ModelIDInput | null,
  assignedAt?: ModelStringInput | null,
  assignedToId?: ModelIDInput | null,
  buildingId?: ModelIDInput | null,
  closedAt?: ModelStringInput | null,
  contactId?: ModelIDInput | null,
  content?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  emailMessageId?: ModelStringInput | null,
  emailReferences?: ModelStringInput | null,
  parentId?: ModelIDInput | null,
  plannedAt?: ModelStringInput | null,
  referenceCode?: ModelStringInput | null,
  sourceType?: ModelTicketSourceTypeInput | null,
  status?: ModelTicketStatusInput | null,
  subject?: ModelStringInput | null,
  unitId?: ModelIDInput | null,
  unread?: ModelBooleanInput | null,
  updatedAt?: ModelStringInput | null,
  readers?: ModelIDInput | null,
  readId?: ModelIDInput | null,
  clientId?: ModelIDInput | null,
  and?: Array< ModelTicketFilterInput | null > | null,
  or?: Array< ModelTicketFilterInput | null > | null,
  not?: ModelTicketFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelUnitFilterInput = {
  id?: ModelIDInput | null,
  acquisitionAdditionalCostsValue?: ModelFloatInput | null,
  acquisitionAdvertisedValue?: ModelFloatInput | null,
  acquisitionValue?: ModelFloatInput | null,
  advertisedMonthlyCharges?: ModelFloatInput | null,
  advertisedRentalPrice?: ModelFloatInput | null,
  cadastralIncome?: ModelFloatInput | null,
  createdAt?: ModelStringInput | null,
  floor?: ModelIntInput | null,
  jointOwnershipId?: ModelIDInput | null,
  managementDate?: ModelStringInput | null,
  name?: ModelStringInput | null,
  notes?: ModelStringInput | null,
  predictedPrice?: ModelStringInput | null,
  propertyTax?: ModelFloatInput | null,
  publishAddress?: ModelBooleanInput | null,
  surface?: ModelFloatInput | null,
  type?: ModelUnitTypeInput | null,
  buildingId?: ModelIDInput | null,
  unitAdvertisementId?: ModelIDInput | null,
  readers?: ModelIDInput | null,
  readId?: ModelIDInput | null,
  clientId?: ModelIDInput | null,
  and?: Array< ModelUnitFilterInput | null > | null,
  or?: Array< ModelUnitFilterInput | null > | null,
  not?: ModelUnitFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelUnitEventFilterInput = {
  id?: ModelIDInput | null,
  unitId?: ModelIDInput | null,
  type?: ModelUnitEventTypeInput | null,
  startDate?: ModelStringInput | null,
  endDate?: ModelStringInput | null,
  totalCost?: ModelFloatInput | null,
  note?: ModelStringInput | null,
  writers?: ModelIDInput | null,
  readId?: ModelIDInput | null,
  clientId?: ModelIDInput | null,
  and?: Array< ModelUnitEventFilterInput | null > | null,
  or?: Array< ModelUnitEventFilterInput | null > | null,
  not?: ModelUnitEventFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelUnitInventoryFilterInput = {
  id?: ModelIDInput | null,
  privateBatthRoom?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  deletedAt?: ModelStringInput | null,
  kitchenEquipment?: ModelKitchenEquipmentInput | null,
  roomName?: ModelStringInput | null,
  roomType?: ModelUnitInventoryRoomTypeInput | null,
  surface?: ModelFloatInput | null,
  showSurface?: ModelBooleanInput | null,
  unitId?: ModelIDInput | null,
  inside?: ModelBooleanInput | null,
  readId?: ModelIDInput | null,
  clientId?: ModelIDInput | null,
  and?: Array< ModelUnitInventoryFilterInput | null > | null,
  or?: Array< ModelUnitInventoryFilterInput | null > | null,
  not?: ModelUnitInventoryFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelUnitLeaseFilterInput = {
  id?: ModelIDInput | null,
  allowChargeAdjustment?: ModelBooleanInput | null,
  authorizeProfessionalActivity?: ModelBooleanInput | null,
  chargesIndexation?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  endDate?: ModelStringInput | null,
  furnishedRental?: ModelBooleanInput | null,
  furnishedRentalInsuranceByTenant?: ModelBooleanInput | null,
  furnishedRentalRentalPricePercentage?: ModelFloatInput | null,
  initialRentalPrice?: ModelFloatInput | null,
  indexation?: ModelBooleanInput | null,
  advancedIndexation?: ModelBooleanInput | null,
  indexType?: ModelIndexTypeInput | null,
  baseYear?: ModelFloatInput | null,
  baseIndexType?: ModelBaseIndexTypeInput | null,
  baseIndexDate?: ModelStringInput | null,
  nextIndexationMonth?: ModelStringInput | null,
  nextIndexation?: ModelBooleanInput | null,
  leaseId?: ModelIDInput | null,
  mainUnit?: ModelBooleanInput | null,
  rentalPrice?: ModelFloatInput | null,
  signatureDate?: ModelStringInput | null,
  startDate?: ModelStringInput | null,
  unitId?: ModelIDInput | null,
  readers?: ModelIDInput | null,
  readId?: ModelIDInput | null,
  clientId?: ModelIDInput | null,
  and?: Array< ModelUnitLeaseFilterInput | null > | null,
  or?: Array< ModelUnitLeaseFilterInput | null > | null,
  not?: ModelUnitLeaseFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelUnitOwnerFilterInput = {
  id?: ModelIDInput | null,
  disabled?: ModelBooleanInput | null,
  ownerId?: ModelIDInput | null,
  periodFrom?: ModelStringInput | null,
  periodTo?: ModelStringInput | null,
  stake?: ModelFloatInput | null,
  unitId?: ModelIDInput | null,
  readers?: ModelIDInput | null,
  readId?: ModelIDInput | null,
  clientId?: ModelIDInput | null,
  and?: Array< ModelUnitOwnerFilterInput | null > | null,
  or?: Array< ModelUnitOwnerFilterInput | null > | null,
  not?: ModelUnitOwnerFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelTeamFilterInput = {
  id?: ModelIDInput | null,
  name?: ModelStringInput | null,
  parentId?: ModelIDInput | null,
  readId?: ModelIDInput | null,
  clientId?: ModelIDInput | null,
  and?: Array< ModelTeamFilterInput | null > | null,
  or?: Array< ModelTeamFilterInput | null > | null,
  not?: ModelTeamFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelUserFilterInput = {
  id?: ModelIDInput | null,
  email?: ModelStringInput | null,
  firstName?: ModelStringInput | null,
  lastName?: ModelStringInput | null,
  cognitoSub?: ModelIDInput | null,
  googleSub?: ModelIDInput | null,
  facebookSub?: ModelIDInput | null,
  rootUser?: ModelBooleanInput | null,
  refreshToken?: ModelBooleanInput | null,
  userRoleId?: ModelIDInput | null,
  contactId?: ModelIDInput | null,
  status?: ModelUserStatusInput | null,
  readId?: ModelIDInput | null,
  clientId?: ModelIDInput | null,
  _ttl?: ModelIntInput | null,
  and?: Array< ModelUserFilterInput | null > | null,
  or?: Array< ModelUserFilterInput | null > | null,
  not?: ModelUserFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelUserConnection = {
  __typename: "ModelUserConnection",
  items:  Array<UserDTO | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelUserRoleFilterInput = {
  id?: ModelIDInput | null,
  name?: ModelStringInput | null,
  readId?: ModelIDInput | null,
  clientId?: ModelIDInput | null,
  and?: Array< ModelUserRoleFilterInput | null > | null,
  or?: Array< ModelUserRoleFilterInput | null > | null,
  not?: ModelUserRoleFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelUserRoleConnection = {
  __typename: "ModelUserRoleConnection",
  items:  Array<UserRoleDTO | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelUserTeamFilterInput = {
  id?: ModelIDInput | null,
  userId?: ModelIDInput | null,
  teamId?: ModelIDInput | null,
  readId?: ModelIDInput | null,
  clientId?: ModelIDInput | null,
  and?: Array< ModelUserTeamFilterInput | null > | null,
  or?: Array< ModelUserTeamFilterInput | null > | null,
  not?: ModelUserTeamFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelValuationFilterInput = {
  id?: ModelIDInput | null,
  sourceType?: ModelValuationSourceTypeInput | null,
  valorization?: ModelFloatInput | null,
  date?: ModelStringInput | null,
  unitId?: ModelIDInput | null,
  buildingId?: ModelIDInput | null,
  writers?: ModelIDInput | null,
  readId?: ModelIDInput | null,
  clientId?: ModelIDInput | null,
  and?: Array< ModelValuationFilterInput | null > | null,
  or?: Array< ModelValuationFilterInput | null > | null,
  not?: ModelValuationFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelValuationConnection = {
  __typename: "ModelValuationConnection",
  items:  Array<ValuationDTO | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelVariousOperationFilterInput = {
  id?: ModelIDInput | null,
  amount?: ModelFloatInput | null,
  numberOfMonths?: ModelIntInput | null,
  operationType?: ModelLeaseVariousOperationTypeInput | null,
  paymentFrequency?: ModelLeasePaymentFrequencyInput | null,
  type?: ModelVariousOperationTypeInput | null,
  readId?: ModelIDInput | null,
  clientId?: ModelIDInput | null,
  and?: Array< ModelVariousOperationFilterInput | null > | null,
  or?: Array< ModelVariousOperationFilterInput | null > | null,
  not?: ModelVariousOperationFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelVariousOperationConnection = {
  __typename: "ModelVariousOperationConnection",
  items:  Array<VariousOperationDTO | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelSubscriptionAccountLabelFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  bankAccountId?: ModelSubscriptionIDInput | null,
  contactId?: ModelSubscriptionIDInput | null,
  class?: ModelSubscriptionIntInput | null,
  customUsage?: ModelSubscriptionStringInput | null,
  disabled?: ModelSubscriptionBooleanInput | null,
  hoaFundId?: ModelSubscriptionIDInput | null,
  ownerId?: ModelSubscriptionIDInput | null,
  topClass?: ModelSubscriptionIntInput | null,
  vatNonDeductiblePercentage?: ModelSubscriptionFloatInput | null,
  and?: Array< ModelSubscriptionAccountLabelFilterInput | null > | null,
  or?: Array< ModelSubscriptionAccountLabelFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionIDInput = {
  ne?: string | null,
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  contains?: string | null,
  notContains?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
  in?: Array< string | null > | null,
  notIn?: Array< string | null > | null,
};

export type ModelSubscriptionIntInput = {
  ne?: number | null,
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
  in?: Array< number | null > | null,
  notIn?: Array< number | null > | null,
};

export type ModelSubscriptionStringInput = {
  ne?: string | null,
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  contains?: string | null,
  notContains?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
  in?: Array< string | null > | null,
  notIn?: Array< string | null > | null,
};

export type ModelSubscriptionBooleanInput = {
  ne?: boolean | null,
  eq?: boolean | null,
};

export type ModelSubscriptionPostingFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  class?: ModelSubscriptionIntInput | null,
  customLabel?: ModelSubscriptionStringInput | null,
  topClass?: ModelSubscriptionIntInput | null,
  type?: ModelSubscriptionStringInput | null,
  totalAmount?: ModelSubscriptionFloatInput | null,
  periodFrom?: ModelSubscriptionStringInput | null,
  periodTo?: ModelSubscriptionStringInput | null,
  buildingId?: ModelSubscriptionIDInput | null,
  unitId?: ModelSubscriptionIDInput | null,
  invoiceId?: ModelSubscriptionIDInput | null,
  chargeId?: ModelSubscriptionIDInput | null,
  transactionId?: ModelSubscriptionIDInput | null,
  leaseId?: ModelSubscriptionIDInput | null,
  bankAccountId?: ModelSubscriptionIDInput | null,
  accountLabelId?: ModelSubscriptionIDInput | null,
  contactId?: ModelSubscriptionIDInput | null,
  leaseVariousOperationId?: ModelSubscriptionIDInput | null,
  statementId?: ModelSubscriptionIDInput | null,
  amountVatExcluded?: ModelSubscriptionFloatInput | null,
  vatAmount?: ModelSubscriptionFloatInput | null,
  vatRateId?: ModelSubscriptionIDInput | null,
  vatRateValue?: ModelSubscriptionFloatInput | null,
  foreignId?: ModelSubscriptionIDInput | null,
  foreignType?: ModelSubscriptionStringInput | null,
  invoicePostingId?: ModelSubscriptionIDInput | null,
  reconciledAt?: ModelSubscriptionStringInput | null,
  status?: ModelSubscriptionStringInput | null,
  chargeOwnerRepartition?: ModelSubscriptionFloatInput | null,
  chargeRepartitionMetric?: ModelSubscriptionStringInput | null,
  chargeRepartitionValue?: ModelSubscriptionFloatInput | null,
  chargeSplitNumber?: ModelSubscriptionIntInput | null,
  chargeType?: ModelSubscriptionStringInput | null,
  provisional?: ModelSubscriptionBooleanInput | null,
  flaggedAt?: ModelSubscriptionStringInput | null,
  carriedForward?: ModelSubscriptionBooleanInput | null,
  and?: Array< ModelSubscriptionPostingFilterInput | null > | null,
  or?: Array< ModelSubscriptionPostingFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionFloatInput = {
  ne?: number | null,
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
  in?: Array< number | null > | null,
  notIn?: Array< number | null > | null,
};

export type ModelSubscriptionBankAccountFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  contactId?: ModelSubscriptionIDInput | null,
  number?: ModelSubscriptionStringInput | null,
  bicNumber?: ModelSubscriptionStringInput | null,
  bankName?: ModelSubscriptionStringInput | null,
  contactIds?: ModelSubscriptionIDInput | null,
  buildingIds?: ModelSubscriptionIDInput | null,
  holderName?: ModelSubscriptionStringInput | null,
  label?: ModelSubscriptionStringInput | null,
  disabled?: ModelSubscriptionBooleanInput | null,
  integrations?: ModelSubscriptionStringInput | null,
  matchingRule?: ModelSubscriptionStringInput | null,
  balance?: ModelSubscriptionFloatInput | null,
  balanceDate?: ModelSubscriptionStringInput | null,
  type?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionBankAccountFilterInput | null > | null,
  or?: Array< ModelSubscriptionBankAccountFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionTransactionFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  status?: ModelSubscriptionStringInput | null,
  sequence?: ModelSubscriptionFloatInput | null,
  statementDate?: ModelSubscriptionStringInput | null,
  operationDate?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  remittanceInformationType?: ModelSubscriptionStringInput | null,
  remittanceInformation?: ModelSubscriptionStringInput | null,
  comment?: ModelSubscriptionStringInput | null,
  amount?: ModelSubscriptionFloatInput | null,
  bankAccountId?: ModelSubscriptionIDInput | null,
  counterpartName?: ModelSubscriptionStringInput | null,
  counterpartAccountNumber?: ModelSubscriptionStringInput | null,
  origin?: ModelSubscriptionStringInput | null,
  proposedLeaseId?: ModelSubscriptionIDInput | null,
  proposedUnitId?: ModelSubscriptionIDInput | null,
  proposedContractorId?: ModelSubscriptionIDInput | null,
  proposedOwnerId?: ModelSubscriptionIDInput | null,
  proposedMatch?: ModelSubscriptionIntInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionTransactionFilterInput | null > | null,
  or?: Array< ModelSubscriptionTransactionFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionBillingItemFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  name?: ModelSubscriptionStringInput | null,
  baseAmount?: ModelSubscriptionIntInput | null,
  billingType?: ModelSubscriptionStringInput | null,
  amountCalculationType?: ModelSubscriptionStringInput | null,
  percentageBase?: ModelSubscriptionStringInput | null,
  period?: ModelSubscriptionStringInput | null,
  vatRateId?: ModelSubscriptionIDInput | null,
  invoiceId?: ModelSubscriptionIDInput | null,
  quantity?: ModelSubscriptionFloatInput | null,
  percentage?: ModelSubscriptionFloatInput | null,
  allocationOption?: ModelSubscriptionStringInput | null,
  multipleUnitsSplit?: ModelSubscriptionStringInput | null,
  leaseIds?: ModelSubscriptionIDInput | null,
  unitIds?: ModelSubscriptionIDInput | null,
  buildingIds?: ModelSubscriptionIDInput | null,
  accountLabelId?: ModelSubscriptionIDInput | null,
  and?: Array< ModelSubscriptionBillingItemFilterInput | null > | null,
  or?: Array< ModelSubscriptionBillingItemFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionBuildingFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  name?: ModelSubscriptionStringInput | null,
  addressId?: ModelSubscriptionIDInput | null,
  acquisitionValue?: ModelSubscriptionFloatInput | null,
  acquisitionAdditionalCostsValue?: ModelSubscriptionFloatInput | null,
  acquisitionAdvertisedValue?: ModelSubscriptionFloatInput | null,
  amountOfFacades?: ModelSubscriptionIntInput | null,
  amountOfFloors?: ModelSubscriptionIntInput | null,
  amountOfHousings?: ModelSubscriptionIntInput | null,
  buildingState?: ModelSubscriptionStringInput | null,
  cadastralIncome?: ModelSubscriptionFloatInput | null,
  constructionYear?: ModelSubscriptionStringInput | null,
  janitor?: ModelSubscriptionBooleanInput | null,
  jointOwnershipId?: ModelSubscriptionIDInput | null,
  notes?: ModelSubscriptionStringInput | null,
  propertyTax?: ModelSubscriptionFloatInput | null,
  residenceName?: ModelSubscriptionStringInput | null,
  buildingSiteId?: ModelSubscriptionIDInput | null,
  clientId?: ModelSubscriptionIDInput | null,
  and?: Array< ModelSubscriptionBuildingFilterInput | null > | null,
  or?: Array< ModelSubscriptionBuildingFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionBuildingEventFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  buildingId?: ModelSubscriptionIDInput | null,
  type?: ModelSubscriptionStringInput | null,
  startDate?: ModelSubscriptionStringInput | null,
  endDate?: ModelSubscriptionStringInput | null,
  totalCost?: ModelSubscriptionFloatInput | null,
  note?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionBuildingEventFilterInput | null > | null,
  or?: Array< ModelSubscriptionBuildingEventFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionBuildingOwnerFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  buildingId?: ModelSubscriptionIDInput | null,
  contactId?: ModelSubscriptionIDInput | null,
  disabled?: ModelSubscriptionBooleanInput | null,
  periodFrom?: ModelSubscriptionStringInput | null,
  periodTo?: ModelSubscriptionStringInput | null,
  stake?: ModelSubscriptionFloatInput | null,
  and?: Array< ModelSubscriptionBuildingOwnerFilterInput | null > | null,
  or?: Array< ModelSubscriptionBuildingOwnerFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionBuildingSiteFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  name?: ModelSubscriptionStringInput | null,
  clientId?: ModelSubscriptionIDInput | null,
  and?: Array< ModelSubscriptionBuildingSiteFilterInput | null > | null,
  or?: Array< ModelSubscriptionBuildingSiteFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionChargeFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  status?: ModelSubscriptionStringInput | null,
  invoiceDate?: ModelSubscriptionStringInput | null,
  paymentDueDate?: ModelSubscriptionStringInput | null,
  archivedDate?: ModelSubscriptionStringInput | null,
  periodFrom?: ModelSubscriptionStringInput | null,
  periodTo?: ModelSubscriptionStringInput | null,
  totalAmount?: ModelSubscriptionFloatInput | null,
  payableAmount?: ModelSubscriptionFloatInput | null,
  source?: ModelSubscriptionStringInput | null,
  draftFromOcr?: ModelSubscriptionBooleanInput | null,
  accountingDocumentId?: ModelSubscriptionIDInput | null,
  paid?: ModelSubscriptionBooleanInput | null,
  remittanceInformation?: ModelSubscriptionStringInput | null,
  note?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  creatorEmail?: ModelSubscriptionStringInput | null,
  createdById?: ModelSubscriptionIDInput | null,
  contractorId?: ModelSubscriptionIDInput | null,
  recipientId?: ModelSubscriptionIDInput | null,
  documentId?: ModelSubscriptionIDInput | null,
  and?: Array< ModelSubscriptionChargeFilterInput | null > | null,
  or?: Array< ModelSubscriptionChargeFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionCommunicationFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  addressId?: ModelSubscriptionIDInput | null,
  body?: ModelSubscriptionStringInput | null,
  buildingId?: ModelSubscriptionStringInput | null,
  channel?: ModelSubscriptionStringInput | null,
  communicationTemplateId?: ModelSubscriptionIDInput | null,
  concernedContactIds?: ModelSubscriptionIDInput | null,
  contactId?: ModelSubscriptionIDInput | null,
  contactIds?: ModelSubscriptionIDInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  expirationDate?: ModelSubscriptionStringInput | null,
  invoiceId?: ModelSubscriptionIDInput | null,
  leaseId?: ModelSubscriptionIDInput | null,
  leasePriceHistoryId?: ModelSubscriptionIDInput | null,
  letterTrackingCode?: ModelSubscriptionStringInput | null,
  letterTrackingProvider?: ModelSubscriptionStringInput | null,
  linkedCommunicationsIds?: ModelSubscriptionIDInput | null,
  recipient?: ModelSubscriptionStringInput | null,
  recipientContactIdsInBcc?: ModelSubscriptionIDInput | null,
  recipientContactIdsInCc?: ModelSubscriptionIDInput | null,
  recipientInBcc?: ModelSubscriptionStringInput | null,
  recipientInCc?: ModelSubscriptionStringInput | null,
  scheduledAt?: ModelSubscriptionStringInput | null,
  deliveredAt?: ModelSubscriptionStringInput | null,
  errorCode?: ModelSubscriptionStringInput | null,
  nextRetryAt?: ModelSubscriptionStringInput | null,
  sendRetryCount?: ModelSubscriptionIntInput | null,
  sender?: ModelSubscriptionStringInput | null,
  sentAt?: ModelSubscriptionStringInput | null,
  externalId?: ModelSubscriptionIDInput | null,
  externalStatus?: ModelSubscriptionStringInput | null,
  signatureDocumentId?: ModelSubscriptionIDInput | null,
  snoozedDate?: ModelSubscriptionStringInput | null,
  statementId?: ModelSubscriptionIDInput | null,
  status?: ModelSubscriptionStringInput | null,
  subject?: ModelSubscriptionStringInput | null,
  toSend?: ModelSubscriptionBooleanInput | null,
  hideLogo?: ModelSubscriptionBooleanInput | null,
  type?: ModelSubscriptionStringInput | null,
  _ttl?: ModelSubscriptionIntInput | null,
  unitId?: ModelSubscriptionIDInput | null,
  and?: Array< ModelSubscriptionCommunicationFilterInput | null > | null,
  or?: Array< ModelSubscriptionCommunicationFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionCommunicationSettingsProfileFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  defaultName?: ModelSubscriptionStringInput | null,
  isDefaultSetting?: ModelSubscriptionBooleanInput | null,
  referent?: ModelSubscriptionStringInput | null,
  replacementId?: ModelSubscriptionIDInput | null,
  displayLogo?: ModelSubscriptionBooleanInput | null,
  tenantStatementView?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionCommunicationSettingsProfileFilterInput | null > | null,
  or?: Array< ModelSubscriptionCommunicationSettingsProfileFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionContactFilterInput = {
  createdAt?: ModelSubscriptionStringInput | null,
  firstName?: ModelSubscriptionStringInput | null,
  lastName?: ModelSubscriptionStringInput | null,
  companyName?: ModelSubscriptionStringInput | null,
  commercialName?: ModelSubscriptionStringInput | null,
  communicationSettingsProfileId?: ModelSubscriptionIDInput | null,
  businessNumber?: ModelSubscriptionStringInput | null,
  types?: ModelSubscriptionStringInput | null,
  vat?: ModelSubscriptionStringInput | null,
  email?: ModelSubscriptionStringInput | null,
  birthDate?: ModelSubscriptionStringInput | null,
  birthPlace?: ModelSubscriptionStringInput | null,
  nationalRegister?: ModelSubscriptionStringInput | null,
  ipiNumber?: ModelSubscriptionStringInput | null,
  insuranceCompany?: ModelSubscriptionStringInput | null,
  insuranceContractNumber?: ModelSubscriptionStringInput | null,
  judicialDistrict?: ModelSubscriptionStringInput | null,
  civility?: ModelSubscriptionStringInput | null,
  addressId?: ModelSubscriptionIDInput | null,
  language?: ModelSubscriptionStringInput | null,
  notes?: ModelSubscriptionStringInput | null,
  profileType?: ModelSubscriptionStringInput | null,
  agencyRateDisabled?: ModelSubscriptionBooleanInput | null,
  supplierPaymentMode?: ModelSubscriptionStringInput | null,
  status?: ModelSubscriptionStringInput | null,
  sendInvitation?: ModelSubscriptionBooleanInput | null,
  and?: Array< ModelSubscriptionContactFilterInput | null > | null,
  or?: Array< ModelSubscriptionContactFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionAddressFilterInput = {
  status?: ModelSubscriptionStringInput | null,
  street?: ModelSubscriptionStringInput | null,
  number?: ModelSubscriptionStringInput | null,
  box?: ModelSubscriptionStringInput | null,
  postalCode?: ModelSubscriptionStringInput | null,
  city?: ModelSubscriptionStringInput | null,
  region?: ModelSubscriptionStringInput | null,
  country?: ModelSubscriptionStringInput | null,
  latitude?: ModelSubscriptionFloatInput | null,
  longitude?: ModelSubscriptionFloatInput | null,
  and?: Array< ModelSubscriptionAddressFilterInput | null > | null,
  or?: Array< ModelSubscriptionAddressFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionCustomFieldFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  fieldName?: ModelSubscriptionStringInput | null,
  fieldType?: ModelSubscriptionStringInput | null,
  foreignKey?: ModelSubscriptionIDInput | null,
  foreignTableName?: ModelSubscriptionStringInput | null,
  order?: ModelSubscriptionIntInput | null,
  and?: Array< ModelSubscriptionCustomFieldFilterInput | null > | null,
  or?: Array< ModelSubscriptionCustomFieldFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionCustomSubscriptionFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  name?: ModelSubscriptionStringInput | null,
  value?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  _ttl?: ModelSubscriptionIntInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionCustomSubscriptionFilterInput | null > | null,
  or?: Array< ModelSubscriptionCustomSubscriptionFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionEntityRelationFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  sourceId?: ModelSubscriptionIDInput | null,
  sourceTableName?: ModelSubscriptionStringInput | null,
  foreignId?: ModelSubscriptionIDInput | null,
  foreignTableName?: ModelSubscriptionStringInput | null,
  linkDescription?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionEntityRelationFilterInput | null > | null,
  or?: Array< ModelSubscriptionEntityRelationFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionFileFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  bucket?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  categoryId?: ModelSubscriptionIDInput | null,
  foreignKey?: ModelSubscriptionIDInput | null,
  key?: ModelSubscriptionStringInput | null,
  mimeType?: ModelSubscriptionStringInput | null,
  region?: ModelSubscriptionStringInput | null,
  size?: ModelSubscriptionIntInput | null,
  _ttl?: ModelSubscriptionIntInput | null,
  and?: Array< ModelSubscriptionFileFilterInput | null > | null,
  or?: Array< ModelSubscriptionFileFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionDocumentCategoryFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  entity?: ModelSubscriptionStringInput | null,
  fileCategory?: ModelSubscriptionStringInput | null,
  parentId?: ModelSubscriptionIDInput | null,
  and?: Array< ModelSubscriptionDocumentCategoryFilterInput | null > | null,
  or?: Array< ModelSubscriptionDocumentCategoryFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionSignatureDocumentFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  additionalMessage?: ModelSubscriptionStringInput | null,
  automaticRemindersDisabled?: ModelSubscriptionBooleanInput | null,
  communicationBody?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  expirationDate?: ModelSubscriptionStringInput | null,
  fileIds?: ModelSubscriptionIDInput | null,
  foreignKey?: ModelSubscriptionIDInput | null,
  foreignTableName?: ModelSubscriptionStringInput | null,
  sentAt?: ModelSubscriptionStringInput | null,
  signatureMethods?: ModelSubscriptionStringInput | null,
  status?: ModelSubscriptionStringInput | null,
  externalStatus?: ModelSubscriptionStringInput | null,
  type?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionSignatureDocumentFilterInput | null > | null,
  or?: Array< ModelSubscriptionSignatureDocumentFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionFilterGroupFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  name?: ModelSubscriptionStringInput | null,
  screenName?: ModelSubscriptionStringInput | null,
  type?: ModelSubscriptionStringInput | null,
  userId?: ModelSubscriptionIDInput | null,
  and?: Array< ModelSubscriptionFilterGroupFilterInput | null > | null,
  or?: Array< ModelSubscriptionFilterGroupFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionIntegrationFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  error?: ModelSubscriptionStringInput | null,
  lastRun?: ModelSubscriptionStringInput | null,
  name?: ModelSubscriptionStringInput | null,
  status?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionIntegrationFilterInput | null > | null,
  or?: Array< ModelSubscriptionIntegrationFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionInvoiceFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  amount?: ModelSubscriptionFloatInput | null,
  bankAccountId?: ModelSubscriptionIDInput | null,
  communicationId?: ModelSubscriptionIDInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  creditNote?: ModelSubscriptionBooleanInput | null,
  creditNoteLabel?: ModelSubscriptionStringInput | null,
  dueDate?: ModelSubscriptionStringInput | null,
  invoiceDate?: ModelSubscriptionStringInput | null,
  invoiceNumber?: ModelSubscriptionStringInput | null,
  ownerId?: ModelSubscriptionIDInput | null,
  invoiceSenderId?: ModelSubscriptionIDInput | null,
  leaseId?: ModelSubscriptionIDInput | null,
  paid?: ModelSubscriptionBooleanInput | null,
  postedDate?: ModelSubscriptionStringInput | null,
  purchaseOrderNumber?: ModelSubscriptionStringInput | null,
  receiptNumber?: ModelSubscriptionStringInput | null,
  reminderDates?: ModelSubscriptionStringInput | null,
  note?: ModelSubscriptionStringInput | null,
  remittanceInformation?: ModelSubscriptionStringInput | null,
  statementId?: ModelSubscriptionIDInput | null,
  status?: ModelSubscriptionStringInput | null,
  type?: ModelSubscriptionStringInput | null,
  unitId?: ModelSubscriptionIDInput | null,
  reversedInvoiceId?: ModelSubscriptionIDInput | null,
  and?: Array< ModelSubscriptionInvoiceFilterInput | null > | null,
  or?: Array< ModelSubscriptionInvoiceFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionLeaseFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  balance?: ModelSubscriptionFloatInput | null,
  canBeExtended?: ModelSubscriptionBooleanInput | null,
  communicationSettingsProfileId?: ModelSubscriptionIDInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  endDate?: ModelSubscriptionStringInput | null,
  includeRealEstateInLeaseContract?: ModelSubscriptionBooleanInput | null,
  invoiceSenderId?: ModelSubscriptionIDInput | null,
  inventoryOfFixturesExpert?: ModelSubscriptionStringInput | null,
  inventoryOfFixturesMethod?: ModelSubscriptionStringInput | null,
  inventoryOfFixturesType?: ModelSubscriptionStringInput | null,
  ipiNumber?: ModelSubscriptionStringInput | null,
  language?: ModelSubscriptionStringInput | null,
  lastDraftInvoiceDate?: ModelSubscriptionStringInput | null,
  lastIndexationProcessDate?: ModelSubscriptionStringInput | null,
  lastInvoiceDate?: ModelSubscriptionStringInput | null,
  legalCompetentAuthority?: ModelSubscriptionStringInput | null,
  name?: ModelSubscriptionStringInput | null,
  notes?: ModelSubscriptionStringInput | null,
  paymentFrequency?: ModelSubscriptionStringInput | null,
  paymentInvoicePeriod?: ModelSubscriptionStringInput | null,
  paymentInvoicePeriodCustomDay?: ModelSubscriptionIntInput | null,
  purchaseOrderNumber?: ModelSubscriptionStringInput | null,
  realEstateAgency?: ModelSubscriptionStringInput | null,
  realEstateTax?: ModelSubscriptionIntInput | null,
  remittanceInformation?: ModelSubscriptionStringInput | null,
  remittanceInformationType?: ModelSubscriptionStringInput | null,
  signatureDate?: ModelSubscriptionStringInput | null,
  startDate?: ModelSubscriptionStringInput | null,
  nextIndexationMonth?: ModelSubscriptionStringInput | null,
  nextIndexation?: ModelSubscriptionBooleanInput | null,
  status?: ModelSubscriptionStringInput | null,
  technicCommunicationSettingsProfileId?: ModelSubscriptionIDInput | null,
  totalInitialRentalPrice?: ModelSubscriptionFloatInput | null,
  totalRentalPrice?: ModelSubscriptionFloatInput | null,
  type?: ModelSubscriptionStringInput | null,
  subletting?: ModelSubscriptionBooleanInput | null,
  vatRateRentId?: ModelSubscriptionIDInput | null,
  bankAccountId?: ModelSubscriptionIDInput | null,
  and?: Array< ModelSubscriptionLeaseFilterInput | null > | null,
  or?: Array< ModelSubscriptionLeaseFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionLeaseContactFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  leaseId?: ModelSubscriptionIDInput | null,
  contactId?: ModelSubscriptionIDInput | null,
  contactRole?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionLeaseContactFilterInput | null > | null,
  or?: Array< ModelSubscriptionLeaseContactFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionLeasePriceHistoryFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  previousTotalRentalPrice?: ModelSubscriptionFloatInput | null,
  totalRentalPrice?: ModelSubscriptionFloatInput | null,
  optimalTotalRentalPrice?: ModelSubscriptionFloatInput | null,
  optimalTotalMonthlyCharges?: ModelSubscriptionFloatInput | null,
  applicationDate?: ModelSubscriptionStringInput | null,
  status?: ModelSubscriptionStringInput | null,
  comment?: ModelSubscriptionStringInput | null,
  type?: ModelSubscriptionStringInput | null,
  communicationId?: ModelSubscriptionIDInput | null,
  leaseId?: ModelSubscriptionIDInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionLeasePriceHistoryFilterInput | null > | null,
  or?: Array< ModelSubscriptionLeasePriceHistoryFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionNotificationFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  createdBy?: ModelSubscriptionStringInput | null,
  type?: ModelSubscriptionStringInput | null,
  message?: ModelSubscriptionStringInput | null,
  popupDate?: ModelSubscriptionStringInput | null,
  expirationDate?: ModelSubscriptionStringInput | null,
  status?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  buildingId?: ModelSubscriptionIDInput | null,
  unitId?: ModelSubscriptionIDInput | null,
  leaseId?: ModelSubscriptionIDInput | null,
  technicId?: ModelSubscriptionIDInput | null,
  ticketId?: ModelSubscriptionIDInput | null,
  and?: Array< ModelSubscriptionNotificationFilterInput | null > | null,
  or?: Array< ModelSubscriptionNotificationFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionScheduleRuleFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  conditionsOperator?: ModelSubscriptionStringInput | null,
  foreignKey?: ModelSubscriptionIDInput | null,
  foreignTableName?: ModelSubscriptionStringInput | null,
  order?: ModelSubscriptionIntInput | null,
  and?: Array< ModelSubscriptionScheduleRuleFilterInput | null > | null,
  or?: Array< ModelSubscriptionScheduleRuleFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionSendingSourceFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  createdById?: ModelSubscriptionIDInput | null,
  emailAddress?: ModelSubscriptionStringInput | null,
  issuesEmail?: ModelSubscriptionStringInput | null,
  chargesEmail?: ModelSubscriptionStringInput | null,
  errorMessage?: ModelSubscriptionStringInput | null,
  name?: ModelSubscriptionStringInput | null,
  lastReminderDate?: ModelSubscriptionStringInput | null,
  status?: ModelSubscriptionStringInput | null,
  statusLastVerification?: ModelSubscriptionStringInput | null,
  verifiedType?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionSendingSourceFilterInput | null > | null,
  or?: Array< ModelSubscriptionSendingSourceFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionTagFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  color?: ModelSubscriptionStringInput | null,
  foreignTableName?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionTagFilterInput | null > | null,
  or?: Array< ModelSubscriptionTagFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionTechnicFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  type?: ModelSubscriptionStringInput | null,
  contractNumber?: ModelSubscriptionStringInput | null,
  communicationSettingsProfileId?: ModelSubscriptionIDInput | null,
  technicLibraryId?: ModelSubscriptionIDInput | null,
  technicName?: ModelSubscriptionStringInput | null,
  lastControlDate?: ModelSubscriptionStringInput | null,
  status?: ModelSubscriptionStringInput | null,
  utilityType?: ModelSubscriptionStringInput | null,
  utilityEanCode?: ModelSubscriptionStringInput | null,
  utilityMeterNumber?: ModelSubscriptionStringInput | null,
  utilityDistributorId?: ModelSubscriptionIDInput | null,
  buildingId?: ModelSubscriptionIDInput | null,
  unitId?: ModelSubscriptionIDInput | null,
  leaseId?: ModelSubscriptionIDInput | null,
  contactId?: ModelSubscriptionIDInput | null,
  originalTechnicId?: ModelSubscriptionIDInput | null,
  replacedTechnicId?: ModelSubscriptionIDInput | null,
  certificateIds?: ModelSubscriptionIDInput | null,
  readers?: ModelSubscriptionIDInput | null,
  writers?: ModelSubscriptionIDInput | null,
  readId?: ModelSubscriptionIDInput | null,
  clientId?: ModelSubscriptionIDInput | null,
  and?: Array< ModelSubscriptionTechnicFilterInput | null > | null,
  or?: Array< ModelSubscriptionTechnicFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionTechnicLibraryFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  communicationSettingsProfileId?: ModelSubscriptionIDInput | null,
  criticality?: ModelSubscriptionStringInput | null,
  isDefault?: ModelSubscriptionBooleanInput | null,
  issuingAuthority?: ModelSubscriptionStringInput | null,
  linkedCertificateIds?: ModelSubscriptionIDInput | null,
  locationScope?: ModelSubscriptionStringInput | null,
  status?: ModelSubscriptionStringInput | null,
  tagIds?: ModelSubscriptionIDInput | null,
  technicLibraryFormat?: ModelSubscriptionStringInput | null,
  type?: ModelSubscriptionStringInput | null,
  readId?: ModelSubscriptionIDInput | null,
  clientId?: ModelSubscriptionIDInput | null,
  and?: Array< ModelSubscriptionTechnicLibraryFilterInput | null > | null,
  or?: Array< ModelSubscriptionTechnicLibraryFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionTicketFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  assignedAt?: ModelSubscriptionStringInput | null,
  assignedToId?: ModelSubscriptionIDInput | null,
  buildingId?: ModelSubscriptionIDInput | null,
  closedAt?: ModelSubscriptionStringInput | null,
  contactId?: ModelSubscriptionIDInput | null,
  content?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  emailMessageId?: ModelSubscriptionStringInput | null,
  emailReferences?: ModelSubscriptionStringInput | null,
  parentId?: ModelSubscriptionIDInput | null,
  plannedAt?: ModelSubscriptionStringInput | null,
  referenceCode?: ModelSubscriptionStringInput | null,
  sourceType?: ModelSubscriptionStringInput | null,
  status?: ModelSubscriptionStringInput | null,
  subject?: ModelSubscriptionStringInput | null,
  unitId?: ModelSubscriptionIDInput | null,
  unread?: ModelSubscriptionBooleanInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionTicketFilterInput | null > | null,
  or?: Array< ModelSubscriptionTicketFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionUnitFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  acquisitionAdditionalCostsValue?: ModelSubscriptionFloatInput | null,
  acquisitionAdvertisedValue?: ModelSubscriptionFloatInput | null,
  acquisitionValue?: ModelSubscriptionFloatInput | null,
  advertisedMonthlyCharges?: ModelSubscriptionFloatInput | null,
  advertisedRentalPrice?: ModelSubscriptionFloatInput | null,
  cadastralIncome?: ModelSubscriptionFloatInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  floor?: ModelSubscriptionIntInput | null,
  jointOwnershipId?: ModelSubscriptionIDInput | null,
  managementDate?: ModelSubscriptionStringInput | null,
  name?: ModelSubscriptionStringInput | null,
  notes?: ModelSubscriptionStringInput | null,
  predictedPrice?: ModelSubscriptionStringInput | null,
  propertyTax?: ModelSubscriptionFloatInput | null,
  publishAddress?: ModelSubscriptionBooleanInput | null,
  surface?: ModelSubscriptionFloatInput | null,
  type?: ModelSubscriptionStringInput | null,
  buildingId?: ModelSubscriptionIDInput | null,
  unitAdvertisementId?: ModelSubscriptionIDInput | null,
  and?: Array< ModelSubscriptionUnitFilterInput | null > | null,
  or?: Array< ModelSubscriptionUnitFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionUnitEventFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  unitId?: ModelSubscriptionIDInput | null,
  type?: ModelSubscriptionStringInput | null,
  startDate?: ModelSubscriptionStringInput | null,
  endDate?: ModelSubscriptionStringInput | null,
  totalCost?: ModelSubscriptionFloatInput | null,
  note?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionUnitEventFilterInput | null > | null,
  or?: Array< ModelSubscriptionUnitEventFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionUnitInventoryFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  privateBatthRoom?: ModelSubscriptionBooleanInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  deletedAt?: ModelSubscriptionStringInput | null,
  kitchenEquipment?: ModelSubscriptionStringInput | null,
  roomName?: ModelSubscriptionStringInput | null,
  roomType?: ModelSubscriptionStringInput | null,
  surface?: ModelSubscriptionFloatInput | null,
  showSurface?: ModelSubscriptionBooleanInput | null,
  unitId?: ModelSubscriptionIDInput | null,
  inside?: ModelSubscriptionBooleanInput | null,
  and?: Array< ModelSubscriptionUnitInventoryFilterInput | null > | null,
  or?: Array< ModelSubscriptionUnitInventoryFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionUnitLeaseFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  allowChargeAdjustment?: ModelSubscriptionBooleanInput | null,
  authorizeProfessionalActivity?: ModelSubscriptionBooleanInput | null,
  chargesIndexation?: ModelSubscriptionBooleanInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  endDate?: ModelSubscriptionStringInput | null,
  furnishedRental?: ModelSubscriptionBooleanInput | null,
  furnishedRentalInsuranceByTenant?: ModelSubscriptionBooleanInput | null,
  furnishedRentalRentalPricePercentage?: ModelSubscriptionFloatInput | null,
  initialRentalPrice?: ModelSubscriptionFloatInput | null,
  indexation?: ModelSubscriptionBooleanInput | null,
  advancedIndexation?: ModelSubscriptionBooleanInput | null,
  indexType?: ModelSubscriptionStringInput | null,
  baseYear?: ModelSubscriptionFloatInput | null,
  baseIndexType?: ModelSubscriptionStringInput | null,
  baseIndexDate?: ModelSubscriptionStringInput | null,
  nextIndexationMonth?: ModelSubscriptionStringInput | null,
  nextIndexation?: ModelSubscriptionBooleanInput | null,
  leaseId?: ModelSubscriptionIDInput | null,
  mainUnit?: ModelSubscriptionBooleanInput | null,
  rentalPrice?: ModelSubscriptionFloatInput | null,
  signatureDate?: ModelSubscriptionStringInput | null,
  startDate?: ModelSubscriptionStringInput | null,
  unitId?: ModelSubscriptionIDInput | null,
  and?: Array< ModelSubscriptionUnitLeaseFilterInput | null > | null,
  or?: Array< ModelSubscriptionUnitLeaseFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionUnitOwnerFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  disabled?: ModelSubscriptionBooleanInput | null,
  ownerId?: ModelSubscriptionIDInput | null,
  periodFrom?: ModelSubscriptionStringInput | null,
  periodTo?: ModelSubscriptionStringInput | null,
  stake?: ModelSubscriptionFloatInput | null,
  unitId?: ModelSubscriptionIDInput | null,
  and?: Array< ModelSubscriptionUnitOwnerFilterInput | null > | null,
  or?: Array< ModelSubscriptionUnitOwnerFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionTeamFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  name?: ModelSubscriptionStringInput | null,
  parentId?: ModelSubscriptionIDInput | null,
  and?: Array< ModelSubscriptionTeamFilterInput | null > | null,
  or?: Array< ModelSubscriptionTeamFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionUserFilterInput = {
  email?: ModelSubscriptionStringInput | null,
  firstName?: ModelSubscriptionStringInput | null,
  lastName?: ModelSubscriptionStringInput | null,
  cognitoSub?: ModelSubscriptionIDInput | null,
  googleSub?: ModelSubscriptionIDInput | null,
  facebookSub?: ModelSubscriptionIDInput | null,
  rootUser?: ModelSubscriptionBooleanInput | null,
  refreshToken?: ModelSubscriptionBooleanInput | null,
  userRoleId?: ModelSubscriptionIDInput | null,
  contactId?: ModelSubscriptionIDInput | null,
  status?: ModelSubscriptionStringInput | null,
  _ttl?: ModelSubscriptionIntInput | null,
  and?: Array< ModelSubscriptionUserFilterInput | null > | null,
  or?: Array< ModelSubscriptionUserFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionUserRoleFilterInput = {
  name?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionUserRoleFilterInput | null > | null,
  or?: Array< ModelSubscriptionUserRoleFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionUserTeamFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  userId?: ModelSubscriptionIDInput | null,
  teamId?: ModelSubscriptionIDInput | null,
  and?: Array< ModelSubscriptionUserTeamFilterInput | null > | null,
  or?: Array< ModelSubscriptionUserTeamFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type CreateClientAccountMutationVariables = {
  input: CreateClientAccountInput,
};

export type CreateClientAccountMutation = {
  createClientAccount?:  {
    __typename: "MutationStatus",
    status?: boolean | null,
    id: string,
  } | null,
};

export type InviteUserToClientAccountMutationVariables = {
  input: InviteUserToClientAccountInput,
};

export type InviteUserToClientAccountMutation = {
  inviteUserToClientAccount?:  {
    __typename: "MutationStatus",
    status?: boolean | null,
    id: string,
  } | null,
};

export type InviteContactToClientAccountMutationVariables = {
  input: InviteContactToClientAccountInput,
};

export type InviteContactToClientAccountMutation = {
  inviteContactToClientAccount?:  {
    __typename: "MutationStatus",
    status?: boolean | null,
    id: string,
  } | null,
};

export type IsEmailAlreadyTakenMutationVariables = {
  input: IsEmailAlreadyTakenInput,
};

export type IsEmailAlreadyTakenMutation = {
  isEmailAlreadyTaken?:  {
    __typename: "StatusResult",
    success: boolean,
    message?: string | null,
  } | null,
};

export type RevokePontoIntegrationMutationVariables = {
  input: RevokePontoIntegrationInput,
};

export type RevokePontoIntegrationMutation = {
  revokePontoIntegration?:  {
    __typename: "MutationStatus",
    status?: boolean | null,
    id: string,
  } | null,
};

export type VerifyPontoIntegrationMutationVariables = {
  input: VerifyPontoIntegrationInput,
};

export type VerifyPontoIntegrationMutation = {
  verifyPontoIntegration?:  {
    __typename: "MutationStatus",
    status?: boolean | null,
    id: string,
  } | null,
};

export type ProcessOcrMutationVariables = {
  input: ProcessOcrInput,
};

export type ProcessOcrMutation = {
  processOcr?:  {
    __typename: "MutationStatus",
    status?: boolean | null,
    id: string,
  } | null,
};

export type HandleAdvertisementPublishingMutationVariables = {
  input: AdvertisementPublishingInput,
};

export type HandleAdvertisementPublishingMutation = {
  handleAdvertisementPublishing?:  {
    __typename: "AdvertisementPostingMutationStatus",
    id: string,
    statusList?:  Array< {
      __typename: "AdvertisementPostingStatus",
      publishingPlatform: PublishingPlatform,
      status: boolean,
      successCode: number,
    } > | null,
    errorMessage?: string | null,
  } | null,
};

export type GenerateReportMutationVariables = {
  input: GenerateReportInput,
};

export type GenerateReportMutation = {
  generateReport?:  {
    __typename: "GenerateReportResult",
    errorCode?: GenerateReportErrorCode | null,
    status: boolean,
  } | null,
};

export type CreatePeppolDocumentMutationVariables = {
  input: CreatePeppolDocumentInput,
};

export type CreatePeppolDocumentMutation = {
  createPeppolDocument:  {
    __typename: "CreatePeppolDocumentResponse",
    size: number,
    status: string,
  },
};

export type ResendInvoiceToPeppolMutationVariables = {
  input: ResendInvoiceToPeppolInput,
};

export type ResendInvoiceToPeppolMutation = {
  resendInvoiceToPeppol?:  {
    __typename: "StatusResult",
    success: boolean,
    message?: string | null,
  } | null,
};

export type SendInvoiceToPeppolMutationVariables = {
  input: SendInvoiceToPeppolInput,
};

export type SendInvoiceToPeppolMutation = {
  sendInvoiceToPeppol:  {
    __typename: "StatusResult",
    success: boolean,
    message?: string | null,
  },
};

export type VerifyPeppolContactMutationVariables = {
  input: VerifyPeppolContactInput,
};

export type VerifyPeppolContactMutation = {
  verifyPeppolContact:  {
    __typename: "VerifyPeppolContactResponse",
    contactId: string,
    isContactVerified: boolean,
  },
};

export type BatchChangeCommunicationsMutationVariables = {
  input: BatchChangeCommunicationsInput,
};

export type BatchChangeCommunicationsMutation = {
  batchChangeCommunications?:  {
    __typename: "MutationStatus",
    status?: boolean | null,
    id: string,
  } | null,
};

export type DecideLeasePriceHistoriesMutationVariables = {
  input: DecideLeasePriceHistoriesInput,
};

export type DecideLeasePriceHistoriesMutation = {
  decideLeasePriceHistories?:  {
    __typename: "DecideLeasePriceHistoriesResult",
    failed:  Array< {
      __typename: "DecideLeasePriceHistoryFailure",
      id: string,
      reason: DecideLeasePriceHistoryFailureReason,
    } >,
    succeededIds: Array< string >,
  } | null,
};

export type DownloadCommunicationsMutationVariables = {
  input: DownloadCommunicationsInput,
};

export type SubmitCommunicationDialogMutationVariables = {
  input: SubmitCommunicationDialogInput,
};

export type DownloadCommunicationsMutation = {
  downloadCommunications?:  {
    __typename: "DownloadCommunicationsResult",
    key?: string | null,
    success: boolean,
    zipUrl?: string | null,
  } | null,
};

export type ConvertHeicToJpegMutationVariables = {
  input: ConvertHeicToJpegInput,
};

export type ConvertHeicToJpegMutation = {
  convertHeicToJpeg?:  {
    __typename: "ConvertHeicToJpegResult",
    fileUrl: string,
    fileKey: string,
  } | null,
};

export type TranslateTextMutationVariables = {
  input: TranslateTextInput,
};

export type TranslateTextMutation = {
  translateText?:  {
    __typename: "TranslateTextResult",
    success: boolean,
    result?: string | null,
  } | null,
};

export type GenerateDocumentMutationVariables = {
  input: GenerateDocumentInput,
};

export type GenerateDocumentMutation = {
  generateDocument?:  {
    __typename: "MutationStatus",
    status?: boolean | null,
    id: string,
  } | null,
};

export type RejectDocumentMutationVariables = {
  input: RejectDocumentInput,
};

export type RejectDocumentMutation = {
  rejectDocument?:  {
    __typename: "MutationStatus",
    status?: boolean | null,
    id: string,
  } | null,
};

export type RemindSignatureDocumentMutationVariables = {
  input: RemindSignatureDocumentInput,
};

export type RemindSignatureDocumentMutation = {
  remindSignatureDocument?:  {
    __typename: "MutationStatus",
    status?: boolean | null,
    id: string,
  } | null,
};

export type SignatureFilesQueryVariables = {
  input: SignatureFilesInput,
};

export type SignatureFilesQuery = {
  signatureFiles: Array<FileDTO>,
};

export type GetDownloadZipFileUrlMutationVariables = {
  input: DownloadFoldersInput,
};

export type GetDownloadZipFileUrlMutation = {
  getDownloadZipFileUrl?:  {
    __typename: "StatusResult",
    success: boolean,
    message?: string | null,
  } | null,
};

export type ChangeProfessionalActivityForLeaseMutationVariables = {
  input: ChangeProfessionalActivityForLeaseInput,
};

export type ChangeProfessionalActivityForLeaseMutation = {
  changeProfessionalActivityForLease?:  {
    __typename: "MutationStatus",
    status?: boolean | null,
    id: string,
  } | null,
};

export type RecordEarlyDepartureMutationVariables = {
  input: RecordEarlyDepartureInput,
};

export type RecordEarlyDepartureMutation = {
  recordEarlyDeparture?:  {
    __typename: "MutationStatus",
    status?: boolean | null,
    id: string,
  } | null,
};

export type VerifyPendingSendingSourceMutationVariables = {
  input: VerifyPendingSendingSourceInput,
};

export type VerifyPendingSendingSourceMutation = {
  verifyPendingSendingSource?:  {
    __typename: "MutationStatus",
    status?: boolean | null,
    id: string,
  } | null,
};

export type RecalculateStatementMutationVariables = {
  input: RecalculateStatementInput,
};

export type RecalculateStatementMutation = {
  recalculateStatement?:  {
    __typename: "MutationStatus",
    status?: boolean | null,
    id: string,
  } | null,
};

export type DeleteEntityByIdMutationVariables = {
  input: DeleteEntityByIdInput,
};

export type DeleteEntityByIdMutation = {
  deleteEntityById?:  {
    __typename: "MutationStatus",
    status?: boolean | null,
    id: string,
  } | null,
};

export type ArchiveEntityMutationVariables = {
  input: ArchiveEntityInput,
};

export type ArchiveEntityMutation = {
  archiveEntity?:  {
    __typename: "MutationStatus",
    status?: boolean | null,
    id: string,
  } | null,
};

export type HandleUserRightsChangeMutationVariables = {
  input: UserRightsChangeInput,
};

export type HandleUserRightsChangeMutation = {
  handleUserRightsChange?:  {
    __typename: "MutationStatus",
    status?: boolean | null,
    id: string,
  } | null,
};

export type UpdateUserCustomMutationVariables = {
  input: MutationUserInput,
};

export type UpdateUserCustomMutation = {
  updateUserCustom?:  {
    __typename: "StatusResult",
    success: boolean,
    message?: string | null,
  } | null,
};

export type CreateAndValidateCompanyInvoiceMutationVariables = {
  input: CreateCompanyInvoiceInput,
};

export type CreateAndValidateCompanyInvoiceMutation = {
  createAndValidateCompanyInvoice?:  {
    __typename: "MutationStatus",
    status?: boolean | null,
    id: string,
  } | null,
};

export type UpdateCompanyInvoiceMutationVariables = {
  input: UpdateCompanyInvoiceInput,
};

export type UpdateCompanyInvoiceMutation = {
  updateCompanyInvoice?:  {
    __typename: "MutationStatus",
    status?: boolean | null,
    id: string,
  } | null,
};

export type DuplicateCompanyInvoiceMutationVariables = {
  input: DuplicateCompanyInvoiceInput,
};

export type DuplicateCompanyInvoiceMutation = {
  duplicateCompanyInvoice?:  {
    __typename: "MutationStatus",
    status?: boolean | null,
    id: string,
  } | null,
};

export type ReverseCompanyInvoiceMutationVariables = {
  input: ReverseCompanyInvoiceInput,
};

export type ReverseCompanyInvoiceMutation = {
  reverseCompanyInvoice?:  {
    __typename: "MutationStatus",
    status?: boolean | null,
    id: string,
  } | null,
};

export type ValidateInvoiceMutationVariables = {
  input: ValidateInvoiceInput,
};

export type ValidateInvoiceMutation = {
  validateInvoice?:  {
    __typename: "MutationStatus",
    status?: boolean | null,
    id: string,
  } | null,
};

export type ResetInvoiceToDraftMutationVariables = {
  input: ResetInvoiceToDraftInput,
};

export type ResetInvoiceToDraftMutation = {
  resetInvoiceToDraft?:  {
    __typename: "MutationStatus",
    status?: boolean | null,
    id: string,
  } | null,
};

export type SendInvoiceMutationVariables = {
  input: SendInvoiceInput,
};

export type SendInvoiceMutation = {
  sendInvoice?:  {
    __typename: "MutationStatus",
    status?: boolean | null,
    id: string,
  } | null,
};

export type UpdateLeaseBillingItemMutationVariables = {
  input: UpdateLeaseBillingItemInput,
};

export type UpdateLeaseBillingItemMutation = {
  updateLeaseBillingItem:  {
    __typename: "UpdateLeaseBillingItemResult",
    id: string,
    status: UpdateLeaseBillingItemStatus,
    invoiceId?: string | null,
    creditNoteId?: string | null,
  },
};

export type DeleteDraftInvoiceMutationVariables = {
  input: DeleteDraftInvoiceInput,
};

export type DeleteDraftInvoiceMutation = {
  deleteDraftInvoice?:  {
    __typename: "MutationStatus",
    status?: boolean | null,
    id: string,
  } | null,
};

export type ChangeTransactionLinksMutationVariables = {
  input: ChangeTransactionLinksInput,
};

export type ChangeTransactionLinksMutation = {
  changeTransactionLinks?:  {
    __typename: "TransactionsUpdatedStatus",
    id: string,
    status?: boolean | null,
    transactionIdsUpdated?: Array< string > | null,
  } | null,
};

export type ReconcileTransactionWithTransactionMutationVariables = {
  input: ReconcileTransactionWithTransactionInput,
};

export type ReconcileTransactionWithTransactionMutation = {
  reconcileTransactionWithTransaction?:  {
    __typename: "MutationStatus",
    status?: boolean | null,
    id: string,
  } | null,
};

export type ReconcileTransactionWithInvoicesMutationVariables = {
  input: ReconcileTransactionWithInvoicesInput,
};

export type ReconcileTransactionWithInvoicesMutation = {
  reconcileTransactionWithInvoices?:  {
    __typename: "MutationStatus",
    status?: boolean | null,
    id: string,
  } | null,
};

export type ReconcileInvoicesWithCreditNotesMutationVariables = {
  input: ReconcileInvoicesWithCreditNotesInput,
};

export type ReconcileInvoicesWithCreditNotesMutation = {
  reconcileInvoicesWithCreditNotes?:  {
    __typename: "MutationStatus",
    status?: boolean | null,
    id: string,
  } | null,
};

export type ReconcilePendingBalanceWithInvoicesMutationVariables = {
  input: ReconcilePendingBalanceWithInvoicesInput,
};

export type ReconcilePendingBalanceWithInvoicesMutation = {
  reconcilePendingBalanceWithInvoices?:  {
    __typename: "MutationStatus",
    status?: boolean | null,
    id: string,
  } | null,
};

export type UnreconcileTransactionOrInvoicesMutationVariables = {
  input: UnreconcileTransactionOrInvoicesInput,
};

export type UnreconcileTransactionOrInvoicesMutation = {
  unreconcileTransactionOrInvoices?:  {
    __typename: "MutationStatus",
    status?: boolean | null,
    id: string,
  } | null,
};

export type ReverseTransactionMutationVariables = {
  input: ReverseTransactionInput,
};

export type ReverseTransactionMutation = {
  reverseTransaction?:  {
    __typename: "MutationStatus",
    status?: boolean | null,
    id: string,
  } | null,
};

export type SnoozeTransactionMutationVariables = {
  input: SnoozeTransactionInput,
};

export type SnoozeTransactionMutation = {
  snoozeTransaction?:  {
    __typename: "MutationStatus",
    status?: boolean | null,
    id: string,
  } | null,
};

export type WriteOffPendingBalanceMutationVariables = {
  input: WriteOffPendingBalanceInput,
};

export type WriteOffPendingBalanceMutation = {
  writeOffPendingBalance?:  {
    __typename: "MutationStatus",
    status?: boolean | null,
    id: string,
  } | null,
};

export type OpenInvoiceDisputeMutationVariables = {
  input: OpenInvoiceDisputeInput,
};

export type OpenInvoiceDisputeMutation = {
  openInvoiceDispute?:  {
    __typename: "MutationStatus",
    status?: boolean | null,
    id: string,
  } | null,
};

export type LiftInvoiceDisputeMutationVariables = {
  input: LiftInvoiceDisputeInput,
};

export type LiftInvoiceDisputeMutation = {
  liftInvoiceDispute?:  {
    __typename: "MutationStatus",
    status?: boolean | null,
    id: string,
  } | null,
};

export type EditPrivateAccountTransactionAmountMutationVariables = {
  input: EditPrivateAccountTransactionAmountInput,
};

export type EditPrivateAccountTransactionAmountMutation = {
  editPrivateAccountTransactionAmount?:  {
    __typename: "MutationStatus",
    status?: boolean | null,
    id: string,
  } | null,
};

export type CreatePaymentProviderAccountMutationVariables = {
  input: CreatePaymentProviderAccountInput,
};

export type CreatePaymentProviderAccountMutation = {
  createPaymentProviderAccount?:  {
    __typename: "CreatePaymentProviderAccountResult",
    url?: string | null,
  } | null,
};

export type CreateMandateLinkMutationVariables = {
  input: CreateMandateLinkInput,
};

export type CreateMandateLinkMutation = {
  createMandateLink?:  {
    __typename: "MutationStatus",
    status?: boolean | null,
    id: string,
  } | null,
};

export type CreatePaymentLinkMutationVariables = {
  input: CreatePaymentLinkInput,
};

export type CreatePaymentLinkMutation = {
  createPaymentLink?:  {
    __typename: "MutationStatus",
    status?: boolean | null,
    id: string,
  } | null,
};

export type ChargeInvoiceByMandateMutationVariables = {
  input: ChargeInvoiceByMandateInput,
};

export type ChargeInvoiceByMandateMutation = {
  chargeInvoiceByMandate?:  {
    __typename: "MutationStatus",
    status?: boolean | null,
    id: string,
  } | null,
};

export type AutoReconcilePaymentProviderPayoutMutationVariables = {
  input: AutoReconcilePaymentProviderPayoutInput,
};

export type AutoReconcilePaymentProviderPayoutMutation = {
  autoReconcilePaymentProviderPayout?:  {
    __typename: "MutationStatus",
    status?: boolean | null,
    id: string,
  } | null,
};

export type CreateU2REntitiesFromExactOnlineMutationVariables = {
  input: CreateU2REntitiesFromExactOnlineInput,
};

export type CreateU2REntitiesFromExactOnlineMutation = {
  createU2REntitiesFromExactOnline?: string | null,
};

export type GetExactOnlineClientIdMutationVariables = {
  input: GetExactOnlineClientIdInput,
};

export type GetExactOnlineClientIdMutation = {
  getExactOnlineClientId?: string | null,
};

export type GetExactOnlineEntitiesMutationVariables = {
  input: GetExactOnlineEntitiesInput,
};

export type GetExactOnlineEntitiesMutation = {
  getExactOnlineEntities?: string | null,
};

export type SynchronizeExactOnlineMutationVariables = {
  input: SynchronizeExactOnlineInput,
};

export type SynchronizeExactOnlineMutation = {
  synchronizeExactOnline?: string | null,
};

export type SaveExactOnlineEntitiesMatchingMutationVariables = {
  input: SaveExactOnlineEntitiesMatchingInput,
};

export type SaveExactOnlineEntitiesMatchingMutation = {
  saveExactOnlineEntitiesMatching?: string | null,
};

export type VerifyExactOnlineIntegrationMutationVariables = {
  input: VerifyExactOnlineIntegrationInput,
};

export type VerifyExactOnlineIntegrationMutation = {
  verifyExactOnlineIntegration?: string | null,
};

export type CreateAccountLabelMutationVariables = {
  input: CreateAccountLabelInput,
  condition?: ModelAccountLabelConditionInput | null,
};

export type CreateAccountLabelMutation = {
  createAccountLabel?:  {
    __typename: "AccountLabel",
    id: string,
    labels?:  Array< {
      __typename: "CustomLabel",
      language: string,
      label: string,
    } > | null,
    bankAccountId?: string | null,
    bankAccount?:  {
      __typename: "BankAccount",
      id: string,
      contactId: string,
      contact?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      number: string,
      bicNumber?: string | null,
      bankName?: string | null,
      contactIds?: Array< string > | null,
      buildingIds?: Array< string > | null,
      holderName?: string | null,
      label?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      disabled?: boolean | null,
      integrations?: Array< IntegrationName > | null,
      matchingRule?: BankAccountMatchingRule | null,
      balance?: number | null,
      balanceDate?: string | null,
      type: BankAccountType,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    contactId?: string | null,
    contact?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    class: number,
    customUsage?: AccountLabelCustomUsage | null,
    customValues?:  Array< {
      __typename: "CustomValue",
      name: string,
      value: string,
    } > | null,
    disabled?: boolean | null,
    ownerId?: string | null,
    owner?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    topClass: number,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateAccountLabelMutationVariables = {
  input: UpdateAccountLabelInput,
  condition?: ModelAccountLabelConditionInput | null,
};

export type UpdateAccountLabelMutation = {
  updateAccountLabel?:  {
    __typename: "AccountLabel",
    id: string,
    labels?:  Array< {
      __typename: "CustomLabel",
      language: string,
      label: string,
    } > | null,
    bankAccountId?: string | null,
    bankAccount?:  {
      __typename: "BankAccount",
      id: string,
      contactId: string,
      contact?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      number: string,
      bicNumber?: string | null,
      bankName?: string | null,
      contactIds?: Array< string > | null,
      buildingIds?: Array< string > | null,
      holderName?: string | null,
      label?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      disabled?: boolean | null,
      integrations?: Array< IntegrationName > | null,
      matchingRule?: BankAccountMatchingRule | null,
      balance?: number | null,
      balanceDate?: string | null,
      type: BankAccountType,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    contactId?: string | null,
    contact?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    class: number,
    customUsage?: AccountLabelCustomUsage | null,
    customValues?:  Array< {
      __typename: "CustomValue",
      name: string,
      value: string,
    } > | null,
    disabled?: boolean | null,
    ownerId?: string | null,
    owner?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    topClass: number,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteAccountLabelMutationVariables = {
  input: DeleteAccountLabelInput,
  condition?: ModelAccountLabelConditionInput | null,
};

export type DeleteAccountLabelMutation = {
  deleteAccountLabel?:  {
    __typename: "AccountLabel",
    id: string,
    labels?:  Array< {
      __typename: "CustomLabel",
      language: string,
      label: string,
    } > | null,
    bankAccountId?: string | null,
    bankAccount?:  {
      __typename: "BankAccount",
      id: string,
      contactId: string,
      contact?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      number: string,
      bicNumber?: string | null,
      bankName?: string | null,
      contactIds?: Array< string > | null,
      buildingIds?: Array< string > | null,
      holderName?: string | null,
      label?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      disabled?: boolean | null,
      integrations?: Array< IntegrationName > | null,
      matchingRule?: BankAccountMatchingRule | null,
      balance?: number | null,
      balanceDate?: string | null,
      type: BankAccountType,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    contactId?: string | null,
    contact?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    class: number,
    customUsage?: AccountLabelCustomUsage | null,
    customValues?:  Array< {
      __typename: "CustomValue",
      name: string,
      value: string,
    } > | null,
    disabled?: boolean | null,
    ownerId?: string | null,
    owner?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    topClass: number,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreatePostingMutationVariables = {
  input: CreatePostingInput,
  condition?: ModelPostingConditionInput | null,
};

export type CreatePostingMutation = {
  createPosting?:  {
    __typename: "Posting",
    id: string,
    createdAt?: string | null,
    class: number,
    customLabel?: string | null,
    customValues?:  Array< {
      __typename: "CustomValue",
      name: string,
      value: string,
    } > | null,
    topClass: number,
    type: PostingType,
    totalAmount: number,
    periodFrom: string,
    periodTo: string,
    buildingId?: string | null,
    building?:  {
      __typename: "Building",
      id: string,
      name: string,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      acquisitionValue?: number | null,
      acquisitionAdditionalCostsValue?: number | null,
      acquisitionAdvertisedValue?: number | null,
      amountOfFacades?: number | null,
      amountOfFloors?: number | null,
      amountOfHousings?: number | null,
      buildingState?: BuildingState | null,
      cadastralIncome?: number | null,
      constructionYear?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      janitor?: boolean | null,
      jointOwnershipId?: string | null,
      notes?: string | null,
      owners?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      propertyTax?: number | null,
      residenceName?: string | null,
      buildingSiteId?: string | null,
      buildingSite?:  {
        __typename: "BuildingSite",
        id: string,
        name: string,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      units?:  {
        __typename: "ModelUnitConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      events?:  {
        __typename: "ModelBuildingEventConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      teams?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    unitId?: string | null,
    unit?:  {
      __typename: "Unit",
      id: string,
      acquisitionAdditionalCostsValue?: number | null,
      acquisitionAdvertisedValue?: number | null,
      acquisitionValue?: number | null,
      advertisedMonthlyCharges?: number | null,
      advertisedRentalPrice?: number | null,
      cadastralIncome?: number | null,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      floor?: number | null,
      jointOwnershipId?: string | null,
      managementDate: string,
      name: string,
      notes?: string | null,
      predictedPrice?: string | null,
      propertyTax?: number | null,
      publishAddress?: boolean | null,
      surface?: number | null,
      type: UnitType,
      buildingId: string,
      building?:  {
        __typename: "Building",
        id: string,
        name: string,
        addressId?: string | null,
        acquisitionValue?: number | null,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        amountOfFacades?: number | null,
        amountOfFloors?: number | null,
        amountOfHousings?: number | null,
        buildingState?: BuildingState | null,
        cadastralIncome?: number | null,
        constructionYear?: string | null,
        janitor?: boolean | null,
        jointOwnershipId?: string | null,
        notes?: string | null,
        propertyTax?: number | null,
        residenceName?: string | null,
        buildingSiteId?: string | null,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      owners?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leases?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      events?:  {
        __typename: "ModelUnitEventConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      unitAdvertisementId?: string | null,
      unitInventories?:  {
        __typename: "ModelUnitInventoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    invoiceId?: string | null,
    invoice?:  {
      __typename: "Invoice",
      id: string,
      amount: number,
      bankAccountId: string,
      bankAccount?:  {
        __typename: "BankAccount",
        id: string,
        contactId: string,
        number: string,
        bicNumber?: string | null,
        bankName?: string | null,
        contactIds?: Array< string > | null,
        buildingIds?: Array< string > | null,
        holderName?: string | null,
        label?: string | null,
        disabled?: boolean | null,
        integrations?: Array< IntegrationName > | null,
        matchingRule?: BankAccountMatchingRule | null,
        balance?: number | null,
        balanceDate?: string | null,
        type: BankAccountType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      communicationId?: string | null,
      communication?:  {
        __typename: "Communication",
        id: string,
        addressId?: string | null,
        body: string,
        buildingId?: string | null,
        channel: CommunicationChannel,
        communicationTemplateId?: string | null,
        concernedContactIds?: Array< string > | null,
        contactId?: string | null,
        contactIds?: Array< string > | null,
        createdAt?: string | null,
        expirationDate?: string | null,
        invoiceId?: string | null,
        leaseId?: string | null,
        leasePriceHistoryId?: string | null,
        letterTrackingCode?: string | null,
        letterTrackingProvider?: TrackingProvider | null,
        linkedCommunicationsIds?: Array< string > | null,
        supportingDocumentFileIds?: Array< string > | null,
        recipient?: string | null,
        recipientContactIdsInBcc?: Array< string > | null,
        recipientContactIdsInCc?: Array< string > | null,
        recipientInBcc?: string | null,
        recipientInCc?: string | null,
        scheduledAt?: string | null,
        deliveredAt?: string | null,
        errorCode?: CommunicationErrorCode | null,
        nextRetryAt?: string | null,
        sendRetryCount?: number | null,
        sender?: string | null,
        sentAt?: string | null,
        externalId?: string | null,
        externalStatus?: string | null,
        signatureDocumentId?: string | null,
        snoozedDate?: string | null,
        statementId?: string | null,
        status: CommunicationStatus,
        subject: string,
        toSend: boolean,
        hideLogo?: boolean | null,
        type: CommunicationType,
        _ttl?: number | null,
        unitId?: string | null,
        readId: string,
        readers?: Array< string > | null,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      createdAt: string,
      creditNote?: boolean | null,
      creditNoteLabel?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      dueDate?: string | null,
      invoiceDate: string,
      invoiceNumber?: string | null,
      ownerId?: string | null,
      owner?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      invoiceSenderId: string,
      invoiceSender?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      leaseId?: string | null,
      lease?:  {
        __typename: "Lease",
        id: string,
        balance?: number | null,
        canBeExtended?: boolean | null,
        communicationSettingsProfileId: string,
        createdAt?: string | null,
        endDate: string,
        includeRealEstateInLeaseContract?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        invoiceSenderId: string,
        inventoryOfFixturesExpert?: string | null,
        inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
        inventoryOfFixturesType?: InventoryOfFixturesType | null,
        ipiNumber?: string | null,
        language: Language,
        lastDraftInvoiceDate?: string | null,
        lastIndexationProcessDate?: string | null,
        lastInvoiceDate?: string | null,
        legalCompetentAuthority?: string | null,
        name: string,
        notes?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        purchaseOrderNumber?: string | null,
        realEstateAgency?: string | null,
        realEstateTax?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        signatureDate?: string | null,
        startDate: string,
        nextIndexationMonth?: string | null,
        nextIndexation?: boolean | null,
        status: LeaseStatus,
        technicCommunicationSettingsProfileId: string,
        totalInitialRentalPrice: number,
        totalRentalPrice: number,
        type: LeaseType,
        subletting?: boolean | null,
        vatRateRentId?: string | null,
        bankAccountId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      paid: boolean,
      integrations?:  {
        __typename: "InvoiceIntegrations",
      } | null,
      postedDate?: string | null,
      purchaseOrderNumber?: string | null,
      receiptNumber?: string | null,
      reminderDates?: Array< string > | null,
      note?: string | null,
      remittanceInformation?: string | null,
      statementId?: string | null,
      statement?:  {
        __typename: "Statement",
        id: string,
        closingStatement: boolean,
        periodFrom: string,
        periodTo: string,
        attachSupportingDocuments?: boolean | null,
        selectedPocketKeys?: Array< string > | null,
        source: StatementSource,
        status: StatementStatus,
        sentDate?: string | null,
        leaseId?: string | null,
        ownerId?: string | null,
        types?: Array< StatementType > | null,
        viewType: StatementViewType,
        unitIds?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      status: InvoiceStatus,
      type: InvoiceType,
      unitId?: string | null,
      unit?:  {
        __typename: "Unit",
        id: string,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        acquisitionValue?: number | null,
        advertisedMonthlyCharges?: number | null,
        advertisedRentalPrice?: number | null,
        cadastralIncome?: number | null,
        createdAt?: string | null,
        floor?: number | null,
        jointOwnershipId?: string | null,
        managementDate: string,
        name: string,
        notes?: string | null,
        predictedPrice?: string | null,
        propertyTax?: number | null,
        publishAddress?: boolean | null,
        surface?: number | null,
        type: UnitType,
        buildingId: string,
        unitAdvertisementId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      reversedInvoiceId?: string | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    chargeId?: string | null,
    charge?:  {
      __typename: "Charge",
      id: string,
      status: ChargeStatus,
      invoiceDate?: string | null,
      paymentDueDate?: string | null,
      archivedDate?: string | null,
      periodFrom?: string | null,
      periodTo?: string | null,
      totalAmount?: number | null,
      source: ChargeSource,
      draftFromOcr?: boolean | null,
      accountingDocumentId?: string | null,
      paid: boolean,
      remittanceInformation?: string | null,
      note?: string | null,
      createdAt: string,
      creatorEmail?: string | null,
      createdById?: string | null,
      createdBy?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contractorId?: string | null,
      contractor?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      proposedContractors?:  Array< {
        __typename: "ProposedValue",
        id: string,
        confidence?: number | null,
      } > | null,
      recipientId?: string | null,
      recipient?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      proposedRecipients?:  Array< {
        __typename: "ProposedValue",
        id: string,
        confidence?: number | null,
      } > | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      documentId: string,
      document?:  {
        __typename: "File",
        id: string,
        bucket: string,
        createdAt?: string | null,
        categoryId: string,
        foreignKey: string,
        foreignTableName: string,
        key: string,
        mimeType?: string | null,
        region: string,
        size?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        _ttl?: number | null,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      postings?:  {
        __typename: "ModelPostingConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    transactionId?: string | null,
    transaction?:  {
      __typename: "Transaction",
      id: string,
      status: TransactionStatus,
      sequence?: number | null,
      statementDate: string,
      operationDate?: string | null,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      remittanceInformationType?: RemittanceType | null,
      remittanceInformation?: string | null,
      comment?: string | null,
      amount: number,
      bankAccountId: string,
      bankAccount?:  {
        __typename: "BankAccount",
        id: string,
        contactId: string,
        number: string,
        bicNumber?: string | null,
        bankName?: string | null,
        contactIds?: Array< string > | null,
        buildingIds?: Array< string > | null,
        holderName?: string | null,
        label?: string | null,
        disabled?: boolean | null,
        integrations?: Array< IntegrationName > | null,
        matchingRule?: BankAccountMatchingRule | null,
        balance?: number | null,
        balanceDate?: string | null,
        type: BankAccountType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      counterpartName?: string | null,
      counterpartAccountNumber?: string | null,
      origin: TransactionOrigin,
      proposedLeaseId?: string | null,
      proposedUnitId?: string | null,
      proposedContractorId?: string | null,
      proposedOwnerId?: string | null,
      proposedMatch?: number | null,
      links?:  Array< {
        __typename: "TransactionLink",
        amount: number,
        linkId: string,
        linkType: TransactionLinkType,
      } > | null,
      postings?:  {
        __typename: "ModelPostingConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    leaseId?: string | null,
    lease?:  {
      __typename: "Lease",
      id: string,
      advancedChargesInvoices?:  {
        __typename: "LeaseAdvancedChargesInvoice",
        communicationSettingsProfileId: string,
        invoiceSenderId: string,
        lastDraftInvoiceDate?: string | null,
        lastInvoiceDate?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        bankAccountId?: string | null,
      } | null,
      balance?: number | null,
      canBeExtended?: boolean | null,
      communicationSettingsProfileId: string,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      endDate: string,
      includeRealEstateInLeaseContract?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      invoiceSenderId: string,
      invoiceSender?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      inventoryOfFixturesExpert?: string | null,
      inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
      inventoryOfFixturesType?: InventoryOfFixturesType | null,
      ipiNumber?: string | null,
      language: Language,
      lastDraftInvoiceDate?: string | null,
      lastIndexationProcessDate?: string | null,
      lastInvoiceDate?: string | null,
      legalCompetentAuthority?: string | null,
      name: string,
      notes?: string | null,
      paymentFrequency: LeasePaymentFrequency,
      paymentInvoicePeriod: LeasePaymentInvoicePeriod,
      paymentInvoicePeriodCustomDay?: number | null,
      paymentOption?:  {
        __typename: "LeasePaymentOption",
        customerId?: string | null,
        enabled: boolean,
        mandateActivatedAt?: string | null,
        mandateStatus?: PaymentProviderMandateStatus | null,
        paymentMethodId?: string | null,
        qrType?: LeaseQrType | null,
      } | null,
      purchaseOrderNumber?: string | null,
      realEstateAgency?: string | null,
      realEstateTax?: number | null,
      remittanceInformation?: string | null,
      remittanceInformationType?: LeaseRemittanceType | null,
      rentalGuaranty?:  {
        __typename: "LeaseRentalGuaranty",
        amount: number,
        blockedAmount?: number | null,
        releasedAmount?: number | null,
        type: LeaseRentalGuarantyType,
        financialInstitution?: string | null,
      } | null,
      signatureDate?: string | null,
      startDate: string,
      nextIndexationMonth?: string | null,
      nextIndexation?: boolean | null,
      status: LeaseStatus,
      technicCommunicationSettingsProfileId: string,
      totalInitialRentalPrice: number,
      totalRentalPrice: number,
      type: LeaseType,
      subletting?: boolean | null,
      vatRateRentId?: string | null,
      vatRateRent?:  {
        __typename: "VatRate",
        id: string,
        country: string,
        label: string,
        value?: number | null,
        ownerId?: string | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      additionalClauses?:  {
        __typename: "ModelLeaseAdditionalClauseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      bankAccountId?: string | null,
      bankAccount?:  {
        __typename: "BankAccount",
        id: string,
        contactId: string,
        number: string,
        bicNumber?: string | null,
        bankName?: string | null,
        contactIds?: Array< string > | null,
        buildingIds?: Array< string > | null,
        holderName?: string | null,
        label?: string | null,
        disabled?: boolean | null,
        integrations?: Array< IntegrationName > | null,
        matchingRule?: BankAccountMatchingRule | null,
        balance?: number | null,
        balanceDate?: string | null,
        type: BankAccountType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contacts?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      files?:  {
        __typename: "ModelFileConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leaseActionHistories?:  {
        __typename: "ModelLeaseActionHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leasePriceHistories?:  {
        __typename: "ModelLeasePriceHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      signatureDocuments?:  {
        __typename: "ModelSignatureDocumentConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      variousOperations?:  {
        __typename: "ModelLeaseVariousOperationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    bankAccountId?: string | null,
    bankAccount?:  {
      __typename: "BankAccount",
      id: string,
      contactId: string,
      contact?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      number: string,
      bicNumber?: string | null,
      bankName?: string | null,
      contactIds?: Array< string > | null,
      buildingIds?: Array< string > | null,
      holderName?: string | null,
      label?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      disabled?: boolean | null,
      integrations?: Array< IntegrationName > | null,
      matchingRule?: BankAccountMatchingRule | null,
      balance?: number | null,
      balanceDate?: string | null,
      type: BankAccountType,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    accountLabelId?: string | null,
    accountLabel?:  {
      __typename: "AccountLabel",
      id: string,
      labels?:  Array< {
        __typename: "CustomLabel",
        language: string,
        label: string,
      } > | null,
      bankAccountId?: string | null,
      bankAccount?:  {
        __typename: "BankAccount",
        id: string,
        contactId: string,
        number: string,
        bicNumber?: string | null,
        bankName?: string | null,
        contactIds?: Array< string > | null,
        buildingIds?: Array< string > | null,
        holderName?: string | null,
        label?: string | null,
        disabled?: boolean | null,
        integrations?: Array< IntegrationName > | null,
        matchingRule?: BankAccountMatchingRule | null,
        balance?: number | null,
        balanceDate?: string | null,
        type: BankAccountType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contactId?: string | null,
      contact?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      class: number,
      customUsage?: AccountLabelCustomUsage | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      disabled?: boolean | null,
      ownerId?: string | null,
      owner?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      topClass: number,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    contactId?: string | null,
    contact?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    leaseVariousOperationId?: string | null,
    leaseVariousOperation?:  {
      __typename: "LeaseVariousOperation",
      id: string,
      accountLabelIds?: Array< string > | null,
      amount: number,
      contactId: string,
      createdAt: string,
      createdBy?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      endDate: string,
      invoiceSenderId?: string | null,
      invoiceSender?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      label?: string | null,
      lastInvoiceDate?: string | null,
      leaseId: string,
      lease?:  {
        __typename: "Lease",
        id: string,
        balance?: number | null,
        canBeExtended?: boolean | null,
        communicationSettingsProfileId: string,
        createdAt?: string | null,
        endDate: string,
        includeRealEstateInLeaseContract?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        invoiceSenderId: string,
        inventoryOfFixturesExpert?: string | null,
        inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
        inventoryOfFixturesType?: InventoryOfFixturesType | null,
        ipiNumber?: string | null,
        language: Language,
        lastDraftInvoiceDate?: string | null,
        lastIndexationProcessDate?: string | null,
        lastInvoiceDate?: string | null,
        legalCompetentAuthority?: string | null,
        name: string,
        notes?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        purchaseOrderNumber?: string | null,
        realEstateAgency?: string | null,
        realEstateTax?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        signatureDate?: string | null,
        startDate: string,
        nextIndexationMonth?: string | null,
        nextIndexation?: boolean | null,
        status: LeaseStatus,
        technicCommunicationSettingsProfileId: string,
        totalInitialRentalPrice: number,
        totalRentalPrice: number,
        type: LeaseType,
        subletting?: boolean | null,
        vatRateRentId?: string | null,
        bankAccountId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      leaseVariousOperationHistories?:  Array< {
        __typename: "LeaseVariousOperationHistory",
        periodFrom: string,
        periodTo: string,
        amount: number,
      } > | null,
      operationType: LeaseVariousOperationType,
      paymentFrequency: LeasePaymentFrequency,
      paymentInvoicePeriod: LeasePaymentInvoicePeriod,
      paymentInvoicePeriodCustomDay?: number | null,
      reason?: string | null,
      separateInvoice: boolean,
      startDate: string,
      type: VariousOperationType,
      unit?:  {
        __typename: "Unit",
        id: string,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        acquisitionValue?: number | null,
        advertisedMonthlyCharges?: number | null,
        advertisedRentalPrice?: number | null,
        cadastralIncome?: number | null,
        createdAt?: string | null,
        floor?: number | null,
        jointOwnershipId?: string | null,
        managementDate: string,
        name: string,
        notes?: string | null,
        predictedPrice?: string | null,
        propertyTax?: number | null,
        publishAddress?: boolean | null,
        surface?: number | null,
        type: UnitType,
        buildingId: string,
        unitAdvertisementId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      unitId: string,
      vatRateId?: string | null,
      vatRate?:  {
        __typename: "VatRate",
        id: string,
        country: string,
        label: string,
        value?: number | null,
        ownerId?: string | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      readId: string,
      readers?: Array< string > | null,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    statementId?: string | null,
    amountVatExcluded?: number | null,
    vatAmount?: number | null,
    vatRate?:  {
      __typename: "VatRate",
      id: string,
      country: string,
      label: string,
      value?: number | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      ownerId?: string | null,
      owner?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    vatRateId?: string | null,
    vatRateValue?: number | null,
    foreignId?: string | null,
    foreignType?: PostingForeignType | null,
    invoicePostingId?: string | null,
    reconciledAt?: string | null,
    status?: PostingStatus | null,
    chargeOwnerRepartition?: number | null,
    chargeRepartitionMetric?: string | null,
    chargeRepartitionValue?: number | null,
    chargeSplitNumber?: number | null,
    chargeType?: PostingChargeType | null,
    readers?: Array< string > | null,
    readId: string,
    clientId: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdatePostingMutationVariables = {
  input: UpdatePostingInput,
  condition?: ModelPostingConditionInput | null,
};

export type UpdatePostingMutation = {
  updatePosting?:  {
    __typename: "Posting",
    id: string,
    createdAt?: string | null,
    class: number,
    customLabel?: string | null,
    customValues?:  Array< {
      __typename: "CustomValue",
      name: string,
      value: string,
    } > | null,
    topClass: number,
    type: PostingType,
    totalAmount: number,
    periodFrom: string,
    periodTo: string,
    buildingId?: string | null,
    building?:  {
      __typename: "Building",
      id: string,
      name: string,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      acquisitionValue?: number | null,
      acquisitionAdditionalCostsValue?: number | null,
      acquisitionAdvertisedValue?: number | null,
      amountOfFacades?: number | null,
      amountOfFloors?: number | null,
      amountOfHousings?: number | null,
      buildingState?: BuildingState | null,
      cadastralIncome?: number | null,
      constructionYear?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      janitor?: boolean | null,
      jointOwnershipId?: string | null,
      notes?: string | null,
      owners?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      propertyTax?: number | null,
      residenceName?: string | null,
      buildingSiteId?: string | null,
      buildingSite?:  {
        __typename: "BuildingSite",
        id: string,
        name: string,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      units?:  {
        __typename: "ModelUnitConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      events?:  {
        __typename: "ModelBuildingEventConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      teams?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    unitId?: string | null,
    unit?:  {
      __typename: "Unit",
      id: string,
      acquisitionAdditionalCostsValue?: number | null,
      acquisitionAdvertisedValue?: number | null,
      acquisitionValue?: number | null,
      advertisedMonthlyCharges?: number | null,
      advertisedRentalPrice?: number | null,
      cadastralIncome?: number | null,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      floor?: number | null,
      jointOwnershipId?: string | null,
      managementDate: string,
      name: string,
      notes?: string | null,
      predictedPrice?: string | null,
      propertyTax?: number | null,
      publishAddress?: boolean | null,
      surface?: number | null,
      type: UnitType,
      buildingId: string,
      building?:  {
        __typename: "Building",
        id: string,
        name: string,
        addressId?: string | null,
        acquisitionValue?: number | null,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        amountOfFacades?: number | null,
        amountOfFloors?: number | null,
        amountOfHousings?: number | null,
        buildingState?: BuildingState | null,
        cadastralIncome?: number | null,
        constructionYear?: string | null,
        janitor?: boolean | null,
        jointOwnershipId?: string | null,
        notes?: string | null,
        propertyTax?: number | null,
        residenceName?: string | null,
        buildingSiteId?: string | null,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      owners?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leases?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      events?:  {
        __typename: "ModelUnitEventConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      unitAdvertisementId?: string | null,
      unitInventories?:  {
        __typename: "ModelUnitInventoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    invoiceId?: string | null,
    invoice?:  {
      __typename: "Invoice",
      id: string,
      amount: number,
      bankAccountId: string,
      bankAccount?:  {
        __typename: "BankAccount",
        id: string,
        contactId: string,
        number: string,
        bicNumber?: string | null,
        bankName?: string | null,
        contactIds?: Array< string > | null,
        buildingIds?: Array< string > | null,
        holderName?: string | null,
        label?: string | null,
        disabled?: boolean | null,
        integrations?: Array< IntegrationName > | null,
        matchingRule?: BankAccountMatchingRule | null,
        balance?: number | null,
        balanceDate?: string | null,
        type: BankAccountType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      communicationId?: string | null,
      communication?:  {
        __typename: "Communication",
        id: string,
        addressId?: string | null,
        body: string,
        buildingId?: string | null,
        channel: CommunicationChannel,
        communicationTemplateId?: string | null,
        concernedContactIds?: Array< string > | null,
        contactId?: string | null,
        contactIds?: Array< string > | null,
        createdAt?: string | null,
        expirationDate?: string | null,
        invoiceId?: string | null,
        leaseId?: string | null,
        leasePriceHistoryId?: string | null,
        letterTrackingCode?: string | null,
        letterTrackingProvider?: TrackingProvider | null,
        linkedCommunicationsIds?: Array< string > | null,
        supportingDocumentFileIds?: Array< string > | null,
        recipient?: string | null,
        recipientContactIdsInBcc?: Array< string > | null,
        recipientContactIdsInCc?: Array< string > | null,
        recipientInBcc?: string | null,
        recipientInCc?: string | null,
        scheduledAt?: string | null,
        deliveredAt?: string | null,
        errorCode?: CommunicationErrorCode | null,
        nextRetryAt?: string | null,
        sendRetryCount?: number | null,
        sender?: string | null,
        sentAt?: string | null,
        externalId?: string | null,
        externalStatus?: string | null,
        signatureDocumentId?: string | null,
        snoozedDate?: string | null,
        statementId?: string | null,
        status: CommunicationStatus,
        subject: string,
        toSend: boolean,
        hideLogo?: boolean | null,
        type: CommunicationType,
        _ttl?: number | null,
        unitId?: string | null,
        readId: string,
        readers?: Array< string > | null,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      createdAt: string,
      creditNote?: boolean | null,
      creditNoteLabel?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      dueDate?: string | null,
      invoiceDate: string,
      invoiceNumber?: string | null,
      ownerId?: string | null,
      owner?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      invoiceSenderId: string,
      invoiceSender?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      leaseId?: string | null,
      lease?:  {
        __typename: "Lease",
        id: string,
        balance?: number | null,
        canBeExtended?: boolean | null,
        communicationSettingsProfileId: string,
        createdAt?: string | null,
        endDate: string,
        includeRealEstateInLeaseContract?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        invoiceSenderId: string,
        inventoryOfFixturesExpert?: string | null,
        inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
        inventoryOfFixturesType?: InventoryOfFixturesType | null,
        ipiNumber?: string | null,
        language: Language,
        lastDraftInvoiceDate?: string | null,
        lastIndexationProcessDate?: string | null,
        lastInvoiceDate?: string | null,
        legalCompetentAuthority?: string | null,
        name: string,
        notes?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        purchaseOrderNumber?: string | null,
        realEstateAgency?: string | null,
        realEstateTax?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        signatureDate?: string | null,
        startDate: string,
        nextIndexationMonth?: string | null,
        nextIndexation?: boolean | null,
        status: LeaseStatus,
        technicCommunicationSettingsProfileId: string,
        totalInitialRentalPrice: number,
        totalRentalPrice: number,
        type: LeaseType,
        subletting?: boolean | null,
        vatRateRentId?: string | null,
        bankAccountId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      paid: boolean,
      integrations?:  {
        __typename: "InvoiceIntegrations",
      } | null,
      postedDate?: string | null,
      purchaseOrderNumber?: string | null,
      receiptNumber?: string | null,
      reminderDates?: Array< string > | null,
      note?: string | null,
      remittanceInformation?: string | null,
      statementId?: string | null,
      statement?:  {
        __typename: "Statement",
        id: string,
        closingStatement: boolean,
        periodFrom: string,
        periodTo: string,
        attachSupportingDocuments?: boolean | null,
        selectedPocketKeys?: Array< string > | null,
        source: StatementSource,
        status: StatementStatus,
        sentDate?: string | null,
        leaseId?: string | null,
        ownerId?: string | null,
        types?: Array< StatementType > | null,
        viewType: StatementViewType,
        unitIds?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      status: InvoiceStatus,
      type: InvoiceType,
      unitId?: string | null,
      unit?:  {
        __typename: "Unit",
        id: string,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        acquisitionValue?: number | null,
        advertisedMonthlyCharges?: number | null,
        advertisedRentalPrice?: number | null,
        cadastralIncome?: number | null,
        createdAt?: string | null,
        floor?: number | null,
        jointOwnershipId?: string | null,
        managementDate: string,
        name: string,
        notes?: string | null,
        predictedPrice?: string | null,
        propertyTax?: number | null,
        publishAddress?: boolean | null,
        surface?: number | null,
        type: UnitType,
        buildingId: string,
        unitAdvertisementId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      reversedInvoiceId?: string | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    chargeId?: string | null,
    charge?:  {
      __typename: "Charge",
      id: string,
      status: ChargeStatus,
      invoiceDate?: string | null,
      paymentDueDate?: string | null,
      archivedDate?: string | null,
      periodFrom?: string | null,
      periodTo?: string | null,
      totalAmount?: number | null,
      source: ChargeSource,
      draftFromOcr?: boolean | null,
      accountingDocumentId?: string | null,
      paid: boolean,
      remittanceInformation?: string | null,
      note?: string | null,
      createdAt: string,
      creatorEmail?: string | null,
      createdById?: string | null,
      createdBy?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contractorId?: string | null,
      contractor?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      proposedContractors?:  Array< {
        __typename: "ProposedValue",
        id: string,
        confidence?: number | null,
      } > | null,
      recipientId?: string | null,
      recipient?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      proposedRecipients?:  Array< {
        __typename: "ProposedValue",
        id: string,
        confidence?: number | null,
      } > | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      documentId: string,
      document?:  {
        __typename: "File",
        id: string,
        bucket: string,
        createdAt?: string | null,
        categoryId: string,
        foreignKey: string,
        foreignTableName: string,
        key: string,
        mimeType?: string | null,
        region: string,
        size?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        _ttl?: number | null,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      postings?:  {
        __typename: "ModelPostingConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    transactionId?: string | null,
    transaction?:  {
      __typename: "Transaction",
      id: string,
      status: TransactionStatus,
      sequence?: number | null,
      statementDate: string,
      operationDate?: string | null,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      remittanceInformationType?: RemittanceType | null,
      remittanceInformation?: string | null,
      comment?: string | null,
      amount: number,
      bankAccountId: string,
      bankAccount?:  {
        __typename: "BankAccount",
        id: string,
        contactId: string,
        number: string,
        bicNumber?: string | null,
        bankName?: string | null,
        contactIds?: Array< string > | null,
        buildingIds?: Array< string > | null,
        holderName?: string | null,
        label?: string | null,
        disabled?: boolean | null,
        integrations?: Array< IntegrationName > | null,
        matchingRule?: BankAccountMatchingRule | null,
        balance?: number | null,
        balanceDate?: string | null,
        type: BankAccountType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      counterpartName?: string | null,
      counterpartAccountNumber?: string | null,
      origin: TransactionOrigin,
      proposedLeaseId?: string | null,
      proposedUnitId?: string | null,
      proposedContractorId?: string | null,
      proposedOwnerId?: string | null,
      proposedMatch?: number | null,
      links?:  Array< {
        __typename: "TransactionLink",
        amount: number,
        linkId: string,
        linkType: TransactionLinkType,
      } > | null,
      postings?:  {
        __typename: "ModelPostingConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    leaseId?: string | null,
    lease?:  {
      __typename: "Lease",
      id: string,
      advancedChargesInvoices?:  {
        __typename: "LeaseAdvancedChargesInvoice",
        communicationSettingsProfileId: string,
        invoiceSenderId: string,
        lastDraftInvoiceDate?: string | null,
        lastInvoiceDate?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        bankAccountId?: string | null,
      } | null,
      balance?: number | null,
      canBeExtended?: boolean | null,
      communicationSettingsProfileId: string,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      endDate: string,
      includeRealEstateInLeaseContract?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      invoiceSenderId: string,
      invoiceSender?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      inventoryOfFixturesExpert?: string | null,
      inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
      inventoryOfFixturesType?: InventoryOfFixturesType | null,
      ipiNumber?: string | null,
      language: Language,
      lastDraftInvoiceDate?: string | null,
      lastIndexationProcessDate?: string | null,
      lastInvoiceDate?: string | null,
      legalCompetentAuthority?: string | null,
      name: string,
      notes?: string | null,
      paymentFrequency: LeasePaymentFrequency,
      paymentInvoicePeriod: LeasePaymentInvoicePeriod,
      paymentInvoicePeriodCustomDay?: number | null,
      paymentOption?:  {
        __typename: "LeasePaymentOption",
        customerId?: string | null,
        enabled: boolean,
        mandateActivatedAt?: string | null,
        mandateStatus?: PaymentProviderMandateStatus | null,
        paymentMethodId?: string | null,
        qrType?: LeaseQrType | null,
      } | null,
      purchaseOrderNumber?: string | null,
      realEstateAgency?: string | null,
      realEstateTax?: number | null,
      remittanceInformation?: string | null,
      remittanceInformationType?: LeaseRemittanceType | null,
      rentalGuaranty?:  {
        __typename: "LeaseRentalGuaranty",
        amount: number,
        blockedAmount?: number | null,
        releasedAmount?: number | null,
        type: LeaseRentalGuarantyType,
        financialInstitution?: string | null,
      } | null,
      signatureDate?: string | null,
      startDate: string,
      nextIndexationMonth?: string | null,
      nextIndexation?: boolean | null,
      status: LeaseStatus,
      technicCommunicationSettingsProfileId: string,
      totalInitialRentalPrice: number,
      totalRentalPrice: number,
      type: LeaseType,
      subletting?: boolean | null,
      vatRateRentId?: string | null,
      vatRateRent?:  {
        __typename: "VatRate",
        id: string,
        country: string,
        label: string,
        value?: number | null,
        ownerId?: string | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      additionalClauses?:  {
        __typename: "ModelLeaseAdditionalClauseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      bankAccountId?: string | null,
      bankAccount?:  {
        __typename: "BankAccount",
        id: string,
        contactId: string,
        number: string,
        bicNumber?: string | null,
        bankName?: string | null,
        contactIds?: Array< string > | null,
        buildingIds?: Array< string > | null,
        holderName?: string | null,
        label?: string | null,
        disabled?: boolean | null,
        integrations?: Array< IntegrationName > | null,
        matchingRule?: BankAccountMatchingRule | null,
        balance?: number | null,
        balanceDate?: string | null,
        type: BankAccountType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contacts?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      files?:  {
        __typename: "ModelFileConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leaseActionHistories?:  {
        __typename: "ModelLeaseActionHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leasePriceHistories?:  {
        __typename: "ModelLeasePriceHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      signatureDocuments?:  {
        __typename: "ModelSignatureDocumentConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      variousOperations?:  {
        __typename: "ModelLeaseVariousOperationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    bankAccountId?: string | null,
    bankAccount?:  {
      __typename: "BankAccount",
      id: string,
      contactId: string,
      contact?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      number: string,
      bicNumber?: string | null,
      bankName?: string | null,
      contactIds?: Array< string > | null,
      buildingIds?: Array< string > | null,
      holderName?: string | null,
      label?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      disabled?: boolean | null,
      integrations?: Array< IntegrationName > | null,
      matchingRule?: BankAccountMatchingRule | null,
      balance?: number | null,
      balanceDate?: string | null,
      type: BankAccountType,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    accountLabelId?: string | null,
    accountLabel?:  {
      __typename: "AccountLabel",
      id: string,
      labels?:  Array< {
        __typename: "CustomLabel",
        language: string,
        label: string,
      } > | null,
      bankAccountId?: string | null,
      bankAccount?:  {
        __typename: "BankAccount",
        id: string,
        contactId: string,
        number: string,
        bicNumber?: string | null,
        bankName?: string | null,
        contactIds?: Array< string > | null,
        buildingIds?: Array< string > | null,
        holderName?: string | null,
        label?: string | null,
        disabled?: boolean | null,
        integrations?: Array< IntegrationName > | null,
        matchingRule?: BankAccountMatchingRule | null,
        balance?: number | null,
        balanceDate?: string | null,
        type: BankAccountType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contactId?: string | null,
      contact?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      class: number,
      customUsage?: AccountLabelCustomUsage | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      disabled?: boolean | null,
      ownerId?: string | null,
      owner?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      topClass: number,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    contactId?: string | null,
    contact?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    leaseVariousOperationId?: string | null,
    leaseVariousOperation?:  {
      __typename: "LeaseVariousOperation",
      id: string,
      accountLabelIds?: Array< string > | null,
      amount: number,
      contactId: string,
      createdAt: string,
      createdBy?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      endDate: string,
      invoiceSenderId?: string | null,
      invoiceSender?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      label?: string | null,
      lastInvoiceDate?: string | null,
      leaseId: string,
      lease?:  {
        __typename: "Lease",
        id: string,
        balance?: number | null,
        canBeExtended?: boolean | null,
        communicationSettingsProfileId: string,
        createdAt?: string | null,
        endDate: string,
        includeRealEstateInLeaseContract?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        invoiceSenderId: string,
        inventoryOfFixturesExpert?: string | null,
        inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
        inventoryOfFixturesType?: InventoryOfFixturesType | null,
        ipiNumber?: string | null,
        language: Language,
        lastDraftInvoiceDate?: string | null,
        lastIndexationProcessDate?: string | null,
        lastInvoiceDate?: string | null,
        legalCompetentAuthority?: string | null,
        name: string,
        notes?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        purchaseOrderNumber?: string | null,
        realEstateAgency?: string | null,
        realEstateTax?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        signatureDate?: string | null,
        startDate: string,
        nextIndexationMonth?: string | null,
        nextIndexation?: boolean | null,
        status: LeaseStatus,
        technicCommunicationSettingsProfileId: string,
        totalInitialRentalPrice: number,
        totalRentalPrice: number,
        type: LeaseType,
        subletting?: boolean | null,
        vatRateRentId?: string | null,
        bankAccountId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      leaseVariousOperationHistories?:  Array< {
        __typename: "LeaseVariousOperationHistory",
        periodFrom: string,
        periodTo: string,
        amount: number,
      } > | null,
      operationType: LeaseVariousOperationType,
      paymentFrequency: LeasePaymentFrequency,
      paymentInvoicePeriod: LeasePaymentInvoicePeriod,
      paymentInvoicePeriodCustomDay?: number | null,
      reason?: string | null,
      separateInvoice: boolean,
      startDate: string,
      type: VariousOperationType,
      unit?:  {
        __typename: "Unit",
        id: string,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        acquisitionValue?: number | null,
        advertisedMonthlyCharges?: number | null,
        advertisedRentalPrice?: number | null,
        cadastralIncome?: number | null,
        createdAt?: string | null,
        floor?: number | null,
        jointOwnershipId?: string | null,
        managementDate: string,
        name: string,
        notes?: string | null,
        predictedPrice?: string | null,
        propertyTax?: number | null,
        publishAddress?: boolean | null,
        surface?: number | null,
        type: UnitType,
        buildingId: string,
        unitAdvertisementId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      unitId: string,
      vatRateId?: string | null,
      vatRate?:  {
        __typename: "VatRate",
        id: string,
        country: string,
        label: string,
        value?: number | null,
        ownerId?: string | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      readId: string,
      readers?: Array< string > | null,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    statementId?: string | null,
    amountVatExcluded?: number | null,
    vatAmount?: number | null,
    vatRate?:  {
      __typename: "VatRate",
      id: string,
      country: string,
      label: string,
      value?: number | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      ownerId?: string | null,
      owner?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    vatRateId?: string | null,
    vatRateValue?: number | null,
    foreignId?: string | null,
    foreignType?: PostingForeignType | null,
    invoicePostingId?: string | null,
    reconciledAt?: string | null,
    status?: PostingStatus | null,
    chargeOwnerRepartition?: number | null,
    chargeRepartitionMetric?: string | null,
    chargeRepartitionValue?: number | null,
    chargeSplitNumber?: number | null,
    chargeType?: PostingChargeType | null,
    readers?: Array< string > | null,
    readId: string,
    clientId: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeletePostingMutationVariables = {
  input: DeletePostingInput,
  condition?: ModelPostingConditionInput | null,
};

export type DeletePostingMutation = {
  deletePosting?:  {
    __typename: "Posting",
    id: string,
    createdAt?: string | null,
    class: number,
    customLabel?: string | null,
    customValues?:  Array< {
      __typename: "CustomValue",
      name: string,
      value: string,
    } > | null,
    topClass: number,
    type: PostingType,
    totalAmount: number,
    periodFrom: string,
    periodTo: string,
    buildingId?: string | null,
    building?:  {
      __typename: "Building",
      id: string,
      name: string,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      acquisitionValue?: number | null,
      acquisitionAdditionalCostsValue?: number | null,
      acquisitionAdvertisedValue?: number | null,
      amountOfFacades?: number | null,
      amountOfFloors?: number | null,
      amountOfHousings?: number | null,
      buildingState?: BuildingState | null,
      cadastralIncome?: number | null,
      constructionYear?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      janitor?: boolean | null,
      jointOwnershipId?: string | null,
      notes?: string | null,
      owners?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      propertyTax?: number | null,
      residenceName?: string | null,
      buildingSiteId?: string | null,
      buildingSite?:  {
        __typename: "BuildingSite",
        id: string,
        name: string,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      units?:  {
        __typename: "ModelUnitConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      events?:  {
        __typename: "ModelBuildingEventConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      teams?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    unitId?: string | null,
    unit?:  {
      __typename: "Unit",
      id: string,
      acquisitionAdditionalCostsValue?: number | null,
      acquisitionAdvertisedValue?: number | null,
      acquisitionValue?: number | null,
      advertisedMonthlyCharges?: number | null,
      advertisedRentalPrice?: number | null,
      cadastralIncome?: number | null,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      floor?: number | null,
      jointOwnershipId?: string | null,
      managementDate: string,
      name: string,
      notes?: string | null,
      predictedPrice?: string | null,
      propertyTax?: number | null,
      publishAddress?: boolean | null,
      surface?: number | null,
      type: UnitType,
      buildingId: string,
      building?:  {
        __typename: "Building",
        id: string,
        name: string,
        addressId?: string | null,
        acquisitionValue?: number | null,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        amountOfFacades?: number | null,
        amountOfFloors?: number | null,
        amountOfHousings?: number | null,
        buildingState?: BuildingState | null,
        cadastralIncome?: number | null,
        constructionYear?: string | null,
        janitor?: boolean | null,
        jointOwnershipId?: string | null,
        notes?: string | null,
        propertyTax?: number | null,
        residenceName?: string | null,
        buildingSiteId?: string | null,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      owners?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leases?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      events?:  {
        __typename: "ModelUnitEventConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      unitAdvertisementId?: string | null,
      unitInventories?:  {
        __typename: "ModelUnitInventoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    invoiceId?: string | null,
    invoice?:  {
      __typename: "Invoice",
      id: string,
      amount: number,
      bankAccountId: string,
      bankAccount?:  {
        __typename: "BankAccount",
        id: string,
        contactId: string,
        number: string,
        bicNumber?: string | null,
        bankName?: string | null,
        contactIds?: Array< string > | null,
        buildingIds?: Array< string > | null,
        holderName?: string | null,
        label?: string | null,
        disabled?: boolean | null,
        integrations?: Array< IntegrationName > | null,
        matchingRule?: BankAccountMatchingRule | null,
        balance?: number | null,
        balanceDate?: string | null,
        type: BankAccountType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      communicationId?: string | null,
      communication?:  {
        __typename: "Communication",
        id: string,
        addressId?: string | null,
        body: string,
        buildingId?: string | null,
        channel: CommunicationChannel,
        communicationTemplateId?: string | null,
        concernedContactIds?: Array< string > | null,
        contactId?: string | null,
        contactIds?: Array< string > | null,
        createdAt?: string | null,
        expirationDate?: string | null,
        invoiceId?: string | null,
        leaseId?: string | null,
        leasePriceHistoryId?: string | null,
        letterTrackingCode?: string | null,
        letterTrackingProvider?: TrackingProvider | null,
        linkedCommunicationsIds?: Array< string > | null,
        supportingDocumentFileIds?: Array< string > | null,
        recipient?: string | null,
        recipientContactIdsInBcc?: Array< string > | null,
        recipientContactIdsInCc?: Array< string > | null,
        recipientInBcc?: string | null,
        recipientInCc?: string | null,
        scheduledAt?: string | null,
        deliveredAt?: string | null,
        errorCode?: CommunicationErrorCode | null,
        nextRetryAt?: string | null,
        sendRetryCount?: number | null,
        sender?: string | null,
        sentAt?: string | null,
        externalId?: string | null,
        externalStatus?: string | null,
        signatureDocumentId?: string | null,
        snoozedDate?: string | null,
        statementId?: string | null,
        status: CommunicationStatus,
        subject: string,
        toSend: boolean,
        hideLogo?: boolean | null,
        type: CommunicationType,
        _ttl?: number | null,
        unitId?: string | null,
        readId: string,
        readers?: Array< string > | null,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      createdAt: string,
      creditNote?: boolean | null,
      creditNoteLabel?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      dueDate?: string | null,
      invoiceDate: string,
      invoiceNumber?: string | null,
      ownerId?: string | null,
      owner?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      invoiceSenderId: string,
      invoiceSender?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      leaseId?: string | null,
      lease?:  {
        __typename: "Lease",
        id: string,
        balance?: number | null,
        canBeExtended?: boolean | null,
        communicationSettingsProfileId: string,
        createdAt?: string | null,
        endDate: string,
        includeRealEstateInLeaseContract?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        invoiceSenderId: string,
        inventoryOfFixturesExpert?: string | null,
        inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
        inventoryOfFixturesType?: InventoryOfFixturesType | null,
        ipiNumber?: string | null,
        language: Language,
        lastDraftInvoiceDate?: string | null,
        lastIndexationProcessDate?: string | null,
        lastInvoiceDate?: string | null,
        legalCompetentAuthority?: string | null,
        name: string,
        notes?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        purchaseOrderNumber?: string | null,
        realEstateAgency?: string | null,
        realEstateTax?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        signatureDate?: string | null,
        startDate: string,
        nextIndexationMonth?: string | null,
        nextIndexation?: boolean | null,
        status: LeaseStatus,
        technicCommunicationSettingsProfileId: string,
        totalInitialRentalPrice: number,
        totalRentalPrice: number,
        type: LeaseType,
        subletting?: boolean | null,
        vatRateRentId?: string | null,
        bankAccountId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      paid: boolean,
      integrations?:  {
        __typename: "InvoiceIntegrations",
      } | null,
      postedDate?: string | null,
      purchaseOrderNumber?: string | null,
      receiptNumber?: string | null,
      reminderDates?: Array< string > | null,
      note?: string | null,
      remittanceInformation?: string | null,
      statementId?: string | null,
      statement?:  {
        __typename: "Statement",
        id: string,
        closingStatement: boolean,
        periodFrom: string,
        periodTo: string,
        attachSupportingDocuments?: boolean | null,
        selectedPocketKeys?: Array< string > | null,
        source: StatementSource,
        status: StatementStatus,
        sentDate?: string | null,
        leaseId?: string | null,
        ownerId?: string | null,
        types?: Array< StatementType > | null,
        viewType: StatementViewType,
        unitIds?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      status: InvoiceStatus,
      type: InvoiceType,
      unitId?: string | null,
      unit?:  {
        __typename: "Unit",
        id: string,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        acquisitionValue?: number | null,
        advertisedMonthlyCharges?: number | null,
        advertisedRentalPrice?: number | null,
        cadastralIncome?: number | null,
        createdAt?: string | null,
        floor?: number | null,
        jointOwnershipId?: string | null,
        managementDate: string,
        name: string,
        notes?: string | null,
        predictedPrice?: string | null,
        propertyTax?: number | null,
        publishAddress?: boolean | null,
        surface?: number | null,
        type: UnitType,
        buildingId: string,
        unitAdvertisementId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      reversedInvoiceId?: string | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    chargeId?: string | null,
    charge?:  {
      __typename: "Charge",
      id: string,
      status: ChargeStatus,
      invoiceDate?: string | null,
      paymentDueDate?: string | null,
      archivedDate?: string | null,
      periodFrom?: string | null,
      periodTo?: string | null,
      totalAmount?: number | null,
      source: ChargeSource,
      draftFromOcr?: boolean | null,
      accountingDocumentId?: string | null,
      paid: boolean,
      remittanceInformation?: string | null,
      note?: string | null,
      createdAt: string,
      creatorEmail?: string | null,
      createdById?: string | null,
      createdBy?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contractorId?: string | null,
      contractor?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      proposedContractors?:  Array< {
        __typename: "ProposedValue",
        id: string,
        confidence?: number | null,
      } > | null,
      recipientId?: string | null,
      recipient?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      proposedRecipients?:  Array< {
        __typename: "ProposedValue",
        id: string,
        confidence?: number | null,
      } > | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      documentId: string,
      document?:  {
        __typename: "File",
        id: string,
        bucket: string,
        createdAt?: string | null,
        categoryId: string,
        foreignKey: string,
        foreignTableName: string,
        key: string,
        mimeType?: string | null,
        region: string,
        size?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        _ttl?: number | null,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      postings?:  {
        __typename: "ModelPostingConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    transactionId?: string | null,
    transaction?:  {
      __typename: "Transaction",
      id: string,
      status: TransactionStatus,
      sequence?: number | null,
      statementDate: string,
      operationDate?: string | null,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      remittanceInformationType?: RemittanceType | null,
      remittanceInformation?: string | null,
      comment?: string | null,
      amount: number,
      bankAccountId: string,
      bankAccount?:  {
        __typename: "BankAccount",
        id: string,
        contactId: string,
        number: string,
        bicNumber?: string | null,
        bankName?: string | null,
        contactIds?: Array< string > | null,
        buildingIds?: Array< string > | null,
        holderName?: string | null,
        label?: string | null,
        disabled?: boolean | null,
        integrations?: Array< IntegrationName > | null,
        matchingRule?: BankAccountMatchingRule | null,
        balance?: number | null,
        balanceDate?: string | null,
        type: BankAccountType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      counterpartName?: string | null,
      counterpartAccountNumber?: string | null,
      origin: TransactionOrigin,
      proposedLeaseId?: string | null,
      proposedUnitId?: string | null,
      proposedContractorId?: string | null,
      proposedOwnerId?: string | null,
      proposedMatch?: number | null,
      links?:  Array< {
        __typename: "TransactionLink",
        amount: number,
        linkId: string,
        linkType: TransactionLinkType,
      } > | null,
      postings?:  {
        __typename: "ModelPostingConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    leaseId?: string | null,
    lease?:  {
      __typename: "Lease",
      id: string,
      advancedChargesInvoices?:  {
        __typename: "LeaseAdvancedChargesInvoice",
        communicationSettingsProfileId: string,
        invoiceSenderId: string,
        lastDraftInvoiceDate?: string | null,
        lastInvoiceDate?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        bankAccountId?: string | null,
      } | null,
      balance?: number | null,
      canBeExtended?: boolean | null,
      communicationSettingsProfileId: string,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      endDate: string,
      includeRealEstateInLeaseContract?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      invoiceSenderId: string,
      invoiceSender?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      inventoryOfFixturesExpert?: string | null,
      inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
      inventoryOfFixturesType?: InventoryOfFixturesType | null,
      ipiNumber?: string | null,
      language: Language,
      lastDraftInvoiceDate?: string | null,
      lastIndexationProcessDate?: string | null,
      lastInvoiceDate?: string | null,
      legalCompetentAuthority?: string | null,
      name: string,
      notes?: string | null,
      paymentFrequency: LeasePaymentFrequency,
      paymentInvoicePeriod: LeasePaymentInvoicePeriod,
      paymentInvoicePeriodCustomDay?: number | null,
      paymentOption?:  {
        __typename: "LeasePaymentOption",
        customerId?: string | null,
        enabled: boolean,
        mandateActivatedAt?: string | null,
        mandateStatus?: PaymentProviderMandateStatus | null,
        paymentMethodId?: string | null,
        qrType?: LeaseQrType | null,
      } | null,
      purchaseOrderNumber?: string | null,
      realEstateAgency?: string | null,
      realEstateTax?: number | null,
      remittanceInformation?: string | null,
      remittanceInformationType?: LeaseRemittanceType | null,
      rentalGuaranty?:  {
        __typename: "LeaseRentalGuaranty",
        amount: number,
        blockedAmount?: number | null,
        releasedAmount?: number | null,
        type: LeaseRentalGuarantyType,
        financialInstitution?: string | null,
      } | null,
      signatureDate?: string | null,
      startDate: string,
      nextIndexationMonth?: string | null,
      nextIndexation?: boolean | null,
      status: LeaseStatus,
      technicCommunicationSettingsProfileId: string,
      totalInitialRentalPrice: number,
      totalRentalPrice: number,
      type: LeaseType,
      subletting?: boolean | null,
      vatRateRentId?: string | null,
      vatRateRent?:  {
        __typename: "VatRate",
        id: string,
        country: string,
        label: string,
        value?: number | null,
        ownerId?: string | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      additionalClauses?:  {
        __typename: "ModelLeaseAdditionalClauseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      bankAccountId?: string | null,
      bankAccount?:  {
        __typename: "BankAccount",
        id: string,
        contactId: string,
        number: string,
        bicNumber?: string | null,
        bankName?: string | null,
        contactIds?: Array< string > | null,
        buildingIds?: Array< string > | null,
        holderName?: string | null,
        label?: string | null,
        disabled?: boolean | null,
        integrations?: Array< IntegrationName > | null,
        matchingRule?: BankAccountMatchingRule | null,
        balance?: number | null,
        balanceDate?: string | null,
        type: BankAccountType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contacts?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      files?:  {
        __typename: "ModelFileConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leaseActionHistories?:  {
        __typename: "ModelLeaseActionHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leasePriceHistories?:  {
        __typename: "ModelLeasePriceHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      signatureDocuments?:  {
        __typename: "ModelSignatureDocumentConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      variousOperations?:  {
        __typename: "ModelLeaseVariousOperationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    bankAccountId?: string | null,
    bankAccount?:  {
      __typename: "BankAccount",
      id: string,
      contactId: string,
      contact?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      number: string,
      bicNumber?: string | null,
      bankName?: string | null,
      contactIds?: Array< string > | null,
      buildingIds?: Array< string > | null,
      holderName?: string | null,
      label?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      disabled?: boolean | null,
      integrations?: Array< IntegrationName > | null,
      matchingRule?: BankAccountMatchingRule | null,
      balance?: number | null,
      balanceDate?: string | null,
      type: BankAccountType,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    accountLabelId?: string | null,
    accountLabel?:  {
      __typename: "AccountLabel",
      id: string,
      labels?:  Array< {
        __typename: "CustomLabel",
        language: string,
        label: string,
      } > | null,
      bankAccountId?: string | null,
      bankAccount?:  {
        __typename: "BankAccount",
        id: string,
        contactId: string,
        number: string,
        bicNumber?: string | null,
        bankName?: string | null,
        contactIds?: Array< string > | null,
        buildingIds?: Array< string > | null,
        holderName?: string | null,
        label?: string | null,
        disabled?: boolean | null,
        integrations?: Array< IntegrationName > | null,
        matchingRule?: BankAccountMatchingRule | null,
        balance?: number | null,
        balanceDate?: string | null,
        type: BankAccountType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contactId?: string | null,
      contact?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      class: number,
      customUsage?: AccountLabelCustomUsage | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      disabled?: boolean | null,
      ownerId?: string | null,
      owner?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      topClass: number,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    contactId?: string | null,
    contact?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    leaseVariousOperationId?: string | null,
    leaseVariousOperation?:  {
      __typename: "LeaseVariousOperation",
      id: string,
      accountLabelIds?: Array< string > | null,
      amount: number,
      contactId: string,
      createdAt: string,
      createdBy?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      endDate: string,
      invoiceSenderId?: string | null,
      invoiceSender?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      label?: string | null,
      lastInvoiceDate?: string | null,
      leaseId: string,
      lease?:  {
        __typename: "Lease",
        id: string,
        balance?: number | null,
        canBeExtended?: boolean | null,
        communicationSettingsProfileId: string,
        createdAt?: string | null,
        endDate: string,
        includeRealEstateInLeaseContract?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        invoiceSenderId: string,
        inventoryOfFixturesExpert?: string | null,
        inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
        inventoryOfFixturesType?: InventoryOfFixturesType | null,
        ipiNumber?: string | null,
        language: Language,
        lastDraftInvoiceDate?: string | null,
        lastIndexationProcessDate?: string | null,
        lastInvoiceDate?: string | null,
        legalCompetentAuthority?: string | null,
        name: string,
        notes?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        purchaseOrderNumber?: string | null,
        realEstateAgency?: string | null,
        realEstateTax?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        signatureDate?: string | null,
        startDate: string,
        nextIndexationMonth?: string | null,
        nextIndexation?: boolean | null,
        status: LeaseStatus,
        technicCommunicationSettingsProfileId: string,
        totalInitialRentalPrice: number,
        totalRentalPrice: number,
        type: LeaseType,
        subletting?: boolean | null,
        vatRateRentId?: string | null,
        bankAccountId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      leaseVariousOperationHistories?:  Array< {
        __typename: "LeaseVariousOperationHistory",
        periodFrom: string,
        periodTo: string,
        amount: number,
      } > | null,
      operationType: LeaseVariousOperationType,
      paymentFrequency: LeasePaymentFrequency,
      paymentInvoicePeriod: LeasePaymentInvoicePeriod,
      paymentInvoicePeriodCustomDay?: number | null,
      reason?: string | null,
      separateInvoice: boolean,
      startDate: string,
      type: VariousOperationType,
      unit?:  {
        __typename: "Unit",
        id: string,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        acquisitionValue?: number | null,
        advertisedMonthlyCharges?: number | null,
        advertisedRentalPrice?: number | null,
        cadastralIncome?: number | null,
        createdAt?: string | null,
        floor?: number | null,
        jointOwnershipId?: string | null,
        managementDate: string,
        name: string,
        notes?: string | null,
        predictedPrice?: string | null,
        propertyTax?: number | null,
        publishAddress?: boolean | null,
        surface?: number | null,
        type: UnitType,
        buildingId: string,
        unitAdvertisementId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      unitId: string,
      vatRateId?: string | null,
      vatRate?:  {
        __typename: "VatRate",
        id: string,
        country: string,
        label: string,
        value?: number | null,
        ownerId?: string | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      readId: string,
      readers?: Array< string > | null,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    statementId?: string | null,
    amountVatExcluded?: number | null,
    vatAmount?: number | null,
    vatRate?:  {
      __typename: "VatRate",
      id: string,
      country: string,
      label: string,
      value?: number | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      ownerId?: string | null,
      owner?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    vatRateId?: string | null,
    vatRateValue?: number | null,
    foreignId?: string | null,
    foreignType?: PostingForeignType | null,
    invoicePostingId?: string | null,
    reconciledAt?: string | null,
    status?: PostingStatus | null,
    chargeOwnerRepartition?: number | null,
    chargeRepartitionMetric?: string | null,
    chargeRepartitionValue?: number | null,
    chargeSplitNumber?: number | null,
    chargeType?: PostingChargeType | null,
    readers?: Array< string > | null,
    readId: string,
    clientId: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateBankAccountMutationVariables = {
  input: CreateBankAccountInput,
  condition?: ModelBankAccountConditionInput | null,
};

export type CreateBankAccountMutation = {
  createBankAccount?:  {
    __typename: "BankAccount",
    id: string,
    contactId: string,
    contact?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    number: string,
    bicNumber?: string | null,
    bankName?: string | null,
    contactIds?: Array< string > | null,
    buildingIds?: Array< string > | null,
    holderName?: string | null,
    label?: string | null,
    customValues?:  Array< {
      __typename: "CustomValue",
      name: string,
      value: string,
    } > | null,
    disabled?: boolean | null,
    integrations?: Array< IntegrationName > | null,
    matchingRule?: BankAccountMatchingRule | null,
    balance?: number | null,
    balanceDate?: string | null,
    type: BankAccountType,
    readers?: Array< string > | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateBankAccountMutationVariables = {
  input: UpdateBankAccountInput,
  condition?: ModelBankAccountConditionInput | null,
};

export type UpdateBankAccountMutation = {
  updateBankAccount?:  {
    __typename: "BankAccount",
    id: string,
    contactId: string,
    contact?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    number: string,
    bicNumber?: string | null,
    bankName?: string | null,
    contactIds?: Array< string > | null,
    buildingIds?: Array< string > | null,
    holderName?: string | null,
    label?: string | null,
    customValues?:  Array< {
      __typename: "CustomValue",
      name: string,
      value: string,
    } > | null,
    disabled?: boolean | null,
    integrations?: Array< IntegrationName > | null,
    matchingRule?: BankAccountMatchingRule | null,
    balance?: number | null,
    balanceDate?: string | null,
    type: BankAccountType,
    readers?: Array< string > | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteBankAccountMutationVariables = {
  input: DeleteBankAccountInput,
  condition?: ModelBankAccountConditionInput | null,
};

export type DeleteBankAccountMutation = {
  deleteBankAccount?:  {
    __typename: "BankAccount",
    id: string,
    contactId: string,
    contact?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    number: string,
    bicNumber?: string | null,
    bankName?: string | null,
    contactIds?: Array< string > | null,
    buildingIds?: Array< string > | null,
    holderName?: string | null,
    label?: string | null,
    customValues?:  Array< {
      __typename: "CustomValue",
      name: string,
      value: string,
    } > | null,
    disabled?: boolean | null,
    integrations?: Array< IntegrationName > | null,
    matchingRule?: BankAccountMatchingRule | null,
    balance?: number | null,
    balanceDate?: string | null,
    type: BankAccountType,
    readers?: Array< string > | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateTransactionMutationVariables = {
  input: CreateTransactionInput,
  condition?: ModelTransactionConditionInput | null,
};

export type CreateTransactionMutation = {
  createTransaction?:  {
    __typename: "Transaction",
    id: string,
    status: TransactionStatus,
    sequence?: number | null,
    statementDate: string,
    operationDate?: string | null,
    createdAt?: string | null,
    customValues?:  Array< {
      __typename: "CustomValue",
      name: string,
      value: string,
    } > | null,
    remittanceInformationType?: RemittanceType | null,
    remittanceInformation?: string | null,
    comment?: string | null,
    amount: number,
    bankAccountId: string,
    bankAccount?:  {
      __typename: "BankAccount",
      id: string,
      contactId: string,
      contact?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      number: string,
      bicNumber?: string | null,
      bankName?: string | null,
      contactIds?: Array< string > | null,
      buildingIds?: Array< string > | null,
      holderName?: string | null,
      label?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      disabled?: boolean | null,
      integrations?: Array< IntegrationName > | null,
      matchingRule?: BankAccountMatchingRule | null,
      balance?: number | null,
      balanceDate?: string | null,
      type: BankAccountType,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    counterpartName?: string | null,
    counterpartAccountNumber?: string | null,
    origin: TransactionOrigin,
    proposedLeaseId?: string | null,
    proposedUnitId?: string | null,
    proposedContractorId?: string | null,
    proposedOwnerId?: string | null,
    proposedMatch?: number | null,
    links?:  Array< {
      __typename: "TransactionLink",
      amount: number,
      linkId: string,
      linkType: TransactionLinkType,
    } > | null,
    postings?:  {
      __typename: "ModelPostingConnection",
      items:  Array< {
        __typename: "Posting",
        id: string,
        createdAt?: string | null,
        class: number,
        customLabel?: string | null,
        topClass: number,
        type: PostingType,
        totalAmount: number,
        periodFrom: string,
        periodTo: string,
        buildingId?: string | null,
        unitId?: string | null,
        invoiceId?: string | null,
        chargeId?: string | null,
        transactionId?: string | null,
        leaseId?: string | null,
        bankAccountId?: string | null,
        accountLabelId?: string | null,
        contactId?: string | null,
        leaseVariousOperationId?: string | null,
        statementId?: string | null,
        amountVatExcluded?: number | null,
        vatAmount?: number | null,
        vatRateId?: string | null,
        vatRateValue?: number | null,
        foreignId?: string | null,
        foreignType?: PostingForeignType | null,
        invoicePostingId?: string | null,
        reconciledAt?: string | null,
        status?: PostingStatus | null,
        chargeOwnerRepartition?: number | null,
        chargeRepartitionMetric?: string | null,
        chargeRepartitionValue?: number | null,
        chargeSplitNumber?: number | null,
        chargeType?: PostingChargeType | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    updatedAt: string,
    readers?: Array< string > | null,
    readId: string,
    clientId: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateTransactionMutationVariables = {
  input: UpdateTransactionInput,
  condition?: ModelTransactionConditionInput | null,
};

export type UpdateTransactionMutation = {
  updateTransaction?:  {
    __typename: "Transaction",
    id: string,
    status: TransactionStatus,
    sequence?: number | null,
    statementDate: string,
    operationDate?: string | null,
    createdAt?: string | null,
    customValues?:  Array< {
      __typename: "CustomValue",
      name: string,
      value: string,
    } > | null,
    remittanceInformationType?: RemittanceType | null,
    remittanceInformation?: string | null,
    comment?: string | null,
    amount: number,
    bankAccountId: string,
    bankAccount?:  {
      __typename: "BankAccount",
      id: string,
      contactId: string,
      contact?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      number: string,
      bicNumber?: string | null,
      bankName?: string | null,
      contactIds?: Array< string > | null,
      buildingIds?: Array< string > | null,
      holderName?: string | null,
      label?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      disabled?: boolean | null,
      integrations?: Array< IntegrationName > | null,
      matchingRule?: BankAccountMatchingRule | null,
      balance?: number | null,
      balanceDate?: string | null,
      type: BankAccountType,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    counterpartName?: string | null,
    counterpartAccountNumber?: string | null,
    origin: TransactionOrigin,
    proposedLeaseId?: string | null,
    proposedUnitId?: string | null,
    proposedContractorId?: string | null,
    proposedOwnerId?: string | null,
    proposedMatch?: number | null,
    links?:  Array< {
      __typename: "TransactionLink",
      amount: number,
      linkId: string,
      linkType: TransactionLinkType,
    } > | null,
    postings?:  {
      __typename: "ModelPostingConnection",
      items:  Array< {
        __typename: "Posting",
        id: string,
        createdAt?: string | null,
        class: number,
        customLabel?: string | null,
        topClass: number,
        type: PostingType,
        totalAmount: number,
        periodFrom: string,
        periodTo: string,
        buildingId?: string | null,
        unitId?: string | null,
        invoiceId?: string | null,
        chargeId?: string | null,
        transactionId?: string | null,
        leaseId?: string | null,
        bankAccountId?: string | null,
        accountLabelId?: string | null,
        contactId?: string | null,
        leaseVariousOperationId?: string | null,
        statementId?: string | null,
        amountVatExcluded?: number | null,
        vatAmount?: number | null,
        vatRateId?: string | null,
        vatRateValue?: number | null,
        foreignId?: string | null,
        foreignType?: PostingForeignType | null,
        invoicePostingId?: string | null,
        reconciledAt?: string | null,
        status?: PostingStatus | null,
        chargeOwnerRepartition?: number | null,
        chargeRepartitionMetric?: string | null,
        chargeRepartitionValue?: number | null,
        chargeSplitNumber?: number | null,
        chargeType?: PostingChargeType | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    updatedAt: string,
    readers?: Array< string > | null,
    readId: string,
    clientId: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteTransactionMutationVariables = {
  input: DeleteTransactionInput,
  condition?: ModelTransactionConditionInput | null,
};

export type DeleteTransactionMutation = {
  deleteTransaction?:  {
    __typename: "Transaction",
    id: string,
    status: TransactionStatus,
    sequence?: number | null,
    statementDate: string,
    operationDate?: string | null,
    createdAt?: string | null,
    customValues?:  Array< {
      __typename: "CustomValue",
      name: string,
      value: string,
    } > | null,
    remittanceInformationType?: RemittanceType | null,
    remittanceInformation?: string | null,
    comment?: string | null,
    amount: number,
    bankAccountId: string,
    bankAccount?:  {
      __typename: "BankAccount",
      id: string,
      contactId: string,
      contact?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      number: string,
      bicNumber?: string | null,
      bankName?: string | null,
      contactIds?: Array< string > | null,
      buildingIds?: Array< string > | null,
      holderName?: string | null,
      label?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      disabled?: boolean | null,
      integrations?: Array< IntegrationName > | null,
      matchingRule?: BankAccountMatchingRule | null,
      balance?: number | null,
      balanceDate?: string | null,
      type: BankAccountType,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    counterpartName?: string | null,
    counterpartAccountNumber?: string | null,
    origin: TransactionOrigin,
    proposedLeaseId?: string | null,
    proposedUnitId?: string | null,
    proposedContractorId?: string | null,
    proposedOwnerId?: string | null,
    proposedMatch?: number | null,
    links?:  Array< {
      __typename: "TransactionLink",
      amount: number,
      linkId: string,
      linkType: TransactionLinkType,
    } > | null,
    postings?:  {
      __typename: "ModelPostingConnection",
      items:  Array< {
        __typename: "Posting",
        id: string,
        createdAt?: string | null,
        class: number,
        customLabel?: string | null,
        topClass: number,
        type: PostingType,
        totalAmount: number,
        periodFrom: string,
        periodTo: string,
        buildingId?: string | null,
        unitId?: string | null,
        invoiceId?: string | null,
        chargeId?: string | null,
        transactionId?: string | null,
        leaseId?: string | null,
        bankAccountId?: string | null,
        accountLabelId?: string | null,
        contactId?: string | null,
        leaseVariousOperationId?: string | null,
        statementId?: string | null,
        amountVatExcluded?: number | null,
        vatAmount?: number | null,
        vatRateId?: string | null,
        vatRateValue?: number | null,
        foreignId?: string | null,
        foreignType?: PostingForeignType | null,
        invoicePostingId?: string | null,
        reconciledAt?: string | null,
        status?: PostingStatus | null,
        chargeOwnerRepartition?: number | null,
        chargeRepartitionMetric?: string | null,
        chargeRepartitionValue?: number | null,
        chargeSplitNumber?: number | null,
        chargeType?: PostingChargeType | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    updatedAt: string,
    readers?: Array< string > | null,
    readId: string,
    clientId: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateCounterpartyIdentityMutationVariables = {
  input: CreateCounterpartyIdentityInput,
  condition?: ModelCounterpartyIdentityConditionInput | null,
};

export type CreateCounterpartyIdentityMutation = {
  createCounterpartyIdentity?:  {
    __typename: "CounterpartyIdentity",
    id: string,
    keyType: CounterpartyIdentityKeyType,
    key: string,
    isFullRemittance?: boolean | null,
    kind: CounterpartyIdentityKind,
    contactId?: string | null,
    source: CounterpartyIdentitySource,
    status: CounterpartyIdentityStatus,
    evidenceCount: number,
    firstSeenAt?: string | null,
    lastSeenAt?: string | null,
    lastCounterpartName?: string | null,
    lastDecisionId?: string | null,
    evidenceTransactionIds?: Array< string > | null,
    exclusionReason?: TransactionExclusionReason | null,
    exclusionComment?: string | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateCounterpartyIdentityMutationVariables = {
  input: UpdateCounterpartyIdentityInput,
  condition?: ModelCounterpartyIdentityConditionInput | null,
};

export type UpdateCounterpartyIdentityMutation = {
  updateCounterpartyIdentity?:  {
    __typename: "CounterpartyIdentity",
    id: string,
    keyType: CounterpartyIdentityKeyType,
    key: string,
    isFullRemittance?: boolean | null,
    kind: CounterpartyIdentityKind,
    contactId?: string | null,
    source: CounterpartyIdentitySource,
    status: CounterpartyIdentityStatus,
    evidenceCount: number,
    firstSeenAt?: string | null,
    lastSeenAt?: string | null,
    lastCounterpartName?: string | null,
    lastDecisionId?: string | null,
    evidenceTransactionIds?: Array< string > | null,
    exclusionReason?: TransactionExclusionReason | null,
    exclusionComment?: string | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteCounterpartyIdentityMutationVariables = {
  input: DeleteCounterpartyIdentityInput,
  condition?: ModelCounterpartyIdentityConditionInput | null,
};

export type DeleteCounterpartyIdentityMutation = {
  deleteCounterpartyIdentity?:  {
    __typename: "CounterpartyIdentity",
    id: string,
    keyType: CounterpartyIdentityKeyType,
    key: string,
    isFullRemittance?: boolean | null,
    kind: CounterpartyIdentityKind,
    contactId?: string | null,
    source: CounterpartyIdentitySource,
    status: CounterpartyIdentityStatus,
    evidenceCount: number,
    firstSeenAt?: string | null,
    lastSeenAt?: string | null,
    lastCounterpartName?: string | null,
    lastDecisionId?: string | null,
    evidenceTransactionIds?: Array< string > | null,
    exclusionReason?: TransactionExclusionReason | null,
    exclusionComment?: string | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type GetCounterpartyIdentityQueryVariables = {
  id: string,
};

export type GetCounterpartyIdentityQuery = {
  getCounterpartyIdentity?:  {
    __typename: "CounterpartyIdentity",
    id: string,
    keyType: CounterpartyIdentityKeyType,
    key: string,
    isFullRemittance?: boolean | null,
    kind: CounterpartyIdentityKind,
    contactId?: string | null,
    source: CounterpartyIdentitySource,
    status: CounterpartyIdentityStatus,
    evidenceCount: number,
    firstSeenAt?: string | null,
    lastSeenAt?: string | null,
    lastCounterpartName?: string | null,
    lastDecisionId?: string | null,
    evidenceTransactionIds?: Array< string > | null,
    exclusionReason?: TransactionExclusionReason | null,
    exclusionComment?: string | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListCounterpartyIdentitiesQueryVariables = {
  filter?: ModelCounterpartyIdentityFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListCounterpartyIdentitiesQuery = {
  listCounterpartyIdentities?:  {
    __typename: "ModelCounterpartyIdentityConnection",
    items:  Array< {
      __typename: "CounterpartyIdentity",
      id: string,
      keyType: CounterpartyIdentityKeyType,
      key: string,
      isFullRemittance?: boolean | null,
      kind: CounterpartyIdentityKind,
      contactId?: string | null,
      source: CounterpartyIdentitySource,
      status: CounterpartyIdentityStatus,
      evidenceCount: number,
      firstSeenAt?: string | null,
      lastSeenAt?: string | null,
      lastCounterpartName?: string | null,
      lastDecisionId?: string | null,
      evidenceTransactionIds?: Array< string > | null,
      exclusionReason?: TransactionExclusionReason | null,
      exclusionComment?: string | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncCounterpartyIdentitiesQueryVariables = {
  filter?: ModelCounterpartyIdentityFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncCounterpartyIdentitiesQuery = {
  syncCounterpartyIdentities?:  {
    __typename: "ModelCounterpartyIdentityConnection",
    items:  Array< {
      __typename: "CounterpartyIdentity",
      id: string,
      keyType: CounterpartyIdentityKeyType,
      key: string,
      isFullRemittance?: boolean | null,
      kind: CounterpartyIdentityKind,
      contactId?: string | null,
      source: CounterpartyIdentitySource,
      status: CounterpartyIdentityStatus,
      evidenceCount: number,
      firstSeenAt?: string | null,
      lastSeenAt?: string | null,
      lastCounterpartName?: string | null,
      lastDecisionId?: string | null,
      evidenceTransactionIds?: Array< string > | null,
      exclusionReason?: TransactionExclusionReason | null,
      exclusionComment?: string | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type CreateCounterpartyRoleMutationVariables = {
  input: CreateCounterpartyRoleInput,
  condition?: ModelCounterpartyRoleConditionInput | null,
};

export type CreateCounterpartyRoleMutation = {
  createCounterpartyRole?:  {
    __typename: "CounterpartyRole",
    id: string,
    subjectId: string,
    targetType: CounterpartyRoleTargetType,
    targetId: string,
    source: CounterpartyIdentitySource,
    status: CounterpartyIdentityStatus,
    evidenceCount: number,
    lastSeenAt?: string | null,
    lastDecisionId?: string | null,
    evidenceTransactionIds?: Array< string > | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateCounterpartyRoleMutationVariables = {
  input: UpdateCounterpartyRoleInput,
  condition?: ModelCounterpartyRoleConditionInput | null,
};

export type UpdateCounterpartyRoleMutation = {
  updateCounterpartyRole?:  {
    __typename: "CounterpartyRole",
    id: string,
    subjectId: string,
    targetType: CounterpartyRoleTargetType,
    targetId: string,
    source: CounterpartyIdentitySource,
    status: CounterpartyIdentityStatus,
    evidenceCount: number,
    lastSeenAt?: string | null,
    lastDecisionId?: string | null,
    evidenceTransactionIds?: Array< string > | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteCounterpartyRoleMutationVariables = {
  input: DeleteCounterpartyRoleInput,
  condition?: ModelCounterpartyRoleConditionInput | null,
};

export type DeleteCounterpartyRoleMutation = {
  deleteCounterpartyRole?:  {
    __typename: "CounterpartyRole",
    id: string,
    subjectId: string,
    targetType: CounterpartyRoleTargetType,
    targetId: string,
    source: CounterpartyIdentitySource,
    status: CounterpartyIdentityStatus,
    evidenceCount: number,
    lastSeenAt?: string | null,
    lastDecisionId?: string | null,
    evidenceTransactionIds?: Array< string > | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type GetCounterpartyRoleQueryVariables = {
  id: string,
};

export type GetCounterpartyRoleQuery = {
  getCounterpartyRole?:  {
    __typename: "CounterpartyRole",
    id: string,
    subjectId: string,
    targetType: CounterpartyRoleTargetType,
    targetId: string,
    source: CounterpartyIdentitySource,
    status: CounterpartyIdentityStatus,
    evidenceCount: number,
    lastSeenAt?: string | null,
    lastDecisionId?: string | null,
    evidenceTransactionIds?: Array< string > | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListCounterpartyRolesQueryVariables = {
  filter?: ModelCounterpartyRoleFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListCounterpartyRolesQuery = {
  listCounterpartyRoles?:  {
    __typename: "ModelCounterpartyRoleConnection",
    items:  Array< {
      __typename: "CounterpartyRole",
      id: string,
      subjectId: string,
      targetType: CounterpartyRoleTargetType,
      targetId: string,
      source: CounterpartyIdentitySource,
      status: CounterpartyIdentityStatus,
      evidenceCount: number,
      lastSeenAt?: string | null,
      lastDecisionId?: string | null,
      evidenceTransactionIds?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncCounterpartyRolesQueryVariables = {
  filter?: ModelCounterpartyRoleFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncCounterpartyRolesQuery = {
  syncCounterpartyRoles?:  {
    __typename: "ModelCounterpartyRoleConnection",
    items:  Array< {
      __typename: "CounterpartyRole",
      id: string,
      subjectId: string,
      targetType: CounterpartyRoleTargetType,
      targetId: string,
      source: CounterpartyIdentitySource,
      status: CounterpartyIdentityStatus,
      evidenceCount: number,
      lastSeenAt?: string | null,
      lastDecisionId?: string | null,
      evidenceTransactionIds?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type CreateTransactionRuleMutationVariables = {
  input: CreateTransactionRuleInput,
  condition?: ModelTransactionRuleConditionInput | null,
};

export type CreateTransactionRuleMutation = {
  createTransactionRule?:  {
    __typename: "TransactionRule",
    id: string,
    isFullRemittance?: boolean | null,
    remittanceInformation?: string | null,
    counterpartName?: string | null,
    counterpartAccountNumber?: string | null,
    usedFields: string,
    exclude: boolean,
    leaseId?: string | null,
    lease?:  {
      __typename: "Lease",
      id: string,
      advancedChargesInvoices?:  {
        __typename: "LeaseAdvancedChargesInvoice",
        communicationSettingsProfileId: string,
        invoiceSenderId: string,
        lastDraftInvoiceDate?: string | null,
        lastInvoiceDate?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        bankAccountId?: string | null,
      } | null,
      balance?: number | null,
      canBeExtended?: boolean | null,
      communicationSettingsProfileId: string,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      endDate: string,
      includeRealEstateInLeaseContract?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      invoiceSenderId: string,
      invoiceSender?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      inventoryOfFixturesExpert?: string | null,
      inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
      inventoryOfFixturesType?: InventoryOfFixturesType | null,
      ipiNumber?: string | null,
      language: Language,
      lastDraftInvoiceDate?: string | null,
      lastIndexationProcessDate?: string | null,
      lastInvoiceDate?: string | null,
      legalCompetentAuthority?: string | null,
      name: string,
      notes?: string | null,
      paymentFrequency: LeasePaymentFrequency,
      paymentInvoicePeriod: LeasePaymentInvoicePeriod,
      paymentInvoicePeriodCustomDay?: number | null,
      paymentOption?:  {
        __typename: "LeasePaymentOption",
        customerId?: string | null,
        enabled: boolean,
        mandateActivatedAt?: string | null,
        mandateStatus?: PaymentProviderMandateStatus | null,
        paymentMethodId?: string | null,
        qrType?: LeaseQrType | null,
      } | null,
      purchaseOrderNumber?: string | null,
      realEstateAgency?: string | null,
      realEstateTax?: number | null,
      remittanceInformation?: string | null,
      remittanceInformationType?: LeaseRemittanceType | null,
      rentalGuaranty?:  {
        __typename: "LeaseRentalGuaranty",
        amount: number,
        blockedAmount?: number | null,
        releasedAmount?: number | null,
        type: LeaseRentalGuarantyType,
        financialInstitution?: string | null,
      } | null,
      signatureDate?: string | null,
      startDate: string,
      nextIndexationMonth?: string | null,
      nextIndexation?: boolean | null,
      status: LeaseStatus,
      technicCommunicationSettingsProfileId: string,
      totalInitialRentalPrice: number,
      totalRentalPrice: number,
      type: LeaseType,
      subletting?: boolean | null,
      vatRateRentId?: string | null,
      vatRateRent?:  {
        __typename: "VatRate",
        id: string,
        country: string,
        label: string,
        value?: number | null,
        ownerId?: string | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      additionalClauses?:  {
        __typename: "ModelLeaseAdditionalClauseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      bankAccountId?: string | null,
      bankAccount?:  {
        __typename: "BankAccount",
        id: string,
        contactId: string,
        number: string,
        bicNumber?: string | null,
        bankName?: string | null,
        contactIds?: Array< string > | null,
        buildingIds?: Array< string > | null,
        holderName?: string | null,
        label?: string | null,
        disabled?: boolean | null,
        integrations?: Array< IntegrationName > | null,
        matchingRule?: BankAccountMatchingRule | null,
        balance?: number | null,
        balanceDate?: string | null,
        type: BankAccountType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contacts?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      files?:  {
        __typename: "ModelFileConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leaseActionHistories?:  {
        __typename: "ModelLeaseActionHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leasePriceHistories?:  {
        __typename: "ModelLeasePriceHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      signatureDocuments?:  {
        __typename: "ModelSignatureDocumentConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      variousOperations?:  {
        __typename: "ModelLeaseVariousOperationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    unitId?: string | null,
    unit?:  {
      __typename: "Unit",
      id: string,
      acquisitionAdditionalCostsValue?: number | null,
      acquisitionAdvertisedValue?: number | null,
      acquisitionValue?: number | null,
      advertisedMonthlyCharges?: number | null,
      advertisedRentalPrice?: number | null,
      cadastralIncome?: number | null,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      floor?: number | null,
      jointOwnershipId?: string | null,
      managementDate: string,
      name: string,
      notes?: string | null,
      predictedPrice?: string | null,
      propertyTax?: number | null,
      publishAddress?: boolean | null,
      surface?: number | null,
      type: UnitType,
      buildingId: string,
      building?:  {
        __typename: "Building",
        id: string,
        name: string,
        addressId?: string | null,
        acquisitionValue?: number | null,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        amountOfFacades?: number | null,
        amountOfFloors?: number | null,
        amountOfHousings?: number | null,
        buildingState?: BuildingState | null,
        cadastralIncome?: number | null,
        constructionYear?: string | null,
        janitor?: boolean | null,
        jointOwnershipId?: string | null,
        notes?: string | null,
        propertyTax?: number | null,
        residenceName?: string | null,
        buildingSiteId?: string | null,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      owners?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leases?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      events?:  {
        __typename: "ModelUnitEventConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      unitAdvertisementId?: string | null,
      unitInventories?:  {
        __typename: "ModelUnitInventoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    contractorId?: string | null,
    contractor?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    ownerId?: string | null,
    owner?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateTransactionRuleMutationVariables = {
  input: UpdateTransactionRuleInput,
  condition?: ModelTransactionRuleConditionInput | null,
};

export type UpdateTransactionRuleMutation = {
  updateTransactionRule?:  {
    __typename: "TransactionRule",
    id: string,
    isFullRemittance?: boolean | null,
    remittanceInformation?: string | null,
    counterpartName?: string | null,
    counterpartAccountNumber?: string | null,
    usedFields: string,
    exclude: boolean,
    leaseId?: string | null,
    lease?:  {
      __typename: "Lease",
      id: string,
      advancedChargesInvoices?:  {
        __typename: "LeaseAdvancedChargesInvoice",
        communicationSettingsProfileId: string,
        invoiceSenderId: string,
        lastDraftInvoiceDate?: string | null,
        lastInvoiceDate?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        bankAccountId?: string | null,
      } | null,
      balance?: number | null,
      canBeExtended?: boolean | null,
      communicationSettingsProfileId: string,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      endDate: string,
      includeRealEstateInLeaseContract?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      invoiceSenderId: string,
      invoiceSender?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      inventoryOfFixturesExpert?: string | null,
      inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
      inventoryOfFixturesType?: InventoryOfFixturesType | null,
      ipiNumber?: string | null,
      language: Language,
      lastDraftInvoiceDate?: string | null,
      lastIndexationProcessDate?: string | null,
      lastInvoiceDate?: string | null,
      legalCompetentAuthority?: string | null,
      name: string,
      notes?: string | null,
      paymentFrequency: LeasePaymentFrequency,
      paymentInvoicePeriod: LeasePaymentInvoicePeriod,
      paymentInvoicePeriodCustomDay?: number | null,
      paymentOption?:  {
        __typename: "LeasePaymentOption",
        customerId?: string | null,
        enabled: boolean,
        mandateActivatedAt?: string | null,
        mandateStatus?: PaymentProviderMandateStatus | null,
        paymentMethodId?: string | null,
        qrType?: LeaseQrType | null,
      } | null,
      purchaseOrderNumber?: string | null,
      realEstateAgency?: string | null,
      realEstateTax?: number | null,
      remittanceInformation?: string | null,
      remittanceInformationType?: LeaseRemittanceType | null,
      rentalGuaranty?:  {
        __typename: "LeaseRentalGuaranty",
        amount: number,
        blockedAmount?: number | null,
        releasedAmount?: number | null,
        type: LeaseRentalGuarantyType,
        financialInstitution?: string | null,
      } | null,
      signatureDate?: string | null,
      startDate: string,
      nextIndexationMonth?: string | null,
      nextIndexation?: boolean | null,
      status: LeaseStatus,
      technicCommunicationSettingsProfileId: string,
      totalInitialRentalPrice: number,
      totalRentalPrice: number,
      type: LeaseType,
      subletting?: boolean | null,
      vatRateRentId?: string | null,
      vatRateRent?:  {
        __typename: "VatRate",
        id: string,
        country: string,
        label: string,
        value?: number | null,
        ownerId?: string | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      additionalClauses?:  {
        __typename: "ModelLeaseAdditionalClauseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      bankAccountId?: string | null,
      bankAccount?:  {
        __typename: "BankAccount",
        id: string,
        contactId: string,
        number: string,
        bicNumber?: string | null,
        bankName?: string | null,
        contactIds?: Array< string > | null,
        buildingIds?: Array< string > | null,
        holderName?: string | null,
        label?: string | null,
        disabled?: boolean | null,
        integrations?: Array< IntegrationName > | null,
        matchingRule?: BankAccountMatchingRule | null,
        balance?: number | null,
        balanceDate?: string | null,
        type: BankAccountType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contacts?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      files?:  {
        __typename: "ModelFileConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leaseActionHistories?:  {
        __typename: "ModelLeaseActionHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leasePriceHistories?:  {
        __typename: "ModelLeasePriceHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      signatureDocuments?:  {
        __typename: "ModelSignatureDocumentConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      variousOperations?:  {
        __typename: "ModelLeaseVariousOperationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    unitId?: string | null,
    unit?:  {
      __typename: "Unit",
      id: string,
      acquisitionAdditionalCostsValue?: number | null,
      acquisitionAdvertisedValue?: number | null,
      acquisitionValue?: number | null,
      advertisedMonthlyCharges?: number | null,
      advertisedRentalPrice?: number | null,
      cadastralIncome?: number | null,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      floor?: number | null,
      jointOwnershipId?: string | null,
      managementDate: string,
      name: string,
      notes?: string | null,
      predictedPrice?: string | null,
      propertyTax?: number | null,
      publishAddress?: boolean | null,
      surface?: number | null,
      type: UnitType,
      buildingId: string,
      building?:  {
        __typename: "Building",
        id: string,
        name: string,
        addressId?: string | null,
        acquisitionValue?: number | null,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        amountOfFacades?: number | null,
        amountOfFloors?: number | null,
        amountOfHousings?: number | null,
        buildingState?: BuildingState | null,
        cadastralIncome?: number | null,
        constructionYear?: string | null,
        janitor?: boolean | null,
        jointOwnershipId?: string | null,
        notes?: string | null,
        propertyTax?: number | null,
        residenceName?: string | null,
        buildingSiteId?: string | null,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      owners?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leases?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      events?:  {
        __typename: "ModelUnitEventConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      unitAdvertisementId?: string | null,
      unitInventories?:  {
        __typename: "ModelUnitInventoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    contractorId?: string | null,
    contractor?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    ownerId?: string | null,
    owner?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteTransactionRuleMutationVariables = {
  input: DeleteTransactionRuleInput,
  condition?: ModelTransactionRuleConditionInput | null,
};

export type DeleteTransactionRuleMutation = {
  deleteTransactionRule?:  {
    __typename: "TransactionRule",
    id: string,
    isFullRemittance?: boolean | null,
    remittanceInformation?: string | null,
    counterpartName?: string | null,
    counterpartAccountNumber?: string | null,
    usedFields: string,
    exclude: boolean,
    leaseId?: string | null,
    lease?:  {
      __typename: "Lease",
      id: string,
      advancedChargesInvoices?:  {
        __typename: "LeaseAdvancedChargesInvoice",
        communicationSettingsProfileId: string,
        invoiceSenderId: string,
        lastDraftInvoiceDate?: string | null,
        lastInvoiceDate?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        bankAccountId?: string | null,
      } | null,
      balance?: number | null,
      canBeExtended?: boolean | null,
      communicationSettingsProfileId: string,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      endDate: string,
      includeRealEstateInLeaseContract?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      invoiceSenderId: string,
      invoiceSender?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      inventoryOfFixturesExpert?: string | null,
      inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
      inventoryOfFixturesType?: InventoryOfFixturesType | null,
      ipiNumber?: string | null,
      language: Language,
      lastDraftInvoiceDate?: string | null,
      lastIndexationProcessDate?: string | null,
      lastInvoiceDate?: string | null,
      legalCompetentAuthority?: string | null,
      name: string,
      notes?: string | null,
      paymentFrequency: LeasePaymentFrequency,
      paymentInvoicePeriod: LeasePaymentInvoicePeriod,
      paymentInvoicePeriodCustomDay?: number | null,
      paymentOption?:  {
        __typename: "LeasePaymentOption",
        customerId?: string | null,
        enabled: boolean,
        mandateActivatedAt?: string | null,
        mandateStatus?: PaymentProviderMandateStatus | null,
        paymentMethodId?: string | null,
        qrType?: LeaseQrType | null,
      } | null,
      purchaseOrderNumber?: string | null,
      realEstateAgency?: string | null,
      realEstateTax?: number | null,
      remittanceInformation?: string | null,
      remittanceInformationType?: LeaseRemittanceType | null,
      rentalGuaranty?:  {
        __typename: "LeaseRentalGuaranty",
        amount: number,
        blockedAmount?: number | null,
        releasedAmount?: number | null,
        type: LeaseRentalGuarantyType,
        financialInstitution?: string | null,
      } | null,
      signatureDate?: string | null,
      startDate: string,
      nextIndexationMonth?: string | null,
      nextIndexation?: boolean | null,
      status: LeaseStatus,
      technicCommunicationSettingsProfileId: string,
      totalInitialRentalPrice: number,
      totalRentalPrice: number,
      type: LeaseType,
      subletting?: boolean | null,
      vatRateRentId?: string | null,
      vatRateRent?:  {
        __typename: "VatRate",
        id: string,
        country: string,
        label: string,
        value?: number | null,
        ownerId?: string | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      additionalClauses?:  {
        __typename: "ModelLeaseAdditionalClauseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      bankAccountId?: string | null,
      bankAccount?:  {
        __typename: "BankAccount",
        id: string,
        contactId: string,
        number: string,
        bicNumber?: string | null,
        bankName?: string | null,
        contactIds?: Array< string > | null,
        buildingIds?: Array< string > | null,
        holderName?: string | null,
        label?: string | null,
        disabled?: boolean | null,
        integrations?: Array< IntegrationName > | null,
        matchingRule?: BankAccountMatchingRule | null,
        balance?: number | null,
        balanceDate?: string | null,
        type: BankAccountType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contacts?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      files?:  {
        __typename: "ModelFileConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leaseActionHistories?:  {
        __typename: "ModelLeaseActionHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leasePriceHistories?:  {
        __typename: "ModelLeasePriceHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      signatureDocuments?:  {
        __typename: "ModelSignatureDocumentConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      variousOperations?:  {
        __typename: "ModelLeaseVariousOperationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    unitId?: string | null,
    unit?:  {
      __typename: "Unit",
      id: string,
      acquisitionAdditionalCostsValue?: number | null,
      acquisitionAdvertisedValue?: number | null,
      acquisitionValue?: number | null,
      advertisedMonthlyCharges?: number | null,
      advertisedRentalPrice?: number | null,
      cadastralIncome?: number | null,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      floor?: number | null,
      jointOwnershipId?: string | null,
      managementDate: string,
      name: string,
      notes?: string | null,
      predictedPrice?: string | null,
      propertyTax?: number | null,
      publishAddress?: boolean | null,
      surface?: number | null,
      type: UnitType,
      buildingId: string,
      building?:  {
        __typename: "Building",
        id: string,
        name: string,
        addressId?: string | null,
        acquisitionValue?: number | null,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        amountOfFacades?: number | null,
        amountOfFloors?: number | null,
        amountOfHousings?: number | null,
        buildingState?: BuildingState | null,
        cadastralIncome?: number | null,
        constructionYear?: string | null,
        janitor?: boolean | null,
        jointOwnershipId?: string | null,
        notes?: string | null,
        propertyTax?: number | null,
        residenceName?: string | null,
        buildingSiteId?: string | null,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      owners?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leases?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      events?:  {
        __typename: "ModelUnitEventConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      unitAdvertisementId?: string | null,
      unitInventories?:  {
        __typename: "ModelUnitInventoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    contractorId?: string | null,
    contractor?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    ownerId?: string | null,
    owner?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateVatRateMutationVariables = {
  input: CreateVatRateInput,
  condition?: ModelVatRateConditionInput | null,
};

export type CreateVatRateMutation = {
  createVatRate?:  {
    __typename: "VatRate",
    id: string,
    country: string,
    label: string,
    value?: number | null,
    customValues?:  Array< {
      __typename: "CustomValue",
      name: string,
      value: string,
    } > | null,
    ownerId?: string | null,
    owner?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateVatRateMutationVariables = {
  input: UpdateVatRateInput,
  condition?: ModelVatRateConditionInput | null,
};

export type UpdateVatRateMutation = {
  updateVatRate?:  {
    __typename: "VatRate",
    id: string,
    country: string,
    label: string,
    value?: number | null,
    customValues?:  Array< {
      __typename: "CustomValue",
      name: string,
      value: string,
    } > | null,
    ownerId?: string | null,
    owner?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteVatRateMutationVariables = {
  input: DeleteVatRateInput,
  condition?: ModelVatRateConditionInput | null,
};

export type DeleteVatRateMutation = {
  deleteVatRate?:  {
    __typename: "VatRate",
    id: string,
    country: string,
    label: string,
    value?: number | null,
    customValues?:  Array< {
      __typename: "CustomValue",
      name: string,
      value: string,
    } > | null,
    ownerId?: string | null,
    owner?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateAdvertisementMutationVariables = {
  input: CreateAdvertisementInput,
  condition?: ModelAdvertisementConditionInput | null,
};

export type CreateAdvertisementMutation = {
  createAdvertisement?:  {
    __typename: "Advertisement",
    id: string,
    type?: AdvertisementUnitType | null,
    subType?: AdvertisementUnitSubType | null,
    amenities?: Array< AmenitiesType > | null,
    amountOfFacades?: number | null,
    availabilityDate?: string | null,
    certificateOfConformity?: CertificateOfConformityType | null,
    citationForPlanningOffence?: boolean | null,
    descriptions?:  Array< {
      __typename: "AdvertisementDescription",
      language: string,
      description?: string | null,
    } > | null,
    delimitedZone?: DelimitedZoneType | null,
    floodProneArea?: FloodProneAreaType | null,
    furnished?: boolean | null,
    firstOccupancy?: boolean | null,
    gardenSurface?: number | null,
    heatingAmenities?: Array< HeatingAmenities > | null,
    heatingType?: HeatingType | null,
    landTerrain?: Array< LandTerrainType > | null,
    landArea?: number | null,
    length?: number | null,
    nearbyComodities?:  Array< {
      __typename: "NearbyComodity",
      type: NearbyCommoditiesTypes,
      name: string,
      distance: number,
    } > | null,
    publishedPlatforms?:  Array< {
      __typename: "PublishedPlatform",
      name: PublishingPlatform,
      publishedDate: string,
      id: string,
    } > | null,
    planningPermission?: boolean | null,
    publishCadastralIncome?: boolean | null,
    resort?: boolean | null,
    rightOfPreemption?: boolean | null,
    subdivisionAuthorization?: boolean | null,
    wheelChairAccessible?: boolean | null,
    width?: number | null,
    terraceSurface?: number | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateAdvertisementMutationVariables = {
  input: UpdateAdvertisementInput,
  condition?: ModelAdvertisementConditionInput | null,
};

export type UpdateAdvertisementMutation = {
  updateAdvertisement?:  {
    __typename: "Advertisement",
    id: string,
    type?: AdvertisementUnitType | null,
    subType?: AdvertisementUnitSubType | null,
    amenities?: Array< AmenitiesType > | null,
    amountOfFacades?: number | null,
    availabilityDate?: string | null,
    certificateOfConformity?: CertificateOfConformityType | null,
    citationForPlanningOffence?: boolean | null,
    descriptions?:  Array< {
      __typename: "AdvertisementDescription",
      language: string,
      description?: string | null,
    } > | null,
    delimitedZone?: DelimitedZoneType | null,
    floodProneArea?: FloodProneAreaType | null,
    furnished?: boolean | null,
    firstOccupancy?: boolean | null,
    gardenSurface?: number | null,
    heatingAmenities?: Array< HeatingAmenities > | null,
    heatingType?: HeatingType | null,
    landTerrain?: Array< LandTerrainType > | null,
    landArea?: number | null,
    length?: number | null,
    nearbyComodities?:  Array< {
      __typename: "NearbyComodity",
      type: NearbyCommoditiesTypes,
      name: string,
      distance: number,
    } > | null,
    publishedPlatforms?:  Array< {
      __typename: "PublishedPlatform",
      name: PublishingPlatform,
      publishedDate: string,
      id: string,
    } > | null,
    planningPermission?: boolean | null,
    publishCadastralIncome?: boolean | null,
    resort?: boolean | null,
    rightOfPreemption?: boolean | null,
    subdivisionAuthorization?: boolean | null,
    wheelChairAccessible?: boolean | null,
    width?: number | null,
    terraceSurface?: number | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteAdvertisementMutationVariables = {
  input: DeleteAdvertisementInput,
  condition?: ModelAdvertisementConditionInput | null,
};

export type DeleteAdvertisementMutation = {
  deleteAdvertisement?:  {
    __typename: "Advertisement",
    id: string,
    type?: AdvertisementUnitType | null,
    subType?: AdvertisementUnitSubType | null,
    amenities?: Array< AmenitiesType > | null,
    amountOfFacades?: number | null,
    availabilityDate?: string | null,
    certificateOfConformity?: CertificateOfConformityType | null,
    citationForPlanningOffence?: boolean | null,
    descriptions?:  Array< {
      __typename: "AdvertisementDescription",
      language: string,
      description?: string | null,
    } > | null,
    delimitedZone?: DelimitedZoneType | null,
    floodProneArea?: FloodProneAreaType | null,
    furnished?: boolean | null,
    firstOccupancy?: boolean | null,
    gardenSurface?: number | null,
    heatingAmenities?: Array< HeatingAmenities > | null,
    heatingType?: HeatingType | null,
    landTerrain?: Array< LandTerrainType > | null,
    landArea?: number | null,
    length?: number | null,
    nearbyComodities?:  Array< {
      __typename: "NearbyComodity",
      type: NearbyCommoditiesTypes,
      name: string,
      distance: number,
    } > | null,
    publishedPlatforms?:  Array< {
      __typename: "PublishedPlatform",
      name: PublishingPlatform,
      publishedDate: string,
      id: string,
    } > | null,
    planningPermission?: boolean | null,
    publishCadastralIncome?: boolean | null,
    resort?: boolean | null,
    rightOfPreemption?: boolean | null,
    subdivisionAuthorization?: boolean | null,
    wheelChairAccessible?: boolean | null,
    width?: number | null,
    terraceSurface?: number | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateAgencyRateMutationVariables = {
  input: CreateAgencyRateInput,
  condition?: ModelAgencyRateConditionInput | null,
};

export type CreateAgencyRateMutation = {
  createAgencyRate?:  {
    __typename: "AgencyRate",
    id: string,
    amountDetails:  Array< {
      __typename: "AgencyRateAmountDetail",
      amountType: AgencyRateAmountDetailType,
      endAmount?: number | null,
      feeApplied: number,
      startAmount: number,
    } >,
    rateWhenVacant?:  {
      __typename: "AgencyRateWhenVacant",
      amount: number,
      type: AgencyRateAmountDetailType,
    } | null,
    amountMinimumFees?: number | null,
    custom: boolean,
    feesAppliedTo: AgencyRateFeesType,
    includedInAmount?: Array< AgencyRateIncludedAmount > | null,
    name: string,
    owners?:  {
      __typename: "ModelAgencyRateOwnerConnection",
      items:  Array< {
        __typename: "AgencyRateOwner",
        id: string,
        agencyRateId: string,
        contactId: string,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    repartitionType: AgencyRateRepartitionType,
    type: AgencyRateType,
    unitType: Array< UnitType >,
    vatRateId?: string | null,
    unitIds?: Array< string | null > | null,
    vatRate?:  {
      __typename: "VatRate",
      id: string,
      country: string,
      label: string,
      value?: number | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      ownerId?: string | null,
      owner?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateAgencyRateMutationVariables = {
  input: UpdateAgencyRateInput,
  condition?: ModelAgencyRateConditionInput | null,
};

export type UpdateAgencyRateMutation = {
  updateAgencyRate?:  {
    __typename: "AgencyRate",
    id: string,
    amountDetails:  Array< {
      __typename: "AgencyRateAmountDetail",
      amountType: AgencyRateAmountDetailType,
      endAmount?: number | null,
      feeApplied: number,
      startAmount: number,
    } >,
    rateWhenVacant?:  {
      __typename: "AgencyRateWhenVacant",
      amount: number,
      type: AgencyRateAmountDetailType,
    } | null,
    amountMinimumFees?: number | null,
    custom: boolean,
    feesAppliedTo: AgencyRateFeesType,
    includedInAmount?: Array< AgencyRateIncludedAmount > | null,
    name: string,
    owners?:  {
      __typename: "ModelAgencyRateOwnerConnection",
      items:  Array< {
        __typename: "AgencyRateOwner",
        id: string,
        agencyRateId: string,
        contactId: string,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    repartitionType: AgencyRateRepartitionType,
    type: AgencyRateType,
    unitType: Array< UnitType >,
    vatRateId?: string | null,
    unitIds?: Array< string | null > | null,
    vatRate?:  {
      __typename: "VatRate",
      id: string,
      country: string,
      label: string,
      value?: number | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      ownerId?: string | null,
      owner?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteAgencyRateMutationVariables = {
  input: DeleteAgencyRateInput,
  condition?: ModelAgencyRateConditionInput | null,
};

export type DeleteAgencyRateMutation = {
  deleteAgencyRate?:  {
    __typename: "AgencyRate",
    id: string,
    amountDetails:  Array< {
      __typename: "AgencyRateAmountDetail",
      amountType: AgencyRateAmountDetailType,
      endAmount?: number | null,
      feeApplied: number,
      startAmount: number,
    } >,
    rateWhenVacant?:  {
      __typename: "AgencyRateWhenVacant",
      amount: number,
      type: AgencyRateAmountDetailType,
    } | null,
    amountMinimumFees?: number | null,
    custom: boolean,
    feesAppliedTo: AgencyRateFeesType,
    includedInAmount?: Array< AgencyRateIncludedAmount > | null,
    name: string,
    owners?:  {
      __typename: "ModelAgencyRateOwnerConnection",
      items:  Array< {
        __typename: "AgencyRateOwner",
        id: string,
        agencyRateId: string,
        contactId: string,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    repartitionType: AgencyRateRepartitionType,
    type: AgencyRateType,
    unitType: Array< UnitType >,
    vatRateId?: string | null,
    unitIds?: Array< string | null > | null,
    vatRate?:  {
      __typename: "VatRate",
      id: string,
      country: string,
      label: string,
      value?: number | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      ownerId?: string | null,
      owner?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateAgencyRateOwnerMutationVariables = {
  input: CreateAgencyRateOwnerInput,
  condition?: ModelAgencyRateOwnerConditionInput | null,
};

export type CreateAgencyRateOwnerMutation = {
  createAgencyRateOwner?:  {
    __typename: "AgencyRateOwner",
    id: string,
    agencyRateId: string,
    contactId: string,
    agencyRate?:  {
      __typename: "AgencyRate",
      id: string,
      amountDetails:  Array< {
        __typename: "AgencyRateAmountDetail",
        amountType: AgencyRateAmountDetailType,
        endAmount?: number | null,
        feeApplied: number,
        startAmount: number,
      } >,
      rateWhenVacant?:  {
        __typename: "AgencyRateWhenVacant",
        amount: number,
        type: AgencyRateAmountDetailType,
      } | null,
      amountMinimumFees?: number | null,
      custom: boolean,
      feesAppliedTo: AgencyRateFeesType,
      includedInAmount?: Array< AgencyRateIncludedAmount > | null,
      name: string,
      owners?:  {
        __typename: "ModelAgencyRateOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      repartitionType: AgencyRateRepartitionType,
      type: AgencyRateType,
      unitType: Array< UnitType >,
      vatRateId?: string | null,
      unitIds?: Array< string | null > | null,
      vatRate?:  {
        __typename: "VatRate",
        id: string,
        country: string,
        label: string,
        value?: number | null,
        ownerId?: string | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    owner?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateAgencyRateOwnerMutationVariables = {
  input: UpdateAgencyRateOwnerInput,
  condition?: ModelAgencyRateOwnerConditionInput | null,
};

export type UpdateAgencyRateOwnerMutation = {
  updateAgencyRateOwner?:  {
    __typename: "AgencyRateOwner",
    id: string,
    agencyRateId: string,
    contactId: string,
    agencyRate?:  {
      __typename: "AgencyRate",
      id: string,
      amountDetails:  Array< {
        __typename: "AgencyRateAmountDetail",
        amountType: AgencyRateAmountDetailType,
        endAmount?: number | null,
        feeApplied: number,
        startAmount: number,
      } >,
      rateWhenVacant?:  {
        __typename: "AgencyRateWhenVacant",
        amount: number,
        type: AgencyRateAmountDetailType,
      } | null,
      amountMinimumFees?: number | null,
      custom: boolean,
      feesAppliedTo: AgencyRateFeesType,
      includedInAmount?: Array< AgencyRateIncludedAmount > | null,
      name: string,
      owners?:  {
        __typename: "ModelAgencyRateOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      repartitionType: AgencyRateRepartitionType,
      type: AgencyRateType,
      unitType: Array< UnitType >,
      vatRateId?: string | null,
      unitIds?: Array< string | null > | null,
      vatRate?:  {
        __typename: "VatRate",
        id: string,
        country: string,
        label: string,
        value?: number | null,
        ownerId?: string | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    owner?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteAgencyRateOwnerMutationVariables = {
  input: DeleteAgencyRateOwnerInput,
  condition?: ModelAgencyRateOwnerConditionInput | null,
};

export type DeleteAgencyRateOwnerMutation = {
  deleteAgencyRateOwner?:  {
    __typename: "AgencyRateOwner",
    id: string,
    agencyRateId: string,
    contactId: string,
    agencyRate?:  {
      __typename: "AgencyRate",
      id: string,
      amountDetails:  Array< {
        __typename: "AgencyRateAmountDetail",
        amountType: AgencyRateAmountDetailType,
        endAmount?: number | null,
        feeApplied: number,
        startAmount: number,
      } >,
      rateWhenVacant?:  {
        __typename: "AgencyRateWhenVacant",
        amount: number,
        type: AgencyRateAmountDetailType,
      } | null,
      amountMinimumFees?: number | null,
      custom: boolean,
      feesAppliedTo: AgencyRateFeesType,
      includedInAmount?: Array< AgencyRateIncludedAmount > | null,
      name: string,
      owners?:  {
        __typename: "ModelAgencyRateOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      repartitionType: AgencyRateRepartitionType,
      type: AgencyRateType,
      unitType: Array< UnitType >,
      vatRateId?: string | null,
      unitIds?: Array< string | null > | null,
      vatRate?:  {
        __typename: "VatRate",
        id: string,
        country: string,
        label: string,
        value?: number | null,
        ownerId?: string | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    owner?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateAgencyRateStatementMutationVariables = {
  input: CreateAgencyRateStatementInput,
  condition?: ModelAgencyRateStatementConditionInput | null,
};

export type CreateAgencyRateStatementMutation = {
  createAgencyRateStatement?:  {
    __typename: "AgencyRateStatement",
    id: string,
    agencyRate?:  {
      __typename: "AgencyRate",
      id: string,
      amountDetails:  Array< {
        __typename: "AgencyRateAmountDetail",
        amountType: AgencyRateAmountDetailType,
        endAmount?: number | null,
        feeApplied: number,
        startAmount: number,
      } >,
      rateWhenVacant?:  {
        __typename: "AgencyRateWhenVacant",
        amount: number,
        type: AgencyRateAmountDetailType,
      } | null,
      amountMinimumFees?: number | null,
      custom: boolean,
      feesAppliedTo: AgencyRateFeesType,
      includedInAmount?: Array< AgencyRateIncludedAmount > | null,
      name: string,
      owners?:  {
        __typename: "ModelAgencyRateOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      repartitionType: AgencyRateRepartitionType,
      type: AgencyRateType,
      unitType: Array< UnitType >,
      vatRateId?: string | null,
      unitIds?: Array< string | null > | null,
      vatRate?:  {
        __typename: "VatRate",
        id: string,
        country: string,
        label: string,
        value?: number | null,
        ownerId?: string | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    agencyRateId: string,
    statement?:  {
      __typename: "Statement",
      id: string,
      amounts?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      chargeStatements?:  {
        __typename: "ModelChargeStatementConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      closingStatement: boolean,
      periodFrom: string,
      periodTo: string,
      attachSupportingDocuments?: boolean | null,
      selectedPocketKeys?: Array< string > | null,
      source: StatementSource,
      status: StatementStatus,
      sentDate?: string | null,
      leaseId?: string | null,
      lease?:  {
        __typename: "Lease",
        id: string,
        balance?: number | null,
        canBeExtended?: boolean | null,
        communicationSettingsProfileId: string,
        createdAt?: string | null,
        endDate: string,
        includeRealEstateInLeaseContract?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        invoiceSenderId: string,
        inventoryOfFixturesExpert?: string | null,
        inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
        inventoryOfFixturesType?: InventoryOfFixturesType | null,
        ipiNumber?: string | null,
        language: Language,
        lastDraftInvoiceDate?: string | null,
        lastIndexationProcessDate?: string | null,
        lastInvoiceDate?: string | null,
        legalCompetentAuthority?: string | null,
        name: string,
        notes?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        purchaseOrderNumber?: string | null,
        realEstateAgency?: string | null,
        realEstateTax?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        signatureDate?: string | null,
        startDate: string,
        nextIndexationMonth?: string | null,
        nextIndexation?: boolean | null,
        status: LeaseStatus,
        technicCommunicationSettingsProfileId: string,
        totalInitialRentalPrice: number,
        totalRentalPrice: number,
        type: LeaseType,
        subletting?: boolean | null,
        vatRateRentId?: string | null,
        bankAccountId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      agencyRateStatements?:  {
        __typename: "ModelAgencyRateStatementConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      ownerId?: string | null,
      owner?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      repaymentStatements?:  {
        __typename: "ModelRepaymentStatementConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      types?: Array< StatementType > | null,
      viewType: StatementViewType,
      unitIds?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    statementId: string,
    unitAmounts?:  Array< {
      __typename: "AgencyRateStatementAmount",
      unitId?: string | null,
      amountRateable: number,
      fixedAmount: number,
    } > | null,
    totalAmountRateable: number,
    totalFixedAmount: number,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateAgencyRateStatementMutationVariables = {
  input: UpdateAgencyRateStatementInput,
  condition?: ModelAgencyRateStatementConditionInput | null,
};

export type UpdateAgencyRateStatementMutation = {
  updateAgencyRateStatement?:  {
    __typename: "AgencyRateStatement",
    id: string,
    agencyRate?:  {
      __typename: "AgencyRate",
      id: string,
      amountDetails:  Array< {
        __typename: "AgencyRateAmountDetail",
        amountType: AgencyRateAmountDetailType,
        endAmount?: number | null,
        feeApplied: number,
        startAmount: number,
      } >,
      rateWhenVacant?:  {
        __typename: "AgencyRateWhenVacant",
        amount: number,
        type: AgencyRateAmountDetailType,
      } | null,
      amountMinimumFees?: number | null,
      custom: boolean,
      feesAppliedTo: AgencyRateFeesType,
      includedInAmount?: Array< AgencyRateIncludedAmount > | null,
      name: string,
      owners?:  {
        __typename: "ModelAgencyRateOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      repartitionType: AgencyRateRepartitionType,
      type: AgencyRateType,
      unitType: Array< UnitType >,
      vatRateId?: string | null,
      unitIds?: Array< string | null > | null,
      vatRate?:  {
        __typename: "VatRate",
        id: string,
        country: string,
        label: string,
        value?: number | null,
        ownerId?: string | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    agencyRateId: string,
    statement?:  {
      __typename: "Statement",
      id: string,
      amounts?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      chargeStatements?:  {
        __typename: "ModelChargeStatementConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      closingStatement: boolean,
      periodFrom: string,
      periodTo: string,
      attachSupportingDocuments?: boolean | null,
      selectedPocketKeys?: Array< string > | null,
      source: StatementSource,
      status: StatementStatus,
      sentDate?: string | null,
      leaseId?: string | null,
      lease?:  {
        __typename: "Lease",
        id: string,
        balance?: number | null,
        canBeExtended?: boolean | null,
        communicationSettingsProfileId: string,
        createdAt?: string | null,
        endDate: string,
        includeRealEstateInLeaseContract?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        invoiceSenderId: string,
        inventoryOfFixturesExpert?: string | null,
        inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
        inventoryOfFixturesType?: InventoryOfFixturesType | null,
        ipiNumber?: string | null,
        language: Language,
        lastDraftInvoiceDate?: string | null,
        lastIndexationProcessDate?: string | null,
        lastInvoiceDate?: string | null,
        legalCompetentAuthority?: string | null,
        name: string,
        notes?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        purchaseOrderNumber?: string | null,
        realEstateAgency?: string | null,
        realEstateTax?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        signatureDate?: string | null,
        startDate: string,
        nextIndexationMonth?: string | null,
        nextIndexation?: boolean | null,
        status: LeaseStatus,
        technicCommunicationSettingsProfileId: string,
        totalInitialRentalPrice: number,
        totalRentalPrice: number,
        type: LeaseType,
        subletting?: boolean | null,
        vatRateRentId?: string | null,
        bankAccountId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      agencyRateStatements?:  {
        __typename: "ModelAgencyRateStatementConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      ownerId?: string | null,
      owner?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      repaymentStatements?:  {
        __typename: "ModelRepaymentStatementConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      types?: Array< StatementType > | null,
      viewType: StatementViewType,
      unitIds?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    statementId: string,
    unitAmounts?:  Array< {
      __typename: "AgencyRateStatementAmount",
      unitId?: string | null,
      amountRateable: number,
      fixedAmount: number,
    } > | null,
    totalAmountRateable: number,
    totalFixedAmount: number,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteAgencyRateStatementMutationVariables = {
  input: DeleteAgencyRateStatementInput,
  condition?: ModelAgencyRateStatementConditionInput | null,
};

export type DeleteAgencyRateStatementMutation = {
  deleteAgencyRateStatement?:  {
    __typename: "AgencyRateStatement",
    id: string,
    agencyRate?:  {
      __typename: "AgencyRate",
      id: string,
      amountDetails:  Array< {
        __typename: "AgencyRateAmountDetail",
        amountType: AgencyRateAmountDetailType,
        endAmount?: number | null,
        feeApplied: number,
        startAmount: number,
      } >,
      rateWhenVacant?:  {
        __typename: "AgencyRateWhenVacant",
        amount: number,
        type: AgencyRateAmountDetailType,
      } | null,
      amountMinimumFees?: number | null,
      custom: boolean,
      feesAppliedTo: AgencyRateFeesType,
      includedInAmount?: Array< AgencyRateIncludedAmount > | null,
      name: string,
      owners?:  {
        __typename: "ModelAgencyRateOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      repartitionType: AgencyRateRepartitionType,
      type: AgencyRateType,
      unitType: Array< UnitType >,
      vatRateId?: string | null,
      unitIds?: Array< string | null > | null,
      vatRate?:  {
        __typename: "VatRate",
        id: string,
        country: string,
        label: string,
        value?: number | null,
        ownerId?: string | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    agencyRateId: string,
    statement?:  {
      __typename: "Statement",
      id: string,
      amounts?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      chargeStatements?:  {
        __typename: "ModelChargeStatementConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      closingStatement: boolean,
      periodFrom: string,
      periodTo: string,
      attachSupportingDocuments?: boolean | null,
      selectedPocketKeys?: Array< string > | null,
      source: StatementSource,
      status: StatementStatus,
      sentDate?: string | null,
      leaseId?: string | null,
      lease?:  {
        __typename: "Lease",
        id: string,
        balance?: number | null,
        canBeExtended?: boolean | null,
        communicationSettingsProfileId: string,
        createdAt?: string | null,
        endDate: string,
        includeRealEstateInLeaseContract?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        invoiceSenderId: string,
        inventoryOfFixturesExpert?: string | null,
        inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
        inventoryOfFixturesType?: InventoryOfFixturesType | null,
        ipiNumber?: string | null,
        language: Language,
        lastDraftInvoiceDate?: string | null,
        lastIndexationProcessDate?: string | null,
        lastInvoiceDate?: string | null,
        legalCompetentAuthority?: string | null,
        name: string,
        notes?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        purchaseOrderNumber?: string | null,
        realEstateAgency?: string | null,
        realEstateTax?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        signatureDate?: string | null,
        startDate: string,
        nextIndexationMonth?: string | null,
        nextIndexation?: boolean | null,
        status: LeaseStatus,
        technicCommunicationSettingsProfileId: string,
        totalInitialRentalPrice: number,
        totalRentalPrice: number,
        type: LeaseType,
        subletting?: boolean | null,
        vatRateRentId?: string | null,
        bankAccountId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      agencyRateStatements?:  {
        __typename: "ModelAgencyRateStatementConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      ownerId?: string | null,
      owner?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      repaymentStatements?:  {
        __typename: "ModelRepaymentStatementConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      types?: Array< StatementType > | null,
      viewType: StatementViewType,
      unitIds?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    statementId: string,
    unitAmounts?:  Array< {
      __typename: "AgencyRateStatementAmount",
      unitId?: string | null,
      amountRateable: number,
      fixedAmount: number,
    } > | null,
    totalAmountRateable: number,
    totalFixedAmount: number,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateBillingItemMutationVariables = {
  input: CreateBillingItemInput,
  condition?: ModelBillingItemConditionInput | null,
};

export type CreateBillingItemMutation = {
  createBillingItem?:  {
    __typename: "BillingItem",
    id: string,
    name: string,
    baseAmount?: number | null,
    billingType?: InvoiceBillingType | null,
    amountCalculationType?: InvoiceAmountCalculationType | null,
    percentageBase?: InvoicePercentageBase | null,
    period?: LeasePaymentFrequency | null,
    vatRateId?: string | null,
    vatRate?:  {
      __typename: "VatRate",
      id: string,
      country: string,
      label: string,
      value?: number | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      ownerId?: string | null,
      owner?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    invoiceId?: string | null,
    quantity?: number | null,
    percentage?: number | null,
    allocationOption: BillingItemAllocationOption,
    multipleUnitsSplit?: BillingItemMultipleUnitsSplitOption | null,
    leaseIds?: Array< string | null > | null,
    unitIds?: Array< string | null > | null,
    buildingIds?: Array< string | null > | null,
    accountLabelId?: string | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateBillingItemMutationVariables = {
  input: UpdateBillingItemInput,
  condition?: ModelBillingItemConditionInput | null,
};

export type UpdateBillingItemMutation = {
  updateBillingItem?:  {
    __typename: "BillingItem",
    id: string,
    name: string,
    baseAmount?: number | null,
    billingType?: InvoiceBillingType | null,
    amountCalculationType?: InvoiceAmountCalculationType | null,
    percentageBase?: InvoicePercentageBase | null,
    period?: LeasePaymentFrequency | null,
    vatRateId?: string | null,
    vatRate?:  {
      __typename: "VatRate",
      id: string,
      country: string,
      label: string,
      value?: number | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      ownerId?: string | null,
      owner?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    invoiceId?: string | null,
    quantity?: number | null,
    percentage?: number | null,
    allocationOption: BillingItemAllocationOption,
    multipleUnitsSplit?: BillingItemMultipleUnitsSplitOption | null,
    leaseIds?: Array< string | null > | null,
    unitIds?: Array< string | null > | null,
    buildingIds?: Array< string | null > | null,
    accountLabelId?: string | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteBillingItemMutationVariables = {
  input: DeleteBillingItemInput,
  condition?: ModelBillingItemConditionInput | null,
};

export type DeleteBillingItemMutation = {
  deleteBillingItem?:  {
    __typename: "BillingItem",
    id: string,
    name: string,
    baseAmount?: number | null,
    billingType?: InvoiceBillingType | null,
    amountCalculationType?: InvoiceAmountCalculationType | null,
    percentageBase?: InvoicePercentageBase | null,
    period?: LeasePaymentFrequency | null,
    vatRateId?: string | null,
    vatRate?:  {
      __typename: "VatRate",
      id: string,
      country: string,
      label: string,
      value?: number | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      ownerId?: string | null,
      owner?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    invoiceId?: string | null,
    quantity?: number | null,
    percentage?: number | null,
    allocationOption: BillingItemAllocationOption,
    multipleUnitsSplit?: BillingItemMultipleUnitsSplitOption | null,
    leaseIds?: Array< string | null > | null,
    unitIds?: Array< string | null > | null,
    buildingIds?: Array< string | null > | null,
    accountLabelId?: string | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateBuildingMutationVariables = {
  input: CreateBuildingInput,
  condition?: ModelBuildingConditionInput | null,
};

export type CreateBuildingMutation = {
  createBuilding?:  {
    __typename: "Building",
    id: string,
    name: string,
    addressId?: string | null,
    address?:  {
      __typename: "Address",
      id: string,
      status?: AddressStatus | null,
      street: string,
      number?: string | null,
      box?: string | null,
      postalCode?: string | null,
      city?: string | null,
      region?: string | null,
      country?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      latitude?: number | null,
      longitude?: number | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    acquisitionValue?: number | null,
    acquisitionAdditionalCostsValue?: number | null,
    acquisitionAdvertisedValue?: number | null,
    amountOfFacades?: number | null,
    amountOfFloors?: number | null,
    amountOfHousings?: number | null,
    buildingState?: BuildingState | null,
    cadastralIncome?: number | null,
    constructionYear?: string | null,
    customValues?:  Array< {
      __typename: "CustomValue",
      name: string,
      value: string,
    } > | null,
    janitor?: boolean | null,
    jointOwnershipId?: string | null,
    notes?: string | null,
    owners?:  {
      __typename: "ModelBuildingOwnerConnection",
      items:  Array< {
        __typename: "BuildingOwner",
        id: string,
        buildingId: string,
        contactId: string,
        disabled?: boolean | null,
        periodFrom?: string | null,
        periodTo?: string | null,
        stake: number,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    propertyTax?: number | null,
    residenceName?: string | null,
    buildingSiteId?: string | null,
    buildingSite?:  {
      __typename: "BuildingSite",
      id: string,
      name: string,
      buildings?:  {
        __typename: "ModelBuildingConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      teams?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    units?:  {
      __typename: "ModelUnitConnection",
      items:  Array< {
        __typename: "Unit",
        id: string,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        acquisitionValue?: number | null,
        advertisedMonthlyCharges?: number | null,
        advertisedRentalPrice?: number | null,
        cadastralIncome?: number | null,
        createdAt?: string | null,
        floor?: number | null,
        jointOwnershipId?: string | null,
        managementDate: string,
        name: string,
        notes?: string | null,
        predictedPrice?: string | null,
        propertyTax?: number | null,
        publishAddress?: boolean | null,
        surface?: number | null,
        type: UnitType,
        buildingId: string,
        unitAdvertisementId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    events?:  {
      __typename: "ModelBuildingEventConnection",
      items:  Array< {
        __typename: "BuildingEvent",
        id: string,
        buildingId: string,
        type: string,
        startDate: string,
        endDate: string,
        totalCost?: number | null,
        note?: string | null,
        writers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    readers?: Array< string > | null,
    teams?: Array< string > | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateBuildingMutationVariables = {
  input: UpdateBuildingInput,
  condition?: ModelBuildingConditionInput | null,
};

export type UpdateBuildingMutation = {
  updateBuilding?:  {
    __typename: "Building",
    id: string,
    name: string,
    addressId?: string | null,
    address?:  {
      __typename: "Address",
      id: string,
      status?: AddressStatus | null,
      street: string,
      number?: string | null,
      box?: string | null,
      postalCode?: string | null,
      city?: string | null,
      region?: string | null,
      country?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      latitude?: number | null,
      longitude?: number | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    acquisitionValue?: number | null,
    acquisitionAdditionalCostsValue?: number | null,
    acquisitionAdvertisedValue?: number | null,
    amountOfFacades?: number | null,
    amountOfFloors?: number | null,
    amountOfHousings?: number | null,
    buildingState?: BuildingState | null,
    cadastralIncome?: number | null,
    constructionYear?: string | null,
    customValues?:  Array< {
      __typename: "CustomValue",
      name: string,
      value: string,
    } > | null,
    janitor?: boolean | null,
    jointOwnershipId?: string | null,
    notes?: string | null,
    owners?:  {
      __typename: "ModelBuildingOwnerConnection",
      items:  Array< {
        __typename: "BuildingOwner",
        id: string,
        buildingId: string,
        contactId: string,
        disabled?: boolean | null,
        periodFrom?: string | null,
        periodTo?: string | null,
        stake: number,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    propertyTax?: number | null,
    residenceName?: string | null,
    buildingSiteId?: string | null,
    buildingSite?:  {
      __typename: "BuildingSite",
      id: string,
      name: string,
      buildings?:  {
        __typename: "ModelBuildingConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      teams?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    units?:  {
      __typename: "ModelUnitConnection",
      items:  Array< {
        __typename: "Unit",
        id: string,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        acquisitionValue?: number | null,
        advertisedMonthlyCharges?: number | null,
        advertisedRentalPrice?: number | null,
        cadastralIncome?: number | null,
        createdAt?: string | null,
        floor?: number | null,
        jointOwnershipId?: string | null,
        managementDate: string,
        name: string,
        notes?: string | null,
        predictedPrice?: string | null,
        propertyTax?: number | null,
        publishAddress?: boolean | null,
        surface?: number | null,
        type: UnitType,
        buildingId: string,
        unitAdvertisementId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    events?:  {
      __typename: "ModelBuildingEventConnection",
      items:  Array< {
        __typename: "BuildingEvent",
        id: string,
        buildingId: string,
        type: string,
        startDate: string,
        endDate: string,
        totalCost?: number | null,
        note?: string | null,
        writers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    readers?: Array< string > | null,
    teams?: Array< string > | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteBuildingMutationVariables = {
  input: DeleteBuildingInput,
  condition?: ModelBuildingConditionInput | null,
};

export type DeleteBuildingMutation = {
  deleteBuilding?:  {
    __typename: "Building",
    id: string,
    name: string,
    addressId?: string | null,
    address?:  {
      __typename: "Address",
      id: string,
      status?: AddressStatus | null,
      street: string,
      number?: string | null,
      box?: string | null,
      postalCode?: string | null,
      city?: string | null,
      region?: string | null,
      country?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      latitude?: number | null,
      longitude?: number | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    acquisitionValue?: number | null,
    acquisitionAdditionalCostsValue?: number | null,
    acquisitionAdvertisedValue?: number | null,
    amountOfFacades?: number | null,
    amountOfFloors?: number | null,
    amountOfHousings?: number | null,
    buildingState?: BuildingState | null,
    cadastralIncome?: number | null,
    constructionYear?: string | null,
    customValues?:  Array< {
      __typename: "CustomValue",
      name: string,
      value: string,
    } > | null,
    janitor?: boolean | null,
    jointOwnershipId?: string | null,
    notes?: string | null,
    owners?:  {
      __typename: "ModelBuildingOwnerConnection",
      items:  Array< {
        __typename: "BuildingOwner",
        id: string,
        buildingId: string,
        contactId: string,
        disabled?: boolean | null,
        periodFrom?: string | null,
        periodTo?: string | null,
        stake: number,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    propertyTax?: number | null,
    residenceName?: string | null,
    buildingSiteId?: string | null,
    buildingSite?:  {
      __typename: "BuildingSite",
      id: string,
      name: string,
      buildings?:  {
        __typename: "ModelBuildingConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      teams?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    units?:  {
      __typename: "ModelUnitConnection",
      items:  Array< {
        __typename: "Unit",
        id: string,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        acquisitionValue?: number | null,
        advertisedMonthlyCharges?: number | null,
        advertisedRentalPrice?: number | null,
        cadastralIncome?: number | null,
        createdAt?: string | null,
        floor?: number | null,
        jointOwnershipId?: string | null,
        managementDate: string,
        name: string,
        notes?: string | null,
        predictedPrice?: string | null,
        propertyTax?: number | null,
        publishAddress?: boolean | null,
        surface?: number | null,
        type: UnitType,
        buildingId: string,
        unitAdvertisementId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    events?:  {
      __typename: "ModelBuildingEventConnection",
      items:  Array< {
        __typename: "BuildingEvent",
        id: string,
        buildingId: string,
        type: string,
        startDate: string,
        endDate: string,
        totalCost?: number | null,
        note?: string | null,
        writers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    readers?: Array< string > | null,
    teams?: Array< string > | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateBuildingEventMutationVariables = {
  input: CreateBuildingEventInput,
  condition?: ModelBuildingEventConditionInput | null,
};

export type CreateBuildingEventMutation = {
  createBuildingEvent?:  {
    __typename: "BuildingEvent",
    id: string,
    buildingId: string,
    type: string,
    startDate: string,
    endDate: string,
    totalCost?: number | null,
    note?: string | null,
    writers?: Array< string > | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateBuildingEventMutationVariables = {
  input: UpdateBuildingEventInput,
  condition?: ModelBuildingEventConditionInput | null,
};

export type UpdateBuildingEventMutation = {
  updateBuildingEvent?:  {
    __typename: "BuildingEvent",
    id: string,
    buildingId: string,
    type: string,
    startDate: string,
    endDate: string,
    totalCost?: number | null,
    note?: string | null,
    writers?: Array< string > | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteBuildingEventMutationVariables = {
  input: DeleteBuildingEventInput,
  condition?: ModelBuildingEventConditionInput | null,
};

export type DeleteBuildingEventMutation = {
  deleteBuildingEvent?:  {
    __typename: "BuildingEvent",
    id: string,
    buildingId: string,
    type: string,
    startDate: string,
    endDate: string,
    totalCost?: number | null,
    note?: string | null,
    writers?: Array< string > | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateBuildingOwnerMutationVariables = {
  input: CreateBuildingOwnerInput,
  condition?: ModelBuildingOwnerConditionInput | null,
};

export type CreateBuildingOwnerMutation = {
  createBuildingOwner?:  {
    __typename: "BuildingOwner",
    id: string,
    buildingId: string,
    building?:  {
      __typename: "Building",
      id: string,
      name: string,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      acquisitionValue?: number | null,
      acquisitionAdditionalCostsValue?: number | null,
      acquisitionAdvertisedValue?: number | null,
      amountOfFacades?: number | null,
      amountOfFloors?: number | null,
      amountOfHousings?: number | null,
      buildingState?: BuildingState | null,
      cadastralIncome?: number | null,
      constructionYear?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      janitor?: boolean | null,
      jointOwnershipId?: string | null,
      notes?: string | null,
      owners?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      propertyTax?: number | null,
      residenceName?: string | null,
      buildingSiteId?: string | null,
      buildingSite?:  {
        __typename: "BuildingSite",
        id: string,
        name: string,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      units?:  {
        __typename: "ModelUnitConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      events?:  {
        __typename: "ModelBuildingEventConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      teams?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    contactId: string,
    disabled?: boolean | null,
    owner?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    periodFrom?: string | null,
    periodTo?: string | null,
    stake: number,
    readers?: Array< string > | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateBuildingOwnerMutationVariables = {
  input: UpdateBuildingOwnerInput,
  condition?: ModelBuildingOwnerConditionInput | null,
};

export type UpdateBuildingOwnerMutation = {
  updateBuildingOwner?:  {
    __typename: "BuildingOwner",
    id: string,
    buildingId: string,
    building?:  {
      __typename: "Building",
      id: string,
      name: string,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      acquisitionValue?: number | null,
      acquisitionAdditionalCostsValue?: number | null,
      acquisitionAdvertisedValue?: number | null,
      amountOfFacades?: number | null,
      amountOfFloors?: number | null,
      amountOfHousings?: number | null,
      buildingState?: BuildingState | null,
      cadastralIncome?: number | null,
      constructionYear?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      janitor?: boolean | null,
      jointOwnershipId?: string | null,
      notes?: string | null,
      owners?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      propertyTax?: number | null,
      residenceName?: string | null,
      buildingSiteId?: string | null,
      buildingSite?:  {
        __typename: "BuildingSite",
        id: string,
        name: string,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      units?:  {
        __typename: "ModelUnitConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      events?:  {
        __typename: "ModelBuildingEventConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      teams?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    contactId: string,
    disabled?: boolean | null,
    owner?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    periodFrom?: string | null,
    periodTo?: string | null,
    stake: number,
    readers?: Array< string > | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteBuildingOwnerMutationVariables = {
  input: DeleteBuildingOwnerInput,
  condition?: ModelBuildingOwnerConditionInput | null,
};

export type DeleteBuildingOwnerMutation = {
  deleteBuildingOwner?:  {
    __typename: "BuildingOwner",
    id: string,
    buildingId: string,
    building?:  {
      __typename: "Building",
      id: string,
      name: string,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      acquisitionValue?: number | null,
      acquisitionAdditionalCostsValue?: number | null,
      acquisitionAdvertisedValue?: number | null,
      amountOfFacades?: number | null,
      amountOfFloors?: number | null,
      amountOfHousings?: number | null,
      buildingState?: BuildingState | null,
      cadastralIncome?: number | null,
      constructionYear?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      janitor?: boolean | null,
      jointOwnershipId?: string | null,
      notes?: string | null,
      owners?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      propertyTax?: number | null,
      residenceName?: string | null,
      buildingSiteId?: string | null,
      buildingSite?:  {
        __typename: "BuildingSite",
        id: string,
        name: string,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      units?:  {
        __typename: "ModelUnitConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      events?:  {
        __typename: "ModelBuildingEventConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      teams?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    contactId: string,
    disabled?: boolean | null,
    owner?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    periodFrom?: string | null,
    periodTo?: string | null,
    stake: number,
    readers?: Array< string > | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateBuildingSiteMutationVariables = {
  input: CreateBuildingSiteInput,
  condition?: ModelBuildingSiteConditionInput | null,
};

export type CreateBuildingSiteMutation = {
  createBuildingSite?:  {
    __typename: "BuildingSite",
    id: string,
    name: string,
    buildings?:  {
      __typename: "ModelBuildingConnection",
      items:  Array< {
        __typename: "Building",
        id: string,
        name: string,
        addressId?: string | null,
        acquisitionValue?: number | null,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        amountOfFacades?: number | null,
        amountOfFloors?: number | null,
        amountOfHousings?: number | null,
        buildingState?: BuildingState | null,
        cadastralIncome?: number | null,
        constructionYear?: string | null,
        janitor?: boolean | null,
        jointOwnershipId?: string | null,
        notes?: string | null,
        propertyTax?: number | null,
        residenceName?: string | null,
        buildingSiteId?: string | null,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    readers?: Array< string > | null,
    teams?: Array< string > | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateBuildingSiteMutationVariables = {
  input: UpdateBuildingSiteInput,
  condition?: ModelBuildingSiteConditionInput | null,
};

export type UpdateBuildingSiteMutation = {
  updateBuildingSite?:  {
    __typename: "BuildingSite",
    id: string,
    name: string,
    buildings?:  {
      __typename: "ModelBuildingConnection",
      items:  Array< {
        __typename: "Building",
        id: string,
        name: string,
        addressId?: string | null,
        acquisitionValue?: number | null,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        amountOfFacades?: number | null,
        amountOfFloors?: number | null,
        amountOfHousings?: number | null,
        buildingState?: BuildingState | null,
        cadastralIncome?: number | null,
        constructionYear?: string | null,
        janitor?: boolean | null,
        jointOwnershipId?: string | null,
        notes?: string | null,
        propertyTax?: number | null,
        residenceName?: string | null,
        buildingSiteId?: string | null,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    readers?: Array< string > | null,
    teams?: Array< string > | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteBuildingSiteMutationVariables = {
  input: DeleteBuildingSiteInput,
  condition?: ModelBuildingSiteConditionInput | null,
};

export type DeleteBuildingSiteMutation = {
  deleteBuildingSite?:  {
    __typename: "BuildingSite",
    id: string,
    name: string,
    buildings?:  {
      __typename: "ModelBuildingConnection",
      items:  Array< {
        __typename: "Building",
        id: string,
        name: string,
        addressId?: string | null,
        acquisitionValue?: number | null,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        amountOfFacades?: number | null,
        amountOfFloors?: number | null,
        amountOfHousings?: number | null,
        buildingState?: BuildingState | null,
        cadastralIncome?: number | null,
        constructionYear?: string | null,
        janitor?: boolean | null,
        jointOwnershipId?: string | null,
        notes?: string | null,
        propertyTax?: number | null,
        residenceName?: string | null,
        buildingSiteId?: string | null,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    readers?: Array< string > | null,
    teams?: Array< string > | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateChargeMutationVariables = {
  input: CreateChargeInput,
  condition?: ModelChargeConditionInput | null,
};

export type CreateChargeMutation = {
  createCharge?:  {
    __typename: "Charge",
    id: string,
    status: ChargeStatus,
    invoiceDate?: string | null,
    paymentDueDate?: string | null,
    archivedDate?: string | null,
    periodFrom?: string | null,
    periodTo?: string | null,
    totalAmount?: number | null,
    source: ChargeSource,
    draftFromOcr?: boolean | null,
    accountingDocumentId?: string | null,
    paid: boolean,
    remittanceInformation?: string | null,
    note?: string | null,
    createdAt: string,
    creatorEmail?: string | null,
    createdById?: string | null,
    createdBy?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    contractorId?: string | null,
    contractor?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    proposedContractors?:  Array< {
      __typename: "ProposedValue",
      id: string,
      confidence?: number | null,
    } > | null,
    recipientId?: string | null,
    recipient?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    proposedRecipients?:  Array< {
      __typename: "ProposedValue",
      id: string,
      confidence?: number | null,
    } > | null,
    customValues?:  Array< {
      __typename: "CustomValue",
      name: string,
      value: string,
    } > | null,
    documentId: string,
    document?:  {
      __typename: "File",
      id: string,
      bucket: string,
      createdAt?: string | null,
      category?:  {
        __typename: "DocumentCategory",
        id: string,
        entity?: string | null,
        fileCategory: FileCategory,
        parentId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      categoryId: string,
      foreignKey: string,
      foreignTableName: string,
      key: string,
      mimeType?: string | null,
      region: string,
      signaturePositions?:  Array< {
        __typename: "SignaturePosition",
        top: number,
        left: number,
        page: number,
        width?: number | null,
        height?: number | null,
        contactId: string,
      } > | null,
      size?: number | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      _ttl?: number | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    postings?:  {
      __typename: "ModelPostingConnection",
      items:  Array< {
        __typename: "Posting",
        id: string,
        createdAt?: string | null,
        class: number,
        customLabel?: string | null,
        topClass: number,
        type: PostingType,
        totalAmount: number,
        periodFrom: string,
        periodTo: string,
        buildingId?: string | null,
        unitId?: string | null,
        invoiceId?: string | null,
        chargeId?: string | null,
        transactionId?: string | null,
        leaseId?: string | null,
        bankAccountId?: string | null,
        accountLabelId?: string | null,
        contactId?: string | null,
        leaseVariousOperationId?: string | null,
        statementId?: string | null,
        amountVatExcluded?: number | null,
        vatAmount?: number | null,
        vatRateId?: string | null,
        vatRateValue?: number | null,
        foreignId?: string | null,
        foreignType?: PostingForeignType | null,
        invoicePostingId?: string | null,
        reconciledAt?: string | null,
        status?: PostingStatus | null,
        chargeOwnerRepartition?: number | null,
        chargeRepartitionMetric?: string | null,
        chargeRepartitionValue?: number | null,
        chargeSplitNumber?: number | null,
        chargeType?: PostingChargeType | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    readId: string,
    clientId: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateChargeMutationVariables = {
  input: UpdateChargeInput,
  condition?: ModelChargeConditionInput | null,
};

export type UpdateChargeMutation = {
  updateCharge?:  {
    __typename: "Charge",
    id: string,
    status: ChargeStatus,
    invoiceDate?: string | null,
    paymentDueDate?: string | null,
    archivedDate?: string | null,
    periodFrom?: string | null,
    periodTo?: string | null,
    totalAmount?: number | null,
    source: ChargeSource,
    draftFromOcr?: boolean | null,
    accountingDocumentId?: string | null,
    paid: boolean,
    remittanceInformation?: string | null,
    note?: string | null,
    createdAt: string,
    creatorEmail?: string | null,
    createdById?: string | null,
    createdBy?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    contractorId?: string | null,
    contractor?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    proposedContractors?:  Array< {
      __typename: "ProposedValue",
      id: string,
      confidence?: number | null,
    } > | null,
    recipientId?: string | null,
    recipient?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    proposedRecipients?:  Array< {
      __typename: "ProposedValue",
      id: string,
      confidence?: number | null,
    } > | null,
    customValues?:  Array< {
      __typename: "CustomValue",
      name: string,
      value: string,
    } > | null,
    documentId: string,
    document?:  {
      __typename: "File",
      id: string,
      bucket: string,
      createdAt?: string | null,
      category?:  {
        __typename: "DocumentCategory",
        id: string,
        entity?: string | null,
        fileCategory: FileCategory,
        parentId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      categoryId: string,
      foreignKey: string,
      foreignTableName: string,
      key: string,
      mimeType?: string | null,
      region: string,
      signaturePositions?:  Array< {
        __typename: "SignaturePosition",
        top: number,
        left: number,
        page: number,
        width?: number | null,
        height?: number | null,
        contactId: string,
      } > | null,
      size?: number | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      _ttl?: number | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    postings?:  {
      __typename: "ModelPostingConnection",
      items:  Array< {
        __typename: "Posting",
        id: string,
        createdAt?: string | null,
        class: number,
        customLabel?: string | null,
        topClass: number,
        type: PostingType,
        totalAmount: number,
        periodFrom: string,
        periodTo: string,
        buildingId?: string | null,
        unitId?: string | null,
        invoiceId?: string | null,
        chargeId?: string | null,
        transactionId?: string | null,
        leaseId?: string | null,
        bankAccountId?: string | null,
        accountLabelId?: string | null,
        contactId?: string | null,
        leaseVariousOperationId?: string | null,
        statementId?: string | null,
        amountVatExcluded?: number | null,
        vatAmount?: number | null,
        vatRateId?: string | null,
        vatRateValue?: number | null,
        foreignId?: string | null,
        foreignType?: PostingForeignType | null,
        invoicePostingId?: string | null,
        reconciledAt?: string | null,
        status?: PostingStatus | null,
        chargeOwnerRepartition?: number | null,
        chargeRepartitionMetric?: string | null,
        chargeRepartitionValue?: number | null,
        chargeSplitNumber?: number | null,
        chargeType?: PostingChargeType | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    readId: string,
    clientId: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteChargeMutationVariables = {
  input: DeleteChargeInput,
  condition?: ModelChargeConditionInput | null,
};

export type DeleteChargeMutation = {
  deleteCharge?:  {
    __typename: "Charge",
    id: string,
    status: ChargeStatus,
    invoiceDate?: string | null,
    paymentDueDate?: string | null,
    archivedDate?: string | null,
    periodFrom?: string | null,
    periodTo?: string | null,
    totalAmount?: number | null,
    source: ChargeSource,
    draftFromOcr?: boolean | null,
    accountingDocumentId?: string | null,
    paid: boolean,
    remittanceInformation?: string | null,
    note?: string | null,
    createdAt: string,
    creatorEmail?: string | null,
    createdById?: string | null,
    createdBy?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    contractorId?: string | null,
    contractor?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    proposedContractors?:  Array< {
      __typename: "ProposedValue",
      id: string,
      confidence?: number | null,
    } > | null,
    recipientId?: string | null,
    recipient?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    proposedRecipients?:  Array< {
      __typename: "ProposedValue",
      id: string,
      confidence?: number | null,
    } > | null,
    customValues?:  Array< {
      __typename: "CustomValue",
      name: string,
      value: string,
    } > | null,
    documentId: string,
    document?:  {
      __typename: "File",
      id: string,
      bucket: string,
      createdAt?: string | null,
      category?:  {
        __typename: "DocumentCategory",
        id: string,
        entity?: string | null,
        fileCategory: FileCategory,
        parentId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      categoryId: string,
      foreignKey: string,
      foreignTableName: string,
      key: string,
      mimeType?: string | null,
      region: string,
      signaturePositions?:  Array< {
        __typename: "SignaturePosition",
        top: number,
        left: number,
        page: number,
        width?: number | null,
        height?: number | null,
        contactId: string,
      } > | null,
      size?: number | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      _ttl?: number | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    postings?:  {
      __typename: "ModelPostingConnection",
      items:  Array< {
        __typename: "Posting",
        id: string,
        createdAt?: string | null,
        class: number,
        customLabel?: string | null,
        topClass: number,
        type: PostingType,
        totalAmount: number,
        periodFrom: string,
        periodTo: string,
        buildingId?: string | null,
        unitId?: string | null,
        invoiceId?: string | null,
        chargeId?: string | null,
        transactionId?: string | null,
        leaseId?: string | null,
        bankAccountId?: string | null,
        accountLabelId?: string | null,
        contactId?: string | null,
        leaseVariousOperationId?: string | null,
        statementId?: string | null,
        amountVatExcluded?: number | null,
        vatAmount?: number | null,
        vatRateId?: string | null,
        vatRateValue?: number | null,
        foreignId?: string | null,
        foreignType?: PostingForeignType | null,
        invoicePostingId?: string | null,
        reconciledAt?: string | null,
        status?: PostingStatus | null,
        chargeOwnerRepartition?: number | null,
        chargeRepartitionMetric?: string | null,
        chargeRepartitionValue?: number | null,
        chargeSplitNumber?: number | null,
        chargeType?: PostingChargeType | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    readId: string,
    clientId: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateChargeStatementMutationVariables = {
  input: CreateChargeStatementInput,
  condition?: ModelChargeStatementConditionInput | null,
};

export type CreateChargeStatementMutation = {
  createChargeStatement?:  {
    __typename: "ChargeStatement",
    id: string,
    charge?:  {
      __typename: "Charge",
      id: string,
      status: ChargeStatus,
      invoiceDate?: string | null,
      paymentDueDate?: string | null,
      archivedDate?: string | null,
      periodFrom?: string | null,
      periodTo?: string | null,
      totalAmount?: number | null,
      source: ChargeSource,
      draftFromOcr?: boolean | null,
      accountingDocumentId?: string | null,
      paid: boolean,
      remittanceInformation?: string | null,
      note?: string | null,
      createdAt: string,
      creatorEmail?: string | null,
      createdById?: string | null,
      createdBy?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contractorId?: string | null,
      contractor?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      proposedContractors?:  Array< {
        __typename: "ProposedValue",
        id: string,
        confidence?: number | null,
      } > | null,
      recipientId?: string | null,
      recipient?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      proposedRecipients?:  Array< {
        __typename: "ProposedValue",
        id: string,
        confidence?: number | null,
      } > | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      documentId: string,
      document?:  {
        __typename: "File",
        id: string,
        bucket: string,
        createdAt?: string | null,
        categoryId: string,
        foreignKey: string,
        foreignTableName: string,
        key: string,
        mimeType?: string | null,
        region: string,
        size?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        _ttl?: number | null,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      postings?:  {
        __typename: "ModelPostingConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    chargeId: string,
    statement?:  {
      __typename: "Statement",
      id: string,
      amounts?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      chargeStatements?:  {
        __typename: "ModelChargeStatementConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      closingStatement: boolean,
      periodFrom: string,
      periodTo: string,
      attachSupportingDocuments?: boolean | null,
      selectedPocketKeys?: Array< string > | null,
      source: StatementSource,
      status: StatementStatus,
      sentDate?: string | null,
      leaseId?: string | null,
      lease?:  {
        __typename: "Lease",
        id: string,
        balance?: number | null,
        canBeExtended?: boolean | null,
        communicationSettingsProfileId: string,
        createdAt?: string | null,
        endDate: string,
        includeRealEstateInLeaseContract?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        invoiceSenderId: string,
        inventoryOfFixturesExpert?: string | null,
        inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
        inventoryOfFixturesType?: InventoryOfFixturesType | null,
        ipiNumber?: string | null,
        language: Language,
        lastDraftInvoiceDate?: string | null,
        lastIndexationProcessDate?: string | null,
        lastInvoiceDate?: string | null,
        legalCompetentAuthority?: string | null,
        name: string,
        notes?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        purchaseOrderNumber?: string | null,
        realEstateAgency?: string | null,
        realEstateTax?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        signatureDate?: string | null,
        startDate: string,
        nextIndexationMonth?: string | null,
        nextIndexation?: boolean | null,
        status: LeaseStatus,
        technicCommunicationSettingsProfileId: string,
        totalInitialRentalPrice: number,
        totalRentalPrice: number,
        type: LeaseType,
        subletting?: boolean | null,
        vatRateRentId?: string | null,
        bankAccountId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      agencyRateStatements?:  {
        __typename: "ModelAgencyRateStatementConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      ownerId?: string | null,
      owner?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      repaymentStatements?:  {
        __typename: "ModelRepaymentStatementConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      types?: Array< StatementType > | null,
      viewType: StatementViewType,
      unitIds?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    statementId: string,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateChargeStatementMutationVariables = {
  input: UpdateChargeStatementInput,
  condition?: ModelChargeStatementConditionInput | null,
};

export type UpdateChargeStatementMutation = {
  updateChargeStatement?:  {
    __typename: "ChargeStatement",
    id: string,
    charge?:  {
      __typename: "Charge",
      id: string,
      status: ChargeStatus,
      invoiceDate?: string | null,
      paymentDueDate?: string | null,
      archivedDate?: string | null,
      periodFrom?: string | null,
      periodTo?: string | null,
      totalAmount?: number | null,
      source: ChargeSource,
      draftFromOcr?: boolean | null,
      accountingDocumentId?: string | null,
      paid: boolean,
      remittanceInformation?: string | null,
      note?: string | null,
      createdAt: string,
      creatorEmail?: string | null,
      createdById?: string | null,
      createdBy?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contractorId?: string | null,
      contractor?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      proposedContractors?:  Array< {
        __typename: "ProposedValue",
        id: string,
        confidence?: number | null,
      } > | null,
      recipientId?: string | null,
      recipient?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      proposedRecipients?:  Array< {
        __typename: "ProposedValue",
        id: string,
        confidence?: number | null,
      } > | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      documentId: string,
      document?:  {
        __typename: "File",
        id: string,
        bucket: string,
        createdAt?: string | null,
        categoryId: string,
        foreignKey: string,
        foreignTableName: string,
        key: string,
        mimeType?: string | null,
        region: string,
        size?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        _ttl?: number | null,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      postings?:  {
        __typename: "ModelPostingConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    chargeId: string,
    statement?:  {
      __typename: "Statement",
      id: string,
      amounts?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      chargeStatements?:  {
        __typename: "ModelChargeStatementConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      closingStatement: boolean,
      periodFrom: string,
      periodTo: string,
      attachSupportingDocuments?: boolean | null,
      selectedPocketKeys?: Array< string > | null,
      source: StatementSource,
      status: StatementStatus,
      sentDate?: string | null,
      leaseId?: string | null,
      lease?:  {
        __typename: "Lease",
        id: string,
        balance?: number | null,
        canBeExtended?: boolean | null,
        communicationSettingsProfileId: string,
        createdAt?: string | null,
        endDate: string,
        includeRealEstateInLeaseContract?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        invoiceSenderId: string,
        inventoryOfFixturesExpert?: string | null,
        inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
        inventoryOfFixturesType?: InventoryOfFixturesType | null,
        ipiNumber?: string | null,
        language: Language,
        lastDraftInvoiceDate?: string | null,
        lastIndexationProcessDate?: string | null,
        lastInvoiceDate?: string | null,
        legalCompetentAuthority?: string | null,
        name: string,
        notes?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        purchaseOrderNumber?: string | null,
        realEstateAgency?: string | null,
        realEstateTax?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        signatureDate?: string | null,
        startDate: string,
        nextIndexationMonth?: string | null,
        nextIndexation?: boolean | null,
        status: LeaseStatus,
        technicCommunicationSettingsProfileId: string,
        totalInitialRentalPrice: number,
        totalRentalPrice: number,
        type: LeaseType,
        subletting?: boolean | null,
        vatRateRentId?: string | null,
        bankAccountId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      agencyRateStatements?:  {
        __typename: "ModelAgencyRateStatementConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      ownerId?: string | null,
      owner?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      repaymentStatements?:  {
        __typename: "ModelRepaymentStatementConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      types?: Array< StatementType > | null,
      viewType: StatementViewType,
      unitIds?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    statementId: string,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteChargeStatementMutationVariables = {
  input: DeleteChargeStatementInput,
  condition?: ModelChargeStatementConditionInput | null,
};

export type DeleteChargeStatementMutation = {
  deleteChargeStatement?:  {
    __typename: "ChargeStatement",
    id: string,
    charge?:  {
      __typename: "Charge",
      id: string,
      status: ChargeStatus,
      invoiceDate?: string | null,
      paymentDueDate?: string | null,
      archivedDate?: string | null,
      periodFrom?: string | null,
      periodTo?: string | null,
      totalAmount?: number | null,
      source: ChargeSource,
      draftFromOcr?: boolean | null,
      accountingDocumentId?: string | null,
      paid: boolean,
      remittanceInformation?: string | null,
      note?: string | null,
      createdAt: string,
      creatorEmail?: string | null,
      createdById?: string | null,
      createdBy?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contractorId?: string | null,
      contractor?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      proposedContractors?:  Array< {
        __typename: "ProposedValue",
        id: string,
        confidence?: number | null,
      } > | null,
      recipientId?: string | null,
      recipient?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      proposedRecipients?:  Array< {
        __typename: "ProposedValue",
        id: string,
        confidence?: number | null,
      } > | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      documentId: string,
      document?:  {
        __typename: "File",
        id: string,
        bucket: string,
        createdAt?: string | null,
        categoryId: string,
        foreignKey: string,
        foreignTableName: string,
        key: string,
        mimeType?: string | null,
        region: string,
        size?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        _ttl?: number | null,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      postings?:  {
        __typename: "ModelPostingConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    chargeId: string,
    statement?:  {
      __typename: "Statement",
      id: string,
      amounts?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      chargeStatements?:  {
        __typename: "ModelChargeStatementConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      closingStatement: boolean,
      periodFrom: string,
      periodTo: string,
      attachSupportingDocuments?: boolean | null,
      selectedPocketKeys?: Array< string > | null,
      source: StatementSource,
      status: StatementStatus,
      sentDate?: string | null,
      leaseId?: string | null,
      lease?:  {
        __typename: "Lease",
        id: string,
        balance?: number | null,
        canBeExtended?: boolean | null,
        communicationSettingsProfileId: string,
        createdAt?: string | null,
        endDate: string,
        includeRealEstateInLeaseContract?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        invoiceSenderId: string,
        inventoryOfFixturesExpert?: string | null,
        inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
        inventoryOfFixturesType?: InventoryOfFixturesType | null,
        ipiNumber?: string | null,
        language: Language,
        lastDraftInvoiceDate?: string | null,
        lastIndexationProcessDate?: string | null,
        lastInvoiceDate?: string | null,
        legalCompetentAuthority?: string | null,
        name: string,
        notes?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        purchaseOrderNumber?: string | null,
        realEstateAgency?: string | null,
        realEstateTax?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        signatureDate?: string | null,
        startDate: string,
        nextIndexationMonth?: string | null,
        nextIndexation?: boolean | null,
        status: LeaseStatus,
        technicCommunicationSettingsProfileId: string,
        totalInitialRentalPrice: number,
        totalRentalPrice: number,
        type: LeaseType,
        subletting?: boolean | null,
        vatRateRentId?: string | null,
        bankAccountId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      agencyRateStatements?:  {
        __typename: "ModelAgencyRateStatementConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      ownerId?: string | null,
      owner?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      repaymentStatements?:  {
        __typename: "ModelRepaymentStatementConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      types?: Array< StatementType > | null,
      viewType: StatementViewType,
      unitIds?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    statementId: string,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateRepartitionKeyMutationVariables = {
  input: CreateRepartitionKeyInput,
  condition?: ModelRepartitionKeyConditionInput | null,
};

export type CreateRepartitionKeyMutation = {
  createRepartitionKey?:  {
    __typename: "RepartitionKey",
    id: string,
    name: string,
    type: RepartitionKeyType,
    accountLabelId?: string | null,
    accountLabel?:  {
      __typename: "AccountLabel",
      id: string,
      labels?:  Array< {
        __typename: "CustomLabel",
        language: string,
        label: string,
      } > | null,
      bankAccountId?: string | null,
      bankAccount?:  {
        __typename: "BankAccount",
        id: string,
        contactId: string,
        number: string,
        bicNumber?: string | null,
        bankName?: string | null,
        contactIds?: Array< string > | null,
        buildingIds?: Array< string > | null,
        holderName?: string | null,
        label?: string | null,
        disabled?: boolean | null,
        integrations?: Array< IntegrationName > | null,
        matchingRule?: BankAccountMatchingRule | null,
        balance?: number | null,
        balanceDate?: string | null,
        type: BankAccountType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contactId?: string | null,
      contact?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      class: number,
      customUsage?: AccountLabelCustomUsage | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      disabled?: boolean | null,
      ownerId?: string | null,
      owner?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      topClass: number,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    buildingId?: string | null,
    building?:  {
      __typename: "Building",
      id: string,
      name: string,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      acquisitionValue?: number | null,
      acquisitionAdditionalCostsValue?: number | null,
      acquisitionAdvertisedValue?: number | null,
      amountOfFacades?: number | null,
      amountOfFloors?: number | null,
      amountOfHousings?: number | null,
      buildingState?: BuildingState | null,
      cadastralIncome?: number | null,
      constructionYear?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      janitor?: boolean | null,
      jointOwnershipId?: string | null,
      notes?: string | null,
      owners?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      propertyTax?: number | null,
      residenceName?: string | null,
      buildingSiteId?: string | null,
      buildingSite?:  {
        __typename: "BuildingSite",
        id: string,
        name: string,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      units?:  {
        __typename: "ModelUnitConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      events?:  {
        __typename: "ModelBuildingEventConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      teams?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    buildingSiteId?: string | null,
    buildingSite?:  {
      __typename: "BuildingSite",
      id: string,
      name: string,
      buildings?:  {
        __typename: "ModelBuildingConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      teams?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    unitRepartition?:  Array< {
      __typename: "RepartitionValues",
      unitId: string,
      value: number,
    } > | null,
    ownerRepartition: number,
    tenantRepartition: number,
    repartitionMetric: string,
    technics?: Array< string > | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateRepartitionKeyMutationVariables = {
  input: UpdateRepartitionKeyInput,
  condition?: ModelRepartitionKeyConditionInput | null,
};

export type UpdateRepartitionKeyMutation = {
  updateRepartitionKey?:  {
    __typename: "RepartitionKey",
    id: string,
    name: string,
    type: RepartitionKeyType,
    accountLabelId?: string | null,
    accountLabel?:  {
      __typename: "AccountLabel",
      id: string,
      labels?:  Array< {
        __typename: "CustomLabel",
        language: string,
        label: string,
      } > | null,
      bankAccountId?: string | null,
      bankAccount?:  {
        __typename: "BankAccount",
        id: string,
        contactId: string,
        number: string,
        bicNumber?: string | null,
        bankName?: string | null,
        contactIds?: Array< string > | null,
        buildingIds?: Array< string > | null,
        holderName?: string | null,
        label?: string | null,
        disabled?: boolean | null,
        integrations?: Array< IntegrationName > | null,
        matchingRule?: BankAccountMatchingRule | null,
        balance?: number | null,
        balanceDate?: string | null,
        type: BankAccountType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contactId?: string | null,
      contact?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      class: number,
      customUsage?: AccountLabelCustomUsage | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      disabled?: boolean | null,
      ownerId?: string | null,
      owner?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      topClass: number,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    buildingId?: string | null,
    building?:  {
      __typename: "Building",
      id: string,
      name: string,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      acquisitionValue?: number | null,
      acquisitionAdditionalCostsValue?: number | null,
      acquisitionAdvertisedValue?: number | null,
      amountOfFacades?: number | null,
      amountOfFloors?: number | null,
      amountOfHousings?: number | null,
      buildingState?: BuildingState | null,
      cadastralIncome?: number | null,
      constructionYear?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      janitor?: boolean | null,
      jointOwnershipId?: string | null,
      notes?: string | null,
      owners?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      propertyTax?: number | null,
      residenceName?: string | null,
      buildingSiteId?: string | null,
      buildingSite?:  {
        __typename: "BuildingSite",
        id: string,
        name: string,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      units?:  {
        __typename: "ModelUnitConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      events?:  {
        __typename: "ModelBuildingEventConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      teams?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    buildingSiteId?: string | null,
    buildingSite?:  {
      __typename: "BuildingSite",
      id: string,
      name: string,
      buildings?:  {
        __typename: "ModelBuildingConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      teams?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    unitRepartition?:  Array< {
      __typename: "RepartitionValues",
      unitId: string,
      value: number,
    } > | null,
    ownerRepartition: number,
    tenantRepartition: number,
    repartitionMetric: string,
    technics?: Array< string > | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteRepartitionKeyMutationVariables = {
  input: DeleteRepartitionKeyInput,
  condition?: ModelRepartitionKeyConditionInput | null,
};

export type DeleteRepartitionKeyMutation = {
  deleteRepartitionKey?:  {
    __typename: "RepartitionKey",
    id: string,
    name: string,
    type: RepartitionKeyType,
    accountLabelId?: string | null,
    accountLabel?:  {
      __typename: "AccountLabel",
      id: string,
      labels?:  Array< {
        __typename: "CustomLabel",
        language: string,
        label: string,
      } > | null,
      bankAccountId?: string | null,
      bankAccount?:  {
        __typename: "BankAccount",
        id: string,
        contactId: string,
        number: string,
        bicNumber?: string | null,
        bankName?: string | null,
        contactIds?: Array< string > | null,
        buildingIds?: Array< string > | null,
        holderName?: string | null,
        label?: string | null,
        disabled?: boolean | null,
        integrations?: Array< IntegrationName > | null,
        matchingRule?: BankAccountMatchingRule | null,
        balance?: number | null,
        balanceDate?: string | null,
        type: BankAccountType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contactId?: string | null,
      contact?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      class: number,
      customUsage?: AccountLabelCustomUsage | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      disabled?: boolean | null,
      ownerId?: string | null,
      owner?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      topClass: number,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    buildingId?: string | null,
    building?:  {
      __typename: "Building",
      id: string,
      name: string,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      acquisitionValue?: number | null,
      acquisitionAdditionalCostsValue?: number | null,
      acquisitionAdvertisedValue?: number | null,
      amountOfFacades?: number | null,
      amountOfFloors?: number | null,
      amountOfHousings?: number | null,
      buildingState?: BuildingState | null,
      cadastralIncome?: number | null,
      constructionYear?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      janitor?: boolean | null,
      jointOwnershipId?: string | null,
      notes?: string | null,
      owners?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      propertyTax?: number | null,
      residenceName?: string | null,
      buildingSiteId?: string | null,
      buildingSite?:  {
        __typename: "BuildingSite",
        id: string,
        name: string,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      units?:  {
        __typename: "ModelUnitConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      events?:  {
        __typename: "ModelBuildingEventConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      teams?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    buildingSiteId?: string | null,
    buildingSite?:  {
      __typename: "BuildingSite",
      id: string,
      name: string,
      buildings?:  {
        __typename: "ModelBuildingConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      teams?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    unitRepartition?:  Array< {
      __typename: "RepartitionValues",
      unitId: string,
      value: number,
    } > | null,
    ownerRepartition: number,
    tenantRepartition: number,
    repartitionMetric: string,
    technics?: Array< string > | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateClientMutationVariables = {
  input: CreateClientInput,
  condition?: ModelClientConditionInput | null,
};

export type CreateClientMutation = {
  createClient?:  {
    __typename: "Client",
    id: string,
    accountType: AccountType,
    contactId: string,
    contact?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    generalConditionsAcceptDate: string,
    lastGeneralConditionsAcceptedVersion: string,
    GDPRAcceptDate: string,
    lastGDPRAcceptedVersion: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateClientMutationVariables = {
  input: UpdateClientInput,
  condition?: ModelClientConditionInput | null,
};

export type UpdateClientMutation = {
  updateClient?:  {
    __typename: "Client",
    id: string,
    accountType: AccountType,
    contactId: string,
    contact?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    generalConditionsAcceptDate: string,
    lastGeneralConditionsAcceptedVersion: string,
    GDPRAcceptDate: string,
    lastGDPRAcceptedVersion: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteClientMutationVariables = {
  input: DeleteClientInput,
  condition?: ModelClientConditionInput | null,
};

export type DeleteClientMutation = {
  deleteClient?:  {
    __typename: "Client",
    id: string,
    accountType: AccountType,
    contactId: string,
    contact?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    generalConditionsAcceptDate: string,
    lastGeneralConditionsAcceptedVersion: string,
    GDPRAcceptDate: string,
    lastGDPRAcceptedVersion: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateCommunicationMutationVariables = {
  input: CreateCommunicationInput,
  condition?: ModelCommunicationConditionInput | null,
};

export type CreateCommunicationMutation = {
  createCommunication?:  {
    __typename: "Communication",
    id: string,
    addressId?: string | null,
    address?:  {
      __typename: "Address",
      id: string,
      status?: AddressStatus | null,
      street: string,
      number?: string | null,
      box?: string | null,
      postalCode?: string | null,
      city?: string | null,
      region?: string | null,
      country?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      latitude?: number | null,
      longitude?: number | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    blockedRecipients?:  Array< {
      __typename: "CommunicationBlockedRecipient",
      recipient: string,
      bounceType: BounceType,
    } > | null,
    body: string,
    buildingId?: string | null,
    channel: CommunicationChannel,
    communicationTemplateId?: string | null,
    concernedContactIds?: Array< string > | null,
    contactId?: string | null,
    contactIds?: Array< string > | null,
    createdAt?: string | null,
    draftProperties?:  {
      __typename: "CommunicationDraftProperties",
      allowRecipientsToSeeEachOther?: boolean | null,
      bcc?: Array< string > | null,
      buildingIds?: Array< string > | null,
      cc?: Array< string > | null,
      contactIds?: Array< string > | null,
      contactTypes?: Array< ContactType > | null,
      entityType: string,
      leaseIds?: Array< string > | null,
      sendInBcc?: boolean | null,
      unitIds?: Array< string > | null,
      unitTypeFilter?: string | null,
    } | null,
    expirationDate?: string | null,
    files?:  {
      __typename: "ModelFileConnection",
      items:  Array< {
        __typename: "File",
        id: string,
        bucket: string,
        createdAt?: string | null,
        categoryId: string,
        foreignKey: string,
        foreignTableName: string,
        key: string,
        mimeType?: string | null,
        region: string,
        size?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        _ttl?: number | null,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    invoice?:  {
      __typename: "Invoice",
      id: string,
      amount: number,
      bankAccountId: string,
      bankAccount?:  {
        __typename: "BankAccount",
        id: string,
        contactId: string,
        number: string,
        bicNumber?: string | null,
        bankName?: string | null,
        contactIds?: Array< string > | null,
        buildingIds?: Array< string > | null,
        holderName?: string | null,
        label?: string | null,
        disabled?: boolean | null,
        integrations?: Array< IntegrationName > | null,
        matchingRule?: BankAccountMatchingRule | null,
        balance?: number | null,
        balanceDate?: string | null,
        type: BankAccountType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      communicationId?: string | null,
      communication?:  {
        __typename: "Communication",
        id: string,
        addressId?: string | null,
        body: string,
        buildingId?: string | null,
        channel: CommunicationChannel,
        communicationTemplateId?: string | null,
        concernedContactIds?: Array< string > | null,
        contactId?: string | null,
        contactIds?: Array< string > | null,
        createdAt?: string | null,
        expirationDate?: string | null,
        invoiceId?: string | null,
        leaseId?: string | null,
        leasePriceHistoryId?: string | null,
        letterTrackingCode?: string | null,
        letterTrackingProvider?: TrackingProvider | null,
        linkedCommunicationsIds?: Array< string > | null,
        supportingDocumentFileIds?: Array< string > | null,
        recipient?: string | null,
        recipientContactIdsInBcc?: Array< string > | null,
        recipientContactIdsInCc?: Array< string > | null,
        recipientInBcc?: string | null,
        recipientInCc?: string | null,
        scheduledAt?: string | null,
        deliveredAt?: string | null,
        errorCode?: CommunicationErrorCode | null,
        nextRetryAt?: string | null,
        sendRetryCount?: number | null,
        sender?: string | null,
        sentAt?: string | null,
        externalId?: string | null,
        externalStatus?: string | null,
        signatureDocumentId?: string | null,
        snoozedDate?: string | null,
        statementId?: string | null,
        status: CommunicationStatus,
        subject: string,
        toSend: boolean,
        hideLogo?: boolean | null,
        type: CommunicationType,
        _ttl?: number | null,
        unitId?: string | null,
        readId: string,
        readers?: Array< string > | null,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      createdAt: string,
      creditNote?: boolean | null,
      creditNoteLabel?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      dueDate?: string | null,
      invoiceDate: string,
      invoiceNumber?: string | null,
      ownerId?: string | null,
      owner?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      invoiceSenderId: string,
      invoiceSender?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      leaseId?: string | null,
      lease?:  {
        __typename: "Lease",
        id: string,
        balance?: number | null,
        canBeExtended?: boolean | null,
        communicationSettingsProfileId: string,
        createdAt?: string | null,
        endDate: string,
        includeRealEstateInLeaseContract?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        invoiceSenderId: string,
        inventoryOfFixturesExpert?: string | null,
        inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
        inventoryOfFixturesType?: InventoryOfFixturesType | null,
        ipiNumber?: string | null,
        language: Language,
        lastDraftInvoiceDate?: string | null,
        lastIndexationProcessDate?: string | null,
        lastInvoiceDate?: string | null,
        legalCompetentAuthority?: string | null,
        name: string,
        notes?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        purchaseOrderNumber?: string | null,
        realEstateAgency?: string | null,
        realEstateTax?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        signatureDate?: string | null,
        startDate: string,
        nextIndexationMonth?: string | null,
        nextIndexation?: boolean | null,
        status: LeaseStatus,
        technicCommunicationSettingsProfileId: string,
        totalInitialRentalPrice: number,
        totalRentalPrice: number,
        type: LeaseType,
        subletting?: boolean | null,
        vatRateRentId?: string | null,
        bankAccountId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      paid: boolean,
      integrations?:  {
        __typename: "InvoiceIntegrations",
      } | null,
      postedDate?: string | null,
      purchaseOrderNumber?: string | null,
      receiptNumber?: string | null,
      reminderDates?: Array< string > | null,
      note?: string | null,
      remittanceInformation?: string | null,
      statementId?: string | null,
      statement?:  {
        __typename: "Statement",
        id: string,
        closingStatement: boolean,
        periodFrom: string,
        periodTo: string,
        attachSupportingDocuments?: boolean | null,
        selectedPocketKeys?: Array< string > | null,
        source: StatementSource,
        status: StatementStatus,
        sentDate?: string | null,
        leaseId?: string | null,
        ownerId?: string | null,
        types?: Array< StatementType > | null,
        viewType: StatementViewType,
        unitIds?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      status: InvoiceStatus,
      type: InvoiceType,
      unitId?: string | null,
      unit?:  {
        __typename: "Unit",
        id: string,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        acquisitionValue?: number | null,
        advertisedMonthlyCharges?: number | null,
        advertisedRentalPrice?: number | null,
        cadastralIncome?: number | null,
        createdAt?: string | null,
        floor?: number | null,
        jointOwnershipId?: string | null,
        managementDate: string,
        name: string,
        notes?: string | null,
        predictedPrice?: string | null,
        propertyTax?: number | null,
        publishAddress?: boolean | null,
        surface?: number | null,
        type: UnitType,
        buildingId: string,
        unitAdvertisementId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      reversedInvoiceId?: string | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    invoiceId?: string | null,
    lease?:  {
      __typename: "Lease",
      id: string,
      advancedChargesInvoices?:  {
        __typename: "LeaseAdvancedChargesInvoice",
        communicationSettingsProfileId: string,
        invoiceSenderId: string,
        lastDraftInvoiceDate?: string | null,
        lastInvoiceDate?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        bankAccountId?: string | null,
      } | null,
      balance?: number | null,
      canBeExtended?: boolean | null,
      communicationSettingsProfileId: string,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      endDate: string,
      includeRealEstateInLeaseContract?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      invoiceSenderId: string,
      invoiceSender?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      inventoryOfFixturesExpert?: string | null,
      inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
      inventoryOfFixturesType?: InventoryOfFixturesType | null,
      ipiNumber?: string | null,
      language: Language,
      lastDraftInvoiceDate?: string | null,
      lastIndexationProcessDate?: string | null,
      lastInvoiceDate?: string | null,
      legalCompetentAuthority?: string | null,
      name: string,
      notes?: string | null,
      paymentFrequency: LeasePaymentFrequency,
      paymentInvoicePeriod: LeasePaymentInvoicePeriod,
      paymentInvoicePeriodCustomDay?: number | null,
      paymentOption?:  {
        __typename: "LeasePaymentOption",
        customerId?: string | null,
        enabled: boolean,
        mandateActivatedAt?: string | null,
        mandateStatus?: PaymentProviderMandateStatus | null,
        paymentMethodId?: string | null,
        qrType?: LeaseQrType | null,
      } | null,
      purchaseOrderNumber?: string | null,
      realEstateAgency?: string | null,
      realEstateTax?: number | null,
      remittanceInformation?: string | null,
      remittanceInformationType?: LeaseRemittanceType | null,
      rentalGuaranty?:  {
        __typename: "LeaseRentalGuaranty",
        amount: number,
        blockedAmount?: number | null,
        releasedAmount?: number | null,
        type: LeaseRentalGuarantyType,
        financialInstitution?: string | null,
      } | null,
      signatureDate?: string | null,
      startDate: string,
      nextIndexationMonth?: string | null,
      nextIndexation?: boolean | null,
      status: LeaseStatus,
      technicCommunicationSettingsProfileId: string,
      totalInitialRentalPrice: number,
      totalRentalPrice: number,
      type: LeaseType,
      subletting?: boolean | null,
      vatRateRentId?: string | null,
      vatRateRent?:  {
        __typename: "VatRate",
        id: string,
        country: string,
        label: string,
        value?: number | null,
        ownerId?: string | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      additionalClauses?:  {
        __typename: "ModelLeaseAdditionalClauseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      bankAccountId?: string | null,
      bankAccount?:  {
        __typename: "BankAccount",
        id: string,
        contactId: string,
        number: string,
        bicNumber?: string | null,
        bankName?: string | null,
        contactIds?: Array< string > | null,
        buildingIds?: Array< string > | null,
        holderName?: string | null,
        label?: string | null,
        disabled?: boolean | null,
        integrations?: Array< IntegrationName > | null,
        matchingRule?: BankAccountMatchingRule | null,
        balance?: number | null,
        balanceDate?: string | null,
        type: BankAccountType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contacts?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      files?:  {
        __typename: "ModelFileConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leaseActionHistories?:  {
        __typename: "ModelLeaseActionHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leasePriceHistories?:  {
        __typename: "ModelLeasePriceHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      signatureDocuments?:  {
        __typename: "ModelSignatureDocumentConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      variousOperations?:  {
        __typename: "ModelLeaseVariousOperationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    leaseId?: string | null,
    leasePriceHistoryId?: string | null,
    leasePriceHistory?:  {
      __typename: "LeasePriceHistory",
      id: string,
      previousTotalRentalPrice: number,
      totalRentalPrice: number,
      optimalTotalRentalPrice?: number | null,
      optimalTotalMonthlyCharges?: number | null,
      applicationDate: string,
      status: LeaseAmountUpdateStatus,
      comment?: string | null,
      amountDetails:  Array< {
        __typename: "LeasePriceHistoryDetail",
        unitId: string,
        indexationBaseIndex?: number | null,
        indexationNewIndex?: number | null,
        previousRentalPrice: number,
        newRentalPrice: number,
        rentalStatus: LeasePriceHistoryStatus,
        monthlyChargesStatus: LeasePriceHistoryStatus,
        optimalNewRentalPrice?: number | null,
        optimalNewMonthlyChargesPrice?: number | null,
        epb?: string | null,
        epbIssueDate?: string | null,
        oldestIndexForCorrectionFactorCalculation?: number | null,
        newestIndexForCorrectionFactorCalculation?: number | null,
        rentIndexedPriceAfterNewEpbReduction?: number | null,
        chargesIndexedPriceAfterNewEpbReduction?: number | null,
        correctionFactor?: number | null,
        reductionPercentage?: number | null,
        rentDifference?: number | null,
        rentReduction?: number | null,
        indexedRentAfterReduction?: number | null,
        chargesDifference?: number | null,
        chargesReduction?: number | null,
        indexedChargesAfterReduction?: number | null,
        previousYearIndexationNewIndex?: number | null,
        previousYearIndexedRent?: number | null,
        previousYearIndexedCharges?: number | null,
      } >,
      type: LeasePriceHistoryType,
      communicationId?: string | null,
      communication?:  {
        __typename: "Communication",
        id: string,
        addressId?: string | null,
        body: string,
        buildingId?: string | null,
        channel: CommunicationChannel,
        communicationTemplateId?: string | null,
        concernedContactIds?: Array< string > | null,
        contactId?: string | null,
        contactIds?: Array< string > | null,
        createdAt?: string | null,
        expirationDate?: string | null,
        invoiceId?: string | null,
        leaseId?: string | null,
        leasePriceHistoryId?: string | null,
        letterTrackingCode?: string | null,
        letterTrackingProvider?: TrackingProvider | null,
        linkedCommunicationsIds?: Array< string > | null,
        supportingDocumentFileIds?: Array< string > | null,
        recipient?: string | null,
        recipientContactIdsInBcc?: Array< string > | null,
        recipientContactIdsInCc?: Array< string > | null,
        recipientInBcc?: string | null,
        recipientInCc?: string | null,
        scheduledAt?: string | null,
        deliveredAt?: string | null,
        errorCode?: CommunicationErrorCode | null,
        nextRetryAt?: string | null,
        sendRetryCount?: number | null,
        sender?: string | null,
        sentAt?: string | null,
        externalId?: string | null,
        externalStatus?: string | null,
        signatureDocumentId?: string | null,
        snoozedDate?: string | null,
        statementId?: string | null,
        status: CommunicationStatus,
        subject: string,
        toSend: boolean,
        hideLogo?: boolean | null,
        type: CommunicationType,
        _ttl?: number | null,
        unitId?: string | null,
        readId: string,
        readers?: Array< string > | null,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      leaseId: string,
      lease?:  {
        __typename: "Lease",
        id: string,
        balance?: number | null,
        canBeExtended?: boolean | null,
        communicationSettingsProfileId: string,
        createdAt?: string | null,
        endDate: string,
        includeRealEstateInLeaseContract?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        invoiceSenderId: string,
        inventoryOfFixturesExpert?: string | null,
        inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
        inventoryOfFixturesType?: InventoryOfFixturesType | null,
        ipiNumber?: string | null,
        language: Language,
        lastDraftInvoiceDate?: string | null,
        lastIndexationProcessDate?: string | null,
        lastInvoiceDate?: string | null,
        legalCompetentAuthority?: string | null,
        name: string,
        notes?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        purchaseOrderNumber?: string | null,
        realEstateAgency?: string | null,
        realEstateTax?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        signatureDate?: string | null,
        startDate: string,
        nextIndexationMonth?: string | null,
        nextIndexation?: boolean | null,
        status: LeaseStatus,
        technicCommunicationSettingsProfileId: string,
        totalInitialRentalPrice: number,
        totalRentalPrice: number,
        type: LeaseType,
        subletting?: boolean | null,
        vatRateRentId?: string | null,
        bankAccountId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      createdAt?: string | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    letterTrackingCode?: string | null,
    letterTrackingProvider?: TrackingProvider | null,
    linkedCommunicationsIds?: Array< string > | null,
    supportingDocumentFileIds?: Array< string > | null,
    recipient?: string | null,
    recipientContactIdsInBcc?: Array< string > | null,
    recipientContactIdsInCc?: Array< string > | null,
    recipientInBcc?: string | null,
    recipientInCc?: string | null,
    scheduledAt?: string | null,
    deliveredAt?: string | null,
    errorCode?: CommunicationErrorCode | null,
    nextRetryAt?: string | null,
    sendRetryCount?: number | null,
    sender?: string | null,
    sentAt?: string | null,
    externalId?: string | null,
    externalStatus?: string | null,
    signatureDocumentId?: string | null,
    signatureDocument?:  {
      __typename: "SignatureDocument",
      id: string,
      additionalMessage?: string | null,
      automaticRemindersDisabled?: boolean | null,
      communicationBody?: string | null,
      createdAt?: string | null,
      expirationDate?: string | null,
      fileIds?: Array< string > | null,
      foreignKey: string,
      foreignTableName: string,
      sentAt?: string | null,
      signatureMethods: Array< SignatureType >,
      signatureResults:  Array< {
        __typename: "SignatureDocumentResult",
        openedDate?: string | null,
        signedDate?: string | null,
        signed?: boolean | null,
        signatureLink?: string | null,
        rejectReason?: string | null,
        lastSignInviteSentDate?: string | null,
        reminderDates?: Array< string > | null,
        trackingProvider?: TrackingProvider | null,
        trackingCode?: string | null,
        contactId: string,
      } >,
      status: SignatureDocumentStatus,
      externalStatus?: string | null,
      type: SignatureDocumentType,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    snoozedDate?: string | null,
    statement?:  {
      __typename: "Statement",
      id: string,
      amounts?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      chargeStatements?:  {
        __typename: "ModelChargeStatementConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      closingStatement: boolean,
      periodFrom: string,
      periodTo: string,
      attachSupportingDocuments?: boolean | null,
      selectedPocketKeys?: Array< string > | null,
      source: StatementSource,
      status: StatementStatus,
      sentDate?: string | null,
      leaseId?: string | null,
      lease?:  {
        __typename: "Lease",
        id: string,
        balance?: number | null,
        canBeExtended?: boolean | null,
        communicationSettingsProfileId: string,
        createdAt?: string | null,
        endDate: string,
        includeRealEstateInLeaseContract?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        invoiceSenderId: string,
        inventoryOfFixturesExpert?: string | null,
        inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
        inventoryOfFixturesType?: InventoryOfFixturesType | null,
        ipiNumber?: string | null,
        language: Language,
        lastDraftInvoiceDate?: string | null,
        lastIndexationProcessDate?: string | null,
        lastInvoiceDate?: string | null,
        legalCompetentAuthority?: string | null,
        name: string,
        notes?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        purchaseOrderNumber?: string | null,
        realEstateAgency?: string | null,
        realEstateTax?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        signatureDate?: string | null,
        startDate: string,
        nextIndexationMonth?: string | null,
        nextIndexation?: boolean | null,
        status: LeaseStatus,
        technicCommunicationSettingsProfileId: string,
        totalInitialRentalPrice: number,
        totalRentalPrice: number,
        type: LeaseType,
        subletting?: boolean | null,
        vatRateRentId?: string | null,
        bankAccountId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      agencyRateStatements?:  {
        __typename: "ModelAgencyRateStatementConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      ownerId?: string | null,
      owner?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      repaymentStatements?:  {
        __typename: "ModelRepaymentStatementConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      types?: Array< StatementType > | null,
      viewType: StatementViewType,
      unitIds?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    statementId?: string | null,
    status: CommunicationStatus,
    subject: string,
    toSend: boolean,
    hideLogo?: boolean | null,
    type: CommunicationType,
    _ttl?: number | null,
    unit?:  {
      __typename: "Unit",
      id: string,
      acquisitionAdditionalCostsValue?: number | null,
      acquisitionAdvertisedValue?: number | null,
      acquisitionValue?: number | null,
      advertisedMonthlyCharges?: number | null,
      advertisedRentalPrice?: number | null,
      cadastralIncome?: number | null,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      floor?: number | null,
      jointOwnershipId?: string | null,
      managementDate: string,
      name: string,
      notes?: string | null,
      predictedPrice?: string | null,
      propertyTax?: number | null,
      publishAddress?: boolean | null,
      surface?: number | null,
      type: UnitType,
      buildingId: string,
      building?:  {
        __typename: "Building",
        id: string,
        name: string,
        addressId?: string | null,
        acquisitionValue?: number | null,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        amountOfFacades?: number | null,
        amountOfFloors?: number | null,
        amountOfHousings?: number | null,
        buildingState?: BuildingState | null,
        cadastralIncome?: number | null,
        constructionYear?: string | null,
        janitor?: boolean | null,
        jointOwnershipId?: string | null,
        notes?: string | null,
        propertyTax?: number | null,
        residenceName?: string | null,
        buildingSiteId?: string | null,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      owners?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leases?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      events?:  {
        __typename: "ModelUnitEventConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      unitAdvertisementId?: string | null,
      unitInventories?:  {
        __typename: "ModelUnitInventoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    unitId?: string | null,
    readId: string,
    readers?: Array< string > | null,
    clientId: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateCommunicationMutationVariables = {
  input: UpdateCommunicationInput,
  condition?: ModelCommunicationConditionInput | null,
};

export type UpdateCommunicationMutation = {
  updateCommunication?:  {
    __typename: "Communication",
    id: string,
    addressId?: string | null,
    address?:  {
      __typename: "Address",
      id: string,
      status?: AddressStatus | null,
      street: string,
      number?: string | null,
      box?: string | null,
      postalCode?: string | null,
      city?: string | null,
      region?: string | null,
      country?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      latitude?: number | null,
      longitude?: number | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    blockedRecipients?:  Array< {
      __typename: "CommunicationBlockedRecipient",
      recipient: string,
      bounceType: BounceType,
    } > | null,
    body: string,
    buildingId?: string | null,
    channel: CommunicationChannel,
    communicationTemplateId?: string | null,
    concernedContactIds?: Array< string > | null,
    contactId?: string | null,
    contactIds?: Array< string > | null,
    createdAt?: string | null,
    draftProperties?:  {
      __typename: "CommunicationDraftProperties",
      allowRecipientsToSeeEachOther?: boolean | null,
      bcc?: Array< string > | null,
      buildingIds?: Array< string > | null,
      cc?: Array< string > | null,
      contactIds?: Array< string > | null,
      contactTypes?: Array< ContactType > | null,
      entityType: string,
      leaseIds?: Array< string > | null,
      sendInBcc?: boolean | null,
      unitIds?: Array< string > | null,
      unitTypeFilter?: string | null,
    } | null,
    expirationDate?: string | null,
    files?:  {
      __typename: "ModelFileConnection",
      items:  Array< {
        __typename: "File",
        id: string,
        bucket: string,
        createdAt?: string | null,
        categoryId: string,
        foreignKey: string,
        foreignTableName: string,
        key: string,
        mimeType?: string | null,
        region: string,
        size?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        _ttl?: number | null,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    invoice?:  {
      __typename: "Invoice",
      id: string,
      amount: number,
      bankAccountId: string,
      bankAccount?:  {
        __typename: "BankAccount",
        id: string,
        contactId: string,
        number: string,
        bicNumber?: string | null,
        bankName?: string | null,
        contactIds?: Array< string > | null,
        buildingIds?: Array< string > | null,
        holderName?: string | null,
        label?: string | null,
        disabled?: boolean | null,
        integrations?: Array< IntegrationName > | null,
        matchingRule?: BankAccountMatchingRule | null,
        balance?: number | null,
        balanceDate?: string | null,
        type: BankAccountType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      communicationId?: string | null,
      communication?:  {
        __typename: "Communication",
        id: string,
        addressId?: string | null,
        body: string,
        buildingId?: string | null,
        channel: CommunicationChannel,
        communicationTemplateId?: string | null,
        concernedContactIds?: Array< string > | null,
        contactId?: string | null,
        contactIds?: Array< string > | null,
        createdAt?: string | null,
        expirationDate?: string | null,
        invoiceId?: string | null,
        leaseId?: string | null,
        leasePriceHistoryId?: string | null,
        letterTrackingCode?: string | null,
        letterTrackingProvider?: TrackingProvider | null,
        linkedCommunicationsIds?: Array< string > | null,
        supportingDocumentFileIds?: Array< string > | null,
        recipient?: string | null,
        recipientContactIdsInBcc?: Array< string > | null,
        recipientContactIdsInCc?: Array< string > | null,
        recipientInBcc?: string | null,
        recipientInCc?: string | null,
        scheduledAt?: string | null,
        deliveredAt?: string | null,
        errorCode?: CommunicationErrorCode | null,
        nextRetryAt?: string | null,
        sendRetryCount?: number | null,
        sender?: string | null,
        sentAt?: string | null,
        externalId?: string | null,
        externalStatus?: string | null,
        signatureDocumentId?: string | null,
        snoozedDate?: string | null,
        statementId?: string | null,
        status: CommunicationStatus,
        subject: string,
        toSend: boolean,
        hideLogo?: boolean | null,
        type: CommunicationType,
        _ttl?: number | null,
        unitId?: string | null,
        readId: string,
        readers?: Array< string > | null,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      createdAt: string,
      creditNote?: boolean | null,
      creditNoteLabel?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      dueDate?: string | null,
      invoiceDate: string,
      invoiceNumber?: string | null,
      ownerId?: string | null,
      owner?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      invoiceSenderId: string,
      invoiceSender?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      leaseId?: string | null,
      lease?:  {
        __typename: "Lease",
        id: string,
        balance?: number | null,
        canBeExtended?: boolean | null,
        communicationSettingsProfileId: string,
        createdAt?: string | null,
        endDate: string,
        includeRealEstateInLeaseContract?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        invoiceSenderId: string,
        inventoryOfFixturesExpert?: string | null,
        inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
        inventoryOfFixturesType?: InventoryOfFixturesType | null,
        ipiNumber?: string | null,
        language: Language,
        lastDraftInvoiceDate?: string | null,
        lastIndexationProcessDate?: string | null,
        lastInvoiceDate?: string | null,
        legalCompetentAuthority?: string | null,
        name: string,
        notes?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        purchaseOrderNumber?: string | null,
        realEstateAgency?: string | null,
        realEstateTax?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        signatureDate?: string | null,
        startDate: string,
        nextIndexationMonth?: string | null,
        nextIndexation?: boolean | null,
        status: LeaseStatus,
        technicCommunicationSettingsProfileId: string,
        totalInitialRentalPrice: number,
        totalRentalPrice: number,
        type: LeaseType,
        subletting?: boolean | null,
        vatRateRentId?: string | null,
        bankAccountId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      paid: boolean,
      integrations?:  {
        __typename: "InvoiceIntegrations",
      } | null,
      postedDate?: string | null,
      purchaseOrderNumber?: string | null,
      receiptNumber?: string | null,
      reminderDates?: Array< string > | null,
      note?: string | null,
      remittanceInformation?: string | null,
      statementId?: string | null,
      statement?:  {
        __typename: "Statement",
        id: string,
        closingStatement: boolean,
        periodFrom: string,
        periodTo: string,
        attachSupportingDocuments?: boolean | null,
        selectedPocketKeys?: Array< string > | null,
        source: StatementSource,
        status: StatementStatus,
        sentDate?: string | null,
        leaseId?: string | null,
        ownerId?: string | null,
        types?: Array< StatementType > | null,
        viewType: StatementViewType,
        unitIds?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      status: InvoiceStatus,
      type: InvoiceType,
      unitId?: string | null,
      unit?:  {
        __typename: "Unit",
        id: string,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        acquisitionValue?: number | null,
        advertisedMonthlyCharges?: number | null,
        advertisedRentalPrice?: number | null,
        cadastralIncome?: number | null,
        createdAt?: string | null,
        floor?: number | null,
        jointOwnershipId?: string | null,
        managementDate: string,
        name: string,
        notes?: string | null,
        predictedPrice?: string | null,
        propertyTax?: number | null,
        publishAddress?: boolean | null,
        surface?: number | null,
        type: UnitType,
        buildingId: string,
        unitAdvertisementId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      reversedInvoiceId?: string | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    invoiceId?: string | null,
    lease?:  {
      __typename: "Lease",
      id: string,
      advancedChargesInvoices?:  {
        __typename: "LeaseAdvancedChargesInvoice",
        communicationSettingsProfileId: string,
        invoiceSenderId: string,
        lastDraftInvoiceDate?: string | null,
        lastInvoiceDate?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        bankAccountId?: string | null,
      } | null,
      balance?: number | null,
      canBeExtended?: boolean | null,
      communicationSettingsProfileId: string,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      endDate: string,
      includeRealEstateInLeaseContract?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      invoiceSenderId: string,
      invoiceSender?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      inventoryOfFixturesExpert?: string | null,
      inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
      inventoryOfFixturesType?: InventoryOfFixturesType | null,
      ipiNumber?: string | null,
      language: Language,
      lastDraftInvoiceDate?: string | null,
      lastIndexationProcessDate?: string | null,
      lastInvoiceDate?: string | null,
      legalCompetentAuthority?: string | null,
      name: string,
      notes?: string | null,
      paymentFrequency: LeasePaymentFrequency,
      paymentInvoicePeriod: LeasePaymentInvoicePeriod,
      paymentInvoicePeriodCustomDay?: number | null,
      paymentOption?:  {
        __typename: "LeasePaymentOption",
        customerId?: string | null,
        enabled: boolean,
        mandateActivatedAt?: string | null,
        mandateStatus?: PaymentProviderMandateStatus | null,
        paymentMethodId?: string | null,
        qrType?: LeaseQrType | null,
      } | null,
      purchaseOrderNumber?: string | null,
      realEstateAgency?: string | null,
      realEstateTax?: number | null,
      remittanceInformation?: string | null,
      remittanceInformationType?: LeaseRemittanceType | null,
      rentalGuaranty?:  {
        __typename: "LeaseRentalGuaranty",
        amount: number,
        blockedAmount?: number | null,
        releasedAmount?: number | null,
        type: LeaseRentalGuarantyType,
        financialInstitution?: string | null,
      } | null,
      signatureDate?: string | null,
      startDate: string,
      nextIndexationMonth?: string | null,
      nextIndexation?: boolean | null,
      status: LeaseStatus,
      technicCommunicationSettingsProfileId: string,
      totalInitialRentalPrice: number,
      totalRentalPrice: number,
      type: LeaseType,
      subletting?: boolean | null,
      vatRateRentId?: string | null,
      vatRateRent?:  {
        __typename: "VatRate",
        id: string,
        country: string,
        label: string,
        value?: number | null,
        ownerId?: string | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      additionalClauses?:  {
        __typename: "ModelLeaseAdditionalClauseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      bankAccountId?: string | null,
      bankAccount?:  {
        __typename: "BankAccount",
        id: string,
        contactId: string,
        number: string,
        bicNumber?: string | null,
        bankName?: string | null,
        contactIds?: Array< string > | null,
        buildingIds?: Array< string > | null,
        holderName?: string | null,
        label?: string | null,
        disabled?: boolean | null,
        integrations?: Array< IntegrationName > | null,
        matchingRule?: BankAccountMatchingRule | null,
        balance?: number | null,
        balanceDate?: string | null,
        type: BankAccountType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contacts?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      files?:  {
        __typename: "ModelFileConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leaseActionHistories?:  {
        __typename: "ModelLeaseActionHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leasePriceHistories?:  {
        __typename: "ModelLeasePriceHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      signatureDocuments?:  {
        __typename: "ModelSignatureDocumentConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      variousOperations?:  {
        __typename: "ModelLeaseVariousOperationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    leaseId?: string | null,
    leasePriceHistoryId?: string | null,
    leasePriceHistory?:  {
      __typename: "LeasePriceHistory",
      id: string,
      previousTotalRentalPrice: number,
      totalRentalPrice: number,
      optimalTotalRentalPrice?: number | null,
      optimalTotalMonthlyCharges?: number | null,
      applicationDate: string,
      status: LeaseAmountUpdateStatus,
      comment?: string | null,
      amountDetails:  Array< {
        __typename: "LeasePriceHistoryDetail",
        unitId: string,
        indexationBaseIndex?: number | null,
        indexationNewIndex?: number | null,
        previousRentalPrice: number,
        newRentalPrice: number,
        rentalStatus: LeasePriceHistoryStatus,
        monthlyChargesStatus: LeasePriceHistoryStatus,
        optimalNewRentalPrice?: number | null,
        optimalNewMonthlyChargesPrice?: number | null,
        epb?: string | null,
        epbIssueDate?: string | null,
        oldestIndexForCorrectionFactorCalculation?: number | null,
        newestIndexForCorrectionFactorCalculation?: number | null,
        rentIndexedPriceAfterNewEpbReduction?: number | null,
        chargesIndexedPriceAfterNewEpbReduction?: number | null,
        correctionFactor?: number | null,
        reductionPercentage?: number | null,
        rentDifference?: number | null,
        rentReduction?: number | null,
        indexedRentAfterReduction?: number | null,
        chargesDifference?: number | null,
        chargesReduction?: number | null,
        indexedChargesAfterReduction?: number | null,
        previousYearIndexationNewIndex?: number | null,
        previousYearIndexedRent?: number | null,
        previousYearIndexedCharges?: number | null,
      } >,
      type: LeasePriceHistoryType,
      communicationId?: string | null,
      communication?:  {
        __typename: "Communication",
        id: string,
        addressId?: string | null,
        body: string,
        buildingId?: string | null,
        channel: CommunicationChannel,
        communicationTemplateId?: string | null,
        concernedContactIds?: Array< string > | null,
        contactId?: string | null,
        contactIds?: Array< string > | null,
        createdAt?: string | null,
        expirationDate?: string | null,
        invoiceId?: string | null,
        leaseId?: string | null,
        leasePriceHistoryId?: string | null,
        letterTrackingCode?: string | null,
        letterTrackingProvider?: TrackingProvider | null,
        linkedCommunicationsIds?: Array< string > | null,
        supportingDocumentFileIds?: Array< string > | null,
        recipient?: string | null,
        recipientContactIdsInBcc?: Array< string > | null,
        recipientContactIdsInCc?: Array< string > | null,
        recipientInBcc?: string | null,
        recipientInCc?: string | null,
        scheduledAt?: string | null,
        deliveredAt?: string | null,
        errorCode?: CommunicationErrorCode | null,
        nextRetryAt?: string | null,
        sendRetryCount?: number | null,
        sender?: string | null,
        sentAt?: string | null,
        externalId?: string | null,
        externalStatus?: string | null,
        signatureDocumentId?: string | null,
        snoozedDate?: string | null,
        statementId?: string | null,
        status: CommunicationStatus,
        subject: string,
        toSend: boolean,
        hideLogo?: boolean | null,
        type: CommunicationType,
        _ttl?: number | null,
        unitId?: string | null,
        readId: string,
        readers?: Array< string > | null,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      leaseId: string,
      lease?:  {
        __typename: "Lease",
        id: string,
        balance?: number | null,
        canBeExtended?: boolean | null,
        communicationSettingsProfileId: string,
        createdAt?: string | null,
        endDate: string,
        includeRealEstateInLeaseContract?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        invoiceSenderId: string,
        inventoryOfFixturesExpert?: string | null,
        inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
        inventoryOfFixturesType?: InventoryOfFixturesType | null,
        ipiNumber?: string | null,
        language: Language,
        lastDraftInvoiceDate?: string | null,
        lastIndexationProcessDate?: string | null,
        lastInvoiceDate?: string | null,
        legalCompetentAuthority?: string | null,
        name: string,
        notes?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        purchaseOrderNumber?: string | null,
        realEstateAgency?: string | null,
        realEstateTax?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        signatureDate?: string | null,
        startDate: string,
        nextIndexationMonth?: string | null,
        nextIndexation?: boolean | null,
        status: LeaseStatus,
        technicCommunicationSettingsProfileId: string,
        totalInitialRentalPrice: number,
        totalRentalPrice: number,
        type: LeaseType,
        subletting?: boolean | null,
        vatRateRentId?: string | null,
        bankAccountId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      createdAt?: string | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    letterTrackingCode?: string | null,
    letterTrackingProvider?: TrackingProvider | null,
    linkedCommunicationsIds?: Array< string > | null,
    supportingDocumentFileIds?: Array< string > | null,
    recipient?: string | null,
    recipientContactIdsInBcc?: Array< string > | null,
    recipientContactIdsInCc?: Array< string > | null,
    recipientInBcc?: string | null,
    recipientInCc?: string | null,
    scheduledAt?: string | null,
    deliveredAt?: string | null,
    errorCode?: CommunicationErrorCode | null,
    nextRetryAt?: string | null,
    sendRetryCount?: number | null,
    sender?: string | null,
    sentAt?: string | null,
    externalId?: string | null,
    externalStatus?: string | null,
    signatureDocumentId?: string | null,
    signatureDocument?:  {
      __typename: "SignatureDocument",
      id: string,
      additionalMessage?: string | null,
      automaticRemindersDisabled?: boolean | null,
      communicationBody?: string | null,
      createdAt?: string | null,
      expirationDate?: string | null,
      fileIds?: Array< string > | null,
      foreignKey: string,
      foreignTableName: string,
      sentAt?: string | null,
      signatureMethods: Array< SignatureType >,
      signatureResults:  Array< {
        __typename: "SignatureDocumentResult",
        openedDate?: string | null,
        signedDate?: string | null,
        signed?: boolean | null,
        signatureLink?: string | null,
        rejectReason?: string | null,
        lastSignInviteSentDate?: string | null,
        reminderDates?: Array< string > | null,
        trackingProvider?: TrackingProvider | null,
        trackingCode?: string | null,
        contactId: string,
      } >,
      status: SignatureDocumentStatus,
      externalStatus?: string | null,
      type: SignatureDocumentType,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    snoozedDate?: string | null,
    statement?:  {
      __typename: "Statement",
      id: string,
      amounts?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      chargeStatements?:  {
        __typename: "ModelChargeStatementConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      closingStatement: boolean,
      periodFrom: string,
      periodTo: string,
      attachSupportingDocuments?: boolean | null,
      selectedPocketKeys?: Array< string > | null,
      source: StatementSource,
      status: StatementStatus,
      sentDate?: string | null,
      leaseId?: string | null,
      lease?:  {
        __typename: "Lease",
        id: string,
        balance?: number | null,
        canBeExtended?: boolean | null,
        communicationSettingsProfileId: string,
        createdAt?: string | null,
        endDate: string,
        includeRealEstateInLeaseContract?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        invoiceSenderId: string,
        inventoryOfFixturesExpert?: string | null,
        inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
        inventoryOfFixturesType?: InventoryOfFixturesType | null,
        ipiNumber?: string | null,
        language: Language,
        lastDraftInvoiceDate?: string | null,
        lastIndexationProcessDate?: string | null,
        lastInvoiceDate?: string | null,
        legalCompetentAuthority?: string | null,
        name: string,
        notes?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        purchaseOrderNumber?: string | null,
        realEstateAgency?: string | null,
        realEstateTax?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        signatureDate?: string | null,
        startDate: string,
        nextIndexationMonth?: string | null,
        nextIndexation?: boolean | null,
        status: LeaseStatus,
        technicCommunicationSettingsProfileId: string,
        totalInitialRentalPrice: number,
        totalRentalPrice: number,
        type: LeaseType,
        subletting?: boolean | null,
        vatRateRentId?: string | null,
        bankAccountId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      agencyRateStatements?:  {
        __typename: "ModelAgencyRateStatementConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      ownerId?: string | null,
      owner?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      repaymentStatements?:  {
        __typename: "ModelRepaymentStatementConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      types?: Array< StatementType > | null,
      viewType: StatementViewType,
      unitIds?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    statementId?: string | null,
    status: CommunicationStatus,
    subject: string,
    toSend: boolean,
    hideLogo?: boolean | null,
    type: CommunicationType,
    _ttl?: number | null,
    unit?:  {
      __typename: "Unit",
      id: string,
      acquisitionAdditionalCostsValue?: number | null,
      acquisitionAdvertisedValue?: number | null,
      acquisitionValue?: number | null,
      advertisedMonthlyCharges?: number | null,
      advertisedRentalPrice?: number | null,
      cadastralIncome?: number | null,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      floor?: number | null,
      jointOwnershipId?: string | null,
      managementDate: string,
      name: string,
      notes?: string | null,
      predictedPrice?: string | null,
      propertyTax?: number | null,
      publishAddress?: boolean | null,
      surface?: number | null,
      type: UnitType,
      buildingId: string,
      building?:  {
        __typename: "Building",
        id: string,
        name: string,
        addressId?: string | null,
        acquisitionValue?: number | null,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        amountOfFacades?: number | null,
        amountOfFloors?: number | null,
        amountOfHousings?: number | null,
        buildingState?: BuildingState | null,
        cadastralIncome?: number | null,
        constructionYear?: string | null,
        janitor?: boolean | null,
        jointOwnershipId?: string | null,
        notes?: string | null,
        propertyTax?: number | null,
        residenceName?: string | null,
        buildingSiteId?: string | null,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      owners?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leases?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      events?:  {
        __typename: "ModelUnitEventConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      unitAdvertisementId?: string | null,
      unitInventories?:  {
        __typename: "ModelUnitInventoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    unitId?: string | null,
    readId: string,
    readers?: Array< string > | null,
    clientId: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteCommunicationMutationVariables = {
  input: DeleteCommunicationInput,
  condition?: ModelCommunicationConditionInput | null,
};

export type DeleteCommunicationMutation = {
  deleteCommunication?:  {
    __typename: "Communication",
    id: string,
    addressId?: string | null,
    address?:  {
      __typename: "Address",
      id: string,
      status?: AddressStatus | null,
      street: string,
      number?: string | null,
      box?: string | null,
      postalCode?: string | null,
      city?: string | null,
      region?: string | null,
      country?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      latitude?: number | null,
      longitude?: number | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    blockedRecipients?:  Array< {
      __typename: "CommunicationBlockedRecipient",
      recipient: string,
      bounceType: BounceType,
    } > | null,
    body: string,
    buildingId?: string | null,
    channel: CommunicationChannel,
    communicationTemplateId?: string | null,
    concernedContactIds?: Array< string > | null,
    contactId?: string | null,
    contactIds?: Array< string > | null,
    createdAt?: string | null,
    draftProperties?:  {
      __typename: "CommunicationDraftProperties",
      allowRecipientsToSeeEachOther?: boolean | null,
      bcc?: Array< string > | null,
      buildingIds?: Array< string > | null,
      cc?: Array< string > | null,
      contactIds?: Array< string > | null,
      contactTypes?: Array< ContactType > | null,
      entityType: string,
      leaseIds?: Array< string > | null,
      sendInBcc?: boolean | null,
      unitIds?: Array< string > | null,
      unitTypeFilter?: string | null,
    } | null,
    expirationDate?: string | null,
    files?:  {
      __typename: "ModelFileConnection",
      items:  Array< {
        __typename: "File",
        id: string,
        bucket: string,
        createdAt?: string | null,
        categoryId: string,
        foreignKey: string,
        foreignTableName: string,
        key: string,
        mimeType?: string | null,
        region: string,
        size?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        _ttl?: number | null,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    invoice?:  {
      __typename: "Invoice",
      id: string,
      amount: number,
      bankAccountId: string,
      bankAccount?:  {
        __typename: "BankAccount",
        id: string,
        contactId: string,
        number: string,
        bicNumber?: string | null,
        bankName?: string | null,
        contactIds?: Array< string > | null,
        buildingIds?: Array< string > | null,
        holderName?: string | null,
        label?: string | null,
        disabled?: boolean | null,
        integrations?: Array< IntegrationName > | null,
        matchingRule?: BankAccountMatchingRule | null,
        balance?: number | null,
        balanceDate?: string | null,
        type: BankAccountType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      communicationId?: string | null,
      communication?:  {
        __typename: "Communication",
        id: string,
        addressId?: string | null,
        body: string,
        buildingId?: string | null,
        channel: CommunicationChannel,
        communicationTemplateId?: string | null,
        concernedContactIds?: Array< string > | null,
        contactId?: string | null,
        contactIds?: Array< string > | null,
        createdAt?: string | null,
        expirationDate?: string | null,
        invoiceId?: string | null,
        leaseId?: string | null,
        leasePriceHistoryId?: string | null,
        letterTrackingCode?: string | null,
        letterTrackingProvider?: TrackingProvider | null,
        linkedCommunicationsIds?: Array< string > | null,
        supportingDocumentFileIds?: Array< string > | null,
        recipient?: string | null,
        recipientContactIdsInBcc?: Array< string > | null,
        recipientContactIdsInCc?: Array< string > | null,
        recipientInBcc?: string | null,
        recipientInCc?: string | null,
        scheduledAt?: string | null,
        deliveredAt?: string | null,
        errorCode?: CommunicationErrorCode | null,
        nextRetryAt?: string | null,
        sendRetryCount?: number | null,
        sender?: string | null,
        sentAt?: string | null,
        externalId?: string | null,
        externalStatus?: string | null,
        signatureDocumentId?: string | null,
        snoozedDate?: string | null,
        statementId?: string | null,
        status: CommunicationStatus,
        subject: string,
        toSend: boolean,
        hideLogo?: boolean | null,
        type: CommunicationType,
        _ttl?: number | null,
        unitId?: string | null,
        readId: string,
        readers?: Array< string > | null,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      createdAt: string,
      creditNote?: boolean | null,
      creditNoteLabel?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      dueDate?: string | null,
      invoiceDate: string,
      invoiceNumber?: string | null,
      ownerId?: string | null,
      owner?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      invoiceSenderId: string,
      invoiceSender?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      leaseId?: string | null,
      lease?:  {
        __typename: "Lease",
        id: string,
        balance?: number | null,
        canBeExtended?: boolean | null,
        communicationSettingsProfileId: string,
        createdAt?: string | null,
        endDate: string,
        includeRealEstateInLeaseContract?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        invoiceSenderId: string,
        inventoryOfFixturesExpert?: string | null,
        inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
        inventoryOfFixturesType?: InventoryOfFixturesType | null,
        ipiNumber?: string | null,
        language: Language,
        lastDraftInvoiceDate?: string | null,
        lastIndexationProcessDate?: string | null,
        lastInvoiceDate?: string | null,
        legalCompetentAuthority?: string | null,
        name: string,
        notes?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        purchaseOrderNumber?: string | null,
        realEstateAgency?: string | null,
        realEstateTax?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        signatureDate?: string | null,
        startDate: string,
        nextIndexationMonth?: string | null,
        nextIndexation?: boolean | null,
        status: LeaseStatus,
        technicCommunicationSettingsProfileId: string,
        totalInitialRentalPrice: number,
        totalRentalPrice: number,
        type: LeaseType,
        subletting?: boolean | null,
        vatRateRentId?: string | null,
        bankAccountId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      paid: boolean,
      integrations?:  {
        __typename: "InvoiceIntegrations",
      } | null,
      postedDate?: string | null,
      purchaseOrderNumber?: string | null,
      receiptNumber?: string | null,
      reminderDates?: Array< string > | null,
      note?: string | null,
      remittanceInformation?: string | null,
      statementId?: string | null,
      statement?:  {
        __typename: "Statement",
        id: string,
        closingStatement: boolean,
        periodFrom: string,
        periodTo: string,
        attachSupportingDocuments?: boolean | null,
        selectedPocketKeys?: Array< string > | null,
        source: StatementSource,
        status: StatementStatus,
        sentDate?: string | null,
        leaseId?: string | null,
        ownerId?: string | null,
        types?: Array< StatementType > | null,
        viewType: StatementViewType,
        unitIds?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      status: InvoiceStatus,
      type: InvoiceType,
      unitId?: string | null,
      unit?:  {
        __typename: "Unit",
        id: string,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        acquisitionValue?: number | null,
        advertisedMonthlyCharges?: number | null,
        advertisedRentalPrice?: number | null,
        cadastralIncome?: number | null,
        createdAt?: string | null,
        floor?: number | null,
        jointOwnershipId?: string | null,
        managementDate: string,
        name: string,
        notes?: string | null,
        predictedPrice?: string | null,
        propertyTax?: number | null,
        publishAddress?: boolean | null,
        surface?: number | null,
        type: UnitType,
        buildingId: string,
        unitAdvertisementId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      reversedInvoiceId?: string | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    invoiceId?: string | null,
    lease?:  {
      __typename: "Lease",
      id: string,
      advancedChargesInvoices?:  {
        __typename: "LeaseAdvancedChargesInvoice",
        communicationSettingsProfileId: string,
        invoiceSenderId: string,
        lastDraftInvoiceDate?: string | null,
        lastInvoiceDate?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        bankAccountId?: string | null,
      } | null,
      balance?: number | null,
      canBeExtended?: boolean | null,
      communicationSettingsProfileId: string,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      endDate: string,
      includeRealEstateInLeaseContract?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      invoiceSenderId: string,
      invoiceSender?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      inventoryOfFixturesExpert?: string | null,
      inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
      inventoryOfFixturesType?: InventoryOfFixturesType | null,
      ipiNumber?: string | null,
      language: Language,
      lastDraftInvoiceDate?: string | null,
      lastIndexationProcessDate?: string | null,
      lastInvoiceDate?: string | null,
      legalCompetentAuthority?: string | null,
      name: string,
      notes?: string | null,
      paymentFrequency: LeasePaymentFrequency,
      paymentInvoicePeriod: LeasePaymentInvoicePeriod,
      paymentInvoicePeriodCustomDay?: number | null,
      paymentOption?:  {
        __typename: "LeasePaymentOption",
        customerId?: string | null,
        enabled: boolean,
        mandateActivatedAt?: string | null,
        mandateStatus?: PaymentProviderMandateStatus | null,
        paymentMethodId?: string | null,
        qrType?: LeaseQrType | null,
      } | null,
      purchaseOrderNumber?: string | null,
      realEstateAgency?: string | null,
      realEstateTax?: number | null,
      remittanceInformation?: string | null,
      remittanceInformationType?: LeaseRemittanceType | null,
      rentalGuaranty?:  {
        __typename: "LeaseRentalGuaranty",
        amount: number,
        blockedAmount?: number | null,
        releasedAmount?: number | null,
        type: LeaseRentalGuarantyType,
        financialInstitution?: string | null,
      } | null,
      signatureDate?: string | null,
      startDate: string,
      nextIndexationMonth?: string | null,
      nextIndexation?: boolean | null,
      status: LeaseStatus,
      technicCommunicationSettingsProfileId: string,
      totalInitialRentalPrice: number,
      totalRentalPrice: number,
      type: LeaseType,
      subletting?: boolean | null,
      vatRateRentId?: string | null,
      vatRateRent?:  {
        __typename: "VatRate",
        id: string,
        country: string,
        label: string,
        value?: number | null,
        ownerId?: string | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      additionalClauses?:  {
        __typename: "ModelLeaseAdditionalClauseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      bankAccountId?: string | null,
      bankAccount?:  {
        __typename: "BankAccount",
        id: string,
        contactId: string,
        number: string,
        bicNumber?: string | null,
        bankName?: string | null,
        contactIds?: Array< string > | null,
        buildingIds?: Array< string > | null,
        holderName?: string | null,
        label?: string | null,
        disabled?: boolean | null,
        integrations?: Array< IntegrationName > | null,
        matchingRule?: BankAccountMatchingRule | null,
        balance?: number | null,
        balanceDate?: string | null,
        type: BankAccountType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contacts?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      files?:  {
        __typename: "ModelFileConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leaseActionHistories?:  {
        __typename: "ModelLeaseActionHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leasePriceHistories?:  {
        __typename: "ModelLeasePriceHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      signatureDocuments?:  {
        __typename: "ModelSignatureDocumentConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      variousOperations?:  {
        __typename: "ModelLeaseVariousOperationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    leaseId?: string | null,
    leasePriceHistoryId?: string | null,
    leasePriceHistory?:  {
      __typename: "LeasePriceHistory",
      id: string,
      previousTotalRentalPrice: number,
      totalRentalPrice: number,
      optimalTotalRentalPrice?: number | null,
      optimalTotalMonthlyCharges?: number | null,
      applicationDate: string,
      status: LeaseAmountUpdateStatus,
      comment?: string | null,
      amountDetails:  Array< {
        __typename: "LeasePriceHistoryDetail",
        unitId: string,
        indexationBaseIndex?: number | null,
        indexationNewIndex?: number | null,
        previousRentalPrice: number,
        newRentalPrice: number,
        rentalStatus: LeasePriceHistoryStatus,
        monthlyChargesStatus: LeasePriceHistoryStatus,
        optimalNewRentalPrice?: number | null,
        optimalNewMonthlyChargesPrice?: number | null,
        epb?: string | null,
        epbIssueDate?: string | null,
        oldestIndexForCorrectionFactorCalculation?: number | null,
        newestIndexForCorrectionFactorCalculation?: number | null,
        rentIndexedPriceAfterNewEpbReduction?: number | null,
        chargesIndexedPriceAfterNewEpbReduction?: number | null,
        correctionFactor?: number | null,
        reductionPercentage?: number | null,
        rentDifference?: number | null,
        rentReduction?: number | null,
        indexedRentAfterReduction?: number | null,
        chargesDifference?: number | null,
        chargesReduction?: number | null,
        indexedChargesAfterReduction?: number | null,
        previousYearIndexationNewIndex?: number | null,
        previousYearIndexedRent?: number | null,
        previousYearIndexedCharges?: number | null,
      } >,
      type: LeasePriceHistoryType,
      communicationId?: string | null,
      communication?:  {
        __typename: "Communication",
        id: string,
        addressId?: string | null,
        body: string,
        buildingId?: string | null,
        channel: CommunicationChannel,
        communicationTemplateId?: string | null,
        concernedContactIds?: Array< string > | null,
        contactId?: string | null,
        contactIds?: Array< string > | null,
        createdAt?: string | null,
        expirationDate?: string | null,
        invoiceId?: string | null,
        leaseId?: string | null,
        leasePriceHistoryId?: string | null,
        letterTrackingCode?: string | null,
        letterTrackingProvider?: TrackingProvider | null,
        linkedCommunicationsIds?: Array< string > | null,
        supportingDocumentFileIds?: Array< string > | null,
        recipient?: string | null,
        recipientContactIdsInBcc?: Array< string > | null,
        recipientContactIdsInCc?: Array< string > | null,
        recipientInBcc?: string | null,
        recipientInCc?: string | null,
        scheduledAt?: string | null,
        deliveredAt?: string | null,
        errorCode?: CommunicationErrorCode | null,
        nextRetryAt?: string | null,
        sendRetryCount?: number | null,
        sender?: string | null,
        sentAt?: string | null,
        externalId?: string | null,
        externalStatus?: string | null,
        signatureDocumentId?: string | null,
        snoozedDate?: string | null,
        statementId?: string | null,
        status: CommunicationStatus,
        subject: string,
        toSend: boolean,
        hideLogo?: boolean | null,
        type: CommunicationType,
        _ttl?: number | null,
        unitId?: string | null,
        readId: string,
        readers?: Array< string > | null,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      leaseId: string,
      lease?:  {
        __typename: "Lease",
        id: string,
        balance?: number | null,
        canBeExtended?: boolean | null,
        communicationSettingsProfileId: string,
        createdAt?: string | null,
        endDate: string,
        includeRealEstateInLeaseContract?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        invoiceSenderId: string,
        inventoryOfFixturesExpert?: string | null,
        inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
        inventoryOfFixturesType?: InventoryOfFixturesType | null,
        ipiNumber?: string | null,
        language: Language,
        lastDraftInvoiceDate?: string | null,
        lastIndexationProcessDate?: string | null,
        lastInvoiceDate?: string | null,
        legalCompetentAuthority?: string | null,
        name: string,
        notes?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        purchaseOrderNumber?: string | null,
        realEstateAgency?: string | null,
        realEstateTax?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        signatureDate?: string | null,
        startDate: string,
        nextIndexationMonth?: string | null,
        nextIndexation?: boolean | null,
        status: LeaseStatus,
        technicCommunicationSettingsProfileId: string,
        totalInitialRentalPrice: number,
        totalRentalPrice: number,
        type: LeaseType,
        subletting?: boolean | null,
        vatRateRentId?: string | null,
        bankAccountId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      createdAt?: string | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    letterTrackingCode?: string | null,
    letterTrackingProvider?: TrackingProvider | null,
    linkedCommunicationsIds?: Array< string > | null,
    supportingDocumentFileIds?: Array< string > | null,
    recipient?: string | null,
    recipientContactIdsInBcc?: Array< string > | null,
    recipientContactIdsInCc?: Array< string > | null,
    recipientInBcc?: string | null,
    recipientInCc?: string | null,
    scheduledAt?: string | null,
    deliveredAt?: string | null,
    errorCode?: CommunicationErrorCode | null,
    nextRetryAt?: string | null,
    sendRetryCount?: number | null,
    sender?: string | null,
    sentAt?: string | null,
    externalId?: string | null,
    externalStatus?: string | null,
    signatureDocumentId?: string | null,
    signatureDocument?:  {
      __typename: "SignatureDocument",
      id: string,
      additionalMessage?: string | null,
      automaticRemindersDisabled?: boolean | null,
      communicationBody?: string | null,
      createdAt?: string | null,
      expirationDate?: string | null,
      fileIds?: Array< string > | null,
      foreignKey: string,
      foreignTableName: string,
      sentAt?: string | null,
      signatureMethods: Array< SignatureType >,
      signatureResults:  Array< {
        __typename: "SignatureDocumentResult",
        openedDate?: string | null,
        signedDate?: string | null,
        signed?: boolean | null,
        signatureLink?: string | null,
        rejectReason?: string | null,
        lastSignInviteSentDate?: string | null,
        reminderDates?: Array< string > | null,
        trackingProvider?: TrackingProvider | null,
        trackingCode?: string | null,
        contactId: string,
      } >,
      status: SignatureDocumentStatus,
      externalStatus?: string | null,
      type: SignatureDocumentType,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    snoozedDate?: string | null,
    statement?:  {
      __typename: "Statement",
      id: string,
      amounts?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      chargeStatements?:  {
        __typename: "ModelChargeStatementConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      closingStatement: boolean,
      periodFrom: string,
      periodTo: string,
      attachSupportingDocuments?: boolean | null,
      selectedPocketKeys?: Array< string > | null,
      source: StatementSource,
      status: StatementStatus,
      sentDate?: string | null,
      leaseId?: string | null,
      lease?:  {
        __typename: "Lease",
        id: string,
        balance?: number | null,
        canBeExtended?: boolean | null,
        communicationSettingsProfileId: string,
        createdAt?: string | null,
        endDate: string,
        includeRealEstateInLeaseContract?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        invoiceSenderId: string,
        inventoryOfFixturesExpert?: string | null,
        inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
        inventoryOfFixturesType?: InventoryOfFixturesType | null,
        ipiNumber?: string | null,
        language: Language,
        lastDraftInvoiceDate?: string | null,
        lastIndexationProcessDate?: string | null,
        lastInvoiceDate?: string | null,
        legalCompetentAuthority?: string | null,
        name: string,
        notes?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        purchaseOrderNumber?: string | null,
        realEstateAgency?: string | null,
        realEstateTax?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        signatureDate?: string | null,
        startDate: string,
        nextIndexationMonth?: string | null,
        nextIndexation?: boolean | null,
        status: LeaseStatus,
        technicCommunicationSettingsProfileId: string,
        totalInitialRentalPrice: number,
        totalRentalPrice: number,
        type: LeaseType,
        subletting?: boolean | null,
        vatRateRentId?: string | null,
        bankAccountId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      agencyRateStatements?:  {
        __typename: "ModelAgencyRateStatementConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      ownerId?: string | null,
      owner?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      repaymentStatements?:  {
        __typename: "ModelRepaymentStatementConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      types?: Array< StatementType > | null,
      viewType: StatementViewType,
      unitIds?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    statementId?: string | null,
    status: CommunicationStatus,
    subject: string,
    toSend: boolean,
    hideLogo?: boolean | null,
    type: CommunicationType,
    _ttl?: number | null,
    unit?:  {
      __typename: "Unit",
      id: string,
      acquisitionAdditionalCostsValue?: number | null,
      acquisitionAdvertisedValue?: number | null,
      acquisitionValue?: number | null,
      advertisedMonthlyCharges?: number | null,
      advertisedRentalPrice?: number | null,
      cadastralIncome?: number | null,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      floor?: number | null,
      jointOwnershipId?: string | null,
      managementDate: string,
      name: string,
      notes?: string | null,
      predictedPrice?: string | null,
      propertyTax?: number | null,
      publishAddress?: boolean | null,
      surface?: number | null,
      type: UnitType,
      buildingId: string,
      building?:  {
        __typename: "Building",
        id: string,
        name: string,
        addressId?: string | null,
        acquisitionValue?: number | null,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        amountOfFacades?: number | null,
        amountOfFloors?: number | null,
        amountOfHousings?: number | null,
        buildingState?: BuildingState | null,
        cadastralIncome?: number | null,
        constructionYear?: string | null,
        janitor?: boolean | null,
        jointOwnershipId?: string | null,
        notes?: string | null,
        propertyTax?: number | null,
        residenceName?: string | null,
        buildingSiteId?: string | null,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      owners?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leases?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      events?:  {
        __typename: "ModelUnitEventConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      unitAdvertisementId?: string | null,
      unitInventories?:  {
        __typename: "ModelUnitInventoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    unitId?: string | null,
    readId: string,
    readers?: Array< string > | null,
    clientId: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateCommunicationSettingsProfileMutationVariables = {
  input: CreateCommunicationSettingsProfileInput,
  condition?: ModelCommunicationSettingsProfileConditionInput | null,
};

export type CreateCommunicationSettingsProfileMutation = {
  createCommunicationSettingsProfile?:  {
    __typename: "CommunicationSettingsProfile",
    id: string,
    communicationsSettings:  Array< {
      __typename: "CommunicationSettings",
      channels: Array< CommunicationChannel >,
      communicationType: CommunicationType,
      daysBeforeDueDate?: number | null,
      daysOverdue?: number | null,
      frequency?:  {
        __typename: "CommunicationFrequencySetting",
        dateFrom?: CommunicationFrequencySettingPeriodDateFrom | null,
        periodInterval: number,
        periodType: CommunicationFrequencySettingPeriodType,
      } | null,
      invoiceDaysAfterPeriodStart?: number | null,
      sendingRule: CommunicationSendingRule,
      recipients: Array< CommunicationSettingRecipient >,
      recipientsInBcc: Array< CommunicationSettingRecipient >,
      recipientsInCopy: Array< string >,
      displayOpenBalance?: boolean | null,
    } >,
    createdAt?: string | null,
    defaultName?: string | null,
    isDefaultSetting: boolean,
    referent: CommunicationSettingsProfileReferent,
    replacementId?: string | null,
    displayLogo: boolean,
    tenantStatementView: StatementViewType,
    readId: string,
    readers?: Array< string > | null,
    clientId: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateCommunicationSettingsProfileMutationVariables = {
  input: UpdateCommunicationSettingsProfileInput,
  condition?: ModelCommunicationSettingsProfileConditionInput | null,
};

export type UpdateCommunicationSettingsProfileMutation = {
  updateCommunicationSettingsProfile?:  {
    __typename: "CommunicationSettingsProfile",
    id: string,
    communicationsSettings:  Array< {
      __typename: "CommunicationSettings",
      channels: Array< CommunicationChannel >,
      communicationType: CommunicationType,
      daysBeforeDueDate?: number | null,
      daysOverdue?: number | null,
      frequency?:  {
        __typename: "CommunicationFrequencySetting",
        dateFrom?: CommunicationFrequencySettingPeriodDateFrom | null,
        periodInterval: number,
        periodType: CommunicationFrequencySettingPeriodType,
      } | null,
      invoiceDaysAfterPeriodStart?: number | null,
      sendingRule: CommunicationSendingRule,
      recipients: Array< CommunicationSettingRecipient >,
      recipientsInBcc: Array< CommunicationSettingRecipient >,
      recipientsInCopy: Array< string >,
      displayOpenBalance?: boolean | null,
    } >,
    createdAt?: string | null,
    defaultName?: string | null,
    isDefaultSetting: boolean,
    referent: CommunicationSettingsProfileReferent,
    replacementId?: string | null,
    displayLogo: boolean,
    tenantStatementView: StatementViewType,
    readId: string,
    readers?: Array< string > | null,
    clientId: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteCommunicationSettingsProfileMutationVariables = {
  input: DeleteCommunicationSettingsProfileInput,
  condition?: ModelCommunicationSettingsProfileConditionInput | null,
};

export type DeleteCommunicationSettingsProfileMutation = {
  deleteCommunicationSettingsProfile?:  {
    __typename: "CommunicationSettingsProfile",
    id: string,
    communicationsSettings:  Array< {
      __typename: "CommunicationSettings",
      channels: Array< CommunicationChannel >,
      communicationType: CommunicationType,
      daysBeforeDueDate?: number | null,
      daysOverdue?: number | null,
      frequency?:  {
        __typename: "CommunicationFrequencySetting",
        dateFrom?: CommunicationFrequencySettingPeriodDateFrom | null,
        periodInterval: number,
        periodType: CommunicationFrequencySettingPeriodType,
      } | null,
      invoiceDaysAfterPeriodStart?: number | null,
      sendingRule: CommunicationSendingRule,
      recipients: Array< CommunicationSettingRecipient >,
      recipientsInBcc: Array< CommunicationSettingRecipient >,
      recipientsInCopy: Array< string >,
      displayOpenBalance?: boolean | null,
    } >,
    createdAt?: string | null,
    defaultName?: string | null,
    isDefaultSetting: boolean,
    referent: CommunicationSettingsProfileReferent,
    replacementId?: string | null,
    displayLogo: boolean,
    tenantStatementView: StatementViewType,
    readId: string,
    readers?: Array< string > | null,
    clientId: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateTemplateMutationVariables = {
  input: CreateTemplateInput,
  condition?: ModelTemplateConditionInput | null,
};

export type CreateTemplateMutation = {
  createTemplate?:  {
    __typename: "Template",
    id: string,
    language: string,
    name?: string | null,
    subject?: string | null,
    subjectRawFormat?: string | null,
    body: string,
    bodyRawFormat?: string | null,
    type: TemplateType,
    subType: TemplateSubType,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateTemplateMutationVariables = {
  input: UpdateTemplateInput,
  condition?: ModelTemplateConditionInput | null,
};

export type UpdateTemplateMutation = {
  updateTemplate?:  {
    __typename: "Template",
    id: string,
    language: string,
    name?: string | null,
    subject?: string | null,
    subjectRawFormat?: string | null,
    body: string,
    bodyRawFormat?: string | null,
    type: TemplateType,
    subType: TemplateSubType,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteTemplateMutationVariables = {
  input: DeleteTemplateInput,
  condition?: ModelTemplateConditionInput | null,
};

export type DeleteTemplateMutation = {
  deleteTemplate?:  {
    __typename: "Template",
    id: string,
    language: string,
    name?: string | null,
    subject?: string | null,
    subjectRawFormat?: string | null,
    body: string,
    bodyRawFormat?: string | null,
    type: TemplateType,
    subType: TemplateSubType,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateContactMutationVariables = {
  input: CreateContactInput,
  condition?: ModelContactConditionInput | null,
};

export type CreateContactMutation = {
  createContact?:  {
    __typename: "Contact",
    id: string,
    createdAt?: string | null,
    firstName?: string | null,
    lastName?: string | null,
    companyName?: string | null,
    commercialName?: string | null,
    communicationSettingsProfileId?: string | null,
    customValues?:  Array< {
      __typename: "CustomValue",
      name: string,
      value: string,
    } > | null,
    businessNumber?: string | null,
    types: Array< ContactType >,
    vat?: string | null,
    emails?:  Array< {
      __typename: "Email",
      address: string,
      isPrimary: boolean,
      label?: string | null,
    } > | null,
    email?: string | null,
    birthDate?: string | null,
    birthPlace?: string | null,
    nationalRegister?: string | null,
    ipiNumber?: string | null,
    insuranceCompany?: string | null,
    insuranceContractNumber?: string | null,
    judicialDistrict?: string | null,
    civility?: CivilityType | null,
    addressId?: string | null,
    address?:  {
      __typename: "Address",
      id: string,
      status?: AddressStatus | null,
      street: string,
      number?: string | null,
      box?: string | null,
      postalCode?: string | null,
      city?: string | null,
      region?: string | null,
      country?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      latitude?: number | null,
      longitude?: number | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    phoneNumbers?:  Array< {
      __typename: "PhoneNumber",
      countryCode: string,
      isPrimary: boolean,
      label?: string | null,
      number: string,
    } > | null,
    language?: string | null,
    notes?: string | null,
    profileType: ContactProfileType,
    jointOwners?:  Array< {
      __typename: "JointOwner",
      contactId: string,
      contactPerson?: boolean | null,
    } > | null,
    hoaFunds?:  Array< {
      __typename: "ContactHoaFund",
      archivedAt?: string | null,
      id: string,
      kind: HoaFundKind,
      name: string,
    } > | null,
    agencyRateDisabled?: boolean | null,
    attachStatementSupportingDocuments?: boolean | null,
    status?: ContactStatus | null,
    leases?:  {
      __typename: "ModelLeaseContactConnection",
      items:  Array< {
        __typename: "LeaseContact",
        id: string,
        leaseId: string,
        contactId: string,
        contactRole: ContactType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    buildings?:  {
      __typename: "ModelBuildingOwnerConnection",
      items:  Array< {
        __typename: "BuildingOwner",
        id: string,
        buildingId: string,
        contactId: string,
        disabled?: boolean | null,
        periodFrom?: string | null,
        periodTo?: string | null,
        stake: number,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    units?:  {
      __typename: "ModelUnitOwnerConnection",
      items:  Array< {
        __typename: "UnitOwner",
        id: string,
        disabled?: boolean | null,
        ownerId: string,
        periodFrom?: string | null,
        periodTo?: string | null,
        stake: number,
        unitId: string,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    sendInvitation: boolean,
    peppolProperties?:  {
      __typename: "ContactPeppolProperties",
      isRegistered: boolean,
      mustSend: boolean,
    } | null,
    integrations?:  {
      __typename: "ContactIntegrations",
      paymentProperties?:  {
        __typename: "PaymentProviderProperties",
        accountId: string,
      } | null,
    } | null,
    readers?: Array< string > | null,
    readId: string,
    clientId: string,
    sourceEntityRelations?:  {
      __typename: "ModelEntityRelationConnection",
      items:  Array< {
        __typename: "EntityRelation",
        id: string,
        sourceId: string,
        sourceTableName: string,
        foreignId: string,
        foreignTableName: string,
        linkDescription?: string | null,
        clientId: string,
        readers?: Array< string > | null,
        readId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    foreignEntityRelations?:  {
      __typename: "ModelEntityRelationConnection",
      items:  Array< {
        __typename: "EntityRelation",
        id: string,
        sourceId: string,
        sourceTableName: string,
        foreignId: string,
        foreignTableName: string,
        linkDescription?: string | null,
        clientId: string,
        readers?: Array< string > | null,
        readId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateContactMutationVariables = {
  input: UpdateContactInput,
  condition?: ModelContactConditionInput | null,
};

export type UpdateContactMutation = {
  updateContact?:  {
    __typename: "Contact",
    id: string,
    createdAt?: string | null,
    firstName?: string | null,
    lastName?: string | null,
    companyName?: string | null,
    commercialName?: string | null,
    communicationSettingsProfileId?: string | null,
    customValues?:  Array< {
      __typename: "CustomValue",
      name: string,
      value: string,
    } > | null,
    businessNumber?: string | null,
    types: Array< ContactType >,
    vat?: string | null,
    emails?:  Array< {
      __typename: "Email",
      address: string,
      isPrimary: boolean,
      label?: string | null,
    } > | null,
    email?: string | null,
    birthDate?: string | null,
    birthPlace?: string | null,
    nationalRegister?: string | null,
    ipiNumber?: string | null,
    insuranceCompany?: string | null,
    insuranceContractNumber?: string | null,
    judicialDistrict?: string | null,
    civility?: CivilityType | null,
    addressId?: string | null,
    address?:  {
      __typename: "Address",
      id: string,
      status?: AddressStatus | null,
      street: string,
      number?: string | null,
      box?: string | null,
      postalCode?: string | null,
      city?: string | null,
      region?: string | null,
      country?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      latitude?: number | null,
      longitude?: number | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    phoneNumbers?:  Array< {
      __typename: "PhoneNumber",
      countryCode: string,
      isPrimary: boolean,
      label?: string | null,
      number: string,
    } > | null,
    language?: string | null,
    notes?: string | null,
    profileType: ContactProfileType,
    jointOwners?:  Array< {
      __typename: "JointOwner",
      contactId: string,
      contactPerson?: boolean | null,
    } > | null,
    hoaFunds?:  Array< {
      __typename: "ContactHoaFund",
      archivedAt?: string | null,
      id: string,
      kind: HoaFundKind,
      name: string,
    } > | null,
    agencyRateDisabled?: boolean | null,
    attachStatementSupportingDocuments?: boolean | null,
    status?: ContactStatus | null,
    leases?:  {
      __typename: "ModelLeaseContactConnection",
      items:  Array< {
        __typename: "LeaseContact",
        id: string,
        leaseId: string,
        contactId: string,
        contactRole: ContactType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    buildings?:  {
      __typename: "ModelBuildingOwnerConnection",
      items:  Array< {
        __typename: "BuildingOwner",
        id: string,
        buildingId: string,
        contactId: string,
        disabled?: boolean | null,
        periodFrom?: string | null,
        periodTo?: string | null,
        stake: number,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    units?:  {
      __typename: "ModelUnitOwnerConnection",
      items:  Array< {
        __typename: "UnitOwner",
        id: string,
        disabled?: boolean | null,
        ownerId: string,
        periodFrom?: string | null,
        periodTo?: string | null,
        stake: number,
        unitId: string,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    sendInvitation: boolean,
    peppolProperties?:  {
      __typename: "ContactPeppolProperties",
      isRegistered: boolean,
      mustSend: boolean,
    } | null,
    integrations?:  {
      __typename: "ContactIntegrations",
      paymentProperties?:  {
        __typename: "PaymentProviderProperties",
        accountId: string,
      } | null,
    } | null,
    readers?: Array< string > | null,
    readId: string,
    clientId: string,
    sourceEntityRelations?:  {
      __typename: "ModelEntityRelationConnection",
      items:  Array< {
        __typename: "EntityRelation",
        id: string,
        sourceId: string,
        sourceTableName: string,
        foreignId: string,
        foreignTableName: string,
        linkDescription?: string | null,
        clientId: string,
        readers?: Array< string > | null,
        readId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    foreignEntityRelations?:  {
      __typename: "ModelEntityRelationConnection",
      items:  Array< {
        __typename: "EntityRelation",
        id: string,
        sourceId: string,
        sourceTableName: string,
        foreignId: string,
        foreignTableName: string,
        linkDescription?: string | null,
        clientId: string,
        readers?: Array< string > | null,
        readId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteContactMutationVariables = {
  input: DeleteContactInput,
  condition?: ModelContactConditionInput | null,
};

export type DeleteContactMutation = {
  deleteContact?:  {
    __typename: "Contact",
    id: string,
    createdAt?: string | null,
    firstName?: string | null,
    lastName?: string | null,
    companyName?: string | null,
    commercialName?: string | null,
    communicationSettingsProfileId?: string | null,
    customValues?:  Array< {
      __typename: "CustomValue",
      name: string,
      value: string,
    } > | null,
    businessNumber?: string | null,
    types: Array< ContactType >,
    vat?: string | null,
    emails?:  Array< {
      __typename: "Email",
      address: string,
      isPrimary: boolean,
      label?: string | null,
    } > | null,
    email?: string | null,
    birthDate?: string | null,
    birthPlace?: string | null,
    nationalRegister?: string | null,
    ipiNumber?: string | null,
    insuranceCompany?: string | null,
    insuranceContractNumber?: string | null,
    judicialDistrict?: string | null,
    civility?: CivilityType | null,
    addressId?: string | null,
    address?:  {
      __typename: "Address",
      id: string,
      status?: AddressStatus | null,
      street: string,
      number?: string | null,
      box?: string | null,
      postalCode?: string | null,
      city?: string | null,
      region?: string | null,
      country?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      latitude?: number | null,
      longitude?: number | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    phoneNumbers?:  Array< {
      __typename: "PhoneNumber",
      countryCode: string,
      isPrimary: boolean,
      label?: string | null,
      number: string,
    } > | null,
    language?: string | null,
    notes?: string | null,
    profileType: ContactProfileType,
    jointOwners?:  Array< {
      __typename: "JointOwner",
      contactId: string,
      contactPerson?: boolean | null,
    } > | null,
    hoaFunds?:  Array< {
      __typename: "ContactHoaFund",
      archivedAt?: string | null,
      id: string,
      kind: HoaFundKind,
      name: string,
    } > | null,
    agencyRateDisabled?: boolean | null,
    attachStatementSupportingDocuments?: boolean | null,
    status?: ContactStatus | null,
    leases?:  {
      __typename: "ModelLeaseContactConnection",
      items:  Array< {
        __typename: "LeaseContact",
        id: string,
        leaseId: string,
        contactId: string,
        contactRole: ContactType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    buildings?:  {
      __typename: "ModelBuildingOwnerConnection",
      items:  Array< {
        __typename: "BuildingOwner",
        id: string,
        buildingId: string,
        contactId: string,
        disabled?: boolean | null,
        periodFrom?: string | null,
        periodTo?: string | null,
        stake: number,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    units?:  {
      __typename: "ModelUnitOwnerConnection",
      items:  Array< {
        __typename: "UnitOwner",
        id: string,
        disabled?: boolean | null,
        ownerId: string,
        periodFrom?: string | null,
        periodTo?: string | null,
        stake: number,
        unitId: string,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    sendInvitation: boolean,
    peppolProperties?:  {
      __typename: "ContactPeppolProperties",
      isRegistered: boolean,
      mustSend: boolean,
    } | null,
    integrations?:  {
      __typename: "ContactIntegrations",
      paymentProperties?:  {
        __typename: "PaymentProviderProperties",
        accountId: string,
      } | null,
    } | null,
    readers?: Array< string > | null,
    readId: string,
    clientId: string,
    sourceEntityRelations?:  {
      __typename: "ModelEntityRelationConnection",
      items:  Array< {
        __typename: "EntityRelation",
        id: string,
        sourceId: string,
        sourceTableName: string,
        foreignId: string,
        foreignTableName: string,
        linkDescription?: string | null,
        clientId: string,
        readers?: Array< string > | null,
        readId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    foreignEntityRelations?:  {
      __typename: "ModelEntityRelationConnection",
      items:  Array< {
        __typename: "EntityRelation",
        id: string,
        sourceId: string,
        sourceTableName: string,
        foreignId: string,
        foreignTableName: string,
        linkDescription?: string | null,
        clientId: string,
        readers?: Array< string > | null,
        readId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateAddressMutationVariables = {
  input: CreateAddressInput,
  condition?: ModelAddressConditionInput | null,
};

export type CreateAddressMutation = {
  createAddress?:  {
    __typename: "Address",
    id: string,
    status?: AddressStatus | null,
    street: string,
    number?: string | null,
    box?: string | null,
    postalCode?: string | null,
    city?: string | null,
    region?: string | null,
    country?: string | null,
    customValues?:  Array< {
      __typename: "CustomValue",
      name: string,
      value: string,
    } > | null,
    latitude?: number | null,
    longitude?: number | null,
    readers?: Array< string > | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateAddressMutationVariables = {
  input: UpdateAddressInput,
  condition?: ModelAddressConditionInput | null,
};

export type UpdateAddressMutation = {
  updateAddress?:  {
    __typename: "Address",
    id: string,
    status?: AddressStatus | null,
    street: string,
    number?: string | null,
    box?: string | null,
    postalCode?: string | null,
    city?: string | null,
    region?: string | null,
    country?: string | null,
    customValues?:  Array< {
      __typename: "CustomValue",
      name: string,
      value: string,
    } > | null,
    latitude?: number | null,
    longitude?: number | null,
    readers?: Array< string > | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteAddressMutationVariables = {
  input: DeleteAddressInput,
  condition?: ModelAddressConditionInput | null,
};

export type DeleteAddressMutation = {
  deleteAddress?:  {
    __typename: "Address",
    id: string,
    status?: AddressStatus | null,
    street: string,
    number?: string | null,
    box?: string | null,
    postalCode?: string | null,
    city?: string | null,
    region?: string | null,
    country?: string | null,
    customValues?:  Array< {
      __typename: "CustomValue",
      name: string,
      value: string,
    } > | null,
    latitude?: number | null,
    longitude?: number | null,
    readers?: Array< string > | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateCustomFieldMutationVariables = {
  input: CreateCustomFieldInput,
  condition?: ModelCustomFieldConditionInput | null,
};

export type CreateCustomFieldMutation = {
  createCustomField?:  {
    __typename: "CustomField",
    id: string,
    fieldName: string,
    fieldType: CustomFieldType,
    foreignKey: string,
    foreignTableName: string,
    labels:  Array< {
      __typename: "CustomLabel",
      language: string,
      label: string,
    } >,
    customFieldProperties?:  {
      __typename: "CustomFieldProperties",
      isRequired?: boolean | null,
      isDefault?: boolean | null,
      defaultValue?: string | null,
      options?:  Array< {
        __typename: "CustomFieldOption",
        id: string,
      } > | null,
    } | null,
    order?: number | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateCustomFieldMutationVariables = {
  input: UpdateCustomFieldInput,
  condition?: ModelCustomFieldConditionInput | null,
};

export type UpdateCustomFieldMutation = {
  updateCustomField?:  {
    __typename: "CustomField",
    id: string,
    fieldName: string,
    fieldType: CustomFieldType,
    foreignKey: string,
    foreignTableName: string,
    labels:  Array< {
      __typename: "CustomLabel",
      language: string,
      label: string,
    } >,
    customFieldProperties?:  {
      __typename: "CustomFieldProperties",
      isRequired?: boolean | null,
      isDefault?: boolean | null,
      defaultValue?: string | null,
      options?:  Array< {
        __typename: "CustomFieldOption",
        id: string,
      } > | null,
    } | null,
    order?: number | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteCustomFieldMutationVariables = {
  input: DeleteCustomFieldInput,
  condition?: ModelCustomFieldConditionInput | null,
};

export type DeleteCustomFieldMutation = {
  deleteCustomField?:  {
    __typename: "CustomField",
    id: string,
    fieldName: string,
    fieldType: CustomFieldType,
    foreignKey: string,
    foreignTableName: string,
    labels:  Array< {
      __typename: "CustomLabel",
      language: string,
      label: string,
    } >,
    customFieldProperties?:  {
      __typename: "CustomFieldProperties",
      isRequired?: boolean | null,
      isDefault?: boolean | null,
      defaultValue?: string | null,
      options?:  Array< {
        __typename: "CustomFieldOption",
        id: string,
      } > | null,
    } | null,
    order?: number | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteCustomFieldDeepInput = {
  id: string,
};

export type DeleteCustomFieldDeepMutationVariables = {
  input: DeleteCustomFieldDeepInput,
};

export type DeleteCustomFieldDeepMutation = {
  deleteCustomFieldDeep?:  {
    __typename: "MutationStatus",
    status?: boolean | null,
    id: string,
  } | null,
};

export type CreateCustomSubscriptionMutationVariables = {
  input: CreateCustomSubscriptionInput,
  condition?: ModelCustomSubscriptionConditionInput | null,
};

export type CreateCustomSubscriptionMutation = {
  createCustomSubscription?:  {
    __typename: "CustomSubscription",
    id: string,
    name: CustomSubscriptionType,
    value: string,
    createdAt?: string | null,
    userId?: string | null,
    _ttl: number,
    updatedAt: string,
    clientId: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateCustomSubscriptionMutationVariables = {
  input: UpdateCustomSubscriptionInput,
  condition?: ModelCustomSubscriptionConditionInput | null,
};

export type UpdateCustomSubscriptionMutation = {
  updateCustomSubscription?:  {
    __typename: "CustomSubscription",
    id: string,
    name: CustomSubscriptionType,
    value: string,
    createdAt?: string | null,
    userId?: string | null,
    _ttl: number,
    updatedAt: string,
    clientId: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteCustomSubscriptionMutationVariables = {
  input: DeleteCustomSubscriptionInput,
  condition?: ModelCustomSubscriptionConditionInput | null,
};

export type DeleteCustomSubscriptionMutation = {
  deleteCustomSubscription?:  {
    __typename: "CustomSubscription",
    id: string,
    name: CustomSubscriptionType,
    value: string,
    createdAt?: string | null,
    userId?: string | null,
    _ttl: number,
    updatedAt: string,
    clientId: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateEntityRelationMutationVariables = {
  input: CreateEntityRelationInput,
  condition?: ModelEntityRelationConditionInput | null,
};

export type CreateEntityRelationMutation = {
  createEntityRelation?:  {
    __typename: "EntityRelation",
    id: string,
    sourceId: string,
    sourceTableName: string,
    foreignId: string,
    foreignTableName: string,
    linkDescription?: string | null,
    linkProperties?:  {
      __typename: "RelationLinkProperties",
      contact?:  {
        __typename: "ContactRelationLinkProperties",
        communicationSubscriptions?: Array< ContactCommunicationSubscriptionTypes > | null,
      } | null,
    } | null,
    clientId: string,
    readers?: Array< string > | null,
    readId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateEntityRelationMutationVariables = {
  input: UpdateEntityRelationInput,
  condition?: ModelEntityRelationConditionInput | null,
};

export type UpdateEntityRelationMutation = {
  updateEntityRelation?:  {
    __typename: "EntityRelation",
    id: string,
    sourceId: string,
    sourceTableName: string,
    foreignId: string,
    foreignTableName: string,
    linkDescription?: string | null,
    linkProperties?:  {
      __typename: "RelationLinkProperties",
      contact?:  {
        __typename: "ContactRelationLinkProperties",
        communicationSubscriptions?: Array< ContactCommunicationSubscriptionTypes > | null,
      } | null,
    } | null,
    clientId: string,
    readers?: Array< string > | null,
    readId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteEntityRelationMutationVariables = {
  input: DeleteEntityRelationInput,
  condition?: ModelEntityRelationConditionInput | null,
};

export type DeleteEntityRelationMutation = {
  deleteEntityRelation?:  {
    __typename: "EntityRelation",
    id: string,
    sourceId: string,
    sourceTableName: string,
    foreignId: string,
    foreignTableName: string,
    linkDescription?: string | null,
    linkProperties?:  {
      __typename: "RelationLinkProperties",
      contact?:  {
        __typename: "ContactRelationLinkProperties",
        communicationSubscriptions?: Array< ContactCommunicationSubscriptionTypes > | null,
      } | null,
    } | null,
    clientId: string,
    readers?: Array< string > | null,
    readId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateFileMutationVariables = {
  input: CreateFileInput,
  condition?: ModelFileConditionInput | null,
};

export type CreateFileMutation = {
  createFile?:  {
    __typename: "File",
    id: string,
    bucket: string,
    createdAt?: string | null,
    category?:  {
      __typename: "DocumentCategory",
      id: string,
      entity?: string | null,
      fileCategory: FileCategory,
      labels:  Array< {
        __typename: "CustomLabel",
        language: string,
        label: string,
      } >,
      parentId?: string | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    categoryId: string,
    foreignKey: string,
    foreignTableName: string,
    key: string,
    mimeType?: string | null,
    region: string,
    signaturePositions?:  Array< {
      __typename: "SignaturePosition",
      top: number,
      left: number,
      page: number,
      width?: number | null,
      height?: number | null,
      contactId: string,
    } > | null,
    size?: number | null,
    readers?: Array< string > | null,
    readId: string,
    clientId: string,
    _ttl?: number | null,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateFileMutationVariables = {
  input: UpdateFileInput,
  condition?: ModelFileConditionInput | null,
};

export type UpdateFileMutation = {
  updateFile?:  {
    __typename: "File",
    id: string,
    bucket: string,
    createdAt?: string | null,
    category?:  {
      __typename: "DocumentCategory",
      id: string,
      entity?: string | null,
      fileCategory: FileCategory,
      labels:  Array< {
        __typename: "CustomLabel",
        language: string,
        label: string,
      } >,
      parentId?: string | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    categoryId: string,
    foreignKey: string,
    foreignTableName: string,
    key: string,
    mimeType?: string | null,
    region: string,
    signaturePositions?:  Array< {
      __typename: "SignaturePosition",
      top: number,
      left: number,
      page: number,
      width?: number | null,
      height?: number | null,
      contactId: string,
    } > | null,
    size?: number | null,
    readers?: Array< string > | null,
    readId: string,
    clientId: string,
    _ttl?: number | null,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteFileMutationVariables = {
  input: DeleteFileInput,
  condition?: ModelFileConditionInput | null,
};

export type DeleteFileMutation = {
  deleteFile?:  {
    __typename: "File",
    id: string,
    bucket: string,
    createdAt?: string | null,
    category?:  {
      __typename: "DocumentCategory",
      id: string,
      entity?: string | null,
      fileCategory: FileCategory,
      labels:  Array< {
        __typename: "CustomLabel",
        language: string,
        label: string,
      } >,
      parentId?: string | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    categoryId: string,
    foreignKey: string,
    foreignTableName: string,
    key: string,
    mimeType?: string | null,
    region: string,
    signaturePositions?:  Array< {
      __typename: "SignaturePosition",
      top: number,
      left: number,
      page: number,
      width?: number | null,
      height?: number | null,
      contactId: string,
    } > | null,
    size?: number | null,
    readers?: Array< string > | null,
    readId: string,
    clientId: string,
    _ttl?: number | null,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateDocumentCategoryMutationVariables = {
  input: CreateDocumentCategoryInput,
  condition?: ModelDocumentCategoryConditionInput | null,
};

export type CreateDocumentCategoryMutation = {
  createDocumentCategory?:  {
    __typename: "DocumentCategory",
    id: string,
    entity?: string | null,
    fileCategory: FileCategory,
    labels:  Array< {
      __typename: "CustomLabel",
      language: string,
      label: string,
    } >,
    parentId?: string | null,
    readers?: Array< string > | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateDocumentCategoryMutationVariables = {
  input: UpdateDocumentCategoryInput,
  condition?: ModelDocumentCategoryConditionInput | null,
};

export type UpdateDocumentCategoryMutation = {
  updateDocumentCategory?:  {
    __typename: "DocumentCategory",
    id: string,
    entity?: string | null,
    fileCategory: FileCategory,
    labels:  Array< {
      __typename: "CustomLabel",
      language: string,
      label: string,
    } >,
    parentId?: string | null,
    readers?: Array< string > | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteDocumentCategoryMutationVariables = {
  input: DeleteDocumentCategoryInput,
  condition?: ModelDocumentCategoryConditionInput | null,
};

export type DeleteDocumentCategoryMutation = {
  deleteDocumentCategory?:  {
    __typename: "DocumentCategory",
    id: string,
    entity?: string | null,
    fileCategory: FileCategory,
    labels:  Array< {
      __typename: "CustomLabel",
      language: string,
      label: string,
    } >,
    parentId?: string | null,
    readers?: Array< string > | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateSignatureDocumentMutationVariables = {
  input: CreateSignatureDocumentInput,
  condition?: ModelSignatureDocumentConditionInput | null,
};

export type CreateSignatureDocumentMutation = {
  createSignatureDocument?:  {
    __typename: "SignatureDocument",
    id: string,
    additionalMessage?: string | null,
    automaticRemindersDisabled?: boolean | null,
    communicationBody?: string | null,
    createdAt?: string | null,
    expirationDate?: string | null,
    fileIds?: Array< string > | null,
    foreignKey: string,
    foreignTableName: string,
    sentAt?: string | null,
    signatureMethods: Array< SignatureType >,
    signatureResults:  Array< {
      __typename: "SignatureDocumentResult",
      openedDate?: string | null,
      signedDate?: string | null,
      signed?: boolean | null,
      signatureLink?: string | null,
      rejectReason?: string | null,
      lastSignInviteSentDate?: string | null,
      reminderDates?: Array< string > | null,
      trackingProvider?: TrackingProvider | null,
      trackingCode?: string | null,
      contactId: string,
    } >,
    status: SignatureDocumentStatus,
    externalStatus?: string | null,
    type: SignatureDocumentType,
    readers?: Array< string > | null,
    readId: string,
    clientId: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateSignatureDocumentMutationVariables = {
  input: UpdateSignatureDocumentInput,
  condition?: ModelSignatureDocumentConditionInput | null,
};

export type UpdateSignatureDocumentMutation = {
  updateSignatureDocument?:  {
    __typename: "SignatureDocument",
    id: string,
    additionalMessage?: string | null,
    automaticRemindersDisabled?: boolean | null,
    communicationBody?: string | null,
    createdAt?: string | null,
    expirationDate?: string | null,
    fileIds?: Array< string > | null,
    foreignKey: string,
    foreignTableName: string,
    sentAt?: string | null,
    signatureMethods: Array< SignatureType >,
    signatureResults:  Array< {
      __typename: "SignatureDocumentResult",
      openedDate?: string | null,
      signedDate?: string | null,
      signed?: boolean | null,
      signatureLink?: string | null,
      rejectReason?: string | null,
      lastSignInviteSentDate?: string | null,
      reminderDates?: Array< string > | null,
      trackingProvider?: TrackingProvider | null,
      trackingCode?: string | null,
      contactId: string,
    } >,
    status: SignatureDocumentStatus,
    externalStatus?: string | null,
    type: SignatureDocumentType,
    readers?: Array< string > | null,
    readId: string,
    clientId: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteSignatureDocumentMutationVariables = {
  input: DeleteSignatureDocumentInput,
  condition?: ModelSignatureDocumentConditionInput | null,
};

export type DeleteSignatureDocumentMutation = {
  deleteSignatureDocument?:  {
    __typename: "SignatureDocument",
    id: string,
    additionalMessage?: string | null,
    automaticRemindersDisabled?: boolean | null,
    communicationBody?: string | null,
    createdAt?: string | null,
    expirationDate?: string | null,
    fileIds?: Array< string > | null,
    foreignKey: string,
    foreignTableName: string,
    sentAt?: string | null,
    signatureMethods: Array< SignatureType >,
    signatureResults:  Array< {
      __typename: "SignatureDocumentResult",
      openedDate?: string | null,
      signedDate?: string | null,
      signed?: boolean | null,
      signatureLink?: string | null,
      rejectReason?: string | null,
      lastSignInviteSentDate?: string | null,
      reminderDates?: Array< string > | null,
      trackingProvider?: TrackingProvider | null,
      trackingCode?: string | null,
      contactId: string,
    } >,
    status: SignatureDocumentStatus,
    externalStatus?: string | null,
    type: SignatureDocumentType,
    readers?: Array< string > | null,
    readId: string,
    clientId: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateFilterGroupMutationVariables = {
  input: CreateFilterGroupInput,
  condition?: ModelFilterGroupConditionInput | null,
};

export type CreateFilterGroupMutation = {
  createFilterGroup?:  {
    __typename: "FilterGroup",
    id: string,
    filterGroupDetails:  Array< {
      __typename: "FilterGroupDetails",
      filterEntityType: FilterEntityType,
      filterEntityField?: string | null,
      filterEntityValues?: Array< string > | null,
      filterEntityNumber?: number | null,
      filterEntityDate?: string | null,
    } >,
    name?: string | null,
    screenName?: ScreenName | null,
    type: FilterGroupType,
    userId?: string | null,
    user?:  {
      __typename: "User",
      id: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      cognitoSub?: string | null,
      googleSub?: string | null,
      facebookSub?: string | null,
      rootUser?: boolean | null,
      refreshToken?: boolean | null,
      teams?:  {
        __typename: "ModelUserTeamConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      userRoleId?: string | null,
      userRole?:  {
        __typename: "UserRole",
        id: string,
        name: string,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contactId?: string | null,
      contact?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      status: UserStatus,
      readId: string,
      clientId: string,
      _ttl?: number | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateFilterGroupMutationVariables = {
  input: UpdateFilterGroupInput,
  condition?: ModelFilterGroupConditionInput | null,
};

export type UpdateFilterGroupMutation = {
  updateFilterGroup?:  {
    __typename: "FilterGroup",
    id: string,
    filterGroupDetails:  Array< {
      __typename: "FilterGroupDetails",
      filterEntityType: FilterEntityType,
      filterEntityField?: string | null,
      filterEntityValues?: Array< string > | null,
      filterEntityNumber?: number | null,
      filterEntityDate?: string | null,
    } >,
    name?: string | null,
    screenName?: ScreenName | null,
    type: FilterGroupType,
    userId?: string | null,
    user?:  {
      __typename: "User",
      id: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      cognitoSub?: string | null,
      googleSub?: string | null,
      facebookSub?: string | null,
      rootUser?: boolean | null,
      refreshToken?: boolean | null,
      teams?:  {
        __typename: "ModelUserTeamConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      userRoleId?: string | null,
      userRole?:  {
        __typename: "UserRole",
        id: string,
        name: string,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contactId?: string | null,
      contact?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      status: UserStatus,
      readId: string,
      clientId: string,
      _ttl?: number | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteFilterGroupMutationVariables = {
  input: DeleteFilterGroupInput,
  condition?: ModelFilterGroupConditionInput | null,
};

export type DeleteFilterGroupMutation = {
  deleteFilterGroup?:  {
    __typename: "FilterGroup",
    id: string,
    filterGroupDetails:  Array< {
      __typename: "FilterGroupDetails",
      filterEntityType: FilterEntityType,
      filterEntityField?: string | null,
      filterEntityValues?: Array< string > | null,
      filterEntityNumber?: number | null,
      filterEntityDate?: string | null,
    } >,
    name?: string | null,
    screenName?: ScreenName | null,
    type: FilterGroupType,
    userId?: string | null,
    user?:  {
      __typename: "User",
      id: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      cognitoSub?: string | null,
      googleSub?: string | null,
      facebookSub?: string | null,
      rootUser?: boolean | null,
      refreshToken?: boolean | null,
      teams?:  {
        __typename: "ModelUserTeamConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      userRoleId?: string | null,
      userRole?:  {
        __typename: "UserRole",
        id: string,
        name: string,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contactId?: string | null,
      contact?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      status: UserStatus,
      readId: string,
      clientId: string,
      _ttl?: number | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateIntegrationMutationVariables = {
  input: CreateIntegrationInput,
  condition?: ModelIntegrationConditionInput | null,
};

export type CreateIntegrationMutation = {
  createIntegration?:  {
    __typename: "Integration",
    id: string,
    configurations?:  Array< {
      __typename: "IntegrationConfiguration",
      name: string,
      value: string,
    } > | null,
    error?: string | null,
    lastRun?: string | null,
    name: IntegrationName,
    status: IntegrationStatus,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateIntegrationMutationVariables = {
  input: UpdateIntegrationInput,
  condition?: ModelIntegrationConditionInput | null,
};

export type UpdateIntegrationMutation = {
  updateIntegration?:  {
    __typename: "Integration",
    id: string,
    configurations?:  Array< {
      __typename: "IntegrationConfiguration",
      name: string,
      value: string,
    } > | null,
    error?: string | null,
    lastRun?: string | null,
    name: IntegrationName,
    status: IntegrationStatus,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteIntegrationMutationVariables = {
  input: DeleteIntegrationInput,
  condition?: ModelIntegrationConditionInput | null,
};

export type DeleteIntegrationMutation = {
  deleteIntegration?:  {
    __typename: "Integration",
    id: string,
    configurations?:  Array< {
      __typename: "IntegrationConfiguration",
      name: string,
      value: string,
    } > | null,
    error?: string | null,
    lastRun?: string | null,
    name: IntegrationName,
    status: IntegrationStatus,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateInvoiceMutationVariables = {
  input: CreateInvoiceInput,
  condition?: ModelInvoiceConditionInput | null,
};

export type CreateInvoiceMutation = {
  createInvoice?:  {
    __typename: "Invoice",
    id: string,
    amount: number,
    bankAccountId: string,
    bankAccount?:  {
      __typename: "BankAccount",
      id: string,
      contactId: string,
      contact?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      number: string,
      bicNumber?: string | null,
      bankName?: string | null,
      contactIds?: Array< string > | null,
      buildingIds?: Array< string > | null,
      holderName?: string | null,
      label?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      disabled?: boolean | null,
      integrations?: Array< IntegrationName > | null,
      matchingRule?: BankAccountMatchingRule | null,
      balance?: number | null,
      balanceDate?: string | null,
      type: BankAccountType,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    communicationId?: string | null,
    communication?:  {
      __typename: "Communication",
      id: string,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      blockedRecipients?:  Array< {
        __typename: "CommunicationBlockedRecipient",
        recipient: string,
        bounceType: BounceType,
      } > | null,
      body: string,
      buildingId?: string | null,
      channel: CommunicationChannel,
      communicationTemplateId?: string | null,
      concernedContactIds?: Array< string > | null,
      contactId?: string | null,
      contactIds?: Array< string > | null,
      createdAt?: string | null,
      draftProperties?:  {
        __typename: "CommunicationDraftProperties",
        allowRecipientsToSeeEachOther?: boolean | null,
        bcc?: Array< string > | null,
        buildingIds?: Array< string > | null,
        cc?: Array< string > | null,
        contactIds?: Array< string > | null,
        contactTypes?: Array< ContactType > | null,
        entityType: string,
        leaseIds?: Array< string > | null,
        sendInBcc?: boolean | null,
        unitIds?: Array< string > | null,
        unitTypeFilter?: string | null,
      } | null,
      expirationDate?: string | null,
      files?:  {
        __typename: "ModelFileConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      invoice?:  {
        __typename: "Invoice",
        id: string,
        amount: number,
        bankAccountId: string,
        communicationId?: string | null,
        createdAt: string,
        creditNote?: boolean | null,
        creditNoteLabel?: string | null,
        dueDate?: string | null,
        invoiceDate: string,
        invoiceNumber?: string | null,
        ownerId?: string | null,
        invoiceSenderId: string,
        leaseId?: string | null,
        paid: boolean,
        postedDate?: string | null,
        purchaseOrderNumber?: string | null,
        receiptNumber?: string | null,
        reminderDates?: Array< string > | null,
        note?: string | null,
        remittanceInformation?: string | null,
        statementId?: string | null,
        status: InvoiceStatus,
        type: InvoiceType,
        unitId?: string | null,
        reversedInvoiceId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      invoiceId?: string | null,
      lease?:  {
        __typename: "Lease",
        id: string,
        balance?: number | null,
        canBeExtended?: boolean | null,
        communicationSettingsProfileId: string,
        createdAt?: string | null,
        endDate: string,
        includeRealEstateInLeaseContract?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        invoiceSenderId: string,
        inventoryOfFixturesExpert?: string | null,
        inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
        inventoryOfFixturesType?: InventoryOfFixturesType | null,
        ipiNumber?: string | null,
        language: Language,
        lastDraftInvoiceDate?: string | null,
        lastIndexationProcessDate?: string | null,
        lastInvoiceDate?: string | null,
        legalCompetentAuthority?: string | null,
        name: string,
        notes?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        purchaseOrderNumber?: string | null,
        realEstateAgency?: string | null,
        realEstateTax?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        signatureDate?: string | null,
        startDate: string,
        nextIndexationMonth?: string | null,
        nextIndexation?: boolean | null,
        status: LeaseStatus,
        technicCommunicationSettingsProfileId: string,
        totalInitialRentalPrice: number,
        totalRentalPrice: number,
        type: LeaseType,
        subletting?: boolean | null,
        vatRateRentId?: string | null,
        bankAccountId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      leaseId?: string | null,
      leasePriceHistoryId?: string | null,
      leasePriceHistory?:  {
        __typename: "LeasePriceHistory",
        id: string,
        previousTotalRentalPrice: number,
        totalRentalPrice: number,
        optimalTotalRentalPrice?: number | null,
        optimalTotalMonthlyCharges?: number | null,
        applicationDate: string,
        status: LeaseAmountUpdateStatus,
        comment?: string | null,
        type: LeasePriceHistoryType,
        communicationId?: string | null,
        leaseId: string,
        createdAt?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      letterTrackingCode?: string | null,
      letterTrackingProvider?: TrackingProvider | null,
      linkedCommunicationsIds?: Array< string > | null,
      supportingDocumentFileIds?: Array< string > | null,
      recipient?: string | null,
      recipientContactIdsInBcc?: Array< string > | null,
      recipientContactIdsInCc?: Array< string > | null,
      recipientInBcc?: string | null,
      recipientInCc?: string | null,
      scheduledAt?: string | null,
      deliveredAt?: string | null,
      errorCode?: CommunicationErrorCode | null,
      nextRetryAt?: string | null,
      sendRetryCount?: number | null,
      sender?: string | null,
      sentAt?: string | null,
      externalId?: string | null,
      externalStatus?: string | null,
      signatureDocumentId?: string | null,
      signatureDocument?:  {
        __typename: "SignatureDocument",
        id: string,
        additionalMessage?: string | null,
        automaticRemindersDisabled?: boolean | null,
        communicationBody?: string | null,
        createdAt?: string | null,
        expirationDate?: string | null,
        fileIds?: Array< string > | null,
        foreignKey: string,
        foreignTableName: string,
        sentAt?: string | null,
        signatureMethods: Array< SignatureType >,
        status: SignatureDocumentStatus,
        externalStatus?: string | null,
        type: SignatureDocumentType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      snoozedDate?: string | null,
      statement?:  {
        __typename: "Statement",
        id: string,
        closingStatement: boolean,
        periodFrom: string,
        periodTo: string,
        attachSupportingDocuments?: boolean | null,
        selectedPocketKeys?: Array< string > | null,
        source: StatementSource,
        status: StatementStatus,
        sentDate?: string | null,
        leaseId?: string | null,
        ownerId?: string | null,
        types?: Array< StatementType > | null,
        viewType: StatementViewType,
        unitIds?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      statementId?: string | null,
      status: CommunicationStatus,
      subject: string,
      toSend: boolean,
      hideLogo?: boolean | null,
      type: CommunicationType,
      _ttl?: number | null,
      unit?:  {
        __typename: "Unit",
        id: string,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        acquisitionValue?: number | null,
        advertisedMonthlyCharges?: number | null,
        advertisedRentalPrice?: number | null,
        cadastralIncome?: number | null,
        createdAt?: string | null,
        floor?: number | null,
        jointOwnershipId?: string | null,
        managementDate: string,
        name: string,
        notes?: string | null,
        predictedPrice?: string | null,
        propertyTax?: number | null,
        publishAddress?: boolean | null,
        surface?: number | null,
        type: UnitType,
        buildingId: string,
        unitAdvertisementId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      unitId?: string | null,
      readId: string,
      readers?: Array< string > | null,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    createdAt: string,
    creditNote?: boolean | null,
    creditNoteLabel?: string | null,
    customValues?:  Array< {
      __typename: "CustomValue",
      name: string,
      value: string,
    } > | null,
    dueDate?: string | null,
    invoiceDate: string,
    invoiceNumber?: string | null,
    ownerId?: string | null,
    owner?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    invoiceSenderId: string,
    invoiceSender?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    leaseId?: string | null,
    lease?:  {
      __typename: "Lease",
      id: string,
      advancedChargesInvoices?:  {
        __typename: "LeaseAdvancedChargesInvoice",
        communicationSettingsProfileId: string,
        invoiceSenderId: string,
        lastDraftInvoiceDate?: string | null,
        lastInvoiceDate?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        bankAccountId?: string | null,
      } | null,
      balance?: number | null,
      canBeExtended?: boolean | null,
      communicationSettingsProfileId: string,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      endDate: string,
      includeRealEstateInLeaseContract?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      invoiceSenderId: string,
      invoiceSender?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      inventoryOfFixturesExpert?: string | null,
      inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
      inventoryOfFixturesType?: InventoryOfFixturesType | null,
      ipiNumber?: string | null,
      language: Language,
      lastDraftInvoiceDate?: string | null,
      lastIndexationProcessDate?: string | null,
      lastInvoiceDate?: string | null,
      legalCompetentAuthority?: string | null,
      name: string,
      notes?: string | null,
      paymentFrequency: LeasePaymentFrequency,
      paymentInvoicePeriod: LeasePaymentInvoicePeriod,
      paymentInvoicePeriodCustomDay?: number | null,
      paymentOption?:  {
        __typename: "LeasePaymentOption",
        customerId?: string | null,
        enabled: boolean,
        mandateActivatedAt?: string | null,
        mandateStatus?: PaymentProviderMandateStatus | null,
        paymentMethodId?: string | null,
        qrType?: LeaseQrType | null,
      } | null,
      purchaseOrderNumber?: string | null,
      realEstateAgency?: string | null,
      realEstateTax?: number | null,
      remittanceInformation?: string | null,
      remittanceInformationType?: LeaseRemittanceType | null,
      rentalGuaranty?:  {
        __typename: "LeaseRentalGuaranty",
        amount: number,
        blockedAmount?: number | null,
        releasedAmount?: number | null,
        type: LeaseRentalGuarantyType,
        financialInstitution?: string | null,
      } | null,
      signatureDate?: string | null,
      startDate: string,
      nextIndexationMonth?: string | null,
      nextIndexation?: boolean | null,
      status: LeaseStatus,
      technicCommunicationSettingsProfileId: string,
      totalInitialRentalPrice: number,
      totalRentalPrice: number,
      type: LeaseType,
      subletting?: boolean | null,
      vatRateRentId?: string | null,
      vatRateRent?:  {
        __typename: "VatRate",
        id: string,
        country: string,
        label: string,
        value?: number | null,
        ownerId?: string | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      additionalClauses?:  {
        __typename: "ModelLeaseAdditionalClauseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      bankAccountId?: string | null,
      bankAccount?:  {
        __typename: "BankAccount",
        id: string,
        contactId: string,
        number: string,
        bicNumber?: string | null,
        bankName?: string | null,
        contactIds?: Array< string > | null,
        buildingIds?: Array< string > | null,
        holderName?: string | null,
        label?: string | null,
        disabled?: boolean | null,
        integrations?: Array< IntegrationName > | null,
        matchingRule?: BankAccountMatchingRule | null,
        balance?: number | null,
        balanceDate?: string | null,
        type: BankAccountType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contacts?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      files?:  {
        __typename: "ModelFileConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leaseActionHistories?:  {
        __typename: "ModelLeaseActionHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leasePriceHistories?:  {
        __typename: "ModelLeasePriceHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      signatureDocuments?:  {
        __typename: "ModelSignatureDocumentConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      variousOperations?:  {
        __typename: "ModelLeaseVariousOperationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    paid: boolean,
    integrations?:  {
      __typename: "InvoiceIntegrations",
      paymentProperties?:  {
        __typename: "InvoicePaymentProviderProperties",
        availableOn?: string | null,
        error?: string | null,
        feeAmount?: number | null,
        paymentIntentId?: string | null,
        paymentLinkAmount?: number | null,
        paymentLinkUrl?: string | null,
        payoutId?: string | null,
        statementDescriptor?: string | null,
      } | null,
    } | null,
    postedDate?: string | null,
    purchaseOrderNumber?: string | null,
    receiptNumber?: string | null,
    reminderDates?: Array< string > | null,
    note?: string | null,
    remittanceInformation?: string | null,
    statementId?: string | null,
    statement?:  {
      __typename: "Statement",
      id: string,
      amounts?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      chargeStatements?:  {
        __typename: "ModelChargeStatementConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      closingStatement: boolean,
      periodFrom: string,
      periodTo: string,
      attachSupportingDocuments?: boolean | null,
      selectedPocketKeys?: Array< string > | null,
      source: StatementSource,
      status: StatementStatus,
      sentDate?: string | null,
      leaseId?: string | null,
      lease?:  {
        __typename: "Lease",
        id: string,
        balance?: number | null,
        canBeExtended?: boolean | null,
        communicationSettingsProfileId: string,
        createdAt?: string | null,
        endDate: string,
        includeRealEstateInLeaseContract?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        invoiceSenderId: string,
        inventoryOfFixturesExpert?: string | null,
        inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
        inventoryOfFixturesType?: InventoryOfFixturesType | null,
        ipiNumber?: string | null,
        language: Language,
        lastDraftInvoiceDate?: string | null,
        lastIndexationProcessDate?: string | null,
        lastInvoiceDate?: string | null,
        legalCompetentAuthority?: string | null,
        name: string,
        notes?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        purchaseOrderNumber?: string | null,
        realEstateAgency?: string | null,
        realEstateTax?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        signatureDate?: string | null,
        startDate: string,
        nextIndexationMonth?: string | null,
        nextIndexation?: boolean | null,
        status: LeaseStatus,
        technicCommunicationSettingsProfileId: string,
        totalInitialRentalPrice: number,
        totalRentalPrice: number,
        type: LeaseType,
        subletting?: boolean | null,
        vatRateRentId?: string | null,
        bankAccountId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      agencyRateStatements?:  {
        __typename: "ModelAgencyRateStatementConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      ownerId?: string | null,
      owner?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      repaymentStatements?:  {
        __typename: "ModelRepaymentStatementConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      types?: Array< StatementType > | null,
      viewType: StatementViewType,
      unitIds?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    status: InvoiceStatus,
    type: InvoiceType,
    unitId?: string | null,
    unit?:  {
      __typename: "Unit",
      id: string,
      acquisitionAdditionalCostsValue?: number | null,
      acquisitionAdvertisedValue?: number | null,
      acquisitionValue?: number | null,
      advertisedMonthlyCharges?: number | null,
      advertisedRentalPrice?: number | null,
      cadastralIncome?: number | null,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      floor?: number | null,
      jointOwnershipId?: string | null,
      managementDate: string,
      name: string,
      notes?: string | null,
      predictedPrice?: string | null,
      propertyTax?: number | null,
      publishAddress?: boolean | null,
      surface?: number | null,
      type: UnitType,
      buildingId: string,
      building?:  {
        __typename: "Building",
        id: string,
        name: string,
        addressId?: string | null,
        acquisitionValue?: number | null,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        amountOfFacades?: number | null,
        amountOfFloors?: number | null,
        amountOfHousings?: number | null,
        buildingState?: BuildingState | null,
        cadastralIncome?: number | null,
        constructionYear?: string | null,
        janitor?: boolean | null,
        jointOwnershipId?: string | null,
        notes?: string | null,
        propertyTax?: number | null,
        residenceName?: string | null,
        buildingSiteId?: string | null,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      owners?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leases?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      events?:  {
        __typename: "ModelUnitEventConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      unitAdvertisementId?: string | null,
      unitInventories?:  {
        __typename: "ModelUnitInventoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    reversedInvoiceId?: string | null,
    readers?: Array< string > | null,
    readId: string,
    clientId: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateInvoiceMutationVariables = {
  input: UpdateInvoiceInput,
  condition?: ModelInvoiceConditionInput | null,
};

export type UpdateInvoiceMutation = {
  updateInvoice?:  {
    __typename: "Invoice",
    id: string,
    amount: number,
    bankAccountId: string,
    bankAccount?:  {
      __typename: "BankAccount",
      id: string,
      contactId: string,
      contact?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      number: string,
      bicNumber?: string | null,
      bankName?: string | null,
      contactIds?: Array< string > | null,
      buildingIds?: Array< string > | null,
      holderName?: string | null,
      label?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      disabled?: boolean | null,
      integrations?: Array< IntegrationName > | null,
      matchingRule?: BankAccountMatchingRule | null,
      balance?: number | null,
      balanceDate?: string | null,
      type: BankAccountType,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    communicationId?: string | null,
    communication?:  {
      __typename: "Communication",
      id: string,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      blockedRecipients?:  Array< {
        __typename: "CommunicationBlockedRecipient",
        recipient: string,
        bounceType: BounceType,
      } > | null,
      body: string,
      buildingId?: string | null,
      channel: CommunicationChannel,
      communicationTemplateId?: string | null,
      concernedContactIds?: Array< string > | null,
      contactId?: string | null,
      contactIds?: Array< string > | null,
      createdAt?: string | null,
      draftProperties?:  {
        __typename: "CommunicationDraftProperties",
        allowRecipientsToSeeEachOther?: boolean | null,
        bcc?: Array< string > | null,
        buildingIds?: Array< string > | null,
        cc?: Array< string > | null,
        contactIds?: Array< string > | null,
        contactTypes?: Array< ContactType > | null,
        entityType: string,
        leaseIds?: Array< string > | null,
        sendInBcc?: boolean | null,
        unitIds?: Array< string > | null,
        unitTypeFilter?: string | null,
      } | null,
      expirationDate?: string | null,
      files?:  {
        __typename: "ModelFileConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      invoice?:  {
        __typename: "Invoice",
        id: string,
        amount: number,
        bankAccountId: string,
        communicationId?: string | null,
        createdAt: string,
        creditNote?: boolean | null,
        creditNoteLabel?: string | null,
        dueDate?: string | null,
        invoiceDate: string,
        invoiceNumber?: string | null,
        ownerId?: string | null,
        invoiceSenderId: string,
        leaseId?: string | null,
        paid: boolean,
        postedDate?: string | null,
        purchaseOrderNumber?: string | null,
        receiptNumber?: string | null,
        reminderDates?: Array< string > | null,
        note?: string | null,
        remittanceInformation?: string | null,
        statementId?: string | null,
        status: InvoiceStatus,
        type: InvoiceType,
        unitId?: string | null,
        reversedInvoiceId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      invoiceId?: string | null,
      lease?:  {
        __typename: "Lease",
        id: string,
        balance?: number | null,
        canBeExtended?: boolean | null,
        communicationSettingsProfileId: string,
        createdAt?: string | null,
        endDate: string,
        includeRealEstateInLeaseContract?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        invoiceSenderId: string,
        inventoryOfFixturesExpert?: string | null,
        inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
        inventoryOfFixturesType?: InventoryOfFixturesType | null,
        ipiNumber?: string | null,
        language: Language,
        lastDraftInvoiceDate?: string | null,
        lastIndexationProcessDate?: string | null,
        lastInvoiceDate?: string | null,
        legalCompetentAuthority?: string | null,
        name: string,
        notes?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        purchaseOrderNumber?: string | null,
        realEstateAgency?: string | null,
        realEstateTax?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        signatureDate?: string | null,
        startDate: string,
        nextIndexationMonth?: string | null,
        nextIndexation?: boolean | null,
        status: LeaseStatus,
        technicCommunicationSettingsProfileId: string,
        totalInitialRentalPrice: number,
        totalRentalPrice: number,
        type: LeaseType,
        subletting?: boolean | null,
        vatRateRentId?: string | null,
        bankAccountId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      leaseId?: string | null,
      leasePriceHistoryId?: string | null,
      leasePriceHistory?:  {
        __typename: "LeasePriceHistory",
        id: string,
        previousTotalRentalPrice: number,
        totalRentalPrice: number,
        optimalTotalRentalPrice?: number | null,
        optimalTotalMonthlyCharges?: number | null,
        applicationDate: string,
        status: LeaseAmountUpdateStatus,
        comment?: string | null,
        type: LeasePriceHistoryType,
        communicationId?: string | null,
        leaseId: string,
        createdAt?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      letterTrackingCode?: string | null,
      letterTrackingProvider?: TrackingProvider | null,
      linkedCommunicationsIds?: Array< string > | null,
      supportingDocumentFileIds?: Array< string > | null,
      recipient?: string | null,
      recipientContactIdsInBcc?: Array< string > | null,
      recipientContactIdsInCc?: Array< string > | null,
      recipientInBcc?: string | null,
      recipientInCc?: string | null,
      scheduledAt?: string | null,
      deliveredAt?: string | null,
      errorCode?: CommunicationErrorCode | null,
      nextRetryAt?: string | null,
      sendRetryCount?: number | null,
      sender?: string | null,
      sentAt?: string | null,
      externalId?: string | null,
      externalStatus?: string | null,
      signatureDocumentId?: string | null,
      signatureDocument?:  {
        __typename: "SignatureDocument",
        id: string,
        additionalMessage?: string | null,
        automaticRemindersDisabled?: boolean | null,
        communicationBody?: string | null,
        createdAt?: string | null,
        expirationDate?: string | null,
        fileIds?: Array< string > | null,
        foreignKey: string,
        foreignTableName: string,
        sentAt?: string | null,
        signatureMethods: Array< SignatureType >,
        status: SignatureDocumentStatus,
        externalStatus?: string | null,
        type: SignatureDocumentType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      snoozedDate?: string | null,
      statement?:  {
        __typename: "Statement",
        id: string,
        closingStatement: boolean,
        periodFrom: string,
        periodTo: string,
        attachSupportingDocuments?: boolean | null,
        selectedPocketKeys?: Array< string > | null,
        source: StatementSource,
        status: StatementStatus,
        sentDate?: string | null,
        leaseId?: string | null,
        ownerId?: string | null,
        types?: Array< StatementType > | null,
        viewType: StatementViewType,
        unitIds?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      statementId?: string | null,
      status: CommunicationStatus,
      subject: string,
      toSend: boolean,
      hideLogo?: boolean | null,
      type: CommunicationType,
      _ttl?: number | null,
      unit?:  {
        __typename: "Unit",
        id: string,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        acquisitionValue?: number | null,
        advertisedMonthlyCharges?: number | null,
        advertisedRentalPrice?: number | null,
        cadastralIncome?: number | null,
        createdAt?: string | null,
        floor?: number | null,
        jointOwnershipId?: string | null,
        managementDate: string,
        name: string,
        notes?: string | null,
        predictedPrice?: string | null,
        propertyTax?: number | null,
        publishAddress?: boolean | null,
        surface?: number | null,
        type: UnitType,
        buildingId: string,
        unitAdvertisementId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      unitId?: string | null,
      readId: string,
      readers?: Array< string > | null,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    createdAt: string,
    creditNote?: boolean | null,
    creditNoteLabel?: string | null,
    customValues?:  Array< {
      __typename: "CustomValue",
      name: string,
      value: string,
    } > | null,
    dueDate?: string | null,
    invoiceDate: string,
    invoiceNumber?: string | null,
    ownerId?: string | null,
    owner?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    invoiceSenderId: string,
    invoiceSender?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    leaseId?: string | null,
    lease?:  {
      __typename: "Lease",
      id: string,
      advancedChargesInvoices?:  {
        __typename: "LeaseAdvancedChargesInvoice",
        communicationSettingsProfileId: string,
        invoiceSenderId: string,
        lastDraftInvoiceDate?: string | null,
        lastInvoiceDate?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        bankAccountId?: string | null,
      } | null,
      balance?: number | null,
      canBeExtended?: boolean | null,
      communicationSettingsProfileId: string,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      endDate: string,
      includeRealEstateInLeaseContract?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      invoiceSenderId: string,
      invoiceSender?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      inventoryOfFixturesExpert?: string | null,
      inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
      inventoryOfFixturesType?: InventoryOfFixturesType | null,
      ipiNumber?: string | null,
      language: Language,
      lastDraftInvoiceDate?: string | null,
      lastIndexationProcessDate?: string | null,
      lastInvoiceDate?: string | null,
      legalCompetentAuthority?: string | null,
      name: string,
      notes?: string | null,
      paymentFrequency: LeasePaymentFrequency,
      paymentInvoicePeriod: LeasePaymentInvoicePeriod,
      paymentInvoicePeriodCustomDay?: number | null,
      paymentOption?:  {
        __typename: "LeasePaymentOption",
        customerId?: string | null,
        enabled: boolean,
        mandateActivatedAt?: string | null,
        mandateStatus?: PaymentProviderMandateStatus | null,
        paymentMethodId?: string | null,
        qrType?: LeaseQrType | null,
      } | null,
      purchaseOrderNumber?: string | null,
      realEstateAgency?: string | null,
      realEstateTax?: number | null,
      remittanceInformation?: string | null,
      remittanceInformationType?: LeaseRemittanceType | null,
      rentalGuaranty?:  {
        __typename: "LeaseRentalGuaranty",
        amount: number,
        blockedAmount?: number | null,
        releasedAmount?: number | null,
        type: LeaseRentalGuarantyType,
        financialInstitution?: string | null,
      } | null,
      signatureDate?: string | null,
      startDate: string,
      nextIndexationMonth?: string | null,
      nextIndexation?: boolean | null,
      status: LeaseStatus,
      technicCommunicationSettingsProfileId: string,
      totalInitialRentalPrice: number,
      totalRentalPrice: number,
      type: LeaseType,
      subletting?: boolean | null,
      vatRateRentId?: string | null,
      vatRateRent?:  {
        __typename: "VatRate",
        id: string,
        country: string,
        label: string,
        value?: number | null,
        ownerId?: string | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      additionalClauses?:  {
        __typename: "ModelLeaseAdditionalClauseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      bankAccountId?: string | null,
      bankAccount?:  {
        __typename: "BankAccount",
        id: string,
        contactId: string,
        number: string,
        bicNumber?: string | null,
        bankName?: string | null,
        contactIds?: Array< string > | null,
        buildingIds?: Array< string > | null,
        holderName?: string | null,
        label?: string | null,
        disabled?: boolean | null,
        integrations?: Array< IntegrationName > | null,
        matchingRule?: BankAccountMatchingRule | null,
        balance?: number | null,
        balanceDate?: string | null,
        type: BankAccountType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contacts?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      files?:  {
        __typename: "ModelFileConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leaseActionHistories?:  {
        __typename: "ModelLeaseActionHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leasePriceHistories?:  {
        __typename: "ModelLeasePriceHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      signatureDocuments?:  {
        __typename: "ModelSignatureDocumentConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      variousOperations?:  {
        __typename: "ModelLeaseVariousOperationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    paid: boolean,
    integrations?:  {
      __typename: "InvoiceIntegrations",
      paymentProperties?:  {
        __typename: "InvoicePaymentProviderProperties",
        availableOn?: string | null,
        error?: string | null,
        feeAmount?: number | null,
        paymentIntentId?: string | null,
        paymentLinkAmount?: number | null,
        paymentLinkUrl?: string | null,
        payoutId?: string | null,
        statementDescriptor?: string | null,
      } | null,
    } | null,
    postedDate?: string | null,
    purchaseOrderNumber?: string | null,
    receiptNumber?: string | null,
    reminderDates?: Array< string > | null,
    note?: string | null,
    remittanceInformation?: string | null,
    statementId?: string | null,
    statement?:  {
      __typename: "Statement",
      id: string,
      amounts?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      chargeStatements?:  {
        __typename: "ModelChargeStatementConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      closingStatement: boolean,
      periodFrom: string,
      periodTo: string,
      attachSupportingDocuments?: boolean | null,
      selectedPocketKeys?: Array< string > | null,
      source: StatementSource,
      status: StatementStatus,
      sentDate?: string | null,
      leaseId?: string | null,
      lease?:  {
        __typename: "Lease",
        id: string,
        balance?: number | null,
        canBeExtended?: boolean | null,
        communicationSettingsProfileId: string,
        createdAt?: string | null,
        endDate: string,
        includeRealEstateInLeaseContract?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        invoiceSenderId: string,
        inventoryOfFixturesExpert?: string | null,
        inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
        inventoryOfFixturesType?: InventoryOfFixturesType | null,
        ipiNumber?: string | null,
        language: Language,
        lastDraftInvoiceDate?: string | null,
        lastIndexationProcessDate?: string | null,
        lastInvoiceDate?: string | null,
        legalCompetentAuthority?: string | null,
        name: string,
        notes?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        purchaseOrderNumber?: string | null,
        realEstateAgency?: string | null,
        realEstateTax?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        signatureDate?: string | null,
        startDate: string,
        nextIndexationMonth?: string | null,
        nextIndexation?: boolean | null,
        status: LeaseStatus,
        technicCommunicationSettingsProfileId: string,
        totalInitialRentalPrice: number,
        totalRentalPrice: number,
        type: LeaseType,
        subletting?: boolean | null,
        vatRateRentId?: string | null,
        bankAccountId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      agencyRateStatements?:  {
        __typename: "ModelAgencyRateStatementConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      ownerId?: string | null,
      owner?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      repaymentStatements?:  {
        __typename: "ModelRepaymentStatementConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      types?: Array< StatementType > | null,
      viewType: StatementViewType,
      unitIds?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    status: InvoiceStatus,
    type: InvoiceType,
    unitId?: string | null,
    unit?:  {
      __typename: "Unit",
      id: string,
      acquisitionAdditionalCostsValue?: number | null,
      acquisitionAdvertisedValue?: number | null,
      acquisitionValue?: number | null,
      advertisedMonthlyCharges?: number | null,
      advertisedRentalPrice?: number | null,
      cadastralIncome?: number | null,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      floor?: number | null,
      jointOwnershipId?: string | null,
      managementDate: string,
      name: string,
      notes?: string | null,
      predictedPrice?: string | null,
      propertyTax?: number | null,
      publishAddress?: boolean | null,
      surface?: number | null,
      type: UnitType,
      buildingId: string,
      building?:  {
        __typename: "Building",
        id: string,
        name: string,
        addressId?: string | null,
        acquisitionValue?: number | null,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        amountOfFacades?: number | null,
        amountOfFloors?: number | null,
        amountOfHousings?: number | null,
        buildingState?: BuildingState | null,
        cadastralIncome?: number | null,
        constructionYear?: string | null,
        janitor?: boolean | null,
        jointOwnershipId?: string | null,
        notes?: string | null,
        propertyTax?: number | null,
        residenceName?: string | null,
        buildingSiteId?: string | null,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      owners?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leases?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      events?:  {
        __typename: "ModelUnitEventConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      unitAdvertisementId?: string | null,
      unitInventories?:  {
        __typename: "ModelUnitInventoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    reversedInvoiceId?: string | null,
    readers?: Array< string > | null,
    readId: string,
    clientId: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteInvoiceMutationVariables = {
  input: DeleteInvoiceInput,
  condition?: ModelInvoiceConditionInput | null,
};

export type DeleteInvoiceMutation = {
  deleteInvoice?:  {
    __typename: "Invoice",
    id: string,
    amount: number,
    bankAccountId: string,
    bankAccount?:  {
      __typename: "BankAccount",
      id: string,
      contactId: string,
      contact?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      number: string,
      bicNumber?: string | null,
      bankName?: string | null,
      contactIds?: Array< string > | null,
      buildingIds?: Array< string > | null,
      holderName?: string | null,
      label?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      disabled?: boolean | null,
      integrations?: Array< IntegrationName > | null,
      matchingRule?: BankAccountMatchingRule | null,
      balance?: number | null,
      balanceDate?: string | null,
      type: BankAccountType,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    communicationId?: string | null,
    communication?:  {
      __typename: "Communication",
      id: string,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      blockedRecipients?:  Array< {
        __typename: "CommunicationBlockedRecipient",
        recipient: string,
        bounceType: BounceType,
      } > | null,
      body: string,
      buildingId?: string | null,
      channel: CommunicationChannel,
      communicationTemplateId?: string | null,
      concernedContactIds?: Array< string > | null,
      contactId?: string | null,
      contactIds?: Array< string > | null,
      createdAt?: string | null,
      draftProperties?:  {
        __typename: "CommunicationDraftProperties",
        allowRecipientsToSeeEachOther?: boolean | null,
        bcc?: Array< string > | null,
        buildingIds?: Array< string > | null,
        cc?: Array< string > | null,
        contactIds?: Array< string > | null,
        contactTypes?: Array< ContactType > | null,
        entityType: string,
        leaseIds?: Array< string > | null,
        sendInBcc?: boolean | null,
        unitIds?: Array< string > | null,
        unitTypeFilter?: string | null,
      } | null,
      expirationDate?: string | null,
      files?:  {
        __typename: "ModelFileConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      invoice?:  {
        __typename: "Invoice",
        id: string,
        amount: number,
        bankAccountId: string,
        communicationId?: string | null,
        createdAt: string,
        creditNote?: boolean | null,
        creditNoteLabel?: string | null,
        dueDate?: string | null,
        invoiceDate: string,
        invoiceNumber?: string | null,
        ownerId?: string | null,
        invoiceSenderId: string,
        leaseId?: string | null,
        paid: boolean,
        postedDate?: string | null,
        purchaseOrderNumber?: string | null,
        receiptNumber?: string | null,
        reminderDates?: Array< string > | null,
        note?: string | null,
        remittanceInformation?: string | null,
        statementId?: string | null,
        status: InvoiceStatus,
        type: InvoiceType,
        unitId?: string | null,
        reversedInvoiceId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      invoiceId?: string | null,
      lease?:  {
        __typename: "Lease",
        id: string,
        balance?: number | null,
        canBeExtended?: boolean | null,
        communicationSettingsProfileId: string,
        createdAt?: string | null,
        endDate: string,
        includeRealEstateInLeaseContract?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        invoiceSenderId: string,
        inventoryOfFixturesExpert?: string | null,
        inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
        inventoryOfFixturesType?: InventoryOfFixturesType | null,
        ipiNumber?: string | null,
        language: Language,
        lastDraftInvoiceDate?: string | null,
        lastIndexationProcessDate?: string | null,
        lastInvoiceDate?: string | null,
        legalCompetentAuthority?: string | null,
        name: string,
        notes?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        purchaseOrderNumber?: string | null,
        realEstateAgency?: string | null,
        realEstateTax?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        signatureDate?: string | null,
        startDate: string,
        nextIndexationMonth?: string | null,
        nextIndexation?: boolean | null,
        status: LeaseStatus,
        technicCommunicationSettingsProfileId: string,
        totalInitialRentalPrice: number,
        totalRentalPrice: number,
        type: LeaseType,
        subletting?: boolean | null,
        vatRateRentId?: string | null,
        bankAccountId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      leaseId?: string | null,
      leasePriceHistoryId?: string | null,
      leasePriceHistory?:  {
        __typename: "LeasePriceHistory",
        id: string,
        previousTotalRentalPrice: number,
        totalRentalPrice: number,
        optimalTotalRentalPrice?: number | null,
        optimalTotalMonthlyCharges?: number | null,
        applicationDate: string,
        status: LeaseAmountUpdateStatus,
        comment?: string | null,
        type: LeasePriceHistoryType,
        communicationId?: string | null,
        leaseId: string,
        createdAt?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      letterTrackingCode?: string | null,
      letterTrackingProvider?: TrackingProvider | null,
      linkedCommunicationsIds?: Array< string > | null,
      supportingDocumentFileIds?: Array< string > | null,
      recipient?: string | null,
      recipientContactIdsInBcc?: Array< string > | null,
      recipientContactIdsInCc?: Array< string > | null,
      recipientInBcc?: string | null,
      recipientInCc?: string | null,
      scheduledAt?: string | null,
      deliveredAt?: string | null,
      errorCode?: CommunicationErrorCode | null,
      nextRetryAt?: string | null,
      sendRetryCount?: number | null,
      sender?: string | null,
      sentAt?: string | null,
      externalId?: string | null,
      externalStatus?: string | null,
      signatureDocumentId?: string | null,
      signatureDocument?:  {
        __typename: "SignatureDocument",
        id: string,
        additionalMessage?: string | null,
        automaticRemindersDisabled?: boolean | null,
        communicationBody?: string | null,
        createdAt?: string | null,
        expirationDate?: string | null,
        fileIds?: Array< string > | null,
        foreignKey: string,
        foreignTableName: string,
        sentAt?: string | null,
        signatureMethods: Array< SignatureType >,
        status: SignatureDocumentStatus,
        externalStatus?: string | null,
        type: SignatureDocumentType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      snoozedDate?: string | null,
      statement?:  {
        __typename: "Statement",
        id: string,
        closingStatement: boolean,
        periodFrom: string,
        periodTo: string,
        attachSupportingDocuments?: boolean | null,
        selectedPocketKeys?: Array< string > | null,
        source: StatementSource,
        status: StatementStatus,
        sentDate?: string | null,
        leaseId?: string | null,
        ownerId?: string | null,
        types?: Array< StatementType > | null,
        viewType: StatementViewType,
        unitIds?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      statementId?: string | null,
      status: CommunicationStatus,
      subject: string,
      toSend: boolean,
      hideLogo?: boolean | null,
      type: CommunicationType,
      _ttl?: number | null,
      unit?:  {
        __typename: "Unit",
        id: string,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        acquisitionValue?: number | null,
        advertisedMonthlyCharges?: number | null,
        advertisedRentalPrice?: number | null,
        cadastralIncome?: number | null,
        createdAt?: string | null,
        floor?: number | null,
        jointOwnershipId?: string | null,
        managementDate: string,
        name: string,
        notes?: string | null,
        predictedPrice?: string | null,
        propertyTax?: number | null,
        publishAddress?: boolean | null,
        surface?: number | null,
        type: UnitType,
        buildingId: string,
        unitAdvertisementId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      unitId?: string | null,
      readId: string,
      readers?: Array< string > | null,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    createdAt: string,
    creditNote?: boolean | null,
    creditNoteLabel?: string | null,
    customValues?:  Array< {
      __typename: "CustomValue",
      name: string,
      value: string,
    } > | null,
    dueDate?: string | null,
    invoiceDate: string,
    invoiceNumber?: string | null,
    ownerId?: string | null,
    owner?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    invoiceSenderId: string,
    invoiceSender?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    leaseId?: string | null,
    lease?:  {
      __typename: "Lease",
      id: string,
      advancedChargesInvoices?:  {
        __typename: "LeaseAdvancedChargesInvoice",
        communicationSettingsProfileId: string,
        invoiceSenderId: string,
        lastDraftInvoiceDate?: string | null,
        lastInvoiceDate?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        bankAccountId?: string | null,
      } | null,
      balance?: number | null,
      canBeExtended?: boolean | null,
      communicationSettingsProfileId: string,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      endDate: string,
      includeRealEstateInLeaseContract?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      invoiceSenderId: string,
      invoiceSender?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      inventoryOfFixturesExpert?: string | null,
      inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
      inventoryOfFixturesType?: InventoryOfFixturesType | null,
      ipiNumber?: string | null,
      language: Language,
      lastDraftInvoiceDate?: string | null,
      lastIndexationProcessDate?: string | null,
      lastInvoiceDate?: string | null,
      legalCompetentAuthority?: string | null,
      name: string,
      notes?: string | null,
      paymentFrequency: LeasePaymentFrequency,
      paymentInvoicePeriod: LeasePaymentInvoicePeriod,
      paymentInvoicePeriodCustomDay?: number | null,
      paymentOption?:  {
        __typename: "LeasePaymentOption",
        customerId?: string | null,
        enabled: boolean,
        mandateActivatedAt?: string | null,
        mandateStatus?: PaymentProviderMandateStatus | null,
        paymentMethodId?: string | null,
        qrType?: LeaseQrType | null,
      } | null,
      purchaseOrderNumber?: string | null,
      realEstateAgency?: string | null,
      realEstateTax?: number | null,
      remittanceInformation?: string | null,
      remittanceInformationType?: LeaseRemittanceType | null,
      rentalGuaranty?:  {
        __typename: "LeaseRentalGuaranty",
        amount: number,
        blockedAmount?: number | null,
        releasedAmount?: number | null,
        type: LeaseRentalGuarantyType,
        financialInstitution?: string | null,
      } | null,
      signatureDate?: string | null,
      startDate: string,
      nextIndexationMonth?: string | null,
      nextIndexation?: boolean | null,
      status: LeaseStatus,
      technicCommunicationSettingsProfileId: string,
      totalInitialRentalPrice: number,
      totalRentalPrice: number,
      type: LeaseType,
      subletting?: boolean | null,
      vatRateRentId?: string | null,
      vatRateRent?:  {
        __typename: "VatRate",
        id: string,
        country: string,
        label: string,
        value?: number | null,
        ownerId?: string | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      additionalClauses?:  {
        __typename: "ModelLeaseAdditionalClauseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      bankAccountId?: string | null,
      bankAccount?:  {
        __typename: "BankAccount",
        id: string,
        contactId: string,
        number: string,
        bicNumber?: string | null,
        bankName?: string | null,
        contactIds?: Array< string > | null,
        buildingIds?: Array< string > | null,
        holderName?: string | null,
        label?: string | null,
        disabled?: boolean | null,
        integrations?: Array< IntegrationName > | null,
        matchingRule?: BankAccountMatchingRule | null,
        balance?: number | null,
        balanceDate?: string | null,
        type: BankAccountType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contacts?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      files?:  {
        __typename: "ModelFileConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leaseActionHistories?:  {
        __typename: "ModelLeaseActionHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leasePriceHistories?:  {
        __typename: "ModelLeasePriceHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      signatureDocuments?:  {
        __typename: "ModelSignatureDocumentConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      variousOperations?:  {
        __typename: "ModelLeaseVariousOperationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    paid: boolean,
    integrations?:  {
      __typename: "InvoiceIntegrations",
      paymentProperties?:  {
        __typename: "InvoicePaymentProviderProperties",
        availableOn?: string | null,
        error?: string | null,
        feeAmount?: number | null,
        paymentIntentId?: string | null,
        paymentLinkAmount?: number | null,
        paymentLinkUrl?: string | null,
        payoutId?: string | null,
        statementDescriptor?: string | null,
      } | null,
    } | null,
    postedDate?: string | null,
    purchaseOrderNumber?: string | null,
    receiptNumber?: string | null,
    reminderDates?: Array< string > | null,
    note?: string | null,
    remittanceInformation?: string | null,
    statementId?: string | null,
    statement?:  {
      __typename: "Statement",
      id: string,
      amounts?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      chargeStatements?:  {
        __typename: "ModelChargeStatementConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      closingStatement: boolean,
      periodFrom: string,
      periodTo: string,
      attachSupportingDocuments?: boolean | null,
      selectedPocketKeys?: Array< string > | null,
      source: StatementSource,
      status: StatementStatus,
      sentDate?: string | null,
      leaseId?: string | null,
      lease?:  {
        __typename: "Lease",
        id: string,
        balance?: number | null,
        canBeExtended?: boolean | null,
        communicationSettingsProfileId: string,
        createdAt?: string | null,
        endDate: string,
        includeRealEstateInLeaseContract?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        invoiceSenderId: string,
        inventoryOfFixturesExpert?: string | null,
        inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
        inventoryOfFixturesType?: InventoryOfFixturesType | null,
        ipiNumber?: string | null,
        language: Language,
        lastDraftInvoiceDate?: string | null,
        lastIndexationProcessDate?: string | null,
        lastInvoiceDate?: string | null,
        legalCompetentAuthority?: string | null,
        name: string,
        notes?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        purchaseOrderNumber?: string | null,
        realEstateAgency?: string | null,
        realEstateTax?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        signatureDate?: string | null,
        startDate: string,
        nextIndexationMonth?: string | null,
        nextIndexation?: boolean | null,
        status: LeaseStatus,
        technicCommunicationSettingsProfileId: string,
        totalInitialRentalPrice: number,
        totalRentalPrice: number,
        type: LeaseType,
        subletting?: boolean | null,
        vatRateRentId?: string | null,
        bankAccountId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      agencyRateStatements?:  {
        __typename: "ModelAgencyRateStatementConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      ownerId?: string | null,
      owner?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      repaymentStatements?:  {
        __typename: "ModelRepaymentStatementConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      types?: Array< StatementType > | null,
      viewType: StatementViewType,
      unitIds?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    status: InvoiceStatus,
    type: InvoiceType,
    unitId?: string | null,
    unit?:  {
      __typename: "Unit",
      id: string,
      acquisitionAdditionalCostsValue?: number | null,
      acquisitionAdvertisedValue?: number | null,
      acquisitionValue?: number | null,
      advertisedMonthlyCharges?: number | null,
      advertisedRentalPrice?: number | null,
      cadastralIncome?: number | null,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      floor?: number | null,
      jointOwnershipId?: string | null,
      managementDate: string,
      name: string,
      notes?: string | null,
      predictedPrice?: string | null,
      propertyTax?: number | null,
      publishAddress?: boolean | null,
      surface?: number | null,
      type: UnitType,
      buildingId: string,
      building?:  {
        __typename: "Building",
        id: string,
        name: string,
        addressId?: string | null,
        acquisitionValue?: number | null,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        amountOfFacades?: number | null,
        amountOfFloors?: number | null,
        amountOfHousings?: number | null,
        buildingState?: BuildingState | null,
        cadastralIncome?: number | null,
        constructionYear?: string | null,
        janitor?: boolean | null,
        jointOwnershipId?: string | null,
        notes?: string | null,
        propertyTax?: number | null,
        residenceName?: string | null,
        buildingSiteId?: string | null,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      owners?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leases?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      events?:  {
        __typename: "ModelUnitEventConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      unitAdvertisementId?: string | null,
      unitInventories?:  {
        __typename: "ModelUnitInventoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    reversedInvoiceId?: string | null,
    readers?: Array< string > | null,
    readId: string,
    clientId: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateInvoiceSettingMutationVariables = {
  input: CreateInvoiceSettingInput,
  condition?: ModelInvoiceSettingConditionInput | null,
};

export type CreateInvoiceSettingMutation = {
  createInvoiceSetting?:  {
    __typename: "InvoiceSetting",
    id: string,
    creditNoteFormat: string,
    creditNoteLastUpdate: string,
    creditNoteIncrementNumber: number,
    invoiceFormat: string,
    invoiceLastUpdate: string,
    invoiceIncrementNumber: number,
    paymentRequestFormat: string,
    paymentRequestLastUpdate: string,
    paymentRequestIncrementNumber: number,
    receiptFormat: string,
    receiptLastUpdate: string,
    receiptIncrementNumber: number,
    variousOperationFormat: string,
    variousOperationLastUpdate: string,
    variousOperationIncrementNumber: number,
    customInvoicingConfiguration?: boolean | null,
    defaultVatRateId?: string | null,
    fiscalYearStart?: string | null,
    allPurposeInvoiceIssuer?: boolean | null,
    paymentBankAccountId?: string | null,
    ownerId: string,
    owner?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateInvoiceSettingMutationVariables = {
  input: UpdateInvoiceSettingInput,
  condition?: ModelInvoiceSettingConditionInput | null,
};

export type UpdateInvoiceSettingMutation = {
  updateInvoiceSetting?:  {
    __typename: "InvoiceSetting",
    id: string,
    creditNoteFormat: string,
    creditNoteLastUpdate: string,
    creditNoteIncrementNumber: number,
    invoiceFormat: string,
    invoiceLastUpdate: string,
    invoiceIncrementNumber: number,
    paymentRequestFormat: string,
    paymentRequestLastUpdate: string,
    paymentRequestIncrementNumber: number,
    receiptFormat: string,
    receiptLastUpdate: string,
    receiptIncrementNumber: number,
    variousOperationFormat: string,
    variousOperationLastUpdate: string,
    variousOperationIncrementNumber: number,
    customInvoicingConfiguration?: boolean | null,
    defaultVatRateId?: string | null,
    fiscalYearStart?: string | null,
    allPurposeInvoiceIssuer?: boolean | null,
    paymentBankAccountId?: string | null,
    ownerId: string,
    owner?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteInvoiceSettingMutationVariables = {
  input: DeleteInvoiceSettingInput,
  condition?: ModelInvoiceSettingConditionInput | null,
};

export type DeleteInvoiceSettingMutation = {
  deleteInvoiceSetting?:  {
    __typename: "InvoiceSetting",
    id: string,
    creditNoteFormat: string,
    creditNoteLastUpdate: string,
    creditNoteIncrementNumber: number,
    invoiceFormat: string,
    invoiceLastUpdate: string,
    invoiceIncrementNumber: number,
    paymentRequestFormat: string,
    paymentRequestLastUpdate: string,
    paymentRequestIncrementNumber: number,
    receiptFormat: string,
    receiptLastUpdate: string,
    receiptIncrementNumber: number,
    variousOperationFormat: string,
    variousOperationLastUpdate: string,
    variousOperationIncrementNumber: number,
    customInvoicingConfiguration?: boolean | null,
    defaultVatRateId?: string | null,
    fiscalYearStart?: string | null,
    allPurposeInvoiceIssuer?: boolean | null,
    paymentBankAccountId?: string | null,
    ownerId: string,
    owner?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateLeaseMutationVariables = {
  input: CreateLeaseInput,
  condition?: ModelLeaseConditionInput | null,
};

export type CreateLeaseMutation = {
  createLease?:  {
    __typename: "Lease",
    id: string,
    advancedChargesInvoices?:  {
      __typename: "LeaseAdvancedChargesInvoice",
      communicationSettingsProfileId: string,
      invoiceSenderId: string,
      lastDraftInvoiceDate?: string | null,
      lastInvoiceDate?: string | null,
      paymentFrequency: LeasePaymentFrequency,
      paymentInvoicePeriod: LeasePaymentInvoicePeriod,
      paymentInvoicePeriodCustomDay?: number | null,
      remittanceInformation?: string | null,
      remittanceInformationType?: LeaseRemittanceType | null,
      bankAccountId?: string | null,
    } | null,
    balance?: number | null,
    canBeExtended?: boolean | null,
    communicationSettingsProfileId: string,
    createdAt?: string | null,
    customValues?:  Array< {
      __typename: "CustomValue",
      name: string,
      value: string,
    } > | null,
    endDate: string,
    includeRealEstateInLeaseContract?: boolean | null,
    attachStatementSupportingDocuments?: boolean | null,
    invoiceSenderId: string,
    invoiceSender?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    inventoryOfFixturesExpert?: string | null,
    inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
    inventoryOfFixturesType?: InventoryOfFixturesType | null,
    ipiNumber?: string | null,
    language: Language,
    lastDraftInvoiceDate?: string | null,
    lastIndexationProcessDate?: string | null,
    lastInvoiceDate?: string | null,
    legalCompetentAuthority?: string | null,
    name: string,
    notes?: string | null,
    paymentFrequency: LeasePaymentFrequency,
    paymentInvoicePeriod: LeasePaymentInvoicePeriod,
    paymentInvoicePeriodCustomDay?: number | null,
    paymentOption?:  {
      __typename: "LeasePaymentOption",
      customerId?: string | null,
      enabled: boolean,
      mandateActivatedAt?: string | null,
      mandateStatus?: PaymentProviderMandateStatus | null,
      paymentMethodId?: string | null,
      qrType?: LeaseQrType | null,
    } | null,
    purchaseOrderNumber?: string | null,
    realEstateAgency?: string | null,
    realEstateTax?: number | null,
    remittanceInformation?: string | null,
    remittanceInformationType?: LeaseRemittanceType | null,
    rentalGuaranty?:  {
      __typename: "LeaseRentalGuaranty",
      amount: number,
      blockedAmount?: number | null,
      releasedAmount?: number | null,
      type: LeaseRentalGuarantyType,
      financialInstitution?: string | null,
    } | null,
    signatureDate?: string | null,
    startDate: string,
    nextIndexationMonth?: string | null,
    nextIndexation?: boolean | null,
    status: LeaseStatus,
    technicCommunicationSettingsProfileId: string,
    totalInitialRentalPrice: number,
    totalRentalPrice: number,
    type: LeaseType,
    subletting?: boolean | null,
    vatRateRentId?: string | null,
    vatRateRent?:  {
      __typename: "VatRate",
      id: string,
      country: string,
      label: string,
      value?: number | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      ownerId?: string | null,
      owner?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    additionalClauses?:  {
      __typename: "ModelLeaseAdditionalClauseConnection",
      items:  Array< {
        __typename: "LeaseAdditionalClause",
        id: string,
        leaseId: string,
        title?: string | null,
        body: string,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    bankAccountId?: string | null,
    bankAccount?:  {
      __typename: "BankAccount",
      id: string,
      contactId: string,
      contact?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      number: string,
      bicNumber?: string | null,
      bankName?: string | null,
      contactIds?: Array< string > | null,
      buildingIds?: Array< string > | null,
      holderName?: string | null,
      label?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      disabled?: boolean | null,
      integrations?: Array< IntegrationName > | null,
      matchingRule?: BankAccountMatchingRule | null,
      balance?: number | null,
      balanceDate?: string | null,
      type: BankAccountType,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    contacts?:  {
      __typename: "ModelLeaseContactConnection",
      items:  Array< {
        __typename: "LeaseContact",
        id: string,
        leaseId: string,
        contactId: string,
        contactRole: ContactType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    files?:  {
      __typename: "ModelFileConnection",
      items:  Array< {
        __typename: "File",
        id: string,
        bucket: string,
        createdAt?: string | null,
        categoryId: string,
        foreignKey: string,
        foreignTableName: string,
        key: string,
        mimeType?: string | null,
        region: string,
        size?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        _ttl?: number | null,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    leaseActionHistories?:  {
      __typename: "ModelLeaseActionHistoryConnection",
      items:  Array< {
        __typename: "LeaseActionHistory",
        id: string,
        action: LeaseAction,
        comment?: string | null,
        contactId: string,
        createdAt?: string | null,
        leaseId: string,
        communicationId?: string | null,
        signatureDocumentId?: string | null,
        status?: LeaseActionHistoryStatus | null,
        communicationChannel?: CommunicationChannel | null,
        communicationSendDate?: string | null,
        communicationByPlatform?: boolean | null,
        endReason?: LeaseActionEndReason | null,
        endReasonOwnUseRelation?: string | null,
        endReasonOwnUseName?: string | null,
        initiator?: LeaseActionEndInitiator | null,
        totalAmount?: number | null,
        totalAmountLabel?: string | null,
        automatic?: boolean | null,
        hasLeaseTypeChanged?: boolean | null,
        jiraId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    leasePriceHistories?:  {
      __typename: "ModelLeasePriceHistoryConnection",
      items:  Array< {
        __typename: "LeasePriceHistory",
        id: string,
        previousTotalRentalPrice: number,
        totalRentalPrice: number,
        optimalTotalRentalPrice?: number | null,
        optimalTotalMonthlyCharges?: number | null,
        applicationDate: string,
        status: LeaseAmountUpdateStatus,
        comment?: string | null,
        type: LeasePriceHistoryType,
        communicationId?: string | null,
        leaseId: string,
        createdAt?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    signatureDocuments?:  {
      __typename: "ModelSignatureDocumentConnection",
      items:  Array< {
        __typename: "SignatureDocument",
        id: string,
        additionalMessage?: string | null,
        automaticRemindersDisabled?: boolean | null,
        communicationBody?: string | null,
        createdAt?: string | null,
        expirationDate?: string | null,
        fileIds?: Array< string > | null,
        foreignKey: string,
        foreignTableName: string,
        sentAt?: string | null,
        signatureMethods: Array< SignatureType >,
        status: SignatureDocumentStatus,
        externalStatus?: string | null,
        type: SignatureDocumentType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    units?:  {
      __typename: "ModelUnitLeaseConnection",
      items:  Array< {
        __typename: "UnitLease",
        id: string,
        allowChargeAdjustment?: boolean | null,
        authorizeProfessionalActivity?: boolean | null,
        chargesIndexation?: boolean | null,
        createdAt?: string | null,
        endDate: string,
        furnishedRental?: boolean | null,
        furnishedRentalInsuranceByTenant?: boolean | null,
        furnishedRentalRentalPricePercentage?: number | null,
        initialRentalPrice: number,
        indexation?: boolean | null,
        advancedIndexation?: boolean | null,
        indexType?: IndexType | null,
        baseYear?: number | null,
        baseIndexType?: BaseIndexType | null,
        baseIndexDate?: string | null,
        nextIndexationMonth?: string | null,
        nextIndexation?: boolean | null,
        leaseId: string,
        mainUnit: boolean,
        rentalPrice: number,
        signatureDate?: string | null,
        startDate: string,
        unitId: string,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    variousOperations?:  {
      __typename: "ModelLeaseVariousOperationConnection",
      items:  Array< {
        __typename: "LeaseVariousOperation",
        id: string,
        accountLabelIds?: Array< string > | null,
        amount: number,
        contactId: string,
        createdAt: string,
        endDate: string,
        invoiceSenderId?: string | null,
        label?: string | null,
        lastInvoiceDate?: string | null,
        leaseId: string,
        operationType: LeaseVariousOperationType,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        reason?: string | null,
        separateInvoice: boolean,
        startDate: string,
        type: VariousOperationType,
        unitId: string,
        vatRateId?: string | null,
        readId: string,
        readers?: Array< string > | null,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    readers?: Array< string > | null,
    readId: string,
    clientId: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateLeaseMutationVariables = {
  input: UpdateLeaseInput,
  condition?: ModelLeaseConditionInput | null,
};

export type UpdateLeaseMutation = {
  updateLease?:  {
    __typename: "Lease",
    id: string,
    advancedChargesInvoices?:  {
      __typename: "LeaseAdvancedChargesInvoice",
      communicationSettingsProfileId: string,
      invoiceSenderId: string,
      lastDraftInvoiceDate?: string | null,
      lastInvoiceDate?: string | null,
      paymentFrequency: LeasePaymentFrequency,
      paymentInvoicePeriod: LeasePaymentInvoicePeriod,
      paymentInvoicePeriodCustomDay?: number | null,
      remittanceInformation?: string | null,
      remittanceInformationType?: LeaseRemittanceType | null,
      bankAccountId?: string | null,
    } | null,
    balance?: number | null,
    canBeExtended?: boolean | null,
    communicationSettingsProfileId: string,
    createdAt?: string | null,
    customValues?:  Array< {
      __typename: "CustomValue",
      name: string,
      value: string,
    } > | null,
    endDate: string,
    includeRealEstateInLeaseContract?: boolean | null,
    attachStatementSupportingDocuments?: boolean | null,
    invoiceSenderId: string,
    invoiceSender?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    inventoryOfFixturesExpert?: string | null,
    inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
    inventoryOfFixturesType?: InventoryOfFixturesType | null,
    ipiNumber?: string | null,
    language: Language,
    lastDraftInvoiceDate?: string | null,
    lastIndexationProcessDate?: string | null,
    lastInvoiceDate?: string | null,
    legalCompetentAuthority?: string | null,
    name: string,
    notes?: string | null,
    paymentFrequency: LeasePaymentFrequency,
    paymentInvoicePeriod: LeasePaymentInvoicePeriod,
    paymentInvoicePeriodCustomDay?: number | null,
    paymentOption?:  {
      __typename: "LeasePaymentOption",
      customerId?: string | null,
      enabled: boolean,
      mandateActivatedAt?: string | null,
      mandateStatus?: PaymentProviderMandateStatus | null,
      paymentMethodId?: string | null,
      qrType?: LeaseQrType | null,
    } | null,
    purchaseOrderNumber?: string | null,
    realEstateAgency?: string | null,
    realEstateTax?: number | null,
    remittanceInformation?: string | null,
    remittanceInformationType?: LeaseRemittanceType | null,
    rentalGuaranty?:  {
      __typename: "LeaseRentalGuaranty",
      amount: number,
      blockedAmount?: number | null,
      releasedAmount?: number | null,
      type: LeaseRentalGuarantyType,
      financialInstitution?: string | null,
    } | null,
    signatureDate?: string | null,
    startDate: string,
    nextIndexationMonth?: string | null,
    nextIndexation?: boolean | null,
    status: LeaseStatus,
    technicCommunicationSettingsProfileId: string,
    totalInitialRentalPrice: number,
    totalRentalPrice: number,
    type: LeaseType,
    subletting?: boolean | null,
    vatRateRentId?: string | null,
    vatRateRent?:  {
      __typename: "VatRate",
      id: string,
      country: string,
      label: string,
      value?: number | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      ownerId?: string | null,
      owner?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    additionalClauses?:  {
      __typename: "ModelLeaseAdditionalClauseConnection",
      items:  Array< {
        __typename: "LeaseAdditionalClause",
        id: string,
        leaseId: string,
        title?: string | null,
        body: string,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    bankAccountId?: string | null,
    bankAccount?:  {
      __typename: "BankAccount",
      id: string,
      contactId: string,
      contact?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      number: string,
      bicNumber?: string | null,
      bankName?: string | null,
      contactIds?: Array< string > | null,
      buildingIds?: Array< string > | null,
      holderName?: string | null,
      label?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      disabled?: boolean | null,
      integrations?: Array< IntegrationName > | null,
      matchingRule?: BankAccountMatchingRule | null,
      balance?: number | null,
      balanceDate?: string | null,
      type: BankAccountType,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    contacts?:  {
      __typename: "ModelLeaseContactConnection",
      items:  Array< {
        __typename: "LeaseContact",
        id: string,
        leaseId: string,
        contactId: string,
        contactRole: ContactType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    files?:  {
      __typename: "ModelFileConnection",
      items:  Array< {
        __typename: "File",
        id: string,
        bucket: string,
        createdAt?: string | null,
        categoryId: string,
        foreignKey: string,
        foreignTableName: string,
        key: string,
        mimeType?: string | null,
        region: string,
        size?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        _ttl?: number | null,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    leaseActionHistories?:  {
      __typename: "ModelLeaseActionHistoryConnection",
      items:  Array< {
        __typename: "LeaseActionHistory",
        id: string,
        action: LeaseAction,
        comment?: string | null,
        contactId: string,
        createdAt?: string | null,
        leaseId: string,
        communicationId?: string | null,
        signatureDocumentId?: string | null,
        status?: LeaseActionHistoryStatus | null,
        communicationChannel?: CommunicationChannel | null,
        communicationSendDate?: string | null,
        communicationByPlatform?: boolean | null,
        endReason?: LeaseActionEndReason | null,
        endReasonOwnUseRelation?: string | null,
        endReasonOwnUseName?: string | null,
        initiator?: LeaseActionEndInitiator | null,
        totalAmount?: number | null,
        totalAmountLabel?: string | null,
        automatic?: boolean | null,
        hasLeaseTypeChanged?: boolean | null,
        jiraId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    leasePriceHistories?:  {
      __typename: "ModelLeasePriceHistoryConnection",
      items:  Array< {
        __typename: "LeasePriceHistory",
        id: string,
        previousTotalRentalPrice: number,
        totalRentalPrice: number,
        optimalTotalRentalPrice?: number | null,
        optimalTotalMonthlyCharges?: number | null,
        applicationDate: string,
        status: LeaseAmountUpdateStatus,
        comment?: string | null,
        type: LeasePriceHistoryType,
        communicationId?: string | null,
        leaseId: string,
        createdAt?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    signatureDocuments?:  {
      __typename: "ModelSignatureDocumentConnection",
      items:  Array< {
        __typename: "SignatureDocument",
        id: string,
        additionalMessage?: string | null,
        automaticRemindersDisabled?: boolean | null,
        communicationBody?: string | null,
        createdAt?: string | null,
        expirationDate?: string | null,
        fileIds?: Array< string > | null,
        foreignKey: string,
        foreignTableName: string,
        sentAt?: string | null,
        signatureMethods: Array< SignatureType >,
        status: SignatureDocumentStatus,
        externalStatus?: string | null,
        type: SignatureDocumentType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    units?:  {
      __typename: "ModelUnitLeaseConnection",
      items:  Array< {
        __typename: "UnitLease",
        id: string,
        allowChargeAdjustment?: boolean | null,
        authorizeProfessionalActivity?: boolean | null,
        chargesIndexation?: boolean | null,
        createdAt?: string | null,
        endDate: string,
        furnishedRental?: boolean | null,
        furnishedRentalInsuranceByTenant?: boolean | null,
        furnishedRentalRentalPricePercentage?: number | null,
        initialRentalPrice: number,
        indexation?: boolean | null,
        advancedIndexation?: boolean | null,
        indexType?: IndexType | null,
        baseYear?: number | null,
        baseIndexType?: BaseIndexType | null,
        baseIndexDate?: string | null,
        nextIndexationMonth?: string | null,
        nextIndexation?: boolean | null,
        leaseId: string,
        mainUnit: boolean,
        rentalPrice: number,
        signatureDate?: string | null,
        startDate: string,
        unitId: string,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    variousOperations?:  {
      __typename: "ModelLeaseVariousOperationConnection",
      items:  Array< {
        __typename: "LeaseVariousOperation",
        id: string,
        accountLabelIds?: Array< string > | null,
        amount: number,
        contactId: string,
        createdAt: string,
        endDate: string,
        invoiceSenderId?: string | null,
        label?: string | null,
        lastInvoiceDate?: string | null,
        leaseId: string,
        operationType: LeaseVariousOperationType,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        reason?: string | null,
        separateInvoice: boolean,
        startDate: string,
        type: VariousOperationType,
        unitId: string,
        vatRateId?: string | null,
        readId: string,
        readers?: Array< string > | null,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    readers?: Array< string > | null,
    readId: string,
    clientId: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteLeaseMutationVariables = {
  input: DeleteLeaseInput,
  condition?: ModelLeaseConditionInput | null,
};

export type DeleteLeaseMutation = {
  deleteLease?:  {
    __typename: "Lease",
    id: string,
    advancedChargesInvoices?:  {
      __typename: "LeaseAdvancedChargesInvoice",
      communicationSettingsProfileId: string,
      invoiceSenderId: string,
      lastDraftInvoiceDate?: string | null,
      lastInvoiceDate?: string | null,
      paymentFrequency: LeasePaymentFrequency,
      paymentInvoicePeriod: LeasePaymentInvoicePeriod,
      paymentInvoicePeriodCustomDay?: number | null,
      remittanceInformation?: string | null,
      remittanceInformationType?: LeaseRemittanceType | null,
      bankAccountId?: string | null,
    } | null,
    balance?: number | null,
    canBeExtended?: boolean | null,
    communicationSettingsProfileId: string,
    createdAt?: string | null,
    customValues?:  Array< {
      __typename: "CustomValue",
      name: string,
      value: string,
    } > | null,
    endDate: string,
    includeRealEstateInLeaseContract?: boolean | null,
    attachStatementSupportingDocuments?: boolean | null,
    invoiceSenderId: string,
    invoiceSender?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    inventoryOfFixturesExpert?: string | null,
    inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
    inventoryOfFixturesType?: InventoryOfFixturesType | null,
    ipiNumber?: string | null,
    language: Language,
    lastDraftInvoiceDate?: string | null,
    lastIndexationProcessDate?: string | null,
    lastInvoiceDate?: string | null,
    legalCompetentAuthority?: string | null,
    name: string,
    notes?: string | null,
    paymentFrequency: LeasePaymentFrequency,
    paymentInvoicePeriod: LeasePaymentInvoicePeriod,
    paymentInvoicePeriodCustomDay?: number | null,
    paymentOption?:  {
      __typename: "LeasePaymentOption",
      customerId?: string | null,
      enabled: boolean,
      mandateActivatedAt?: string | null,
      mandateStatus?: PaymentProviderMandateStatus | null,
      paymentMethodId?: string | null,
      qrType?: LeaseQrType | null,
    } | null,
    purchaseOrderNumber?: string | null,
    realEstateAgency?: string | null,
    realEstateTax?: number | null,
    remittanceInformation?: string | null,
    remittanceInformationType?: LeaseRemittanceType | null,
    rentalGuaranty?:  {
      __typename: "LeaseRentalGuaranty",
      amount: number,
      blockedAmount?: number | null,
      releasedAmount?: number | null,
      type: LeaseRentalGuarantyType,
      financialInstitution?: string | null,
    } | null,
    signatureDate?: string | null,
    startDate: string,
    nextIndexationMonth?: string | null,
    nextIndexation?: boolean | null,
    status: LeaseStatus,
    technicCommunicationSettingsProfileId: string,
    totalInitialRentalPrice: number,
    totalRentalPrice: number,
    type: LeaseType,
    subletting?: boolean | null,
    vatRateRentId?: string | null,
    vatRateRent?:  {
      __typename: "VatRate",
      id: string,
      country: string,
      label: string,
      value?: number | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      ownerId?: string | null,
      owner?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    additionalClauses?:  {
      __typename: "ModelLeaseAdditionalClauseConnection",
      items:  Array< {
        __typename: "LeaseAdditionalClause",
        id: string,
        leaseId: string,
        title?: string | null,
        body: string,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    bankAccountId?: string | null,
    bankAccount?:  {
      __typename: "BankAccount",
      id: string,
      contactId: string,
      contact?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      number: string,
      bicNumber?: string | null,
      bankName?: string | null,
      contactIds?: Array< string > | null,
      buildingIds?: Array< string > | null,
      holderName?: string | null,
      label?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      disabled?: boolean | null,
      integrations?: Array< IntegrationName > | null,
      matchingRule?: BankAccountMatchingRule | null,
      balance?: number | null,
      balanceDate?: string | null,
      type: BankAccountType,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    contacts?:  {
      __typename: "ModelLeaseContactConnection",
      items:  Array< {
        __typename: "LeaseContact",
        id: string,
        leaseId: string,
        contactId: string,
        contactRole: ContactType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    files?:  {
      __typename: "ModelFileConnection",
      items:  Array< {
        __typename: "File",
        id: string,
        bucket: string,
        createdAt?: string | null,
        categoryId: string,
        foreignKey: string,
        foreignTableName: string,
        key: string,
        mimeType?: string | null,
        region: string,
        size?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        _ttl?: number | null,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    leaseActionHistories?:  {
      __typename: "ModelLeaseActionHistoryConnection",
      items:  Array< {
        __typename: "LeaseActionHistory",
        id: string,
        action: LeaseAction,
        comment?: string | null,
        contactId: string,
        createdAt?: string | null,
        leaseId: string,
        communicationId?: string | null,
        signatureDocumentId?: string | null,
        status?: LeaseActionHistoryStatus | null,
        communicationChannel?: CommunicationChannel | null,
        communicationSendDate?: string | null,
        communicationByPlatform?: boolean | null,
        endReason?: LeaseActionEndReason | null,
        endReasonOwnUseRelation?: string | null,
        endReasonOwnUseName?: string | null,
        initiator?: LeaseActionEndInitiator | null,
        totalAmount?: number | null,
        totalAmountLabel?: string | null,
        automatic?: boolean | null,
        hasLeaseTypeChanged?: boolean | null,
        jiraId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    leasePriceHistories?:  {
      __typename: "ModelLeasePriceHistoryConnection",
      items:  Array< {
        __typename: "LeasePriceHistory",
        id: string,
        previousTotalRentalPrice: number,
        totalRentalPrice: number,
        optimalTotalRentalPrice?: number | null,
        optimalTotalMonthlyCharges?: number | null,
        applicationDate: string,
        status: LeaseAmountUpdateStatus,
        comment?: string | null,
        type: LeasePriceHistoryType,
        communicationId?: string | null,
        leaseId: string,
        createdAt?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    signatureDocuments?:  {
      __typename: "ModelSignatureDocumentConnection",
      items:  Array< {
        __typename: "SignatureDocument",
        id: string,
        additionalMessage?: string | null,
        automaticRemindersDisabled?: boolean | null,
        communicationBody?: string | null,
        createdAt?: string | null,
        expirationDate?: string | null,
        fileIds?: Array< string > | null,
        foreignKey: string,
        foreignTableName: string,
        sentAt?: string | null,
        signatureMethods: Array< SignatureType >,
        status: SignatureDocumentStatus,
        externalStatus?: string | null,
        type: SignatureDocumentType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    units?:  {
      __typename: "ModelUnitLeaseConnection",
      items:  Array< {
        __typename: "UnitLease",
        id: string,
        allowChargeAdjustment?: boolean | null,
        authorizeProfessionalActivity?: boolean | null,
        chargesIndexation?: boolean | null,
        createdAt?: string | null,
        endDate: string,
        furnishedRental?: boolean | null,
        furnishedRentalInsuranceByTenant?: boolean | null,
        furnishedRentalRentalPricePercentage?: number | null,
        initialRentalPrice: number,
        indexation?: boolean | null,
        advancedIndexation?: boolean | null,
        indexType?: IndexType | null,
        baseYear?: number | null,
        baseIndexType?: BaseIndexType | null,
        baseIndexDate?: string | null,
        nextIndexationMonth?: string | null,
        nextIndexation?: boolean | null,
        leaseId: string,
        mainUnit: boolean,
        rentalPrice: number,
        signatureDate?: string | null,
        startDate: string,
        unitId: string,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    variousOperations?:  {
      __typename: "ModelLeaseVariousOperationConnection",
      items:  Array< {
        __typename: "LeaseVariousOperation",
        id: string,
        accountLabelIds?: Array< string > | null,
        amount: number,
        contactId: string,
        createdAt: string,
        endDate: string,
        invoiceSenderId?: string | null,
        label?: string | null,
        lastInvoiceDate?: string | null,
        leaseId: string,
        operationType: LeaseVariousOperationType,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        reason?: string | null,
        separateInvoice: boolean,
        startDate: string,
        type: VariousOperationType,
        unitId: string,
        vatRateId?: string | null,
        readId: string,
        readers?: Array< string > | null,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    readers?: Array< string > | null,
    readId: string,
    clientId: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateLeaseActionHistoryMutationVariables = {
  input: CreateLeaseActionHistoryInput,
  condition?: ModelLeaseActionHistoryConditionInput | null,
};

export type CreateLeaseActionHistoryMutation = {
  createLeaseActionHistory?:  {
    __typename: "LeaseActionHistory",
    id: string,
    action: LeaseAction,
    comment?: string | null,
    contactId: string,
    createdAt?: string | null,
    createdBy?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    historyDetails:  Array< {
      __typename: "LeaseActionHistoryDetail",
      unitId: string,
      newEndDate?: string | null,
      newSignatureDate?: string | null,
      newStartDate?: string | null,
      previousEndDate?: string | null,
      previousSignatureDate?: string | null,
      previousStartDate?: string | null,
    } >,
    leaseId: string,
    lease?:  {
      __typename: "Lease",
      id: string,
      advancedChargesInvoices?:  {
        __typename: "LeaseAdvancedChargesInvoice",
        communicationSettingsProfileId: string,
        invoiceSenderId: string,
        lastDraftInvoiceDate?: string | null,
        lastInvoiceDate?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        bankAccountId?: string | null,
      } | null,
      balance?: number | null,
      canBeExtended?: boolean | null,
      communicationSettingsProfileId: string,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      endDate: string,
      includeRealEstateInLeaseContract?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      invoiceSenderId: string,
      invoiceSender?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      inventoryOfFixturesExpert?: string | null,
      inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
      inventoryOfFixturesType?: InventoryOfFixturesType | null,
      ipiNumber?: string | null,
      language: Language,
      lastDraftInvoiceDate?: string | null,
      lastIndexationProcessDate?: string | null,
      lastInvoiceDate?: string | null,
      legalCompetentAuthority?: string | null,
      name: string,
      notes?: string | null,
      paymentFrequency: LeasePaymentFrequency,
      paymentInvoicePeriod: LeasePaymentInvoicePeriod,
      paymentInvoicePeriodCustomDay?: number | null,
      paymentOption?:  {
        __typename: "LeasePaymentOption",
        customerId?: string | null,
        enabled: boolean,
        mandateActivatedAt?: string | null,
        mandateStatus?: PaymentProviderMandateStatus | null,
        paymentMethodId?: string | null,
        qrType?: LeaseQrType | null,
      } | null,
      purchaseOrderNumber?: string | null,
      realEstateAgency?: string | null,
      realEstateTax?: number | null,
      remittanceInformation?: string | null,
      remittanceInformationType?: LeaseRemittanceType | null,
      rentalGuaranty?:  {
        __typename: "LeaseRentalGuaranty",
        amount: number,
        blockedAmount?: number | null,
        releasedAmount?: number | null,
        type: LeaseRentalGuarantyType,
        financialInstitution?: string | null,
      } | null,
      signatureDate?: string | null,
      startDate: string,
      nextIndexationMonth?: string | null,
      nextIndexation?: boolean | null,
      status: LeaseStatus,
      technicCommunicationSettingsProfileId: string,
      totalInitialRentalPrice: number,
      totalRentalPrice: number,
      type: LeaseType,
      subletting?: boolean | null,
      vatRateRentId?: string | null,
      vatRateRent?:  {
        __typename: "VatRate",
        id: string,
        country: string,
        label: string,
        value?: number | null,
        ownerId?: string | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      additionalClauses?:  {
        __typename: "ModelLeaseAdditionalClauseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      bankAccountId?: string | null,
      bankAccount?:  {
        __typename: "BankAccount",
        id: string,
        contactId: string,
        number: string,
        bicNumber?: string | null,
        bankName?: string | null,
        contactIds?: Array< string > | null,
        buildingIds?: Array< string > | null,
        holderName?: string | null,
        label?: string | null,
        disabled?: boolean | null,
        integrations?: Array< IntegrationName > | null,
        matchingRule?: BankAccountMatchingRule | null,
        balance?: number | null,
        balanceDate?: string | null,
        type: BankAccountType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contacts?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      files?:  {
        __typename: "ModelFileConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leaseActionHistories?:  {
        __typename: "ModelLeaseActionHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leasePriceHistories?:  {
        __typename: "ModelLeasePriceHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      signatureDocuments?:  {
        __typename: "ModelSignatureDocumentConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      variousOperations?:  {
        __typename: "ModelLeaseVariousOperationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    communicationId?: string | null,
    communication?:  {
      __typename: "Communication",
      id: string,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      blockedRecipients?:  Array< {
        __typename: "CommunicationBlockedRecipient",
        recipient: string,
        bounceType: BounceType,
      } > | null,
      body: string,
      buildingId?: string | null,
      channel: CommunicationChannel,
      communicationTemplateId?: string | null,
      concernedContactIds?: Array< string > | null,
      contactId?: string | null,
      contactIds?: Array< string > | null,
      createdAt?: string | null,
      draftProperties?:  {
        __typename: "CommunicationDraftProperties",
        allowRecipientsToSeeEachOther?: boolean | null,
        bcc?: Array< string > | null,
        buildingIds?: Array< string > | null,
        cc?: Array< string > | null,
        contactIds?: Array< string > | null,
        contactTypes?: Array< ContactType > | null,
        entityType: string,
        leaseIds?: Array< string > | null,
        sendInBcc?: boolean | null,
        unitIds?: Array< string > | null,
        unitTypeFilter?: string | null,
      } | null,
      expirationDate?: string | null,
      files?:  {
        __typename: "ModelFileConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      invoice?:  {
        __typename: "Invoice",
        id: string,
        amount: number,
        bankAccountId: string,
        communicationId?: string | null,
        createdAt: string,
        creditNote?: boolean | null,
        creditNoteLabel?: string | null,
        dueDate?: string | null,
        invoiceDate: string,
        invoiceNumber?: string | null,
        ownerId?: string | null,
        invoiceSenderId: string,
        leaseId?: string | null,
        paid: boolean,
        postedDate?: string | null,
        receiptNumber?: string | null,
        reminderDates?: Array< string > | null,
        remittanceInformation?: string | null,
        statementId?: string | null,
        status: InvoiceStatus,
        type: InvoiceType,
        unitId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      invoiceId?: string | null,
      lease?:  {
        __typename: "Lease",
        id: string,
        balance?: number | null,
        canBeExtended?: boolean | null,
        communicationSettingsProfileId: string,
        createdAt?: string | null,
        endDate: string,
        includeRealEstateInLeaseContract?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        invoiceSenderId: string,
        inventoryOfFixturesExpert?: string | null,
        inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
        inventoryOfFixturesType?: InventoryOfFixturesType | null,
        ipiNumber?: string | null,
        language: Language,
        lastIndexationProcessDate?: string | null,
        lastInvoiceDate?: string | null,
        legalCompetentAuthority?: string | null,
        name: string,
        notes?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        realEstateAgency?: string | null,
        realEstateTax?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        signatureDate?: string | null,
        startDate: string,
        nextIndexationMonth?: string | null,
        nextIndexation?: boolean | null,
        status: LeaseStatus,
        technicCommunicationSettingsProfileId: string,
        totalInitialRentalPrice: number,
        totalRentalPrice: number,
        type: LeaseType,
        subletting?: boolean | null,
        vatRateRentId?: string | null,
        bankAccountId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      leaseId?: string | null,
      leasePriceHistoryId?: string | null,
      leasePriceHistory?:  {
        __typename: "LeasePriceHistory",
        id: string,
        previousTotalRentalPrice: number,
        totalRentalPrice: number,
        optimalTotalRentalPrice?: number | null,
        optimalTotalMonthlyCharges?: number | null,
        applicationDate: string,
        status: LeaseAmountUpdateStatus,
        comment?: string | null,
        type: LeasePriceHistoryType,
        communicationId?: string | null,
        leaseId: string,
        createdAt?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      letterTrackingCode?: string | null,
      letterTrackingProvider?: TrackingProvider | null,
      linkedCommunicationsIds?: Array< string > | null,
      supportingDocumentFileIds?: Array< string > | null,
      recipient?: string | null,
      recipientContactIdsInBcc?: Array< string > | null,
      recipientContactIdsInCc?: Array< string > | null,
      recipientInBcc?: string | null,
      recipientInCc?: string | null,
      scheduledAt?: string | null,
      deliveredAt?: string | null,
      errorCode?: CommunicationErrorCode | null,
      nextRetryAt?: string | null,
      sendRetryCount?: number | null,
      sender?: string | null,
      sentAt?: string | null,
      externalId?: string | null,
      externalStatus?: string | null,
      signatureDocumentId?: string | null,
      signatureDocument?:  {
        __typename: "SignatureDocument",
        id: string,
        additionalMessage?: string | null,
        automaticRemindersDisabled?: boolean | null,
        communicationBody?: string | null,
        createdAt?: string | null,
        expirationDate?: string | null,
        fileIds?: Array< string > | null,
        foreignKey: string,
        foreignTableName: string,
        sentAt?: string | null,
        signatureMethods: Array< SignatureType >,
        status: SignatureDocumentStatus,
        externalStatus?: string | null,
        type: SignatureDocumentType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      snoozedDate?: string | null,
      statement?:  {
        __typename: "Statement",
        id: string,
        closingStatement: boolean,
        periodFrom: string,
        periodTo: string,
        attachSupportingDocuments?: boolean | null,
        selectedPocketKeys?: Array< string > | null,
        source: StatementSource,
        status: StatementStatus,
        sentDate?: string | null,
        leaseId?: string | null,
        ownerId?: string | null,
        types?: Array< StatementType > | null,
        viewType: StatementViewType,
        unitIds?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      statementId?: string | null,
      status: CommunicationStatus,
      subject: string,
      toSend: boolean,
      hideLogo?: boolean | null,
      type: CommunicationType,
      _ttl?: number | null,
      unit?:  {
        __typename: "Unit",
        id: string,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        acquisitionValue?: number | null,
        advertisedMonthlyCharges?: number | null,
        advertisedRentalPrice?: number | null,
        cadastralIncome?: number | null,
        createdAt?: string | null,
        floor?: number | null,
        jointOwnershipId?: string | null,
        managementDate: string,
        name: string,
        notes?: string | null,
        predictedPrice?: string | null,
        propertyTax?: number | null,
        publishAddress?: boolean | null,
        surface?: number | null,
        type: UnitType,
        buildingId: string,
        unitAdvertisementId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      unitId?: string | null,
      readId: string,
      readers?: Array< string > | null,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    signatureDocumentId?: string | null,
    signatureDocument?:  {
      __typename: "SignatureDocument",
      id: string,
      additionalMessage?: string | null,
      automaticRemindersDisabled?: boolean | null,
      communicationBody?: string | null,
      createdAt?: string | null,
      expirationDate?: string | null,
      fileIds?: Array< string > | null,
      foreignKey: string,
      foreignTableName: string,
      sentAt?: string | null,
      signatureMethods: Array< SignatureType >,
      signatureResults:  Array< {
        __typename: "SignatureDocumentResult",
        openedDate?: string | null,
        signedDate?: string | null,
        signed?: boolean | null,
        signatureLink?: string | null,
        rejectReason?: string | null,
        lastSignInviteSentDate?: string | null,
        reminderDates?: Array< string > | null,
        trackingProvider?: TrackingProvider | null,
        trackingCode?: string | null,
        contactId: string,
      } >,
      status: SignatureDocumentStatus,
      externalStatus?: string | null,
      type: SignatureDocumentType,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    status?: LeaseActionHistoryStatus | null,
    communicationChannel?: CommunicationChannel | null,
    communicationSendDate?: string | null,
    communicationByPlatform?: boolean | null,
    endReason?: LeaseActionEndReason | null,
    endReasonOwnUseRelation?: string | null,
    endReasonOwnUseName?: string | null,
    initiator?: LeaseActionEndInitiator | null,
    totalAmount?: number | null,
    totalAmountLabel?: string | null,
    automatic?: boolean | null,
    hasLeaseTypeChanged?: boolean | null,
    jiraId?: string | null,
    readers?: Array< string > | null,
    readId: string,
    clientId: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateLeaseActionHistoryMutationVariables = {
  input: UpdateLeaseActionHistoryInput,
  condition?: ModelLeaseActionHistoryConditionInput | null,
};

export type UpdateLeaseActionHistoryMutation = {
  updateLeaseActionHistory?:  {
    __typename: "LeaseActionHistory",
    id: string,
    action: LeaseAction,
    comment?: string | null,
    contactId: string,
    createdAt?: string | null,
    createdBy?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    historyDetails:  Array< {
      __typename: "LeaseActionHistoryDetail",
      unitId: string,
      newEndDate?: string | null,
      newSignatureDate?: string | null,
      newStartDate?: string | null,
      previousEndDate?: string | null,
      previousSignatureDate?: string | null,
      previousStartDate?: string | null,
    } >,
    leaseId: string,
    lease?:  {
      __typename: "Lease",
      id: string,
      advancedChargesInvoices?:  {
        __typename: "LeaseAdvancedChargesInvoice",
        communicationSettingsProfileId: string,
        invoiceSenderId: string,
        lastDraftInvoiceDate?: string | null,
        lastInvoiceDate?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        bankAccountId?: string | null,
      } | null,
      balance?: number | null,
      canBeExtended?: boolean | null,
      communicationSettingsProfileId: string,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      endDate: string,
      includeRealEstateInLeaseContract?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      invoiceSenderId: string,
      invoiceSender?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      inventoryOfFixturesExpert?: string | null,
      inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
      inventoryOfFixturesType?: InventoryOfFixturesType | null,
      ipiNumber?: string | null,
      language: Language,
      lastDraftInvoiceDate?: string | null,
      lastIndexationProcessDate?: string | null,
      lastInvoiceDate?: string | null,
      legalCompetentAuthority?: string | null,
      name: string,
      notes?: string | null,
      paymentFrequency: LeasePaymentFrequency,
      paymentInvoicePeriod: LeasePaymentInvoicePeriod,
      paymentInvoicePeriodCustomDay?: number | null,
      paymentOption?:  {
        __typename: "LeasePaymentOption",
        customerId?: string | null,
        enabled: boolean,
        mandateActivatedAt?: string | null,
        mandateStatus?: PaymentProviderMandateStatus | null,
        paymentMethodId?: string | null,
        qrType?: LeaseQrType | null,
      } | null,
      purchaseOrderNumber?: string | null,
      realEstateAgency?: string | null,
      realEstateTax?: number | null,
      remittanceInformation?: string | null,
      remittanceInformationType?: LeaseRemittanceType | null,
      rentalGuaranty?:  {
        __typename: "LeaseRentalGuaranty",
        amount: number,
        blockedAmount?: number | null,
        releasedAmount?: number | null,
        type: LeaseRentalGuarantyType,
        financialInstitution?: string | null,
      } | null,
      signatureDate?: string | null,
      startDate: string,
      nextIndexationMonth?: string | null,
      nextIndexation?: boolean | null,
      status: LeaseStatus,
      technicCommunicationSettingsProfileId: string,
      totalInitialRentalPrice: number,
      totalRentalPrice: number,
      type: LeaseType,
      subletting?: boolean | null,
      vatRateRentId?: string | null,
      vatRateRent?:  {
        __typename: "VatRate",
        id: string,
        country: string,
        label: string,
        value?: number | null,
        ownerId?: string | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      additionalClauses?:  {
        __typename: "ModelLeaseAdditionalClauseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      bankAccountId?: string | null,
      bankAccount?:  {
        __typename: "BankAccount",
        id: string,
        contactId: string,
        number: string,
        bicNumber?: string | null,
        bankName?: string | null,
        contactIds?: Array< string > | null,
        buildingIds?: Array< string > | null,
        holderName?: string | null,
        label?: string | null,
        disabled?: boolean | null,
        integrations?: Array< IntegrationName > | null,
        matchingRule?: BankAccountMatchingRule | null,
        balance?: number | null,
        balanceDate?: string | null,
        type: BankAccountType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contacts?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      files?:  {
        __typename: "ModelFileConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leaseActionHistories?:  {
        __typename: "ModelLeaseActionHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leasePriceHistories?:  {
        __typename: "ModelLeasePriceHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      signatureDocuments?:  {
        __typename: "ModelSignatureDocumentConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      variousOperations?:  {
        __typename: "ModelLeaseVariousOperationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    communicationId?: string | null,
    communication?:  {
      __typename: "Communication",
      id: string,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      blockedRecipients?:  Array< {
        __typename: "CommunicationBlockedRecipient",
        recipient: string,
        bounceType: BounceType,
      } > | null,
      body: string,
      buildingId?: string | null,
      channel: CommunicationChannel,
      communicationTemplateId?: string | null,
      concernedContactIds?: Array< string > | null,
      contactId?: string | null,
      contactIds?: Array< string > | null,
      createdAt?: string | null,
      draftProperties?:  {
        __typename: "CommunicationDraftProperties",
        allowRecipientsToSeeEachOther?: boolean | null,
        bcc?: Array< string > | null,
        buildingIds?: Array< string > | null,
        cc?: Array< string > | null,
        contactIds?: Array< string > | null,
        contactTypes?: Array< ContactType > | null,
        entityType: string,
        leaseIds?: Array< string > | null,
        sendInBcc?: boolean | null,
        unitIds?: Array< string > | null,
        unitTypeFilter?: string | null,
      } | null,
      expirationDate?: string | null,
      files?:  {
        __typename: "ModelFileConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      invoice?:  {
        __typename: "Invoice",
        id: string,
        amount: number,
        bankAccountId: string,
        communicationId?: string | null,
        createdAt: string,
        creditNote?: boolean | null,
        creditNoteLabel?: string | null,
        dueDate?: string | null,
        invoiceDate: string,
        invoiceNumber?: string | null,
        ownerId?: string | null,
        invoiceSenderId: string,
        leaseId?: string | null,
        paid: boolean,
        postedDate?: string | null,
        receiptNumber?: string | null,
        reminderDates?: Array< string > | null,
        remittanceInformation?: string | null,
        statementId?: string | null,
        status: InvoiceStatus,
        type: InvoiceType,
        unitId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      invoiceId?: string | null,
      lease?:  {
        __typename: "Lease",
        id: string,
        balance?: number | null,
        canBeExtended?: boolean | null,
        communicationSettingsProfileId: string,
        createdAt?: string | null,
        endDate: string,
        includeRealEstateInLeaseContract?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        invoiceSenderId: string,
        inventoryOfFixturesExpert?: string | null,
        inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
        inventoryOfFixturesType?: InventoryOfFixturesType | null,
        ipiNumber?: string | null,
        language: Language,
        lastIndexationProcessDate?: string | null,
        lastInvoiceDate?: string | null,
        legalCompetentAuthority?: string | null,
        name: string,
        notes?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        realEstateAgency?: string | null,
        realEstateTax?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        signatureDate?: string | null,
        startDate: string,
        nextIndexationMonth?: string | null,
        nextIndexation?: boolean | null,
        status: LeaseStatus,
        technicCommunicationSettingsProfileId: string,
        totalInitialRentalPrice: number,
        totalRentalPrice: number,
        type: LeaseType,
        subletting?: boolean | null,
        vatRateRentId?: string | null,
        bankAccountId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      leaseId?: string | null,
      leasePriceHistoryId?: string | null,
      leasePriceHistory?:  {
        __typename: "LeasePriceHistory",
        id: string,
        previousTotalRentalPrice: number,
        totalRentalPrice: number,
        optimalTotalRentalPrice?: number | null,
        optimalTotalMonthlyCharges?: number | null,
        applicationDate: string,
        status: LeaseAmountUpdateStatus,
        comment?: string | null,
        type: LeasePriceHistoryType,
        communicationId?: string | null,
        leaseId: string,
        createdAt?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      letterTrackingCode?: string | null,
      letterTrackingProvider?: TrackingProvider | null,
      linkedCommunicationsIds?: Array< string > | null,
      supportingDocumentFileIds?: Array< string > | null,
      recipient?: string | null,
      recipientContactIdsInBcc?: Array< string > | null,
      recipientContactIdsInCc?: Array< string > | null,
      recipientInBcc?: string | null,
      recipientInCc?: string | null,
      scheduledAt?: string | null,
      deliveredAt?: string | null,
      errorCode?: CommunicationErrorCode | null,
      nextRetryAt?: string | null,
      sendRetryCount?: number | null,
      sender?: string | null,
      sentAt?: string | null,
      externalId?: string | null,
      externalStatus?: string | null,
      signatureDocumentId?: string | null,
      signatureDocument?:  {
        __typename: "SignatureDocument",
        id: string,
        additionalMessage?: string | null,
        automaticRemindersDisabled?: boolean | null,
        communicationBody?: string | null,
        createdAt?: string | null,
        expirationDate?: string | null,
        fileIds?: Array< string > | null,
        foreignKey: string,
        foreignTableName: string,
        sentAt?: string | null,
        signatureMethods: Array< SignatureType >,
        status: SignatureDocumentStatus,
        externalStatus?: string | null,
        type: SignatureDocumentType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      snoozedDate?: string | null,
      statement?:  {
        __typename: "Statement",
        id: string,
        closingStatement: boolean,
        periodFrom: string,
        periodTo: string,
        attachSupportingDocuments?: boolean | null,
        selectedPocketKeys?: Array< string > | null,
        source: StatementSource,
        status: StatementStatus,
        sentDate?: string | null,
        leaseId?: string | null,
        ownerId?: string | null,
        types?: Array< StatementType > | null,
        viewType: StatementViewType,
        unitIds?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      statementId?: string | null,
      status: CommunicationStatus,
      subject: string,
      toSend: boolean,
      hideLogo?: boolean | null,
      type: CommunicationType,
      _ttl?: number | null,
      unit?:  {
        __typename: "Unit",
        id: string,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        acquisitionValue?: number | null,
        advertisedMonthlyCharges?: number | null,
        advertisedRentalPrice?: number | null,
        cadastralIncome?: number | null,
        createdAt?: string | null,
        floor?: number | null,
        jointOwnershipId?: string | null,
        managementDate: string,
        name: string,
        notes?: string | null,
        predictedPrice?: string | null,
        propertyTax?: number | null,
        publishAddress?: boolean | null,
        surface?: number | null,
        type: UnitType,
        buildingId: string,
        unitAdvertisementId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      unitId?: string | null,
      readId: string,
      readers?: Array< string > | null,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    signatureDocumentId?: string | null,
    signatureDocument?:  {
      __typename: "SignatureDocument",
      id: string,
      additionalMessage?: string | null,
      automaticRemindersDisabled?: boolean | null,
      communicationBody?: string | null,
      createdAt?: string | null,
      expirationDate?: string | null,
      fileIds?: Array< string > | null,
      foreignKey: string,
      foreignTableName: string,
      sentAt?: string | null,
      signatureMethods: Array< SignatureType >,
      signatureResults:  Array< {
        __typename: "SignatureDocumentResult",
        openedDate?: string | null,
        signedDate?: string | null,
        signed?: boolean | null,
        signatureLink?: string | null,
        rejectReason?: string | null,
        lastSignInviteSentDate?: string | null,
        reminderDates?: Array< string > | null,
        trackingProvider?: TrackingProvider | null,
        trackingCode?: string | null,
        contactId: string,
      } >,
      status: SignatureDocumentStatus,
      externalStatus?: string | null,
      type: SignatureDocumentType,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    status?: LeaseActionHistoryStatus | null,
    communicationChannel?: CommunicationChannel | null,
    communicationSendDate?: string | null,
    communicationByPlatform?: boolean | null,
    endReason?: LeaseActionEndReason | null,
    endReasonOwnUseRelation?: string | null,
    endReasonOwnUseName?: string | null,
    initiator?: LeaseActionEndInitiator | null,
    totalAmount?: number | null,
    totalAmountLabel?: string | null,
    automatic?: boolean | null,
    hasLeaseTypeChanged?: boolean | null,
    jiraId?: string | null,
    readers?: Array< string > | null,
    readId: string,
    clientId: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteLeaseActionHistoryMutationVariables = {
  input: DeleteLeaseActionHistoryInput,
  condition?: ModelLeaseActionHistoryConditionInput | null,
};

export type DeleteLeaseActionHistoryMutation = {
  deleteLeaseActionHistory?:  {
    __typename: "LeaseActionHistory",
    id: string,
    action: LeaseAction,
    comment?: string | null,
    contactId: string,
    createdAt?: string | null,
    createdBy?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    historyDetails:  Array< {
      __typename: "LeaseActionHistoryDetail",
      unitId: string,
      newEndDate?: string | null,
      newSignatureDate?: string | null,
      newStartDate?: string | null,
      previousEndDate?: string | null,
      previousSignatureDate?: string | null,
      previousStartDate?: string | null,
    } >,
    leaseId: string,
    lease?:  {
      __typename: "Lease",
      id: string,
      advancedChargesInvoices?:  {
        __typename: "LeaseAdvancedChargesInvoice",
        communicationSettingsProfileId: string,
        invoiceSenderId: string,
        lastDraftInvoiceDate?: string | null,
        lastInvoiceDate?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        bankAccountId?: string | null,
      } | null,
      balance?: number | null,
      canBeExtended?: boolean | null,
      communicationSettingsProfileId: string,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      endDate: string,
      includeRealEstateInLeaseContract?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      invoiceSenderId: string,
      invoiceSender?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      inventoryOfFixturesExpert?: string | null,
      inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
      inventoryOfFixturesType?: InventoryOfFixturesType | null,
      ipiNumber?: string | null,
      language: Language,
      lastDraftInvoiceDate?: string | null,
      lastIndexationProcessDate?: string | null,
      lastInvoiceDate?: string | null,
      legalCompetentAuthority?: string | null,
      name: string,
      notes?: string | null,
      paymentFrequency: LeasePaymentFrequency,
      paymentInvoicePeriod: LeasePaymentInvoicePeriod,
      paymentInvoicePeriodCustomDay?: number | null,
      paymentOption?:  {
        __typename: "LeasePaymentOption",
        customerId?: string | null,
        enabled: boolean,
        mandateActivatedAt?: string | null,
        mandateStatus?: PaymentProviderMandateStatus | null,
        paymentMethodId?: string | null,
        qrType?: LeaseQrType | null,
      } | null,
      purchaseOrderNumber?: string | null,
      realEstateAgency?: string | null,
      realEstateTax?: number | null,
      remittanceInformation?: string | null,
      remittanceInformationType?: LeaseRemittanceType | null,
      rentalGuaranty?:  {
        __typename: "LeaseRentalGuaranty",
        amount: number,
        blockedAmount?: number | null,
        releasedAmount?: number | null,
        type: LeaseRentalGuarantyType,
        financialInstitution?: string | null,
      } | null,
      signatureDate?: string | null,
      startDate: string,
      nextIndexationMonth?: string | null,
      nextIndexation?: boolean | null,
      status: LeaseStatus,
      technicCommunicationSettingsProfileId: string,
      totalInitialRentalPrice: number,
      totalRentalPrice: number,
      type: LeaseType,
      subletting?: boolean | null,
      vatRateRentId?: string | null,
      vatRateRent?:  {
        __typename: "VatRate",
        id: string,
        country: string,
        label: string,
        value?: number | null,
        ownerId?: string | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      additionalClauses?:  {
        __typename: "ModelLeaseAdditionalClauseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      bankAccountId?: string | null,
      bankAccount?:  {
        __typename: "BankAccount",
        id: string,
        contactId: string,
        number: string,
        bicNumber?: string | null,
        bankName?: string | null,
        contactIds?: Array< string > | null,
        buildingIds?: Array< string > | null,
        holderName?: string | null,
        label?: string | null,
        disabled?: boolean | null,
        integrations?: Array< IntegrationName > | null,
        matchingRule?: BankAccountMatchingRule | null,
        balance?: number | null,
        balanceDate?: string | null,
        type: BankAccountType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contacts?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      files?:  {
        __typename: "ModelFileConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leaseActionHistories?:  {
        __typename: "ModelLeaseActionHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leasePriceHistories?:  {
        __typename: "ModelLeasePriceHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      signatureDocuments?:  {
        __typename: "ModelSignatureDocumentConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      variousOperations?:  {
        __typename: "ModelLeaseVariousOperationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    communicationId?: string | null,
    communication?:  {
      __typename: "Communication",
      id: string,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      blockedRecipients?:  Array< {
        __typename: "CommunicationBlockedRecipient",
        recipient: string,
        bounceType: BounceType,
      } > | null,
      body: string,
      buildingId?: string | null,
      channel: CommunicationChannel,
      communicationTemplateId?: string | null,
      concernedContactIds?: Array< string > | null,
      contactId?: string | null,
      contactIds?: Array< string > | null,
      createdAt?: string | null,
      draftProperties?:  {
        __typename: "CommunicationDraftProperties",
        allowRecipientsToSeeEachOther?: boolean | null,
        bcc?: Array< string > | null,
        buildingIds?: Array< string > | null,
        cc?: Array< string > | null,
        contactIds?: Array< string > | null,
        contactTypes?: Array< ContactType > | null,
        entityType: string,
        leaseIds?: Array< string > | null,
        sendInBcc?: boolean | null,
        unitIds?: Array< string > | null,
        unitTypeFilter?: string | null,
      } | null,
      expirationDate?: string | null,
      files?:  {
        __typename: "ModelFileConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      invoice?:  {
        __typename: "Invoice",
        id: string,
        amount: number,
        bankAccountId: string,
        communicationId?: string | null,
        createdAt: string,
        creditNote?: boolean | null,
        creditNoteLabel?: string | null,
        dueDate?: string | null,
        invoiceDate: string,
        invoiceNumber?: string | null,
        ownerId?: string | null,
        invoiceSenderId: string,
        leaseId?: string | null,
        paid: boolean,
        postedDate?: string | null,
        receiptNumber?: string | null,
        reminderDates?: Array< string > | null,
        remittanceInformation?: string | null,
        statementId?: string | null,
        status: InvoiceStatus,
        type: InvoiceType,
        unitId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      invoiceId?: string | null,
      lease?:  {
        __typename: "Lease",
        id: string,
        balance?: number | null,
        canBeExtended?: boolean | null,
        communicationSettingsProfileId: string,
        createdAt?: string | null,
        endDate: string,
        includeRealEstateInLeaseContract?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        invoiceSenderId: string,
        inventoryOfFixturesExpert?: string | null,
        inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
        inventoryOfFixturesType?: InventoryOfFixturesType | null,
        ipiNumber?: string | null,
        language: Language,
        lastIndexationProcessDate?: string | null,
        lastInvoiceDate?: string | null,
        legalCompetentAuthority?: string | null,
        name: string,
        notes?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        realEstateAgency?: string | null,
        realEstateTax?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        signatureDate?: string | null,
        startDate: string,
        nextIndexationMonth?: string | null,
        nextIndexation?: boolean | null,
        status: LeaseStatus,
        technicCommunicationSettingsProfileId: string,
        totalInitialRentalPrice: number,
        totalRentalPrice: number,
        type: LeaseType,
        subletting?: boolean | null,
        vatRateRentId?: string | null,
        bankAccountId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      leaseId?: string | null,
      leasePriceHistoryId?: string | null,
      leasePriceHistory?:  {
        __typename: "LeasePriceHistory",
        id: string,
        previousTotalRentalPrice: number,
        totalRentalPrice: number,
        optimalTotalRentalPrice?: number | null,
        optimalTotalMonthlyCharges?: number | null,
        applicationDate: string,
        status: LeaseAmountUpdateStatus,
        comment?: string | null,
        type: LeasePriceHistoryType,
        communicationId?: string | null,
        leaseId: string,
        createdAt?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      letterTrackingCode?: string | null,
      letterTrackingProvider?: TrackingProvider | null,
      linkedCommunicationsIds?: Array< string > | null,
      supportingDocumentFileIds?: Array< string > | null,
      recipient?: string | null,
      recipientContactIdsInBcc?: Array< string > | null,
      recipientContactIdsInCc?: Array< string > | null,
      recipientInBcc?: string | null,
      recipientInCc?: string | null,
      scheduledAt?: string | null,
      deliveredAt?: string | null,
      errorCode?: CommunicationErrorCode | null,
      nextRetryAt?: string | null,
      sendRetryCount?: number | null,
      sender?: string | null,
      sentAt?: string | null,
      externalId?: string | null,
      externalStatus?: string | null,
      signatureDocumentId?: string | null,
      signatureDocument?:  {
        __typename: "SignatureDocument",
        id: string,
        additionalMessage?: string | null,
        automaticRemindersDisabled?: boolean | null,
        communicationBody?: string | null,
        createdAt?: string | null,
        expirationDate?: string | null,
        fileIds?: Array< string > | null,
        foreignKey: string,
        foreignTableName: string,
        sentAt?: string | null,
        signatureMethods: Array< SignatureType >,
        status: SignatureDocumentStatus,
        externalStatus?: string | null,
        type: SignatureDocumentType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      snoozedDate?: string | null,
      statement?:  {
        __typename: "Statement",
        id: string,
        closingStatement: boolean,
        periodFrom: string,
        periodTo: string,
        attachSupportingDocuments?: boolean | null,
        selectedPocketKeys?: Array< string > | null,
        source: StatementSource,
        status: StatementStatus,
        sentDate?: string | null,
        leaseId?: string | null,
        ownerId?: string | null,
        types?: Array< StatementType > | null,
        viewType: StatementViewType,
        unitIds?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      statementId?: string | null,
      status: CommunicationStatus,
      subject: string,
      toSend: boolean,
      hideLogo?: boolean | null,
      type: CommunicationType,
      _ttl?: number | null,
      unit?:  {
        __typename: "Unit",
        id: string,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        acquisitionValue?: number | null,
        advertisedMonthlyCharges?: number | null,
        advertisedRentalPrice?: number | null,
        cadastralIncome?: number | null,
        createdAt?: string | null,
        floor?: number | null,
        jointOwnershipId?: string | null,
        managementDate: string,
        name: string,
        notes?: string | null,
        predictedPrice?: string | null,
        propertyTax?: number | null,
        publishAddress?: boolean | null,
        surface?: number | null,
        type: UnitType,
        buildingId: string,
        unitAdvertisementId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      unitId?: string | null,
      readId: string,
      readers?: Array< string > | null,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    signatureDocumentId?: string | null,
    signatureDocument?:  {
      __typename: "SignatureDocument",
      id: string,
      additionalMessage?: string | null,
      automaticRemindersDisabled?: boolean | null,
      communicationBody?: string | null,
      createdAt?: string | null,
      expirationDate?: string | null,
      fileIds?: Array< string > | null,
      foreignKey: string,
      foreignTableName: string,
      sentAt?: string | null,
      signatureMethods: Array< SignatureType >,
      signatureResults:  Array< {
        __typename: "SignatureDocumentResult",
        openedDate?: string | null,
        signedDate?: string | null,
        signed?: boolean | null,
        signatureLink?: string | null,
        rejectReason?: string | null,
        lastSignInviteSentDate?: string | null,
        reminderDates?: Array< string > | null,
        trackingProvider?: TrackingProvider | null,
        trackingCode?: string | null,
        contactId: string,
      } >,
      status: SignatureDocumentStatus,
      externalStatus?: string | null,
      type: SignatureDocumentType,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    status?: LeaseActionHistoryStatus | null,
    communicationChannel?: CommunicationChannel | null,
    communicationSendDate?: string | null,
    communicationByPlatform?: boolean | null,
    endReason?: LeaseActionEndReason | null,
    endReasonOwnUseRelation?: string | null,
    endReasonOwnUseName?: string | null,
    initiator?: LeaseActionEndInitiator | null,
    totalAmount?: number | null,
    totalAmountLabel?: string | null,
    automatic?: boolean | null,
    hasLeaseTypeChanged?: boolean | null,
    jiraId?: string | null,
    readers?: Array< string > | null,
    readId: string,
    clientId: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateLeaseAdditionalClauseMutationVariables = {
  input: CreateLeaseAdditionalClauseInput,
  condition?: ModelLeaseAdditionalClauseConditionInput | null,
};

export type CreateLeaseAdditionalClauseMutation = {
  createLeaseAdditionalClause?:  {
    __typename: "LeaseAdditionalClause",
    id: string,
    leaseId: string,
    lease?:  {
      __typename: "Lease",
      id: string,
      advancedChargesInvoices?:  {
        __typename: "LeaseAdvancedChargesInvoice",
        communicationSettingsProfileId: string,
        invoiceSenderId: string,
        lastDraftInvoiceDate?: string | null,
        lastInvoiceDate?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        bankAccountId?: string | null,
      } | null,
      balance?: number | null,
      canBeExtended?: boolean | null,
      communicationSettingsProfileId: string,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      endDate: string,
      includeRealEstateInLeaseContract?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      invoiceSenderId: string,
      invoiceSender?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      inventoryOfFixturesExpert?: string | null,
      inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
      inventoryOfFixturesType?: InventoryOfFixturesType | null,
      ipiNumber?: string | null,
      language: Language,
      lastDraftInvoiceDate?: string | null,
      lastIndexationProcessDate?: string | null,
      lastInvoiceDate?: string | null,
      legalCompetentAuthority?: string | null,
      name: string,
      notes?: string | null,
      paymentFrequency: LeasePaymentFrequency,
      paymentInvoicePeriod: LeasePaymentInvoicePeriod,
      paymentInvoicePeriodCustomDay?: number | null,
      paymentOption?:  {
        __typename: "LeasePaymentOption",
        customerId?: string | null,
        enabled: boolean,
        mandateActivatedAt?: string | null,
        mandateStatus?: PaymentProviderMandateStatus | null,
        paymentMethodId?: string | null,
        qrType?: LeaseQrType | null,
      } | null,
      purchaseOrderNumber?: string | null,
      realEstateAgency?: string | null,
      realEstateTax?: number | null,
      remittanceInformation?: string | null,
      remittanceInformationType?: LeaseRemittanceType | null,
      rentalGuaranty?:  {
        __typename: "LeaseRentalGuaranty",
        amount: number,
        blockedAmount?: number | null,
        releasedAmount?: number | null,
        type: LeaseRentalGuarantyType,
        financialInstitution?: string | null,
      } | null,
      signatureDate?: string | null,
      startDate: string,
      nextIndexationMonth?: string | null,
      nextIndexation?: boolean | null,
      status: LeaseStatus,
      technicCommunicationSettingsProfileId: string,
      totalInitialRentalPrice: number,
      totalRentalPrice: number,
      type: LeaseType,
      subletting?: boolean | null,
      vatRateRentId?: string | null,
      vatRateRent?:  {
        __typename: "VatRate",
        id: string,
        country: string,
        label: string,
        value?: number | null,
        ownerId?: string | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      additionalClauses?:  {
        __typename: "ModelLeaseAdditionalClauseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      bankAccountId?: string | null,
      bankAccount?:  {
        __typename: "BankAccount",
        id: string,
        contactId: string,
        number: string,
        bicNumber?: string | null,
        bankName?: string | null,
        contactIds?: Array< string > | null,
        buildingIds?: Array< string > | null,
        holderName?: string | null,
        label?: string | null,
        disabled?: boolean | null,
        integrations?: Array< IntegrationName > | null,
        matchingRule?: BankAccountMatchingRule | null,
        balance?: number | null,
        balanceDate?: string | null,
        type: BankAccountType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contacts?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      files?:  {
        __typename: "ModelFileConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leaseActionHistories?:  {
        __typename: "ModelLeaseActionHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leasePriceHistories?:  {
        __typename: "ModelLeasePriceHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      signatureDocuments?:  {
        __typename: "ModelSignatureDocumentConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      variousOperations?:  {
        __typename: "ModelLeaseVariousOperationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    title?: string | null,
    body: string,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateLeaseAdditionalClauseMutationVariables = {
  input: UpdateLeaseAdditionalClauseInput,
  condition?: ModelLeaseAdditionalClauseConditionInput | null,
};

export type UpdateLeaseAdditionalClauseMutation = {
  updateLeaseAdditionalClause?:  {
    __typename: "LeaseAdditionalClause",
    id: string,
    leaseId: string,
    lease?:  {
      __typename: "Lease",
      id: string,
      advancedChargesInvoices?:  {
        __typename: "LeaseAdvancedChargesInvoice",
        communicationSettingsProfileId: string,
        invoiceSenderId: string,
        lastDraftInvoiceDate?: string | null,
        lastInvoiceDate?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        bankAccountId?: string | null,
      } | null,
      balance?: number | null,
      canBeExtended?: boolean | null,
      communicationSettingsProfileId: string,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      endDate: string,
      includeRealEstateInLeaseContract?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      invoiceSenderId: string,
      invoiceSender?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      inventoryOfFixturesExpert?: string | null,
      inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
      inventoryOfFixturesType?: InventoryOfFixturesType | null,
      ipiNumber?: string | null,
      language: Language,
      lastDraftInvoiceDate?: string | null,
      lastIndexationProcessDate?: string | null,
      lastInvoiceDate?: string | null,
      legalCompetentAuthority?: string | null,
      name: string,
      notes?: string | null,
      paymentFrequency: LeasePaymentFrequency,
      paymentInvoicePeriod: LeasePaymentInvoicePeriod,
      paymentInvoicePeriodCustomDay?: number | null,
      paymentOption?:  {
        __typename: "LeasePaymentOption",
        customerId?: string | null,
        enabled: boolean,
        mandateActivatedAt?: string | null,
        mandateStatus?: PaymentProviderMandateStatus | null,
        paymentMethodId?: string | null,
        qrType?: LeaseQrType | null,
      } | null,
      purchaseOrderNumber?: string | null,
      realEstateAgency?: string | null,
      realEstateTax?: number | null,
      remittanceInformation?: string | null,
      remittanceInformationType?: LeaseRemittanceType | null,
      rentalGuaranty?:  {
        __typename: "LeaseRentalGuaranty",
        amount: number,
        blockedAmount?: number | null,
        releasedAmount?: number | null,
        type: LeaseRentalGuarantyType,
        financialInstitution?: string | null,
      } | null,
      signatureDate?: string | null,
      startDate: string,
      nextIndexationMonth?: string | null,
      nextIndexation?: boolean | null,
      status: LeaseStatus,
      technicCommunicationSettingsProfileId: string,
      totalInitialRentalPrice: number,
      totalRentalPrice: number,
      type: LeaseType,
      subletting?: boolean | null,
      vatRateRentId?: string | null,
      vatRateRent?:  {
        __typename: "VatRate",
        id: string,
        country: string,
        label: string,
        value?: number | null,
        ownerId?: string | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      additionalClauses?:  {
        __typename: "ModelLeaseAdditionalClauseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      bankAccountId?: string | null,
      bankAccount?:  {
        __typename: "BankAccount",
        id: string,
        contactId: string,
        number: string,
        bicNumber?: string | null,
        bankName?: string | null,
        contactIds?: Array< string > | null,
        buildingIds?: Array< string > | null,
        holderName?: string | null,
        label?: string | null,
        disabled?: boolean | null,
        integrations?: Array< IntegrationName > | null,
        matchingRule?: BankAccountMatchingRule | null,
        balance?: number | null,
        balanceDate?: string | null,
        type: BankAccountType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contacts?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      files?:  {
        __typename: "ModelFileConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leaseActionHistories?:  {
        __typename: "ModelLeaseActionHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leasePriceHistories?:  {
        __typename: "ModelLeasePriceHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      signatureDocuments?:  {
        __typename: "ModelSignatureDocumentConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      variousOperations?:  {
        __typename: "ModelLeaseVariousOperationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    title?: string | null,
    body: string,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteLeaseAdditionalClauseMutationVariables = {
  input: DeleteLeaseAdditionalClauseInput,
  condition?: ModelLeaseAdditionalClauseConditionInput | null,
};

export type DeleteLeaseAdditionalClauseMutation = {
  deleteLeaseAdditionalClause?:  {
    __typename: "LeaseAdditionalClause",
    id: string,
    leaseId: string,
    lease?:  {
      __typename: "Lease",
      id: string,
      advancedChargesInvoices?:  {
        __typename: "LeaseAdvancedChargesInvoice",
        communicationSettingsProfileId: string,
        invoiceSenderId: string,
        lastDraftInvoiceDate?: string | null,
        lastInvoiceDate?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        bankAccountId?: string | null,
      } | null,
      balance?: number | null,
      canBeExtended?: boolean | null,
      communicationSettingsProfileId: string,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      endDate: string,
      includeRealEstateInLeaseContract?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      invoiceSenderId: string,
      invoiceSender?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      inventoryOfFixturesExpert?: string | null,
      inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
      inventoryOfFixturesType?: InventoryOfFixturesType | null,
      ipiNumber?: string | null,
      language: Language,
      lastDraftInvoiceDate?: string | null,
      lastIndexationProcessDate?: string | null,
      lastInvoiceDate?: string | null,
      legalCompetentAuthority?: string | null,
      name: string,
      notes?: string | null,
      paymentFrequency: LeasePaymentFrequency,
      paymentInvoicePeriod: LeasePaymentInvoicePeriod,
      paymentInvoicePeriodCustomDay?: number | null,
      paymentOption?:  {
        __typename: "LeasePaymentOption",
        customerId?: string | null,
        enabled: boolean,
        mandateActivatedAt?: string | null,
        mandateStatus?: PaymentProviderMandateStatus | null,
        paymentMethodId?: string | null,
        qrType?: LeaseQrType | null,
      } | null,
      purchaseOrderNumber?: string | null,
      realEstateAgency?: string | null,
      realEstateTax?: number | null,
      remittanceInformation?: string | null,
      remittanceInformationType?: LeaseRemittanceType | null,
      rentalGuaranty?:  {
        __typename: "LeaseRentalGuaranty",
        amount: number,
        blockedAmount?: number | null,
        releasedAmount?: number | null,
        type: LeaseRentalGuarantyType,
        financialInstitution?: string | null,
      } | null,
      signatureDate?: string | null,
      startDate: string,
      nextIndexationMonth?: string | null,
      nextIndexation?: boolean | null,
      status: LeaseStatus,
      technicCommunicationSettingsProfileId: string,
      totalInitialRentalPrice: number,
      totalRentalPrice: number,
      type: LeaseType,
      subletting?: boolean | null,
      vatRateRentId?: string | null,
      vatRateRent?:  {
        __typename: "VatRate",
        id: string,
        country: string,
        label: string,
        value?: number | null,
        ownerId?: string | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      additionalClauses?:  {
        __typename: "ModelLeaseAdditionalClauseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      bankAccountId?: string | null,
      bankAccount?:  {
        __typename: "BankAccount",
        id: string,
        contactId: string,
        number: string,
        bicNumber?: string | null,
        bankName?: string | null,
        contactIds?: Array< string > | null,
        buildingIds?: Array< string > | null,
        holderName?: string | null,
        label?: string | null,
        disabled?: boolean | null,
        integrations?: Array< IntegrationName > | null,
        matchingRule?: BankAccountMatchingRule | null,
        balance?: number | null,
        balanceDate?: string | null,
        type: BankAccountType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contacts?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      files?:  {
        __typename: "ModelFileConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leaseActionHistories?:  {
        __typename: "ModelLeaseActionHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leasePriceHistories?:  {
        __typename: "ModelLeasePriceHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      signatureDocuments?:  {
        __typename: "ModelSignatureDocumentConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      variousOperations?:  {
        __typename: "ModelLeaseVariousOperationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    title?: string | null,
    body: string,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateLeaseContactMutationVariables = {
  input: CreateLeaseContactInput,
  condition?: ModelLeaseContactConditionInput | null,
};

export type CreateLeaseContactMutation = {
  createLeaseContact?:  {
    __typename: "LeaseContact",
    id: string,
    leaseId: string,
    contactId: string,
    lease?:  {
      __typename: "Lease",
      id: string,
      advancedChargesInvoices?:  {
        __typename: "LeaseAdvancedChargesInvoice",
        communicationSettingsProfileId: string,
        invoiceSenderId: string,
        lastDraftInvoiceDate?: string | null,
        lastInvoiceDate?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        bankAccountId?: string | null,
      } | null,
      balance?: number | null,
      canBeExtended?: boolean | null,
      communicationSettingsProfileId: string,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      endDate: string,
      includeRealEstateInLeaseContract?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      invoiceSenderId: string,
      invoiceSender?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      inventoryOfFixturesExpert?: string | null,
      inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
      inventoryOfFixturesType?: InventoryOfFixturesType | null,
      ipiNumber?: string | null,
      language: Language,
      lastDraftInvoiceDate?: string | null,
      lastIndexationProcessDate?: string | null,
      lastInvoiceDate?: string | null,
      legalCompetentAuthority?: string | null,
      name: string,
      notes?: string | null,
      paymentFrequency: LeasePaymentFrequency,
      paymentInvoicePeriod: LeasePaymentInvoicePeriod,
      paymentInvoicePeriodCustomDay?: number | null,
      paymentOption?:  {
        __typename: "LeasePaymentOption",
        customerId?: string | null,
        enabled: boolean,
        mandateActivatedAt?: string | null,
        mandateStatus?: PaymentProviderMandateStatus | null,
        paymentMethodId?: string | null,
        qrType?: LeaseQrType | null,
      } | null,
      purchaseOrderNumber?: string | null,
      realEstateAgency?: string | null,
      realEstateTax?: number | null,
      remittanceInformation?: string | null,
      remittanceInformationType?: LeaseRemittanceType | null,
      rentalGuaranty?:  {
        __typename: "LeaseRentalGuaranty",
        amount: number,
        blockedAmount?: number | null,
        releasedAmount?: number | null,
        type: LeaseRentalGuarantyType,
        financialInstitution?: string | null,
      } | null,
      signatureDate?: string | null,
      startDate: string,
      nextIndexationMonth?: string | null,
      nextIndexation?: boolean | null,
      status: LeaseStatus,
      technicCommunicationSettingsProfileId: string,
      totalInitialRentalPrice: number,
      totalRentalPrice: number,
      type: LeaseType,
      subletting?: boolean | null,
      vatRateRentId?: string | null,
      vatRateRent?:  {
        __typename: "VatRate",
        id: string,
        country: string,
        label: string,
        value?: number | null,
        ownerId?: string | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      additionalClauses?:  {
        __typename: "ModelLeaseAdditionalClauseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      bankAccountId?: string | null,
      bankAccount?:  {
        __typename: "BankAccount",
        id: string,
        contactId: string,
        number: string,
        bicNumber?: string | null,
        bankName?: string | null,
        contactIds?: Array< string > | null,
        buildingIds?: Array< string > | null,
        holderName?: string | null,
        label?: string | null,
        disabled?: boolean | null,
        integrations?: Array< IntegrationName > | null,
        matchingRule?: BankAccountMatchingRule | null,
        balance?: number | null,
        balanceDate?: string | null,
        type: BankAccountType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contacts?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      files?:  {
        __typename: "ModelFileConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leaseActionHistories?:  {
        __typename: "ModelLeaseActionHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leasePriceHistories?:  {
        __typename: "ModelLeasePriceHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      signatureDocuments?:  {
        __typename: "ModelSignatureDocumentConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      variousOperations?:  {
        __typename: "ModelLeaseVariousOperationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    contact?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    contactRole: ContactType,
    readers?: Array< string > | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateLeaseContactMutationVariables = {
  input: UpdateLeaseContactInput,
  condition?: ModelLeaseContactConditionInput | null,
};

export type UpdateLeaseContactMutation = {
  updateLeaseContact?:  {
    __typename: "LeaseContact",
    id: string,
    leaseId: string,
    contactId: string,
    lease?:  {
      __typename: "Lease",
      id: string,
      advancedChargesInvoices?:  {
        __typename: "LeaseAdvancedChargesInvoice",
        communicationSettingsProfileId: string,
        invoiceSenderId: string,
        lastDraftInvoiceDate?: string | null,
        lastInvoiceDate?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        bankAccountId?: string | null,
      } | null,
      balance?: number | null,
      canBeExtended?: boolean | null,
      communicationSettingsProfileId: string,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      endDate: string,
      includeRealEstateInLeaseContract?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      invoiceSenderId: string,
      invoiceSender?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      inventoryOfFixturesExpert?: string | null,
      inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
      inventoryOfFixturesType?: InventoryOfFixturesType | null,
      ipiNumber?: string | null,
      language: Language,
      lastDraftInvoiceDate?: string | null,
      lastIndexationProcessDate?: string | null,
      lastInvoiceDate?: string | null,
      legalCompetentAuthority?: string | null,
      name: string,
      notes?: string | null,
      paymentFrequency: LeasePaymentFrequency,
      paymentInvoicePeriod: LeasePaymentInvoicePeriod,
      paymentInvoicePeriodCustomDay?: number | null,
      paymentOption?:  {
        __typename: "LeasePaymentOption",
        customerId?: string | null,
        enabled: boolean,
        mandateActivatedAt?: string | null,
        mandateStatus?: PaymentProviderMandateStatus | null,
        paymentMethodId?: string | null,
        qrType?: LeaseQrType | null,
      } | null,
      purchaseOrderNumber?: string | null,
      realEstateAgency?: string | null,
      realEstateTax?: number | null,
      remittanceInformation?: string | null,
      remittanceInformationType?: LeaseRemittanceType | null,
      rentalGuaranty?:  {
        __typename: "LeaseRentalGuaranty",
        amount: number,
        blockedAmount?: number | null,
        releasedAmount?: number | null,
        type: LeaseRentalGuarantyType,
        financialInstitution?: string | null,
      } | null,
      signatureDate?: string | null,
      startDate: string,
      nextIndexationMonth?: string | null,
      nextIndexation?: boolean | null,
      status: LeaseStatus,
      technicCommunicationSettingsProfileId: string,
      totalInitialRentalPrice: number,
      totalRentalPrice: number,
      type: LeaseType,
      subletting?: boolean | null,
      vatRateRentId?: string | null,
      vatRateRent?:  {
        __typename: "VatRate",
        id: string,
        country: string,
        label: string,
        value?: number | null,
        ownerId?: string | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      additionalClauses?:  {
        __typename: "ModelLeaseAdditionalClauseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      bankAccountId?: string | null,
      bankAccount?:  {
        __typename: "BankAccount",
        id: string,
        contactId: string,
        number: string,
        bicNumber?: string | null,
        bankName?: string | null,
        contactIds?: Array< string > | null,
        buildingIds?: Array< string > | null,
        holderName?: string | null,
        label?: string | null,
        disabled?: boolean | null,
        integrations?: Array< IntegrationName > | null,
        matchingRule?: BankAccountMatchingRule | null,
        balance?: number | null,
        balanceDate?: string | null,
        type: BankAccountType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contacts?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      files?:  {
        __typename: "ModelFileConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leaseActionHistories?:  {
        __typename: "ModelLeaseActionHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leasePriceHistories?:  {
        __typename: "ModelLeasePriceHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      signatureDocuments?:  {
        __typename: "ModelSignatureDocumentConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      variousOperations?:  {
        __typename: "ModelLeaseVariousOperationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    contact?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    contactRole: ContactType,
    readers?: Array< string > | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteLeaseContactMutationVariables = {
  input: DeleteLeaseContactInput,
  condition?: ModelLeaseContactConditionInput | null,
};

export type DeleteLeaseContactMutation = {
  deleteLeaseContact?:  {
    __typename: "LeaseContact",
    id: string,
    leaseId: string,
    contactId: string,
    lease?:  {
      __typename: "Lease",
      id: string,
      advancedChargesInvoices?:  {
        __typename: "LeaseAdvancedChargesInvoice",
        communicationSettingsProfileId: string,
        invoiceSenderId: string,
        lastDraftInvoiceDate?: string | null,
        lastInvoiceDate?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        bankAccountId?: string | null,
      } | null,
      balance?: number | null,
      canBeExtended?: boolean | null,
      communicationSettingsProfileId: string,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      endDate: string,
      includeRealEstateInLeaseContract?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      invoiceSenderId: string,
      invoiceSender?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      inventoryOfFixturesExpert?: string | null,
      inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
      inventoryOfFixturesType?: InventoryOfFixturesType | null,
      ipiNumber?: string | null,
      language: Language,
      lastDraftInvoiceDate?: string | null,
      lastIndexationProcessDate?: string | null,
      lastInvoiceDate?: string | null,
      legalCompetentAuthority?: string | null,
      name: string,
      notes?: string | null,
      paymentFrequency: LeasePaymentFrequency,
      paymentInvoicePeriod: LeasePaymentInvoicePeriod,
      paymentInvoicePeriodCustomDay?: number | null,
      paymentOption?:  {
        __typename: "LeasePaymentOption",
        customerId?: string | null,
        enabled: boolean,
        mandateActivatedAt?: string | null,
        mandateStatus?: PaymentProviderMandateStatus | null,
        paymentMethodId?: string | null,
        qrType?: LeaseQrType | null,
      } | null,
      purchaseOrderNumber?: string | null,
      realEstateAgency?: string | null,
      realEstateTax?: number | null,
      remittanceInformation?: string | null,
      remittanceInformationType?: LeaseRemittanceType | null,
      rentalGuaranty?:  {
        __typename: "LeaseRentalGuaranty",
        amount: number,
        blockedAmount?: number | null,
        releasedAmount?: number | null,
        type: LeaseRentalGuarantyType,
        financialInstitution?: string | null,
      } | null,
      signatureDate?: string | null,
      startDate: string,
      nextIndexationMonth?: string | null,
      nextIndexation?: boolean | null,
      status: LeaseStatus,
      technicCommunicationSettingsProfileId: string,
      totalInitialRentalPrice: number,
      totalRentalPrice: number,
      type: LeaseType,
      subletting?: boolean | null,
      vatRateRentId?: string | null,
      vatRateRent?:  {
        __typename: "VatRate",
        id: string,
        country: string,
        label: string,
        value?: number | null,
        ownerId?: string | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      additionalClauses?:  {
        __typename: "ModelLeaseAdditionalClauseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      bankAccountId?: string | null,
      bankAccount?:  {
        __typename: "BankAccount",
        id: string,
        contactId: string,
        number: string,
        bicNumber?: string | null,
        bankName?: string | null,
        contactIds?: Array< string > | null,
        buildingIds?: Array< string > | null,
        holderName?: string | null,
        label?: string | null,
        disabled?: boolean | null,
        integrations?: Array< IntegrationName > | null,
        matchingRule?: BankAccountMatchingRule | null,
        balance?: number | null,
        balanceDate?: string | null,
        type: BankAccountType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contacts?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      files?:  {
        __typename: "ModelFileConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leaseActionHistories?:  {
        __typename: "ModelLeaseActionHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leasePriceHistories?:  {
        __typename: "ModelLeasePriceHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      signatureDocuments?:  {
        __typename: "ModelSignatureDocumentConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      variousOperations?:  {
        __typename: "ModelLeaseVariousOperationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    contact?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    contactRole: ContactType,
    readers?: Array< string > | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateLeasePriceHistoryMutationVariables = {
  input: CreateLeasePriceHistoryInput,
  condition?: ModelLeasePriceHistoryConditionInput | null,
};

export type CreateLeasePriceHistoryMutation = {
  createLeasePriceHistory?:  {
    __typename: "LeasePriceHistory",
    id: string,
    previousTotalRentalPrice: number,
    totalRentalPrice: number,
    optimalTotalRentalPrice?: number | null,
    optimalTotalMonthlyCharges?: number | null,
    applicationDate: string,
    status: LeaseAmountUpdateStatus,
    comment?: string | null,
    amountDetails:  Array< {
      __typename: "LeasePriceHistoryDetail",
      unitId: string,
      indexationBaseIndex?: number | null,
      indexationNewIndex?: number | null,
      previousRentalPrice: number,
      newRentalPrice: number,
      rentalStatus: LeasePriceHistoryStatus,
      monthlyChargesStatus: LeasePriceHistoryStatus,
      optimalNewRentalPrice?: number | null,
      optimalNewMonthlyChargesPrice?: number | null,
      epb?: string | null,
      epbIssueDate?: string | null,
      oldestIndexForCorrectionFactorCalculation?: number | null,
      newestIndexForCorrectionFactorCalculation?: number | null,
      rentIndexedPriceAfterNewEpbReduction?: number | null,
      chargesIndexedPriceAfterNewEpbReduction?: number | null,
      correctionFactor?: number | null,
      chargesAmountsDetails?:  Array< {
        __typename: "LeasePriceHistoryChargeAmountsDetails",
        leaseVariousOperationId: string,
        previousMonthlyAmount: number,
        newMonthlyAmount: number,
        indexationBaseIndex?: number | null,
        indexationBaseAmount?: number | null,
        indexationBaseIndexDate?: string | null,
        indexed?: boolean | null,
      } > | null,
      reductionPercentage?: number | null,
      rentDifference?: number | null,
      rentReduction?: number | null,
      indexedRentAfterReduction?: number | null,
      chargesDifference?: number | null,
      chargesReduction?: number | null,
      indexedChargesAfterReduction?: number | null,
      previousYearIndexationNewIndex?: number | null,
      previousYearIndexedRent?: number | null,
      previousYearIndexedCharges?: number | null,
    } >,
    type: LeasePriceHistoryType,
    communicationId?: string | null,
    communication?:  {
      __typename: "Communication",
      id: string,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      blockedRecipients?:  Array< {
        __typename: "CommunicationBlockedRecipient",
        recipient: string,
        bounceType: BounceType,
      } > | null,
      body: string,
      buildingId?: string | null,
      channel: CommunicationChannel,
      communicationTemplateId?: string | null,
      concernedContactIds?: Array< string > | null,
      contactId?: string | null,
      contactIds?: Array< string > | null,
      createdAt?: string | null,
      draftProperties?:  {
        __typename: "CommunicationDraftProperties",
        allowRecipientsToSeeEachOther?: boolean | null,
        bcc?: Array< string > | null,
        buildingIds?: Array< string > | null,
        cc?: Array< string > | null,
        contactIds?: Array< string > | null,
        contactTypes?: Array< ContactType > | null,
        entityType: string,
        leaseIds?: Array< string > | null,
        sendInBcc?: boolean | null,
        unitIds?: Array< string > | null,
        unitTypeFilter?: string | null,
      } | null,
      expirationDate?: string | null,
      files?:  {
        __typename: "ModelFileConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      invoice?:  {
        __typename: "Invoice",
        id: string,
        amount: number,
        bankAccountId: string,
        communicationId?: string | null,
        createdAt: string,
        creditNote?: boolean | null,
        creditNoteLabel?: string | null,
        dueDate?: string | null,
        invoiceDate: string,
        invoiceNumber?: string | null,
        ownerId?: string | null,
        invoiceSenderId: string,
        leaseId?: string | null,
        paid: boolean,
        postedDate?: string | null,
        purchaseOrderNumber?: string | null,
        receiptNumber?: string | null,
        reminderDates?: Array< string > | null,
        note?: string | null,
        remittanceInformation?: string | null,
        statementId?: string | null,
        status: InvoiceStatus,
        type: InvoiceType,
        unitId?: string | null,
        reversedInvoiceId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      invoiceId?: string | null,
      lease?:  {
        __typename: "Lease",
        id: string,
        balance?: number | null,
        canBeExtended?: boolean | null,
        communicationSettingsProfileId: string,
        createdAt?: string | null,
        endDate: string,
        includeRealEstateInLeaseContract?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        invoiceSenderId: string,
        inventoryOfFixturesExpert?: string | null,
        inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
        inventoryOfFixturesType?: InventoryOfFixturesType | null,
        ipiNumber?: string | null,
        language: Language,
        lastDraftInvoiceDate?: string | null,
        lastIndexationProcessDate?: string | null,
        lastInvoiceDate?: string | null,
        legalCompetentAuthority?: string | null,
        name: string,
        notes?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        purchaseOrderNumber?: string | null,
        realEstateAgency?: string | null,
        realEstateTax?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        signatureDate?: string | null,
        startDate: string,
        nextIndexationMonth?: string | null,
        nextIndexation?: boolean | null,
        status: LeaseStatus,
        technicCommunicationSettingsProfileId: string,
        totalInitialRentalPrice: number,
        totalRentalPrice: number,
        type: LeaseType,
        subletting?: boolean | null,
        vatRateRentId?: string | null,
        bankAccountId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      leaseId?: string | null,
      leasePriceHistoryId?: string | null,
      leasePriceHistory?:  {
        __typename: "LeasePriceHistory",
        id: string,
        previousTotalRentalPrice: number,
        totalRentalPrice: number,
        optimalTotalRentalPrice?: number | null,
        optimalTotalMonthlyCharges?: number | null,
        applicationDate: string,
        status: LeaseAmountUpdateStatus,
        comment?: string | null,
        type: LeasePriceHistoryType,
        communicationId?: string | null,
        leaseId: string,
        createdAt?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      letterTrackingCode?: string | null,
      letterTrackingProvider?: TrackingProvider | null,
      linkedCommunicationsIds?: Array< string > | null,
      supportingDocumentFileIds?: Array< string > | null,
      recipient?: string | null,
      recipientContactIdsInBcc?: Array< string > | null,
      recipientContactIdsInCc?: Array< string > | null,
      recipientInBcc?: string | null,
      recipientInCc?: string | null,
      scheduledAt?: string | null,
      deliveredAt?: string | null,
      errorCode?: CommunicationErrorCode | null,
      nextRetryAt?: string | null,
      sendRetryCount?: number | null,
      sender?: string | null,
      sentAt?: string | null,
      externalId?: string | null,
      externalStatus?: string | null,
      signatureDocumentId?: string | null,
      signatureDocument?:  {
        __typename: "SignatureDocument",
        id: string,
        additionalMessage?: string | null,
        automaticRemindersDisabled?: boolean | null,
        communicationBody?: string | null,
        createdAt?: string | null,
        expirationDate?: string | null,
        fileIds?: Array< string > | null,
        foreignKey: string,
        foreignTableName: string,
        sentAt?: string | null,
        signatureMethods: Array< SignatureType >,
        status: SignatureDocumentStatus,
        externalStatus?: string | null,
        type: SignatureDocumentType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      snoozedDate?: string | null,
      statement?:  {
        __typename: "Statement",
        id: string,
        closingStatement: boolean,
        periodFrom: string,
        periodTo: string,
        attachSupportingDocuments?: boolean | null,
        selectedPocketKeys?: Array< string > | null,
        source: StatementSource,
        status: StatementStatus,
        sentDate?: string | null,
        leaseId?: string | null,
        ownerId?: string | null,
        types?: Array< StatementType > | null,
        viewType: StatementViewType,
        unitIds?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      statementId?: string | null,
      status: CommunicationStatus,
      subject: string,
      toSend: boolean,
      hideLogo?: boolean | null,
      type: CommunicationType,
      _ttl?: number | null,
      unit?:  {
        __typename: "Unit",
        id: string,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        acquisitionValue?: number | null,
        advertisedMonthlyCharges?: number | null,
        advertisedRentalPrice?: number | null,
        cadastralIncome?: number | null,
        createdAt?: string | null,
        floor?: number | null,
        jointOwnershipId?: string | null,
        managementDate: string,
        name: string,
        notes?: string | null,
        predictedPrice?: string | null,
        propertyTax?: number | null,
        publishAddress?: boolean | null,
        surface?: number | null,
        type: UnitType,
        buildingId: string,
        unitAdvertisementId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      unitId?: string | null,
      readId: string,
      readers?: Array< string > | null,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    leaseId: string,
    lease?:  {
      __typename: "Lease",
      id: string,
      advancedChargesInvoices?:  {
        __typename: "LeaseAdvancedChargesInvoice",
        communicationSettingsProfileId: string,
        invoiceSenderId: string,
        lastDraftInvoiceDate?: string | null,
        lastInvoiceDate?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        bankAccountId?: string | null,
      } | null,
      balance?: number | null,
      canBeExtended?: boolean | null,
      communicationSettingsProfileId: string,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      endDate: string,
      includeRealEstateInLeaseContract?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      invoiceSenderId: string,
      invoiceSender?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      inventoryOfFixturesExpert?: string | null,
      inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
      inventoryOfFixturesType?: InventoryOfFixturesType | null,
      ipiNumber?: string | null,
      language: Language,
      lastDraftInvoiceDate?: string | null,
      lastIndexationProcessDate?: string | null,
      lastInvoiceDate?: string | null,
      legalCompetentAuthority?: string | null,
      name: string,
      notes?: string | null,
      paymentFrequency: LeasePaymentFrequency,
      paymentInvoicePeriod: LeasePaymentInvoicePeriod,
      paymentInvoicePeriodCustomDay?: number | null,
      paymentOption?:  {
        __typename: "LeasePaymentOption",
        customerId?: string | null,
        enabled: boolean,
        mandateActivatedAt?: string | null,
        mandateStatus?: PaymentProviderMandateStatus | null,
        paymentMethodId?: string | null,
        qrType?: LeaseQrType | null,
      } | null,
      purchaseOrderNumber?: string | null,
      realEstateAgency?: string | null,
      realEstateTax?: number | null,
      remittanceInformation?: string | null,
      remittanceInformationType?: LeaseRemittanceType | null,
      rentalGuaranty?:  {
        __typename: "LeaseRentalGuaranty",
        amount: number,
        blockedAmount?: number | null,
        releasedAmount?: number | null,
        type: LeaseRentalGuarantyType,
        financialInstitution?: string | null,
      } | null,
      signatureDate?: string | null,
      startDate: string,
      nextIndexationMonth?: string | null,
      nextIndexation?: boolean | null,
      status: LeaseStatus,
      technicCommunicationSettingsProfileId: string,
      totalInitialRentalPrice: number,
      totalRentalPrice: number,
      type: LeaseType,
      subletting?: boolean | null,
      vatRateRentId?: string | null,
      vatRateRent?:  {
        __typename: "VatRate",
        id: string,
        country: string,
        label: string,
        value?: number | null,
        ownerId?: string | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      additionalClauses?:  {
        __typename: "ModelLeaseAdditionalClauseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      bankAccountId?: string | null,
      bankAccount?:  {
        __typename: "BankAccount",
        id: string,
        contactId: string,
        number: string,
        bicNumber?: string | null,
        bankName?: string | null,
        contactIds?: Array< string > | null,
        buildingIds?: Array< string > | null,
        holderName?: string | null,
        label?: string | null,
        disabled?: boolean | null,
        integrations?: Array< IntegrationName > | null,
        matchingRule?: BankAccountMatchingRule | null,
        balance?: number | null,
        balanceDate?: string | null,
        type: BankAccountType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contacts?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      files?:  {
        __typename: "ModelFileConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leaseActionHistories?:  {
        __typename: "ModelLeaseActionHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leasePriceHistories?:  {
        __typename: "ModelLeasePriceHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      signatureDocuments?:  {
        __typename: "ModelSignatureDocumentConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      variousOperations?:  {
        __typename: "ModelLeaseVariousOperationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    createdAt?: string | null,
    readers?: Array< string > | null,
    readId: string,
    clientId: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateLeasePriceHistoryMutationVariables = {
  input: UpdateLeasePriceHistoryInput,
  condition?: ModelLeasePriceHistoryConditionInput | null,
};

export type UpdateLeasePriceHistoryMutation = {
  updateLeasePriceHistory?:  {
    __typename: "LeasePriceHistory",
    id: string,
    previousTotalRentalPrice: number,
    totalRentalPrice: number,
    optimalTotalRentalPrice?: number | null,
    optimalTotalMonthlyCharges?: number | null,
    applicationDate: string,
    status: LeaseAmountUpdateStatus,
    comment?: string | null,
    amountDetails:  Array< {
      __typename: "LeasePriceHistoryDetail",
      unitId: string,
      indexationBaseIndex?: number | null,
      indexationNewIndex?: number | null,
      previousRentalPrice: number,
      newRentalPrice: number,
      rentalStatus: LeasePriceHistoryStatus,
      monthlyChargesStatus: LeasePriceHistoryStatus,
      optimalNewRentalPrice?: number | null,
      optimalNewMonthlyChargesPrice?: number | null,
      epb?: string | null,
      epbIssueDate?: string | null,
      oldestIndexForCorrectionFactorCalculation?: number | null,
      newestIndexForCorrectionFactorCalculation?: number | null,
      rentIndexedPriceAfterNewEpbReduction?: number | null,
      chargesIndexedPriceAfterNewEpbReduction?: number | null,
      correctionFactor?: number | null,
      chargesAmountsDetails?:  Array< {
        __typename: "LeasePriceHistoryChargeAmountsDetails",
        leaseVariousOperationId: string,
        previousMonthlyAmount: number,
        newMonthlyAmount: number,
        indexationBaseIndex?: number | null,
        indexationBaseAmount?: number | null,
        indexationBaseIndexDate?: string | null,
        indexed?: boolean | null,
      } > | null,
      reductionPercentage?: number | null,
      rentDifference?: number | null,
      rentReduction?: number | null,
      indexedRentAfterReduction?: number | null,
      chargesDifference?: number | null,
      chargesReduction?: number | null,
      indexedChargesAfterReduction?: number | null,
      previousYearIndexationNewIndex?: number | null,
      previousYearIndexedRent?: number | null,
      previousYearIndexedCharges?: number | null,
    } >,
    type: LeasePriceHistoryType,
    communicationId?: string | null,
    communication?:  {
      __typename: "Communication",
      id: string,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      blockedRecipients?:  Array< {
        __typename: "CommunicationBlockedRecipient",
        recipient: string,
        bounceType: BounceType,
      } > | null,
      body: string,
      buildingId?: string | null,
      channel: CommunicationChannel,
      communicationTemplateId?: string | null,
      concernedContactIds?: Array< string > | null,
      contactId?: string | null,
      contactIds?: Array< string > | null,
      createdAt?: string | null,
      draftProperties?:  {
        __typename: "CommunicationDraftProperties",
        allowRecipientsToSeeEachOther?: boolean | null,
        bcc?: Array< string > | null,
        buildingIds?: Array< string > | null,
        cc?: Array< string > | null,
        contactIds?: Array< string > | null,
        contactTypes?: Array< ContactType > | null,
        entityType: string,
        leaseIds?: Array< string > | null,
        sendInBcc?: boolean | null,
        unitIds?: Array< string > | null,
        unitTypeFilter?: string | null,
      } | null,
      expirationDate?: string | null,
      files?:  {
        __typename: "ModelFileConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      invoice?:  {
        __typename: "Invoice",
        id: string,
        amount: number,
        bankAccountId: string,
        communicationId?: string | null,
        createdAt: string,
        creditNote?: boolean | null,
        creditNoteLabel?: string | null,
        dueDate?: string | null,
        invoiceDate: string,
        invoiceNumber?: string | null,
        ownerId?: string | null,
        invoiceSenderId: string,
        leaseId?: string | null,
        paid: boolean,
        postedDate?: string | null,
        purchaseOrderNumber?: string | null,
        receiptNumber?: string | null,
        reminderDates?: Array< string > | null,
        note?: string | null,
        remittanceInformation?: string | null,
        statementId?: string | null,
        status: InvoiceStatus,
        type: InvoiceType,
        unitId?: string | null,
        reversedInvoiceId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      invoiceId?: string | null,
      lease?:  {
        __typename: "Lease",
        id: string,
        balance?: number | null,
        canBeExtended?: boolean | null,
        communicationSettingsProfileId: string,
        createdAt?: string | null,
        endDate: string,
        includeRealEstateInLeaseContract?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        invoiceSenderId: string,
        inventoryOfFixturesExpert?: string | null,
        inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
        inventoryOfFixturesType?: InventoryOfFixturesType | null,
        ipiNumber?: string | null,
        language: Language,
        lastDraftInvoiceDate?: string | null,
        lastIndexationProcessDate?: string | null,
        lastInvoiceDate?: string | null,
        legalCompetentAuthority?: string | null,
        name: string,
        notes?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        purchaseOrderNumber?: string | null,
        realEstateAgency?: string | null,
        realEstateTax?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        signatureDate?: string | null,
        startDate: string,
        nextIndexationMonth?: string | null,
        nextIndexation?: boolean | null,
        status: LeaseStatus,
        technicCommunicationSettingsProfileId: string,
        totalInitialRentalPrice: number,
        totalRentalPrice: number,
        type: LeaseType,
        subletting?: boolean | null,
        vatRateRentId?: string | null,
        bankAccountId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      leaseId?: string | null,
      leasePriceHistoryId?: string | null,
      leasePriceHistory?:  {
        __typename: "LeasePriceHistory",
        id: string,
        previousTotalRentalPrice: number,
        totalRentalPrice: number,
        optimalTotalRentalPrice?: number | null,
        optimalTotalMonthlyCharges?: number | null,
        applicationDate: string,
        status: LeaseAmountUpdateStatus,
        comment?: string | null,
        type: LeasePriceHistoryType,
        communicationId?: string | null,
        leaseId: string,
        createdAt?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      letterTrackingCode?: string | null,
      letterTrackingProvider?: TrackingProvider | null,
      linkedCommunicationsIds?: Array< string > | null,
      supportingDocumentFileIds?: Array< string > | null,
      recipient?: string | null,
      recipientContactIdsInBcc?: Array< string > | null,
      recipientContactIdsInCc?: Array< string > | null,
      recipientInBcc?: string | null,
      recipientInCc?: string | null,
      scheduledAt?: string | null,
      deliveredAt?: string | null,
      errorCode?: CommunicationErrorCode | null,
      nextRetryAt?: string | null,
      sendRetryCount?: number | null,
      sender?: string | null,
      sentAt?: string | null,
      externalId?: string | null,
      externalStatus?: string | null,
      signatureDocumentId?: string | null,
      signatureDocument?:  {
        __typename: "SignatureDocument",
        id: string,
        additionalMessage?: string | null,
        automaticRemindersDisabled?: boolean | null,
        communicationBody?: string | null,
        createdAt?: string | null,
        expirationDate?: string | null,
        fileIds?: Array< string > | null,
        foreignKey: string,
        foreignTableName: string,
        sentAt?: string | null,
        signatureMethods: Array< SignatureType >,
        status: SignatureDocumentStatus,
        externalStatus?: string | null,
        type: SignatureDocumentType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      snoozedDate?: string | null,
      statement?:  {
        __typename: "Statement",
        id: string,
        closingStatement: boolean,
        periodFrom: string,
        periodTo: string,
        attachSupportingDocuments?: boolean | null,
        selectedPocketKeys?: Array< string > | null,
        source: StatementSource,
        status: StatementStatus,
        sentDate?: string | null,
        leaseId?: string | null,
        ownerId?: string | null,
        types?: Array< StatementType > | null,
        viewType: StatementViewType,
        unitIds?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      statementId?: string | null,
      status: CommunicationStatus,
      subject: string,
      toSend: boolean,
      hideLogo?: boolean | null,
      type: CommunicationType,
      _ttl?: number | null,
      unit?:  {
        __typename: "Unit",
        id: string,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        acquisitionValue?: number | null,
        advertisedMonthlyCharges?: number | null,
        advertisedRentalPrice?: number | null,
        cadastralIncome?: number | null,
        createdAt?: string | null,
        floor?: number | null,
        jointOwnershipId?: string | null,
        managementDate: string,
        name: string,
        notes?: string | null,
        predictedPrice?: string | null,
        propertyTax?: number | null,
        publishAddress?: boolean | null,
        surface?: number | null,
        type: UnitType,
        buildingId: string,
        unitAdvertisementId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      unitId?: string | null,
      readId: string,
      readers?: Array< string > | null,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    leaseId: string,
    lease?:  {
      __typename: "Lease",
      id: string,
      advancedChargesInvoices?:  {
        __typename: "LeaseAdvancedChargesInvoice",
        communicationSettingsProfileId: string,
        invoiceSenderId: string,
        lastDraftInvoiceDate?: string | null,
        lastInvoiceDate?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        bankAccountId?: string | null,
      } | null,
      balance?: number | null,
      canBeExtended?: boolean | null,
      communicationSettingsProfileId: string,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      endDate: string,
      includeRealEstateInLeaseContract?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      invoiceSenderId: string,
      invoiceSender?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      inventoryOfFixturesExpert?: string | null,
      inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
      inventoryOfFixturesType?: InventoryOfFixturesType | null,
      ipiNumber?: string | null,
      language: Language,
      lastDraftInvoiceDate?: string | null,
      lastIndexationProcessDate?: string | null,
      lastInvoiceDate?: string | null,
      legalCompetentAuthority?: string | null,
      name: string,
      notes?: string | null,
      paymentFrequency: LeasePaymentFrequency,
      paymentInvoicePeriod: LeasePaymentInvoicePeriod,
      paymentInvoicePeriodCustomDay?: number | null,
      paymentOption?:  {
        __typename: "LeasePaymentOption",
        customerId?: string | null,
        enabled: boolean,
        mandateActivatedAt?: string | null,
        mandateStatus?: PaymentProviderMandateStatus | null,
        paymentMethodId?: string | null,
        qrType?: LeaseQrType | null,
      } | null,
      purchaseOrderNumber?: string | null,
      realEstateAgency?: string | null,
      realEstateTax?: number | null,
      remittanceInformation?: string | null,
      remittanceInformationType?: LeaseRemittanceType | null,
      rentalGuaranty?:  {
        __typename: "LeaseRentalGuaranty",
        amount: number,
        blockedAmount?: number | null,
        releasedAmount?: number | null,
        type: LeaseRentalGuarantyType,
        financialInstitution?: string | null,
      } | null,
      signatureDate?: string | null,
      startDate: string,
      nextIndexationMonth?: string | null,
      nextIndexation?: boolean | null,
      status: LeaseStatus,
      technicCommunicationSettingsProfileId: string,
      totalInitialRentalPrice: number,
      totalRentalPrice: number,
      type: LeaseType,
      subletting?: boolean | null,
      vatRateRentId?: string | null,
      vatRateRent?:  {
        __typename: "VatRate",
        id: string,
        country: string,
        label: string,
        value?: number | null,
        ownerId?: string | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      additionalClauses?:  {
        __typename: "ModelLeaseAdditionalClauseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      bankAccountId?: string | null,
      bankAccount?:  {
        __typename: "BankAccount",
        id: string,
        contactId: string,
        number: string,
        bicNumber?: string | null,
        bankName?: string | null,
        contactIds?: Array< string > | null,
        buildingIds?: Array< string > | null,
        holderName?: string | null,
        label?: string | null,
        disabled?: boolean | null,
        integrations?: Array< IntegrationName > | null,
        matchingRule?: BankAccountMatchingRule | null,
        balance?: number | null,
        balanceDate?: string | null,
        type: BankAccountType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contacts?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      files?:  {
        __typename: "ModelFileConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leaseActionHistories?:  {
        __typename: "ModelLeaseActionHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leasePriceHistories?:  {
        __typename: "ModelLeasePriceHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      signatureDocuments?:  {
        __typename: "ModelSignatureDocumentConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      variousOperations?:  {
        __typename: "ModelLeaseVariousOperationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    createdAt?: string | null,
    readers?: Array< string > | null,
    readId: string,
    clientId: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteLeasePriceHistoryMutationVariables = {
  input: DeleteLeasePriceHistoryInput,
  condition?: ModelLeasePriceHistoryConditionInput | null,
};

export type DeleteLeasePriceHistoryMutation = {
  deleteLeasePriceHistory?:  {
    __typename: "LeasePriceHistory",
    id: string,
    previousTotalRentalPrice: number,
    totalRentalPrice: number,
    optimalTotalRentalPrice?: number | null,
    optimalTotalMonthlyCharges?: number | null,
    applicationDate: string,
    status: LeaseAmountUpdateStatus,
    comment?: string | null,
    amountDetails:  Array< {
      __typename: "LeasePriceHistoryDetail",
      unitId: string,
      indexationBaseIndex?: number | null,
      indexationNewIndex?: number | null,
      previousRentalPrice: number,
      newRentalPrice: number,
      rentalStatus: LeasePriceHistoryStatus,
      monthlyChargesStatus: LeasePriceHistoryStatus,
      optimalNewRentalPrice?: number | null,
      optimalNewMonthlyChargesPrice?: number | null,
      epb?: string | null,
      epbIssueDate?: string | null,
      oldestIndexForCorrectionFactorCalculation?: number | null,
      newestIndexForCorrectionFactorCalculation?: number | null,
      rentIndexedPriceAfterNewEpbReduction?: number | null,
      chargesIndexedPriceAfterNewEpbReduction?: number | null,
      correctionFactor?: number | null,
      chargesAmountsDetails?:  Array< {
        __typename: "LeasePriceHistoryChargeAmountsDetails",
        leaseVariousOperationId: string,
        previousMonthlyAmount: number,
        newMonthlyAmount: number,
        indexationBaseIndex?: number | null,
        indexationBaseAmount?: number | null,
        indexationBaseIndexDate?: string | null,
        indexed?: boolean | null,
      } > | null,
      reductionPercentage?: number | null,
      rentDifference?: number | null,
      rentReduction?: number | null,
      indexedRentAfterReduction?: number | null,
      chargesDifference?: number | null,
      chargesReduction?: number | null,
      indexedChargesAfterReduction?: number | null,
      previousYearIndexationNewIndex?: number | null,
      previousYearIndexedRent?: number | null,
      previousYearIndexedCharges?: number | null,
    } >,
    type: LeasePriceHistoryType,
    communicationId?: string | null,
    communication?:  {
      __typename: "Communication",
      id: string,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      blockedRecipients?:  Array< {
        __typename: "CommunicationBlockedRecipient",
        recipient: string,
        bounceType: BounceType,
      } > | null,
      body: string,
      buildingId?: string | null,
      channel: CommunicationChannel,
      communicationTemplateId?: string | null,
      concernedContactIds?: Array< string > | null,
      contactId?: string | null,
      contactIds?: Array< string > | null,
      createdAt?: string | null,
      draftProperties?:  {
        __typename: "CommunicationDraftProperties",
        allowRecipientsToSeeEachOther?: boolean | null,
        bcc?: Array< string > | null,
        buildingIds?: Array< string > | null,
        cc?: Array< string > | null,
        contactIds?: Array< string > | null,
        contactTypes?: Array< ContactType > | null,
        entityType: string,
        leaseIds?: Array< string > | null,
        sendInBcc?: boolean | null,
        unitIds?: Array< string > | null,
        unitTypeFilter?: string | null,
      } | null,
      expirationDate?: string | null,
      files?:  {
        __typename: "ModelFileConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      invoice?:  {
        __typename: "Invoice",
        id: string,
        amount: number,
        bankAccountId: string,
        communicationId?: string | null,
        createdAt: string,
        creditNote?: boolean | null,
        creditNoteLabel?: string | null,
        dueDate?: string | null,
        invoiceDate: string,
        invoiceNumber?: string | null,
        ownerId?: string | null,
        invoiceSenderId: string,
        leaseId?: string | null,
        paid: boolean,
        postedDate?: string | null,
        purchaseOrderNumber?: string | null,
        receiptNumber?: string | null,
        reminderDates?: Array< string > | null,
        note?: string | null,
        remittanceInformation?: string | null,
        statementId?: string | null,
        status: InvoiceStatus,
        type: InvoiceType,
        unitId?: string | null,
        reversedInvoiceId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      invoiceId?: string | null,
      lease?:  {
        __typename: "Lease",
        id: string,
        balance?: number | null,
        canBeExtended?: boolean | null,
        communicationSettingsProfileId: string,
        createdAt?: string | null,
        endDate: string,
        includeRealEstateInLeaseContract?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        invoiceSenderId: string,
        inventoryOfFixturesExpert?: string | null,
        inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
        inventoryOfFixturesType?: InventoryOfFixturesType | null,
        ipiNumber?: string | null,
        language: Language,
        lastDraftInvoiceDate?: string | null,
        lastIndexationProcessDate?: string | null,
        lastInvoiceDate?: string | null,
        legalCompetentAuthority?: string | null,
        name: string,
        notes?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        purchaseOrderNumber?: string | null,
        realEstateAgency?: string | null,
        realEstateTax?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        signatureDate?: string | null,
        startDate: string,
        nextIndexationMonth?: string | null,
        nextIndexation?: boolean | null,
        status: LeaseStatus,
        technicCommunicationSettingsProfileId: string,
        totalInitialRentalPrice: number,
        totalRentalPrice: number,
        type: LeaseType,
        subletting?: boolean | null,
        vatRateRentId?: string | null,
        bankAccountId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      leaseId?: string | null,
      leasePriceHistoryId?: string | null,
      leasePriceHistory?:  {
        __typename: "LeasePriceHistory",
        id: string,
        previousTotalRentalPrice: number,
        totalRentalPrice: number,
        optimalTotalRentalPrice?: number | null,
        optimalTotalMonthlyCharges?: number | null,
        applicationDate: string,
        status: LeaseAmountUpdateStatus,
        comment?: string | null,
        type: LeasePriceHistoryType,
        communicationId?: string | null,
        leaseId: string,
        createdAt?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      letterTrackingCode?: string | null,
      letterTrackingProvider?: TrackingProvider | null,
      linkedCommunicationsIds?: Array< string > | null,
      supportingDocumentFileIds?: Array< string > | null,
      recipient?: string | null,
      recipientContactIdsInBcc?: Array< string > | null,
      recipientContactIdsInCc?: Array< string > | null,
      recipientInBcc?: string | null,
      recipientInCc?: string | null,
      scheduledAt?: string | null,
      deliveredAt?: string | null,
      errorCode?: CommunicationErrorCode | null,
      nextRetryAt?: string | null,
      sendRetryCount?: number | null,
      sender?: string | null,
      sentAt?: string | null,
      externalId?: string | null,
      externalStatus?: string | null,
      signatureDocumentId?: string | null,
      signatureDocument?:  {
        __typename: "SignatureDocument",
        id: string,
        additionalMessage?: string | null,
        automaticRemindersDisabled?: boolean | null,
        communicationBody?: string | null,
        createdAt?: string | null,
        expirationDate?: string | null,
        fileIds?: Array< string > | null,
        foreignKey: string,
        foreignTableName: string,
        sentAt?: string | null,
        signatureMethods: Array< SignatureType >,
        status: SignatureDocumentStatus,
        externalStatus?: string | null,
        type: SignatureDocumentType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      snoozedDate?: string | null,
      statement?:  {
        __typename: "Statement",
        id: string,
        closingStatement: boolean,
        periodFrom: string,
        periodTo: string,
        attachSupportingDocuments?: boolean | null,
        selectedPocketKeys?: Array< string > | null,
        source: StatementSource,
        status: StatementStatus,
        sentDate?: string | null,
        leaseId?: string | null,
        ownerId?: string | null,
        types?: Array< StatementType > | null,
        viewType: StatementViewType,
        unitIds?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      statementId?: string | null,
      status: CommunicationStatus,
      subject: string,
      toSend: boolean,
      hideLogo?: boolean | null,
      type: CommunicationType,
      _ttl?: number | null,
      unit?:  {
        __typename: "Unit",
        id: string,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        acquisitionValue?: number | null,
        advertisedMonthlyCharges?: number | null,
        advertisedRentalPrice?: number | null,
        cadastralIncome?: number | null,
        createdAt?: string | null,
        floor?: number | null,
        jointOwnershipId?: string | null,
        managementDate: string,
        name: string,
        notes?: string | null,
        predictedPrice?: string | null,
        propertyTax?: number | null,
        publishAddress?: boolean | null,
        surface?: number | null,
        type: UnitType,
        buildingId: string,
        unitAdvertisementId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      unitId?: string | null,
      readId: string,
      readers?: Array< string > | null,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    leaseId: string,
    lease?:  {
      __typename: "Lease",
      id: string,
      advancedChargesInvoices?:  {
        __typename: "LeaseAdvancedChargesInvoice",
        communicationSettingsProfileId: string,
        invoiceSenderId: string,
        lastDraftInvoiceDate?: string | null,
        lastInvoiceDate?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        bankAccountId?: string | null,
      } | null,
      balance?: number | null,
      canBeExtended?: boolean | null,
      communicationSettingsProfileId: string,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      endDate: string,
      includeRealEstateInLeaseContract?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      invoiceSenderId: string,
      invoiceSender?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      inventoryOfFixturesExpert?: string | null,
      inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
      inventoryOfFixturesType?: InventoryOfFixturesType | null,
      ipiNumber?: string | null,
      language: Language,
      lastDraftInvoiceDate?: string | null,
      lastIndexationProcessDate?: string | null,
      lastInvoiceDate?: string | null,
      legalCompetentAuthority?: string | null,
      name: string,
      notes?: string | null,
      paymentFrequency: LeasePaymentFrequency,
      paymentInvoicePeriod: LeasePaymentInvoicePeriod,
      paymentInvoicePeriodCustomDay?: number | null,
      paymentOption?:  {
        __typename: "LeasePaymentOption",
        customerId?: string | null,
        enabled: boolean,
        mandateActivatedAt?: string | null,
        mandateStatus?: PaymentProviderMandateStatus | null,
        paymentMethodId?: string | null,
        qrType?: LeaseQrType | null,
      } | null,
      purchaseOrderNumber?: string | null,
      realEstateAgency?: string | null,
      realEstateTax?: number | null,
      remittanceInformation?: string | null,
      remittanceInformationType?: LeaseRemittanceType | null,
      rentalGuaranty?:  {
        __typename: "LeaseRentalGuaranty",
        amount: number,
        blockedAmount?: number | null,
        releasedAmount?: number | null,
        type: LeaseRentalGuarantyType,
        financialInstitution?: string | null,
      } | null,
      signatureDate?: string | null,
      startDate: string,
      nextIndexationMonth?: string | null,
      nextIndexation?: boolean | null,
      status: LeaseStatus,
      technicCommunicationSettingsProfileId: string,
      totalInitialRentalPrice: number,
      totalRentalPrice: number,
      type: LeaseType,
      subletting?: boolean | null,
      vatRateRentId?: string | null,
      vatRateRent?:  {
        __typename: "VatRate",
        id: string,
        country: string,
        label: string,
        value?: number | null,
        ownerId?: string | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      additionalClauses?:  {
        __typename: "ModelLeaseAdditionalClauseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      bankAccountId?: string | null,
      bankAccount?:  {
        __typename: "BankAccount",
        id: string,
        contactId: string,
        number: string,
        bicNumber?: string | null,
        bankName?: string | null,
        contactIds?: Array< string > | null,
        buildingIds?: Array< string > | null,
        holderName?: string | null,
        label?: string | null,
        disabled?: boolean | null,
        integrations?: Array< IntegrationName > | null,
        matchingRule?: BankAccountMatchingRule | null,
        balance?: number | null,
        balanceDate?: string | null,
        type: BankAccountType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contacts?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      files?:  {
        __typename: "ModelFileConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leaseActionHistories?:  {
        __typename: "ModelLeaseActionHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leasePriceHistories?:  {
        __typename: "ModelLeasePriceHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      signatureDocuments?:  {
        __typename: "ModelSignatureDocumentConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      variousOperations?:  {
        __typename: "ModelLeaseVariousOperationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    createdAt?: string | null,
    readers?: Array< string > | null,
    readId: string,
    clientId: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateLeaseVariousOperationMutationVariables = {
  input: CreateLeaseVariousOperationInput,
  condition?: ModelLeaseVariousOperationConditionInput | null,
};

export type CreateLeaseVariousOperationMutation = {
  createLeaseVariousOperation?:  {
    __typename: "LeaseVariousOperation",
    id: string,
    accountLabelIds?: Array< string > | null,
    amount: number,
    contactId: string,
    createdAt: string,
    createdBy?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    endDate: string,
    invoiceSenderId?: string | null,
    invoiceSender?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    label?: string | null,
    lastInvoiceDate?: string | null,
    leaseId: string,
    lease?:  {
      __typename: "Lease",
      id: string,
      advancedChargesInvoices?:  {
        __typename: "LeaseAdvancedChargesInvoice",
        communicationSettingsProfileId: string,
        invoiceSenderId: string,
        lastDraftInvoiceDate?: string | null,
        lastInvoiceDate?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        bankAccountId?: string | null,
      } | null,
      balance?: number | null,
      canBeExtended?: boolean | null,
      communicationSettingsProfileId: string,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      endDate: string,
      includeRealEstateInLeaseContract?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      invoiceSenderId: string,
      invoiceSender?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      inventoryOfFixturesExpert?: string | null,
      inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
      inventoryOfFixturesType?: InventoryOfFixturesType | null,
      ipiNumber?: string | null,
      language: Language,
      lastDraftInvoiceDate?: string | null,
      lastIndexationProcessDate?: string | null,
      lastInvoiceDate?: string | null,
      legalCompetentAuthority?: string | null,
      name: string,
      notes?: string | null,
      paymentFrequency: LeasePaymentFrequency,
      paymentInvoicePeriod: LeasePaymentInvoicePeriod,
      paymentInvoicePeriodCustomDay?: number | null,
      paymentOption?:  {
        __typename: "LeasePaymentOption",
        customerId?: string | null,
        enabled: boolean,
        mandateActivatedAt?: string | null,
        mandateStatus?: PaymentProviderMandateStatus | null,
        paymentMethodId?: string | null,
        qrType?: LeaseQrType | null,
      } | null,
      purchaseOrderNumber?: string | null,
      realEstateAgency?: string | null,
      realEstateTax?: number | null,
      remittanceInformation?: string | null,
      remittanceInformationType?: LeaseRemittanceType | null,
      rentalGuaranty?:  {
        __typename: "LeaseRentalGuaranty",
        amount: number,
        blockedAmount?: number | null,
        releasedAmount?: number | null,
        type: LeaseRentalGuarantyType,
        financialInstitution?: string | null,
      } | null,
      signatureDate?: string | null,
      startDate: string,
      nextIndexationMonth?: string | null,
      nextIndexation?: boolean | null,
      status: LeaseStatus,
      technicCommunicationSettingsProfileId: string,
      totalInitialRentalPrice: number,
      totalRentalPrice: number,
      type: LeaseType,
      subletting?: boolean | null,
      vatRateRentId?: string | null,
      vatRateRent?:  {
        __typename: "VatRate",
        id: string,
        country: string,
        label: string,
        value?: number | null,
        ownerId?: string | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      additionalClauses?:  {
        __typename: "ModelLeaseAdditionalClauseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      bankAccountId?: string | null,
      bankAccount?:  {
        __typename: "BankAccount",
        id: string,
        contactId: string,
        number: string,
        bicNumber?: string | null,
        bankName?: string | null,
        contactIds?: Array< string > | null,
        buildingIds?: Array< string > | null,
        holderName?: string | null,
        label?: string | null,
        disabled?: boolean | null,
        integrations?: Array< IntegrationName > | null,
        matchingRule?: BankAccountMatchingRule | null,
        balance?: number | null,
        balanceDate?: string | null,
        type: BankAccountType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contacts?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      files?:  {
        __typename: "ModelFileConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leaseActionHistories?:  {
        __typename: "ModelLeaseActionHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leasePriceHistories?:  {
        __typename: "ModelLeasePriceHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      signatureDocuments?:  {
        __typename: "ModelSignatureDocumentConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      variousOperations?:  {
        __typename: "ModelLeaseVariousOperationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    leaseVariousOperationHistories?:  Array< {
      __typename: "LeaseVariousOperationHistory",
      periodFrom: string,
      periodTo: string,
      amount: number,
    } > | null,
    operationType: LeaseVariousOperationType,
    paymentFrequency: LeasePaymentFrequency,
    paymentInvoicePeriod: LeasePaymentInvoicePeriod,
    paymentInvoicePeriodCustomDay?: number | null,
    reason?: string | null,
    separateInvoice: boolean,
    startDate: string,
    type: VariousOperationType,
    unit?:  {
      __typename: "Unit",
      id: string,
      acquisitionAdditionalCostsValue?: number | null,
      acquisitionAdvertisedValue?: number | null,
      acquisitionValue?: number | null,
      advertisedMonthlyCharges?: number | null,
      advertisedRentalPrice?: number | null,
      cadastralIncome?: number | null,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      floor?: number | null,
      jointOwnershipId?: string | null,
      managementDate: string,
      name: string,
      notes?: string | null,
      predictedPrice?: string | null,
      propertyTax?: number | null,
      publishAddress?: boolean | null,
      surface?: number | null,
      type: UnitType,
      buildingId: string,
      building?:  {
        __typename: "Building",
        id: string,
        name: string,
        addressId?: string | null,
        acquisitionValue?: number | null,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        amountOfFacades?: number | null,
        amountOfFloors?: number | null,
        amountOfHousings?: number | null,
        buildingState?: BuildingState | null,
        cadastralIncome?: number | null,
        constructionYear?: string | null,
        janitor?: boolean | null,
        jointOwnershipId?: string | null,
        notes?: string | null,
        propertyTax?: number | null,
        residenceName?: string | null,
        buildingSiteId?: string | null,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      owners?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leases?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      events?:  {
        __typename: "ModelUnitEventConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      unitAdvertisementId?: string | null,
      unitInventories?:  {
        __typename: "ModelUnitInventoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    unitId: string,
    vatRateId?: string | null,
    vatRate?:  {
      __typename: "VatRate",
      id: string,
      country: string,
      label: string,
      value?: number | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      ownerId?: string | null,
      owner?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    readId: string,
    readers?: Array< string > | null,
    clientId: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateLeaseVariousOperationMutationVariables = {
  input: UpdateLeaseVariousOperationInput,
  condition?: ModelLeaseVariousOperationConditionInput | null,
};

export type UpdateLeaseVariousOperationMutation = {
  updateLeaseVariousOperation?:  {
    __typename: "LeaseVariousOperation",
    id: string,
    accountLabelIds?: Array< string > | null,
    amount: number,
    contactId: string,
    createdAt: string,
    createdBy?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    endDate: string,
    invoiceSenderId?: string | null,
    invoiceSender?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    label?: string | null,
    lastInvoiceDate?: string | null,
    leaseId: string,
    lease?:  {
      __typename: "Lease",
      id: string,
      advancedChargesInvoices?:  {
        __typename: "LeaseAdvancedChargesInvoice",
        communicationSettingsProfileId: string,
        invoiceSenderId: string,
        lastDraftInvoiceDate?: string | null,
        lastInvoiceDate?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        bankAccountId?: string | null,
      } | null,
      balance?: number | null,
      canBeExtended?: boolean | null,
      communicationSettingsProfileId: string,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      endDate: string,
      includeRealEstateInLeaseContract?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      invoiceSenderId: string,
      invoiceSender?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      inventoryOfFixturesExpert?: string | null,
      inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
      inventoryOfFixturesType?: InventoryOfFixturesType | null,
      ipiNumber?: string | null,
      language: Language,
      lastDraftInvoiceDate?: string | null,
      lastIndexationProcessDate?: string | null,
      lastInvoiceDate?: string | null,
      legalCompetentAuthority?: string | null,
      name: string,
      notes?: string | null,
      paymentFrequency: LeasePaymentFrequency,
      paymentInvoicePeriod: LeasePaymentInvoicePeriod,
      paymentInvoicePeriodCustomDay?: number | null,
      paymentOption?:  {
        __typename: "LeasePaymentOption",
        customerId?: string | null,
        enabled: boolean,
        mandateActivatedAt?: string | null,
        mandateStatus?: PaymentProviderMandateStatus | null,
        paymentMethodId?: string | null,
        qrType?: LeaseQrType | null,
      } | null,
      purchaseOrderNumber?: string | null,
      realEstateAgency?: string | null,
      realEstateTax?: number | null,
      remittanceInformation?: string | null,
      remittanceInformationType?: LeaseRemittanceType | null,
      rentalGuaranty?:  {
        __typename: "LeaseRentalGuaranty",
        amount: number,
        blockedAmount?: number | null,
        releasedAmount?: number | null,
        type: LeaseRentalGuarantyType,
        financialInstitution?: string | null,
      } | null,
      signatureDate?: string | null,
      startDate: string,
      nextIndexationMonth?: string | null,
      nextIndexation?: boolean | null,
      status: LeaseStatus,
      technicCommunicationSettingsProfileId: string,
      totalInitialRentalPrice: number,
      totalRentalPrice: number,
      type: LeaseType,
      subletting?: boolean | null,
      vatRateRentId?: string | null,
      vatRateRent?:  {
        __typename: "VatRate",
        id: string,
        country: string,
        label: string,
        value?: number | null,
        ownerId?: string | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      additionalClauses?:  {
        __typename: "ModelLeaseAdditionalClauseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      bankAccountId?: string | null,
      bankAccount?:  {
        __typename: "BankAccount",
        id: string,
        contactId: string,
        number: string,
        bicNumber?: string | null,
        bankName?: string | null,
        contactIds?: Array< string > | null,
        buildingIds?: Array< string > | null,
        holderName?: string | null,
        label?: string | null,
        disabled?: boolean | null,
        integrations?: Array< IntegrationName > | null,
        matchingRule?: BankAccountMatchingRule | null,
        balance?: number | null,
        balanceDate?: string | null,
        type: BankAccountType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contacts?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      files?:  {
        __typename: "ModelFileConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leaseActionHistories?:  {
        __typename: "ModelLeaseActionHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leasePriceHistories?:  {
        __typename: "ModelLeasePriceHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      signatureDocuments?:  {
        __typename: "ModelSignatureDocumentConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      variousOperations?:  {
        __typename: "ModelLeaseVariousOperationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    leaseVariousOperationHistories?:  Array< {
      __typename: "LeaseVariousOperationHistory",
      periodFrom: string,
      periodTo: string,
      amount: number,
    } > | null,
    operationType: LeaseVariousOperationType,
    paymentFrequency: LeasePaymentFrequency,
    paymentInvoicePeriod: LeasePaymentInvoicePeriod,
    paymentInvoicePeriodCustomDay?: number | null,
    reason?: string | null,
    separateInvoice: boolean,
    startDate: string,
    type: VariousOperationType,
    unit?:  {
      __typename: "Unit",
      id: string,
      acquisitionAdditionalCostsValue?: number | null,
      acquisitionAdvertisedValue?: number | null,
      acquisitionValue?: number | null,
      advertisedMonthlyCharges?: number | null,
      advertisedRentalPrice?: number | null,
      cadastralIncome?: number | null,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      floor?: number | null,
      jointOwnershipId?: string | null,
      managementDate: string,
      name: string,
      notes?: string | null,
      predictedPrice?: string | null,
      propertyTax?: number | null,
      publishAddress?: boolean | null,
      surface?: number | null,
      type: UnitType,
      buildingId: string,
      building?:  {
        __typename: "Building",
        id: string,
        name: string,
        addressId?: string | null,
        acquisitionValue?: number | null,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        amountOfFacades?: number | null,
        amountOfFloors?: number | null,
        amountOfHousings?: number | null,
        buildingState?: BuildingState | null,
        cadastralIncome?: number | null,
        constructionYear?: string | null,
        janitor?: boolean | null,
        jointOwnershipId?: string | null,
        notes?: string | null,
        propertyTax?: number | null,
        residenceName?: string | null,
        buildingSiteId?: string | null,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      owners?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leases?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      events?:  {
        __typename: "ModelUnitEventConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      unitAdvertisementId?: string | null,
      unitInventories?:  {
        __typename: "ModelUnitInventoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    unitId: string,
    vatRateId?: string | null,
    vatRate?:  {
      __typename: "VatRate",
      id: string,
      country: string,
      label: string,
      value?: number | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      ownerId?: string | null,
      owner?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    readId: string,
    readers?: Array< string > | null,
    clientId: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteLeaseVariousOperationMutationVariables = {
  input: DeleteLeaseVariousOperationInput,
  condition?: ModelLeaseVariousOperationConditionInput | null,
};

export type DeleteLeaseVariousOperationMutation = {
  deleteLeaseVariousOperation?:  {
    __typename: "LeaseVariousOperation",
    id: string,
    accountLabelIds?: Array< string > | null,
    amount: number,
    contactId: string,
    createdAt: string,
    createdBy?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    endDate: string,
    invoiceSenderId?: string | null,
    invoiceSender?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    label?: string | null,
    lastInvoiceDate?: string | null,
    leaseId: string,
    lease?:  {
      __typename: "Lease",
      id: string,
      advancedChargesInvoices?:  {
        __typename: "LeaseAdvancedChargesInvoice",
        communicationSettingsProfileId: string,
        invoiceSenderId: string,
        lastDraftInvoiceDate?: string | null,
        lastInvoiceDate?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        bankAccountId?: string | null,
      } | null,
      balance?: number | null,
      canBeExtended?: boolean | null,
      communicationSettingsProfileId: string,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      endDate: string,
      includeRealEstateInLeaseContract?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      invoiceSenderId: string,
      invoiceSender?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      inventoryOfFixturesExpert?: string | null,
      inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
      inventoryOfFixturesType?: InventoryOfFixturesType | null,
      ipiNumber?: string | null,
      language: Language,
      lastDraftInvoiceDate?: string | null,
      lastIndexationProcessDate?: string | null,
      lastInvoiceDate?: string | null,
      legalCompetentAuthority?: string | null,
      name: string,
      notes?: string | null,
      paymentFrequency: LeasePaymentFrequency,
      paymentInvoicePeriod: LeasePaymentInvoicePeriod,
      paymentInvoicePeriodCustomDay?: number | null,
      paymentOption?:  {
        __typename: "LeasePaymentOption",
        customerId?: string | null,
        enabled: boolean,
        mandateActivatedAt?: string | null,
        mandateStatus?: PaymentProviderMandateStatus | null,
        paymentMethodId?: string | null,
        qrType?: LeaseQrType | null,
      } | null,
      purchaseOrderNumber?: string | null,
      realEstateAgency?: string | null,
      realEstateTax?: number | null,
      remittanceInformation?: string | null,
      remittanceInformationType?: LeaseRemittanceType | null,
      rentalGuaranty?:  {
        __typename: "LeaseRentalGuaranty",
        amount: number,
        blockedAmount?: number | null,
        releasedAmount?: number | null,
        type: LeaseRentalGuarantyType,
        financialInstitution?: string | null,
      } | null,
      signatureDate?: string | null,
      startDate: string,
      nextIndexationMonth?: string | null,
      nextIndexation?: boolean | null,
      status: LeaseStatus,
      technicCommunicationSettingsProfileId: string,
      totalInitialRentalPrice: number,
      totalRentalPrice: number,
      type: LeaseType,
      subletting?: boolean | null,
      vatRateRentId?: string | null,
      vatRateRent?:  {
        __typename: "VatRate",
        id: string,
        country: string,
        label: string,
        value?: number | null,
        ownerId?: string | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      additionalClauses?:  {
        __typename: "ModelLeaseAdditionalClauseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      bankAccountId?: string | null,
      bankAccount?:  {
        __typename: "BankAccount",
        id: string,
        contactId: string,
        number: string,
        bicNumber?: string | null,
        bankName?: string | null,
        contactIds?: Array< string > | null,
        buildingIds?: Array< string > | null,
        holderName?: string | null,
        label?: string | null,
        disabled?: boolean | null,
        integrations?: Array< IntegrationName > | null,
        matchingRule?: BankAccountMatchingRule | null,
        balance?: number | null,
        balanceDate?: string | null,
        type: BankAccountType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contacts?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      files?:  {
        __typename: "ModelFileConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leaseActionHistories?:  {
        __typename: "ModelLeaseActionHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leasePriceHistories?:  {
        __typename: "ModelLeasePriceHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      signatureDocuments?:  {
        __typename: "ModelSignatureDocumentConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      variousOperations?:  {
        __typename: "ModelLeaseVariousOperationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    leaseVariousOperationHistories?:  Array< {
      __typename: "LeaseVariousOperationHistory",
      periodFrom: string,
      periodTo: string,
      amount: number,
    } > | null,
    operationType: LeaseVariousOperationType,
    paymentFrequency: LeasePaymentFrequency,
    paymentInvoicePeriod: LeasePaymentInvoicePeriod,
    paymentInvoicePeriodCustomDay?: number | null,
    reason?: string | null,
    separateInvoice: boolean,
    startDate: string,
    type: VariousOperationType,
    unit?:  {
      __typename: "Unit",
      id: string,
      acquisitionAdditionalCostsValue?: number | null,
      acquisitionAdvertisedValue?: number | null,
      acquisitionValue?: number | null,
      advertisedMonthlyCharges?: number | null,
      advertisedRentalPrice?: number | null,
      cadastralIncome?: number | null,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      floor?: number | null,
      jointOwnershipId?: string | null,
      managementDate: string,
      name: string,
      notes?: string | null,
      predictedPrice?: string | null,
      propertyTax?: number | null,
      publishAddress?: boolean | null,
      surface?: number | null,
      type: UnitType,
      buildingId: string,
      building?:  {
        __typename: "Building",
        id: string,
        name: string,
        addressId?: string | null,
        acquisitionValue?: number | null,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        amountOfFacades?: number | null,
        amountOfFloors?: number | null,
        amountOfHousings?: number | null,
        buildingState?: BuildingState | null,
        cadastralIncome?: number | null,
        constructionYear?: string | null,
        janitor?: boolean | null,
        jointOwnershipId?: string | null,
        notes?: string | null,
        propertyTax?: number | null,
        residenceName?: string | null,
        buildingSiteId?: string | null,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      owners?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leases?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      events?:  {
        __typename: "ModelUnitEventConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      unitAdvertisementId?: string | null,
      unitInventories?:  {
        __typename: "ModelUnitInventoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    unitId: string,
    vatRateId?: string | null,
    vatRate?:  {
      __typename: "VatRate",
      id: string,
      country: string,
      label: string,
      value?: number | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      ownerId?: string | null,
      owner?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    readId: string,
    readers?: Array< string > | null,
    clientId: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateMortgageMutationVariables = {
  input: CreateMortgageInput,
  condition?: ModelMortgageConditionInput | null,
};

export type CreateMortgageMutation = {
  createMortgage?:  {
    __typename: "Mortgage",
    id: string,
    lender: string,
    durationInYears: number,
    rateType: MortgageRateType,
    interestRate: number,
    aprRate: number,
    startDate: string,
    amount: number,
    monthlyPayment: number,
    unitId?: string | null,
    unit?:  {
      __typename: "Unit",
      id: string,
      acquisitionAdditionalCostsValue?: number | null,
      acquisitionAdvertisedValue?: number | null,
      acquisitionValue?: number | null,
      advertisedMonthlyCharges?: number | null,
      advertisedRentalPrice?: number | null,
      cadastralIncome?: number | null,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      floor?: number | null,
      jointOwnershipId?: string | null,
      managementDate: string,
      name: string,
      notes?: string | null,
      predictedPrice?: string | null,
      propertyTax?: number | null,
      publishAddress?: boolean | null,
      surface?: number | null,
      type: UnitType,
      buildingId: string,
      building?:  {
        __typename: "Building",
        id: string,
        name: string,
        addressId?: string | null,
        acquisitionValue?: number | null,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        amountOfFacades?: number | null,
        amountOfFloors?: number | null,
        amountOfHousings?: number | null,
        buildingState?: BuildingState | null,
        cadastralIncome?: number | null,
        constructionYear?: string | null,
        janitor?: boolean | null,
        jointOwnershipId?: string | null,
        notes?: string | null,
        propertyTax?: number | null,
        residenceName?: string | null,
        buildingSiteId?: string | null,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      owners?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leases?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      events?:  {
        __typename: "ModelUnitEventConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      unitAdvertisementId?: string | null,
      unitInventories?:  {
        __typename: "ModelUnitInventoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    buildingId?: string | null,
    building?:  {
      __typename: "Building",
      id: string,
      name: string,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      acquisitionValue?: number | null,
      acquisitionAdditionalCostsValue?: number | null,
      acquisitionAdvertisedValue?: number | null,
      amountOfFacades?: number | null,
      amountOfFloors?: number | null,
      amountOfHousings?: number | null,
      buildingState?: BuildingState | null,
      cadastralIncome?: number | null,
      constructionYear?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      janitor?: boolean | null,
      jointOwnershipId?: string | null,
      notes?: string | null,
      owners?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      propertyTax?: number | null,
      residenceName?: string | null,
      buildingSiteId?: string | null,
      buildingSite?:  {
        __typename: "BuildingSite",
        id: string,
        name: string,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      units?:  {
        __typename: "ModelUnitConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      events?:  {
        __typename: "ModelBuildingEventConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      teams?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    writers?: Array< string > | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateMortgageMutationVariables = {
  input: UpdateMortgageInput,
  condition?: ModelMortgageConditionInput | null,
};

export type UpdateMortgageMutation = {
  updateMortgage?:  {
    __typename: "Mortgage",
    id: string,
    lender: string,
    durationInYears: number,
    rateType: MortgageRateType,
    interestRate: number,
    aprRate: number,
    startDate: string,
    amount: number,
    monthlyPayment: number,
    unitId?: string | null,
    unit?:  {
      __typename: "Unit",
      id: string,
      acquisitionAdditionalCostsValue?: number | null,
      acquisitionAdvertisedValue?: number | null,
      acquisitionValue?: number | null,
      advertisedMonthlyCharges?: number | null,
      advertisedRentalPrice?: number | null,
      cadastralIncome?: number | null,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      floor?: number | null,
      jointOwnershipId?: string | null,
      managementDate: string,
      name: string,
      notes?: string | null,
      predictedPrice?: string | null,
      propertyTax?: number | null,
      publishAddress?: boolean | null,
      surface?: number | null,
      type: UnitType,
      buildingId: string,
      building?:  {
        __typename: "Building",
        id: string,
        name: string,
        addressId?: string | null,
        acquisitionValue?: number | null,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        amountOfFacades?: number | null,
        amountOfFloors?: number | null,
        amountOfHousings?: number | null,
        buildingState?: BuildingState | null,
        cadastralIncome?: number | null,
        constructionYear?: string | null,
        janitor?: boolean | null,
        jointOwnershipId?: string | null,
        notes?: string | null,
        propertyTax?: number | null,
        residenceName?: string | null,
        buildingSiteId?: string | null,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      owners?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leases?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      events?:  {
        __typename: "ModelUnitEventConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      unitAdvertisementId?: string | null,
      unitInventories?:  {
        __typename: "ModelUnitInventoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    buildingId?: string | null,
    building?:  {
      __typename: "Building",
      id: string,
      name: string,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      acquisitionValue?: number | null,
      acquisitionAdditionalCostsValue?: number | null,
      acquisitionAdvertisedValue?: number | null,
      amountOfFacades?: number | null,
      amountOfFloors?: number | null,
      amountOfHousings?: number | null,
      buildingState?: BuildingState | null,
      cadastralIncome?: number | null,
      constructionYear?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      janitor?: boolean | null,
      jointOwnershipId?: string | null,
      notes?: string | null,
      owners?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      propertyTax?: number | null,
      residenceName?: string | null,
      buildingSiteId?: string | null,
      buildingSite?:  {
        __typename: "BuildingSite",
        id: string,
        name: string,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      units?:  {
        __typename: "ModelUnitConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      events?:  {
        __typename: "ModelBuildingEventConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      teams?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    writers?: Array< string > | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteMortgageMutationVariables = {
  input: DeleteMortgageInput,
  condition?: ModelMortgageConditionInput | null,
};

export type DeleteMortgageMutation = {
  deleteMortgage?:  {
    __typename: "Mortgage",
    id: string,
    lender: string,
    durationInYears: number,
    rateType: MortgageRateType,
    interestRate: number,
    aprRate: number,
    startDate: string,
    amount: number,
    monthlyPayment: number,
    unitId?: string | null,
    unit?:  {
      __typename: "Unit",
      id: string,
      acquisitionAdditionalCostsValue?: number | null,
      acquisitionAdvertisedValue?: number | null,
      acquisitionValue?: number | null,
      advertisedMonthlyCharges?: number | null,
      advertisedRentalPrice?: number | null,
      cadastralIncome?: number | null,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      floor?: number | null,
      jointOwnershipId?: string | null,
      managementDate: string,
      name: string,
      notes?: string | null,
      predictedPrice?: string | null,
      propertyTax?: number | null,
      publishAddress?: boolean | null,
      surface?: number | null,
      type: UnitType,
      buildingId: string,
      building?:  {
        __typename: "Building",
        id: string,
        name: string,
        addressId?: string | null,
        acquisitionValue?: number | null,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        amountOfFacades?: number | null,
        amountOfFloors?: number | null,
        amountOfHousings?: number | null,
        buildingState?: BuildingState | null,
        cadastralIncome?: number | null,
        constructionYear?: string | null,
        janitor?: boolean | null,
        jointOwnershipId?: string | null,
        notes?: string | null,
        propertyTax?: number | null,
        residenceName?: string | null,
        buildingSiteId?: string | null,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      owners?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leases?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      events?:  {
        __typename: "ModelUnitEventConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      unitAdvertisementId?: string | null,
      unitInventories?:  {
        __typename: "ModelUnitInventoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    buildingId?: string | null,
    building?:  {
      __typename: "Building",
      id: string,
      name: string,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      acquisitionValue?: number | null,
      acquisitionAdditionalCostsValue?: number | null,
      acquisitionAdvertisedValue?: number | null,
      amountOfFacades?: number | null,
      amountOfFloors?: number | null,
      amountOfHousings?: number | null,
      buildingState?: BuildingState | null,
      cadastralIncome?: number | null,
      constructionYear?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      janitor?: boolean | null,
      jointOwnershipId?: string | null,
      notes?: string | null,
      owners?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      propertyTax?: number | null,
      residenceName?: string | null,
      buildingSiteId?: string | null,
      buildingSite?:  {
        __typename: "BuildingSite",
        id: string,
        name: string,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      units?:  {
        __typename: "ModelUnitConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      events?:  {
        __typename: "ModelBuildingEventConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      teams?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    writers?: Array< string > | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateNotificationMutationVariables = {
  input: CreateNotificationInput,
  condition?: ModelNotificationConditionInput | null,
};

export type CreateNotificationMutation = {
  createNotification?:  {
    __typename: "Notification",
    id: string,
    createdBy: NotificationCreation,
    type?: NotificationType | null,
    message?: string | null,
    popupDate: string,
    expirationDate?: string | null,
    status: NotificationStatus,
    createdAt?: string | null,
    buildingId?: string | null,
    building?:  {
      __typename: "Building",
      id: string,
      name: string,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      acquisitionValue?: number | null,
      acquisitionAdditionalCostsValue?: number | null,
      acquisitionAdvertisedValue?: number | null,
      amountOfFacades?: number | null,
      amountOfFloors?: number | null,
      amountOfHousings?: number | null,
      buildingState?: BuildingState | null,
      cadastralIncome?: number | null,
      constructionYear?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      janitor?: boolean | null,
      jointOwnershipId?: string | null,
      notes?: string | null,
      owners?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      propertyTax?: number | null,
      residenceName?: string | null,
      buildingSiteId?: string | null,
      buildingSite?:  {
        __typename: "BuildingSite",
        id: string,
        name: string,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      units?:  {
        __typename: "ModelUnitConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      events?:  {
        __typename: "ModelBuildingEventConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      teams?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    unitId?: string | null,
    unit?:  {
      __typename: "Unit",
      id: string,
      acquisitionAdditionalCostsValue?: number | null,
      acquisitionAdvertisedValue?: number | null,
      acquisitionValue?: number | null,
      advertisedMonthlyCharges?: number | null,
      advertisedRentalPrice?: number | null,
      cadastralIncome?: number | null,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      floor?: number | null,
      jointOwnershipId?: string | null,
      managementDate: string,
      name: string,
      notes?: string | null,
      predictedPrice?: string | null,
      propertyTax?: number | null,
      publishAddress?: boolean | null,
      surface?: number | null,
      type: UnitType,
      buildingId: string,
      building?:  {
        __typename: "Building",
        id: string,
        name: string,
        addressId?: string | null,
        acquisitionValue?: number | null,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        amountOfFacades?: number | null,
        amountOfFloors?: number | null,
        amountOfHousings?: number | null,
        buildingState?: BuildingState | null,
        cadastralIncome?: number | null,
        constructionYear?: string | null,
        janitor?: boolean | null,
        jointOwnershipId?: string | null,
        notes?: string | null,
        propertyTax?: number | null,
        residenceName?: string | null,
        buildingSiteId?: string | null,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      owners?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leases?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      events?:  {
        __typename: "ModelUnitEventConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      unitAdvertisementId?: string | null,
      unitInventories?:  {
        __typename: "ModelUnitInventoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    leaseId?: string | null,
    lease?:  {
      __typename: "Lease",
      id: string,
      advancedChargesInvoices?:  {
        __typename: "LeaseAdvancedChargesInvoice",
        communicationSettingsProfileId: string,
        invoiceSenderId: string,
        lastDraftInvoiceDate?: string | null,
        lastInvoiceDate?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        bankAccountId?: string | null,
      } | null,
      balance?: number | null,
      canBeExtended?: boolean | null,
      communicationSettingsProfileId: string,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      endDate: string,
      includeRealEstateInLeaseContract?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      invoiceSenderId: string,
      invoiceSender?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      inventoryOfFixturesExpert?: string | null,
      inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
      inventoryOfFixturesType?: InventoryOfFixturesType | null,
      ipiNumber?: string | null,
      language: Language,
      lastDraftInvoiceDate?: string | null,
      lastIndexationProcessDate?: string | null,
      lastInvoiceDate?: string | null,
      legalCompetentAuthority?: string | null,
      name: string,
      notes?: string | null,
      paymentFrequency: LeasePaymentFrequency,
      paymentInvoicePeriod: LeasePaymentInvoicePeriod,
      paymentInvoicePeriodCustomDay?: number | null,
      paymentOption?:  {
        __typename: "LeasePaymentOption",
        customerId?: string | null,
        enabled: boolean,
        mandateActivatedAt?: string | null,
        mandateStatus?: PaymentProviderMandateStatus | null,
        paymentMethodId?: string | null,
        qrType?: LeaseQrType | null,
      } | null,
      purchaseOrderNumber?: string | null,
      realEstateAgency?: string | null,
      realEstateTax?: number | null,
      remittanceInformation?: string | null,
      remittanceInformationType?: LeaseRemittanceType | null,
      rentalGuaranty?:  {
        __typename: "LeaseRentalGuaranty",
        amount: number,
        blockedAmount?: number | null,
        releasedAmount?: number | null,
        type: LeaseRentalGuarantyType,
        financialInstitution?: string | null,
      } | null,
      signatureDate?: string | null,
      startDate: string,
      nextIndexationMonth?: string | null,
      nextIndexation?: boolean | null,
      status: LeaseStatus,
      technicCommunicationSettingsProfileId: string,
      totalInitialRentalPrice: number,
      totalRentalPrice: number,
      type: LeaseType,
      subletting?: boolean | null,
      vatRateRentId?: string | null,
      vatRateRent?:  {
        __typename: "VatRate",
        id: string,
        country: string,
        label: string,
        value?: number | null,
        ownerId?: string | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      additionalClauses?:  {
        __typename: "ModelLeaseAdditionalClauseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      bankAccountId?: string | null,
      bankAccount?:  {
        __typename: "BankAccount",
        id: string,
        contactId: string,
        number: string,
        bicNumber?: string | null,
        bankName?: string | null,
        contactIds?: Array< string > | null,
        buildingIds?: Array< string > | null,
        holderName?: string | null,
        label?: string | null,
        disabled?: boolean | null,
        integrations?: Array< IntegrationName > | null,
        matchingRule?: BankAccountMatchingRule | null,
        balance?: number | null,
        balanceDate?: string | null,
        type: BankAccountType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contacts?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      files?:  {
        __typename: "ModelFileConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leaseActionHistories?:  {
        __typename: "ModelLeaseActionHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leasePriceHistories?:  {
        __typename: "ModelLeasePriceHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      signatureDocuments?:  {
        __typename: "ModelSignatureDocumentConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      variousOperations?:  {
        __typename: "ModelLeaseVariousOperationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    technicId?: string | null,
    technic?:  {
      __typename: "Technic",
      id: string,
      type: TechnicType,
      contractNumber?: string | null,
      communicationSettingsProfileId: string,
      maintenanceHistory?:  Array< {
        __typename: "TechnicMaintenanceHistory",
        date: string,
        contactId?: string | null,
        fileId?: string | null,
      } > | null,
      technicLibraryId?: string | null,
      technicLibrary?:  {
        __typename: "TechnicLibrary",
        id: string,
        communicationSettingsProfileId?: string | null,
        criticality: TechnicLibraryCriticality,
        isDefault?: boolean | null,
        issuingAuthority?: string | null,
        linkedCertificateIds?: Array< string > | null,
        locationScope?: TechnicLibraryLocationScope | null,
        status: TechnicLibraryStatus,
        tagIds?: Array< string > | null,
        technicLibraryFormat?: string | null,
        type: TechnicLibraryType,
        utilityTypes?: Array< UtilityType > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      technicName?: string | null,
      lastControlDate?: string | null,
      status?: TechnicStatus | null,
      utilityType?: UtilityType | null,
      utilityEanCode?: string | null,
      utilityMeterNumber?: string | null,
      utilityDistributorId?: string | null,
      utilityDistributor?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      utilityHistory?:  Array< {
        __typename: "UtilityHistory",
        date: string,
        reason?: UtilityReadingReason | null,
        reading: number,
        secondReading?: number | null,
      } > | null,
      files?:  {
        __typename: "ModelFileConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildingId?: string | null,
      building?:  {
        __typename: "Building",
        id: string,
        name: string,
        addressId?: string | null,
        acquisitionValue?: number | null,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        amountOfFacades?: number | null,
        amountOfFloors?: number | null,
        amountOfHousings?: number | null,
        buildingState?: BuildingState | null,
        cadastralIncome?: number | null,
        constructionYear?: string | null,
        janitor?: boolean | null,
        jointOwnershipId?: string | null,
        notes?: string | null,
        propertyTax?: number | null,
        residenceName?: string | null,
        buildingSiteId?: string | null,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      unitId?: string | null,
      unit?:  {
        __typename: "Unit",
        id: string,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        acquisitionValue?: number | null,
        advertisedMonthlyCharges?: number | null,
        advertisedRentalPrice?: number | null,
        cadastralIncome?: number | null,
        createdAt?: string | null,
        floor?: number | null,
        jointOwnershipId?: string | null,
        managementDate: string,
        name: string,
        notes?: string | null,
        predictedPrice?: string | null,
        propertyTax?: number | null,
        publishAddress?: boolean | null,
        surface?: number | null,
        type: UnitType,
        buildingId: string,
        unitAdvertisementId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      leaseId?: string | null,
      lease?:  {
        __typename: "Lease",
        id: string,
        balance?: number | null,
        canBeExtended?: boolean | null,
        communicationSettingsProfileId: string,
        createdAt?: string | null,
        endDate: string,
        includeRealEstateInLeaseContract?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        invoiceSenderId: string,
        inventoryOfFixturesExpert?: string | null,
        inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
        inventoryOfFixturesType?: InventoryOfFixturesType | null,
        ipiNumber?: string | null,
        language: Language,
        lastDraftInvoiceDate?: string | null,
        lastIndexationProcessDate?: string | null,
        lastInvoiceDate?: string | null,
        legalCompetentAuthority?: string | null,
        name: string,
        notes?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        purchaseOrderNumber?: string | null,
        realEstateAgency?: string | null,
        realEstateTax?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        signatureDate?: string | null,
        startDate: string,
        nextIndexationMonth?: string | null,
        nextIndexation?: boolean | null,
        status: LeaseStatus,
        technicCommunicationSettingsProfileId: string,
        totalInitialRentalPrice: number,
        totalRentalPrice: number,
        type: LeaseType,
        subletting?: boolean | null,
        vatRateRentId?: string | null,
        bankAccountId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contactId?: string | null,
      contact?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      originalTechnicId?: string | null,
      replacedTechnicId?: string | null,
      certificateIds?: Array< string > | null,
      readers?: Array< string > | null,
      writers?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    ticketId?: string | null,
    ticket?:  {
      __typename: "Ticket",
      id: string,
      assignedAt?: string | null,
      assignedTo?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      assignedToId?: string | null,
      attachment?:  {
        __typename: "ModelFileConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      building?:  {
        __typename: "Building",
        id: string,
        name: string,
        addressId?: string | null,
        acquisitionValue?: number | null,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        amountOfFacades?: number | null,
        amountOfFloors?: number | null,
        amountOfHousings?: number | null,
        buildingState?: BuildingState | null,
        cadastralIncome?: number | null,
        constructionYear?: string | null,
        janitor?: boolean | null,
        jointOwnershipId?: string | null,
        notes?: string | null,
        propertyTax?: number | null,
        residenceName?: string | null,
        buildingSiteId?: string | null,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      buildingId?: string | null,
      closedAt?: string | null,
      contact?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contactId: string,
      content: string,
      conversations?:  {
        __typename: "ModelTicketConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      createdAt: string,
      emailMessageId?: string | null,
      emailReferences?: Array< string | null > | null,
      parentId?: string | null,
      plannedAt?: string | null,
      referenceCode?: string | null,
      sourceType: TicketSourceType,
      status?: TicketStatus | null,
      subject: string,
      unit?:  {
        __typename: "Unit",
        id: string,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        acquisitionValue?: number | null,
        advertisedMonthlyCharges?: number | null,
        advertisedRentalPrice?: number | null,
        cadastralIncome?: number | null,
        createdAt?: string | null,
        floor?: number | null,
        jointOwnershipId?: string | null,
        managementDate: string,
        name: string,
        notes?: string | null,
        predictedPrice?: string | null,
        propertyTax?: number | null,
        publishAddress?: boolean | null,
        surface?: number | null,
        type: UnitType,
        buildingId: string,
        unitAdvertisementId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      unitId?: string | null,
      unread: boolean,
      updatedAt?: string | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    readId: string,
    clientId: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateNotificationMutationVariables = {
  input: UpdateNotificationInput,
  condition?: ModelNotificationConditionInput | null,
};

export type UpdateNotificationMutation = {
  updateNotification?:  {
    __typename: "Notification",
    id: string,
    createdBy: NotificationCreation,
    type?: NotificationType | null,
    message?: string | null,
    popupDate: string,
    expirationDate?: string | null,
    status: NotificationStatus,
    createdAt?: string | null,
    buildingId?: string | null,
    building?:  {
      __typename: "Building",
      id: string,
      name: string,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      acquisitionValue?: number | null,
      acquisitionAdditionalCostsValue?: number | null,
      acquisitionAdvertisedValue?: number | null,
      amountOfFacades?: number | null,
      amountOfFloors?: number | null,
      amountOfHousings?: number | null,
      buildingState?: BuildingState | null,
      cadastralIncome?: number | null,
      constructionYear?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      janitor?: boolean | null,
      jointOwnershipId?: string | null,
      notes?: string | null,
      owners?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      propertyTax?: number | null,
      residenceName?: string | null,
      buildingSiteId?: string | null,
      buildingSite?:  {
        __typename: "BuildingSite",
        id: string,
        name: string,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      units?:  {
        __typename: "ModelUnitConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      events?:  {
        __typename: "ModelBuildingEventConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      teams?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    unitId?: string | null,
    unit?:  {
      __typename: "Unit",
      id: string,
      acquisitionAdditionalCostsValue?: number | null,
      acquisitionAdvertisedValue?: number | null,
      acquisitionValue?: number | null,
      advertisedMonthlyCharges?: number | null,
      advertisedRentalPrice?: number | null,
      cadastralIncome?: number | null,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      floor?: number | null,
      jointOwnershipId?: string | null,
      managementDate: string,
      name: string,
      notes?: string | null,
      predictedPrice?: string | null,
      propertyTax?: number | null,
      publishAddress?: boolean | null,
      surface?: number | null,
      type: UnitType,
      buildingId: string,
      building?:  {
        __typename: "Building",
        id: string,
        name: string,
        addressId?: string | null,
        acquisitionValue?: number | null,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        amountOfFacades?: number | null,
        amountOfFloors?: number | null,
        amountOfHousings?: number | null,
        buildingState?: BuildingState | null,
        cadastralIncome?: number | null,
        constructionYear?: string | null,
        janitor?: boolean | null,
        jointOwnershipId?: string | null,
        notes?: string | null,
        propertyTax?: number | null,
        residenceName?: string | null,
        buildingSiteId?: string | null,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      owners?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leases?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      events?:  {
        __typename: "ModelUnitEventConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      unitAdvertisementId?: string | null,
      unitInventories?:  {
        __typename: "ModelUnitInventoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    leaseId?: string | null,
    lease?:  {
      __typename: "Lease",
      id: string,
      advancedChargesInvoices?:  {
        __typename: "LeaseAdvancedChargesInvoice",
        communicationSettingsProfileId: string,
        invoiceSenderId: string,
        lastDraftInvoiceDate?: string | null,
        lastInvoiceDate?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        bankAccountId?: string | null,
      } | null,
      balance?: number | null,
      canBeExtended?: boolean | null,
      communicationSettingsProfileId: string,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      endDate: string,
      includeRealEstateInLeaseContract?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      invoiceSenderId: string,
      invoiceSender?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      inventoryOfFixturesExpert?: string | null,
      inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
      inventoryOfFixturesType?: InventoryOfFixturesType | null,
      ipiNumber?: string | null,
      language: Language,
      lastDraftInvoiceDate?: string | null,
      lastIndexationProcessDate?: string | null,
      lastInvoiceDate?: string | null,
      legalCompetentAuthority?: string | null,
      name: string,
      notes?: string | null,
      paymentFrequency: LeasePaymentFrequency,
      paymentInvoicePeriod: LeasePaymentInvoicePeriod,
      paymentInvoicePeriodCustomDay?: number | null,
      paymentOption?:  {
        __typename: "LeasePaymentOption",
        customerId?: string | null,
        enabled: boolean,
        mandateActivatedAt?: string | null,
        mandateStatus?: PaymentProviderMandateStatus | null,
        paymentMethodId?: string | null,
        qrType?: LeaseQrType | null,
      } | null,
      purchaseOrderNumber?: string | null,
      realEstateAgency?: string | null,
      realEstateTax?: number | null,
      remittanceInformation?: string | null,
      remittanceInformationType?: LeaseRemittanceType | null,
      rentalGuaranty?:  {
        __typename: "LeaseRentalGuaranty",
        amount: number,
        blockedAmount?: number | null,
        releasedAmount?: number | null,
        type: LeaseRentalGuarantyType,
        financialInstitution?: string | null,
      } | null,
      signatureDate?: string | null,
      startDate: string,
      nextIndexationMonth?: string | null,
      nextIndexation?: boolean | null,
      status: LeaseStatus,
      technicCommunicationSettingsProfileId: string,
      totalInitialRentalPrice: number,
      totalRentalPrice: number,
      type: LeaseType,
      subletting?: boolean | null,
      vatRateRentId?: string | null,
      vatRateRent?:  {
        __typename: "VatRate",
        id: string,
        country: string,
        label: string,
        value?: number | null,
        ownerId?: string | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      additionalClauses?:  {
        __typename: "ModelLeaseAdditionalClauseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      bankAccountId?: string | null,
      bankAccount?:  {
        __typename: "BankAccount",
        id: string,
        contactId: string,
        number: string,
        bicNumber?: string | null,
        bankName?: string | null,
        contactIds?: Array< string > | null,
        buildingIds?: Array< string > | null,
        holderName?: string | null,
        label?: string | null,
        disabled?: boolean | null,
        integrations?: Array< IntegrationName > | null,
        matchingRule?: BankAccountMatchingRule | null,
        balance?: number | null,
        balanceDate?: string | null,
        type: BankAccountType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contacts?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      files?:  {
        __typename: "ModelFileConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leaseActionHistories?:  {
        __typename: "ModelLeaseActionHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leasePriceHistories?:  {
        __typename: "ModelLeasePriceHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      signatureDocuments?:  {
        __typename: "ModelSignatureDocumentConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      variousOperations?:  {
        __typename: "ModelLeaseVariousOperationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    technicId?: string | null,
    technic?:  {
      __typename: "Technic",
      id: string,
      type: TechnicType,
      contractNumber?: string | null,
      communicationSettingsProfileId: string,
      maintenanceHistory?:  Array< {
        __typename: "TechnicMaintenanceHistory",
        date: string,
        contactId?: string | null,
        fileId?: string | null,
      } > | null,
      technicLibraryId?: string | null,
      technicLibrary?:  {
        __typename: "TechnicLibrary",
        id: string,
        communicationSettingsProfileId?: string | null,
        criticality: TechnicLibraryCriticality,
        isDefault?: boolean | null,
        issuingAuthority?: string | null,
        linkedCertificateIds?: Array< string > | null,
        locationScope?: TechnicLibraryLocationScope | null,
        status: TechnicLibraryStatus,
        tagIds?: Array< string > | null,
        technicLibraryFormat?: string | null,
        type: TechnicLibraryType,
        utilityTypes?: Array< UtilityType > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      technicName?: string | null,
      lastControlDate?: string | null,
      status?: TechnicStatus | null,
      utilityType?: UtilityType | null,
      utilityEanCode?: string | null,
      utilityMeterNumber?: string | null,
      utilityDistributorId?: string | null,
      utilityDistributor?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      utilityHistory?:  Array< {
        __typename: "UtilityHistory",
        date: string,
        reason?: UtilityReadingReason | null,
        reading: number,
        secondReading?: number | null,
      } > | null,
      files?:  {
        __typename: "ModelFileConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildingId?: string | null,
      building?:  {
        __typename: "Building",
        id: string,
        name: string,
        addressId?: string | null,
        acquisitionValue?: number | null,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        amountOfFacades?: number | null,
        amountOfFloors?: number | null,
        amountOfHousings?: number | null,
        buildingState?: BuildingState | null,
        cadastralIncome?: number | null,
        constructionYear?: string | null,
        janitor?: boolean | null,
        jointOwnershipId?: string | null,
        notes?: string | null,
        propertyTax?: number | null,
        residenceName?: string | null,
        buildingSiteId?: string | null,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      unitId?: string | null,
      unit?:  {
        __typename: "Unit",
        id: string,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        acquisitionValue?: number | null,
        advertisedMonthlyCharges?: number | null,
        advertisedRentalPrice?: number | null,
        cadastralIncome?: number | null,
        createdAt?: string | null,
        floor?: number | null,
        jointOwnershipId?: string | null,
        managementDate: string,
        name: string,
        notes?: string | null,
        predictedPrice?: string | null,
        propertyTax?: number | null,
        publishAddress?: boolean | null,
        surface?: number | null,
        type: UnitType,
        buildingId: string,
        unitAdvertisementId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      leaseId?: string | null,
      lease?:  {
        __typename: "Lease",
        id: string,
        balance?: number | null,
        canBeExtended?: boolean | null,
        communicationSettingsProfileId: string,
        createdAt?: string | null,
        endDate: string,
        includeRealEstateInLeaseContract?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        invoiceSenderId: string,
        inventoryOfFixturesExpert?: string | null,
        inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
        inventoryOfFixturesType?: InventoryOfFixturesType | null,
        ipiNumber?: string | null,
        language: Language,
        lastDraftInvoiceDate?: string | null,
        lastIndexationProcessDate?: string | null,
        lastInvoiceDate?: string | null,
        legalCompetentAuthority?: string | null,
        name: string,
        notes?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        purchaseOrderNumber?: string | null,
        realEstateAgency?: string | null,
        realEstateTax?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        signatureDate?: string | null,
        startDate: string,
        nextIndexationMonth?: string | null,
        nextIndexation?: boolean | null,
        status: LeaseStatus,
        technicCommunicationSettingsProfileId: string,
        totalInitialRentalPrice: number,
        totalRentalPrice: number,
        type: LeaseType,
        subletting?: boolean | null,
        vatRateRentId?: string | null,
        bankAccountId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contactId?: string | null,
      contact?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      originalTechnicId?: string | null,
      replacedTechnicId?: string | null,
      certificateIds?: Array< string > | null,
      readers?: Array< string > | null,
      writers?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    ticketId?: string | null,
    ticket?:  {
      __typename: "Ticket",
      id: string,
      assignedAt?: string | null,
      assignedTo?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      assignedToId?: string | null,
      attachment?:  {
        __typename: "ModelFileConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      building?:  {
        __typename: "Building",
        id: string,
        name: string,
        addressId?: string | null,
        acquisitionValue?: number | null,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        amountOfFacades?: number | null,
        amountOfFloors?: number | null,
        amountOfHousings?: number | null,
        buildingState?: BuildingState | null,
        cadastralIncome?: number | null,
        constructionYear?: string | null,
        janitor?: boolean | null,
        jointOwnershipId?: string | null,
        notes?: string | null,
        propertyTax?: number | null,
        residenceName?: string | null,
        buildingSiteId?: string | null,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      buildingId?: string | null,
      closedAt?: string | null,
      contact?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contactId: string,
      content: string,
      conversations?:  {
        __typename: "ModelTicketConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      createdAt: string,
      emailMessageId?: string | null,
      emailReferences?: Array< string | null > | null,
      parentId?: string | null,
      plannedAt?: string | null,
      referenceCode?: string | null,
      sourceType: TicketSourceType,
      status?: TicketStatus | null,
      subject: string,
      unit?:  {
        __typename: "Unit",
        id: string,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        acquisitionValue?: number | null,
        advertisedMonthlyCharges?: number | null,
        advertisedRentalPrice?: number | null,
        cadastralIncome?: number | null,
        createdAt?: string | null,
        floor?: number | null,
        jointOwnershipId?: string | null,
        managementDate: string,
        name: string,
        notes?: string | null,
        predictedPrice?: string | null,
        propertyTax?: number | null,
        publishAddress?: boolean | null,
        surface?: number | null,
        type: UnitType,
        buildingId: string,
        unitAdvertisementId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      unitId?: string | null,
      unread: boolean,
      updatedAt?: string | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    readId: string,
    clientId: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteNotificationMutationVariables = {
  input: DeleteNotificationInput,
  condition?: ModelNotificationConditionInput | null,
};

export type DeleteNotificationMutation = {
  deleteNotification?:  {
    __typename: "Notification",
    id: string,
    createdBy: NotificationCreation,
    type?: NotificationType | null,
    message?: string | null,
    popupDate: string,
    expirationDate?: string | null,
    status: NotificationStatus,
    createdAt?: string | null,
    buildingId?: string | null,
    building?:  {
      __typename: "Building",
      id: string,
      name: string,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      acquisitionValue?: number | null,
      acquisitionAdditionalCostsValue?: number | null,
      acquisitionAdvertisedValue?: number | null,
      amountOfFacades?: number | null,
      amountOfFloors?: number | null,
      amountOfHousings?: number | null,
      buildingState?: BuildingState | null,
      cadastralIncome?: number | null,
      constructionYear?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      janitor?: boolean | null,
      jointOwnershipId?: string | null,
      notes?: string | null,
      owners?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      propertyTax?: number | null,
      residenceName?: string | null,
      buildingSiteId?: string | null,
      buildingSite?:  {
        __typename: "BuildingSite",
        id: string,
        name: string,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      units?:  {
        __typename: "ModelUnitConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      events?:  {
        __typename: "ModelBuildingEventConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      teams?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    unitId?: string | null,
    unit?:  {
      __typename: "Unit",
      id: string,
      acquisitionAdditionalCostsValue?: number | null,
      acquisitionAdvertisedValue?: number | null,
      acquisitionValue?: number | null,
      advertisedMonthlyCharges?: number | null,
      advertisedRentalPrice?: number | null,
      cadastralIncome?: number | null,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      floor?: number | null,
      jointOwnershipId?: string | null,
      managementDate: string,
      name: string,
      notes?: string | null,
      predictedPrice?: string | null,
      propertyTax?: number | null,
      publishAddress?: boolean | null,
      surface?: number | null,
      type: UnitType,
      buildingId: string,
      building?:  {
        __typename: "Building",
        id: string,
        name: string,
        addressId?: string | null,
        acquisitionValue?: number | null,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        amountOfFacades?: number | null,
        amountOfFloors?: number | null,
        amountOfHousings?: number | null,
        buildingState?: BuildingState | null,
        cadastralIncome?: number | null,
        constructionYear?: string | null,
        janitor?: boolean | null,
        jointOwnershipId?: string | null,
        notes?: string | null,
        propertyTax?: number | null,
        residenceName?: string | null,
        buildingSiteId?: string | null,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      owners?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leases?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      events?:  {
        __typename: "ModelUnitEventConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      unitAdvertisementId?: string | null,
      unitInventories?:  {
        __typename: "ModelUnitInventoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    leaseId?: string | null,
    lease?:  {
      __typename: "Lease",
      id: string,
      advancedChargesInvoices?:  {
        __typename: "LeaseAdvancedChargesInvoice",
        communicationSettingsProfileId: string,
        invoiceSenderId: string,
        lastDraftInvoiceDate?: string | null,
        lastInvoiceDate?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        bankAccountId?: string | null,
      } | null,
      balance?: number | null,
      canBeExtended?: boolean | null,
      communicationSettingsProfileId: string,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      endDate: string,
      includeRealEstateInLeaseContract?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      invoiceSenderId: string,
      invoiceSender?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      inventoryOfFixturesExpert?: string | null,
      inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
      inventoryOfFixturesType?: InventoryOfFixturesType | null,
      ipiNumber?: string | null,
      language: Language,
      lastDraftInvoiceDate?: string | null,
      lastIndexationProcessDate?: string | null,
      lastInvoiceDate?: string | null,
      legalCompetentAuthority?: string | null,
      name: string,
      notes?: string | null,
      paymentFrequency: LeasePaymentFrequency,
      paymentInvoicePeriod: LeasePaymentInvoicePeriod,
      paymentInvoicePeriodCustomDay?: number | null,
      paymentOption?:  {
        __typename: "LeasePaymentOption",
        customerId?: string | null,
        enabled: boolean,
        mandateActivatedAt?: string | null,
        mandateStatus?: PaymentProviderMandateStatus | null,
        paymentMethodId?: string | null,
        qrType?: LeaseQrType | null,
      } | null,
      purchaseOrderNumber?: string | null,
      realEstateAgency?: string | null,
      realEstateTax?: number | null,
      remittanceInformation?: string | null,
      remittanceInformationType?: LeaseRemittanceType | null,
      rentalGuaranty?:  {
        __typename: "LeaseRentalGuaranty",
        amount: number,
        blockedAmount?: number | null,
        releasedAmount?: number | null,
        type: LeaseRentalGuarantyType,
        financialInstitution?: string | null,
      } | null,
      signatureDate?: string | null,
      startDate: string,
      nextIndexationMonth?: string | null,
      nextIndexation?: boolean | null,
      status: LeaseStatus,
      technicCommunicationSettingsProfileId: string,
      totalInitialRentalPrice: number,
      totalRentalPrice: number,
      type: LeaseType,
      subletting?: boolean | null,
      vatRateRentId?: string | null,
      vatRateRent?:  {
        __typename: "VatRate",
        id: string,
        country: string,
        label: string,
        value?: number | null,
        ownerId?: string | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      additionalClauses?:  {
        __typename: "ModelLeaseAdditionalClauseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      bankAccountId?: string | null,
      bankAccount?:  {
        __typename: "BankAccount",
        id: string,
        contactId: string,
        number: string,
        bicNumber?: string | null,
        bankName?: string | null,
        contactIds?: Array< string > | null,
        buildingIds?: Array< string > | null,
        holderName?: string | null,
        label?: string | null,
        disabled?: boolean | null,
        integrations?: Array< IntegrationName > | null,
        matchingRule?: BankAccountMatchingRule | null,
        balance?: number | null,
        balanceDate?: string | null,
        type: BankAccountType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contacts?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      files?:  {
        __typename: "ModelFileConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leaseActionHistories?:  {
        __typename: "ModelLeaseActionHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leasePriceHistories?:  {
        __typename: "ModelLeasePriceHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      signatureDocuments?:  {
        __typename: "ModelSignatureDocumentConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      variousOperations?:  {
        __typename: "ModelLeaseVariousOperationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    technicId?: string | null,
    technic?:  {
      __typename: "Technic",
      id: string,
      type: TechnicType,
      contractNumber?: string | null,
      communicationSettingsProfileId: string,
      maintenanceHistory?:  Array< {
        __typename: "TechnicMaintenanceHistory",
        date: string,
        contactId?: string | null,
        fileId?: string | null,
      } > | null,
      technicLibraryId?: string | null,
      technicLibrary?:  {
        __typename: "TechnicLibrary",
        id: string,
        communicationSettingsProfileId?: string | null,
        criticality: TechnicLibraryCriticality,
        isDefault?: boolean | null,
        issuingAuthority?: string | null,
        linkedCertificateIds?: Array< string > | null,
        locationScope?: TechnicLibraryLocationScope | null,
        status: TechnicLibraryStatus,
        tagIds?: Array< string > | null,
        technicLibraryFormat?: string | null,
        type: TechnicLibraryType,
        utilityTypes?: Array< UtilityType > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      technicName?: string | null,
      lastControlDate?: string | null,
      status?: TechnicStatus | null,
      utilityType?: UtilityType | null,
      utilityEanCode?: string | null,
      utilityMeterNumber?: string | null,
      utilityDistributorId?: string | null,
      utilityDistributor?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      utilityHistory?:  Array< {
        __typename: "UtilityHistory",
        date: string,
        reason?: UtilityReadingReason | null,
        reading: number,
        secondReading?: number | null,
      } > | null,
      files?:  {
        __typename: "ModelFileConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildingId?: string | null,
      building?:  {
        __typename: "Building",
        id: string,
        name: string,
        addressId?: string | null,
        acquisitionValue?: number | null,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        amountOfFacades?: number | null,
        amountOfFloors?: number | null,
        amountOfHousings?: number | null,
        buildingState?: BuildingState | null,
        cadastralIncome?: number | null,
        constructionYear?: string | null,
        janitor?: boolean | null,
        jointOwnershipId?: string | null,
        notes?: string | null,
        propertyTax?: number | null,
        residenceName?: string | null,
        buildingSiteId?: string | null,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      unitId?: string | null,
      unit?:  {
        __typename: "Unit",
        id: string,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        acquisitionValue?: number | null,
        advertisedMonthlyCharges?: number | null,
        advertisedRentalPrice?: number | null,
        cadastralIncome?: number | null,
        createdAt?: string | null,
        floor?: number | null,
        jointOwnershipId?: string | null,
        managementDate: string,
        name: string,
        notes?: string | null,
        predictedPrice?: string | null,
        propertyTax?: number | null,
        publishAddress?: boolean | null,
        surface?: number | null,
        type: UnitType,
        buildingId: string,
        unitAdvertisementId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      leaseId?: string | null,
      lease?:  {
        __typename: "Lease",
        id: string,
        balance?: number | null,
        canBeExtended?: boolean | null,
        communicationSettingsProfileId: string,
        createdAt?: string | null,
        endDate: string,
        includeRealEstateInLeaseContract?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        invoiceSenderId: string,
        inventoryOfFixturesExpert?: string | null,
        inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
        inventoryOfFixturesType?: InventoryOfFixturesType | null,
        ipiNumber?: string | null,
        language: Language,
        lastDraftInvoiceDate?: string | null,
        lastIndexationProcessDate?: string | null,
        lastInvoiceDate?: string | null,
        legalCompetentAuthority?: string | null,
        name: string,
        notes?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        purchaseOrderNumber?: string | null,
        realEstateAgency?: string | null,
        realEstateTax?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        signatureDate?: string | null,
        startDate: string,
        nextIndexationMonth?: string | null,
        nextIndexation?: boolean | null,
        status: LeaseStatus,
        technicCommunicationSettingsProfileId: string,
        totalInitialRentalPrice: number,
        totalRentalPrice: number,
        type: LeaseType,
        subletting?: boolean | null,
        vatRateRentId?: string | null,
        bankAccountId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contactId?: string | null,
      contact?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      originalTechnicId?: string | null,
      replacedTechnicId?: string | null,
      certificateIds?: Array< string > | null,
      readers?: Array< string > | null,
      writers?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    ticketId?: string | null,
    ticket?:  {
      __typename: "Ticket",
      id: string,
      assignedAt?: string | null,
      assignedTo?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      assignedToId?: string | null,
      attachment?:  {
        __typename: "ModelFileConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      building?:  {
        __typename: "Building",
        id: string,
        name: string,
        addressId?: string | null,
        acquisitionValue?: number | null,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        amountOfFacades?: number | null,
        amountOfFloors?: number | null,
        amountOfHousings?: number | null,
        buildingState?: BuildingState | null,
        cadastralIncome?: number | null,
        constructionYear?: string | null,
        janitor?: boolean | null,
        jointOwnershipId?: string | null,
        notes?: string | null,
        propertyTax?: number | null,
        residenceName?: string | null,
        buildingSiteId?: string | null,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      buildingId?: string | null,
      closedAt?: string | null,
      contact?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contactId: string,
      content: string,
      conversations?:  {
        __typename: "ModelTicketConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      createdAt: string,
      emailMessageId?: string | null,
      emailReferences?: Array< string | null > | null,
      parentId?: string | null,
      plannedAt?: string | null,
      referenceCode?: string | null,
      sourceType: TicketSourceType,
      status?: TicketStatus | null,
      subject: string,
      unit?:  {
        __typename: "Unit",
        id: string,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        acquisitionValue?: number | null,
        advertisedMonthlyCharges?: number | null,
        advertisedRentalPrice?: number | null,
        cadastralIncome?: number | null,
        createdAt?: string | null,
        floor?: number | null,
        jointOwnershipId?: string | null,
        managementDate: string,
        name: string,
        notes?: string | null,
        predictedPrice?: string | null,
        propertyTax?: number | null,
        publishAddress?: boolean | null,
        surface?: number | null,
        type: UnitType,
        buildingId: string,
        unitAdvertisementId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      unitId?: string | null,
      unread: boolean,
      updatedAt?: string | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    readId: string,
    clientId: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateScheduleRuleMutationVariables = {
  input: CreateScheduleRuleInput,
  condition?: ModelScheduleRuleConditionInput | null,
};

export type CreateScheduleRuleMutation = {
  createScheduleRule?:  {
    __typename: "ScheduleRule",
    id: string,
    conditions:  Array< {
      __typename: "RuleCondition",
      attribute:  {
        __typename: "RuleAttributeRef",
        attributeName: string,
      },
      comparisonMode?: RuleComparisonMode | null,
      operator: RuleConditionOperator,
      values?: Array< string > | null,
      valueKind: RuleValueKind,
    } >,
    conditionsOperator?: RuleConditionsOperator | null,
    foreignKey: string,
    foreignTableName: string,
    name?:  Array< {
      __typename: "CustomLabel",
      language: string,
      label: string,
    } > | null,
    order?: number | null,
    outcome:  {
      __typename: "RuleOutcome",
      interval?:  {
        __typename: "RuleIntervalOutcome",
      } | null,
      type: RuleOutcomeType,
    },
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateScheduleRuleMutationVariables = {
  input: UpdateScheduleRuleInput,
  condition?: ModelScheduleRuleConditionInput | null,
};

export type UpdateScheduleRuleMutation = {
  updateScheduleRule?:  {
    __typename: "ScheduleRule",
    id: string,
    conditions:  Array< {
      __typename: "RuleCondition",
      attribute:  {
        __typename: "RuleAttributeRef",
        attributeName: string,
      },
      comparisonMode?: RuleComparisonMode | null,
      operator: RuleConditionOperator,
      values?: Array< string > | null,
      valueKind: RuleValueKind,
    } >,
    conditionsOperator?: RuleConditionsOperator | null,
    foreignKey: string,
    foreignTableName: string,
    name?:  Array< {
      __typename: "CustomLabel",
      language: string,
      label: string,
    } > | null,
    order?: number | null,
    outcome:  {
      __typename: "RuleOutcome",
      interval?:  {
        __typename: "RuleIntervalOutcome",
      } | null,
      type: RuleOutcomeType,
    },
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteScheduleRuleMutationVariables = {
  input: DeleteScheduleRuleInput,
  condition?: ModelScheduleRuleConditionInput | null,
};

export type DeleteScheduleRuleMutation = {
  deleteScheduleRule?:  {
    __typename: "ScheduleRule",
    id: string,
    conditions:  Array< {
      __typename: "RuleCondition",
      attribute:  {
        __typename: "RuleAttributeRef",
        attributeName: string,
      },
      comparisonMode?: RuleComparisonMode | null,
      operator: RuleConditionOperator,
      values?: Array< string > | null,
      valueKind: RuleValueKind,
    } >,
    conditionsOperator?: RuleConditionsOperator | null,
    foreignKey: string,
    foreignTableName: string,
    name?:  Array< {
      __typename: "CustomLabel",
      language: string,
      label: string,
    } > | null,
    order?: number | null,
    outcome:  {
      __typename: "RuleOutcome",
      interval?:  {
        __typename: "RuleIntervalOutcome",
      } | null,
      type: RuleOutcomeType,
    },
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateSendingSourceMutationVariables = {
  input: CreateSendingSourceInput,
  condition?: ModelSendingSourceConditionInput | null,
};

export type CreateSendingSourceMutation = {
  createSendingSource?:  {
    __typename: "SendingSource",
    id: string,
    createdAt?: string | null,
    createdById?: string | null,
    createdBy?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    dnsRecords?:  Array< {
      __typename: "DNSRecord",
      name: string,
      type: string,
      value: string,
    } > | null,
    emailAddress: string,
    issuesEmail: string,
    chargesEmail: string,
    errorMessage?: SendingSourceErrorType | null,
    name: string,
    lastReminderDate?: string | null,
    status: SendingSourceStatus,
    statusLastVerification?: string | null,
    verifiedType: SendingSourceVerifiedType,
    readId: string,
    clientId: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateSendingSourceMutationVariables = {
  input: UpdateSendingSourceInput,
  condition?: ModelSendingSourceConditionInput | null,
};

export type UpdateSendingSourceMutation = {
  updateSendingSource?:  {
    __typename: "SendingSource",
    id: string,
    createdAt?: string | null,
    createdById?: string | null,
    createdBy?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    dnsRecords?:  Array< {
      __typename: "DNSRecord",
      name: string,
      type: string,
      value: string,
    } > | null,
    emailAddress: string,
    issuesEmail: string,
    chargesEmail: string,
    errorMessage?: SendingSourceErrorType | null,
    name: string,
    lastReminderDate?: string | null,
    status: SendingSourceStatus,
    statusLastVerification?: string | null,
    verifiedType: SendingSourceVerifiedType,
    readId: string,
    clientId: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteSendingSourceMutationVariables = {
  input: DeleteSendingSourceInput,
  condition?: ModelSendingSourceConditionInput | null,
};

export type DeleteSendingSourceMutation = {
  deleteSendingSource?:  {
    __typename: "SendingSource",
    id: string,
    createdAt?: string | null,
    createdById?: string | null,
    createdBy?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    dnsRecords?:  Array< {
      __typename: "DNSRecord",
      name: string,
      type: string,
      value: string,
    } > | null,
    emailAddress: string,
    issuesEmail: string,
    chargesEmail: string,
    errorMessage?: SendingSourceErrorType | null,
    name: string,
    lastReminderDate?: string | null,
    status: SendingSourceStatus,
    statusLastVerification?: string | null,
    verifiedType: SendingSourceVerifiedType,
    readId: string,
    clientId: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateSettingMutationVariables = {
  input: CreateSettingInput,
  condition?: ModelSettingConditionInput | null,
};

export type CreateSettingMutation = {
  createSetting?:  {
    __typename: "Setting",
    id: string,
    name: SettingType,
    value: string,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateSettingMutationVariables = {
  input: UpdateSettingInput,
  condition?: ModelSettingConditionInput | null,
};

export type UpdateSettingMutation = {
  updateSetting?:  {
    __typename: "Setting",
    id: string,
    name: SettingType,
    value: string,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteSettingMutationVariables = {
  input: DeleteSettingInput,
  condition?: ModelSettingConditionInput | null,
};

export type DeleteSettingMutation = {
  deleteSetting?:  {
    __typename: "Setting",
    id: string,
    name: SettingType,
    value: string,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateReconciliationSettingMutationVariables = {
  input: CreateReconciliationSettingInput,
  condition?: ModelReconciliationSettingConditionInput | null,
};

export type CreateReconciliationSettingMutation = {
  createReconciliationSetting?:  {
    __typename: "ReconciliationSetting",
    id: string,
    type: ReconciliationSettingType,
    allocationMode: ReconciliationAllocationMode,
    leaseId?: string | null,
    ownerId?: string | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateReconciliationSettingMutationVariables = {
  input: UpdateReconciliationSettingInput,
  condition?: ModelReconciliationSettingConditionInput | null,
};

export type UpdateReconciliationSettingMutation = {
  updateReconciliationSetting?:  {
    __typename: "ReconciliationSetting",
    id: string,
    type: ReconciliationSettingType,
    allocationMode: ReconciliationAllocationMode,
    leaseId?: string | null,
    ownerId?: string | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteReconciliationSettingMutationVariables = {
  input: DeleteReconciliationSettingInput,
  condition?: ModelReconciliationSettingConditionInput | null,
};

export type DeleteReconciliationSettingMutation = {
  deleteReconciliationSetting?:  {
    __typename: "ReconciliationSetting",
    id: string,
    type: ReconciliationSettingType,
    allocationMode: ReconciliationAllocationMode,
    leaseId?: string | null,
    ownerId?: string | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateRepaymentStatementMutationVariables = {
  input: CreateRepaymentStatementInput,
  condition?: ModelRepaymentStatementConditionInput | null,
};

export type CreateRepaymentStatementMutation = {
  createRepaymentStatement?:  {
    __typename: "RepaymentStatement",
    id: string,
    accountOwnership: RepaymentStatementAccountOwnership,
    delaysCleared: number,
    expectedRent: number,
    lease?:  {
      __typename: "Lease",
      id: string,
      advancedChargesInvoices?:  {
        __typename: "LeaseAdvancedChargesInvoice",
        communicationSettingsProfileId: string,
        invoiceSenderId: string,
        lastDraftInvoiceDate?: string | null,
        lastInvoiceDate?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        bankAccountId?: string | null,
      } | null,
      balance?: number | null,
      canBeExtended?: boolean | null,
      communicationSettingsProfileId: string,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      endDate: string,
      includeRealEstateInLeaseContract?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      invoiceSenderId: string,
      invoiceSender?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      inventoryOfFixturesExpert?: string | null,
      inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
      inventoryOfFixturesType?: InventoryOfFixturesType | null,
      ipiNumber?: string | null,
      language: Language,
      lastDraftInvoiceDate?: string | null,
      lastIndexationProcessDate?: string | null,
      lastInvoiceDate?: string | null,
      legalCompetentAuthority?: string | null,
      name: string,
      notes?: string | null,
      paymentFrequency: LeasePaymentFrequency,
      paymentInvoicePeriod: LeasePaymentInvoicePeriod,
      paymentInvoicePeriodCustomDay?: number | null,
      paymentOption?:  {
        __typename: "LeasePaymentOption",
        customerId?: string | null,
        enabled: boolean,
        mandateActivatedAt?: string | null,
        mandateStatus?: PaymentProviderMandateStatus | null,
        paymentMethodId?: string | null,
        qrType?: LeaseQrType | null,
      } | null,
      purchaseOrderNumber?: string | null,
      realEstateAgency?: string | null,
      realEstateTax?: number | null,
      remittanceInformation?: string | null,
      remittanceInformationType?: LeaseRemittanceType | null,
      rentalGuaranty?:  {
        __typename: "LeaseRentalGuaranty",
        amount: number,
        blockedAmount?: number | null,
        releasedAmount?: number | null,
        type: LeaseRentalGuarantyType,
        financialInstitution?: string | null,
      } | null,
      signatureDate?: string | null,
      startDate: string,
      nextIndexationMonth?: string | null,
      nextIndexation?: boolean | null,
      status: LeaseStatus,
      technicCommunicationSettingsProfileId: string,
      totalInitialRentalPrice: number,
      totalRentalPrice: number,
      type: LeaseType,
      subletting?: boolean | null,
      vatRateRentId?: string | null,
      vatRateRent?:  {
        __typename: "VatRate",
        id: string,
        country: string,
        label: string,
        value?: number | null,
        ownerId?: string | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      additionalClauses?:  {
        __typename: "ModelLeaseAdditionalClauseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      bankAccountId?: string | null,
      bankAccount?:  {
        __typename: "BankAccount",
        id: string,
        contactId: string,
        number: string,
        bicNumber?: string | null,
        bankName?: string | null,
        contactIds?: Array< string > | null,
        buildingIds?: Array< string > | null,
        holderName?: string | null,
        label?: string | null,
        disabled?: boolean | null,
        integrations?: Array< IntegrationName > | null,
        matchingRule?: BankAccountMatchingRule | null,
        balance?: number | null,
        balanceDate?: string | null,
        type: BankAccountType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contacts?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      files?:  {
        __typename: "ModelFileConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leaseActionHistories?:  {
        __typename: "ModelLeaseActionHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leasePriceHistories?:  {
        __typename: "ModelLeasePriceHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      signatureDocuments?:  {
        __typename: "ModelSignatureDocumentConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      variousOperations?:  {
        __typename: "ModelLeaseVariousOperationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    leaseId: string,
    rentsCollected: number,
    repaymentStatementDetails:  Array< {
      __typename: "RepaymentStatementDetail",
      class: number,
      customLabel?: string | null,
      invoiceId: string,
      invoicePostingId: string,
      originalTotalAmount: number,
      periodFrom: string,
      periodTo: string,
      totalAmount: number,
      transactionId?: string | null,
      type: RepaymentStatementDetailType,
    } >,
    statement?:  {
      __typename: "Statement",
      id: string,
      amounts?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      chargeStatements?:  {
        __typename: "ModelChargeStatementConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      closingStatement: boolean,
      periodFrom: string,
      periodTo: string,
      attachSupportingDocuments?: boolean | null,
      selectedPocketKeys?: Array< string > | null,
      source: StatementSource,
      status: StatementStatus,
      sentDate?: string | null,
      leaseId?: string | null,
      lease?:  {
        __typename: "Lease",
        id: string,
        balance?: number | null,
        canBeExtended?: boolean | null,
        communicationSettingsProfileId: string,
        createdAt?: string | null,
        endDate: string,
        includeRealEstateInLeaseContract?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        invoiceSenderId: string,
        inventoryOfFixturesExpert?: string | null,
        inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
        inventoryOfFixturesType?: InventoryOfFixturesType | null,
        ipiNumber?: string | null,
        language: Language,
        lastDraftInvoiceDate?: string | null,
        lastIndexationProcessDate?: string | null,
        lastInvoiceDate?: string | null,
        legalCompetentAuthority?: string | null,
        name: string,
        notes?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        purchaseOrderNumber?: string | null,
        realEstateAgency?: string | null,
        realEstateTax?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        signatureDate?: string | null,
        startDate: string,
        nextIndexationMonth?: string | null,
        nextIndexation?: boolean | null,
        status: LeaseStatus,
        technicCommunicationSettingsProfileId: string,
        totalInitialRentalPrice: number,
        totalRentalPrice: number,
        type: LeaseType,
        subletting?: boolean | null,
        vatRateRentId?: string | null,
        bankAccountId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      agencyRateStatements?:  {
        __typename: "ModelAgencyRateStatementConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      ownerId?: string | null,
      owner?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      repaymentStatements?:  {
        __typename: "ModelRepaymentStatementConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      types?: Array< StatementType > | null,
      viewType: StatementViewType,
      unitIds?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    statementId: string,
    totalReceivedInJointAccount: number,
    totalExpectedInOwnerAccount: number,
    unpaidRents: number,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateRepaymentStatementMutationVariables = {
  input: UpdateRepaymentStatementInput,
  condition?: ModelRepaymentStatementConditionInput | null,
};

export type UpdateRepaymentStatementMutation = {
  updateRepaymentStatement?:  {
    __typename: "RepaymentStatement",
    id: string,
    accountOwnership: RepaymentStatementAccountOwnership,
    delaysCleared: number,
    expectedRent: number,
    lease?:  {
      __typename: "Lease",
      id: string,
      advancedChargesInvoices?:  {
        __typename: "LeaseAdvancedChargesInvoice",
        communicationSettingsProfileId: string,
        invoiceSenderId: string,
        lastDraftInvoiceDate?: string | null,
        lastInvoiceDate?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        bankAccountId?: string | null,
      } | null,
      balance?: number | null,
      canBeExtended?: boolean | null,
      communicationSettingsProfileId: string,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      endDate: string,
      includeRealEstateInLeaseContract?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      invoiceSenderId: string,
      invoiceSender?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      inventoryOfFixturesExpert?: string | null,
      inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
      inventoryOfFixturesType?: InventoryOfFixturesType | null,
      ipiNumber?: string | null,
      language: Language,
      lastDraftInvoiceDate?: string | null,
      lastIndexationProcessDate?: string | null,
      lastInvoiceDate?: string | null,
      legalCompetentAuthority?: string | null,
      name: string,
      notes?: string | null,
      paymentFrequency: LeasePaymentFrequency,
      paymentInvoicePeriod: LeasePaymentInvoicePeriod,
      paymentInvoicePeriodCustomDay?: number | null,
      paymentOption?:  {
        __typename: "LeasePaymentOption",
        customerId?: string | null,
        enabled: boolean,
        mandateActivatedAt?: string | null,
        mandateStatus?: PaymentProviderMandateStatus | null,
        paymentMethodId?: string | null,
        qrType?: LeaseQrType | null,
      } | null,
      purchaseOrderNumber?: string | null,
      realEstateAgency?: string | null,
      realEstateTax?: number | null,
      remittanceInformation?: string | null,
      remittanceInformationType?: LeaseRemittanceType | null,
      rentalGuaranty?:  {
        __typename: "LeaseRentalGuaranty",
        amount: number,
        blockedAmount?: number | null,
        releasedAmount?: number | null,
        type: LeaseRentalGuarantyType,
        financialInstitution?: string | null,
      } | null,
      signatureDate?: string | null,
      startDate: string,
      nextIndexationMonth?: string | null,
      nextIndexation?: boolean | null,
      status: LeaseStatus,
      technicCommunicationSettingsProfileId: string,
      totalInitialRentalPrice: number,
      totalRentalPrice: number,
      type: LeaseType,
      subletting?: boolean | null,
      vatRateRentId?: string | null,
      vatRateRent?:  {
        __typename: "VatRate",
        id: string,
        country: string,
        label: string,
        value?: number | null,
        ownerId?: string | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      additionalClauses?:  {
        __typename: "ModelLeaseAdditionalClauseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      bankAccountId?: string | null,
      bankAccount?:  {
        __typename: "BankAccount",
        id: string,
        contactId: string,
        number: string,
        bicNumber?: string | null,
        bankName?: string | null,
        contactIds?: Array< string > | null,
        buildingIds?: Array< string > | null,
        holderName?: string | null,
        label?: string | null,
        disabled?: boolean | null,
        integrations?: Array< IntegrationName > | null,
        matchingRule?: BankAccountMatchingRule | null,
        balance?: number | null,
        balanceDate?: string | null,
        type: BankAccountType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contacts?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      files?:  {
        __typename: "ModelFileConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leaseActionHistories?:  {
        __typename: "ModelLeaseActionHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leasePriceHistories?:  {
        __typename: "ModelLeasePriceHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      signatureDocuments?:  {
        __typename: "ModelSignatureDocumentConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      variousOperations?:  {
        __typename: "ModelLeaseVariousOperationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    leaseId: string,
    rentsCollected: number,
    repaymentStatementDetails:  Array< {
      __typename: "RepaymentStatementDetail",
      class: number,
      customLabel?: string | null,
      invoiceId: string,
      invoicePostingId: string,
      originalTotalAmount: number,
      periodFrom: string,
      periodTo: string,
      totalAmount: number,
      transactionId?: string | null,
      type: RepaymentStatementDetailType,
    } >,
    statement?:  {
      __typename: "Statement",
      id: string,
      amounts?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      chargeStatements?:  {
        __typename: "ModelChargeStatementConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      closingStatement: boolean,
      periodFrom: string,
      periodTo: string,
      attachSupportingDocuments?: boolean | null,
      selectedPocketKeys?: Array< string > | null,
      source: StatementSource,
      status: StatementStatus,
      sentDate?: string | null,
      leaseId?: string | null,
      lease?:  {
        __typename: "Lease",
        id: string,
        balance?: number | null,
        canBeExtended?: boolean | null,
        communicationSettingsProfileId: string,
        createdAt?: string | null,
        endDate: string,
        includeRealEstateInLeaseContract?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        invoiceSenderId: string,
        inventoryOfFixturesExpert?: string | null,
        inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
        inventoryOfFixturesType?: InventoryOfFixturesType | null,
        ipiNumber?: string | null,
        language: Language,
        lastDraftInvoiceDate?: string | null,
        lastIndexationProcessDate?: string | null,
        lastInvoiceDate?: string | null,
        legalCompetentAuthority?: string | null,
        name: string,
        notes?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        purchaseOrderNumber?: string | null,
        realEstateAgency?: string | null,
        realEstateTax?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        signatureDate?: string | null,
        startDate: string,
        nextIndexationMonth?: string | null,
        nextIndexation?: boolean | null,
        status: LeaseStatus,
        technicCommunicationSettingsProfileId: string,
        totalInitialRentalPrice: number,
        totalRentalPrice: number,
        type: LeaseType,
        subletting?: boolean | null,
        vatRateRentId?: string | null,
        bankAccountId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      agencyRateStatements?:  {
        __typename: "ModelAgencyRateStatementConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      ownerId?: string | null,
      owner?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      repaymentStatements?:  {
        __typename: "ModelRepaymentStatementConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      types?: Array< StatementType > | null,
      viewType: StatementViewType,
      unitIds?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    statementId: string,
    totalReceivedInJointAccount: number,
    totalExpectedInOwnerAccount: number,
    unpaidRents: number,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteRepaymentStatementMutationVariables = {
  input: DeleteRepaymentStatementInput,
  condition?: ModelRepaymentStatementConditionInput | null,
};

export type DeleteRepaymentStatementMutation = {
  deleteRepaymentStatement?:  {
    __typename: "RepaymentStatement",
    id: string,
    accountOwnership: RepaymentStatementAccountOwnership,
    delaysCleared: number,
    expectedRent: number,
    lease?:  {
      __typename: "Lease",
      id: string,
      advancedChargesInvoices?:  {
        __typename: "LeaseAdvancedChargesInvoice",
        communicationSettingsProfileId: string,
        invoiceSenderId: string,
        lastDraftInvoiceDate?: string | null,
        lastInvoiceDate?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        bankAccountId?: string | null,
      } | null,
      balance?: number | null,
      canBeExtended?: boolean | null,
      communicationSettingsProfileId: string,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      endDate: string,
      includeRealEstateInLeaseContract?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      invoiceSenderId: string,
      invoiceSender?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      inventoryOfFixturesExpert?: string | null,
      inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
      inventoryOfFixturesType?: InventoryOfFixturesType | null,
      ipiNumber?: string | null,
      language: Language,
      lastDraftInvoiceDate?: string | null,
      lastIndexationProcessDate?: string | null,
      lastInvoiceDate?: string | null,
      legalCompetentAuthority?: string | null,
      name: string,
      notes?: string | null,
      paymentFrequency: LeasePaymentFrequency,
      paymentInvoicePeriod: LeasePaymentInvoicePeriod,
      paymentInvoicePeriodCustomDay?: number | null,
      paymentOption?:  {
        __typename: "LeasePaymentOption",
        customerId?: string | null,
        enabled: boolean,
        mandateActivatedAt?: string | null,
        mandateStatus?: PaymentProviderMandateStatus | null,
        paymentMethodId?: string | null,
        qrType?: LeaseQrType | null,
      } | null,
      purchaseOrderNumber?: string | null,
      realEstateAgency?: string | null,
      realEstateTax?: number | null,
      remittanceInformation?: string | null,
      remittanceInformationType?: LeaseRemittanceType | null,
      rentalGuaranty?:  {
        __typename: "LeaseRentalGuaranty",
        amount: number,
        blockedAmount?: number | null,
        releasedAmount?: number | null,
        type: LeaseRentalGuarantyType,
        financialInstitution?: string | null,
      } | null,
      signatureDate?: string | null,
      startDate: string,
      nextIndexationMonth?: string | null,
      nextIndexation?: boolean | null,
      status: LeaseStatus,
      technicCommunicationSettingsProfileId: string,
      totalInitialRentalPrice: number,
      totalRentalPrice: number,
      type: LeaseType,
      subletting?: boolean | null,
      vatRateRentId?: string | null,
      vatRateRent?:  {
        __typename: "VatRate",
        id: string,
        country: string,
        label: string,
        value?: number | null,
        ownerId?: string | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      additionalClauses?:  {
        __typename: "ModelLeaseAdditionalClauseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      bankAccountId?: string | null,
      bankAccount?:  {
        __typename: "BankAccount",
        id: string,
        contactId: string,
        number: string,
        bicNumber?: string | null,
        bankName?: string | null,
        contactIds?: Array< string > | null,
        buildingIds?: Array< string > | null,
        holderName?: string | null,
        label?: string | null,
        disabled?: boolean | null,
        integrations?: Array< IntegrationName > | null,
        matchingRule?: BankAccountMatchingRule | null,
        balance?: number | null,
        balanceDate?: string | null,
        type: BankAccountType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contacts?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      files?:  {
        __typename: "ModelFileConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leaseActionHistories?:  {
        __typename: "ModelLeaseActionHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leasePriceHistories?:  {
        __typename: "ModelLeasePriceHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      signatureDocuments?:  {
        __typename: "ModelSignatureDocumentConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      variousOperations?:  {
        __typename: "ModelLeaseVariousOperationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    leaseId: string,
    rentsCollected: number,
    repaymentStatementDetails:  Array< {
      __typename: "RepaymentStatementDetail",
      class: number,
      customLabel?: string | null,
      invoiceId: string,
      invoicePostingId: string,
      originalTotalAmount: number,
      periodFrom: string,
      periodTo: string,
      totalAmount: number,
      transactionId?: string | null,
      type: RepaymentStatementDetailType,
    } >,
    statement?:  {
      __typename: "Statement",
      id: string,
      amounts?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      chargeStatements?:  {
        __typename: "ModelChargeStatementConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      closingStatement: boolean,
      periodFrom: string,
      periodTo: string,
      attachSupportingDocuments?: boolean | null,
      selectedPocketKeys?: Array< string > | null,
      source: StatementSource,
      status: StatementStatus,
      sentDate?: string | null,
      leaseId?: string | null,
      lease?:  {
        __typename: "Lease",
        id: string,
        balance?: number | null,
        canBeExtended?: boolean | null,
        communicationSettingsProfileId: string,
        createdAt?: string | null,
        endDate: string,
        includeRealEstateInLeaseContract?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        invoiceSenderId: string,
        inventoryOfFixturesExpert?: string | null,
        inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
        inventoryOfFixturesType?: InventoryOfFixturesType | null,
        ipiNumber?: string | null,
        language: Language,
        lastDraftInvoiceDate?: string | null,
        lastIndexationProcessDate?: string | null,
        lastInvoiceDate?: string | null,
        legalCompetentAuthority?: string | null,
        name: string,
        notes?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        purchaseOrderNumber?: string | null,
        realEstateAgency?: string | null,
        realEstateTax?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        signatureDate?: string | null,
        startDate: string,
        nextIndexationMonth?: string | null,
        nextIndexation?: boolean | null,
        status: LeaseStatus,
        technicCommunicationSettingsProfileId: string,
        totalInitialRentalPrice: number,
        totalRentalPrice: number,
        type: LeaseType,
        subletting?: boolean | null,
        vatRateRentId?: string | null,
        bankAccountId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      agencyRateStatements?:  {
        __typename: "ModelAgencyRateStatementConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      ownerId?: string | null,
      owner?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      repaymentStatements?:  {
        __typename: "ModelRepaymentStatementConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      types?: Array< StatementType > | null,
      viewType: StatementViewType,
      unitIds?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    statementId: string,
    totalReceivedInJointAccount: number,
    totalExpectedInOwnerAccount: number,
    unpaidRents: number,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateStatementMutationVariables = {
  input: CreateStatementInput,
  condition?: ModelStatementConditionInput | null,
};

export type CreateStatementMutation = {
  createStatement?:  {
    __typename: "Statement",
    id: string,
    amounts?:  Array< {
      __typename: "CustomValue",
      name: string,
      value: string,
    } > | null,
    chargeStatements?:  {
      __typename: "ModelChargeStatementConnection",
      items:  Array< {
        __typename: "ChargeStatement",
        id: string,
        chargeId: string,
        statementId: string,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    closingStatement: boolean,
    periodFrom: string,
    periodTo: string,
    attachSupportingDocuments?: boolean | null,
    selectedPocketKeys?: Array< string > | null,
    source: StatementSource,
    status: StatementStatus,
    sentDate?: string | null,
    leaseId?: string | null,
    lease?:  {
      __typename: "Lease",
      id: string,
      advancedChargesInvoices?:  {
        __typename: "LeaseAdvancedChargesInvoice",
        communicationSettingsProfileId: string,
        invoiceSenderId: string,
        lastDraftInvoiceDate?: string | null,
        lastInvoiceDate?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        bankAccountId?: string | null,
      } | null,
      balance?: number | null,
      canBeExtended?: boolean | null,
      communicationSettingsProfileId: string,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      endDate: string,
      includeRealEstateInLeaseContract?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      invoiceSenderId: string,
      invoiceSender?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      inventoryOfFixturesExpert?: string | null,
      inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
      inventoryOfFixturesType?: InventoryOfFixturesType | null,
      ipiNumber?: string | null,
      language: Language,
      lastDraftInvoiceDate?: string | null,
      lastIndexationProcessDate?: string | null,
      lastInvoiceDate?: string | null,
      legalCompetentAuthority?: string | null,
      name: string,
      notes?: string | null,
      paymentFrequency: LeasePaymentFrequency,
      paymentInvoicePeriod: LeasePaymentInvoicePeriod,
      paymentInvoicePeriodCustomDay?: number | null,
      paymentOption?:  {
        __typename: "LeasePaymentOption",
        customerId?: string | null,
        enabled: boolean,
        mandateActivatedAt?: string | null,
        mandateStatus?: PaymentProviderMandateStatus | null,
        paymentMethodId?: string | null,
        qrType?: LeaseQrType | null,
      } | null,
      purchaseOrderNumber?: string | null,
      realEstateAgency?: string | null,
      realEstateTax?: number | null,
      remittanceInformation?: string | null,
      remittanceInformationType?: LeaseRemittanceType | null,
      rentalGuaranty?:  {
        __typename: "LeaseRentalGuaranty",
        amount: number,
        blockedAmount?: number | null,
        releasedAmount?: number | null,
        type: LeaseRentalGuarantyType,
        financialInstitution?: string | null,
      } | null,
      signatureDate?: string | null,
      startDate: string,
      nextIndexationMonth?: string | null,
      nextIndexation?: boolean | null,
      status: LeaseStatus,
      technicCommunicationSettingsProfileId: string,
      totalInitialRentalPrice: number,
      totalRentalPrice: number,
      type: LeaseType,
      subletting?: boolean | null,
      vatRateRentId?: string | null,
      vatRateRent?:  {
        __typename: "VatRate",
        id: string,
        country: string,
        label: string,
        value?: number | null,
        ownerId?: string | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      additionalClauses?:  {
        __typename: "ModelLeaseAdditionalClauseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      bankAccountId?: string | null,
      bankAccount?:  {
        __typename: "BankAccount",
        id: string,
        contactId: string,
        number: string,
        bicNumber?: string | null,
        bankName?: string | null,
        contactIds?: Array< string > | null,
        buildingIds?: Array< string > | null,
        holderName?: string | null,
        label?: string | null,
        disabled?: boolean | null,
        integrations?: Array< IntegrationName > | null,
        matchingRule?: BankAccountMatchingRule | null,
        balance?: number | null,
        balanceDate?: string | null,
        type: BankAccountType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contacts?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      files?:  {
        __typename: "ModelFileConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leaseActionHistories?:  {
        __typename: "ModelLeaseActionHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leasePriceHistories?:  {
        __typename: "ModelLeasePriceHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      signatureDocuments?:  {
        __typename: "ModelSignatureDocumentConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      variousOperations?:  {
        __typename: "ModelLeaseVariousOperationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    agencyRateStatements?:  {
      __typename: "ModelAgencyRateStatementConnection",
      items:  Array< {
        __typename: "AgencyRateStatement",
        id: string,
        agencyRateId: string,
        statementId: string,
        totalAmountRateable: number,
        totalFixedAmount: number,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    ownerId?: string | null,
    owner?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    repaymentStatements?:  {
      __typename: "ModelRepaymentStatementConnection",
      items:  Array< {
        __typename: "RepaymentStatement",
        id: string,
        accountOwnership: RepaymentStatementAccountOwnership,
        delaysCleared: number,
        expectedRent: number,
        leaseId: string,
        rentsCollected: number,
        statementId: string,
        totalReceivedInJointAccount: number,
        totalExpectedInOwnerAccount: number,
        unpaidRents: number,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    types?: Array< StatementType > | null,
    viewType: StatementViewType,
    unitIds?: Array< string > | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateStatementMutationVariables = {
  input: UpdateStatementInput,
  condition?: ModelStatementConditionInput | null,
};

export type UpdateStatementMutation = {
  updateStatement?:  {
    __typename: "Statement",
    id: string,
    amounts?:  Array< {
      __typename: "CustomValue",
      name: string,
      value: string,
    } > | null,
    chargeStatements?:  {
      __typename: "ModelChargeStatementConnection",
      items:  Array< {
        __typename: "ChargeStatement",
        id: string,
        chargeId: string,
        statementId: string,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    closingStatement: boolean,
    periodFrom: string,
    periodTo: string,
    attachSupportingDocuments?: boolean | null,
    selectedPocketKeys?: Array< string > | null,
    source: StatementSource,
    status: StatementStatus,
    sentDate?: string | null,
    leaseId?: string | null,
    lease?:  {
      __typename: "Lease",
      id: string,
      advancedChargesInvoices?:  {
        __typename: "LeaseAdvancedChargesInvoice",
        communicationSettingsProfileId: string,
        invoiceSenderId: string,
        lastDraftInvoiceDate?: string | null,
        lastInvoiceDate?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        bankAccountId?: string | null,
      } | null,
      balance?: number | null,
      canBeExtended?: boolean | null,
      communicationSettingsProfileId: string,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      endDate: string,
      includeRealEstateInLeaseContract?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      invoiceSenderId: string,
      invoiceSender?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      inventoryOfFixturesExpert?: string | null,
      inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
      inventoryOfFixturesType?: InventoryOfFixturesType | null,
      ipiNumber?: string | null,
      language: Language,
      lastDraftInvoiceDate?: string | null,
      lastIndexationProcessDate?: string | null,
      lastInvoiceDate?: string | null,
      legalCompetentAuthority?: string | null,
      name: string,
      notes?: string | null,
      paymentFrequency: LeasePaymentFrequency,
      paymentInvoicePeriod: LeasePaymentInvoicePeriod,
      paymentInvoicePeriodCustomDay?: number | null,
      paymentOption?:  {
        __typename: "LeasePaymentOption",
        customerId?: string | null,
        enabled: boolean,
        mandateActivatedAt?: string | null,
        mandateStatus?: PaymentProviderMandateStatus | null,
        paymentMethodId?: string | null,
        qrType?: LeaseQrType | null,
      } | null,
      purchaseOrderNumber?: string | null,
      realEstateAgency?: string | null,
      realEstateTax?: number | null,
      remittanceInformation?: string | null,
      remittanceInformationType?: LeaseRemittanceType | null,
      rentalGuaranty?:  {
        __typename: "LeaseRentalGuaranty",
        amount: number,
        blockedAmount?: number | null,
        releasedAmount?: number | null,
        type: LeaseRentalGuarantyType,
        financialInstitution?: string | null,
      } | null,
      signatureDate?: string | null,
      startDate: string,
      nextIndexationMonth?: string | null,
      nextIndexation?: boolean | null,
      status: LeaseStatus,
      technicCommunicationSettingsProfileId: string,
      totalInitialRentalPrice: number,
      totalRentalPrice: number,
      type: LeaseType,
      subletting?: boolean | null,
      vatRateRentId?: string | null,
      vatRateRent?:  {
        __typename: "VatRate",
        id: string,
        country: string,
        label: string,
        value?: number | null,
        ownerId?: string | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      additionalClauses?:  {
        __typename: "ModelLeaseAdditionalClauseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      bankAccountId?: string | null,
      bankAccount?:  {
        __typename: "BankAccount",
        id: string,
        contactId: string,
        number: string,
        bicNumber?: string | null,
        bankName?: string | null,
        contactIds?: Array< string > | null,
        buildingIds?: Array< string > | null,
        holderName?: string | null,
        label?: string | null,
        disabled?: boolean | null,
        integrations?: Array< IntegrationName > | null,
        matchingRule?: BankAccountMatchingRule | null,
        balance?: number | null,
        balanceDate?: string | null,
        type: BankAccountType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contacts?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      files?:  {
        __typename: "ModelFileConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leaseActionHistories?:  {
        __typename: "ModelLeaseActionHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leasePriceHistories?:  {
        __typename: "ModelLeasePriceHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      signatureDocuments?:  {
        __typename: "ModelSignatureDocumentConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      variousOperations?:  {
        __typename: "ModelLeaseVariousOperationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    agencyRateStatements?:  {
      __typename: "ModelAgencyRateStatementConnection",
      items:  Array< {
        __typename: "AgencyRateStatement",
        id: string,
        agencyRateId: string,
        statementId: string,
        totalAmountRateable: number,
        totalFixedAmount: number,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    ownerId?: string | null,
    owner?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    repaymentStatements?:  {
      __typename: "ModelRepaymentStatementConnection",
      items:  Array< {
        __typename: "RepaymentStatement",
        id: string,
        accountOwnership: RepaymentStatementAccountOwnership,
        delaysCleared: number,
        expectedRent: number,
        leaseId: string,
        rentsCollected: number,
        statementId: string,
        totalReceivedInJointAccount: number,
        totalExpectedInOwnerAccount: number,
        unpaidRents: number,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    types?: Array< StatementType > | null,
    viewType: StatementViewType,
    unitIds?: Array< string > | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteStatementMutationVariables = {
  input: DeleteStatementInput,
  condition?: ModelStatementConditionInput | null,
};

export type DeleteStatementMutation = {
  deleteStatement?:  {
    __typename: "Statement",
    id: string,
    amounts?:  Array< {
      __typename: "CustomValue",
      name: string,
      value: string,
    } > | null,
    chargeStatements?:  {
      __typename: "ModelChargeStatementConnection",
      items:  Array< {
        __typename: "ChargeStatement",
        id: string,
        chargeId: string,
        statementId: string,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    closingStatement: boolean,
    periodFrom: string,
    periodTo: string,
    attachSupportingDocuments?: boolean | null,
    selectedPocketKeys?: Array< string > | null,
    source: StatementSource,
    status: StatementStatus,
    sentDate?: string | null,
    leaseId?: string | null,
    lease?:  {
      __typename: "Lease",
      id: string,
      advancedChargesInvoices?:  {
        __typename: "LeaseAdvancedChargesInvoice",
        communicationSettingsProfileId: string,
        invoiceSenderId: string,
        lastDraftInvoiceDate?: string | null,
        lastInvoiceDate?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        bankAccountId?: string | null,
      } | null,
      balance?: number | null,
      canBeExtended?: boolean | null,
      communicationSettingsProfileId: string,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      endDate: string,
      includeRealEstateInLeaseContract?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      invoiceSenderId: string,
      invoiceSender?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      inventoryOfFixturesExpert?: string | null,
      inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
      inventoryOfFixturesType?: InventoryOfFixturesType | null,
      ipiNumber?: string | null,
      language: Language,
      lastDraftInvoiceDate?: string | null,
      lastIndexationProcessDate?: string | null,
      lastInvoiceDate?: string | null,
      legalCompetentAuthority?: string | null,
      name: string,
      notes?: string | null,
      paymentFrequency: LeasePaymentFrequency,
      paymentInvoicePeriod: LeasePaymentInvoicePeriod,
      paymentInvoicePeriodCustomDay?: number | null,
      paymentOption?:  {
        __typename: "LeasePaymentOption",
        customerId?: string | null,
        enabled: boolean,
        mandateActivatedAt?: string | null,
        mandateStatus?: PaymentProviderMandateStatus | null,
        paymentMethodId?: string | null,
        qrType?: LeaseQrType | null,
      } | null,
      purchaseOrderNumber?: string | null,
      realEstateAgency?: string | null,
      realEstateTax?: number | null,
      remittanceInformation?: string | null,
      remittanceInformationType?: LeaseRemittanceType | null,
      rentalGuaranty?:  {
        __typename: "LeaseRentalGuaranty",
        amount: number,
        blockedAmount?: number | null,
        releasedAmount?: number | null,
        type: LeaseRentalGuarantyType,
        financialInstitution?: string | null,
      } | null,
      signatureDate?: string | null,
      startDate: string,
      nextIndexationMonth?: string | null,
      nextIndexation?: boolean | null,
      status: LeaseStatus,
      technicCommunicationSettingsProfileId: string,
      totalInitialRentalPrice: number,
      totalRentalPrice: number,
      type: LeaseType,
      subletting?: boolean | null,
      vatRateRentId?: string | null,
      vatRateRent?:  {
        __typename: "VatRate",
        id: string,
        country: string,
        label: string,
        value?: number | null,
        ownerId?: string | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      additionalClauses?:  {
        __typename: "ModelLeaseAdditionalClauseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      bankAccountId?: string | null,
      bankAccount?:  {
        __typename: "BankAccount",
        id: string,
        contactId: string,
        number: string,
        bicNumber?: string | null,
        bankName?: string | null,
        contactIds?: Array< string > | null,
        buildingIds?: Array< string > | null,
        holderName?: string | null,
        label?: string | null,
        disabled?: boolean | null,
        integrations?: Array< IntegrationName > | null,
        matchingRule?: BankAccountMatchingRule | null,
        balance?: number | null,
        balanceDate?: string | null,
        type: BankAccountType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contacts?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      files?:  {
        __typename: "ModelFileConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leaseActionHistories?:  {
        __typename: "ModelLeaseActionHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leasePriceHistories?:  {
        __typename: "ModelLeasePriceHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      signatureDocuments?:  {
        __typename: "ModelSignatureDocumentConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      variousOperations?:  {
        __typename: "ModelLeaseVariousOperationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    agencyRateStatements?:  {
      __typename: "ModelAgencyRateStatementConnection",
      items:  Array< {
        __typename: "AgencyRateStatement",
        id: string,
        agencyRateId: string,
        statementId: string,
        totalAmountRateable: number,
        totalFixedAmount: number,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    ownerId?: string | null,
    owner?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    repaymentStatements?:  {
      __typename: "ModelRepaymentStatementConnection",
      items:  Array< {
        __typename: "RepaymentStatement",
        id: string,
        accountOwnership: RepaymentStatementAccountOwnership,
        delaysCleared: number,
        expectedRent: number,
        leaseId: string,
        rentsCollected: number,
        statementId: string,
        totalReceivedInJointAccount: number,
        totalExpectedInOwnerAccount: number,
        unpaidRents: number,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    types?: Array< StatementType > | null,
    viewType: StatementViewType,
    unitIds?: Array< string > | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateStatementSettingMutationVariables = {
  input: CreateStatementSettingInput,
  condition?: ModelStatementSettingConditionInput | null,
};

export type CreateStatementSettingMutation = {
  createStatementSetting?:  {
    __typename: "StatementSetting",
    id: string,
    type: StatementSettingType,
    custom: boolean,
    disabled?: boolean | null,
    monthFrequency: number,
    startMonth?: string | null,
    generationDay?: number | null,
    leaseId?: string | null,
    lease?:  {
      __typename: "Lease",
      id: string,
      advancedChargesInvoices?:  {
        __typename: "LeaseAdvancedChargesInvoice",
        communicationSettingsProfileId: string,
        invoiceSenderId: string,
        lastDraftInvoiceDate?: string | null,
        lastInvoiceDate?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        bankAccountId?: string | null,
      } | null,
      balance?: number | null,
      canBeExtended?: boolean | null,
      communicationSettingsProfileId: string,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      endDate: string,
      includeRealEstateInLeaseContract?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      invoiceSenderId: string,
      invoiceSender?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      inventoryOfFixturesExpert?: string | null,
      inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
      inventoryOfFixturesType?: InventoryOfFixturesType | null,
      ipiNumber?: string | null,
      language: Language,
      lastDraftInvoiceDate?: string | null,
      lastIndexationProcessDate?: string | null,
      lastInvoiceDate?: string | null,
      legalCompetentAuthority?: string | null,
      name: string,
      notes?: string | null,
      paymentFrequency: LeasePaymentFrequency,
      paymentInvoicePeriod: LeasePaymentInvoicePeriod,
      paymentInvoicePeriodCustomDay?: number | null,
      paymentOption?:  {
        __typename: "LeasePaymentOption",
        customerId?: string | null,
        enabled: boolean,
        mandateActivatedAt?: string | null,
        mandateStatus?: PaymentProviderMandateStatus | null,
        paymentMethodId?: string | null,
        qrType?: LeaseQrType | null,
      } | null,
      purchaseOrderNumber?: string | null,
      realEstateAgency?: string | null,
      realEstateTax?: number | null,
      remittanceInformation?: string | null,
      remittanceInformationType?: LeaseRemittanceType | null,
      rentalGuaranty?:  {
        __typename: "LeaseRentalGuaranty",
        amount: number,
        blockedAmount?: number | null,
        releasedAmount?: number | null,
        type: LeaseRentalGuarantyType,
        financialInstitution?: string | null,
      } | null,
      signatureDate?: string | null,
      startDate: string,
      nextIndexationMonth?: string | null,
      nextIndexation?: boolean | null,
      status: LeaseStatus,
      technicCommunicationSettingsProfileId: string,
      totalInitialRentalPrice: number,
      totalRentalPrice: number,
      type: LeaseType,
      subletting?: boolean | null,
      vatRateRentId?: string | null,
      vatRateRent?:  {
        __typename: "VatRate",
        id: string,
        country: string,
        label: string,
        value?: number | null,
        ownerId?: string | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      additionalClauses?:  {
        __typename: "ModelLeaseAdditionalClauseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      bankAccountId?: string | null,
      bankAccount?:  {
        __typename: "BankAccount",
        id: string,
        contactId: string,
        number: string,
        bicNumber?: string | null,
        bankName?: string | null,
        contactIds?: Array< string > | null,
        buildingIds?: Array< string > | null,
        holderName?: string | null,
        label?: string | null,
        disabled?: boolean | null,
        integrations?: Array< IntegrationName > | null,
        matchingRule?: BankAccountMatchingRule | null,
        balance?: number | null,
        balanceDate?: string | null,
        type: BankAccountType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contacts?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      files?:  {
        __typename: "ModelFileConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leaseActionHistories?:  {
        __typename: "ModelLeaseActionHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leasePriceHistories?:  {
        __typename: "ModelLeasePriceHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      signatureDocuments?:  {
        __typename: "ModelSignatureDocumentConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      variousOperations?:  {
        __typename: "ModelLeaseVariousOperationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    ownerId?: string | null,
    owner?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateStatementSettingMutationVariables = {
  input: UpdateStatementSettingInput,
  condition?: ModelStatementSettingConditionInput | null,
};

export type UpdateStatementSettingMutation = {
  updateStatementSetting?:  {
    __typename: "StatementSetting",
    id: string,
    type: StatementSettingType,
    custom: boolean,
    disabled?: boolean | null,
    monthFrequency: number,
    startMonth?: string | null,
    generationDay?: number | null,
    leaseId?: string | null,
    lease?:  {
      __typename: "Lease",
      id: string,
      advancedChargesInvoices?:  {
        __typename: "LeaseAdvancedChargesInvoice",
        communicationSettingsProfileId: string,
        invoiceSenderId: string,
        lastDraftInvoiceDate?: string | null,
        lastInvoiceDate?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        bankAccountId?: string | null,
      } | null,
      balance?: number | null,
      canBeExtended?: boolean | null,
      communicationSettingsProfileId: string,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      endDate: string,
      includeRealEstateInLeaseContract?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      invoiceSenderId: string,
      invoiceSender?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      inventoryOfFixturesExpert?: string | null,
      inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
      inventoryOfFixturesType?: InventoryOfFixturesType | null,
      ipiNumber?: string | null,
      language: Language,
      lastDraftInvoiceDate?: string | null,
      lastIndexationProcessDate?: string | null,
      lastInvoiceDate?: string | null,
      legalCompetentAuthority?: string | null,
      name: string,
      notes?: string | null,
      paymentFrequency: LeasePaymentFrequency,
      paymentInvoicePeriod: LeasePaymentInvoicePeriod,
      paymentInvoicePeriodCustomDay?: number | null,
      paymentOption?:  {
        __typename: "LeasePaymentOption",
        customerId?: string | null,
        enabled: boolean,
        mandateActivatedAt?: string | null,
        mandateStatus?: PaymentProviderMandateStatus | null,
        paymentMethodId?: string | null,
        qrType?: LeaseQrType | null,
      } | null,
      purchaseOrderNumber?: string | null,
      realEstateAgency?: string | null,
      realEstateTax?: number | null,
      remittanceInformation?: string | null,
      remittanceInformationType?: LeaseRemittanceType | null,
      rentalGuaranty?:  {
        __typename: "LeaseRentalGuaranty",
        amount: number,
        blockedAmount?: number | null,
        releasedAmount?: number | null,
        type: LeaseRentalGuarantyType,
        financialInstitution?: string | null,
      } | null,
      signatureDate?: string | null,
      startDate: string,
      nextIndexationMonth?: string | null,
      nextIndexation?: boolean | null,
      status: LeaseStatus,
      technicCommunicationSettingsProfileId: string,
      totalInitialRentalPrice: number,
      totalRentalPrice: number,
      type: LeaseType,
      subletting?: boolean | null,
      vatRateRentId?: string | null,
      vatRateRent?:  {
        __typename: "VatRate",
        id: string,
        country: string,
        label: string,
        value?: number | null,
        ownerId?: string | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      additionalClauses?:  {
        __typename: "ModelLeaseAdditionalClauseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      bankAccountId?: string | null,
      bankAccount?:  {
        __typename: "BankAccount",
        id: string,
        contactId: string,
        number: string,
        bicNumber?: string | null,
        bankName?: string | null,
        contactIds?: Array< string > | null,
        buildingIds?: Array< string > | null,
        holderName?: string | null,
        label?: string | null,
        disabled?: boolean | null,
        integrations?: Array< IntegrationName > | null,
        matchingRule?: BankAccountMatchingRule | null,
        balance?: number | null,
        balanceDate?: string | null,
        type: BankAccountType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contacts?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      files?:  {
        __typename: "ModelFileConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leaseActionHistories?:  {
        __typename: "ModelLeaseActionHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leasePriceHistories?:  {
        __typename: "ModelLeasePriceHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      signatureDocuments?:  {
        __typename: "ModelSignatureDocumentConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      variousOperations?:  {
        __typename: "ModelLeaseVariousOperationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    ownerId?: string | null,
    owner?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteStatementSettingMutationVariables = {
  input: DeleteStatementSettingInput,
  condition?: ModelStatementSettingConditionInput | null,
};

export type DeleteStatementSettingMutation = {
  deleteStatementSetting?:  {
    __typename: "StatementSetting",
    id: string,
    type: StatementSettingType,
    custom: boolean,
    disabled?: boolean | null,
    monthFrequency: number,
    startMonth?: string | null,
    generationDay?: number | null,
    leaseId?: string | null,
    lease?:  {
      __typename: "Lease",
      id: string,
      advancedChargesInvoices?:  {
        __typename: "LeaseAdvancedChargesInvoice",
        communicationSettingsProfileId: string,
        invoiceSenderId: string,
        lastDraftInvoiceDate?: string | null,
        lastInvoiceDate?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        bankAccountId?: string | null,
      } | null,
      balance?: number | null,
      canBeExtended?: boolean | null,
      communicationSettingsProfileId: string,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      endDate: string,
      includeRealEstateInLeaseContract?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      invoiceSenderId: string,
      invoiceSender?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      inventoryOfFixturesExpert?: string | null,
      inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
      inventoryOfFixturesType?: InventoryOfFixturesType | null,
      ipiNumber?: string | null,
      language: Language,
      lastDraftInvoiceDate?: string | null,
      lastIndexationProcessDate?: string | null,
      lastInvoiceDate?: string | null,
      legalCompetentAuthority?: string | null,
      name: string,
      notes?: string | null,
      paymentFrequency: LeasePaymentFrequency,
      paymentInvoicePeriod: LeasePaymentInvoicePeriod,
      paymentInvoicePeriodCustomDay?: number | null,
      paymentOption?:  {
        __typename: "LeasePaymentOption",
        customerId?: string | null,
        enabled: boolean,
        mandateActivatedAt?: string | null,
        mandateStatus?: PaymentProviderMandateStatus | null,
        paymentMethodId?: string | null,
        qrType?: LeaseQrType | null,
      } | null,
      purchaseOrderNumber?: string | null,
      realEstateAgency?: string | null,
      realEstateTax?: number | null,
      remittanceInformation?: string | null,
      remittanceInformationType?: LeaseRemittanceType | null,
      rentalGuaranty?:  {
        __typename: "LeaseRentalGuaranty",
        amount: number,
        blockedAmount?: number | null,
        releasedAmount?: number | null,
        type: LeaseRentalGuarantyType,
        financialInstitution?: string | null,
      } | null,
      signatureDate?: string | null,
      startDate: string,
      nextIndexationMonth?: string | null,
      nextIndexation?: boolean | null,
      status: LeaseStatus,
      technicCommunicationSettingsProfileId: string,
      totalInitialRentalPrice: number,
      totalRentalPrice: number,
      type: LeaseType,
      subletting?: boolean | null,
      vatRateRentId?: string | null,
      vatRateRent?:  {
        __typename: "VatRate",
        id: string,
        country: string,
        label: string,
        value?: number | null,
        ownerId?: string | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      additionalClauses?:  {
        __typename: "ModelLeaseAdditionalClauseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      bankAccountId?: string | null,
      bankAccount?:  {
        __typename: "BankAccount",
        id: string,
        contactId: string,
        number: string,
        bicNumber?: string | null,
        bankName?: string | null,
        contactIds?: Array< string > | null,
        buildingIds?: Array< string > | null,
        holderName?: string | null,
        label?: string | null,
        disabled?: boolean | null,
        integrations?: Array< IntegrationName > | null,
        matchingRule?: BankAccountMatchingRule | null,
        balance?: number | null,
        balanceDate?: string | null,
        type: BankAccountType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contacts?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      files?:  {
        __typename: "ModelFileConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leaseActionHistories?:  {
        __typename: "ModelLeaseActionHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leasePriceHistories?:  {
        __typename: "ModelLeasePriceHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      signatureDocuments?:  {
        __typename: "ModelSignatureDocumentConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      variousOperations?:  {
        __typename: "ModelLeaseVariousOperationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    ownerId?: string | null,
    owner?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateTagMutationVariables = {
  input: CreateTagInput,
  condition?: ModelTagConditionInput | null,
};

export type CreateTagMutation = {
  createTag?:  {
    __typename: "Tag",
    id: string,
    color?: string | null,
    foreignTableName: string,
    labels:  Array< {
      __typename: "CustomLabel",
      language: string,
      label: string,
    } >,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateTagMutationVariables = {
  input: UpdateTagInput,
  condition?: ModelTagConditionInput | null,
};

export type UpdateTagMutation = {
  updateTag?:  {
    __typename: "Tag",
    id: string,
    color?: string | null,
    foreignTableName: string,
    labels:  Array< {
      __typename: "CustomLabel",
      language: string,
      label: string,
    } >,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteTagMutationVariables = {
  input: DeleteTagInput,
  condition?: ModelTagConditionInput | null,
};

export type DeleteTagMutation = {
  deleteTag?:  {
    __typename: "Tag",
    id: string,
    color?: string | null,
    foreignTableName: string,
    labels:  Array< {
      __typename: "CustomLabel",
      language: string,
      label: string,
    } >,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateTechnicMutationVariables = {
  input: CreateTechnicInput,
  condition?: ModelTechnicConditionInput | null,
};

export type CreateTechnicMutation = {
  createTechnic?:  {
    __typename: "Technic",
    id: string,
    type: TechnicType,
    contractNumber?: string | null,
    communicationSettingsProfileId: string,
    maintenanceHistory?:  Array< {
      __typename: "TechnicMaintenanceHistory",
      date: string,
      contactId?: string | null,
      fileId?: string | null,
    } > | null,
    technicLibraryId?: string | null,
    technicLibrary?:  {
      __typename: "TechnicLibrary",
      id: string,
      certificateValidity?:  {
        __typename: "CertificateLibraryValidity",
        nonCompliant?: boolean | null,
        overlapping?: boolean | null,
        riskLevel?: RiskLevelExpiration | null,
      } | null,
      communicationSettingsProfileId?: string | null,
      criticality: TechnicLibraryCriticality,
      customFields?:  {
        __typename: "ModelCustomFieldConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      descriptions?:  Array< {
        __typename: "CustomLabel",
        language: string,
        label: string,
      } > | null,
      isDefault?: boolean | null,
      issuingAuthority?: string | null,
      linkedCertificateIds?: Array< string > | null,
      locationScope?: TechnicLibraryLocationScope | null,
      maintenanceSchemas?:  Array< {
        __typename: "TechnicLibraryMaintenanceSchema",
        id: string,
        criticality: TechnicLibraryCriticality,
        deadline?: string | null,
        maintenanceType: TechnicLibraryMaintenanceType,
        notificationsEnabled?: boolean | null,
        notificationType?: NotificationType | null,
        proofType?: Array< TechnicLibraryProofType > | null,
        recurrence?: TechnicLibraryRecurrence | null,
        responsibleParty: TechnicLibraryResponsibleParty,
        triggerType?: TechnicLibraryTriggerType | null,
      } > | null,
      names:  Array< {
        __typename: "CustomLabel",
        language: string,
        label: string,
      } >,
      status: TechnicLibraryStatus,
      tagIds?: Array< string > | null,
      technicLibraryFormat?: string | null,
      type: TechnicLibraryType,
      utilityTypes?: Array< UtilityType > | null,
      validity?:  {
        __typename: "TechnicLibraryValidity",
        value: number,
        validityUnit: TechnicLibraryValidityUnit,
      } | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    technicName?: string | null,
    lastControlDate?: string | null,
    status?: TechnicStatus | null,
    utilityType?: UtilityType | null,
    utilityEanCode?: string | null,
    utilityMeterNumber?: string | null,
    utilityDistributorId?: string | null,
    utilityDistributor?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    utilityHistory?:  Array< {
      __typename: "UtilityHistory",
      date: string,
      reason?: UtilityReadingReason | null,
      reading: number,
      secondReading?: number | null,
    } > | null,
    files?:  {
      __typename: "ModelFileConnection",
      items:  Array< {
        __typename: "File",
        id: string,
        bucket: string,
        createdAt?: string | null,
        categoryId: string,
        foreignKey: string,
        foreignTableName: string,
        key: string,
        mimeType?: string | null,
        region: string,
        size?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        _ttl?: number | null,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    buildingId?: string | null,
    building?:  {
      __typename: "Building",
      id: string,
      name: string,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      acquisitionValue?: number | null,
      acquisitionAdditionalCostsValue?: number | null,
      acquisitionAdvertisedValue?: number | null,
      amountOfFacades?: number | null,
      amountOfFloors?: number | null,
      amountOfHousings?: number | null,
      buildingState?: BuildingState | null,
      cadastralIncome?: number | null,
      constructionYear?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      janitor?: boolean | null,
      jointOwnershipId?: string | null,
      notes?: string | null,
      owners?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      propertyTax?: number | null,
      residenceName?: string | null,
      buildingSiteId?: string | null,
      buildingSite?:  {
        __typename: "BuildingSite",
        id: string,
        name: string,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      units?:  {
        __typename: "ModelUnitConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      events?:  {
        __typename: "ModelBuildingEventConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      teams?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    unitId?: string | null,
    unit?:  {
      __typename: "Unit",
      id: string,
      acquisitionAdditionalCostsValue?: number | null,
      acquisitionAdvertisedValue?: number | null,
      acquisitionValue?: number | null,
      advertisedMonthlyCharges?: number | null,
      advertisedRentalPrice?: number | null,
      cadastralIncome?: number | null,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      floor?: number | null,
      jointOwnershipId?: string | null,
      managementDate: string,
      name: string,
      notes?: string | null,
      predictedPrice?: string | null,
      propertyTax?: number | null,
      publishAddress?: boolean | null,
      surface?: number | null,
      type: UnitType,
      buildingId: string,
      building?:  {
        __typename: "Building",
        id: string,
        name: string,
        addressId?: string | null,
        acquisitionValue?: number | null,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        amountOfFacades?: number | null,
        amountOfFloors?: number | null,
        amountOfHousings?: number | null,
        buildingState?: BuildingState | null,
        cadastralIncome?: number | null,
        constructionYear?: string | null,
        janitor?: boolean | null,
        jointOwnershipId?: string | null,
        notes?: string | null,
        propertyTax?: number | null,
        residenceName?: string | null,
        buildingSiteId?: string | null,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      owners?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leases?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      events?:  {
        __typename: "ModelUnitEventConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      unitAdvertisementId?: string | null,
      unitInventories?:  {
        __typename: "ModelUnitInventoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    leaseId?: string | null,
    lease?:  {
      __typename: "Lease",
      id: string,
      advancedChargesInvoices?:  {
        __typename: "LeaseAdvancedChargesInvoice",
        communicationSettingsProfileId: string,
        invoiceSenderId: string,
        lastDraftInvoiceDate?: string | null,
        lastInvoiceDate?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        bankAccountId?: string | null,
      } | null,
      balance?: number | null,
      canBeExtended?: boolean | null,
      communicationSettingsProfileId: string,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      endDate: string,
      includeRealEstateInLeaseContract?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      invoiceSenderId: string,
      invoiceSender?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      inventoryOfFixturesExpert?: string | null,
      inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
      inventoryOfFixturesType?: InventoryOfFixturesType | null,
      ipiNumber?: string | null,
      language: Language,
      lastDraftInvoiceDate?: string | null,
      lastIndexationProcessDate?: string | null,
      lastInvoiceDate?: string | null,
      legalCompetentAuthority?: string | null,
      name: string,
      notes?: string | null,
      paymentFrequency: LeasePaymentFrequency,
      paymentInvoicePeriod: LeasePaymentInvoicePeriod,
      paymentInvoicePeriodCustomDay?: number | null,
      paymentOption?:  {
        __typename: "LeasePaymentOption",
        customerId?: string | null,
        enabled: boolean,
        mandateActivatedAt?: string | null,
        mandateStatus?: PaymentProviderMandateStatus | null,
        paymentMethodId?: string | null,
        qrType?: LeaseQrType | null,
      } | null,
      purchaseOrderNumber?: string | null,
      realEstateAgency?: string | null,
      realEstateTax?: number | null,
      remittanceInformation?: string | null,
      remittanceInformationType?: LeaseRemittanceType | null,
      rentalGuaranty?:  {
        __typename: "LeaseRentalGuaranty",
        amount: number,
        blockedAmount?: number | null,
        releasedAmount?: number | null,
        type: LeaseRentalGuarantyType,
        financialInstitution?: string | null,
      } | null,
      signatureDate?: string | null,
      startDate: string,
      nextIndexationMonth?: string | null,
      nextIndexation?: boolean | null,
      status: LeaseStatus,
      technicCommunicationSettingsProfileId: string,
      totalInitialRentalPrice: number,
      totalRentalPrice: number,
      type: LeaseType,
      subletting?: boolean | null,
      vatRateRentId?: string | null,
      vatRateRent?:  {
        __typename: "VatRate",
        id: string,
        country: string,
        label: string,
        value?: number | null,
        ownerId?: string | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      additionalClauses?:  {
        __typename: "ModelLeaseAdditionalClauseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      bankAccountId?: string | null,
      bankAccount?:  {
        __typename: "BankAccount",
        id: string,
        contactId: string,
        number: string,
        bicNumber?: string | null,
        bankName?: string | null,
        contactIds?: Array< string > | null,
        buildingIds?: Array< string > | null,
        holderName?: string | null,
        label?: string | null,
        disabled?: boolean | null,
        integrations?: Array< IntegrationName > | null,
        matchingRule?: BankAccountMatchingRule | null,
        balance?: number | null,
        balanceDate?: string | null,
        type: BankAccountType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contacts?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      files?:  {
        __typename: "ModelFileConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leaseActionHistories?:  {
        __typename: "ModelLeaseActionHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leasePriceHistories?:  {
        __typename: "ModelLeasePriceHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      signatureDocuments?:  {
        __typename: "ModelSignatureDocumentConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      variousOperations?:  {
        __typename: "ModelLeaseVariousOperationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    contactId?: string | null,
    contact?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    customValues?:  Array< {
      __typename: "CustomValue",
      name: string,
      value: string,
    } > | null,
    originalTechnicId?: string | null,
    replacedTechnicId?: string | null,
    certificateIds?: Array< string > | null,
    readers?: Array< string > | null,
    writers?: Array< string > | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateTechnicMutationVariables = {
  input: UpdateTechnicInput,
  condition?: ModelTechnicConditionInput | null,
};

export type UpdateTechnicMutation = {
  updateTechnic?:  {
    __typename: "Technic",
    id: string,
    type: TechnicType,
    contractNumber?: string | null,
    communicationSettingsProfileId: string,
    maintenanceHistory?:  Array< {
      __typename: "TechnicMaintenanceHistory",
      date: string,
      contactId?: string | null,
      fileId?: string | null,
    } > | null,
    technicLibraryId?: string | null,
    technicLibrary?:  {
      __typename: "TechnicLibrary",
      id: string,
      certificateValidity?:  {
        __typename: "CertificateLibraryValidity",
        nonCompliant?: boolean | null,
        overlapping?: boolean | null,
        riskLevel?: RiskLevelExpiration | null,
      } | null,
      communicationSettingsProfileId?: string | null,
      criticality: TechnicLibraryCriticality,
      customFields?:  {
        __typename: "ModelCustomFieldConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      descriptions?:  Array< {
        __typename: "CustomLabel",
        language: string,
        label: string,
      } > | null,
      isDefault?: boolean | null,
      issuingAuthority?: string | null,
      linkedCertificateIds?: Array< string > | null,
      locationScope?: TechnicLibraryLocationScope | null,
      maintenanceSchemas?:  Array< {
        __typename: "TechnicLibraryMaintenanceSchema",
        id: string,
        criticality: TechnicLibraryCriticality,
        deadline?: string | null,
        maintenanceType: TechnicLibraryMaintenanceType,
        notificationsEnabled?: boolean | null,
        notificationType?: NotificationType | null,
        proofType?: Array< TechnicLibraryProofType > | null,
        recurrence?: TechnicLibraryRecurrence | null,
        responsibleParty: TechnicLibraryResponsibleParty,
        triggerType?: TechnicLibraryTriggerType | null,
      } > | null,
      names:  Array< {
        __typename: "CustomLabel",
        language: string,
        label: string,
      } >,
      status: TechnicLibraryStatus,
      tagIds?: Array< string > | null,
      technicLibraryFormat?: string | null,
      type: TechnicLibraryType,
      utilityTypes?: Array< UtilityType > | null,
      validity?:  {
        __typename: "TechnicLibraryValidity",
        value: number,
        validityUnit: TechnicLibraryValidityUnit,
      } | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    technicName?: string | null,
    lastControlDate?: string | null,
    status?: TechnicStatus | null,
    utilityType?: UtilityType | null,
    utilityEanCode?: string | null,
    utilityMeterNumber?: string | null,
    utilityDistributorId?: string | null,
    utilityDistributor?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    utilityHistory?:  Array< {
      __typename: "UtilityHistory",
      date: string,
      reason?: UtilityReadingReason | null,
      reading: number,
      secondReading?: number | null,
    } > | null,
    files?:  {
      __typename: "ModelFileConnection",
      items:  Array< {
        __typename: "File",
        id: string,
        bucket: string,
        createdAt?: string | null,
        categoryId: string,
        foreignKey: string,
        foreignTableName: string,
        key: string,
        mimeType?: string | null,
        region: string,
        size?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        _ttl?: number | null,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    buildingId?: string | null,
    building?:  {
      __typename: "Building",
      id: string,
      name: string,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      acquisitionValue?: number | null,
      acquisitionAdditionalCostsValue?: number | null,
      acquisitionAdvertisedValue?: number | null,
      amountOfFacades?: number | null,
      amountOfFloors?: number | null,
      amountOfHousings?: number | null,
      buildingState?: BuildingState | null,
      cadastralIncome?: number | null,
      constructionYear?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      janitor?: boolean | null,
      jointOwnershipId?: string | null,
      notes?: string | null,
      owners?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      propertyTax?: number | null,
      residenceName?: string | null,
      buildingSiteId?: string | null,
      buildingSite?:  {
        __typename: "BuildingSite",
        id: string,
        name: string,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      units?:  {
        __typename: "ModelUnitConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      events?:  {
        __typename: "ModelBuildingEventConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      teams?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    unitId?: string | null,
    unit?:  {
      __typename: "Unit",
      id: string,
      acquisitionAdditionalCostsValue?: number | null,
      acquisitionAdvertisedValue?: number | null,
      acquisitionValue?: number | null,
      advertisedMonthlyCharges?: number | null,
      advertisedRentalPrice?: number | null,
      cadastralIncome?: number | null,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      floor?: number | null,
      jointOwnershipId?: string | null,
      managementDate: string,
      name: string,
      notes?: string | null,
      predictedPrice?: string | null,
      propertyTax?: number | null,
      publishAddress?: boolean | null,
      surface?: number | null,
      type: UnitType,
      buildingId: string,
      building?:  {
        __typename: "Building",
        id: string,
        name: string,
        addressId?: string | null,
        acquisitionValue?: number | null,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        amountOfFacades?: number | null,
        amountOfFloors?: number | null,
        amountOfHousings?: number | null,
        buildingState?: BuildingState | null,
        cadastralIncome?: number | null,
        constructionYear?: string | null,
        janitor?: boolean | null,
        jointOwnershipId?: string | null,
        notes?: string | null,
        propertyTax?: number | null,
        residenceName?: string | null,
        buildingSiteId?: string | null,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      owners?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leases?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      events?:  {
        __typename: "ModelUnitEventConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      unitAdvertisementId?: string | null,
      unitInventories?:  {
        __typename: "ModelUnitInventoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    leaseId?: string | null,
    lease?:  {
      __typename: "Lease",
      id: string,
      advancedChargesInvoices?:  {
        __typename: "LeaseAdvancedChargesInvoice",
        communicationSettingsProfileId: string,
        invoiceSenderId: string,
        lastDraftInvoiceDate?: string | null,
        lastInvoiceDate?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        bankAccountId?: string | null,
      } | null,
      balance?: number | null,
      canBeExtended?: boolean | null,
      communicationSettingsProfileId: string,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      endDate: string,
      includeRealEstateInLeaseContract?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      invoiceSenderId: string,
      invoiceSender?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      inventoryOfFixturesExpert?: string | null,
      inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
      inventoryOfFixturesType?: InventoryOfFixturesType | null,
      ipiNumber?: string | null,
      language: Language,
      lastDraftInvoiceDate?: string | null,
      lastIndexationProcessDate?: string | null,
      lastInvoiceDate?: string | null,
      legalCompetentAuthority?: string | null,
      name: string,
      notes?: string | null,
      paymentFrequency: LeasePaymentFrequency,
      paymentInvoicePeriod: LeasePaymentInvoicePeriod,
      paymentInvoicePeriodCustomDay?: number | null,
      paymentOption?:  {
        __typename: "LeasePaymentOption",
        customerId?: string | null,
        enabled: boolean,
        mandateActivatedAt?: string | null,
        mandateStatus?: PaymentProviderMandateStatus | null,
        paymentMethodId?: string | null,
        qrType?: LeaseQrType | null,
      } | null,
      purchaseOrderNumber?: string | null,
      realEstateAgency?: string | null,
      realEstateTax?: number | null,
      remittanceInformation?: string | null,
      remittanceInformationType?: LeaseRemittanceType | null,
      rentalGuaranty?:  {
        __typename: "LeaseRentalGuaranty",
        amount: number,
        blockedAmount?: number | null,
        releasedAmount?: number | null,
        type: LeaseRentalGuarantyType,
        financialInstitution?: string | null,
      } | null,
      signatureDate?: string | null,
      startDate: string,
      nextIndexationMonth?: string | null,
      nextIndexation?: boolean | null,
      status: LeaseStatus,
      technicCommunicationSettingsProfileId: string,
      totalInitialRentalPrice: number,
      totalRentalPrice: number,
      type: LeaseType,
      subletting?: boolean | null,
      vatRateRentId?: string | null,
      vatRateRent?:  {
        __typename: "VatRate",
        id: string,
        country: string,
        label: string,
        value?: number | null,
        ownerId?: string | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      additionalClauses?:  {
        __typename: "ModelLeaseAdditionalClauseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      bankAccountId?: string | null,
      bankAccount?:  {
        __typename: "BankAccount",
        id: string,
        contactId: string,
        number: string,
        bicNumber?: string | null,
        bankName?: string | null,
        contactIds?: Array< string > | null,
        buildingIds?: Array< string > | null,
        holderName?: string | null,
        label?: string | null,
        disabled?: boolean | null,
        integrations?: Array< IntegrationName > | null,
        matchingRule?: BankAccountMatchingRule | null,
        balance?: number | null,
        balanceDate?: string | null,
        type: BankAccountType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contacts?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      files?:  {
        __typename: "ModelFileConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leaseActionHistories?:  {
        __typename: "ModelLeaseActionHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leasePriceHistories?:  {
        __typename: "ModelLeasePriceHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      signatureDocuments?:  {
        __typename: "ModelSignatureDocumentConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      variousOperations?:  {
        __typename: "ModelLeaseVariousOperationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    contactId?: string | null,
    contact?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    customValues?:  Array< {
      __typename: "CustomValue",
      name: string,
      value: string,
    } > | null,
    originalTechnicId?: string | null,
    replacedTechnicId?: string | null,
    certificateIds?: Array< string > | null,
    readers?: Array< string > | null,
    writers?: Array< string > | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteTechnicMutationVariables = {
  input: DeleteTechnicInput,
  condition?: ModelTechnicConditionInput | null,
};

export type DeleteTechnicMutation = {
  deleteTechnic?:  {
    __typename: "Technic",
    id: string,
    type: TechnicType,
    contractNumber?: string | null,
    communicationSettingsProfileId: string,
    maintenanceHistory?:  Array< {
      __typename: "TechnicMaintenanceHistory",
      date: string,
      contactId?: string | null,
      fileId?: string | null,
    } > | null,
    technicLibraryId?: string | null,
    technicLibrary?:  {
      __typename: "TechnicLibrary",
      id: string,
      certificateValidity?:  {
        __typename: "CertificateLibraryValidity",
        nonCompliant?: boolean | null,
        overlapping?: boolean | null,
        riskLevel?: RiskLevelExpiration | null,
      } | null,
      communicationSettingsProfileId?: string | null,
      criticality: TechnicLibraryCriticality,
      customFields?:  {
        __typename: "ModelCustomFieldConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      descriptions?:  Array< {
        __typename: "CustomLabel",
        language: string,
        label: string,
      } > | null,
      isDefault?: boolean | null,
      issuingAuthority?: string | null,
      linkedCertificateIds?: Array< string > | null,
      locationScope?: TechnicLibraryLocationScope | null,
      maintenanceSchemas?:  Array< {
        __typename: "TechnicLibraryMaintenanceSchema",
        id: string,
        criticality: TechnicLibraryCriticality,
        deadline?: string | null,
        maintenanceType: TechnicLibraryMaintenanceType,
        notificationsEnabled?: boolean | null,
        notificationType?: NotificationType | null,
        proofType?: Array< TechnicLibraryProofType > | null,
        recurrence?: TechnicLibraryRecurrence | null,
        responsibleParty: TechnicLibraryResponsibleParty,
        triggerType?: TechnicLibraryTriggerType | null,
      } > | null,
      names:  Array< {
        __typename: "CustomLabel",
        language: string,
        label: string,
      } >,
      status: TechnicLibraryStatus,
      tagIds?: Array< string > | null,
      technicLibraryFormat?: string | null,
      type: TechnicLibraryType,
      utilityTypes?: Array< UtilityType > | null,
      validity?:  {
        __typename: "TechnicLibraryValidity",
        value: number,
        validityUnit: TechnicLibraryValidityUnit,
      } | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    technicName?: string | null,
    lastControlDate?: string | null,
    status?: TechnicStatus | null,
    utilityType?: UtilityType | null,
    utilityEanCode?: string | null,
    utilityMeterNumber?: string | null,
    utilityDistributorId?: string | null,
    utilityDistributor?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    utilityHistory?:  Array< {
      __typename: "UtilityHistory",
      date: string,
      reason?: UtilityReadingReason | null,
      reading: number,
      secondReading?: number | null,
    } > | null,
    files?:  {
      __typename: "ModelFileConnection",
      items:  Array< {
        __typename: "File",
        id: string,
        bucket: string,
        createdAt?: string | null,
        categoryId: string,
        foreignKey: string,
        foreignTableName: string,
        key: string,
        mimeType?: string | null,
        region: string,
        size?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        _ttl?: number | null,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    buildingId?: string | null,
    building?:  {
      __typename: "Building",
      id: string,
      name: string,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      acquisitionValue?: number | null,
      acquisitionAdditionalCostsValue?: number | null,
      acquisitionAdvertisedValue?: number | null,
      amountOfFacades?: number | null,
      amountOfFloors?: number | null,
      amountOfHousings?: number | null,
      buildingState?: BuildingState | null,
      cadastralIncome?: number | null,
      constructionYear?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      janitor?: boolean | null,
      jointOwnershipId?: string | null,
      notes?: string | null,
      owners?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      propertyTax?: number | null,
      residenceName?: string | null,
      buildingSiteId?: string | null,
      buildingSite?:  {
        __typename: "BuildingSite",
        id: string,
        name: string,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      units?:  {
        __typename: "ModelUnitConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      events?:  {
        __typename: "ModelBuildingEventConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      teams?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    unitId?: string | null,
    unit?:  {
      __typename: "Unit",
      id: string,
      acquisitionAdditionalCostsValue?: number | null,
      acquisitionAdvertisedValue?: number | null,
      acquisitionValue?: number | null,
      advertisedMonthlyCharges?: number | null,
      advertisedRentalPrice?: number | null,
      cadastralIncome?: number | null,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      floor?: number | null,
      jointOwnershipId?: string | null,
      managementDate: string,
      name: string,
      notes?: string | null,
      predictedPrice?: string | null,
      propertyTax?: number | null,
      publishAddress?: boolean | null,
      surface?: number | null,
      type: UnitType,
      buildingId: string,
      building?:  {
        __typename: "Building",
        id: string,
        name: string,
        addressId?: string | null,
        acquisitionValue?: number | null,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        amountOfFacades?: number | null,
        amountOfFloors?: number | null,
        amountOfHousings?: number | null,
        buildingState?: BuildingState | null,
        cadastralIncome?: number | null,
        constructionYear?: string | null,
        janitor?: boolean | null,
        jointOwnershipId?: string | null,
        notes?: string | null,
        propertyTax?: number | null,
        residenceName?: string | null,
        buildingSiteId?: string | null,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      owners?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leases?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      events?:  {
        __typename: "ModelUnitEventConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      unitAdvertisementId?: string | null,
      unitInventories?:  {
        __typename: "ModelUnitInventoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    leaseId?: string | null,
    lease?:  {
      __typename: "Lease",
      id: string,
      advancedChargesInvoices?:  {
        __typename: "LeaseAdvancedChargesInvoice",
        communicationSettingsProfileId: string,
        invoiceSenderId: string,
        lastDraftInvoiceDate?: string | null,
        lastInvoiceDate?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        bankAccountId?: string | null,
      } | null,
      balance?: number | null,
      canBeExtended?: boolean | null,
      communicationSettingsProfileId: string,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      endDate: string,
      includeRealEstateInLeaseContract?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      invoiceSenderId: string,
      invoiceSender?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      inventoryOfFixturesExpert?: string | null,
      inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
      inventoryOfFixturesType?: InventoryOfFixturesType | null,
      ipiNumber?: string | null,
      language: Language,
      lastDraftInvoiceDate?: string | null,
      lastIndexationProcessDate?: string | null,
      lastInvoiceDate?: string | null,
      legalCompetentAuthority?: string | null,
      name: string,
      notes?: string | null,
      paymentFrequency: LeasePaymentFrequency,
      paymentInvoicePeriod: LeasePaymentInvoicePeriod,
      paymentInvoicePeriodCustomDay?: number | null,
      paymentOption?:  {
        __typename: "LeasePaymentOption",
        customerId?: string | null,
        enabled: boolean,
        mandateActivatedAt?: string | null,
        mandateStatus?: PaymentProviderMandateStatus | null,
        paymentMethodId?: string | null,
        qrType?: LeaseQrType | null,
      } | null,
      purchaseOrderNumber?: string | null,
      realEstateAgency?: string | null,
      realEstateTax?: number | null,
      remittanceInformation?: string | null,
      remittanceInformationType?: LeaseRemittanceType | null,
      rentalGuaranty?:  {
        __typename: "LeaseRentalGuaranty",
        amount: number,
        blockedAmount?: number | null,
        releasedAmount?: number | null,
        type: LeaseRentalGuarantyType,
        financialInstitution?: string | null,
      } | null,
      signatureDate?: string | null,
      startDate: string,
      nextIndexationMonth?: string | null,
      nextIndexation?: boolean | null,
      status: LeaseStatus,
      technicCommunicationSettingsProfileId: string,
      totalInitialRentalPrice: number,
      totalRentalPrice: number,
      type: LeaseType,
      subletting?: boolean | null,
      vatRateRentId?: string | null,
      vatRateRent?:  {
        __typename: "VatRate",
        id: string,
        country: string,
        label: string,
        value?: number | null,
        ownerId?: string | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      additionalClauses?:  {
        __typename: "ModelLeaseAdditionalClauseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      bankAccountId?: string | null,
      bankAccount?:  {
        __typename: "BankAccount",
        id: string,
        contactId: string,
        number: string,
        bicNumber?: string | null,
        bankName?: string | null,
        contactIds?: Array< string > | null,
        buildingIds?: Array< string > | null,
        holderName?: string | null,
        label?: string | null,
        disabled?: boolean | null,
        integrations?: Array< IntegrationName > | null,
        matchingRule?: BankAccountMatchingRule | null,
        balance?: number | null,
        balanceDate?: string | null,
        type: BankAccountType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contacts?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      files?:  {
        __typename: "ModelFileConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leaseActionHistories?:  {
        __typename: "ModelLeaseActionHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leasePriceHistories?:  {
        __typename: "ModelLeasePriceHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      signatureDocuments?:  {
        __typename: "ModelSignatureDocumentConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      variousOperations?:  {
        __typename: "ModelLeaseVariousOperationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    contactId?: string | null,
    contact?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    customValues?:  Array< {
      __typename: "CustomValue",
      name: string,
      value: string,
    } > | null,
    originalTechnicId?: string | null,
    replacedTechnicId?: string | null,
    certificateIds?: Array< string > | null,
    readers?: Array< string > | null,
    writers?: Array< string > | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateTechnicLibraryMutationVariables = {
  input: CreateTechnicLibraryInput,
  condition?: ModelTechnicLibraryConditionInput | null,
};

export type CreateTechnicLibraryMutation = {
  createTechnicLibrary?:  {
    __typename: "TechnicLibrary",
    id: string,
    certificateValidity?:  {
      __typename: "CertificateLibraryValidity",
      gracePeriod?:  {
        __typename: "TechnicLibraryValidity",
        value: number,
        validityUnit: TechnicLibraryValidityUnit,
      } | null,
      nonCompliant?: boolean | null,
      overlapping?: boolean | null,
      riskLevel?: RiskLevelExpiration | null,
    } | null,
    communicationSettingsProfileId?: string | null,
    criticality: TechnicLibraryCriticality,
    customFields?:  {
      __typename: "ModelCustomFieldConnection",
      items:  Array< {
        __typename: "CustomField",
        id: string,
        fieldName: string,
        fieldType: CustomFieldType,
        foreignKey: string,
        foreignTableName: string,
        order?: number | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    descriptions?:  Array< {
      __typename: "CustomLabel",
      language: string,
      label: string,
    } > | null,
    isDefault?: boolean | null,
    issuingAuthority?: string | null,
    linkedCertificateIds?: Array< string > | null,
    locationScope?: TechnicLibraryLocationScope | null,
    maintenanceSchemas?:  Array< {
      __typename: "TechnicLibraryMaintenanceSchema",
      id: string,
      criticality: TechnicLibraryCriticality,
      deadline?: string | null,
      descriptions?:  Array< {
        __typename: "CustomLabel",
        language: string,
        label: string,
      } > | null,
      interval?:  {
        __typename: "TechnicLibraryValidity",
        value: number,
        validityUnit: TechnicLibraryValidityUnit,
      } | null,
      maintenanceType: TechnicLibraryMaintenanceType,
      names:  Array< {
        __typename: "CustomLabel",
        language: string,
        label: string,
      } >,
      notificationsEnabled?: boolean | null,
      notificationType?: NotificationType | null,
      proofType?: Array< TechnicLibraryProofType > | null,
      proofTypeName?:  Array< {
        __typename: "CustomLabel",
        language: string,
        label: string,
      } > | null,
      recurrence?: TechnicLibraryRecurrence | null,
      responsibleParty: TechnicLibraryResponsibleParty,
      triggerType?: TechnicLibraryTriggerType | null,
    } > | null,
    names:  Array< {
      __typename: "CustomLabel",
      language: string,
      label: string,
    } >,
    status: TechnicLibraryStatus,
    tagIds?: Array< string > | null,
    technicLibraryFormat?: string | null,
    type: TechnicLibraryType,
    utilityTypes?: Array< UtilityType > | null,
    validity?:  {
      __typename: "TechnicLibraryValidity",
      value: number,
      validityUnit: TechnicLibraryValidityUnit,
    } | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateTechnicLibraryMutationVariables = {
  input: UpdateTechnicLibraryInput,
  condition?: ModelTechnicLibraryConditionInput | null,
};

export type UpdateTechnicLibraryMutation = {
  updateTechnicLibrary?:  {
    __typename: "TechnicLibrary",
    id: string,
    certificateValidity?:  {
      __typename: "CertificateLibraryValidity",
      gracePeriod?:  {
        __typename: "TechnicLibraryValidity",
        value: number,
        validityUnit: TechnicLibraryValidityUnit,
      } | null,
      nonCompliant?: boolean | null,
      overlapping?: boolean | null,
      riskLevel?: RiskLevelExpiration | null,
    } | null,
    communicationSettingsProfileId?: string | null,
    criticality: TechnicLibraryCriticality,
    customFields?:  {
      __typename: "ModelCustomFieldConnection",
      items:  Array< {
        __typename: "CustomField",
        id: string,
        fieldName: string,
        fieldType: CustomFieldType,
        foreignKey: string,
        foreignTableName: string,
        order?: number | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    descriptions?:  Array< {
      __typename: "CustomLabel",
      language: string,
      label: string,
    } > | null,
    isDefault?: boolean | null,
    issuingAuthority?: string | null,
    linkedCertificateIds?: Array< string > | null,
    locationScope?: TechnicLibraryLocationScope | null,
    maintenanceSchemas?:  Array< {
      __typename: "TechnicLibraryMaintenanceSchema",
      id: string,
      criticality: TechnicLibraryCriticality,
      deadline?: string | null,
      descriptions?:  Array< {
        __typename: "CustomLabel",
        language: string,
        label: string,
      } > | null,
      interval?:  {
        __typename: "TechnicLibraryValidity",
        value: number,
        validityUnit: TechnicLibraryValidityUnit,
      } | null,
      maintenanceType: TechnicLibraryMaintenanceType,
      names:  Array< {
        __typename: "CustomLabel",
        language: string,
        label: string,
      } >,
      notificationsEnabled?: boolean | null,
      notificationType?: NotificationType | null,
      proofType?: Array< TechnicLibraryProofType > | null,
      proofTypeName?:  Array< {
        __typename: "CustomLabel",
        language: string,
        label: string,
      } > | null,
      recurrence?: TechnicLibraryRecurrence | null,
      responsibleParty: TechnicLibraryResponsibleParty,
      triggerType?: TechnicLibraryTriggerType | null,
    } > | null,
    names:  Array< {
      __typename: "CustomLabel",
      language: string,
      label: string,
    } >,
    status: TechnicLibraryStatus,
    tagIds?: Array< string > | null,
    technicLibraryFormat?: string | null,
    type: TechnicLibraryType,
    utilityTypes?: Array< UtilityType > | null,
    validity?:  {
      __typename: "TechnicLibraryValidity",
      value: number,
      validityUnit: TechnicLibraryValidityUnit,
    } | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteTechnicLibraryMutationVariables = {
  input: DeleteTechnicLibraryInput,
  condition?: ModelTechnicLibraryConditionInput | null,
};

export type DeleteTechnicLibraryMutation = {
  deleteTechnicLibrary?:  {
    __typename: "TechnicLibrary",
    id: string,
    certificateValidity?:  {
      __typename: "CertificateLibraryValidity",
      gracePeriod?:  {
        __typename: "TechnicLibraryValidity",
        value: number,
        validityUnit: TechnicLibraryValidityUnit,
      } | null,
      nonCompliant?: boolean | null,
      overlapping?: boolean | null,
      riskLevel?: RiskLevelExpiration | null,
    } | null,
    communicationSettingsProfileId?: string | null,
    criticality: TechnicLibraryCriticality,
    customFields?:  {
      __typename: "ModelCustomFieldConnection",
      items:  Array< {
        __typename: "CustomField",
        id: string,
        fieldName: string,
        fieldType: CustomFieldType,
        foreignKey: string,
        foreignTableName: string,
        order?: number | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    descriptions?:  Array< {
      __typename: "CustomLabel",
      language: string,
      label: string,
    } > | null,
    isDefault?: boolean | null,
    issuingAuthority?: string | null,
    linkedCertificateIds?: Array< string > | null,
    locationScope?: TechnicLibraryLocationScope | null,
    maintenanceSchemas?:  Array< {
      __typename: "TechnicLibraryMaintenanceSchema",
      id: string,
      criticality: TechnicLibraryCriticality,
      deadline?: string | null,
      descriptions?:  Array< {
        __typename: "CustomLabel",
        language: string,
        label: string,
      } > | null,
      interval?:  {
        __typename: "TechnicLibraryValidity",
        value: number,
        validityUnit: TechnicLibraryValidityUnit,
      } | null,
      maintenanceType: TechnicLibraryMaintenanceType,
      names:  Array< {
        __typename: "CustomLabel",
        language: string,
        label: string,
      } >,
      notificationsEnabled?: boolean | null,
      notificationType?: NotificationType | null,
      proofType?: Array< TechnicLibraryProofType > | null,
      proofTypeName?:  Array< {
        __typename: "CustomLabel",
        language: string,
        label: string,
      } > | null,
      recurrence?: TechnicLibraryRecurrence | null,
      responsibleParty: TechnicLibraryResponsibleParty,
      triggerType?: TechnicLibraryTriggerType | null,
    } > | null,
    names:  Array< {
      __typename: "CustomLabel",
      language: string,
      label: string,
    } >,
    status: TechnicLibraryStatus,
    tagIds?: Array< string > | null,
    technicLibraryFormat?: string | null,
    type: TechnicLibraryType,
    utilityTypes?: Array< UtilityType > | null,
    validity?:  {
      __typename: "TechnicLibraryValidity",
      value: number,
      validityUnit: TechnicLibraryValidityUnit,
    } | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateTicketMutationVariables = {
  input: CreateTicketInput,
  condition?: ModelTicketConditionInput | null,
};

export type CreateTicketMutation = {
  createTicket?:  {
    __typename: "Ticket",
    id: string,
    assignedAt?: string | null,
    assignedTo?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    assignedToId?: string | null,
    attachment?:  {
      __typename: "ModelFileConnection",
      items:  Array< {
        __typename: "File",
        id: string,
        bucket: string,
        createdAt?: string | null,
        categoryId: string,
        foreignKey: string,
        foreignTableName: string,
        key: string,
        mimeType?: string | null,
        region: string,
        size?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        _ttl?: number | null,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    building?:  {
      __typename: "Building",
      id: string,
      name: string,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      acquisitionValue?: number | null,
      acquisitionAdditionalCostsValue?: number | null,
      acquisitionAdvertisedValue?: number | null,
      amountOfFacades?: number | null,
      amountOfFloors?: number | null,
      amountOfHousings?: number | null,
      buildingState?: BuildingState | null,
      cadastralIncome?: number | null,
      constructionYear?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      janitor?: boolean | null,
      jointOwnershipId?: string | null,
      notes?: string | null,
      owners?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      propertyTax?: number | null,
      residenceName?: string | null,
      buildingSiteId?: string | null,
      buildingSite?:  {
        __typename: "BuildingSite",
        id: string,
        name: string,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      units?:  {
        __typename: "ModelUnitConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      events?:  {
        __typename: "ModelBuildingEventConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      teams?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    buildingId?: string | null,
    closedAt?: string | null,
    contact?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    contactId: string,
    content: string,
    conversations?:  {
      __typename: "ModelTicketConnection",
      items:  Array< {
        __typename: "Ticket",
        id: string,
        assignedAt?: string | null,
        assignedToId?: string | null,
        buildingId?: string | null,
        closedAt?: string | null,
        contactId: string,
        content: string,
        createdAt: string,
        emailMessageId?: string | null,
        emailReferences?: Array< string | null > | null,
        parentId?: string | null,
        plannedAt?: string | null,
        referenceCode?: string | null,
        sourceType: TicketSourceType,
        status?: TicketStatus | null,
        subject: string,
        unitId?: string | null,
        unread: boolean,
        updatedAt?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    createdAt: string,
    emailMessageId?: string | null,
    emailReferences?: Array< string | null > | null,
    parentId?: string | null,
    plannedAt?: string | null,
    referenceCode?: string | null,
    sourceType: TicketSourceType,
    status?: TicketStatus | null,
    subject: string,
    unit?:  {
      __typename: "Unit",
      id: string,
      acquisitionAdditionalCostsValue?: number | null,
      acquisitionAdvertisedValue?: number | null,
      acquisitionValue?: number | null,
      advertisedMonthlyCharges?: number | null,
      advertisedRentalPrice?: number | null,
      cadastralIncome?: number | null,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      floor?: number | null,
      jointOwnershipId?: string | null,
      managementDate: string,
      name: string,
      notes?: string | null,
      predictedPrice?: string | null,
      propertyTax?: number | null,
      publishAddress?: boolean | null,
      surface?: number | null,
      type: UnitType,
      buildingId: string,
      building?:  {
        __typename: "Building",
        id: string,
        name: string,
        addressId?: string | null,
        acquisitionValue?: number | null,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        amountOfFacades?: number | null,
        amountOfFloors?: number | null,
        amountOfHousings?: number | null,
        buildingState?: BuildingState | null,
        cadastralIncome?: number | null,
        constructionYear?: string | null,
        janitor?: boolean | null,
        jointOwnershipId?: string | null,
        notes?: string | null,
        propertyTax?: number | null,
        residenceName?: string | null,
        buildingSiteId?: string | null,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      owners?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leases?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      events?:  {
        __typename: "ModelUnitEventConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      unitAdvertisementId?: string | null,
      unitInventories?:  {
        __typename: "ModelUnitInventoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    unitId?: string | null,
    unread: boolean,
    updatedAt?: string | null,
    readers?: Array< string > | null,
    readId: string,
    clientId: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateTicketMutationVariables = {
  input: UpdateTicketInput,
  condition?: ModelTicketConditionInput | null,
};

export type UpdateTicketMutation = {
  updateTicket?:  {
    __typename: "Ticket",
    id: string,
    assignedAt?: string | null,
    assignedTo?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    assignedToId?: string | null,
    attachment?:  {
      __typename: "ModelFileConnection",
      items:  Array< {
        __typename: "File",
        id: string,
        bucket: string,
        createdAt?: string | null,
        categoryId: string,
        foreignKey: string,
        foreignTableName: string,
        key: string,
        mimeType?: string | null,
        region: string,
        size?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        _ttl?: number | null,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    building?:  {
      __typename: "Building",
      id: string,
      name: string,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      acquisitionValue?: number | null,
      acquisitionAdditionalCostsValue?: number | null,
      acquisitionAdvertisedValue?: number | null,
      amountOfFacades?: number | null,
      amountOfFloors?: number | null,
      amountOfHousings?: number | null,
      buildingState?: BuildingState | null,
      cadastralIncome?: number | null,
      constructionYear?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      janitor?: boolean | null,
      jointOwnershipId?: string | null,
      notes?: string | null,
      owners?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      propertyTax?: number | null,
      residenceName?: string | null,
      buildingSiteId?: string | null,
      buildingSite?:  {
        __typename: "BuildingSite",
        id: string,
        name: string,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      units?:  {
        __typename: "ModelUnitConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      events?:  {
        __typename: "ModelBuildingEventConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      teams?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    buildingId?: string | null,
    closedAt?: string | null,
    contact?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    contactId: string,
    content: string,
    conversations?:  {
      __typename: "ModelTicketConnection",
      items:  Array< {
        __typename: "Ticket",
        id: string,
        assignedAt?: string | null,
        assignedToId?: string | null,
        buildingId?: string | null,
        closedAt?: string | null,
        contactId: string,
        content: string,
        createdAt: string,
        emailMessageId?: string | null,
        emailReferences?: Array< string | null > | null,
        parentId?: string | null,
        plannedAt?: string | null,
        referenceCode?: string | null,
        sourceType: TicketSourceType,
        status?: TicketStatus | null,
        subject: string,
        unitId?: string | null,
        unread: boolean,
        updatedAt?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    createdAt: string,
    emailMessageId?: string | null,
    emailReferences?: Array< string | null > | null,
    parentId?: string | null,
    plannedAt?: string | null,
    referenceCode?: string | null,
    sourceType: TicketSourceType,
    status?: TicketStatus | null,
    subject: string,
    unit?:  {
      __typename: "Unit",
      id: string,
      acquisitionAdditionalCostsValue?: number | null,
      acquisitionAdvertisedValue?: number | null,
      acquisitionValue?: number | null,
      advertisedMonthlyCharges?: number | null,
      advertisedRentalPrice?: number | null,
      cadastralIncome?: number | null,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      floor?: number | null,
      jointOwnershipId?: string | null,
      managementDate: string,
      name: string,
      notes?: string | null,
      predictedPrice?: string | null,
      propertyTax?: number | null,
      publishAddress?: boolean | null,
      surface?: number | null,
      type: UnitType,
      buildingId: string,
      building?:  {
        __typename: "Building",
        id: string,
        name: string,
        addressId?: string | null,
        acquisitionValue?: number | null,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        amountOfFacades?: number | null,
        amountOfFloors?: number | null,
        amountOfHousings?: number | null,
        buildingState?: BuildingState | null,
        cadastralIncome?: number | null,
        constructionYear?: string | null,
        janitor?: boolean | null,
        jointOwnershipId?: string | null,
        notes?: string | null,
        propertyTax?: number | null,
        residenceName?: string | null,
        buildingSiteId?: string | null,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      owners?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leases?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      events?:  {
        __typename: "ModelUnitEventConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      unitAdvertisementId?: string | null,
      unitInventories?:  {
        __typename: "ModelUnitInventoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    unitId?: string | null,
    unread: boolean,
    updatedAt?: string | null,
    readers?: Array< string > | null,
    readId: string,
    clientId: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteTicketMutationVariables = {
  input: DeleteTicketInput,
  condition?: ModelTicketConditionInput | null,
};

export type DeleteTicketMutation = {
  deleteTicket?:  {
    __typename: "Ticket",
    id: string,
    assignedAt?: string | null,
    assignedTo?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    assignedToId?: string | null,
    attachment?:  {
      __typename: "ModelFileConnection",
      items:  Array< {
        __typename: "File",
        id: string,
        bucket: string,
        createdAt?: string | null,
        categoryId: string,
        foreignKey: string,
        foreignTableName: string,
        key: string,
        mimeType?: string | null,
        region: string,
        size?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        _ttl?: number | null,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    building?:  {
      __typename: "Building",
      id: string,
      name: string,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      acquisitionValue?: number | null,
      acquisitionAdditionalCostsValue?: number | null,
      acquisitionAdvertisedValue?: number | null,
      amountOfFacades?: number | null,
      amountOfFloors?: number | null,
      amountOfHousings?: number | null,
      buildingState?: BuildingState | null,
      cadastralIncome?: number | null,
      constructionYear?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      janitor?: boolean | null,
      jointOwnershipId?: string | null,
      notes?: string | null,
      owners?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      propertyTax?: number | null,
      residenceName?: string | null,
      buildingSiteId?: string | null,
      buildingSite?:  {
        __typename: "BuildingSite",
        id: string,
        name: string,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      units?:  {
        __typename: "ModelUnitConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      events?:  {
        __typename: "ModelBuildingEventConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      teams?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    buildingId?: string | null,
    closedAt?: string | null,
    contact?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    contactId: string,
    content: string,
    conversations?:  {
      __typename: "ModelTicketConnection",
      items:  Array< {
        __typename: "Ticket",
        id: string,
        assignedAt?: string | null,
        assignedToId?: string | null,
        buildingId?: string | null,
        closedAt?: string | null,
        contactId: string,
        content: string,
        createdAt: string,
        emailMessageId?: string | null,
        emailReferences?: Array< string | null > | null,
        parentId?: string | null,
        plannedAt?: string | null,
        referenceCode?: string | null,
        sourceType: TicketSourceType,
        status?: TicketStatus | null,
        subject: string,
        unitId?: string | null,
        unread: boolean,
        updatedAt?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    createdAt: string,
    emailMessageId?: string | null,
    emailReferences?: Array< string | null > | null,
    parentId?: string | null,
    plannedAt?: string | null,
    referenceCode?: string | null,
    sourceType: TicketSourceType,
    status?: TicketStatus | null,
    subject: string,
    unit?:  {
      __typename: "Unit",
      id: string,
      acquisitionAdditionalCostsValue?: number | null,
      acquisitionAdvertisedValue?: number | null,
      acquisitionValue?: number | null,
      advertisedMonthlyCharges?: number | null,
      advertisedRentalPrice?: number | null,
      cadastralIncome?: number | null,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      floor?: number | null,
      jointOwnershipId?: string | null,
      managementDate: string,
      name: string,
      notes?: string | null,
      predictedPrice?: string | null,
      propertyTax?: number | null,
      publishAddress?: boolean | null,
      surface?: number | null,
      type: UnitType,
      buildingId: string,
      building?:  {
        __typename: "Building",
        id: string,
        name: string,
        addressId?: string | null,
        acquisitionValue?: number | null,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        amountOfFacades?: number | null,
        amountOfFloors?: number | null,
        amountOfHousings?: number | null,
        buildingState?: BuildingState | null,
        cadastralIncome?: number | null,
        constructionYear?: string | null,
        janitor?: boolean | null,
        jointOwnershipId?: string | null,
        notes?: string | null,
        propertyTax?: number | null,
        residenceName?: string | null,
        buildingSiteId?: string | null,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      owners?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leases?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      events?:  {
        __typename: "ModelUnitEventConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      unitAdvertisementId?: string | null,
      unitInventories?:  {
        __typename: "ModelUnitInventoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    unitId?: string | null,
    unread: boolean,
    updatedAt?: string | null,
    readers?: Array< string > | null,
    readId: string,
    clientId: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateUnitMutationVariables = {
  input: CreateUnitInput,
  condition?: ModelUnitConditionInput | null,
};

export type CreateUnitMutation = {
  createUnit?:  {
    __typename: "Unit",
    id: string,
    acquisitionAdditionalCostsValue?: number | null,
    acquisitionAdvertisedValue?: number | null,
    acquisitionValue?: number | null,
    advertisedMonthlyCharges?: number | null,
    advertisedRentalPrice?: number | null,
    cadastralIncome?: number | null,
    createdAt?: string | null,
    customValues?:  Array< {
      __typename: "CustomValue",
      name: string,
      value: string,
    } > | null,
    floor?: number | null,
    jointOwnershipId?: string | null,
    managementDate: string,
    name: string,
    notes?: string | null,
    predictedPrice?: string | null,
    propertyTax?: number | null,
    publishAddress?: boolean | null,
    surface?: number | null,
    type: UnitType,
    buildingId: string,
    building?:  {
      __typename: "Building",
      id: string,
      name: string,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      acquisitionValue?: number | null,
      acquisitionAdditionalCostsValue?: number | null,
      acquisitionAdvertisedValue?: number | null,
      amountOfFacades?: number | null,
      amountOfFloors?: number | null,
      amountOfHousings?: number | null,
      buildingState?: BuildingState | null,
      cadastralIncome?: number | null,
      constructionYear?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      janitor?: boolean | null,
      jointOwnershipId?: string | null,
      notes?: string | null,
      owners?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      propertyTax?: number | null,
      residenceName?: string | null,
      buildingSiteId?: string | null,
      buildingSite?:  {
        __typename: "BuildingSite",
        id: string,
        name: string,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      units?:  {
        __typename: "ModelUnitConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      events?:  {
        __typename: "ModelBuildingEventConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      teams?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    owners?:  {
      __typename: "ModelUnitOwnerConnection",
      items:  Array< {
        __typename: "UnitOwner",
        id: string,
        disabled?: boolean | null,
        ownerId: string,
        periodFrom?: string | null,
        periodTo?: string | null,
        stake: number,
        unitId: string,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    leases?:  {
      __typename: "ModelUnitLeaseConnection",
      items:  Array< {
        __typename: "UnitLease",
        id: string,
        allowChargeAdjustment?: boolean | null,
        authorizeProfessionalActivity?: boolean | null,
        chargesIndexation?: boolean | null,
        createdAt?: string | null,
        endDate: string,
        furnishedRental?: boolean | null,
        furnishedRentalInsuranceByTenant?: boolean | null,
        furnishedRentalRentalPricePercentage?: number | null,
        initialRentalPrice: number,
        indexation?: boolean | null,
        advancedIndexation?: boolean | null,
        indexType?: IndexType | null,
        baseYear?: number | null,
        baseIndexType?: BaseIndexType | null,
        baseIndexDate?: string | null,
        nextIndexationMonth?: string | null,
        nextIndexation?: boolean | null,
        leaseId: string,
        mainUnit: boolean,
        rentalPrice: number,
        signatureDate?: string | null,
        startDate: string,
        unitId: string,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    events?:  {
      __typename: "ModelUnitEventConnection",
      items:  Array< {
        __typename: "UnitEvent",
        id: string,
        unitId: string,
        type: UnitEventType,
        startDate: string,
        endDate: string,
        totalCost?: number | null,
        note?: string | null,
        writers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    unitAdvertisementId?: string | null,
    unitInventories?:  {
      __typename: "ModelUnitInventoryConnection",
      items:  Array< {
        __typename: "UnitInventory",
        id: string,
        privateBatthRoom?: boolean | null,
        createdAt?: string | null,
        deletedAt?: string | null,
        kitchenEquipment?: KitchenEquipment | null,
        roomName?: string | null,
        roomType: UnitInventoryRoomType,
        surface?: number | null,
        showSurface?: boolean | null,
        unitId: string,
        inside: boolean,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    readers?: Array< string > | null,
    readId: string,
    clientId: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateUnitMutationVariables = {
  input: UpdateUnitInput,
  condition?: ModelUnitConditionInput | null,
};

export type UpdateUnitMutation = {
  updateUnit?:  {
    __typename: "Unit",
    id: string,
    acquisitionAdditionalCostsValue?: number | null,
    acquisitionAdvertisedValue?: number | null,
    acquisitionValue?: number | null,
    advertisedMonthlyCharges?: number | null,
    advertisedRentalPrice?: number | null,
    cadastralIncome?: number | null,
    createdAt?: string | null,
    customValues?:  Array< {
      __typename: "CustomValue",
      name: string,
      value: string,
    } > | null,
    floor?: number | null,
    jointOwnershipId?: string | null,
    managementDate: string,
    name: string,
    notes?: string | null,
    predictedPrice?: string | null,
    propertyTax?: number | null,
    publishAddress?: boolean | null,
    surface?: number | null,
    type: UnitType,
    buildingId: string,
    building?:  {
      __typename: "Building",
      id: string,
      name: string,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      acquisitionValue?: number | null,
      acquisitionAdditionalCostsValue?: number | null,
      acquisitionAdvertisedValue?: number | null,
      amountOfFacades?: number | null,
      amountOfFloors?: number | null,
      amountOfHousings?: number | null,
      buildingState?: BuildingState | null,
      cadastralIncome?: number | null,
      constructionYear?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      janitor?: boolean | null,
      jointOwnershipId?: string | null,
      notes?: string | null,
      owners?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      propertyTax?: number | null,
      residenceName?: string | null,
      buildingSiteId?: string | null,
      buildingSite?:  {
        __typename: "BuildingSite",
        id: string,
        name: string,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      units?:  {
        __typename: "ModelUnitConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      events?:  {
        __typename: "ModelBuildingEventConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      teams?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    owners?:  {
      __typename: "ModelUnitOwnerConnection",
      items:  Array< {
        __typename: "UnitOwner",
        id: string,
        disabled?: boolean | null,
        ownerId: string,
        periodFrom?: string | null,
        periodTo?: string | null,
        stake: number,
        unitId: string,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    leases?:  {
      __typename: "ModelUnitLeaseConnection",
      items:  Array< {
        __typename: "UnitLease",
        id: string,
        allowChargeAdjustment?: boolean | null,
        authorizeProfessionalActivity?: boolean | null,
        chargesIndexation?: boolean | null,
        createdAt?: string | null,
        endDate: string,
        furnishedRental?: boolean | null,
        furnishedRentalInsuranceByTenant?: boolean | null,
        furnishedRentalRentalPricePercentage?: number | null,
        initialRentalPrice: number,
        indexation?: boolean | null,
        advancedIndexation?: boolean | null,
        indexType?: IndexType | null,
        baseYear?: number | null,
        baseIndexType?: BaseIndexType | null,
        baseIndexDate?: string | null,
        nextIndexationMonth?: string | null,
        nextIndexation?: boolean | null,
        leaseId: string,
        mainUnit: boolean,
        rentalPrice: number,
        signatureDate?: string | null,
        startDate: string,
        unitId: string,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    events?:  {
      __typename: "ModelUnitEventConnection",
      items:  Array< {
        __typename: "UnitEvent",
        id: string,
        unitId: string,
        type: UnitEventType,
        startDate: string,
        endDate: string,
        totalCost?: number | null,
        note?: string | null,
        writers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    unitAdvertisementId?: string | null,
    unitInventories?:  {
      __typename: "ModelUnitInventoryConnection",
      items:  Array< {
        __typename: "UnitInventory",
        id: string,
        privateBatthRoom?: boolean | null,
        createdAt?: string | null,
        deletedAt?: string | null,
        kitchenEquipment?: KitchenEquipment | null,
        roomName?: string | null,
        roomType: UnitInventoryRoomType,
        surface?: number | null,
        showSurface?: boolean | null,
        unitId: string,
        inside: boolean,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    readers?: Array< string > | null,
    readId: string,
    clientId: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteUnitMutationVariables = {
  input: DeleteUnitInput,
  condition?: ModelUnitConditionInput | null,
};

export type DeleteUnitMutation = {
  deleteUnit?:  {
    __typename: "Unit",
    id: string,
    acquisitionAdditionalCostsValue?: number | null,
    acquisitionAdvertisedValue?: number | null,
    acquisitionValue?: number | null,
    advertisedMonthlyCharges?: number | null,
    advertisedRentalPrice?: number | null,
    cadastralIncome?: number | null,
    createdAt?: string | null,
    customValues?:  Array< {
      __typename: "CustomValue",
      name: string,
      value: string,
    } > | null,
    floor?: number | null,
    jointOwnershipId?: string | null,
    managementDate: string,
    name: string,
    notes?: string | null,
    predictedPrice?: string | null,
    propertyTax?: number | null,
    publishAddress?: boolean | null,
    surface?: number | null,
    type: UnitType,
    buildingId: string,
    building?:  {
      __typename: "Building",
      id: string,
      name: string,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      acquisitionValue?: number | null,
      acquisitionAdditionalCostsValue?: number | null,
      acquisitionAdvertisedValue?: number | null,
      amountOfFacades?: number | null,
      amountOfFloors?: number | null,
      amountOfHousings?: number | null,
      buildingState?: BuildingState | null,
      cadastralIncome?: number | null,
      constructionYear?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      janitor?: boolean | null,
      jointOwnershipId?: string | null,
      notes?: string | null,
      owners?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      propertyTax?: number | null,
      residenceName?: string | null,
      buildingSiteId?: string | null,
      buildingSite?:  {
        __typename: "BuildingSite",
        id: string,
        name: string,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      units?:  {
        __typename: "ModelUnitConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      events?:  {
        __typename: "ModelBuildingEventConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      teams?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    owners?:  {
      __typename: "ModelUnitOwnerConnection",
      items:  Array< {
        __typename: "UnitOwner",
        id: string,
        disabled?: boolean | null,
        ownerId: string,
        periodFrom?: string | null,
        periodTo?: string | null,
        stake: number,
        unitId: string,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    leases?:  {
      __typename: "ModelUnitLeaseConnection",
      items:  Array< {
        __typename: "UnitLease",
        id: string,
        allowChargeAdjustment?: boolean | null,
        authorizeProfessionalActivity?: boolean | null,
        chargesIndexation?: boolean | null,
        createdAt?: string | null,
        endDate: string,
        furnishedRental?: boolean | null,
        furnishedRentalInsuranceByTenant?: boolean | null,
        furnishedRentalRentalPricePercentage?: number | null,
        initialRentalPrice: number,
        indexation?: boolean | null,
        advancedIndexation?: boolean | null,
        indexType?: IndexType | null,
        baseYear?: number | null,
        baseIndexType?: BaseIndexType | null,
        baseIndexDate?: string | null,
        nextIndexationMonth?: string | null,
        nextIndexation?: boolean | null,
        leaseId: string,
        mainUnit: boolean,
        rentalPrice: number,
        signatureDate?: string | null,
        startDate: string,
        unitId: string,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    events?:  {
      __typename: "ModelUnitEventConnection",
      items:  Array< {
        __typename: "UnitEvent",
        id: string,
        unitId: string,
        type: UnitEventType,
        startDate: string,
        endDate: string,
        totalCost?: number | null,
        note?: string | null,
        writers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    unitAdvertisementId?: string | null,
    unitInventories?:  {
      __typename: "ModelUnitInventoryConnection",
      items:  Array< {
        __typename: "UnitInventory",
        id: string,
        privateBatthRoom?: boolean | null,
        createdAt?: string | null,
        deletedAt?: string | null,
        kitchenEquipment?: KitchenEquipment | null,
        roomName?: string | null,
        roomType: UnitInventoryRoomType,
        surface?: number | null,
        showSurface?: boolean | null,
        unitId: string,
        inside: boolean,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    readers?: Array< string > | null,
    readId: string,
    clientId: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateUnitEventMutationVariables = {
  input: CreateUnitEventInput,
  condition?: ModelUnitEventConditionInput | null,
};

export type CreateUnitEventMutation = {
  createUnitEvent?:  {
    __typename: "UnitEvent",
    id: string,
    unitId: string,
    type: UnitEventType,
    startDate: string,
    endDate: string,
    totalCost?: number | null,
    note?: string | null,
    writers?: Array< string > | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateUnitEventMutationVariables = {
  input: UpdateUnitEventInput,
  condition?: ModelUnitEventConditionInput | null,
};

export type UpdateUnitEventMutation = {
  updateUnitEvent?:  {
    __typename: "UnitEvent",
    id: string,
    unitId: string,
    type: UnitEventType,
    startDate: string,
    endDate: string,
    totalCost?: number | null,
    note?: string | null,
    writers?: Array< string > | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteUnitEventMutationVariables = {
  input: DeleteUnitEventInput,
  condition?: ModelUnitEventConditionInput | null,
};

export type DeleteUnitEventMutation = {
  deleteUnitEvent?:  {
    __typename: "UnitEvent",
    id: string,
    unitId: string,
    type: UnitEventType,
    startDate: string,
    endDate: string,
    totalCost?: number | null,
    note?: string | null,
    writers?: Array< string > | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateUnitInventoryMutationVariables = {
  input: CreateUnitInventoryInput,
  condition?: ModelUnitInventoryConditionInput | null,
};

export type CreateUnitInventoryMutation = {
  createUnitInventory?:  {
    __typename: "UnitInventory",
    id: string,
    privateBatthRoom?: boolean | null,
    createdAt?: string | null,
    deletedAt?: string | null,
    kitchenEquipment?: KitchenEquipment | null,
    roomName?: string | null,
    roomType: UnitInventoryRoomType,
    surface?: number | null,
    showSurface?: boolean | null,
    unitId: string,
    inside: boolean,
    readId: string,
    clientId: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateUnitInventoryMutationVariables = {
  input: UpdateUnitInventoryInput,
  condition?: ModelUnitInventoryConditionInput | null,
};

export type UpdateUnitInventoryMutation = {
  updateUnitInventory?:  {
    __typename: "UnitInventory",
    id: string,
    privateBatthRoom?: boolean | null,
    createdAt?: string | null,
    deletedAt?: string | null,
    kitchenEquipment?: KitchenEquipment | null,
    roomName?: string | null,
    roomType: UnitInventoryRoomType,
    surface?: number | null,
    showSurface?: boolean | null,
    unitId: string,
    inside: boolean,
    readId: string,
    clientId: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteUnitInventoryMutationVariables = {
  input: DeleteUnitInventoryInput,
  condition?: ModelUnitInventoryConditionInput | null,
};

export type DeleteUnitInventoryMutation = {
  deleteUnitInventory?:  {
    __typename: "UnitInventory",
    id: string,
    privateBatthRoom?: boolean | null,
    createdAt?: string | null,
    deletedAt?: string | null,
    kitchenEquipment?: KitchenEquipment | null,
    roomName?: string | null,
    roomType: UnitInventoryRoomType,
    surface?: number | null,
    showSurface?: boolean | null,
    unitId: string,
    inside: boolean,
    readId: string,
    clientId: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateUnitLeaseMutationVariables = {
  input: CreateUnitLeaseInput,
  condition?: ModelUnitLeaseConditionInput | null,
};

export type CreateUnitLeaseMutation = {
  createUnitLease?:  {
    __typename: "UnitLease",
    id: string,
    allowChargeAdjustment?: boolean | null,
    authorizeProfessionalActivity?: boolean | null,
    chargesIndexation?: boolean | null,
    createdAt?: string | null,
    endDate: string,
    furnishedRental?: boolean | null,
    furnishedRentalInsuranceByTenant?: boolean | null,
    furnishedRentalRentalPricePercentage?: number | null,
    initialRentalPrice: number,
    indexation?: boolean | null,
    advancedIndexation?: boolean | null,
    indexType?: IndexType | null,
    baseYear?: number | null,
    baseIndexType?: BaseIndexType | null,
    baseIndexDate?: string | null,
    nextIndexationMonth?: string | null,
    nextIndexation?: boolean | null,
    leaseId: string,
    mainUnit: boolean,
    rentalPrice: number,
    signatureDate?: string | null,
    startDate: string,
    unitId: string,
    unit?:  {
      __typename: "Unit",
      id: string,
      acquisitionAdditionalCostsValue?: number | null,
      acquisitionAdvertisedValue?: number | null,
      acquisitionValue?: number | null,
      advertisedMonthlyCharges?: number | null,
      advertisedRentalPrice?: number | null,
      cadastralIncome?: number | null,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      floor?: number | null,
      jointOwnershipId?: string | null,
      managementDate: string,
      name: string,
      notes?: string | null,
      predictedPrice?: string | null,
      propertyTax?: number | null,
      publishAddress?: boolean | null,
      surface?: number | null,
      type: UnitType,
      buildingId: string,
      building?:  {
        __typename: "Building",
        id: string,
        name: string,
        addressId?: string | null,
        acquisitionValue?: number | null,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        amountOfFacades?: number | null,
        amountOfFloors?: number | null,
        amountOfHousings?: number | null,
        buildingState?: BuildingState | null,
        cadastralIncome?: number | null,
        constructionYear?: string | null,
        janitor?: boolean | null,
        jointOwnershipId?: string | null,
        notes?: string | null,
        propertyTax?: number | null,
        residenceName?: string | null,
        buildingSiteId?: string | null,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      owners?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leases?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      events?:  {
        __typename: "ModelUnitEventConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      unitAdvertisementId?: string | null,
      unitInventories?:  {
        __typename: "ModelUnitInventoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    lease?:  {
      __typename: "Lease",
      id: string,
      advancedChargesInvoices?:  {
        __typename: "LeaseAdvancedChargesInvoice",
        communicationSettingsProfileId: string,
        invoiceSenderId: string,
        lastDraftInvoiceDate?: string | null,
        lastInvoiceDate?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        bankAccountId?: string | null,
      } | null,
      balance?: number | null,
      canBeExtended?: boolean | null,
      communicationSettingsProfileId: string,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      endDate: string,
      includeRealEstateInLeaseContract?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      invoiceSenderId: string,
      invoiceSender?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      inventoryOfFixturesExpert?: string | null,
      inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
      inventoryOfFixturesType?: InventoryOfFixturesType | null,
      ipiNumber?: string | null,
      language: Language,
      lastDraftInvoiceDate?: string | null,
      lastIndexationProcessDate?: string | null,
      lastInvoiceDate?: string | null,
      legalCompetentAuthority?: string | null,
      name: string,
      notes?: string | null,
      paymentFrequency: LeasePaymentFrequency,
      paymentInvoicePeriod: LeasePaymentInvoicePeriod,
      paymentInvoicePeriodCustomDay?: number | null,
      paymentOption?:  {
        __typename: "LeasePaymentOption",
        customerId?: string | null,
        enabled: boolean,
        mandateActivatedAt?: string | null,
        mandateStatus?: PaymentProviderMandateStatus | null,
        paymentMethodId?: string | null,
        qrType?: LeaseQrType | null,
      } | null,
      purchaseOrderNumber?: string | null,
      realEstateAgency?: string | null,
      realEstateTax?: number | null,
      remittanceInformation?: string | null,
      remittanceInformationType?: LeaseRemittanceType | null,
      rentalGuaranty?:  {
        __typename: "LeaseRentalGuaranty",
        amount: number,
        blockedAmount?: number | null,
        releasedAmount?: number | null,
        type: LeaseRentalGuarantyType,
        financialInstitution?: string | null,
      } | null,
      signatureDate?: string | null,
      startDate: string,
      nextIndexationMonth?: string | null,
      nextIndexation?: boolean | null,
      status: LeaseStatus,
      technicCommunicationSettingsProfileId: string,
      totalInitialRentalPrice: number,
      totalRentalPrice: number,
      type: LeaseType,
      subletting?: boolean | null,
      vatRateRentId?: string | null,
      vatRateRent?:  {
        __typename: "VatRate",
        id: string,
        country: string,
        label: string,
        value?: number | null,
        ownerId?: string | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      additionalClauses?:  {
        __typename: "ModelLeaseAdditionalClauseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      bankAccountId?: string | null,
      bankAccount?:  {
        __typename: "BankAccount",
        id: string,
        contactId: string,
        number: string,
        bicNumber?: string | null,
        bankName?: string | null,
        contactIds?: Array< string > | null,
        buildingIds?: Array< string > | null,
        holderName?: string | null,
        label?: string | null,
        disabled?: boolean | null,
        integrations?: Array< IntegrationName > | null,
        matchingRule?: BankAccountMatchingRule | null,
        balance?: number | null,
        balanceDate?: string | null,
        type: BankAccountType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contacts?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      files?:  {
        __typename: "ModelFileConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leaseActionHistories?:  {
        __typename: "ModelLeaseActionHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leasePriceHistories?:  {
        __typename: "ModelLeasePriceHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      signatureDocuments?:  {
        __typename: "ModelSignatureDocumentConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      variousOperations?:  {
        __typename: "ModelLeaseVariousOperationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    readers?: Array< string > | null,
    readId: string,
    clientId: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateUnitLeaseMutationVariables = {
  input: UpdateUnitLeaseInput,
  condition?: ModelUnitLeaseConditionInput | null,
};

export type UpdateUnitLeaseMutation = {
  updateUnitLease?:  {
    __typename: "UnitLease",
    id: string,
    allowChargeAdjustment?: boolean | null,
    authorizeProfessionalActivity?: boolean | null,
    chargesIndexation?: boolean | null,
    createdAt?: string | null,
    endDate: string,
    furnishedRental?: boolean | null,
    furnishedRentalInsuranceByTenant?: boolean | null,
    furnishedRentalRentalPricePercentage?: number | null,
    initialRentalPrice: number,
    indexation?: boolean | null,
    advancedIndexation?: boolean | null,
    indexType?: IndexType | null,
    baseYear?: number | null,
    baseIndexType?: BaseIndexType | null,
    baseIndexDate?: string | null,
    nextIndexationMonth?: string | null,
    nextIndexation?: boolean | null,
    leaseId: string,
    mainUnit: boolean,
    rentalPrice: number,
    signatureDate?: string | null,
    startDate: string,
    unitId: string,
    unit?:  {
      __typename: "Unit",
      id: string,
      acquisitionAdditionalCostsValue?: number | null,
      acquisitionAdvertisedValue?: number | null,
      acquisitionValue?: number | null,
      advertisedMonthlyCharges?: number | null,
      advertisedRentalPrice?: number | null,
      cadastralIncome?: number | null,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      floor?: number | null,
      jointOwnershipId?: string | null,
      managementDate: string,
      name: string,
      notes?: string | null,
      predictedPrice?: string | null,
      propertyTax?: number | null,
      publishAddress?: boolean | null,
      surface?: number | null,
      type: UnitType,
      buildingId: string,
      building?:  {
        __typename: "Building",
        id: string,
        name: string,
        addressId?: string | null,
        acquisitionValue?: number | null,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        amountOfFacades?: number | null,
        amountOfFloors?: number | null,
        amountOfHousings?: number | null,
        buildingState?: BuildingState | null,
        cadastralIncome?: number | null,
        constructionYear?: string | null,
        janitor?: boolean | null,
        jointOwnershipId?: string | null,
        notes?: string | null,
        propertyTax?: number | null,
        residenceName?: string | null,
        buildingSiteId?: string | null,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      owners?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leases?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      events?:  {
        __typename: "ModelUnitEventConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      unitAdvertisementId?: string | null,
      unitInventories?:  {
        __typename: "ModelUnitInventoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    lease?:  {
      __typename: "Lease",
      id: string,
      advancedChargesInvoices?:  {
        __typename: "LeaseAdvancedChargesInvoice",
        communicationSettingsProfileId: string,
        invoiceSenderId: string,
        lastDraftInvoiceDate?: string | null,
        lastInvoiceDate?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        bankAccountId?: string | null,
      } | null,
      balance?: number | null,
      canBeExtended?: boolean | null,
      communicationSettingsProfileId: string,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      endDate: string,
      includeRealEstateInLeaseContract?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      invoiceSenderId: string,
      invoiceSender?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      inventoryOfFixturesExpert?: string | null,
      inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
      inventoryOfFixturesType?: InventoryOfFixturesType | null,
      ipiNumber?: string | null,
      language: Language,
      lastDraftInvoiceDate?: string | null,
      lastIndexationProcessDate?: string | null,
      lastInvoiceDate?: string | null,
      legalCompetentAuthority?: string | null,
      name: string,
      notes?: string | null,
      paymentFrequency: LeasePaymentFrequency,
      paymentInvoicePeriod: LeasePaymentInvoicePeriod,
      paymentInvoicePeriodCustomDay?: number | null,
      paymentOption?:  {
        __typename: "LeasePaymentOption",
        customerId?: string | null,
        enabled: boolean,
        mandateActivatedAt?: string | null,
        mandateStatus?: PaymentProviderMandateStatus | null,
        paymentMethodId?: string | null,
        qrType?: LeaseQrType | null,
      } | null,
      purchaseOrderNumber?: string | null,
      realEstateAgency?: string | null,
      realEstateTax?: number | null,
      remittanceInformation?: string | null,
      remittanceInformationType?: LeaseRemittanceType | null,
      rentalGuaranty?:  {
        __typename: "LeaseRentalGuaranty",
        amount: number,
        blockedAmount?: number | null,
        releasedAmount?: number | null,
        type: LeaseRentalGuarantyType,
        financialInstitution?: string | null,
      } | null,
      signatureDate?: string | null,
      startDate: string,
      nextIndexationMonth?: string | null,
      nextIndexation?: boolean | null,
      status: LeaseStatus,
      technicCommunicationSettingsProfileId: string,
      totalInitialRentalPrice: number,
      totalRentalPrice: number,
      type: LeaseType,
      subletting?: boolean | null,
      vatRateRentId?: string | null,
      vatRateRent?:  {
        __typename: "VatRate",
        id: string,
        country: string,
        label: string,
        value?: number | null,
        ownerId?: string | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      additionalClauses?:  {
        __typename: "ModelLeaseAdditionalClauseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      bankAccountId?: string | null,
      bankAccount?:  {
        __typename: "BankAccount",
        id: string,
        contactId: string,
        number: string,
        bicNumber?: string | null,
        bankName?: string | null,
        contactIds?: Array< string > | null,
        buildingIds?: Array< string > | null,
        holderName?: string | null,
        label?: string | null,
        disabled?: boolean | null,
        integrations?: Array< IntegrationName > | null,
        matchingRule?: BankAccountMatchingRule | null,
        balance?: number | null,
        balanceDate?: string | null,
        type: BankAccountType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contacts?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      files?:  {
        __typename: "ModelFileConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leaseActionHistories?:  {
        __typename: "ModelLeaseActionHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leasePriceHistories?:  {
        __typename: "ModelLeasePriceHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      signatureDocuments?:  {
        __typename: "ModelSignatureDocumentConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      variousOperations?:  {
        __typename: "ModelLeaseVariousOperationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    readers?: Array< string > | null,
    readId: string,
    clientId: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteUnitLeaseMutationVariables = {
  input: DeleteUnitLeaseInput,
  condition?: ModelUnitLeaseConditionInput | null,
};

export type DeleteUnitLeaseMutation = {
  deleteUnitLease?:  {
    __typename: "UnitLease",
    id: string,
    allowChargeAdjustment?: boolean | null,
    authorizeProfessionalActivity?: boolean | null,
    chargesIndexation?: boolean | null,
    createdAt?: string | null,
    endDate: string,
    furnishedRental?: boolean | null,
    furnishedRentalInsuranceByTenant?: boolean | null,
    furnishedRentalRentalPricePercentage?: number | null,
    initialRentalPrice: number,
    indexation?: boolean | null,
    advancedIndexation?: boolean | null,
    indexType?: IndexType | null,
    baseYear?: number | null,
    baseIndexType?: BaseIndexType | null,
    baseIndexDate?: string | null,
    nextIndexationMonth?: string | null,
    nextIndexation?: boolean | null,
    leaseId: string,
    mainUnit: boolean,
    rentalPrice: number,
    signatureDate?: string | null,
    startDate: string,
    unitId: string,
    unit?:  {
      __typename: "Unit",
      id: string,
      acquisitionAdditionalCostsValue?: number | null,
      acquisitionAdvertisedValue?: number | null,
      acquisitionValue?: number | null,
      advertisedMonthlyCharges?: number | null,
      advertisedRentalPrice?: number | null,
      cadastralIncome?: number | null,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      floor?: number | null,
      jointOwnershipId?: string | null,
      managementDate: string,
      name: string,
      notes?: string | null,
      predictedPrice?: string | null,
      propertyTax?: number | null,
      publishAddress?: boolean | null,
      surface?: number | null,
      type: UnitType,
      buildingId: string,
      building?:  {
        __typename: "Building",
        id: string,
        name: string,
        addressId?: string | null,
        acquisitionValue?: number | null,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        amountOfFacades?: number | null,
        amountOfFloors?: number | null,
        amountOfHousings?: number | null,
        buildingState?: BuildingState | null,
        cadastralIncome?: number | null,
        constructionYear?: string | null,
        janitor?: boolean | null,
        jointOwnershipId?: string | null,
        notes?: string | null,
        propertyTax?: number | null,
        residenceName?: string | null,
        buildingSiteId?: string | null,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      owners?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leases?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      events?:  {
        __typename: "ModelUnitEventConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      unitAdvertisementId?: string | null,
      unitInventories?:  {
        __typename: "ModelUnitInventoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    lease?:  {
      __typename: "Lease",
      id: string,
      advancedChargesInvoices?:  {
        __typename: "LeaseAdvancedChargesInvoice",
        communicationSettingsProfileId: string,
        invoiceSenderId: string,
        lastDraftInvoiceDate?: string | null,
        lastInvoiceDate?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        bankAccountId?: string | null,
      } | null,
      balance?: number | null,
      canBeExtended?: boolean | null,
      communicationSettingsProfileId: string,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      endDate: string,
      includeRealEstateInLeaseContract?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      invoiceSenderId: string,
      invoiceSender?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      inventoryOfFixturesExpert?: string | null,
      inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
      inventoryOfFixturesType?: InventoryOfFixturesType | null,
      ipiNumber?: string | null,
      language: Language,
      lastDraftInvoiceDate?: string | null,
      lastIndexationProcessDate?: string | null,
      lastInvoiceDate?: string | null,
      legalCompetentAuthority?: string | null,
      name: string,
      notes?: string | null,
      paymentFrequency: LeasePaymentFrequency,
      paymentInvoicePeriod: LeasePaymentInvoicePeriod,
      paymentInvoicePeriodCustomDay?: number | null,
      paymentOption?:  {
        __typename: "LeasePaymentOption",
        customerId?: string | null,
        enabled: boolean,
        mandateActivatedAt?: string | null,
        mandateStatus?: PaymentProviderMandateStatus | null,
        paymentMethodId?: string | null,
        qrType?: LeaseQrType | null,
      } | null,
      purchaseOrderNumber?: string | null,
      realEstateAgency?: string | null,
      realEstateTax?: number | null,
      remittanceInformation?: string | null,
      remittanceInformationType?: LeaseRemittanceType | null,
      rentalGuaranty?:  {
        __typename: "LeaseRentalGuaranty",
        amount: number,
        blockedAmount?: number | null,
        releasedAmount?: number | null,
        type: LeaseRentalGuarantyType,
        financialInstitution?: string | null,
      } | null,
      signatureDate?: string | null,
      startDate: string,
      nextIndexationMonth?: string | null,
      nextIndexation?: boolean | null,
      status: LeaseStatus,
      technicCommunicationSettingsProfileId: string,
      totalInitialRentalPrice: number,
      totalRentalPrice: number,
      type: LeaseType,
      subletting?: boolean | null,
      vatRateRentId?: string | null,
      vatRateRent?:  {
        __typename: "VatRate",
        id: string,
        country: string,
        label: string,
        value?: number | null,
        ownerId?: string | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      additionalClauses?:  {
        __typename: "ModelLeaseAdditionalClauseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      bankAccountId?: string | null,
      bankAccount?:  {
        __typename: "BankAccount",
        id: string,
        contactId: string,
        number: string,
        bicNumber?: string | null,
        bankName?: string | null,
        contactIds?: Array< string > | null,
        buildingIds?: Array< string > | null,
        holderName?: string | null,
        label?: string | null,
        disabled?: boolean | null,
        integrations?: Array< IntegrationName > | null,
        matchingRule?: BankAccountMatchingRule | null,
        balance?: number | null,
        balanceDate?: string | null,
        type: BankAccountType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contacts?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      files?:  {
        __typename: "ModelFileConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leaseActionHistories?:  {
        __typename: "ModelLeaseActionHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leasePriceHistories?:  {
        __typename: "ModelLeasePriceHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      signatureDocuments?:  {
        __typename: "ModelSignatureDocumentConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      variousOperations?:  {
        __typename: "ModelLeaseVariousOperationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    readers?: Array< string > | null,
    readId: string,
    clientId: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateUnitOwnerMutationVariables = {
  input: CreateUnitOwnerInput,
  condition?: ModelUnitOwnerConditionInput | null,
};

export type CreateUnitOwnerMutation = {
  createUnitOwner?:  {
    __typename: "UnitOwner",
    id: string,
    disabled?: boolean | null,
    owner?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    ownerId: string,
    periodFrom?: string | null,
    periodTo?: string | null,
    stake: number,
    unit?:  {
      __typename: "Unit",
      id: string,
      acquisitionAdditionalCostsValue?: number | null,
      acquisitionAdvertisedValue?: number | null,
      acquisitionValue?: number | null,
      advertisedMonthlyCharges?: number | null,
      advertisedRentalPrice?: number | null,
      cadastralIncome?: number | null,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      floor?: number | null,
      jointOwnershipId?: string | null,
      managementDate: string,
      name: string,
      notes?: string | null,
      predictedPrice?: string | null,
      propertyTax?: number | null,
      publishAddress?: boolean | null,
      surface?: number | null,
      type: UnitType,
      buildingId: string,
      building?:  {
        __typename: "Building",
        id: string,
        name: string,
        addressId?: string | null,
        acquisitionValue?: number | null,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        amountOfFacades?: number | null,
        amountOfFloors?: number | null,
        amountOfHousings?: number | null,
        buildingState?: BuildingState | null,
        cadastralIncome?: number | null,
        constructionYear?: string | null,
        janitor?: boolean | null,
        jointOwnershipId?: string | null,
        notes?: string | null,
        propertyTax?: number | null,
        residenceName?: string | null,
        buildingSiteId?: string | null,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      owners?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leases?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      events?:  {
        __typename: "ModelUnitEventConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      unitAdvertisementId?: string | null,
      unitInventories?:  {
        __typename: "ModelUnitInventoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    unitId: string,
    readers?: Array< string > | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateUnitOwnerMutationVariables = {
  input: UpdateUnitOwnerInput,
  condition?: ModelUnitOwnerConditionInput | null,
};

export type UpdateUnitOwnerMutation = {
  updateUnitOwner?:  {
    __typename: "UnitOwner",
    id: string,
    disabled?: boolean | null,
    owner?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    ownerId: string,
    periodFrom?: string | null,
    periodTo?: string | null,
    stake: number,
    unit?:  {
      __typename: "Unit",
      id: string,
      acquisitionAdditionalCostsValue?: number | null,
      acquisitionAdvertisedValue?: number | null,
      acquisitionValue?: number | null,
      advertisedMonthlyCharges?: number | null,
      advertisedRentalPrice?: number | null,
      cadastralIncome?: number | null,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      floor?: number | null,
      jointOwnershipId?: string | null,
      managementDate: string,
      name: string,
      notes?: string | null,
      predictedPrice?: string | null,
      propertyTax?: number | null,
      publishAddress?: boolean | null,
      surface?: number | null,
      type: UnitType,
      buildingId: string,
      building?:  {
        __typename: "Building",
        id: string,
        name: string,
        addressId?: string | null,
        acquisitionValue?: number | null,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        amountOfFacades?: number | null,
        amountOfFloors?: number | null,
        amountOfHousings?: number | null,
        buildingState?: BuildingState | null,
        cadastralIncome?: number | null,
        constructionYear?: string | null,
        janitor?: boolean | null,
        jointOwnershipId?: string | null,
        notes?: string | null,
        propertyTax?: number | null,
        residenceName?: string | null,
        buildingSiteId?: string | null,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      owners?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leases?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      events?:  {
        __typename: "ModelUnitEventConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      unitAdvertisementId?: string | null,
      unitInventories?:  {
        __typename: "ModelUnitInventoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    unitId: string,
    readers?: Array< string > | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteUnitOwnerMutationVariables = {
  input: DeleteUnitOwnerInput,
  condition?: ModelUnitOwnerConditionInput | null,
};

export type DeleteUnitOwnerMutation = {
  deleteUnitOwner?:  {
    __typename: "UnitOwner",
    id: string,
    disabled?: boolean | null,
    owner?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    ownerId: string,
    periodFrom?: string | null,
    periodTo?: string | null,
    stake: number,
    unit?:  {
      __typename: "Unit",
      id: string,
      acquisitionAdditionalCostsValue?: number | null,
      acquisitionAdvertisedValue?: number | null,
      acquisitionValue?: number | null,
      advertisedMonthlyCharges?: number | null,
      advertisedRentalPrice?: number | null,
      cadastralIncome?: number | null,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      floor?: number | null,
      jointOwnershipId?: string | null,
      managementDate: string,
      name: string,
      notes?: string | null,
      predictedPrice?: string | null,
      propertyTax?: number | null,
      publishAddress?: boolean | null,
      surface?: number | null,
      type: UnitType,
      buildingId: string,
      building?:  {
        __typename: "Building",
        id: string,
        name: string,
        addressId?: string | null,
        acquisitionValue?: number | null,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        amountOfFacades?: number | null,
        amountOfFloors?: number | null,
        amountOfHousings?: number | null,
        buildingState?: BuildingState | null,
        cadastralIncome?: number | null,
        constructionYear?: string | null,
        janitor?: boolean | null,
        jointOwnershipId?: string | null,
        notes?: string | null,
        propertyTax?: number | null,
        residenceName?: string | null,
        buildingSiteId?: string | null,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      owners?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leases?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      events?:  {
        __typename: "ModelUnitEventConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      unitAdvertisementId?: string | null,
      unitInventories?:  {
        __typename: "ModelUnitInventoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    unitId: string,
    readers?: Array< string > | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateTeamMutationVariables = {
  input: CreateTeamInput,
  condition?: ModelTeamConditionInput | null,
};

export type CreateTeamMutation = {
  createTeam?:  {
    __typename: "Team",
    id: string,
    name: string,
    parentId?: string | null,
    children?:  {
      __typename: "ModelTeamConnection",
      items:  Array< {
        __typename: "Team",
        id: string,
        name: string,
        parentId?: string | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    users?:  {
      __typename: "ModelUserTeamConnection",
      items:  Array< {
        __typename: "UserTeam",
        id: string,
        userId: string,
        teamId: string,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateTeamMutationVariables = {
  input: UpdateTeamInput,
  condition?: ModelTeamConditionInput | null,
};

export type UpdateTeamMutation = {
  updateTeam?:  {
    __typename: "Team",
    id: string,
    name: string,
    parentId?: string | null,
    children?:  {
      __typename: "ModelTeamConnection",
      items:  Array< {
        __typename: "Team",
        id: string,
        name: string,
        parentId?: string | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    users?:  {
      __typename: "ModelUserTeamConnection",
      items:  Array< {
        __typename: "UserTeam",
        id: string,
        userId: string,
        teamId: string,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteTeamMutationVariables = {
  input: DeleteTeamInput,
  condition?: ModelTeamConditionInput | null,
};

export type DeleteTeamMutation = {
  deleteTeam?:  {
    __typename: "Team",
    id: string,
    name: string,
    parentId?: string | null,
    children?:  {
      __typename: "ModelTeamConnection",
      items:  Array< {
        __typename: "Team",
        id: string,
        name: string,
        parentId?: string | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    users?:  {
      __typename: "ModelUserTeamConnection",
      items:  Array< {
        __typename: "UserTeam",
        id: string,
        userId: string,
        teamId: string,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateUserMutationVariables = {
  input: CreateUserInput,
  condition?: ModelUserConditionInput | null,
};

export type CreateUserMutation = {
  createUser?:  {
    __typename: "User",
    id: string,
    email: string,
    firstName?: string | null,
    lastName?: string | null,
    cognitoSub?: string | null,
    googleSub?: string | null,
    facebookSub?: string | null,
    rootUser?: boolean | null,
    refreshToken?: boolean | null,
    teams?:  {
      __typename: "ModelUserTeamConnection",
      items:  Array< {
        __typename: "UserTeam",
        id: string,
        userId: string,
        teamId: string,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    userRoleId?: string | null,
    userRole?:  {
      __typename: "UserRole",
      id: string,
      name: string,
      userRights?:  Array< {
        __typename: "UserRight",
        access?: Array< UserRightAccessType > | null,
        section: UserRightSection,
      } > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    contactId?: string | null,
    contact?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    status: UserStatus,
    readId: string,
    clientId: string,
    _ttl?: number | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateUserMutationVariables = {
  input: UpdateUserInput,
  condition?: ModelUserConditionInput | null,
};

export type UpdateUserMutation = {
  updateUser?:  {
    __typename: "User",
    id: string,
    email: string,
    firstName?: string | null,
    lastName?: string | null,
    cognitoSub?: string | null,
    googleSub?: string | null,
    facebookSub?: string | null,
    rootUser?: boolean | null,
    refreshToken?: boolean | null,
    teams?:  {
      __typename: "ModelUserTeamConnection",
      items:  Array< {
        __typename: "UserTeam",
        id: string,
        userId: string,
        teamId: string,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    userRoleId?: string | null,
    userRole?:  {
      __typename: "UserRole",
      id: string,
      name: string,
      userRights?:  Array< {
        __typename: "UserRight",
        access?: Array< UserRightAccessType > | null,
        section: UserRightSection,
      } > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    contactId?: string | null,
    contact?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    status: UserStatus,
    readId: string,
    clientId: string,
    _ttl?: number | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteUserMutationVariables = {
  input: DeleteUserInput,
  condition?: ModelUserConditionInput | null,
};

export type DeleteUserMutation = {
  deleteUser?:  {
    __typename: "User",
    id: string,
    email: string,
    firstName?: string | null,
    lastName?: string | null,
    cognitoSub?: string | null,
    googleSub?: string | null,
    facebookSub?: string | null,
    rootUser?: boolean | null,
    refreshToken?: boolean | null,
    teams?:  {
      __typename: "ModelUserTeamConnection",
      items:  Array< {
        __typename: "UserTeam",
        id: string,
        userId: string,
        teamId: string,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    userRoleId?: string | null,
    userRole?:  {
      __typename: "UserRole",
      id: string,
      name: string,
      userRights?:  Array< {
        __typename: "UserRight",
        access?: Array< UserRightAccessType > | null,
        section: UserRightSection,
      } > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    contactId?: string | null,
    contact?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    status: UserStatus,
    readId: string,
    clientId: string,
    _ttl?: number | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateUserRoleMutationVariables = {
  input: CreateUserRoleInput,
  condition?: ModelUserRoleConditionInput | null,
};

export type CreateUserRoleMutation = {
  createUserRole?:  {
    __typename: "UserRole",
    id: string,
    name: string,
    userRights?:  Array< {
      __typename: "UserRight",
      access?: Array< UserRightAccessType > | null,
      section: UserRightSection,
    } > | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateUserRoleMutationVariables = {
  input: UpdateUserRoleInput,
  condition?: ModelUserRoleConditionInput | null,
};

export type UpdateUserRoleMutation = {
  updateUserRole?:  {
    __typename: "UserRole",
    id: string,
    name: string,
    userRights?:  Array< {
      __typename: "UserRight",
      access?: Array< UserRightAccessType > | null,
      section: UserRightSection,
    } > | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteUserRoleMutationVariables = {
  input: DeleteUserRoleInput,
  condition?: ModelUserRoleConditionInput | null,
};

export type DeleteUserRoleMutation = {
  deleteUserRole?:  {
    __typename: "UserRole",
    id: string,
    name: string,
    userRights?:  Array< {
      __typename: "UserRight",
      access?: Array< UserRightAccessType > | null,
      section: UserRightSection,
    } > | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateUserTeamMutationVariables = {
  input: CreateUserTeamInput,
  condition?: ModelUserTeamConditionInput | null,
};

export type CreateUserTeamMutation = {
  createUserTeam?:  {
    __typename: "UserTeam",
    id: string,
    userId: string,
    teamId: string,
    team?:  {
      __typename: "Team",
      id: string,
      name: string,
      parentId?: string | null,
      children?:  {
        __typename: "ModelTeamConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      users?:  {
        __typename: "ModelUserTeamConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    user?:  {
      __typename: "User",
      id: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      cognitoSub?: string | null,
      googleSub?: string | null,
      facebookSub?: string | null,
      rootUser?: boolean | null,
      refreshToken?: boolean | null,
      teams?:  {
        __typename: "ModelUserTeamConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      userRoleId?: string | null,
      userRole?:  {
        __typename: "UserRole",
        id: string,
        name: string,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contactId?: string | null,
      contact?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      status: UserStatus,
      readId: string,
      clientId: string,
      _ttl?: number | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateUserTeamMutationVariables = {
  input: UpdateUserTeamInput,
  condition?: ModelUserTeamConditionInput | null,
};

export type UpdateUserTeamMutation = {
  updateUserTeam?:  {
    __typename: "UserTeam",
    id: string,
    userId: string,
    teamId: string,
    team?:  {
      __typename: "Team",
      id: string,
      name: string,
      parentId?: string | null,
      children?:  {
        __typename: "ModelTeamConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      users?:  {
        __typename: "ModelUserTeamConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    user?:  {
      __typename: "User",
      id: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      cognitoSub?: string | null,
      googleSub?: string | null,
      facebookSub?: string | null,
      rootUser?: boolean | null,
      refreshToken?: boolean | null,
      teams?:  {
        __typename: "ModelUserTeamConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      userRoleId?: string | null,
      userRole?:  {
        __typename: "UserRole",
        id: string,
        name: string,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contactId?: string | null,
      contact?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      status: UserStatus,
      readId: string,
      clientId: string,
      _ttl?: number | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteUserTeamMutationVariables = {
  input: DeleteUserTeamInput,
  condition?: ModelUserTeamConditionInput | null,
};

export type DeleteUserTeamMutation = {
  deleteUserTeam?:  {
    __typename: "UserTeam",
    id: string,
    userId: string,
    teamId: string,
    team?:  {
      __typename: "Team",
      id: string,
      name: string,
      parentId?: string | null,
      children?:  {
        __typename: "ModelTeamConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      users?:  {
        __typename: "ModelUserTeamConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    user?:  {
      __typename: "User",
      id: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      cognitoSub?: string | null,
      googleSub?: string | null,
      facebookSub?: string | null,
      rootUser?: boolean | null,
      refreshToken?: boolean | null,
      teams?:  {
        __typename: "ModelUserTeamConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      userRoleId?: string | null,
      userRole?:  {
        __typename: "UserRole",
        id: string,
        name: string,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contactId?: string | null,
      contact?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      status: UserStatus,
      readId: string,
      clientId: string,
      _ttl?: number | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateValuationMutationVariables = {
  input: CreateValuationInput,
  condition?: ModelValuationConditionInput | null,
};

export type CreateValuationMutation = {
  createValuation?:  {
    __typename: "Valuation",
    id: string,
    sourceType?: ValuationSourceType | null,
    valorization: number,
    date: string,
    unitId?: string | null,
    unit?:  {
      __typename: "Unit",
      id: string,
      acquisitionAdditionalCostsValue?: number | null,
      acquisitionAdvertisedValue?: number | null,
      acquisitionValue?: number | null,
      advertisedMonthlyCharges?: number | null,
      advertisedRentalPrice?: number | null,
      cadastralIncome?: number | null,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      floor?: number | null,
      jointOwnershipId?: string | null,
      managementDate: string,
      name: string,
      notes?: string | null,
      predictedPrice?: string | null,
      propertyTax?: number | null,
      publishAddress?: boolean | null,
      surface?: number | null,
      type: UnitType,
      buildingId: string,
      building?:  {
        __typename: "Building",
        id: string,
        name: string,
        addressId?: string | null,
        acquisitionValue?: number | null,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        amountOfFacades?: number | null,
        amountOfFloors?: number | null,
        amountOfHousings?: number | null,
        buildingState?: BuildingState | null,
        cadastralIncome?: number | null,
        constructionYear?: string | null,
        janitor?: boolean | null,
        jointOwnershipId?: string | null,
        notes?: string | null,
        propertyTax?: number | null,
        residenceName?: string | null,
        buildingSiteId?: string | null,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      owners?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leases?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      events?:  {
        __typename: "ModelUnitEventConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      unitAdvertisementId?: string | null,
      unitInventories?:  {
        __typename: "ModelUnitInventoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    buildingId?: string | null,
    building?:  {
      __typename: "Building",
      id: string,
      name: string,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      acquisitionValue?: number | null,
      acquisitionAdditionalCostsValue?: number | null,
      acquisitionAdvertisedValue?: number | null,
      amountOfFacades?: number | null,
      amountOfFloors?: number | null,
      amountOfHousings?: number | null,
      buildingState?: BuildingState | null,
      cadastralIncome?: number | null,
      constructionYear?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      janitor?: boolean | null,
      jointOwnershipId?: string | null,
      notes?: string | null,
      owners?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      propertyTax?: number | null,
      residenceName?: string | null,
      buildingSiteId?: string | null,
      buildingSite?:  {
        __typename: "BuildingSite",
        id: string,
        name: string,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      units?:  {
        __typename: "ModelUnitConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      events?:  {
        __typename: "ModelBuildingEventConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      teams?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    writers?: Array< string > | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateValuationMutationVariables = {
  input: UpdateValuationInput,
  condition?: ModelValuationConditionInput | null,
};

export type UpdateValuationMutation = {
  updateValuation?:  {
    __typename: "Valuation",
    id: string,
    sourceType?: ValuationSourceType | null,
    valorization: number,
    date: string,
    unitId?: string | null,
    unit?:  {
      __typename: "Unit",
      id: string,
      acquisitionAdditionalCostsValue?: number | null,
      acquisitionAdvertisedValue?: number | null,
      acquisitionValue?: number | null,
      advertisedMonthlyCharges?: number | null,
      advertisedRentalPrice?: number | null,
      cadastralIncome?: number | null,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      floor?: number | null,
      jointOwnershipId?: string | null,
      managementDate: string,
      name: string,
      notes?: string | null,
      predictedPrice?: string | null,
      propertyTax?: number | null,
      publishAddress?: boolean | null,
      surface?: number | null,
      type: UnitType,
      buildingId: string,
      building?:  {
        __typename: "Building",
        id: string,
        name: string,
        addressId?: string | null,
        acquisitionValue?: number | null,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        amountOfFacades?: number | null,
        amountOfFloors?: number | null,
        amountOfHousings?: number | null,
        buildingState?: BuildingState | null,
        cadastralIncome?: number | null,
        constructionYear?: string | null,
        janitor?: boolean | null,
        jointOwnershipId?: string | null,
        notes?: string | null,
        propertyTax?: number | null,
        residenceName?: string | null,
        buildingSiteId?: string | null,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      owners?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leases?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      events?:  {
        __typename: "ModelUnitEventConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      unitAdvertisementId?: string | null,
      unitInventories?:  {
        __typename: "ModelUnitInventoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    buildingId?: string | null,
    building?:  {
      __typename: "Building",
      id: string,
      name: string,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      acquisitionValue?: number | null,
      acquisitionAdditionalCostsValue?: number | null,
      acquisitionAdvertisedValue?: number | null,
      amountOfFacades?: number | null,
      amountOfFloors?: number | null,
      amountOfHousings?: number | null,
      buildingState?: BuildingState | null,
      cadastralIncome?: number | null,
      constructionYear?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      janitor?: boolean | null,
      jointOwnershipId?: string | null,
      notes?: string | null,
      owners?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      propertyTax?: number | null,
      residenceName?: string | null,
      buildingSiteId?: string | null,
      buildingSite?:  {
        __typename: "BuildingSite",
        id: string,
        name: string,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      units?:  {
        __typename: "ModelUnitConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      events?:  {
        __typename: "ModelBuildingEventConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      teams?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    writers?: Array< string > | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteValuationMutationVariables = {
  input: DeleteValuationInput,
  condition?: ModelValuationConditionInput | null,
};

export type DeleteValuationMutation = {
  deleteValuation?:  {
    __typename: "Valuation",
    id: string,
    sourceType?: ValuationSourceType | null,
    valorization: number,
    date: string,
    unitId?: string | null,
    unit?:  {
      __typename: "Unit",
      id: string,
      acquisitionAdditionalCostsValue?: number | null,
      acquisitionAdvertisedValue?: number | null,
      acquisitionValue?: number | null,
      advertisedMonthlyCharges?: number | null,
      advertisedRentalPrice?: number | null,
      cadastralIncome?: number | null,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      floor?: number | null,
      jointOwnershipId?: string | null,
      managementDate: string,
      name: string,
      notes?: string | null,
      predictedPrice?: string | null,
      propertyTax?: number | null,
      publishAddress?: boolean | null,
      surface?: number | null,
      type: UnitType,
      buildingId: string,
      building?:  {
        __typename: "Building",
        id: string,
        name: string,
        addressId?: string | null,
        acquisitionValue?: number | null,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        amountOfFacades?: number | null,
        amountOfFloors?: number | null,
        amountOfHousings?: number | null,
        buildingState?: BuildingState | null,
        cadastralIncome?: number | null,
        constructionYear?: string | null,
        janitor?: boolean | null,
        jointOwnershipId?: string | null,
        notes?: string | null,
        propertyTax?: number | null,
        residenceName?: string | null,
        buildingSiteId?: string | null,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      owners?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leases?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      events?:  {
        __typename: "ModelUnitEventConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      unitAdvertisementId?: string | null,
      unitInventories?:  {
        __typename: "ModelUnitInventoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    buildingId?: string | null,
    building?:  {
      __typename: "Building",
      id: string,
      name: string,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      acquisitionValue?: number | null,
      acquisitionAdditionalCostsValue?: number | null,
      acquisitionAdvertisedValue?: number | null,
      amountOfFacades?: number | null,
      amountOfFloors?: number | null,
      amountOfHousings?: number | null,
      buildingState?: BuildingState | null,
      cadastralIncome?: number | null,
      constructionYear?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      janitor?: boolean | null,
      jointOwnershipId?: string | null,
      notes?: string | null,
      owners?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      propertyTax?: number | null,
      residenceName?: string | null,
      buildingSiteId?: string | null,
      buildingSite?:  {
        __typename: "BuildingSite",
        id: string,
        name: string,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      units?:  {
        __typename: "ModelUnitConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      events?:  {
        __typename: "ModelBuildingEventConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      teams?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    writers?: Array< string > | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateVariousOperationMutationVariables = {
  input: CreateVariousOperationInput,
  condition?: ModelVariousOperationConditionInput | null,
};

export type CreateVariousOperationMutation = {
  createVariousOperation?:  {
    __typename: "VariousOperation",
    id: string,
    amount: number,
    labels?:  Array< {
      __typename: "CustomLabel",
      language: string,
      label: string,
    } > | null,
    numberOfMonths?: number | null,
    operationType: LeaseVariousOperationType,
    paymentFrequency: LeasePaymentFrequency,
    type: VariousOperationType,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateVariousOperationMutationVariables = {
  input: UpdateVariousOperationInput,
  condition?: ModelVariousOperationConditionInput | null,
};

export type UpdateVariousOperationMutation = {
  updateVariousOperation?:  {
    __typename: "VariousOperation",
    id: string,
    amount: number,
    labels?:  Array< {
      __typename: "CustomLabel",
      language: string,
      label: string,
    } > | null,
    numberOfMonths?: number | null,
    operationType: LeaseVariousOperationType,
    paymentFrequency: LeasePaymentFrequency,
    type: VariousOperationType,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteVariousOperationMutationVariables = {
  input: DeleteVariousOperationInput,
  condition?: ModelVariousOperationConditionInput | null,
};

export type DeleteVariousOperationMutation = {
  deleteVariousOperation?:  {
    __typename: "VariousOperation",
    id: string,
    amount: number,
    labels?:  Array< {
      __typename: "CustomLabel",
      language: string,
      label: string,
    } > | null,
    numberOfMonths?: number | null,
    operationType: LeaseVariousOperationType,
    paymentFrequency: LeasePaymentFrequency,
    type: VariousOperationType,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type GetAccountLabelQueryVariables = {
  id: string,
};

export type GetAccountLabelQuery = {
  getAccountLabel?:  {
    __typename: "AccountLabel",
    id: string,
    labels?:  Array< {
      __typename: "CustomLabel",
      language: string,
      label: string,
    } > | null,
    bankAccountId?: string | null,
    bankAccount?:  {
      __typename: "BankAccount",
      id: string,
      contactId: string,
      contact?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      number: string,
      bicNumber?: string | null,
      bankName?: string | null,
      contactIds?: Array< string > | null,
      buildingIds?: Array< string > | null,
      holderName?: string | null,
      label?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      disabled?: boolean | null,
      integrations?: Array< IntegrationName > | null,
      matchingRule?: BankAccountMatchingRule | null,
      balance?: number | null,
      balanceDate?: string | null,
      type: BankAccountType,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    contactId?: string | null,
    contact?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    class: number,
    customUsage?: AccountLabelCustomUsage | null,
    customValues?:  Array< {
      __typename: "CustomValue",
      name: string,
      value: string,
    } > | null,
    disabled?: boolean | null,
    ownerId?: string | null,
    owner?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    topClass: number,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListAccountLabelsQueryVariables = {
  filter?: ModelAccountLabelFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListAccountLabelsQuery = {
  listAccountLabels?:  {
    __typename: "ModelAccountLabelConnection",
    items:  Array< {
      __typename: "AccountLabel",
      id: string,
      labels?:  Array< {
        __typename: "CustomLabel",
        language: string,
        label: string,
      } > | null,
      bankAccountId?: string | null,
      bankAccount?:  {
        __typename: "BankAccount",
        id: string,
        contactId: string,
        number: string,
        bicNumber?: string | null,
        bankName?: string | null,
        contactIds?: Array< string > | null,
        buildingIds?: Array< string > | null,
        holderName?: string | null,
        label?: string | null,
        disabled?: boolean | null,
        integrations?: Array< IntegrationName > | null,
        matchingRule?: BankAccountMatchingRule | null,
        balance?: number | null,
        balanceDate?: string | null,
        type: BankAccountType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contactId?: string | null,
      contact?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      class: number,
      customUsage?: AccountLabelCustomUsage | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      disabled?: boolean | null,
      ownerId?: string | null,
      owner?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      topClass: number,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncAccountLabelsQueryVariables = {
  filter?: ModelAccountLabelFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncAccountLabelsQuery = {
  syncAccountLabels?:  {
    __typename: "ModelAccountLabelConnection",
    items:  Array< {
      __typename: "AccountLabel",
      id: string,
      labels?:  Array< {
        __typename: "CustomLabel",
        language: string,
        label: string,
      } > | null,
      bankAccountId?: string | null,
      bankAccount?:  {
        __typename: "BankAccount",
        id: string,
        contactId: string,
        number: string,
        bicNumber?: string | null,
        bankName?: string | null,
        contactIds?: Array< string > | null,
        buildingIds?: Array< string > | null,
        holderName?: string | null,
        label?: string | null,
        disabled?: boolean | null,
        integrations?: Array< IntegrationName > | null,
        matchingRule?: BankAccountMatchingRule | null,
        balance?: number | null,
        balanceDate?: string | null,
        type: BankAccountType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contactId?: string | null,
      contact?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      class: number,
      customUsage?: AccountLabelCustomUsage | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      disabled?: boolean | null,
      ownerId?: string | null,
      owner?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      topClass: number,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetPostingQueryVariables = {
  id: string,
};

export type GetPostingQuery = {
  getPosting?:  {
    __typename: "Posting",
    id: string,
    createdAt?: string | null,
    class: number,
    customLabel?: string | null,
    customValues?:  Array< {
      __typename: "CustomValue",
      name: string,
      value: string,
    } > | null,
    topClass: number,
    type: PostingType,
    totalAmount: number,
    periodFrom: string,
    periodTo: string,
    buildingId?: string | null,
    building?:  {
      __typename: "Building",
      id: string,
      name: string,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      acquisitionValue?: number | null,
      acquisitionAdditionalCostsValue?: number | null,
      acquisitionAdvertisedValue?: number | null,
      amountOfFacades?: number | null,
      amountOfFloors?: number | null,
      amountOfHousings?: number | null,
      buildingState?: BuildingState | null,
      cadastralIncome?: number | null,
      constructionYear?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      janitor?: boolean | null,
      jointOwnershipId?: string | null,
      notes?: string | null,
      owners?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      propertyTax?: number | null,
      residenceName?: string | null,
      buildingSiteId?: string | null,
      buildingSite?:  {
        __typename: "BuildingSite",
        id: string,
        name: string,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      units?:  {
        __typename: "ModelUnitConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      events?:  {
        __typename: "ModelBuildingEventConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      teams?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    unitId?: string | null,
    unit?:  {
      __typename: "Unit",
      id: string,
      acquisitionAdditionalCostsValue?: number | null,
      acquisitionAdvertisedValue?: number | null,
      acquisitionValue?: number | null,
      advertisedMonthlyCharges?: number | null,
      advertisedRentalPrice?: number | null,
      cadastralIncome?: number | null,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      floor?: number | null,
      jointOwnershipId?: string | null,
      managementDate: string,
      name: string,
      notes?: string | null,
      predictedPrice?: string | null,
      propertyTax?: number | null,
      publishAddress?: boolean | null,
      surface?: number | null,
      type: UnitType,
      buildingId: string,
      building?:  {
        __typename: "Building",
        id: string,
        name: string,
        addressId?: string | null,
        acquisitionValue?: number | null,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        amountOfFacades?: number | null,
        amountOfFloors?: number | null,
        amountOfHousings?: number | null,
        buildingState?: BuildingState | null,
        cadastralIncome?: number | null,
        constructionYear?: string | null,
        janitor?: boolean | null,
        jointOwnershipId?: string | null,
        notes?: string | null,
        propertyTax?: number | null,
        residenceName?: string | null,
        buildingSiteId?: string | null,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      owners?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leases?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      events?:  {
        __typename: "ModelUnitEventConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      unitAdvertisementId?: string | null,
      unitInventories?:  {
        __typename: "ModelUnitInventoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    invoiceId?: string | null,
    invoice?:  {
      __typename: "Invoice",
      id: string,
      amount: number,
      bankAccountId: string,
      bankAccount?:  {
        __typename: "BankAccount",
        id: string,
        contactId: string,
        number: string,
        bicNumber?: string | null,
        bankName?: string | null,
        contactIds?: Array< string > | null,
        buildingIds?: Array< string > | null,
        holderName?: string | null,
        label?: string | null,
        disabled?: boolean | null,
        integrations?: Array< IntegrationName > | null,
        matchingRule?: BankAccountMatchingRule | null,
        balance?: number | null,
        balanceDate?: string | null,
        type: BankAccountType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      communicationId?: string | null,
      communication?:  {
        __typename: "Communication",
        id: string,
        addressId?: string | null,
        body: string,
        buildingId?: string | null,
        channel: CommunicationChannel,
        communicationTemplateId?: string | null,
        concernedContactIds?: Array< string > | null,
        contactId?: string | null,
        contactIds?: Array< string > | null,
        createdAt?: string | null,
        expirationDate?: string | null,
        invoiceId?: string | null,
        leaseId?: string | null,
        leasePriceHistoryId?: string | null,
        letterTrackingCode?: string | null,
        letterTrackingProvider?: TrackingProvider | null,
        linkedCommunicationsIds?: Array< string > | null,
        supportingDocumentFileIds?: Array< string > | null,
        recipient?: string | null,
        recipientContactIdsInBcc?: Array< string > | null,
        recipientContactIdsInCc?: Array< string > | null,
        recipientInBcc?: string | null,
        recipientInCc?: string | null,
        scheduledAt?: string | null,
        deliveredAt?: string | null,
        errorCode?: CommunicationErrorCode | null,
        nextRetryAt?: string | null,
        sendRetryCount?: number | null,
        sender?: string | null,
        sentAt?: string | null,
        externalId?: string | null,
        externalStatus?: string | null,
        signatureDocumentId?: string | null,
        snoozedDate?: string | null,
        statementId?: string | null,
        status: CommunicationStatus,
        subject: string,
        toSend: boolean,
        hideLogo?: boolean | null,
        type: CommunicationType,
        _ttl?: number | null,
        unitId?: string | null,
        readId: string,
        readers?: Array< string > | null,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      createdAt: string,
      creditNote?: boolean | null,
      creditNoteLabel?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      dueDate?: string | null,
      invoiceDate: string,
      invoiceNumber?: string | null,
      ownerId?: string | null,
      owner?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      invoiceSenderId: string,
      invoiceSender?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      leaseId?: string | null,
      lease?:  {
        __typename: "Lease",
        id: string,
        balance?: number | null,
        canBeExtended?: boolean | null,
        communicationSettingsProfileId: string,
        createdAt?: string | null,
        endDate: string,
        includeRealEstateInLeaseContract?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        invoiceSenderId: string,
        inventoryOfFixturesExpert?: string | null,
        inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
        inventoryOfFixturesType?: InventoryOfFixturesType | null,
        ipiNumber?: string | null,
        language: Language,
        lastDraftInvoiceDate?: string | null,
        lastIndexationProcessDate?: string | null,
        lastInvoiceDate?: string | null,
        legalCompetentAuthority?: string | null,
        name: string,
        notes?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        purchaseOrderNumber?: string | null,
        realEstateAgency?: string | null,
        realEstateTax?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        signatureDate?: string | null,
        startDate: string,
        nextIndexationMonth?: string | null,
        nextIndexation?: boolean | null,
        status: LeaseStatus,
        technicCommunicationSettingsProfileId: string,
        totalInitialRentalPrice: number,
        totalRentalPrice: number,
        type: LeaseType,
        subletting?: boolean | null,
        vatRateRentId?: string | null,
        bankAccountId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      paid: boolean,
      integrations?:  {
        __typename: "InvoiceIntegrations",
      } | null,
      postedDate?: string | null,
      purchaseOrderNumber?: string | null,
      receiptNumber?: string | null,
      reminderDates?: Array< string > | null,
      note?: string | null,
      remittanceInformation?: string | null,
      statementId?: string | null,
      statement?:  {
        __typename: "Statement",
        id: string,
        closingStatement: boolean,
        periodFrom: string,
        periodTo: string,
        attachSupportingDocuments?: boolean | null,
        selectedPocketKeys?: Array< string > | null,
        source: StatementSource,
        status: StatementStatus,
        sentDate?: string | null,
        leaseId?: string | null,
        ownerId?: string | null,
        types?: Array< StatementType > | null,
        viewType: StatementViewType,
        unitIds?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      status: InvoiceStatus,
      type: InvoiceType,
      unitId?: string | null,
      unit?:  {
        __typename: "Unit",
        id: string,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        acquisitionValue?: number | null,
        advertisedMonthlyCharges?: number | null,
        advertisedRentalPrice?: number | null,
        cadastralIncome?: number | null,
        createdAt?: string | null,
        floor?: number | null,
        jointOwnershipId?: string | null,
        managementDate: string,
        name: string,
        notes?: string | null,
        predictedPrice?: string | null,
        propertyTax?: number | null,
        publishAddress?: boolean | null,
        surface?: number | null,
        type: UnitType,
        buildingId: string,
        unitAdvertisementId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      reversedInvoiceId?: string | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    chargeId?: string | null,
    charge?:  {
      __typename: "Charge",
      id: string,
      status: ChargeStatus,
      invoiceDate?: string | null,
      paymentDueDate?: string | null,
      archivedDate?: string | null,
      periodFrom?: string | null,
      periodTo?: string | null,
      totalAmount?: number | null,
      source: ChargeSource,
      draftFromOcr?: boolean | null,
      accountingDocumentId?: string | null,
      paid: boolean,
      remittanceInformation?: string | null,
      note?: string | null,
      createdAt: string,
      creatorEmail?: string | null,
      createdById?: string | null,
      createdBy?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contractorId?: string | null,
      contractor?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      proposedContractors?:  Array< {
        __typename: "ProposedValue",
        id: string,
        confidence?: number | null,
      } > | null,
      recipientId?: string | null,
      recipient?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      proposedRecipients?:  Array< {
        __typename: "ProposedValue",
        id: string,
        confidence?: number | null,
      } > | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      documentId: string,
      document?:  {
        __typename: "File",
        id: string,
        bucket: string,
        createdAt?: string | null,
        categoryId: string,
        foreignKey: string,
        foreignTableName: string,
        key: string,
        mimeType?: string | null,
        region: string,
        size?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        _ttl?: number | null,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      postings?:  {
        __typename: "ModelPostingConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    transactionId?: string | null,
    transaction?:  {
      __typename: "Transaction",
      id: string,
      status: TransactionStatus,
      sequence?: number | null,
      statementDate: string,
      operationDate?: string | null,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      remittanceInformationType?: RemittanceType | null,
      remittanceInformation?: string | null,
      comment?: string | null,
      amount: number,
      bankAccountId: string,
      bankAccount?:  {
        __typename: "BankAccount",
        id: string,
        contactId: string,
        number: string,
        bicNumber?: string | null,
        bankName?: string | null,
        contactIds?: Array< string > | null,
        buildingIds?: Array< string > | null,
        holderName?: string | null,
        label?: string | null,
        disabled?: boolean | null,
        integrations?: Array< IntegrationName > | null,
        matchingRule?: BankAccountMatchingRule | null,
        balance?: number | null,
        balanceDate?: string | null,
        type: BankAccountType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      counterpartName?: string | null,
      counterpartAccountNumber?: string | null,
      origin: TransactionOrigin,
      proposedLeaseId?: string | null,
      proposedUnitId?: string | null,
      proposedContractorId?: string | null,
      proposedOwnerId?: string | null,
      proposedMatch?: number | null,
      links?:  Array< {
        __typename: "TransactionLink",
        amount: number,
        linkId: string,
        linkType: TransactionLinkType,
      } > | null,
      postings?:  {
        __typename: "ModelPostingConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    leaseId?: string | null,
    lease?:  {
      __typename: "Lease",
      id: string,
      advancedChargesInvoices?:  {
        __typename: "LeaseAdvancedChargesInvoice",
        communicationSettingsProfileId: string,
        invoiceSenderId: string,
        lastDraftInvoiceDate?: string | null,
        lastInvoiceDate?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        bankAccountId?: string | null,
      } | null,
      balance?: number | null,
      canBeExtended?: boolean | null,
      communicationSettingsProfileId: string,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      endDate: string,
      includeRealEstateInLeaseContract?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      invoiceSenderId: string,
      invoiceSender?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      inventoryOfFixturesExpert?: string | null,
      inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
      inventoryOfFixturesType?: InventoryOfFixturesType | null,
      ipiNumber?: string | null,
      language: Language,
      lastDraftInvoiceDate?: string | null,
      lastIndexationProcessDate?: string | null,
      lastInvoiceDate?: string | null,
      legalCompetentAuthority?: string | null,
      name: string,
      notes?: string | null,
      paymentFrequency: LeasePaymentFrequency,
      paymentInvoicePeriod: LeasePaymentInvoicePeriod,
      paymentInvoicePeriodCustomDay?: number | null,
      paymentOption?:  {
        __typename: "LeasePaymentOption",
        customerId?: string | null,
        enabled: boolean,
        mandateActivatedAt?: string | null,
        mandateStatus?: PaymentProviderMandateStatus | null,
        paymentMethodId?: string | null,
        qrType?: LeaseQrType | null,
      } | null,
      purchaseOrderNumber?: string | null,
      realEstateAgency?: string | null,
      realEstateTax?: number | null,
      remittanceInformation?: string | null,
      remittanceInformationType?: LeaseRemittanceType | null,
      rentalGuaranty?:  {
        __typename: "LeaseRentalGuaranty",
        amount: number,
        blockedAmount?: number | null,
        releasedAmount?: number | null,
        type: LeaseRentalGuarantyType,
        financialInstitution?: string | null,
      } | null,
      signatureDate?: string | null,
      startDate: string,
      nextIndexationMonth?: string | null,
      nextIndexation?: boolean | null,
      status: LeaseStatus,
      technicCommunicationSettingsProfileId: string,
      totalInitialRentalPrice: number,
      totalRentalPrice: number,
      type: LeaseType,
      subletting?: boolean | null,
      vatRateRentId?: string | null,
      vatRateRent?:  {
        __typename: "VatRate",
        id: string,
        country: string,
        label: string,
        value?: number | null,
        ownerId?: string | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      additionalClauses?:  {
        __typename: "ModelLeaseAdditionalClauseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      bankAccountId?: string | null,
      bankAccount?:  {
        __typename: "BankAccount",
        id: string,
        contactId: string,
        number: string,
        bicNumber?: string | null,
        bankName?: string | null,
        contactIds?: Array< string > | null,
        buildingIds?: Array< string > | null,
        holderName?: string | null,
        label?: string | null,
        disabled?: boolean | null,
        integrations?: Array< IntegrationName > | null,
        matchingRule?: BankAccountMatchingRule | null,
        balance?: number | null,
        balanceDate?: string | null,
        type: BankAccountType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contacts?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      files?:  {
        __typename: "ModelFileConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leaseActionHistories?:  {
        __typename: "ModelLeaseActionHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leasePriceHistories?:  {
        __typename: "ModelLeasePriceHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      signatureDocuments?:  {
        __typename: "ModelSignatureDocumentConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      variousOperations?:  {
        __typename: "ModelLeaseVariousOperationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    bankAccountId?: string | null,
    bankAccount?:  {
      __typename: "BankAccount",
      id: string,
      contactId: string,
      contact?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      number: string,
      bicNumber?: string | null,
      bankName?: string | null,
      contactIds?: Array< string > | null,
      buildingIds?: Array< string > | null,
      holderName?: string | null,
      label?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      disabled?: boolean | null,
      integrations?: Array< IntegrationName > | null,
      matchingRule?: BankAccountMatchingRule | null,
      balance?: number | null,
      balanceDate?: string | null,
      type: BankAccountType,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    accountLabelId?: string | null,
    accountLabel?:  {
      __typename: "AccountLabel",
      id: string,
      labels?:  Array< {
        __typename: "CustomLabel",
        language: string,
        label: string,
      } > | null,
      bankAccountId?: string | null,
      bankAccount?:  {
        __typename: "BankAccount",
        id: string,
        contactId: string,
        number: string,
        bicNumber?: string | null,
        bankName?: string | null,
        contactIds?: Array< string > | null,
        buildingIds?: Array< string > | null,
        holderName?: string | null,
        label?: string | null,
        disabled?: boolean | null,
        integrations?: Array< IntegrationName > | null,
        matchingRule?: BankAccountMatchingRule | null,
        balance?: number | null,
        balanceDate?: string | null,
        type: BankAccountType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contactId?: string | null,
      contact?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      class: number,
      customUsage?: AccountLabelCustomUsage | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      disabled?: boolean | null,
      ownerId?: string | null,
      owner?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      topClass: number,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    contactId?: string | null,
    contact?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    leaseVariousOperationId?: string | null,
    leaseVariousOperation?:  {
      __typename: "LeaseVariousOperation",
      id: string,
      accountLabelIds?: Array< string > | null,
      amount: number,
      contactId: string,
      createdAt: string,
      createdBy?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      endDate: string,
      invoiceSenderId?: string | null,
      invoiceSender?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      label?: string | null,
      lastInvoiceDate?: string | null,
      leaseId: string,
      lease?:  {
        __typename: "Lease",
        id: string,
        balance?: number | null,
        canBeExtended?: boolean | null,
        communicationSettingsProfileId: string,
        createdAt?: string | null,
        endDate: string,
        includeRealEstateInLeaseContract?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        invoiceSenderId: string,
        inventoryOfFixturesExpert?: string | null,
        inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
        inventoryOfFixturesType?: InventoryOfFixturesType | null,
        ipiNumber?: string | null,
        language: Language,
        lastDraftInvoiceDate?: string | null,
        lastIndexationProcessDate?: string | null,
        lastInvoiceDate?: string | null,
        legalCompetentAuthority?: string | null,
        name: string,
        notes?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        purchaseOrderNumber?: string | null,
        realEstateAgency?: string | null,
        realEstateTax?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        signatureDate?: string | null,
        startDate: string,
        nextIndexationMonth?: string | null,
        nextIndexation?: boolean | null,
        status: LeaseStatus,
        technicCommunicationSettingsProfileId: string,
        totalInitialRentalPrice: number,
        totalRentalPrice: number,
        type: LeaseType,
        subletting?: boolean | null,
        vatRateRentId?: string | null,
        bankAccountId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      leaseVariousOperationHistories?:  Array< {
        __typename: "LeaseVariousOperationHistory",
        periodFrom: string,
        periodTo: string,
        amount: number,
      } > | null,
      operationType: LeaseVariousOperationType,
      paymentFrequency: LeasePaymentFrequency,
      paymentInvoicePeriod: LeasePaymentInvoicePeriod,
      paymentInvoicePeriodCustomDay?: number | null,
      reason?: string | null,
      separateInvoice: boolean,
      startDate: string,
      type: VariousOperationType,
      unit?:  {
        __typename: "Unit",
        id: string,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        acquisitionValue?: number | null,
        advertisedMonthlyCharges?: number | null,
        advertisedRentalPrice?: number | null,
        cadastralIncome?: number | null,
        createdAt?: string | null,
        floor?: number | null,
        jointOwnershipId?: string | null,
        managementDate: string,
        name: string,
        notes?: string | null,
        predictedPrice?: string | null,
        propertyTax?: number | null,
        publishAddress?: boolean | null,
        surface?: number | null,
        type: UnitType,
        buildingId: string,
        unitAdvertisementId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      unitId: string,
      vatRateId?: string | null,
      vatRate?:  {
        __typename: "VatRate",
        id: string,
        country: string,
        label: string,
        value?: number | null,
        ownerId?: string | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      readId: string,
      readers?: Array< string > | null,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    statementId?: string | null,
    amountVatExcluded?: number | null,
    vatAmount?: number | null,
    vatRate?:  {
      __typename: "VatRate",
      id: string,
      country: string,
      label: string,
      value?: number | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      ownerId?: string | null,
      owner?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    vatRateId?: string | null,
    vatRateValue?: number | null,
    foreignId?: string | null,
    foreignType?: PostingForeignType | null,
    invoicePostingId?: string | null,
    reconciledAt?: string | null,
    status?: PostingStatus | null,
    chargeOwnerRepartition?: number | null,
    chargeRepartitionMetric?: string | null,
    chargeRepartitionValue?: number | null,
    chargeSplitNumber?: number | null,
    chargeType?: PostingChargeType | null,
    readers?: Array< string > | null,
    readId: string,
    clientId: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListPostingsQueryVariables = {
  filter?: ModelPostingFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListPostingsQuery = {
  listPostings?:  {
    __typename: "ModelPostingConnection",
    items:  Array< {
      __typename: "Posting",
      id: string,
      createdAt?: string | null,
      class: number,
      customLabel?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      topClass: number,
      type: PostingType,
      totalAmount: number,
      periodFrom: string,
      periodTo: string,
      buildingId?: string | null,
      building?:  {
        __typename: "Building",
        id: string,
        name: string,
        addressId?: string | null,
        acquisitionValue?: number | null,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        amountOfFacades?: number | null,
        amountOfFloors?: number | null,
        amountOfHousings?: number | null,
        buildingState?: BuildingState | null,
        cadastralIncome?: number | null,
        constructionYear?: string | null,
        janitor?: boolean | null,
        jointOwnershipId?: string | null,
        notes?: string | null,
        propertyTax?: number | null,
        residenceName?: string | null,
        buildingSiteId?: string | null,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      unitId?: string | null,
      unit?:  {
        __typename: "Unit",
        id: string,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        acquisitionValue?: number | null,
        advertisedMonthlyCharges?: number | null,
        advertisedRentalPrice?: number | null,
        cadastralIncome?: number | null,
        createdAt?: string | null,
        floor?: number | null,
        jointOwnershipId?: string | null,
        managementDate: string,
        name: string,
        notes?: string | null,
        predictedPrice?: string | null,
        propertyTax?: number | null,
        publishAddress?: boolean | null,
        surface?: number | null,
        type: UnitType,
        buildingId: string,
        unitAdvertisementId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      invoiceId?: string | null,
      invoice?:  {
        __typename: "Invoice",
        id: string,
        amount: number,
        bankAccountId: string,
        communicationId?: string | null,
        createdAt: string,
        creditNote?: boolean | null,
        creditNoteLabel?: string | null,
        dueDate?: string | null,
        invoiceDate: string,
        invoiceNumber?: string | null,
        ownerId?: string | null,
        invoiceSenderId: string,
        leaseId?: string | null,
        paid: boolean,
        postedDate?: string | null,
        purchaseOrderNumber?: string | null,
        receiptNumber?: string | null,
        reminderDates?: Array< string > | null,
        note?: string | null,
        remittanceInformation?: string | null,
        statementId?: string | null,
        status: InvoiceStatus,
        type: InvoiceType,
        unitId?: string | null,
        reversedInvoiceId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      chargeId?: string | null,
      charge?:  {
        __typename: "Charge",
        id: string,
        status: ChargeStatus,
        invoiceDate?: string | null,
        paymentDueDate?: string | null,
        archivedDate?: string | null,
        periodFrom?: string | null,
        periodTo?: string | null,
        totalAmount?: number | null,
        source: ChargeSource,
        draftFromOcr?: boolean | null,
        accountingDocumentId?: string | null,
        paid: boolean,
        remittanceInformation?: string | null,
        note?: string | null,
        createdAt: string,
        creatorEmail?: string | null,
        createdById?: string | null,
        contractorId?: string | null,
        recipientId?: string | null,
        documentId: string,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      transactionId?: string | null,
      transaction?:  {
        __typename: "Transaction",
        id: string,
        status: TransactionStatus,
        sequence?: number | null,
        statementDate: string,
        operationDate?: string | null,
        createdAt?: string | null,
        remittanceInformationType?: RemittanceType | null,
        remittanceInformation?: string | null,
        comment?: string | null,
        amount: number,
        bankAccountId: string,
        counterpartName?: string | null,
        counterpartAccountNumber?: string | null,
        origin: TransactionOrigin,
        proposedLeaseId?: string | null,
        proposedUnitId?: string | null,
        proposedContractorId?: string | null,
        proposedOwnerId?: string | null,
        proposedMatch?: number | null,
        updatedAt: string,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      leaseId?: string | null,
      lease?:  {
        __typename: "Lease",
        id: string,
        balance?: number | null,
        canBeExtended?: boolean | null,
        communicationSettingsProfileId: string,
        createdAt?: string | null,
        endDate: string,
        includeRealEstateInLeaseContract?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        invoiceSenderId: string,
        inventoryOfFixturesExpert?: string | null,
        inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
        inventoryOfFixturesType?: InventoryOfFixturesType | null,
        ipiNumber?: string | null,
        language: Language,
        lastDraftInvoiceDate?: string | null,
        lastIndexationProcessDate?: string | null,
        lastInvoiceDate?: string | null,
        legalCompetentAuthority?: string | null,
        name: string,
        notes?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        purchaseOrderNumber?: string | null,
        realEstateAgency?: string | null,
        realEstateTax?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        signatureDate?: string | null,
        startDate: string,
        nextIndexationMonth?: string | null,
        nextIndexation?: boolean | null,
        status: LeaseStatus,
        technicCommunicationSettingsProfileId: string,
        totalInitialRentalPrice: number,
        totalRentalPrice: number,
        type: LeaseType,
        subletting?: boolean | null,
        vatRateRentId?: string | null,
        bankAccountId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      bankAccountId?: string | null,
      bankAccount?:  {
        __typename: "BankAccount",
        id: string,
        contactId: string,
        number: string,
        bicNumber?: string | null,
        bankName?: string | null,
        contactIds?: Array< string > | null,
        buildingIds?: Array< string > | null,
        holderName?: string | null,
        label?: string | null,
        disabled?: boolean | null,
        integrations?: Array< IntegrationName > | null,
        matchingRule?: BankAccountMatchingRule | null,
        balance?: number | null,
        balanceDate?: string | null,
        type: BankAccountType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      accountLabelId?: string | null,
      accountLabel?:  {
        __typename: "AccountLabel",
        id: string,
        bankAccountId?: string | null,
        contactId?: string | null,
        class: number,
        customUsage?: AccountLabelCustomUsage | null,
        disabled?: boolean | null,
        ownerId?: string | null,
        topClass: number,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contactId?: string | null,
      contact?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      leaseVariousOperationId?: string | null,
      leaseVariousOperation?:  {
        __typename: "LeaseVariousOperation",
        id: string,
        accountLabelIds?: Array< string > | null,
        amount: number,
        contactId: string,
        createdAt: string,
        endDate: string,
        invoiceSenderId?: string | null,
        label?: string | null,
        lastInvoiceDate?: string | null,
        leaseId: string,
        operationType: LeaseVariousOperationType,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        reason?: string | null,
        separateInvoice: boolean,
        startDate: string,
        type: VariousOperationType,
        unitId: string,
        vatRateId?: string | null,
        readId: string,
        readers?: Array< string > | null,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      statementId?: string | null,
      amountVatExcluded?: number | null,
      vatAmount?: number | null,
      vatRate?:  {
        __typename: "VatRate",
        id: string,
        country: string,
        label: string,
        value?: number | null,
        ownerId?: string | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      vatRateId?: string | null,
      vatRateValue?: number | null,
      foreignId?: string | null,
      foreignType?: PostingForeignType | null,
      invoicePostingId?: string | null,
      reconciledAt?: string | null,
      status?: PostingStatus | null,
      chargeOwnerRepartition?: number | null,
      chargeRepartitionMetric?: string | null,
      chargeRepartitionValue?: number | null,
      chargeSplitNumber?: number | null,
      chargeType?: PostingChargeType | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncPostingsQueryVariables = {
  filter?: ModelPostingFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncPostingsQuery = {
  syncPostings?:  {
    __typename: "ModelPostingConnection",
    items:  Array< {
      __typename: "Posting",
      id: string,
      createdAt?: string | null,
      class: number,
      customLabel?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      topClass: number,
      type: PostingType,
      totalAmount: number,
      periodFrom: string,
      periodTo: string,
      buildingId?: string | null,
      building?:  {
        __typename: "Building",
        id: string,
        name: string,
        addressId?: string | null,
        acquisitionValue?: number | null,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        amountOfFacades?: number | null,
        amountOfFloors?: number | null,
        amountOfHousings?: number | null,
        buildingState?: BuildingState | null,
        cadastralIncome?: number | null,
        constructionYear?: string | null,
        janitor?: boolean | null,
        jointOwnershipId?: string | null,
        notes?: string | null,
        propertyTax?: number | null,
        residenceName?: string | null,
        buildingSiteId?: string | null,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      unitId?: string | null,
      unit?:  {
        __typename: "Unit",
        id: string,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        acquisitionValue?: number | null,
        advertisedMonthlyCharges?: number | null,
        advertisedRentalPrice?: number | null,
        cadastralIncome?: number | null,
        createdAt?: string | null,
        floor?: number | null,
        jointOwnershipId?: string | null,
        managementDate: string,
        name: string,
        notes?: string | null,
        predictedPrice?: string | null,
        propertyTax?: number | null,
        publishAddress?: boolean | null,
        surface?: number | null,
        type: UnitType,
        buildingId: string,
        unitAdvertisementId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      invoiceId?: string | null,
      invoice?:  {
        __typename: "Invoice",
        id: string,
        amount: number,
        bankAccountId: string,
        communicationId?: string | null,
        createdAt: string,
        creditNote?: boolean | null,
        creditNoteLabel?: string | null,
        dueDate?: string | null,
        invoiceDate: string,
        invoiceNumber?: string | null,
        ownerId?: string | null,
        invoiceSenderId: string,
        leaseId?: string | null,
        paid: boolean,
        postedDate?: string | null,
        purchaseOrderNumber?: string | null,
        receiptNumber?: string | null,
        reminderDates?: Array< string > | null,
        note?: string | null,
        remittanceInformation?: string | null,
        statementId?: string | null,
        status: InvoiceStatus,
        type: InvoiceType,
        unitId?: string | null,
        reversedInvoiceId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      chargeId?: string | null,
      charge?:  {
        __typename: "Charge",
        id: string,
        status: ChargeStatus,
        invoiceDate?: string | null,
        paymentDueDate?: string | null,
        archivedDate?: string | null,
        periodFrom?: string | null,
        periodTo?: string | null,
        totalAmount?: number | null,
        source: ChargeSource,
        draftFromOcr?: boolean | null,
        accountingDocumentId?: string | null,
        paid: boolean,
        remittanceInformation?: string | null,
        note?: string | null,
        createdAt: string,
        creatorEmail?: string | null,
        createdById?: string | null,
        contractorId?: string | null,
        recipientId?: string | null,
        documentId: string,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      transactionId?: string | null,
      transaction?:  {
        __typename: "Transaction",
        id: string,
        status: TransactionStatus,
        sequence?: number | null,
        statementDate: string,
        operationDate?: string | null,
        createdAt?: string | null,
        remittanceInformationType?: RemittanceType | null,
        remittanceInformation?: string | null,
        comment?: string | null,
        amount: number,
        bankAccountId: string,
        counterpartName?: string | null,
        counterpartAccountNumber?: string | null,
        origin: TransactionOrigin,
        proposedLeaseId?: string | null,
        proposedUnitId?: string | null,
        proposedContractorId?: string | null,
        proposedOwnerId?: string | null,
        proposedMatch?: number | null,
        updatedAt: string,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      leaseId?: string | null,
      lease?:  {
        __typename: "Lease",
        id: string,
        balance?: number | null,
        canBeExtended?: boolean | null,
        communicationSettingsProfileId: string,
        createdAt?: string | null,
        endDate: string,
        includeRealEstateInLeaseContract?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        invoiceSenderId: string,
        inventoryOfFixturesExpert?: string | null,
        inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
        inventoryOfFixturesType?: InventoryOfFixturesType | null,
        ipiNumber?: string | null,
        language: Language,
        lastDraftInvoiceDate?: string | null,
        lastIndexationProcessDate?: string | null,
        lastInvoiceDate?: string | null,
        legalCompetentAuthority?: string | null,
        name: string,
        notes?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        purchaseOrderNumber?: string | null,
        realEstateAgency?: string | null,
        realEstateTax?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        signatureDate?: string | null,
        startDate: string,
        nextIndexationMonth?: string | null,
        nextIndexation?: boolean | null,
        status: LeaseStatus,
        technicCommunicationSettingsProfileId: string,
        totalInitialRentalPrice: number,
        totalRentalPrice: number,
        type: LeaseType,
        subletting?: boolean | null,
        vatRateRentId?: string | null,
        bankAccountId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      bankAccountId?: string | null,
      bankAccount?:  {
        __typename: "BankAccount",
        id: string,
        contactId: string,
        number: string,
        bicNumber?: string | null,
        bankName?: string | null,
        contactIds?: Array< string > | null,
        buildingIds?: Array< string > | null,
        holderName?: string | null,
        label?: string | null,
        disabled?: boolean | null,
        integrations?: Array< IntegrationName > | null,
        matchingRule?: BankAccountMatchingRule | null,
        balance?: number | null,
        balanceDate?: string | null,
        type: BankAccountType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      accountLabelId?: string | null,
      accountLabel?:  {
        __typename: "AccountLabel",
        id: string,
        bankAccountId?: string | null,
        contactId?: string | null,
        class: number,
        customUsage?: AccountLabelCustomUsage | null,
        disabled?: boolean | null,
        ownerId?: string | null,
        topClass: number,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contactId?: string | null,
      contact?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      leaseVariousOperationId?: string | null,
      leaseVariousOperation?:  {
        __typename: "LeaseVariousOperation",
        id: string,
        accountLabelIds?: Array< string > | null,
        amount: number,
        contactId: string,
        createdAt: string,
        endDate: string,
        invoiceSenderId?: string | null,
        label?: string | null,
        lastInvoiceDate?: string | null,
        leaseId: string,
        operationType: LeaseVariousOperationType,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        reason?: string | null,
        separateInvoice: boolean,
        startDate: string,
        type: VariousOperationType,
        unitId: string,
        vatRateId?: string | null,
        readId: string,
        readers?: Array< string > | null,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      statementId?: string | null,
      amountVatExcluded?: number | null,
      vatAmount?: number | null,
      vatRate?:  {
        __typename: "VatRate",
        id: string,
        country: string,
        label: string,
        value?: number | null,
        ownerId?: string | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      vatRateId?: string | null,
      vatRateValue?: number | null,
      foreignId?: string | null,
      foreignType?: PostingForeignType | null,
      invoicePostingId?: string | null,
      reconciledAt?: string | null,
      status?: PostingStatus | null,
      chargeOwnerRepartition?: number | null,
      chargeRepartitionMetric?: string | null,
      chargeRepartitionValue?: number | null,
      chargeSplitNumber?: number | null,
      chargeType?: PostingChargeType | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetBankAccountQueryVariables = {
  id: string,
};

export type GetBankAccountQuery = {
  getBankAccount?:  {
    __typename: "BankAccount",
    id: string,
    contactId: string,
    contact?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    number: string,
    bicNumber?: string | null,
    bankName?: string | null,
    contactIds?: Array< string > | null,
    buildingIds?: Array< string > | null,
    holderName?: string | null,
    label?: string | null,
    customValues?:  Array< {
      __typename: "CustomValue",
      name: string,
      value: string,
    } > | null,
    disabled?: boolean | null,
    integrations?: Array< IntegrationName > | null,
    matchingRule?: BankAccountMatchingRule | null,
    balance?: number | null,
    balanceDate?: string | null,
    type: BankAccountType,
    readers?: Array< string > | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListBankAccountsQueryVariables = {
  filter?: ModelBankAccountFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListBankAccountsQuery = {
  listBankAccounts?:  {
    __typename: "ModelBankAccountConnection",
    items:  Array< {
      __typename: "BankAccount",
      id: string,
      contactId: string,
      contact?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      number: string,
      bicNumber?: string | null,
      bankName?: string | null,
      contactIds?: Array< string > | null,
      buildingIds?: Array< string > | null,
      holderName?: string | null,
      label?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      disabled?: boolean | null,
      integrations?: Array< IntegrationName > | null,
      matchingRule?: BankAccountMatchingRule | null,
      balance?: number | null,
      balanceDate?: string | null,
      type: BankAccountType,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncBankAccountsQueryVariables = {
  filter?: ModelBankAccountFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncBankAccountsQuery = {
  syncBankAccounts?:  {
    __typename: "ModelBankAccountConnection",
    items:  Array< {
      __typename: "BankAccount",
      id: string,
      contactId: string,
      contact?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      number: string,
      bicNumber?: string | null,
      bankName?: string | null,
      contactIds?: Array< string > | null,
      buildingIds?: Array< string > | null,
      holderName?: string | null,
      label?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      disabled?: boolean | null,
      integrations?: Array< IntegrationName > | null,
      matchingRule?: BankAccountMatchingRule | null,
      balance?: number | null,
      balanceDate?: string | null,
      type: BankAccountType,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetTransactionQueryVariables = {
  id: string,
};

export type GetTransactionQuery = {
  getTransaction?:  {
    __typename: "Transaction",
    id: string,
    status: TransactionStatus,
    sequence?: number | null,
    statementDate: string,
    operationDate?: string | null,
    createdAt?: string | null,
    customValues?:  Array< {
      __typename: "CustomValue",
      name: string,
      value: string,
    } > | null,
    remittanceInformationType?: RemittanceType | null,
    remittanceInformation?: string | null,
    comment?: string | null,
    amount: number,
    bankAccountId: string,
    bankAccount?:  {
      __typename: "BankAccount",
      id: string,
      contactId: string,
      contact?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      number: string,
      bicNumber?: string | null,
      bankName?: string | null,
      contactIds?: Array< string > | null,
      buildingIds?: Array< string > | null,
      holderName?: string | null,
      label?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      disabled?: boolean | null,
      integrations?: Array< IntegrationName > | null,
      matchingRule?: BankAccountMatchingRule | null,
      balance?: number | null,
      balanceDate?: string | null,
      type: BankAccountType,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    counterpartName?: string | null,
    counterpartAccountNumber?: string | null,
    origin: TransactionOrigin,
    proposedLeaseId?: string | null,
    proposedUnitId?: string | null,
    proposedContractorId?: string | null,
    proposedOwnerId?: string | null,
    proposedMatch?: number | null,
    links?:  Array< {
      __typename: "TransactionLink",
      amount: number,
      linkId: string,
      linkType: TransactionLinkType,
    } > | null,
    postings?:  {
      __typename: "ModelPostingConnection",
      items:  Array< {
        __typename: "Posting",
        id: string,
        createdAt?: string | null,
        class: number,
        customLabel?: string | null,
        topClass: number,
        type: PostingType,
        totalAmount: number,
        periodFrom: string,
        periodTo: string,
        buildingId?: string | null,
        unitId?: string | null,
        invoiceId?: string | null,
        chargeId?: string | null,
        transactionId?: string | null,
        leaseId?: string | null,
        bankAccountId?: string | null,
        accountLabelId?: string | null,
        contactId?: string | null,
        leaseVariousOperationId?: string | null,
        statementId?: string | null,
        amountVatExcluded?: number | null,
        vatAmount?: number | null,
        vatRateId?: string | null,
        vatRateValue?: number | null,
        foreignId?: string | null,
        foreignType?: PostingForeignType | null,
        invoicePostingId?: string | null,
        reconciledAt?: string | null,
        status?: PostingStatus | null,
        chargeOwnerRepartition?: number | null,
        chargeRepartitionMetric?: string | null,
        chargeRepartitionValue?: number | null,
        chargeSplitNumber?: number | null,
        chargeType?: PostingChargeType | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    updatedAt: string,
    readers?: Array< string > | null,
    readId: string,
    clientId: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListTransactionsQueryVariables = {
  filter?: ModelTransactionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListTransactionsQuery = {
  listTransactions?:  {
    __typename: "ModelTransactionConnection",
    items:  Array< {
      __typename: "Transaction",
      id: string,
      status: TransactionStatus,
      sequence?: number | null,
      statementDate: string,
      operationDate?: string | null,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      remittanceInformationType?: RemittanceType | null,
      remittanceInformation?: string | null,
      comment?: string | null,
      amount: number,
      bankAccountId: string,
      bankAccount?:  {
        __typename: "BankAccount",
        id: string,
        contactId: string,
        number: string,
        bicNumber?: string | null,
        bankName?: string | null,
        contactIds?: Array< string > | null,
        buildingIds?: Array< string > | null,
        holderName?: string | null,
        label?: string | null,
        disabled?: boolean | null,
        integrations?: Array< IntegrationName > | null,
        matchingRule?: BankAccountMatchingRule | null,
        balance?: number | null,
        balanceDate?: string | null,
        type: BankAccountType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      counterpartName?: string | null,
      counterpartAccountNumber?: string | null,
      origin: TransactionOrigin,
      proposedLeaseId?: string | null,
      proposedUnitId?: string | null,
      proposedContractorId?: string | null,
      proposedOwnerId?: string | null,
      proposedMatch?: number | null,
      links?:  Array< {
        __typename: "TransactionLink",
        amount: number,
        linkId: string,
        linkType: TransactionLinkType,
      } > | null,
      postings?:  {
        __typename: "ModelPostingConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncTransactionsQueryVariables = {
  filter?: ModelTransactionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncTransactionsQuery = {
  syncTransactions?:  {
    __typename: "ModelTransactionConnection",
    items:  Array< {
      __typename: "Transaction",
      id: string,
      status: TransactionStatus,
      sequence?: number | null,
      statementDate: string,
      operationDate?: string | null,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      remittanceInformationType?: RemittanceType | null,
      remittanceInformation?: string | null,
      comment?: string | null,
      amount: number,
      bankAccountId: string,
      bankAccount?:  {
        __typename: "BankAccount",
        id: string,
        contactId: string,
        number: string,
        bicNumber?: string | null,
        bankName?: string | null,
        contactIds?: Array< string > | null,
        buildingIds?: Array< string > | null,
        holderName?: string | null,
        label?: string | null,
        disabled?: boolean | null,
        integrations?: Array< IntegrationName > | null,
        matchingRule?: BankAccountMatchingRule | null,
        balance?: number | null,
        balanceDate?: string | null,
        type: BankAccountType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      counterpartName?: string | null,
      counterpartAccountNumber?: string | null,
      origin: TransactionOrigin,
      proposedLeaseId?: string | null,
      proposedUnitId?: string | null,
      proposedContractorId?: string | null,
      proposedOwnerId?: string | null,
      proposedMatch?: number | null,
      links?:  Array< {
        __typename: "TransactionLink",
        amount: number,
        linkId: string,
        linkType: TransactionLinkType,
      } > | null,
      postings?:  {
        __typename: "ModelPostingConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetTransactionRuleQueryVariables = {
  id: string,
};

export type GetTransactionRuleQuery = {
  getTransactionRule?:  {
    __typename: "TransactionRule",
    id: string,
    isFullRemittance?: boolean | null,
    remittanceInformation?: string | null,
    counterpartName?: string | null,
    counterpartAccountNumber?: string | null,
    usedFields: string,
    exclude: boolean,
    leaseId?: string | null,
    lease?:  {
      __typename: "Lease",
      id: string,
      advancedChargesInvoices?:  {
        __typename: "LeaseAdvancedChargesInvoice",
        communicationSettingsProfileId: string,
        invoiceSenderId: string,
        lastDraftInvoiceDate?: string | null,
        lastInvoiceDate?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        bankAccountId?: string | null,
      } | null,
      balance?: number | null,
      canBeExtended?: boolean | null,
      communicationSettingsProfileId: string,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      endDate: string,
      includeRealEstateInLeaseContract?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      invoiceSenderId: string,
      invoiceSender?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      inventoryOfFixturesExpert?: string | null,
      inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
      inventoryOfFixturesType?: InventoryOfFixturesType | null,
      ipiNumber?: string | null,
      language: Language,
      lastDraftInvoiceDate?: string | null,
      lastIndexationProcessDate?: string | null,
      lastInvoiceDate?: string | null,
      legalCompetentAuthority?: string | null,
      name: string,
      notes?: string | null,
      paymentFrequency: LeasePaymentFrequency,
      paymentInvoicePeriod: LeasePaymentInvoicePeriod,
      paymentInvoicePeriodCustomDay?: number | null,
      paymentOption?:  {
        __typename: "LeasePaymentOption",
        customerId?: string | null,
        enabled: boolean,
        mandateActivatedAt?: string | null,
        mandateStatus?: PaymentProviderMandateStatus | null,
        paymentMethodId?: string | null,
        qrType?: LeaseQrType | null,
      } | null,
      purchaseOrderNumber?: string | null,
      realEstateAgency?: string | null,
      realEstateTax?: number | null,
      remittanceInformation?: string | null,
      remittanceInformationType?: LeaseRemittanceType | null,
      rentalGuaranty?:  {
        __typename: "LeaseRentalGuaranty",
        amount: number,
        blockedAmount?: number | null,
        releasedAmount?: number | null,
        type: LeaseRentalGuarantyType,
        financialInstitution?: string | null,
      } | null,
      signatureDate?: string | null,
      startDate: string,
      nextIndexationMonth?: string | null,
      nextIndexation?: boolean | null,
      status: LeaseStatus,
      technicCommunicationSettingsProfileId: string,
      totalInitialRentalPrice: number,
      totalRentalPrice: number,
      type: LeaseType,
      subletting?: boolean | null,
      vatRateRentId?: string | null,
      vatRateRent?:  {
        __typename: "VatRate",
        id: string,
        country: string,
        label: string,
        value?: number | null,
        ownerId?: string | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      additionalClauses?:  {
        __typename: "ModelLeaseAdditionalClauseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      bankAccountId?: string | null,
      bankAccount?:  {
        __typename: "BankAccount",
        id: string,
        contactId: string,
        number: string,
        bicNumber?: string | null,
        bankName?: string | null,
        contactIds?: Array< string > | null,
        buildingIds?: Array< string > | null,
        holderName?: string | null,
        label?: string | null,
        disabled?: boolean | null,
        integrations?: Array< IntegrationName > | null,
        matchingRule?: BankAccountMatchingRule | null,
        balance?: number | null,
        balanceDate?: string | null,
        type: BankAccountType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contacts?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      files?:  {
        __typename: "ModelFileConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leaseActionHistories?:  {
        __typename: "ModelLeaseActionHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leasePriceHistories?:  {
        __typename: "ModelLeasePriceHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      signatureDocuments?:  {
        __typename: "ModelSignatureDocumentConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      variousOperations?:  {
        __typename: "ModelLeaseVariousOperationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    unitId?: string | null,
    unit?:  {
      __typename: "Unit",
      id: string,
      acquisitionAdditionalCostsValue?: number | null,
      acquisitionAdvertisedValue?: number | null,
      acquisitionValue?: number | null,
      advertisedMonthlyCharges?: number | null,
      advertisedRentalPrice?: number | null,
      cadastralIncome?: number | null,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      floor?: number | null,
      jointOwnershipId?: string | null,
      managementDate: string,
      name: string,
      notes?: string | null,
      predictedPrice?: string | null,
      propertyTax?: number | null,
      publishAddress?: boolean | null,
      surface?: number | null,
      type: UnitType,
      buildingId: string,
      building?:  {
        __typename: "Building",
        id: string,
        name: string,
        addressId?: string | null,
        acquisitionValue?: number | null,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        amountOfFacades?: number | null,
        amountOfFloors?: number | null,
        amountOfHousings?: number | null,
        buildingState?: BuildingState | null,
        cadastralIncome?: number | null,
        constructionYear?: string | null,
        janitor?: boolean | null,
        jointOwnershipId?: string | null,
        notes?: string | null,
        propertyTax?: number | null,
        residenceName?: string | null,
        buildingSiteId?: string | null,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      owners?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leases?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      events?:  {
        __typename: "ModelUnitEventConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      unitAdvertisementId?: string | null,
      unitInventories?:  {
        __typename: "ModelUnitInventoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    contractorId?: string | null,
    contractor?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    ownerId?: string | null,
    owner?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListTransactionRulesQueryVariables = {
  filter?: ModelTransactionRuleFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListTransactionRulesQuery = {
  listTransactionRules?:  {
    __typename: "ModelTransactionRuleConnection",
    items:  Array< {
      __typename: "TransactionRule",
      id: string,
      isFullRemittance?: boolean | null,
      remittanceInformation?: string | null,
      counterpartName?: string | null,
      counterpartAccountNumber?: string | null,
      usedFields: string,
      exclude: boolean,
      leaseId?: string | null,
      lease?:  {
        __typename: "Lease",
        id: string,
        balance?: number | null,
        canBeExtended?: boolean | null,
        communicationSettingsProfileId: string,
        createdAt?: string | null,
        endDate: string,
        includeRealEstateInLeaseContract?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        invoiceSenderId: string,
        inventoryOfFixturesExpert?: string | null,
        inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
        inventoryOfFixturesType?: InventoryOfFixturesType | null,
        ipiNumber?: string | null,
        language: Language,
        lastDraftInvoiceDate?: string | null,
        lastIndexationProcessDate?: string | null,
        lastInvoiceDate?: string | null,
        legalCompetentAuthority?: string | null,
        name: string,
        notes?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        purchaseOrderNumber?: string | null,
        realEstateAgency?: string | null,
        realEstateTax?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        signatureDate?: string | null,
        startDate: string,
        nextIndexationMonth?: string | null,
        nextIndexation?: boolean | null,
        status: LeaseStatus,
        technicCommunicationSettingsProfileId: string,
        totalInitialRentalPrice: number,
        totalRentalPrice: number,
        type: LeaseType,
        subletting?: boolean | null,
        vatRateRentId?: string | null,
        bankAccountId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      unitId?: string | null,
      unit?:  {
        __typename: "Unit",
        id: string,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        acquisitionValue?: number | null,
        advertisedMonthlyCharges?: number | null,
        advertisedRentalPrice?: number | null,
        cadastralIncome?: number | null,
        createdAt?: string | null,
        floor?: number | null,
        jointOwnershipId?: string | null,
        managementDate: string,
        name: string,
        notes?: string | null,
        predictedPrice?: string | null,
        propertyTax?: number | null,
        publishAddress?: boolean | null,
        surface?: number | null,
        type: UnitType,
        buildingId: string,
        unitAdvertisementId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contractorId?: string | null,
      contractor?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      ownerId?: string | null,
      owner?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncTransactionRulesQueryVariables = {
  filter?: ModelTransactionRuleFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncTransactionRulesQuery = {
  syncTransactionRules?:  {
    __typename: "ModelTransactionRuleConnection",
    items:  Array< {
      __typename: "TransactionRule",
      id: string,
      isFullRemittance?: boolean | null,
      remittanceInformation?: string | null,
      counterpartName?: string | null,
      counterpartAccountNumber?: string | null,
      usedFields: string,
      exclude: boolean,
      leaseId?: string | null,
      lease?:  {
        __typename: "Lease",
        id: string,
        balance?: number | null,
        canBeExtended?: boolean | null,
        communicationSettingsProfileId: string,
        createdAt?: string | null,
        endDate: string,
        includeRealEstateInLeaseContract?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        invoiceSenderId: string,
        inventoryOfFixturesExpert?: string | null,
        inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
        inventoryOfFixturesType?: InventoryOfFixturesType | null,
        ipiNumber?: string | null,
        language: Language,
        lastDraftInvoiceDate?: string | null,
        lastIndexationProcessDate?: string | null,
        lastInvoiceDate?: string | null,
        legalCompetentAuthority?: string | null,
        name: string,
        notes?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        purchaseOrderNumber?: string | null,
        realEstateAgency?: string | null,
        realEstateTax?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        signatureDate?: string | null,
        startDate: string,
        nextIndexationMonth?: string | null,
        nextIndexation?: boolean | null,
        status: LeaseStatus,
        technicCommunicationSettingsProfileId: string,
        totalInitialRentalPrice: number,
        totalRentalPrice: number,
        type: LeaseType,
        subletting?: boolean | null,
        vatRateRentId?: string | null,
        bankAccountId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      unitId?: string | null,
      unit?:  {
        __typename: "Unit",
        id: string,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        acquisitionValue?: number | null,
        advertisedMonthlyCharges?: number | null,
        advertisedRentalPrice?: number | null,
        cadastralIncome?: number | null,
        createdAt?: string | null,
        floor?: number | null,
        jointOwnershipId?: string | null,
        managementDate: string,
        name: string,
        notes?: string | null,
        predictedPrice?: string | null,
        propertyTax?: number | null,
        publishAddress?: boolean | null,
        surface?: number | null,
        type: UnitType,
        buildingId: string,
        unitAdvertisementId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contractorId?: string | null,
      contractor?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      ownerId?: string | null,
      owner?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetVatRateQueryVariables = {
  id: string,
};

export type GetVatRateQuery = {
  getVatRate?:  {
    __typename: "VatRate",
    id: string,
    country: string,
    label: string,
    value?: number | null,
    customValues?:  Array< {
      __typename: "CustomValue",
      name: string,
      value: string,
    } > | null,
    ownerId?: string | null,
    owner?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListVatRatesQueryVariables = {
  filter?: ModelVatRateFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListVatRatesQuery = {
  listVatRates?:  {
    __typename: "ModelVatRateConnection",
    items:  Array< {
      __typename: "VatRate",
      id: string,
      country: string,
      label: string,
      value?: number | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      ownerId?: string | null,
      owner?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncVatRatesQueryVariables = {
  filter?: ModelVatRateFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncVatRatesQuery = {
  syncVatRates?:  {
    __typename: "ModelVatRateConnection",
    items:  Array< {
      __typename: "VatRate",
      id: string,
      country: string,
      label: string,
      value?: number | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      ownerId?: string | null,
      owner?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetAdvertisementQueryVariables = {
  id: string,
};

export type GetAdvertisementQuery = {
  getAdvertisement?:  {
    __typename: "Advertisement",
    id: string,
    type?: AdvertisementUnitType | null,
    subType?: AdvertisementUnitSubType | null,
    amenities?: Array< AmenitiesType > | null,
    amountOfFacades?: number | null,
    availabilityDate?: string | null,
    certificateOfConformity?: CertificateOfConformityType | null,
    citationForPlanningOffence?: boolean | null,
    descriptions?:  Array< {
      __typename: "AdvertisementDescription",
      language: string,
      description?: string | null,
    } > | null,
    delimitedZone?: DelimitedZoneType | null,
    floodProneArea?: FloodProneAreaType | null,
    furnished?: boolean | null,
    firstOccupancy?: boolean | null,
    gardenSurface?: number | null,
    heatingAmenities?: Array< HeatingAmenities > | null,
    heatingType?: HeatingType | null,
    landTerrain?: Array< LandTerrainType > | null,
    landArea?: number | null,
    length?: number | null,
    nearbyComodities?:  Array< {
      __typename: "NearbyComodity",
      type: NearbyCommoditiesTypes,
      name: string,
      distance: number,
    } > | null,
    publishedPlatforms?:  Array< {
      __typename: "PublishedPlatform",
      name: PublishingPlatform,
      publishedDate: string,
      id: string,
    } > | null,
    planningPermission?: boolean | null,
    publishCadastralIncome?: boolean | null,
    resort?: boolean | null,
    rightOfPreemption?: boolean | null,
    subdivisionAuthorization?: boolean | null,
    wheelChairAccessible?: boolean | null,
    width?: number | null,
    terraceSurface?: number | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListAdvertisementsQueryVariables = {
  filter?: ModelAdvertisementFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListAdvertisementsQuery = {
  listAdvertisements?:  {
    __typename: "ModelAdvertisementConnection",
    items:  Array< {
      __typename: "Advertisement",
      id: string,
      type?: AdvertisementUnitType | null,
      subType?: AdvertisementUnitSubType | null,
      amenities?: Array< AmenitiesType > | null,
      amountOfFacades?: number | null,
      availabilityDate?: string | null,
      certificateOfConformity?: CertificateOfConformityType | null,
      citationForPlanningOffence?: boolean | null,
      descriptions?:  Array< {
        __typename: "AdvertisementDescription",
        language: string,
        description?: string | null,
      } > | null,
      delimitedZone?: DelimitedZoneType | null,
      floodProneArea?: FloodProneAreaType | null,
      furnished?: boolean | null,
      firstOccupancy?: boolean | null,
      gardenSurface?: number | null,
      heatingAmenities?: Array< HeatingAmenities > | null,
      heatingType?: HeatingType | null,
      landTerrain?: Array< LandTerrainType > | null,
      landArea?: number | null,
      length?: number | null,
      nearbyComodities?:  Array< {
        __typename: "NearbyComodity",
        type: NearbyCommoditiesTypes,
        name: string,
        distance: number,
      } > | null,
      publishedPlatforms?:  Array< {
        __typename: "PublishedPlatform",
        name: PublishingPlatform,
        publishedDate: string,
        id: string,
      } > | null,
      planningPermission?: boolean | null,
      publishCadastralIncome?: boolean | null,
      resort?: boolean | null,
      rightOfPreemption?: boolean | null,
      subdivisionAuthorization?: boolean | null,
      wheelChairAccessible?: boolean | null,
      width?: number | null,
      terraceSurface?: number | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncAdvertisementsQueryVariables = {
  filter?: ModelAdvertisementFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncAdvertisementsQuery = {
  syncAdvertisements?:  {
    __typename: "ModelAdvertisementConnection",
    items:  Array< {
      __typename: "Advertisement",
      id: string,
      type?: AdvertisementUnitType | null,
      subType?: AdvertisementUnitSubType | null,
      amenities?: Array< AmenitiesType > | null,
      amountOfFacades?: number | null,
      availabilityDate?: string | null,
      certificateOfConformity?: CertificateOfConformityType | null,
      citationForPlanningOffence?: boolean | null,
      descriptions?:  Array< {
        __typename: "AdvertisementDescription",
        language: string,
        description?: string | null,
      } > | null,
      delimitedZone?: DelimitedZoneType | null,
      floodProneArea?: FloodProneAreaType | null,
      furnished?: boolean | null,
      firstOccupancy?: boolean | null,
      gardenSurface?: number | null,
      heatingAmenities?: Array< HeatingAmenities > | null,
      heatingType?: HeatingType | null,
      landTerrain?: Array< LandTerrainType > | null,
      landArea?: number | null,
      length?: number | null,
      nearbyComodities?:  Array< {
        __typename: "NearbyComodity",
        type: NearbyCommoditiesTypes,
        name: string,
        distance: number,
      } > | null,
      publishedPlatforms?:  Array< {
        __typename: "PublishedPlatform",
        name: PublishingPlatform,
        publishedDate: string,
        id: string,
      } > | null,
      planningPermission?: boolean | null,
      publishCadastralIncome?: boolean | null,
      resort?: boolean | null,
      rightOfPreemption?: boolean | null,
      subdivisionAuthorization?: boolean | null,
      wheelChairAccessible?: boolean | null,
      width?: number | null,
      terraceSurface?: number | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetAgencyRateQueryVariables = {
  id: string,
};

export type GetAgencyRateQuery = {
  getAgencyRate?:  {
    __typename: "AgencyRate",
    id: string,
    amountDetails:  Array< {
      __typename: "AgencyRateAmountDetail",
      amountType: AgencyRateAmountDetailType,
      endAmount?: number | null,
      feeApplied: number,
      startAmount: number,
    } >,
    rateWhenVacant?:  {
      __typename: "AgencyRateWhenVacant",
      amount: number,
      type: AgencyRateAmountDetailType,
    } | null,
    amountMinimumFees?: number | null,
    custom: boolean,
    feesAppliedTo: AgencyRateFeesType,
    includedInAmount?: Array< AgencyRateIncludedAmount > | null,
    name: string,
    owners?:  {
      __typename: "ModelAgencyRateOwnerConnection",
      items:  Array< {
        __typename: "AgencyRateOwner",
        id: string,
        agencyRateId: string,
        contactId: string,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    repartitionType: AgencyRateRepartitionType,
    type: AgencyRateType,
    unitType: Array< UnitType >,
    vatRateId?: string | null,
    unitIds?: Array< string | null > | null,
    vatRate?:  {
      __typename: "VatRate",
      id: string,
      country: string,
      label: string,
      value?: number | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      ownerId?: string | null,
      owner?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListAgencyRatesQueryVariables = {
  filter?: ModelAgencyRateFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListAgencyRatesQuery = {
  listAgencyRates?:  {
    __typename: "ModelAgencyRateConnection",
    items:  Array< {
      __typename: "AgencyRate",
      id: string,
      amountDetails:  Array< {
        __typename: "AgencyRateAmountDetail",
        amountType: AgencyRateAmountDetailType,
        endAmount?: number | null,
        feeApplied: number,
        startAmount: number,
      } >,
      rateWhenVacant?:  {
        __typename: "AgencyRateWhenVacant",
        amount: number,
        type: AgencyRateAmountDetailType,
      } | null,
      amountMinimumFees?: number | null,
      custom: boolean,
      feesAppliedTo: AgencyRateFeesType,
      includedInAmount?: Array< AgencyRateIncludedAmount > | null,
      name: string,
      owners?:  {
        __typename: "ModelAgencyRateOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      repartitionType: AgencyRateRepartitionType,
      type: AgencyRateType,
      unitType: Array< UnitType >,
      vatRateId?: string | null,
      unitIds?: Array< string | null > | null,
      vatRate?:  {
        __typename: "VatRate",
        id: string,
        country: string,
        label: string,
        value?: number | null,
        ownerId?: string | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncAgencyRatesQueryVariables = {
  filter?: ModelAgencyRateFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncAgencyRatesQuery = {
  syncAgencyRates?:  {
    __typename: "ModelAgencyRateConnection",
    items:  Array< {
      __typename: "AgencyRate",
      id: string,
      amountDetails:  Array< {
        __typename: "AgencyRateAmountDetail",
        amountType: AgencyRateAmountDetailType,
        endAmount?: number | null,
        feeApplied: number,
        startAmount: number,
      } >,
      rateWhenVacant?:  {
        __typename: "AgencyRateWhenVacant",
        amount: number,
        type: AgencyRateAmountDetailType,
      } | null,
      amountMinimumFees?: number | null,
      custom: boolean,
      feesAppliedTo: AgencyRateFeesType,
      includedInAmount?: Array< AgencyRateIncludedAmount > | null,
      name: string,
      owners?:  {
        __typename: "ModelAgencyRateOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      repartitionType: AgencyRateRepartitionType,
      type: AgencyRateType,
      unitType: Array< UnitType >,
      vatRateId?: string | null,
      unitIds?: Array< string | null > | null,
      vatRate?:  {
        __typename: "VatRate",
        id: string,
        country: string,
        label: string,
        value?: number | null,
        ownerId?: string | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetAgencyRateOwnerQueryVariables = {
  id: string,
};

export type GetAgencyRateOwnerQuery = {
  getAgencyRateOwner?:  {
    __typename: "AgencyRateOwner",
    id: string,
    agencyRateId: string,
    contactId: string,
    agencyRate?:  {
      __typename: "AgencyRate",
      id: string,
      amountDetails:  Array< {
        __typename: "AgencyRateAmountDetail",
        amountType: AgencyRateAmountDetailType,
        endAmount?: number | null,
        feeApplied: number,
        startAmount: number,
      } >,
      rateWhenVacant?:  {
        __typename: "AgencyRateWhenVacant",
        amount: number,
        type: AgencyRateAmountDetailType,
      } | null,
      amountMinimumFees?: number | null,
      custom: boolean,
      feesAppliedTo: AgencyRateFeesType,
      includedInAmount?: Array< AgencyRateIncludedAmount > | null,
      name: string,
      owners?:  {
        __typename: "ModelAgencyRateOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      repartitionType: AgencyRateRepartitionType,
      type: AgencyRateType,
      unitType: Array< UnitType >,
      vatRateId?: string | null,
      unitIds?: Array< string | null > | null,
      vatRate?:  {
        __typename: "VatRate",
        id: string,
        country: string,
        label: string,
        value?: number | null,
        ownerId?: string | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    owner?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListAgencyRateOwnersQueryVariables = {
  filter?: ModelAgencyRateOwnerFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListAgencyRateOwnersQuery = {
  listAgencyRateOwners?:  {
    __typename: "ModelAgencyRateOwnerConnection",
    items:  Array< {
      __typename: "AgencyRateOwner",
      id: string,
      agencyRateId: string,
      contactId: string,
      agencyRate?:  {
        __typename: "AgencyRate",
        id: string,
        amountMinimumFees?: number | null,
        custom: boolean,
        feesAppliedTo: AgencyRateFeesType,
        includedInAmount?: Array< AgencyRateIncludedAmount > | null,
        name: string,
        repartitionType: AgencyRateRepartitionType,
        type: AgencyRateType,
        unitType: Array< UnitType >,
        vatRateId?: string | null,
        unitIds?: Array< string | null > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      owner?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncAgencyRateOwnersQueryVariables = {
  filter?: ModelAgencyRateOwnerFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncAgencyRateOwnersQuery = {
  syncAgencyRateOwners?:  {
    __typename: "ModelAgencyRateOwnerConnection",
    items:  Array< {
      __typename: "AgencyRateOwner",
      id: string,
      agencyRateId: string,
      contactId: string,
      agencyRate?:  {
        __typename: "AgencyRate",
        id: string,
        amountMinimumFees?: number | null,
        custom: boolean,
        feesAppliedTo: AgencyRateFeesType,
        includedInAmount?: Array< AgencyRateIncludedAmount > | null,
        name: string,
        repartitionType: AgencyRateRepartitionType,
        type: AgencyRateType,
        unitType: Array< UnitType >,
        vatRateId?: string | null,
        unitIds?: Array< string | null > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      owner?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetAgencyRateStatementQueryVariables = {
  id: string,
};

export type GetAgencyRateStatementQuery = {
  getAgencyRateStatement?:  {
    __typename: "AgencyRateStatement",
    id: string,
    agencyRate?:  {
      __typename: "AgencyRate",
      id: string,
      amountDetails:  Array< {
        __typename: "AgencyRateAmountDetail",
        amountType: AgencyRateAmountDetailType,
        endAmount?: number | null,
        feeApplied: number,
        startAmount: number,
      } >,
      rateWhenVacant?:  {
        __typename: "AgencyRateWhenVacant",
        amount: number,
        type: AgencyRateAmountDetailType,
      } | null,
      amountMinimumFees?: number | null,
      custom: boolean,
      feesAppliedTo: AgencyRateFeesType,
      includedInAmount?: Array< AgencyRateIncludedAmount > | null,
      name: string,
      owners?:  {
        __typename: "ModelAgencyRateOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      repartitionType: AgencyRateRepartitionType,
      type: AgencyRateType,
      unitType: Array< UnitType >,
      vatRateId?: string | null,
      unitIds?: Array< string | null > | null,
      vatRate?:  {
        __typename: "VatRate",
        id: string,
        country: string,
        label: string,
        value?: number | null,
        ownerId?: string | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    agencyRateId: string,
    statement?:  {
      __typename: "Statement",
      id: string,
      amounts?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      chargeStatements?:  {
        __typename: "ModelChargeStatementConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      closingStatement: boolean,
      periodFrom: string,
      periodTo: string,
      attachSupportingDocuments?: boolean | null,
      selectedPocketKeys?: Array< string > | null,
      source: StatementSource,
      status: StatementStatus,
      sentDate?: string | null,
      leaseId?: string | null,
      lease?:  {
        __typename: "Lease",
        id: string,
        balance?: number | null,
        canBeExtended?: boolean | null,
        communicationSettingsProfileId: string,
        createdAt?: string | null,
        endDate: string,
        includeRealEstateInLeaseContract?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        invoiceSenderId: string,
        inventoryOfFixturesExpert?: string | null,
        inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
        inventoryOfFixturesType?: InventoryOfFixturesType | null,
        ipiNumber?: string | null,
        language: Language,
        lastDraftInvoiceDate?: string | null,
        lastIndexationProcessDate?: string | null,
        lastInvoiceDate?: string | null,
        legalCompetentAuthority?: string | null,
        name: string,
        notes?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        purchaseOrderNumber?: string | null,
        realEstateAgency?: string | null,
        realEstateTax?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        signatureDate?: string | null,
        startDate: string,
        nextIndexationMonth?: string | null,
        nextIndexation?: boolean | null,
        status: LeaseStatus,
        technicCommunicationSettingsProfileId: string,
        totalInitialRentalPrice: number,
        totalRentalPrice: number,
        type: LeaseType,
        subletting?: boolean | null,
        vatRateRentId?: string | null,
        bankAccountId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      agencyRateStatements?:  {
        __typename: "ModelAgencyRateStatementConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      ownerId?: string | null,
      owner?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      repaymentStatements?:  {
        __typename: "ModelRepaymentStatementConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      types?: Array< StatementType > | null,
      viewType: StatementViewType,
      unitIds?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    statementId: string,
    unitAmounts?:  Array< {
      __typename: "AgencyRateStatementAmount",
      unitId?: string | null,
      amountRateable: number,
      fixedAmount: number,
    } > | null,
    totalAmountRateable: number,
    totalFixedAmount: number,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListAgencyRateStatementsQueryVariables = {
  filter?: ModelAgencyRateStatementFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListAgencyRateStatementsQuery = {
  listAgencyRateStatements?:  {
    __typename: "ModelAgencyRateStatementConnection",
    items:  Array< {
      __typename: "AgencyRateStatement",
      id: string,
      agencyRate?:  {
        __typename: "AgencyRate",
        id: string,
        amountMinimumFees?: number | null,
        custom: boolean,
        feesAppliedTo: AgencyRateFeesType,
        includedInAmount?: Array< AgencyRateIncludedAmount > | null,
        name: string,
        repartitionType: AgencyRateRepartitionType,
        type: AgencyRateType,
        unitType: Array< UnitType >,
        vatRateId?: string | null,
        unitIds?: Array< string | null > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      agencyRateId: string,
      statement?:  {
        __typename: "Statement",
        id: string,
        closingStatement: boolean,
        periodFrom: string,
        periodTo: string,
        attachSupportingDocuments?: boolean | null,
        selectedPocketKeys?: Array< string > | null,
        source: StatementSource,
        status: StatementStatus,
        sentDate?: string | null,
        leaseId?: string | null,
        ownerId?: string | null,
        types?: Array< StatementType > | null,
        viewType: StatementViewType,
        unitIds?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      statementId: string,
      unitAmounts?:  Array< {
        __typename: "AgencyRateStatementAmount",
        unitId?: string | null,
        amountRateable: number,
        fixedAmount: number,
      } > | null,
      totalAmountRateable: number,
      totalFixedAmount: number,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncAgencyRateStatementsQueryVariables = {
  filter?: ModelAgencyRateStatementFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncAgencyRateStatementsQuery = {
  syncAgencyRateStatements?:  {
    __typename: "ModelAgencyRateStatementConnection",
    items:  Array< {
      __typename: "AgencyRateStatement",
      id: string,
      agencyRate?:  {
        __typename: "AgencyRate",
        id: string,
        amountMinimumFees?: number | null,
        custom: boolean,
        feesAppliedTo: AgencyRateFeesType,
        includedInAmount?: Array< AgencyRateIncludedAmount > | null,
        name: string,
        repartitionType: AgencyRateRepartitionType,
        type: AgencyRateType,
        unitType: Array< UnitType >,
        vatRateId?: string | null,
        unitIds?: Array< string | null > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      agencyRateId: string,
      statement?:  {
        __typename: "Statement",
        id: string,
        closingStatement: boolean,
        periodFrom: string,
        periodTo: string,
        attachSupportingDocuments?: boolean | null,
        selectedPocketKeys?: Array< string > | null,
        source: StatementSource,
        status: StatementStatus,
        sentDate?: string | null,
        leaseId?: string | null,
        ownerId?: string | null,
        types?: Array< StatementType > | null,
        viewType: StatementViewType,
        unitIds?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      statementId: string,
      unitAmounts?:  Array< {
        __typename: "AgencyRateStatementAmount",
        unitId?: string | null,
        amountRateable: number,
        fixedAmount: number,
      } > | null,
      totalAmountRateable: number,
      totalFixedAmount: number,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetBillingItemQueryVariables = {
  id: string,
};

export type GetBillingItemQuery = {
  getBillingItem?:  {
    __typename: "BillingItem",
    id: string,
    name: string,
    baseAmount?: number | null,
    billingType?: InvoiceBillingType | null,
    amountCalculationType?: InvoiceAmountCalculationType | null,
    percentageBase?: InvoicePercentageBase | null,
    period?: LeasePaymentFrequency | null,
    vatRateId?: string | null,
    vatRate?:  {
      __typename: "VatRate",
      id: string,
      country: string,
      label: string,
      value?: number | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      ownerId?: string | null,
      owner?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    invoiceId?: string | null,
    quantity?: number | null,
    percentage?: number | null,
    allocationOption: BillingItemAllocationOption,
    multipleUnitsSplit?: BillingItemMultipleUnitsSplitOption | null,
    leaseIds?: Array< string | null > | null,
    unitIds?: Array< string | null > | null,
    buildingIds?: Array< string | null > | null,
    accountLabelId?: string | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListBillingItemsQueryVariables = {
  filter?: ModelBillingItemFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListBillingItemsQuery = {
  listBillingItems?:  {
    __typename: "ModelBillingItemConnection",
    items:  Array< {
      __typename: "BillingItem",
      id: string,
      name: string,
      baseAmount?: number | null,
      billingType?: InvoiceBillingType | null,
      amountCalculationType?: InvoiceAmountCalculationType | null,
      percentageBase?: InvoicePercentageBase | null,
      period?: LeasePaymentFrequency | null,
      vatRateId?: string | null,
      vatRate?:  {
        __typename: "VatRate",
        id: string,
        country: string,
        label: string,
        value?: number | null,
        ownerId?: string | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      invoiceId?: string | null,
      quantity?: number | null,
      percentage?: number | null,
      allocationOption: BillingItemAllocationOption,
      multipleUnitsSplit?: BillingItemMultipleUnitsSplitOption | null,
      leaseIds?: Array< string | null > | null,
      unitIds?: Array< string | null > | null,
      buildingIds?: Array< string | null > | null,
      accountLabelId?: string | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncBillingItemsQueryVariables = {
  filter?: ModelBillingItemFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncBillingItemsQuery = {
  syncBillingItems?:  {
    __typename: "ModelBillingItemConnection",
    items:  Array< {
      __typename: "BillingItem",
      id: string,
      name: string,
      baseAmount?: number | null,
      billingType?: InvoiceBillingType | null,
      amountCalculationType?: InvoiceAmountCalculationType | null,
      percentageBase?: InvoicePercentageBase | null,
      period?: LeasePaymentFrequency | null,
      vatRateId?: string | null,
      vatRate?:  {
        __typename: "VatRate",
        id: string,
        country: string,
        label: string,
        value?: number | null,
        ownerId?: string | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      invoiceId?: string | null,
      quantity?: number | null,
      percentage?: number | null,
      allocationOption: BillingItemAllocationOption,
      multipleUnitsSplit?: BillingItemMultipleUnitsSplitOption | null,
      leaseIds?: Array< string | null > | null,
      unitIds?: Array< string | null > | null,
      buildingIds?: Array< string | null > | null,
      accountLabelId?: string | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetBuildingQueryVariables = {
  id: string,
};

export type GetBuildingQuery = {
  getBuilding?:  {
    __typename: "Building",
    id: string,
    name: string,
    addressId?: string | null,
    address?:  {
      __typename: "Address",
      id: string,
      status?: AddressStatus | null,
      street: string,
      number?: string | null,
      box?: string | null,
      postalCode?: string | null,
      city?: string | null,
      region?: string | null,
      country?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      latitude?: number | null,
      longitude?: number | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    acquisitionValue?: number | null,
    acquisitionAdditionalCostsValue?: number | null,
    acquisitionAdvertisedValue?: number | null,
    amountOfFacades?: number | null,
    amountOfFloors?: number | null,
    amountOfHousings?: number | null,
    buildingState?: BuildingState | null,
    cadastralIncome?: number | null,
    constructionYear?: string | null,
    customValues?:  Array< {
      __typename: "CustomValue",
      name: string,
      value: string,
    } > | null,
    janitor?: boolean | null,
    jointOwnershipId?: string | null,
    notes?: string | null,
    owners?:  {
      __typename: "ModelBuildingOwnerConnection",
      items:  Array< {
        __typename: "BuildingOwner",
        id: string,
        buildingId: string,
        contactId: string,
        disabled?: boolean | null,
        periodFrom?: string | null,
        periodTo?: string | null,
        stake: number,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    propertyTax?: number | null,
    residenceName?: string | null,
    buildingSiteId?: string | null,
    buildingSite?:  {
      __typename: "BuildingSite",
      id: string,
      name: string,
      buildings?:  {
        __typename: "ModelBuildingConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      teams?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    units?:  {
      __typename: "ModelUnitConnection",
      items:  Array< {
        __typename: "Unit",
        id: string,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        acquisitionValue?: number | null,
        advertisedMonthlyCharges?: number | null,
        advertisedRentalPrice?: number | null,
        cadastralIncome?: number | null,
        createdAt?: string | null,
        floor?: number | null,
        jointOwnershipId?: string | null,
        managementDate: string,
        name: string,
        notes?: string | null,
        predictedPrice?: string | null,
        propertyTax?: number | null,
        publishAddress?: boolean | null,
        surface?: number | null,
        type: UnitType,
        buildingId: string,
        unitAdvertisementId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    events?:  {
      __typename: "ModelBuildingEventConnection",
      items:  Array< {
        __typename: "BuildingEvent",
        id: string,
        buildingId: string,
        type: string,
        startDate: string,
        endDate: string,
        totalCost?: number | null,
        note?: string | null,
        writers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    readers?: Array< string > | null,
    teams?: Array< string > | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListBuildingsQueryVariables = {
  filter?: ModelBuildingFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListBuildingsQuery = {
  listBuildings?:  {
    __typename: "ModelBuildingConnection",
    items:  Array< {
      __typename: "Building",
      id: string,
      name: string,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      acquisitionValue?: number | null,
      acquisitionAdditionalCostsValue?: number | null,
      acquisitionAdvertisedValue?: number | null,
      amountOfFacades?: number | null,
      amountOfFloors?: number | null,
      amountOfHousings?: number | null,
      buildingState?: BuildingState | null,
      cadastralIncome?: number | null,
      constructionYear?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      janitor?: boolean | null,
      jointOwnershipId?: string | null,
      notes?: string | null,
      owners?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      propertyTax?: number | null,
      residenceName?: string | null,
      buildingSiteId?: string | null,
      buildingSite?:  {
        __typename: "BuildingSite",
        id: string,
        name: string,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      units?:  {
        __typename: "ModelUnitConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      events?:  {
        __typename: "ModelBuildingEventConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      teams?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncBuildingsQueryVariables = {
  filter?: ModelBuildingFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncBuildingsQuery = {
  syncBuildings?:  {
    __typename: "ModelBuildingConnection",
    items:  Array< {
      __typename: "Building",
      id: string,
      name: string,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      acquisitionValue?: number | null,
      acquisitionAdditionalCostsValue?: number | null,
      acquisitionAdvertisedValue?: number | null,
      amountOfFacades?: number | null,
      amountOfFloors?: number | null,
      amountOfHousings?: number | null,
      buildingState?: BuildingState | null,
      cadastralIncome?: number | null,
      constructionYear?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      janitor?: boolean | null,
      jointOwnershipId?: string | null,
      notes?: string | null,
      owners?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      propertyTax?: number | null,
      residenceName?: string | null,
      buildingSiteId?: string | null,
      buildingSite?:  {
        __typename: "BuildingSite",
        id: string,
        name: string,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      units?:  {
        __typename: "ModelUnitConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      events?:  {
        __typename: "ModelBuildingEventConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      teams?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetBuildingEventQueryVariables = {
  id: string,
};

export type GetBuildingEventQuery = {
  getBuildingEvent?:  {
    __typename: "BuildingEvent",
    id: string,
    buildingId: string,
    type: string,
    startDate: string,
    endDate: string,
    totalCost?: number | null,
    note?: string | null,
    writers?: Array< string > | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListBuildingEventsQueryVariables = {
  filter?: ModelBuildingEventFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListBuildingEventsQuery = {
  listBuildingEvents?:  {
    __typename: "ModelBuildingEventConnection",
    items:  Array< {
      __typename: "BuildingEvent",
      id: string,
      buildingId: string,
      type: string,
      startDate: string,
      endDate: string,
      totalCost?: number | null,
      note?: string | null,
      writers?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncBuildingEventsQueryVariables = {
  filter?: ModelBuildingEventFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncBuildingEventsQuery = {
  syncBuildingEvents?:  {
    __typename: "ModelBuildingEventConnection",
    items:  Array< {
      __typename: "BuildingEvent",
      id: string,
      buildingId: string,
      type: string,
      startDate: string,
      endDate: string,
      totalCost?: number | null,
      note?: string | null,
      writers?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetBuildingOwnerQueryVariables = {
  id: string,
};

export type GetBuildingOwnerQuery = {
  getBuildingOwner?:  {
    __typename: "BuildingOwner",
    id: string,
    buildingId: string,
    building?:  {
      __typename: "Building",
      id: string,
      name: string,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      acquisitionValue?: number | null,
      acquisitionAdditionalCostsValue?: number | null,
      acquisitionAdvertisedValue?: number | null,
      amountOfFacades?: number | null,
      amountOfFloors?: number | null,
      amountOfHousings?: number | null,
      buildingState?: BuildingState | null,
      cadastralIncome?: number | null,
      constructionYear?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      janitor?: boolean | null,
      jointOwnershipId?: string | null,
      notes?: string | null,
      owners?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      propertyTax?: number | null,
      residenceName?: string | null,
      buildingSiteId?: string | null,
      buildingSite?:  {
        __typename: "BuildingSite",
        id: string,
        name: string,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      units?:  {
        __typename: "ModelUnitConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      events?:  {
        __typename: "ModelBuildingEventConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      teams?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    contactId: string,
    disabled?: boolean | null,
    owner?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    periodFrom?: string | null,
    periodTo?: string | null,
    stake: number,
    readers?: Array< string > | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListBuildingOwnersQueryVariables = {
  filter?: ModelBuildingOwnerFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListBuildingOwnersQuery = {
  listBuildingOwners?:  {
    __typename: "ModelBuildingOwnerConnection",
    items:  Array< {
      __typename: "BuildingOwner",
      id: string,
      buildingId: string,
      building?:  {
        __typename: "Building",
        id: string,
        name: string,
        addressId?: string | null,
        acquisitionValue?: number | null,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        amountOfFacades?: number | null,
        amountOfFloors?: number | null,
        amountOfHousings?: number | null,
        buildingState?: BuildingState | null,
        cadastralIncome?: number | null,
        constructionYear?: string | null,
        janitor?: boolean | null,
        jointOwnershipId?: string | null,
        notes?: string | null,
        propertyTax?: number | null,
        residenceName?: string | null,
        buildingSiteId?: string | null,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contactId: string,
      disabled?: boolean | null,
      owner?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      periodFrom?: string | null,
      periodTo?: string | null,
      stake: number,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncBuildingOwnersQueryVariables = {
  filter?: ModelBuildingOwnerFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncBuildingOwnersQuery = {
  syncBuildingOwners?:  {
    __typename: "ModelBuildingOwnerConnection",
    items:  Array< {
      __typename: "BuildingOwner",
      id: string,
      buildingId: string,
      building?:  {
        __typename: "Building",
        id: string,
        name: string,
        addressId?: string | null,
        acquisitionValue?: number | null,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        amountOfFacades?: number | null,
        amountOfFloors?: number | null,
        amountOfHousings?: number | null,
        buildingState?: BuildingState | null,
        cadastralIncome?: number | null,
        constructionYear?: string | null,
        janitor?: boolean | null,
        jointOwnershipId?: string | null,
        notes?: string | null,
        propertyTax?: number | null,
        residenceName?: string | null,
        buildingSiteId?: string | null,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contactId: string,
      disabled?: boolean | null,
      owner?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      periodFrom?: string | null,
      periodTo?: string | null,
      stake: number,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetBuildingSiteQueryVariables = {
  id: string,
};

export type GetBuildingSiteQuery = {
  getBuildingSite?:  {
    __typename: "BuildingSite",
    id: string,
    name: string,
    buildings?:  {
      __typename: "ModelBuildingConnection",
      items:  Array< {
        __typename: "Building",
        id: string,
        name: string,
        addressId?: string | null,
        acquisitionValue?: number | null,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        amountOfFacades?: number | null,
        amountOfFloors?: number | null,
        amountOfHousings?: number | null,
        buildingState?: BuildingState | null,
        cadastralIncome?: number | null,
        constructionYear?: string | null,
        janitor?: boolean | null,
        jointOwnershipId?: string | null,
        notes?: string | null,
        propertyTax?: number | null,
        residenceName?: string | null,
        buildingSiteId?: string | null,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    readers?: Array< string > | null,
    teams?: Array< string > | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListBuildingSitesQueryVariables = {
  filter?: ModelBuildingSiteFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListBuildingSitesQuery = {
  listBuildingSites?:  {
    __typename: "ModelBuildingSiteConnection",
    items:  Array< {
      __typename: "BuildingSite",
      id: string,
      name: string,
      buildings?:  {
        __typename: "ModelBuildingConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      teams?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncBuildingSitesQueryVariables = {
  filter?: ModelBuildingSiteFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncBuildingSitesQuery = {
  syncBuildingSites?:  {
    __typename: "ModelBuildingSiteConnection",
    items:  Array< {
      __typename: "BuildingSite",
      id: string,
      name: string,
      buildings?:  {
        __typename: "ModelBuildingConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      teams?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetChargeQueryVariables = {
  id: string,
};

export type GetChargeQuery = {
  getCharge?:  {
    __typename: "Charge",
    id: string,
    status: ChargeStatus,
    invoiceDate?: string | null,
    paymentDueDate?: string | null,
    archivedDate?: string | null,
    periodFrom?: string | null,
    periodTo?: string | null,
    totalAmount?: number | null,
    source: ChargeSource,
    draftFromOcr?: boolean | null,
    accountingDocumentId?: string | null,
    paid: boolean,
    remittanceInformation?: string | null,
    note?: string | null,
    createdAt: string,
    creatorEmail?: string | null,
    createdById?: string | null,
    createdBy?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    contractorId?: string | null,
    contractor?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    proposedContractors?:  Array< {
      __typename: "ProposedValue",
      id: string,
      confidence?: number | null,
    } > | null,
    recipientId?: string | null,
    recipient?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    proposedRecipients?:  Array< {
      __typename: "ProposedValue",
      id: string,
      confidence?: number | null,
    } > | null,
    customValues?:  Array< {
      __typename: "CustomValue",
      name: string,
      value: string,
    } > | null,
    documentId: string,
    document?:  {
      __typename: "File",
      id: string,
      bucket: string,
      createdAt?: string | null,
      category?:  {
        __typename: "DocumentCategory",
        id: string,
        entity?: string | null,
        fileCategory: FileCategory,
        parentId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      categoryId: string,
      foreignKey: string,
      foreignTableName: string,
      key: string,
      mimeType?: string | null,
      region: string,
      signaturePositions?:  Array< {
        __typename: "SignaturePosition",
        top: number,
        left: number,
        page: number,
        width?: number | null,
        height?: number | null,
        contactId: string,
      } > | null,
      size?: number | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      _ttl?: number | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    postings?:  {
      __typename: "ModelPostingConnection",
      items:  Array< {
        __typename: "Posting",
        id: string,
        createdAt?: string | null,
        class: number,
        customLabel?: string | null,
        topClass: number,
        type: PostingType,
        totalAmount: number,
        periodFrom: string,
        periodTo: string,
        buildingId?: string | null,
        unitId?: string | null,
        invoiceId?: string | null,
        chargeId?: string | null,
        transactionId?: string | null,
        leaseId?: string | null,
        bankAccountId?: string | null,
        accountLabelId?: string | null,
        contactId?: string | null,
        leaseVariousOperationId?: string | null,
        statementId?: string | null,
        amountVatExcluded?: number | null,
        vatAmount?: number | null,
        vatRateId?: string | null,
        vatRateValue?: number | null,
        foreignId?: string | null,
        foreignType?: PostingForeignType | null,
        invoicePostingId?: string | null,
        reconciledAt?: string | null,
        status?: PostingStatus | null,
        chargeOwnerRepartition?: number | null,
        chargeRepartitionMetric?: string | null,
        chargeRepartitionValue?: number | null,
        chargeSplitNumber?: number | null,
        chargeType?: PostingChargeType | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    readId: string,
    clientId: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListChargesQueryVariables = {
  filter?: ModelChargeFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListChargesQuery = {
  listCharges?:  {
    __typename: "ModelChargeConnection",
    items:  Array< {
      __typename: "Charge",
      id: string,
      status: ChargeStatus,
      invoiceDate?: string | null,
      paymentDueDate?: string | null,
      archivedDate?: string | null,
      periodFrom?: string | null,
      periodTo?: string | null,
      totalAmount?: number | null,
      source: ChargeSource,
      draftFromOcr?: boolean | null,
      accountingDocumentId?: string | null,
      paid: boolean,
      remittanceInformation?: string | null,
      note?: string | null,
      createdAt: string,
      creatorEmail?: string | null,
      createdById?: string | null,
      createdBy?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contractorId?: string | null,
      contractor?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      proposedContractors?:  Array< {
        __typename: "ProposedValue",
        id: string,
        confidence?: number | null,
      } > | null,
      recipientId?: string | null,
      recipient?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      proposedRecipients?:  Array< {
        __typename: "ProposedValue",
        id: string,
        confidence?: number | null,
      } > | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      documentId: string,
      document?:  {
        __typename: "File",
        id: string,
        bucket: string,
        createdAt?: string | null,
        categoryId: string,
        foreignKey: string,
        foreignTableName: string,
        key: string,
        mimeType?: string | null,
        region: string,
        size?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        _ttl?: number | null,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      postings?:  {
        __typename: "ModelPostingConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncChargesQueryVariables = {
  filter?: ModelChargeFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncChargesQuery = {
  syncCharges?:  {
    __typename: "ModelChargeConnection",
    items:  Array< {
      __typename: "Charge",
      id: string,
      status: ChargeStatus,
      invoiceDate?: string | null,
      paymentDueDate?: string | null,
      archivedDate?: string | null,
      periodFrom?: string | null,
      periodTo?: string | null,
      totalAmount?: number | null,
      source: ChargeSource,
      draftFromOcr?: boolean | null,
      accountingDocumentId?: string | null,
      paid: boolean,
      remittanceInformation?: string | null,
      note?: string | null,
      createdAt: string,
      creatorEmail?: string | null,
      createdById?: string | null,
      createdBy?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contractorId?: string | null,
      contractor?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      proposedContractors?:  Array< {
        __typename: "ProposedValue",
        id: string,
        confidence?: number | null,
      } > | null,
      recipientId?: string | null,
      recipient?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      proposedRecipients?:  Array< {
        __typename: "ProposedValue",
        id: string,
        confidence?: number | null,
      } > | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      documentId: string,
      document?:  {
        __typename: "File",
        id: string,
        bucket: string,
        createdAt?: string | null,
        categoryId: string,
        foreignKey: string,
        foreignTableName: string,
        key: string,
        mimeType?: string | null,
        region: string,
        size?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        _ttl?: number | null,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      postings?:  {
        __typename: "ModelPostingConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetChargeStatementQueryVariables = {
  id: string,
};

export type GetChargeStatementQuery = {
  getChargeStatement?:  {
    __typename: "ChargeStatement",
    id: string,
    charge?:  {
      __typename: "Charge",
      id: string,
      status: ChargeStatus,
      invoiceDate?: string | null,
      paymentDueDate?: string | null,
      archivedDate?: string | null,
      periodFrom?: string | null,
      periodTo?: string | null,
      totalAmount?: number | null,
      source: ChargeSource,
      draftFromOcr?: boolean | null,
      accountingDocumentId?: string | null,
      paid: boolean,
      remittanceInformation?: string | null,
      note?: string | null,
      createdAt: string,
      creatorEmail?: string | null,
      createdById?: string | null,
      createdBy?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contractorId?: string | null,
      contractor?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      proposedContractors?:  Array< {
        __typename: "ProposedValue",
        id: string,
        confidence?: number | null,
      } > | null,
      recipientId?: string | null,
      recipient?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      proposedRecipients?:  Array< {
        __typename: "ProposedValue",
        id: string,
        confidence?: number | null,
      } > | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      documentId: string,
      document?:  {
        __typename: "File",
        id: string,
        bucket: string,
        createdAt?: string | null,
        categoryId: string,
        foreignKey: string,
        foreignTableName: string,
        key: string,
        mimeType?: string | null,
        region: string,
        size?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        _ttl?: number | null,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      postings?:  {
        __typename: "ModelPostingConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    chargeId: string,
    statement?:  {
      __typename: "Statement",
      id: string,
      amounts?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      chargeStatements?:  {
        __typename: "ModelChargeStatementConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      closingStatement: boolean,
      periodFrom: string,
      periodTo: string,
      attachSupportingDocuments?: boolean | null,
      selectedPocketKeys?: Array< string > | null,
      source: StatementSource,
      status: StatementStatus,
      sentDate?: string | null,
      leaseId?: string | null,
      lease?:  {
        __typename: "Lease",
        id: string,
        balance?: number | null,
        canBeExtended?: boolean | null,
        communicationSettingsProfileId: string,
        createdAt?: string | null,
        endDate: string,
        includeRealEstateInLeaseContract?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        invoiceSenderId: string,
        inventoryOfFixturesExpert?: string | null,
        inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
        inventoryOfFixturesType?: InventoryOfFixturesType | null,
        ipiNumber?: string | null,
        language: Language,
        lastDraftInvoiceDate?: string | null,
        lastIndexationProcessDate?: string | null,
        lastInvoiceDate?: string | null,
        legalCompetentAuthority?: string | null,
        name: string,
        notes?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        purchaseOrderNumber?: string | null,
        realEstateAgency?: string | null,
        realEstateTax?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        signatureDate?: string | null,
        startDate: string,
        nextIndexationMonth?: string | null,
        nextIndexation?: boolean | null,
        status: LeaseStatus,
        technicCommunicationSettingsProfileId: string,
        totalInitialRentalPrice: number,
        totalRentalPrice: number,
        type: LeaseType,
        subletting?: boolean | null,
        vatRateRentId?: string | null,
        bankAccountId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      agencyRateStatements?:  {
        __typename: "ModelAgencyRateStatementConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      ownerId?: string | null,
      owner?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      repaymentStatements?:  {
        __typename: "ModelRepaymentStatementConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      types?: Array< StatementType > | null,
      viewType: StatementViewType,
      unitIds?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    statementId: string,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListChargeStatementsQueryVariables = {
  filter?: ModelChargeStatementFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListChargeStatementsQuery = {
  listChargeStatements?:  {
    __typename: "ModelChargeStatementConnection",
    items:  Array< {
      __typename: "ChargeStatement",
      id: string,
      charge?:  {
        __typename: "Charge",
        id: string,
        status: ChargeStatus,
        invoiceDate?: string | null,
        paymentDueDate?: string | null,
        archivedDate?: string | null,
        periodFrom?: string | null,
        periodTo?: string | null,
        totalAmount?: number | null,
        source: ChargeSource,
        draftFromOcr?: boolean | null,
        accountingDocumentId?: string | null,
        paid: boolean,
        remittanceInformation?: string | null,
        note?: string | null,
        createdAt: string,
        creatorEmail?: string | null,
        createdById?: string | null,
        contractorId?: string | null,
        recipientId?: string | null,
        documentId: string,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      chargeId: string,
      statement?:  {
        __typename: "Statement",
        id: string,
        closingStatement: boolean,
        periodFrom: string,
        periodTo: string,
        attachSupportingDocuments?: boolean | null,
        selectedPocketKeys?: Array< string > | null,
        source: StatementSource,
        status: StatementStatus,
        sentDate?: string | null,
        leaseId?: string | null,
        ownerId?: string | null,
        types?: Array< StatementType > | null,
        viewType: StatementViewType,
        unitIds?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      statementId: string,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncChargeStatementsQueryVariables = {
  filter?: ModelChargeStatementFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncChargeStatementsQuery = {
  syncChargeStatements?:  {
    __typename: "ModelChargeStatementConnection",
    items:  Array< {
      __typename: "ChargeStatement",
      id: string,
      charge?:  {
        __typename: "Charge",
        id: string,
        status: ChargeStatus,
        invoiceDate?: string | null,
        paymentDueDate?: string | null,
        archivedDate?: string | null,
        periodFrom?: string | null,
        periodTo?: string | null,
        totalAmount?: number | null,
        source: ChargeSource,
        draftFromOcr?: boolean | null,
        accountingDocumentId?: string | null,
        paid: boolean,
        remittanceInformation?: string | null,
        note?: string | null,
        createdAt: string,
        creatorEmail?: string | null,
        createdById?: string | null,
        contractorId?: string | null,
        recipientId?: string | null,
        documentId: string,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      chargeId: string,
      statement?:  {
        __typename: "Statement",
        id: string,
        closingStatement: boolean,
        periodFrom: string,
        periodTo: string,
        attachSupportingDocuments?: boolean | null,
        selectedPocketKeys?: Array< string > | null,
        source: StatementSource,
        status: StatementStatus,
        sentDate?: string | null,
        leaseId?: string | null,
        ownerId?: string | null,
        types?: Array< StatementType > | null,
        viewType: StatementViewType,
        unitIds?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      statementId: string,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetRepartitionKeyQueryVariables = {
  id: string,
};

export type GetRepartitionKeyQuery = {
  getRepartitionKey?:  {
    __typename: "RepartitionKey",
    id: string,
    name: string,
    type: RepartitionKeyType,
    accountLabelId?: string | null,
    accountLabel?:  {
      __typename: "AccountLabel",
      id: string,
      labels?:  Array< {
        __typename: "CustomLabel",
        language: string,
        label: string,
      } > | null,
      bankAccountId?: string | null,
      bankAccount?:  {
        __typename: "BankAccount",
        id: string,
        contactId: string,
        number: string,
        bicNumber?: string | null,
        bankName?: string | null,
        contactIds?: Array< string > | null,
        buildingIds?: Array< string > | null,
        holderName?: string | null,
        label?: string | null,
        disabled?: boolean | null,
        integrations?: Array< IntegrationName > | null,
        matchingRule?: BankAccountMatchingRule | null,
        balance?: number | null,
        balanceDate?: string | null,
        type: BankAccountType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contactId?: string | null,
      contact?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      class: number,
      customUsage?: AccountLabelCustomUsage | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      disabled?: boolean | null,
      ownerId?: string | null,
      owner?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      topClass: number,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    buildingId?: string | null,
    building?:  {
      __typename: "Building",
      id: string,
      name: string,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      acquisitionValue?: number | null,
      acquisitionAdditionalCostsValue?: number | null,
      acquisitionAdvertisedValue?: number | null,
      amountOfFacades?: number | null,
      amountOfFloors?: number | null,
      amountOfHousings?: number | null,
      buildingState?: BuildingState | null,
      cadastralIncome?: number | null,
      constructionYear?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      janitor?: boolean | null,
      jointOwnershipId?: string | null,
      notes?: string | null,
      owners?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      propertyTax?: number | null,
      residenceName?: string | null,
      buildingSiteId?: string | null,
      buildingSite?:  {
        __typename: "BuildingSite",
        id: string,
        name: string,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      units?:  {
        __typename: "ModelUnitConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      events?:  {
        __typename: "ModelBuildingEventConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      teams?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    buildingSiteId?: string | null,
    buildingSite?:  {
      __typename: "BuildingSite",
      id: string,
      name: string,
      buildings?:  {
        __typename: "ModelBuildingConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      teams?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    unitRepartition?:  Array< {
      __typename: "RepartitionValues",
      unitId: string,
      value: number,
    } > | null,
    ownerRepartition: number,
    tenantRepartition: number,
    repartitionMetric: string,
    technics?: Array< string > | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListRepartitionKeysQueryVariables = {
  filter?: ModelRepartitionKeyFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListRepartitionKeysQuery = {
  listRepartitionKeys?:  {
    __typename: "ModelRepartitionKeyConnection",
    items:  Array< {
      __typename: "RepartitionKey",
      id: string,
      name: string,
      type: RepartitionKeyType,
      accountLabelId?: string | null,
      accountLabel?:  {
        __typename: "AccountLabel",
        id: string,
        bankAccountId?: string | null,
        contactId?: string | null,
        class: number,
        customUsage?: AccountLabelCustomUsage | null,
        disabled?: boolean | null,
        ownerId?: string | null,
        topClass: number,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      buildingId?: string | null,
      building?:  {
        __typename: "Building",
        id: string,
        name: string,
        addressId?: string | null,
        acquisitionValue?: number | null,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        amountOfFacades?: number | null,
        amountOfFloors?: number | null,
        amountOfHousings?: number | null,
        buildingState?: BuildingState | null,
        cadastralIncome?: number | null,
        constructionYear?: string | null,
        janitor?: boolean | null,
        jointOwnershipId?: string | null,
        notes?: string | null,
        propertyTax?: number | null,
        residenceName?: string | null,
        buildingSiteId?: string | null,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      buildingSiteId?: string | null,
      buildingSite?:  {
        __typename: "BuildingSite",
        id: string,
        name: string,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      unitRepartition?:  Array< {
        __typename: "RepartitionValues",
        unitId: string,
        value: number,
      } > | null,
      ownerRepartition: number,
      tenantRepartition: number,
      repartitionMetric: string,
      technics?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncRepartitionKeysQueryVariables = {
  filter?: ModelRepartitionKeyFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncRepartitionKeysQuery = {
  syncRepartitionKeys?:  {
    __typename: "ModelRepartitionKeyConnection",
    items:  Array< {
      __typename: "RepartitionKey",
      id: string,
      name: string,
      type: RepartitionKeyType,
      accountLabelId?: string | null,
      accountLabel?:  {
        __typename: "AccountLabel",
        id: string,
        bankAccountId?: string | null,
        contactId?: string | null,
        class: number,
        customUsage?: AccountLabelCustomUsage | null,
        disabled?: boolean | null,
        ownerId?: string | null,
        topClass: number,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      buildingId?: string | null,
      building?:  {
        __typename: "Building",
        id: string,
        name: string,
        addressId?: string | null,
        acquisitionValue?: number | null,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        amountOfFacades?: number | null,
        amountOfFloors?: number | null,
        amountOfHousings?: number | null,
        buildingState?: BuildingState | null,
        cadastralIncome?: number | null,
        constructionYear?: string | null,
        janitor?: boolean | null,
        jointOwnershipId?: string | null,
        notes?: string | null,
        propertyTax?: number | null,
        residenceName?: string | null,
        buildingSiteId?: string | null,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      buildingSiteId?: string | null,
      buildingSite?:  {
        __typename: "BuildingSite",
        id: string,
        name: string,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      unitRepartition?:  Array< {
        __typename: "RepartitionValues",
        unitId: string,
        value: number,
      } > | null,
      ownerRepartition: number,
      tenantRepartition: number,
      repartitionMetric: string,
      technics?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetClientQueryVariables = {
  id: string,
};

export type GetClientQuery = {
  getClient?:  {
    __typename: "Client",
    id: string,
    accountType: AccountType,
    contactId: string,
    contact?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    generalConditionsAcceptDate: string,
    lastGeneralConditionsAcceptedVersion: string,
    GDPRAcceptDate: string,
    lastGDPRAcceptedVersion: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListClientsQueryVariables = {
  filter?: ModelClientFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListClientsQuery = {
  listClients?:  {
    __typename: "ModelClientConnection",
    items:  Array< {
      __typename: "Client",
      id: string,
      accountType: AccountType,
      contactId: string,
      contact?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      generalConditionsAcceptDate: string,
      lastGeneralConditionsAcceptedVersion: string,
      GDPRAcceptDate: string,
      lastGDPRAcceptedVersion: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncClientsQueryVariables = {
  filter?: ModelClientFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncClientsQuery = {
  syncClients?:  {
    __typename: "ModelClientConnection",
    items:  Array< {
      __typename: "Client",
      id: string,
      accountType: AccountType,
      contactId: string,
      contact?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      generalConditionsAcceptDate: string,
      lastGeneralConditionsAcceptedVersion: string,
      GDPRAcceptDate: string,
      lastGDPRAcceptedVersion: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetCommunicationQueryVariables = {
  id: string,
};

export type GetCommunicationQuery = {
  getCommunication?:  {
    __typename: "Communication",
    id: string,
    addressId?: string | null,
    address?:  {
      __typename: "Address",
      id: string,
      status?: AddressStatus | null,
      street: string,
      number?: string | null,
      box?: string | null,
      postalCode?: string | null,
      city?: string | null,
      region?: string | null,
      country?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      latitude?: number | null,
      longitude?: number | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    blockedRecipients?:  Array< {
      __typename: "CommunicationBlockedRecipient",
      recipient: string,
      bounceType: BounceType,
    } > | null,
    body: string,
    buildingId?: string | null,
    channel: CommunicationChannel,
    communicationTemplateId?: string | null,
    concernedContactIds?: Array< string > | null,
    contactId?: string | null,
    contactIds?: Array< string > | null,
    createdAt?: string | null,
    draftProperties?:  {
      __typename: "CommunicationDraftProperties",
      allowRecipientsToSeeEachOther?: boolean | null,
      bcc?: Array< string > | null,
      buildingIds?: Array< string > | null,
      cc?: Array< string > | null,
      contactIds?: Array< string > | null,
      contactTypes?: Array< ContactType > | null,
      entityType: string,
      leaseIds?: Array< string > | null,
      sendInBcc?: boolean | null,
      unitIds?: Array< string > | null,
      unitTypeFilter?: string | null,
    } | null,
    expirationDate?: string | null,
    files?:  {
      __typename: "ModelFileConnection",
      items:  Array< {
        __typename: "File",
        id: string,
        bucket: string,
        createdAt?: string | null,
        categoryId: string,
        foreignKey: string,
        foreignTableName: string,
        key: string,
        mimeType?: string | null,
        region: string,
        size?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        _ttl?: number | null,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    invoice?:  {
      __typename: "Invoice",
      id: string,
      amount: number,
      bankAccountId: string,
      bankAccount?:  {
        __typename: "BankAccount",
        id: string,
        contactId: string,
        number: string,
        bicNumber?: string | null,
        bankName?: string | null,
        contactIds?: Array< string > | null,
        buildingIds?: Array< string > | null,
        holderName?: string | null,
        label?: string | null,
        disabled?: boolean | null,
        integrations?: Array< IntegrationName > | null,
        matchingRule?: BankAccountMatchingRule | null,
        balance?: number | null,
        balanceDate?: string | null,
        type: BankAccountType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      communicationId?: string | null,
      communication?:  {
        __typename: "Communication",
        id: string,
        addressId?: string | null,
        body: string,
        buildingId?: string | null,
        channel: CommunicationChannel,
        communicationTemplateId?: string | null,
        concernedContactIds?: Array< string > | null,
        contactId?: string | null,
        contactIds?: Array< string > | null,
        createdAt?: string | null,
        expirationDate?: string | null,
        invoiceId?: string | null,
        leaseId?: string | null,
        leasePriceHistoryId?: string | null,
        letterTrackingCode?: string | null,
        letterTrackingProvider?: TrackingProvider | null,
        linkedCommunicationsIds?: Array< string > | null,
        supportingDocumentFileIds?: Array< string > | null,
        recipient?: string | null,
        recipientContactIdsInBcc?: Array< string > | null,
        recipientContactIdsInCc?: Array< string > | null,
        recipientInBcc?: string | null,
        recipientInCc?: string | null,
        scheduledAt?: string | null,
        deliveredAt?: string | null,
        errorCode?: CommunicationErrorCode | null,
        nextRetryAt?: string | null,
        sendRetryCount?: number | null,
        sender?: string | null,
        sentAt?: string | null,
        externalId?: string | null,
        externalStatus?: string | null,
        signatureDocumentId?: string | null,
        snoozedDate?: string | null,
        statementId?: string | null,
        status: CommunicationStatus,
        subject: string,
        toSend: boolean,
        hideLogo?: boolean | null,
        type: CommunicationType,
        _ttl?: number | null,
        unitId?: string | null,
        readId: string,
        readers?: Array< string > | null,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      createdAt: string,
      creditNote?: boolean | null,
      creditNoteLabel?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      dueDate?: string | null,
      invoiceDate: string,
      invoiceNumber?: string | null,
      ownerId?: string | null,
      owner?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      invoiceSenderId: string,
      invoiceSender?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      leaseId?: string | null,
      lease?:  {
        __typename: "Lease",
        id: string,
        balance?: number | null,
        canBeExtended?: boolean | null,
        communicationSettingsProfileId: string,
        createdAt?: string | null,
        endDate: string,
        includeRealEstateInLeaseContract?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        invoiceSenderId: string,
        inventoryOfFixturesExpert?: string | null,
        inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
        inventoryOfFixturesType?: InventoryOfFixturesType | null,
        ipiNumber?: string | null,
        language: Language,
        lastDraftInvoiceDate?: string | null,
        lastIndexationProcessDate?: string | null,
        lastInvoiceDate?: string | null,
        legalCompetentAuthority?: string | null,
        name: string,
        notes?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        purchaseOrderNumber?: string | null,
        realEstateAgency?: string | null,
        realEstateTax?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        signatureDate?: string | null,
        startDate: string,
        nextIndexationMonth?: string | null,
        nextIndexation?: boolean | null,
        status: LeaseStatus,
        technicCommunicationSettingsProfileId: string,
        totalInitialRentalPrice: number,
        totalRentalPrice: number,
        type: LeaseType,
        subletting?: boolean | null,
        vatRateRentId?: string | null,
        bankAccountId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      paid: boolean,
      integrations?:  {
        __typename: "InvoiceIntegrations",
      } | null,
      postedDate?: string | null,
      purchaseOrderNumber?: string | null,
      receiptNumber?: string | null,
      reminderDates?: Array< string > | null,
      note?: string | null,
      remittanceInformation?: string | null,
      statementId?: string | null,
      statement?:  {
        __typename: "Statement",
        id: string,
        closingStatement: boolean,
        periodFrom: string,
        periodTo: string,
        attachSupportingDocuments?: boolean | null,
        selectedPocketKeys?: Array< string > | null,
        source: StatementSource,
        status: StatementStatus,
        sentDate?: string | null,
        leaseId?: string | null,
        ownerId?: string | null,
        types?: Array< StatementType > | null,
        viewType: StatementViewType,
        unitIds?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      status: InvoiceStatus,
      type: InvoiceType,
      unitId?: string | null,
      unit?:  {
        __typename: "Unit",
        id: string,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        acquisitionValue?: number | null,
        advertisedMonthlyCharges?: number | null,
        advertisedRentalPrice?: number | null,
        cadastralIncome?: number | null,
        createdAt?: string | null,
        floor?: number | null,
        jointOwnershipId?: string | null,
        managementDate: string,
        name: string,
        notes?: string | null,
        predictedPrice?: string | null,
        propertyTax?: number | null,
        publishAddress?: boolean | null,
        surface?: number | null,
        type: UnitType,
        buildingId: string,
        unitAdvertisementId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      reversedInvoiceId?: string | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    invoiceId?: string | null,
    lease?:  {
      __typename: "Lease",
      id: string,
      advancedChargesInvoices?:  {
        __typename: "LeaseAdvancedChargesInvoice",
        communicationSettingsProfileId: string,
        invoiceSenderId: string,
        lastDraftInvoiceDate?: string | null,
        lastInvoiceDate?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        bankAccountId?: string | null,
      } | null,
      balance?: number | null,
      canBeExtended?: boolean | null,
      communicationSettingsProfileId: string,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      endDate: string,
      includeRealEstateInLeaseContract?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      invoiceSenderId: string,
      invoiceSender?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      inventoryOfFixturesExpert?: string | null,
      inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
      inventoryOfFixturesType?: InventoryOfFixturesType | null,
      ipiNumber?: string | null,
      language: Language,
      lastDraftInvoiceDate?: string | null,
      lastIndexationProcessDate?: string | null,
      lastInvoiceDate?: string | null,
      legalCompetentAuthority?: string | null,
      name: string,
      notes?: string | null,
      paymentFrequency: LeasePaymentFrequency,
      paymentInvoicePeriod: LeasePaymentInvoicePeriod,
      paymentInvoicePeriodCustomDay?: number | null,
      paymentOption?:  {
        __typename: "LeasePaymentOption",
        customerId?: string | null,
        enabled: boolean,
        mandateActivatedAt?: string | null,
        mandateStatus?: PaymentProviderMandateStatus | null,
        paymentMethodId?: string | null,
        qrType?: LeaseQrType | null,
      } | null,
      purchaseOrderNumber?: string | null,
      realEstateAgency?: string | null,
      realEstateTax?: number | null,
      remittanceInformation?: string | null,
      remittanceInformationType?: LeaseRemittanceType | null,
      rentalGuaranty?:  {
        __typename: "LeaseRentalGuaranty",
        amount: number,
        blockedAmount?: number | null,
        releasedAmount?: number | null,
        type: LeaseRentalGuarantyType,
        financialInstitution?: string | null,
      } | null,
      signatureDate?: string | null,
      startDate: string,
      nextIndexationMonth?: string | null,
      nextIndexation?: boolean | null,
      status: LeaseStatus,
      technicCommunicationSettingsProfileId: string,
      totalInitialRentalPrice: number,
      totalRentalPrice: number,
      type: LeaseType,
      subletting?: boolean | null,
      vatRateRentId?: string | null,
      vatRateRent?:  {
        __typename: "VatRate",
        id: string,
        country: string,
        label: string,
        value?: number | null,
        ownerId?: string | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      additionalClauses?:  {
        __typename: "ModelLeaseAdditionalClauseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      bankAccountId?: string | null,
      bankAccount?:  {
        __typename: "BankAccount",
        id: string,
        contactId: string,
        number: string,
        bicNumber?: string | null,
        bankName?: string | null,
        contactIds?: Array< string > | null,
        buildingIds?: Array< string > | null,
        holderName?: string | null,
        label?: string | null,
        disabled?: boolean | null,
        integrations?: Array< IntegrationName > | null,
        matchingRule?: BankAccountMatchingRule | null,
        balance?: number | null,
        balanceDate?: string | null,
        type: BankAccountType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contacts?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      files?:  {
        __typename: "ModelFileConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leaseActionHistories?:  {
        __typename: "ModelLeaseActionHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leasePriceHistories?:  {
        __typename: "ModelLeasePriceHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      signatureDocuments?:  {
        __typename: "ModelSignatureDocumentConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      variousOperations?:  {
        __typename: "ModelLeaseVariousOperationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    leaseId?: string | null,
    leasePriceHistoryId?: string | null,
    leasePriceHistory?:  {
      __typename: "LeasePriceHistory",
      id: string,
      previousTotalRentalPrice: number,
      totalRentalPrice: number,
      optimalTotalRentalPrice?: number | null,
      optimalTotalMonthlyCharges?: number | null,
      applicationDate: string,
      status: LeaseAmountUpdateStatus,
      comment?: string | null,
      amountDetails:  Array< {
        __typename: "LeasePriceHistoryDetail",
        unitId: string,
        indexationBaseIndex?: number | null,
        indexationNewIndex?: number | null,
        previousRentalPrice: number,
        newRentalPrice: number,
        rentalStatus: LeasePriceHistoryStatus,
        monthlyChargesStatus: LeasePriceHistoryStatus,
        optimalNewRentalPrice?: number | null,
        optimalNewMonthlyChargesPrice?: number | null,
        epb?: string | null,
        epbIssueDate?: string | null,
        oldestIndexForCorrectionFactorCalculation?: number | null,
        newestIndexForCorrectionFactorCalculation?: number | null,
        rentIndexedPriceAfterNewEpbReduction?: number | null,
        chargesIndexedPriceAfterNewEpbReduction?: number | null,
        correctionFactor?: number | null,
        reductionPercentage?: number | null,
        rentDifference?: number | null,
        rentReduction?: number | null,
        indexedRentAfterReduction?: number | null,
        chargesDifference?: number | null,
        chargesReduction?: number | null,
        indexedChargesAfterReduction?: number | null,
        previousYearIndexationNewIndex?: number | null,
        previousYearIndexedRent?: number | null,
        previousYearIndexedCharges?: number | null,
      } >,
      type: LeasePriceHistoryType,
      communicationId?: string | null,
      communication?:  {
        __typename: "Communication",
        id: string,
        addressId?: string | null,
        body: string,
        buildingId?: string | null,
        channel: CommunicationChannel,
        communicationTemplateId?: string | null,
        concernedContactIds?: Array< string > | null,
        contactId?: string | null,
        contactIds?: Array< string > | null,
        createdAt?: string | null,
        expirationDate?: string | null,
        invoiceId?: string | null,
        leaseId?: string | null,
        leasePriceHistoryId?: string | null,
        letterTrackingCode?: string | null,
        letterTrackingProvider?: TrackingProvider | null,
        linkedCommunicationsIds?: Array< string > | null,
        supportingDocumentFileIds?: Array< string > | null,
        recipient?: string | null,
        recipientContactIdsInBcc?: Array< string > | null,
        recipientContactIdsInCc?: Array< string > | null,
        recipientInBcc?: string | null,
        recipientInCc?: string | null,
        scheduledAt?: string | null,
        deliveredAt?: string | null,
        errorCode?: CommunicationErrorCode | null,
        nextRetryAt?: string | null,
        sendRetryCount?: number | null,
        sender?: string | null,
        sentAt?: string | null,
        externalId?: string | null,
        externalStatus?: string | null,
        signatureDocumentId?: string | null,
        snoozedDate?: string | null,
        statementId?: string | null,
        status: CommunicationStatus,
        subject: string,
        toSend: boolean,
        hideLogo?: boolean | null,
        type: CommunicationType,
        _ttl?: number | null,
        unitId?: string | null,
        readId: string,
        readers?: Array< string > | null,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      leaseId: string,
      lease?:  {
        __typename: "Lease",
        id: string,
        balance?: number | null,
        canBeExtended?: boolean | null,
        communicationSettingsProfileId: string,
        createdAt?: string | null,
        endDate: string,
        includeRealEstateInLeaseContract?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        invoiceSenderId: string,
        inventoryOfFixturesExpert?: string | null,
        inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
        inventoryOfFixturesType?: InventoryOfFixturesType | null,
        ipiNumber?: string | null,
        language: Language,
        lastDraftInvoiceDate?: string | null,
        lastIndexationProcessDate?: string | null,
        lastInvoiceDate?: string | null,
        legalCompetentAuthority?: string | null,
        name: string,
        notes?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        purchaseOrderNumber?: string | null,
        realEstateAgency?: string | null,
        realEstateTax?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        signatureDate?: string | null,
        startDate: string,
        nextIndexationMonth?: string | null,
        nextIndexation?: boolean | null,
        status: LeaseStatus,
        technicCommunicationSettingsProfileId: string,
        totalInitialRentalPrice: number,
        totalRentalPrice: number,
        type: LeaseType,
        subletting?: boolean | null,
        vatRateRentId?: string | null,
        bankAccountId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      createdAt?: string | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    letterTrackingCode?: string | null,
    letterTrackingProvider?: TrackingProvider | null,
    linkedCommunicationsIds?: Array< string > | null,
    supportingDocumentFileIds?: Array< string > | null,
    recipient?: string | null,
    recipientContactIdsInBcc?: Array< string > | null,
    recipientContactIdsInCc?: Array< string > | null,
    recipientInBcc?: string | null,
    recipientInCc?: string | null,
    scheduledAt?: string | null,
    deliveredAt?: string | null,
    errorCode?: CommunicationErrorCode | null,
    nextRetryAt?: string | null,
    sendRetryCount?: number | null,
    sender?: string | null,
    sentAt?: string | null,
    externalId?: string | null,
    externalStatus?: string | null,
    signatureDocumentId?: string | null,
    signatureDocument?:  {
      __typename: "SignatureDocument",
      id: string,
      additionalMessage?: string | null,
      automaticRemindersDisabled?: boolean | null,
      communicationBody?: string | null,
      createdAt?: string | null,
      expirationDate?: string | null,
      fileIds?: Array< string > | null,
      foreignKey: string,
      foreignTableName: string,
      sentAt?: string | null,
      signatureMethods: Array< SignatureType >,
      signatureResults:  Array< {
        __typename: "SignatureDocumentResult",
        openedDate?: string | null,
        signedDate?: string | null,
        signed?: boolean | null,
        signatureLink?: string | null,
        rejectReason?: string | null,
        lastSignInviteSentDate?: string | null,
        reminderDates?: Array< string > | null,
        trackingProvider?: TrackingProvider | null,
        trackingCode?: string | null,
        contactId: string,
      } >,
      status: SignatureDocumentStatus,
      externalStatus?: string | null,
      type: SignatureDocumentType,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    snoozedDate?: string | null,
    statement?:  {
      __typename: "Statement",
      id: string,
      amounts?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      chargeStatements?:  {
        __typename: "ModelChargeStatementConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      closingStatement: boolean,
      periodFrom: string,
      periodTo: string,
      attachSupportingDocuments?: boolean | null,
      selectedPocketKeys?: Array< string > | null,
      source: StatementSource,
      status: StatementStatus,
      sentDate?: string | null,
      leaseId?: string | null,
      lease?:  {
        __typename: "Lease",
        id: string,
        balance?: number | null,
        canBeExtended?: boolean | null,
        communicationSettingsProfileId: string,
        createdAt?: string | null,
        endDate: string,
        includeRealEstateInLeaseContract?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        invoiceSenderId: string,
        inventoryOfFixturesExpert?: string | null,
        inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
        inventoryOfFixturesType?: InventoryOfFixturesType | null,
        ipiNumber?: string | null,
        language: Language,
        lastDraftInvoiceDate?: string | null,
        lastIndexationProcessDate?: string | null,
        lastInvoiceDate?: string | null,
        legalCompetentAuthority?: string | null,
        name: string,
        notes?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        purchaseOrderNumber?: string | null,
        realEstateAgency?: string | null,
        realEstateTax?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        signatureDate?: string | null,
        startDate: string,
        nextIndexationMonth?: string | null,
        nextIndexation?: boolean | null,
        status: LeaseStatus,
        technicCommunicationSettingsProfileId: string,
        totalInitialRentalPrice: number,
        totalRentalPrice: number,
        type: LeaseType,
        subletting?: boolean | null,
        vatRateRentId?: string | null,
        bankAccountId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      agencyRateStatements?:  {
        __typename: "ModelAgencyRateStatementConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      ownerId?: string | null,
      owner?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      repaymentStatements?:  {
        __typename: "ModelRepaymentStatementConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      types?: Array< StatementType > | null,
      viewType: StatementViewType,
      unitIds?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    statementId?: string | null,
    status: CommunicationStatus,
    subject: string,
    toSend: boolean,
    hideLogo?: boolean | null,
    type: CommunicationType,
    _ttl?: number | null,
    unit?:  {
      __typename: "Unit",
      id: string,
      acquisitionAdditionalCostsValue?: number | null,
      acquisitionAdvertisedValue?: number | null,
      acquisitionValue?: number | null,
      advertisedMonthlyCharges?: number | null,
      advertisedRentalPrice?: number | null,
      cadastralIncome?: number | null,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      floor?: number | null,
      jointOwnershipId?: string | null,
      managementDate: string,
      name: string,
      notes?: string | null,
      predictedPrice?: string | null,
      propertyTax?: number | null,
      publishAddress?: boolean | null,
      surface?: number | null,
      type: UnitType,
      buildingId: string,
      building?:  {
        __typename: "Building",
        id: string,
        name: string,
        addressId?: string | null,
        acquisitionValue?: number | null,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        amountOfFacades?: number | null,
        amountOfFloors?: number | null,
        amountOfHousings?: number | null,
        buildingState?: BuildingState | null,
        cadastralIncome?: number | null,
        constructionYear?: string | null,
        janitor?: boolean | null,
        jointOwnershipId?: string | null,
        notes?: string | null,
        propertyTax?: number | null,
        residenceName?: string | null,
        buildingSiteId?: string | null,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      owners?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leases?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      events?:  {
        __typename: "ModelUnitEventConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      unitAdvertisementId?: string | null,
      unitInventories?:  {
        __typename: "ModelUnitInventoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    unitId?: string | null,
    readId: string,
    readers?: Array< string > | null,
    clientId: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListCommunicationsQueryVariables = {
  filter?: ModelCommunicationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListCommunicationsQuery = {
  listCommunications?:  {
    __typename: "ModelCommunicationConnection",
    items:  Array< {
      __typename: "Communication",
      id: string,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      blockedRecipients?:  Array< {
        __typename: "CommunicationBlockedRecipient",
        recipient: string,
        bounceType: BounceType,
      } > | null,
      body: string,
      buildingId?: string | null,
      channel: CommunicationChannel,
      communicationTemplateId?: string | null,
      concernedContactIds?: Array< string > | null,
      contactId?: string | null,
      contactIds?: Array< string > | null,
      createdAt?: string | null,
      draftProperties?:  {
        __typename: "CommunicationDraftProperties",
        allowRecipientsToSeeEachOther?: boolean | null,
        bcc?: Array< string > | null,
        buildingIds?: Array< string > | null,
        cc?: Array< string > | null,
        contactIds?: Array< string > | null,
        contactTypes?: Array< ContactType > | null,
        entityType: string,
        leaseIds?: Array< string > | null,
        sendInBcc?: boolean | null,
        unitIds?: Array< string > | null,
        unitTypeFilter?: string | null,
      } | null,
      expirationDate?: string | null,
      files?:  {
        __typename: "ModelFileConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      invoice?:  {
        __typename: "Invoice",
        id: string,
        amount: number,
        bankAccountId: string,
        communicationId?: string | null,
        createdAt: string,
        creditNote?: boolean | null,
        creditNoteLabel?: string | null,
        dueDate?: string | null,
        invoiceDate: string,
        invoiceNumber?: string | null,
        ownerId?: string | null,
        invoiceSenderId: string,
        leaseId?: string | null,
        paid: boolean,
        postedDate?: string | null,
        purchaseOrderNumber?: string | null,
        receiptNumber?: string | null,
        reminderDates?: Array< string > | null,
        note?: string | null,
        remittanceInformation?: string | null,
        statementId?: string | null,
        status: InvoiceStatus,
        type: InvoiceType,
        unitId?: string | null,
        reversedInvoiceId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      invoiceId?: string | null,
      lease?:  {
        __typename: "Lease",
        id: string,
        balance?: number | null,
        canBeExtended?: boolean | null,
        communicationSettingsProfileId: string,
        createdAt?: string | null,
        endDate: string,
        includeRealEstateInLeaseContract?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        invoiceSenderId: string,
        inventoryOfFixturesExpert?: string | null,
        inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
        inventoryOfFixturesType?: InventoryOfFixturesType | null,
        ipiNumber?: string | null,
        language: Language,
        lastDraftInvoiceDate?: string | null,
        lastIndexationProcessDate?: string | null,
        lastInvoiceDate?: string | null,
        legalCompetentAuthority?: string | null,
        name: string,
        notes?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        purchaseOrderNumber?: string | null,
        realEstateAgency?: string | null,
        realEstateTax?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        signatureDate?: string | null,
        startDate: string,
        nextIndexationMonth?: string | null,
        nextIndexation?: boolean | null,
        status: LeaseStatus,
        technicCommunicationSettingsProfileId: string,
        totalInitialRentalPrice: number,
        totalRentalPrice: number,
        type: LeaseType,
        subletting?: boolean | null,
        vatRateRentId?: string | null,
        bankAccountId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      leaseId?: string | null,
      leasePriceHistoryId?: string | null,
      leasePriceHistory?:  {
        __typename: "LeasePriceHistory",
        id: string,
        previousTotalRentalPrice: number,
        totalRentalPrice: number,
        optimalTotalRentalPrice?: number | null,
        optimalTotalMonthlyCharges?: number | null,
        applicationDate: string,
        status: LeaseAmountUpdateStatus,
        comment?: string | null,
        type: LeasePriceHistoryType,
        communicationId?: string | null,
        leaseId: string,
        createdAt?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      letterTrackingCode?: string | null,
      letterTrackingProvider?: TrackingProvider | null,
      linkedCommunicationsIds?: Array< string > | null,
      supportingDocumentFileIds?: Array< string > | null,
      recipient?: string | null,
      recipientContactIdsInBcc?: Array< string > | null,
      recipientContactIdsInCc?: Array< string > | null,
      recipientInBcc?: string | null,
      recipientInCc?: string | null,
      scheduledAt?: string | null,
      deliveredAt?: string | null,
      errorCode?: CommunicationErrorCode | null,
      nextRetryAt?: string | null,
      sendRetryCount?: number | null,
      sender?: string | null,
      sentAt?: string | null,
      externalId?: string | null,
      externalStatus?: string | null,
      signatureDocumentId?: string | null,
      signatureDocument?:  {
        __typename: "SignatureDocument",
        id: string,
        additionalMessage?: string | null,
        automaticRemindersDisabled?: boolean | null,
        communicationBody?: string | null,
        createdAt?: string | null,
        expirationDate?: string | null,
        fileIds?: Array< string > | null,
        foreignKey: string,
        foreignTableName: string,
        sentAt?: string | null,
        signatureMethods: Array< SignatureType >,
        status: SignatureDocumentStatus,
        externalStatus?: string | null,
        type: SignatureDocumentType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      snoozedDate?: string | null,
      statement?:  {
        __typename: "Statement",
        id: string,
        closingStatement: boolean,
        periodFrom: string,
        periodTo: string,
        attachSupportingDocuments?: boolean | null,
        selectedPocketKeys?: Array< string > | null,
        source: StatementSource,
        status: StatementStatus,
        sentDate?: string | null,
        leaseId?: string | null,
        ownerId?: string | null,
        types?: Array< StatementType > | null,
        viewType: StatementViewType,
        unitIds?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      statementId?: string | null,
      status: CommunicationStatus,
      subject: string,
      toSend: boolean,
      hideLogo?: boolean | null,
      type: CommunicationType,
      _ttl?: number | null,
      unit?:  {
        __typename: "Unit",
        id: string,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        acquisitionValue?: number | null,
        advertisedMonthlyCharges?: number | null,
        advertisedRentalPrice?: number | null,
        cadastralIncome?: number | null,
        createdAt?: string | null,
        floor?: number | null,
        jointOwnershipId?: string | null,
        managementDate: string,
        name: string,
        notes?: string | null,
        predictedPrice?: string | null,
        propertyTax?: number | null,
        publishAddress?: boolean | null,
        surface?: number | null,
        type: UnitType,
        buildingId: string,
        unitAdvertisementId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      unitId?: string | null,
      readId: string,
      readers?: Array< string > | null,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncCommunicationsQueryVariables = {
  filter?: ModelCommunicationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncCommunicationsQuery = {
  syncCommunications?:  {
    __typename: "ModelCommunicationConnection",
    items:  Array< {
      __typename: "Communication",
      id: string,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      blockedRecipients?:  Array< {
        __typename: "CommunicationBlockedRecipient",
        recipient: string,
        bounceType: BounceType,
      } > | null,
      body: string,
      buildingId?: string | null,
      channel: CommunicationChannel,
      communicationTemplateId?: string | null,
      concernedContactIds?: Array< string > | null,
      contactId?: string | null,
      contactIds?: Array< string > | null,
      createdAt?: string | null,
      draftProperties?:  {
        __typename: "CommunicationDraftProperties",
        allowRecipientsToSeeEachOther?: boolean | null,
        bcc?: Array< string > | null,
        buildingIds?: Array< string > | null,
        cc?: Array< string > | null,
        contactIds?: Array< string > | null,
        contactTypes?: Array< ContactType > | null,
        entityType: string,
        leaseIds?: Array< string > | null,
        sendInBcc?: boolean | null,
        unitIds?: Array< string > | null,
        unitTypeFilter?: string | null,
      } | null,
      expirationDate?: string | null,
      files?:  {
        __typename: "ModelFileConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      invoice?:  {
        __typename: "Invoice",
        id: string,
        amount: number,
        bankAccountId: string,
        communicationId?: string | null,
        createdAt: string,
        creditNote?: boolean | null,
        creditNoteLabel?: string | null,
        dueDate?: string | null,
        invoiceDate: string,
        invoiceNumber?: string | null,
        ownerId?: string | null,
        invoiceSenderId: string,
        leaseId?: string | null,
        paid: boolean,
        postedDate?: string | null,
        purchaseOrderNumber?: string | null,
        receiptNumber?: string | null,
        reminderDates?: Array< string > | null,
        note?: string | null,
        remittanceInformation?: string | null,
        statementId?: string | null,
        status: InvoiceStatus,
        type: InvoiceType,
        unitId?: string | null,
        reversedInvoiceId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      invoiceId?: string | null,
      lease?:  {
        __typename: "Lease",
        id: string,
        balance?: number | null,
        canBeExtended?: boolean | null,
        communicationSettingsProfileId: string,
        createdAt?: string | null,
        endDate: string,
        includeRealEstateInLeaseContract?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        invoiceSenderId: string,
        inventoryOfFixturesExpert?: string | null,
        inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
        inventoryOfFixturesType?: InventoryOfFixturesType | null,
        ipiNumber?: string | null,
        language: Language,
        lastDraftInvoiceDate?: string | null,
        lastIndexationProcessDate?: string | null,
        lastInvoiceDate?: string | null,
        legalCompetentAuthority?: string | null,
        name: string,
        notes?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        purchaseOrderNumber?: string | null,
        realEstateAgency?: string | null,
        realEstateTax?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        signatureDate?: string | null,
        startDate: string,
        nextIndexationMonth?: string | null,
        nextIndexation?: boolean | null,
        status: LeaseStatus,
        technicCommunicationSettingsProfileId: string,
        totalInitialRentalPrice: number,
        totalRentalPrice: number,
        type: LeaseType,
        subletting?: boolean | null,
        vatRateRentId?: string | null,
        bankAccountId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      leaseId?: string | null,
      leasePriceHistoryId?: string | null,
      leasePriceHistory?:  {
        __typename: "LeasePriceHistory",
        id: string,
        previousTotalRentalPrice: number,
        totalRentalPrice: number,
        optimalTotalRentalPrice?: number | null,
        optimalTotalMonthlyCharges?: number | null,
        applicationDate: string,
        status: LeaseAmountUpdateStatus,
        comment?: string | null,
        type: LeasePriceHistoryType,
        communicationId?: string | null,
        leaseId: string,
        createdAt?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      letterTrackingCode?: string | null,
      letterTrackingProvider?: TrackingProvider | null,
      linkedCommunicationsIds?: Array< string > | null,
      supportingDocumentFileIds?: Array< string > | null,
      recipient?: string | null,
      recipientContactIdsInBcc?: Array< string > | null,
      recipientContactIdsInCc?: Array< string > | null,
      recipientInBcc?: string | null,
      recipientInCc?: string | null,
      scheduledAt?: string | null,
      deliveredAt?: string | null,
      errorCode?: CommunicationErrorCode | null,
      nextRetryAt?: string | null,
      sendRetryCount?: number | null,
      sender?: string | null,
      sentAt?: string | null,
      externalId?: string | null,
      externalStatus?: string | null,
      signatureDocumentId?: string | null,
      signatureDocument?:  {
        __typename: "SignatureDocument",
        id: string,
        additionalMessage?: string | null,
        automaticRemindersDisabled?: boolean | null,
        communicationBody?: string | null,
        createdAt?: string | null,
        expirationDate?: string | null,
        fileIds?: Array< string > | null,
        foreignKey: string,
        foreignTableName: string,
        sentAt?: string | null,
        signatureMethods: Array< SignatureType >,
        status: SignatureDocumentStatus,
        externalStatus?: string | null,
        type: SignatureDocumentType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      snoozedDate?: string | null,
      statement?:  {
        __typename: "Statement",
        id: string,
        closingStatement: boolean,
        periodFrom: string,
        periodTo: string,
        attachSupportingDocuments?: boolean | null,
        selectedPocketKeys?: Array< string > | null,
        source: StatementSource,
        status: StatementStatus,
        sentDate?: string | null,
        leaseId?: string | null,
        ownerId?: string | null,
        types?: Array< StatementType > | null,
        viewType: StatementViewType,
        unitIds?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      statementId?: string | null,
      status: CommunicationStatus,
      subject: string,
      toSend: boolean,
      hideLogo?: boolean | null,
      type: CommunicationType,
      _ttl?: number | null,
      unit?:  {
        __typename: "Unit",
        id: string,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        acquisitionValue?: number | null,
        advertisedMonthlyCharges?: number | null,
        advertisedRentalPrice?: number | null,
        cadastralIncome?: number | null,
        createdAt?: string | null,
        floor?: number | null,
        jointOwnershipId?: string | null,
        managementDate: string,
        name: string,
        notes?: string | null,
        predictedPrice?: string | null,
        propertyTax?: number | null,
        publishAddress?: boolean | null,
        surface?: number | null,
        type: UnitType,
        buildingId: string,
        unitAdvertisementId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      unitId?: string | null,
      readId: string,
      readers?: Array< string > | null,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetCommunicationSettingsProfileQueryVariables = {
  id: string,
};

export type GetCommunicationSettingsProfileQuery = {
  getCommunicationSettingsProfile?:  {
    __typename: "CommunicationSettingsProfile",
    id: string,
    communicationsSettings:  Array< {
      __typename: "CommunicationSettings",
      channels: Array< CommunicationChannel >,
      communicationType: CommunicationType,
      daysBeforeDueDate?: number | null,
      daysOverdue?: number | null,
      frequency?:  {
        __typename: "CommunicationFrequencySetting",
        dateFrom?: CommunicationFrequencySettingPeriodDateFrom | null,
        periodInterval: number,
        periodType: CommunicationFrequencySettingPeriodType,
      } | null,
      invoiceDaysAfterPeriodStart?: number | null,
      sendingRule: CommunicationSendingRule,
      recipients: Array< CommunicationSettingRecipient >,
      recipientsInBcc: Array< CommunicationSettingRecipient >,
      recipientsInCopy: Array< string >,
      displayOpenBalance?: boolean | null,
    } >,
    createdAt?: string | null,
    defaultName?: string | null,
    isDefaultSetting: boolean,
    referent: CommunicationSettingsProfileReferent,
    replacementId?: string | null,
    displayLogo: boolean,
    tenantStatementView: StatementViewType,
    readId: string,
    readers?: Array< string > | null,
    clientId: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListCommunicationSettingsProfilesQueryVariables = {
  filter?: ModelCommunicationSettingsProfileFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListCommunicationSettingsProfilesQuery = {
  listCommunicationSettingsProfiles?:  {
    __typename: "ModelCommunicationSettingsProfileConnection",
    items:  Array< {
      __typename: "CommunicationSettingsProfile",
      id: string,
      communicationsSettings:  Array< {
        __typename: "CommunicationSettings",
        channels: Array< CommunicationChannel >,
        communicationType: CommunicationType,
        daysBeforeDueDate?: number | null,
        daysOverdue?: number | null,
        invoiceDaysAfterPeriodStart?: number | null,
        sendingRule: CommunicationSendingRule,
        recipients: Array< CommunicationSettingRecipient >,
        recipientsInBcc: Array< CommunicationSettingRecipient >,
        recipientsInCopy: Array< string >,
        displayOpenBalance?: boolean | null,
      } >,
      createdAt?: string | null,
      defaultName?: string | null,
      isDefaultSetting: boolean,
      referent: CommunicationSettingsProfileReferent,
      replacementId?: string | null,
      displayLogo: boolean,
      tenantStatementView: StatementViewType,
      readId: string,
      readers?: Array< string > | null,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncCommunicationSettingsProfilesQueryVariables = {
  filter?: ModelCommunicationSettingsProfileFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncCommunicationSettingsProfilesQuery = {
  syncCommunicationSettingsProfiles?:  {
    __typename: "ModelCommunicationSettingsProfileConnection",
    items:  Array< {
      __typename: "CommunicationSettingsProfile",
      id: string,
      communicationsSettings:  Array< {
        __typename: "CommunicationSettings",
        channels: Array< CommunicationChannel >,
        communicationType: CommunicationType,
        daysBeforeDueDate?: number | null,
        daysOverdue?: number | null,
        invoiceDaysAfterPeriodStart?: number | null,
        sendingRule: CommunicationSendingRule,
        recipients: Array< CommunicationSettingRecipient >,
        recipientsInBcc: Array< CommunicationSettingRecipient >,
        recipientsInCopy: Array< string >,
        displayOpenBalance?: boolean | null,
      } >,
      createdAt?: string | null,
      defaultName?: string | null,
      isDefaultSetting: boolean,
      referent: CommunicationSettingsProfileReferent,
      replacementId?: string | null,
      displayLogo: boolean,
      tenantStatementView: StatementViewType,
      readId: string,
      readers?: Array< string > | null,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetTemplateQueryVariables = {
  id: string,
};

export type GetTemplateQuery = {
  getTemplate?:  {
    __typename: "Template",
    id: string,
    language: string,
    name?: string | null,
    subject?: string | null,
    subjectRawFormat?: string | null,
    body: string,
    bodyRawFormat?: string | null,
    type: TemplateType,
    subType: TemplateSubType,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListTemplatesQueryVariables = {
  filter?: ModelTemplateFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListTemplatesQuery = {
  listTemplates?:  {
    __typename: "ModelTemplateConnection",
    items:  Array< {
      __typename: "Template",
      id: string,
      language: string,
      name?: string | null,
      subject?: string | null,
      subjectRawFormat?: string | null,
      body: string,
      bodyRawFormat?: string | null,
      type: TemplateType,
      subType: TemplateSubType,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncTemplatesQueryVariables = {
  filter?: ModelTemplateFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncTemplatesQuery = {
  syncTemplates?:  {
    __typename: "ModelTemplateConnection",
    items:  Array< {
      __typename: "Template",
      id: string,
      language: string,
      name?: string | null,
      subject?: string | null,
      subjectRawFormat?: string | null,
      body: string,
      bodyRawFormat?: string | null,
      type: TemplateType,
      subType: TemplateSubType,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetContactQueryVariables = {
  id: string,
};

export type GetContactQuery = {
  getContact?:  {
    __typename: "Contact",
    id: string,
    createdAt?: string | null,
    firstName?: string | null,
    lastName?: string | null,
    companyName?: string | null,
    commercialName?: string | null,
    communicationSettingsProfileId?: string | null,
    customValues?:  Array< {
      __typename: "CustomValue",
      name: string,
      value: string,
    } > | null,
    businessNumber?: string | null,
    types: Array< ContactType >,
    vat?: string | null,
    emails?:  Array< {
      __typename: "Email",
      address: string,
      isPrimary: boolean,
      label?: string | null,
    } > | null,
    email?: string | null,
    birthDate?: string | null,
    birthPlace?: string | null,
    nationalRegister?: string | null,
    ipiNumber?: string | null,
    insuranceCompany?: string | null,
    insuranceContractNumber?: string | null,
    judicialDistrict?: string | null,
    civility?: CivilityType | null,
    addressId?: string | null,
    address?:  {
      __typename: "Address",
      id: string,
      status?: AddressStatus | null,
      street: string,
      number?: string | null,
      box?: string | null,
      postalCode?: string | null,
      city?: string | null,
      region?: string | null,
      country?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      latitude?: number | null,
      longitude?: number | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    phoneNumbers?:  Array< {
      __typename: "PhoneNumber",
      countryCode: string,
      isPrimary: boolean,
      label?: string | null,
      number: string,
    } > | null,
    language?: string | null,
    notes?: string | null,
    profileType: ContactProfileType,
    jointOwners?:  Array< {
      __typename: "JointOwner",
      contactId: string,
      contactPerson?: boolean | null,
    } > | null,
    hoaFunds?:  Array< {
      __typename: "ContactHoaFund",
      archivedAt?: string | null,
      id: string,
      kind: HoaFundKind,
      name: string,
    } > | null,
    agencyRateDisabled?: boolean | null,
    attachStatementSupportingDocuments?: boolean | null,
    status?: ContactStatus | null,
    leases?:  {
      __typename: "ModelLeaseContactConnection",
      items:  Array< {
        __typename: "LeaseContact",
        id: string,
        leaseId: string,
        contactId: string,
        contactRole: ContactType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    buildings?:  {
      __typename: "ModelBuildingOwnerConnection",
      items:  Array< {
        __typename: "BuildingOwner",
        id: string,
        buildingId: string,
        contactId: string,
        disabled?: boolean | null,
        periodFrom?: string | null,
        periodTo?: string | null,
        stake: number,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    units?:  {
      __typename: "ModelUnitOwnerConnection",
      items:  Array< {
        __typename: "UnitOwner",
        id: string,
        disabled?: boolean | null,
        ownerId: string,
        periodFrom?: string | null,
        periodTo?: string | null,
        stake: number,
        unitId: string,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    sendInvitation: boolean,
    peppolProperties?:  {
      __typename: "ContactPeppolProperties",
      isRegistered: boolean,
      mustSend: boolean,
    } | null,
    integrations?:  {
      __typename: "ContactIntegrations",
      paymentProperties?:  {
        __typename: "PaymentProviderProperties",
        accountId: string,
      } | null,
    } | null,
    readers?: Array< string > | null,
    readId: string,
    clientId: string,
    sourceEntityRelations?:  {
      __typename: "ModelEntityRelationConnection",
      items:  Array< {
        __typename: "EntityRelation",
        id: string,
        sourceId: string,
        sourceTableName: string,
        foreignId: string,
        foreignTableName: string,
        linkDescription?: string | null,
        clientId: string,
        readers?: Array< string > | null,
        readId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    foreignEntityRelations?:  {
      __typename: "ModelEntityRelationConnection",
      items:  Array< {
        __typename: "EntityRelation",
        id: string,
        sourceId: string,
        sourceTableName: string,
        foreignId: string,
        foreignTableName: string,
        linkDescription?: string | null,
        clientId: string,
        readers?: Array< string > | null,
        readId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListContactsQueryVariables = {
  filter?: ModelContactFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListContactsQuery = {
  listContacts?:  {
    __typename: "ModelContactConnection",
    items:  Array< {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncContactsQueryVariables = {
  filter?: ModelContactFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncContactsQuery = {
  syncContacts?:  {
    __typename: "ModelContactConnection",
    items:  Array< {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetAddressQueryVariables = {
  id: string,
};

export type GetAddressQuery = {
  getAddress?:  {
    __typename: "Address",
    id: string,
    status?: AddressStatus | null,
    street: string,
    number?: string | null,
    box?: string | null,
    postalCode?: string | null,
    city?: string | null,
    region?: string | null,
    country?: string | null,
    customValues?:  Array< {
      __typename: "CustomValue",
      name: string,
      value: string,
    } > | null,
    latitude?: number | null,
    longitude?: number | null,
    readers?: Array< string > | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListAddressesQueryVariables = {
  filter?: ModelAddressFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListAddressesQuery = {
  listAddresses?:  {
    __typename: "ModelAddressConnection",
    items:  Array< {
      __typename: "Address",
      id: string,
      status?: AddressStatus | null,
      street: string,
      number?: string | null,
      box?: string | null,
      postalCode?: string | null,
      city?: string | null,
      region?: string | null,
      country?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      latitude?: number | null,
      longitude?: number | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncAddressesQueryVariables = {
  filter?: ModelAddressFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncAddressesQuery = {
  syncAddresses?:  {
    __typename: "ModelAddressConnection",
    items:  Array< {
      __typename: "Address",
      id: string,
      status?: AddressStatus | null,
      street: string,
      number?: string | null,
      box?: string | null,
      postalCode?: string | null,
      city?: string | null,
      region?: string | null,
      country?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      latitude?: number | null,
      longitude?: number | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetCustomFieldQueryVariables = {
  id: string,
};

export type GetCustomFieldQuery = {
  getCustomField?:  {
    __typename: "CustomField",
    id: string,
    fieldName: string,
    fieldType: CustomFieldType,
    foreignKey: string,
    foreignTableName: string,
    labels:  Array< {
      __typename: "CustomLabel",
      language: string,
      label: string,
    } >,
    customFieldProperties?:  {
      __typename: "CustomFieldProperties",
      isRequired?: boolean | null,
      isDefault?: boolean | null,
      defaultValue?: string | null,
      options?:  Array< {
        __typename: "CustomFieldOption",
        id: string,
      } > | null,
    } | null,
    order?: number | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListCustomFieldsQueryVariables = {
  filter?: ModelCustomFieldFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListCustomFieldsQuery = {
  listCustomFields?:  {
    __typename: "ModelCustomFieldConnection",
    items:  Array< {
      __typename: "CustomField",
      id: string,
      fieldName: string,
      fieldType: CustomFieldType,
      foreignKey: string,
      foreignTableName: string,
      labels:  Array< {
        __typename: "CustomLabel",
        language: string,
        label: string,
      } >,
      customFieldProperties?:  {
        __typename: "CustomFieldProperties",
        isRequired?: boolean | null,
        isDefault?: boolean | null,
        defaultValue?: string | null,
      } | null,
      order?: number | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncCustomFieldsQueryVariables = {
  filter?: ModelCustomFieldFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncCustomFieldsQuery = {
  syncCustomFields?:  {
    __typename: "ModelCustomFieldConnection",
    items:  Array< {
      __typename: "CustomField",
      id: string,
      fieldName: string,
      fieldType: CustomFieldType,
      foreignKey: string,
      foreignTableName: string,
      labels:  Array< {
        __typename: "CustomLabel",
        language: string,
        label: string,
      } >,
      customFieldProperties?:  {
        __typename: "CustomFieldProperties",
        isRequired?: boolean | null,
        isDefault?: boolean | null,
        defaultValue?: string | null,
      } | null,
      order?: number | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetCustomSubscriptionQueryVariables = {
  id: string,
};

export type GetCustomSubscriptionQuery = {
  getCustomSubscription?:  {
    __typename: "CustomSubscription",
    id: string,
    name: CustomSubscriptionType,
    value: string,
    createdAt?: string | null,
    userId?: string | null,
    _ttl: number,
    updatedAt: string,
    clientId: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListCustomSubscriptionsQueryVariables = {
  filter?: ModelCustomSubscriptionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListCustomSubscriptionsQuery = {
  listCustomSubscriptions?:  {
    __typename: "ModelCustomSubscriptionConnection",
    items:  Array< {
      __typename: "CustomSubscription",
      id: string,
      name: CustomSubscriptionType,
      value: string,
      createdAt?: string | null,
      userId?: string | null,
      _ttl: number,
      updatedAt: string,
      clientId: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncCustomSubscriptionsQueryVariables = {
  filter?: ModelCustomSubscriptionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncCustomSubscriptionsQuery = {
  syncCustomSubscriptions?:  {
    __typename: "ModelCustomSubscriptionConnection",
    items:  Array< {
      __typename: "CustomSubscription",
      id: string,
      name: CustomSubscriptionType,
      value: string,
      createdAt?: string | null,
      userId?: string | null,
      _ttl: number,
      updatedAt: string,
      clientId: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetEntityRelationQueryVariables = {
  id: string,
};

export type GetEntityRelationQuery = {
  getEntityRelation?:  {
    __typename: "EntityRelation",
    id: string,
    sourceId: string,
    sourceTableName: string,
    foreignId: string,
    foreignTableName: string,
    linkDescription?: string | null,
    linkProperties?:  {
      __typename: "RelationLinkProperties",
      contact?:  {
        __typename: "ContactRelationLinkProperties",
        communicationSubscriptions?: Array< ContactCommunicationSubscriptionTypes > | null,
      } | null,
    } | null,
    clientId: string,
    readers?: Array< string > | null,
    readId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListEntityRelationsQueryVariables = {
  filter?: ModelEntityRelationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListEntityRelationsQuery = {
  listEntityRelations?:  {
    __typename: "ModelEntityRelationConnection",
    items:  Array< {
      __typename: "EntityRelation",
      id: string,
      sourceId: string,
      sourceTableName: string,
      foreignId: string,
      foreignTableName: string,
      linkDescription?: string | null,
      linkProperties?:  {
        __typename: "RelationLinkProperties",
      } | null,
      clientId: string,
      readers?: Array< string > | null,
      readId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncEntityRelationsQueryVariables = {
  filter?: ModelEntityRelationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncEntityRelationsQuery = {
  syncEntityRelations?:  {
    __typename: "ModelEntityRelationConnection",
    items:  Array< {
      __typename: "EntityRelation",
      id: string,
      sourceId: string,
      sourceTableName: string,
      foreignId: string,
      foreignTableName: string,
      linkDescription?: string | null,
      linkProperties?:  {
        __typename: "RelationLinkProperties",
      } | null,
      clientId: string,
      readers?: Array< string > | null,
      readId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type EntityRelationsBySourceIdQueryVariables = {
  sourceId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelEntityRelationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type EntityRelationsBySourceIdQuery = {
  entityRelationsBySourceId?:  {
    __typename: "ModelEntityRelationConnection",
    items:  Array< {
      __typename: "EntityRelation",
      id: string,
      sourceId: string,
      sourceTableName: string,
      foreignId: string,
      foreignTableName: string,
      linkDescription?: string | null,
      linkProperties?:  {
        __typename: "RelationLinkProperties",
      } | null,
      clientId: string,
      readers?: Array< string > | null,
      readId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type EntityRelationsByForeignIdQueryVariables = {
  foreignId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelEntityRelationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type EntityRelationsByForeignIdQuery = {
  entityRelationsByForeignId?:  {
    __typename: "ModelEntityRelationConnection",
    items:  Array< {
      __typename: "EntityRelation",
      id: string,
      sourceId: string,
      sourceTableName: string,
      foreignId: string,
      foreignTableName: string,
      linkDescription?: string | null,
      linkProperties?:  {
        __typename: "RelationLinkProperties",
      } | null,
      clientId: string,
      readers?: Array< string > | null,
      readId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetFileQueryVariables = {
  id: string,
};

export type GetFileQuery = {
  getFile?:  {
    __typename: "File",
    id: string,
    bucket: string,
    createdAt?: string | null,
    category?:  {
      __typename: "DocumentCategory",
      id: string,
      entity?: string | null,
      fileCategory: FileCategory,
      labels:  Array< {
        __typename: "CustomLabel",
        language: string,
        label: string,
      } >,
      parentId?: string | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    categoryId: string,
    foreignKey: string,
    foreignTableName: string,
    key: string,
    mimeType?: string | null,
    region: string,
    signaturePositions?:  Array< {
      __typename: "SignaturePosition",
      top: number,
      left: number,
      page: number,
      width?: number | null,
      height?: number | null,
      contactId: string,
    } > | null,
    size?: number | null,
    readers?: Array< string > | null,
    readId: string,
    clientId: string,
    _ttl?: number | null,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListFilesQueryVariables = {
  filter?: ModelFileFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListFilesQuery = {
  listFiles?:  {
    __typename: "ModelFileConnection",
    items:  Array< {
      __typename: "File",
      id: string,
      bucket: string,
      createdAt?: string | null,
      category?:  {
        __typename: "DocumentCategory",
        id: string,
        entity?: string | null,
        fileCategory: FileCategory,
        parentId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      categoryId: string,
      foreignKey: string,
      foreignTableName: string,
      key: string,
      mimeType?: string | null,
      region: string,
      signaturePositions?:  Array< {
        __typename: "SignaturePosition",
        top: number,
        left: number,
        page: number,
        width?: number | null,
        height?: number | null,
        contactId: string,
      } > | null,
      size?: number | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      _ttl?: number | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncFilesQueryVariables = {
  filter?: ModelFileFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncFilesQuery = {
  syncFiles?:  {
    __typename: "ModelFileConnection",
    items:  Array< {
      __typename: "File",
      id: string,
      bucket: string,
      createdAt?: string | null,
      category?:  {
        __typename: "DocumentCategory",
        id: string,
        entity?: string | null,
        fileCategory: FileCategory,
        parentId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      categoryId: string,
      foreignKey: string,
      foreignTableName: string,
      key: string,
      mimeType?: string | null,
      region: string,
      signaturePositions?:  Array< {
        __typename: "SignaturePosition",
        top: number,
        left: number,
        page: number,
        width?: number | null,
        height?: number | null,
        contactId: string,
      } > | null,
      size?: number | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      _ttl?: number | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type FilesByKeyQueryVariables = {
  key: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelFileFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type FilesByKeyQuery = {
  filesByKey?:  {
    __typename: "ModelFileConnection",
    items:  Array< {
      __typename: "File",
      id: string,
      bucket: string,
      createdAt?: string | null,
      category?:  {
        __typename: "DocumentCategory",
        id: string,
        entity?: string | null,
        fileCategory: FileCategory,
        parentId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      categoryId: string,
      foreignKey: string,
      foreignTableName: string,
      key: string,
      mimeType?: string | null,
      region: string,
      signaturePositions?:  Array< {
        __typename: "SignaturePosition",
        top: number,
        left: number,
        page: number,
        width?: number | null,
        height?: number | null,
        contactId: string,
      } > | null,
      size?: number | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      _ttl?: number | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetDocumentCategoryQueryVariables = {
  id: string,
};

export type GetDocumentCategoryQuery = {
  getDocumentCategory?:  {
    __typename: "DocumentCategory",
    id: string,
    entity?: string | null,
    fileCategory: FileCategory,
    labels:  Array< {
      __typename: "CustomLabel",
      language: string,
      label: string,
    } >,
    parentId?: string | null,
    readers?: Array< string > | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListDocumentCategoriesQueryVariables = {
  filter?: ModelDocumentCategoryFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListDocumentCategoriesQuery = {
  listDocumentCategories?:  {
    __typename: "ModelDocumentCategoryConnection",
    items:  Array< {
      __typename: "DocumentCategory",
      id: string,
      entity?: string | null,
      fileCategory: FileCategory,
      labels:  Array< {
        __typename: "CustomLabel",
        language: string,
        label: string,
      } >,
      parentId?: string | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncDocumentCategoriesQueryVariables = {
  filter?: ModelDocumentCategoryFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncDocumentCategoriesQuery = {
  syncDocumentCategories?:  {
    __typename: "ModelDocumentCategoryConnection",
    items:  Array< {
      __typename: "DocumentCategory",
      id: string,
      entity?: string | null,
      fileCategory: FileCategory,
      labels:  Array< {
        __typename: "CustomLabel",
        language: string,
        label: string,
      } >,
      parentId?: string | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetSignatureDocumentQueryVariables = {
  id: string,
};

export type GetSignatureDocumentQuery = {
  getSignatureDocument?:  {
    __typename: "SignatureDocument",
    id: string,
    additionalMessage?: string | null,
    automaticRemindersDisabled?: boolean | null,
    communicationBody?: string | null,
    createdAt?: string | null,
    expirationDate?: string | null,
    fileIds?: Array< string > | null,
    foreignKey: string,
    foreignTableName: string,
    sentAt?: string | null,
    signatureMethods: Array< SignatureType >,
    signatureResults:  Array< {
      __typename: "SignatureDocumentResult",
      openedDate?: string | null,
      signedDate?: string | null,
      signed?: boolean | null,
      signatureLink?: string | null,
      rejectReason?: string | null,
      lastSignInviteSentDate?: string | null,
      reminderDates?: Array< string > | null,
      trackingProvider?: TrackingProvider | null,
      trackingCode?: string | null,
      contactId: string,
    } >,
    status: SignatureDocumentStatus,
    externalStatus?: string | null,
    type: SignatureDocumentType,
    readers?: Array< string > | null,
    readId: string,
    clientId: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListSignatureDocumentsQueryVariables = {
  filter?: ModelSignatureDocumentFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListSignatureDocumentsQuery = {
  listSignatureDocuments?:  {
    __typename: "ModelSignatureDocumentConnection",
    items:  Array< {
      __typename: "SignatureDocument",
      id: string,
      additionalMessage?: string | null,
      automaticRemindersDisabled?: boolean | null,
      communicationBody?: string | null,
      createdAt?: string | null,
      expirationDate?: string | null,
      fileIds?: Array< string > | null,
      foreignKey: string,
      foreignTableName: string,
      sentAt?: string | null,
      signatureMethods: Array< SignatureType >,
      signatureResults:  Array< {
        __typename: "SignatureDocumentResult",
        openedDate?: string | null,
        signedDate?: string | null,
        signed?: boolean | null,
        signatureLink?: string | null,
        rejectReason?: string | null,
        lastSignInviteSentDate?: string | null,
        reminderDates?: Array< string > | null,
        trackingProvider?: TrackingProvider | null,
        trackingCode?: string | null,
        contactId: string,
      } >,
      status: SignatureDocumentStatus,
      externalStatus?: string | null,
      type: SignatureDocumentType,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncSignatureDocumentsQueryVariables = {
  filter?: ModelSignatureDocumentFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncSignatureDocumentsQuery = {
  syncSignatureDocuments?:  {
    __typename: "ModelSignatureDocumentConnection",
    items:  Array< {
      __typename: "SignatureDocument",
      id: string,
      additionalMessage?: string | null,
      automaticRemindersDisabled?: boolean | null,
      communicationBody?: string | null,
      createdAt?: string | null,
      expirationDate?: string | null,
      fileIds?: Array< string > | null,
      foreignKey: string,
      foreignTableName: string,
      sentAt?: string | null,
      signatureMethods: Array< SignatureType >,
      signatureResults:  Array< {
        __typename: "SignatureDocumentResult",
        openedDate?: string | null,
        signedDate?: string | null,
        signed?: boolean | null,
        signatureLink?: string | null,
        rejectReason?: string | null,
        lastSignInviteSentDate?: string | null,
        reminderDates?: Array< string > | null,
        trackingProvider?: TrackingProvider | null,
        trackingCode?: string | null,
        contactId: string,
      } >,
      status: SignatureDocumentStatus,
      externalStatus?: string | null,
      type: SignatureDocumentType,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetFilterGroupQueryVariables = {
  id: string,
};

export type GetFilterGroupQuery = {
  getFilterGroup?:  {
    __typename: "FilterGroup",
    id: string,
    filterGroupDetails:  Array< {
      __typename: "FilterGroupDetails",
      filterEntityType: FilterEntityType,
      filterEntityField?: string | null,
      filterEntityValues?: Array< string > | null,
      filterEntityNumber?: number | null,
      filterEntityDate?: string | null,
    } >,
    name?: string | null,
    screenName?: ScreenName | null,
    type: FilterGroupType,
    userId?: string | null,
    user?:  {
      __typename: "User",
      id: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      cognitoSub?: string | null,
      googleSub?: string | null,
      facebookSub?: string | null,
      rootUser?: boolean | null,
      refreshToken?: boolean | null,
      teams?:  {
        __typename: "ModelUserTeamConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      userRoleId?: string | null,
      userRole?:  {
        __typename: "UserRole",
        id: string,
        name: string,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contactId?: string | null,
      contact?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      status: UserStatus,
      readId: string,
      clientId: string,
      _ttl?: number | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListFilterGroupsQueryVariables = {
  filter?: ModelFilterGroupFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListFilterGroupsQuery = {
  listFilterGroups?:  {
    __typename: "ModelFilterGroupConnection",
    items:  Array< {
      __typename: "FilterGroup",
      id: string,
      filterGroupDetails:  Array< {
        __typename: "FilterGroupDetails",
        filterEntityType: FilterEntityType,
        filterEntityField?: string | null,
        filterEntityValues?: Array< string > | null,
        filterEntityNumber?: number | null,
        filterEntityDate?: string | null,
      } >,
      name?: string | null,
      screenName?: ScreenName | null,
      type: FilterGroupType,
      userId?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        cognitoSub?: string | null,
        googleSub?: string | null,
        facebookSub?: string | null,
        rootUser?: boolean | null,
        refreshToken?: boolean | null,
        userRoleId?: string | null,
        contactId?: string | null,
        status: UserStatus,
        readId: string,
        clientId: string,
        _ttl?: number | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncFilterGroupsQueryVariables = {
  filter?: ModelFilterGroupFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncFilterGroupsQuery = {
  syncFilterGroups?:  {
    __typename: "ModelFilterGroupConnection",
    items:  Array< {
      __typename: "FilterGroup",
      id: string,
      filterGroupDetails:  Array< {
        __typename: "FilterGroupDetails",
        filterEntityType: FilterEntityType,
        filterEntityField?: string | null,
        filterEntityValues?: Array< string > | null,
        filterEntityNumber?: number | null,
        filterEntityDate?: string | null,
      } >,
      name?: string | null,
      screenName?: ScreenName | null,
      type: FilterGroupType,
      userId?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        cognitoSub?: string | null,
        googleSub?: string | null,
        facebookSub?: string | null,
        rootUser?: boolean | null,
        refreshToken?: boolean | null,
        userRoleId?: string | null,
        contactId?: string | null,
        status: UserStatus,
        readId: string,
        clientId: string,
        _ttl?: number | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetIntegrationQueryVariables = {
  id: string,
};

export type GetIntegrationQuery = {
  getIntegration?:  {
    __typename: "Integration",
    id: string,
    configurations?:  Array< {
      __typename: "IntegrationConfiguration",
      name: string,
      value: string,
    } > | null,
    error?: string | null,
    lastRun?: string | null,
    name: IntegrationName,
    status: IntegrationStatus,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListIntegrationsQueryVariables = {
  filter?: ModelIntegrationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListIntegrationsQuery = {
  listIntegrations?:  {
    __typename: "ModelIntegrationConnection",
    items:  Array< {
      __typename: "Integration",
      id: string,
      configurations?:  Array< {
        __typename: "IntegrationConfiguration",
        name: string,
        value: string,
      } > | null,
      error?: string | null,
      lastRun?: string | null,
      name: IntegrationName,
      status: IntegrationStatus,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncIntegrationsQueryVariables = {
  filter?: ModelIntegrationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncIntegrationsQuery = {
  syncIntegrations?:  {
    __typename: "ModelIntegrationConnection",
    items:  Array< {
      __typename: "Integration",
      id: string,
      configurations?:  Array< {
        __typename: "IntegrationConfiguration",
        name: string,
        value: string,
      } > | null,
      error?: string | null,
      lastRun?: string | null,
      name: IntegrationName,
      status: IntegrationStatus,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetInvoiceQueryVariables = {
  id: string,
};

export type GetInvoiceQuery = {
  getInvoice?:  {
    __typename: "Invoice",
    id: string,
    amount: number,
    bankAccountId: string,
    bankAccount?:  {
      __typename: "BankAccount",
      id: string,
      contactId: string,
      contact?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      number: string,
      bicNumber?: string | null,
      bankName?: string | null,
      contactIds?: Array< string > | null,
      buildingIds?: Array< string > | null,
      holderName?: string | null,
      label?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      disabled?: boolean | null,
      integrations?: Array< IntegrationName > | null,
      matchingRule?: BankAccountMatchingRule | null,
      balance?: number | null,
      balanceDate?: string | null,
      type: BankAccountType,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    communicationId?: string | null,
    communication?:  {
      __typename: "Communication",
      id: string,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      blockedRecipients?:  Array< {
        __typename: "CommunicationBlockedRecipient",
        recipient: string,
        bounceType: BounceType,
      } > | null,
      body: string,
      buildingId?: string | null,
      channel: CommunicationChannel,
      communicationTemplateId?: string | null,
      concernedContactIds?: Array< string > | null,
      contactId?: string | null,
      contactIds?: Array< string > | null,
      createdAt?: string | null,
      draftProperties?:  {
        __typename: "CommunicationDraftProperties",
        allowRecipientsToSeeEachOther?: boolean | null,
        bcc?: Array< string > | null,
        buildingIds?: Array< string > | null,
        cc?: Array< string > | null,
        contactIds?: Array< string > | null,
        contactTypes?: Array< ContactType > | null,
        entityType: string,
        leaseIds?: Array< string > | null,
        sendInBcc?: boolean | null,
        unitIds?: Array< string > | null,
        unitTypeFilter?: string | null,
      } | null,
      expirationDate?: string | null,
      files?:  {
        __typename: "ModelFileConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      invoice?:  {
        __typename: "Invoice",
        id: string,
        amount: number,
        bankAccountId: string,
        communicationId?: string | null,
        createdAt: string,
        creditNote?: boolean | null,
        creditNoteLabel?: string | null,
        dueDate?: string | null,
        invoiceDate: string,
        invoiceNumber?: string | null,
        ownerId?: string | null,
        invoiceSenderId: string,
        leaseId?: string | null,
        paid: boolean,
        postedDate?: string | null,
        purchaseOrderNumber?: string | null,
        receiptNumber?: string | null,
        reminderDates?: Array< string > | null,
        note?: string | null,
        remittanceInformation?: string | null,
        statementId?: string | null,
        status: InvoiceStatus,
        type: InvoiceType,
        unitId?: string | null,
        reversedInvoiceId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      invoiceId?: string | null,
      lease?:  {
        __typename: "Lease",
        id: string,
        balance?: number | null,
        canBeExtended?: boolean | null,
        communicationSettingsProfileId: string,
        createdAt?: string | null,
        endDate: string,
        includeRealEstateInLeaseContract?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        invoiceSenderId: string,
        inventoryOfFixturesExpert?: string | null,
        inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
        inventoryOfFixturesType?: InventoryOfFixturesType | null,
        ipiNumber?: string | null,
        language: Language,
        lastDraftInvoiceDate?: string | null,
        lastIndexationProcessDate?: string | null,
        lastInvoiceDate?: string | null,
        legalCompetentAuthority?: string | null,
        name: string,
        notes?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        purchaseOrderNumber?: string | null,
        realEstateAgency?: string | null,
        realEstateTax?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        signatureDate?: string | null,
        startDate: string,
        nextIndexationMonth?: string | null,
        nextIndexation?: boolean | null,
        status: LeaseStatus,
        technicCommunicationSettingsProfileId: string,
        totalInitialRentalPrice: number,
        totalRentalPrice: number,
        type: LeaseType,
        subletting?: boolean | null,
        vatRateRentId?: string | null,
        bankAccountId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      leaseId?: string | null,
      leasePriceHistoryId?: string | null,
      leasePriceHistory?:  {
        __typename: "LeasePriceHistory",
        id: string,
        previousTotalRentalPrice: number,
        totalRentalPrice: number,
        optimalTotalRentalPrice?: number | null,
        optimalTotalMonthlyCharges?: number | null,
        applicationDate: string,
        status: LeaseAmountUpdateStatus,
        comment?: string | null,
        type: LeasePriceHistoryType,
        communicationId?: string | null,
        leaseId: string,
        createdAt?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      letterTrackingCode?: string | null,
      letterTrackingProvider?: TrackingProvider | null,
      linkedCommunicationsIds?: Array< string > | null,
      supportingDocumentFileIds?: Array< string > | null,
      recipient?: string | null,
      recipientContactIdsInBcc?: Array< string > | null,
      recipientContactIdsInCc?: Array< string > | null,
      recipientInBcc?: string | null,
      recipientInCc?: string | null,
      scheduledAt?: string | null,
      deliveredAt?: string | null,
      errorCode?: CommunicationErrorCode | null,
      nextRetryAt?: string | null,
      sendRetryCount?: number | null,
      sender?: string | null,
      sentAt?: string | null,
      externalId?: string | null,
      externalStatus?: string | null,
      signatureDocumentId?: string | null,
      signatureDocument?:  {
        __typename: "SignatureDocument",
        id: string,
        additionalMessage?: string | null,
        automaticRemindersDisabled?: boolean | null,
        communicationBody?: string | null,
        createdAt?: string | null,
        expirationDate?: string | null,
        fileIds?: Array< string > | null,
        foreignKey: string,
        foreignTableName: string,
        sentAt?: string | null,
        signatureMethods: Array< SignatureType >,
        status: SignatureDocumentStatus,
        externalStatus?: string | null,
        type: SignatureDocumentType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      snoozedDate?: string | null,
      statement?:  {
        __typename: "Statement",
        id: string,
        closingStatement: boolean,
        periodFrom: string,
        periodTo: string,
        attachSupportingDocuments?: boolean | null,
        selectedPocketKeys?: Array< string > | null,
        source: StatementSource,
        status: StatementStatus,
        sentDate?: string | null,
        leaseId?: string | null,
        ownerId?: string | null,
        types?: Array< StatementType > | null,
        viewType: StatementViewType,
        unitIds?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      statementId?: string | null,
      status: CommunicationStatus,
      subject: string,
      toSend: boolean,
      hideLogo?: boolean | null,
      type: CommunicationType,
      _ttl?: number | null,
      unit?:  {
        __typename: "Unit",
        id: string,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        acquisitionValue?: number | null,
        advertisedMonthlyCharges?: number | null,
        advertisedRentalPrice?: number | null,
        cadastralIncome?: number | null,
        createdAt?: string | null,
        floor?: number | null,
        jointOwnershipId?: string | null,
        managementDate: string,
        name: string,
        notes?: string | null,
        predictedPrice?: string | null,
        propertyTax?: number | null,
        publishAddress?: boolean | null,
        surface?: number | null,
        type: UnitType,
        buildingId: string,
        unitAdvertisementId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      unitId?: string | null,
      readId: string,
      readers?: Array< string > | null,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    createdAt: string,
    creditNote?: boolean | null,
    creditNoteLabel?: string | null,
    customValues?:  Array< {
      __typename: "CustomValue",
      name: string,
      value: string,
    } > | null,
    dueDate?: string | null,
    invoiceDate: string,
    invoiceNumber?: string | null,
    ownerId?: string | null,
    owner?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    invoiceSenderId: string,
    invoiceSender?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    leaseId?: string | null,
    lease?:  {
      __typename: "Lease",
      id: string,
      advancedChargesInvoices?:  {
        __typename: "LeaseAdvancedChargesInvoice",
        communicationSettingsProfileId: string,
        invoiceSenderId: string,
        lastDraftInvoiceDate?: string | null,
        lastInvoiceDate?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        bankAccountId?: string | null,
      } | null,
      balance?: number | null,
      canBeExtended?: boolean | null,
      communicationSettingsProfileId: string,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      endDate: string,
      includeRealEstateInLeaseContract?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      invoiceSenderId: string,
      invoiceSender?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      inventoryOfFixturesExpert?: string | null,
      inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
      inventoryOfFixturesType?: InventoryOfFixturesType | null,
      ipiNumber?: string | null,
      language: Language,
      lastDraftInvoiceDate?: string | null,
      lastIndexationProcessDate?: string | null,
      lastInvoiceDate?: string | null,
      legalCompetentAuthority?: string | null,
      name: string,
      notes?: string | null,
      paymentFrequency: LeasePaymentFrequency,
      paymentInvoicePeriod: LeasePaymentInvoicePeriod,
      paymentInvoicePeriodCustomDay?: number | null,
      paymentOption?:  {
        __typename: "LeasePaymentOption",
        customerId?: string | null,
        enabled: boolean,
        mandateActivatedAt?: string | null,
        mandateStatus?: PaymentProviderMandateStatus | null,
        paymentMethodId?: string | null,
        qrType?: LeaseQrType | null,
      } | null,
      purchaseOrderNumber?: string | null,
      realEstateAgency?: string | null,
      realEstateTax?: number | null,
      remittanceInformation?: string | null,
      remittanceInformationType?: LeaseRemittanceType | null,
      rentalGuaranty?:  {
        __typename: "LeaseRentalGuaranty",
        amount: number,
        blockedAmount?: number | null,
        releasedAmount?: number | null,
        type: LeaseRentalGuarantyType,
        financialInstitution?: string | null,
      } | null,
      signatureDate?: string | null,
      startDate: string,
      nextIndexationMonth?: string | null,
      nextIndexation?: boolean | null,
      status: LeaseStatus,
      technicCommunicationSettingsProfileId: string,
      totalInitialRentalPrice: number,
      totalRentalPrice: number,
      type: LeaseType,
      subletting?: boolean | null,
      vatRateRentId?: string | null,
      vatRateRent?:  {
        __typename: "VatRate",
        id: string,
        country: string,
        label: string,
        value?: number | null,
        ownerId?: string | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      additionalClauses?:  {
        __typename: "ModelLeaseAdditionalClauseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      bankAccountId?: string | null,
      bankAccount?:  {
        __typename: "BankAccount",
        id: string,
        contactId: string,
        number: string,
        bicNumber?: string | null,
        bankName?: string | null,
        contactIds?: Array< string > | null,
        buildingIds?: Array< string > | null,
        holderName?: string | null,
        label?: string | null,
        disabled?: boolean | null,
        integrations?: Array< IntegrationName > | null,
        matchingRule?: BankAccountMatchingRule | null,
        balance?: number | null,
        balanceDate?: string | null,
        type: BankAccountType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contacts?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      files?:  {
        __typename: "ModelFileConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leaseActionHistories?:  {
        __typename: "ModelLeaseActionHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leasePriceHistories?:  {
        __typename: "ModelLeasePriceHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      signatureDocuments?:  {
        __typename: "ModelSignatureDocumentConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      variousOperations?:  {
        __typename: "ModelLeaseVariousOperationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    paid: boolean,
    integrations?:  {
      __typename: "InvoiceIntegrations",
      paymentProperties?:  {
        __typename: "InvoicePaymentProviderProperties",
        availableOn?: string | null,
        error?: string | null,
        feeAmount?: number | null,
        paymentIntentId?: string | null,
        paymentLinkAmount?: number | null,
        paymentLinkUrl?: string | null,
        payoutId?: string | null,
        statementDescriptor?: string | null,
      } | null,
    } | null,
    postedDate?: string | null,
    purchaseOrderNumber?: string | null,
    receiptNumber?: string | null,
    reminderDates?: Array< string > | null,
    note?: string | null,
    remittanceInformation?: string | null,
    statementId?: string | null,
    statement?:  {
      __typename: "Statement",
      id: string,
      amounts?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      chargeStatements?:  {
        __typename: "ModelChargeStatementConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      closingStatement: boolean,
      periodFrom: string,
      periodTo: string,
      attachSupportingDocuments?: boolean | null,
      selectedPocketKeys?: Array< string > | null,
      source: StatementSource,
      status: StatementStatus,
      sentDate?: string | null,
      leaseId?: string | null,
      lease?:  {
        __typename: "Lease",
        id: string,
        balance?: number | null,
        canBeExtended?: boolean | null,
        communicationSettingsProfileId: string,
        createdAt?: string | null,
        endDate: string,
        includeRealEstateInLeaseContract?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        invoiceSenderId: string,
        inventoryOfFixturesExpert?: string | null,
        inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
        inventoryOfFixturesType?: InventoryOfFixturesType | null,
        ipiNumber?: string | null,
        language: Language,
        lastDraftInvoiceDate?: string | null,
        lastIndexationProcessDate?: string | null,
        lastInvoiceDate?: string | null,
        legalCompetentAuthority?: string | null,
        name: string,
        notes?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        purchaseOrderNumber?: string | null,
        realEstateAgency?: string | null,
        realEstateTax?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        signatureDate?: string | null,
        startDate: string,
        nextIndexationMonth?: string | null,
        nextIndexation?: boolean | null,
        status: LeaseStatus,
        technicCommunicationSettingsProfileId: string,
        totalInitialRentalPrice: number,
        totalRentalPrice: number,
        type: LeaseType,
        subletting?: boolean | null,
        vatRateRentId?: string | null,
        bankAccountId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      agencyRateStatements?:  {
        __typename: "ModelAgencyRateStatementConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      ownerId?: string | null,
      owner?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      repaymentStatements?:  {
        __typename: "ModelRepaymentStatementConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      types?: Array< StatementType > | null,
      viewType: StatementViewType,
      unitIds?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    status: InvoiceStatus,
    type: InvoiceType,
    unitId?: string | null,
    unit?:  {
      __typename: "Unit",
      id: string,
      acquisitionAdditionalCostsValue?: number | null,
      acquisitionAdvertisedValue?: number | null,
      acquisitionValue?: number | null,
      advertisedMonthlyCharges?: number | null,
      advertisedRentalPrice?: number | null,
      cadastralIncome?: number | null,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      floor?: number | null,
      jointOwnershipId?: string | null,
      managementDate: string,
      name: string,
      notes?: string | null,
      predictedPrice?: string | null,
      propertyTax?: number | null,
      publishAddress?: boolean | null,
      surface?: number | null,
      type: UnitType,
      buildingId: string,
      building?:  {
        __typename: "Building",
        id: string,
        name: string,
        addressId?: string | null,
        acquisitionValue?: number | null,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        amountOfFacades?: number | null,
        amountOfFloors?: number | null,
        amountOfHousings?: number | null,
        buildingState?: BuildingState | null,
        cadastralIncome?: number | null,
        constructionYear?: string | null,
        janitor?: boolean | null,
        jointOwnershipId?: string | null,
        notes?: string | null,
        propertyTax?: number | null,
        residenceName?: string | null,
        buildingSiteId?: string | null,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      owners?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leases?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      events?:  {
        __typename: "ModelUnitEventConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      unitAdvertisementId?: string | null,
      unitInventories?:  {
        __typename: "ModelUnitInventoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    reversedInvoiceId?: string | null,
    readers?: Array< string > | null,
    readId: string,
    clientId: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListInvoicesQueryVariables = {
  filter?: ModelInvoiceFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListInvoicesQuery = {
  listInvoices?:  {
    __typename: "ModelInvoiceConnection",
    items:  Array< {
      __typename: "Invoice",
      id: string,
      amount: number,
      bankAccountId: string,
      bankAccount?:  {
        __typename: "BankAccount",
        id: string,
        contactId: string,
        number: string,
        bicNumber?: string | null,
        bankName?: string | null,
        contactIds?: Array< string > | null,
        buildingIds?: Array< string > | null,
        holderName?: string | null,
        label?: string | null,
        disabled?: boolean | null,
        integrations?: Array< IntegrationName > | null,
        matchingRule?: BankAccountMatchingRule | null,
        balance?: number | null,
        balanceDate?: string | null,
        type: BankAccountType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      communicationId?: string | null,
      communication?:  {
        __typename: "Communication",
        id: string,
        addressId?: string | null,
        body: string,
        buildingId?: string | null,
        channel: CommunicationChannel,
        communicationTemplateId?: string | null,
        concernedContactIds?: Array< string > | null,
        contactId?: string | null,
        contactIds?: Array< string > | null,
        createdAt?: string | null,
        expirationDate?: string | null,
        invoiceId?: string | null,
        leaseId?: string | null,
        leasePriceHistoryId?: string | null,
        letterTrackingCode?: string | null,
        letterTrackingProvider?: TrackingProvider | null,
        linkedCommunicationsIds?: Array< string > | null,
        supportingDocumentFileIds?: Array< string > | null,
        recipient?: string | null,
        recipientContactIdsInBcc?: Array< string > | null,
        recipientContactIdsInCc?: Array< string > | null,
        recipientInBcc?: string | null,
        recipientInCc?: string | null,
        scheduledAt?: string | null,
        deliveredAt?: string | null,
        errorCode?: CommunicationErrorCode | null,
        nextRetryAt?: string | null,
        sendRetryCount?: number | null,
        sender?: string | null,
        sentAt?: string | null,
        externalId?: string | null,
        externalStatus?: string | null,
        signatureDocumentId?: string | null,
        snoozedDate?: string | null,
        statementId?: string | null,
        status: CommunicationStatus,
        subject: string,
        toSend: boolean,
        hideLogo?: boolean | null,
        type: CommunicationType,
        _ttl?: number | null,
        unitId?: string | null,
        readId: string,
        readers?: Array< string > | null,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      createdAt: string,
      creditNote?: boolean | null,
      creditNoteLabel?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      dueDate?: string | null,
      invoiceDate: string,
      invoiceNumber?: string | null,
      ownerId?: string | null,
      owner?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      invoiceSenderId: string,
      invoiceSender?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      leaseId?: string | null,
      lease?:  {
        __typename: "Lease",
        id: string,
        balance?: number | null,
        canBeExtended?: boolean | null,
        communicationSettingsProfileId: string,
        createdAt?: string | null,
        endDate: string,
        includeRealEstateInLeaseContract?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        invoiceSenderId: string,
        inventoryOfFixturesExpert?: string | null,
        inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
        inventoryOfFixturesType?: InventoryOfFixturesType | null,
        ipiNumber?: string | null,
        language: Language,
        lastDraftInvoiceDate?: string | null,
        lastIndexationProcessDate?: string | null,
        lastInvoiceDate?: string | null,
        legalCompetentAuthority?: string | null,
        name: string,
        notes?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        purchaseOrderNumber?: string | null,
        realEstateAgency?: string | null,
        realEstateTax?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        signatureDate?: string | null,
        startDate: string,
        nextIndexationMonth?: string | null,
        nextIndexation?: boolean | null,
        status: LeaseStatus,
        technicCommunicationSettingsProfileId: string,
        totalInitialRentalPrice: number,
        totalRentalPrice: number,
        type: LeaseType,
        subletting?: boolean | null,
        vatRateRentId?: string | null,
        bankAccountId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      paid: boolean,
      integrations?:  {
        __typename: "InvoiceIntegrations",
      } | null,
      postedDate?: string | null,
      purchaseOrderNumber?: string | null,
      receiptNumber?: string | null,
      reminderDates?: Array< string > | null,
      note?: string | null,
      remittanceInformation?: string | null,
      statementId?: string | null,
      statement?:  {
        __typename: "Statement",
        id: string,
        closingStatement: boolean,
        periodFrom: string,
        periodTo: string,
        attachSupportingDocuments?: boolean | null,
        selectedPocketKeys?: Array< string > | null,
        source: StatementSource,
        status: StatementStatus,
        sentDate?: string | null,
        leaseId?: string | null,
        ownerId?: string | null,
        types?: Array< StatementType > | null,
        viewType: StatementViewType,
        unitIds?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      status: InvoiceStatus,
      type: InvoiceType,
      unitId?: string | null,
      unit?:  {
        __typename: "Unit",
        id: string,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        acquisitionValue?: number | null,
        advertisedMonthlyCharges?: number | null,
        advertisedRentalPrice?: number | null,
        cadastralIncome?: number | null,
        createdAt?: string | null,
        floor?: number | null,
        jointOwnershipId?: string | null,
        managementDate: string,
        name: string,
        notes?: string | null,
        predictedPrice?: string | null,
        propertyTax?: number | null,
        publishAddress?: boolean | null,
        surface?: number | null,
        type: UnitType,
        buildingId: string,
        unitAdvertisementId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      reversedInvoiceId?: string | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncInvoicesQueryVariables = {
  filter?: ModelInvoiceFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncInvoicesQuery = {
  syncInvoices?:  {
    __typename: "ModelInvoiceConnection",
    items:  Array< {
      __typename: "Invoice",
      id: string,
      amount: number,
      bankAccountId: string,
      bankAccount?:  {
        __typename: "BankAccount",
        id: string,
        contactId: string,
        number: string,
        bicNumber?: string | null,
        bankName?: string | null,
        contactIds?: Array< string > | null,
        buildingIds?: Array< string > | null,
        holderName?: string | null,
        label?: string | null,
        disabled?: boolean | null,
        integrations?: Array< IntegrationName > | null,
        matchingRule?: BankAccountMatchingRule | null,
        balance?: number | null,
        balanceDate?: string | null,
        type: BankAccountType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      communicationId?: string | null,
      communication?:  {
        __typename: "Communication",
        id: string,
        addressId?: string | null,
        body: string,
        buildingId?: string | null,
        channel: CommunicationChannel,
        communicationTemplateId?: string | null,
        concernedContactIds?: Array< string > | null,
        contactId?: string | null,
        contactIds?: Array< string > | null,
        createdAt?: string | null,
        expirationDate?: string | null,
        invoiceId?: string | null,
        leaseId?: string | null,
        leasePriceHistoryId?: string | null,
        letterTrackingCode?: string | null,
        letterTrackingProvider?: TrackingProvider | null,
        linkedCommunicationsIds?: Array< string > | null,
        supportingDocumentFileIds?: Array< string > | null,
        recipient?: string | null,
        recipientContactIdsInBcc?: Array< string > | null,
        recipientContactIdsInCc?: Array< string > | null,
        recipientInBcc?: string | null,
        recipientInCc?: string | null,
        scheduledAt?: string | null,
        deliveredAt?: string | null,
        errorCode?: CommunicationErrorCode | null,
        nextRetryAt?: string | null,
        sendRetryCount?: number | null,
        sender?: string | null,
        sentAt?: string | null,
        externalId?: string | null,
        externalStatus?: string | null,
        signatureDocumentId?: string | null,
        snoozedDate?: string | null,
        statementId?: string | null,
        status: CommunicationStatus,
        subject: string,
        toSend: boolean,
        hideLogo?: boolean | null,
        type: CommunicationType,
        _ttl?: number | null,
        unitId?: string | null,
        readId: string,
        readers?: Array< string > | null,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      createdAt: string,
      creditNote?: boolean | null,
      creditNoteLabel?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      dueDate?: string | null,
      invoiceDate: string,
      invoiceNumber?: string | null,
      ownerId?: string | null,
      owner?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      invoiceSenderId: string,
      invoiceSender?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      leaseId?: string | null,
      lease?:  {
        __typename: "Lease",
        id: string,
        balance?: number | null,
        canBeExtended?: boolean | null,
        communicationSettingsProfileId: string,
        createdAt?: string | null,
        endDate: string,
        includeRealEstateInLeaseContract?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        invoiceSenderId: string,
        inventoryOfFixturesExpert?: string | null,
        inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
        inventoryOfFixturesType?: InventoryOfFixturesType | null,
        ipiNumber?: string | null,
        language: Language,
        lastDraftInvoiceDate?: string | null,
        lastIndexationProcessDate?: string | null,
        lastInvoiceDate?: string | null,
        legalCompetentAuthority?: string | null,
        name: string,
        notes?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        purchaseOrderNumber?: string | null,
        realEstateAgency?: string | null,
        realEstateTax?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        signatureDate?: string | null,
        startDate: string,
        nextIndexationMonth?: string | null,
        nextIndexation?: boolean | null,
        status: LeaseStatus,
        technicCommunicationSettingsProfileId: string,
        totalInitialRentalPrice: number,
        totalRentalPrice: number,
        type: LeaseType,
        subletting?: boolean | null,
        vatRateRentId?: string | null,
        bankAccountId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      paid: boolean,
      integrations?:  {
        __typename: "InvoiceIntegrations",
      } | null,
      postedDate?: string | null,
      purchaseOrderNumber?: string | null,
      receiptNumber?: string | null,
      reminderDates?: Array< string > | null,
      note?: string | null,
      remittanceInformation?: string | null,
      statementId?: string | null,
      statement?:  {
        __typename: "Statement",
        id: string,
        closingStatement: boolean,
        periodFrom: string,
        periodTo: string,
        attachSupportingDocuments?: boolean | null,
        selectedPocketKeys?: Array< string > | null,
        source: StatementSource,
        status: StatementStatus,
        sentDate?: string | null,
        leaseId?: string | null,
        ownerId?: string | null,
        types?: Array< StatementType > | null,
        viewType: StatementViewType,
        unitIds?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      status: InvoiceStatus,
      type: InvoiceType,
      unitId?: string | null,
      unit?:  {
        __typename: "Unit",
        id: string,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        acquisitionValue?: number | null,
        advertisedMonthlyCharges?: number | null,
        advertisedRentalPrice?: number | null,
        cadastralIncome?: number | null,
        createdAt?: string | null,
        floor?: number | null,
        jointOwnershipId?: string | null,
        managementDate: string,
        name: string,
        notes?: string | null,
        predictedPrice?: string | null,
        propertyTax?: number | null,
        publishAddress?: boolean | null,
        surface?: number | null,
        type: UnitType,
        buildingId: string,
        unitAdvertisementId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      reversedInvoiceId?: string | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetInvoiceSettingQueryVariables = {
  id: string,
};

export type GetInvoiceSettingQuery = {
  getInvoiceSetting?:  {
    __typename: "InvoiceSetting",
    id: string,
    creditNoteFormat: string,
    creditNoteLastUpdate: string,
    creditNoteIncrementNumber: number,
    invoiceFormat: string,
    invoiceLastUpdate: string,
    invoiceIncrementNumber: number,
    paymentRequestFormat: string,
    paymentRequestLastUpdate: string,
    paymentRequestIncrementNumber: number,
    receiptFormat: string,
    receiptLastUpdate: string,
    receiptIncrementNumber: number,
    variousOperationFormat: string,
    variousOperationLastUpdate: string,
    variousOperationIncrementNumber: number,
    customInvoicingConfiguration?: boolean | null,
    defaultVatRateId?: string | null,
    fiscalYearStart?: string | null,
    allPurposeInvoiceIssuer?: boolean | null,
    paymentBankAccountId?: string | null,
    ownerId: string,
    owner?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListInvoiceSettingsQueryVariables = {
  filter?: ModelInvoiceSettingFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListInvoiceSettingsQuery = {
  listInvoiceSettings?:  {
    __typename: "ModelInvoiceSettingConnection",
    items:  Array< {
      __typename: "InvoiceSetting",
      id: string,
      creditNoteFormat: string,
      creditNoteLastUpdate: string,
      creditNoteIncrementNumber: number,
      invoiceFormat: string,
      invoiceLastUpdate: string,
      invoiceIncrementNumber: number,
      paymentRequestFormat: string,
      paymentRequestLastUpdate: string,
      paymentRequestIncrementNumber: number,
      receiptFormat: string,
      receiptLastUpdate: string,
      receiptIncrementNumber: number,
      variousOperationFormat: string,
      variousOperationLastUpdate: string,
      variousOperationIncrementNumber: number,
      customInvoicingConfiguration?: boolean | null,
      defaultVatRateId?: string | null,
      fiscalYearStart?: string | null,
      allPurposeInvoiceIssuer?: boolean | null,
      paymentBankAccountId?: string | null,
      ownerId: string,
      owner?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncInvoiceSettingsQueryVariables = {
  filter?: ModelInvoiceSettingFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncInvoiceSettingsQuery = {
  syncInvoiceSettings?:  {
    __typename: "ModelInvoiceSettingConnection",
    items:  Array< {
      __typename: "InvoiceSetting",
      id: string,
      creditNoteFormat: string,
      creditNoteLastUpdate: string,
      creditNoteIncrementNumber: number,
      invoiceFormat: string,
      invoiceLastUpdate: string,
      invoiceIncrementNumber: number,
      paymentRequestFormat: string,
      paymentRequestLastUpdate: string,
      paymentRequestIncrementNumber: number,
      receiptFormat: string,
      receiptLastUpdate: string,
      receiptIncrementNumber: number,
      variousOperationFormat: string,
      variousOperationLastUpdate: string,
      variousOperationIncrementNumber: number,
      customInvoicingConfiguration?: boolean | null,
      defaultVatRateId?: string | null,
      fiscalYearStart?: string | null,
      allPurposeInvoiceIssuer?: boolean | null,
      paymentBankAccountId?: string | null,
      ownerId: string,
      owner?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetLeaseQueryVariables = {
  id: string,
};

export type GetLeaseQuery = {
  getLease?:  {
    __typename: "Lease",
    id: string,
    advancedChargesInvoices?:  {
      __typename: "LeaseAdvancedChargesInvoice",
      communicationSettingsProfileId: string,
      invoiceSenderId: string,
      lastDraftInvoiceDate?: string | null,
      lastInvoiceDate?: string | null,
      paymentFrequency: LeasePaymentFrequency,
      paymentInvoicePeriod: LeasePaymentInvoicePeriod,
      paymentInvoicePeriodCustomDay?: number | null,
      remittanceInformation?: string | null,
      remittanceInformationType?: LeaseRemittanceType | null,
      bankAccountId?: string | null,
    } | null,
    balance?: number | null,
    canBeExtended?: boolean | null,
    communicationSettingsProfileId: string,
    createdAt?: string | null,
    customValues?:  Array< {
      __typename: "CustomValue",
      name: string,
      value: string,
    } > | null,
    endDate: string,
    includeRealEstateInLeaseContract?: boolean | null,
    attachStatementSupportingDocuments?: boolean | null,
    invoiceSenderId: string,
    invoiceSender?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    inventoryOfFixturesExpert?: string | null,
    inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
    inventoryOfFixturesType?: InventoryOfFixturesType | null,
    ipiNumber?: string | null,
    language: Language,
    lastDraftInvoiceDate?: string | null,
    lastIndexationProcessDate?: string | null,
    lastInvoiceDate?: string | null,
    legalCompetentAuthority?: string | null,
    name: string,
    notes?: string | null,
    paymentFrequency: LeasePaymentFrequency,
    paymentInvoicePeriod: LeasePaymentInvoicePeriod,
    paymentInvoicePeriodCustomDay?: number | null,
    paymentOption?:  {
      __typename: "LeasePaymentOption",
      customerId?: string | null,
      enabled: boolean,
      mandateActivatedAt?: string | null,
      mandateStatus?: PaymentProviderMandateStatus | null,
      paymentMethodId?: string | null,
      qrType?: LeaseQrType | null,
    } | null,
    purchaseOrderNumber?: string | null,
    realEstateAgency?: string | null,
    realEstateTax?: number | null,
    remittanceInformation?: string | null,
    remittanceInformationType?: LeaseRemittanceType | null,
    rentalGuaranty?:  {
      __typename: "LeaseRentalGuaranty",
      amount: number,
      blockedAmount?: number | null,
      releasedAmount?: number | null,
      type: LeaseRentalGuarantyType,
      financialInstitution?: string | null,
    } | null,
    signatureDate?: string | null,
    startDate: string,
    nextIndexationMonth?: string | null,
    nextIndexation?: boolean | null,
    status: LeaseStatus,
    technicCommunicationSettingsProfileId: string,
    totalInitialRentalPrice: number,
    totalRentalPrice: number,
    type: LeaseType,
    subletting?: boolean | null,
    vatRateRentId?: string | null,
    vatRateRent?:  {
      __typename: "VatRate",
      id: string,
      country: string,
      label: string,
      value?: number | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      ownerId?: string | null,
      owner?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    additionalClauses?:  {
      __typename: "ModelLeaseAdditionalClauseConnection",
      items:  Array< {
        __typename: "LeaseAdditionalClause",
        id: string,
        leaseId: string,
        title?: string | null,
        body: string,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    bankAccountId?: string | null,
    bankAccount?:  {
      __typename: "BankAccount",
      id: string,
      contactId: string,
      contact?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      number: string,
      bicNumber?: string | null,
      bankName?: string | null,
      contactIds?: Array< string > | null,
      buildingIds?: Array< string > | null,
      holderName?: string | null,
      label?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      disabled?: boolean | null,
      integrations?: Array< IntegrationName > | null,
      matchingRule?: BankAccountMatchingRule | null,
      balance?: number | null,
      balanceDate?: string | null,
      type: BankAccountType,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    contacts?:  {
      __typename: "ModelLeaseContactConnection",
      items:  Array< {
        __typename: "LeaseContact",
        id: string,
        leaseId: string,
        contactId: string,
        contactRole: ContactType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    files?:  {
      __typename: "ModelFileConnection",
      items:  Array< {
        __typename: "File",
        id: string,
        bucket: string,
        createdAt?: string | null,
        categoryId: string,
        foreignKey: string,
        foreignTableName: string,
        key: string,
        mimeType?: string | null,
        region: string,
        size?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        _ttl?: number | null,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    leaseActionHistories?:  {
      __typename: "ModelLeaseActionHistoryConnection",
      items:  Array< {
        __typename: "LeaseActionHistory",
        id: string,
        action: LeaseAction,
        comment?: string | null,
        contactId: string,
        createdAt?: string | null,
        leaseId: string,
        communicationId?: string | null,
        signatureDocumentId?: string | null,
        status?: LeaseActionHistoryStatus | null,
        communicationChannel?: CommunicationChannel | null,
        communicationSendDate?: string | null,
        communicationByPlatform?: boolean | null,
        endReason?: LeaseActionEndReason | null,
        endReasonOwnUseRelation?: string | null,
        endReasonOwnUseName?: string | null,
        initiator?: LeaseActionEndInitiator | null,
        totalAmount?: number | null,
        totalAmountLabel?: string | null,
        automatic?: boolean | null,
        hasLeaseTypeChanged?: boolean | null,
        jiraId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    leasePriceHistories?:  {
      __typename: "ModelLeasePriceHistoryConnection",
      items:  Array< {
        __typename: "LeasePriceHistory",
        id: string,
        previousTotalRentalPrice: number,
        totalRentalPrice: number,
        optimalTotalRentalPrice?: number | null,
        optimalTotalMonthlyCharges?: number | null,
        applicationDate: string,
        status: LeaseAmountUpdateStatus,
        comment?: string | null,
        type: LeasePriceHistoryType,
        communicationId?: string | null,
        leaseId: string,
        createdAt?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    signatureDocuments?:  {
      __typename: "ModelSignatureDocumentConnection",
      items:  Array< {
        __typename: "SignatureDocument",
        id: string,
        additionalMessage?: string | null,
        automaticRemindersDisabled?: boolean | null,
        communicationBody?: string | null,
        createdAt?: string | null,
        expirationDate?: string | null,
        fileIds?: Array< string > | null,
        foreignKey: string,
        foreignTableName: string,
        sentAt?: string | null,
        signatureMethods: Array< SignatureType >,
        status: SignatureDocumentStatus,
        externalStatus?: string | null,
        type: SignatureDocumentType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    units?:  {
      __typename: "ModelUnitLeaseConnection",
      items:  Array< {
        __typename: "UnitLease",
        id: string,
        allowChargeAdjustment?: boolean | null,
        authorizeProfessionalActivity?: boolean | null,
        chargesIndexation?: boolean | null,
        createdAt?: string | null,
        endDate: string,
        furnishedRental?: boolean | null,
        furnishedRentalInsuranceByTenant?: boolean | null,
        furnishedRentalRentalPricePercentage?: number | null,
        initialRentalPrice: number,
        indexation?: boolean | null,
        advancedIndexation?: boolean | null,
        indexType?: IndexType | null,
        baseYear?: number | null,
        baseIndexType?: BaseIndexType | null,
        baseIndexDate?: string | null,
        nextIndexationMonth?: string | null,
        nextIndexation?: boolean | null,
        leaseId: string,
        mainUnit: boolean,
        rentalPrice: number,
        signatureDate?: string | null,
        startDate: string,
        unitId: string,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    variousOperations?:  {
      __typename: "ModelLeaseVariousOperationConnection",
      items:  Array< {
        __typename: "LeaseVariousOperation",
        id: string,
        accountLabelIds?: Array< string > | null,
        amount: number,
        contactId: string,
        createdAt: string,
        endDate: string,
        invoiceSenderId?: string | null,
        label?: string | null,
        lastInvoiceDate?: string | null,
        leaseId: string,
        operationType: LeaseVariousOperationType,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        reason?: string | null,
        separateInvoice: boolean,
        startDate: string,
        type: VariousOperationType,
        unitId: string,
        vatRateId?: string | null,
        readId: string,
        readers?: Array< string > | null,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    readers?: Array< string > | null,
    readId: string,
    clientId: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListLeasesQueryVariables = {
  filter?: ModelLeaseFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListLeasesQuery = {
  listLeases?:  {
    __typename: "ModelLeaseConnection",
    items:  Array< {
      __typename: "Lease",
      id: string,
      advancedChargesInvoices?:  {
        __typename: "LeaseAdvancedChargesInvoice",
        communicationSettingsProfileId: string,
        invoiceSenderId: string,
        lastDraftInvoiceDate?: string | null,
        lastInvoiceDate?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        bankAccountId?: string | null,
      } | null,
      balance?: number | null,
      canBeExtended?: boolean | null,
      communicationSettingsProfileId: string,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      endDate: string,
      includeRealEstateInLeaseContract?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      invoiceSenderId: string,
      invoiceSender?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      inventoryOfFixturesExpert?: string | null,
      inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
      inventoryOfFixturesType?: InventoryOfFixturesType | null,
      ipiNumber?: string | null,
      language: Language,
      lastDraftInvoiceDate?: string | null,
      lastIndexationProcessDate?: string | null,
      lastInvoiceDate?: string | null,
      legalCompetentAuthority?: string | null,
      name: string,
      notes?: string | null,
      paymentFrequency: LeasePaymentFrequency,
      paymentInvoicePeriod: LeasePaymentInvoicePeriod,
      paymentInvoicePeriodCustomDay?: number | null,
      paymentOption?:  {
        __typename: "LeasePaymentOption",
        customerId?: string | null,
        enabled: boolean,
        mandateActivatedAt?: string | null,
        mandateStatus?: PaymentProviderMandateStatus | null,
        paymentMethodId?: string | null,
        qrType?: LeaseQrType | null,
      } | null,
      purchaseOrderNumber?: string | null,
      realEstateAgency?: string | null,
      realEstateTax?: number | null,
      remittanceInformation?: string | null,
      remittanceInformationType?: LeaseRemittanceType | null,
      rentalGuaranty?:  {
        __typename: "LeaseRentalGuaranty",
        amount: number,
        blockedAmount?: number | null,
        releasedAmount?: number | null,
        type: LeaseRentalGuarantyType,
        financialInstitution?: string | null,
      } | null,
      signatureDate?: string | null,
      startDate: string,
      nextIndexationMonth?: string | null,
      nextIndexation?: boolean | null,
      status: LeaseStatus,
      technicCommunicationSettingsProfileId: string,
      totalInitialRentalPrice: number,
      totalRentalPrice: number,
      type: LeaseType,
      subletting?: boolean | null,
      vatRateRentId?: string | null,
      vatRateRent?:  {
        __typename: "VatRate",
        id: string,
        country: string,
        label: string,
        value?: number | null,
        ownerId?: string | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      additionalClauses?:  {
        __typename: "ModelLeaseAdditionalClauseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      bankAccountId?: string | null,
      bankAccount?:  {
        __typename: "BankAccount",
        id: string,
        contactId: string,
        number: string,
        bicNumber?: string | null,
        bankName?: string | null,
        contactIds?: Array< string > | null,
        buildingIds?: Array< string > | null,
        holderName?: string | null,
        label?: string | null,
        disabled?: boolean | null,
        integrations?: Array< IntegrationName > | null,
        matchingRule?: BankAccountMatchingRule | null,
        balance?: number | null,
        balanceDate?: string | null,
        type: BankAccountType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contacts?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      files?:  {
        __typename: "ModelFileConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leaseActionHistories?:  {
        __typename: "ModelLeaseActionHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leasePriceHistories?:  {
        __typename: "ModelLeasePriceHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      signatureDocuments?:  {
        __typename: "ModelSignatureDocumentConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      variousOperations?:  {
        __typename: "ModelLeaseVariousOperationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncLeasesQueryVariables = {
  filter?: ModelLeaseFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncLeasesQuery = {
  syncLeases?:  {
    __typename: "ModelLeaseConnection",
    items:  Array< {
      __typename: "Lease",
      id: string,
      advancedChargesInvoices?:  {
        __typename: "LeaseAdvancedChargesInvoice",
        communicationSettingsProfileId: string,
        invoiceSenderId: string,
        lastDraftInvoiceDate?: string | null,
        lastInvoiceDate?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        bankAccountId?: string | null,
      } | null,
      balance?: number | null,
      canBeExtended?: boolean | null,
      communicationSettingsProfileId: string,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      endDate: string,
      includeRealEstateInLeaseContract?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      invoiceSenderId: string,
      invoiceSender?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      inventoryOfFixturesExpert?: string | null,
      inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
      inventoryOfFixturesType?: InventoryOfFixturesType | null,
      ipiNumber?: string | null,
      language: Language,
      lastDraftInvoiceDate?: string | null,
      lastIndexationProcessDate?: string | null,
      lastInvoiceDate?: string | null,
      legalCompetentAuthority?: string | null,
      name: string,
      notes?: string | null,
      paymentFrequency: LeasePaymentFrequency,
      paymentInvoicePeriod: LeasePaymentInvoicePeriod,
      paymentInvoicePeriodCustomDay?: number | null,
      paymentOption?:  {
        __typename: "LeasePaymentOption",
        customerId?: string | null,
        enabled: boolean,
        mandateActivatedAt?: string | null,
        mandateStatus?: PaymentProviderMandateStatus | null,
        paymentMethodId?: string | null,
        qrType?: LeaseQrType | null,
      } | null,
      purchaseOrderNumber?: string | null,
      realEstateAgency?: string | null,
      realEstateTax?: number | null,
      remittanceInformation?: string | null,
      remittanceInformationType?: LeaseRemittanceType | null,
      rentalGuaranty?:  {
        __typename: "LeaseRentalGuaranty",
        amount: number,
        blockedAmount?: number | null,
        releasedAmount?: number | null,
        type: LeaseRentalGuarantyType,
        financialInstitution?: string | null,
      } | null,
      signatureDate?: string | null,
      startDate: string,
      nextIndexationMonth?: string | null,
      nextIndexation?: boolean | null,
      status: LeaseStatus,
      technicCommunicationSettingsProfileId: string,
      totalInitialRentalPrice: number,
      totalRentalPrice: number,
      type: LeaseType,
      subletting?: boolean | null,
      vatRateRentId?: string | null,
      vatRateRent?:  {
        __typename: "VatRate",
        id: string,
        country: string,
        label: string,
        value?: number | null,
        ownerId?: string | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      additionalClauses?:  {
        __typename: "ModelLeaseAdditionalClauseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      bankAccountId?: string | null,
      bankAccount?:  {
        __typename: "BankAccount",
        id: string,
        contactId: string,
        number: string,
        bicNumber?: string | null,
        bankName?: string | null,
        contactIds?: Array< string > | null,
        buildingIds?: Array< string > | null,
        holderName?: string | null,
        label?: string | null,
        disabled?: boolean | null,
        integrations?: Array< IntegrationName > | null,
        matchingRule?: BankAccountMatchingRule | null,
        balance?: number | null,
        balanceDate?: string | null,
        type: BankAccountType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contacts?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      files?:  {
        __typename: "ModelFileConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leaseActionHistories?:  {
        __typename: "ModelLeaseActionHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leasePriceHistories?:  {
        __typename: "ModelLeasePriceHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      signatureDocuments?:  {
        __typename: "ModelSignatureDocumentConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      variousOperations?:  {
        __typename: "ModelLeaseVariousOperationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetLeaseActionHistoryQueryVariables = {
  id: string,
};

export type GetLeaseActionHistoryQuery = {
  getLeaseActionHistory?:  {
    __typename: "LeaseActionHistory",
    id: string,
    action: LeaseAction,
    comment?: string | null,
    contactId: string,
    createdAt?: string | null,
    createdBy?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    historyDetails:  Array< {
      __typename: "LeaseActionHistoryDetail",
      unitId: string,
      newEndDate?: string | null,
      newSignatureDate?: string | null,
      newStartDate?: string | null,
      previousEndDate?: string | null,
      previousSignatureDate?: string | null,
      previousStartDate?: string | null,
    } >,
    leaseId: string,
    lease?:  {
      __typename: "Lease",
      id: string,
      advancedChargesInvoices?:  {
        __typename: "LeaseAdvancedChargesInvoice",
        communicationSettingsProfileId: string,
        invoiceSenderId: string,
        lastDraftInvoiceDate?: string | null,
        lastInvoiceDate?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        bankAccountId?: string | null,
      } | null,
      balance?: number | null,
      canBeExtended?: boolean | null,
      communicationSettingsProfileId: string,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      endDate: string,
      includeRealEstateInLeaseContract?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      invoiceSenderId: string,
      invoiceSender?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      inventoryOfFixturesExpert?: string | null,
      inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
      inventoryOfFixturesType?: InventoryOfFixturesType | null,
      ipiNumber?: string | null,
      language: Language,
      lastDraftInvoiceDate?: string | null,
      lastIndexationProcessDate?: string | null,
      lastInvoiceDate?: string | null,
      legalCompetentAuthority?: string | null,
      name: string,
      notes?: string | null,
      paymentFrequency: LeasePaymentFrequency,
      paymentInvoicePeriod: LeasePaymentInvoicePeriod,
      paymentInvoicePeriodCustomDay?: number | null,
      paymentOption?:  {
        __typename: "LeasePaymentOption",
        customerId?: string | null,
        enabled: boolean,
        mandateActivatedAt?: string | null,
        mandateStatus?: PaymentProviderMandateStatus | null,
        paymentMethodId?: string | null,
        qrType?: LeaseQrType | null,
      } | null,
      purchaseOrderNumber?: string | null,
      realEstateAgency?: string | null,
      realEstateTax?: number | null,
      remittanceInformation?: string | null,
      remittanceInformationType?: LeaseRemittanceType | null,
      rentalGuaranty?:  {
        __typename: "LeaseRentalGuaranty",
        amount: number,
        blockedAmount?: number | null,
        releasedAmount?: number | null,
        type: LeaseRentalGuarantyType,
        financialInstitution?: string | null,
      } | null,
      signatureDate?: string | null,
      startDate: string,
      nextIndexationMonth?: string | null,
      nextIndexation?: boolean | null,
      status: LeaseStatus,
      technicCommunicationSettingsProfileId: string,
      totalInitialRentalPrice: number,
      totalRentalPrice: number,
      type: LeaseType,
      subletting?: boolean | null,
      vatRateRentId?: string | null,
      vatRateRent?:  {
        __typename: "VatRate",
        id: string,
        country: string,
        label: string,
        value?: number | null,
        ownerId?: string | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      additionalClauses?:  {
        __typename: "ModelLeaseAdditionalClauseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      bankAccountId?: string | null,
      bankAccount?:  {
        __typename: "BankAccount",
        id: string,
        contactId: string,
        number: string,
        bicNumber?: string | null,
        bankName?: string | null,
        contactIds?: Array< string > | null,
        buildingIds?: Array< string > | null,
        holderName?: string | null,
        label?: string | null,
        disabled?: boolean | null,
        integrations?: Array< IntegrationName > | null,
        matchingRule?: BankAccountMatchingRule | null,
        balance?: number | null,
        balanceDate?: string | null,
        type: BankAccountType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contacts?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      files?:  {
        __typename: "ModelFileConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leaseActionHistories?:  {
        __typename: "ModelLeaseActionHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leasePriceHistories?:  {
        __typename: "ModelLeasePriceHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      signatureDocuments?:  {
        __typename: "ModelSignatureDocumentConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      variousOperations?:  {
        __typename: "ModelLeaseVariousOperationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    communicationId?: string | null,
    communication?:  {
      __typename: "Communication",
      id: string,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      blockedRecipients?:  Array< {
        __typename: "CommunicationBlockedRecipient",
        recipient: string,
        bounceType: BounceType,
      } > | null,
      body: string,
      buildingId?: string | null,
      channel: CommunicationChannel,
      communicationTemplateId?: string | null,
      concernedContactIds?: Array< string > | null,
      contactId?: string | null,
      contactIds?: Array< string > | null,
      createdAt?: string | null,
      draftProperties?:  {
        __typename: "CommunicationDraftProperties",
        allowRecipientsToSeeEachOther?: boolean | null,
        bcc?: Array< string > | null,
        buildingIds?: Array< string > | null,
        cc?: Array< string > | null,
        contactIds?: Array< string > | null,
        contactTypes?: Array< ContactType > | null,
        entityType: string,
        leaseIds?: Array< string > | null,
        sendInBcc?: boolean | null,
        unitIds?: Array< string > | null,
        unitTypeFilter?: string | null,
      } | null,
      expirationDate?: string | null,
      files?:  {
        __typename: "ModelFileConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      invoice?:  {
        __typename: "Invoice",
        id: string,
        amount: number,
        bankAccountId: string,
        communicationId?: string | null,
        createdAt: string,
        creditNote?: boolean | null,
        creditNoteLabel?: string | null,
        dueDate?: string | null,
        invoiceDate: string,
        invoiceNumber?: string | null,
        ownerId?: string | null,
        invoiceSenderId: string,
        leaseId?: string | null,
        paid: boolean,
        postedDate?: string | null,
        receiptNumber?: string | null,
        reminderDates?: Array< string > | null,
        remittanceInformation?: string | null,
        statementId?: string | null,
        status: InvoiceStatus,
        type: InvoiceType,
        unitId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      invoiceId?: string | null,
      lease?:  {
        __typename: "Lease",
        id: string,
        balance?: number | null,
        canBeExtended?: boolean | null,
        communicationSettingsProfileId: string,
        createdAt?: string | null,
        endDate: string,
        includeRealEstateInLeaseContract?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        invoiceSenderId: string,
        inventoryOfFixturesExpert?: string | null,
        inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
        inventoryOfFixturesType?: InventoryOfFixturesType | null,
        ipiNumber?: string | null,
        language: Language,
        lastIndexationProcessDate?: string | null,
        lastInvoiceDate?: string | null,
        legalCompetentAuthority?: string | null,
        name: string,
        notes?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        realEstateAgency?: string | null,
        realEstateTax?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        signatureDate?: string | null,
        startDate: string,
        nextIndexationMonth?: string | null,
        nextIndexation?: boolean | null,
        status: LeaseStatus,
        technicCommunicationSettingsProfileId: string,
        totalInitialRentalPrice: number,
        totalRentalPrice: number,
        type: LeaseType,
        subletting?: boolean | null,
        vatRateRentId?: string | null,
        bankAccountId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      leaseId?: string | null,
      leasePriceHistoryId?: string | null,
      leasePriceHistory?:  {
        __typename: "LeasePriceHistory",
        id: string,
        previousTotalRentalPrice: number,
        totalRentalPrice: number,
        optimalTotalRentalPrice?: number | null,
        optimalTotalMonthlyCharges?: number | null,
        applicationDate: string,
        status: LeaseAmountUpdateStatus,
        comment?: string | null,
        type: LeasePriceHistoryType,
        communicationId?: string | null,
        leaseId: string,
        createdAt?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      letterTrackingCode?: string | null,
      letterTrackingProvider?: TrackingProvider | null,
      linkedCommunicationsIds?: Array< string > | null,
      supportingDocumentFileIds?: Array< string > | null,
      recipient?: string | null,
      recipientContactIdsInBcc?: Array< string > | null,
      recipientContactIdsInCc?: Array< string > | null,
      recipientInBcc?: string | null,
      recipientInCc?: string | null,
      scheduledAt?: string | null,
      deliveredAt?: string | null,
      errorCode?: CommunicationErrorCode | null,
      nextRetryAt?: string | null,
      sendRetryCount?: number | null,
      sender?: string | null,
      sentAt?: string | null,
      externalId?: string | null,
      externalStatus?: string | null,
      signatureDocumentId?: string | null,
      signatureDocument?:  {
        __typename: "SignatureDocument",
        id: string,
        additionalMessage?: string | null,
        automaticRemindersDisabled?: boolean | null,
        communicationBody?: string | null,
        createdAt?: string | null,
        expirationDate?: string | null,
        fileIds?: Array< string > | null,
        foreignKey: string,
        foreignTableName: string,
        sentAt?: string | null,
        signatureMethods: Array< SignatureType >,
        status: SignatureDocumentStatus,
        externalStatus?: string | null,
        type: SignatureDocumentType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      snoozedDate?: string | null,
      statement?:  {
        __typename: "Statement",
        id: string,
        closingStatement: boolean,
        periodFrom: string,
        periodTo: string,
        attachSupportingDocuments?: boolean | null,
        selectedPocketKeys?: Array< string > | null,
        source: StatementSource,
        status: StatementStatus,
        sentDate?: string | null,
        leaseId?: string | null,
        ownerId?: string | null,
        types?: Array< StatementType > | null,
        viewType: StatementViewType,
        unitIds?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      statementId?: string | null,
      status: CommunicationStatus,
      subject: string,
      toSend: boolean,
      hideLogo?: boolean | null,
      type: CommunicationType,
      _ttl?: number | null,
      unit?:  {
        __typename: "Unit",
        id: string,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        acquisitionValue?: number | null,
        advertisedMonthlyCharges?: number | null,
        advertisedRentalPrice?: number | null,
        cadastralIncome?: number | null,
        createdAt?: string | null,
        floor?: number | null,
        jointOwnershipId?: string | null,
        managementDate: string,
        name: string,
        notes?: string | null,
        predictedPrice?: string | null,
        propertyTax?: number | null,
        publishAddress?: boolean | null,
        surface?: number | null,
        type: UnitType,
        buildingId: string,
        unitAdvertisementId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      unitId?: string | null,
      readId: string,
      readers?: Array< string > | null,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    signatureDocumentId?: string | null,
    signatureDocument?:  {
      __typename: "SignatureDocument",
      id: string,
      additionalMessage?: string | null,
      automaticRemindersDisabled?: boolean | null,
      communicationBody?: string | null,
      createdAt?: string | null,
      expirationDate?: string | null,
      fileIds?: Array< string > | null,
      foreignKey: string,
      foreignTableName: string,
      sentAt?: string | null,
      signatureMethods: Array< SignatureType >,
      signatureResults:  Array< {
        __typename: "SignatureDocumentResult",
        openedDate?: string | null,
        signedDate?: string | null,
        signed?: boolean | null,
        signatureLink?: string | null,
        rejectReason?: string | null,
        lastSignInviteSentDate?: string | null,
        reminderDates?: Array< string > | null,
        trackingProvider?: TrackingProvider | null,
        trackingCode?: string | null,
        contactId: string,
      } >,
      status: SignatureDocumentStatus,
      externalStatus?: string | null,
      type: SignatureDocumentType,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    status?: LeaseActionHistoryStatus | null,
    communicationChannel?: CommunicationChannel | null,
    communicationSendDate?: string | null,
    communicationByPlatform?: boolean | null,
    endReason?: LeaseActionEndReason | null,
    endReasonOwnUseRelation?: string | null,
    endReasonOwnUseName?: string | null,
    initiator?: LeaseActionEndInitiator | null,
    totalAmount?: number | null,
    totalAmountLabel?: string | null,
    automatic?: boolean | null,
    hasLeaseTypeChanged?: boolean | null,
    jiraId?: string | null,
    readers?: Array< string > | null,
    readId: string,
    clientId: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListLeaseActionHistoriesQueryVariables = {
  filter?: ModelLeaseActionHistoryFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListLeaseActionHistoriesQuery = {
  listLeaseActionHistories?:  {
    __typename: "ModelLeaseActionHistoryConnection",
    items:  Array< {
      __typename: "LeaseActionHistory",
      id: string,
      action: LeaseAction,
      comment?: string | null,
      contactId: string,
      createdAt?: string | null,
      createdBy?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      historyDetails:  Array< {
        __typename: "LeaseActionHistoryDetail",
        unitId: string,
        newEndDate?: string | null,
        newSignatureDate?: string | null,
        newStartDate?: string | null,
        previousEndDate?: string | null,
        previousSignatureDate?: string | null,
        previousStartDate?: string | null,
      } >,
      leaseId: string,
      lease?:  {
        __typename: "Lease",
        id: string,
        balance?: number | null,
        canBeExtended?: boolean | null,
        communicationSettingsProfileId: string,
        createdAt?: string | null,
        endDate: string,
        includeRealEstateInLeaseContract?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        invoiceSenderId: string,
        inventoryOfFixturesExpert?: string | null,
        inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
        inventoryOfFixturesType?: InventoryOfFixturesType | null,
        ipiNumber?: string | null,
        language: Language,
        lastDraftInvoiceDate?: string | null,
        lastIndexationProcessDate?: string | null,
        lastInvoiceDate?: string | null,
        legalCompetentAuthority?: string | null,
        name: string,
        notes?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        purchaseOrderNumber?: string | null,
        realEstateAgency?: string | null,
        realEstateTax?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        signatureDate?: string | null,
        startDate: string,
        nextIndexationMonth?: string | null,
        nextIndexation?: boolean | null,
        status: LeaseStatus,
        technicCommunicationSettingsProfileId: string,
        totalInitialRentalPrice: number,
        totalRentalPrice: number,
        type: LeaseType,
        subletting?: boolean | null,
        vatRateRentId?: string | null,
        bankAccountId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      communicationId?: string | null,
      communication?:  {
        __typename: "Communication",
        id: string,
        addressId?: string | null,
        body: string,
        buildingId?: string | null,
        channel: CommunicationChannel,
        communicationTemplateId?: string | null,
        concernedContactIds?: Array< string > | null,
        contactId?: string | null,
        contactIds?: Array< string > | null,
        createdAt?: string | null,
        expirationDate?: string | null,
        invoiceId?: string | null,
        leaseId?: string | null,
        leasePriceHistoryId?: string | null,
        letterTrackingCode?: string | null,
        letterTrackingProvider?: TrackingProvider | null,
        linkedCommunicationsIds?: Array< string > | null,
        supportingDocumentFileIds?: Array< string > | null,
        recipient?: string | null,
        recipientContactIdsInBcc?: Array< string > | null,
        recipientContactIdsInCc?: Array< string > | null,
        recipientInBcc?: string | null,
        recipientInCc?: string | null,
        scheduledAt?: string | null,
        deliveredAt?: string | null,
        errorCode?: CommunicationErrorCode | null,
        nextRetryAt?: string | null,
        sendRetryCount?: number | null,
        sender?: string | null,
        sentAt?: string | null,
        externalId?: string | null,
        externalStatus?: string | null,
        signatureDocumentId?: string | null,
        snoozedDate?: string | null,
        statementId?: string | null,
        status: CommunicationStatus,
        subject: string,
        toSend: boolean,
        hideLogo?: boolean | null,
        type: CommunicationType,
        _ttl?: number | null,
        unitId?: string | null,
        readId: string,
        readers?: Array< string > | null,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      signatureDocumentId?: string | null,
      signatureDocument?:  {
        __typename: "SignatureDocument",
        id: string,
        additionalMessage?: string | null,
        automaticRemindersDisabled?: boolean | null,
        communicationBody?: string | null,
        createdAt?: string | null,
        expirationDate?: string | null,
        fileIds?: Array< string > | null,
        foreignKey: string,
        foreignTableName: string,
        sentAt?: string | null,
        signatureMethods: Array< SignatureType >,
        status: SignatureDocumentStatus,
        externalStatus?: string | null,
        type: SignatureDocumentType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      status?: LeaseActionHistoryStatus | null,
      communicationChannel?: CommunicationChannel | null,
      communicationSendDate?: string | null,
      communicationByPlatform?: boolean | null,
      endReason?: LeaseActionEndReason | null,
      endReasonOwnUseRelation?: string | null,
      endReasonOwnUseName?: string | null,
      initiator?: LeaseActionEndInitiator | null,
      totalAmount?: number | null,
      totalAmountLabel?: string | null,
      automatic?: boolean | null,
      hasLeaseTypeChanged?: boolean | null,
      jiraId?: string | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncLeaseActionHistoriesQueryVariables = {
  filter?: ModelLeaseActionHistoryFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncLeaseActionHistoriesQuery = {
  syncLeaseActionHistories?:  {
    __typename: "ModelLeaseActionHistoryConnection",
    items:  Array< {
      __typename: "LeaseActionHistory",
      id: string,
      action: LeaseAction,
      comment?: string | null,
      contactId: string,
      createdAt?: string | null,
      createdBy?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      historyDetails:  Array< {
        __typename: "LeaseActionHistoryDetail",
        unitId: string,
        newEndDate?: string | null,
        newSignatureDate?: string | null,
        newStartDate?: string | null,
        previousEndDate?: string | null,
        previousSignatureDate?: string | null,
        previousStartDate?: string | null,
      } >,
      leaseId: string,
      lease?:  {
        __typename: "Lease",
        id: string,
        balance?: number | null,
        canBeExtended?: boolean | null,
        communicationSettingsProfileId: string,
        createdAt?: string | null,
        endDate: string,
        includeRealEstateInLeaseContract?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        invoiceSenderId: string,
        inventoryOfFixturesExpert?: string | null,
        inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
        inventoryOfFixturesType?: InventoryOfFixturesType | null,
        ipiNumber?: string | null,
        language: Language,
        lastDraftInvoiceDate?: string | null,
        lastIndexationProcessDate?: string | null,
        lastInvoiceDate?: string | null,
        legalCompetentAuthority?: string | null,
        name: string,
        notes?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        purchaseOrderNumber?: string | null,
        realEstateAgency?: string | null,
        realEstateTax?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        signatureDate?: string | null,
        startDate: string,
        nextIndexationMonth?: string | null,
        nextIndexation?: boolean | null,
        status: LeaseStatus,
        technicCommunicationSettingsProfileId: string,
        totalInitialRentalPrice: number,
        totalRentalPrice: number,
        type: LeaseType,
        subletting?: boolean | null,
        vatRateRentId?: string | null,
        bankAccountId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      communicationId?: string | null,
      communication?:  {
        __typename: "Communication",
        id: string,
        addressId?: string | null,
        body: string,
        buildingId?: string | null,
        channel: CommunicationChannel,
        communicationTemplateId?: string | null,
        concernedContactIds?: Array< string > | null,
        contactId?: string | null,
        contactIds?: Array< string > | null,
        createdAt?: string | null,
        expirationDate?: string | null,
        invoiceId?: string | null,
        leaseId?: string | null,
        leasePriceHistoryId?: string | null,
        letterTrackingCode?: string | null,
        letterTrackingProvider?: TrackingProvider | null,
        linkedCommunicationsIds?: Array< string > | null,
        supportingDocumentFileIds?: Array< string > | null,
        recipient?: string | null,
        recipientContactIdsInBcc?: Array< string > | null,
        recipientContactIdsInCc?: Array< string > | null,
        recipientInBcc?: string | null,
        recipientInCc?: string | null,
        scheduledAt?: string | null,
        deliveredAt?: string | null,
        errorCode?: CommunicationErrorCode | null,
        nextRetryAt?: string | null,
        sendRetryCount?: number | null,
        sender?: string | null,
        sentAt?: string | null,
        externalId?: string | null,
        externalStatus?: string | null,
        signatureDocumentId?: string | null,
        snoozedDate?: string | null,
        statementId?: string | null,
        status: CommunicationStatus,
        subject: string,
        toSend: boolean,
        hideLogo?: boolean | null,
        type: CommunicationType,
        _ttl?: number | null,
        unitId?: string | null,
        readId: string,
        readers?: Array< string > | null,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      signatureDocumentId?: string | null,
      signatureDocument?:  {
        __typename: "SignatureDocument",
        id: string,
        additionalMessage?: string | null,
        automaticRemindersDisabled?: boolean | null,
        communicationBody?: string | null,
        createdAt?: string | null,
        expirationDate?: string | null,
        fileIds?: Array< string > | null,
        foreignKey: string,
        foreignTableName: string,
        sentAt?: string | null,
        signatureMethods: Array< SignatureType >,
        status: SignatureDocumentStatus,
        externalStatus?: string | null,
        type: SignatureDocumentType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      status?: LeaseActionHistoryStatus | null,
      communicationChannel?: CommunicationChannel | null,
      communicationSendDate?: string | null,
      communicationByPlatform?: boolean | null,
      endReason?: LeaseActionEndReason | null,
      endReasonOwnUseRelation?: string | null,
      endReasonOwnUseName?: string | null,
      initiator?: LeaseActionEndInitiator | null,
      totalAmount?: number | null,
      totalAmountLabel?: string | null,
      automatic?: boolean | null,
      hasLeaseTypeChanged?: boolean | null,
      jiraId?: string | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetLeaseAdditionalClauseQueryVariables = {
  id: string,
};

export type GetLeaseAdditionalClauseQuery = {
  getLeaseAdditionalClause?:  {
    __typename: "LeaseAdditionalClause",
    id: string,
    leaseId: string,
    lease?:  {
      __typename: "Lease",
      id: string,
      advancedChargesInvoices?:  {
        __typename: "LeaseAdvancedChargesInvoice",
        communicationSettingsProfileId: string,
        invoiceSenderId: string,
        lastDraftInvoiceDate?: string | null,
        lastInvoiceDate?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        bankAccountId?: string | null,
      } | null,
      balance?: number | null,
      canBeExtended?: boolean | null,
      communicationSettingsProfileId: string,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      endDate: string,
      includeRealEstateInLeaseContract?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      invoiceSenderId: string,
      invoiceSender?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      inventoryOfFixturesExpert?: string | null,
      inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
      inventoryOfFixturesType?: InventoryOfFixturesType | null,
      ipiNumber?: string | null,
      language: Language,
      lastDraftInvoiceDate?: string | null,
      lastIndexationProcessDate?: string | null,
      lastInvoiceDate?: string | null,
      legalCompetentAuthority?: string | null,
      name: string,
      notes?: string | null,
      paymentFrequency: LeasePaymentFrequency,
      paymentInvoicePeriod: LeasePaymentInvoicePeriod,
      paymentInvoicePeriodCustomDay?: number | null,
      paymentOption?:  {
        __typename: "LeasePaymentOption",
        customerId?: string | null,
        enabled: boolean,
        mandateActivatedAt?: string | null,
        mandateStatus?: PaymentProviderMandateStatus | null,
        paymentMethodId?: string | null,
        qrType?: LeaseQrType | null,
      } | null,
      purchaseOrderNumber?: string | null,
      realEstateAgency?: string | null,
      realEstateTax?: number | null,
      remittanceInformation?: string | null,
      remittanceInformationType?: LeaseRemittanceType | null,
      rentalGuaranty?:  {
        __typename: "LeaseRentalGuaranty",
        amount: number,
        blockedAmount?: number | null,
        releasedAmount?: number | null,
        type: LeaseRentalGuarantyType,
        financialInstitution?: string | null,
      } | null,
      signatureDate?: string | null,
      startDate: string,
      nextIndexationMonth?: string | null,
      nextIndexation?: boolean | null,
      status: LeaseStatus,
      technicCommunicationSettingsProfileId: string,
      totalInitialRentalPrice: number,
      totalRentalPrice: number,
      type: LeaseType,
      subletting?: boolean | null,
      vatRateRentId?: string | null,
      vatRateRent?:  {
        __typename: "VatRate",
        id: string,
        country: string,
        label: string,
        value?: number | null,
        ownerId?: string | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      additionalClauses?:  {
        __typename: "ModelLeaseAdditionalClauseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      bankAccountId?: string | null,
      bankAccount?:  {
        __typename: "BankAccount",
        id: string,
        contactId: string,
        number: string,
        bicNumber?: string | null,
        bankName?: string | null,
        contactIds?: Array< string > | null,
        buildingIds?: Array< string > | null,
        holderName?: string | null,
        label?: string | null,
        disabled?: boolean | null,
        integrations?: Array< IntegrationName > | null,
        matchingRule?: BankAccountMatchingRule | null,
        balance?: number | null,
        balanceDate?: string | null,
        type: BankAccountType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contacts?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      files?:  {
        __typename: "ModelFileConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leaseActionHistories?:  {
        __typename: "ModelLeaseActionHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leasePriceHistories?:  {
        __typename: "ModelLeasePriceHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      signatureDocuments?:  {
        __typename: "ModelSignatureDocumentConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      variousOperations?:  {
        __typename: "ModelLeaseVariousOperationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    title?: string | null,
    body: string,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListLeaseAdditionalClausesQueryVariables = {
  filter?: ModelLeaseAdditionalClauseFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListLeaseAdditionalClausesQuery = {
  listLeaseAdditionalClauses?:  {
    __typename: "ModelLeaseAdditionalClauseConnection",
    items:  Array< {
      __typename: "LeaseAdditionalClause",
      id: string,
      leaseId: string,
      lease?:  {
        __typename: "Lease",
        id: string,
        balance?: number | null,
        canBeExtended?: boolean | null,
        communicationSettingsProfileId: string,
        createdAt?: string | null,
        endDate: string,
        includeRealEstateInLeaseContract?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        invoiceSenderId: string,
        inventoryOfFixturesExpert?: string | null,
        inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
        inventoryOfFixturesType?: InventoryOfFixturesType | null,
        ipiNumber?: string | null,
        language: Language,
        lastDraftInvoiceDate?: string | null,
        lastIndexationProcessDate?: string | null,
        lastInvoiceDate?: string | null,
        legalCompetentAuthority?: string | null,
        name: string,
        notes?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        purchaseOrderNumber?: string | null,
        realEstateAgency?: string | null,
        realEstateTax?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        signatureDate?: string | null,
        startDate: string,
        nextIndexationMonth?: string | null,
        nextIndexation?: boolean | null,
        status: LeaseStatus,
        technicCommunicationSettingsProfileId: string,
        totalInitialRentalPrice: number,
        totalRentalPrice: number,
        type: LeaseType,
        subletting?: boolean | null,
        vatRateRentId?: string | null,
        bankAccountId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      title?: string | null,
      body: string,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncLeaseAdditionalClausesQueryVariables = {
  filter?: ModelLeaseAdditionalClauseFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncLeaseAdditionalClausesQuery = {
  syncLeaseAdditionalClauses?:  {
    __typename: "ModelLeaseAdditionalClauseConnection",
    items:  Array< {
      __typename: "LeaseAdditionalClause",
      id: string,
      leaseId: string,
      lease?:  {
        __typename: "Lease",
        id: string,
        balance?: number | null,
        canBeExtended?: boolean | null,
        communicationSettingsProfileId: string,
        createdAt?: string | null,
        endDate: string,
        includeRealEstateInLeaseContract?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        invoiceSenderId: string,
        inventoryOfFixturesExpert?: string | null,
        inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
        inventoryOfFixturesType?: InventoryOfFixturesType | null,
        ipiNumber?: string | null,
        language: Language,
        lastDraftInvoiceDate?: string | null,
        lastIndexationProcessDate?: string | null,
        lastInvoiceDate?: string | null,
        legalCompetentAuthority?: string | null,
        name: string,
        notes?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        purchaseOrderNumber?: string | null,
        realEstateAgency?: string | null,
        realEstateTax?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        signatureDate?: string | null,
        startDate: string,
        nextIndexationMonth?: string | null,
        nextIndexation?: boolean | null,
        status: LeaseStatus,
        technicCommunicationSettingsProfileId: string,
        totalInitialRentalPrice: number,
        totalRentalPrice: number,
        type: LeaseType,
        subletting?: boolean | null,
        vatRateRentId?: string | null,
        bankAccountId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      title?: string | null,
      body: string,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetLeaseContactQueryVariables = {
  id: string,
};

export type GetLeaseContactQuery = {
  getLeaseContact?:  {
    __typename: "LeaseContact",
    id: string,
    leaseId: string,
    contactId: string,
    lease?:  {
      __typename: "Lease",
      id: string,
      advancedChargesInvoices?:  {
        __typename: "LeaseAdvancedChargesInvoice",
        communicationSettingsProfileId: string,
        invoiceSenderId: string,
        lastDraftInvoiceDate?: string | null,
        lastInvoiceDate?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        bankAccountId?: string | null,
      } | null,
      balance?: number | null,
      canBeExtended?: boolean | null,
      communicationSettingsProfileId: string,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      endDate: string,
      includeRealEstateInLeaseContract?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      invoiceSenderId: string,
      invoiceSender?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      inventoryOfFixturesExpert?: string | null,
      inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
      inventoryOfFixturesType?: InventoryOfFixturesType | null,
      ipiNumber?: string | null,
      language: Language,
      lastDraftInvoiceDate?: string | null,
      lastIndexationProcessDate?: string | null,
      lastInvoiceDate?: string | null,
      legalCompetentAuthority?: string | null,
      name: string,
      notes?: string | null,
      paymentFrequency: LeasePaymentFrequency,
      paymentInvoicePeriod: LeasePaymentInvoicePeriod,
      paymentInvoicePeriodCustomDay?: number | null,
      paymentOption?:  {
        __typename: "LeasePaymentOption",
        customerId?: string | null,
        enabled: boolean,
        mandateActivatedAt?: string | null,
        mandateStatus?: PaymentProviderMandateStatus | null,
        paymentMethodId?: string | null,
        qrType?: LeaseQrType | null,
      } | null,
      purchaseOrderNumber?: string | null,
      realEstateAgency?: string | null,
      realEstateTax?: number | null,
      remittanceInformation?: string | null,
      remittanceInformationType?: LeaseRemittanceType | null,
      rentalGuaranty?:  {
        __typename: "LeaseRentalGuaranty",
        amount: number,
        blockedAmount?: number | null,
        releasedAmount?: number | null,
        type: LeaseRentalGuarantyType,
        financialInstitution?: string | null,
      } | null,
      signatureDate?: string | null,
      startDate: string,
      nextIndexationMonth?: string | null,
      nextIndexation?: boolean | null,
      status: LeaseStatus,
      technicCommunicationSettingsProfileId: string,
      totalInitialRentalPrice: number,
      totalRentalPrice: number,
      type: LeaseType,
      subletting?: boolean | null,
      vatRateRentId?: string | null,
      vatRateRent?:  {
        __typename: "VatRate",
        id: string,
        country: string,
        label: string,
        value?: number | null,
        ownerId?: string | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      additionalClauses?:  {
        __typename: "ModelLeaseAdditionalClauseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      bankAccountId?: string | null,
      bankAccount?:  {
        __typename: "BankAccount",
        id: string,
        contactId: string,
        number: string,
        bicNumber?: string | null,
        bankName?: string | null,
        contactIds?: Array< string > | null,
        buildingIds?: Array< string > | null,
        holderName?: string | null,
        label?: string | null,
        disabled?: boolean | null,
        integrations?: Array< IntegrationName > | null,
        matchingRule?: BankAccountMatchingRule | null,
        balance?: number | null,
        balanceDate?: string | null,
        type: BankAccountType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contacts?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      files?:  {
        __typename: "ModelFileConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leaseActionHistories?:  {
        __typename: "ModelLeaseActionHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leasePriceHistories?:  {
        __typename: "ModelLeasePriceHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      signatureDocuments?:  {
        __typename: "ModelSignatureDocumentConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      variousOperations?:  {
        __typename: "ModelLeaseVariousOperationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    contact?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    contactRole: ContactType,
    readers?: Array< string > | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListLeaseContactsQueryVariables = {
  filter?: ModelLeaseContactFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListLeaseContactsQuery = {
  listLeaseContacts?:  {
    __typename: "ModelLeaseContactConnection",
    items:  Array< {
      __typename: "LeaseContact",
      id: string,
      leaseId: string,
      contactId: string,
      lease?:  {
        __typename: "Lease",
        id: string,
        balance?: number | null,
        canBeExtended?: boolean | null,
        communicationSettingsProfileId: string,
        createdAt?: string | null,
        endDate: string,
        includeRealEstateInLeaseContract?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        invoiceSenderId: string,
        inventoryOfFixturesExpert?: string | null,
        inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
        inventoryOfFixturesType?: InventoryOfFixturesType | null,
        ipiNumber?: string | null,
        language: Language,
        lastDraftInvoiceDate?: string | null,
        lastIndexationProcessDate?: string | null,
        lastInvoiceDate?: string | null,
        legalCompetentAuthority?: string | null,
        name: string,
        notes?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        purchaseOrderNumber?: string | null,
        realEstateAgency?: string | null,
        realEstateTax?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        signatureDate?: string | null,
        startDate: string,
        nextIndexationMonth?: string | null,
        nextIndexation?: boolean | null,
        status: LeaseStatus,
        technicCommunicationSettingsProfileId: string,
        totalInitialRentalPrice: number,
        totalRentalPrice: number,
        type: LeaseType,
        subletting?: boolean | null,
        vatRateRentId?: string | null,
        bankAccountId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contact?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contactRole: ContactType,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncLeaseContactsQueryVariables = {
  filter?: ModelLeaseContactFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncLeaseContactsQuery = {
  syncLeaseContacts?:  {
    __typename: "ModelLeaseContactConnection",
    items:  Array< {
      __typename: "LeaseContact",
      id: string,
      leaseId: string,
      contactId: string,
      lease?:  {
        __typename: "Lease",
        id: string,
        balance?: number | null,
        canBeExtended?: boolean | null,
        communicationSettingsProfileId: string,
        createdAt?: string | null,
        endDate: string,
        includeRealEstateInLeaseContract?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        invoiceSenderId: string,
        inventoryOfFixturesExpert?: string | null,
        inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
        inventoryOfFixturesType?: InventoryOfFixturesType | null,
        ipiNumber?: string | null,
        language: Language,
        lastDraftInvoiceDate?: string | null,
        lastIndexationProcessDate?: string | null,
        lastInvoiceDate?: string | null,
        legalCompetentAuthority?: string | null,
        name: string,
        notes?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        purchaseOrderNumber?: string | null,
        realEstateAgency?: string | null,
        realEstateTax?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        signatureDate?: string | null,
        startDate: string,
        nextIndexationMonth?: string | null,
        nextIndexation?: boolean | null,
        status: LeaseStatus,
        technicCommunicationSettingsProfileId: string,
        totalInitialRentalPrice: number,
        totalRentalPrice: number,
        type: LeaseType,
        subletting?: boolean | null,
        vatRateRentId?: string | null,
        bankAccountId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contact?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contactRole: ContactType,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetLeasePriceHistoryQueryVariables = {
  id: string,
};

export type GetLeasePriceHistoryQuery = {
  getLeasePriceHistory?:  {
    __typename: "LeasePriceHistory",
    id: string,
    previousTotalRentalPrice: number,
    totalRentalPrice: number,
    optimalTotalRentalPrice?: number | null,
    optimalTotalMonthlyCharges?: number | null,
    applicationDate: string,
    status: LeaseAmountUpdateStatus,
    comment?: string | null,
    amountDetails:  Array< {
      __typename: "LeasePriceHistoryDetail",
      unitId: string,
      indexationBaseIndex?: number | null,
      indexationNewIndex?: number | null,
      previousRentalPrice: number,
      newRentalPrice: number,
      rentalStatus: LeasePriceHistoryStatus,
      monthlyChargesStatus: LeasePriceHistoryStatus,
      optimalNewRentalPrice?: number | null,
      optimalNewMonthlyChargesPrice?: number | null,
      epb?: string | null,
      epbIssueDate?: string | null,
      oldestIndexForCorrectionFactorCalculation?: number | null,
      newestIndexForCorrectionFactorCalculation?: number | null,
      rentIndexedPriceAfterNewEpbReduction?: number | null,
      chargesIndexedPriceAfterNewEpbReduction?: number | null,
      correctionFactor?: number | null,
      chargesAmountsDetails?:  Array< {
        __typename: "LeasePriceHistoryChargeAmountsDetails",
        leaseVariousOperationId: string,
        previousMonthlyAmount: number,
        newMonthlyAmount: number,
        indexationBaseIndex?: number | null,
        indexationBaseAmount?: number | null,
        indexationBaseIndexDate?: string | null,
        indexed?: boolean | null,
      } > | null,
      reductionPercentage?: number | null,
      rentDifference?: number | null,
      rentReduction?: number | null,
      indexedRentAfterReduction?: number | null,
      chargesDifference?: number | null,
      chargesReduction?: number | null,
      indexedChargesAfterReduction?: number | null,
      previousYearIndexationNewIndex?: number | null,
      previousYearIndexedRent?: number | null,
      previousYearIndexedCharges?: number | null,
    } >,
    type: LeasePriceHistoryType,
    communicationId?: string | null,
    communication?:  {
      __typename: "Communication",
      id: string,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      blockedRecipients?:  Array< {
        __typename: "CommunicationBlockedRecipient",
        recipient: string,
        bounceType: BounceType,
      } > | null,
      body: string,
      buildingId?: string | null,
      channel: CommunicationChannel,
      communicationTemplateId?: string | null,
      concernedContactIds?: Array< string > | null,
      contactId?: string | null,
      contactIds?: Array< string > | null,
      createdAt?: string | null,
      draftProperties?:  {
        __typename: "CommunicationDraftProperties",
        allowRecipientsToSeeEachOther?: boolean | null,
        bcc?: Array< string > | null,
        buildingIds?: Array< string > | null,
        cc?: Array< string > | null,
        contactIds?: Array< string > | null,
        contactTypes?: Array< ContactType > | null,
        entityType: string,
        leaseIds?: Array< string > | null,
        sendInBcc?: boolean | null,
        unitIds?: Array< string > | null,
        unitTypeFilter?: string | null,
      } | null,
      expirationDate?: string | null,
      files?:  {
        __typename: "ModelFileConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      invoice?:  {
        __typename: "Invoice",
        id: string,
        amount: number,
        bankAccountId: string,
        communicationId?: string | null,
        createdAt: string,
        creditNote?: boolean | null,
        creditNoteLabel?: string | null,
        dueDate?: string | null,
        invoiceDate: string,
        invoiceNumber?: string | null,
        ownerId?: string | null,
        invoiceSenderId: string,
        leaseId?: string | null,
        paid: boolean,
        postedDate?: string | null,
        purchaseOrderNumber?: string | null,
        receiptNumber?: string | null,
        reminderDates?: Array< string > | null,
        note?: string | null,
        remittanceInformation?: string | null,
        statementId?: string | null,
        status: InvoiceStatus,
        type: InvoiceType,
        unitId?: string | null,
        reversedInvoiceId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      invoiceId?: string | null,
      lease?:  {
        __typename: "Lease",
        id: string,
        balance?: number | null,
        canBeExtended?: boolean | null,
        communicationSettingsProfileId: string,
        createdAt?: string | null,
        endDate: string,
        includeRealEstateInLeaseContract?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        invoiceSenderId: string,
        inventoryOfFixturesExpert?: string | null,
        inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
        inventoryOfFixturesType?: InventoryOfFixturesType | null,
        ipiNumber?: string | null,
        language: Language,
        lastDraftInvoiceDate?: string | null,
        lastIndexationProcessDate?: string | null,
        lastInvoiceDate?: string | null,
        legalCompetentAuthority?: string | null,
        name: string,
        notes?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        purchaseOrderNumber?: string | null,
        realEstateAgency?: string | null,
        realEstateTax?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        signatureDate?: string | null,
        startDate: string,
        nextIndexationMonth?: string | null,
        nextIndexation?: boolean | null,
        status: LeaseStatus,
        technicCommunicationSettingsProfileId: string,
        totalInitialRentalPrice: number,
        totalRentalPrice: number,
        type: LeaseType,
        subletting?: boolean | null,
        vatRateRentId?: string | null,
        bankAccountId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      leaseId?: string | null,
      leasePriceHistoryId?: string | null,
      leasePriceHistory?:  {
        __typename: "LeasePriceHistory",
        id: string,
        previousTotalRentalPrice: number,
        totalRentalPrice: number,
        optimalTotalRentalPrice?: number | null,
        optimalTotalMonthlyCharges?: number | null,
        applicationDate: string,
        status: LeaseAmountUpdateStatus,
        comment?: string | null,
        type: LeasePriceHistoryType,
        communicationId?: string | null,
        leaseId: string,
        createdAt?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      letterTrackingCode?: string | null,
      letterTrackingProvider?: TrackingProvider | null,
      linkedCommunicationsIds?: Array< string > | null,
      supportingDocumentFileIds?: Array< string > | null,
      recipient?: string | null,
      recipientContactIdsInBcc?: Array< string > | null,
      recipientContactIdsInCc?: Array< string > | null,
      recipientInBcc?: string | null,
      recipientInCc?: string | null,
      scheduledAt?: string | null,
      deliveredAt?: string | null,
      errorCode?: CommunicationErrorCode | null,
      nextRetryAt?: string | null,
      sendRetryCount?: number | null,
      sender?: string | null,
      sentAt?: string | null,
      externalId?: string | null,
      externalStatus?: string | null,
      signatureDocumentId?: string | null,
      signatureDocument?:  {
        __typename: "SignatureDocument",
        id: string,
        additionalMessage?: string | null,
        automaticRemindersDisabled?: boolean | null,
        communicationBody?: string | null,
        createdAt?: string | null,
        expirationDate?: string | null,
        fileIds?: Array< string > | null,
        foreignKey: string,
        foreignTableName: string,
        sentAt?: string | null,
        signatureMethods: Array< SignatureType >,
        status: SignatureDocumentStatus,
        externalStatus?: string | null,
        type: SignatureDocumentType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      snoozedDate?: string | null,
      statement?:  {
        __typename: "Statement",
        id: string,
        closingStatement: boolean,
        periodFrom: string,
        periodTo: string,
        attachSupportingDocuments?: boolean | null,
        selectedPocketKeys?: Array< string > | null,
        source: StatementSource,
        status: StatementStatus,
        sentDate?: string | null,
        leaseId?: string | null,
        ownerId?: string | null,
        types?: Array< StatementType > | null,
        viewType: StatementViewType,
        unitIds?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      statementId?: string | null,
      status: CommunicationStatus,
      subject: string,
      toSend: boolean,
      hideLogo?: boolean | null,
      type: CommunicationType,
      _ttl?: number | null,
      unit?:  {
        __typename: "Unit",
        id: string,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        acquisitionValue?: number | null,
        advertisedMonthlyCharges?: number | null,
        advertisedRentalPrice?: number | null,
        cadastralIncome?: number | null,
        createdAt?: string | null,
        floor?: number | null,
        jointOwnershipId?: string | null,
        managementDate: string,
        name: string,
        notes?: string | null,
        predictedPrice?: string | null,
        propertyTax?: number | null,
        publishAddress?: boolean | null,
        surface?: number | null,
        type: UnitType,
        buildingId: string,
        unitAdvertisementId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      unitId?: string | null,
      readId: string,
      readers?: Array< string > | null,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    leaseId: string,
    lease?:  {
      __typename: "Lease",
      id: string,
      advancedChargesInvoices?:  {
        __typename: "LeaseAdvancedChargesInvoice",
        communicationSettingsProfileId: string,
        invoiceSenderId: string,
        lastDraftInvoiceDate?: string | null,
        lastInvoiceDate?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        bankAccountId?: string | null,
      } | null,
      balance?: number | null,
      canBeExtended?: boolean | null,
      communicationSettingsProfileId: string,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      endDate: string,
      includeRealEstateInLeaseContract?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      invoiceSenderId: string,
      invoiceSender?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      inventoryOfFixturesExpert?: string | null,
      inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
      inventoryOfFixturesType?: InventoryOfFixturesType | null,
      ipiNumber?: string | null,
      language: Language,
      lastDraftInvoiceDate?: string | null,
      lastIndexationProcessDate?: string | null,
      lastInvoiceDate?: string | null,
      legalCompetentAuthority?: string | null,
      name: string,
      notes?: string | null,
      paymentFrequency: LeasePaymentFrequency,
      paymentInvoicePeriod: LeasePaymentInvoicePeriod,
      paymentInvoicePeriodCustomDay?: number | null,
      paymentOption?:  {
        __typename: "LeasePaymentOption",
        customerId?: string | null,
        enabled: boolean,
        mandateActivatedAt?: string | null,
        mandateStatus?: PaymentProviderMandateStatus | null,
        paymentMethodId?: string | null,
        qrType?: LeaseQrType | null,
      } | null,
      purchaseOrderNumber?: string | null,
      realEstateAgency?: string | null,
      realEstateTax?: number | null,
      remittanceInformation?: string | null,
      remittanceInformationType?: LeaseRemittanceType | null,
      rentalGuaranty?:  {
        __typename: "LeaseRentalGuaranty",
        amount: number,
        blockedAmount?: number | null,
        releasedAmount?: number | null,
        type: LeaseRentalGuarantyType,
        financialInstitution?: string | null,
      } | null,
      signatureDate?: string | null,
      startDate: string,
      nextIndexationMonth?: string | null,
      nextIndexation?: boolean | null,
      status: LeaseStatus,
      technicCommunicationSettingsProfileId: string,
      totalInitialRentalPrice: number,
      totalRentalPrice: number,
      type: LeaseType,
      subletting?: boolean | null,
      vatRateRentId?: string | null,
      vatRateRent?:  {
        __typename: "VatRate",
        id: string,
        country: string,
        label: string,
        value?: number | null,
        ownerId?: string | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      additionalClauses?:  {
        __typename: "ModelLeaseAdditionalClauseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      bankAccountId?: string | null,
      bankAccount?:  {
        __typename: "BankAccount",
        id: string,
        contactId: string,
        number: string,
        bicNumber?: string | null,
        bankName?: string | null,
        contactIds?: Array< string > | null,
        buildingIds?: Array< string > | null,
        holderName?: string | null,
        label?: string | null,
        disabled?: boolean | null,
        integrations?: Array< IntegrationName > | null,
        matchingRule?: BankAccountMatchingRule | null,
        balance?: number | null,
        balanceDate?: string | null,
        type: BankAccountType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contacts?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      files?:  {
        __typename: "ModelFileConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leaseActionHistories?:  {
        __typename: "ModelLeaseActionHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leasePriceHistories?:  {
        __typename: "ModelLeasePriceHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      signatureDocuments?:  {
        __typename: "ModelSignatureDocumentConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      variousOperations?:  {
        __typename: "ModelLeaseVariousOperationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    createdAt?: string | null,
    readers?: Array< string > | null,
    readId: string,
    clientId: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListLeasePriceHistoriesQueryVariables = {
  filter?: ModelLeasePriceHistoryFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListLeasePriceHistoriesQuery = {
  listLeasePriceHistories?:  {
    __typename: "ModelLeasePriceHistoryConnection",
    items:  Array< {
      __typename: "LeasePriceHistory",
      id: string,
      previousTotalRentalPrice: number,
      totalRentalPrice: number,
      optimalTotalRentalPrice?: number | null,
      optimalTotalMonthlyCharges?: number | null,
      applicationDate: string,
      status: LeaseAmountUpdateStatus,
      comment?: string | null,
      amountDetails:  Array< {
        __typename: "LeasePriceHistoryDetail",
        unitId: string,
        indexationBaseIndex?: number | null,
        indexationNewIndex?: number | null,
        previousRentalPrice: number,
        newRentalPrice: number,
        rentalStatus: LeasePriceHistoryStatus,
        monthlyChargesStatus: LeasePriceHistoryStatus,
        optimalNewRentalPrice?: number | null,
        optimalNewMonthlyChargesPrice?: number | null,
        epb?: string | null,
        epbIssueDate?: string | null,
        oldestIndexForCorrectionFactorCalculation?: number | null,
        newestIndexForCorrectionFactorCalculation?: number | null,
        rentIndexedPriceAfterNewEpbReduction?: number | null,
        chargesIndexedPriceAfterNewEpbReduction?: number | null,
        correctionFactor?: number | null,
        reductionPercentage?: number | null,
        rentDifference?: number | null,
        rentReduction?: number | null,
        indexedRentAfterReduction?: number | null,
        chargesDifference?: number | null,
        chargesReduction?: number | null,
        indexedChargesAfterReduction?: number | null,
        previousYearIndexationNewIndex?: number | null,
        previousYearIndexedRent?: number | null,
        previousYearIndexedCharges?: number | null,
      } >,
      type: LeasePriceHistoryType,
      communicationId?: string | null,
      communication?:  {
        __typename: "Communication",
        id: string,
        addressId?: string | null,
        body: string,
        buildingId?: string | null,
        channel: CommunicationChannel,
        communicationTemplateId?: string | null,
        concernedContactIds?: Array< string > | null,
        contactId?: string | null,
        contactIds?: Array< string > | null,
        createdAt?: string | null,
        expirationDate?: string | null,
        invoiceId?: string | null,
        leaseId?: string | null,
        leasePriceHistoryId?: string | null,
        letterTrackingCode?: string | null,
        letterTrackingProvider?: TrackingProvider | null,
        linkedCommunicationsIds?: Array< string > | null,
        supportingDocumentFileIds?: Array< string > | null,
        recipient?: string | null,
        recipientContactIdsInBcc?: Array< string > | null,
        recipientContactIdsInCc?: Array< string > | null,
        recipientInBcc?: string | null,
        recipientInCc?: string | null,
        scheduledAt?: string | null,
        deliveredAt?: string | null,
        errorCode?: CommunicationErrorCode | null,
        nextRetryAt?: string | null,
        sendRetryCount?: number | null,
        sender?: string | null,
        sentAt?: string | null,
        externalId?: string | null,
        externalStatus?: string | null,
        signatureDocumentId?: string | null,
        snoozedDate?: string | null,
        statementId?: string | null,
        status: CommunicationStatus,
        subject: string,
        toSend: boolean,
        hideLogo?: boolean | null,
        type: CommunicationType,
        _ttl?: number | null,
        unitId?: string | null,
        readId: string,
        readers?: Array< string > | null,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      leaseId: string,
      lease?:  {
        __typename: "Lease",
        id: string,
        balance?: number | null,
        canBeExtended?: boolean | null,
        communicationSettingsProfileId: string,
        createdAt?: string | null,
        endDate: string,
        includeRealEstateInLeaseContract?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        invoiceSenderId: string,
        inventoryOfFixturesExpert?: string | null,
        inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
        inventoryOfFixturesType?: InventoryOfFixturesType | null,
        ipiNumber?: string | null,
        language: Language,
        lastDraftInvoiceDate?: string | null,
        lastIndexationProcessDate?: string | null,
        lastInvoiceDate?: string | null,
        legalCompetentAuthority?: string | null,
        name: string,
        notes?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        purchaseOrderNumber?: string | null,
        realEstateAgency?: string | null,
        realEstateTax?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        signatureDate?: string | null,
        startDate: string,
        nextIndexationMonth?: string | null,
        nextIndexation?: boolean | null,
        status: LeaseStatus,
        technicCommunicationSettingsProfileId: string,
        totalInitialRentalPrice: number,
        totalRentalPrice: number,
        type: LeaseType,
        subletting?: boolean | null,
        vatRateRentId?: string | null,
        bankAccountId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      createdAt?: string | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncLeasePriceHistoriesQueryVariables = {
  filter?: ModelLeasePriceHistoryFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncLeasePriceHistoriesQuery = {
  syncLeasePriceHistories?:  {
    __typename: "ModelLeasePriceHistoryConnection",
    items:  Array< {
      __typename: "LeasePriceHistory",
      id: string,
      previousTotalRentalPrice: number,
      totalRentalPrice: number,
      optimalTotalRentalPrice?: number | null,
      optimalTotalMonthlyCharges?: number | null,
      applicationDate: string,
      status: LeaseAmountUpdateStatus,
      comment?: string | null,
      amountDetails:  Array< {
        __typename: "LeasePriceHistoryDetail",
        unitId: string,
        indexationBaseIndex?: number | null,
        indexationNewIndex?: number | null,
        previousRentalPrice: number,
        newRentalPrice: number,
        rentalStatus: LeasePriceHistoryStatus,
        monthlyChargesStatus: LeasePriceHistoryStatus,
        optimalNewRentalPrice?: number | null,
        optimalNewMonthlyChargesPrice?: number | null,
        epb?: string | null,
        epbIssueDate?: string | null,
        oldestIndexForCorrectionFactorCalculation?: number | null,
        newestIndexForCorrectionFactorCalculation?: number | null,
        rentIndexedPriceAfterNewEpbReduction?: number | null,
        chargesIndexedPriceAfterNewEpbReduction?: number | null,
        correctionFactor?: number | null,
        reductionPercentage?: number | null,
        rentDifference?: number | null,
        rentReduction?: number | null,
        indexedRentAfterReduction?: number | null,
        chargesDifference?: number | null,
        chargesReduction?: number | null,
        indexedChargesAfterReduction?: number | null,
        previousYearIndexationNewIndex?: number | null,
        previousYearIndexedRent?: number | null,
        previousYearIndexedCharges?: number | null,
      } >,
      type: LeasePriceHistoryType,
      communicationId?: string | null,
      communication?:  {
        __typename: "Communication",
        id: string,
        addressId?: string | null,
        body: string,
        buildingId?: string | null,
        channel: CommunicationChannel,
        communicationTemplateId?: string | null,
        concernedContactIds?: Array< string > | null,
        contactId?: string | null,
        contactIds?: Array< string > | null,
        createdAt?: string | null,
        expirationDate?: string | null,
        invoiceId?: string | null,
        leaseId?: string | null,
        leasePriceHistoryId?: string | null,
        letterTrackingCode?: string | null,
        letterTrackingProvider?: TrackingProvider | null,
        linkedCommunicationsIds?: Array< string > | null,
        supportingDocumentFileIds?: Array< string > | null,
        recipient?: string | null,
        recipientContactIdsInBcc?: Array< string > | null,
        recipientContactIdsInCc?: Array< string > | null,
        recipientInBcc?: string | null,
        recipientInCc?: string | null,
        scheduledAt?: string | null,
        deliveredAt?: string | null,
        errorCode?: CommunicationErrorCode | null,
        nextRetryAt?: string | null,
        sendRetryCount?: number | null,
        sender?: string | null,
        sentAt?: string | null,
        externalId?: string | null,
        externalStatus?: string | null,
        signatureDocumentId?: string | null,
        snoozedDate?: string | null,
        statementId?: string | null,
        status: CommunicationStatus,
        subject: string,
        toSend: boolean,
        hideLogo?: boolean | null,
        type: CommunicationType,
        _ttl?: number | null,
        unitId?: string | null,
        readId: string,
        readers?: Array< string > | null,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      leaseId: string,
      lease?:  {
        __typename: "Lease",
        id: string,
        balance?: number | null,
        canBeExtended?: boolean | null,
        communicationSettingsProfileId: string,
        createdAt?: string | null,
        endDate: string,
        includeRealEstateInLeaseContract?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        invoiceSenderId: string,
        inventoryOfFixturesExpert?: string | null,
        inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
        inventoryOfFixturesType?: InventoryOfFixturesType | null,
        ipiNumber?: string | null,
        language: Language,
        lastDraftInvoiceDate?: string | null,
        lastIndexationProcessDate?: string | null,
        lastInvoiceDate?: string | null,
        legalCompetentAuthority?: string | null,
        name: string,
        notes?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        purchaseOrderNumber?: string | null,
        realEstateAgency?: string | null,
        realEstateTax?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        signatureDate?: string | null,
        startDate: string,
        nextIndexationMonth?: string | null,
        nextIndexation?: boolean | null,
        status: LeaseStatus,
        technicCommunicationSettingsProfileId: string,
        totalInitialRentalPrice: number,
        totalRentalPrice: number,
        type: LeaseType,
        subletting?: boolean | null,
        vatRateRentId?: string | null,
        bankAccountId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      createdAt?: string | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetLeaseVariousOperationQueryVariables = {
  id: string,
};

export type GetLeaseVariousOperationQuery = {
  getLeaseVariousOperation?:  {
    __typename: "LeaseVariousOperation",
    id: string,
    accountLabelIds?: Array< string > | null,
    amount: number,
    contactId: string,
    createdAt: string,
    createdBy?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    endDate: string,
    invoiceSenderId?: string | null,
    invoiceSender?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    label?: string | null,
    lastInvoiceDate?: string | null,
    leaseId: string,
    lease?:  {
      __typename: "Lease",
      id: string,
      advancedChargesInvoices?:  {
        __typename: "LeaseAdvancedChargesInvoice",
        communicationSettingsProfileId: string,
        invoiceSenderId: string,
        lastDraftInvoiceDate?: string | null,
        lastInvoiceDate?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        bankAccountId?: string | null,
      } | null,
      balance?: number | null,
      canBeExtended?: boolean | null,
      communicationSettingsProfileId: string,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      endDate: string,
      includeRealEstateInLeaseContract?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      invoiceSenderId: string,
      invoiceSender?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      inventoryOfFixturesExpert?: string | null,
      inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
      inventoryOfFixturesType?: InventoryOfFixturesType | null,
      ipiNumber?: string | null,
      language: Language,
      lastDraftInvoiceDate?: string | null,
      lastIndexationProcessDate?: string | null,
      lastInvoiceDate?: string | null,
      legalCompetentAuthority?: string | null,
      name: string,
      notes?: string | null,
      paymentFrequency: LeasePaymentFrequency,
      paymentInvoicePeriod: LeasePaymentInvoicePeriod,
      paymentInvoicePeriodCustomDay?: number | null,
      paymentOption?:  {
        __typename: "LeasePaymentOption",
        customerId?: string | null,
        enabled: boolean,
        mandateActivatedAt?: string | null,
        mandateStatus?: PaymentProviderMandateStatus | null,
        paymentMethodId?: string | null,
        qrType?: LeaseQrType | null,
      } | null,
      purchaseOrderNumber?: string | null,
      realEstateAgency?: string | null,
      realEstateTax?: number | null,
      remittanceInformation?: string | null,
      remittanceInformationType?: LeaseRemittanceType | null,
      rentalGuaranty?:  {
        __typename: "LeaseRentalGuaranty",
        amount: number,
        blockedAmount?: number | null,
        releasedAmount?: number | null,
        type: LeaseRentalGuarantyType,
        financialInstitution?: string | null,
      } | null,
      signatureDate?: string | null,
      startDate: string,
      nextIndexationMonth?: string | null,
      nextIndexation?: boolean | null,
      status: LeaseStatus,
      technicCommunicationSettingsProfileId: string,
      totalInitialRentalPrice: number,
      totalRentalPrice: number,
      type: LeaseType,
      subletting?: boolean | null,
      vatRateRentId?: string | null,
      vatRateRent?:  {
        __typename: "VatRate",
        id: string,
        country: string,
        label: string,
        value?: number | null,
        ownerId?: string | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      additionalClauses?:  {
        __typename: "ModelLeaseAdditionalClauseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      bankAccountId?: string | null,
      bankAccount?:  {
        __typename: "BankAccount",
        id: string,
        contactId: string,
        number: string,
        bicNumber?: string | null,
        bankName?: string | null,
        contactIds?: Array< string > | null,
        buildingIds?: Array< string > | null,
        holderName?: string | null,
        label?: string | null,
        disabled?: boolean | null,
        integrations?: Array< IntegrationName > | null,
        matchingRule?: BankAccountMatchingRule | null,
        balance?: number | null,
        balanceDate?: string | null,
        type: BankAccountType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contacts?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      files?:  {
        __typename: "ModelFileConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leaseActionHistories?:  {
        __typename: "ModelLeaseActionHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leasePriceHistories?:  {
        __typename: "ModelLeasePriceHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      signatureDocuments?:  {
        __typename: "ModelSignatureDocumentConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      variousOperations?:  {
        __typename: "ModelLeaseVariousOperationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    leaseVariousOperationHistories?:  Array< {
      __typename: "LeaseVariousOperationHistory",
      periodFrom: string,
      periodTo: string,
      amount: number,
    } > | null,
    operationType: LeaseVariousOperationType,
    paymentFrequency: LeasePaymentFrequency,
    paymentInvoicePeriod: LeasePaymentInvoicePeriod,
    paymentInvoicePeriodCustomDay?: number | null,
    reason?: string | null,
    separateInvoice: boolean,
    startDate: string,
    type: VariousOperationType,
    unit?:  {
      __typename: "Unit",
      id: string,
      acquisitionAdditionalCostsValue?: number | null,
      acquisitionAdvertisedValue?: number | null,
      acquisitionValue?: number | null,
      advertisedMonthlyCharges?: number | null,
      advertisedRentalPrice?: number | null,
      cadastralIncome?: number | null,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      floor?: number | null,
      jointOwnershipId?: string | null,
      managementDate: string,
      name: string,
      notes?: string | null,
      predictedPrice?: string | null,
      propertyTax?: number | null,
      publishAddress?: boolean | null,
      surface?: number | null,
      type: UnitType,
      buildingId: string,
      building?:  {
        __typename: "Building",
        id: string,
        name: string,
        addressId?: string | null,
        acquisitionValue?: number | null,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        amountOfFacades?: number | null,
        amountOfFloors?: number | null,
        amountOfHousings?: number | null,
        buildingState?: BuildingState | null,
        cadastralIncome?: number | null,
        constructionYear?: string | null,
        janitor?: boolean | null,
        jointOwnershipId?: string | null,
        notes?: string | null,
        propertyTax?: number | null,
        residenceName?: string | null,
        buildingSiteId?: string | null,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      owners?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leases?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      events?:  {
        __typename: "ModelUnitEventConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      unitAdvertisementId?: string | null,
      unitInventories?:  {
        __typename: "ModelUnitInventoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    unitId: string,
    vatRateId?: string | null,
    vatRate?:  {
      __typename: "VatRate",
      id: string,
      country: string,
      label: string,
      value?: number | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      ownerId?: string | null,
      owner?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    readId: string,
    readers?: Array< string > | null,
    clientId: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListLeaseVariousOperationsQueryVariables = {
  filter?: ModelLeaseVariousOperationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListLeaseVariousOperationsQuery = {
  listLeaseVariousOperations?:  {
    __typename: "ModelLeaseVariousOperationConnection",
    items:  Array< {
      __typename: "LeaseVariousOperation",
      id: string,
      accountLabelIds?: Array< string > | null,
      amount: number,
      contactId: string,
      createdAt: string,
      createdBy?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      endDate: string,
      invoiceSenderId?: string | null,
      invoiceSender?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      label?: string | null,
      lastInvoiceDate?: string | null,
      leaseId: string,
      lease?:  {
        __typename: "Lease",
        id: string,
        balance?: number | null,
        canBeExtended?: boolean | null,
        communicationSettingsProfileId: string,
        createdAt?: string | null,
        endDate: string,
        includeRealEstateInLeaseContract?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        invoiceSenderId: string,
        inventoryOfFixturesExpert?: string | null,
        inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
        inventoryOfFixturesType?: InventoryOfFixturesType | null,
        ipiNumber?: string | null,
        language: Language,
        lastDraftInvoiceDate?: string | null,
        lastIndexationProcessDate?: string | null,
        lastInvoiceDate?: string | null,
        legalCompetentAuthority?: string | null,
        name: string,
        notes?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        purchaseOrderNumber?: string | null,
        realEstateAgency?: string | null,
        realEstateTax?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        signatureDate?: string | null,
        startDate: string,
        nextIndexationMonth?: string | null,
        nextIndexation?: boolean | null,
        status: LeaseStatus,
        technicCommunicationSettingsProfileId: string,
        totalInitialRentalPrice: number,
        totalRentalPrice: number,
        type: LeaseType,
        subletting?: boolean | null,
        vatRateRentId?: string | null,
        bankAccountId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      leaseVariousOperationHistories?:  Array< {
        __typename: "LeaseVariousOperationHistory",
        periodFrom: string,
        periodTo: string,
        amount: number,
      } > | null,
      operationType: LeaseVariousOperationType,
      paymentFrequency: LeasePaymentFrequency,
      paymentInvoicePeriod: LeasePaymentInvoicePeriod,
      paymentInvoicePeriodCustomDay?: number | null,
      reason?: string | null,
      separateInvoice: boolean,
      startDate: string,
      type: VariousOperationType,
      unit?:  {
        __typename: "Unit",
        id: string,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        acquisitionValue?: number | null,
        advertisedMonthlyCharges?: number | null,
        advertisedRentalPrice?: number | null,
        cadastralIncome?: number | null,
        createdAt?: string | null,
        floor?: number | null,
        jointOwnershipId?: string | null,
        managementDate: string,
        name: string,
        notes?: string | null,
        predictedPrice?: string | null,
        propertyTax?: number | null,
        publishAddress?: boolean | null,
        surface?: number | null,
        type: UnitType,
        buildingId: string,
        unitAdvertisementId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      unitId: string,
      vatRateId?: string | null,
      vatRate?:  {
        __typename: "VatRate",
        id: string,
        country: string,
        label: string,
        value?: number | null,
        ownerId?: string | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      readId: string,
      readers?: Array< string > | null,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncLeaseVariousOperationsQueryVariables = {
  filter?: ModelLeaseVariousOperationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncLeaseVariousOperationsQuery = {
  syncLeaseVariousOperations?:  {
    __typename: "ModelLeaseVariousOperationConnection",
    items:  Array< {
      __typename: "LeaseVariousOperation",
      id: string,
      accountLabelIds?: Array< string > | null,
      amount: number,
      contactId: string,
      createdAt: string,
      createdBy?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      endDate: string,
      invoiceSenderId?: string | null,
      invoiceSender?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      label?: string | null,
      lastInvoiceDate?: string | null,
      leaseId: string,
      lease?:  {
        __typename: "Lease",
        id: string,
        balance?: number | null,
        canBeExtended?: boolean | null,
        communicationSettingsProfileId: string,
        createdAt?: string | null,
        endDate: string,
        includeRealEstateInLeaseContract?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        invoiceSenderId: string,
        inventoryOfFixturesExpert?: string | null,
        inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
        inventoryOfFixturesType?: InventoryOfFixturesType | null,
        ipiNumber?: string | null,
        language: Language,
        lastDraftInvoiceDate?: string | null,
        lastIndexationProcessDate?: string | null,
        lastInvoiceDate?: string | null,
        legalCompetentAuthority?: string | null,
        name: string,
        notes?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        purchaseOrderNumber?: string | null,
        realEstateAgency?: string | null,
        realEstateTax?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        signatureDate?: string | null,
        startDate: string,
        nextIndexationMonth?: string | null,
        nextIndexation?: boolean | null,
        status: LeaseStatus,
        technicCommunicationSettingsProfileId: string,
        totalInitialRentalPrice: number,
        totalRentalPrice: number,
        type: LeaseType,
        subletting?: boolean | null,
        vatRateRentId?: string | null,
        bankAccountId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      leaseVariousOperationHistories?:  Array< {
        __typename: "LeaseVariousOperationHistory",
        periodFrom: string,
        periodTo: string,
        amount: number,
      } > | null,
      operationType: LeaseVariousOperationType,
      paymentFrequency: LeasePaymentFrequency,
      paymentInvoicePeriod: LeasePaymentInvoicePeriod,
      paymentInvoicePeriodCustomDay?: number | null,
      reason?: string | null,
      separateInvoice: boolean,
      startDate: string,
      type: VariousOperationType,
      unit?:  {
        __typename: "Unit",
        id: string,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        acquisitionValue?: number | null,
        advertisedMonthlyCharges?: number | null,
        advertisedRentalPrice?: number | null,
        cadastralIncome?: number | null,
        createdAt?: string | null,
        floor?: number | null,
        jointOwnershipId?: string | null,
        managementDate: string,
        name: string,
        notes?: string | null,
        predictedPrice?: string | null,
        propertyTax?: number | null,
        publishAddress?: boolean | null,
        surface?: number | null,
        type: UnitType,
        buildingId: string,
        unitAdvertisementId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      unitId: string,
      vatRateId?: string | null,
      vatRate?:  {
        __typename: "VatRate",
        id: string,
        country: string,
        label: string,
        value?: number | null,
        ownerId?: string | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      readId: string,
      readers?: Array< string > | null,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetMortgageQueryVariables = {
  id: string,
};

export type GetMortgageQuery = {
  getMortgage?:  {
    __typename: "Mortgage",
    id: string,
    lender: string,
    durationInYears: number,
    rateType: MortgageRateType,
    interestRate: number,
    aprRate: number,
    startDate: string,
    amount: number,
    monthlyPayment: number,
    unitId?: string | null,
    unit?:  {
      __typename: "Unit",
      id: string,
      acquisitionAdditionalCostsValue?: number | null,
      acquisitionAdvertisedValue?: number | null,
      acquisitionValue?: number | null,
      advertisedMonthlyCharges?: number | null,
      advertisedRentalPrice?: number | null,
      cadastralIncome?: number | null,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      floor?: number | null,
      jointOwnershipId?: string | null,
      managementDate: string,
      name: string,
      notes?: string | null,
      predictedPrice?: string | null,
      propertyTax?: number | null,
      publishAddress?: boolean | null,
      surface?: number | null,
      type: UnitType,
      buildingId: string,
      building?:  {
        __typename: "Building",
        id: string,
        name: string,
        addressId?: string | null,
        acquisitionValue?: number | null,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        amountOfFacades?: number | null,
        amountOfFloors?: number | null,
        amountOfHousings?: number | null,
        buildingState?: BuildingState | null,
        cadastralIncome?: number | null,
        constructionYear?: string | null,
        janitor?: boolean | null,
        jointOwnershipId?: string | null,
        notes?: string | null,
        propertyTax?: number | null,
        residenceName?: string | null,
        buildingSiteId?: string | null,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      owners?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leases?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      events?:  {
        __typename: "ModelUnitEventConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      unitAdvertisementId?: string | null,
      unitInventories?:  {
        __typename: "ModelUnitInventoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    buildingId?: string | null,
    building?:  {
      __typename: "Building",
      id: string,
      name: string,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      acquisitionValue?: number | null,
      acquisitionAdditionalCostsValue?: number | null,
      acquisitionAdvertisedValue?: number | null,
      amountOfFacades?: number | null,
      amountOfFloors?: number | null,
      amountOfHousings?: number | null,
      buildingState?: BuildingState | null,
      cadastralIncome?: number | null,
      constructionYear?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      janitor?: boolean | null,
      jointOwnershipId?: string | null,
      notes?: string | null,
      owners?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      propertyTax?: number | null,
      residenceName?: string | null,
      buildingSiteId?: string | null,
      buildingSite?:  {
        __typename: "BuildingSite",
        id: string,
        name: string,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      units?:  {
        __typename: "ModelUnitConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      events?:  {
        __typename: "ModelBuildingEventConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      teams?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    writers?: Array< string > | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListMortgagesQueryVariables = {
  filter?: ModelMortgageFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListMortgagesQuery = {
  listMortgages?:  {
    __typename: "ModelMortgageConnection",
    items:  Array< {
      __typename: "Mortgage",
      id: string,
      lender: string,
      durationInYears: number,
      rateType: MortgageRateType,
      interestRate: number,
      aprRate: number,
      startDate: string,
      amount: number,
      monthlyPayment: number,
      unitId?: string | null,
      unit?:  {
        __typename: "Unit",
        id: string,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        acquisitionValue?: number | null,
        advertisedMonthlyCharges?: number | null,
        advertisedRentalPrice?: number | null,
        cadastralIncome?: number | null,
        createdAt?: string | null,
        floor?: number | null,
        jointOwnershipId?: string | null,
        managementDate: string,
        name: string,
        notes?: string | null,
        predictedPrice?: string | null,
        propertyTax?: number | null,
        publishAddress?: boolean | null,
        surface?: number | null,
        type: UnitType,
        buildingId: string,
        unitAdvertisementId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      buildingId?: string | null,
      building?:  {
        __typename: "Building",
        id: string,
        name: string,
        addressId?: string | null,
        acquisitionValue?: number | null,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        amountOfFacades?: number | null,
        amountOfFloors?: number | null,
        amountOfHousings?: number | null,
        buildingState?: BuildingState | null,
        cadastralIncome?: number | null,
        constructionYear?: string | null,
        janitor?: boolean | null,
        jointOwnershipId?: string | null,
        notes?: string | null,
        propertyTax?: number | null,
        residenceName?: string | null,
        buildingSiteId?: string | null,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      writers?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncMortgagesQueryVariables = {
  filter?: ModelMortgageFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncMortgagesQuery = {
  syncMortgages?:  {
    __typename: "ModelMortgageConnection",
    items:  Array< {
      __typename: "Mortgage",
      id: string,
      lender: string,
      durationInYears: number,
      rateType: MortgageRateType,
      interestRate: number,
      aprRate: number,
      startDate: string,
      amount: number,
      monthlyPayment: number,
      unitId?: string | null,
      unit?:  {
        __typename: "Unit",
        id: string,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        acquisitionValue?: number | null,
        advertisedMonthlyCharges?: number | null,
        advertisedRentalPrice?: number | null,
        cadastralIncome?: number | null,
        createdAt?: string | null,
        floor?: number | null,
        jointOwnershipId?: string | null,
        managementDate: string,
        name: string,
        notes?: string | null,
        predictedPrice?: string | null,
        propertyTax?: number | null,
        publishAddress?: boolean | null,
        surface?: number | null,
        type: UnitType,
        buildingId: string,
        unitAdvertisementId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      buildingId?: string | null,
      building?:  {
        __typename: "Building",
        id: string,
        name: string,
        addressId?: string | null,
        acquisitionValue?: number | null,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        amountOfFacades?: number | null,
        amountOfFloors?: number | null,
        amountOfHousings?: number | null,
        buildingState?: BuildingState | null,
        cadastralIncome?: number | null,
        constructionYear?: string | null,
        janitor?: boolean | null,
        jointOwnershipId?: string | null,
        notes?: string | null,
        propertyTax?: number | null,
        residenceName?: string | null,
        buildingSiteId?: string | null,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      writers?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetNotificationQueryVariables = {
  id: string,
};

export type GetNotificationQuery = {
  getNotification?:  {
    __typename: "Notification",
    id: string,
    createdBy: NotificationCreation,
    type?: NotificationType | null,
    message?: string | null,
    popupDate: string,
    expirationDate?: string | null,
    status: NotificationStatus,
    createdAt?: string | null,
    buildingId?: string | null,
    building?:  {
      __typename: "Building",
      id: string,
      name: string,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      acquisitionValue?: number | null,
      acquisitionAdditionalCostsValue?: number | null,
      acquisitionAdvertisedValue?: number | null,
      amountOfFacades?: number | null,
      amountOfFloors?: number | null,
      amountOfHousings?: number | null,
      buildingState?: BuildingState | null,
      cadastralIncome?: number | null,
      constructionYear?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      janitor?: boolean | null,
      jointOwnershipId?: string | null,
      notes?: string | null,
      owners?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      propertyTax?: number | null,
      residenceName?: string | null,
      buildingSiteId?: string | null,
      buildingSite?:  {
        __typename: "BuildingSite",
        id: string,
        name: string,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      units?:  {
        __typename: "ModelUnitConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      events?:  {
        __typename: "ModelBuildingEventConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      teams?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    unitId?: string | null,
    unit?:  {
      __typename: "Unit",
      id: string,
      acquisitionAdditionalCostsValue?: number | null,
      acquisitionAdvertisedValue?: number | null,
      acquisitionValue?: number | null,
      advertisedMonthlyCharges?: number | null,
      advertisedRentalPrice?: number | null,
      cadastralIncome?: number | null,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      floor?: number | null,
      jointOwnershipId?: string | null,
      managementDate: string,
      name: string,
      notes?: string | null,
      predictedPrice?: string | null,
      propertyTax?: number | null,
      publishAddress?: boolean | null,
      surface?: number | null,
      type: UnitType,
      buildingId: string,
      building?:  {
        __typename: "Building",
        id: string,
        name: string,
        addressId?: string | null,
        acquisitionValue?: number | null,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        amountOfFacades?: number | null,
        amountOfFloors?: number | null,
        amountOfHousings?: number | null,
        buildingState?: BuildingState | null,
        cadastralIncome?: number | null,
        constructionYear?: string | null,
        janitor?: boolean | null,
        jointOwnershipId?: string | null,
        notes?: string | null,
        propertyTax?: number | null,
        residenceName?: string | null,
        buildingSiteId?: string | null,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      owners?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leases?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      events?:  {
        __typename: "ModelUnitEventConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      unitAdvertisementId?: string | null,
      unitInventories?:  {
        __typename: "ModelUnitInventoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    leaseId?: string | null,
    lease?:  {
      __typename: "Lease",
      id: string,
      advancedChargesInvoices?:  {
        __typename: "LeaseAdvancedChargesInvoice",
        communicationSettingsProfileId: string,
        invoiceSenderId: string,
        lastDraftInvoiceDate?: string | null,
        lastInvoiceDate?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        bankAccountId?: string | null,
      } | null,
      balance?: number | null,
      canBeExtended?: boolean | null,
      communicationSettingsProfileId: string,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      endDate: string,
      includeRealEstateInLeaseContract?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      invoiceSenderId: string,
      invoiceSender?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      inventoryOfFixturesExpert?: string | null,
      inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
      inventoryOfFixturesType?: InventoryOfFixturesType | null,
      ipiNumber?: string | null,
      language: Language,
      lastDraftInvoiceDate?: string | null,
      lastIndexationProcessDate?: string | null,
      lastInvoiceDate?: string | null,
      legalCompetentAuthority?: string | null,
      name: string,
      notes?: string | null,
      paymentFrequency: LeasePaymentFrequency,
      paymentInvoicePeriod: LeasePaymentInvoicePeriod,
      paymentInvoicePeriodCustomDay?: number | null,
      paymentOption?:  {
        __typename: "LeasePaymentOption",
        customerId?: string | null,
        enabled: boolean,
        mandateActivatedAt?: string | null,
        mandateStatus?: PaymentProviderMandateStatus | null,
        paymentMethodId?: string | null,
        qrType?: LeaseQrType | null,
      } | null,
      purchaseOrderNumber?: string | null,
      realEstateAgency?: string | null,
      realEstateTax?: number | null,
      remittanceInformation?: string | null,
      remittanceInformationType?: LeaseRemittanceType | null,
      rentalGuaranty?:  {
        __typename: "LeaseRentalGuaranty",
        amount: number,
        blockedAmount?: number | null,
        releasedAmount?: number | null,
        type: LeaseRentalGuarantyType,
        financialInstitution?: string | null,
      } | null,
      signatureDate?: string | null,
      startDate: string,
      nextIndexationMonth?: string | null,
      nextIndexation?: boolean | null,
      status: LeaseStatus,
      technicCommunicationSettingsProfileId: string,
      totalInitialRentalPrice: number,
      totalRentalPrice: number,
      type: LeaseType,
      subletting?: boolean | null,
      vatRateRentId?: string | null,
      vatRateRent?:  {
        __typename: "VatRate",
        id: string,
        country: string,
        label: string,
        value?: number | null,
        ownerId?: string | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      additionalClauses?:  {
        __typename: "ModelLeaseAdditionalClauseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      bankAccountId?: string | null,
      bankAccount?:  {
        __typename: "BankAccount",
        id: string,
        contactId: string,
        number: string,
        bicNumber?: string | null,
        bankName?: string | null,
        contactIds?: Array< string > | null,
        buildingIds?: Array< string > | null,
        holderName?: string | null,
        label?: string | null,
        disabled?: boolean | null,
        integrations?: Array< IntegrationName > | null,
        matchingRule?: BankAccountMatchingRule | null,
        balance?: number | null,
        balanceDate?: string | null,
        type: BankAccountType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contacts?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      files?:  {
        __typename: "ModelFileConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leaseActionHistories?:  {
        __typename: "ModelLeaseActionHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leasePriceHistories?:  {
        __typename: "ModelLeasePriceHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      signatureDocuments?:  {
        __typename: "ModelSignatureDocumentConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      variousOperations?:  {
        __typename: "ModelLeaseVariousOperationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    technicId?: string | null,
    technic?:  {
      __typename: "Technic",
      id: string,
      type: TechnicType,
      contractNumber?: string | null,
      communicationSettingsProfileId: string,
      maintenanceHistory?:  Array< {
        __typename: "TechnicMaintenanceHistory",
        date: string,
        contactId?: string | null,
        fileId?: string | null,
      } > | null,
      technicLibraryId?: string | null,
      technicLibrary?:  {
        __typename: "TechnicLibrary",
        id: string,
        communicationSettingsProfileId?: string | null,
        criticality: TechnicLibraryCriticality,
        isDefault?: boolean | null,
        issuingAuthority?: string | null,
        linkedCertificateIds?: Array< string > | null,
        locationScope?: TechnicLibraryLocationScope | null,
        status: TechnicLibraryStatus,
        tagIds?: Array< string > | null,
        technicLibraryFormat?: string | null,
        type: TechnicLibraryType,
        utilityTypes?: Array< UtilityType > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      technicName?: string | null,
      lastControlDate?: string | null,
      status?: TechnicStatus | null,
      utilityType?: UtilityType | null,
      utilityEanCode?: string | null,
      utilityMeterNumber?: string | null,
      utilityDistributorId?: string | null,
      utilityDistributor?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      utilityHistory?:  Array< {
        __typename: "UtilityHistory",
        date: string,
        reason?: UtilityReadingReason | null,
        reading: number,
        secondReading?: number | null,
      } > | null,
      files?:  {
        __typename: "ModelFileConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildingId?: string | null,
      building?:  {
        __typename: "Building",
        id: string,
        name: string,
        addressId?: string | null,
        acquisitionValue?: number | null,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        amountOfFacades?: number | null,
        amountOfFloors?: number | null,
        amountOfHousings?: number | null,
        buildingState?: BuildingState | null,
        cadastralIncome?: number | null,
        constructionYear?: string | null,
        janitor?: boolean | null,
        jointOwnershipId?: string | null,
        notes?: string | null,
        propertyTax?: number | null,
        residenceName?: string | null,
        buildingSiteId?: string | null,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      unitId?: string | null,
      unit?:  {
        __typename: "Unit",
        id: string,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        acquisitionValue?: number | null,
        advertisedMonthlyCharges?: number | null,
        advertisedRentalPrice?: number | null,
        cadastralIncome?: number | null,
        createdAt?: string | null,
        floor?: number | null,
        jointOwnershipId?: string | null,
        managementDate: string,
        name: string,
        notes?: string | null,
        predictedPrice?: string | null,
        propertyTax?: number | null,
        publishAddress?: boolean | null,
        surface?: number | null,
        type: UnitType,
        buildingId: string,
        unitAdvertisementId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      leaseId?: string | null,
      lease?:  {
        __typename: "Lease",
        id: string,
        balance?: number | null,
        canBeExtended?: boolean | null,
        communicationSettingsProfileId: string,
        createdAt?: string | null,
        endDate: string,
        includeRealEstateInLeaseContract?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        invoiceSenderId: string,
        inventoryOfFixturesExpert?: string | null,
        inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
        inventoryOfFixturesType?: InventoryOfFixturesType | null,
        ipiNumber?: string | null,
        language: Language,
        lastDraftInvoiceDate?: string | null,
        lastIndexationProcessDate?: string | null,
        lastInvoiceDate?: string | null,
        legalCompetentAuthority?: string | null,
        name: string,
        notes?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        purchaseOrderNumber?: string | null,
        realEstateAgency?: string | null,
        realEstateTax?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        signatureDate?: string | null,
        startDate: string,
        nextIndexationMonth?: string | null,
        nextIndexation?: boolean | null,
        status: LeaseStatus,
        technicCommunicationSettingsProfileId: string,
        totalInitialRentalPrice: number,
        totalRentalPrice: number,
        type: LeaseType,
        subletting?: boolean | null,
        vatRateRentId?: string | null,
        bankAccountId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contactId?: string | null,
      contact?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      originalTechnicId?: string | null,
      replacedTechnicId?: string | null,
      certificateIds?: Array< string > | null,
      readers?: Array< string > | null,
      writers?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    ticketId?: string | null,
    ticket?:  {
      __typename: "Ticket",
      id: string,
      assignedAt?: string | null,
      assignedTo?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      assignedToId?: string | null,
      attachment?:  {
        __typename: "ModelFileConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      building?:  {
        __typename: "Building",
        id: string,
        name: string,
        addressId?: string | null,
        acquisitionValue?: number | null,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        amountOfFacades?: number | null,
        amountOfFloors?: number | null,
        amountOfHousings?: number | null,
        buildingState?: BuildingState | null,
        cadastralIncome?: number | null,
        constructionYear?: string | null,
        janitor?: boolean | null,
        jointOwnershipId?: string | null,
        notes?: string | null,
        propertyTax?: number | null,
        residenceName?: string | null,
        buildingSiteId?: string | null,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      buildingId?: string | null,
      closedAt?: string | null,
      contact?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contactId: string,
      content: string,
      conversations?:  {
        __typename: "ModelTicketConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      createdAt: string,
      emailMessageId?: string | null,
      emailReferences?: Array< string | null > | null,
      parentId?: string | null,
      plannedAt?: string | null,
      referenceCode?: string | null,
      sourceType: TicketSourceType,
      status?: TicketStatus | null,
      subject: string,
      unit?:  {
        __typename: "Unit",
        id: string,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        acquisitionValue?: number | null,
        advertisedMonthlyCharges?: number | null,
        advertisedRentalPrice?: number | null,
        cadastralIncome?: number | null,
        createdAt?: string | null,
        floor?: number | null,
        jointOwnershipId?: string | null,
        managementDate: string,
        name: string,
        notes?: string | null,
        predictedPrice?: string | null,
        propertyTax?: number | null,
        publishAddress?: boolean | null,
        surface?: number | null,
        type: UnitType,
        buildingId: string,
        unitAdvertisementId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      unitId?: string | null,
      unread: boolean,
      updatedAt?: string | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    readId: string,
    clientId: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListNotificationsQueryVariables = {
  filter?: ModelNotificationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListNotificationsQuery = {
  listNotifications?:  {
    __typename: "ModelNotificationConnection",
    items:  Array< {
      __typename: "Notification",
      id: string,
      createdBy: NotificationCreation,
      type?: NotificationType | null,
      message?: string | null,
      popupDate: string,
      expirationDate?: string | null,
      status: NotificationStatus,
      createdAt?: string | null,
      buildingId?: string | null,
      building?:  {
        __typename: "Building",
        id: string,
        name: string,
        addressId?: string | null,
        acquisitionValue?: number | null,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        amountOfFacades?: number | null,
        amountOfFloors?: number | null,
        amountOfHousings?: number | null,
        buildingState?: BuildingState | null,
        cadastralIncome?: number | null,
        constructionYear?: string | null,
        janitor?: boolean | null,
        jointOwnershipId?: string | null,
        notes?: string | null,
        propertyTax?: number | null,
        residenceName?: string | null,
        buildingSiteId?: string | null,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      unitId?: string | null,
      unit?:  {
        __typename: "Unit",
        id: string,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        acquisitionValue?: number | null,
        advertisedMonthlyCharges?: number | null,
        advertisedRentalPrice?: number | null,
        cadastralIncome?: number | null,
        createdAt?: string | null,
        floor?: number | null,
        jointOwnershipId?: string | null,
        managementDate: string,
        name: string,
        notes?: string | null,
        predictedPrice?: string | null,
        propertyTax?: number | null,
        publishAddress?: boolean | null,
        surface?: number | null,
        type: UnitType,
        buildingId: string,
        unitAdvertisementId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      leaseId?: string | null,
      lease?:  {
        __typename: "Lease",
        id: string,
        balance?: number | null,
        canBeExtended?: boolean | null,
        communicationSettingsProfileId: string,
        createdAt?: string | null,
        endDate: string,
        includeRealEstateInLeaseContract?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        invoiceSenderId: string,
        inventoryOfFixturesExpert?: string | null,
        inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
        inventoryOfFixturesType?: InventoryOfFixturesType | null,
        ipiNumber?: string | null,
        language: Language,
        lastDraftInvoiceDate?: string | null,
        lastIndexationProcessDate?: string | null,
        lastInvoiceDate?: string | null,
        legalCompetentAuthority?: string | null,
        name: string,
        notes?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        purchaseOrderNumber?: string | null,
        realEstateAgency?: string | null,
        realEstateTax?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        signatureDate?: string | null,
        startDate: string,
        nextIndexationMonth?: string | null,
        nextIndexation?: boolean | null,
        status: LeaseStatus,
        technicCommunicationSettingsProfileId: string,
        totalInitialRentalPrice: number,
        totalRentalPrice: number,
        type: LeaseType,
        subletting?: boolean | null,
        vatRateRentId?: string | null,
        bankAccountId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      technicId?: string | null,
      technic?:  {
        __typename: "Technic",
        id: string,
        type: TechnicType,
        contractNumber?: string | null,
        communicationSettingsProfileId: string,
        technicLibraryId?: string | null,
        technicName?: string | null,
        lastControlDate?: string | null,
        status?: TechnicStatus | null,
        utilityType?: UtilityType | null,
        utilityEanCode?: string | null,
        utilityMeterNumber?: string | null,
        utilityDistributorId?: string | null,
        buildingId?: string | null,
        unitId?: string | null,
        leaseId?: string | null,
        contactId?: string | null,
        originalTechnicId?: string | null,
        replacedTechnicId?: string | null,
        certificateIds?: Array< string > | null,
        readers?: Array< string > | null,
        writers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      ticketId?: string | null,
      ticket?:  {
        __typename: "Ticket",
        id: string,
        assignedAt?: string | null,
        assignedToId?: string | null,
        buildingId?: string | null,
        closedAt?: string | null,
        contactId: string,
        content: string,
        createdAt: string,
        emailMessageId?: string | null,
        emailReferences?: Array< string | null > | null,
        parentId?: string | null,
        plannedAt?: string | null,
        referenceCode?: string | null,
        sourceType: TicketSourceType,
        status?: TicketStatus | null,
        subject: string,
        unitId?: string | null,
        unread: boolean,
        updatedAt?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncNotificationsQueryVariables = {
  filter?: ModelNotificationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncNotificationsQuery = {
  syncNotifications?:  {
    __typename: "ModelNotificationConnection",
    items:  Array< {
      __typename: "Notification",
      id: string,
      createdBy: NotificationCreation,
      type?: NotificationType | null,
      message?: string | null,
      popupDate: string,
      expirationDate?: string | null,
      status: NotificationStatus,
      createdAt?: string | null,
      buildingId?: string | null,
      building?:  {
        __typename: "Building",
        id: string,
        name: string,
        addressId?: string | null,
        acquisitionValue?: number | null,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        amountOfFacades?: number | null,
        amountOfFloors?: number | null,
        amountOfHousings?: number | null,
        buildingState?: BuildingState | null,
        cadastralIncome?: number | null,
        constructionYear?: string | null,
        janitor?: boolean | null,
        jointOwnershipId?: string | null,
        notes?: string | null,
        propertyTax?: number | null,
        residenceName?: string | null,
        buildingSiteId?: string | null,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      unitId?: string | null,
      unit?:  {
        __typename: "Unit",
        id: string,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        acquisitionValue?: number | null,
        advertisedMonthlyCharges?: number | null,
        advertisedRentalPrice?: number | null,
        cadastralIncome?: number | null,
        createdAt?: string | null,
        floor?: number | null,
        jointOwnershipId?: string | null,
        managementDate: string,
        name: string,
        notes?: string | null,
        predictedPrice?: string | null,
        propertyTax?: number | null,
        publishAddress?: boolean | null,
        surface?: number | null,
        type: UnitType,
        buildingId: string,
        unitAdvertisementId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      leaseId?: string | null,
      lease?:  {
        __typename: "Lease",
        id: string,
        balance?: number | null,
        canBeExtended?: boolean | null,
        communicationSettingsProfileId: string,
        createdAt?: string | null,
        endDate: string,
        includeRealEstateInLeaseContract?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        invoiceSenderId: string,
        inventoryOfFixturesExpert?: string | null,
        inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
        inventoryOfFixturesType?: InventoryOfFixturesType | null,
        ipiNumber?: string | null,
        language: Language,
        lastDraftInvoiceDate?: string | null,
        lastIndexationProcessDate?: string | null,
        lastInvoiceDate?: string | null,
        legalCompetentAuthority?: string | null,
        name: string,
        notes?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        purchaseOrderNumber?: string | null,
        realEstateAgency?: string | null,
        realEstateTax?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        signatureDate?: string | null,
        startDate: string,
        nextIndexationMonth?: string | null,
        nextIndexation?: boolean | null,
        status: LeaseStatus,
        technicCommunicationSettingsProfileId: string,
        totalInitialRentalPrice: number,
        totalRentalPrice: number,
        type: LeaseType,
        subletting?: boolean | null,
        vatRateRentId?: string | null,
        bankAccountId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      technicId?: string | null,
      technic?:  {
        __typename: "Technic",
        id: string,
        type: TechnicType,
        contractNumber?: string | null,
        communicationSettingsProfileId: string,
        technicLibraryId?: string | null,
        technicName?: string | null,
        lastControlDate?: string | null,
        status?: TechnicStatus | null,
        utilityType?: UtilityType | null,
        utilityEanCode?: string | null,
        utilityMeterNumber?: string | null,
        utilityDistributorId?: string | null,
        buildingId?: string | null,
        unitId?: string | null,
        leaseId?: string | null,
        contactId?: string | null,
        originalTechnicId?: string | null,
        replacedTechnicId?: string | null,
        certificateIds?: Array< string > | null,
        readers?: Array< string > | null,
        writers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      ticketId?: string | null,
      ticket?:  {
        __typename: "Ticket",
        id: string,
        assignedAt?: string | null,
        assignedToId?: string | null,
        buildingId?: string | null,
        closedAt?: string | null,
        contactId: string,
        content: string,
        createdAt: string,
        emailMessageId?: string | null,
        emailReferences?: Array< string | null > | null,
        parentId?: string | null,
        plannedAt?: string | null,
        referenceCode?: string | null,
        sourceType: TicketSourceType,
        status?: TicketStatus | null,
        subject: string,
        unitId?: string | null,
        unread: boolean,
        updatedAt?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetScheduleRuleQueryVariables = {
  id: string,
};

export type GetScheduleRuleQuery = {
  getScheduleRule?:  {
    __typename: "ScheduleRule",
    id: string,
    conditions:  Array< {
      __typename: "RuleCondition",
      attribute:  {
        __typename: "RuleAttributeRef",
        attributeName: string,
      },
      comparisonMode?: RuleComparisonMode | null,
      operator: RuleConditionOperator,
      values?: Array< string > | null,
      valueKind: RuleValueKind,
    } >,
    conditionsOperator?: RuleConditionsOperator | null,
    foreignKey: string,
    foreignTableName: string,
    name?:  Array< {
      __typename: "CustomLabel",
      language: string,
      label: string,
    } > | null,
    order?: number | null,
    outcome:  {
      __typename: "RuleOutcome",
      interval?:  {
        __typename: "RuleIntervalOutcome",
      } | null,
      type: RuleOutcomeType,
    },
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListScheduleRulesQueryVariables = {
  filter?: ModelScheduleRuleFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListScheduleRulesQuery = {
  listScheduleRules?:  {
    __typename: "ModelScheduleRuleConnection",
    items:  Array< {
      __typename: "ScheduleRule",
      id: string,
      conditions:  Array< {
        __typename: "RuleCondition",
        comparisonMode?: RuleComparisonMode | null,
        operator: RuleConditionOperator,
        values?: Array< string > | null,
        valueKind: RuleValueKind,
      } >,
      conditionsOperator?: RuleConditionsOperator | null,
      foreignKey: string,
      foreignTableName: string,
      name?:  Array< {
        __typename: "CustomLabel",
        language: string,
        label: string,
      } > | null,
      order?: number | null,
      outcome:  {
        __typename: "RuleOutcome",
        type: RuleOutcomeType,
      },
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncScheduleRulesQueryVariables = {
  filter?: ModelScheduleRuleFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncScheduleRulesQuery = {
  syncScheduleRules?:  {
    __typename: "ModelScheduleRuleConnection",
    items:  Array< {
      __typename: "ScheduleRule",
      id: string,
      conditions:  Array< {
        __typename: "RuleCondition",
        comparisonMode?: RuleComparisonMode | null,
        operator: RuleConditionOperator,
        values?: Array< string > | null,
        valueKind: RuleValueKind,
      } >,
      conditionsOperator?: RuleConditionsOperator | null,
      foreignKey: string,
      foreignTableName: string,
      name?:  Array< {
        __typename: "CustomLabel",
        language: string,
        label: string,
      } > | null,
      order?: number | null,
      outcome:  {
        __typename: "RuleOutcome",
        type: RuleOutcomeType,
      },
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetSendingSourceQueryVariables = {
  id: string,
};

export type GetSendingSourceQuery = {
  getSendingSource?:  {
    __typename: "SendingSource",
    id: string,
    createdAt?: string | null,
    createdById?: string | null,
    createdBy?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    dnsRecords?:  Array< {
      __typename: "DNSRecord",
      name: string,
      type: string,
      value: string,
    } > | null,
    emailAddress: string,
    issuesEmail: string,
    chargesEmail: string,
    errorMessage?: SendingSourceErrorType | null,
    name: string,
    lastReminderDate?: string | null,
    status: SendingSourceStatus,
    statusLastVerification?: string | null,
    verifiedType: SendingSourceVerifiedType,
    readId: string,
    clientId: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListSendingSourcesQueryVariables = {
  filter?: ModelSendingSourceFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListSendingSourcesQuery = {
  listSendingSources?:  {
    __typename: "ModelSendingSourceConnection",
    items:  Array< {
      __typename: "SendingSource",
      id: string,
      createdAt?: string | null,
      createdById?: string | null,
      createdBy?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      dnsRecords?:  Array< {
        __typename: "DNSRecord",
        name: string,
        type: string,
        value: string,
      } > | null,
      emailAddress: string,
      issuesEmail: string,
      chargesEmail: string,
      errorMessage?: SendingSourceErrorType | null,
      name: string,
      lastReminderDate?: string | null,
      status: SendingSourceStatus,
      statusLastVerification?: string | null,
      verifiedType: SendingSourceVerifiedType,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncSendingSourcesQueryVariables = {
  filter?: ModelSendingSourceFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncSendingSourcesQuery = {
  syncSendingSources?:  {
    __typename: "ModelSendingSourceConnection",
    items:  Array< {
      __typename: "SendingSource",
      id: string,
      createdAt?: string | null,
      createdById?: string | null,
      createdBy?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      dnsRecords?:  Array< {
        __typename: "DNSRecord",
        name: string,
        type: string,
        value: string,
      } > | null,
      emailAddress: string,
      issuesEmail: string,
      chargesEmail: string,
      errorMessage?: SendingSourceErrorType | null,
      name: string,
      lastReminderDate?: string | null,
      status: SendingSourceStatus,
      statusLastVerification?: string | null,
      verifiedType: SendingSourceVerifiedType,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetSettingQueryVariables = {
  id: string,
};

export type GetSettingQuery = {
  getSetting?:  {
    __typename: "Setting",
    id: string,
    name: SettingType,
    value: string,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListSettingsQueryVariables = {
  filter?: ModelSettingFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListSettingsQuery = {
  listSettings?:  {
    __typename: "ModelSettingConnection",
    items:  Array< {
      __typename: "Setting",
      id: string,
      name: SettingType,
      value: string,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncSettingsQueryVariables = {
  filter?: ModelSettingFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncSettingsQuery = {
  syncSettings?:  {
    __typename: "ModelSettingConnection",
    items:  Array< {
      __typename: "Setting",
      id: string,
      name: SettingType,
      value: string,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetReconciliationSettingQueryVariables = {
  id: string,
};

export type GetReconciliationSettingQuery = {
  getReconciliationSetting?:  {
    __typename: "ReconciliationSetting",
    id: string,
    type: ReconciliationSettingType,
    allocationMode: ReconciliationAllocationMode,
    leaseId?: string | null,
    ownerId?: string | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListReconciliationSettingsQueryVariables = {
  filter?: ModelReconciliationSettingFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListReconciliationSettingsQuery = {
  listReconciliationSettings?:  {
    __typename: "ModelReconciliationSettingConnection",
    items:  Array< {
      __typename: "ReconciliationSetting",
      id: string,
      type: ReconciliationSettingType,
      allocationMode: ReconciliationAllocationMode,
      leaseId?: string | null,
      ownerId?: string | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncReconciliationSettingsQueryVariables = {
  filter?: ModelReconciliationSettingFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncReconciliationSettingsQuery = {
  syncReconciliationSettings?:  {
    __typename: "ModelReconciliationSettingConnection",
    items:  Array< {
      __typename: "ReconciliationSetting",
      id: string,
      type: ReconciliationSettingType,
      allocationMode: ReconciliationAllocationMode,
      leaseId?: string | null,
      ownerId?: string | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetRepaymentStatementQueryVariables = {
  id: string,
};

export type GetRepaymentStatementQuery = {
  getRepaymentStatement?:  {
    __typename: "RepaymentStatement",
    id: string,
    accountOwnership: RepaymentStatementAccountOwnership,
    delaysCleared: number,
    expectedRent: number,
    lease?:  {
      __typename: "Lease",
      id: string,
      advancedChargesInvoices?:  {
        __typename: "LeaseAdvancedChargesInvoice",
        communicationSettingsProfileId: string,
        invoiceSenderId: string,
        lastDraftInvoiceDate?: string | null,
        lastInvoiceDate?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        bankAccountId?: string | null,
      } | null,
      balance?: number | null,
      canBeExtended?: boolean | null,
      communicationSettingsProfileId: string,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      endDate: string,
      includeRealEstateInLeaseContract?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      invoiceSenderId: string,
      invoiceSender?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      inventoryOfFixturesExpert?: string | null,
      inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
      inventoryOfFixturesType?: InventoryOfFixturesType | null,
      ipiNumber?: string | null,
      language: Language,
      lastDraftInvoiceDate?: string | null,
      lastIndexationProcessDate?: string | null,
      lastInvoiceDate?: string | null,
      legalCompetentAuthority?: string | null,
      name: string,
      notes?: string | null,
      paymentFrequency: LeasePaymentFrequency,
      paymentInvoicePeriod: LeasePaymentInvoicePeriod,
      paymentInvoicePeriodCustomDay?: number | null,
      paymentOption?:  {
        __typename: "LeasePaymentOption",
        customerId?: string | null,
        enabled: boolean,
        mandateActivatedAt?: string | null,
        mandateStatus?: PaymentProviderMandateStatus | null,
        paymentMethodId?: string | null,
        qrType?: LeaseQrType | null,
      } | null,
      purchaseOrderNumber?: string | null,
      realEstateAgency?: string | null,
      realEstateTax?: number | null,
      remittanceInformation?: string | null,
      remittanceInformationType?: LeaseRemittanceType | null,
      rentalGuaranty?:  {
        __typename: "LeaseRentalGuaranty",
        amount: number,
        blockedAmount?: number | null,
        releasedAmount?: number | null,
        type: LeaseRentalGuarantyType,
        financialInstitution?: string | null,
      } | null,
      signatureDate?: string | null,
      startDate: string,
      nextIndexationMonth?: string | null,
      nextIndexation?: boolean | null,
      status: LeaseStatus,
      technicCommunicationSettingsProfileId: string,
      totalInitialRentalPrice: number,
      totalRentalPrice: number,
      type: LeaseType,
      subletting?: boolean | null,
      vatRateRentId?: string | null,
      vatRateRent?:  {
        __typename: "VatRate",
        id: string,
        country: string,
        label: string,
        value?: number | null,
        ownerId?: string | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      additionalClauses?:  {
        __typename: "ModelLeaseAdditionalClauseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      bankAccountId?: string | null,
      bankAccount?:  {
        __typename: "BankAccount",
        id: string,
        contactId: string,
        number: string,
        bicNumber?: string | null,
        bankName?: string | null,
        contactIds?: Array< string > | null,
        buildingIds?: Array< string > | null,
        holderName?: string | null,
        label?: string | null,
        disabled?: boolean | null,
        integrations?: Array< IntegrationName > | null,
        matchingRule?: BankAccountMatchingRule | null,
        balance?: number | null,
        balanceDate?: string | null,
        type: BankAccountType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contacts?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      files?:  {
        __typename: "ModelFileConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leaseActionHistories?:  {
        __typename: "ModelLeaseActionHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leasePriceHistories?:  {
        __typename: "ModelLeasePriceHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      signatureDocuments?:  {
        __typename: "ModelSignatureDocumentConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      variousOperations?:  {
        __typename: "ModelLeaseVariousOperationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    leaseId: string,
    rentsCollected: number,
    repaymentStatementDetails:  Array< {
      __typename: "RepaymentStatementDetail",
      class: number,
      customLabel?: string | null,
      invoiceId: string,
      invoicePostingId: string,
      originalTotalAmount: number,
      periodFrom: string,
      periodTo: string,
      totalAmount: number,
      transactionId?: string | null,
      type: RepaymentStatementDetailType,
    } >,
    statement?:  {
      __typename: "Statement",
      id: string,
      amounts?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      chargeStatements?:  {
        __typename: "ModelChargeStatementConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      closingStatement: boolean,
      periodFrom: string,
      periodTo: string,
      attachSupportingDocuments?: boolean | null,
      selectedPocketKeys?: Array< string > | null,
      source: StatementSource,
      status: StatementStatus,
      sentDate?: string | null,
      leaseId?: string | null,
      lease?:  {
        __typename: "Lease",
        id: string,
        balance?: number | null,
        canBeExtended?: boolean | null,
        communicationSettingsProfileId: string,
        createdAt?: string | null,
        endDate: string,
        includeRealEstateInLeaseContract?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        invoiceSenderId: string,
        inventoryOfFixturesExpert?: string | null,
        inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
        inventoryOfFixturesType?: InventoryOfFixturesType | null,
        ipiNumber?: string | null,
        language: Language,
        lastDraftInvoiceDate?: string | null,
        lastIndexationProcessDate?: string | null,
        lastInvoiceDate?: string | null,
        legalCompetentAuthority?: string | null,
        name: string,
        notes?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        purchaseOrderNumber?: string | null,
        realEstateAgency?: string | null,
        realEstateTax?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        signatureDate?: string | null,
        startDate: string,
        nextIndexationMonth?: string | null,
        nextIndexation?: boolean | null,
        status: LeaseStatus,
        technicCommunicationSettingsProfileId: string,
        totalInitialRentalPrice: number,
        totalRentalPrice: number,
        type: LeaseType,
        subletting?: boolean | null,
        vatRateRentId?: string | null,
        bankAccountId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      agencyRateStatements?:  {
        __typename: "ModelAgencyRateStatementConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      ownerId?: string | null,
      owner?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      repaymentStatements?:  {
        __typename: "ModelRepaymentStatementConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      types?: Array< StatementType > | null,
      viewType: StatementViewType,
      unitIds?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    statementId: string,
    totalReceivedInJointAccount: number,
    totalExpectedInOwnerAccount: number,
    unpaidRents: number,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListRepaymentStatementsQueryVariables = {
  filter?: ModelRepaymentStatementFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListRepaymentStatementsQuery = {
  listRepaymentStatements?:  {
    __typename: "ModelRepaymentStatementConnection",
    items:  Array< {
      __typename: "RepaymentStatement",
      id: string,
      accountOwnership: RepaymentStatementAccountOwnership,
      delaysCleared: number,
      expectedRent: number,
      lease?:  {
        __typename: "Lease",
        id: string,
        balance?: number | null,
        canBeExtended?: boolean | null,
        communicationSettingsProfileId: string,
        createdAt?: string | null,
        endDate: string,
        includeRealEstateInLeaseContract?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        invoiceSenderId: string,
        inventoryOfFixturesExpert?: string | null,
        inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
        inventoryOfFixturesType?: InventoryOfFixturesType | null,
        ipiNumber?: string | null,
        language: Language,
        lastDraftInvoiceDate?: string | null,
        lastIndexationProcessDate?: string | null,
        lastInvoiceDate?: string | null,
        legalCompetentAuthority?: string | null,
        name: string,
        notes?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        purchaseOrderNumber?: string | null,
        realEstateAgency?: string | null,
        realEstateTax?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        signatureDate?: string | null,
        startDate: string,
        nextIndexationMonth?: string | null,
        nextIndexation?: boolean | null,
        status: LeaseStatus,
        technicCommunicationSettingsProfileId: string,
        totalInitialRentalPrice: number,
        totalRentalPrice: number,
        type: LeaseType,
        subletting?: boolean | null,
        vatRateRentId?: string | null,
        bankAccountId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      leaseId: string,
      rentsCollected: number,
      repaymentStatementDetails:  Array< {
        __typename: "RepaymentStatementDetail",
        class: number,
        customLabel?: string | null,
        invoiceId: string,
        invoicePostingId: string,
        originalTotalAmount: number,
        periodFrom: string,
        periodTo: string,
        totalAmount: number,
        transactionId?: string | null,
        type: RepaymentStatementDetailType,
      } >,
      statement?:  {
        __typename: "Statement",
        id: string,
        closingStatement: boolean,
        periodFrom: string,
        periodTo: string,
        attachSupportingDocuments?: boolean | null,
        selectedPocketKeys?: Array< string > | null,
        source: StatementSource,
        status: StatementStatus,
        sentDate?: string | null,
        leaseId?: string | null,
        ownerId?: string | null,
        types?: Array< StatementType > | null,
        viewType: StatementViewType,
        unitIds?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      statementId: string,
      totalReceivedInJointAccount: number,
      totalExpectedInOwnerAccount: number,
      unpaidRents: number,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncRepaymentStatementsQueryVariables = {
  filter?: ModelRepaymentStatementFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncRepaymentStatementsQuery = {
  syncRepaymentStatements?:  {
    __typename: "ModelRepaymentStatementConnection",
    items:  Array< {
      __typename: "RepaymentStatement",
      id: string,
      accountOwnership: RepaymentStatementAccountOwnership,
      delaysCleared: number,
      expectedRent: number,
      lease?:  {
        __typename: "Lease",
        id: string,
        balance?: number | null,
        canBeExtended?: boolean | null,
        communicationSettingsProfileId: string,
        createdAt?: string | null,
        endDate: string,
        includeRealEstateInLeaseContract?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        invoiceSenderId: string,
        inventoryOfFixturesExpert?: string | null,
        inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
        inventoryOfFixturesType?: InventoryOfFixturesType | null,
        ipiNumber?: string | null,
        language: Language,
        lastDraftInvoiceDate?: string | null,
        lastIndexationProcessDate?: string | null,
        lastInvoiceDate?: string | null,
        legalCompetentAuthority?: string | null,
        name: string,
        notes?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        purchaseOrderNumber?: string | null,
        realEstateAgency?: string | null,
        realEstateTax?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        signatureDate?: string | null,
        startDate: string,
        nextIndexationMonth?: string | null,
        nextIndexation?: boolean | null,
        status: LeaseStatus,
        technicCommunicationSettingsProfileId: string,
        totalInitialRentalPrice: number,
        totalRentalPrice: number,
        type: LeaseType,
        subletting?: boolean | null,
        vatRateRentId?: string | null,
        bankAccountId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      leaseId: string,
      rentsCollected: number,
      repaymentStatementDetails:  Array< {
        __typename: "RepaymentStatementDetail",
        class: number,
        customLabel?: string | null,
        invoiceId: string,
        invoicePostingId: string,
        originalTotalAmount: number,
        periodFrom: string,
        periodTo: string,
        totalAmount: number,
        transactionId?: string | null,
        type: RepaymentStatementDetailType,
      } >,
      statement?:  {
        __typename: "Statement",
        id: string,
        closingStatement: boolean,
        periodFrom: string,
        periodTo: string,
        attachSupportingDocuments?: boolean | null,
        selectedPocketKeys?: Array< string > | null,
        source: StatementSource,
        status: StatementStatus,
        sentDate?: string | null,
        leaseId?: string | null,
        ownerId?: string | null,
        types?: Array< StatementType > | null,
        viewType: StatementViewType,
        unitIds?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      statementId: string,
      totalReceivedInJointAccount: number,
      totalExpectedInOwnerAccount: number,
      unpaidRents: number,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetStatementQueryVariables = {
  id: string,
};

export type GetStatementQuery = {
  getStatement?:  {
    __typename: "Statement",
    id: string,
    amounts?:  Array< {
      __typename: "CustomValue",
      name: string,
      value: string,
    } > | null,
    chargeStatements?:  {
      __typename: "ModelChargeStatementConnection",
      items:  Array< {
        __typename: "ChargeStatement",
        id: string,
        chargeId: string,
        statementId: string,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    closingStatement: boolean,
    periodFrom: string,
    periodTo: string,
    attachSupportingDocuments?: boolean | null,
    selectedPocketKeys?: Array< string > | null,
    source: StatementSource,
    status: StatementStatus,
    sentDate?: string | null,
    leaseId?: string | null,
    lease?:  {
      __typename: "Lease",
      id: string,
      advancedChargesInvoices?:  {
        __typename: "LeaseAdvancedChargesInvoice",
        communicationSettingsProfileId: string,
        invoiceSenderId: string,
        lastDraftInvoiceDate?: string | null,
        lastInvoiceDate?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        bankAccountId?: string | null,
      } | null,
      balance?: number | null,
      canBeExtended?: boolean | null,
      communicationSettingsProfileId: string,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      endDate: string,
      includeRealEstateInLeaseContract?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      invoiceSenderId: string,
      invoiceSender?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      inventoryOfFixturesExpert?: string | null,
      inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
      inventoryOfFixturesType?: InventoryOfFixturesType | null,
      ipiNumber?: string | null,
      language: Language,
      lastDraftInvoiceDate?: string | null,
      lastIndexationProcessDate?: string | null,
      lastInvoiceDate?: string | null,
      legalCompetentAuthority?: string | null,
      name: string,
      notes?: string | null,
      paymentFrequency: LeasePaymentFrequency,
      paymentInvoicePeriod: LeasePaymentInvoicePeriod,
      paymentInvoicePeriodCustomDay?: number | null,
      paymentOption?:  {
        __typename: "LeasePaymentOption",
        customerId?: string | null,
        enabled: boolean,
        mandateActivatedAt?: string | null,
        mandateStatus?: PaymentProviderMandateStatus | null,
        paymentMethodId?: string | null,
        qrType?: LeaseQrType | null,
      } | null,
      purchaseOrderNumber?: string | null,
      realEstateAgency?: string | null,
      realEstateTax?: number | null,
      remittanceInformation?: string | null,
      remittanceInformationType?: LeaseRemittanceType | null,
      rentalGuaranty?:  {
        __typename: "LeaseRentalGuaranty",
        amount: number,
        blockedAmount?: number | null,
        releasedAmount?: number | null,
        type: LeaseRentalGuarantyType,
        financialInstitution?: string | null,
      } | null,
      signatureDate?: string | null,
      startDate: string,
      nextIndexationMonth?: string | null,
      nextIndexation?: boolean | null,
      status: LeaseStatus,
      technicCommunicationSettingsProfileId: string,
      totalInitialRentalPrice: number,
      totalRentalPrice: number,
      type: LeaseType,
      subletting?: boolean | null,
      vatRateRentId?: string | null,
      vatRateRent?:  {
        __typename: "VatRate",
        id: string,
        country: string,
        label: string,
        value?: number | null,
        ownerId?: string | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      additionalClauses?:  {
        __typename: "ModelLeaseAdditionalClauseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      bankAccountId?: string | null,
      bankAccount?:  {
        __typename: "BankAccount",
        id: string,
        contactId: string,
        number: string,
        bicNumber?: string | null,
        bankName?: string | null,
        contactIds?: Array< string > | null,
        buildingIds?: Array< string > | null,
        holderName?: string | null,
        label?: string | null,
        disabled?: boolean | null,
        integrations?: Array< IntegrationName > | null,
        matchingRule?: BankAccountMatchingRule | null,
        balance?: number | null,
        balanceDate?: string | null,
        type: BankAccountType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contacts?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      files?:  {
        __typename: "ModelFileConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leaseActionHistories?:  {
        __typename: "ModelLeaseActionHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leasePriceHistories?:  {
        __typename: "ModelLeasePriceHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      signatureDocuments?:  {
        __typename: "ModelSignatureDocumentConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      variousOperations?:  {
        __typename: "ModelLeaseVariousOperationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    agencyRateStatements?:  {
      __typename: "ModelAgencyRateStatementConnection",
      items:  Array< {
        __typename: "AgencyRateStatement",
        id: string,
        agencyRateId: string,
        statementId: string,
        totalAmountRateable: number,
        totalFixedAmount: number,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    ownerId?: string | null,
    owner?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    repaymentStatements?:  {
      __typename: "ModelRepaymentStatementConnection",
      items:  Array< {
        __typename: "RepaymentStatement",
        id: string,
        accountOwnership: RepaymentStatementAccountOwnership,
        delaysCleared: number,
        expectedRent: number,
        leaseId: string,
        rentsCollected: number,
        statementId: string,
        totalReceivedInJointAccount: number,
        totalExpectedInOwnerAccount: number,
        unpaidRents: number,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    types?: Array< StatementType > | null,
    viewType: StatementViewType,
    unitIds?: Array< string > | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListStatementsQueryVariables = {
  filter?: ModelStatementFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListStatementsQuery = {
  listStatements?:  {
    __typename: "ModelStatementConnection",
    items:  Array< {
      __typename: "Statement",
      id: string,
      amounts?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      chargeStatements?:  {
        __typename: "ModelChargeStatementConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      closingStatement: boolean,
      periodFrom: string,
      periodTo: string,
      attachSupportingDocuments?: boolean | null,
      selectedPocketKeys?: Array< string > | null,
      source: StatementSource,
      status: StatementStatus,
      sentDate?: string | null,
      leaseId?: string | null,
      lease?:  {
        __typename: "Lease",
        id: string,
        balance?: number | null,
        canBeExtended?: boolean | null,
        communicationSettingsProfileId: string,
        createdAt?: string | null,
        endDate: string,
        includeRealEstateInLeaseContract?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        invoiceSenderId: string,
        inventoryOfFixturesExpert?: string | null,
        inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
        inventoryOfFixturesType?: InventoryOfFixturesType | null,
        ipiNumber?: string | null,
        language: Language,
        lastDraftInvoiceDate?: string | null,
        lastIndexationProcessDate?: string | null,
        lastInvoiceDate?: string | null,
        legalCompetentAuthority?: string | null,
        name: string,
        notes?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        purchaseOrderNumber?: string | null,
        realEstateAgency?: string | null,
        realEstateTax?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        signatureDate?: string | null,
        startDate: string,
        nextIndexationMonth?: string | null,
        nextIndexation?: boolean | null,
        status: LeaseStatus,
        technicCommunicationSettingsProfileId: string,
        totalInitialRentalPrice: number,
        totalRentalPrice: number,
        type: LeaseType,
        subletting?: boolean | null,
        vatRateRentId?: string | null,
        bankAccountId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      agencyRateStatements?:  {
        __typename: "ModelAgencyRateStatementConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      ownerId?: string | null,
      owner?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      repaymentStatements?:  {
        __typename: "ModelRepaymentStatementConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      types?: Array< StatementType > | null,
      viewType: StatementViewType,
      unitIds?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncStatementsQueryVariables = {
  filter?: ModelStatementFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncStatementsQuery = {
  syncStatements?:  {
    __typename: "ModelStatementConnection",
    items:  Array< {
      __typename: "Statement",
      id: string,
      amounts?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      chargeStatements?:  {
        __typename: "ModelChargeStatementConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      closingStatement: boolean,
      periodFrom: string,
      periodTo: string,
      attachSupportingDocuments?: boolean | null,
      selectedPocketKeys?: Array< string > | null,
      source: StatementSource,
      status: StatementStatus,
      sentDate?: string | null,
      leaseId?: string | null,
      lease?:  {
        __typename: "Lease",
        id: string,
        balance?: number | null,
        canBeExtended?: boolean | null,
        communicationSettingsProfileId: string,
        createdAt?: string | null,
        endDate: string,
        includeRealEstateInLeaseContract?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        invoiceSenderId: string,
        inventoryOfFixturesExpert?: string | null,
        inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
        inventoryOfFixturesType?: InventoryOfFixturesType | null,
        ipiNumber?: string | null,
        language: Language,
        lastDraftInvoiceDate?: string | null,
        lastIndexationProcessDate?: string | null,
        lastInvoiceDate?: string | null,
        legalCompetentAuthority?: string | null,
        name: string,
        notes?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        purchaseOrderNumber?: string | null,
        realEstateAgency?: string | null,
        realEstateTax?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        signatureDate?: string | null,
        startDate: string,
        nextIndexationMonth?: string | null,
        nextIndexation?: boolean | null,
        status: LeaseStatus,
        technicCommunicationSettingsProfileId: string,
        totalInitialRentalPrice: number,
        totalRentalPrice: number,
        type: LeaseType,
        subletting?: boolean | null,
        vatRateRentId?: string | null,
        bankAccountId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      agencyRateStatements?:  {
        __typename: "ModelAgencyRateStatementConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      ownerId?: string | null,
      owner?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      repaymentStatements?:  {
        __typename: "ModelRepaymentStatementConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      types?: Array< StatementType > | null,
      viewType: StatementViewType,
      unitIds?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetStatementSettingQueryVariables = {
  id: string,
};

export type GetStatementSettingQuery = {
  getStatementSetting?:  {
    __typename: "StatementSetting",
    id: string,
    type: StatementSettingType,
    custom: boolean,
    disabled?: boolean | null,
    monthFrequency: number,
    startMonth?: string | null,
    generationDay?: number | null,
    leaseId?: string | null,
    lease?:  {
      __typename: "Lease",
      id: string,
      advancedChargesInvoices?:  {
        __typename: "LeaseAdvancedChargesInvoice",
        communicationSettingsProfileId: string,
        invoiceSenderId: string,
        lastDraftInvoiceDate?: string | null,
        lastInvoiceDate?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        bankAccountId?: string | null,
      } | null,
      balance?: number | null,
      canBeExtended?: boolean | null,
      communicationSettingsProfileId: string,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      endDate: string,
      includeRealEstateInLeaseContract?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      invoiceSenderId: string,
      invoiceSender?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      inventoryOfFixturesExpert?: string | null,
      inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
      inventoryOfFixturesType?: InventoryOfFixturesType | null,
      ipiNumber?: string | null,
      language: Language,
      lastDraftInvoiceDate?: string | null,
      lastIndexationProcessDate?: string | null,
      lastInvoiceDate?: string | null,
      legalCompetentAuthority?: string | null,
      name: string,
      notes?: string | null,
      paymentFrequency: LeasePaymentFrequency,
      paymentInvoicePeriod: LeasePaymentInvoicePeriod,
      paymentInvoicePeriodCustomDay?: number | null,
      paymentOption?:  {
        __typename: "LeasePaymentOption",
        customerId?: string | null,
        enabled: boolean,
        mandateActivatedAt?: string | null,
        mandateStatus?: PaymentProviderMandateStatus | null,
        paymentMethodId?: string | null,
        qrType?: LeaseQrType | null,
      } | null,
      purchaseOrderNumber?: string | null,
      realEstateAgency?: string | null,
      realEstateTax?: number | null,
      remittanceInformation?: string | null,
      remittanceInformationType?: LeaseRemittanceType | null,
      rentalGuaranty?:  {
        __typename: "LeaseRentalGuaranty",
        amount: number,
        blockedAmount?: number | null,
        releasedAmount?: number | null,
        type: LeaseRentalGuarantyType,
        financialInstitution?: string | null,
      } | null,
      signatureDate?: string | null,
      startDate: string,
      nextIndexationMonth?: string | null,
      nextIndexation?: boolean | null,
      status: LeaseStatus,
      technicCommunicationSettingsProfileId: string,
      totalInitialRentalPrice: number,
      totalRentalPrice: number,
      type: LeaseType,
      subletting?: boolean | null,
      vatRateRentId?: string | null,
      vatRateRent?:  {
        __typename: "VatRate",
        id: string,
        country: string,
        label: string,
        value?: number | null,
        ownerId?: string | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      additionalClauses?:  {
        __typename: "ModelLeaseAdditionalClauseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      bankAccountId?: string | null,
      bankAccount?:  {
        __typename: "BankAccount",
        id: string,
        contactId: string,
        number: string,
        bicNumber?: string | null,
        bankName?: string | null,
        contactIds?: Array< string > | null,
        buildingIds?: Array< string > | null,
        holderName?: string | null,
        label?: string | null,
        disabled?: boolean | null,
        integrations?: Array< IntegrationName > | null,
        matchingRule?: BankAccountMatchingRule | null,
        balance?: number | null,
        balanceDate?: string | null,
        type: BankAccountType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contacts?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      files?:  {
        __typename: "ModelFileConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leaseActionHistories?:  {
        __typename: "ModelLeaseActionHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leasePriceHistories?:  {
        __typename: "ModelLeasePriceHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      signatureDocuments?:  {
        __typename: "ModelSignatureDocumentConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      variousOperations?:  {
        __typename: "ModelLeaseVariousOperationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    ownerId?: string | null,
    owner?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListStatementSettingsQueryVariables = {
  filter?: ModelStatementSettingFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListStatementSettingsQuery = {
  listStatementSettings?:  {
    __typename: "ModelStatementSettingConnection",
    items:  Array< {
      __typename: "StatementSetting",
      id: string,
      type: StatementSettingType,
      custom: boolean,
      disabled?: boolean | null,
      monthFrequency: number,
      startMonth?: string | null,
      generationDay?: number | null,
      leaseId?: string | null,
      lease?:  {
        __typename: "Lease",
        id: string,
        balance?: number | null,
        canBeExtended?: boolean | null,
        communicationSettingsProfileId: string,
        createdAt?: string | null,
        endDate: string,
        includeRealEstateInLeaseContract?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        invoiceSenderId: string,
        inventoryOfFixturesExpert?: string | null,
        inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
        inventoryOfFixturesType?: InventoryOfFixturesType | null,
        ipiNumber?: string | null,
        language: Language,
        lastDraftInvoiceDate?: string | null,
        lastIndexationProcessDate?: string | null,
        lastInvoiceDate?: string | null,
        legalCompetentAuthority?: string | null,
        name: string,
        notes?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        purchaseOrderNumber?: string | null,
        realEstateAgency?: string | null,
        realEstateTax?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        signatureDate?: string | null,
        startDate: string,
        nextIndexationMonth?: string | null,
        nextIndexation?: boolean | null,
        status: LeaseStatus,
        technicCommunicationSettingsProfileId: string,
        totalInitialRentalPrice: number,
        totalRentalPrice: number,
        type: LeaseType,
        subletting?: boolean | null,
        vatRateRentId?: string | null,
        bankAccountId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      ownerId?: string | null,
      owner?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncStatementSettingsQueryVariables = {
  filter?: ModelStatementSettingFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncStatementSettingsQuery = {
  syncStatementSettings?:  {
    __typename: "ModelStatementSettingConnection",
    items:  Array< {
      __typename: "StatementSetting",
      id: string,
      type: StatementSettingType,
      custom: boolean,
      disabled?: boolean | null,
      monthFrequency: number,
      startMonth?: string | null,
      generationDay?: number | null,
      leaseId?: string | null,
      lease?:  {
        __typename: "Lease",
        id: string,
        balance?: number | null,
        canBeExtended?: boolean | null,
        communicationSettingsProfileId: string,
        createdAt?: string | null,
        endDate: string,
        includeRealEstateInLeaseContract?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        invoiceSenderId: string,
        inventoryOfFixturesExpert?: string | null,
        inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
        inventoryOfFixturesType?: InventoryOfFixturesType | null,
        ipiNumber?: string | null,
        language: Language,
        lastDraftInvoiceDate?: string | null,
        lastIndexationProcessDate?: string | null,
        lastInvoiceDate?: string | null,
        legalCompetentAuthority?: string | null,
        name: string,
        notes?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        purchaseOrderNumber?: string | null,
        realEstateAgency?: string | null,
        realEstateTax?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        signatureDate?: string | null,
        startDate: string,
        nextIndexationMonth?: string | null,
        nextIndexation?: boolean | null,
        status: LeaseStatus,
        technicCommunicationSettingsProfileId: string,
        totalInitialRentalPrice: number,
        totalRentalPrice: number,
        type: LeaseType,
        subletting?: boolean | null,
        vatRateRentId?: string | null,
        bankAccountId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      ownerId?: string | null,
      owner?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetTagQueryVariables = {
  id: string,
};

export type GetTagQuery = {
  getTag?:  {
    __typename: "Tag",
    id: string,
    color?: string | null,
    foreignTableName: string,
    labels:  Array< {
      __typename: "CustomLabel",
      language: string,
      label: string,
    } >,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListTagsQueryVariables = {
  filter?: ModelTagFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListTagsQuery = {
  listTags?:  {
    __typename: "ModelTagConnection",
    items:  Array< {
      __typename: "Tag",
      id: string,
      color?: string | null,
      foreignTableName: string,
      labels:  Array< {
        __typename: "CustomLabel",
        language: string,
        label: string,
      } >,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncTagsQueryVariables = {
  filter?: ModelTagFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncTagsQuery = {
  syncTags?:  {
    __typename: "ModelTagConnection",
    items:  Array< {
      __typename: "Tag",
      id: string,
      color?: string | null,
      foreignTableName: string,
      labels:  Array< {
        __typename: "CustomLabel",
        language: string,
        label: string,
      } >,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetTechnicQueryVariables = {
  id: string,
};

export type GetTechnicQuery = {
  getTechnic?:  {
    __typename: "Technic",
    id: string,
    type: TechnicType,
    contractNumber?: string | null,
    communicationSettingsProfileId: string,
    maintenanceHistory?:  Array< {
      __typename: "TechnicMaintenanceHistory",
      date: string,
      contactId?: string | null,
      fileId?: string | null,
    } > | null,
    technicLibraryId?: string | null,
    technicLibrary?:  {
      __typename: "TechnicLibrary",
      id: string,
      certificateValidity?:  {
        __typename: "CertificateLibraryValidity",
        nonCompliant?: boolean | null,
        overlapping?: boolean | null,
        riskLevel?: RiskLevelExpiration | null,
      } | null,
      communicationSettingsProfileId?: string | null,
      criticality: TechnicLibraryCriticality,
      customFields?:  {
        __typename: "ModelCustomFieldConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      descriptions?:  Array< {
        __typename: "CustomLabel",
        language: string,
        label: string,
      } > | null,
      isDefault?: boolean | null,
      issuingAuthority?: string | null,
      linkedCertificateIds?: Array< string > | null,
      locationScope?: TechnicLibraryLocationScope | null,
      maintenanceSchemas?:  Array< {
        __typename: "TechnicLibraryMaintenanceSchema",
        id: string,
        criticality: TechnicLibraryCriticality,
        deadline?: string | null,
        maintenanceType: TechnicLibraryMaintenanceType,
        notificationsEnabled?: boolean | null,
        notificationType?: NotificationType | null,
        proofType?: Array< TechnicLibraryProofType > | null,
        recurrence?: TechnicLibraryRecurrence | null,
        responsibleParty: TechnicLibraryResponsibleParty,
        triggerType?: TechnicLibraryTriggerType | null,
      } > | null,
      names:  Array< {
        __typename: "CustomLabel",
        language: string,
        label: string,
      } >,
      status: TechnicLibraryStatus,
      tagIds?: Array< string > | null,
      technicLibraryFormat?: string | null,
      type: TechnicLibraryType,
      utilityTypes?: Array< UtilityType > | null,
      validity?:  {
        __typename: "TechnicLibraryValidity",
        value: number,
        validityUnit: TechnicLibraryValidityUnit,
      } | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    technicName?: string | null,
    lastControlDate?: string | null,
    status?: TechnicStatus | null,
    utilityType?: UtilityType | null,
    utilityEanCode?: string | null,
    utilityMeterNumber?: string | null,
    utilityDistributorId?: string | null,
    utilityDistributor?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    utilityHistory?:  Array< {
      __typename: "UtilityHistory",
      date: string,
      reason?: UtilityReadingReason | null,
      reading: number,
      secondReading?: number | null,
    } > | null,
    files?:  {
      __typename: "ModelFileConnection",
      items:  Array< {
        __typename: "File",
        id: string,
        bucket: string,
        createdAt?: string | null,
        categoryId: string,
        foreignKey: string,
        foreignTableName: string,
        key: string,
        mimeType?: string | null,
        region: string,
        size?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        _ttl?: number | null,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    buildingId?: string | null,
    building?:  {
      __typename: "Building",
      id: string,
      name: string,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      acquisitionValue?: number | null,
      acquisitionAdditionalCostsValue?: number | null,
      acquisitionAdvertisedValue?: number | null,
      amountOfFacades?: number | null,
      amountOfFloors?: number | null,
      amountOfHousings?: number | null,
      buildingState?: BuildingState | null,
      cadastralIncome?: number | null,
      constructionYear?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      janitor?: boolean | null,
      jointOwnershipId?: string | null,
      notes?: string | null,
      owners?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      propertyTax?: number | null,
      residenceName?: string | null,
      buildingSiteId?: string | null,
      buildingSite?:  {
        __typename: "BuildingSite",
        id: string,
        name: string,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      units?:  {
        __typename: "ModelUnitConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      events?:  {
        __typename: "ModelBuildingEventConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      teams?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    unitId?: string | null,
    unit?:  {
      __typename: "Unit",
      id: string,
      acquisitionAdditionalCostsValue?: number | null,
      acquisitionAdvertisedValue?: number | null,
      acquisitionValue?: number | null,
      advertisedMonthlyCharges?: number | null,
      advertisedRentalPrice?: number | null,
      cadastralIncome?: number | null,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      floor?: number | null,
      jointOwnershipId?: string | null,
      managementDate: string,
      name: string,
      notes?: string | null,
      predictedPrice?: string | null,
      propertyTax?: number | null,
      publishAddress?: boolean | null,
      surface?: number | null,
      type: UnitType,
      buildingId: string,
      building?:  {
        __typename: "Building",
        id: string,
        name: string,
        addressId?: string | null,
        acquisitionValue?: number | null,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        amountOfFacades?: number | null,
        amountOfFloors?: number | null,
        amountOfHousings?: number | null,
        buildingState?: BuildingState | null,
        cadastralIncome?: number | null,
        constructionYear?: string | null,
        janitor?: boolean | null,
        jointOwnershipId?: string | null,
        notes?: string | null,
        propertyTax?: number | null,
        residenceName?: string | null,
        buildingSiteId?: string | null,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      owners?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leases?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      events?:  {
        __typename: "ModelUnitEventConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      unitAdvertisementId?: string | null,
      unitInventories?:  {
        __typename: "ModelUnitInventoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    leaseId?: string | null,
    lease?:  {
      __typename: "Lease",
      id: string,
      advancedChargesInvoices?:  {
        __typename: "LeaseAdvancedChargesInvoice",
        communicationSettingsProfileId: string,
        invoiceSenderId: string,
        lastDraftInvoiceDate?: string | null,
        lastInvoiceDate?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        bankAccountId?: string | null,
      } | null,
      balance?: number | null,
      canBeExtended?: boolean | null,
      communicationSettingsProfileId: string,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      endDate: string,
      includeRealEstateInLeaseContract?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      invoiceSenderId: string,
      invoiceSender?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      inventoryOfFixturesExpert?: string | null,
      inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
      inventoryOfFixturesType?: InventoryOfFixturesType | null,
      ipiNumber?: string | null,
      language: Language,
      lastDraftInvoiceDate?: string | null,
      lastIndexationProcessDate?: string | null,
      lastInvoiceDate?: string | null,
      legalCompetentAuthority?: string | null,
      name: string,
      notes?: string | null,
      paymentFrequency: LeasePaymentFrequency,
      paymentInvoicePeriod: LeasePaymentInvoicePeriod,
      paymentInvoicePeriodCustomDay?: number | null,
      paymentOption?:  {
        __typename: "LeasePaymentOption",
        customerId?: string | null,
        enabled: boolean,
        mandateActivatedAt?: string | null,
        mandateStatus?: PaymentProviderMandateStatus | null,
        paymentMethodId?: string | null,
        qrType?: LeaseQrType | null,
      } | null,
      purchaseOrderNumber?: string | null,
      realEstateAgency?: string | null,
      realEstateTax?: number | null,
      remittanceInformation?: string | null,
      remittanceInformationType?: LeaseRemittanceType | null,
      rentalGuaranty?:  {
        __typename: "LeaseRentalGuaranty",
        amount: number,
        blockedAmount?: number | null,
        releasedAmount?: number | null,
        type: LeaseRentalGuarantyType,
        financialInstitution?: string | null,
      } | null,
      signatureDate?: string | null,
      startDate: string,
      nextIndexationMonth?: string | null,
      nextIndexation?: boolean | null,
      status: LeaseStatus,
      technicCommunicationSettingsProfileId: string,
      totalInitialRentalPrice: number,
      totalRentalPrice: number,
      type: LeaseType,
      subletting?: boolean | null,
      vatRateRentId?: string | null,
      vatRateRent?:  {
        __typename: "VatRate",
        id: string,
        country: string,
        label: string,
        value?: number | null,
        ownerId?: string | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      additionalClauses?:  {
        __typename: "ModelLeaseAdditionalClauseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      bankAccountId?: string | null,
      bankAccount?:  {
        __typename: "BankAccount",
        id: string,
        contactId: string,
        number: string,
        bicNumber?: string | null,
        bankName?: string | null,
        contactIds?: Array< string > | null,
        buildingIds?: Array< string > | null,
        holderName?: string | null,
        label?: string | null,
        disabled?: boolean | null,
        integrations?: Array< IntegrationName > | null,
        matchingRule?: BankAccountMatchingRule | null,
        balance?: number | null,
        balanceDate?: string | null,
        type: BankAccountType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contacts?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      files?:  {
        __typename: "ModelFileConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leaseActionHistories?:  {
        __typename: "ModelLeaseActionHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leasePriceHistories?:  {
        __typename: "ModelLeasePriceHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      signatureDocuments?:  {
        __typename: "ModelSignatureDocumentConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      variousOperations?:  {
        __typename: "ModelLeaseVariousOperationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    contactId?: string | null,
    contact?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    customValues?:  Array< {
      __typename: "CustomValue",
      name: string,
      value: string,
    } > | null,
    originalTechnicId?: string | null,
    replacedTechnicId?: string | null,
    certificateIds?: Array< string > | null,
    readers?: Array< string > | null,
    writers?: Array< string > | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListTechnicsQueryVariables = {
  filter?: ModelTechnicFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListTechnicsQuery = {
  listTechnics?:  {
    __typename: "ModelTechnicConnection",
    items:  Array< {
      __typename: "Technic",
      id: string,
      type: TechnicType,
      contractNumber?: string | null,
      communicationSettingsProfileId: string,
      maintenanceHistory?:  Array< {
        __typename: "TechnicMaintenanceHistory",
        date: string,
        contactId?: string | null,
        fileId?: string | null,
      } > | null,
      technicLibraryId?: string | null,
      technicLibrary?:  {
        __typename: "TechnicLibrary",
        id: string,
        communicationSettingsProfileId?: string | null,
        criticality: TechnicLibraryCriticality,
        isDefault?: boolean | null,
        issuingAuthority?: string | null,
        linkedCertificateIds?: Array< string > | null,
        locationScope?: TechnicLibraryLocationScope | null,
        status: TechnicLibraryStatus,
        tagIds?: Array< string > | null,
        technicLibraryFormat?: string | null,
        type: TechnicLibraryType,
        utilityTypes?: Array< UtilityType > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      technicName?: string | null,
      lastControlDate?: string | null,
      status?: TechnicStatus | null,
      utilityType?: UtilityType | null,
      utilityEanCode?: string | null,
      utilityMeterNumber?: string | null,
      utilityDistributorId?: string | null,
      utilityDistributor?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      utilityHistory?:  Array< {
        __typename: "UtilityHistory",
        date: string,
        reason?: UtilityReadingReason | null,
        reading: number,
        secondReading?: number | null,
      } > | null,
      files?:  {
        __typename: "ModelFileConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildingId?: string | null,
      building?:  {
        __typename: "Building",
        id: string,
        name: string,
        addressId?: string | null,
        acquisitionValue?: number | null,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        amountOfFacades?: number | null,
        amountOfFloors?: number | null,
        amountOfHousings?: number | null,
        buildingState?: BuildingState | null,
        cadastralIncome?: number | null,
        constructionYear?: string | null,
        janitor?: boolean | null,
        jointOwnershipId?: string | null,
        notes?: string | null,
        propertyTax?: number | null,
        residenceName?: string | null,
        buildingSiteId?: string | null,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      unitId?: string | null,
      unit?:  {
        __typename: "Unit",
        id: string,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        acquisitionValue?: number | null,
        advertisedMonthlyCharges?: number | null,
        advertisedRentalPrice?: number | null,
        cadastralIncome?: number | null,
        createdAt?: string | null,
        floor?: number | null,
        jointOwnershipId?: string | null,
        managementDate: string,
        name: string,
        notes?: string | null,
        predictedPrice?: string | null,
        propertyTax?: number | null,
        publishAddress?: boolean | null,
        surface?: number | null,
        type: UnitType,
        buildingId: string,
        unitAdvertisementId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      leaseId?: string | null,
      lease?:  {
        __typename: "Lease",
        id: string,
        balance?: number | null,
        canBeExtended?: boolean | null,
        communicationSettingsProfileId: string,
        createdAt?: string | null,
        endDate: string,
        includeRealEstateInLeaseContract?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        invoiceSenderId: string,
        inventoryOfFixturesExpert?: string | null,
        inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
        inventoryOfFixturesType?: InventoryOfFixturesType | null,
        ipiNumber?: string | null,
        language: Language,
        lastDraftInvoiceDate?: string | null,
        lastIndexationProcessDate?: string | null,
        lastInvoiceDate?: string | null,
        legalCompetentAuthority?: string | null,
        name: string,
        notes?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        purchaseOrderNumber?: string | null,
        realEstateAgency?: string | null,
        realEstateTax?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        signatureDate?: string | null,
        startDate: string,
        nextIndexationMonth?: string | null,
        nextIndexation?: boolean | null,
        status: LeaseStatus,
        technicCommunicationSettingsProfileId: string,
        totalInitialRentalPrice: number,
        totalRentalPrice: number,
        type: LeaseType,
        subletting?: boolean | null,
        vatRateRentId?: string | null,
        bankAccountId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contactId?: string | null,
      contact?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      originalTechnicId?: string | null,
      replacedTechnicId?: string | null,
      certificateIds?: Array< string > | null,
      readers?: Array< string > | null,
      writers?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncTechnicsQueryVariables = {
  filter?: ModelTechnicFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncTechnicsQuery = {
  syncTechnics?:  {
    __typename: "ModelTechnicConnection",
    items:  Array< {
      __typename: "Technic",
      id: string,
      type: TechnicType,
      contractNumber?: string | null,
      communicationSettingsProfileId: string,
      maintenanceHistory?:  Array< {
        __typename: "TechnicMaintenanceHistory",
        date: string,
        contactId?: string | null,
        fileId?: string | null,
      } > | null,
      technicLibraryId?: string | null,
      technicLibrary?:  {
        __typename: "TechnicLibrary",
        id: string,
        communicationSettingsProfileId?: string | null,
        criticality: TechnicLibraryCriticality,
        isDefault?: boolean | null,
        issuingAuthority?: string | null,
        linkedCertificateIds?: Array< string > | null,
        locationScope?: TechnicLibraryLocationScope | null,
        status: TechnicLibraryStatus,
        tagIds?: Array< string > | null,
        technicLibraryFormat?: string | null,
        type: TechnicLibraryType,
        utilityTypes?: Array< UtilityType > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      technicName?: string | null,
      lastControlDate?: string | null,
      status?: TechnicStatus | null,
      utilityType?: UtilityType | null,
      utilityEanCode?: string | null,
      utilityMeterNumber?: string | null,
      utilityDistributorId?: string | null,
      utilityDistributor?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      utilityHistory?:  Array< {
        __typename: "UtilityHistory",
        date: string,
        reason?: UtilityReadingReason | null,
        reading: number,
        secondReading?: number | null,
      } > | null,
      files?:  {
        __typename: "ModelFileConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildingId?: string | null,
      building?:  {
        __typename: "Building",
        id: string,
        name: string,
        addressId?: string | null,
        acquisitionValue?: number | null,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        amountOfFacades?: number | null,
        amountOfFloors?: number | null,
        amountOfHousings?: number | null,
        buildingState?: BuildingState | null,
        cadastralIncome?: number | null,
        constructionYear?: string | null,
        janitor?: boolean | null,
        jointOwnershipId?: string | null,
        notes?: string | null,
        propertyTax?: number | null,
        residenceName?: string | null,
        buildingSiteId?: string | null,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      unitId?: string | null,
      unit?:  {
        __typename: "Unit",
        id: string,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        acquisitionValue?: number | null,
        advertisedMonthlyCharges?: number | null,
        advertisedRentalPrice?: number | null,
        cadastralIncome?: number | null,
        createdAt?: string | null,
        floor?: number | null,
        jointOwnershipId?: string | null,
        managementDate: string,
        name: string,
        notes?: string | null,
        predictedPrice?: string | null,
        propertyTax?: number | null,
        publishAddress?: boolean | null,
        surface?: number | null,
        type: UnitType,
        buildingId: string,
        unitAdvertisementId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      leaseId?: string | null,
      lease?:  {
        __typename: "Lease",
        id: string,
        balance?: number | null,
        canBeExtended?: boolean | null,
        communicationSettingsProfileId: string,
        createdAt?: string | null,
        endDate: string,
        includeRealEstateInLeaseContract?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        invoiceSenderId: string,
        inventoryOfFixturesExpert?: string | null,
        inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
        inventoryOfFixturesType?: InventoryOfFixturesType | null,
        ipiNumber?: string | null,
        language: Language,
        lastDraftInvoiceDate?: string | null,
        lastIndexationProcessDate?: string | null,
        lastInvoiceDate?: string | null,
        legalCompetentAuthority?: string | null,
        name: string,
        notes?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        purchaseOrderNumber?: string | null,
        realEstateAgency?: string | null,
        realEstateTax?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        signatureDate?: string | null,
        startDate: string,
        nextIndexationMonth?: string | null,
        nextIndexation?: boolean | null,
        status: LeaseStatus,
        technicCommunicationSettingsProfileId: string,
        totalInitialRentalPrice: number,
        totalRentalPrice: number,
        type: LeaseType,
        subletting?: boolean | null,
        vatRateRentId?: string | null,
        bankAccountId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contactId?: string | null,
      contact?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      originalTechnicId?: string | null,
      replacedTechnicId?: string | null,
      certificateIds?: Array< string > | null,
      readers?: Array< string > | null,
      writers?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetTechnicLibraryQueryVariables = {
  id: string,
};

export type GetTechnicLibraryQuery = {
  getTechnicLibrary?:  {
    __typename: "TechnicLibrary",
    id: string,
    certificateValidity?:  {
      __typename: "CertificateLibraryValidity",
      gracePeriod?:  {
        __typename: "TechnicLibraryValidity",
        value: number,
        validityUnit: TechnicLibraryValidityUnit,
      } | null,
      nonCompliant?: boolean | null,
      overlapping?: boolean | null,
      riskLevel?: RiskLevelExpiration | null,
    } | null,
    communicationSettingsProfileId?: string | null,
    criticality: TechnicLibraryCriticality,
    customFields?:  {
      __typename: "ModelCustomFieldConnection",
      items:  Array< {
        __typename: "CustomField",
        id: string,
        fieldName: string,
        fieldType: CustomFieldType,
        foreignKey: string,
        foreignTableName: string,
        order?: number | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    descriptions?:  Array< {
      __typename: "CustomLabel",
      language: string,
      label: string,
    } > | null,
    isDefault?: boolean | null,
    issuingAuthority?: string | null,
    linkedCertificateIds?: Array< string > | null,
    locationScope?: TechnicLibraryLocationScope | null,
    maintenanceSchemas?:  Array< {
      __typename: "TechnicLibraryMaintenanceSchema",
      id: string,
      criticality: TechnicLibraryCriticality,
      deadline?: string | null,
      descriptions?:  Array< {
        __typename: "CustomLabel",
        language: string,
        label: string,
      } > | null,
      interval?:  {
        __typename: "TechnicLibraryValidity",
        value: number,
        validityUnit: TechnicLibraryValidityUnit,
      } | null,
      maintenanceType: TechnicLibraryMaintenanceType,
      names:  Array< {
        __typename: "CustomLabel",
        language: string,
        label: string,
      } >,
      notificationsEnabled?: boolean | null,
      notificationType?: NotificationType | null,
      proofType?: Array< TechnicLibraryProofType > | null,
      proofTypeName?:  Array< {
        __typename: "CustomLabel",
        language: string,
        label: string,
      } > | null,
      recurrence?: TechnicLibraryRecurrence | null,
      responsibleParty: TechnicLibraryResponsibleParty,
      triggerType?: TechnicLibraryTriggerType | null,
    } > | null,
    names:  Array< {
      __typename: "CustomLabel",
      language: string,
      label: string,
    } >,
    status: TechnicLibraryStatus,
    tagIds?: Array< string > | null,
    technicLibraryFormat?: string | null,
    type: TechnicLibraryType,
    utilityTypes?: Array< UtilityType > | null,
    validity?:  {
      __typename: "TechnicLibraryValidity",
      value: number,
      validityUnit: TechnicLibraryValidityUnit,
    } | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListTechnicLibrariesQueryVariables = {
  filter?: ModelTechnicLibraryFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListTechnicLibrariesQuery = {
  listTechnicLibraries?:  {
    __typename: "ModelTechnicLibraryConnection",
    items:  Array< {
      __typename: "TechnicLibrary",
      id: string,
      certificateValidity?:  {
        __typename: "CertificateLibraryValidity",
        nonCompliant?: boolean | null,
        overlapping?: boolean | null,
        riskLevel?: RiskLevelExpiration | null,
      } | null,
      communicationSettingsProfileId?: string | null,
      criticality: TechnicLibraryCriticality,
      customFields?:  {
        __typename: "ModelCustomFieldConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      descriptions?:  Array< {
        __typename: "CustomLabel",
        language: string,
        label: string,
      } > | null,
      isDefault?: boolean | null,
      issuingAuthority?: string | null,
      linkedCertificateIds?: Array< string > | null,
      locationScope?: TechnicLibraryLocationScope | null,
      maintenanceSchemas?:  Array< {
        __typename: "TechnicLibraryMaintenanceSchema",
        id: string,
        criticality: TechnicLibraryCriticality,
        deadline?: string | null,
        maintenanceType: TechnicLibraryMaintenanceType,
        notificationsEnabled?: boolean | null,
        notificationType?: NotificationType | null,
        proofType?: Array< TechnicLibraryProofType > | null,
        recurrence?: TechnicLibraryRecurrence | null,
        responsibleParty: TechnicLibraryResponsibleParty,
        triggerType?: TechnicLibraryTriggerType | null,
      } > | null,
      names:  Array< {
        __typename: "CustomLabel",
        language: string,
        label: string,
      } >,
      status: TechnicLibraryStatus,
      tagIds?: Array< string > | null,
      technicLibraryFormat?: string | null,
      type: TechnicLibraryType,
      utilityTypes?: Array< UtilityType > | null,
      validity?:  {
        __typename: "TechnicLibraryValidity",
        value: number,
        validityUnit: TechnicLibraryValidityUnit,
      } | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncTechnicLibrariesQueryVariables = {
  filter?: ModelTechnicLibraryFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncTechnicLibrariesQuery = {
  syncTechnicLibraries?:  {
    __typename: "ModelTechnicLibraryConnection",
    items:  Array< {
      __typename: "TechnicLibrary",
      id: string,
      certificateValidity?:  {
        __typename: "CertificateLibraryValidity",
        nonCompliant?: boolean | null,
        overlapping?: boolean | null,
        riskLevel?: RiskLevelExpiration | null,
      } | null,
      communicationSettingsProfileId?: string | null,
      criticality: TechnicLibraryCriticality,
      customFields?:  {
        __typename: "ModelCustomFieldConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      descriptions?:  Array< {
        __typename: "CustomLabel",
        language: string,
        label: string,
      } > | null,
      isDefault?: boolean | null,
      issuingAuthority?: string | null,
      linkedCertificateIds?: Array< string > | null,
      locationScope?: TechnicLibraryLocationScope | null,
      maintenanceSchemas?:  Array< {
        __typename: "TechnicLibraryMaintenanceSchema",
        id: string,
        criticality: TechnicLibraryCriticality,
        deadline?: string | null,
        maintenanceType: TechnicLibraryMaintenanceType,
        notificationsEnabled?: boolean | null,
        notificationType?: NotificationType | null,
        proofType?: Array< TechnicLibraryProofType > | null,
        recurrence?: TechnicLibraryRecurrence | null,
        responsibleParty: TechnicLibraryResponsibleParty,
        triggerType?: TechnicLibraryTriggerType | null,
      } > | null,
      names:  Array< {
        __typename: "CustomLabel",
        language: string,
        label: string,
      } >,
      status: TechnicLibraryStatus,
      tagIds?: Array< string > | null,
      technicLibraryFormat?: string | null,
      type: TechnicLibraryType,
      utilityTypes?: Array< UtilityType > | null,
      validity?:  {
        __typename: "TechnicLibraryValidity",
        value: number,
        validityUnit: TechnicLibraryValidityUnit,
      } | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetTicketQueryVariables = {
  id: string,
};

export type GetTicketQuery = {
  getTicket?:  {
    __typename: "Ticket",
    id: string,
    assignedAt?: string | null,
    assignedTo?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    assignedToId?: string | null,
    attachment?:  {
      __typename: "ModelFileConnection",
      items:  Array< {
        __typename: "File",
        id: string,
        bucket: string,
        createdAt?: string | null,
        categoryId: string,
        foreignKey: string,
        foreignTableName: string,
        key: string,
        mimeType?: string | null,
        region: string,
        size?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        _ttl?: number | null,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    building?:  {
      __typename: "Building",
      id: string,
      name: string,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      acquisitionValue?: number | null,
      acquisitionAdditionalCostsValue?: number | null,
      acquisitionAdvertisedValue?: number | null,
      amountOfFacades?: number | null,
      amountOfFloors?: number | null,
      amountOfHousings?: number | null,
      buildingState?: BuildingState | null,
      cadastralIncome?: number | null,
      constructionYear?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      janitor?: boolean | null,
      jointOwnershipId?: string | null,
      notes?: string | null,
      owners?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      propertyTax?: number | null,
      residenceName?: string | null,
      buildingSiteId?: string | null,
      buildingSite?:  {
        __typename: "BuildingSite",
        id: string,
        name: string,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      units?:  {
        __typename: "ModelUnitConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      events?:  {
        __typename: "ModelBuildingEventConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      teams?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    buildingId?: string | null,
    closedAt?: string | null,
    contact?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    contactId: string,
    content: string,
    conversations?:  {
      __typename: "ModelTicketConnection",
      items:  Array< {
        __typename: "Ticket",
        id: string,
        assignedAt?: string | null,
        assignedToId?: string | null,
        buildingId?: string | null,
        closedAt?: string | null,
        contactId: string,
        content: string,
        createdAt: string,
        emailMessageId?: string | null,
        emailReferences?: Array< string | null > | null,
        parentId?: string | null,
        plannedAt?: string | null,
        referenceCode?: string | null,
        sourceType: TicketSourceType,
        status?: TicketStatus | null,
        subject: string,
        unitId?: string | null,
        unread: boolean,
        updatedAt?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    createdAt: string,
    emailMessageId?: string | null,
    emailReferences?: Array< string | null > | null,
    parentId?: string | null,
    plannedAt?: string | null,
    referenceCode?: string | null,
    sourceType: TicketSourceType,
    status?: TicketStatus | null,
    subject: string,
    unit?:  {
      __typename: "Unit",
      id: string,
      acquisitionAdditionalCostsValue?: number | null,
      acquisitionAdvertisedValue?: number | null,
      acquisitionValue?: number | null,
      advertisedMonthlyCharges?: number | null,
      advertisedRentalPrice?: number | null,
      cadastralIncome?: number | null,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      floor?: number | null,
      jointOwnershipId?: string | null,
      managementDate: string,
      name: string,
      notes?: string | null,
      predictedPrice?: string | null,
      propertyTax?: number | null,
      publishAddress?: boolean | null,
      surface?: number | null,
      type: UnitType,
      buildingId: string,
      building?:  {
        __typename: "Building",
        id: string,
        name: string,
        addressId?: string | null,
        acquisitionValue?: number | null,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        amountOfFacades?: number | null,
        amountOfFloors?: number | null,
        amountOfHousings?: number | null,
        buildingState?: BuildingState | null,
        cadastralIncome?: number | null,
        constructionYear?: string | null,
        janitor?: boolean | null,
        jointOwnershipId?: string | null,
        notes?: string | null,
        propertyTax?: number | null,
        residenceName?: string | null,
        buildingSiteId?: string | null,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      owners?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leases?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      events?:  {
        __typename: "ModelUnitEventConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      unitAdvertisementId?: string | null,
      unitInventories?:  {
        __typename: "ModelUnitInventoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    unitId?: string | null,
    unread: boolean,
    updatedAt?: string | null,
    readers?: Array< string > | null,
    readId: string,
    clientId: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListTicketsQueryVariables = {
  id?: string | null,
  filter?: ModelTicketFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListTicketsQuery = {
  listTickets?:  {
    __typename: "ModelTicketConnection",
    items:  Array< {
      __typename: "Ticket",
      id: string,
      assignedAt?: string | null,
      assignedTo?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      assignedToId?: string | null,
      attachment?:  {
        __typename: "ModelFileConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      building?:  {
        __typename: "Building",
        id: string,
        name: string,
        addressId?: string | null,
        acquisitionValue?: number | null,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        amountOfFacades?: number | null,
        amountOfFloors?: number | null,
        amountOfHousings?: number | null,
        buildingState?: BuildingState | null,
        cadastralIncome?: number | null,
        constructionYear?: string | null,
        janitor?: boolean | null,
        jointOwnershipId?: string | null,
        notes?: string | null,
        propertyTax?: number | null,
        residenceName?: string | null,
        buildingSiteId?: string | null,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      buildingId?: string | null,
      closedAt?: string | null,
      contact?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contactId: string,
      content: string,
      conversations?:  {
        __typename: "ModelTicketConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      createdAt: string,
      emailMessageId?: string | null,
      emailReferences?: Array< string | null > | null,
      parentId?: string | null,
      plannedAt?: string | null,
      referenceCode?: string | null,
      sourceType: TicketSourceType,
      status?: TicketStatus | null,
      subject: string,
      unit?:  {
        __typename: "Unit",
        id: string,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        acquisitionValue?: number | null,
        advertisedMonthlyCharges?: number | null,
        advertisedRentalPrice?: number | null,
        cadastralIncome?: number | null,
        createdAt?: string | null,
        floor?: number | null,
        jointOwnershipId?: string | null,
        managementDate: string,
        name: string,
        notes?: string | null,
        predictedPrice?: string | null,
        propertyTax?: number | null,
        publishAddress?: boolean | null,
        surface?: number | null,
        type: UnitType,
        buildingId: string,
        unitAdvertisementId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      unitId?: string | null,
      unread: boolean,
      updatedAt?: string | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncTicketsQueryVariables = {
  filter?: ModelTicketFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncTicketsQuery = {
  syncTickets?:  {
    __typename: "ModelTicketConnection",
    items:  Array< {
      __typename: "Ticket",
      id: string,
      assignedAt?: string | null,
      assignedTo?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      assignedToId?: string | null,
      attachment?:  {
        __typename: "ModelFileConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      building?:  {
        __typename: "Building",
        id: string,
        name: string,
        addressId?: string | null,
        acquisitionValue?: number | null,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        amountOfFacades?: number | null,
        amountOfFloors?: number | null,
        amountOfHousings?: number | null,
        buildingState?: BuildingState | null,
        cadastralIncome?: number | null,
        constructionYear?: string | null,
        janitor?: boolean | null,
        jointOwnershipId?: string | null,
        notes?: string | null,
        propertyTax?: number | null,
        residenceName?: string | null,
        buildingSiteId?: string | null,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      buildingId?: string | null,
      closedAt?: string | null,
      contact?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contactId: string,
      content: string,
      conversations?:  {
        __typename: "ModelTicketConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      createdAt: string,
      emailMessageId?: string | null,
      emailReferences?: Array< string | null > | null,
      parentId?: string | null,
      plannedAt?: string | null,
      referenceCode?: string | null,
      sourceType: TicketSourceType,
      status?: TicketStatus | null,
      subject: string,
      unit?:  {
        __typename: "Unit",
        id: string,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        acquisitionValue?: number | null,
        advertisedMonthlyCharges?: number | null,
        advertisedRentalPrice?: number | null,
        cadastralIncome?: number | null,
        createdAt?: string | null,
        floor?: number | null,
        jointOwnershipId?: string | null,
        managementDate: string,
        name: string,
        notes?: string | null,
        predictedPrice?: string | null,
        propertyTax?: number | null,
        publishAddress?: boolean | null,
        surface?: number | null,
        type: UnitType,
        buildingId: string,
        unitAdvertisementId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      unitId?: string | null,
      unread: boolean,
      updatedAt?: string | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetUnitQueryVariables = {
  id: string,
};

export type GetUnitQuery = {
  getUnit?:  {
    __typename: "Unit",
    id: string,
    acquisitionAdditionalCostsValue?: number | null,
    acquisitionAdvertisedValue?: number | null,
    acquisitionValue?: number | null,
    advertisedMonthlyCharges?: number | null,
    advertisedRentalPrice?: number | null,
    cadastralIncome?: number | null,
    createdAt?: string | null,
    customValues?:  Array< {
      __typename: "CustomValue",
      name: string,
      value: string,
    } > | null,
    floor?: number | null,
    jointOwnershipId?: string | null,
    managementDate: string,
    name: string,
    notes?: string | null,
    predictedPrice?: string | null,
    propertyTax?: number | null,
    publishAddress?: boolean | null,
    surface?: number | null,
    type: UnitType,
    buildingId: string,
    building?:  {
      __typename: "Building",
      id: string,
      name: string,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      acquisitionValue?: number | null,
      acquisitionAdditionalCostsValue?: number | null,
      acquisitionAdvertisedValue?: number | null,
      amountOfFacades?: number | null,
      amountOfFloors?: number | null,
      amountOfHousings?: number | null,
      buildingState?: BuildingState | null,
      cadastralIncome?: number | null,
      constructionYear?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      janitor?: boolean | null,
      jointOwnershipId?: string | null,
      notes?: string | null,
      owners?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      propertyTax?: number | null,
      residenceName?: string | null,
      buildingSiteId?: string | null,
      buildingSite?:  {
        __typename: "BuildingSite",
        id: string,
        name: string,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      units?:  {
        __typename: "ModelUnitConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      events?:  {
        __typename: "ModelBuildingEventConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      teams?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    owners?:  {
      __typename: "ModelUnitOwnerConnection",
      items:  Array< {
        __typename: "UnitOwner",
        id: string,
        disabled?: boolean | null,
        ownerId: string,
        periodFrom?: string | null,
        periodTo?: string | null,
        stake: number,
        unitId: string,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    leases?:  {
      __typename: "ModelUnitLeaseConnection",
      items:  Array< {
        __typename: "UnitLease",
        id: string,
        allowChargeAdjustment?: boolean | null,
        authorizeProfessionalActivity?: boolean | null,
        chargesIndexation?: boolean | null,
        createdAt?: string | null,
        endDate: string,
        furnishedRental?: boolean | null,
        furnishedRentalInsuranceByTenant?: boolean | null,
        furnishedRentalRentalPricePercentage?: number | null,
        initialRentalPrice: number,
        indexation?: boolean | null,
        advancedIndexation?: boolean | null,
        indexType?: IndexType | null,
        baseYear?: number | null,
        baseIndexType?: BaseIndexType | null,
        baseIndexDate?: string | null,
        nextIndexationMonth?: string | null,
        nextIndexation?: boolean | null,
        leaseId: string,
        mainUnit: boolean,
        rentalPrice: number,
        signatureDate?: string | null,
        startDate: string,
        unitId: string,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    events?:  {
      __typename: "ModelUnitEventConnection",
      items:  Array< {
        __typename: "UnitEvent",
        id: string,
        unitId: string,
        type: UnitEventType,
        startDate: string,
        endDate: string,
        totalCost?: number | null,
        note?: string | null,
        writers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    unitAdvertisementId?: string | null,
    unitInventories?:  {
      __typename: "ModelUnitInventoryConnection",
      items:  Array< {
        __typename: "UnitInventory",
        id: string,
        privateBatthRoom?: boolean | null,
        createdAt?: string | null,
        deletedAt?: string | null,
        kitchenEquipment?: KitchenEquipment | null,
        roomName?: string | null,
        roomType: UnitInventoryRoomType,
        surface?: number | null,
        showSurface?: boolean | null,
        unitId: string,
        inside: boolean,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    readers?: Array< string > | null,
    readId: string,
    clientId: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListUnitsQueryVariables = {
  filter?: ModelUnitFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListUnitsQuery = {
  listUnits?:  {
    __typename: "ModelUnitConnection",
    items:  Array< {
      __typename: "Unit",
      id: string,
      acquisitionAdditionalCostsValue?: number | null,
      acquisitionAdvertisedValue?: number | null,
      acquisitionValue?: number | null,
      advertisedMonthlyCharges?: number | null,
      advertisedRentalPrice?: number | null,
      cadastralIncome?: number | null,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      floor?: number | null,
      jointOwnershipId?: string | null,
      managementDate: string,
      name: string,
      notes?: string | null,
      predictedPrice?: string | null,
      propertyTax?: number | null,
      publishAddress?: boolean | null,
      surface?: number | null,
      type: UnitType,
      buildingId: string,
      building?:  {
        __typename: "Building",
        id: string,
        name: string,
        addressId?: string | null,
        acquisitionValue?: number | null,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        amountOfFacades?: number | null,
        amountOfFloors?: number | null,
        amountOfHousings?: number | null,
        buildingState?: BuildingState | null,
        cadastralIncome?: number | null,
        constructionYear?: string | null,
        janitor?: boolean | null,
        jointOwnershipId?: string | null,
        notes?: string | null,
        propertyTax?: number | null,
        residenceName?: string | null,
        buildingSiteId?: string | null,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      owners?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leases?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      events?:  {
        __typename: "ModelUnitEventConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      unitAdvertisementId?: string | null,
      unitInventories?:  {
        __typename: "ModelUnitInventoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncUnitsQueryVariables = {
  filter?: ModelUnitFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncUnitsQuery = {
  syncUnits?:  {
    __typename: "ModelUnitConnection",
    items:  Array< {
      __typename: "Unit",
      id: string,
      acquisitionAdditionalCostsValue?: number | null,
      acquisitionAdvertisedValue?: number | null,
      acquisitionValue?: number | null,
      advertisedMonthlyCharges?: number | null,
      advertisedRentalPrice?: number | null,
      cadastralIncome?: number | null,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      floor?: number | null,
      jointOwnershipId?: string | null,
      managementDate: string,
      name: string,
      notes?: string | null,
      predictedPrice?: string | null,
      propertyTax?: number | null,
      publishAddress?: boolean | null,
      surface?: number | null,
      type: UnitType,
      buildingId: string,
      building?:  {
        __typename: "Building",
        id: string,
        name: string,
        addressId?: string | null,
        acquisitionValue?: number | null,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        amountOfFacades?: number | null,
        amountOfFloors?: number | null,
        amountOfHousings?: number | null,
        buildingState?: BuildingState | null,
        cadastralIncome?: number | null,
        constructionYear?: string | null,
        janitor?: boolean | null,
        jointOwnershipId?: string | null,
        notes?: string | null,
        propertyTax?: number | null,
        residenceName?: string | null,
        buildingSiteId?: string | null,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      owners?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leases?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      events?:  {
        __typename: "ModelUnitEventConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      unitAdvertisementId?: string | null,
      unitInventories?:  {
        __typename: "ModelUnitInventoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetUnitEventQueryVariables = {
  id: string,
};

export type GetUnitEventQuery = {
  getUnitEvent?:  {
    __typename: "UnitEvent",
    id: string,
    unitId: string,
    type: UnitEventType,
    startDate: string,
    endDate: string,
    totalCost?: number | null,
    note?: string | null,
    writers?: Array< string > | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListUnitEventsQueryVariables = {
  filter?: ModelUnitEventFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListUnitEventsQuery = {
  listUnitEvents?:  {
    __typename: "ModelUnitEventConnection",
    items:  Array< {
      __typename: "UnitEvent",
      id: string,
      unitId: string,
      type: UnitEventType,
      startDate: string,
      endDate: string,
      totalCost?: number | null,
      note?: string | null,
      writers?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncUnitEventsQueryVariables = {
  filter?: ModelUnitEventFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncUnitEventsQuery = {
  syncUnitEvents?:  {
    __typename: "ModelUnitEventConnection",
    items:  Array< {
      __typename: "UnitEvent",
      id: string,
      unitId: string,
      type: UnitEventType,
      startDate: string,
      endDate: string,
      totalCost?: number | null,
      note?: string | null,
      writers?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetUnitInventoryQueryVariables = {
  id: string,
};

export type GetUnitInventoryQuery = {
  getUnitInventory?:  {
    __typename: "UnitInventory",
    id: string,
    privateBatthRoom?: boolean | null,
    createdAt?: string | null,
    deletedAt?: string | null,
    kitchenEquipment?: KitchenEquipment | null,
    roomName?: string | null,
    roomType: UnitInventoryRoomType,
    surface?: number | null,
    showSurface?: boolean | null,
    unitId: string,
    inside: boolean,
    readId: string,
    clientId: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListUnitInventoriesQueryVariables = {
  filter?: ModelUnitInventoryFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListUnitInventoriesQuery = {
  listUnitInventories?:  {
    __typename: "ModelUnitInventoryConnection",
    items:  Array< {
      __typename: "UnitInventory",
      id: string,
      privateBatthRoom?: boolean | null,
      createdAt?: string | null,
      deletedAt?: string | null,
      kitchenEquipment?: KitchenEquipment | null,
      roomName?: string | null,
      roomType: UnitInventoryRoomType,
      surface?: number | null,
      showSurface?: boolean | null,
      unitId: string,
      inside: boolean,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncUnitInventoriesQueryVariables = {
  filter?: ModelUnitInventoryFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncUnitInventoriesQuery = {
  syncUnitInventories?:  {
    __typename: "ModelUnitInventoryConnection",
    items:  Array< {
      __typename: "UnitInventory",
      id: string,
      privateBatthRoom?: boolean | null,
      createdAt?: string | null,
      deletedAt?: string | null,
      kitchenEquipment?: KitchenEquipment | null,
      roomName?: string | null,
      roomType: UnitInventoryRoomType,
      surface?: number | null,
      showSurface?: boolean | null,
      unitId: string,
      inside: boolean,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetUnitLeaseQueryVariables = {
  id: string,
};

export type GetUnitLeaseQuery = {
  getUnitLease?:  {
    __typename: "UnitLease",
    id: string,
    allowChargeAdjustment?: boolean | null,
    authorizeProfessionalActivity?: boolean | null,
    chargesIndexation?: boolean | null,
    createdAt?: string | null,
    endDate: string,
    furnishedRental?: boolean | null,
    furnishedRentalInsuranceByTenant?: boolean | null,
    furnishedRentalRentalPricePercentage?: number | null,
    initialRentalPrice: number,
    indexation?: boolean | null,
    advancedIndexation?: boolean | null,
    indexType?: IndexType | null,
    baseYear?: number | null,
    baseIndexType?: BaseIndexType | null,
    baseIndexDate?: string | null,
    nextIndexationMonth?: string | null,
    nextIndexation?: boolean | null,
    leaseId: string,
    mainUnit: boolean,
    rentalPrice: number,
    signatureDate?: string | null,
    startDate: string,
    unitId: string,
    unit?:  {
      __typename: "Unit",
      id: string,
      acquisitionAdditionalCostsValue?: number | null,
      acquisitionAdvertisedValue?: number | null,
      acquisitionValue?: number | null,
      advertisedMonthlyCharges?: number | null,
      advertisedRentalPrice?: number | null,
      cadastralIncome?: number | null,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      floor?: number | null,
      jointOwnershipId?: string | null,
      managementDate: string,
      name: string,
      notes?: string | null,
      predictedPrice?: string | null,
      propertyTax?: number | null,
      publishAddress?: boolean | null,
      surface?: number | null,
      type: UnitType,
      buildingId: string,
      building?:  {
        __typename: "Building",
        id: string,
        name: string,
        addressId?: string | null,
        acquisitionValue?: number | null,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        amountOfFacades?: number | null,
        amountOfFloors?: number | null,
        amountOfHousings?: number | null,
        buildingState?: BuildingState | null,
        cadastralIncome?: number | null,
        constructionYear?: string | null,
        janitor?: boolean | null,
        jointOwnershipId?: string | null,
        notes?: string | null,
        propertyTax?: number | null,
        residenceName?: string | null,
        buildingSiteId?: string | null,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      owners?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leases?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      events?:  {
        __typename: "ModelUnitEventConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      unitAdvertisementId?: string | null,
      unitInventories?:  {
        __typename: "ModelUnitInventoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    lease?:  {
      __typename: "Lease",
      id: string,
      advancedChargesInvoices?:  {
        __typename: "LeaseAdvancedChargesInvoice",
        communicationSettingsProfileId: string,
        invoiceSenderId: string,
        lastDraftInvoiceDate?: string | null,
        lastInvoiceDate?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        bankAccountId?: string | null,
      } | null,
      balance?: number | null,
      canBeExtended?: boolean | null,
      communicationSettingsProfileId: string,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      endDate: string,
      includeRealEstateInLeaseContract?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      invoiceSenderId: string,
      invoiceSender?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      inventoryOfFixturesExpert?: string | null,
      inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
      inventoryOfFixturesType?: InventoryOfFixturesType | null,
      ipiNumber?: string | null,
      language: Language,
      lastDraftInvoiceDate?: string | null,
      lastIndexationProcessDate?: string | null,
      lastInvoiceDate?: string | null,
      legalCompetentAuthority?: string | null,
      name: string,
      notes?: string | null,
      paymentFrequency: LeasePaymentFrequency,
      paymentInvoicePeriod: LeasePaymentInvoicePeriod,
      paymentInvoicePeriodCustomDay?: number | null,
      paymentOption?:  {
        __typename: "LeasePaymentOption",
        customerId?: string | null,
        enabled: boolean,
        mandateActivatedAt?: string | null,
        mandateStatus?: PaymentProviderMandateStatus | null,
        paymentMethodId?: string | null,
        qrType?: LeaseQrType | null,
      } | null,
      purchaseOrderNumber?: string | null,
      realEstateAgency?: string | null,
      realEstateTax?: number | null,
      remittanceInformation?: string | null,
      remittanceInformationType?: LeaseRemittanceType | null,
      rentalGuaranty?:  {
        __typename: "LeaseRentalGuaranty",
        amount: number,
        blockedAmount?: number | null,
        releasedAmount?: number | null,
        type: LeaseRentalGuarantyType,
        financialInstitution?: string | null,
      } | null,
      signatureDate?: string | null,
      startDate: string,
      nextIndexationMonth?: string | null,
      nextIndexation?: boolean | null,
      status: LeaseStatus,
      technicCommunicationSettingsProfileId: string,
      totalInitialRentalPrice: number,
      totalRentalPrice: number,
      type: LeaseType,
      subletting?: boolean | null,
      vatRateRentId?: string | null,
      vatRateRent?:  {
        __typename: "VatRate",
        id: string,
        country: string,
        label: string,
        value?: number | null,
        ownerId?: string | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      additionalClauses?:  {
        __typename: "ModelLeaseAdditionalClauseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      bankAccountId?: string | null,
      bankAccount?:  {
        __typename: "BankAccount",
        id: string,
        contactId: string,
        number: string,
        bicNumber?: string | null,
        bankName?: string | null,
        contactIds?: Array< string > | null,
        buildingIds?: Array< string > | null,
        holderName?: string | null,
        label?: string | null,
        disabled?: boolean | null,
        integrations?: Array< IntegrationName > | null,
        matchingRule?: BankAccountMatchingRule | null,
        balance?: number | null,
        balanceDate?: string | null,
        type: BankAccountType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contacts?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      files?:  {
        __typename: "ModelFileConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leaseActionHistories?:  {
        __typename: "ModelLeaseActionHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leasePriceHistories?:  {
        __typename: "ModelLeasePriceHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      signatureDocuments?:  {
        __typename: "ModelSignatureDocumentConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      variousOperations?:  {
        __typename: "ModelLeaseVariousOperationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    readers?: Array< string > | null,
    readId: string,
    clientId: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListUnitLeasesQueryVariables = {
  filter?: ModelUnitLeaseFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListUnitLeasesQuery = {
  listUnitLeases?:  {
    __typename: "ModelUnitLeaseConnection",
    items:  Array< {
      __typename: "UnitLease",
      id: string,
      allowChargeAdjustment?: boolean | null,
      authorizeProfessionalActivity?: boolean | null,
      chargesIndexation?: boolean | null,
      createdAt?: string | null,
      endDate: string,
      furnishedRental?: boolean | null,
      furnishedRentalInsuranceByTenant?: boolean | null,
      furnishedRentalRentalPricePercentage?: number | null,
      initialRentalPrice: number,
      indexation?: boolean | null,
      advancedIndexation?: boolean | null,
      indexType?: IndexType | null,
      baseYear?: number | null,
      baseIndexType?: BaseIndexType | null,
      baseIndexDate?: string | null,
      nextIndexationMonth?: string | null,
      nextIndexation?: boolean | null,
      leaseId: string,
      mainUnit: boolean,
      rentalPrice: number,
      signatureDate?: string | null,
      startDate: string,
      unitId: string,
      unit?:  {
        __typename: "Unit",
        id: string,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        acquisitionValue?: number | null,
        advertisedMonthlyCharges?: number | null,
        advertisedRentalPrice?: number | null,
        cadastralIncome?: number | null,
        createdAt?: string | null,
        floor?: number | null,
        jointOwnershipId?: string | null,
        managementDate: string,
        name: string,
        notes?: string | null,
        predictedPrice?: string | null,
        propertyTax?: number | null,
        publishAddress?: boolean | null,
        surface?: number | null,
        type: UnitType,
        buildingId: string,
        unitAdvertisementId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      lease?:  {
        __typename: "Lease",
        id: string,
        balance?: number | null,
        canBeExtended?: boolean | null,
        communicationSettingsProfileId: string,
        createdAt?: string | null,
        endDate: string,
        includeRealEstateInLeaseContract?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        invoiceSenderId: string,
        inventoryOfFixturesExpert?: string | null,
        inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
        inventoryOfFixturesType?: InventoryOfFixturesType | null,
        ipiNumber?: string | null,
        language: Language,
        lastDraftInvoiceDate?: string | null,
        lastIndexationProcessDate?: string | null,
        lastInvoiceDate?: string | null,
        legalCompetentAuthority?: string | null,
        name: string,
        notes?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        purchaseOrderNumber?: string | null,
        realEstateAgency?: string | null,
        realEstateTax?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        signatureDate?: string | null,
        startDate: string,
        nextIndexationMonth?: string | null,
        nextIndexation?: boolean | null,
        status: LeaseStatus,
        technicCommunicationSettingsProfileId: string,
        totalInitialRentalPrice: number,
        totalRentalPrice: number,
        type: LeaseType,
        subletting?: boolean | null,
        vatRateRentId?: string | null,
        bankAccountId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncUnitLeasesQueryVariables = {
  filter?: ModelUnitLeaseFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncUnitLeasesQuery = {
  syncUnitLeases?:  {
    __typename: "ModelUnitLeaseConnection",
    items:  Array< {
      __typename: "UnitLease",
      id: string,
      allowChargeAdjustment?: boolean | null,
      authorizeProfessionalActivity?: boolean | null,
      chargesIndexation?: boolean | null,
      createdAt?: string | null,
      endDate: string,
      furnishedRental?: boolean | null,
      furnishedRentalInsuranceByTenant?: boolean | null,
      furnishedRentalRentalPricePercentage?: number | null,
      initialRentalPrice: number,
      indexation?: boolean | null,
      advancedIndexation?: boolean | null,
      indexType?: IndexType | null,
      baseYear?: number | null,
      baseIndexType?: BaseIndexType | null,
      baseIndexDate?: string | null,
      nextIndexationMonth?: string | null,
      nextIndexation?: boolean | null,
      leaseId: string,
      mainUnit: boolean,
      rentalPrice: number,
      signatureDate?: string | null,
      startDate: string,
      unitId: string,
      unit?:  {
        __typename: "Unit",
        id: string,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        acquisitionValue?: number | null,
        advertisedMonthlyCharges?: number | null,
        advertisedRentalPrice?: number | null,
        cadastralIncome?: number | null,
        createdAt?: string | null,
        floor?: number | null,
        jointOwnershipId?: string | null,
        managementDate: string,
        name: string,
        notes?: string | null,
        predictedPrice?: string | null,
        propertyTax?: number | null,
        publishAddress?: boolean | null,
        surface?: number | null,
        type: UnitType,
        buildingId: string,
        unitAdvertisementId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      lease?:  {
        __typename: "Lease",
        id: string,
        balance?: number | null,
        canBeExtended?: boolean | null,
        communicationSettingsProfileId: string,
        createdAt?: string | null,
        endDate: string,
        includeRealEstateInLeaseContract?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        invoiceSenderId: string,
        inventoryOfFixturesExpert?: string | null,
        inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
        inventoryOfFixturesType?: InventoryOfFixturesType | null,
        ipiNumber?: string | null,
        language: Language,
        lastDraftInvoiceDate?: string | null,
        lastIndexationProcessDate?: string | null,
        lastInvoiceDate?: string | null,
        legalCompetentAuthority?: string | null,
        name: string,
        notes?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        purchaseOrderNumber?: string | null,
        realEstateAgency?: string | null,
        realEstateTax?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        signatureDate?: string | null,
        startDate: string,
        nextIndexationMonth?: string | null,
        nextIndexation?: boolean | null,
        status: LeaseStatus,
        technicCommunicationSettingsProfileId: string,
        totalInitialRentalPrice: number,
        totalRentalPrice: number,
        type: LeaseType,
        subletting?: boolean | null,
        vatRateRentId?: string | null,
        bankAccountId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetUnitOwnerQueryVariables = {
  id: string,
};

export type GetUnitOwnerQuery = {
  getUnitOwner?:  {
    __typename: "UnitOwner",
    id: string,
    disabled?: boolean | null,
    owner?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    ownerId: string,
    periodFrom?: string | null,
    periodTo?: string | null,
    stake: number,
    unit?:  {
      __typename: "Unit",
      id: string,
      acquisitionAdditionalCostsValue?: number | null,
      acquisitionAdvertisedValue?: number | null,
      acquisitionValue?: number | null,
      advertisedMonthlyCharges?: number | null,
      advertisedRentalPrice?: number | null,
      cadastralIncome?: number | null,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      floor?: number | null,
      jointOwnershipId?: string | null,
      managementDate: string,
      name: string,
      notes?: string | null,
      predictedPrice?: string | null,
      propertyTax?: number | null,
      publishAddress?: boolean | null,
      surface?: number | null,
      type: UnitType,
      buildingId: string,
      building?:  {
        __typename: "Building",
        id: string,
        name: string,
        addressId?: string | null,
        acquisitionValue?: number | null,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        amountOfFacades?: number | null,
        amountOfFloors?: number | null,
        amountOfHousings?: number | null,
        buildingState?: BuildingState | null,
        cadastralIncome?: number | null,
        constructionYear?: string | null,
        janitor?: boolean | null,
        jointOwnershipId?: string | null,
        notes?: string | null,
        propertyTax?: number | null,
        residenceName?: string | null,
        buildingSiteId?: string | null,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      owners?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leases?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      events?:  {
        __typename: "ModelUnitEventConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      unitAdvertisementId?: string | null,
      unitInventories?:  {
        __typename: "ModelUnitInventoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    unitId: string,
    readers?: Array< string > | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListUnitOwnersQueryVariables = {
  filter?: ModelUnitOwnerFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListUnitOwnersQuery = {
  listUnitOwners?:  {
    __typename: "ModelUnitOwnerConnection",
    items:  Array< {
      __typename: "UnitOwner",
      id: string,
      disabled?: boolean | null,
      owner?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      ownerId: string,
      periodFrom?: string | null,
      periodTo?: string | null,
      stake: number,
      unit?:  {
        __typename: "Unit",
        id: string,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        acquisitionValue?: number | null,
        advertisedMonthlyCharges?: number | null,
        advertisedRentalPrice?: number | null,
        cadastralIncome?: number | null,
        createdAt?: string | null,
        floor?: number | null,
        jointOwnershipId?: string | null,
        managementDate: string,
        name: string,
        notes?: string | null,
        predictedPrice?: string | null,
        propertyTax?: number | null,
        publishAddress?: boolean | null,
        surface?: number | null,
        type: UnitType,
        buildingId: string,
        unitAdvertisementId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      unitId: string,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncUnitOwnersQueryVariables = {
  filter?: ModelUnitOwnerFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncUnitOwnersQuery = {
  syncUnitOwners?:  {
    __typename: "ModelUnitOwnerConnection",
    items:  Array< {
      __typename: "UnitOwner",
      id: string,
      disabled?: boolean | null,
      owner?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      ownerId: string,
      periodFrom?: string | null,
      periodTo?: string | null,
      stake: number,
      unit?:  {
        __typename: "Unit",
        id: string,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        acquisitionValue?: number | null,
        advertisedMonthlyCharges?: number | null,
        advertisedRentalPrice?: number | null,
        cadastralIncome?: number | null,
        createdAt?: string | null,
        floor?: number | null,
        jointOwnershipId?: string | null,
        managementDate: string,
        name: string,
        notes?: string | null,
        predictedPrice?: string | null,
        propertyTax?: number | null,
        publishAddress?: boolean | null,
        surface?: number | null,
        type: UnitType,
        buildingId: string,
        unitAdvertisementId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      unitId: string,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetTeamQueryVariables = {
  id: string,
};

export type GetTeamQuery = {
  getTeam?:  {
    __typename: "Team",
    id: string,
    name: string,
    parentId?: string | null,
    children?:  {
      __typename: "ModelTeamConnection",
      items:  Array< {
        __typename: "Team",
        id: string,
        name: string,
        parentId?: string | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    users?:  {
      __typename: "ModelUserTeamConnection",
      items:  Array< {
        __typename: "UserTeam",
        id: string,
        userId: string,
        teamId: string,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListTeamsQueryVariables = {
  filter?: ModelTeamFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListTeamsQuery = {
  listTeams?:  {
    __typename: "ModelTeamConnection",
    items:  Array< {
      __typename: "Team",
      id: string,
      name: string,
      parentId?: string | null,
      children?:  {
        __typename: "ModelTeamConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      users?:  {
        __typename: "ModelUserTeamConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncTeamsQueryVariables = {
  filter?: ModelTeamFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncTeamsQuery = {
  syncTeams?:  {
    __typename: "ModelTeamConnection",
    items:  Array< {
      __typename: "Team",
      id: string,
      name: string,
      parentId?: string | null,
      children?:  {
        __typename: "ModelTeamConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      users?:  {
        __typename: "ModelUserTeamConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetUserQueryVariables = {
  id: string,
};

export type GetUserQuery = {
  getUser?:  {
    __typename: "User",
    id: string,
    email: string,
    firstName?: string | null,
    lastName?: string | null,
    cognitoSub?: string | null,
    googleSub?: string | null,
    facebookSub?: string | null,
    rootUser?: boolean | null,
    refreshToken?: boolean | null,
    teams?:  {
      __typename: "ModelUserTeamConnection",
      items:  Array< {
        __typename: "UserTeam",
        id: string,
        userId: string,
        teamId: string,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    userRoleId?: string | null,
    userRole?:  {
      __typename: "UserRole",
      id: string,
      name: string,
      userRights?:  Array< {
        __typename: "UserRight",
        access?: Array< UserRightAccessType > | null,
        section: UserRightSection,
      } > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    contactId?: string | null,
    contact?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    status: UserStatus,
    readId: string,
    clientId: string,
    _ttl?: number | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListUsersQueryVariables = {
  filter?: ModelUserFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListUsersQuery = {
  listUsers?:  {
    __typename: "ModelUserConnection",
    items:  Array< {
      __typename: "User",
      id: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      cognitoSub?: string | null,
      googleSub?: string | null,
      facebookSub?: string | null,
      rootUser?: boolean | null,
      refreshToken?: boolean | null,
      teams?:  {
        __typename: "ModelUserTeamConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      userRoleId?: string | null,
      userRole?:  {
        __typename: "UserRole",
        id: string,
        name: string,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contactId?: string | null,
      contact?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      status: UserStatus,
      readId: string,
      clientId: string,
      _ttl?: number | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncUsersQueryVariables = {
  filter?: ModelUserFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncUsersQuery = {
  syncUsers?:  {
    __typename: "ModelUserConnection",
    items:  Array< {
      __typename: "User",
      id: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      cognitoSub?: string | null,
      googleSub?: string | null,
      facebookSub?: string | null,
      rootUser?: boolean | null,
      refreshToken?: boolean | null,
      teams?:  {
        __typename: "ModelUserTeamConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      userRoleId?: string | null,
      userRole?:  {
        __typename: "UserRole",
        id: string,
        name: string,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contactId?: string | null,
      contact?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      status: UserStatus,
      readId: string,
      clientId: string,
      _ttl?: number | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetUserRoleQueryVariables = {
  id: string,
};

export type GetUserRoleQuery = {
  getUserRole?:  {
    __typename: "UserRole",
    id: string,
    name: string,
    userRights?:  Array< {
      __typename: "UserRight",
      access?: Array< UserRightAccessType > | null,
      section: UserRightSection,
    } > | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListUserRolesQueryVariables = {
  filter?: ModelUserRoleFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListUserRolesQuery = {
  listUserRoles?:  {
    __typename: "ModelUserRoleConnection",
    items:  Array< {
      __typename: "UserRole",
      id: string,
      name: string,
      userRights?:  Array< {
        __typename: "UserRight",
        access?: Array< UserRightAccessType > | null,
        section: UserRightSection,
      } > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncUserRolesQueryVariables = {
  filter?: ModelUserRoleFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncUserRolesQuery = {
  syncUserRoles?:  {
    __typename: "ModelUserRoleConnection",
    items:  Array< {
      __typename: "UserRole",
      id: string,
      name: string,
      userRights?:  Array< {
        __typename: "UserRight",
        access?: Array< UserRightAccessType > | null,
        section: UserRightSection,
      } > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetUserTeamQueryVariables = {
  id: string,
};

export type GetUserTeamQuery = {
  getUserTeam?:  {
    __typename: "UserTeam",
    id: string,
    userId: string,
    teamId: string,
    team?:  {
      __typename: "Team",
      id: string,
      name: string,
      parentId?: string | null,
      children?:  {
        __typename: "ModelTeamConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      users?:  {
        __typename: "ModelUserTeamConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    user?:  {
      __typename: "User",
      id: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      cognitoSub?: string | null,
      googleSub?: string | null,
      facebookSub?: string | null,
      rootUser?: boolean | null,
      refreshToken?: boolean | null,
      teams?:  {
        __typename: "ModelUserTeamConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      userRoleId?: string | null,
      userRole?:  {
        __typename: "UserRole",
        id: string,
        name: string,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contactId?: string | null,
      contact?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      status: UserStatus,
      readId: string,
      clientId: string,
      _ttl?: number | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListUserTeamsQueryVariables = {
  filter?: ModelUserTeamFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListUserTeamsQuery = {
  listUserTeams?:  {
    __typename: "ModelUserTeamConnection",
    items:  Array< {
      __typename: "UserTeam",
      id: string,
      userId: string,
      teamId: string,
      team?:  {
        __typename: "Team",
        id: string,
        name: string,
        parentId?: string | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      user?:  {
        __typename: "User",
        id: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        cognitoSub?: string | null,
        googleSub?: string | null,
        facebookSub?: string | null,
        rootUser?: boolean | null,
        refreshToken?: boolean | null,
        userRoleId?: string | null,
        contactId?: string | null,
        status: UserStatus,
        readId: string,
        clientId: string,
        _ttl?: number | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncUserTeamsQueryVariables = {
  filter?: ModelUserTeamFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncUserTeamsQuery = {
  syncUserTeams?:  {
    __typename: "ModelUserTeamConnection",
    items:  Array< {
      __typename: "UserTeam",
      id: string,
      userId: string,
      teamId: string,
      team?:  {
        __typename: "Team",
        id: string,
        name: string,
        parentId?: string | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      user?:  {
        __typename: "User",
        id: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        cognitoSub?: string | null,
        googleSub?: string | null,
        facebookSub?: string | null,
        rootUser?: boolean | null,
        refreshToken?: boolean | null,
        userRoleId?: string | null,
        contactId?: string | null,
        status: UserStatus,
        readId: string,
        clientId: string,
        _ttl?: number | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetValuationQueryVariables = {
  id: string,
};

export type GetValuationQuery = {
  getValuation?:  {
    __typename: "Valuation",
    id: string,
    sourceType?: ValuationSourceType | null,
    valorization: number,
    date: string,
    unitId?: string | null,
    unit?:  {
      __typename: "Unit",
      id: string,
      acquisitionAdditionalCostsValue?: number | null,
      acquisitionAdvertisedValue?: number | null,
      acquisitionValue?: number | null,
      advertisedMonthlyCharges?: number | null,
      advertisedRentalPrice?: number | null,
      cadastralIncome?: number | null,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      floor?: number | null,
      jointOwnershipId?: string | null,
      managementDate: string,
      name: string,
      notes?: string | null,
      predictedPrice?: string | null,
      propertyTax?: number | null,
      publishAddress?: boolean | null,
      surface?: number | null,
      type: UnitType,
      buildingId: string,
      building?:  {
        __typename: "Building",
        id: string,
        name: string,
        addressId?: string | null,
        acquisitionValue?: number | null,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        amountOfFacades?: number | null,
        amountOfFloors?: number | null,
        amountOfHousings?: number | null,
        buildingState?: BuildingState | null,
        cadastralIncome?: number | null,
        constructionYear?: string | null,
        janitor?: boolean | null,
        jointOwnershipId?: string | null,
        notes?: string | null,
        propertyTax?: number | null,
        residenceName?: string | null,
        buildingSiteId?: string | null,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      owners?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leases?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      events?:  {
        __typename: "ModelUnitEventConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      unitAdvertisementId?: string | null,
      unitInventories?:  {
        __typename: "ModelUnitInventoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    buildingId?: string | null,
    building?:  {
      __typename: "Building",
      id: string,
      name: string,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      acquisitionValue?: number | null,
      acquisitionAdditionalCostsValue?: number | null,
      acquisitionAdvertisedValue?: number | null,
      amountOfFacades?: number | null,
      amountOfFloors?: number | null,
      amountOfHousings?: number | null,
      buildingState?: BuildingState | null,
      cadastralIncome?: number | null,
      constructionYear?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      janitor?: boolean | null,
      jointOwnershipId?: string | null,
      notes?: string | null,
      owners?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      propertyTax?: number | null,
      residenceName?: string | null,
      buildingSiteId?: string | null,
      buildingSite?:  {
        __typename: "BuildingSite",
        id: string,
        name: string,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      units?:  {
        __typename: "ModelUnitConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      events?:  {
        __typename: "ModelBuildingEventConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      teams?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    writers?: Array< string > | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListValuationsQueryVariables = {
  filter?: ModelValuationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListValuationsQuery = {
  listValuations?:  {
    __typename: "ModelValuationConnection",
    items:  Array< {
      __typename: "Valuation",
      id: string,
      sourceType?: ValuationSourceType | null,
      valorization: number,
      date: string,
      unitId?: string | null,
      unit?:  {
        __typename: "Unit",
        id: string,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        acquisitionValue?: number | null,
        advertisedMonthlyCharges?: number | null,
        advertisedRentalPrice?: number | null,
        cadastralIncome?: number | null,
        createdAt?: string | null,
        floor?: number | null,
        jointOwnershipId?: string | null,
        managementDate: string,
        name: string,
        notes?: string | null,
        predictedPrice?: string | null,
        propertyTax?: number | null,
        publishAddress?: boolean | null,
        surface?: number | null,
        type: UnitType,
        buildingId: string,
        unitAdvertisementId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      buildingId?: string | null,
      building?:  {
        __typename: "Building",
        id: string,
        name: string,
        addressId?: string | null,
        acquisitionValue?: number | null,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        amountOfFacades?: number | null,
        amountOfFloors?: number | null,
        amountOfHousings?: number | null,
        buildingState?: BuildingState | null,
        cadastralIncome?: number | null,
        constructionYear?: string | null,
        janitor?: boolean | null,
        jointOwnershipId?: string | null,
        notes?: string | null,
        propertyTax?: number | null,
        residenceName?: string | null,
        buildingSiteId?: string | null,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      writers?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncValuationsQueryVariables = {
  filter?: ModelValuationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncValuationsQuery = {
  syncValuations?:  {
    __typename: "ModelValuationConnection",
    items:  Array< {
      __typename: "Valuation",
      id: string,
      sourceType?: ValuationSourceType | null,
      valorization: number,
      date: string,
      unitId?: string | null,
      unit?:  {
        __typename: "Unit",
        id: string,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        acquisitionValue?: number | null,
        advertisedMonthlyCharges?: number | null,
        advertisedRentalPrice?: number | null,
        cadastralIncome?: number | null,
        createdAt?: string | null,
        floor?: number | null,
        jointOwnershipId?: string | null,
        managementDate: string,
        name: string,
        notes?: string | null,
        predictedPrice?: string | null,
        propertyTax?: number | null,
        publishAddress?: boolean | null,
        surface?: number | null,
        type: UnitType,
        buildingId: string,
        unitAdvertisementId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      buildingId?: string | null,
      building?:  {
        __typename: "Building",
        id: string,
        name: string,
        addressId?: string | null,
        acquisitionValue?: number | null,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        amountOfFacades?: number | null,
        amountOfFloors?: number | null,
        amountOfHousings?: number | null,
        buildingState?: BuildingState | null,
        cadastralIncome?: number | null,
        constructionYear?: string | null,
        janitor?: boolean | null,
        jointOwnershipId?: string | null,
        notes?: string | null,
        propertyTax?: number | null,
        residenceName?: string | null,
        buildingSiteId?: string | null,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      writers?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetVariousOperationQueryVariables = {
  id: string,
};

export type GetVariousOperationQuery = {
  getVariousOperation?:  {
    __typename: "VariousOperation",
    id: string,
    amount: number,
    labels?:  Array< {
      __typename: "CustomLabel",
      language: string,
      label: string,
    } > | null,
    numberOfMonths?: number | null,
    operationType: LeaseVariousOperationType,
    paymentFrequency: LeasePaymentFrequency,
    type: VariousOperationType,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListVariousOperationsQueryVariables = {
  filter?: ModelVariousOperationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListVariousOperationsQuery = {
  listVariousOperations?:  {
    __typename: "ModelVariousOperationConnection",
    items:  Array< {
      __typename: "VariousOperation",
      id: string,
      amount: number,
      labels?:  Array< {
        __typename: "CustomLabel",
        language: string,
        label: string,
      } > | null,
      numberOfMonths?: number | null,
      operationType: LeaseVariousOperationType,
      paymentFrequency: LeasePaymentFrequency,
      type: VariousOperationType,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncVariousOperationsQueryVariables = {
  filter?: ModelVariousOperationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncVariousOperationsQuery = {
  syncVariousOperations?:  {
    __typename: "ModelVariousOperationConnection",
    items:  Array< {
      __typename: "VariousOperation",
      id: string,
      amount: number,
      labels?:  Array< {
        __typename: "CustomLabel",
        language: string,
        label: string,
      } > | null,
      numberOfMonths?: number | null,
      operationType: LeaseVariousOperationType,
      paymentFrequency: LeasePaymentFrequency,
      type: VariousOperationType,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type OnCreateAccountLabelSubscriptionVariables = {
  filter?: ModelSubscriptionAccountLabelFilterInput | null,
};

export type OnCreateAccountLabelSubscription = {
  onCreateAccountLabel?:  {
    __typename: "AccountLabel",
    id: string,
    labels?:  Array< {
      __typename: "CustomLabel",
      language: string,
      label: string,
    } > | null,
    bankAccountId?: string | null,
    bankAccount?:  {
      __typename: "BankAccount",
      id: string,
      contactId: string,
      contact?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      number: string,
      bicNumber?: string | null,
      bankName?: string | null,
      contactIds?: Array< string > | null,
      buildingIds?: Array< string > | null,
      holderName?: string | null,
      label?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      disabled?: boolean | null,
      integrations?: Array< IntegrationName > | null,
      matchingRule?: BankAccountMatchingRule | null,
      balance?: number | null,
      balanceDate?: string | null,
      type: BankAccountType,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    contactId?: string | null,
    contact?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    class: number,
    customUsage?: AccountLabelCustomUsage | null,
    customValues?:  Array< {
      __typename: "CustomValue",
      name: string,
      value: string,
    } > | null,
    disabled?: boolean | null,
    ownerId?: string | null,
    owner?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    topClass: number,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateAccountLabelSubscriptionVariables = {
  filter?: ModelSubscriptionAccountLabelFilterInput | null,
};

export type OnUpdateAccountLabelSubscription = {
  onUpdateAccountLabel?:  {
    __typename: "AccountLabel",
    id: string,
    labels?:  Array< {
      __typename: "CustomLabel",
      language: string,
      label: string,
    } > | null,
    bankAccountId?: string | null,
    bankAccount?:  {
      __typename: "BankAccount",
      id: string,
      contactId: string,
      contact?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      number: string,
      bicNumber?: string | null,
      bankName?: string | null,
      contactIds?: Array< string > | null,
      buildingIds?: Array< string > | null,
      holderName?: string | null,
      label?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      disabled?: boolean | null,
      integrations?: Array< IntegrationName > | null,
      matchingRule?: BankAccountMatchingRule | null,
      balance?: number | null,
      balanceDate?: string | null,
      type: BankAccountType,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    contactId?: string | null,
    contact?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    class: number,
    customUsage?: AccountLabelCustomUsage | null,
    customValues?:  Array< {
      __typename: "CustomValue",
      name: string,
      value: string,
    } > | null,
    disabled?: boolean | null,
    ownerId?: string | null,
    owner?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    topClass: number,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteAccountLabelSubscriptionVariables = {
  filter?: ModelSubscriptionAccountLabelFilterInput | null,
};

export type OnDeleteAccountLabelSubscription = {
  onDeleteAccountLabel?:  {
    __typename: "AccountLabel",
    id: string,
    labels?:  Array< {
      __typename: "CustomLabel",
      language: string,
      label: string,
    } > | null,
    bankAccountId?: string | null,
    bankAccount?:  {
      __typename: "BankAccount",
      id: string,
      contactId: string,
      contact?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      number: string,
      bicNumber?: string | null,
      bankName?: string | null,
      contactIds?: Array< string > | null,
      buildingIds?: Array< string > | null,
      holderName?: string | null,
      label?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      disabled?: boolean | null,
      integrations?: Array< IntegrationName > | null,
      matchingRule?: BankAccountMatchingRule | null,
      balance?: number | null,
      balanceDate?: string | null,
      type: BankAccountType,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    contactId?: string | null,
    contact?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    class: number,
    customUsage?: AccountLabelCustomUsage | null,
    customValues?:  Array< {
      __typename: "CustomValue",
      name: string,
      value: string,
    } > | null,
    disabled?: boolean | null,
    ownerId?: string | null,
    owner?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    topClass: number,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreatePostingSubscriptionVariables = {
  filter?: ModelSubscriptionPostingFilterInput | null,
};

export type OnCreatePostingSubscription = {
  onCreatePosting?:  {
    __typename: "Posting",
    id: string,
    createdAt?: string | null,
    class: number,
    customLabel?: string | null,
    customValues?:  Array< {
      __typename: "CustomValue",
      name: string,
      value: string,
    } > | null,
    topClass: number,
    type: PostingType,
    totalAmount: number,
    periodFrom: string,
    periodTo: string,
    buildingId?: string | null,
    building?:  {
      __typename: "Building",
      id: string,
      name: string,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      acquisitionValue?: number | null,
      acquisitionAdditionalCostsValue?: number | null,
      acquisitionAdvertisedValue?: number | null,
      amountOfFacades?: number | null,
      amountOfFloors?: number | null,
      amountOfHousings?: number | null,
      buildingState?: BuildingState | null,
      cadastralIncome?: number | null,
      constructionYear?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      janitor?: boolean | null,
      jointOwnershipId?: string | null,
      notes?: string | null,
      owners?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      propertyTax?: number | null,
      residenceName?: string | null,
      buildingSiteId?: string | null,
      buildingSite?:  {
        __typename: "BuildingSite",
        id: string,
        name: string,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      units?:  {
        __typename: "ModelUnitConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      events?:  {
        __typename: "ModelBuildingEventConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      teams?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    unitId?: string | null,
    unit?:  {
      __typename: "Unit",
      id: string,
      acquisitionAdditionalCostsValue?: number | null,
      acquisitionAdvertisedValue?: number | null,
      acquisitionValue?: number | null,
      advertisedMonthlyCharges?: number | null,
      advertisedRentalPrice?: number | null,
      cadastralIncome?: number | null,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      floor?: number | null,
      jointOwnershipId?: string | null,
      managementDate: string,
      name: string,
      notes?: string | null,
      predictedPrice?: string | null,
      propertyTax?: number | null,
      publishAddress?: boolean | null,
      surface?: number | null,
      type: UnitType,
      buildingId: string,
      building?:  {
        __typename: "Building",
        id: string,
        name: string,
        addressId?: string | null,
        acquisitionValue?: number | null,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        amountOfFacades?: number | null,
        amountOfFloors?: number | null,
        amountOfHousings?: number | null,
        buildingState?: BuildingState | null,
        cadastralIncome?: number | null,
        constructionYear?: string | null,
        janitor?: boolean | null,
        jointOwnershipId?: string | null,
        notes?: string | null,
        propertyTax?: number | null,
        residenceName?: string | null,
        buildingSiteId?: string | null,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      owners?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leases?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      events?:  {
        __typename: "ModelUnitEventConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      unitAdvertisementId?: string | null,
      unitInventories?:  {
        __typename: "ModelUnitInventoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    invoiceId?: string | null,
    invoice?:  {
      __typename: "Invoice",
      id: string,
      amount: number,
      bankAccountId: string,
      bankAccount?:  {
        __typename: "BankAccount",
        id: string,
        contactId: string,
        number: string,
        bicNumber?: string | null,
        bankName?: string | null,
        contactIds?: Array< string > | null,
        buildingIds?: Array< string > | null,
        holderName?: string | null,
        label?: string | null,
        disabled?: boolean | null,
        integrations?: Array< IntegrationName > | null,
        matchingRule?: BankAccountMatchingRule | null,
        balance?: number | null,
        balanceDate?: string | null,
        type: BankAccountType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      communicationId?: string | null,
      communication?:  {
        __typename: "Communication",
        id: string,
        addressId?: string | null,
        body: string,
        buildingId?: string | null,
        channel: CommunicationChannel,
        communicationTemplateId?: string | null,
        concernedContactIds?: Array< string > | null,
        contactId?: string | null,
        contactIds?: Array< string > | null,
        createdAt?: string | null,
        expirationDate?: string | null,
        invoiceId?: string | null,
        leaseId?: string | null,
        leasePriceHistoryId?: string | null,
        letterTrackingCode?: string | null,
        letterTrackingProvider?: TrackingProvider | null,
        linkedCommunicationsIds?: Array< string > | null,
        supportingDocumentFileIds?: Array< string > | null,
        recipient?: string | null,
        recipientContactIdsInBcc?: Array< string > | null,
        recipientContactIdsInCc?: Array< string > | null,
        recipientInBcc?: string | null,
        recipientInCc?: string | null,
        scheduledAt?: string | null,
        deliveredAt?: string | null,
        errorCode?: CommunicationErrorCode | null,
        nextRetryAt?: string | null,
        sendRetryCount?: number | null,
        sender?: string | null,
        sentAt?: string | null,
        externalId?: string | null,
        externalStatus?: string | null,
        signatureDocumentId?: string | null,
        snoozedDate?: string | null,
        statementId?: string | null,
        status: CommunicationStatus,
        subject: string,
        toSend: boolean,
        hideLogo?: boolean | null,
        type: CommunicationType,
        _ttl?: number | null,
        unitId?: string | null,
        readId: string,
        readers?: Array< string > | null,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      createdAt: string,
      creditNote?: boolean | null,
      creditNoteLabel?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      dueDate?: string | null,
      invoiceDate: string,
      invoiceNumber?: string | null,
      ownerId?: string | null,
      owner?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      invoiceSenderId: string,
      invoiceSender?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      leaseId?: string | null,
      lease?:  {
        __typename: "Lease",
        id: string,
        balance?: number | null,
        canBeExtended?: boolean | null,
        communicationSettingsProfileId: string,
        createdAt?: string | null,
        endDate: string,
        includeRealEstateInLeaseContract?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        invoiceSenderId: string,
        inventoryOfFixturesExpert?: string | null,
        inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
        inventoryOfFixturesType?: InventoryOfFixturesType | null,
        ipiNumber?: string | null,
        language: Language,
        lastDraftInvoiceDate?: string | null,
        lastIndexationProcessDate?: string | null,
        lastInvoiceDate?: string | null,
        legalCompetentAuthority?: string | null,
        name: string,
        notes?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        purchaseOrderNumber?: string | null,
        realEstateAgency?: string | null,
        realEstateTax?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        signatureDate?: string | null,
        startDate: string,
        nextIndexationMonth?: string | null,
        nextIndexation?: boolean | null,
        status: LeaseStatus,
        technicCommunicationSettingsProfileId: string,
        totalInitialRentalPrice: number,
        totalRentalPrice: number,
        type: LeaseType,
        subletting?: boolean | null,
        vatRateRentId?: string | null,
        bankAccountId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      paid: boolean,
      integrations?:  {
        __typename: "InvoiceIntegrations",
      } | null,
      postedDate?: string | null,
      purchaseOrderNumber?: string | null,
      receiptNumber?: string | null,
      reminderDates?: Array< string > | null,
      note?: string | null,
      remittanceInformation?: string | null,
      statementId?: string | null,
      statement?:  {
        __typename: "Statement",
        id: string,
        closingStatement: boolean,
        periodFrom: string,
        periodTo: string,
        attachSupportingDocuments?: boolean | null,
        selectedPocketKeys?: Array< string > | null,
        source: StatementSource,
        status: StatementStatus,
        sentDate?: string | null,
        leaseId?: string | null,
        ownerId?: string | null,
        types?: Array< StatementType > | null,
        viewType: StatementViewType,
        unitIds?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      status: InvoiceStatus,
      type: InvoiceType,
      unitId?: string | null,
      unit?:  {
        __typename: "Unit",
        id: string,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        acquisitionValue?: number | null,
        advertisedMonthlyCharges?: number | null,
        advertisedRentalPrice?: number | null,
        cadastralIncome?: number | null,
        createdAt?: string | null,
        floor?: number | null,
        jointOwnershipId?: string | null,
        managementDate: string,
        name: string,
        notes?: string | null,
        predictedPrice?: string | null,
        propertyTax?: number | null,
        publishAddress?: boolean | null,
        surface?: number | null,
        type: UnitType,
        buildingId: string,
        unitAdvertisementId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      reversedInvoiceId?: string | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    chargeId?: string | null,
    charge?:  {
      __typename: "Charge",
      id: string,
      status: ChargeStatus,
      invoiceDate?: string | null,
      paymentDueDate?: string | null,
      archivedDate?: string | null,
      periodFrom?: string | null,
      periodTo?: string | null,
      totalAmount?: number | null,
      source: ChargeSource,
      draftFromOcr?: boolean | null,
      accountingDocumentId?: string | null,
      paid: boolean,
      remittanceInformation?: string | null,
      note?: string | null,
      createdAt: string,
      creatorEmail?: string | null,
      createdById?: string | null,
      createdBy?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contractorId?: string | null,
      contractor?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      proposedContractors?:  Array< {
        __typename: "ProposedValue",
        id: string,
        confidence?: number | null,
      } > | null,
      recipientId?: string | null,
      recipient?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      proposedRecipients?:  Array< {
        __typename: "ProposedValue",
        id: string,
        confidence?: number | null,
      } > | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      documentId: string,
      document?:  {
        __typename: "File",
        id: string,
        bucket: string,
        createdAt?: string | null,
        categoryId: string,
        foreignKey: string,
        foreignTableName: string,
        key: string,
        mimeType?: string | null,
        region: string,
        size?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        _ttl?: number | null,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      postings?:  {
        __typename: "ModelPostingConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    transactionId?: string | null,
    transaction?:  {
      __typename: "Transaction",
      id: string,
      status: TransactionStatus,
      sequence?: number | null,
      statementDate: string,
      operationDate?: string | null,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      remittanceInformationType?: RemittanceType | null,
      remittanceInformation?: string | null,
      comment?: string | null,
      amount: number,
      bankAccountId: string,
      bankAccount?:  {
        __typename: "BankAccount",
        id: string,
        contactId: string,
        number: string,
        bicNumber?: string | null,
        bankName?: string | null,
        contactIds?: Array< string > | null,
        buildingIds?: Array< string > | null,
        holderName?: string | null,
        label?: string | null,
        disabled?: boolean | null,
        integrations?: Array< IntegrationName > | null,
        matchingRule?: BankAccountMatchingRule | null,
        balance?: number | null,
        balanceDate?: string | null,
        type: BankAccountType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      counterpartName?: string | null,
      counterpartAccountNumber?: string | null,
      origin: TransactionOrigin,
      proposedLeaseId?: string | null,
      proposedUnitId?: string | null,
      proposedContractorId?: string | null,
      proposedOwnerId?: string | null,
      proposedMatch?: number | null,
      links?:  Array< {
        __typename: "TransactionLink",
        amount: number,
        linkId: string,
        linkType: TransactionLinkType,
      } > | null,
      postings?:  {
        __typename: "ModelPostingConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    leaseId?: string | null,
    lease?:  {
      __typename: "Lease",
      id: string,
      advancedChargesInvoices?:  {
        __typename: "LeaseAdvancedChargesInvoice",
        communicationSettingsProfileId: string,
        invoiceSenderId: string,
        lastDraftInvoiceDate?: string | null,
        lastInvoiceDate?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        bankAccountId?: string | null,
      } | null,
      balance?: number | null,
      canBeExtended?: boolean | null,
      communicationSettingsProfileId: string,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      endDate: string,
      includeRealEstateInLeaseContract?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      invoiceSenderId: string,
      invoiceSender?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      inventoryOfFixturesExpert?: string | null,
      inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
      inventoryOfFixturesType?: InventoryOfFixturesType | null,
      ipiNumber?: string | null,
      language: Language,
      lastDraftInvoiceDate?: string | null,
      lastIndexationProcessDate?: string | null,
      lastInvoiceDate?: string | null,
      legalCompetentAuthority?: string | null,
      name: string,
      notes?: string | null,
      paymentFrequency: LeasePaymentFrequency,
      paymentInvoicePeriod: LeasePaymentInvoicePeriod,
      paymentInvoicePeriodCustomDay?: number | null,
      paymentOption?:  {
        __typename: "LeasePaymentOption",
        customerId?: string | null,
        enabled: boolean,
        mandateActivatedAt?: string | null,
        mandateStatus?: PaymentProviderMandateStatus | null,
        paymentMethodId?: string | null,
        qrType?: LeaseQrType | null,
      } | null,
      purchaseOrderNumber?: string | null,
      realEstateAgency?: string | null,
      realEstateTax?: number | null,
      remittanceInformation?: string | null,
      remittanceInformationType?: LeaseRemittanceType | null,
      rentalGuaranty?:  {
        __typename: "LeaseRentalGuaranty",
        amount: number,
        blockedAmount?: number | null,
        releasedAmount?: number | null,
        type: LeaseRentalGuarantyType,
        financialInstitution?: string | null,
      } | null,
      signatureDate?: string | null,
      startDate: string,
      nextIndexationMonth?: string | null,
      nextIndexation?: boolean | null,
      status: LeaseStatus,
      technicCommunicationSettingsProfileId: string,
      totalInitialRentalPrice: number,
      totalRentalPrice: number,
      type: LeaseType,
      subletting?: boolean | null,
      vatRateRentId?: string | null,
      vatRateRent?:  {
        __typename: "VatRate",
        id: string,
        country: string,
        label: string,
        value?: number | null,
        ownerId?: string | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      additionalClauses?:  {
        __typename: "ModelLeaseAdditionalClauseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      bankAccountId?: string | null,
      bankAccount?:  {
        __typename: "BankAccount",
        id: string,
        contactId: string,
        number: string,
        bicNumber?: string | null,
        bankName?: string | null,
        contactIds?: Array< string > | null,
        buildingIds?: Array< string > | null,
        holderName?: string | null,
        label?: string | null,
        disabled?: boolean | null,
        integrations?: Array< IntegrationName > | null,
        matchingRule?: BankAccountMatchingRule | null,
        balance?: number | null,
        balanceDate?: string | null,
        type: BankAccountType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contacts?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      files?:  {
        __typename: "ModelFileConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leaseActionHistories?:  {
        __typename: "ModelLeaseActionHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leasePriceHistories?:  {
        __typename: "ModelLeasePriceHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      signatureDocuments?:  {
        __typename: "ModelSignatureDocumentConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      variousOperations?:  {
        __typename: "ModelLeaseVariousOperationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    bankAccountId?: string | null,
    bankAccount?:  {
      __typename: "BankAccount",
      id: string,
      contactId: string,
      contact?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      number: string,
      bicNumber?: string | null,
      bankName?: string | null,
      contactIds?: Array< string > | null,
      buildingIds?: Array< string > | null,
      holderName?: string | null,
      label?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      disabled?: boolean | null,
      integrations?: Array< IntegrationName > | null,
      matchingRule?: BankAccountMatchingRule | null,
      balance?: number | null,
      balanceDate?: string | null,
      type: BankAccountType,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    accountLabelId?: string | null,
    accountLabel?:  {
      __typename: "AccountLabel",
      id: string,
      labels?:  Array< {
        __typename: "CustomLabel",
        language: string,
        label: string,
      } > | null,
      bankAccountId?: string | null,
      bankAccount?:  {
        __typename: "BankAccount",
        id: string,
        contactId: string,
        number: string,
        bicNumber?: string | null,
        bankName?: string | null,
        contactIds?: Array< string > | null,
        buildingIds?: Array< string > | null,
        holderName?: string | null,
        label?: string | null,
        disabled?: boolean | null,
        integrations?: Array< IntegrationName > | null,
        matchingRule?: BankAccountMatchingRule | null,
        balance?: number | null,
        balanceDate?: string | null,
        type: BankAccountType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contactId?: string | null,
      contact?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      class: number,
      customUsage?: AccountLabelCustomUsage | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      disabled?: boolean | null,
      ownerId?: string | null,
      owner?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      topClass: number,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    contactId?: string | null,
    contact?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    leaseVariousOperationId?: string | null,
    leaseVariousOperation?:  {
      __typename: "LeaseVariousOperation",
      id: string,
      accountLabelIds?: Array< string > | null,
      amount: number,
      contactId: string,
      createdAt: string,
      createdBy?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      endDate: string,
      invoiceSenderId?: string | null,
      invoiceSender?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      label?: string | null,
      lastInvoiceDate?: string | null,
      leaseId: string,
      lease?:  {
        __typename: "Lease",
        id: string,
        balance?: number | null,
        canBeExtended?: boolean | null,
        communicationSettingsProfileId: string,
        createdAt?: string | null,
        endDate: string,
        includeRealEstateInLeaseContract?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        invoiceSenderId: string,
        inventoryOfFixturesExpert?: string | null,
        inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
        inventoryOfFixturesType?: InventoryOfFixturesType | null,
        ipiNumber?: string | null,
        language: Language,
        lastDraftInvoiceDate?: string | null,
        lastIndexationProcessDate?: string | null,
        lastInvoiceDate?: string | null,
        legalCompetentAuthority?: string | null,
        name: string,
        notes?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        purchaseOrderNumber?: string | null,
        realEstateAgency?: string | null,
        realEstateTax?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        signatureDate?: string | null,
        startDate: string,
        nextIndexationMonth?: string | null,
        nextIndexation?: boolean | null,
        status: LeaseStatus,
        technicCommunicationSettingsProfileId: string,
        totalInitialRentalPrice: number,
        totalRentalPrice: number,
        type: LeaseType,
        subletting?: boolean | null,
        vatRateRentId?: string | null,
        bankAccountId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      leaseVariousOperationHistories?:  Array< {
        __typename: "LeaseVariousOperationHistory",
        periodFrom: string,
        periodTo: string,
        amount: number,
      } > | null,
      operationType: LeaseVariousOperationType,
      paymentFrequency: LeasePaymentFrequency,
      paymentInvoicePeriod: LeasePaymentInvoicePeriod,
      paymentInvoicePeriodCustomDay?: number | null,
      reason?: string | null,
      separateInvoice: boolean,
      startDate: string,
      type: VariousOperationType,
      unit?:  {
        __typename: "Unit",
        id: string,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        acquisitionValue?: number | null,
        advertisedMonthlyCharges?: number | null,
        advertisedRentalPrice?: number | null,
        cadastralIncome?: number | null,
        createdAt?: string | null,
        floor?: number | null,
        jointOwnershipId?: string | null,
        managementDate: string,
        name: string,
        notes?: string | null,
        predictedPrice?: string | null,
        propertyTax?: number | null,
        publishAddress?: boolean | null,
        surface?: number | null,
        type: UnitType,
        buildingId: string,
        unitAdvertisementId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      unitId: string,
      vatRateId?: string | null,
      vatRate?:  {
        __typename: "VatRate",
        id: string,
        country: string,
        label: string,
        value?: number | null,
        ownerId?: string | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      readId: string,
      readers?: Array< string > | null,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    statementId?: string | null,
    amountVatExcluded?: number | null,
    vatAmount?: number | null,
    vatRate?:  {
      __typename: "VatRate",
      id: string,
      country: string,
      label: string,
      value?: number | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      ownerId?: string | null,
      owner?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    vatRateId?: string | null,
    vatRateValue?: number | null,
    foreignId?: string | null,
    foreignType?: PostingForeignType | null,
    invoicePostingId?: string | null,
    reconciledAt?: string | null,
    status?: PostingStatus | null,
    chargeOwnerRepartition?: number | null,
    chargeRepartitionMetric?: string | null,
    chargeRepartitionValue?: number | null,
    chargeSplitNumber?: number | null,
    chargeType?: PostingChargeType | null,
    readers?: Array< string > | null,
    readId: string,
    clientId: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdatePostingSubscriptionVariables = {
  filter?: ModelSubscriptionPostingFilterInput | null,
};

export type OnUpdatePostingSubscription = {
  onUpdatePosting?:  {
    __typename: "Posting",
    id: string,
    createdAt?: string | null,
    class: number,
    customLabel?: string | null,
    customValues?:  Array< {
      __typename: "CustomValue",
      name: string,
      value: string,
    } > | null,
    topClass: number,
    type: PostingType,
    totalAmount: number,
    periodFrom: string,
    periodTo: string,
    buildingId?: string | null,
    building?:  {
      __typename: "Building",
      id: string,
      name: string,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      acquisitionValue?: number | null,
      acquisitionAdditionalCostsValue?: number | null,
      acquisitionAdvertisedValue?: number | null,
      amountOfFacades?: number | null,
      amountOfFloors?: number | null,
      amountOfHousings?: number | null,
      buildingState?: BuildingState | null,
      cadastralIncome?: number | null,
      constructionYear?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      janitor?: boolean | null,
      jointOwnershipId?: string | null,
      notes?: string | null,
      owners?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      propertyTax?: number | null,
      residenceName?: string | null,
      buildingSiteId?: string | null,
      buildingSite?:  {
        __typename: "BuildingSite",
        id: string,
        name: string,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      units?:  {
        __typename: "ModelUnitConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      events?:  {
        __typename: "ModelBuildingEventConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      teams?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    unitId?: string | null,
    unit?:  {
      __typename: "Unit",
      id: string,
      acquisitionAdditionalCostsValue?: number | null,
      acquisitionAdvertisedValue?: number | null,
      acquisitionValue?: number | null,
      advertisedMonthlyCharges?: number | null,
      advertisedRentalPrice?: number | null,
      cadastralIncome?: number | null,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      floor?: number | null,
      jointOwnershipId?: string | null,
      managementDate: string,
      name: string,
      notes?: string | null,
      predictedPrice?: string | null,
      propertyTax?: number | null,
      publishAddress?: boolean | null,
      surface?: number | null,
      type: UnitType,
      buildingId: string,
      building?:  {
        __typename: "Building",
        id: string,
        name: string,
        addressId?: string | null,
        acquisitionValue?: number | null,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        amountOfFacades?: number | null,
        amountOfFloors?: number | null,
        amountOfHousings?: number | null,
        buildingState?: BuildingState | null,
        cadastralIncome?: number | null,
        constructionYear?: string | null,
        janitor?: boolean | null,
        jointOwnershipId?: string | null,
        notes?: string | null,
        propertyTax?: number | null,
        residenceName?: string | null,
        buildingSiteId?: string | null,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      owners?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leases?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      events?:  {
        __typename: "ModelUnitEventConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      unitAdvertisementId?: string | null,
      unitInventories?:  {
        __typename: "ModelUnitInventoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    invoiceId?: string | null,
    invoice?:  {
      __typename: "Invoice",
      id: string,
      amount: number,
      bankAccountId: string,
      bankAccount?:  {
        __typename: "BankAccount",
        id: string,
        contactId: string,
        number: string,
        bicNumber?: string | null,
        bankName?: string | null,
        contactIds?: Array< string > | null,
        buildingIds?: Array< string > | null,
        holderName?: string | null,
        label?: string | null,
        disabled?: boolean | null,
        integrations?: Array< IntegrationName > | null,
        matchingRule?: BankAccountMatchingRule | null,
        balance?: number | null,
        balanceDate?: string | null,
        type: BankAccountType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      communicationId?: string | null,
      communication?:  {
        __typename: "Communication",
        id: string,
        addressId?: string | null,
        body: string,
        buildingId?: string | null,
        channel: CommunicationChannel,
        communicationTemplateId?: string | null,
        concernedContactIds?: Array< string > | null,
        contactId?: string | null,
        contactIds?: Array< string > | null,
        createdAt?: string | null,
        expirationDate?: string | null,
        invoiceId?: string | null,
        leaseId?: string | null,
        leasePriceHistoryId?: string | null,
        letterTrackingCode?: string | null,
        letterTrackingProvider?: TrackingProvider | null,
        linkedCommunicationsIds?: Array< string > | null,
        supportingDocumentFileIds?: Array< string > | null,
        recipient?: string | null,
        recipientContactIdsInBcc?: Array< string > | null,
        recipientContactIdsInCc?: Array< string > | null,
        recipientInBcc?: string | null,
        recipientInCc?: string | null,
        scheduledAt?: string | null,
        deliveredAt?: string | null,
        errorCode?: CommunicationErrorCode | null,
        nextRetryAt?: string | null,
        sendRetryCount?: number | null,
        sender?: string | null,
        sentAt?: string | null,
        externalId?: string | null,
        externalStatus?: string | null,
        signatureDocumentId?: string | null,
        snoozedDate?: string | null,
        statementId?: string | null,
        status: CommunicationStatus,
        subject: string,
        toSend: boolean,
        hideLogo?: boolean | null,
        type: CommunicationType,
        _ttl?: number | null,
        unitId?: string | null,
        readId: string,
        readers?: Array< string > | null,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      createdAt: string,
      creditNote?: boolean | null,
      creditNoteLabel?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      dueDate?: string | null,
      invoiceDate: string,
      invoiceNumber?: string | null,
      ownerId?: string | null,
      owner?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      invoiceSenderId: string,
      invoiceSender?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      leaseId?: string | null,
      lease?:  {
        __typename: "Lease",
        id: string,
        balance?: number | null,
        canBeExtended?: boolean | null,
        communicationSettingsProfileId: string,
        createdAt?: string | null,
        endDate: string,
        includeRealEstateInLeaseContract?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        invoiceSenderId: string,
        inventoryOfFixturesExpert?: string | null,
        inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
        inventoryOfFixturesType?: InventoryOfFixturesType | null,
        ipiNumber?: string | null,
        language: Language,
        lastDraftInvoiceDate?: string | null,
        lastIndexationProcessDate?: string | null,
        lastInvoiceDate?: string | null,
        legalCompetentAuthority?: string | null,
        name: string,
        notes?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        purchaseOrderNumber?: string | null,
        realEstateAgency?: string | null,
        realEstateTax?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        signatureDate?: string | null,
        startDate: string,
        nextIndexationMonth?: string | null,
        nextIndexation?: boolean | null,
        status: LeaseStatus,
        technicCommunicationSettingsProfileId: string,
        totalInitialRentalPrice: number,
        totalRentalPrice: number,
        type: LeaseType,
        subletting?: boolean | null,
        vatRateRentId?: string | null,
        bankAccountId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      paid: boolean,
      integrations?:  {
        __typename: "InvoiceIntegrations",
      } | null,
      postedDate?: string | null,
      purchaseOrderNumber?: string | null,
      receiptNumber?: string | null,
      reminderDates?: Array< string > | null,
      note?: string | null,
      remittanceInformation?: string | null,
      statementId?: string | null,
      statement?:  {
        __typename: "Statement",
        id: string,
        closingStatement: boolean,
        periodFrom: string,
        periodTo: string,
        attachSupportingDocuments?: boolean | null,
        selectedPocketKeys?: Array< string > | null,
        source: StatementSource,
        status: StatementStatus,
        sentDate?: string | null,
        leaseId?: string | null,
        ownerId?: string | null,
        types?: Array< StatementType > | null,
        viewType: StatementViewType,
        unitIds?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      status: InvoiceStatus,
      type: InvoiceType,
      unitId?: string | null,
      unit?:  {
        __typename: "Unit",
        id: string,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        acquisitionValue?: number | null,
        advertisedMonthlyCharges?: number | null,
        advertisedRentalPrice?: number | null,
        cadastralIncome?: number | null,
        createdAt?: string | null,
        floor?: number | null,
        jointOwnershipId?: string | null,
        managementDate: string,
        name: string,
        notes?: string | null,
        predictedPrice?: string | null,
        propertyTax?: number | null,
        publishAddress?: boolean | null,
        surface?: number | null,
        type: UnitType,
        buildingId: string,
        unitAdvertisementId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      reversedInvoiceId?: string | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    chargeId?: string | null,
    charge?:  {
      __typename: "Charge",
      id: string,
      status: ChargeStatus,
      invoiceDate?: string | null,
      paymentDueDate?: string | null,
      archivedDate?: string | null,
      periodFrom?: string | null,
      periodTo?: string | null,
      totalAmount?: number | null,
      source: ChargeSource,
      draftFromOcr?: boolean | null,
      accountingDocumentId?: string | null,
      paid: boolean,
      remittanceInformation?: string | null,
      note?: string | null,
      createdAt: string,
      creatorEmail?: string | null,
      createdById?: string | null,
      createdBy?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contractorId?: string | null,
      contractor?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      proposedContractors?:  Array< {
        __typename: "ProposedValue",
        id: string,
        confidence?: number | null,
      } > | null,
      recipientId?: string | null,
      recipient?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      proposedRecipients?:  Array< {
        __typename: "ProposedValue",
        id: string,
        confidence?: number | null,
      } > | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      documentId: string,
      document?:  {
        __typename: "File",
        id: string,
        bucket: string,
        createdAt?: string | null,
        categoryId: string,
        foreignKey: string,
        foreignTableName: string,
        key: string,
        mimeType?: string | null,
        region: string,
        size?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        _ttl?: number | null,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      postings?:  {
        __typename: "ModelPostingConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    transactionId?: string | null,
    transaction?:  {
      __typename: "Transaction",
      id: string,
      status: TransactionStatus,
      sequence?: number | null,
      statementDate: string,
      operationDate?: string | null,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      remittanceInformationType?: RemittanceType | null,
      remittanceInformation?: string | null,
      comment?: string | null,
      amount: number,
      bankAccountId: string,
      bankAccount?:  {
        __typename: "BankAccount",
        id: string,
        contactId: string,
        number: string,
        bicNumber?: string | null,
        bankName?: string | null,
        contactIds?: Array< string > | null,
        buildingIds?: Array< string > | null,
        holderName?: string | null,
        label?: string | null,
        disabled?: boolean | null,
        integrations?: Array< IntegrationName > | null,
        matchingRule?: BankAccountMatchingRule | null,
        balance?: number | null,
        balanceDate?: string | null,
        type: BankAccountType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      counterpartName?: string | null,
      counterpartAccountNumber?: string | null,
      origin: TransactionOrigin,
      proposedLeaseId?: string | null,
      proposedUnitId?: string | null,
      proposedContractorId?: string | null,
      proposedOwnerId?: string | null,
      proposedMatch?: number | null,
      links?:  Array< {
        __typename: "TransactionLink",
        amount: number,
        linkId: string,
        linkType: TransactionLinkType,
      } > | null,
      postings?:  {
        __typename: "ModelPostingConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    leaseId?: string | null,
    lease?:  {
      __typename: "Lease",
      id: string,
      advancedChargesInvoices?:  {
        __typename: "LeaseAdvancedChargesInvoice",
        communicationSettingsProfileId: string,
        invoiceSenderId: string,
        lastDraftInvoiceDate?: string | null,
        lastInvoiceDate?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        bankAccountId?: string | null,
      } | null,
      balance?: number | null,
      canBeExtended?: boolean | null,
      communicationSettingsProfileId: string,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      endDate: string,
      includeRealEstateInLeaseContract?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      invoiceSenderId: string,
      invoiceSender?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      inventoryOfFixturesExpert?: string | null,
      inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
      inventoryOfFixturesType?: InventoryOfFixturesType | null,
      ipiNumber?: string | null,
      language: Language,
      lastDraftInvoiceDate?: string | null,
      lastIndexationProcessDate?: string | null,
      lastInvoiceDate?: string | null,
      legalCompetentAuthority?: string | null,
      name: string,
      notes?: string | null,
      paymentFrequency: LeasePaymentFrequency,
      paymentInvoicePeriod: LeasePaymentInvoicePeriod,
      paymentInvoicePeriodCustomDay?: number | null,
      paymentOption?:  {
        __typename: "LeasePaymentOption",
        customerId?: string | null,
        enabled: boolean,
        mandateActivatedAt?: string | null,
        mandateStatus?: PaymentProviderMandateStatus | null,
        paymentMethodId?: string | null,
        qrType?: LeaseQrType | null,
      } | null,
      purchaseOrderNumber?: string | null,
      realEstateAgency?: string | null,
      realEstateTax?: number | null,
      remittanceInformation?: string | null,
      remittanceInformationType?: LeaseRemittanceType | null,
      rentalGuaranty?:  {
        __typename: "LeaseRentalGuaranty",
        amount: number,
        blockedAmount?: number | null,
        releasedAmount?: number | null,
        type: LeaseRentalGuarantyType,
        financialInstitution?: string | null,
      } | null,
      signatureDate?: string | null,
      startDate: string,
      nextIndexationMonth?: string | null,
      nextIndexation?: boolean | null,
      status: LeaseStatus,
      technicCommunicationSettingsProfileId: string,
      totalInitialRentalPrice: number,
      totalRentalPrice: number,
      type: LeaseType,
      subletting?: boolean | null,
      vatRateRentId?: string | null,
      vatRateRent?:  {
        __typename: "VatRate",
        id: string,
        country: string,
        label: string,
        value?: number | null,
        ownerId?: string | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      additionalClauses?:  {
        __typename: "ModelLeaseAdditionalClauseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      bankAccountId?: string | null,
      bankAccount?:  {
        __typename: "BankAccount",
        id: string,
        contactId: string,
        number: string,
        bicNumber?: string | null,
        bankName?: string | null,
        contactIds?: Array< string > | null,
        buildingIds?: Array< string > | null,
        holderName?: string | null,
        label?: string | null,
        disabled?: boolean | null,
        integrations?: Array< IntegrationName > | null,
        matchingRule?: BankAccountMatchingRule | null,
        balance?: number | null,
        balanceDate?: string | null,
        type: BankAccountType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contacts?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      files?:  {
        __typename: "ModelFileConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leaseActionHistories?:  {
        __typename: "ModelLeaseActionHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leasePriceHistories?:  {
        __typename: "ModelLeasePriceHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      signatureDocuments?:  {
        __typename: "ModelSignatureDocumentConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      variousOperations?:  {
        __typename: "ModelLeaseVariousOperationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    bankAccountId?: string | null,
    bankAccount?:  {
      __typename: "BankAccount",
      id: string,
      contactId: string,
      contact?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      number: string,
      bicNumber?: string | null,
      bankName?: string | null,
      contactIds?: Array< string > | null,
      buildingIds?: Array< string > | null,
      holderName?: string | null,
      label?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      disabled?: boolean | null,
      integrations?: Array< IntegrationName > | null,
      matchingRule?: BankAccountMatchingRule | null,
      balance?: number | null,
      balanceDate?: string | null,
      type: BankAccountType,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    accountLabelId?: string | null,
    accountLabel?:  {
      __typename: "AccountLabel",
      id: string,
      labels?:  Array< {
        __typename: "CustomLabel",
        language: string,
        label: string,
      } > | null,
      bankAccountId?: string | null,
      bankAccount?:  {
        __typename: "BankAccount",
        id: string,
        contactId: string,
        number: string,
        bicNumber?: string | null,
        bankName?: string | null,
        contactIds?: Array< string > | null,
        buildingIds?: Array< string > | null,
        holderName?: string | null,
        label?: string | null,
        disabled?: boolean | null,
        integrations?: Array< IntegrationName > | null,
        matchingRule?: BankAccountMatchingRule | null,
        balance?: number | null,
        balanceDate?: string | null,
        type: BankAccountType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contactId?: string | null,
      contact?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      class: number,
      customUsage?: AccountLabelCustomUsage | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      disabled?: boolean | null,
      ownerId?: string | null,
      owner?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      topClass: number,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    contactId?: string | null,
    contact?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    leaseVariousOperationId?: string | null,
    leaseVariousOperation?:  {
      __typename: "LeaseVariousOperation",
      id: string,
      accountLabelIds?: Array< string > | null,
      amount: number,
      contactId: string,
      createdAt: string,
      createdBy?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      endDate: string,
      invoiceSenderId?: string | null,
      invoiceSender?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      label?: string | null,
      lastInvoiceDate?: string | null,
      leaseId: string,
      lease?:  {
        __typename: "Lease",
        id: string,
        balance?: number | null,
        canBeExtended?: boolean | null,
        communicationSettingsProfileId: string,
        createdAt?: string | null,
        endDate: string,
        includeRealEstateInLeaseContract?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        invoiceSenderId: string,
        inventoryOfFixturesExpert?: string | null,
        inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
        inventoryOfFixturesType?: InventoryOfFixturesType | null,
        ipiNumber?: string | null,
        language: Language,
        lastDraftInvoiceDate?: string | null,
        lastIndexationProcessDate?: string | null,
        lastInvoiceDate?: string | null,
        legalCompetentAuthority?: string | null,
        name: string,
        notes?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        purchaseOrderNumber?: string | null,
        realEstateAgency?: string | null,
        realEstateTax?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        signatureDate?: string | null,
        startDate: string,
        nextIndexationMonth?: string | null,
        nextIndexation?: boolean | null,
        status: LeaseStatus,
        technicCommunicationSettingsProfileId: string,
        totalInitialRentalPrice: number,
        totalRentalPrice: number,
        type: LeaseType,
        subletting?: boolean | null,
        vatRateRentId?: string | null,
        bankAccountId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      leaseVariousOperationHistories?:  Array< {
        __typename: "LeaseVariousOperationHistory",
        periodFrom: string,
        periodTo: string,
        amount: number,
      } > | null,
      operationType: LeaseVariousOperationType,
      paymentFrequency: LeasePaymentFrequency,
      paymentInvoicePeriod: LeasePaymentInvoicePeriod,
      paymentInvoicePeriodCustomDay?: number | null,
      reason?: string | null,
      separateInvoice: boolean,
      startDate: string,
      type: VariousOperationType,
      unit?:  {
        __typename: "Unit",
        id: string,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        acquisitionValue?: number | null,
        advertisedMonthlyCharges?: number | null,
        advertisedRentalPrice?: number | null,
        cadastralIncome?: number | null,
        createdAt?: string | null,
        floor?: number | null,
        jointOwnershipId?: string | null,
        managementDate: string,
        name: string,
        notes?: string | null,
        predictedPrice?: string | null,
        propertyTax?: number | null,
        publishAddress?: boolean | null,
        surface?: number | null,
        type: UnitType,
        buildingId: string,
        unitAdvertisementId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      unitId: string,
      vatRateId?: string | null,
      vatRate?:  {
        __typename: "VatRate",
        id: string,
        country: string,
        label: string,
        value?: number | null,
        ownerId?: string | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      readId: string,
      readers?: Array< string > | null,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    statementId?: string | null,
    amountVatExcluded?: number | null,
    vatAmount?: number | null,
    vatRate?:  {
      __typename: "VatRate",
      id: string,
      country: string,
      label: string,
      value?: number | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      ownerId?: string | null,
      owner?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    vatRateId?: string | null,
    vatRateValue?: number | null,
    foreignId?: string | null,
    foreignType?: PostingForeignType | null,
    invoicePostingId?: string | null,
    reconciledAt?: string | null,
    status?: PostingStatus | null,
    chargeOwnerRepartition?: number | null,
    chargeRepartitionMetric?: string | null,
    chargeRepartitionValue?: number | null,
    chargeSplitNumber?: number | null,
    chargeType?: PostingChargeType | null,
    readers?: Array< string > | null,
    readId: string,
    clientId: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeletePostingSubscriptionVariables = {
  filter?: ModelSubscriptionPostingFilterInput | null,
};

export type OnDeletePostingSubscription = {
  onDeletePosting?:  {
    __typename: "Posting",
    id: string,
    createdAt?: string | null,
    class: number,
    customLabel?: string | null,
    customValues?:  Array< {
      __typename: "CustomValue",
      name: string,
      value: string,
    } > | null,
    topClass: number,
    type: PostingType,
    totalAmount: number,
    periodFrom: string,
    periodTo: string,
    buildingId?: string | null,
    building?:  {
      __typename: "Building",
      id: string,
      name: string,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      acquisitionValue?: number | null,
      acquisitionAdditionalCostsValue?: number | null,
      acquisitionAdvertisedValue?: number | null,
      amountOfFacades?: number | null,
      amountOfFloors?: number | null,
      amountOfHousings?: number | null,
      buildingState?: BuildingState | null,
      cadastralIncome?: number | null,
      constructionYear?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      janitor?: boolean | null,
      jointOwnershipId?: string | null,
      notes?: string | null,
      owners?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      propertyTax?: number | null,
      residenceName?: string | null,
      buildingSiteId?: string | null,
      buildingSite?:  {
        __typename: "BuildingSite",
        id: string,
        name: string,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      units?:  {
        __typename: "ModelUnitConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      events?:  {
        __typename: "ModelBuildingEventConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      teams?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    unitId?: string | null,
    unit?:  {
      __typename: "Unit",
      id: string,
      acquisitionAdditionalCostsValue?: number | null,
      acquisitionAdvertisedValue?: number | null,
      acquisitionValue?: number | null,
      advertisedMonthlyCharges?: number | null,
      advertisedRentalPrice?: number | null,
      cadastralIncome?: number | null,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      floor?: number | null,
      jointOwnershipId?: string | null,
      managementDate: string,
      name: string,
      notes?: string | null,
      predictedPrice?: string | null,
      propertyTax?: number | null,
      publishAddress?: boolean | null,
      surface?: number | null,
      type: UnitType,
      buildingId: string,
      building?:  {
        __typename: "Building",
        id: string,
        name: string,
        addressId?: string | null,
        acquisitionValue?: number | null,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        amountOfFacades?: number | null,
        amountOfFloors?: number | null,
        amountOfHousings?: number | null,
        buildingState?: BuildingState | null,
        cadastralIncome?: number | null,
        constructionYear?: string | null,
        janitor?: boolean | null,
        jointOwnershipId?: string | null,
        notes?: string | null,
        propertyTax?: number | null,
        residenceName?: string | null,
        buildingSiteId?: string | null,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      owners?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leases?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      events?:  {
        __typename: "ModelUnitEventConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      unitAdvertisementId?: string | null,
      unitInventories?:  {
        __typename: "ModelUnitInventoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    invoiceId?: string | null,
    invoice?:  {
      __typename: "Invoice",
      id: string,
      amount: number,
      bankAccountId: string,
      bankAccount?:  {
        __typename: "BankAccount",
        id: string,
        contactId: string,
        number: string,
        bicNumber?: string | null,
        bankName?: string | null,
        contactIds?: Array< string > | null,
        buildingIds?: Array< string > | null,
        holderName?: string | null,
        label?: string | null,
        disabled?: boolean | null,
        integrations?: Array< IntegrationName > | null,
        matchingRule?: BankAccountMatchingRule | null,
        balance?: number | null,
        balanceDate?: string | null,
        type: BankAccountType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      communicationId?: string | null,
      communication?:  {
        __typename: "Communication",
        id: string,
        addressId?: string | null,
        body: string,
        buildingId?: string | null,
        channel: CommunicationChannel,
        communicationTemplateId?: string | null,
        concernedContactIds?: Array< string > | null,
        contactId?: string | null,
        contactIds?: Array< string > | null,
        createdAt?: string | null,
        expirationDate?: string | null,
        invoiceId?: string | null,
        leaseId?: string | null,
        leasePriceHistoryId?: string | null,
        letterTrackingCode?: string | null,
        letterTrackingProvider?: TrackingProvider | null,
        linkedCommunicationsIds?: Array< string > | null,
        supportingDocumentFileIds?: Array< string > | null,
        recipient?: string | null,
        recipientContactIdsInBcc?: Array< string > | null,
        recipientContactIdsInCc?: Array< string > | null,
        recipientInBcc?: string | null,
        recipientInCc?: string | null,
        scheduledAt?: string | null,
        deliveredAt?: string | null,
        errorCode?: CommunicationErrorCode | null,
        nextRetryAt?: string | null,
        sendRetryCount?: number | null,
        sender?: string | null,
        sentAt?: string | null,
        externalId?: string | null,
        externalStatus?: string | null,
        signatureDocumentId?: string | null,
        snoozedDate?: string | null,
        statementId?: string | null,
        status: CommunicationStatus,
        subject: string,
        toSend: boolean,
        hideLogo?: boolean | null,
        type: CommunicationType,
        _ttl?: number | null,
        unitId?: string | null,
        readId: string,
        readers?: Array< string > | null,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      createdAt: string,
      creditNote?: boolean | null,
      creditNoteLabel?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      dueDate?: string | null,
      invoiceDate: string,
      invoiceNumber?: string | null,
      ownerId?: string | null,
      owner?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      invoiceSenderId: string,
      invoiceSender?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      leaseId?: string | null,
      lease?:  {
        __typename: "Lease",
        id: string,
        balance?: number | null,
        canBeExtended?: boolean | null,
        communicationSettingsProfileId: string,
        createdAt?: string | null,
        endDate: string,
        includeRealEstateInLeaseContract?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        invoiceSenderId: string,
        inventoryOfFixturesExpert?: string | null,
        inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
        inventoryOfFixturesType?: InventoryOfFixturesType | null,
        ipiNumber?: string | null,
        language: Language,
        lastDraftInvoiceDate?: string | null,
        lastIndexationProcessDate?: string | null,
        lastInvoiceDate?: string | null,
        legalCompetentAuthority?: string | null,
        name: string,
        notes?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        purchaseOrderNumber?: string | null,
        realEstateAgency?: string | null,
        realEstateTax?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        signatureDate?: string | null,
        startDate: string,
        nextIndexationMonth?: string | null,
        nextIndexation?: boolean | null,
        status: LeaseStatus,
        technicCommunicationSettingsProfileId: string,
        totalInitialRentalPrice: number,
        totalRentalPrice: number,
        type: LeaseType,
        subletting?: boolean | null,
        vatRateRentId?: string | null,
        bankAccountId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      paid: boolean,
      integrations?:  {
        __typename: "InvoiceIntegrations",
      } | null,
      postedDate?: string | null,
      purchaseOrderNumber?: string | null,
      receiptNumber?: string | null,
      reminderDates?: Array< string > | null,
      note?: string | null,
      remittanceInformation?: string | null,
      statementId?: string | null,
      statement?:  {
        __typename: "Statement",
        id: string,
        closingStatement: boolean,
        periodFrom: string,
        periodTo: string,
        attachSupportingDocuments?: boolean | null,
        selectedPocketKeys?: Array< string > | null,
        source: StatementSource,
        status: StatementStatus,
        sentDate?: string | null,
        leaseId?: string | null,
        ownerId?: string | null,
        types?: Array< StatementType > | null,
        viewType: StatementViewType,
        unitIds?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      status: InvoiceStatus,
      type: InvoiceType,
      unitId?: string | null,
      unit?:  {
        __typename: "Unit",
        id: string,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        acquisitionValue?: number | null,
        advertisedMonthlyCharges?: number | null,
        advertisedRentalPrice?: number | null,
        cadastralIncome?: number | null,
        createdAt?: string | null,
        floor?: number | null,
        jointOwnershipId?: string | null,
        managementDate: string,
        name: string,
        notes?: string | null,
        predictedPrice?: string | null,
        propertyTax?: number | null,
        publishAddress?: boolean | null,
        surface?: number | null,
        type: UnitType,
        buildingId: string,
        unitAdvertisementId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      reversedInvoiceId?: string | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    chargeId?: string | null,
    charge?:  {
      __typename: "Charge",
      id: string,
      status: ChargeStatus,
      invoiceDate?: string | null,
      paymentDueDate?: string | null,
      archivedDate?: string | null,
      periodFrom?: string | null,
      periodTo?: string | null,
      totalAmount?: number | null,
      source: ChargeSource,
      draftFromOcr?: boolean | null,
      accountingDocumentId?: string | null,
      paid: boolean,
      remittanceInformation?: string | null,
      note?: string | null,
      createdAt: string,
      creatorEmail?: string | null,
      createdById?: string | null,
      createdBy?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contractorId?: string | null,
      contractor?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      proposedContractors?:  Array< {
        __typename: "ProposedValue",
        id: string,
        confidence?: number | null,
      } > | null,
      recipientId?: string | null,
      recipient?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      proposedRecipients?:  Array< {
        __typename: "ProposedValue",
        id: string,
        confidence?: number | null,
      } > | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      documentId: string,
      document?:  {
        __typename: "File",
        id: string,
        bucket: string,
        createdAt?: string | null,
        categoryId: string,
        foreignKey: string,
        foreignTableName: string,
        key: string,
        mimeType?: string | null,
        region: string,
        size?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        _ttl?: number | null,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      postings?:  {
        __typename: "ModelPostingConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    transactionId?: string | null,
    transaction?:  {
      __typename: "Transaction",
      id: string,
      status: TransactionStatus,
      sequence?: number | null,
      statementDate: string,
      operationDate?: string | null,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      remittanceInformationType?: RemittanceType | null,
      remittanceInformation?: string | null,
      comment?: string | null,
      amount: number,
      bankAccountId: string,
      bankAccount?:  {
        __typename: "BankAccount",
        id: string,
        contactId: string,
        number: string,
        bicNumber?: string | null,
        bankName?: string | null,
        contactIds?: Array< string > | null,
        buildingIds?: Array< string > | null,
        holderName?: string | null,
        label?: string | null,
        disabled?: boolean | null,
        integrations?: Array< IntegrationName > | null,
        matchingRule?: BankAccountMatchingRule | null,
        balance?: number | null,
        balanceDate?: string | null,
        type: BankAccountType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      counterpartName?: string | null,
      counterpartAccountNumber?: string | null,
      origin: TransactionOrigin,
      proposedLeaseId?: string | null,
      proposedUnitId?: string | null,
      proposedContractorId?: string | null,
      proposedOwnerId?: string | null,
      proposedMatch?: number | null,
      links?:  Array< {
        __typename: "TransactionLink",
        amount: number,
        linkId: string,
        linkType: TransactionLinkType,
      } > | null,
      postings?:  {
        __typename: "ModelPostingConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    leaseId?: string | null,
    lease?:  {
      __typename: "Lease",
      id: string,
      advancedChargesInvoices?:  {
        __typename: "LeaseAdvancedChargesInvoice",
        communicationSettingsProfileId: string,
        invoiceSenderId: string,
        lastDraftInvoiceDate?: string | null,
        lastInvoiceDate?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        bankAccountId?: string | null,
      } | null,
      balance?: number | null,
      canBeExtended?: boolean | null,
      communicationSettingsProfileId: string,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      endDate: string,
      includeRealEstateInLeaseContract?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      invoiceSenderId: string,
      invoiceSender?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      inventoryOfFixturesExpert?: string | null,
      inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
      inventoryOfFixturesType?: InventoryOfFixturesType | null,
      ipiNumber?: string | null,
      language: Language,
      lastDraftInvoiceDate?: string | null,
      lastIndexationProcessDate?: string | null,
      lastInvoiceDate?: string | null,
      legalCompetentAuthority?: string | null,
      name: string,
      notes?: string | null,
      paymentFrequency: LeasePaymentFrequency,
      paymentInvoicePeriod: LeasePaymentInvoicePeriod,
      paymentInvoicePeriodCustomDay?: number | null,
      paymentOption?:  {
        __typename: "LeasePaymentOption",
        customerId?: string | null,
        enabled: boolean,
        mandateActivatedAt?: string | null,
        mandateStatus?: PaymentProviderMandateStatus | null,
        paymentMethodId?: string | null,
        qrType?: LeaseQrType | null,
      } | null,
      purchaseOrderNumber?: string | null,
      realEstateAgency?: string | null,
      realEstateTax?: number | null,
      remittanceInformation?: string | null,
      remittanceInformationType?: LeaseRemittanceType | null,
      rentalGuaranty?:  {
        __typename: "LeaseRentalGuaranty",
        amount: number,
        blockedAmount?: number | null,
        releasedAmount?: number | null,
        type: LeaseRentalGuarantyType,
        financialInstitution?: string | null,
      } | null,
      signatureDate?: string | null,
      startDate: string,
      nextIndexationMonth?: string | null,
      nextIndexation?: boolean | null,
      status: LeaseStatus,
      technicCommunicationSettingsProfileId: string,
      totalInitialRentalPrice: number,
      totalRentalPrice: number,
      type: LeaseType,
      subletting?: boolean | null,
      vatRateRentId?: string | null,
      vatRateRent?:  {
        __typename: "VatRate",
        id: string,
        country: string,
        label: string,
        value?: number | null,
        ownerId?: string | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      additionalClauses?:  {
        __typename: "ModelLeaseAdditionalClauseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      bankAccountId?: string | null,
      bankAccount?:  {
        __typename: "BankAccount",
        id: string,
        contactId: string,
        number: string,
        bicNumber?: string | null,
        bankName?: string | null,
        contactIds?: Array< string > | null,
        buildingIds?: Array< string > | null,
        holderName?: string | null,
        label?: string | null,
        disabled?: boolean | null,
        integrations?: Array< IntegrationName > | null,
        matchingRule?: BankAccountMatchingRule | null,
        balance?: number | null,
        balanceDate?: string | null,
        type: BankAccountType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contacts?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      files?:  {
        __typename: "ModelFileConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leaseActionHistories?:  {
        __typename: "ModelLeaseActionHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leasePriceHistories?:  {
        __typename: "ModelLeasePriceHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      signatureDocuments?:  {
        __typename: "ModelSignatureDocumentConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      variousOperations?:  {
        __typename: "ModelLeaseVariousOperationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    bankAccountId?: string | null,
    bankAccount?:  {
      __typename: "BankAccount",
      id: string,
      contactId: string,
      contact?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      number: string,
      bicNumber?: string | null,
      bankName?: string | null,
      contactIds?: Array< string > | null,
      buildingIds?: Array< string > | null,
      holderName?: string | null,
      label?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      disabled?: boolean | null,
      integrations?: Array< IntegrationName > | null,
      matchingRule?: BankAccountMatchingRule | null,
      balance?: number | null,
      balanceDate?: string | null,
      type: BankAccountType,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    accountLabelId?: string | null,
    accountLabel?:  {
      __typename: "AccountLabel",
      id: string,
      labels?:  Array< {
        __typename: "CustomLabel",
        language: string,
        label: string,
      } > | null,
      bankAccountId?: string | null,
      bankAccount?:  {
        __typename: "BankAccount",
        id: string,
        contactId: string,
        number: string,
        bicNumber?: string | null,
        bankName?: string | null,
        contactIds?: Array< string > | null,
        buildingIds?: Array< string > | null,
        holderName?: string | null,
        label?: string | null,
        disabled?: boolean | null,
        integrations?: Array< IntegrationName > | null,
        matchingRule?: BankAccountMatchingRule | null,
        balance?: number | null,
        balanceDate?: string | null,
        type: BankAccountType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contactId?: string | null,
      contact?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      class: number,
      customUsage?: AccountLabelCustomUsage | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      disabled?: boolean | null,
      ownerId?: string | null,
      owner?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      topClass: number,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    contactId?: string | null,
    contact?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    leaseVariousOperationId?: string | null,
    leaseVariousOperation?:  {
      __typename: "LeaseVariousOperation",
      id: string,
      accountLabelIds?: Array< string > | null,
      amount: number,
      contactId: string,
      createdAt: string,
      createdBy?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      endDate: string,
      invoiceSenderId?: string | null,
      invoiceSender?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      label?: string | null,
      lastInvoiceDate?: string | null,
      leaseId: string,
      lease?:  {
        __typename: "Lease",
        id: string,
        balance?: number | null,
        canBeExtended?: boolean | null,
        communicationSettingsProfileId: string,
        createdAt?: string | null,
        endDate: string,
        includeRealEstateInLeaseContract?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        invoiceSenderId: string,
        inventoryOfFixturesExpert?: string | null,
        inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
        inventoryOfFixturesType?: InventoryOfFixturesType | null,
        ipiNumber?: string | null,
        language: Language,
        lastDraftInvoiceDate?: string | null,
        lastIndexationProcessDate?: string | null,
        lastInvoiceDate?: string | null,
        legalCompetentAuthority?: string | null,
        name: string,
        notes?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        purchaseOrderNumber?: string | null,
        realEstateAgency?: string | null,
        realEstateTax?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        signatureDate?: string | null,
        startDate: string,
        nextIndexationMonth?: string | null,
        nextIndexation?: boolean | null,
        status: LeaseStatus,
        technicCommunicationSettingsProfileId: string,
        totalInitialRentalPrice: number,
        totalRentalPrice: number,
        type: LeaseType,
        subletting?: boolean | null,
        vatRateRentId?: string | null,
        bankAccountId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      leaseVariousOperationHistories?:  Array< {
        __typename: "LeaseVariousOperationHistory",
        periodFrom: string,
        periodTo: string,
        amount: number,
      } > | null,
      operationType: LeaseVariousOperationType,
      paymentFrequency: LeasePaymentFrequency,
      paymentInvoicePeriod: LeasePaymentInvoicePeriod,
      paymentInvoicePeriodCustomDay?: number | null,
      reason?: string | null,
      separateInvoice: boolean,
      startDate: string,
      type: VariousOperationType,
      unit?:  {
        __typename: "Unit",
        id: string,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        acquisitionValue?: number | null,
        advertisedMonthlyCharges?: number | null,
        advertisedRentalPrice?: number | null,
        cadastralIncome?: number | null,
        createdAt?: string | null,
        floor?: number | null,
        jointOwnershipId?: string | null,
        managementDate: string,
        name: string,
        notes?: string | null,
        predictedPrice?: string | null,
        propertyTax?: number | null,
        publishAddress?: boolean | null,
        surface?: number | null,
        type: UnitType,
        buildingId: string,
        unitAdvertisementId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      unitId: string,
      vatRateId?: string | null,
      vatRate?:  {
        __typename: "VatRate",
        id: string,
        country: string,
        label: string,
        value?: number | null,
        ownerId?: string | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      readId: string,
      readers?: Array< string > | null,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    statementId?: string | null,
    amountVatExcluded?: number | null,
    vatAmount?: number | null,
    vatRate?:  {
      __typename: "VatRate",
      id: string,
      country: string,
      label: string,
      value?: number | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      ownerId?: string | null,
      owner?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    vatRateId?: string | null,
    vatRateValue?: number | null,
    foreignId?: string | null,
    foreignType?: PostingForeignType | null,
    invoicePostingId?: string | null,
    reconciledAt?: string | null,
    status?: PostingStatus | null,
    chargeOwnerRepartition?: number | null,
    chargeRepartitionMetric?: string | null,
    chargeRepartitionValue?: number | null,
    chargeSplitNumber?: number | null,
    chargeType?: PostingChargeType | null,
    readers?: Array< string > | null,
    readId: string,
    clientId: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateBankAccountSubscriptionVariables = {
  filter?: ModelSubscriptionBankAccountFilterInput | null,
};

export type OnCreateBankAccountSubscription = {
  onCreateBankAccount?:  {
    __typename: "BankAccount",
    id: string,
    contactId: string,
    contact?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    number: string,
    bicNumber?: string | null,
    bankName?: string | null,
    contactIds?: Array< string > | null,
    buildingIds?: Array< string > | null,
    holderName?: string | null,
    label?: string | null,
    customValues?:  Array< {
      __typename: "CustomValue",
      name: string,
      value: string,
    } > | null,
    disabled?: boolean | null,
    integrations?: Array< IntegrationName > | null,
    matchingRule?: BankAccountMatchingRule | null,
    balance?: number | null,
    balanceDate?: string | null,
    type: BankAccountType,
    readers?: Array< string > | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateBankAccountSubscriptionVariables = {
  filter?: ModelSubscriptionBankAccountFilterInput | null,
};

export type OnUpdateBankAccountSubscription = {
  onUpdateBankAccount?:  {
    __typename: "BankAccount",
    id: string,
    contactId: string,
    contact?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    number: string,
    bicNumber?: string | null,
    bankName?: string | null,
    contactIds?: Array< string > | null,
    buildingIds?: Array< string > | null,
    holderName?: string | null,
    label?: string | null,
    customValues?:  Array< {
      __typename: "CustomValue",
      name: string,
      value: string,
    } > | null,
    disabled?: boolean | null,
    integrations?: Array< IntegrationName > | null,
    matchingRule?: BankAccountMatchingRule | null,
    balance?: number | null,
    balanceDate?: string | null,
    type: BankAccountType,
    readers?: Array< string > | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteBankAccountSubscriptionVariables = {
  filter?: ModelSubscriptionBankAccountFilterInput | null,
};

export type OnDeleteBankAccountSubscription = {
  onDeleteBankAccount?:  {
    __typename: "BankAccount",
    id: string,
    contactId: string,
    contact?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    number: string,
    bicNumber?: string | null,
    bankName?: string | null,
    contactIds?: Array< string > | null,
    buildingIds?: Array< string > | null,
    holderName?: string | null,
    label?: string | null,
    customValues?:  Array< {
      __typename: "CustomValue",
      name: string,
      value: string,
    } > | null,
    disabled?: boolean | null,
    integrations?: Array< IntegrationName > | null,
    matchingRule?: BankAccountMatchingRule | null,
    balance?: number | null,
    balanceDate?: string | null,
    type: BankAccountType,
    readers?: Array< string > | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateTransactionSubscriptionVariables = {
  filter?: ModelSubscriptionTransactionFilterInput | null,
};

export type OnCreateTransactionSubscription = {
  onCreateTransaction?:  {
    __typename: "Transaction",
    id: string,
    status: TransactionStatus,
    sequence?: number | null,
    statementDate: string,
    operationDate?: string | null,
    createdAt?: string | null,
    customValues?:  Array< {
      __typename: "CustomValue",
      name: string,
      value: string,
    } > | null,
    remittanceInformationType?: RemittanceType | null,
    remittanceInformation?: string | null,
    comment?: string | null,
    amount: number,
    bankAccountId: string,
    bankAccount?:  {
      __typename: "BankAccount",
      id: string,
      contactId: string,
      contact?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      number: string,
      bicNumber?: string | null,
      bankName?: string | null,
      contactIds?: Array< string > | null,
      buildingIds?: Array< string > | null,
      holderName?: string | null,
      label?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      disabled?: boolean | null,
      integrations?: Array< IntegrationName > | null,
      matchingRule?: BankAccountMatchingRule | null,
      balance?: number | null,
      balanceDate?: string | null,
      type: BankAccountType,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    counterpartName?: string | null,
    counterpartAccountNumber?: string | null,
    origin: TransactionOrigin,
    proposedLeaseId?: string | null,
    proposedUnitId?: string | null,
    proposedContractorId?: string | null,
    proposedOwnerId?: string | null,
    proposedMatch?: number | null,
    links?:  Array< {
      __typename: "TransactionLink",
      amount: number,
      linkId: string,
      linkType: TransactionLinkType,
    } > | null,
    postings?:  {
      __typename: "ModelPostingConnection",
      items:  Array< {
        __typename: "Posting",
        id: string,
        createdAt?: string | null,
        class: number,
        customLabel?: string | null,
        topClass: number,
        type: PostingType,
        totalAmount: number,
        periodFrom: string,
        periodTo: string,
        buildingId?: string | null,
        unitId?: string | null,
        invoiceId?: string | null,
        chargeId?: string | null,
        transactionId?: string | null,
        leaseId?: string | null,
        bankAccountId?: string | null,
        accountLabelId?: string | null,
        contactId?: string | null,
        leaseVariousOperationId?: string | null,
        statementId?: string | null,
        amountVatExcluded?: number | null,
        vatAmount?: number | null,
        vatRateId?: string | null,
        vatRateValue?: number | null,
        foreignId?: string | null,
        foreignType?: PostingForeignType | null,
        invoicePostingId?: string | null,
        reconciledAt?: string | null,
        status?: PostingStatus | null,
        chargeOwnerRepartition?: number | null,
        chargeRepartitionMetric?: string | null,
        chargeRepartitionValue?: number | null,
        chargeSplitNumber?: number | null,
        chargeType?: PostingChargeType | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    updatedAt: string,
    readers?: Array< string > | null,
    readId: string,
    clientId: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateTransactionSubscriptionVariables = {
  filter?: ModelSubscriptionTransactionFilterInput | null,
};

export type OnUpdateTransactionSubscription = {
  onUpdateTransaction?:  {
    __typename: "Transaction",
    id: string,
    status: TransactionStatus,
    sequence?: number | null,
    statementDate: string,
    operationDate?: string | null,
    createdAt?: string | null,
    customValues?:  Array< {
      __typename: "CustomValue",
      name: string,
      value: string,
    } > | null,
    remittanceInformationType?: RemittanceType | null,
    remittanceInformation?: string | null,
    comment?: string | null,
    amount: number,
    bankAccountId: string,
    bankAccount?:  {
      __typename: "BankAccount",
      id: string,
      contactId: string,
      contact?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      number: string,
      bicNumber?: string | null,
      bankName?: string | null,
      contactIds?: Array< string > | null,
      buildingIds?: Array< string > | null,
      holderName?: string | null,
      label?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      disabled?: boolean | null,
      integrations?: Array< IntegrationName > | null,
      matchingRule?: BankAccountMatchingRule | null,
      balance?: number | null,
      balanceDate?: string | null,
      type: BankAccountType,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    counterpartName?: string | null,
    counterpartAccountNumber?: string | null,
    origin: TransactionOrigin,
    proposedLeaseId?: string | null,
    proposedUnitId?: string | null,
    proposedContractorId?: string | null,
    proposedOwnerId?: string | null,
    proposedMatch?: number | null,
    links?:  Array< {
      __typename: "TransactionLink",
      amount: number,
      linkId: string,
      linkType: TransactionLinkType,
    } > | null,
    postings?:  {
      __typename: "ModelPostingConnection",
      items:  Array< {
        __typename: "Posting",
        id: string,
        createdAt?: string | null,
        class: number,
        customLabel?: string | null,
        topClass: number,
        type: PostingType,
        totalAmount: number,
        periodFrom: string,
        periodTo: string,
        buildingId?: string | null,
        unitId?: string | null,
        invoiceId?: string | null,
        chargeId?: string | null,
        transactionId?: string | null,
        leaseId?: string | null,
        bankAccountId?: string | null,
        accountLabelId?: string | null,
        contactId?: string | null,
        leaseVariousOperationId?: string | null,
        statementId?: string | null,
        amountVatExcluded?: number | null,
        vatAmount?: number | null,
        vatRateId?: string | null,
        vatRateValue?: number | null,
        foreignId?: string | null,
        foreignType?: PostingForeignType | null,
        invoicePostingId?: string | null,
        reconciledAt?: string | null,
        status?: PostingStatus | null,
        chargeOwnerRepartition?: number | null,
        chargeRepartitionMetric?: string | null,
        chargeRepartitionValue?: number | null,
        chargeSplitNumber?: number | null,
        chargeType?: PostingChargeType | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    updatedAt: string,
    readers?: Array< string > | null,
    readId: string,
    clientId: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteTransactionSubscriptionVariables = {
  filter?: ModelSubscriptionTransactionFilterInput | null,
};

export type OnDeleteTransactionSubscription = {
  onDeleteTransaction?:  {
    __typename: "Transaction",
    id: string,
    status: TransactionStatus,
    sequence?: number | null,
    statementDate: string,
    operationDate?: string | null,
    createdAt?: string | null,
    customValues?:  Array< {
      __typename: "CustomValue",
      name: string,
      value: string,
    } > | null,
    remittanceInformationType?: RemittanceType | null,
    remittanceInformation?: string | null,
    comment?: string | null,
    amount: number,
    bankAccountId: string,
    bankAccount?:  {
      __typename: "BankAccount",
      id: string,
      contactId: string,
      contact?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      number: string,
      bicNumber?: string | null,
      bankName?: string | null,
      contactIds?: Array< string > | null,
      buildingIds?: Array< string > | null,
      holderName?: string | null,
      label?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      disabled?: boolean | null,
      integrations?: Array< IntegrationName > | null,
      matchingRule?: BankAccountMatchingRule | null,
      balance?: number | null,
      balanceDate?: string | null,
      type: BankAccountType,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    counterpartName?: string | null,
    counterpartAccountNumber?: string | null,
    origin: TransactionOrigin,
    proposedLeaseId?: string | null,
    proposedUnitId?: string | null,
    proposedContractorId?: string | null,
    proposedOwnerId?: string | null,
    proposedMatch?: number | null,
    links?:  Array< {
      __typename: "TransactionLink",
      amount: number,
      linkId: string,
      linkType: TransactionLinkType,
    } > | null,
    postings?:  {
      __typename: "ModelPostingConnection",
      items:  Array< {
        __typename: "Posting",
        id: string,
        createdAt?: string | null,
        class: number,
        customLabel?: string | null,
        topClass: number,
        type: PostingType,
        totalAmount: number,
        periodFrom: string,
        periodTo: string,
        buildingId?: string | null,
        unitId?: string | null,
        invoiceId?: string | null,
        chargeId?: string | null,
        transactionId?: string | null,
        leaseId?: string | null,
        bankAccountId?: string | null,
        accountLabelId?: string | null,
        contactId?: string | null,
        leaseVariousOperationId?: string | null,
        statementId?: string | null,
        amountVatExcluded?: number | null,
        vatAmount?: number | null,
        vatRateId?: string | null,
        vatRateValue?: number | null,
        foreignId?: string | null,
        foreignType?: PostingForeignType | null,
        invoicePostingId?: string | null,
        reconciledAt?: string | null,
        status?: PostingStatus | null,
        chargeOwnerRepartition?: number | null,
        chargeRepartitionMetric?: string | null,
        chargeRepartitionValue?: number | null,
        chargeSplitNumber?: number | null,
        chargeType?: PostingChargeType | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    updatedAt: string,
    readers?: Array< string > | null,
    readId: string,
    clientId: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateBillingItemSubscriptionVariables = {
  filter?: ModelSubscriptionBillingItemFilterInput | null,
};

export type OnCreateBillingItemSubscription = {
  onCreateBillingItem?:  {
    __typename: "BillingItem",
    id: string,
    name: string,
    baseAmount?: number | null,
    billingType?: InvoiceBillingType | null,
    amountCalculationType?: InvoiceAmountCalculationType | null,
    percentageBase?: InvoicePercentageBase | null,
    period?: LeasePaymentFrequency | null,
    vatRateId?: string | null,
    vatRate?:  {
      __typename: "VatRate",
      id: string,
      country: string,
      label: string,
      value?: number | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      ownerId?: string | null,
      owner?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    invoiceId?: string | null,
    quantity?: number | null,
    percentage?: number | null,
    allocationOption: BillingItemAllocationOption,
    multipleUnitsSplit?: BillingItemMultipleUnitsSplitOption | null,
    leaseIds?: Array< string | null > | null,
    unitIds?: Array< string | null > | null,
    buildingIds?: Array< string | null > | null,
    accountLabelId?: string | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateBillingItemSubscriptionVariables = {
  filter?: ModelSubscriptionBillingItemFilterInput | null,
};

export type OnUpdateBillingItemSubscription = {
  onUpdateBillingItem?:  {
    __typename: "BillingItem",
    id: string,
    name: string,
    baseAmount?: number | null,
    billingType?: InvoiceBillingType | null,
    amountCalculationType?: InvoiceAmountCalculationType | null,
    percentageBase?: InvoicePercentageBase | null,
    period?: LeasePaymentFrequency | null,
    vatRateId?: string | null,
    vatRate?:  {
      __typename: "VatRate",
      id: string,
      country: string,
      label: string,
      value?: number | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      ownerId?: string | null,
      owner?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    invoiceId?: string | null,
    quantity?: number | null,
    percentage?: number | null,
    allocationOption: BillingItemAllocationOption,
    multipleUnitsSplit?: BillingItemMultipleUnitsSplitOption | null,
    leaseIds?: Array< string | null > | null,
    unitIds?: Array< string | null > | null,
    buildingIds?: Array< string | null > | null,
    accountLabelId?: string | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteBillingItemSubscriptionVariables = {
  filter?: ModelSubscriptionBillingItemFilterInput | null,
};

export type OnDeleteBillingItemSubscription = {
  onDeleteBillingItem?:  {
    __typename: "BillingItem",
    id: string,
    name: string,
    baseAmount?: number | null,
    billingType?: InvoiceBillingType | null,
    amountCalculationType?: InvoiceAmountCalculationType | null,
    percentageBase?: InvoicePercentageBase | null,
    period?: LeasePaymentFrequency | null,
    vatRateId?: string | null,
    vatRate?:  {
      __typename: "VatRate",
      id: string,
      country: string,
      label: string,
      value?: number | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      ownerId?: string | null,
      owner?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    invoiceId?: string | null,
    quantity?: number | null,
    percentage?: number | null,
    allocationOption: BillingItemAllocationOption,
    multipleUnitsSplit?: BillingItemMultipleUnitsSplitOption | null,
    leaseIds?: Array< string | null > | null,
    unitIds?: Array< string | null > | null,
    buildingIds?: Array< string | null > | null,
    accountLabelId?: string | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateBuildingSubscriptionVariables = {
  filter?: ModelSubscriptionBuildingFilterInput | null,
};

export type OnCreateBuildingSubscription = {
  onCreateBuilding?:  {
    __typename: "Building",
    id: string,
    name: string,
    addressId?: string | null,
    address?:  {
      __typename: "Address",
      id: string,
      status?: AddressStatus | null,
      street: string,
      number?: string | null,
      box?: string | null,
      postalCode?: string | null,
      city?: string | null,
      region?: string | null,
      country?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      latitude?: number | null,
      longitude?: number | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    acquisitionValue?: number | null,
    acquisitionAdditionalCostsValue?: number | null,
    acquisitionAdvertisedValue?: number | null,
    amountOfFacades?: number | null,
    amountOfFloors?: number | null,
    amountOfHousings?: number | null,
    buildingState?: BuildingState | null,
    cadastralIncome?: number | null,
    constructionYear?: string | null,
    customValues?:  Array< {
      __typename: "CustomValue",
      name: string,
      value: string,
    } > | null,
    janitor?: boolean | null,
    jointOwnershipId?: string | null,
    notes?: string | null,
    owners?:  {
      __typename: "ModelBuildingOwnerConnection",
      items:  Array< {
        __typename: "BuildingOwner",
        id: string,
        buildingId: string,
        contactId: string,
        disabled?: boolean | null,
        periodFrom?: string | null,
        periodTo?: string | null,
        stake: number,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    propertyTax?: number | null,
    residenceName?: string | null,
    buildingSiteId?: string | null,
    buildingSite?:  {
      __typename: "BuildingSite",
      id: string,
      name: string,
      buildings?:  {
        __typename: "ModelBuildingConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      teams?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    units?:  {
      __typename: "ModelUnitConnection",
      items:  Array< {
        __typename: "Unit",
        id: string,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        acquisitionValue?: number | null,
        advertisedMonthlyCharges?: number | null,
        advertisedRentalPrice?: number | null,
        cadastralIncome?: number | null,
        createdAt?: string | null,
        floor?: number | null,
        jointOwnershipId?: string | null,
        managementDate: string,
        name: string,
        notes?: string | null,
        predictedPrice?: string | null,
        propertyTax?: number | null,
        publishAddress?: boolean | null,
        surface?: number | null,
        type: UnitType,
        buildingId: string,
        unitAdvertisementId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    events?:  {
      __typename: "ModelBuildingEventConnection",
      items:  Array< {
        __typename: "BuildingEvent",
        id: string,
        buildingId: string,
        type: string,
        startDate: string,
        endDate: string,
        totalCost?: number | null,
        note?: string | null,
        writers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    readers?: Array< string > | null,
    teams?: Array< string > | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateBuildingSubscriptionVariables = {
  filter?: ModelSubscriptionBuildingFilterInput | null,
};

export type OnUpdateBuildingSubscription = {
  onUpdateBuilding?:  {
    __typename: "Building",
    id: string,
    name: string,
    addressId?: string | null,
    address?:  {
      __typename: "Address",
      id: string,
      status?: AddressStatus | null,
      street: string,
      number?: string | null,
      box?: string | null,
      postalCode?: string | null,
      city?: string | null,
      region?: string | null,
      country?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      latitude?: number | null,
      longitude?: number | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    acquisitionValue?: number | null,
    acquisitionAdditionalCostsValue?: number | null,
    acquisitionAdvertisedValue?: number | null,
    amountOfFacades?: number | null,
    amountOfFloors?: number | null,
    amountOfHousings?: number | null,
    buildingState?: BuildingState | null,
    cadastralIncome?: number | null,
    constructionYear?: string | null,
    customValues?:  Array< {
      __typename: "CustomValue",
      name: string,
      value: string,
    } > | null,
    janitor?: boolean | null,
    jointOwnershipId?: string | null,
    notes?: string | null,
    owners?:  {
      __typename: "ModelBuildingOwnerConnection",
      items:  Array< {
        __typename: "BuildingOwner",
        id: string,
        buildingId: string,
        contactId: string,
        disabled?: boolean | null,
        periodFrom?: string | null,
        periodTo?: string | null,
        stake: number,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    propertyTax?: number | null,
    residenceName?: string | null,
    buildingSiteId?: string | null,
    buildingSite?:  {
      __typename: "BuildingSite",
      id: string,
      name: string,
      buildings?:  {
        __typename: "ModelBuildingConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      teams?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    units?:  {
      __typename: "ModelUnitConnection",
      items:  Array< {
        __typename: "Unit",
        id: string,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        acquisitionValue?: number | null,
        advertisedMonthlyCharges?: number | null,
        advertisedRentalPrice?: number | null,
        cadastralIncome?: number | null,
        createdAt?: string | null,
        floor?: number | null,
        jointOwnershipId?: string | null,
        managementDate: string,
        name: string,
        notes?: string | null,
        predictedPrice?: string | null,
        propertyTax?: number | null,
        publishAddress?: boolean | null,
        surface?: number | null,
        type: UnitType,
        buildingId: string,
        unitAdvertisementId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    events?:  {
      __typename: "ModelBuildingEventConnection",
      items:  Array< {
        __typename: "BuildingEvent",
        id: string,
        buildingId: string,
        type: string,
        startDate: string,
        endDate: string,
        totalCost?: number | null,
        note?: string | null,
        writers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    readers?: Array< string > | null,
    teams?: Array< string > | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteBuildingSubscriptionVariables = {
  filter?: ModelSubscriptionBuildingFilterInput | null,
};

export type OnDeleteBuildingSubscription = {
  onDeleteBuilding?:  {
    __typename: "Building",
    id: string,
    name: string,
    addressId?: string | null,
    address?:  {
      __typename: "Address",
      id: string,
      status?: AddressStatus | null,
      street: string,
      number?: string | null,
      box?: string | null,
      postalCode?: string | null,
      city?: string | null,
      region?: string | null,
      country?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      latitude?: number | null,
      longitude?: number | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    acquisitionValue?: number | null,
    acquisitionAdditionalCostsValue?: number | null,
    acquisitionAdvertisedValue?: number | null,
    amountOfFacades?: number | null,
    amountOfFloors?: number | null,
    amountOfHousings?: number | null,
    buildingState?: BuildingState | null,
    cadastralIncome?: number | null,
    constructionYear?: string | null,
    customValues?:  Array< {
      __typename: "CustomValue",
      name: string,
      value: string,
    } > | null,
    janitor?: boolean | null,
    jointOwnershipId?: string | null,
    notes?: string | null,
    owners?:  {
      __typename: "ModelBuildingOwnerConnection",
      items:  Array< {
        __typename: "BuildingOwner",
        id: string,
        buildingId: string,
        contactId: string,
        disabled?: boolean | null,
        periodFrom?: string | null,
        periodTo?: string | null,
        stake: number,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    propertyTax?: number | null,
    residenceName?: string | null,
    buildingSiteId?: string | null,
    buildingSite?:  {
      __typename: "BuildingSite",
      id: string,
      name: string,
      buildings?:  {
        __typename: "ModelBuildingConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      teams?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    units?:  {
      __typename: "ModelUnitConnection",
      items:  Array< {
        __typename: "Unit",
        id: string,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        acquisitionValue?: number | null,
        advertisedMonthlyCharges?: number | null,
        advertisedRentalPrice?: number | null,
        cadastralIncome?: number | null,
        createdAt?: string | null,
        floor?: number | null,
        jointOwnershipId?: string | null,
        managementDate: string,
        name: string,
        notes?: string | null,
        predictedPrice?: string | null,
        propertyTax?: number | null,
        publishAddress?: boolean | null,
        surface?: number | null,
        type: UnitType,
        buildingId: string,
        unitAdvertisementId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    events?:  {
      __typename: "ModelBuildingEventConnection",
      items:  Array< {
        __typename: "BuildingEvent",
        id: string,
        buildingId: string,
        type: string,
        startDate: string,
        endDate: string,
        totalCost?: number | null,
        note?: string | null,
        writers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    readers?: Array< string > | null,
    teams?: Array< string > | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateBuildingEventSubscriptionVariables = {
  filter?: ModelSubscriptionBuildingEventFilterInput | null,
};

export type OnCreateBuildingEventSubscription = {
  onCreateBuildingEvent?:  {
    __typename: "BuildingEvent",
    id: string,
    buildingId: string,
    type: string,
    startDate: string,
    endDate: string,
    totalCost?: number | null,
    note?: string | null,
    writers?: Array< string > | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateBuildingEventSubscriptionVariables = {
  filter?: ModelSubscriptionBuildingEventFilterInput | null,
};

export type OnUpdateBuildingEventSubscription = {
  onUpdateBuildingEvent?:  {
    __typename: "BuildingEvent",
    id: string,
    buildingId: string,
    type: string,
    startDate: string,
    endDate: string,
    totalCost?: number | null,
    note?: string | null,
    writers?: Array< string > | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteBuildingEventSubscriptionVariables = {
  filter?: ModelSubscriptionBuildingEventFilterInput | null,
};

export type OnDeleteBuildingEventSubscription = {
  onDeleteBuildingEvent?:  {
    __typename: "BuildingEvent",
    id: string,
    buildingId: string,
    type: string,
    startDate: string,
    endDate: string,
    totalCost?: number | null,
    note?: string | null,
    writers?: Array< string > | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateBuildingOwnerSubscriptionVariables = {
  filter?: ModelSubscriptionBuildingOwnerFilterInput | null,
};

export type OnCreateBuildingOwnerSubscription = {
  onCreateBuildingOwner?:  {
    __typename: "BuildingOwner",
    id: string,
    buildingId: string,
    building?:  {
      __typename: "Building",
      id: string,
      name: string,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      acquisitionValue?: number | null,
      acquisitionAdditionalCostsValue?: number | null,
      acquisitionAdvertisedValue?: number | null,
      amountOfFacades?: number | null,
      amountOfFloors?: number | null,
      amountOfHousings?: number | null,
      buildingState?: BuildingState | null,
      cadastralIncome?: number | null,
      constructionYear?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      janitor?: boolean | null,
      jointOwnershipId?: string | null,
      notes?: string | null,
      owners?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      propertyTax?: number | null,
      residenceName?: string | null,
      buildingSiteId?: string | null,
      buildingSite?:  {
        __typename: "BuildingSite",
        id: string,
        name: string,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      units?:  {
        __typename: "ModelUnitConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      events?:  {
        __typename: "ModelBuildingEventConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      teams?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    contactId: string,
    disabled?: boolean | null,
    owner?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    periodFrom?: string | null,
    periodTo?: string | null,
    stake: number,
    readers?: Array< string > | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateBuildingOwnerSubscriptionVariables = {
  filter?: ModelSubscriptionBuildingOwnerFilterInput | null,
};

export type OnUpdateBuildingOwnerSubscription = {
  onUpdateBuildingOwner?:  {
    __typename: "BuildingOwner",
    id: string,
    buildingId: string,
    building?:  {
      __typename: "Building",
      id: string,
      name: string,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      acquisitionValue?: number | null,
      acquisitionAdditionalCostsValue?: number | null,
      acquisitionAdvertisedValue?: number | null,
      amountOfFacades?: number | null,
      amountOfFloors?: number | null,
      amountOfHousings?: number | null,
      buildingState?: BuildingState | null,
      cadastralIncome?: number | null,
      constructionYear?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      janitor?: boolean | null,
      jointOwnershipId?: string | null,
      notes?: string | null,
      owners?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      propertyTax?: number | null,
      residenceName?: string | null,
      buildingSiteId?: string | null,
      buildingSite?:  {
        __typename: "BuildingSite",
        id: string,
        name: string,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      units?:  {
        __typename: "ModelUnitConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      events?:  {
        __typename: "ModelBuildingEventConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      teams?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    contactId: string,
    disabled?: boolean | null,
    owner?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    periodFrom?: string | null,
    periodTo?: string | null,
    stake: number,
    readers?: Array< string > | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteBuildingOwnerSubscriptionVariables = {
  filter?: ModelSubscriptionBuildingOwnerFilterInput | null,
};

export type OnDeleteBuildingOwnerSubscription = {
  onDeleteBuildingOwner?:  {
    __typename: "BuildingOwner",
    id: string,
    buildingId: string,
    building?:  {
      __typename: "Building",
      id: string,
      name: string,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      acquisitionValue?: number | null,
      acquisitionAdditionalCostsValue?: number | null,
      acquisitionAdvertisedValue?: number | null,
      amountOfFacades?: number | null,
      amountOfFloors?: number | null,
      amountOfHousings?: number | null,
      buildingState?: BuildingState | null,
      cadastralIncome?: number | null,
      constructionYear?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      janitor?: boolean | null,
      jointOwnershipId?: string | null,
      notes?: string | null,
      owners?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      propertyTax?: number | null,
      residenceName?: string | null,
      buildingSiteId?: string | null,
      buildingSite?:  {
        __typename: "BuildingSite",
        id: string,
        name: string,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      units?:  {
        __typename: "ModelUnitConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      events?:  {
        __typename: "ModelBuildingEventConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      teams?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    contactId: string,
    disabled?: boolean | null,
    owner?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    periodFrom?: string | null,
    periodTo?: string | null,
    stake: number,
    readers?: Array< string > | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateBuildingSiteSubscriptionVariables = {
  filter?: ModelSubscriptionBuildingSiteFilterInput | null,
};

export type OnCreateBuildingSiteSubscription = {
  onCreateBuildingSite?:  {
    __typename: "BuildingSite",
    id: string,
    name: string,
    buildings?:  {
      __typename: "ModelBuildingConnection",
      items:  Array< {
        __typename: "Building",
        id: string,
        name: string,
        addressId?: string | null,
        acquisitionValue?: number | null,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        amountOfFacades?: number | null,
        amountOfFloors?: number | null,
        amountOfHousings?: number | null,
        buildingState?: BuildingState | null,
        cadastralIncome?: number | null,
        constructionYear?: string | null,
        janitor?: boolean | null,
        jointOwnershipId?: string | null,
        notes?: string | null,
        propertyTax?: number | null,
        residenceName?: string | null,
        buildingSiteId?: string | null,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    readers?: Array< string > | null,
    teams?: Array< string > | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateBuildingSiteSubscriptionVariables = {
  filter?: ModelSubscriptionBuildingSiteFilterInput | null,
};

export type OnUpdateBuildingSiteSubscription = {
  onUpdateBuildingSite?:  {
    __typename: "BuildingSite",
    id: string,
    name: string,
    buildings?:  {
      __typename: "ModelBuildingConnection",
      items:  Array< {
        __typename: "Building",
        id: string,
        name: string,
        addressId?: string | null,
        acquisitionValue?: number | null,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        amountOfFacades?: number | null,
        amountOfFloors?: number | null,
        amountOfHousings?: number | null,
        buildingState?: BuildingState | null,
        cadastralIncome?: number | null,
        constructionYear?: string | null,
        janitor?: boolean | null,
        jointOwnershipId?: string | null,
        notes?: string | null,
        propertyTax?: number | null,
        residenceName?: string | null,
        buildingSiteId?: string | null,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    readers?: Array< string > | null,
    teams?: Array< string > | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteBuildingSiteSubscriptionVariables = {
  filter?: ModelSubscriptionBuildingSiteFilterInput | null,
};

export type OnDeleteBuildingSiteSubscription = {
  onDeleteBuildingSite?:  {
    __typename: "BuildingSite",
    id: string,
    name: string,
    buildings?:  {
      __typename: "ModelBuildingConnection",
      items:  Array< {
        __typename: "Building",
        id: string,
        name: string,
        addressId?: string | null,
        acquisitionValue?: number | null,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        amountOfFacades?: number | null,
        amountOfFloors?: number | null,
        amountOfHousings?: number | null,
        buildingState?: BuildingState | null,
        cadastralIncome?: number | null,
        constructionYear?: string | null,
        janitor?: boolean | null,
        jointOwnershipId?: string | null,
        notes?: string | null,
        propertyTax?: number | null,
        residenceName?: string | null,
        buildingSiteId?: string | null,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    readers?: Array< string > | null,
    teams?: Array< string > | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateChargeSubscriptionVariables = {
  filter?: ModelSubscriptionChargeFilterInput | null,
};

export type OnCreateChargeSubscription = {
  onCreateCharge?:  {
    __typename: "Charge",
    id: string,
    status: ChargeStatus,
    invoiceDate?: string | null,
    paymentDueDate?: string | null,
    archivedDate?: string | null,
    periodFrom?: string | null,
    periodTo?: string | null,
    totalAmount?: number | null,
    source: ChargeSource,
    draftFromOcr?: boolean | null,
    accountingDocumentId?: string | null,
    paid: boolean,
    remittanceInformation?: string | null,
    note?: string | null,
    createdAt: string,
    creatorEmail?: string | null,
    createdById?: string | null,
    createdBy?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    contractorId?: string | null,
    contractor?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    proposedContractors?:  Array< {
      __typename: "ProposedValue",
      id: string,
      confidence?: number | null,
    } > | null,
    recipientId?: string | null,
    recipient?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    proposedRecipients?:  Array< {
      __typename: "ProposedValue",
      id: string,
      confidence?: number | null,
    } > | null,
    customValues?:  Array< {
      __typename: "CustomValue",
      name: string,
      value: string,
    } > | null,
    documentId: string,
    document?:  {
      __typename: "File",
      id: string,
      bucket: string,
      createdAt?: string | null,
      category?:  {
        __typename: "DocumentCategory",
        id: string,
        entity?: string | null,
        fileCategory: FileCategory,
        parentId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      categoryId: string,
      foreignKey: string,
      foreignTableName: string,
      key: string,
      mimeType?: string | null,
      region: string,
      signaturePositions?:  Array< {
        __typename: "SignaturePosition",
        top: number,
        left: number,
        page: number,
        width?: number | null,
        height?: number | null,
        contactId: string,
      } > | null,
      size?: number | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      _ttl?: number | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    postings?:  {
      __typename: "ModelPostingConnection",
      items:  Array< {
        __typename: "Posting",
        id: string,
        createdAt?: string | null,
        class: number,
        customLabel?: string | null,
        topClass: number,
        type: PostingType,
        totalAmount: number,
        periodFrom: string,
        periodTo: string,
        buildingId?: string | null,
        unitId?: string | null,
        invoiceId?: string | null,
        chargeId?: string | null,
        transactionId?: string | null,
        leaseId?: string | null,
        bankAccountId?: string | null,
        accountLabelId?: string | null,
        contactId?: string | null,
        leaseVariousOperationId?: string | null,
        statementId?: string | null,
        amountVatExcluded?: number | null,
        vatAmount?: number | null,
        vatRateId?: string | null,
        vatRateValue?: number | null,
        foreignId?: string | null,
        foreignType?: PostingForeignType | null,
        invoicePostingId?: string | null,
        reconciledAt?: string | null,
        status?: PostingStatus | null,
        chargeOwnerRepartition?: number | null,
        chargeRepartitionMetric?: string | null,
        chargeRepartitionValue?: number | null,
        chargeSplitNumber?: number | null,
        chargeType?: PostingChargeType | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    readId: string,
    clientId: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateChargeSubscriptionVariables = {
  filter?: ModelSubscriptionChargeFilterInput | null,
};

export type OnUpdateChargeSubscription = {
  onUpdateCharge?:  {
    __typename: "Charge",
    id: string,
    status: ChargeStatus,
    invoiceDate?: string | null,
    paymentDueDate?: string | null,
    archivedDate?: string | null,
    periodFrom?: string | null,
    periodTo?: string | null,
    totalAmount?: number | null,
    source: ChargeSource,
    draftFromOcr?: boolean | null,
    accountingDocumentId?: string | null,
    paid: boolean,
    remittanceInformation?: string | null,
    note?: string | null,
    createdAt: string,
    creatorEmail?: string | null,
    createdById?: string | null,
    createdBy?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    contractorId?: string | null,
    contractor?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    proposedContractors?:  Array< {
      __typename: "ProposedValue",
      id: string,
      confidence?: number | null,
    } > | null,
    recipientId?: string | null,
    recipient?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    proposedRecipients?:  Array< {
      __typename: "ProposedValue",
      id: string,
      confidence?: number | null,
    } > | null,
    customValues?:  Array< {
      __typename: "CustomValue",
      name: string,
      value: string,
    } > | null,
    documentId: string,
    document?:  {
      __typename: "File",
      id: string,
      bucket: string,
      createdAt?: string | null,
      category?:  {
        __typename: "DocumentCategory",
        id: string,
        entity?: string | null,
        fileCategory: FileCategory,
        parentId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      categoryId: string,
      foreignKey: string,
      foreignTableName: string,
      key: string,
      mimeType?: string | null,
      region: string,
      signaturePositions?:  Array< {
        __typename: "SignaturePosition",
        top: number,
        left: number,
        page: number,
        width?: number | null,
        height?: number | null,
        contactId: string,
      } > | null,
      size?: number | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      _ttl?: number | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    postings?:  {
      __typename: "ModelPostingConnection",
      items:  Array< {
        __typename: "Posting",
        id: string,
        createdAt?: string | null,
        class: number,
        customLabel?: string | null,
        topClass: number,
        type: PostingType,
        totalAmount: number,
        periodFrom: string,
        periodTo: string,
        buildingId?: string | null,
        unitId?: string | null,
        invoiceId?: string | null,
        chargeId?: string | null,
        transactionId?: string | null,
        leaseId?: string | null,
        bankAccountId?: string | null,
        accountLabelId?: string | null,
        contactId?: string | null,
        leaseVariousOperationId?: string | null,
        statementId?: string | null,
        amountVatExcluded?: number | null,
        vatAmount?: number | null,
        vatRateId?: string | null,
        vatRateValue?: number | null,
        foreignId?: string | null,
        foreignType?: PostingForeignType | null,
        invoicePostingId?: string | null,
        reconciledAt?: string | null,
        status?: PostingStatus | null,
        chargeOwnerRepartition?: number | null,
        chargeRepartitionMetric?: string | null,
        chargeRepartitionValue?: number | null,
        chargeSplitNumber?: number | null,
        chargeType?: PostingChargeType | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    readId: string,
    clientId: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteChargeSubscriptionVariables = {
  filter?: ModelSubscriptionChargeFilterInput | null,
};

export type OnDeleteChargeSubscription = {
  onDeleteCharge?:  {
    __typename: "Charge",
    id: string,
    status: ChargeStatus,
    invoiceDate?: string | null,
    paymentDueDate?: string | null,
    archivedDate?: string | null,
    periodFrom?: string | null,
    periodTo?: string | null,
    totalAmount?: number | null,
    source: ChargeSource,
    draftFromOcr?: boolean | null,
    accountingDocumentId?: string | null,
    paid: boolean,
    remittanceInformation?: string | null,
    note?: string | null,
    createdAt: string,
    creatorEmail?: string | null,
    createdById?: string | null,
    createdBy?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    contractorId?: string | null,
    contractor?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    proposedContractors?:  Array< {
      __typename: "ProposedValue",
      id: string,
      confidence?: number | null,
    } > | null,
    recipientId?: string | null,
    recipient?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    proposedRecipients?:  Array< {
      __typename: "ProposedValue",
      id: string,
      confidence?: number | null,
    } > | null,
    customValues?:  Array< {
      __typename: "CustomValue",
      name: string,
      value: string,
    } > | null,
    documentId: string,
    document?:  {
      __typename: "File",
      id: string,
      bucket: string,
      createdAt?: string | null,
      category?:  {
        __typename: "DocumentCategory",
        id: string,
        entity?: string | null,
        fileCategory: FileCategory,
        parentId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      categoryId: string,
      foreignKey: string,
      foreignTableName: string,
      key: string,
      mimeType?: string | null,
      region: string,
      signaturePositions?:  Array< {
        __typename: "SignaturePosition",
        top: number,
        left: number,
        page: number,
        width?: number | null,
        height?: number | null,
        contactId: string,
      } > | null,
      size?: number | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      _ttl?: number | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    postings?:  {
      __typename: "ModelPostingConnection",
      items:  Array< {
        __typename: "Posting",
        id: string,
        createdAt?: string | null,
        class: number,
        customLabel?: string | null,
        topClass: number,
        type: PostingType,
        totalAmount: number,
        periodFrom: string,
        periodTo: string,
        buildingId?: string | null,
        unitId?: string | null,
        invoiceId?: string | null,
        chargeId?: string | null,
        transactionId?: string | null,
        leaseId?: string | null,
        bankAccountId?: string | null,
        accountLabelId?: string | null,
        contactId?: string | null,
        leaseVariousOperationId?: string | null,
        statementId?: string | null,
        amountVatExcluded?: number | null,
        vatAmount?: number | null,
        vatRateId?: string | null,
        vatRateValue?: number | null,
        foreignId?: string | null,
        foreignType?: PostingForeignType | null,
        invoicePostingId?: string | null,
        reconciledAt?: string | null,
        status?: PostingStatus | null,
        chargeOwnerRepartition?: number | null,
        chargeRepartitionMetric?: string | null,
        chargeRepartitionValue?: number | null,
        chargeSplitNumber?: number | null,
        chargeType?: PostingChargeType | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    readId: string,
    clientId: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateCommunicationSubscriptionVariables = {
  filter?: ModelSubscriptionCommunicationFilterInput | null,
};

export type OnCreateCommunicationSubscription = {
  onCreateCommunication?:  {
    __typename: "Communication",
    id: string,
    addressId?: string | null,
    address?:  {
      __typename: "Address",
      id: string,
      status?: AddressStatus | null,
      street: string,
      number?: string | null,
      box?: string | null,
      postalCode?: string | null,
      city?: string | null,
      region?: string | null,
      country?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      latitude?: number | null,
      longitude?: number | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    blockedRecipients?:  Array< {
      __typename: "CommunicationBlockedRecipient",
      recipient: string,
      bounceType: BounceType,
    } > | null,
    body: string,
    buildingId?: string | null,
    channel: CommunicationChannel,
    communicationTemplateId?: string | null,
    concernedContactIds?: Array< string > | null,
    contactId?: string | null,
    contactIds?: Array< string > | null,
    createdAt?: string | null,
    draftProperties?:  {
      __typename: "CommunicationDraftProperties",
      allowRecipientsToSeeEachOther?: boolean | null,
      bcc?: Array< string > | null,
      buildingIds?: Array< string > | null,
      cc?: Array< string > | null,
      contactIds?: Array< string > | null,
      contactTypes?: Array< ContactType > | null,
      entityType: string,
      leaseIds?: Array< string > | null,
      sendInBcc?: boolean | null,
      unitIds?: Array< string > | null,
      unitTypeFilter?: string | null,
    } | null,
    expirationDate?: string | null,
    files?:  {
      __typename: "ModelFileConnection",
      items:  Array< {
        __typename: "File",
        id: string,
        bucket: string,
        createdAt?: string | null,
        categoryId: string,
        foreignKey: string,
        foreignTableName: string,
        key: string,
        mimeType?: string | null,
        region: string,
        size?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        _ttl?: number | null,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    invoice?:  {
      __typename: "Invoice",
      id: string,
      amount: number,
      bankAccountId: string,
      bankAccount?:  {
        __typename: "BankAccount",
        id: string,
        contactId: string,
        number: string,
        bicNumber?: string | null,
        bankName?: string | null,
        contactIds?: Array< string > | null,
        buildingIds?: Array< string > | null,
        holderName?: string | null,
        label?: string | null,
        disabled?: boolean | null,
        integrations?: Array< IntegrationName > | null,
        matchingRule?: BankAccountMatchingRule | null,
        balance?: number | null,
        balanceDate?: string | null,
        type: BankAccountType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      communicationId?: string | null,
      communication?:  {
        __typename: "Communication",
        id: string,
        addressId?: string | null,
        body: string,
        buildingId?: string | null,
        channel: CommunicationChannel,
        communicationTemplateId?: string | null,
        concernedContactIds?: Array< string > | null,
        contactId?: string | null,
        contactIds?: Array< string > | null,
        createdAt?: string | null,
        expirationDate?: string | null,
        invoiceId?: string | null,
        leaseId?: string | null,
        leasePriceHistoryId?: string | null,
        letterTrackingCode?: string | null,
        letterTrackingProvider?: TrackingProvider | null,
        linkedCommunicationsIds?: Array< string > | null,
        supportingDocumentFileIds?: Array< string > | null,
        recipient?: string | null,
        recipientContactIdsInBcc?: Array< string > | null,
        recipientContactIdsInCc?: Array< string > | null,
        recipientInBcc?: string | null,
        recipientInCc?: string | null,
        scheduledAt?: string | null,
        deliveredAt?: string | null,
        errorCode?: CommunicationErrorCode | null,
        nextRetryAt?: string | null,
        sendRetryCount?: number | null,
        sender?: string | null,
        sentAt?: string | null,
        externalId?: string | null,
        externalStatus?: string | null,
        signatureDocumentId?: string | null,
        snoozedDate?: string | null,
        statementId?: string | null,
        status: CommunicationStatus,
        subject: string,
        toSend: boolean,
        hideLogo?: boolean | null,
        type: CommunicationType,
        _ttl?: number | null,
        unitId?: string | null,
        readId: string,
        readers?: Array< string > | null,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      createdAt: string,
      creditNote?: boolean | null,
      creditNoteLabel?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      dueDate?: string | null,
      invoiceDate: string,
      invoiceNumber?: string | null,
      ownerId?: string | null,
      owner?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      invoiceSenderId: string,
      invoiceSender?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      leaseId?: string | null,
      lease?:  {
        __typename: "Lease",
        id: string,
        balance?: number | null,
        canBeExtended?: boolean | null,
        communicationSettingsProfileId: string,
        createdAt?: string | null,
        endDate: string,
        includeRealEstateInLeaseContract?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        invoiceSenderId: string,
        inventoryOfFixturesExpert?: string | null,
        inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
        inventoryOfFixturesType?: InventoryOfFixturesType | null,
        ipiNumber?: string | null,
        language: Language,
        lastDraftInvoiceDate?: string | null,
        lastIndexationProcessDate?: string | null,
        lastInvoiceDate?: string | null,
        legalCompetentAuthority?: string | null,
        name: string,
        notes?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        purchaseOrderNumber?: string | null,
        realEstateAgency?: string | null,
        realEstateTax?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        signatureDate?: string | null,
        startDate: string,
        nextIndexationMonth?: string | null,
        nextIndexation?: boolean | null,
        status: LeaseStatus,
        technicCommunicationSettingsProfileId: string,
        totalInitialRentalPrice: number,
        totalRentalPrice: number,
        type: LeaseType,
        subletting?: boolean | null,
        vatRateRentId?: string | null,
        bankAccountId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      paid: boolean,
      integrations?:  {
        __typename: "InvoiceIntegrations",
      } | null,
      postedDate?: string | null,
      purchaseOrderNumber?: string | null,
      receiptNumber?: string | null,
      reminderDates?: Array< string > | null,
      note?: string | null,
      remittanceInformation?: string | null,
      statementId?: string | null,
      statement?:  {
        __typename: "Statement",
        id: string,
        closingStatement: boolean,
        periodFrom: string,
        periodTo: string,
        attachSupportingDocuments?: boolean | null,
        selectedPocketKeys?: Array< string > | null,
        source: StatementSource,
        status: StatementStatus,
        sentDate?: string | null,
        leaseId?: string | null,
        ownerId?: string | null,
        types?: Array< StatementType > | null,
        viewType: StatementViewType,
        unitIds?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      status: InvoiceStatus,
      type: InvoiceType,
      unitId?: string | null,
      unit?:  {
        __typename: "Unit",
        id: string,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        acquisitionValue?: number | null,
        advertisedMonthlyCharges?: number | null,
        advertisedRentalPrice?: number | null,
        cadastralIncome?: number | null,
        createdAt?: string | null,
        floor?: number | null,
        jointOwnershipId?: string | null,
        managementDate: string,
        name: string,
        notes?: string | null,
        predictedPrice?: string | null,
        propertyTax?: number | null,
        publishAddress?: boolean | null,
        surface?: number | null,
        type: UnitType,
        buildingId: string,
        unitAdvertisementId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      reversedInvoiceId?: string | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    invoiceId?: string | null,
    lease?:  {
      __typename: "Lease",
      id: string,
      advancedChargesInvoices?:  {
        __typename: "LeaseAdvancedChargesInvoice",
        communicationSettingsProfileId: string,
        invoiceSenderId: string,
        lastDraftInvoiceDate?: string | null,
        lastInvoiceDate?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        bankAccountId?: string | null,
      } | null,
      balance?: number | null,
      canBeExtended?: boolean | null,
      communicationSettingsProfileId: string,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      endDate: string,
      includeRealEstateInLeaseContract?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      invoiceSenderId: string,
      invoiceSender?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      inventoryOfFixturesExpert?: string | null,
      inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
      inventoryOfFixturesType?: InventoryOfFixturesType | null,
      ipiNumber?: string | null,
      language: Language,
      lastDraftInvoiceDate?: string | null,
      lastIndexationProcessDate?: string | null,
      lastInvoiceDate?: string | null,
      legalCompetentAuthority?: string | null,
      name: string,
      notes?: string | null,
      paymentFrequency: LeasePaymentFrequency,
      paymentInvoicePeriod: LeasePaymentInvoicePeriod,
      paymentInvoicePeriodCustomDay?: number | null,
      paymentOption?:  {
        __typename: "LeasePaymentOption",
        customerId?: string | null,
        enabled: boolean,
        mandateActivatedAt?: string | null,
        mandateStatus?: PaymentProviderMandateStatus | null,
        paymentMethodId?: string | null,
        qrType?: LeaseQrType | null,
      } | null,
      purchaseOrderNumber?: string | null,
      realEstateAgency?: string | null,
      realEstateTax?: number | null,
      remittanceInformation?: string | null,
      remittanceInformationType?: LeaseRemittanceType | null,
      rentalGuaranty?:  {
        __typename: "LeaseRentalGuaranty",
        amount: number,
        blockedAmount?: number | null,
        releasedAmount?: number | null,
        type: LeaseRentalGuarantyType,
        financialInstitution?: string | null,
      } | null,
      signatureDate?: string | null,
      startDate: string,
      nextIndexationMonth?: string | null,
      nextIndexation?: boolean | null,
      status: LeaseStatus,
      technicCommunicationSettingsProfileId: string,
      totalInitialRentalPrice: number,
      totalRentalPrice: number,
      type: LeaseType,
      subletting?: boolean | null,
      vatRateRentId?: string | null,
      vatRateRent?:  {
        __typename: "VatRate",
        id: string,
        country: string,
        label: string,
        value?: number | null,
        ownerId?: string | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      additionalClauses?:  {
        __typename: "ModelLeaseAdditionalClauseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      bankAccountId?: string | null,
      bankAccount?:  {
        __typename: "BankAccount",
        id: string,
        contactId: string,
        number: string,
        bicNumber?: string | null,
        bankName?: string | null,
        contactIds?: Array< string > | null,
        buildingIds?: Array< string > | null,
        holderName?: string | null,
        label?: string | null,
        disabled?: boolean | null,
        integrations?: Array< IntegrationName > | null,
        matchingRule?: BankAccountMatchingRule | null,
        balance?: number | null,
        balanceDate?: string | null,
        type: BankAccountType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contacts?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      files?:  {
        __typename: "ModelFileConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leaseActionHistories?:  {
        __typename: "ModelLeaseActionHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leasePriceHistories?:  {
        __typename: "ModelLeasePriceHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      signatureDocuments?:  {
        __typename: "ModelSignatureDocumentConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      variousOperations?:  {
        __typename: "ModelLeaseVariousOperationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    leaseId?: string | null,
    leasePriceHistoryId?: string | null,
    leasePriceHistory?:  {
      __typename: "LeasePriceHistory",
      id: string,
      previousTotalRentalPrice: number,
      totalRentalPrice: number,
      optimalTotalRentalPrice?: number | null,
      optimalTotalMonthlyCharges?: number | null,
      applicationDate: string,
      status: LeaseAmountUpdateStatus,
      comment?: string | null,
      amountDetails:  Array< {
        __typename: "LeasePriceHistoryDetail",
        unitId: string,
        indexationBaseIndex?: number | null,
        indexationNewIndex?: number | null,
        previousRentalPrice: number,
        newRentalPrice: number,
        rentalStatus: LeasePriceHistoryStatus,
        monthlyChargesStatus: LeasePriceHistoryStatus,
        optimalNewRentalPrice?: number | null,
        optimalNewMonthlyChargesPrice?: number | null,
        epb?: string | null,
        epbIssueDate?: string | null,
        oldestIndexForCorrectionFactorCalculation?: number | null,
        newestIndexForCorrectionFactorCalculation?: number | null,
        rentIndexedPriceAfterNewEpbReduction?: number | null,
        chargesIndexedPriceAfterNewEpbReduction?: number | null,
        correctionFactor?: number | null,
        reductionPercentage?: number | null,
        rentDifference?: number | null,
        rentReduction?: number | null,
        indexedRentAfterReduction?: number | null,
        chargesDifference?: number | null,
        chargesReduction?: number | null,
        indexedChargesAfterReduction?: number | null,
        previousYearIndexationNewIndex?: number | null,
        previousYearIndexedRent?: number | null,
        previousYearIndexedCharges?: number | null,
      } >,
      type: LeasePriceHistoryType,
      communicationId?: string | null,
      communication?:  {
        __typename: "Communication",
        id: string,
        addressId?: string | null,
        body: string,
        buildingId?: string | null,
        channel: CommunicationChannel,
        communicationTemplateId?: string | null,
        concernedContactIds?: Array< string > | null,
        contactId?: string | null,
        contactIds?: Array< string > | null,
        createdAt?: string | null,
        expirationDate?: string | null,
        invoiceId?: string | null,
        leaseId?: string | null,
        leasePriceHistoryId?: string | null,
        letterTrackingCode?: string | null,
        letterTrackingProvider?: TrackingProvider | null,
        linkedCommunicationsIds?: Array< string > | null,
        supportingDocumentFileIds?: Array< string > | null,
        recipient?: string | null,
        recipientContactIdsInBcc?: Array< string > | null,
        recipientContactIdsInCc?: Array< string > | null,
        recipientInBcc?: string | null,
        recipientInCc?: string | null,
        scheduledAt?: string | null,
        deliveredAt?: string | null,
        errorCode?: CommunicationErrorCode | null,
        nextRetryAt?: string | null,
        sendRetryCount?: number | null,
        sender?: string | null,
        sentAt?: string | null,
        externalId?: string | null,
        externalStatus?: string | null,
        signatureDocumentId?: string | null,
        snoozedDate?: string | null,
        statementId?: string | null,
        status: CommunicationStatus,
        subject: string,
        toSend: boolean,
        hideLogo?: boolean | null,
        type: CommunicationType,
        _ttl?: number | null,
        unitId?: string | null,
        readId: string,
        readers?: Array< string > | null,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      leaseId: string,
      lease?:  {
        __typename: "Lease",
        id: string,
        balance?: number | null,
        canBeExtended?: boolean | null,
        communicationSettingsProfileId: string,
        createdAt?: string | null,
        endDate: string,
        includeRealEstateInLeaseContract?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        invoiceSenderId: string,
        inventoryOfFixturesExpert?: string | null,
        inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
        inventoryOfFixturesType?: InventoryOfFixturesType | null,
        ipiNumber?: string | null,
        language: Language,
        lastDraftInvoiceDate?: string | null,
        lastIndexationProcessDate?: string | null,
        lastInvoiceDate?: string | null,
        legalCompetentAuthority?: string | null,
        name: string,
        notes?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        purchaseOrderNumber?: string | null,
        realEstateAgency?: string | null,
        realEstateTax?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        signatureDate?: string | null,
        startDate: string,
        nextIndexationMonth?: string | null,
        nextIndexation?: boolean | null,
        status: LeaseStatus,
        technicCommunicationSettingsProfileId: string,
        totalInitialRentalPrice: number,
        totalRentalPrice: number,
        type: LeaseType,
        subletting?: boolean | null,
        vatRateRentId?: string | null,
        bankAccountId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      createdAt?: string | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    letterTrackingCode?: string | null,
    letterTrackingProvider?: TrackingProvider | null,
    linkedCommunicationsIds?: Array< string > | null,
    supportingDocumentFileIds?: Array< string > | null,
    recipient?: string | null,
    recipientContactIdsInBcc?: Array< string > | null,
    recipientContactIdsInCc?: Array< string > | null,
    recipientInBcc?: string | null,
    recipientInCc?: string | null,
    scheduledAt?: string | null,
    deliveredAt?: string | null,
    errorCode?: CommunicationErrorCode | null,
    nextRetryAt?: string | null,
    sendRetryCount?: number | null,
    sender?: string | null,
    sentAt?: string | null,
    externalId?: string | null,
    externalStatus?: string | null,
    signatureDocumentId?: string | null,
    signatureDocument?:  {
      __typename: "SignatureDocument",
      id: string,
      additionalMessage?: string | null,
      automaticRemindersDisabled?: boolean | null,
      communicationBody?: string | null,
      createdAt?: string | null,
      expirationDate?: string | null,
      fileIds?: Array< string > | null,
      foreignKey: string,
      foreignTableName: string,
      sentAt?: string | null,
      signatureMethods: Array< SignatureType >,
      signatureResults:  Array< {
        __typename: "SignatureDocumentResult",
        openedDate?: string | null,
        signedDate?: string | null,
        signed?: boolean | null,
        signatureLink?: string | null,
        rejectReason?: string | null,
        lastSignInviteSentDate?: string | null,
        reminderDates?: Array< string > | null,
        trackingProvider?: TrackingProvider | null,
        trackingCode?: string | null,
        contactId: string,
      } >,
      status: SignatureDocumentStatus,
      externalStatus?: string | null,
      type: SignatureDocumentType,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    snoozedDate?: string | null,
    statement?:  {
      __typename: "Statement",
      id: string,
      amounts?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      chargeStatements?:  {
        __typename: "ModelChargeStatementConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      closingStatement: boolean,
      periodFrom: string,
      periodTo: string,
      attachSupportingDocuments?: boolean | null,
      selectedPocketKeys?: Array< string > | null,
      source: StatementSource,
      status: StatementStatus,
      sentDate?: string | null,
      leaseId?: string | null,
      lease?:  {
        __typename: "Lease",
        id: string,
        balance?: number | null,
        canBeExtended?: boolean | null,
        communicationSettingsProfileId: string,
        createdAt?: string | null,
        endDate: string,
        includeRealEstateInLeaseContract?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        invoiceSenderId: string,
        inventoryOfFixturesExpert?: string | null,
        inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
        inventoryOfFixturesType?: InventoryOfFixturesType | null,
        ipiNumber?: string | null,
        language: Language,
        lastDraftInvoiceDate?: string | null,
        lastIndexationProcessDate?: string | null,
        lastInvoiceDate?: string | null,
        legalCompetentAuthority?: string | null,
        name: string,
        notes?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        purchaseOrderNumber?: string | null,
        realEstateAgency?: string | null,
        realEstateTax?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        signatureDate?: string | null,
        startDate: string,
        nextIndexationMonth?: string | null,
        nextIndexation?: boolean | null,
        status: LeaseStatus,
        technicCommunicationSettingsProfileId: string,
        totalInitialRentalPrice: number,
        totalRentalPrice: number,
        type: LeaseType,
        subletting?: boolean | null,
        vatRateRentId?: string | null,
        bankAccountId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      agencyRateStatements?:  {
        __typename: "ModelAgencyRateStatementConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      ownerId?: string | null,
      owner?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      repaymentStatements?:  {
        __typename: "ModelRepaymentStatementConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      types?: Array< StatementType > | null,
      viewType: StatementViewType,
      unitIds?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    statementId?: string | null,
    status: CommunicationStatus,
    subject: string,
    toSend: boolean,
    hideLogo?: boolean | null,
    type: CommunicationType,
    _ttl?: number | null,
    unit?:  {
      __typename: "Unit",
      id: string,
      acquisitionAdditionalCostsValue?: number | null,
      acquisitionAdvertisedValue?: number | null,
      acquisitionValue?: number | null,
      advertisedMonthlyCharges?: number | null,
      advertisedRentalPrice?: number | null,
      cadastralIncome?: number | null,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      floor?: number | null,
      jointOwnershipId?: string | null,
      managementDate: string,
      name: string,
      notes?: string | null,
      predictedPrice?: string | null,
      propertyTax?: number | null,
      publishAddress?: boolean | null,
      surface?: number | null,
      type: UnitType,
      buildingId: string,
      building?:  {
        __typename: "Building",
        id: string,
        name: string,
        addressId?: string | null,
        acquisitionValue?: number | null,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        amountOfFacades?: number | null,
        amountOfFloors?: number | null,
        amountOfHousings?: number | null,
        buildingState?: BuildingState | null,
        cadastralIncome?: number | null,
        constructionYear?: string | null,
        janitor?: boolean | null,
        jointOwnershipId?: string | null,
        notes?: string | null,
        propertyTax?: number | null,
        residenceName?: string | null,
        buildingSiteId?: string | null,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      owners?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leases?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      events?:  {
        __typename: "ModelUnitEventConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      unitAdvertisementId?: string | null,
      unitInventories?:  {
        __typename: "ModelUnitInventoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    unitId?: string | null,
    readId: string,
    readers?: Array< string > | null,
    clientId: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateCommunicationSubscriptionVariables = {
  filter?: ModelSubscriptionCommunicationFilterInput | null,
};

export type OnUpdateCommunicationSubscription = {
  onUpdateCommunication?:  {
    __typename: "Communication",
    id: string,
    addressId?: string | null,
    address?:  {
      __typename: "Address",
      id: string,
      status?: AddressStatus | null,
      street: string,
      number?: string | null,
      box?: string | null,
      postalCode?: string | null,
      city?: string | null,
      region?: string | null,
      country?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      latitude?: number | null,
      longitude?: number | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    blockedRecipients?:  Array< {
      __typename: "CommunicationBlockedRecipient",
      recipient: string,
      bounceType: BounceType,
    } > | null,
    body: string,
    buildingId?: string | null,
    channel: CommunicationChannel,
    communicationTemplateId?: string | null,
    concernedContactIds?: Array< string > | null,
    contactId?: string | null,
    contactIds?: Array< string > | null,
    createdAt?: string | null,
    draftProperties?:  {
      __typename: "CommunicationDraftProperties",
      allowRecipientsToSeeEachOther?: boolean | null,
      bcc?: Array< string > | null,
      buildingIds?: Array< string > | null,
      cc?: Array< string > | null,
      contactIds?: Array< string > | null,
      contactTypes?: Array< ContactType > | null,
      entityType: string,
      leaseIds?: Array< string > | null,
      sendInBcc?: boolean | null,
      unitIds?: Array< string > | null,
      unitTypeFilter?: string | null,
    } | null,
    expirationDate?: string | null,
    files?:  {
      __typename: "ModelFileConnection",
      items:  Array< {
        __typename: "File",
        id: string,
        bucket: string,
        createdAt?: string | null,
        categoryId: string,
        foreignKey: string,
        foreignTableName: string,
        key: string,
        mimeType?: string | null,
        region: string,
        size?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        _ttl?: number | null,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    invoice?:  {
      __typename: "Invoice",
      id: string,
      amount: number,
      bankAccountId: string,
      bankAccount?:  {
        __typename: "BankAccount",
        id: string,
        contactId: string,
        number: string,
        bicNumber?: string | null,
        bankName?: string | null,
        contactIds?: Array< string > | null,
        buildingIds?: Array< string > | null,
        holderName?: string | null,
        label?: string | null,
        disabled?: boolean | null,
        integrations?: Array< IntegrationName > | null,
        matchingRule?: BankAccountMatchingRule | null,
        balance?: number | null,
        balanceDate?: string | null,
        type: BankAccountType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      communicationId?: string | null,
      communication?:  {
        __typename: "Communication",
        id: string,
        addressId?: string | null,
        body: string,
        buildingId?: string | null,
        channel: CommunicationChannel,
        communicationTemplateId?: string | null,
        concernedContactIds?: Array< string > | null,
        contactId?: string | null,
        contactIds?: Array< string > | null,
        createdAt?: string | null,
        expirationDate?: string | null,
        invoiceId?: string | null,
        leaseId?: string | null,
        leasePriceHistoryId?: string | null,
        letterTrackingCode?: string | null,
        letterTrackingProvider?: TrackingProvider | null,
        linkedCommunicationsIds?: Array< string > | null,
        supportingDocumentFileIds?: Array< string > | null,
        recipient?: string | null,
        recipientContactIdsInBcc?: Array< string > | null,
        recipientContactIdsInCc?: Array< string > | null,
        recipientInBcc?: string | null,
        recipientInCc?: string | null,
        scheduledAt?: string | null,
        deliveredAt?: string | null,
        errorCode?: CommunicationErrorCode | null,
        nextRetryAt?: string | null,
        sendRetryCount?: number | null,
        sender?: string | null,
        sentAt?: string | null,
        externalId?: string | null,
        externalStatus?: string | null,
        signatureDocumentId?: string | null,
        snoozedDate?: string | null,
        statementId?: string | null,
        status: CommunicationStatus,
        subject: string,
        toSend: boolean,
        hideLogo?: boolean | null,
        type: CommunicationType,
        _ttl?: number | null,
        unitId?: string | null,
        readId: string,
        readers?: Array< string > | null,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      createdAt: string,
      creditNote?: boolean | null,
      creditNoteLabel?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      dueDate?: string | null,
      invoiceDate: string,
      invoiceNumber?: string | null,
      ownerId?: string | null,
      owner?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      invoiceSenderId: string,
      invoiceSender?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      leaseId?: string | null,
      lease?:  {
        __typename: "Lease",
        id: string,
        balance?: number | null,
        canBeExtended?: boolean | null,
        communicationSettingsProfileId: string,
        createdAt?: string | null,
        endDate: string,
        includeRealEstateInLeaseContract?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        invoiceSenderId: string,
        inventoryOfFixturesExpert?: string | null,
        inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
        inventoryOfFixturesType?: InventoryOfFixturesType | null,
        ipiNumber?: string | null,
        language: Language,
        lastDraftInvoiceDate?: string | null,
        lastIndexationProcessDate?: string | null,
        lastInvoiceDate?: string | null,
        legalCompetentAuthority?: string | null,
        name: string,
        notes?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        purchaseOrderNumber?: string | null,
        realEstateAgency?: string | null,
        realEstateTax?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        signatureDate?: string | null,
        startDate: string,
        nextIndexationMonth?: string | null,
        nextIndexation?: boolean | null,
        status: LeaseStatus,
        technicCommunicationSettingsProfileId: string,
        totalInitialRentalPrice: number,
        totalRentalPrice: number,
        type: LeaseType,
        subletting?: boolean | null,
        vatRateRentId?: string | null,
        bankAccountId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      paid: boolean,
      integrations?:  {
        __typename: "InvoiceIntegrations",
      } | null,
      postedDate?: string | null,
      purchaseOrderNumber?: string | null,
      receiptNumber?: string | null,
      reminderDates?: Array< string > | null,
      note?: string | null,
      remittanceInformation?: string | null,
      statementId?: string | null,
      statement?:  {
        __typename: "Statement",
        id: string,
        closingStatement: boolean,
        periodFrom: string,
        periodTo: string,
        attachSupportingDocuments?: boolean | null,
        selectedPocketKeys?: Array< string > | null,
        source: StatementSource,
        status: StatementStatus,
        sentDate?: string | null,
        leaseId?: string | null,
        ownerId?: string | null,
        types?: Array< StatementType > | null,
        viewType: StatementViewType,
        unitIds?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      status: InvoiceStatus,
      type: InvoiceType,
      unitId?: string | null,
      unit?:  {
        __typename: "Unit",
        id: string,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        acquisitionValue?: number | null,
        advertisedMonthlyCharges?: number | null,
        advertisedRentalPrice?: number | null,
        cadastralIncome?: number | null,
        createdAt?: string | null,
        floor?: number | null,
        jointOwnershipId?: string | null,
        managementDate: string,
        name: string,
        notes?: string | null,
        predictedPrice?: string | null,
        propertyTax?: number | null,
        publishAddress?: boolean | null,
        surface?: number | null,
        type: UnitType,
        buildingId: string,
        unitAdvertisementId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      reversedInvoiceId?: string | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    invoiceId?: string | null,
    lease?:  {
      __typename: "Lease",
      id: string,
      advancedChargesInvoices?:  {
        __typename: "LeaseAdvancedChargesInvoice",
        communicationSettingsProfileId: string,
        invoiceSenderId: string,
        lastDraftInvoiceDate?: string | null,
        lastInvoiceDate?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        bankAccountId?: string | null,
      } | null,
      balance?: number | null,
      canBeExtended?: boolean | null,
      communicationSettingsProfileId: string,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      endDate: string,
      includeRealEstateInLeaseContract?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      invoiceSenderId: string,
      invoiceSender?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      inventoryOfFixturesExpert?: string | null,
      inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
      inventoryOfFixturesType?: InventoryOfFixturesType | null,
      ipiNumber?: string | null,
      language: Language,
      lastDraftInvoiceDate?: string | null,
      lastIndexationProcessDate?: string | null,
      lastInvoiceDate?: string | null,
      legalCompetentAuthority?: string | null,
      name: string,
      notes?: string | null,
      paymentFrequency: LeasePaymentFrequency,
      paymentInvoicePeriod: LeasePaymentInvoicePeriod,
      paymentInvoicePeriodCustomDay?: number | null,
      paymentOption?:  {
        __typename: "LeasePaymentOption",
        customerId?: string | null,
        enabled: boolean,
        mandateActivatedAt?: string | null,
        mandateStatus?: PaymentProviderMandateStatus | null,
        paymentMethodId?: string | null,
        qrType?: LeaseQrType | null,
      } | null,
      purchaseOrderNumber?: string | null,
      realEstateAgency?: string | null,
      realEstateTax?: number | null,
      remittanceInformation?: string | null,
      remittanceInformationType?: LeaseRemittanceType | null,
      rentalGuaranty?:  {
        __typename: "LeaseRentalGuaranty",
        amount: number,
        blockedAmount?: number | null,
        releasedAmount?: number | null,
        type: LeaseRentalGuarantyType,
        financialInstitution?: string | null,
      } | null,
      signatureDate?: string | null,
      startDate: string,
      nextIndexationMonth?: string | null,
      nextIndexation?: boolean | null,
      status: LeaseStatus,
      technicCommunicationSettingsProfileId: string,
      totalInitialRentalPrice: number,
      totalRentalPrice: number,
      type: LeaseType,
      subletting?: boolean | null,
      vatRateRentId?: string | null,
      vatRateRent?:  {
        __typename: "VatRate",
        id: string,
        country: string,
        label: string,
        value?: number | null,
        ownerId?: string | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      additionalClauses?:  {
        __typename: "ModelLeaseAdditionalClauseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      bankAccountId?: string | null,
      bankAccount?:  {
        __typename: "BankAccount",
        id: string,
        contactId: string,
        number: string,
        bicNumber?: string | null,
        bankName?: string | null,
        contactIds?: Array< string > | null,
        buildingIds?: Array< string > | null,
        holderName?: string | null,
        label?: string | null,
        disabled?: boolean | null,
        integrations?: Array< IntegrationName > | null,
        matchingRule?: BankAccountMatchingRule | null,
        balance?: number | null,
        balanceDate?: string | null,
        type: BankAccountType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contacts?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      files?:  {
        __typename: "ModelFileConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leaseActionHistories?:  {
        __typename: "ModelLeaseActionHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leasePriceHistories?:  {
        __typename: "ModelLeasePriceHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      signatureDocuments?:  {
        __typename: "ModelSignatureDocumentConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      variousOperations?:  {
        __typename: "ModelLeaseVariousOperationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    leaseId?: string | null,
    leasePriceHistoryId?: string | null,
    leasePriceHistory?:  {
      __typename: "LeasePriceHistory",
      id: string,
      previousTotalRentalPrice: number,
      totalRentalPrice: number,
      optimalTotalRentalPrice?: number | null,
      optimalTotalMonthlyCharges?: number | null,
      applicationDate: string,
      status: LeaseAmountUpdateStatus,
      comment?: string | null,
      amountDetails:  Array< {
        __typename: "LeasePriceHistoryDetail",
        unitId: string,
        indexationBaseIndex?: number | null,
        indexationNewIndex?: number | null,
        previousRentalPrice: number,
        newRentalPrice: number,
        rentalStatus: LeasePriceHistoryStatus,
        monthlyChargesStatus: LeasePriceHistoryStatus,
        optimalNewRentalPrice?: number | null,
        optimalNewMonthlyChargesPrice?: number | null,
        epb?: string | null,
        epbIssueDate?: string | null,
        oldestIndexForCorrectionFactorCalculation?: number | null,
        newestIndexForCorrectionFactorCalculation?: number | null,
        rentIndexedPriceAfterNewEpbReduction?: number | null,
        chargesIndexedPriceAfterNewEpbReduction?: number | null,
        correctionFactor?: number | null,
        reductionPercentage?: number | null,
        rentDifference?: number | null,
        rentReduction?: number | null,
        indexedRentAfterReduction?: number | null,
        chargesDifference?: number | null,
        chargesReduction?: number | null,
        indexedChargesAfterReduction?: number | null,
        previousYearIndexationNewIndex?: number | null,
        previousYearIndexedRent?: number | null,
        previousYearIndexedCharges?: number | null,
      } >,
      type: LeasePriceHistoryType,
      communicationId?: string | null,
      communication?:  {
        __typename: "Communication",
        id: string,
        addressId?: string | null,
        body: string,
        buildingId?: string | null,
        channel: CommunicationChannel,
        communicationTemplateId?: string | null,
        concernedContactIds?: Array< string > | null,
        contactId?: string | null,
        contactIds?: Array< string > | null,
        createdAt?: string | null,
        expirationDate?: string | null,
        invoiceId?: string | null,
        leaseId?: string | null,
        leasePriceHistoryId?: string | null,
        letterTrackingCode?: string | null,
        letterTrackingProvider?: TrackingProvider | null,
        linkedCommunicationsIds?: Array< string > | null,
        supportingDocumentFileIds?: Array< string > | null,
        recipient?: string | null,
        recipientContactIdsInBcc?: Array< string > | null,
        recipientContactIdsInCc?: Array< string > | null,
        recipientInBcc?: string | null,
        recipientInCc?: string | null,
        scheduledAt?: string | null,
        deliveredAt?: string | null,
        errorCode?: CommunicationErrorCode | null,
        nextRetryAt?: string | null,
        sendRetryCount?: number | null,
        sender?: string | null,
        sentAt?: string | null,
        externalId?: string | null,
        externalStatus?: string | null,
        signatureDocumentId?: string | null,
        snoozedDate?: string | null,
        statementId?: string | null,
        status: CommunicationStatus,
        subject: string,
        toSend: boolean,
        hideLogo?: boolean | null,
        type: CommunicationType,
        _ttl?: number | null,
        unitId?: string | null,
        readId: string,
        readers?: Array< string > | null,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      leaseId: string,
      lease?:  {
        __typename: "Lease",
        id: string,
        balance?: number | null,
        canBeExtended?: boolean | null,
        communicationSettingsProfileId: string,
        createdAt?: string | null,
        endDate: string,
        includeRealEstateInLeaseContract?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        invoiceSenderId: string,
        inventoryOfFixturesExpert?: string | null,
        inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
        inventoryOfFixturesType?: InventoryOfFixturesType | null,
        ipiNumber?: string | null,
        language: Language,
        lastDraftInvoiceDate?: string | null,
        lastIndexationProcessDate?: string | null,
        lastInvoiceDate?: string | null,
        legalCompetentAuthority?: string | null,
        name: string,
        notes?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        purchaseOrderNumber?: string | null,
        realEstateAgency?: string | null,
        realEstateTax?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        signatureDate?: string | null,
        startDate: string,
        nextIndexationMonth?: string | null,
        nextIndexation?: boolean | null,
        status: LeaseStatus,
        technicCommunicationSettingsProfileId: string,
        totalInitialRentalPrice: number,
        totalRentalPrice: number,
        type: LeaseType,
        subletting?: boolean | null,
        vatRateRentId?: string | null,
        bankAccountId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      createdAt?: string | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    letterTrackingCode?: string | null,
    letterTrackingProvider?: TrackingProvider | null,
    linkedCommunicationsIds?: Array< string > | null,
    supportingDocumentFileIds?: Array< string > | null,
    recipient?: string | null,
    recipientContactIdsInBcc?: Array< string > | null,
    recipientContactIdsInCc?: Array< string > | null,
    recipientInBcc?: string | null,
    recipientInCc?: string | null,
    scheduledAt?: string | null,
    deliveredAt?: string | null,
    errorCode?: CommunicationErrorCode | null,
    nextRetryAt?: string | null,
    sendRetryCount?: number | null,
    sender?: string | null,
    sentAt?: string | null,
    externalId?: string | null,
    externalStatus?: string | null,
    signatureDocumentId?: string | null,
    signatureDocument?:  {
      __typename: "SignatureDocument",
      id: string,
      additionalMessage?: string | null,
      automaticRemindersDisabled?: boolean | null,
      communicationBody?: string | null,
      createdAt?: string | null,
      expirationDate?: string | null,
      fileIds?: Array< string > | null,
      foreignKey: string,
      foreignTableName: string,
      sentAt?: string | null,
      signatureMethods: Array< SignatureType >,
      signatureResults:  Array< {
        __typename: "SignatureDocumentResult",
        openedDate?: string | null,
        signedDate?: string | null,
        signed?: boolean | null,
        signatureLink?: string | null,
        rejectReason?: string | null,
        lastSignInviteSentDate?: string | null,
        reminderDates?: Array< string > | null,
        trackingProvider?: TrackingProvider | null,
        trackingCode?: string | null,
        contactId: string,
      } >,
      status: SignatureDocumentStatus,
      externalStatus?: string | null,
      type: SignatureDocumentType,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    snoozedDate?: string | null,
    statement?:  {
      __typename: "Statement",
      id: string,
      amounts?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      chargeStatements?:  {
        __typename: "ModelChargeStatementConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      closingStatement: boolean,
      periodFrom: string,
      periodTo: string,
      attachSupportingDocuments?: boolean | null,
      selectedPocketKeys?: Array< string > | null,
      source: StatementSource,
      status: StatementStatus,
      sentDate?: string | null,
      leaseId?: string | null,
      lease?:  {
        __typename: "Lease",
        id: string,
        balance?: number | null,
        canBeExtended?: boolean | null,
        communicationSettingsProfileId: string,
        createdAt?: string | null,
        endDate: string,
        includeRealEstateInLeaseContract?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        invoiceSenderId: string,
        inventoryOfFixturesExpert?: string | null,
        inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
        inventoryOfFixturesType?: InventoryOfFixturesType | null,
        ipiNumber?: string | null,
        language: Language,
        lastDraftInvoiceDate?: string | null,
        lastIndexationProcessDate?: string | null,
        lastInvoiceDate?: string | null,
        legalCompetentAuthority?: string | null,
        name: string,
        notes?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        purchaseOrderNumber?: string | null,
        realEstateAgency?: string | null,
        realEstateTax?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        signatureDate?: string | null,
        startDate: string,
        nextIndexationMonth?: string | null,
        nextIndexation?: boolean | null,
        status: LeaseStatus,
        technicCommunicationSettingsProfileId: string,
        totalInitialRentalPrice: number,
        totalRentalPrice: number,
        type: LeaseType,
        subletting?: boolean | null,
        vatRateRentId?: string | null,
        bankAccountId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      agencyRateStatements?:  {
        __typename: "ModelAgencyRateStatementConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      ownerId?: string | null,
      owner?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      repaymentStatements?:  {
        __typename: "ModelRepaymentStatementConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      types?: Array< StatementType > | null,
      viewType: StatementViewType,
      unitIds?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    statementId?: string | null,
    status: CommunicationStatus,
    subject: string,
    toSend: boolean,
    hideLogo?: boolean | null,
    type: CommunicationType,
    _ttl?: number | null,
    unit?:  {
      __typename: "Unit",
      id: string,
      acquisitionAdditionalCostsValue?: number | null,
      acquisitionAdvertisedValue?: number | null,
      acquisitionValue?: number | null,
      advertisedMonthlyCharges?: number | null,
      advertisedRentalPrice?: number | null,
      cadastralIncome?: number | null,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      floor?: number | null,
      jointOwnershipId?: string | null,
      managementDate: string,
      name: string,
      notes?: string | null,
      predictedPrice?: string | null,
      propertyTax?: number | null,
      publishAddress?: boolean | null,
      surface?: number | null,
      type: UnitType,
      buildingId: string,
      building?:  {
        __typename: "Building",
        id: string,
        name: string,
        addressId?: string | null,
        acquisitionValue?: number | null,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        amountOfFacades?: number | null,
        amountOfFloors?: number | null,
        amountOfHousings?: number | null,
        buildingState?: BuildingState | null,
        cadastralIncome?: number | null,
        constructionYear?: string | null,
        janitor?: boolean | null,
        jointOwnershipId?: string | null,
        notes?: string | null,
        propertyTax?: number | null,
        residenceName?: string | null,
        buildingSiteId?: string | null,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      owners?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leases?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      events?:  {
        __typename: "ModelUnitEventConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      unitAdvertisementId?: string | null,
      unitInventories?:  {
        __typename: "ModelUnitInventoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    unitId?: string | null,
    readId: string,
    readers?: Array< string > | null,
    clientId: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteCommunicationSubscriptionVariables = {
  filter?: ModelSubscriptionCommunicationFilterInput | null,
};

export type OnDeleteCommunicationSubscription = {
  onDeleteCommunication?:  {
    __typename: "Communication",
    id: string,
    addressId?: string | null,
    address?:  {
      __typename: "Address",
      id: string,
      status?: AddressStatus | null,
      street: string,
      number?: string | null,
      box?: string | null,
      postalCode?: string | null,
      city?: string | null,
      region?: string | null,
      country?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      latitude?: number | null,
      longitude?: number | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    blockedRecipients?:  Array< {
      __typename: "CommunicationBlockedRecipient",
      recipient: string,
      bounceType: BounceType,
    } > | null,
    body: string,
    buildingId?: string | null,
    channel: CommunicationChannel,
    communicationTemplateId?: string | null,
    concernedContactIds?: Array< string > | null,
    contactId?: string | null,
    contactIds?: Array< string > | null,
    createdAt?: string | null,
    draftProperties?:  {
      __typename: "CommunicationDraftProperties",
      allowRecipientsToSeeEachOther?: boolean | null,
      bcc?: Array< string > | null,
      buildingIds?: Array< string > | null,
      cc?: Array< string > | null,
      contactIds?: Array< string > | null,
      contactTypes?: Array< ContactType > | null,
      entityType: string,
      leaseIds?: Array< string > | null,
      sendInBcc?: boolean | null,
      unitIds?: Array< string > | null,
      unitTypeFilter?: string | null,
    } | null,
    expirationDate?: string | null,
    files?:  {
      __typename: "ModelFileConnection",
      items:  Array< {
        __typename: "File",
        id: string,
        bucket: string,
        createdAt?: string | null,
        categoryId: string,
        foreignKey: string,
        foreignTableName: string,
        key: string,
        mimeType?: string | null,
        region: string,
        size?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        _ttl?: number | null,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    invoice?:  {
      __typename: "Invoice",
      id: string,
      amount: number,
      bankAccountId: string,
      bankAccount?:  {
        __typename: "BankAccount",
        id: string,
        contactId: string,
        number: string,
        bicNumber?: string | null,
        bankName?: string | null,
        contactIds?: Array< string > | null,
        buildingIds?: Array< string > | null,
        holderName?: string | null,
        label?: string | null,
        disabled?: boolean | null,
        integrations?: Array< IntegrationName > | null,
        matchingRule?: BankAccountMatchingRule | null,
        balance?: number | null,
        balanceDate?: string | null,
        type: BankAccountType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      communicationId?: string | null,
      communication?:  {
        __typename: "Communication",
        id: string,
        addressId?: string | null,
        body: string,
        buildingId?: string | null,
        channel: CommunicationChannel,
        communicationTemplateId?: string | null,
        concernedContactIds?: Array< string > | null,
        contactId?: string | null,
        contactIds?: Array< string > | null,
        createdAt?: string | null,
        expirationDate?: string | null,
        invoiceId?: string | null,
        leaseId?: string | null,
        leasePriceHistoryId?: string | null,
        letterTrackingCode?: string | null,
        letterTrackingProvider?: TrackingProvider | null,
        linkedCommunicationsIds?: Array< string > | null,
        supportingDocumentFileIds?: Array< string > | null,
        recipient?: string | null,
        recipientContactIdsInBcc?: Array< string > | null,
        recipientContactIdsInCc?: Array< string > | null,
        recipientInBcc?: string | null,
        recipientInCc?: string | null,
        scheduledAt?: string | null,
        deliveredAt?: string | null,
        errorCode?: CommunicationErrorCode | null,
        nextRetryAt?: string | null,
        sendRetryCount?: number | null,
        sender?: string | null,
        sentAt?: string | null,
        externalId?: string | null,
        externalStatus?: string | null,
        signatureDocumentId?: string | null,
        snoozedDate?: string | null,
        statementId?: string | null,
        status: CommunicationStatus,
        subject: string,
        toSend: boolean,
        hideLogo?: boolean | null,
        type: CommunicationType,
        _ttl?: number | null,
        unitId?: string | null,
        readId: string,
        readers?: Array< string > | null,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      createdAt: string,
      creditNote?: boolean | null,
      creditNoteLabel?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      dueDate?: string | null,
      invoiceDate: string,
      invoiceNumber?: string | null,
      ownerId?: string | null,
      owner?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      invoiceSenderId: string,
      invoiceSender?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      leaseId?: string | null,
      lease?:  {
        __typename: "Lease",
        id: string,
        balance?: number | null,
        canBeExtended?: boolean | null,
        communicationSettingsProfileId: string,
        createdAt?: string | null,
        endDate: string,
        includeRealEstateInLeaseContract?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        invoiceSenderId: string,
        inventoryOfFixturesExpert?: string | null,
        inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
        inventoryOfFixturesType?: InventoryOfFixturesType | null,
        ipiNumber?: string | null,
        language: Language,
        lastDraftInvoiceDate?: string | null,
        lastIndexationProcessDate?: string | null,
        lastInvoiceDate?: string | null,
        legalCompetentAuthority?: string | null,
        name: string,
        notes?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        purchaseOrderNumber?: string | null,
        realEstateAgency?: string | null,
        realEstateTax?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        signatureDate?: string | null,
        startDate: string,
        nextIndexationMonth?: string | null,
        nextIndexation?: boolean | null,
        status: LeaseStatus,
        technicCommunicationSettingsProfileId: string,
        totalInitialRentalPrice: number,
        totalRentalPrice: number,
        type: LeaseType,
        subletting?: boolean | null,
        vatRateRentId?: string | null,
        bankAccountId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      paid: boolean,
      integrations?:  {
        __typename: "InvoiceIntegrations",
      } | null,
      postedDate?: string | null,
      purchaseOrderNumber?: string | null,
      receiptNumber?: string | null,
      reminderDates?: Array< string > | null,
      note?: string | null,
      remittanceInformation?: string | null,
      statementId?: string | null,
      statement?:  {
        __typename: "Statement",
        id: string,
        closingStatement: boolean,
        periodFrom: string,
        periodTo: string,
        attachSupportingDocuments?: boolean | null,
        selectedPocketKeys?: Array< string > | null,
        source: StatementSource,
        status: StatementStatus,
        sentDate?: string | null,
        leaseId?: string | null,
        ownerId?: string | null,
        types?: Array< StatementType > | null,
        viewType: StatementViewType,
        unitIds?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      status: InvoiceStatus,
      type: InvoiceType,
      unitId?: string | null,
      unit?:  {
        __typename: "Unit",
        id: string,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        acquisitionValue?: number | null,
        advertisedMonthlyCharges?: number | null,
        advertisedRentalPrice?: number | null,
        cadastralIncome?: number | null,
        createdAt?: string | null,
        floor?: number | null,
        jointOwnershipId?: string | null,
        managementDate: string,
        name: string,
        notes?: string | null,
        predictedPrice?: string | null,
        propertyTax?: number | null,
        publishAddress?: boolean | null,
        surface?: number | null,
        type: UnitType,
        buildingId: string,
        unitAdvertisementId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      reversedInvoiceId?: string | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    invoiceId?: string | null,
    lease?:  {
      __typename: "Lease",
      id: string,
      advancedChargesInvoices?:  {
        __typename: "LeaseAdvancedChargesInvoice",
        communicationSettingsProfileId: string,
        invoiceSenderId: string,
        lastDraftInvoiceDate?: string | null,
        lastInvoiceDate?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        bankAccountId?: string | null,
      } | null,
      balance?: number | null,
      canBeExtended?: boolean | null,
      communicationSettingsProfileId: string,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      endDate: string,
      includeRealEstateInLeaseContract?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      invoiceSenderId: string,
      invoiceSender?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      inventoryOfFixturesExpert?: string | null,
      inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
      inventoryOfFixturesType?: InventoryOfFixturesType | null,
      ipiNumber?: string | null,
      language: Language,
      lastDraftInvoiceDate?: string | null,
      lastIndexationProcessDate?: string | null,
      lastInvoiceDate?: string | null,
      legalCompetentAuthority?: string | null,
      name: string,
      notes?: string | null,
      paymentFrequency: LeasePaymentFrequency,
      paymentInvoicePeriod: LeasePaymentInvoicePeriod,
      paymentInvoicePeriodCustomDay?: number | null,
      paymentOption?:  {
        __typename: "LeasePaymentOption",
        customerId?: string | null,
        enabled: boolean,
        mandateActivatedAt?: string | null,
        mandateStatus?: PaymentProviderMandateStatus | null,
        paymentMethodId?: string | null,
        qrType?: LeaseQrType | null,
      } | null,
      purchaseOrderNumber?: string | null,
      realEstateAgency?: string | null,
      realEstateTax?: number | null,
      remittanceInformation?: string | null,
      remittanceInformationType?: LeaseRemittanceType | null,
      rentalGuaranty?:  {
        __typename: "LeaseRentalGuaranty",
        amount: number,
        blockedAmount?: number | null,
        releasedAmount?: number | null,
        type: LeaseRentalGuarantyType,
        financialInstitution?: string | null,
      } | null,
      signatureDate?: string | null,
      startDate: string,
      nextIndexationMonth?: string | null,
      nextIndexation?: boolean | null,
      status: LeaseStatus,
      technicCommunicationSettingsProfileId: string,
      totalInitialRentalPrice: number,
      totalRentalPrice: number,
      type: LeaseType,
      subletting?: boolean | null,
      vatRateRentId?: string | null,
      vatRateRent?:  {
        __typename: "VatRate",
        id: string,
        country: string,
        label: string,
        value?: number | null,
        ownerId?: string | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      additionalClauses?:  {
        __typename: "ModelLeaseAdditionalClauseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      bankAccountId?: string | null,
      bankAccount?:  {
        __typename: "BankAccount",
        id: string,
        contactId: string,
        number: string,
        bicNumber?: string | null,
        bankName?: string | null,
        contactIds?: Array< string > | null,
        buildingIds?: Array< string > | null,
        holderName?: string | null,
        label?: string | null,
        disabled?: boolean | null,
        integrations?: Array< IntegrationName > | null,
        matchingRule?: BankAccountMatchingRule | null,
        balance?: number | null,
        balanceDate?: string | null,
        type: BankAccountType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contacts?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      files?:  {
        __typename: "ModelFileConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leaseActionHistories?:  {
        __typename: "ModelLeaseActionHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leasePriceHistories?:  {
        __typename: "ModelLeasePriceHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      signatureDocuments?:  {
        __typename: "ModelSignatureDocumentConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      variousOperations?:  {
        __typename: "ModelLeaseVariousOperationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    leaseId?: string | null,
    leasePriceHistoryId?: string | null,
    leasePriceHistory?:  {
      __typename: "LeasePriceHistory",
      id: string,
      previousTotalRentalPrice: number,
      totalRentalPrice: number,
      optimalTotalRentalPrice?: number | null,
      optimalTotalMonthlyCharges?: number | null,
      applicationDate: string,
      status: LeaseAmountUpdateStatus,
      comment?: string | null,
      amountDetails:  Array< {
        __typename: "LeasePriceHistoryDetail",
        unitId: string,
        indexationBaseIndex?: number | null,
        indexationNewIndex?: number | null,
        previousRentalPrice: number,
        newRentalPrice: number,
        rentalStatus: LeasePriceHistoryStatus,
        monthlyChargesStatus: LeasePriceHistoryStatus,
        optimalNewRentalPrice?: number | null,
        optimalNewMonthlyChargesPrice?: number | null,
        epb?: string | null,
        epbIssueDate?: string | null,
        oldestIndexForCorrectionFactorCalculation?: number | null,
        newestIndexForCorrectionFactorCalculation?: number | null,
        rentIndexedPriceAfterNewEpbReduction?: number | null,
        chargesIndexedPriceAfterNewEpbReduction?: number | null,
        correctionFactor?: number | null,
        reductionPercentage?: number | null,
        rentDifference?: number | null,
        rentReduction?: number | null,
        indexedRentAfterReduction?: number | null,
        chargesDifference?: number | null,
        chargesReduction?: number | null,
        indexedChargesAfterReduction?: number | null,
        previousYearIndexationNewIndex?: number | null,
        previousYearIndexedRent?: number | null,
        previousYearIndexedCharges?: number | null,
      } >,
      type: LeasePriceHistoryType,
      communicationId?: string | null,
      communication?:  {
        __typename: "Communication",
        id: string,
        addressId?: string | null,
        body: string,
        buildingId?: string | null,
        channel: CommunicationChannel,
        communicationTemplateId?: string | null,
        concernedContactIds?: Array< string > | null,
        contactId?: string | null,
        contactIds?: Array< string > | null,
        createdAt?: string | null,
        expirationDate?: string | null,
        invoiceId?: string | null,
        leaseId?: string | null,
        leasePriceHistoryId?: string | null,
        letterTrackingCode?: string | null,
        letterTrackingProvider?: TrackingProvider | null,
        linkedCommunicationsIds?: Array< string > | null,
        supportingDocumentFileIds?: Array< string > | null,
        recipient?: string | null,
        recipientContactIdsInBcc?: Array< string > | null,
        recipientContactIdsInCc?: Array< string > | null,
        recipientInBcc?: string | null,
        recipientInCc?: string | null,
        scheduledAt?: string | null,
        deliveredAt?: string | null,
        errorCode?: CommunicationErrorCode | null,
        nextRetryAt?: string | null,
        sendRetryCount?: number | null,
        sender?: string | null,
        sentAt?: string | null,
        externalId?: string | null,
        externalStatus?: string | null,
        signatureDocumentId?: string | null,
        snoozedDate?: string | null,
        statementId?: string | null,
        status: CommunicationStatus,
        subject: string,
        toSend: boolean,
        hideLogo?: boolean | null,
        type: CommunicationType,
        _ttl?: number | null,
        unitId?: string | null,
        readId: string,
        readers?: Array< string > | null,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      leaseId: string,
      lease?:  {
        __typename: "Lease",
        id: string,
        balance?: number | null,
        canBeExtended?: boolean | null,
        communicationSettingsProfileId: string,
        createdAt?: string | null,
        endDate: string,
        includeRealEstateInLeaseContract?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        invoiceSenderId: string,
        inventoryOfFixturesExpert?: string | null,
        inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
        inventoryOfFixturesType?: InventoryOfFixturesType | null,
        ipiNumber?: string | null,
        language: Language,
        lastDraftInvoiceDate?: string | null,
        lastIndexationProcessDate?: string | null,
        lastInvoiceDate?: string | null,
        legalCompetentAuthority?: string | null,
        name: string,
        notes?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        purchaseOrderNumber?: string | null,
        realEstateAgency?: string | null,
        realEstateTax?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        signatureDate?: string | null,
        startDate: string,
        nextIndexationMonth?: string | null,
        nextIndexation?: boolean | null,
        status: LeaseStatus,
        technicCommunicationSettingsProfileId: string,
        totalInitialRentalPrice: number,
        totalRentalPrice: number,
        type: LeaseType,
        subletting?: boolean | null,
        vatRateRentId?: string | null,
        bankAccountId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      createdAt?: string | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    letterTrackingCode?: string | null,
    letterTrackingProvider?: TrackingProvider | null,
    linkedCommunicationsIds?: Array< string > | null,
    supportingDocumentFileIds?: Array< string > | null,
    recipient?: string | null,
    recipientContactIdsInBcc?: Array< string > | null,
    recipientContactIdsInCc?: Array< string > | null,
    recipientInBcc?: string | null,
    recipientInCc?: string | null,
    scheduledAt?: string | null,
    deliveredAt?: string | null,
    errorCode?: CommunicationErrorCode | null,
    nextRetryAt?: string | null,
    sendRetryCount?: number | null,
    sender?: string | null,
    sentAt?: string | null,
    externalId?: string | null,
    externalStatus?: string | null,
    signatureDocumentId?: string | null,
    signatureDocument?:  {
      __typename: "SignatureDocument",
      id: string,
      additionalMessage?: string | null,
      automaticRemindersDisabled?: boolean | null,
      communicationBody?: string | null,
      createdAt?: string | null,
      expirationDate?: string | null,
      fileIds?: Array< string > | null,
      foreignKey: string,
      foreignTableName: string,
      sentAt?: string | null,
      signatureMethods: Array< SignatureType >,
      signatureResults:  Array< {
        __typename: "SignatureDocumentResult",
        openedDate?: string | null,
        signedDate?: string | null,
        signed?: boolean | null,
        signatureLink?: string | null,
        rejectReason?: string | null,
        lastSignInviteSentDate?: string | null,
        reminderDates?: Array< string > | null,
        trackingProvider?: TrackingProvider | null,
        trackingCode?: string | null,
        contactId: string,
      } >,
      status: SignatureDocumentStatus,
      externalStatus?: string | null,
      type: SignatureDocumentType,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    snoozedDate?: string | null,
    statement?:  {
      __typename: "Statement",
      id: string,
      amounts?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      chargeStatements?:  {
        __typename: "ModelChargeStatementConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      closingStatement: boolean,
      periodFrom: string,
      periodTo: string,
      attachSupportingDocuments?: boolean | null,
      selectedPocketKeys?: Array< string > | null,
      source: StatementSource,
      status: StatementStatus,
      sentDate?: string | null,
      leaseId?: string | null,
      lease?:  {
        __typename: "Lease",
        id: string,
        balance?: number | null,
        canBeExtended?: boolean | null,
        communicationSettingsProfileId: string,
        createdAt?: string | null,
        endDate: string,
        includeRealEstateInLeaseContract?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        invoiceSenderId: string,
        inventoryOfFixturesExpert?: string | null,
        inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
        inventoryOfFixturesType?: InventoryOfFixturesType | null,
        ipiNumber?: string | null,
        language: Language,
        lastDraftInvoiceDate?: string | null,
        lastIndexationProcessDate?: string | null,
        lastInvoiceDate?: string | null,
        legalCompetentAuthority?: string | null,
        name: string,
        notes?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        purchaseOrderNumber?: string | null,
        realEstateAgency?: string | null,
        realEstateTax?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        signatureDate?: string | null,
        startDate: string,
        nextIndexationMonth?: string | null,
        nextIndexation?: boolean | null,
        status: LeaseStatus,
        technicCommunicationSettingsProfileId: string,
        totalInitialRentalPrice: number,
        totalRentalPrice: number,
        type: LeaseType,
        subletting?: boolean | null,
        vatRateRentId?: string | null,
        bankAccountId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      agencyRateStatements?:  {
        __typename: "ModelAgencyRateStatementConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      ownerId?: string | null,
      owner?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      repaymentStatements?:  {
        __typename: "ModelRepaymentStatementConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      types?: Array< StatementType > | null,
      viewType: StatementViewType,
      unitIds?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    statementId?: string | null,
    status: CommunicationStatus,
    subject: string,
    toSend: boolean,
    hideLogo?: boolean | null,
    type: CommunicationType,
    _ttl?: number | null,
    unit?:  {
      __typename: "Unit",
      id: string,
      acquisitionAdditionalCostsValue?: number | null,
      acquisitionAdvertisedValue?: number | null,
      acquisitionValue?: number | null,
      advertisedMonthlyCharges?: number | null,
      advertisedRentalPrice?: number | null,
      cadastralIncome?: number | null,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      floor?: number | null,
      jointOwnershipId?: string | null,
      managementDate: string,
      name: string,
      notes?: string | null,
      predictedPrice?: string | null,
      propertyTax?: number | null,
      publishAddress?: boolean | null,
      surface?: number | null,
      type: UnitType,
      buildingId: string,
      building?:  {
        __typename: "Building",
        id: string,
        name: string,
        addressId?: string | null,
        acquisitionValue?: number | null,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        amountOfFacades?: number | null,
        amountOfFloors?: number | null,
        amountOfHousings?: number | null,
        buildingState?: BuildingState | null,
        cadastralIncome?: number | null,
        constructionYear?: string | null,
        janitor?: boolean | null,
        jointOwnershipId?: string | null,
        notes?: string | null,
        propertyTax?: number | null,
        residenceName?: string | null,
        buildingSiteId?: string | null,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      owners?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leases?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      events?:  {
        __typename: "ModelUnitEventConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      unitAdvertisementId?: string | null,
      unitInventories?:  {
        __typename: "ModelUnitInventoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    unitId?: string | null,
    readId: string,
    readers?: Array< string > | null,
    clientId: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateCommunicationSettingsProfileSubscriptionVariables = {
  filter?: ModelSubscriptionCommunicationSettingsProfileFilterInput | null,
};

export type OnCreateCommunicationSettingsProfileSubscription = {
  onCreateCommunicationSettingsProfile?:  {
    __typename: "CommunicationSettingsProfile",
    id: string,
    communicationsSettings:  Array< {
      __typename: "CommunicationSettings",
      channels: Array< CommunicationChannel >,
      communicationType: CommunicationType,
      daysBeforeDueDate?: number | null,
      daysOverdue?: number | null,
      frequency?:  {
        __typename: "CommunicationFrequencySetting",
        dateFrom?: CommunicationFrequencySettingPeriodDateFrom | null,
        periodInterval: number,
        periodType: CommunicationFrequencySettingPeriodType,
      } | null,
      invoiceDaysAfterPeriodStart?: number | null,
      sendingRule: CommunicationSendingRule,
      recipients: Array< CommunicationSettingRecipient >,
      recipientsInBcc: Array< CommunicationSettingRecipient >,
      recipientsInCopy: Array< string >,
      displayOpenBalance?: boolean | null,
    } >,
    createdAt?: string | null,
    defaultName?: string | null,
    isDefaultSetting: boolean,
    referent: CommunicationSettingsProfileReferent,
    replacementId?: string | null,
    displayLogo: boolean,
    tenantStatementView: StatementViewType,
    readId: string,
    readers?: Array< string > | null,
    clientId: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateCommunicationSettingsProfileSubscriptionVariables = {
  filter?: ModelSubscriptionCommunicationSettingsProfileFilterInput | null,
};

export type OnUpdateCommunicationSettingsProfileSubscription = {
  onUpdateCommunicationSettingsProfile?:  {
    __typename: "CommunicationSettingsProfile",
    id: string,
    communicationsSettings:  Array< {
      __typename: "CommunicationSettings",
      channels: Array< CommunicationChannel >,
      communicationType: CommunicationType,
      daysBeforeDueDate?: number | null,
      daysOverdue?: number | null,
      frequency?:  {
        __typename: "CommunicationFrequencySetting",
        dateFrom?: CommunicationFrequencySettingPeriodDateFrom | null,
        periodInterval: number,
        periodType: CommunicationFrequencySettingPeriodType,
      } | null,
      invoiceDaysAfterPeriodStart?: number | null,
      sendingRule: CommunicationSendingRule,
      recipients: Array< CommunicationSettingRecipient >,
      recipientsInBcc: Array< CommunicationSettingRecipient >,
      recipientsInCopy: Array< string >,
      displayOpenBalance?: boolean | null,
    } >,
    createdAt?: string | null,
    defaultName?: string | null,
    isDefaultSetting: boolean,
    referent: CommunicationSettingsProfileReferent,
    replacementId?: string | null,
    displayLogo: boolean,
    tenantStatementView: StatementViewType,
    readId: string,
    readers?: Array< string > | null,
    clientId: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteCommunicationSettingsProfileSubscriptionVariables = {
  filter?: ModelSubscriptionCommunicationSettingsProfileFilterInput | null,
};

export type OnDeleteCommunicationSettingsProfileSubscription = {
  onDeleteCommunicationSettingsProfile?:  {
    __typename: "CommunicationSettingsProfile",
    id: string,
    communicationsSettings:  Array< {
      __typename: "CommunicationSettings",
      channels: Array< CommunicationChannel >,
      communicationType: CommunicationType,
      daysBeforeDueDate?: number | null,
      daysOverdue?: number | null,
      frequency?:  {
        __typename: "CommunicationFrequencySetting",
        dateFrom?: CommunicationFrequencySettingPeriodDateFrom | null,
        periodInterval: number,
        periodType: CommunicationFrequencySettingPeriodType,
      } | null,
      invoiceDaysAfterPeriodStart?: number | null,
      sendingRule: CommunicationSendingRule,
      recipients: Array< CommunicationSettingRecipient >,
      recipientsInBcc: Array< CommunicationSettingRecipient >,
      recipientsInCopy: Array< string >,
      displayOpenBalance?: boolean | null,
    } >,
    createdAt?: string | null,
    defaultName?: string | null,
    isDefaultSetting: boolean,
    referent: CommunicationSettingsProfileReferent,
    replacementId?: string | null,
    displayLogo: boolean,
    tenantStatementView: StatementViewType,
    readId: string,
    readers?: Array< string > | null,
    clientId: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateContactSubscriptionVariables = {
  filter?: ModelSubscriptionContactFilterInput | null,
};

export type OnCreateContactSubscription = {
  onCreateContact?:  {
    __typename: "Contact",
    id: string,
    createdAt?: string | null,
    firstName?: string | null,
    lastName?: string | null,
    companyName?: string | null,
    commercialName?: string | null,
    communicationSettingsProfileId?: string | null,
    customValues?:  Array< {
      __typename: "CustomValue",
      name: string,
      value: string,
    } > | null,
    businessNumber?: string | null,
    types: Array< ContactType >,
    vat?: string | null,
    emails?:  Array< {
      __typename: "Email",
      address: string,
      isPrimary: boolean,
      label?: string | null,
    } > | null,
    email?: string | null,
    birthDate?: string | null,
    birthPlace?: string | null,
    nationalRegister?: string | null,
    ipiNumber?: string | null,
    insuranceCompany?: string | null,
    insuranceContractNumber?: string | null,
    judicialDistrict?: string | null,
    civility?: CivilityType | null,
    addressId?: string | null,
    address?:  {
      __typename: "Address",
      id: string,
      status?: AddressStatus | null,
      street: string,
      number?: string | null,
      box?: string | null,
      postalCode?: string | null,
      city?: string | null,
      region?: string | null,
      country?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      latitude?: number | null,
      longitude?: number | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    phoneNumbers?:  Array< {
      __typename: "PhoneNumber",
      countryCode: string,
      isPrimary: boolean,
      label?: string | null,
      number: string,
    } > | null,
    language?: string | null,
    notes?: string | null,
    profileType: ContactProfileType,
    jointOwners?:  Array< {
      __typename: "JointOwner",
      contactId: string,
      contactPerson?: boolean | null,
    } > | null,
    hoaFunds?:  Array< {
      __typename: "ContactHoaFund",
      archivedAt?: string | null,
      id: string,
      kind: HoaFundKind,
      name: string,
    } > | null,
    agencyRateDisabled?: boolean | null,
    attachStatementSupportingDocuments?: boolean | null,
    status?: ContactStatus | null,
    leases?:  {
      __typename: "ModelLeaseContactConnection",
      items:  Array< {
        __typename: "LeaseContact",
        id: string,
        leaseId: string,
        contactId: string,
        contactRole: ContactType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    buildings?:  {
      __typename: "ModelBuildingOwnerConnection",
      items:  Array< {
        __typename: "BuildingOwner",
        id: string,
        buildingId: string,
        contactId: string,
        disabled?: boolean | null,
        periodFrom?: string | null,
        periodTo?: string | null,
        stake: number,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    units?:  {
      __typename: "ModelUnitOwnerConnection",
      items:  Array< {
        __typename: "UnitOwner",
        id: string,
        disabled?: boolean | null,
        ownerId: string,
        periodFrom?: string | null,
        periodTo?: string | null,
        stake: number,
        unitId: string,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    sendInvitation: boolean,
    peppolProperties?:  {
      __typename: "ContactPeppolProperties",
      isRegistered: boolean,
      mustSend: boolean,
    } | null,
    integrations?:  {
      __typename: "ContactIntegrations",
      paymentProperties?:  {
        __typename: "PaymentProviderProperties",
        accountId: string,
      } | null,
    } | null,
    readers?: Array< string > | null,
    readId: string,
    clientId: string,
    sourceEntityRelations?:  {
      __typename: "ModelEntityRelationConnection",
      items:  Array< {
        __typename: "EntityRelation",
        id: string,
        sourceId: string,
        sourceTableName: string,
        foreignId: string,
        foreignTableName: string,
        linkDescription?: string | null,
        clientId: string,
        readers?: Array< string > | null,
        readId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    foreignEntityRelations?:  {
      __typename: "ModelEntityRelationConnection",
      items:  Array< {
        __typename: "EntityRelation",
        id: string,
        sourceId: string,
        sourceTableName: string,
        foreignId: string,
        foreignTableName: string,
        linkDescription?: string | null,
        clientId: string,
        readers?: Array< string > | null,
        readId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateContactSubscriptionVariables = {
  filter?: ModelSubscriptionContactFilterInput | null,
};

export type OnUpdateContactSubscription = {
  onUpdateContact?:  {
    __typename: "Contact",
    id: string,
    createdAt?: string | null,
    firstName?: string | null,
    lastName?: string | null,
    companyName?: string | null,
    commercialName?: string | null,
    communicationSettingsProfileId?: string | null,
    customValues?:  Array< {
      __typename: "CustomValue",
      name: string,
      value: string,
    } > | null,
    businessNumber?: string | null,
    types: Array< ContactType >,
    vat?: string | null,
    emails?:  Array< {
      __typename: "Email",
      address: string,
      isPrimary: boolean,
      label?: string | null,
    } > | null,
    email?: string | null,
    birthDate?: string | null,
    birthPlace?: string | null,
    nationalRegister?: string | null,
    ipiNumber?: string | null,
    insuranceCompany?: string | null,
    insuranceContractNumber?: string | null,
    judicialDistrict?: string | null,
    civility?: CivilityType | null,
    addressId?: string | null,
    address?:  {
      __typename: "Address",
      id: string,
      status?: AddressStatus | null,
      street: string,
      number?: string | null,
      box?: string | null,
      postalCode?: string | null,
      city?: string | null,
      region?: string | null,
      country?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      latitude?: number | null,
      longitude?: number | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    phoneNumbers?:  Array< {
      __typename: "PhoneNumber",
      countryCode: string,
      isPrimary: boolean,
      label?: string | null,
      number: string,
    } > | null,
    language?: string | null,
    notes?: string | null,
    profileType: ContactProfileType,
    jointOwners?:  Array< {
      __typename: "JointOwner",
      contactId: string,
      contactPerson?: boolean | null,
    } > | null,
    hoaFunds?:  Array< {
      __typename: "ContactHoaFund",
      archivedAt?: string | null,
      id: string,
      kind: HoaFundKind,
      name: string,
    } > | null,
    agencyRateDisabled?: boolean | null,
    attachStatementSupportingDocuments?: boolean | null,
    status?: ContactStatus | null,
    leases?:  {
      __typename: "ModelLeaseContactConnection",
      items:  Array< {
        __typename: "LeaseContact",
        id: string,
        leaseId: string,
        contactId: string,
        contactRole: ContactType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    buildings?:  {
      __typename: "ModelBuildingOwnerConnection",
      items:  Array< {
        __typename: "BuildingOwner",
        id: string,
        buildingId: string,
        contactId: string,
        disabled?: boolean | null,
        periodFrom?: string | null,
        periodTo?: string | null,
        stake: number,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    units?:  {
      __typename: "ModelUnitOwnerConnection",
      items:  Array< {
        __typename: "UnitOwner",
        id: string,
        disabled?: boolean | null,
        ownerId: string,
        periodFrom?: string | null,
        periodTo?: string | null,
        stake: number,
        unitId: string,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    sendInvitation: boolean,
    peppolProperties?:  {
      __typename: "ContactPeppolProperties",
      isRegistered: boolean,
      mustSend: boolean,
    } | null,
    integrations?:  {
      __typename: "ContactIntegrations",
      paymentProperties?:  {
        __typename: "PaymentProviderProperties",
        accountId: string,
      } | null,
    } | null,
    readers?: Array< string > | null,
    readId: string,
    clientId: string,
    sourceEntityRelations?:  {
      __typename: "ModelEntityRelationConnection",
      items:  Array< {
        __typename: "EntityRelation",
        id: string,
        sourceId: string,
        sourceTableName: string,
        foreignId: string,
        foreignTableName: string,
        linkDescription?: string | null,
        clientId: string,
        readers?: Array< string > | null,
        readId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    foreignEntityRelations?:  {
      __typename: "ModelEntityRelationConnection",
      items:  Array< {
        __typename: "EntityRelation",
        id: string,
        sourceId: string,
        sourceTableName: string,
        foreignId: string,
        foreignTableName: string,
        linkDescription?: string | null,
        clientId: string,
        readers?: Array< string > | null,
        readId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteContactSubscriptionVariables = {
  filter?: ModelSubscriptionContactFilterInput | null,
};

export type OnDeleteContactSubscription = {
  onDeleteContact?:  {
    __typename: "Contact",
    id: string,
    createdAt?: string | null,
    firstName?: string | null,
    lastName?: string | null,
    companyName?: string | null,
    commercialName?: string | null,
    communicationSettingsProfileId?: string | null,
    customValues?:  Array< {
      __typename: "CustomValue",
      name: string,
      value: string,
    } > | null,
    businessNumber?: string | null,
    types: Array< ContactType >,
    vat?: string | null,
    emails?:  Array< {
      __typename: "Email",
      address: string,
      isPrimary: boolean,
      label?: string | null,
    } > | null,
    email?: string | null,
    birthDate?: string | null,
    birthPlace?: string | null,
    nationalRegister?: string | null,
    ipiNumber?: string | null,
    insuranceCompany?: string | null,
    insuranceContractNumber?: string | null,
    judicialDistrict?: string | null,
    civility?: CivilityType | null,
    addressId?: string | null,
    address?:  {
      __typename: "Address",
      id: string,
      status?: AddressStatus | null,
      street: string,
      number?: string | null,
      box?: string | null,
      postalCode?: string | null,
      city?: string | null,
      region?: string | null,
      country?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      latitude?: number | null,
      longitude?: number | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    phoneNumbers?:  Array< {
      __typename: "PhoneNumber",
      countryCode: string,
      isPrimary: boolean,
      label?: string | null,
      number: string,
    } > | null,
    language?: string | null,
    notes?: string | null,
    profileType: ContactProfileType,
    jointOwners?:  Array< {
      __typename: "JointOwner",
      contactId: string,
      contactPerson?: boolean | null,
    } > | null,
    hoaFunds?:  Array< {
      __typename: "ContactHoaFund",
      archivedAt?: string | null,
      id: string,
      kind: HoaFundKind,
      name: string,
    } > | null,
    agencyRateDisabled?: boolean | null,
    attachStatementSupportingDocuments?: boolean | null,
    status?: ContactStatus | null,
    leases?:  {
      __typename: "ModelLeaseContactConnection",
      items:  Array< {
        __typename: "LeaseContact",
        id: string,
        leaseId: string,
        contactId: string,
        contactRole: ContactType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    buildings?:  {
      __typename: "ModelBuildingOwnerConnection",
      items:  Array< {
        __typename: "BuildingOwner",
        id: string,
        buildingId: string,
        contactId: string,
        disabled?: boolean | null,
        periodFrom?: string | null,
        periodTo?: string | null,
        stake: number,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    units?:  {
      __typename: "ModelUnitOwnerConnection",
      items:  Array< {
        __typename: "UnitOwner",
        id: string,
        disabled?: boolean | null,
        ownerId: string,
        periodFrom?: string | null,
        periodTo?: string | null,
        stake: number,
        unitId: string,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    sendInvitation: boolean,
    peppolProperties?:  {
      __typename: "ContactPeppolProperties",
      isRegistered: boolean,
      mustSend: boolean,
    } | null,
    integrations?:  {
      __typename: "ContactIntegrations",
      paymentProperties?:  {
        __typename: "PaymentProviderProperties",
        accountId: string,
      } | null,
    } | null,
    readers?: Array< string > | null,
    readId: string,
    clientId: string,
    sourceEntityRelations?:  {
      __typename: "ModelEntityRelationConnection",
      items:  Array< {
        __typename: "EntityRelation",
        id: string,
        sourceId: string,
        sourceTableName: string,
        foreignId: string,
        foreignTableName: string,
        linkDescription?: string | null,
        clientId: string,
        readers?: Array< string > | null,
        readId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    foreignEntityRelations?:  {
      __typename: "ModelEntityRelationConnection",
      items:  Array< {
        __typename: "EntityRelation",
        id: string,
        sourceId: string,
        sourceTableName: string,
        foreignId: string,
        foreignTableName: string,
        linkDescription?: string | null,
        clientId: string,
        readers?: Array< string > | null,
        readId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateAddressSubscriptionVariables = {
  filter?: ModelSubscriptionAddressFilterInput | null,
};

export type OnCreateAddressSubscription = {
  onCreateAddress?:  {
    __typename: "Address",
    id: string,
    status?: AddressStatus | null,
    street: string,
    number?: string | null,
    box?: string | null,
    postalCode?: string | null,
    city?: string | null,
    region?: string | null,
    country?: string | null,
    customValues?:  Array< {
      __typename: "CustomValue",
      name: string,
      value: string,
    } > | null,
    latitude?: number | null,
    longitude?: number | null,
    readers?: Array< string > | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateAddressSubscriptionVariables = {
  filter?: ModelSubscriptionAddressFilterInput | null,
};

export type OnUpdateAddressSubscription = {
  onUpdateAddress?:  {
    __typename: "Address",
    id: string,
    status?: AddressStatus | null,
    street: string,
    number?: string | null,
    box?: string | null,
    postalCode?: string | null,
    city?: string | null,
    region?: string | null,
    country?: string | null,
    customValues?:  Array< {
      __typename: "CustomValue",
      name: string,
      value: string,
    } > | null,
    latitude?: number | null,
    longitude?: number | null,
    readers?: Array< string > | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteAddressSubscriptionVariables = {
  filter?: ModelSubscriptionAddressFilterInput | null,
};

export type OnDeleteAddressSubscription = {
  onDeleteAddress?:  {
    __typename: "Address",
    id: string,
    status?: AddressStatus | null,
    street: string,
    number?: string | null,
    box?: string | null,
    postalCode?: string | null,
    city?: string | null,
    region?: string | null,
    country?: string | null,
    customValues?:  Array< {
      __typename: "CustomValue",
      name: string,
      value: string,
    } > | null,
    latitude?: number | null,
    longitude?: number | null,
    readers?: Array< string > | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateCustomFieldSubscriptionVariables = {
  filter?: ModelSubscriptionCustomFieldFilterInput | null,
};

export type OnCreateCustomFieldSubscription = {
  onCreateCustomField?:  {
    __typename: "CustomField",
    id: string,
    fieldName: string,
    fieldType: CustomFieldType,
    foreignKey: string,
    foreignTableName: string,
    labels:  Array< {
      __typename: "CustomLabel",
      language: string,
      label: string,
    } >,
    customFieldProperties?:  {
      __typename: "CustomFieldProperties",
      isRequired?: boolean | null,
      isDefault?: boolean | null,
      defaultValue?: string | null,
      options?:  Array< {
        __typename: "CustomFieldOption",
        id: string,
      } > | null,
    } | null,
    order?: number | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateCustomFieldSubscriptionVariables = {
  filter?: ModelSubscriptionCustomFieldFilterInput | null,
};

export type OnUpdateCustomFieldSubscription = {
  onUpdateCustomField?:  {
    __typename: "CustomField",
    id: string,
    fieldName: string,
    fieldType: CustomFieldType,
    foreignKey: string,
    foreignTableName: string,
    labels:  Array< {
      __typename: "CustomLabel",
      language: string,
      label: string,
    } >,
    customFieldProperties?:  {
      __typename: "CustomFieldProperties",
      isRequired?: boolean | null,
      isDefault?: boolean | null,
      defaultValue?: string | null,
      options?:  Array< {
        __typename: "CustomFieldOption",
        id: string,
      } > | null,
    } | null,
    order?: number | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteCustomFieldSubscriptionVariables = {
  filter?: ModelSubscriptionCustomFieldFilterInput | null,
};

export type OnDeleteCustomFieldSubscription = {
  onDeleteCustomField?:  {
    __typename: "CustomField",
    id: string,
    fieldName: string,
    fieldType: CustomFieldType,
    foreignKey: string,
    foreignTableName: string,
    labels:  Array< {
      __typename: "CustomLabel",
      language: string,
      label: string,
    } >,
    customFieldProperties?:  {
      __typename: "CustomFieldProperties",
      isRequired?: boolean | null,
      isDefault?: boolean | null,
      defaultValue?: string | null,
      options?:  Array< {
        __typename: "CustomFieldOption",
        id: string,
      } > | null,
    } | null,
    order?: number | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateCustomSubscriptionSubscriptionVariables = {
  filter?: ModelSubscriptionCustomSubscriptionFilterInput | null,
  userId?: string | null,
};

export type OnCreateCustomSubscriptionSubscription = {
  onCreateCustomSubscription?:  {
    __typename: "CustomSubscription",
    id: string,
    name: CustomSubscriptionType,
    value: string,
    createdAt?: string | null,
    userId?: string | null,
    _ttl: number,
    updatedAt: string,
    clientId: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateCustomSubscriptionSubscriptionVariables = {
  filter?: ModelSubscriptionCustomSubscriptionFilterInput | null,
  userId?: string | null,
};

export type OnUpdateCustomSubscriptionSubscription = {
  onUpdateCustomSubscription?:  {
    __typename: "CustomSubscription",
    id: string,
    name: CustomSubscriptionType,
    value: string,
    createdAt?: string | null,
    userId?: string | null,
    _ttl: number,
    updatedAt: string,
    clientId: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteCustomSubscriptionSubscriptionVariables = {
  filter?: ModelSubscriptionCustomSubscriptionFilterInput | null,
  userId?: string | null,
};

export type OnDeleteCustomSubscriptionSubscription = {
  onDeleteCustomSubscription?:  {
    __typename: "CustomSubscription",
    id: string,
    name: CustomSubscriptionType,
    value: string,
    createdAt?: string | null,
    userId?: string | null,
    _ttl: number,
    updatedAt: string,
    clientId: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateEntityRelationSubscriptionVariables = {
  filter?: ModelSubscriptionEntityRelationFilterInput | null,
};

export type OnCreateEntityRelationSubscription = {
  onCreateEntityRelation?:  {
    __typename: "EntityRelation",
    id: string,
    sourceId: string,
    sourceTableName: string,
    foreignId: string,
    foreignTableName: string,
    linkDescription?: string | null,
    linkProperties?:  {
      __typename: "RelationLinkProperties",
      contact?:  {
        __typename: "ContactRelationLinkProperties",
        communicationSubscriptions?: Array< ContactCommunicationSubscriptionTypes > | null,
      } | null,
    } | null,
    clientId: string,
    readers?: Array< string > | null,
    readId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateEntityRelationSubscriptionVariables = {
  filter?: ModelSubscriptionEntityRelationFilterInput | null,
};

export type OnUpdateEntityRelationSubscription = {
  onUpdateEntityRelation?:  {
    __typename: "EntityRelation",
    id: string,
    sourceId: string,
    sourceTableName: string,
    foreignId: string,
    foreignTableName: string,
    linkDescription?: string | null,
    linkProperties?:  {
      __typename: "RelationLinkProperties",
      contact?:  {
        __typename: "ContactRelationLinkProperties",
        communicationSubscriptions?: Array< ContactCommunicationSubscriptionTypes > | null,
      } | null,
    } | null,
    clientId: string,
    readers?: Array< string > | null,
    readId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteEntityRelationSubscriptionVariables = {
  filter?: ModelSubscriptionEntityRelationFilterInput | null,
};

export type OnDeleteEntityRelationSubscription = {
  onDeleteEntityRelation?:  {
    __typename: "EntityRelation",
    id: string,
    sourceId: string,
    sourceTableName: string,
    foreignId: string,
    foreignTableName: string,
    linkDescription?: string | null,
    linkProperties?:  {
      __typename: "RelationLinkProperties",
      contact?:  {
        __typename: "ContactRelationLinkProperties",
        communicationSubscriptions?: Array< ContactCommunicationSubscriptionTypes > | null,
      } | null,
    } | null,
    clientId: string,
    readers?: Array< string > | null,
    readId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateFileSubscriptionVariables = {
  filter?: ModelSubscriptionFileFilterInput | null,
};

export type OnCreateFileSubscription = {
  onCreateFile?:  {
    __typename: "File",
    id: string,
    bucket: string,
    createdAt?: string | null,
    category?:  {
      __typename: "DocumentCategory",
      id: string,
      entity?: string | null,
      fileCategory: FileCategory,
      labels:  Array< {
        __typename: "CustomLabel",
        language: string,
        label: string,
      } >,
      parentId?: string | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    categoryId: string,
    foreignKey: string,
    foreignTableName: string,
    key: string,
    mimeType?: string | null,
    region: string,
    signaturePositions?:  Array< {
      __typename: "SignaturePosition",
      top: number,
      left: number,
      page: number,
      width?: number | null,
      height?: number | null,
      contactId: string,
    } > | null,
    size?: number | null,
    readers?: Array< string > | null,
    readId: string,
    clientId: string,
    _ttl?: number | null,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateFileSubscriptionVariables = {
  filter?: ModelSubscriptionFileFilterInput | null,
};

export type OnUpdateFileSubscription = {
  onUpdateFile?:  {
    __typename: "File",
    id: string,
    bucket: string,
    createdAt?: string | null,
    category?:  {
      __typename: "DocumentCategory",
      id: string,
      entity?: string | null,
      fileCategory: FileCategory,
      labels:  Array< {
        __typename: "CustomLabel",
        language: string,
        label: string,
      } >,
      parentId?: string | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    categoryId: string,
    foreignKey: string,
    foreignTableName: string,
    key: string,
    mimeType?: string | null,
    region: string,
    signaturePositions?:  Array< {
      __typename: "SignaturePosition",
      top: number,
      left: number,
      page: number,
      width?: number | null,
      height?: number | null,
      contactId: string,
    } > | null,
    size?: number | null,
    readers?: Array< string > | null,
    readId: string,
    clientId: string,
    _ttl?: number | null,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteFileSubscriptionVariables = {
  filter?: ModelSubscriptionFileFilterInput | null,
};

export type OnDeleteFileSubscription = {
  onDeleteFile?:  {
    __typename: "File",
    id: string,
    bucket: string,
    createdAt?: string | null,
    category?:  {
      __typename: "DocumentCategory",
      id: string,
      entity?: string | null,
      fileCategory: FileCategory,
      labels:  Array< {
        __typename: "CustomLabel",
        language: string,
        label: string,
      } >,
      parentId?: string | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    categoryId: string,
    foreignKey: string,
    foreignTableName: string,
    key: string,
    mimeType?: string | null,
    region: string,
    signaturePositions?:  Array< {
      __typename: "SignaturePosition",
      top: number,
      left: number,
      page: number,
      width?: number | null,
      height?: number | null,
      contactId: string,
    } > | null,
    size?: number | null,
    readers?: Array< string > | null,
    readId: string,
    clientId: string,
    _ttl?: number | null,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateDocumentCategorySubscriptionVariables = {
  filter?: ModelSubscriptionDocumentCategoryFilterInput | null,
};

export type OnCreateDocumentCategorySubscription = {
  onCreateDocumentCategory?:  {
    __typename: "DocumentCategory",
    id: string,
    entity?: string | null,
    fileCategory: FileCategory,
    labels:  Array< {
      __typename: "CustomLabel",
      language: string,
      label: string,
    } >,
    parentId?: string | null,
    readers?: Array< string > | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateDocumentCategorySubscriptionVariables = {
  filter?: ModelSubscriptionDocumentCategoryFilterInput | null,
};

export type OnUpdateDocumentCategorySubscription = {
  onUpdateDocumentCategory?:  {
    __typename: "DocumentCategory",
    id: string,
    entity?: string | null,
    fileCategory: FileCategory,
    labels:  Array< {
      __typename: "CustomLabel",
      language: string,
      label: string,
    } >,
    parentId?: string | null,
    readers?: Array< string > | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteDocumentCategorySubscriptionVariables = {
  filter?: ModelSubscriptionDocumentCategoryFilterInput | null,
};

export type OnDeleteDocumentCategorySubscription = {
  onDeleteDocumentCategory?:  {
    __typename: "DocumentCategory",
    id: string,
    entity?: string | null,
    fileCategory: FileCategory,
    labels:  Array< {
      __typename: "CustomLabel",
      language: string,
      label: string,
    } >,
    parentId?: string | null,
    readers?: Array< string > | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateSignatureDocumentSubscriptionVariables = {
  filter?: ModelSubscriptionSignatureDocumentFilterInput | null,
};

export type OnCreateSignatureDocumentSubscription = {
  onCreateSignatureDocument?:  {
    __typename: "SignatureDocument",
    id: string,
    additionalMessage?: string | null,
    automaticRemindersDisabled?: boolean | null,
    communicationBody?: string | null,
    createdAt?: string | null,
    expirationDate?: string | null,
    fileIds?: Array< string > | null,
    foreignKey: string,
    foreignTableName: string,
    sentAt?: string | null,
    signatureMethods: Array< SignatureType >,
    signatureResults:  Array< {
      __typename: "SignatureDocumentResult",
      openedDate?: string | null,
      signedDate?: string | null,
      signed?: boolean | null,
      signatureLink?: string | null,
      rejectReason?: string | null,
      lastSignInviteSentDate?: string | null,
      reminderDates?: Array< string > | null,
      trackingProvider?: TrackingProvider | null,
      trackingCode?: string | null,
      contactId: string,
    } >,
    status: SignatureDocumentStatus,
    externalStatus?: string | null,
    type: SignatureDocumentType,
    readers?: Array< string > | null,
    readId: string,
    clientId: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateSignatureDocumentSubscriptionVariables = {
  filter?: ModelSubscriptionSignatureDocumentFilterInput | null,
};

export type OnUpdateSignatureDocumentSubscription = {
  onUpdateSignatureDocument?:  {
    __typename: "SignatureDocument",
    id: string,
    additionalMessage?: string | null,
    automaticRemindersDisabled?: boolean | null,
    communicationBody?: string | null,
    createdAt?: string | null,
    expirationDate?: string | null,
    fileIds?: Array< string > | null,
    foreignKey: string,
    foreignTableName: string,
    sentAt?: string | null,
    signatureMethods: Array< SignatureType >,
    signatureResults:  Array< {
      __typename: "SignatureDocumentResult",
      openedDate?: string | null,
      signedDate?: string | null,
      signed?: boolean | null,
      signatureLink?: string | null,
      rejectReason?: string | null,
      lastSignInviteSentDate?: string | null,
      reminderDates?: Array< string > | null,
      trackingProvider?: TrackingProvider | null,
      trackingCode?: string | null,
      contactId: string,
    } >,
    status: SignatureDocumentStatus,
    externalStatus?: string | null,
    type: SignatureDocumentType,
    readers?: Array< string > | null,
    readId: string,
    clientId: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteSignatureDocumentSubscriptionVariables = {
  filter?: ModelSubscriptionSignatureDocumentFilterInput | null,
};

export type OnDeleteSignatureDocumentSubscription = {
  onDeleteSignatureDocument?:  {
    __typename: "SignatureDocument",
    id: string,
    additionalMessage?: string | null,
    automaticRemindersDisabled?: boolean | null,
    communicationBody?: string | null,
    createdAt?: string | null,
    expirationDate?: string | null,
    fileIds?: Array< string > | null,
    foreignKey: string,
    foreignTableName: string,
    sentAt?: string | null,
    signatureMethods: Array< SignatureType >,
    signatureResults:  Array< {
      __typename: "SignatureDocumentResult",
      openedDate?: string | null,
      signedDate?: string | null,
      signed?: boolean | null,
      signatureLink?: string | null,
      rejectReason?: string | null,
      lastSignInviteSentDate?: string | null,
      reminderDates?: Array< string > | null,
      trackingProvider?: TrackingProvider | null,
      trackingCode?: string | null,
      contactId: string,
    } >,
    status: SignatureDocumentStatus,
    externalStatus?: string | null,
    type: SignatureDocumentType,
    readers?: Array< string > | null,
    readId: string,
    clientId: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateFilterGroupSubscriptionVariables = {
  filter?: ModelSubscriptionFilterGroupFilterInput | null,
};

export type OnCreateFilterGroupSubscription = {
  onCreateFilterGroup?:  {
    __typename: "FilterGroup",
    id: string,
    filterGroupDetails:  Array< {
      __typename: "FilterGroupDetails",
      filterEntityType: FilterEntityType,
      filterEntityField?: string | null,
      filterEntityValues?: Array< string > | null,
      filterEntityNumber?: number | null,
      filterEntityDate?: string | null,
    } >,
    name?: string | null,
    screenName?: ScreenName | null,
    type: FilterGroupType,
    userId?: string | null,
    user?:  {
      __typename: "User",
      id: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      cognitoSub?: string | null,
      googleSub?: string | null,
      facebookSub?: string | null,
      rootUser?: boolean | null,
      refreshToken?: boolean | null,
      teams?:  {
        __typename: "ModelUserTeamConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      userRoleId?: string | null,
      userRole?:  {
        __typename: "UserRole",
        id: string,
        name: string,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contactId?: string | null,
      contact?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      status: UserStatus,
      readId: string,
      clientId: string,
      _ttl?: number | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateFilterGroupSubscriptionVariables = {
  filter?: ModelSubscriptionFilterGroupFilterInput | null,
};

export type OnUpdateFilterGroupSubscription = {
  onUpdateFilterGroup?:  {
    __typename: "FilterGroup",
    id: string,
    filterGroupDetails:  Array< {
      __typename: "FilterGroupDetails",
      filterEntityType: FilterEntityType,
      filterEntityField?: string | null,
      filterEntityValues?: Array< string > | null,
      filterEntityNumber?: number | null,
      filterEntityDate?: string | null,
    } >,
    name?: string | null,
    screenName?: ScreenName | null,
    type: FilterGroupType,
    userId?: string | null,
    user?:  {
      __typename: "User",
      id: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      cognitoSub?: string | null,
      googleSub?: string | null,
      facebookSub?: string | null,
      rootUser?: boolean | null,
      refreshToken?: boolean | null,
      teams?:  {
        __typename: "ModelUserTeamConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      userRoleId?: string | null,
      userRole?:  {
        __typename: "UserRole",
        id: string,
        name: string,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contactId?: string | null,
      contact?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      status: UserStatus,
      readId: string,
      clientId: string,
      _ttl?: number | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteFilterGroupSubscriptionVariables = {
  filter?: ModelSubscriptionFilterGroupFilterInput | null,
};

export type OnDeleteFilterGroupSubscription = {
  onDeleteFilterGroup?:  {
    __typename: "FilterGroup",
    id: string,
    filterGroupDetails:  Array< {
      __typename: "FilterGroupDetails",
      filterEntityType: FilterEntityType,
      filterEntityField?: string | null,
      filterEntityValues?: Array< string > | null,
      filterEntityNumber?: number | null,
      filterEntityDate?: string | null,
    } >,
    name?: string | null,
    screenName?: ScreenName | null,
    type: FilterGroupType,
    userId?: string | null,
    user?:  {
      __typename: "User",
      id: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      cognitoSub?: string | null,
      googleSub?: string | null,
      facebookSub?: string | null,
      rootUser?: boolean | null,
      refreshToken?: boolean | null,
      teams?:  {
        __typename: "ModelUserTeamConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      userRoleId?: string | null,
      userRole?:  {
        __typename: "UserRole",
        id: string,
        name: string,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contactId?: string | null,
      contact?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      status: UserStatus,
      readId: string,
      clientId: string,
      _ttl?: number | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateIntegrationSubscriptionVariables = {
  filter?: ModelSubscriptionIntegrationFilterInput | null,
};

export type OnCreateIntegrationSubscription = {
  onCreateIntegration?:  {
    __typename: "Integration",
    id: string,
    configurations?:  Array< {
      __typename: "IntegrationConfiguration",
      name: string,
      value: string,
    } > | null,
    error?: string | null,
    lastRun?: string | null,
    name: IntegrationName,
    status: IntegrationStatus,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateIntegrationSubscriptionVariables = {
  filter?: ModelSubscriptionIntegrationFilterInput | null,
};

export type OnUpdateIntegrationSubscription = {
  onUpdateIntegration?:  {
    __typename: "Integration",
    id: string,
    configurations?:  Array< {
      __typename: "IntegrationConfiguration",
      name: string,
      value: string,
    } > | null,
    error?: string | null,
    lastRun?: string | null,
    name: IntegrationName,
    status: IntegrationStatus,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteIntegrationSubscriptionVariables = {
  filter?: ModelSubscriptionIntegrationFilterInput | null,
};

export type OnDeleteIntegrationSubscription = {
  onDeleteIntegration?:  {
    __typename: "Integration",
    id: string,
    configurations?:  Array< {
      __typename: "IntegrationConfiguration",
      name: string,
      value: string,
    } > | null,
    error?: string | null,
    lastRun?: string | null,
    name: IntegrationName,
    status: IntegrationStatus,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateInvoiceSubscriptionVariables = {
  filter?: ModelSubscriptionInvoiceFilterInput | null,
};

export type OnCreateInvoiceSubscription = {
  onCreateInvoice?:  {
    __typename: "Invoice",
    id: string,
    amount: number,
    bankAccountId: string,
    bankAccount?:  {
      __typename: "BankAccount",
      id: string,
      contactId: string,
      contact?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      number: string,
      bicNumber?: string | null,
      bankName?: string | null,
      contactIds?: Array< string > | null,
      buildingIds?: Array< string > | null,
      holderName?: string | null,
      label?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      disabled?: boolean | null,
      integrations?: Array< IntegrationName > | null,
      matchingRule?: BankAccountMatchingRule | null,
      balance?: number | null,
      balanceDate?: string | null,
      type: BankAccountType,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    communicationId?: string | null,
    communication?:  {
      __typename: "Communication",
      id: string,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      blockedRecipients?:  Array< {
        __typename: "CommunicationBlockedRecipient",
        recipient: string,
        bounceType: BounceType,
      } > | null,
      body: string,
      buildingId?: string | null,
      channel: CommunicationChannel,
      communicationTemplateId?: string | null,
      concernedContactIds?: Array< string > | null,
      contactId?: string | null,
      contactIds?: Array< string > | null,
      createdAt?: string | null,
      draftProperties?:  {
        __typename: "CommunicationDraftProperties",
        allowRecipientsToSeeEachOther?: boolean | null,
        bcc?: Array< string > | null,
        buildingIds?: Array< string > | null,
        cc?: Array< string > | null,
        contactIds?: Array< string > | null,
        contactTypes?: Array< ContactType > | null,
        entityType: string,
        leaseIds?: Array< string > | null,
        sendInBcc?: boolean | null,
        unitIds?: Array< string > | null,
        unitTypeFilter?: string | null,
      } | null,
      expirationDate?: string | null,
      files?:  {
        __typename: "ModelFileConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      invoice?:  {
        __typename: "Invoice",
        id: string,
        amount: number,
        bankAccountId: string,
        communicationId?: string | null,
        createdAt: string,
        creditNote?: boolean | null,
        creditNoteLabel?: string | null,
        dueDate?: string | null,
        invoiceDate: string,
        invoiceNumber?: string | null,
        ownerId?: string | null,
        invoiceSenderId: string,
        leaseId?: string | null,
        paid: boolean,
        postedDate?: string | null,
        purchaseOrderNumber?: string | null,
        receiptNumber?: string | null,
        reminderDates?: Array< string > | null,
        note?: string | null,
        remittanceInformation?: string | null,
        statementId?: string | null,
        status: InvoiceStatus,
        type: InvoiceType,
        unitId?: string | null,
        reversedInvoiceId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      invoiceId?: string | null,
      lease?:  {
        __typename: "Lease",
        id: string,
        balance?: number | null,
        canBeExtended?: boolean | null,
        communicationSettingsProfileId: string,
        createdAt?: string | null,
        endDate: string,
        includeRealEstateInLeaseContract?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        invoiceSenderId: string,
        inventoryOfFixturesExpert?: string | null,
        inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
        inventoryOfFixturesType?: InventoryOfFixturesType | null,
        ipiNumber?: string | null,
        language: Language,
        lastDraftInvoiceDate?: string | null,
        lastIndexationProcessDate?: string | null,
        lastInvoiceDate?: string | null,
        legalCompetentAuthority?: string | null,
        name: string,
        notes?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        purchaseOrderNumber?: string | null,
        realEstateAgency?: string | null,
        realEstateTax?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        signatureDate?: string | null,
        startDate: string,
        nextIndexationMonth?: string | null,
        nextIndexation?: boolean | null,
        status: LeaseStatus,
        technicCommunicationSettingsProfileId: string,
        totalInitialRentalPrice: number,
        totalRentalPrice: number,
        type: LeaseType,
        subletting?: boolean | null,
        vatRateRentId?: string | null,
        bankAccountId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      leaseId?: string | null,
      leasePriceHistoryId?: string | null,
      leasePriceHistory?:  {
        __typename: "LeasePriceHistory",
        id: string,
        previousTotalRentalPrice: number,
        totalRentalPrice: number,
        optimalTotalRentalPrice?: number | null,
        optimalTotalMonthlyCharges?: number | null,
        applicationDate: string,
        status: LeaseAmountUpdateStatus,
        comment?: string | null,
        type: LeasePriceHistoryType,
        communicationId?: string | null,
        leaseId: string,
        createdAt?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      letterTrackingCode?: string | null,
      letterTrackingProvider?: TrackingProvider | null,
      linkedCommunicationsIds?: Array< string > | null,
      supportingDocumentFileIds?: Array< string > | null,
      recipient?: string | null,
      recipientContactIdsInBcc?: Array< string > | null,
      recipientContactIdsInCc?: Array< string > | null,
      recipientInBcc?: string | null,
      recipientInCc?: string | null,
      scheduledAt?: string | null,
      deliveredAt?: string | null,
      errorCode?: CommunicationErrorCode | null,
      nextRetryAt?: string | null,
      sendRetryCount?: number | null,
      sender?: string | null,
      sentAt?: string | null,
      externalId?: string | null,
      externalStatus?: string | null,
      signatureDocumentId?: string | null,
      signatureDocument?:  {
        __typename: "SignatureDocument",
        id: string,
        additionalMessage?: string | null,
        automaticRemindersDisabled?: boolean | null,
        communicationBody?: string | null,
        createdAt?: string | null,
        expirationDate?: string | null,
        fileIds?: Array< string > | null,
        foreignKey: string,
        foreignTableName: string,
        sentAt?: string | null,
        signatureMethods: Array< SignatureType >,
        status: SignatureDocumentStatus,
        externalStatus?: string | null,
        type: SignatureDocumentType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      snoozedDate?: string | null,
      statement?:  {
        __typename: "Statement",
        id: string,
        closingStatement: boolean,
        periodFrom: string,
        periodTo: string,
        attachSupportingDocuments?: boolean | null,
        selectedPocketKeys?: Array< string > | null,
        source: StatementSource,
        status: StatementStatus,
        sentDate?: string | null,
        leaseId?: string | null,
        ownerId?: string | null,
        types?: Array< StatementType > | null,
        viewType: StatementViewType,
        unitIds?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      statementId?: string | null,
      status: CommunicationStatus,
      subject: string,
      toSend: boolean,
      hideLogo?: boolean | null,
      type: CommunicationType,
      _ttl?: number | null,
      unit?:  {
        __typename: "Unit",
        id: string,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        acquisitionValue?: number | null,
        advertisedMonthlyCharges?: number | null,
        advertisedRentalPrice?: number | null,
        cadastralIncome?: number | null,
        createdAt?: string | null,
        floor?: number | null,
        jointOwnershipId?: string | null,
        managementDate: string,
        name: string,
        notes?: string | null,
        predictedPrice?: string | null,
        propertyTax?: number | null,
        publishAddress?: boolean | null,
        surface?: number | null,
        type: UnitType,
        buildingId: string,
        unitAdvertisementId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      unitId?: string | null,
      readId: string,
      readers?: Array< string > | null,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    createdAt: string,
    creditNote?: boolean | null,
    creditNoteLabel?: string | null,
    customValues?:  Array< {
      __typename: "CustomValue",
      name: string,
      value: string,
    } > | null,
    dueDate?: string | null,
    invoiceDate: string,
    invoiceNumber?: string | null,
    ownerId?: string | null,
    owner?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    invoiceSenderId: string,
    invoiceSender?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    leaseId?: string | null,
    lease?:  {
      __typename: "Lease",
      id: string,
      advancedChargesInvoices?:  {
        __typename: "LeaseAdvancedChargesInvoice",
        communicationSettingsProfileId: string,
        invoiceSenderId: string,
        lastDraftInvoiceDate?: string | null,
        lastInvoiceDate?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        bankAccountId?: string | null,
      } | null,
      balance?: number | null,
      canBeExtended?: boolean | null,
      communicationSettingsProfileId: string,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      endDate: string,
      includeRealEstateInLeaseContract?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      invoiceSenderId: string,
      invoiceSender?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      inventoryOfFixturesExpert?: string | null,
      inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
      inventoryOfFixturesType?: InventoryOfFixturesType | null,
      ipiNumber?: string | null,
      language: Language,
      lastDraftInvoiceDate?: string | null,
      lastIndexationProcessDate?: string | null,
      lastInvoiceDate?: string | null,
      legalCompetentAuthority?: string | null,
      name: string,
      notes?: string | null,
      paymentFrequency: LeasePaymentFrequency,
      paymentInvoicePeriod: LeasePaymentInvoicePeriod,
      paymentInvoicePeriodCustomDay?: number | null,
      paymentOption?:  {
        __typename: "LeasePaymentOption",
        customerId?: string | null,
        enabled: boolean,
        mandateActivatedAt?: string | null,
        mandateStatus?: PaymentProviderMandateStatus | null,
        paymentMethodId?: string | null,
        qrType?: LeaseQrType | null,
      } | null,
      purchaseOrderNumber?: string | null,
      realEstateAgency?: string | null,
      realEstateTax?: number | null,
      remittanceInformation?: string | null,
      remittanceInformationType?: LeaseRemittanceType | null,
      rentalGuaranty?:  {
        __typename: "LeaseRentalGuaranty",
        amount: number,
        blockedAmount?: number | null,
        releasedAmount?: number | null,
        type: LeaseRentalGuarantyType,
        financialInstitution?: string | null,
      } | null,
      signatureDate?: string | null,
      startDate: string,
      nextIndexationMonth?: string | null,
      nextIndexation?: boolean | null,
      status: LeaseStatus,
      technicCommunicationSettingsProfileId: string,
      totalInitialRentalPrice: number,
      totalRentalPrice: number,
      type: LeaseType,
      subletting?: boolean | null,
      vatRateRentId?: string | null,
      vatRateRent?:  {
        __typename: "VatRate",
        id: string,
        country: string,
        label: string,
        value?: number | null,
        ownerId?: string | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      additionalClauses?:  {
        __typename: "ModelLeaseAdditionalClauseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      bankAccountId?: string | null,
      bankAccount?:  {
        __typename: "BankAccount",
        id: string,
        contactId: string,
        number: string,
        bicNumber?: string | null,
        bankName?: string | null,
        contactIds?: Array< string > | null,
        buildingIds?: Array< string > | null,
        holderName?: string | null,
        label?: string | null,
        disabled?: boolean | null,
        integrations?: Array< IntegrationName > | null,
        matchingRule?: BankAccountMatchingRule | null,
        balance?: number | null,
        balanceDate?: string | null,
        type: BankAccountType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contacts?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      files?:  {
        __typename: "ModelFileConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leaseActionHistories?:  {
        __typename: "ModelLeaseActionHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leasePriceHistories?:  {
        __typename: "ModelLeasePriceHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      signatureDocuments?:  {
        __typename: "ModelSignatureDocumentConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      variousOperations?:  {
        __typename: "ModelLeaseVariousOperationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    paid: boolean,
    integrations?:  {
      __typename: "InvoiceIntegrations",
      paymentProperties?:  {
        __typename: "InvoicePaymentProviderProperties",
        availableOn?: string | null,
        error?: string | null,
        feeAmount?: number | null,
        paymentIntentId?: string | null,
        paymentLinkAmount?: number | null,
        paymentLinkUrl?: string | null,
        payoutId?: string | null,
        statementDescriptor?: string | null,
      } | null,
    } | null,
    postedDate?: string | null,
    purchaseOrderNumber?: string | null,
    receiptNumber?: string | null,
    reminderDates?: Array< string > | null,
    note?: string | null,
    remittanceInformation?: string | null,
    statementId?: string | null,
    statement?:  {
      __typename: "Statement",
      id: string,
      amounts?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      chargeStatements?:  {
        __typename: "ModelChargeStatementConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      closingStatement: boolean,
      periodFrom: string,
      periodTo: string,
      attachSupportingDocuments?: boolean | null,
      selectedPocketKeys?: Array< string > | null,
      source: StatementSource,
      status: StatementStatus,
      sentDate?: string | null,
      leaseId?: string | null,
      lease?:  {
        __typename: "Lease",
        id: string,
        balance?: number | null,
        canBeExtended?: boolean | null,
        communicationSettingsProfileId: string,
        createdAt?: string | null,
        endDate: string,
        includeRealEstateInLeaseContract?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        invoiceSenderId: string,
        inventoryOfFixturesExpert?: string | null,
        inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
        inventoryOfFixturesType?: InventoryOfFixturesType | null,
        ipiNumber?: string | null,
        language: Language,
        lastDraftInvoiceDate?: string | null,
        lastIndexationProcessDate?: string | null,
        lastInvoiceDate?: string | null,
        legalCompetentAuthority?: string | null,
        name: string,
        notes?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        purchaseOrderNumber?: string | null,
        realEstateAgency?: string | null,
        realEstateTax?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        signatureDate?: string | null,
        startDate: string,
        nextIndexationMonth?: string | null,
        nextIndexation?: boolean | null,
        status: LeaseStatus,
        technicCommunicationSettingsProfileId: string,
        totalInitialRentalPrice: number,
        totalRentalPrice: number,
        type: LeaseType,
        subletting?: boolean | null,
        vatRateRentId?: string | null,
        bankAccountId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      agencyRateStatements?:  {
        __typename: "ModelAgencyRateStatementConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      ownerId?: string | null,
      owner?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      repaymentStatements?:  {
        __typename: "ModelRepaymentStatementConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      types?: Array< StatementType > | null,
      viewType: StatementViewType,
      unitIds?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    status: InvoiceStatus,
    type: InvoiceType,
    unitId?: string | null,
    unit?:  {
      __typename: "Unit",
      id: string,
      acquisitionAdditionalCostsValue?: number | null,
      acquisitionAdvertisedValue?: number | null,
      acquisitionValue?: number | null,
      advertisedMonthlyCharges?: number | null,
      advertisedRentalPrice?: number | null,
      cadastralIncome?: number | null,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      floor?: number | null,
      jointOwnershipId?: string | null,
      managementDate: string,
      name: string,
      notes?: string | null,
      predictedPrice?: string | null,
      propertyTax?: number | null,
      publishAddress?: boolean | null,
      surface?: number | null,
      type: UnitType,
      buildingId: string,
      building?:  {
        __typename: "Building",
        id: string,
        name: string,
        addressId?: string | null,
        acquisitionValue?: number | null,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        amountOfFacades?: number | null,
        amountOfFloors?: number | null,
        amountOfHousings?: number | null,
        buildingState?: BuildingState | null,
        cadastralIncome?: number | null,
        constructionYear?: string | null,
        janitor?: boolean | null,
        jointOwnershipId?: string | null,
        notes?: string | null,
        propertyTax?: number | null,
        residenceName?: string | null,
        buildingSiteId?: string | null,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      owners?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leases?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      events?:  {
        __typename: "ModelUnitEventConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      unitAdvertisementId?: string | null,
      unitInventories?:  {
        __typename: "ModelUnitInventoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    reversedInvoiceId?: string | null,
    readers?: Array< string > | null,
    readId: string,
    clientId: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateInvoiceSubscriptionVariables = {
  filter?: ModelSubscriptionInvoiceFilterInput | null,
};

export type OnUpdateInvoiceSubscription = {
  onUpdateInvoice?:  {
    __typename: "Invoice",
    id: string,
    amount: number,
    bankAccountId: string,
    bankAccount?:  {
      __typename: "BankAccount",
      id: string,
      contactId: string,
      contact?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      number: string,
      bicNumber?: string | null,
      bankName?: string | null,
      contactIds?: Array< string > | null,
      buildingIds?: Array< string > | null,
      holderName?: string | null,
      label?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      disabled?: boolean | null,
      integrations?: Array< IntegrationName > | null,
      matchingRule?: BankAccountMatchingRule | null,
      balance?: number | null,
      balanceDate?: string | null,
      type: BankAccountType,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    communicationId?: string | null,
    communication?:  {
      __typename: "Communication",
      id: string,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      blockedRecipients?:  Array< {
        __typename: "CommunicationBlockedRecipient",
        recipient: string,
        bounceType: BounceType,
      } > | null,
      body: string,
      buildingId?: string | null,
      channel: CommunicationChannel,
      communicationTemplateId?: string | null,
      concernedContactIds?: Array< string > | null,
      contactId?: string | null,
      contactIds?: Array< string > | null,
      createdAt?: string | null,
      draftProperties?:  {
        __typename: "CommunicationDraftProperties",
        allowRecipientsToSeeEachOther?: boolean | null,
        bcc?: Array< string > | null,
        buildingIds?: Array< string > | null,
        cc?: Array< string > | null,
        contactIds?: Array< string > | null,
        contactTypes?: Array< ContactType > | null,
        entityType: string,
        leaseIds?: Array< string > | null,
        sendInBcc?: boolean | null,
        unitIds?: Array< string > | null,
        unitTypeFilter?: string | null,
      } | null,
      expirationDate?: string | null,
      files?:  {
        __typename: "ModelFileConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      invoice?:  {
        __typename: "Invoice",
        id: string,
        amount: number,
        bankAccountId: string,
        communicationId?: string | null,
        createdAt: string,
        creditNote?: boolean | null,
        creditNoteLabel?: string | null,
        dueDate?: string | null,
        invoiceDate: string,
        invoiceNumber?: string | null,
        ownerId?: string | null,
        invoiceSenderId: string,
        leaseId?: string | null,
        paid: boolean,
        postedDate?: string | null,
        purchaseOrderNumber?: string | null,
        receiptNumber?: string | null,
        reminderDates?: Array< string > | null,
        note?: string | null,
        remittanceInformation?: string | null,
        statementId?: string | null,
        status: InvoiceStatus,
        type: InvoiceType,
        unitId?: string | null,
        reversedInvoiceId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      invoiceId?: string | null,
      lease?:  {
        __typename: "Lease",
        id: string,
        balance?: number | null,
        canBeExtended?: boolean | null,
        communicationSettingsProfileId: string,
        createdAt?: string | null,
        endDate: string,
        includeRealEstateInLeaseContract?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        invoiceSenderId: string,
        inventoryOfFixturesExpert?: string | null,
        inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
        inventoryOfFixturesType?: InventoryOfFixturesType | null,
        ipiNumber?: string | null,
        language: Language,
        lastDraftInvoiceDate?: string | null,
        lastIndexationProcessDate?: string | null,
        lastInvoiceDate?: string | null,
        legalCompetentAuthority?: string | null,
        name: string,
        notes?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        purchaseOrderNumber?: string | null,
        realEstateAgency?: string | null,
        realEstateTax?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        signatureDate?: string | null,
        startDate: string,
        nextIndexationMonth?: string | null,
        nextIndexation?: boolean | null,
        status: LeaseStatus,
        technicCommunicationSettingsProfileId: string,
        totalInitialRentalPrice: number,
        totalRentalPrice: number,
        type: LeaseType,
        subletting?: boolean | null,
        vatRateRentId?: string | null,
        bankAccountId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      leaseId?: string | null,
      leasePriceHistoryId?: string | null,
      leasePriceHistory?:  {
        __typename: "LeasePriceHistory",
        id: string,
        previousTotalRentalPrice: number,
        totalRentalPrice: number,
        optimalTotalRentalPrice?: number | null,
        optimalTotalMonthlyCharges?: number | null,
        applicationDate: string,
        status: LeaseAmountUpdateStatus,
        comment?: string | null,
        type: LeasePriceHistoryType,
        communicationId?: string | null,
        leaseId: string,
        createdAt?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      letterTrackingCode?: string | null,
      letterTrackingProvider?: TrackingProvider | null,
      linkedCommunicationsIds?: Array< string > | null,
      supportingDocumentFileIds?: Array< string > | null,
      recipient?: string | null,
      recipientContactIdsInBcc?: Array< string > | null,
      recipientContactIdsInCc?: Array< string > | null,
      recipientInBcc?: string | null,
      recipientInCc?: string | null,
      scheduledAt?: string | null,
      deliveredAt?: string | null,
      errorCode?: CommunicationErrorCode | null,
      nextRetryAt?: string | null,
      sendRetryCount?: number | null,
      sender?: string | null,
      sentAt?: string | null,
      externalId?: string | null,
      externalStatus?: string | null,
      signatureDocumentId?: string | null,
      signatureDocument?:  {
        __typename: "SignatureDocument",
        id: string,
        additionalMessage?: string | null,
        automaticRemindersDisabled?: boolean | null,
        communicationBody?: string | null,
        createdAt?: string | null,
        expirationDate?: string | null,
        fileIds?: Array< string > | null,
        foreignKey: string,
        foreignTableName: string,
        sentAt?: string | null,
        signatureMethods: Array< SignatureType >,
        status: SignatureDocumentStatus,
        externalStatus?: string | null,
        type: SignatureDocumentType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      snoozedDate?: string | null,
      statement?:  {
        __typename: "Statement",
        id: string,
        closingStatement: boolean,
        periodFrom: string,
        periodTo: string,
        attachSupportingDocuments?: boolean | null,
        selectedPocketKeys?: Array< string > | null,
        source: StatementSource,
        status: StatementStatus,
        sentDate?: string | null,
        leaseId?: string | null,
        ownerId?: string | null,
        types?: Array< StatementType > | null,
        viewType: StatementViewType,
        unitIds?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      statementId?: string | null,
      status: CommunicationStatus,
      subject: string,
      toSend: boolean,
      hideLogo?: boolean | null,
      type: CommunicationType,
      _ttl?: number | null,
      unit?:  {
        __typename: "Unit",
        id: string,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        acquisitionValue?: number | null,
        advertisedMonthlyCharges?: number | null,
        advertisedRentalPrice?: number | null,
        cadastralIncome?: number | null,
        createdAt?: string | null,
        floor?: number | null,
        jointOwnershipId?: string | null,
        managementDate: string,
        name: string,
        notes?: string | null,
        predictedPrice?: string | null,
        propertyTax?: number | null,
        publishAddress?: boolean | null,
        surface?: number | null,
        type: UnitType,
        buildingId: string,
        unitAdvertisementId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      unitId?: string | null,
      readId: string,
      readers?: Array< string > | null,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    createdAt: string,
    creditNote?: boolean | null,
    creditNoteLabel?: string | null,
    customValues?:  Array< {
      __typename: "CustomValue",
      name: string,
      value: string,
    } > | null,
    dueDate?: string | null,
    invoiceDate: string,
    invoiceNumber?: string | null,
    ownerId?: string | null,
    owner?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    invoiceSenderId: string,
    invoiceSender?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    leaseId?: string | null,
    lease?:  {
      __typename: "Lease",
      id: string,
      advancedChargesInvoices?:  {
        __typename: "LeaseAdvancedChargesInvoice",
        communicationSettingsProfileId: string,
        invoiceSenderId: string,
        lastDraftInvoiceDate?: string | null,
        lastInvoiceDate?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        bankAccountId?: string | null,
      } | null,
      balance?: number | null,
      canBeExtended?: boolean | null,
      communicationSettingsProfileId: string,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      endDate: string,
      includeRealEstateInLeaseContract?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      invoiceSenderId: string,
      invoiceSender?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      inventoryOfFixturesExpert?: string | null,
      inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
      inventoryOfFixturesType?: InventoryOfFixturesType | null,
      ipiNumber?: string | null,
      language: Language,
      lastDraftInvoiceDate?: string | null,
      lastIndexationProcessDate?: string | null,
      lastInvoiceDate?: string | null,
      legalCompetentAuthority?: string | null,
      name: string,
      notes?: string | null,
      paymentFrequency: LeasePaymentFrequency,
      paymentInvoicePeriod: LeasePaymentInvoicePeriod,
      paymentInvoicePeriodCustomDay?: number | null,
      paymentOption?:  {
        __typename: "LeasePaymentOption",
        customerId?: string | null,
        enabled: boolean,
        mandateActivatedAt?: string | null,
        mandateStatus?: PaymentProviderMandateStatus | null,
        paymentMethodId?: string | null,
        qrType?: LeaseQrType | null,
      } | null,
      purchaseOrderNumber?: string | null,
      realEstateAgency?: string | null,
      realEstateTax?: number | null,
      remittanceInformation?: string | null,
      remittanceInformationType?: LeaseRemittanceType | null,
      rentalGuaranty?:  {
        __typename: "LeaseRentalGuaranty",
        amount: number,
        blockedAmount?: number | null,
        releasedAmount?: number | null,
        type: LeaseRentalGuarantyType,
        financialInstitution?: string | null,
      } | null,
      signatureDate?: string | null,
      startDate: string,
      nextIndexationMonth?: string | null,
      nextIndexation?: boolean | null,
      status: LeaseStatus,
      technicCommunicationSettingsProfileId: string,
      totalInitialRentalPrice: number,
      totalRentalPrice: number,
      type: LeaseType,
      subletting?: boolean | null,
      vatRateRentId?: string | null,
      vatRateRent?:  {
        __typename: "VatRate",
        id: string,
        country: string,
        label: string,
        value?: number | null,
        ownerId?: string | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      additionalClauses?:  {
        __typename: "ModelLeaseAdditionalClauseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      bankAccountId?: string | null,
      bankAccount?:  {
        __typename: "BankAccount",
        id: string,
        contactId: string,
        number: string,
        bicNumber?: string | null,
        bankName?: string | null,
        contactIds?: Array< string > | null,
        buildingIds?: Array< string > | null,
        holderName?: string | null,
        label?: string | null,
        disabled?: boolean | null,
        integrations?: Array< IntegrationName > | null,
        matchingRule?: BankAccountMatchingRule | null,
        balance?: number | null,
        balanceDate?: string | null,
        type: BankAccountType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contacts?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      files?:  {
        __typename: "ModelFileConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leaseActionHistories?:  {
        __typename: "ModelLeaseActionHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leasePriceHistories?:  {
        __typename: "ModelLeasePriceHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      signatureDocuments?:  {
        __typename: "ModelSignatureDocumentConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      variousOperations?:  {
        __typename: "ModelLeaseVariousOperationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    paid: boolean,
    integrations?:  {
      __typename: "InvoiceIntegrations",
      paymentProperties?:  {
        __typename: "InvoicePaymentProviderProperties",
        availableOn?: string | null,
        error?: string | null,
        feeAmount?: number | null,
        paymentIntentId?: string | null,
        paymentLinkAmount?: number | null,
        paymentLinkUrl?: string | null,
        payoutId?: string | null,
        statementDescriptor?: string | null,
      } | null,
    } | null,
    postedDate?: string | null,
    purchaseOrderNumber?: string | null,
    receiptNumber?: string | null,
    reminderDates?: Array< string > | null,
    note?: string | null,
    remittanceInformation?: string | null,
    statementId?: string | null,
    statement?:  {
      __typename: "Statement",
      id: string,
      amounts?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      chargeStatements?:  {
        __typename: "ModelChargeStatementConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      closingStatement: boolean,
      periodFrom: string,
      periodTo: string,
      attachSupportingDocuments?: boolean | null,
      selectedPocketKeys?: Array< string > | null,
      source: StatementSource,
      status: StatementStatus,
      sentDate?: string | null,
      leaseId?: string | null,
      lease?:  {
        __typename: "Lease",
        id: string,
        balance?: number | null,
        canBeExtended?: boolean | null,
        communicationSettingsProfileId: string,
        createdAt?: string | null,
        endDate: string,
        includeRealEstateInLeaseContract?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        invoiceSenderId: string,
        inventoryOfFixturesExpert?: string | null,
        inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
        inventoryOfFixturesType?: InventoryOfFixturesType | null,
        ipiNumber?: string | null,
        language: Language,
        lastDraftInvoiceDate?: string | null,
        lastIndexationProcessDate?: string | null,
        lastInvoiceDate?: string | null,
        legalCompetentAuthority?: string | null,
        name: string,
        notes?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        purchaseOrderNumber?: string | null,
        realEstateAgency?: string | null,
        realEstateTax?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        signatureDate?: string | null,
        startDate: string,
        nextIndexationMonth?: string | null,
        nextIndexation?: boolean | null,
        status: LeaseStatus,
        technicCommunicationSettingsProfileId: string,
        totalInitialRentalPrice: number,
        totalRentalPrice: number,
        type: LeaseType,
        subletting?: boolean | null,
        vatRateRentId?: string | null,
        bankAccountId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      agencyRateStatements?:  {
        __typename: "ModelAgencyRateStatementConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      ownerId?: string | null,
      owner?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      repaymentStatements?:  {
        __typename: "ModelRepaymentStatementConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      types?: Array< StatementType > | null,
      viewType: StatementViewType,
      unitIds?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    status: InvoiceStatus,
    type: InvoiceType,
    unitId?: string | null,
    unit?:  {
      __typename: "Unit",
      id: string,
      acquisitionAdditionalCostsValue?: number | null,
      acquisitionAdvertisedValue?: number | null,
      acquisitionValue?: number | null,
      advertisedMonthlyCharges?: number | null,
      advertisedRentalPrice?: number | null,
      cadastralIncome?: number | null,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      floor?: number | null,
      jointOwnershipId?: string | null,
      managementDate: string,
      name: string,
      notes?: string | null,
      predictedPrice?: string | null,
      propertyTax?: number | null,
      publishAddress?: boolean | null,
      surface?: number | null,
      type: UnitType,
      buildingId: string,
      building?:  {
        __typename: "Building",
        id: string,
        name: string,
        addressId?: string | null,
        acquisitionValue?: number | null,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        amountOfFacades?: number | null,
        amountOfFloors?: number | null,
        amountOfHousings?: number | null,
        buildingState?: BuildingState | null,
        cadastralIncome?: number | null,
        constructionYear?: string | null,
        janitor?: boolean | null,
        jointOwnershipId?: string | null,
        notes?: string | null,
        propertyTax?: number | null,
        residenceName?: string | null,
        buildingSiteId?: string | null,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      owners?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leases?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      events?:  {
        __typename: "ModelUnitEventConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      unitAdvertisementId?: string | null,
      unitInventories?:  {
        __typename: "ModelUnitInventoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    reversedInvoiceId?: string | null,
    readers?: Array< string > | null,
    readId: string,
    clientId: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteInvoiceSubscriptionVariables = {
  filter?: ModelSubscriptionInvoiceFilterInput | null,
};

export type OnDeleteInvoiceSubscription = {
  onDeleteInvoice?:  {
    __typename: "Invoice",
    id: string,
    amount: number,
    bankAccountId: string,
    bankAccount?:  {
      __typename: "BankAccount",
      id: string,
      contactId: string,
      contact?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      number: string,
      bicNumber?: string | null,
      bankName?: string | null,
      contactIds?: Array< string > | null,
      buildingIds?: Array< string > | null,
      holderName?: string | null,
      label?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      disabled?: boolean | null,
      integrations?: Array< IntegrationName > | null,
      matchingRule?: BankAccountMatchingRule | null,
      balance?: number | null,
      balanceDate?: string | null,
      type: BankAccountType,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    communicationId?: string | null,
    communication?:  {
      __typename: "Communication",
      id: string,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      blockedRecipients?:  Array< {
        __typename: "CommunicationBlockedRecipient",
        recipient: string,
        bounceType: BounceType,
      } > | null,
      body: string,
      buildingId?: string | null,
      channel: CommunicationChannel,
      communicationTemplateId?: string | null,
      concernedContactIds?: Array< string > | null,
      contactId?: string | null,
      contactIds?: Array< string > | null,
      createdAt?: string | null,
      draftProperties?:  {
        __typename: "CommunicationDraftProperties",
        allowRecipientsToSeeEachOther?: boolean | null,
        bcc?: Array< string > | null,
        buildingIds?: Array< string > | null,
        cc?: Array< string > | null,
        contactIds?: Array< string > | null,
        contactTypes?: Array< ContactType > | null,
        entityType: string,
        leaseIds?: Array< string > | null,
        sendInBcc?: boolean | null,
        unitIds?: Array< string > | null,
        unitTypeFilter?: string | null,
      } | null,
      expirationDate?: string | null,
      files?:  {
        __typename: "ModelFileConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      invoice?:  {
        __typename: "Invoice",
        id: string,
        amount: number,
        bankAccountId: string,
        communicationId?: string | null,
        createdAt: string,
        creditNote?: boolean | null,
        creditNoteLabel?: string | null,
        dueDate?: string | null,
        invoiceDate: string,
        invoiceNumber?: string | null,
        ownerId?: string | null,
        invoiceSenderId: string,
        leaseId?: string | null,
        paid: boolean,
        postedDate?: string | null,
        purchaseOrderNumber?: string | null,
        receiptNumber?: string | null,
        reminderDates?: Array< string > | null,
        note?: string | null,
        remittanceInformation?: string | null,
        statementId?: string | null,
        status: InvoiceStatus,
        type: InvoiceType,
        unitId?: string | null,
        reversedInvoiceId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      invoiceId?: string | null,
      lease?:  {
        __typename: "Lease",
        id: string,
        balance?: number | null,
        canBeExtended?: boolean | null,
        communicationSettingsProfileId: string,
        createdAt?: string | null,
        endDate: string,
        includeRealEstateInLeaseContract?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        invoiceSenderId: string,
        inventoryOfFixturesExpert?: string | null,
        inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
        inventoryOfFixturesType?: InventoryOfFixturesType | null,
        ipiNumber?: string | null,
        language: Language,
        lastDraftInvoiceDate?: string | null,
        lastIndexationProcessDate?: string | null,
        lastInvoiceDate?: string | null,
        legalCompetentAuthority?: string | null,
        name: string,
        notes?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        purchaseOrderNumber?: string | null,
        realEstateAgency?: string | null,
        realEstateTax?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        signatureDate?: string | null,
        startDate: string,
        nextIndexationMonth?: string | null,
        nextIndexation?: boolean | null,
        status: LeaseStatus,
        technicCommunicationSettingsProfileId: string,
        totalInitialRentalPrice: number,
        totalRentalPrice: number,
        type: LeaseType,
        subletting?: boolean | null,
        vatRateRentId?: string | null,
        bankAccountId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      leaseId?: string | null,
      leasePriceHistoryId?: string | null,
      leasePriceHistory?:  {
        __typename: "LeasePriceHistory",
        id: string,
        previousTotalRentalPrice: number,
        totalRentalPrice: number,
        optimalTotalRentalPrice?: number | null,
        optimalTotalMonthlyCharges?: number | null,
        applicationDate: string,
        status: LeaseAmountUpdateStatus,
        comment?: string | null,
        type: LeasePriceHistoryType,
        communicationId?: string | null,
        leaseId: string,
        createdAt?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      letterTrackingCode?: string | null,
      letterTrackingProvider?: TrackingProvider | null,
      linkedCommunicationsIds?: Array< string > | null,
      supportingDocumentFileIds?: Array< string > | null,
      recipient?: string | null,
      recipientContactIdsInBcc?: Array< string > | null,
      recipientContactIdsInCc?: Array< string > | null,
      recipientInBcc?: string | null,
      recipientInCc?: string | null,
      scheduledAt?: string | null,
      deliveredAt?: string | null,
      errorCode?: CommunicationErrorCode | null,
      nextRetryAt?: string | null,
      sendRetryCount?: number | null,
      sender?: string | null,
      sentAt?: string | null,
      externalId?: string | null,
      externalStatus?: string | null,
      signatureDocumentId?: string | null,
      signatureDocument?:  {
        __typename: "SignatureDocument",
        id: string,
        additionalMessage?: string | null,
        automaticRemindersDisabled?: boolean | null,
        communicationBody?: string | null,
        createdAt?: string | null,
        expirationDate?: string | null,
        fileIds?: Array< string > | null,
        foreignKey: string,
        foreignTableName: string,
        sentAt?: string | null,
        signatureMethods: Array< SignatureType >,
        status: SignatureDocumentStatus,
        externalStatus?: string | null,
        type: SignatureDocumentType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      snoozedDate?: string | null,
      statement?:  {
        __typename: "Statement",
        id: string,
        closingStatement: boolean,
        periodFrom: string,
        periodTo: string,
        attachSupportingDocuments?: boolean | null,
        selectedPocketKeys?: Array< string > | null,
        source: StatementSource,
        status: StatementStatus,
        sentDate?: string | null,
        leaseId?: string | null,
        ownerId?: string | null,
        types?: Array< StatementType > | null,
        viewType: StatementViewType,
        unitIds?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      statementId?: string | null,
      status: CommunicationStatus,
      subject: string,
      toSend: boolean,
      hideLogo?: boolean | null,
      type: CommunicationType,
      _ttl?: number | null,
      unit?:  {
        __typename: "Unit",
        id: string,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        acquisitionValue?: number | null,
        advertisedMonthlyCharges?: number | null,
        advertisedRentalPrice?: number | null,
        cadastralIncome?: number | null,
        createdAt?: string | null,
        floor?: number | null,
        jointOwnershipId?: string | null,
        managementDate: string,
        name: string,
        notes?: string | null,
        predictedPrice?: string | null,
        propertyTax?: number | null,
        publishAddress?: boolean | null,
        surface?: number | null,
        type: UnitType,
        buildingId: string,
        unitAdvertisementId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      unitId?: string | null,
      readId: string,
      readers?: Array< string > | null,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    createdAt: string,
    creditNote?: boolean | null,
    creditNoteLabel?: string | null,
    customValues?:  Array< {
      __typename: "CustomValue",
      name: string,
      value: string,
    } > | null,
    dueDate?: string | null,
    invoiceDate: string,
    invoiceNumber?: string | null,
    ownerId?: string | null,
    owner?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    invoiceSenderId: string,
    invoiceSender?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    leaseId?: string | null,
    lease?:  {
      __typename: "Lease",
      id: string,
      advancedChargesInvoices?:  {
        __typename: "LeaseAdvancedChargesInvoice",
        communicationSettingsProfileId: string,
        invoiceSenderId: string,
        lastDraftInvoiceDate?: string | null,
        lastInvoiceDate?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        bankAccountId?: string | null,
      } | null,
      balance?: number | null,
      canBeExtended?: boolean | null,
      communicationSettingsProfileId: string,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      endDate: string,
      includeRealEstateInLeaseContract?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      invoiceSenderId: string,
      invoiceSender?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      inventoryOfFixturesExpert?: string | null,
      inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
      inventoryOfFixturesType?: InventoryOfFixturesType | null,
      ipiNumber?: string | null,
      language: Language,
      lastDraftInvoiceDate?: string | null,
      lastIndexationProcessDate?: string | null,
      lastInvoiceDate?: string | null,
      legalCompetentAuthority?: string | null,
      name: string,
      notes?: string | null,
      paymentFrequency: LeasePaymentFrequency,
      paymentInvoicePeriod: LeasePaymentInvoicePeriod,
      paymentInvoicePeriodCustomDay?: number | null,
      paymentOption?:  {
        __typename: "LeasePaymentOption",
        customerId?: string | null,
        enabled: boolean,
        mandateActivatedAt?: string | null,
        mandateStatus?: PaymentProviderMandateStatus | null,
        paymentMethodId?: string | null,
        qrType?: LeaseQrType | null,
      } | null,
      purchaseOrderNumber?: string | null,
      realEstateAgency?: string | null,
      realEstateTax?: number | null,
      remittanceInformation?: string | null,
      remittanceInformationType?: LeaseRemittanceType | null,
      rentalGuaranty?:  {
        __typename: "LeaseRentalGuaranty",
        amount: number,
        blockedAmount?: number | null,
        releasedAmount?: number | null,
        type: LeaseRentalGuarantyType,
        financialInstitution?: string | null,
      } | null,
      signatureDate?: string | null,
      startDate: string,
      nextIndexationMonth?: string | null,
      nextIndexation?: boolean | null,
      status: LeaseStatus,
      technicCommunicationSettingsProfileId: string,
      totalInitialRentalPrice: number,
      totalRentalPrice: number,
      type: LeaseType,
      subletting?: boolean | null,
      vatRateRentId?: string | null,
      vatRateRent?:  {
        __typename: "VatRate",
        id: string,
        country: string,
        label: string,
        value?: number | null,
        ownerId?: string | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      additionalClauses?:  {
        __typename: "ModelLeaseAdditionalClauseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      bankAccountId?: string | null,
      bankAccount?:  {
        __typename: "BankAccount",
        id: string,
        contactId: string,
        number: string,
        bicNumber?: string | null,
        bankName?: string | null,
        contactIds?: Array< string > | null,
        buildingIds?: Array< string > | null,
        holderName?: string | null,
        label?: string | null,
        disabled?: boolean | null,
        integrations?: Array< IntegrationName > | null,
        matchingRule?: BankAccountMatchingRule | null,
        balance?: number | null,
        balanceDate?: string | null,
        type: BankAccountType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contacts?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      files?:  {
        __typename: "ModelFileConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leaseActionHistories?:  {
        __typename: "ModelLeaseActionHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leasePriceHistories?:  {
        __typename: "ModelLeasePriceHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      signatureDocuments?:  {
        __typename: "ModelSignatureDocumentConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      variousOperations?:  {
        __typename: "ModelLeaseVariousOperationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    paid: boolean,
    integrations?:  {
      __typename: "InvoiceIntegrations",
      paymentProperties?:  {
        __typename: "InvoicePaymentProviderProperties",
        availableOn?: string | null,
        error?: string | null,
        feeAmount?: number | null,
        paymentIntentId?: string | null,
        paymentLinkAmount?: number | null,
        paymentLinkUrl?: string | null,
        payoutId?: string | null,
        statementDescriptor?: string | null,
      } | null,
    } | null,
    postedDate?: string | null,
    purchaseOrderNumber?: string | null,
    receiptNumber?: string | null,
    reminderDates?: Array< string > | null,
    note?: string | null,
    remittanceInformation?: string | null,
    statementId?: string | null,
    statement?:  {
      __typename: "Statement",
      id: string,
      amounts?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      chargeStatements?:  {
        __typename: "ModelChargeStatementConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      closingStatement: boolean,
      periodFrom: string,
      periodTo: string,
      attachSupportingDocuments?: boolean | null,
      selectedPocketKeys?: Array< string > | null,
      source: StatementSource,
      status: StatementStatus,
      sentDate?: string | null,
      leaseId?: string | null,
      lease?:  {
        __typename: "Lease",
        id: string,
        balance?: number | null,
        canBeExtended?: boolean | null,
        communicationSettingsProfileId: string,
        createdAt?: string | null,
        endDate: string,
        includeRealEstateInLeaseContract?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        invoiceSenderId: string,
        inventoryOfFixturesExpert?: string | null,
        inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
        inventoryOfFixturesType?: InventoryOfFixturesType | null,
        ipiNumber?: string | null,
        language: Language,
        lastDraftInvoiceDate?: string | null,
        lastIndexationProcessDate?: string | null,
        lastInvoiceDate?: string | null,
        legalCompetentAuthority?: string | null,
        name: string,
        notes?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        purchaseOrderNumber?: string | null,
        realEstateAgency?: string | null,
        realEstateTax?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        signatureDate?: string | null,
        startDate: string,
        nextIndexationMonth?: string | null,
        nextIndexation?: boolean | null,
        status: LeaseStatus,
        technicCommunicationSettingsProfileId: string,
        totalInitialRentalPrice: number,
        totalRentalPrice: number,
        type: LeaseType,
        subletting?: boolean | null,
        vatRateRentId?: string | null,
        bankAccountId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      agencyRateStatements?:  {
        __typename: "ModelAgencyRateStatementConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      ownerId?: string | null,
      owner?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      repaymentStatements?:  {
        __typename: "ModelRepaymentStatementConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      types?: Array< StatementType > | null,
      viewType: StatementViewType,
      unitIds?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    status: InvoiceStatus,
    type: InvoiceType,
    unitId?: string | null,
    unit?:  {
      __typename: "Unit",
      id: string,
      acquisitionAdditionalCostsValue?: number | null,
      acquisitionAdvertisedValue?: number | null,
      acquisitionValue?: number | null,
      advertisedMonthlyCharges?: number | null,
      advertisedRentalPrice?: number | null,
      cadastralIncome?: number | null,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      floor?: number | null,
      jointOwnershipId?: string | null,
      managementDate: string,
      name: string,
      notes?: string | null,
      predictedPrice?: string | null,
      propertyTax?: number | null,
      publishAddress?: boolean | null,
      surface?: number | null,
      type: UnitType,
      buildingId: string,
      building?:  {
        __typename: "Building",
        id: string,
        name: string,
        addressId?: string | null,
        acquisitionValue?: number | null,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        amountOfFacades?: number | null,
        amountOfFloors?: number | null,
        amountOfHousings?: number | null,
        buildingState?: BuildingState | null,
        cadastralIncome?: number | null,
        constructionYear?: string | null,
        janitor?: boolean | null,
        jointOwnershipId?: string | null,
        notes?: string | null,
        propertyTax?: number | null,
        residenceName?: string | null,
        buildingSiteId?: string | null,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      owners?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leases?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      events?:  {
        __typename: "ModelUnitEventConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      unitAdvertisementId?: string | null,
      unitInventories?:  {
        __typename: "ModelUnitInventoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    reversedInvoiceId?: string | null,
    readers?: Array< string > | null,
    readId: string,
    clientId: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateLeaseSubscriptionVariables = {
  filter?: ModelSubscriptionLeaseFilterInput | null,
};

export type OnCreateLeaseSubscription = {
  onCreateLease?:  {
    __typename: "Lease",
    id: string,
    advancedChargesInvoices?:  {
      __typename: "LeaseAdvancedChargesInvoice",
      communicationSettingsProfileId: string,
      invoiceSenderId: string,
      lastDraftInvoiceDate?: string | null,
      lastInvoiceDate?: string | null,
      paymentFrequency: LeasePaymentFrequency,
      paymentInvoicePeriod: LeasePaymentInvoicePeriod,
      paymentInvoicePeriodCustomDay?: number | null,
      remittanceInformation?: string | null,
      remittanceInformationType?: LeaseRemittanceType | null,
      bankAccountId?: string | null,
    } | null,
    balance?: number | null,
    canBeExtended?: boolean | null,
    communicationSettingsProfileId: string,
    createdAt?: string | null,
    customValues?:  Array< {
      __typename: "CustomValue",
      name: string,
      value: string,
    } > | null,
    endDate: string,
    includeRealEstateInLeaseContract?: boolean | null,
    attachStatementSupportingDocuments?: boolean | null,
    invoiceSenderId: string,
    invoiceSender?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    inventoryOfFixturesExpert?: string | null,
    inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
    inventoryOfFixturesType?: InventoryOfFixturesType | null,
    ipiNumber?: string | null,
    language: Language,
    lastDraftInvoiceDate?: string | null,
    lastIndexationProcessDate?: string | null,
    lastInvoiceDate?: string | null,
    legalCompetentAuthority?: string | null,
    name: string,
    notes?: string | null,
    paymentFrequency: LeasePaymentFrequency,
    paymentInvoicePeriod: LeasePaymentInvoicePeriod,
    paymentInvoicePeriodCustomDay?: number | null,
    paymentOption?:  {
      __typename: "LeasePaymentOption",
      customerId?: string | null,
      enabled: boolean,
      mandateActivatedAt?: string | null,
      mandateStatus?: PaymentProviderMandateStatus | null,
      paymentMethodId?: string | null,
      qrType?: LeaseQrType | null,
    } | null,
    purchaseOrderNumber?: string | null,
    realEstateAgency?: string | null,
    realEstateTax?: number | null,
    remittanceInformation?: string | null,
    remittanceInformationType?: LeaseRemittanceType | null,
    rentalGuaranty?:  {
      __typename: "LeaseRentalGuaranty",
      amount: number,
      blockedAmount?: number | null,
      releasedAmount?: number | null,
      type: LeaseRentalGuarantyType,
      financialInstitution?: string | null,
    } | null,
    signatureDate?: string | null,
    startDate: string,
    nextIndexationMonth?: string | null,
    nextIndexation?: boolean | null,
    status: LeaseStatus,
    technicCommunicationSettingsProfileId: string,
    totalInitialRentalPrice: number,
    totalRentalPrice: number,
    type: LeaseType,
    subletting?: boolean | null,
    vatRateRentId?: string | null,
    vatRateRent?:  {
      __typename: "VatRate",
      id: string,
      country: string,
      label: string,
      value?: number | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      ownerId?: string | null,
      owner?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    additionalClauses?:  {
      __typename: "ModelLeaseAdditionalClauseConnection",
      items:  Array< {
        __typename: "LeaseAdditionalClause",
        id: string,
        leaseId: string,
        title?: string | null,
        body: string,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    bankAccountId?: string | null,
    bankAccount?:  {
      __typename: "BankAccount",
      id: string,
      contactId: string,
      contact?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      number: string,
      bicNumber?: string | null,
      bankName?: string | null,
      contactIds?: Array< string > | null,
      buildingIds?: Array< string > | null,
      holderName?: string | null,
      label?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      disabled?: boolean | null,
      integrations?: Array< IntegrationName > | null,
      matchingRule?: BankAccountMatchingRule | null,
      balance?: number | null,
      balanceDate?: string | null,
      type: BankAccountType,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    contacts?:  {
      __typename: "ModelLeaseContactConnection",
      items:  Array< {
        __typename: "LeaseContact",
        id: string,
        leaseId: string,
        contactId: string,
        contactRole: ContactType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    files?:  {
      __typename: "ModelFileConnection",
      items:  Array< {
        __typename: "File",
        id: string,
        bucket: string,
        createdAt?: string | null,
        categoryId: string,
        foreignKey: string,
        foreignTableName: string,
        key: string,
        mimeType?: string | null,
        region: string,
        size?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        _ttl?: number | null,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    leaseActionHistories?:  {
      __typename: "ModelLeaseActionHistoryConnection",
      items:  Array< {
        __typename: "LeaseActionHistory",
        id: string,
        action: LeaseAction,
        comment?: string | null,
        contactId: string,
        createdAt?: string | null,
        leaseId: string,
        communicationId?: string | null,
        signatureDocumentId?: string | null,
        status?: LeaseActionHistoryStatus | null,
        communicationChannel?: CommunicationChannel | null,
        communicationSendDate?: string | null,
        communicationByPlatform?: boolean | null,
        endReason?: LeaseActionEndReason | null,
        endReasonOwnUseRelation?: string | null,
        endReasonOwnUseName?: string | null,
        initiator?: LeaseActionEndInitiator | null,
        totalAmount?: number | null,
        totalAmountLabel?: string | null,
        automatic?: boolean | null,
        hasLeaseTypeChanged?: boolean | null,
        jiraId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    leasePriceHistories?:  {
      __typename: "ModelLeasePriceHistoryConnection",
      items:  Array< {
        __typename: "LeasePriceHistory",
        id: string,
        previousTotalRentalPrice: number,
        totalRentalPrice: number,
        optimalTotalRentalPrice?: number | null,
        optimalTotalMonthlyCharges?: number | null,
        applicationDate: string,
        status: LeaseAmountUpdateStatus,
        comment?: string | null,
        type: LeasePriceHistoryType,
        communicationId?: string | null,
        leaseId: string,
        createdAt?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    signatureDocuments?:  {
      __typename: "ModelSignatureDocumentConnection",
      items:  Array< {
        __typename: "SignatureDocument",
        id: string,
        additionalMessage?: string | null,
        automaticRemindersDisabled?: boolean | null,
        communicationBody?: string | null,
        createdAt?: string | null,
        expirationDate?: string | null,
        fileIds?: Array< string > | null,
        foreignKey: string,
        foreignTableName: string,
        sentAt?: string | null,
        signatureMethods: Array< SignatureType >,
        status: SignatureDocumentStatus,
        externalStatus?: string | null,
        type: SignatureDocumentType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    units?:  {
      __typename: "ModelUnitLeaseConnection",
      items:  Array< {
        __typename: "UnitLease",
        id: string,
        allowChargeAdjustment?: boolean | null,
        authorizeProfessionalActivity?: boolean | null,
        chargesIndexation?: boolean | null,
        createdAt?: string | null,
        endDate: string,
        furnishedRental?: boolean | null,
        furnishedRentalInsuranceByTenant?: boolean | null,
        furnishedRentalRentalPricePercentage?: number | null,
        initialRentalPrice: number,
        indexation?: boolean | null,
        advancedIndexation?: boolean | null,
        indexType?: IndexType | null,
        baseYear?: number | null,
        baseIndexType?: BaseIndexType | null,
        baseIndexDate?: string | null,
        nextIndexationMonth?: string | null,
        nextIndexation?: boolean | null,
        leaseId: string,
        mainUnit: boolean,
        rentalPrice: number,
        signatureDate?: string | null,
        startDate: string,
        unitId: string,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    variousOperations?:  {
      __typename: "ModelLeaseVariousOperationConnection",
      items:  Array< {
        __typename: "LeaseVariousOperation",
        id: string,
        accountLabelIds?: Array< string > | null,
        amount: number,
        contactId: string,
        createdAt: string,
        endDate: string,
        invoiceSenderId?: string | null,
        label?: string | null,
        lastInvoiceDate?: string | null,
        leaseId: string,
        operationType: LeaseVariousOperationType,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        reason?: string | null,
        separateInvoice: boolean,
        startDate: string,
        type: VariousOperationType,
        unitId: string,
        vatRateId?: string | null,
        readId: string,
        readers?: Array< string > | null,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    readers?: Array< string > | null,
    readId: string,
    clientId: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateLeaseSubscriptionVariables = {
  filter?: ModelSubscriptionLeaseFilterInput | null,
};

export type OnUpdateLeaseSubscription = {
  onUpdateLease?:  {
    __typename: "Lease",
    id: string,
    advancedChargesInvoices?:  {
      __typename: "LeaseAdvancedChargesInvoice",
      communicationSettingsProfileId: string,
      invoiceSenderId: string,
      lastDraftInvoiceDate?: string | null,
      lastInvoiceDate?: string | null,
      paymentFrequency: LeasePaymentFrequency,
      paymentInvoicePeriod: LeasePaymentInvoicePeriod,
      paymentInvoicePeriodCustomDay?: number | null,
      remittanceInformation?: string | null,
      remittanceInformationType?: LeaseRemittanceType | null,
      bankAccountId?: string | null,
    } | null,
    balance?: number | null,
    canBeExtended?: boolean | null,
    communicationSettingsProfileId: string,
    createdAt?: string | null,
    customValues?:  Array< {
      __typename: "CustomValue",
      name: string,
      value: string,
    } > | null,
    endDate: string,
    includeRealEstateInLeaseContract?: boolean | null,
    attachStatementSupportingDocuments?: boolean | null,
    invoiceSenderId: string,
    invoiceSender?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    inventoryOfFixturesExpert?: string | null,
    inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
    inventoryOfFixturesType?: InventoryOfFixturesType | null,
    ipiNumber?: string | null,
    language: Language,
    lastDraftInvoiceDate?: string | null,
    lastIndexationProcessDate?: string | null,
    lastInvoiceDate?: string | null,
    legalCompetentAuthority?: string | null,
    name: string,
    notes?: string | null,
    paymentFrequency: LeasePaymentFrequency,
    paymentInvoicePeriod: LeasePaymentInvoicePeriod,
    paymentInvoicePeriodCustomDay?: number | null,
    paymentOption?:  {
      __typename: "LeasePaymentOption",
      customerId?: string | null,
      enabled: boolean,
      mandateActivatedAt?: string | null,
      mandateStatus?: PaymentProviderMandateStatus | null,
      paymentMethodId?: string | null,
      qrType?: LeaseQrType | null,
    } | null,
    purchaseOrderNumber?: string | null,
    realEstateAgency?: string | null,
    realEstateTax?: number | null,
    remittanceInformation?: string | null,
    remittanceInformationType?: LeaseRemittanceType | null,
    rentalGuaranty?:  {
      __typename: "LeaseRentalGuaranty",
      amount: number,
      blockedAmount?: number | null,
      releasedAmount?: number | null,
      type: LeaseRentalGuarantyType,
      financialInstitution?: string | null,
    } | null,
    signatureDate?: string | null,
    startDate: string,
    nextIndexationMonth?: string | null,
    nextIndexation?: boolean | null,
    status: LeaseStatus,
    technicCommunicationSettingsProfileId: string,
    totalInitialRentalPrice: number,
    totalRentalPrice: number,
    type: LeaseType,
    subletting?: boolean | null,
    vatRateRentId?: string | null,
    vatRateRent?:  {
      __typename: "VatRate",
      id: string,
      country: string,
      label: string,
      value?: number | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      ownerId?: string | null,
      owner?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    additionalClauses?:  {
      __typename: "ModelLeaseAdditionalClauseConnection",
      items:  Array< {
        __typename: "LeaseAdditionalClause",
        id: string,
        leaseId: string,
        title?: string | null,
        body: string,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    bankAccountId?: string | null,
    bankAccount?:  {
      __typename: "BankAccount",
      id: string,
      contactId: string,
      contact?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      number: string,
      bicNumber?: string | null,
      bankName?: string | null,
      contactIds?: Array< string > | null,
      buildingIds?: Array< string > | null,
      holderName?: string | null,
      label?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      disabled?: boolean | null,
      integrations?: Array< IntegrationName > | null,
      matchingRule?: BankAccountMatchingRule | null,
      balance?: number | null,
      balanceDate?: string | null,
      type: BankAccountType,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    contacts?:  {
      __typename: "ModelLeaseContactConnection",
      items:  Array< {
        __typename: "LeaseContact",
        id: string,
        leaseId: string,
        contactId: string,
        contactRole: ContactType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    files?:  {
      __typename: "ModelFileConnection",
      items:  Array< {
        __typename: "File",
        id: string,
        bucket: string,
        createdAt?: string | null,
        categoryId: string,
        foreignKey: string,
        foreignTableName: string,
        key: string,
        mimeType?: string | null,
        region: string,
        size?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        _ttl?: number | null,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    leaseActionHistories?:  {
      __typename: "ModelLeaseActionHistoryConnection",
      items:  Array< {
        __typename: "LeaseActionHistory",
        id: string,
        action: LeaseAction,
        comment?: string | null,
        contactId: string,
        createdAt?: string | null,
        leaseId: string,
        communicationId?: string | null,
        signatureDocumentId?: string | null,
        status?: LeaseActionHistoryStatus | null,
        communicationChannel?: CommunicationChannel | null,
        communicationSendDate?: string | null,
        communicationByPlatform?: boolean | null,
        endReason?: LeaseActionEndReason | null,
        endReasonOwnUseRelation?: string | null,
        endReasonOwnUseName?: string | null,
        initiator?: LeaseActionEndInitiator | null,
        totalAmount?: number | null,
        totalAmountLabel?: string | null,
        automatic?: boolean | null,
        hasLeaseTypeChanged?: boolean | null,
        jiraId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    leasePriceHistories?:  {
      __typename: "ModelLeasePriceHistoryConnection",
      items:  Array< {
        __typename: "LeasePriceHistory",
        id: string,
        previousTotalRentalPrice: number,
        totalRentalPrice: number,
        optimalTotalRentalPrice?: number | null,
        optimalTotalMonthlyCharges?: number | null,
        applicationDate: string,
        status: LeaseAmountUpdateStatus,
        comment?: string | null,
        type: LeasePriceHistoryType,
        communicationId?: string | null,
        leaseId: string,
        createdAt?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    signatureDocuments?:  {
      __typename: "ModelSignatureDocumentConnection",
      items:  Array< {
        __typename: "SignatureDocument",
        id: string,
        additionalMessage?: string | null,
        automaticRemindersDisabled?: boolean | null,
        communicationBody?: string | null,
        createdAt?: string | null,
        expirationDate?: string | null,
        fileIds?: Array< string > | null,
        foreignKey: string,
        foreignTableName: string,
        sentAt?: string | null,
        signatureMethods: Array< SignatureType >,
        status: SignatureDocumentStatus,
        externalStatus?: string | null,
        type: SignatureDocumentType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    units?:  {
      __typename: "ModelUnitLeaseConnection",
      items:  Array< {
        __typename: "UnitLease",
        id: string,
        allowChargeAdjustment?: boolean | null,
        authorizeProfessionalActivity?: boolean | null,
        chargesIndexation?: boolean | null,
        createdAt?: string | null,
        endDate: string,
        furnishedRental?: boolean | null,
        furnishedRentalInsuranceByTenant?: boolean | null,
        furnishedRentalRentalPricePercentage?: number | null,
        initialRentalPrice: number,
        indexation?: boolean | null,
        advancedIndexation?: boolean | null,
        indexType?: IndexType | null,
        baseYear?: number | null,
        baseIndexType?: BaseIndexType | null,
        baseIndexDate?: string | null,
        nextIndexationMonth?: string | null,
        nextIndexation?: boolean | null,
        leaseId: string,
        mainUnit: boolean,
        rentalPrice: number,
        signatureDate?: string | null,
        startDate: string,
        unitId: string,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    variousOperations?:  {
      __typename: "ModelLeaseVariousOperationConnection",
      items:  Array< {
        __typename: "LeaseVariousOperation",
        id: string,
        accountLabelIds?: Array< string > | null,
        amount: number,
        contactId: string,
        createdAt: string,
        endDate: string,
        invoiceSenderId?: string | null,
        label?: string | null,
        lastInvoiceDate?: string | null,
        leaseId: string,
        operationType: LeaseVariousOperationType,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        reason?: string | null,
        separateInvoice: boolean,
        startDate: string,
        type: VariousOperationType,
        unitId: string,
        vatRateId?: string | null,
        readId: string,
        readers?: Array< string > | null,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    readers?: Array< string > | null,
    readId: string,
    clientId: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteLeaseSubscriptionVariables = {
  filter?: ModelSubscriptionLeaseFilterInput | null,
};

export type OnDeleteLeaseSubscription = {
  onDeleteLease?:  {
    __typename: "Lease",
    id: string,
    advancedChargesInvoices?:  {
      __typename: "LeaseAdvancedChargesInvoice",
      communicationSettingsProfileId: string,
      invoiceSenderId: string,
      lastDraftInvoiceDate?: string | null,
      lastInvoiceDate?: string | null,
      paymentFrequency: LeasePaymentFrequency,
      paymentInvoicePeriod: LeasePaymentInvoicePeriod,
      paymentInvoicePeriodCustomDay?: number | null,
      remittanceInformation?: string | null,
      remittanceInformationType?: LeaseRemittanceType | null,
      bankAccountId?: string | null,
    } | null,
    balance?: number | null,
    canBeExtended?: boolean | null,
    communicationSettingsProfileId: string,
    createdAt?: string | null,
    customValues?:  Array< {
      __typename: "CustomValue",
      name: string,
      value: string,
    } > | null,
    endDate: string,
    includeRealEstateInLeaseContract?: boolean | null,
    attachStatementSupportingDocuments?: boolean | null,
    invoiceSenderId: string,
    invoiceSender?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    inventoryOfFixturesExpert?: string | null,
    inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
    inventoryOfFixturesType?: InventoryOfFixturesType | null,
    ipiNumber?: string | null,
    language: Language,
    lastDraftInvoiceDate?: string | null,
    lastIndexationProcessDate?: string | null,
    lastInvoiceDate?: string | null,
    legalCompetentAuthority?: string | null,
    name: string,
    notes?: string | null,
    paymentFrequency: LeasePaymentFrequency,
    paymentInvoicePeriod: LeasePaymentInvoicePeriod,
    paymentInvoicePeriodCustomDay?: number | null,
    paymentOption?:  {
      __typename: "LeasePaymentOption",
      customerId?: string | null,
      enabled: boolean,
      mandateActivatedAt?: string | null,
      mandateStatus?: PaymentProviderMandateStatus | null,
      paymentMethodId?: string | null,
      qrType?: LeaseQrType | null,
    } | null,
    purchaseOrderNumber?: string | null,
    realEstateAgency?: string | null,
    realEstateTax?: number | null,
    remittanceInformation?: string | null,
    remittanceInformationType?: LeaseRemittanceType | null,
    rentalGuaranty?:  {
      __typename: "LeaseRentalGuaranty",
      amount: number,
      blockedAmount?: number | null,
      releasedAmount?: number | null,
      type: LeaseRentalGuarantyType,
      financialInstitution?: string | null,
    } | null,
    signatureDate?: string | null,
    startDate: string,
    nextIndexationMonth?: string | null,
    nextIndexation?: boolean | null,
    status: LeaseStatus,
    technicCommunicationSettingsProfileId: string,
    totalInitialRentalPrice: number,
    totalRentalPrice: number,
    type: LeaseType,
    subletting?: boolean | null,
    vatRateRentId?: string | null,
    vatRateRent?:  {
      __typename: "VatRate",
      id: string,
      country: string,
      label: string,
      value?: number | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      ownerId?: string | null,
      owner?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    additionalClauses?:  {
      __typename: "ModelLeaseAdditionalClauseConnection",
      items:  Array< {
        __typename: "LeaseAdditionalClause",
        id: string,
        leaseId: string,
        title?: string | null,
        body: string,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    bankAccountId?: string | null,
    bankAccount?:  {
      __typename: "BankAccount",
      id: string,
      contactId: string,
      contact?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      number: string,
      bicNumber?: string | null,
      bankName?: string | null,
      contactIds?: Array< string > | null,
      buildingIds?: Array< string > | null,
      holderName?: string | null,
      label?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      disabled?: boolean | null,
      integrations?: Array< IntegrationName > | null,
      matchingRule?: BankAccountMatchingRule | null,
      balance?: number | null,
      balanceDate?: string | null,
      type: BankAccountType,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    contacts?:  {
      __typename: "ModelLeaseContactConnection",
      items:  Array< {
        __typename: "LeaseContact",
        id: string,
        leaseId: string,
        contactId: string,
        contactRole: ContactType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    files?:  {
      __typename: "ModelFileConnection",
      items:  Array< {
        __typename: "File",
        id: string,
        bucket: string,
        createdAt?: string | null,
        categoryId: string,
        foreignKey: string,
        foreignTableName: string,
        key: string,
        mimeType?: string | null,
        region: string,
        size?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        _ttl?: number | null,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    leaseActionHistories?:  {
      __typename: "ModelLeaseActionHistoryConnection",
      items:  Array< {
        __typename: "LeaseActionHistory",
        id: string,
        action: LeaseAction,
        comment?: string | null,
        contactId: string,
        createdAt?: string | null,
        leaseId: string,
        communicationId?: string | null,
        signatureDocumentId?: string | null,
        status?: LeaseActionHistoryStatus | null,
        communicationChannel?: CommunicationChannel | null,
        communicationSendDate?: string | null,
        communicationByPlatform?: boolean | null,
        endReason?: LeaseActionEndReason | null,
        endReasonOwnUseRelation?: string | null,
        endReasonOwnUseName?: string | null,
        initiator?: LeaseActionEndInitiator | null,
        totalAmount?: number | null,
        totalAmountLabel?: string | null,
        automatic?: boolean | null,
        hasLeaseTypeChanged?: boolean | null,
        jiraId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    leasePriceHistories?:  {
      __typename: "ModelLeasePriceHistoryConnection",
      items:  Array< {
        __typename: "LeasePriceHistory",
        id: string,
        previousTotalRentalPrice: number,
        totalRentalPrice: number,
        optimalTotalRentalPrice?: number | null,
        optimalTotalMonthlyCharges?: number | null,
        applicationDate: string,
        status: LeaseAmountUpdateStatus,
        comment?: string | null,
        type: LeasePriceHistoryType,
        communicationId?: string | null,
        leaseId: string,
        createdAt?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    signatureDocuments?:  {
      __typename: "ModelSignatureDocumentConnection",
      items:  Array< {
        __typename: "SignatureDocument",
        id: string,
        additionalMessage?: string | null,
        automaticRemindersDisabled?: boolean | null,
        communicationBody?: string | null,
        createdAt?: string | null,
        expirationDate?: string | null,
        fileIds?: Array< string > | null,
        foreignKey: string,
        foreignTableName: string,
        sentAt?: string | null,
        signatureMethods: Array< SignatureType >,
        status: SignatureDocumentStatus,
        externalStatus?: string | null,
        type: SignatureDocumentType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    units?:  {
      __typename: "ModelUnitLeaseConnection",
      items:  Array< {
        __typename: "UnitLease",
        id: string,
        allowChargeAdjustment?: boolean | null,
        authorizeProfessionalActivity?: boolean | null,
        chargesIndexation?: boolean | null,
        createdAt?: string | null,
        endDate: string,
        furnishedRental?: boolean | null,
        furnishedRentalInsuranceByTenant?: boolean | null,
        furnishedRentalRentalPricePercentage?: number | null,
        initialRentalPrice: number,
        indexation?: boolean | null,
        advancedIndexation?: boolean | null,
        indexType?: IndexType | null,
        baseYear?: number | null,
        baseIndexType?: BaseIndexType | null,
        baseIndexDate?: string | null,
        nextIndexationMonth?: string | null,
        nextIndexation?: boolean | null,
        leaseId: string,
        mainUnit: boolean,
        rentalPrice: number,
        signatureDate?: string | null,
        startDate: string,
        unitId: string,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    variousOperations?:  {
      __typename: "ModelLeaseVariousOperationConnection",
      items:  Array< {
        __typename: "LeaseVariousOperation",
        id: string,
        accountLabelIds?: Array< string > | null,
        amount: number,
        contactId: string,
        createdAt: string,
        endDate: string,
        invoiceSenderId?: string | null,
        label?: string | null,
        lastInvoiceDate?: string | null,
        leaseId: string,
        operationType: LeaseVariousOperationType,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        reason?: string | null,
        separateInvoice: boolean,
        startDate: string,
        type: VariousOperationType,
        unitId: string,
        vatRateId?: string | null,
        readId: string,
        readers?: Array< string > | null,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    readers?: Array< string > | null,
    readId: string,
    clientId: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateLeaseContactSubscriptionVariables = {
  filter?: ModelSubscriptionLeaseContactFilterInput | null,
};

export type OnCreateLeaseContactSubscription = {
  onCreateLeaseContact?:  {
    __typename: "LeaseContact",
    id: string,
    leaseId: string,
    contactId: string,
    lease?:  {
      __typename: "Lease",
      id: string,
      advancedChargesInvoices?:  {
        __typename: "LeaseAdvancedChargesInvoice",
        communicationSettingsProfileId: string,
        invoiceSenderId: string,
        lastDraftInvoiceDate?: string | null,
        lastInvoiceDate?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        bankAccountId?: string | null,
      } | null,
      balance?: number | null,
      canBeExtended?: boolean | null,
      communicationSettingsProfileId: string,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      endDate: string,
      includeRealEstateInLeaseContract?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      invoiceSenderId: string,
      invoiceSender?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      inventoryOfFixturesExpert?: string | null,
      inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
      inventoryOfFixturesType?: InventoryOfFixturesType | null,
      ipiNumber?: string | null,
      language: Language,
      lastDraftInvoiceDate?: string | null,
      lastIndexationProcessDate?: string | null,
      lastInvoiceDate?: string | null,
      legalCompetentAuthority?: string | null,
      name: string,
      notes?: string | null,
      paymentFrequency: LeasePaymentFrequency,
      paymentInvoicePeriod: LeasePaymentInvoicePeriod,
      paymentInvoicePeriodCustomDay?: number | null,
      paymentOption?:  {
        __typename: "LeasePaymentOption",
        customerId?: string | null,
        enabled: boolean,
        mandateActivatedAt?: string | null,
        mandateStatus?: PaymentProviderMandateStatus | null,
        paymentMethodId?: string | null,
        qrType?: LeaseQrType | null,
      } | null,
      purchaseOrderNumber?: string | null,
      realEstateAgency?: string | null,
      realEstateTax?: number | null,
      remittanceInformation?: string | null,
      remittanceInformationType?: LeaseRemittanceType | null,
      rentalGuaranty?:  {
        __typename: "LeaseRentalGuaranty",
        amount: number,
        blockedAmount?: number | null,
        releasedAmount?: number | null,
        type: LeaseRentalGuarantyType,
        financialInstitution?: string | null,
      } | null,
      signatureDate?: string | null,
      startDate: string,
      nextIndexationMonth?: string | null,
      nextIndexation?: boolean | null,
      status: LeaseStatus,
      technicCommunicationSettingsProfileId: string,
      totalInitialRentalPrice: number,
      totalRentalPrice: number,
      type: LeaseType,
      subletting?: boolean | null,
      vatRateRentId?: string | null,
      vatRateRent?:  {
        __typename: "VatRate",
        id: string,
        country: string,
        label: string,
        value?: number | null,
        ownerId?: string | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      additionalClauses?:  {
        __typename: "ModelLeaseAdditionalClauseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      bankAccountId?: string | null,
      bankAccount?:  {
        __typename: "BankAccount",
        id: string,
        contactId: string,
        number: string,
        bicNumber?: string | null,
        bankName?: string | null,
        contactIds?: Array< string > | null,
        buildingIds?: Array< string > | null,
        holderName?: string | null,
        label?: string | null,
        disabled?: boolean | null,
        integrations?: Array< IntegrationName > | null,
        matchingRule?: BankAccountMatchingRule | null,
        balance?: number | null,
        balanceDate?: string | null,
        type: BankAccountType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contacts?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      files?:  {
        __typename: "ModelFileConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leaseActionHistories?:  {
        __typename: "ModelLeaseActionHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leasePriceHistories?:  {
        __typename: "ModelLeasePriceHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      signatureDocuments?:  {
        __typename: "ModelSignatureDocumentConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      variousOperations?:  {
        __typename: "ModelLeaseVariousOperationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    contact?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    contactRole: ContactType,
    readers?: Array< string > | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateLeaseContactSubscriptionVariables = {
  filter?: ModelSubscriptionLeaseContactFilterInput | null,
};

export type OnUpdateLeaseContactSubscription = {
  onUpdateLeaseContact?:  {
    __typename: "LeaseContact",
    id: string,
    leaseId: string,
    contactId: string,
    lease?:  {
      __typename: "Lease",
      id: string,
      advancedChargesInvoices?:  {
        __typename: "LeaseAdvancedChargesInvoice",
        communicationSettingsProfileId: string,
        invoiceSenderId: string,
        lastDraftInvoiceDate?: string | null,
        lastInvoiceDate?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        bankAccountId?: string | null,
      } | null,
      balance?: number | null,
      canBeExtended?: boolean | null,
      communicationSettingsProfileId: string,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      endDate: string,
      includeRealEstateInLeaseContract?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      invoiceSenderId: string,
      invoiceSender?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      inventoryOfFixturesExpert?: string | null,
      inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
      inventoryOfFixturesType?: InventoryOfFixturesType | null,
      ipiNumber?: string | null,
      language: Language,
      lastDraftInvoiceDate?: string | null,
      lastIndexationProcessDate?: string | null,
      lastInvoiceDate?: string | null,
      legalCompetentAuthority?: string | null,
      name: string,
      notes?: string | null,
      paymentFrequency: LeasePaymentFrequency,
      paymentInvoicePeriod: LeasePaymentInvoicePeriod,
      paymentInvoicePeriodCustomDay?: number | null,
      paymentOption?:  {
        __typename: "LeasePaymentOption",
        customerId?: string | null,
        enabled: boolean,
        mandateActivatedAt?: string | null,
        mandateStatus?: PaymentProviderMandateStatus | null,
        paymentMethodId?: string | null,
        qrType?: LeaseQrType | null,
      } | null,
      purchaseOrderNumber?: string | null,
      realEstateAgency?: string | null,
      realEstateTax?: number | null,
      remittanceInformation?: string | null,
      remittanceInformationType?: LeaseRemittanceType | null,
      rentalGuaranty?:  {
        __typename: "LeaseRentalGuaranty",
        amount: number,
        blockedAmount?: number | null,
        releasedAmount?: number | null,
        type: LeaseRentalGuarantyType,
        financialInstitution?: string | null,
      } | null,
      signatureDate?: string | null,
      startDate: string,
      nextIndexationMonth?: string | null,
      nextIndexation?: boolean | null,
      status: LeaseStatus,
      technicCommunicationSettingsProfileId: string,
      totalInitialRentalPrice: number,
      totalRentalPrice: number,
      type: LeaseType,
      subletting?: boolean | null,
      vatRateRentId?: string | null,
      vatRateRent?:  {
        __typename: "VatRate",
        id: string,
        country: string,
        label: string,
        value?: number | null,
        ownerId?: string | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      additionalClauses?:  {
        __typename: "ModelLeaseAdditionalClauseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      bankAccountId?: string | null,
      bankAccount?:  {
        __typename: "BankAccount",
        id: string,
        contactId: string,
        number: string,
        bicNumber?: string | null,
        bankName?: string | null,
        contactIds?: Array< string > | null,
        buildingIds?: Array< string > | null,
        holderName?: string | null,
        label?: string | null,
        disabled?: boolean | null,
        integrations?: Array< IntegrationName > | null,
        matchingRule?: BankAccountMatchingRule | null,
        balance?: number | null,
        balanceDate?: string | null,
        type: BankAccountType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contacts?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      files?:  {
        __typename: "ModelFileConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leaseActionHistories?:  {
        __typename: "ModelLeaseActionHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leasePriceHistories?:  {
        __typename: "ModelLeasePriceHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      signatureDocuments?:  {
        __typename: "ModelSignatureDocumentConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      variousOperations?:  {
        __typename: "ModelLeaseVariousOperationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    contact?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    contactRole: ContactType,
    readers?: Array< string > | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteLeaseContactSubscriptionVariables = {
  filter?: ModelSubscriptionLeaseContactFilterInput | null,
};

export type OnDeleteLeaseContactSubscription = {
  onDeleteLeaseContact?:  {
    __typename: "LeaseContact",
    id: string,
    leaseId: string,
    contactId: string,
    lease?:  {
      __typename: "Lease",
      id: string,
      advancedChargesInvoices?:  {
        __typename: "LeaseAdvancedChargesInvoice",
        communicationSettingsProfileId: string,
        invoiceSenderId: string,
        lastDraftInvoiceDate?: string | null,
        lastInvoiceDate?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        bankAccountId?: string | null,
      } | null,
      balance?: number | null,
      canBeExtended?: boolean | null,
      communicationSettingsProfileId: string,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      endDate: string,
      includeRealEstateInLeaseContract?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      invoiceSenderId: string,
      invoiceSender?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      inventoryOfFixturesExpert?: string | null,
      inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
      inventoryOfFixturesType?: InventoryOfFixturesType | null,
      ipiNumber?: string | null,
      language: Language,
      lastDraftInvoiceDate?: string | null,
      lastIndexationProcessDate?: string | null,
      lastInvoiceDate?: string | null,
      legalCompetentAuthority?: string | null,
      name: string,
      notes?: string | null,
      paymentFrequency: LeasePaymentFrequency,
      paymentInvoicePeriod: LeasePaymentInvoicePeriod,
      paymentInvoicePeriodCustomDay?: number | null,
      paymentOption?:  {
        __typename: "LeasePaymentOption",
        customerId?: string | null,
        enabled: boolean,
        mandateActivatedAt?: string | null,
        mandateStatus?: PaymentProviderMandateStatus | null,
        paymentMethodId?: string | null,
        qrType?: LeaseQrType | null,
      } | null,
      purchaseOrderNumber?: string | null,
      realEstateAgency?: string | null,
      realEstateTax?: number | null,
      remittanceInformation?: string | null,
      remittanceInformationType?: LeaseRemittanceType | null,
      rentalGuaranty?:  {
        __typename: "LeaseRentalGuaranty",
        amount: number,
        blockedAmount?: number | null,
        releasedAmount?: number | null,
        type: LeaseRentalGuarantyType,
        financialInstitution?: string | null,
      } | null,
      signatureDate?: string | null,
      startDate: string,
      nextIndexationMonth?: string | null,
      nextIndexation?: boolean | null,
      status: LeaseStatus,
      technicCommunicationSettingsProfileId: string,
      totalInitialRentalPrice: number,
      totalRentalPrice: number,
      type: LeaseType,
      subletting?: boolean | null,
      vatRateRentId?: string | null,
      vatRateRent?:  {
        __typename: "VatRate",
        id: string,
        country: string,
        label: string,
        value?: number | null,
        ownerId?: string | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      additionalClauses?:  {
        __typename: "ModelLeaseAdditionalClauseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      bankAccountId?: string | null,
      bankAccount?:  {
        __typename: "BankAccount",
        id: string,
        contactId: string,
        number: string,
        bicNumber?: string | null,
        bankName?: string | null,
        contactIds?: Array< string > | null,
        buildingIds?: Array< string > | null,
        holderName?: string | null,
        label?: string | null,
        disabled?: boolean | null,
        integrations?: Array< IntegrationName > | null,
        matchingRule?: BankAccountMatchingRule | null,
        balance?: number | null,
        balanceDate?: string | null,
        type: BankAccountType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contacts?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      files?:  {
        __typename: "ModelFileConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leaseActionHistories?:  {
        __typename: "ModelLeaseActionHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leasePriceHistories?:  {
        __typename: "ModelLeasePriceHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      signatureDocuments?:  {
        __typename: "ModelSignatureDocumentConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      variousOperations?:  {
        __typename: "ModelLeaseVariousOperationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    contact?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    contactRole: ContactType,
    readers?: Array< string > | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateLeasePriceHistorySubscriptionVariables = {
  filter?: ModelSubscriptionLeasePriceHistoryFilterInput | null,
};

export type OnCreateLeasePriceHistorySubscription = {
  onCreateLeasePriceHistory?:  {
    __typename: "LeasePriceHistory",
    id: string,
    previousTotalRentalPrice: number,
    totalRentalPrice: number,
    optimalTotalRentalPrice?: number | null,
    optimalTotalMonthlyCharges?: number | null,
    applicationDate: string,
    status: LeaseAmountUpdateStatus,
    comment?: string | null,
    amountDetails:  Array< {
      __typename: "LeasePriceHistoryDetail",
      unitId: string,
      indexationBaseIndex?: number | null,
      indexationNewIndex?: number | null,
      previousRentalPrice: number,
      newRentalPrice: number,
      rentalStatus: LeasePriceHistoryStatus,
      monthlyChargesStatus: LeasePriceHistoryStatus,
      optimalNewRentalPrice?: number | null,
      optimalNewMonthlyChargesPrice?: number | null,
      epb?: string | null,
      epbIssueDate?: string | null,
      oldestIndexForCorrectionFactorCalculation?: number | null,
      newestIndexForCorrectionFactorCalculation?: number | null,
      rentIndexedPriceAfterNewEpbReduction?: number | null,
      chargesIndexedPriceAfterNewEpbReduction?: number | null,
      correctionFactor?: number | null,
      chargesAmountsDetails?:  Array< {
        __typename: "LeasePriceHistoryChargeAmountsDetails",
        leaseVariousOperationId: string,
        previousMonthlyAmount: number,
        newMonthlyAmount: number,
        indexationBaseIndex?: number | null,
        indexationBaseAmount?: number | null,
        indexationBaseIndexDate?: string | null,
        indexed?: boolean | null,
      } > | null,
      reductionPercentage?: number | null,
      rentDifference?: number | null,
      rentReduction?: number | null,
      indexedRentAfterReduction?: number | null,
      chargesDifference?: number | null,
      chargesReduction?: number | null,
      indexedChargesAfterReduction?: number | null,
      previousYearIndexationNewIndex?: number | null,
      previousYearIndexedRent?: number | null,
      previousYearIndexedCharges?: number | null,
    } >,
    type: LeasePriceHistoryType,
    communicationId?: string | null,
    communication?:  {
      __typename: "Communication",
      id: string,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      blockedRecipients?:  Array< {
        __typename: "CommunicationBlockedRecipient",
        recipient: string,
        bounceType: BounceType,
      } > | null,
      body: string,
      buildingId?: string | null,
      channel: CommunicationChannel,
      communicationTemplateId?: string | null,
      concernedContactIds?: Array< string > | null,
      contactId?: string | null,
      contactIds?: Array< string > | null,
      createdAt?: string | null,
      draftProperties?:  {
        __typename: "CommunicationDraftProperties",
        allowRecipientsToSeeEachOther?: boolean | null,
        bcc?: Array< string > | null,
        buildingIds?: Array< string > | null,
        cc?: Array< string > | null,
        contactIds?: Array< string > | null,
        contactTypes?: Array< ContactType > | null,
        entityType: string,
        leaseIds?: Array< string > | null,
        sendInBcc?: boolean | null,
        unitIds?: Array< string > | null,
        unitTypeFilter?: string | null,
      } | null,
      expirationDate?: string | null,
      files?:  {
        __typename: "ModelFileConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      invoice?:  {
        __typename: "Invoice",
        id: string,
        amount: number,
        bankAccountId: string,
        communicationId?: string | null,
        createdAt: string,
        creditNote?: boolean | null,
        creditNoteLabel?: string | null,
        dueDate?: string | null,
        invoiceDate: string,
        invoiceNumber?: string | null,
        ownerId?: string | null,
        invoiceSenderId: string,
        leaseId?: string | null,
        paid: boolean,
        postedDate?: string | null,
        purchaseOrderNumber?: string | null,
        receiptNumber?: string | null,
        reminderDates?: Array< string > | null,
        note?: string | null,
        remittanceInformation?: string | null,
        statementId?: string | null,
        status: InvoiceStatus,
        type: InvoiceType,
        unitId?: string | null,
        reversedInvoiceId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      invoiceId?: string | null,
      lease?:  {
        __typename: "Lease",
        id: string,
        balance?: number | null,
        canBeExtended?: boolean | null,
        communicationSettingsProfileId: string,
        createdAt?: string | null,
        endDate: string,
        includeRealEstateInLeaseContract?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        invoiceSenderId: string,
        inventoryOfFixturesExpert?: string | null,
        inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
        inventoryOfFixturesType?: InventoryOfFixturesType | null,
        ipiNumber?: string | null,
        language: Language,
        lastDraftInvoiceDate?: string | null,
        lastIndexationProcessDate?: string | null,
        lastInvoiceDate?: string | null,
        legalCompetentAuthority?: string | null,
        name: string,
        notes?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        purchaseOrderNumber?: string | null,
        realEstateAgency?: string | null,
        realEstateTax?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        signatureDate?: string | null,
        startDate: string,
        nextIndexationMonth?: string | null,
        nextIndexation?: boolean | null,
        status: LeaseStatus,
        technicCommunicationSettingsProfileId: string,
        totalInitialRentalPrice: number,
        totalRentalPrice: number,
        type: LeaseType,
        subletting?: boolean | null,
        vatRateRentId?: string | null,
        bankAccountId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      leaseId?: string | null,
      leasePriceHistoryId?: string | null,
      leasePriceHistory?:  {
        __typename: "LeasePriceHistory",
        id: string,
        previousTotalRentalPrice: number,
        totalRentalPrice: number,
        optimalTotalRentalPrice?: number | null,
        optimalTotalMonthlyCharges?: number | null,
        applicationDate: string,
        status: LeaseAmountUpdateStatus,
        comment?: string | null,
        type: LeasePriceHistoryType,
        communicationId?: string | null,
        leaseId: string,
        createdAt?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      letterTrackingCode?: string | null,
      letterTrackingProvider?: TrackingProvider | null,
      linkedCommunicationsIds?: Array< string > | null,
      supportingDocumentFileIds?: Array< string > | null,
      recipient?: string | null,
      recipientContactIdsInBcc?: Array< string > | null,
      recipientContactIdsInCc?: Array< string > | null,
      recipientInBcc?: string | null,
      recipientInCc?: string | null,
      scheduledAt?: string | null,
      deliveredAt?: string | null,
      errorCode?: CommunicationErrorCode | null,
      nextRetryAt?: string | null,
      sendRetryCount?: number | null,
      sender?: string | null,
      sentAt?: string | null,
      externalId?: string | null,
      externalStatus?: string | null,
      signatureDocumentId?: string | null,
      signatureDocument?:  {
        __typename: "SignatureDocument",
        id: string,
        additionalMessage?: string | null,
        automaticRemindersDisabled?: boolean | null,
        communicationBody?: string | null,
        createdAt?: string | null,
        expirationDate?: string | null,
        fileIds?: Array< string > | null,
        foreignKey: string,
        foreignTableName: string,
        sentAt?: string | null,
        signatureMethods: Array< SignatureType >,
        status: SignatureDocumentStatus,
        externalStatus?: string | null,
        type: SignatureDocumentType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      snoozedDate?: string | null,
      statement?:  {
        __typename: "Statement",
        id: string,
        closingStatement: boolean,
        periodFrom: string,
        periodTo: string,
        attachSupportingDocuments?: boolean | null,
        selectedPocketKeys?: Array< string > | null,
        source: StatementSource,
        status: StatementStatus,
        sentDate?: string | null,
        leaseId?: string | null,
        ownerId?: string | null,
        types?: Array< StatementType > | null,
        viewType: StatementViewType,
        unitIds?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      statementId?: string | null,
      status: CommunicationStatus,
      subject: string,
      toSend: boolean,
      hideLogo?: boolean | null,
      type: CommunicationType,
      _ttl?: number | null,
      unit?:  {
        __typename: "Unit",
        id: string,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        acquisitionValue?: number | null,
        advertisedMonthlyCharges?: number | null,
        advertisedRentalPrice?: number | null,
        cadastralIncome?: number | null,
        createdAt?: string | null,
        floor?: number | null,
        jointOwnershipId?: string | null,
        managementDate: string,
        name: string,
        notes?: string | null,
        predictedPrice?: string | null,
        propertyTax?: number | null,
        publishAddress?: boolean | null,
        surface?: number | null,
        type: UnitType,
        buildingId: string,
        unitAdvertisementId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      unitId?: string | null,
      readId: string,
      readers?: Array< string > | null,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    leaseId: string,
    lease?:  {
      __typename: "Lease",
      id: string,
      advancedChargesInvoices?:  {
        __typename: "LeaseAdvancedChargesInvoice",
        communicationSettingsProfileId: string,
        invoiceSenderId: string,
        lastDraftInvoiceDate?: string | null,
        lastInvoiceDate?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        bankAccountId?: string | null,
      } | null,
      balance?: number | null,
      canBeExtended?: boolean | null,
      communicationSettingsProfileId: string,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      endDate: string,
      includeRealEstateInLeaseContract?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      invoiceSenderId: string,
      invoiceSender?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      inventoryOfFixturesExpert?: string | null,
      inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
      inventoryOfFixturesType?: InventoryOfFixturesType | null,
      ipiNumber?: string | null,
      language: Language,
      lastDraftInvoiceDate?: string | null,
      lastIndexationProcessDate?: string | null,
      lastInvoiceDate?: string | null,
      legalCompetentAuthority?: string | null,
      name: string,
      notes?: string | null,
      paymentFrequency: LeasePaymentFrequency,
      paymentInvoicePeriod: LeasePaymentInvoicePeriod,
      paymentInvoicePeriodCustomDay?: number | null,
      paymentOption?:  {
        __typename: "LeasePaymentOption",
        customerId?: string | null,
        enabled: boolean,
        mandateActivatedAt?: string | null,
        mandateStatus?: PaymentProviderMandateStatus | null,
        paymentMethodId?: string | null,
        qrType?: LeaseQrType | null,
      } | null,
      purchaseOrderNumber?: string | null,
      realEstateAgency?: string | null,
      realEstateTax?: number | null,
      remittanceInformation?: string | null,
      remittanceInformationType?: LeaseRemittanceType | null,
      rentalGuaranty?:  {
        __typename: "LeaseRentalGuaranty",
        amount: number,
        blockedAmount?: number | null,
        releasedAmount?: number | null,
        type: LeaseRentalGuarantyType,
        financialInstitution?: string | null,
      } | null,
      signatureDate?: string | null,
      startDate: string,
      nextIndexationMonth?: string | null,
      nextIndexation?: boolean | null,
      status: LeaseStatus,
      technicCommunicationSettingsProfileId: string,
      totalInitialRentalPrice: number,
      totalRentalPrice: number,
      type: LeaseType,
      subletting?: boolean | null,
      vatRateRentId?: string | null,
      vatRateRent?:  {
        __typename: "VatRate",
        id: string,
        country: string,
        label: string,
        value?: number | null,
        ownerId?: string | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      additionalClauses?:  {
        __typename: "ModelLeaseAdditionalClauseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      bankAccountId?: string | null,
      bankAccount?:  {
        __typename: "BankAccount",
        id: string,
        contactId: string,
        number: string,
        bicNumber?: string | null,
        bankName?: string | null,
        contactIds?: Array< string > | null,
        buildingIds?: Array< string > | null,
        holderName?: string | null,
        label?: string | null,
        disabled?: boolean | null,
        integrations?: Array< IntegrationName > | null,
        matchingRule?: BankAccountMatchingRule | null,
        balance?: number | null,
        balanceDate?: string | null,
        type: BankAccountType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contacts?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      files?:  {
        __typename: "ModelFileConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leaseActionHistories?:  {
        __typename: "ModelLeaseActionHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leasePriceHistories?:  {
        __typename: "ModelLeasePriceHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      signatureDocuments?:  {
        __typename: "ModelSignatureDocumentConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      variousOperations?:  {
        __typename: "ModelLeaseVariousOperationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    createdAt?: string | null,
    readers?: Array< string > | null,
    readId: string,
    clientId: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateLeasePriceHistorySubscriptionVariables = {
  filter?: ModelSubscriptionLeasePriceHistoryFilterInput | null,
};

export type OnUpdateLeasePriceHistorySubscription = {
  onUpdateLeasePriceHistory?:  {
    __typename: "LeasePriceHistory",
    id: string,
    previousTotalRentalPrice: number,
    totalRentalPrice: number,
    optimalTotalRentalPrice?: number | null,
    optimalTotalMonthlyCharges?: number | null,
    applicationDate: string,
    status: LeaseAmountUpdateStatus,
    comment?: string | null,
    amountDetails:  Array< {
      __typename: "LeasePriceHistoryDetail",
      unitId: string,
      indexationBaseIndex?: number | null,
      indexationNewIndex?: number | null,
      previousRentalPrice: number,
      newRentalPrice: number,
      rentalStatus: LeasePriceHistoryStatus,
      monthlyChargesStatus: LeasePriceHistoryStatus,
      optimalNewRentalPrice?: number | null,
      optimalNewMonthlyChargesPrice?: number | null,
      epb?: string | null,
      epbIssueDate?: string | null,
      oldestIndexForCorrectionFactorCalculation?: number | null,
      newestIndexForCorrectionFactorCalculation?: number | null,
      rentIndexedPriceAfterNewEpbReduction?: number | null,
      chargesIndexedPriceAfterNewEpbReduction?: number | null,
      correctionFactor?: number | null,
      chargesAmountsDetails?:  Array< {
        __typename: "LeasePriceHistoryChargeAmountsDetails",
        leaseVariousOperationId: string,
        previousMonthlyAmount: number,
        newMonthlyAmount: number,
        indexationBaseIndex?: number | null,
        indexationBaseAmount?: number | null,
        indexationBaseIndexDate?: string | null,
        indexed?: boolean | null,
      } > | null,
      reductionPercentage?: number | null,
      rentDifference?: number | null,
      rentReduction?: number | null,
      indexedRentAfterReduction?: number | null,
      chargesDifference?: number | null,
      chargesReduction?: number | null,
      indexedChargesAfterReduction?: number | null,
      previousYearIndexationNewIndex?: number | null,
      previousYearIndexedRent?: number | null,
      previousYearIndexedCharges?: number | null,
    } >,
    type: LeasePriceHistoryType,
    communicationId?: string | null,
    communication?:  {
      __typename: "Communication",
      id: string,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      blockedRecipients?:  Array< {
        __typename: "CommunicationBlockedRecipient",
        recipient: string,
        bounceType: BounceType,
      } > | null,
      body: string,
      buildingId?: string | null,
      channel: CommunicationChannel,
      communicationTemplateId?: string | null,
      concernedContactIds?: Array< string > | null,
      contactId?: string | null,
      contactIds?: Array< string > | null,
      createdAt?: string | null,
      draftProperties?:  {
        __typename: "CommunicationDraftProperties",
        allowRecipientsToSeeEachOther?: boolean | null,
        bcc?: Array< string > | null,
        buildingIds?: Array< string > | null,
        cc?: Array< string > | null,
        contactIds?: Array< string > | null,
        contactTypes?: Array< ContactType > | null,
        entityType: string,
        leaseIds?: Array< string > | null,
        sendInBcc?: boolean | null,
        unitIds?: Array< string > | null,
        unitTypeFilter?: string | null,
      } | null,
      expirationDate?: string | null,
      files?:  {
        __typename: "ModelFileConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      invoice?:  {
        __typename: "Invoice",
        id: string,
        amount: number,
        bankAccountId: string,
        communicationId?: string | null,
        createdAt: string,
        creditNote?: boolean | null,
        creditNoteLabel?: string | null,
        dueDate?: string | null,
        invoiceDate: string,
        invoiceNumber?: string | null,
        ownerId?: string | null,
        invoiceSenderId: string,
        leaseId?: string | null,
        paid: boolean,
        postedDate?: string | null,
        purchaseOrderNumber?: string | null,
        receiptNumber?: string | null,
        reminderDates?: Array< string > | null,
        note?: string | null,
        remittanceInformation?: string | null,
        statementId?: string | null,
        status: InvoiceStatus,
        type: InvoiceType,
        unitId?: string | null,
        reversedInvoiceId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      invoiceId?: string | null,
      lease?:  {
        __typename: "Lease",
        id: string,
        balance?: number | null,
        canBeExtended?: boolean | null,
        communicationSettingsProfileId: string,
        createdAt?: string | null,
        endDate: string,
        includeRealEstateInLeaseContract?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        invoiceSenderId: string,
        inventoryOfFixturesExpert?: string | null,
        inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
        inventoryOfFixturesType?: InventoryOfFixturesType | null,
        ipiNumber?: string | null,
        language: Language,
        lastDraftInvoiceDate?: string | null,
        lastIndexationProcessDate?: string | null,
        lastInvoiceDate?: string | null,
        legalCompetentAuthority?: string | null,
        name: string,
        notes?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        purchaseOrderNumber?: string | null,
        realEstateAgency?: string | null,
        realEstateTax?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        signatureDate?: string | null,
        startDate: string,
        nextIndexationMonth?: string | null,
        nextIndexation?: boolean | null,
        status: LeaseStatus,
        technicCommunicationSettingsProfileId: string,
        totalInitialRentalPrice: number,
        totalRentalPrice: number,
        type: LeaseType,
        subletting?: boolean | null,
        vatRateRentId?: string | null,
        bankAccountId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      leaseId?: string | null,
      leasePriceHistoryId?: string | null,
      leasePriceHistory?:  {
        __typename: "LeasePriceHistory",
        id: string,
        previousTotalRentalPrice: number,
        totalRentalPrice: number,
        optimalTotalRentalPrice?: number | null,
        optimalTotalMonthlyCharges?: number | null,
        applicationDate: string,
        status: LeaseAmountUpdateStatus,
        comment?: string | null,
        type: LeasePriceHistoryType,
        communicationId?: string | null,
        leaseId: string,
        createdAt?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      letterTrackingCode?: string | null,
      letterTrackingProvider?: TrackingProvider | null,
      linkedCommunicationsIds?: Array< string > | null,
      supportingDocumentFileIds?: Array< string > | null,
      recipient?: string | null,
      recipientContactIdsInBcc?: Array< string > | null,
      recipientContactIdsInCc?: Array< string > | null,
      recipientInBcc?: string | null,
      recipientInCc?: string | null,
      scheduledAt?: string | null,
      deliveredAt?: string | null,
      errorCode?: CommunicationErrorCode | null,
      nextRetryAt?: string | null,
      sendRetryCount?: number | null,
      sender?: string | null,
      sentAt?: string | null,
      externalId?: string | null,
      externalStatus?: string | null,
      signatureDocumentId?: string | null,
      signatureDocument?:  {
        __typename: "SignatureDocument",
        id: string,
        additionalMessage?: string | null,
        automaticRemindersDisabled?: boolean | null,
        communicationBody?: string | null,
        createdAt?: string | null,
        expirationDate?: string | null,
        fileIds?: Array< string > | null,
        foreignKey: string,
        foreignTableName: string,
        sentAt?: string | null,
        signatureMethods: Array< SignatureType >,
        status: SignatureDocumentStatus,
        externalStatus?: string | null,
        type: SignatureDocumentType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      snoozedDate?: string | null,
      statement?:  {
        __typename: "Statement",
        id: string,
        closingStatement: boolean,
        periodFrom: string,
        periodTo: string,
        attachSupportingDocuments?: boolean | null,
        selectedPocketKeys?: Array< string > | null,
        source: StatementSource,
        status: StatementStatus,
        sentDate?: string | null,
        leaseId?: string | null,
        ownerId?: string | null,
        types?: Array< StatementType > | null,
        viewType: StatementViewType,
        unitIds?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      statementId?: string | null,
      status: CommunicationStatus,
      subject: string,
      toSend: boolean,
      hideLogo?: boolean | null,
      type: CommunicationType,
      _ttl?: number | null,
      unit?:  {
        __typename: "Unit",
        id: string,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        acquisitionValue?: number | null,
        advertisedMonthlyCharges?: number | null,
        advertisedRentalPrice?: number | null,
        cadastralIncome?: number | null,
        createdAt?: string | null,
        floor?: number | null,
        jointOwnershipId?: string | null,
        managementDate: string,
        name: string,
        notes?: string | null,
        predictedPrice?: string | null,
        propertyTax?: number | null,
        publishAddress?: boolean | null,
        surface?: number | null,
        type: UnitType,
        buildingId: string,
        unitAdvertisementId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      unitId?: string | null,
      readId: string,
      readers?: Array< string > | null,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    leaseId: string,
    lease?:  {
      __typename: "Lease",
      id: string,
      advancedChargesInvoices?:  {
        __typename: "LeaseAdvancedChargesInvoice",
        communicationSettingsProfileId: string,
        invoiceSenderId: string,
        lastDraftInvoiceDate?: string | null,
        lastInvoiceDate?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        bankAccountId?: string | null,
      } | null,
      balance?: number | null,
      canBeExtended?: boolean | null,
      communicationSettingsProfileId: string,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      endDate: string,
      includeRealEstateInLeaseContract?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      invoiceSenderId: string,
      invoiceSender?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      inventoryOfFixturesExpert?: string | null,
      inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
      inventoryOfFixturesType?: InventoryOfFixturesType | null,
      ipiNumber?: string | null,
      language: Language,
      lastDraftInvoiceDate?: string | null,
      lastIndexationProcessDate?: string | null,
      lastInvoiceDate?: string | null,
      legalCompetentAuthority?: string | null,
      name: string,
      notes?: string | null,
      paymentFrequency: LeasePaymentFrequency,
      paymentInvoicePeriod: LeasePaymentInvoicePeriod,
      paymentInvoicePeriodCustomDay?: number | null,
      paymentOption?:  {
        __typename: "LeasePaymentOption",
        customerId?: string | null,
        enabled: boolean,
        mandateActivatedAt?: string | null,
        mandateStatus?: PaymentProviderMandateStatus | null,
        paymentMethodId?: string | null,
        qrType?: LeaseQrType | null,
      } | null,
      purchaseOrderNumber?: string | null,
      realEstateAgency?: string | null,
      realEstateTax?: number | null,
      remittanceInformation?: string | null,
      remittanceInformationType?: LeaseRemittanceType | null,
      rentalGuaranty?:  {
        __typename: "LeaseRentalGuaranty",
        amount: number,
        blockedAmount?: number | null,
        releasedAmount?: number | null,
        type: LeaseRentalGuarantyType,
        financialInstitution?: string | null,
      } | null,
      signatureDate?: string | null,
      startDate: string,
      nextIndexationMonth?: string | null,
      nextIndexation?: boolean | null,
      status: LeaseStatus,
      technicCommunicationSettingsProfileId: string,
      totalInitialRentalPrice: number,
      totalRentalPrice: number,
      type: LeaseType,
      subletting?: boolean | null,
      vatRateRentId?: string | null,
      vatRateRent?:  {
        __typename: "VatRate",
        id: string,
        country: string,
        label: string,
        value?: number | null,
        ownerId?: string | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      additionalClauses?:  {
        __typename: "ModelLeaseAdditionalClauseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      bankAccountId?: string | null,
      bankAccount?:  {
        __typename: "BankAccount",
        id: string,
        contactId: string,
        number: string,
        bicNumber?: string | null,
        bankName?: string | null,
        contactIds?: Array< string > | null,
        buildingIds?: Array< string > | null,
        holderName?: string | null,
        label?: string | null,
        disabled?: boolean | null,
        integrations?: Array< IntegrationName > | null,
        matchingRule?: BankAccountMatchingRule | null,
        balance?: number | null,
        balanceDate?: string | null,
        type: BankAccountType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contacts?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      files?:  {
        __typename: "ModelFileConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leaseActionHistories?:  {
        __typename: "ModelLeaseActionHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leasePriceHistories?:  {
        __typename: "ModelLeasePriceHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      signatureDocuments?:  {
        __typename: "ModelSignatureDocumentConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      variousOperations?:  {
        __typename: "ModelLeaseVariousOperationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    createdAt?: string | null,
    readers?: Array< string > | null,
    readId: string,
    clientId: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteLeasePriceHistorySubscriptionVariables = {
  filter?: ModelSubscriptionLeasePriceHistoryFilterInput | null,
};

export type OnDeleteLeasePriceHistorySubscription = {
  onDeleteLeasePriceHistory?:  {
    __typename: "LeasePriceHistory",
    id: string,
    previousTotalRentalPrice: number,
    totalRentalPrice: number,
    optimalTotalRentalPrice?: number | null,
    optimalTotalMonthlyCharges?: number | null,
    applicationDate: string,
    status: LeaseAmountUpdateStatus,
    comment?: string | null,
    amountDetails:  Array< {
      __typename: "LeasePriceHistoryDetail",
      unitId: string,
      indexationBaseIndex?: number | null,
      indexationNewIndex?: number | null,
      previousRentalPrice: number,
      newRentalPrice: number,
      rentalStatus: LeasePriceHistoryStatus,
      monthlyChargesStatus: LeasePriceHistoryStatus,
      optimalNewRentalPrice?: number | null,
      optimalNewMonthlyChargesPrice?: number | null,
      epb?: string | null,
      epbIssueDate?: string | null,
      oldestIndexForCorrectionFactorCalculation?: number | null,
      newestIndexForCorrectionFactorCalculation?: number | null,
      rentIndexedPriceAfterNewEpbReduction?: number | null,
      chargesIndexedPriceAfterNewEpbReduction?: number | null,
      correctionFactor?: number | null,
      chargesAmountsDetails?:  Array< {
        __typename: "LeasePriceHistoryChargeAmountsDetails",
        leaseVariousOperationId: string,
        previousMonthlyAmount: number,
        newMonthlyAmount: number,
        indexationBaseIndex?: number | null,
        indexationBaseAmount?: number | null,
        indexationBaseIndexDate?: string | null,
        indexed?: boolean | null,
      } > | null,
      reductionPercentage?: number | null,
      rentDifference?: number | null,
      rentReduction?: number | null,
      indexedRentAfterReduction?: number | null,
      chargesDifference?: number | null,
      chargesReduction?: number | null,
      indexedChargesAfterReduction?: number | null,
      previousYearIndexationNewIndex?: number | null,
      previousYearIndexedRent?: number | null,
      previousYearIndexedCharges?: number | null,
    } >,
    type: LeasePriceHistoryType,
    communicationId?: string | null,
    communication?:  {
      __typename: "Communication",
      id: string,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      blockedRecipients?:  Array< {
        __typename: "CommunicationBlockedRecipient",
        recipient: string,
        bounceType: BounceType,
      } > | null,
      body: string,
      buildingId?: string | null,
      channel: CommunicationChannel,
      communicationTemplateId?: string | null,
      concernedContactIds?: Array< string > | null,
      contactId?: string | null,
      contactIds?: Array< string > | null,
      createdAt?: string | null,
      draftProperties?:  {
        __typename: "CommunicationDraftProperties",
        allowRecipientsToSeeEachOther?: boolean | null,
        bcc?: Array< string > | null,
        buildingIds?: Array< string > | null,
        cc?: Array< string > | null,
        contactIds?: Array< string > | null,
        contactTypes?: Array< ContactType > | null,
        entityType: string,
        leaseIds?: Array< string > | null,
        sendInBcc?: boolean | null,
        unitIds?: Array< string > | null,
        unitTypeFilter?: string | null,
      } | null,
      expirationDate?: string | null,
      files?:  {
        __typename: "ModelFileConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      invoice?:  {
        __typename: "Invoice",
        id: string,
        amount: number,
        bankAccountId: string,
        communicationId?: string | null,
        createdAt: string,
        creditNote?: boolean | null,
        creditNoteLabel?: string | null,
        dueDate?: string | null,
        invoiceDate: string,
        invoiceNumber?: string | null,
        ownerId?: string | null,
        invoiceSenderId: string,
        leaseId?: string | null,
        paid: boolean,
        postedDate?: string | null,
        purchaseOrderNumber?: string | null,
        receiptNumber?: string | null,
        reminderDates?: Array< string > | null,
        note?: string | null,
        remittanceInformation?: string | null,
        statementId?: string | null,
        status: InvoiceStatus,
        type: InvoiceType,
        unitId?: string | null,
        reversedInvoiceId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      invoiceId?: string | null,
      lease?:  {
        __typename: "Lease",
        id: string,
        balance?: number | null,
        canBeExtended?: boolean | null,
        communicationSettingsProfileId: string,
        createdAt?: string | null,
        endDate: string,
        includeRealEstateInLeaseContract?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        invoiceSenderId: string,
        inventoryOfFixturesExpert?: string | null,
        inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
        inventoryOfFixturesType?: InventoryOfFixturesType | null,
        ipiNumber?: string | null,
        language: Language,
        lastDraftInvoiceDate?: string | null,
        lastIndexationProcessDate?: string | null,
        lastInvoiceDate?: string | null,
        legalCompetentAuthority?: string | null,
        name: string,
        notes?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        purchaseOrderNumber?: string | null,
        realEstateAgency?: string | null,
        realEstateTax?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        signatureDate?: string | null,
        startDate: string,
        nextIndexationMonth?: string | null,
        nextIndexation?: boolean | null,
        status: LeaseStatus,
        technicCommunicationSettingsProfileId: string,
        totalInitialRentalPrice: number,
        totalRentalPrice: number,
        type: LeaseType,
        subletting?: boolean | null,
        vatRateRentId?: string | null,
        bankAccountId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      leaseId?: string | null,
      leasePriceHistoryId?: string | null,
      leasePriceHistory?:  {
        __typename: "LeasePriceHistory",
        id: string,
        previousTotalRentalPrice: number,
        totalRentalPrice: number,
        optimalTotalRentalPrice?: number | null,
        optimalTotalMonthlyCharges?: number | null,
        applicationDate: string,
        status: LeaseAmountUpdateStatus,
        comment?: string | null,
        type: LeasePriceHistoryType,
        communicationId?: string | null,
        leaseId: string,
        createdAt?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      letterTrackingCode?: string | null,
      letterTrackingProvider?: TrackingProvider | null,
      linkedCommunicationsIds?: Array< string > | null,
      supportingDocumentFileIds?: Array< string > | null,
      recipient?: string | null,
      recipientContactIdsInBcc?: Array< string > | null,
      recipientContactIdsInCc?: Array< string > | null,
      recipientInBcc?: string | null,
      recipientInCc?: string | null,
      scheduledAt?: string | null,
      deliveredAt?: string | null,
      errorCode?: CommunicationErrorCode | null,
      nextRetryAt?: string | null,
      sendRetryCount?: number | null,
      sender?: string | null,
      sentAt?: string | null,
      externalId?: string | null,
      externalStatus?: string | null,
      signatureDocumentId?: string | null,
      signatureDocument?:  {
        __typename: "SignatureDocument",
        id: string,
        additionalMessage?: string | null,
        automaticRemindersDisabled?: boolean | null,
        communicationBody?: string | null,
        createdAt?: string | null,
        expirationDate?: string | null,
        fileIds?: Array< string > | null,
        foreignKey: string,
        foreignTableName: string,
        sentAt?: string | null,
        signatureMethods: Array< SignatureType >,
        status: SignatureDocumentStatus,
        externalStatus?: string | null,
        type: SignatureDocumentType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      snoozedDate?: string | null,
      statement?:  {
        __typename: "Statement",
        id: string,
        closingStatement: boolean,
        periodFrom: string,
        periodTo: string,
        attachSupportingDocuments?: boolean | null,
        selectedPocketKeys?: Array< string > | null,
        source: StatementSource,
        status: StatementStatus,
        sentDate?: string | null,
        leaseId?: string | null,
        ownerId?: string | null,
        types?: Array< StatementType > | null,
        viewType: StatementViewType,
        unitIds?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      statementId?: string | null,
      status: CommunicationStatus,
      subject: string,
      toSend: boolean,
      hideLogo?: boolean | null,
      type: CommunicationType,
      _ttl?: number | null,
      unit?:  {
        __typename: "Unit",
        id: string,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        acquisitionValue?: number | null,
        advertisedMonthlyCharges?: number | null,
        advertisedRentalPrice?: number | null,
        cadastralIncome?: number | null,
        createdAt?: string | null,
        floor?: number | null,
        jointOwnershipId?: string | null,
        managementDate: string,
        name: string,
        notes?: string | null,
        predictedPrice?: string | null,
        propertyTax?: number | null,
        publishAddress?: boolean | null,
        surface?: number | null,
        type: UnitType,
        buildingId: string,
        unitAdvertisementId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      unitId?: string | null,
      readId: string,
      readers?: Array< string > | null,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    leaseId: string,
    lease?:  {
      __typename: "Lease",
      id: string,
      advancedChargesInvoices?:  {
        __typename: "LeaseAdvancedChargesInvoice",
        communicationSettingsProfileId: string,
        invoiceSenderId: string,
        lastDraftInvoiceDate?: string | null,
        lastInvoiceDate?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        bankAccountId?: string | null,
      } | null,
      balance?: number | null,
      canBeExtended?: boolean | null,
      communicationSettingsProfileId: string,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      endDate: string,
      includeRealEstateInLeaseContract?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      invoiceSenderId: string,
      invoiceSender?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      inventoryOfFixturesExpert?: string | null,
      inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
      inventoryOfFixturesType?: InventoryOfFixturesType | null,
      ipiNumber?: string | null,
      language: Language,
      lastDraftInvoiceDate?: string | null,
      lastIndexationProcessDate?: string | null,
      lastInvoiceDate?: string | null,
      legalCompetentAuthority?: string | null,
      name: string,
      notes?: string | null,
      paymentFrequency: LeasePaymentFrequency,
      paymentInvoicePeriod: LeasePaymentInvoicePeriod,
      paymentInvoicePeriodCustomDay?: number | null,
      paymentOption?:  {
        __typename: "LeasePaymentOption",
        customerId?: string | null,
        enabled: boolean,
        mandateActivatedAt?: string | null,
        mandateStatus?: PaymentProviderMandateStatus | null,
        paymentMethodId?: string | null,
        qrType?: LeaseQrType | null,
      } | null,
      purchaseOrderNumber?: string | null,
      realEstateAgency?: string | null,
      realEstateTax?: number | null,
      remittanceInformation?: string | null,
      remittanceInformationType?: LeaseRemittanceType | null,
      rentalGuaranty?:  {
        __typename: "LeaseRentalGuaranty",
        amount: number,
        blockedAmount?: number | null,
        releasedAmount?: number | null,
        type: LeaseRentalGuarantyType,
        financialInstitution?: string | null,
      } | null,
      signatureDate?: string | null,
      startDate: string,
      nextIndexationMonth?: string | null,
      nextIndexation?: boolean | null,
      status: LeaseStatus,
      technicCommunicationSettingsProfileId: string,
      totalInitialRentalPrice: number,
      totalRentalPrice: number,
      type: LeaseType,
      subletting?: boolean | null,
      vatRateRentId?: string | null,
      vatRateRent?:  {
        __typename: "VatRate",
        id: string,
        country: string,
        label: string,
        value?: number | null,
        ownerId?: string | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      additionalClauses?:  {
        __typename: "ModelLeaseAdditionalClauseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      bankAccountId?: string | null,
      bankAccount?:  {
        __typename: "BankAccount",
        id: string,
        contactId: string,
        number: string,
        bicNumber?: string | null,
        bankName?: string | null,
        contactIds?: Array< string > | null,
        buildingIds?: Array< string > | null,
        holderName?: string | null,
        label?: string | null,
        disabled?: boolean | null,
        integrations?: Array< IntegrationName > | null,
        matchingRule?: BankAccountMatchingRule | null,
        balance?: number | null,
        balanceDate?: string | null,
        type: BankAccountType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contacts?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      files?:  {
        __typename: "ModelFileConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leaseActionHistories?:  {
        __typename: "ModelLeaseActionHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leasePriceHistories?:  {
        __typename: "ModelLeasePriceHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      signatureDocuments?:  {
        __typename: "ModelSignatureDocumentConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      variousOperations?:  {
        __typename: "ModelLeaseVariousOperationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    createdAt?: string | null,
    readers?: Array< string > | null,
    readId: string,
    clientId: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateNotificationSubscriptionVariables = {
  filter?: ModelSubscriptionNotificationFilterInput | null,
};

export type OnCreateNotificationSubscription = {
  onCreateNotification?:  {
    __typename: "Notification",
    id: string,
    createdBy: NotificationCreation,
    type?: NotificationType | null,
    message?: string | null,
    popupDate: string,
    expirationDate?: string | null,
    status: NotificationStatus,
    createdAt?: string | null,
    buildingId?: string | null,
    building?:  {
      __typename: "Building",
      id: string,
      name: string,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      acquisitionValue?: number | null,
      acquisitionAdditionalCostsValue?: number | null,
      acquisitionAdvertisedValue?: number | null,
      amountOfFacades?: number | null,
      amountOfFloors?: number | null,
      amountOfHousings?: number | null,
      buildingState?: BuildingState | null,
      cadastralIncome?: number | null,
      constructionYear?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      janitor?: boolean | null,
      jointOwnershipId?: string | null,
      notes?: string | null,
      owners?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      propertyTax?: number | null,
      residenceName?: string | null,
      buildingSiteId?: string | null,
      buildingSite?:  {
        __typename: "BuildingSite",
        id: string,
        name: string,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      units?:  {
        __typename: "ModelUnitConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      events?:  {
        __typename: "ModelBuildingEventConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      teams?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    unitId?: string | null,
    unit?:  {
      __typename: "Unit",
      id: string,
      acquisitionAdditionalCostsValue?: number | null,
      acquisitionAdvertisedValue?: number | null,
      acquisitionValue?: number | null,
      advertisedMonthlyCharges?: number | null,
      advertisedRentalPrice?: number | null,
      cadastralIncome?: number | null,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      floor?: number | null,
      jointOwnershipId?: string | null,
      managementDate: string,
      name: string,
      notes?: string | null,
      predictedPrice?: string | null,
      propertyTax?: number | null,
      publishAddress?: boolean | null,
      surface?: number | null,
      type: UnitType,
      buildingId: string,
      building?:  {
        __typename: "Building",
        id: string,
        name: string,
        addressId?: string | null,
        acquisitionValue?: number | null,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        amountOfFacades?: number | null,
        amountOfFloors?: number | null,
        amountOfHousings?: number | null,
        buildingState?: BuildingState | null,
        cadastralIncome?: number | null,
        constructionYear?: string | null,
        janitor?: boolean | null,
        jointOwnershipId?: string | null,
        notes?: string | null,
        propertyTax?: number | null,
        residenceName?: string | null,
        buildingSiteId?: string | null,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      owners?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leases?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      events?:  {
        __typename: "ModelUnitEventConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      unitAdvertisementId?: string | null,
      unitInventories?:  {
        __typename: "ModelUnitInventoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    leaseId?: string | null,
    lease?:  {
      __typename: "Lease",
      id: string,
      advancedChargesInvoices?:  {
        __typename: "LeaseAdvancedChargesInvoice",
        communicationSettingsProfileId: string,
        invoiceSenderId: string,
        lastDraftInvoiceDate?: string | null,
        lastInvoiceDate?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        bankAccountId?: string | null,
      } | null,
      balance?: number | null,
      canBeExtended?: boolean | null,
      communicationSettingsProfileId: string,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      endDate: string,
      includeRealEstateInLeaseContract?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      invoiceSenderId: string,
      invoiceSender?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      inventoryOfFixturesExpert?: string | null,
      inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
      inventoryOfFixturesType?: InventoryOfFixturesType | null,
      ipiNumber?: string | null,
      language: Language,
      lastDraftInvoiceDate?: string | null,
      lastIndexationProcessDate?: string | null,
      lastInvoiceDate?: string | null,
      legalCompetentAuthority?: string | null,
      name: string,
      notes?: string | null,
      paymentFrequency: LeasePaymentFrequency,
      paymentInvoicePeriod: LeasePaymentInvoicePeriod,
      paymentInvoicePeriodCustomDay?: number | null,
      paymentOption?:  {
        __typename: "LeasePaymentOption",
        customerId?: string | null,
        enabled: boolean,
        mandateActivatedAt?: string | null,
        mandateStatus?: PaymentProviderMandateStatus | null,
        paymentMethodId?: string | null,
        qrType?: LeaseQrType | null,
      } | null,
      purchaseOrderNumber?: string | null,
      realEstateAgency?: string | null,
      realEstateTax?: number | null,
      remittanceInformation?: string | null,
      remittanceInformationType?: LeaseRemittanceType | null,
      rentalGuaranty?:  {
        __typename: "LeaseRentalGuaranty",
        amount: number,
        blockedAmount?: number | null,
        releasedAmount?: number | null,
        type: LeaseRentalGuarantyType,
        financialInstitution?: string | null,
      } | null,
      signatureDate?: string | null,
      startDate: string,
      nextIndexationMonth?: string | null,
      nextIndexation?: boolean | null,
      status: LeaseStatus,
      technicCommunicationSettingsProfileId: string,
      totalInitialRentalPrice: number,
      totalRentalPrice: number,
      type: LeaseType,
      subletting?: boolean | null,
      vatRateRentId?: string | null,
      vatRateRent?:  {
        __typename: "VatRate",
        id: string,
        country: string,
        label: string,
        value?: number | null,
        ownerId?: string | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      additionalClauses?:  {
        __typename: "ModelLeaseAdditionalClauseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      bankAccountId?: string | null,
      bankAccount?:  {
        __typename: "BankAccount",
        id: string,
        contactId: string,
        number: string,
        bicNumber?: string | null,
        bankName?: string | null,
        contactIds?: Array< string > | null,
        buildingIds?: Array< string > | null,
        holderName?: string | null,
        label?: string | null,
        disabled?: boolean | null,
        integrations?: Array< IntegrationName > | null,
        matchingRule?: BankAccountMatchingRule | null,
        balance?: number | null,
        balanceDate?: string | null,
        type: BankAccountType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contacts?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      files?:  {
        __typename: "ModelFileConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leaseActionHistories?:  {
        __typename: "ModelLeaseActionHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leasePriceHistories?:  {
        __typename: "ModelLeasePriceHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      signatureDocuments?:  {
        __typename: "ModelSignatureDocumentConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      variousOperations?:  {
        __typename: "ModelLeaseVariousOperationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    technicId?: string | null,
    technic?:  {
      __typename: "Technic",
      id: string,
      type: TechnicType,
      contractNumber?: string | null,
      communicationSettingsProfileId: string,
      maintenanceHistory?:  Array< {
        __typename: "TechnicMaintenanceHistory",
        date: string,
        contactId?: string | null,
        fileId?: string | null,
      } > | null,
      technicLibraryId?: string | null,
      technicLibrary?:  {
        __typename: "TechnicLibrary",
        id: string,
        communicationSettingsProfileId?: string | null,
        criticality: TechnicLibraryCriticality,
        isDefault?: boolean | null,
        issuingAuthority?: string | null,
        linkedCertificateIds?: Array< string > | null,
        locationScope?: TechnicLibraryLocationScope | null,
        status: TechnicLibraryStatus,
        tagIds?: Array< string > | null,
        technicLibraryFormat?: string | null,
        type: TechnicLibraryType,
        utilityTypes?: Array< UtilityType > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      technicName?: string | null,
      lastControlDate?: string | null,
      status?: TechnicStatus | null,
      utilityType?: UtilityType | null,
      utilityEanCode?: string | null,
      utilityMeterNumber?: string | null,
      utilityDistributorId?: string | null,
      utilityDistributor?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      utilityHistory?:  Array< {
        __typename: "UtilityHistory",
        date: string,
        reason?: UtilityReadingReason | null,
        reading: number,
        secondReading?: number | null,
      } > | null,
      files?:  {
        __typename: "ModelFileConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildingId?: string | null,
      building?:  {
        __typename: "Building",
        id: string,
        name: string,
        addressId?: string | null,
        acquisitionValue?: number | null,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        amountOfFacades?: number | null,
        amountOfFloors?: number | null,
        amountOfHousings?: number | null,
        buildingState?: BuildingState | null,
        cadastralIncome?: number | null,
        constructionYear?: string | null,
        janitor?: boolean | null,
        jointOwnershipId?: string | null,
        notes?: string | null,
        propertyTax?: number | null,
        residenceName?: string | null,
        buildingSiteId?: string | null,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      unitId?: string | null,
      unit?:  {
        __typename: "Unit",
        id: string,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        acquisitionValue?: number | null,
        advertisedMonthlyCharges?: number | null,
        advertisedRentalPrice?: number | null,
        cadastralIncome?: number | null,
        createdAt?: string | null,
        floor?: number | null,
        jointOwnershipId?: string | null,
        managementDate: string,
        name: string,
        notes?: string | null,
        predictedPrice?: string | null,
        propertyTax?: number | null,
        publishAddress?: boolean | null,
        surface?: number | null,
        type: UnitType,
        buildingId: string,
        unitAdvertisementId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      leaseId?: string | null,
      lease?:  {
        __typename: "Lease",
        id: string,
        balance?: number | null,
        canBeExtended?: boolean | null,
        communicationSettingsProfileId: string,
        createdAt?: string | null,
        endDate: string,
        includeRealEstateInLeaseContract?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        invoiceSenderId: string,
        inventoryOfFixturesExpert?: string | null,
        inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
        inventoryOfFixturesType?: InventoryOfFixturesType | null,
        ipiNumber?: string | null,
        language: Language,
        lastDraftInvoiceDate?: string | null,
        lastIndexationProcessDate?: string | null,
        lastInvoiceDate?: string | null,
        legalCompetentAuthority?: string | null,
        name: string,
        notes?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        purchaseOrderNumber?: string | null,
        realEstateAgency?: string | null,
        realEstateTax?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        signatureDate?: string | null,
        startDate: string,
        nextIndexationMonth?: string | null,
        nextIndexation?: boolean | null,
        status: LeaseStatus,
        technicCommunicationSettingsProfileId: string,
        totalInitialRentalPrice: number,
        totalRentalPrice: number,
        type: LeaseType,
        subletting?: boolean | null,
        vatRateRentId?: string | null,
        bankAccountId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contactId?: string | null,
      contact?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      originalTechnicId?: string | null,
      replacedTechnicId?: string | null,
      certificateIds?: Array< string > | null,
      readers?: Array< string > | null,
      writers?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    ticketId?: string | null,
    ticket?:  {
      __typename: "Ticket",
      id: string,
      assignedAt?: string | null,
      assignedTo?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      assignedToId?: string | null,
      attachment?:  {
        __typename: "ModelFileConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      building?:  {
        __typename: "Building",
        id: string,
        name: string,
        addressId?: string | null,
        acquisitionValue?: number | null,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        amountOfFacades?: number | null,
        amountOfFloors?: number | null,
        amountOfHousings?: number | null,
        buildingState?: BuildingState | null,
        cadastralIncome?: number | null,
        constructionYear?: string | null,
        janitor?: boolean | null,
        jointOwnershipId?: string | null,
        notes?: string | null,
        propertyTax?: number | null,
        residenceName?: string | null,
        buildingSiteId?: string | null,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      buildingId?: string | null,
      closedAt?: string | null,
      contact?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contactId: string,
      content: string,
      conversations?:  {
        __typename: "ModelTicketConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      createdAt: string,
      emailMessageId?: string | null,
      emailReferences?: Array< string | null > | null,
      parentId?: string | null,
      plannedAt?: string | null,
      referenceCode?: string | null,
      sourceType: TicketSourceType,
      status?: TicketStatus | null,
      subject: string,
      unit?:  {
        __typename: "Unit",
        id: string,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        acquisitionValue?: number | null,
        advertisedMonthlyCharges?: number | null,
        advertisedRentalPrice?: number | null,
        cadastralIncome?: number | null,
        createdAt?: string | null,
        floor?: number | null,
        jointOwnershipId?: string | null,
        managementDate: string,
        name: string,
        notes?: string | null,
        predictedPrice?: string | null,
        propertyTax?: number | null,
        publishAddress?: boolean | null,
        surface?: number | null,
        type: UnitType,
        buildingId: string,
        unitAdvertisementId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      unitId?: string | null,
      unread: boolean,
      updatedAt?: string | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    readId: string,
    clientId: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateNotificationSubscriptionVariables = {
  filter?: ModelSubscriptionNotificationFilterInput | null,
};

export type OnUpdateNotificationSubscription = {
  onUpdateNotification?:  {
    __typename: "Notification",
    id: string,
    createdBy: NotificationCreation,
    type?: NotificationType | null,
    message?: string | null,
    popupDate: string,
    expirationDate?: string | null,
    status: NotificationStatus,
    createdAt?: string | null,
    buildingId?: string | null,
    building?:  {
      __typename: "Building",
      id: string,
      name: string,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      acquisitionValue?: number | null,
      acquisitionAdditionalCostsValue?: number | null,
      acquisitionAdvertisedValue?: number | null,
      amountOfFacades?: number | null,
      amountOfFloors?: number | null,
      amountOfHousings?: number | null,
      buildingState?: BuildingState | null,
      cadastralIncome?: number | null,
      constructionYear?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      janitor?: boolean | null,
      jointOwnershipId?: string | null,
      notes?: string | null,
      owners?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      propertyTax?: number | null,
      residenceName?: string | null,
      buildingSiteId?: string | null,
      buildingSite?:  {
        __typename: "BuildingSite",
        id: string,
        name: string,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      units?:  {
        __typename: "ModelUnitConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      events?:  {
        __typename: "ModelBuildingEventConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      teams?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    unitId?: string | null,
    unit?:  {
      __typename: "Unit",
      id: string,
      acquisitionAdditionalCostsValue?: number | null,
      acquisitionAdvertisedValue?: number | null,
      acquisitionValue?: number | null,
      advertisedMonthlyCharges?: number | null,
      advertisedRentalPrice?: number | null,
      cadastralIncome?: number | null,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      floor?: number | null,
      jointOwnershipId?: string | null,
      managementDate: string,
      name: string,
      notes?: string | null,
      predictedPrice?: string | null,
      propertyTax?: number | null,
      publishAddress?: boolean | null,
      surface?: number | null,
      type: UnitType,
      buildingId: string,
      building?:  {
        __typename: "Building",
        id: string,
        name: string,
        addressId?: string | null,
        acquisitionValue?: number | null,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        amountOfFacades?: number | null,
        amountOfFloors?: number | null,
        amountOfHousings?: number | null,
        buildingState?: BuildingState | null,
        cadastralIncome?: number | null,
        constructionYear?: string | null,
        janitor?: boolean | null,
        jointOwnershipId?: string | null,
        notes?: string | null,
        propertyTax?: number | null,
        residenceName?: string | null,
        buildingSiteId?: string | null,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      owners?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leases?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      events?:  {
        __typename: "ModelUnitEventConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      unitAdvertisementId?: string | null,
      unitInventories?:  {
        __typename: "ModelUnitInventoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    leaseId?: string | null,
    lease?:  {
      __typename: "Lease",
      id: string,
      advancedChargesInvoices?:  {
        __typename: "LeaseAdvancedChargesInvoice",
        communicationSettingsProfileId: string,
        invoiceSenderId: string,
        lastDraftInvoiceDate?: string | null,
        lastInvoiceDate?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        bankAccountId?: string | null,
      } | null,
      balance?: number | null,
      canBeExtended?: boolean | null,
      communicationSettingsProfileId: string,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      endDate: string,
      includeRealEstateInLeaseContract?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      invoiceSenderId: string,
      invoiceSender?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      inventoryOfFixturesExpert?: string | null,
      inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
      inventoryOfFixturesType?: InventoryOfFixturesType | null,
      ipiNumber?: string | null,
      language: Language,
      lastDraftInvoiceDate?: string | null,
      lastIndexationProcessDate?: string | null,
      lastInvoiceDate?: string | null,
      legalCompetentAuthority?: string | null,
      name: string,
      notes?: string | null,
      paymentFrequency: LeasePaymentFrequency,
      paymentInvoicePeriod: LeasePaymentInvoicePeriod,
      paymentInvoicePeriodCustomDay?: number | null,
      paymentOption?:  {
        __typename: "LeasePaymentOption",
        customerId?: string | null,
        enabled: boolean,
        mandateActivatedAt?: string | null,
        mandateStatus?: PaymentProviderMandateStatus | null,
        paymentMethodId?: string | null,
        qrType?: LeaseQrType | null,
      } | null,
      purchaseOrderNumber?: string | null,
      realEstateAgency?: string | null,
      realEstateTax?: number | null,
      remittanceInformation?: string | null,
      remittanceInformationType?: LeaseRemittanceType | null,
      rentalGuaranty?:  {
        __typename: "LeaseRentalGuaranty",
        amount: number,
        blockedAmount?: number | null,
        releasedAmount?: number | null,
        type: LeaseRentalGuarantyType,
        financialInstitution?: string | null,
      } | null,
      signatureDate?: string | null,
      startDate: string,
      nextIndexationMonth?: string | null,
      nextIndexation?: boolean | null,
      status: LeaseStatus,
      technicCommunicationSettingsProfileId: string,
      totalInitialRentalPrice: number,
      totalRentalPrice: number,
      type: LeaseType,
      subletting?: boolean | null,
      vatRateRentId?: string | null,
      vatRateRent?:  {
        __typename: "VatRate",
        id: string,
        country: string,
        label: string,
        value?: number | null,
        ownerId?: string | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      additionalClauses?:  {
        __typename: "ModelLeaseAdditionalClauseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      bankAccountId?: string | null,
      bankAccount?:  {
        __typename: "BankAccount",
        id: string,
        contactId: string,
        number: string,
        bicNumber?: string | null,
        bankName?: string | null,
        contactIds?: Array< string > | null,
        buildingIds?: Array< string > | null,
        holderName?: string | null,
        label?: string | null,
        disabled?: boolean | null,
        integrations?: Array< IntegrationName > | null,
        matchingRule?: BankAccountMatchingRule | null,
        balance?: number | null,
        balanceDate?: string | null,
        type: BankAccountType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contacts?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      files?:  {
        __typename: "ModelFileConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leaseActionHistories?:  {
        __typename: "ModelLeaseActionHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leasePriceHistories?:  {
        __typename: "ModelLeasePriceHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      signatureDocuments?:  {
        __typename: "ModelSignatureDocumentConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      variousOperations?:  {
        __typename: "ModelLeaseVariousOperationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    technicId?: string | null,
    technic?:  {
      __typename: "Technic",
      id: string,
      type: TechnicType,
      contractNumber?: string | null,
      communicationSettingsProfileId: string,
      maintenanceHistory?:  Array< {
        __typename: "TechnicMaintenanceHistory",
        date: string,
        contactId?: string | null,
        fileId?: string | null,
      } > | null,
      technicLibraryId?: string | null,
      technicLibrary?:  {
        __typename: "TechnicLibrary",
        id: string,
        communicationSettingsProfileId?: string | null,
        criticality: TechnicLibraryCriticality,
        isDefault?: boolean | null,
        issuingAuthority?: string | null,
        linkedCertificateIds?: Array< string > | null,
        locationScope?: TechnicLibraryLocationScope | null,
        status: TechnicLibraryStatus,
        tagIds?: Array< string > | null,
        technicLibraryFormat?: string | null,
        type: TechnicLibraryType,
        utilityTypes?: Array< UtilityType > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      technicName?: string | null,
      lastControlDate?: string | null,
      status?: TechnicStatus | null,
      utilityType?: UtilityType | null,
      utilityEanCode?: string | null,
      utilityMeterNumber?: string | null,
      utilityDistributorId?: string | null,
      utilityDistributor?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      utilityHistory?:  Array< {
        __typename: "UtilityHistory",
        date: string,
        reason?: UtilityReadingReason | null,
        reading: number,
        secondReading?: number | null,
      } > | null,
      files?:  {
        __typename: "ModelFileConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildingId?: string | null,
      building?:  {
        __typename: "Building",
        id: string,
        name: string,
        addressId?: string | null,
        acquisitionValue?: number | null,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        amountOfFacades?: number | null,
        amountOfFloors?: number | null,
        amountOfHousings?: number | null,
        buildingState?: BuildingState | null,
        cadastralIncome?: number | null,
        constructionYear?: string | null,
        janitor?: boolean | null,
        jointOwnershipId?: string | null,
        notes?: string | null,
        propertyTax?: number | null,
        residenceName?: string | null,
        buildingSiteId?: string | null,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      unitId?: string | null,
      unit?:  {
        __typename: "Unit",
        id: string,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        acquisitionValue?: number | null,
        advertisedMonthlyCharges?: number | null,
        advertisedRentalPrice?: number | null,
        cadastralIncome?: number | null,
        createdAt?: string | null,
        floor?: number | null,
        jointOwnershipId?: string | null,
        managementDate: string,
        name: string,
        notes?: string | null,
        predictedPrice?: string | null,
        propertyTax?: number | null,
        publishAddress?: boolean | null,
        surface?: number | null,
        type: UnitType,
        buildingId: string,
        unitAdvertisementId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      leaseId?: string | null,
      lease?:  {
        __typename: "Lease",
        id: string,
        balance?: number | null,
        canBeExtended?: boolean | null,
        communicationSettingsProfileId: string,
        createdAt?: string | null,
        endDate: string,
        includeRealEstateInLeaseContract?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        invoiceSenderId: string,
        inventoryOfFixturesExpert?: string | null,
        inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
        inventoryOfFixturesType?: InventoryOfFixturesType | null,
        ipiNumber?: string | null,
        language: Language,
        lastDraftInvoiceDate?: string | null,
        lastIndexationProcessDate?: string | null,
        lastInvoiceDate?: string | null,
        legalCompetentAuthority?: string | null,
        name: string,
        notes?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        purchaseOrderNumber?: string | null,
        realEstateAgency?: string | null,
        realEstateTax?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        signatureDate?: string | null,
        startDate: string,
        nextIndexationMonth?: string | null,
        nextIndexation?: boolean | null,
        status: LeaseStatus,
        technicCommunicationSettingsProfileId: string,
        totalInitialRentalPrice: number,
        totalRentalPrice: number,
        type: LeaseType,
        subletting?: boolean | null,
        vatRateRentId?: string | null,
        bankAccountId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contactId?: string | null,
      contact?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      originalTechnicId?: string | null,
      replacedTechnicId?: string | null,
      certificateIds?: Array< string > | null,
      readers?: Array< string > | null,
      writers?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    ticketId?: string | null,
    ticket?:  {
      __typename: "Ticket",
      id: string,
      assignedAt?: string | null,
      assignedTo?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      assignedToId?: string | null,
      attachment?:  {
        __typename: "ModelFileConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      building?:  {
        __typename: "Building",
        id: string,
        name: string,
        addressId?: string | null,
        acquisitionValue?: number | null,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        amountOfFacades?: number | null,
        amountOfFloors?: number | null,
        amountOfHousings?: number | null,
        buildingState?: BuildingState | null,
        cadastralIncome?: number | null,
        constructionYear?: string | null,
        janitor?: boolean | null,
        jointOwnershipId?: string | null,
        notes?: string | null,
        propertyTax?: number | null,
        residenceName?: string | null,
        buildingSiteId?: string | null,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      buildingId?: string | null,
      closedAt?: string | null,
      contact?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contactId: string,
      content: string,
      conversations?:  {
        __typename: "ModelTicketConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      createdAt: string,
      emailMessageId?: string | null,
      emailReferences?: Array< string | null > | null,
      parentId?: string | null,
      plannedAt?: string | null,
      referenceCode?: string | null,
      sourceType: TicketSourceType,
      status?: TicketStatus | null,
      subject: string,
      unit?:  {
        __typename: "Unit",
        id: string,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        acquisitionValue?: number | null,
        advertisedMonthlyCharges?: number | null,
        advertisedRentalPrice?: number | null,
        cadastralIncome?: number | null,
        createdAt?: string | null,
        floor?: number | null,
        jointOwnershipId?: string | null,
        managementDate: string,
        name: string,
        notes?: string | null,
        predictedPrice?: string | null,
        propertyTax?: number | null,
        publishAddress?: boolean | null,
        surface?: number | null,
        type: UnitType,
        buildingId: string,
        unitAdvertisementId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      unitId?: string | null,
      unread: boolean,
      updatedAt?: string | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    readId: string,
    clientId: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteNotificationSubscriptionVariables = {
  filter?: ModelSubscriptionNotificationFilterInput | null,
};

export type OnDeleteNotificationSubscription = {
  onDeleteNotification?:  {
    __typename: "Notification",
    id: string,
    createdBy: NotificationCreation,
    type?: NotificationType | null,
    message?: string | null,
    popupDate: string,
    expirationDate?: string | null,
    status: NotificationStatus,
    createdAt?: string | null,
    buildingId?: string | null,
    building?:  {
      __typename: "Building",
      id: string,
      name: string,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      acquisitionValue?: number | null,
      acquisitionAdditionalCostsValue?: number | null,
      acquisitionAdvertisedValue?: number | null,
      amountOfFacades?: number | null,
      amountOfFloors?: number | null,
      amountOfHousings?: number | null,
      buildingState?: BuildingState | null,
      cadastralIncome?: number | null,
      constructionYear?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      janitor?: boolean | null,
      jointOwnershipId?: string | null,
      notes?: string | null,
      owners?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      propertyTax?: number | null,
      residenceName?: string | null,
      buildingSiteId?: string | null,
      buildingSite?:  {
        __typename: "BuildingSite",
        id: string,
        name: string,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      units?:  {
        __typename: "ModelUnitConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      events?:  {
        __typename: "ModelBuildingEventConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      teams?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    unitId?: string | null,
    unit?:  {
      __typename: "Unit",
      id: string,
      acquisitionAdditionalCostsValue?: number | null,
      acquisitionAdvertisedValue?: number | null,
      acquisitionValue?: number | null,
      advertisedMonthlyCharges?: number | null,
      advertisedRentalPrice?: number | null,
      cadastralIncome?: number | null,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      floor?: number | null,
      jointOwnershipId?: string | null,
      managementDate: string,
      name: string,
      notes?: string | null,
      predictedPrice?: string | null,
      propertyTax?: number | null,
      publishAddress?: boolean | null,
      surface?: number | null,
      type: UnitType,
      buildingId: string,
      building?:  {
        __typename: "Building",
        id: string,
        name: string,
        addressId?: string | null,
        acquisitionValue?: number | null,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        amountOfFacades?: number | null,
        amountOfFloors?: number | null,
        amountOfHousings?: number | null,
        buildingState?: BuildingState | null,
        cadastralIncome?: number | null,
        constructionYear?: string | null,
        janitor?: boolean | null,
        jointOwnershipId?: string | null,
        notes?: string | null,
        propertyTax?: number | null,
        residenceName?: string | null,
        buildingSiteId?: string | null,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      owners?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leases?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      events?:  {
        __typename: "ModelUnitEventConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      unitAdvertisementId?: string | null,
      unitInventories?:  {
        __typename: "ModelUnitInventoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    leaseId?: string | null,
    lease?:  {
      __typename: "Lease",
      id: string,
      advancedChargesInvoices?:  {
        __typename: "LeaseAdvancedChargesInvoice",
        communicationSettingsProfileId: string,
        invoiceSenderId: string,
        lastDraftInvoiceDate?: string | null,
        lastInvoiceDate?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        bankAccountId?: string | null,
      } | null,
      balance?: number | null,
      canBeExtended?: boolean | null,
      communicationSettingsProfileId: string,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      endDate: string,
      includeRealEstateInLeaseContract?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      invoiceSenderId: string,
      invoiceSender?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      inventoryOfFixturesExpert?: string | null,
      inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
      inventoryOfFixturesType?: InventoryOfFixturesType | null,
      ipiNumber?: string | null,
      language: Language,
      lastDraftInvoiceDate?: string | null,
      lastIndexationProcessDate?: string | null,
      lastInvoiceDate?: string | null,
      legalCompetentAuthority?: string | null,
      name: string,
      notes?: string | null,
      paymentFrequency: LeasePaymentFrequency,
      paymentInvoicePeriod: LeasePaymentInvoicePeriod,
      paymentInvoicePeriodCustomDay?: number | null,
      paymentOption?:  {
        __typename: "LeasePaymentOption",
        customerId?: string | null,
        enabled: boolean,
        mandateActivatedAt?: string | null,
        mandateStatus?: PaymentProviderMandateStatus | null,
        paymentMethodId?: string | null,
        qrType?: LeaseQrType | null,
      } | null,
      purchaseOrderNumber?: string | null,
      realEstateAgency?: string | null,
      realEstateTax?: number | null,
      remittanceInformation?: string | null,
      remittanceInformationType?: LeaseRemittanceType | null,
      rentalGuaranty?:  {
        __typename: "LeaseRentalGuaranty",
        amount: number,
        blockedAmount?: number | null,
        releasedAmount?: number | null,
        type: LeaseRentalGuarantyType,
        financialInstitution?: string | null,
      } | null,
      signatureDate?: string | null,
      startDate: string,
      nextIndexationMonth?: string | null,
      nextIndexation?: boolean | null,
      status: LeaseStatus,
      technicCommunicationSettingsProfileId: string,
      totalInitialRentalPrice: number,
      totalRentalPrice: number,
      type: LeaseType,
      subletting?: boolean | null,
      vatRateRentId?: string | null,
      vatRateRent?:  {
        __typename: "VatRate",
        id: string,
        country: string,
        label: string,
        value?: number | null,
        ownerId?: string | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      additionalClauses?:  {
        __typename: "ModelLeaseAdditionalClauseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      bankAccountId?: string | null,
      bankAccount?:  {
        __typename: "BankAccount",
        id: string,
        contactId: string,
        number: string,
        bicNumber?: string | null,
        bankName?: string | null,
        contactIds?: Array< string > | null,
        buildingIds?: Array< string > | null,
        holderName?: string | null,
        label?: string | null,
        disabled?: boolean | null,
        integrations?: Array< IntegrationName > | null,
        matchingRule?: BankAccountMatchingRule | null,
        balance?: number | null,
        balanceDate?: string | null,
        type: BankAccountType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contacts?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      files?:  {
        __typename: "ModelFileConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leaseActionHistories?:  {
        __typename: "ModelLeaseActionHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leasePriceHistories?:  {
        __typename: "ModelLeasePriceHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      signatureDocuments?:  {
        __typename: "ModelSignatureDocumentConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      variousOperations?:  {
        __typename: "ModelLeaseVariousOperationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    technicId?: string | null,
    technic?:  {
      __typename: "Technic",
      id: string,
      type: TechnicType,
      contractNumber?: string | null,
      communicationSettingsProfileId: string,
      maintenanceHistory?:  Array< {
        __typename: "TechnicMaintenanceHistory",
        date: string,
        contactId?: string | null,
        fileId?: string | null,
      } > | null,
      technicLibraryId?: string | null,
      technicLibrary?:  {
        __typename: "TechnicLibrary",
        id: string,
        communicationSettingsProfileId?: string | null,
        criticality: TechnicLibraryCriticality,
        isDefault?: boolean | null,
        issuingAuthority?: string | null,
        linkedCertificateIds?: Array< string > | null,
        locationScope?: TechnicLibraryLocationScope | null,
        status: TechnicLibraryStatus,
        tagIds?: Array< string > | null,
        technicLibraryFormat?: string | null,
        type: TechnicLibraryType,
        utilityTypes?: Array< UtilityType > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      technicName?: string | null,
      lastControlDate?: string | null,
      status?: TechnicStatus | null,
      utilityType?: UtilityType | null,
      utilityEanCode?: string | null,
      utilityMeterNumber?: string | null,
      utilityDistributorId?: string | null,
      utilityDistributor?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      utilityHistory?:  Array< {
        __typename: "UtilityHistory",
        date: string,
        reason?: UtilityReadingReason | null,
        reading: number,
        secondReading?: number | null,
      } > | null,
      files?:  {
        __typename: "ModelFileConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildingId?: string | null,
      building?:  {
        __typename: "Building",
        id: string,
        name: string,
        addressId?: string | null,
        acquisitionValue?: number | null,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        amountOfFacades?: number | null,
        amountOfFloors?: number | null,
        amountOfHousings?: number | null,
        buildingState?: BuildingState | null,
        cadastralIncome?: number | null,
        constructionYear?: string | null,
        janitor?: boolean | null,
        jointOwnershipId?: string | null,
        notes?: string | null,
        propertyTax?: number | null,
        residenceName?: string | null,
        buildingSiteId?: string | null,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      unitId?: string | null,
      unit?:  {
        __typename: "Unit",
        id: string,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        acquisitionValue?: number | null,
        advertisedMonthlyCharges?: number | null,
        advertisedRentalPrice?: number | null,
        cadastralIncome?: number | null,
        createdAt?: string | null,
        floor?: number | null,
        jointOwnershipId?: string | null,
        managementDate: string,
        name: string,
        notes?: string | null,
        predictedPrice?: string | null,
        propertyTax?: number | null,
        publishAddress?: boolean | null,
        surface?: number | null,
        type: UnitType,
        buildingId: string,
        unitAdvertisementId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      leaseId?: string | null,
      lease?:  {
        __typename: "Lease",
        id: string,
        balance?: number | null,
        canBeExtended?: boolean | null,
        communicationSettingsProfileId: string,
        createdAt?: string | null,
        endDate: string,
        includeRealEstateInLeaseContract?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        invoiceSenderId: string,
        inventoryOfFixturesExpert?: string | null,
        inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
        inventoryOfFixturesType?: InventoryOfFixturesType | null,
        ipiNumber?: string | null,
        language: Language,
        lastDraftInvoiceDate?: string | null,
        lastIndexationProcessDate?: string | null,
        lastInvoiceDate?: string | null,
        legalCompetentAuthority?: string | null,
        name: string,
        notes?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        purchaseOrderNumber?: string | null,
        realEstateAgency?: string | null,
        realEstateTax?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        signatureDate?: string | null,
        startDate: string,
        nextIndexationMonth?: string | null,
        nextIndexation?: boolean | null,
        status: LeaseStatus,
        technicCommunicationSettingsProfileId: string,
        totalInitialRentalPrice: number,
        totalRentalPrice: number,
        type: LeaseType,
        subletting?: boolean | null,
        vatRateRentId?: string | null,
        bankAccountId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contactId?: string | null,
      contact?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      originalTechnicId?: string | null,
      replacedTechnicId?: string | null,
      certificateIds?: Array< string > | null,
      readers?: Array< string > | null,
      writers?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    ticketId?: string | null,
    ticket?:  {
      __typename: "Ticket",
      id: string,
      assignedAt?: string | null,
      assignedTo?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      assignedToId?: string | null,
      attachment?:  {
        __typename: "ModelFileConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      building?:  {
        __typename: "Building",
        id: string,
        name: string,
        addressId?: string | null,
        acquisitionValue?: number | null,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        amountOfFacades?: number | null,
        amountOfFloors?: number | null,
        amountOfHousings?: number | null,
        buildingState?: BuildingState | null,
        cadastralIncome?: number | null,
        constructionYear?: string | null,
        janitor?: boolean | null,
        jointOwnershipId?: string | null,
        notes?: string | null,
        propertyTax?: number | null,
        residenceName?: string | null,
        buildingSiteId?: string | null,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      buildingId?: string | null,
      closedAt?: string | null,
      contact?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contactId: string,
      content: string,
      conversations?:  {
        __typename: "ModelTicketConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      createdAt: string,
      emailMessageId?: string | null,
      emailReferences?: Array< string | null > | null,
      parentId?: string | null,
      plannedAt?: string | null,
      referenceCode?: string | null,
      sourceType: TicketSourceType,
      status?: TicketStatus | null,
      subject: string,
      unit?:  {
        __typename: "Unit",
        id: string,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        acquisitionValue?: number | null,
        advertisedMonthlyCharges?: number | null,
        advertisedRentalPrice?: number | null,
        cadastralIncome?: number | null,
        createdAt?: string | null,
        floor?: number | null,
        jointOwnershipId?: string | null,
        managementDate: string,
        name: string,
        notes?: string | null,
        predictedPrice?: string | null,
        propertyTax?: number | null,
        publishAddress?: boolean | null,
        surface?: number | null,
        type: UnitType,
        buildingId: string,
        unitAdvertisementId?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      unitId?: string | null,
      unread: boolean,
      updatedAt?: string | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    readId: string,
    clientId: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateScheduleRuleSubscriptionVariables = {
  filter?: ModelSubscriptionScheduleRuleFilterInput | null,
};

export type OnCreateScheduleRuleSubscription = {
  onCreateScheduleRule?:  {
    __typename: "ScheduleRule",
    id: string,
    conditions:  Array< {
      __typename: "RuleCondition",
      attribute:  {
        __typename: "RuleAttributeRef",
        attributeName: string,
      },
      comparisonMode?: RuleComparisonMode | null,
      operator: RuleConditionOperator,
      values?: Array< string > | null,
      valueKind: RuleValueKind,
    } >,
    conditionsOperator?: RuleConditionsOperator | null,
    foreignKey: string,
    foreignTableName: string,
    name?:  Array< {
      __typename: "CustomLabel",
      language: string,
      label: string,
    } > | null,
    order?: number | null,
    outcome:  {
      __typename: "RuleOutcome",
      interval?:  {
        __typename: "RuleIntervalOutcome",
      } | null,
      type: RuleOutcomeType,
    },
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateScheduleRuleSubscriptionVariables = {
  filter?: ModelSubscriptionScheduleRuleFilterInput | null,
};

export type OnUpdateScheduleRuleSubscription = {
  onUpdateScheduleRule?:  {
    __typename: "ScheduleRule",
    id: string,
    conditions:  Array< {
      __typename: "RuleCondition",
      attribute:  {
        __typename: "RuleAttributeRef",
        attributeName: string,
      },
      comparisonMode?: RuleComparisonMode | null,
      operator: RuleConditionOperator,
      values?: Array< string > | null,
      valueKind: RuleValueKind,
    } >,
    conditionsOperator?: RuleConditionsOperator | null,
    foreignKey: string,
    foreignTableName: string,
    name?:  Array< {
      __typename: "CustomLabel",
      language: string,
      label: string,
    } > | null,
    order?: number | null,
    outcome:  {
      __typename: "RuleOutcome",
      interval?:  {
        __typename: "RuleIntervalOutcome",
      } | null,
      type: RuleOutcomeType,
    },
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteScheduleRuleSubscriptionVariables = {
  filter?: ModelSubscriptionScheduleRuleFilterInput | null,
};

export type OnDeleteScheduleRuleSubscription = {
  onDeleteScheduleRule?:  {
    __typename: "ScheduleRule",
    id: string,
    conditions:  Array< {
      __typename: "RuleCondition",
      attribute:  {
        __typename: "RuleAttributeRef",
        attributeName: string,
      },
      comparisonMode?: RuleComparisonMode | null,
      operator: RuleConditionOperator,
      values?: Array< string > | null,
      valueKind: RuleValueKind,
    } >,
    conditionsOperator?: RuleConditionsOperator | null,
    foreignKey: string,
    foreignTableName: string,
    name?:  Array< {
      __typename: "CustomLabel",
      language: string,
      label: string,
    } > | null,
    order?: number | null,
    outcome:  {
      __typename: "RuleOutcome",
      interval?:  {
        __typename: "RuleIntervalOutcome",
      } | null,
      type: RuleOutcomeType,
    },
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateSendingSourceSubscriptionVariables = {
  filter?: ModelSubscriptionSendingSourceFilterInput | null,
};

export type OnCreateSendingSourceSubscription = {
  onCreateSendingSource?:  {
    __typename: "SendingSource",
    id: string,
    createdAt?: string | null,
    createdById?: string | null,
    createdBy?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    dnsRecords?:  Array< {
      __typename: "DNSRecord",
      name: string,
      type: string,
      value: string,
    } > | null,
    emailAddress: string,
    issuesEmail: string,
    chargesEmail: string,
    errorMessage?: SendingSourceErrorType | null,
    name: string,
    lastReminderDate?: string | null,
    status: SendingSourceStatus,
    statusLastVerification?: string | null,
    verifiedType: SendingSourceVerifiedType,
    readId: string,
    clientId: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateSendingSourceSubscriptionVariables = {
  filter?: ModelSubscriptionSendingSourceFilterInput | null,
};

export type OnUpdateSendingSourceSubscription = {
  onUpdateSendingSource?:  {
    __typename: "SendingSource",
    id: string,
    createdAt?: string | null,
    createdById?: string | null,
    createdBy?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    dnsRecords?:  Array< {
      __typename: "DNSRecord",
      name: string,
      type: string,
      value: string,
    } > | null,
    emailAddress: string,
    issuesEmail: string,
    chargesEmail: string,
    errorMessage?: SendingSourceErrorType | null,
    name: string,
    lastReminderDate?: string | null,
    status: SendingSourceStatus,
    statusLastVerification?: string | null,
    verifiedType: SendingSourceVerifiedType,
    readId: string,
    clientId: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteSendingSourceSubscriptionVariables = {
  filter?: ModelSubscriptionSendingSourceFilterInput | null,
};

export type OnDeleteSendingSourceSubscription = {
  onDeleteSendingSource?:  {
    __typename: "SendingSource",
    id: string,
    createdAt?: string | null,
    createdById?: string | null,
    createdBy?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    dnsRecords?:  Array< {
      __typename: "DNSRecord",
      name: string,
      type: string,
      value: string,
    } > | null,
    emailAddress: string,
    issuesEmail: string,
    chargesEmail: string,
    errorMessage?: SendingSourceErrorType | null,
    name: string,
    lastReminderDate?: string | null,
    status: SendingSourceStatus,
    statusLastVerification?: string | null,
    verifiedType: SendingSourceVerifiedType,
    readId: string,
    clientId: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateTagSubscriptionVariables = {
  filter?: ModelSubscriptionTagFilterInput | null,
};

export type OnCreateTagSubscription = {
  onCreateTag?:  {
    __typename: "Tag",
    id: string,
    color?: string | null,
    foreignTableName: string,
    labels:  Array< {
      __typename: "CustomLabel",
      language: string,
      label: string,
    } >,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateTagSubscriptionVariables = {
  filter?: ModelSubscriptionTagFilterInput | null,
};

export type OnUpdateTagSubscription = {
  onUpdateTag?:  {
    __typename: "Tag",
    id: string,
    color?: string | null,
    foreignTableName: string,
    labels:  Array< {
      __typename: "CustomLabel",
      language: string,
      label: string,
    } >,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteTagSubscriptionVariables = {
  filter?: ModelSubscriptionTagFilterInput | null,
};

export type OnDeleteTagSubscription = {
  onDeleteTag?:  {
    __typename: "Tag",
    id: string,
    color?: string | null,
    foreignTableName: string,
    labels:  Array< {
      __typename: "CustomLabel",
      language: string,
      label: string,
    } >,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateTechnicSubscriptionVariables = {
  filter?: ModelSubscriptionTechnicFilterInput | null,
};

export type OnCreateTechnicSubscription = {
  onCreateTechnic?:  {
    __typename: "Technic",
    id: string,
    type: TechnicType,
    contractNumber?: string | null,
    communicationSettingsProfileId: string,
    maintenanceHistory?:  Array< {
      __typename: "TechnicMaintenanceHistory",
      date: string,
      contactId?: string | null,
      fileId?: string | null,
    } > | null,
    technicLibraryId?: string | null,
    technicLibrary?:  {
      __typename: "TechnicLibrary",
      id: string,
      certificateValidity?:  {
        __typename: "CertificateLibraryValidity",
        nonCompliant?: boolean | null,
        overlapping?: boolean | null,
        riskLevel?: RiskLevelExpiration | null,
      } | null,
      communicationSettingsProfileId?: string | null,
      criticality: TechnicLibraryCriticality,
      customFields?:  {
        __typename: "ModelCustomFieldConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      descriptions?:  Array< {
        __typename: "CustomLabel",
        language: string,
        label: string,
      } > | null,
      isDefault?: boolean | null,
      issuingAuthority?: string | null,
      linkedCertificateIds?: Array< string > | null,
      locationScope?: TechnicLibraryLocationScope | null,
      maintenanceSchemas?:  Array< {
        __typename: "TechnicLibraryMaintenanceSchema",
        id: string,
        criticality: TechnicLibraryCriticality,
        deadline?: string | null,
        maintenanceType: TechnicLibraryMaintenanceType,
        notificationsEnabled?: boolean | null,
        notificationType?: NotificationType | null,
        proofType?: Array< TechnicLibraryProofType > | null,
        recurrence?: TechnicLibraryRecurrence | null,
        responsibleParty: TechnicLibraryResponsibleParty,
        triggerType?: TechnicLibraryTriggerType | null,
      } > | null,
      names:  Array< {
        __typename: "CustomLabel",
        language: string,
        label: string,
      } >,
      status: TechnicLibraryStatus,
      tagIds?: Array< string > | null,
      technicLibraryFormat?: string | null,
      type: TechnicLibraryType,
      utilityTypes?: Array< UtilityType > | null,
      validity?:  {
        __typename: "TechnicLibraryValidity",
        value: number,
        validityUnit: TechnicLibraryValidityUnit,
      } | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    technicName?: string | null,
    lastControlDate?: string | null,
    status?: TechnicStatus | null,
    utilityType?: UtilityType | null,
    utilityEanCode?: string | null,
    utilityMeterNumber?: string | null,
    utilityDistributorId?: string | null,
    utilityDistributor?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    utilityHistory?:  Array< {
      __typename: "UtilityHistory",
      date: string,
      reason?: UtilityReadingReason | null,
      reading: number,
      secondReading?: number | null,
    } > | null,
    files?:  {
      __typename: "ModelFileConnection",
      items:  Array< {
        __typename: "File",
        id: string,
        bucket: string,
        createdAt?: string | null,
        categoryId: string,
        foreignKey: string,
        foreignTableName: string,
        key: string,
        mimeType?: string | null,
        region: string,
        size?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        _ttl?: number | null,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    buildingId?: string | null,
    building?:  {
      __typename: "Building",
      id: string,
      name: string,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      acquisitionValue?: number | null,
      acquisitionAdditionalCostsValue?: number | null,
      acquisitionAdvertisedValue?: number | null,
      amountOfFacades?: number | null,
      amountOfFloors?: number | null,
      amountOfHousings?: number | null,
      buildingState?: BuildingState | null,
      cadastralIncome?: number | null,
      constructionYear?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      janitor?: boolean | null,
      jointOwnershipId?: string | null,
      notes?: string | null,
      owners?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      propertyTax?: number | null,
      residenceName?: string | null,
      buildingSiteId?: string | null,
      buildingSite?:  {
        __typename: "BuildingSite",
        id: string,
        name: string,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      units?:  {
        __typename: "ModelUnitConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      events?:  {
        __typename: "ModelBuildingEventConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      teams?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    unitId?: string | null,
    unit?:  {
      __typename: "Unit",
      id: string,
      acquisitionAdditionalCostsValue?: number | null,
      acquisitionAdvertisedValue?: number | null,
      acquisitionValue?: number | null,
      advertisedMonthlyCharges?: number | null,
      advertisedRentalPrice?: number | null,
      cadastralIncome?: number | null,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      floor?: number | null,
      jointOwnershipId?: string | null,
      managementDate: string,
      name: string,
      notes?: string | null,
      predictedPrice?: string | null,
      propertyTax?: number | null,
      publishAddress?: boolean | null,
      surface?: number | null,
      type: UnitType,
      buildingId: string,
      building?:  {
        __typename: "Building",
        id: string,
        name: string,
        addressId?: string | null,
        acquisitionValue?: number | null,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        amountOfFacades?: number | null,
        amountOfFloors?: number | null,
        amountOfHousings?: number | null,
        buildingState?: BuildingState | null,
        cadastralIncome?: number | null,
        constructionYear?: string | null,
        janitor?: boolean | null,
        jointOwnershipId?: string | null,
        notes?: string | null,
        propertyTax?: number | null,
        residenceName?: string | null,
        buildingSiteId?: string | null,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      owners?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leases?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      events?:  {
        __typename: "ModelUnitEventConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      unitAdvertisementId?: string | null,
      unitInventories?:  {
        __typename: "ModelUnitInventoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    leaseId?: string | null,
    lease?:  {
      __typename: "Lease",
      id: string,
      advancedChargesInvoices?:  {
        __typename: "LeaseAdvancedChargesInvoice",
        communicationSettingsProfileId: string,
        invoiceSenderId: string,
        lastDraftInvoiceDate?: string | null,
        lastInvoiceDate?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        bankAccountId?: string | null,
      } | null,
      balance?: number | null,
      canBeExtended?: boolean | null,
      communicationSettingsProfileId: string,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      endDate: string,
      includeRealEstateInLeaseContract?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      invoiceSenderId: string,
      invoiceSender?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      inventoryOfFixturesExpert?: string | null,
      inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
      inventoryOfFixturesType?: InventoryOfFixturesType | null,
      ipiNumber?: string | null,
      language: Language,
      lastDraftInvoiceDate?: string | null,
      lastIndexationProcessDate?: string | null,
      lastInvoiceDate?: string | null,
      legalCompetentAuthority?: string | null,
      name: string,
      notes?: string | null,
      paymentFrequency: LeasePaymentFrequency,
      paymentInvoicePeriod: LeasePaymentInvoicePeriod,
      paymentInvoicePeriodCustomDay?: number | null,
      paymentOption?:  {
        __typename: "LeasePaymentOption",
        customerId?: string | null,
        enabled: boolean,
        mandateActivatedAt?: string | null,
        mandateStatus?: PaymentProviderMandateStatus | null,
        paymentMethodId?: string | null,
        qrType?: LeaseQrType | null,
      } | null,
      purchaseOrderNumber?: string | null,
      realEstateAgency?: string | null,
      realEstateTax?: number | null,
      remittanceInformation?: string | null,
      remittanceInformationType?: LeaseRemittanceType | null,
      rentalGuaranty?:  {
        __typename: "LeaseRentalGuaranty",
        amount: number,
        blockedAmount?: number | null,
        releasedAmount?: number | null,
        type: LeaseRentalGuarantyType,
        financialInstitution?: string | null,
      } | null,
      signatureDate?: string | null,
      startDate: string,
      nextIndexationMonth?: string | null,
      nextIndexation?: boolean | null,
      status: LeaseStatus,
      technicCommunicationSettingsProfileId: string,
      totalInitialRentalPrice: number,
      totalRentalPrice: number,
      type: LeaseType,
      subletting?: boolean | null,
      vatRateRentId?: string | null,
      vatRateRent?:  {
        __typename: "VatRate",
        id: string,
        country: string,
        label: string,
        value?: number | null,
        ownerId?: string | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      additionalClauses?:  {
        __typename: "ModelLeaseAdditionalClauseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      bankAccountId?: string | null,
      bankAccount?:  {
        __typename: "BankAccount",
        id: string,
        contactId: string,
        number: string,
        bicNumber?: string | null,
        bankName?: string | null,
        contactIds?: Array< string > | null,
        buildingIds?: Array< string > | null,
        holderName?: string | null,
        label?: string | null,
        disabled?: boolean | null,
        integrations?: Array< IntegrationName > | null,
        matchingRule?: BankAccountMatchingRule | null,
        balance?: number | null,
        balanceDate?: string | null,
        type: BankAccountType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contacts?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      files?:  {
        __typename: "ModelFileConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leaseActionHistories?:  {
        __typename: "ModelLeaseActionHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leasePriceHistories?:  {
        __typename: "ModelLeasePriceHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      signatureDocuments?:  {
        __typename: "ModelSignatureDocumentConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      variousOperations?:  {
        __typename: "ModelLeaseVariousOperationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    contactId?: string | null,
    contact?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    customValues?:  Array< {
      __typename: "CustomValue",
      name: string,
      value: string,
    } > | null,
    originalTechnicId?: string | null,
    replacedTechnicId?: string | null,
    certificateIds?: Array< string > | null,
    readers?: Array< string > | null,
    writers?: Array< string > | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateTechnicSubscriptionVariables = {
  filter?: ModelSubscriptionTechnicFilterInput | null,
};

export type OnUpdateTechnicSubscription = {
  onUpdateTechnic?:  {
    __typename: "Technic",
    id: string,
    type: TechnicType,
    contractNumber?: string | null,
    communicationSettingsProfileId: string,
    maintenanceHistory?:  Array< {
      __typename: "TechnicMaintenanceHistory",
      date: string,
      contactId?: string | null,
      fileId?: string | null,
    } > | null,
    technicLibraryId?: string | null,
    technicLibrary?:  {
      __typename: "TechnicLibrary",
      id: string,
      certificateValidity?:  {
        __typename: "CertificateLibraryValidity",
        nonCompliant?: boolean | null,
        overlapping?: boolean | null,
        riskLevel?: RiskLevelExpiration | null,
      } | null,
      communicationSettingsProfileId?: string | null,
      criticality: TechnicLibraryCriticality,
      customFields?:  {
        __typename: "ModelCustomFieldConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      descriptions?:  Array< {
        __typename: "CustomLabel",
        language: string,
        label: string,
      } > | null,
      isDefault?: boolean | null,
      issuingAuthority?: string | null,
      linkedCertificateIds?: Array< string > | null,
      locationScope?: TechnicLibraryLocationScope | null,
      maintenanceSchemas?:  Array< {
        __typename: "TechnicLibraryMaintenanceSchema",
        id: string,
        criticality: TechnicLibraryCriticality,
        deadline?: string | null,
        maintenanceType: TechnicLibraryMaintenanceType,
        notificationsEnabled?: boolean | null,
        notificationType?: NotificationType | null,
        proofType?: Array< TechnicLibraryProofType > | null,
        recurrence?: TechnicLibraryRecurrence | null,
        responsibleParty: TechnicLibraryResponsibleParty,
        triggerType?: TechnicLibraryTriggerType | null,
      } > | null,
      names:  Array< {
        __typename: "CustomLabel",
        language: string,
        label: string,
      } >,
      status: TechnicLibraryStatus,
      tagIds?: Array< string > | null,
      technicLibraryFormat?: string | null,
      type: TechnicLibraryType,
      utilityTypes?: Array< UtilityType > | null,
      validity?:  {
        __typename: "TechnicLibraryValidity",
        value: number,
        validityUnit: TechnicLibraryValidityUnit,
      } | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    technicName?: string | null,
    lastControlDate?: string | null,
    status?: TechnicStatus | null,
    utilityType?: UtilityType | null,
    utilityEanCode?: string | null,
    utilityMeterNumber?: string | null,
    utilityDistributorId?: string | null,
    utilityDistributor?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    utilityHistory?:  Array< {
      __typename: "UtilityHistory",
      date: string,
      reason?: UtilityReadingReason | null,
      reading: number,
      secondReading?: number | null,
    } > | null,
    files?:  {
      __typename: "ModelFileConnection",
      items:  Array< {
        __typename: "File",
        id: string,
        bucket: string,
        createdAt?: string | null,
        categoryId: string,
        foreignKey: string,
        foreignTableName: string,
        key: string,
        mimeType?: string | null,
        region: string,
        size?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        _ttl?: number | null,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    buildingId?: string | null,
    building?:  {
      __typename: "Building",
      id: string,
      name: string,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      acquisitionValue?: number | null,
      acquisitionAdditionalCostsValue?: number | null,
      acquisitionAdvertisedValue?: number | null,
      amountOfFacades?: number | null,
      amountOfFloors?: number | null,
      amountOfHousings?: number | null,
      buildingState?: BuildingState | null,
      cadastralIncome?: number | null,
      constructionYear?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      janitor?: boolean | null,
      jointOwnershipId?: string | null,
      notes?: string | null,
      owners?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      propertyTax?: number | null,
      residenceName?: string | null,
      buildingSiteId?: string | null,
      buildingSite?:  {
        __typename: "BuildingSite",
        id: string,
        name: string,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      units?:  {
        __typename: "ModelUnitConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      events?:  {
        __typename: "ModelBuildingEventConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      teams?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    unitId?: string | null,
    unit?:  {
      __typename: "Unit",
      id: string,
      acquisitionAdditionalCostsValue?: number | null,
      acquisitionAdvertisedValue?: number | null,
      acquisitionValue?: number | null,
      advertisedMonthlyCharges?: number | null,
      advertisedRentalPrice?: number | null,
      cadastralIncome?: number | null,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      floor?: number | null,
      jointOwnershipId?: string | null,
      managementDate: string,
      name: string,
      notes?: string | null,
      predictedPrice?: string | null,
      propertyTax?: number | null,
      publishAddress?: boolean | null,
      surface?: number | null,
      type: UnitType,
      buildingId: string,
      building?:  {
        __typename: "Building",
        id: string,
        name: string,
        addressId?: string | null,
        acquisitionValue?: number | null,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        amountOfFacades?: number | null,
        amountOfFloors?: number | null,
        amountOfHousings?: number | null,
        buildingState?: BuildingState | null,
        cadastralIncome?: number | null,
        constructionYear?: string | null,
        janitor?: boolean | null,
        jointOwnershipId?: string | null,
        notes?: string | null,
        propertyTax?: number | null,
        residenceName?: string | null,
        buildingSiteId?: string | null,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      owners?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leases?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      events?:  {
        __typename: "ModelUnitEventConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      unitAdvertisementId?: string | null,
      unitInventories?:  {
        __typename: "ModelUnitInventoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    leaseId?: string | null,
    lease?:  {
      __typename: "Lease",
      id: string,
      advancedChargesInvoices?:  {
        __typename: "LeaseAdvancedChargesInvoice",
        communicationSettingsProfileId: string,
        invoiceSenderId: string,
        lastDraftInvoiceDate?: string | null,
        lastInvoiceDate?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        bankAccountId?: string | null,
      } | null,
      balance?: number | null,
      canBeExtended?: boolean | null,
      communicationSettingsProfileId: string,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      endDate: string,
      includeRealEstateInLeaseContract?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      invoiceSenderId: string,
      invoiceSender?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      inventoryOfFixturesExpert?: string | null,
      inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
      inventoryOfFixturesType?: InventoryOfFixturesType | null,
      ipiNumber?: string | null,
      language: Language,
      lastDraftInvoiceDate?: string | null,
      lastIndexationProcessDate?: string | null,
      lastInvoiceDate?: string | null,
      legalCompetentAuthority?: string | null,
      name: string,
      notes?: string | null,
      paymentFrequency: LeasePaymentFrequency,
      paymentInvoicePeriod: LeasePaymentInvoicePeriod,
      paymentInvoicePeriodCustomDay?: number | null,
      paymentOption?:  {
        __typename: "LeasePaymentOption",
        customerId?: string | null,
        enabled: boolean,
        mandateActivatedAt?: string | null,
        mandateStatus?: PaymentProviderMandateStatus | null,
        paymentMethodId?: string | null,
        qrType?: LeaseQrType | null,
      } | null,
      purchaseOrderNumber?: string | null,
      realEstateAgency?: string | null,
      realEstateTax?: number | null,
      remittanceInformation?: string | null,
      remittanceInformationType?: LeaseRemittanceType | null,
      rentalGuaranty?:  {
        __typename: "LeaseRentalGuaranty",
        amount: number,
        blockedAmount?: number | null,
        releasedAmount?: number | null,
        type: LeaseRentalGuarantyType,
        financialInstitution?: string | null,
      } | null,
      signatureDate?: string | null,
      startDate: string,
      nextIndexationMonth?: string | null,
      nextIndexation?: boolean | null,
      status: LeaseStatus,
      technicCommunicationSettingsProfileId: string,
      totalInitialRentalPrice: number,
      totalRentalPrice: number,
      type: LeaseType,
      subletting?: boolean | null,
      vatRateRentId?: string | null,
      vatRateRent?:  {
        __typename: "VatRate",
        id: string,
        country: string,
        label: string,
        value?: number | null,
        ownerId?: string | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      additionalClauses?:  {
        __typename: "ModelLeaseAdditionalClauseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      bankAccountId?: string | null,
      bankAccount?:  {
        __typename: "BankAccount",
        id: string,
        contactId: string,
        number: string,
        bicNumber?: string | null,
        bankName?: string | null,
        contactIds?: Array< string > | null,
        buildingIds?: Array< string > | null,
        holderName?: string | null,
        label?: string | null,
        disabled?: boolean | null,
        integrations?: Array< IntegrationName > | null,
        matchingRule?: BankAccountMatchingRule | null,
        balance?: number | null,
        balanceDate?: string | null,
        type: BankAccountType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contacts?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      files?:  {
        __typename: "ModelFileConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leaseActionHistories?:  {
        __typename: "ModelLeaseActionHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leasePriceHistories?:  {
        __typename: "ModelLeasePriceHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      signatureDocuments?:  {
        __typename: "ModelSignatureDocumentConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      variousOperations?:  {
        __typename: "ModelLeaseVariousOperationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    contactId?: string | null,
    contact?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    customValues?:  Array< {
      __typename: "CustomValue",
      name: string,
      value: string,
    } > | null,
    originalTechnicId?: string | null,
    replacedTechnicId?: string | null,
    certificateIds?: Array< string > | null,
    readers?: Array< string > | null,
    writers?: Array< string > | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteTechnicSubscriptionVariables = {
  filter?: ModelSubscriptionTechnicFilterInput | null,
};

export type OnDeleteTechnicSubscription = {
  onDeleteTechnic?:  {
    __typename: "Technic",
    id: string,
    type: TechnicType,
    contractNumber?: string | null,
    communicationSettingsProfileId: string,
    maintenanceHistory?:  Array< {
      __typename: "TechnicMaintenanceHistory",
      date: string,
      contactId?: string | null,
      fileId?: string | null,
    } > | null,
    technicLibraryId?: string | null,
    technicLibrary?:  {
      __typename: "TechnicLibrary",
      id: string,
      certificateValidity?:  {
        __typename: "CertificateLibraryValidity",
        nonCompliant?: boolean | null,
        overlapping?: boolean | null,
        riskLevel?: RiskLevelExpiration | null,
      } | null,
      communicationSettingsProfileId?: string | null,
      criticality: TechnicLibraryCriticality,
      customFields?:  {
        __typename: "ModelCustomFieldConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      descriptions?:  Array< {
        __typename: "CustomLabel",
        language: string,
        label: string,
      } > | null,
      isDefault?: boolean | null,
      issuingAuthority?: string | null,
      linkedCertificateIds?: Array< string > | null,
      locationScope?: TechnicLibraryLocationScope | null,
      maintenanceSchemas?:  Array< {
        __typename: "TechnicLibraryMaintenanceSchema",
        id: string,
        criticality: TechnicLibraryCriticality,
        deadline?: string | null,
        maintenanceType: TechnicLibraryMaintenanceType,
        notificationsEnabled?: boolean | null,
        notificationType?: NotificationType | null,
        proofType?: Array< TechnicLibraryProofType > | null,
        recurrence?: TechnicLibraryRecurrence | null,
        responsibleParty: TechnicLibraryResponsibleParty,
        triggerType?: TechnicLibraryTriggerType | null,
      } > | null,
      names:  Array< {
        __typename: "CustomLabel",
        language: string,
        label: string,
      } >,
      status: TechnicLibraryStatus,
      tagIds?: Array< string > | null,
      technicLibraryFormat?: string | null,
      type: TechnicLibraryType,
      utilityTypes?: Array< UtilityType > | null,
      validity?:  {
        __typename: "TechnicLibraryValidity",
        value: number,
        validityUnit: TechnicLibraryValidityUnit,
      } | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    technicName?: string | null,
    lastControlDate?: string | null,
    status?: TechnicStatus | null,
    utilityType?: UtilityType | null,
    utilityEanCode?: string | null,
    utilityMeterNumber?: string | null,
    utilityDistributorId?: string | null,
    utilityDistributor?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    utilityHistory?:  Array< {
      __typename: "UtilityHistory",
      date: string,
      reason?: UtilityReadingReason | null,
      reading: number,
      secondReading?: number | null,
    } > | null,
    files?:  {
      __typename: "ModelFileConnection",
      items:  Array< {
        __typename: "File",
        id: string,
        bucket: string,
        createdAt?: string | null,
        categoryId: string,
        foreignKey: string,
        foreignTableName: string,
        key: string,
        mimeType?: string | null,
        region: string,
        size?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        _ttl?: number | null,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    buildingId?: string | null,
    building?:  {
      __typename: "Building",
      id: string,
      name: string,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      acquisitionValue?: number | null,
      acquisitionAdditionalCostsValue?: number | null,
      acquisitionAdvertisedValue?: number | null,
      amountOfFacades?: number | null,
      amountOfFloors?: number | null,
      amountOfHousings?: number | null,
      buildingState?: BuildingState | null,
      cadastralIncome?: number | null,
      constructionYear?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      janitor?: boolean | null,
      jointOwnershipId?: string | null,
      notes?: string | null,
      owners?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      propertyTax?: number | null,
      residenceName?: string | null,
      buildingSiteId?: string | null,
      buildingSite?:  {
        __typename: "BuildingSite",
        id: string,
        name: string,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      units?:  {
        __typename: "ModelUnitConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      events?:  {
        __typename: "ModelBuildingEventConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      teams?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    unitId?: string | null,
    unit?:  {
      __typename: "Unit",
      id: string,
      acquisitionAdditionalCostsValue?: number | null,
      acquisitionAdvertisedValue?: number | null,
      acquisitionValue?: number | null,
      advertisedMonthlyCharges?: number | null,
      advertisedRentalPrice?: number | null,
      cadastralIncome?: number | null,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      floor?: number | null,
      jointOwnershipId?: string | null,
      managementDate: string,
      name: string,
      notes?: string | null,
      predictedPrice?: string | null,
      propertyTax?: number | null,
      publishAddress?: boolean | null,
      surface?: number | null,
      type: UnitType,
      buildingId: string,
      building?:  {
        __typename: "Building",
        id: string,
        name: string,
        addressId?: string | null,
        acquisitionValue?: number | null,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        amountOfFacades?: number | null,
        amountOfFloors?: number | null,
        amountOfHousings?: number | null,
        buildingState?: BuildingState | null,
        cadastralIncome?: number | null,
        constructionYear?: string | null,
        janitor?: boolean | null,
        jointOwnershipId?: string | null,
        notes?: string | null,
        propertyTax?: number | null,
        residenceName?: string | null,
        buildingSiteId?: string | null,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      owners?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leases?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      events?:  {
        __typename: "ModelUnitEventConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      unitAdvertisementId?: string | null,
      unitInventories?:  {
        __typename: "ModelUnitInventoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    leaseId?: string | null,
    lease?:  {
      __typename: "Lease",
      id: string,
      advancedChargesInvoices?:  {
        __typename: "LeaseAdvancedChargesInvoice",
        communicationSettingsProfileId: string,
        invoiceSenderId: string,
        lastDraftInvoiceDate?: string | null,
        lastInvoiceDate?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        bankAccountId?: string | null,
      } | null,
      balance?: number | null,
      canBeExtended?: boolean | null,
      communicationSettingsProfileId: string,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      endDate: string,
      includeRealEstateInLeaseContract?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      invoiceSenderId: string,
      invoiceSender?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      inventoryOfFixturesExpert?: string | null,
      inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
      inventoryOfFixturesType?: InventoryOfFixturesType | null,
      ipiNumber?: string | null,
      language: Language,
      lastDraftInvoiceDate?: string | null,
      lastIndexationProcessDate?: string | null,
      lastInvoiceDate?: string | null,
      legalCompetentAuthority?: string | null,
      name: string,
      notes?: string | null,
      paymentFrequency: LeasePaymentFrequency,
      paymentInvoicePeriod: LeasePaymentInvoicePeriod,
      paymentInvoicePeriodCustomDay?: number | null,
      paymentOption?:  {
        __typename: "LeasePaymentOption",
        customerId?: string | null,
        enabled: boolean,
        mandateActivatedAt?: string | null,
        mandateStatus?: PaymentProviderMandateStatus | null,
        paymentMethodId?: string | null,
        qrType?: LeaseQrType | null,
      } | null,
      purchaseOrderNumber?: string | null,
      realEstateAgency?: string | null,
      realEstateTax?: number | null,
      remittanceInformation?: string | null,
      remittanceInformationType?: LeaseRemittanceType | null,
      rentalGuaranty?:  {
        __typename: "LeaseRentalGuaranty",
        amount: number,
        blockedAmount?: number | null,
        releasedAmount?: number | null,
        type: LeaseRentalGuarantyType,
        financialInstitution?: string | null,
      } | null,
      signatureDate?: string | null,
      startDate: string,
      nextIndexationMonth?: string | null,
      nextIndexation?: boolean | null,
      status: LeaseStatus,
      technicCommunicationSettingsProfileId: string,
      totalInitialRentalPrice: number,
      totalRentalPrice: number,
      type: LeaseType,
      subletting?: boolean | null,
      vatRateRentId?: string | null,
      vatRateRent?:  {
        __typename: "VatRate",
        id: string,
        country: string,
        label: string,
        value?: number | null,
        ownerId?: string | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      additionalClauses?:  {
        __typename: "ModelLeaseAdditionalClauseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      bankAccountId?: string | null,
      bankAccount?:  {
        __typename: "BankAccount",
        id: string,
        contactId: string,
        number: string,
        bicNumber?: string | null,
        bankName?: string | null,
        contactIds?: Array< string > | null,
        buildingIds?: Array< string > | null,
        holderName?: string | null,
        label?: string | null,
        disabled?: boolean | null,
        integrations?: Array< IntegrationName > | null,
        matchingRule?: BankAccountMatchingRule | null,
        balance?: number | null,
        balanceDate?: string | null,
        type: BankAccountType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contacts?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      files?:  {
        __typename: "ModelFileConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leaseActionHistories?:  {
        __typename: "ModelLeaseActionHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leasePriceHistories?:  {
        __typename: "ModelLeasePriceHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      signatureDocuments?:  {
        __typename: "ModelSignatureDocumentConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      variousOperations?:  {
        __typename: "ModelLeaseVariousOperationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    contactId?: string | null,
    contact?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    customValues?:  Array< {
      __typename: "CustomValue",
      name: string,
      value: string,
    } > | null,
    originalTechnicId?: string | null,
    replacedTechnicId?: string | null,
    certificateIds?: Array< string > | null,
    readers?: Array< string > | null,
    writers?: Array< string > | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateTechnicLibrarySubscriptionVariables = {
  filter?: ModelSubscriptionTechnicLibraryFilterInput | null,
};

export type OnCreateTechnicLibrarySubscription = {
  onCreateTechnicLibrary?:  {
    __typename: "TechnicLibrary",
    id: string,
    certificateValidity?:  {
      __typename: "CertificateLibraryValidity",
      gracePeriod?:  {
        __typename: "TechnicLibraryValidity",
        value: number,
        validityUnit: TechnicLibraryValidityUnit,
      } | null,
      nonCompliant?: boolean | null,
      overlapping?: boolean | null,
      riskLevel?: RiskLevelExpiration | null,
    } | null,
    communicationSettingsProfileId?: string | null,
    criticality: TechnicLibraryCriticality,
    customFields?:  {
      __typename: "ModelCustomFieldConnection",
      items:  Array< {
        __typename: "CustomField",
        id: string,
        fieldName: string,
        fieldType: CustomFieldType,
        foreignKey: string,
        foreignTableName: string,
        order?: number | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    descriptions?:  Array< {
      __typename: "CustomLabel",
      language: string,
      label: string,
    } > | null,
    isDefault?: boolean | null,
    issuingAuthority?: string | null,
    linkedCertificateIds?: Array< string > | null,
    locationScope?: TechnicLibraryLocationScope | null,
    maintenanceSchemas?:  Array< {
      __typename: "TechnicLibraryMaintenanceSchema",
      id: string,
      criticality: TechnicLibraryCriticality,
      deadline?: string | null,
      descriptions?:  Array< {
        __typename: "CustomLabel",
        language: string,
        label: string,
      } > | null,
      interval?:  {
        __typename: "TechnicLibraryValidity",
        value: number,
        validityUnit: TechnicLibraryValidityUnit,
      } | null,
      maintenanceType: TechnicLibraryMaintenanceType,
      names:  Array< {
        __typename: "CustomLabel",
        language: string,
        label: string,
      } >,
      notificationsEnabled?: boolean | null,
      notificationType?: NotificationType | null,
      proofType?: Array< TechnicLibraryProofType > | null,
      proofTypeName?:  Array< {
        __typename: "CustomLabel",
        language: string,
        label: string,
      } > | null,
      recurrence?: TechnicLibraryRecurrence | null,
      responsibleParty: TechnicLibraryResponsibleParty,
      triggerType?: TechnicLibraryTriggerType | null,
    } > | null,
    names:  Array< {
      __typename: "CustomLabel",
      language: string,
      label: string,
    } >,
    status: TechnicLibraryStatus,
    tagIds?: Array< string > | null,
    technicLibraryFormat?: string | null,
    type: TechnicLibraryType,
    utilityTypes?: Array< UtilityType > | null,
    validity?:  {
      __typename: "TechnicLibraryValidity",
      value: number,
      validityUnit: TechnicLibraryValidityUnit,
    } | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateTechnicLibrarySubscriptionVariables = {
  filter?: ModelSubscriptionTechnicLibraryFilterInput | null,
};

export type OnUpdateTechnicLibrarySubscription = {
  onUpdateTechnicLibrary?:  {
    __typename: "TechnicLibrary",
    id: string,
    certificateValidity?:  {
      __typename: "CertificateLibraryValidity",
      gracePeriod?:  {
        __typename: "TechnicLibraryValidity",
        value: number,
        validityUnit: TechnicLibraryValidityUnit,
      } | null,
      nonCompliant?: boolean | null,
      overlapping?: boolean | null,
      riskLevel?: RiskLevelExpiration | null,
    } | null,
    communicationSettingsProfileId?: string | null,
    criticality: TechnicLibraryCriticality,
    customFields?:  {
      __typename: "ModelCustomFieldConnection",
      items:  Array< {
        __typename: "CustomField",
        id: string,
        fieldName: string,
        fieldType: CustomFieldType,
        foreignKey: string,
        foreignTableName: string,
        order?: number | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    descriptions?:  Array< {
      __typename: "CustomLabel",
      language: string,
      label: string,
    } > | null,
    isDefault?: boolean | null,
    issuingAuthority?: string | null,
    linkedCertificateIds?: Array< string > | null,
    locationScope?: TechnicLibraryLocationScope | null,
    maintenanceSchemas?:  Array< {
      __typename: "TechnicLibraryMaintenanceSchema",
      id: string,
      criticality: TechnicLibraryCriticality,
      deadline?: string | null,
      descriptions?:  Array< {
        __typename: "CustomLabel",
        language: string,
        label: string,
      } > | null,
      interval?:  {
        __typename: "TechnicLibraryValidity",
        value: number,
        validityUnit: TechnicLibraryValidityUnit,
      } | null,
      maintenanceType: TechnicLibraryMaintenanceType,
      names:  Array< {
        __typename: "CustomLabel",
        language: string,
        label: string,
      } >,
      notificationsEnabled?: boolean | null,
      notificationType?: NotificationType | null,
      proofType?: Array< TechnicLibraryProofType > | null,
      proofTypeName?:  Array< {
        __typename: "CustomLabel",
        language: string,
        label: string,
      } > | null,
      recurrence?: TechnicLibraryRecurrence | null,
      responsibleParty: TechnicLibraryResponsibleParty,
      triggerType?: TechnicLibraryTriggerType | null,
    } > | null,
    names:  Array< {
      __typename: "CustomLabel",
      language: string,
      label: string,
    } >,
    status: TechnicLibraryStatus,
    tagIds?: Array< string > | null,
    technicLibraryFormat?: string | null,
    type: TechnicLibraryType,
    utilityTypes?: Array< UtilityType > | null,
    validity?:  {
      __typename: "TechnicLibraryValidity",
      value: number,
      validityUnit: TechnicLibraryValidityUnit,
    } | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteTechnicLibrarySubscriptionVariables = {
  filter?: ModelSubscriptionTechnicLibraryFilterInput | null,
};

export type OnDeleteTechnicLibrarySubscription = {
  onDeleteTechnicLibrary?:  {
    __typename: "TechnicLibrary",
    id: string,
    certificateValidity?:  {
      __typename: "CertificateLibraryValidity",
      gracePeriod?:  {
        __typename: "TechnicLibraryValidity",
        value: number,
        validityUnit: TechnicLibraryValidityUnit,
      } | null,
      nonCompliant?: boolean | null,
      overlapping?: boolean | null,
      riskLevel?: RiskLevelExpiration | null,
    } | null,
    communicationSettingsProfileId?: string | null,
    criticality: TechnicLibraryCriticality,
    customFields?:  {
      __typename: "ModelCustomFieldConnection",
      items:  Array< {
        __typename: "CustomField",
        id: string,
        fieldName: string,
        fieldType: CustomFieldType,
        foreignKey: string,
        foreignTableName: string,
        order?: number | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    descriptions?:  Array< {
      __typename: "CustomLabel",
      language: string,
      label: string,
    } > | null,
    isDefault?: boolean | null,
    issuingAuthority?: string | null,
    linkedCertificateIds?: Array< string > | null,
    locationScope?: TechnicLibraryLocationScope | null,
    maintenanceSchemas?:  Array< {
      __typename: "TechnicLibraryMaintenanceSchema",
      id: string,
      criticality: TechnicLibraryCriticality,
      deadline?: string | null,
      descriptions?:  Array< {
        __typename: "CustomLabel",
        language: string,
        label: string,
      } > | null,
      interval?:  {
        __typename: "TechnicLibraryValidity",
        value: number,
        validityUnit: TechnicLibraryValidityUnit,
      } | null,
      maintenanceType: TechnicLibraryMaintenanceType,
      names:  Array< {
        __typename: "CustomLabel",
        language: string,
        label: string,
      } >,
      notificationsEnabled?: boolean | null,
      notificationType?: NotificationType | null,
      proofType?: Array< TechnicLibraryProofType > | null,
      proofTypeName?:  Array< {
        __typename: "CustomLabel",
        language: string,
        label: string,
      } > | null,
      recurrence?: TechnicLibraryRecurrence | null,
      responsibleParty: TechnicLibraryResponsibleParty,
      triggerType?: TechnicLibraryTriggerType | null,
    } > | null,
    names:  Array< {
      __typename: "CustomLabel",
      language: string,
      label: string,
    } >,
    status: TechnicLibraryStatus,
    tagIds?: Array< string > | null,
    technicLibraryFormat?: string | null,
    type: TechnicLibraryType,
    utilityTypes?: Array< UtilityType > | null,
    validity?:  {
      __typename: "TechnicLibraryValidity",
      value: number,
      validityUnit: TechnicLibraryValidityUnit,
    } | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateTicketSubscriptionVariables = {
  filter?: ModelSubscriptionTicketFilterInput | null,
};

export type OnCreateTicketSubscription = {
  onCreateTicket?:  {
    __typename: "Ticket",
    id: string,
    assignedAt?: string | null,
    assignedTo?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    assignedToId?: string | null,
    attachment?:  {
      __typename: "ModelFileConnection",
      items:  Array< {
        __typename: "File",
        id: string,
        bucket: string,
        createdAt?: string | null,
        categoryId: string,
        foreignKey: string,
        foreignTableName: string,
        key: string,
        mimeType?: string | null,
        region: string,
        size?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        _ttl?: number | null,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    building?:  {
      __typename: "Building",
      id: string,
      name: string,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      acquisitionValue?: number | null,
      acquisitionAdditionalCostsValue?: number | null,
      acquisitionAdvertisedValue?: number | null,
      amountOfFacades?: number | null,
      amountOfFloors?: number | null,
      amountOfHousings?: number | null,
      buildingState?: BuildingState | null,
      cadastralIncome?: number | null,
      constructionYear?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      janitor?: boolean | null,
      jointOwnershipId?: string | null,
      notes?: string | null,
      owners?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      propertyTax?: number | null,
      residenceName?: string | null,
      buildingSiteId?: string | null,
      buildingSite?:  {
        __typename: "BuildingSite",
        id: string,
        name: string,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      units?:  {
        __typename: "ModelUnitConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      events?:  {
        __typename: "ModelBuildingEventConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      teams?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    buildingId?: string | null,
    closedAt?: string | null,
    contact?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    contactId: string,
    content: string,
    conversations?:  {
      __typename: "ModelTicketConnection",
      items:  Array< {
        __typename: "Ticket",
        id: string,
        assignedAt?: string | null,
        assignedToId?: string | null,
        buildingId?: string | null,
        closedAt?: string | null,
        contactId: string,
        content: string,
        createdAt: string,
        emailMessageId?: string | null,
        emailReferences?: Array< string | null > | null,
        parentId?: string | null,
        plannedAt?: string | null,
        referenceCode?: string | null,
        sourceType: TicketSourceType,
        status?: TicketStatus | null,
        subject: string,
        unitId?: string | null,
        unread: boolean,
        updatedAt?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    createdAt: string,
    emailMessageId?: string | null,
    emailReferences?: Array< string | null > | null,
    parentId?: string | null,
    plannedAt?: string | null,
    referenceCode?: string | null,
    sourceType: TicketSourceType,
    status?: TicketStatus | null,
    subject: string,
    unit?:  {
      __typename: "Unit",
      id: string,
      acquisitionAdditionalCostsValue?: number | null,
      acquisitionAdvertisedValue?: number | null,
      acquisitionValue?: number | null,
      advertisedMonthlyCharges?: number | null,
      advertisedRentalPrice?: number | null,
      cadastralIncome?: number | null,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      floor?: number | null,
      jointOwnershipId?: string | null,
      managementDate: string,
      name: string,
      notes?: string | null,
      predictedPrice?: string | null,
      propertyTax?: number | null,
      publishAddress?: boolean | null,
      surface?: number | null,
      type: UnitType,
      buildingId: string,
      building?:  {
        __typename: "Building",
        id: string,
        name: string,
        addressId?: string | null,
        acquisitionValue?: number | null,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        amountOfFacades?: number | null,
        amountOfFloors?: number | null,
        amountOfHousings?: number | null,
        buildingState?: BuildingState | null,
        cadastralIncome?: number | null,
        constructionYear?: string | null,
        janitor?: boolean | null,
        jointOwnershipId?: string | null,
        notes?: string | null,
        propertyTax?: number | null,
        residenceName?: string | null,
        buildingSiteId?: string | null,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      owners?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leases?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      events?:  {
        __typename: "ModelUnitEventConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      unitAdvertisementId?: string | null,
      unitInventories?:  {
        __typename: "ModelUnitInventoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    unitId?: string | null,
    unread: boolean,
    updatedAt?: string | null,
    readers?: Array< string > | null,
    readId: string,
    clientId: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateTicketSubscriptionVariables = {
  filter?: ModelSubscriptionTicketFilterInput | null,
};

export type OnUpdateTicketSubscription = {
  onUpdateTicket?:  {
    __typename: "Ticket",
    id: string,
    assignedAt?: string | null,
    assignedTo?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    assignedToId?: string | null,
    attachment?:  {
      __typename: "ModelFileConnection",
      items:  Array< {
        __typename: "File",
        id: string,
        bucket: string,
        createdAt?: string | null,
        categoryId: string,
        foreignKey: string,
        foreignTableName: string,
        key: string,
        mimeType?: string | null,
        region: string,
        size?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        _ttl?: number | null,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    building?:  {
      __typename: "Building",
      id: string,
      name: string,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      acquisitionValue?: number | null,
      acquisitionAdditionalCostsValue?: number | null,
      acquisitionAdvertisedValue?: number | null,
      amountOfFacades?: number | null,
      amountOfFloors?: number | null,
      amountOfHousings?: number | null,
      buildingState?: BuildingState | null,
      cadastralIncome?: number | null,
      constructionYear?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      janitor?: boolean | null,
      jointOwnershipId?: string | null,
      notes?: string | null,
      owners?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      propertyTax?: number | null,
      residenceName?: string | null,
      buildingSiteId?: string | null,
      buildingSite?:  {
        __typename: "BuildingSite",
        id: string,
        name: string,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      units?:  {
        __typename: "ModelUnitConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      events?:  {
        __typename: "ModelBuildingEventConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      teams?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    buildingId?: string | null,
    closedAt?: string | null,
    contact?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    contactId: string,
    content: string,
    conversations?:  {
      __typename: "ModelTicketConnection",
      items:  Array< {
        __typename: "Ticket",
        id: string,
        assignedAt?: string | null,
        assignedToId?: string | null,
        buildingId?: string | null,
        closedAt?: string | null,
        contactId: string,
        content: string,
        createdAt: string,
        emailMessageId?: string | null,
        emailReferences?: Array< string | null > | null,
        parentId?: string | null,
        plannedAt?: string | null,
        referenceCode?: string | null,
        sourceType: TicketSourceType,
        status?: TicketStatus | null,
        subject: string,
        unitId?: string | null,
        unread: boolean,
        updatedAt?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    createdAt: string,
    emailMessageId?: string | null,
    emailReferences?: Array< string | null > | null,
    parentId?: string | null,
    plannedAt?: string | null,
    referenceCode?: string | null,
    sourceType: TicketSourceType,
    status?: TicketStatus | null,
    subject: string,
    unit?:  {
      __typename: "Unit",
      id: string,
      acquisitionAdditionalCostsValue?: number | null,
      acquisitionAdvertisedValue?: number | null,
      acquisitionValue?: number | null,
      advertisedMonthlyCharges?: number | null,
      advertisedRentalPrice?: number | null,
      cadastralIncome?: number | null,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      floor?: number | null,
      jointOwnershipId?: string | null,
      managementDate: string,
      name: string,
      notes?: string | null,
      predictedPrice?: string | null,
      propertyTax?: number | null,
      publishAddress?: boolean | null,
      surface?: number | null,
      type: UnitType,
      buildingId: string,
      building?:  {
        __typename: "Building",
        id: string,
        name: string,
        addressId?: string | null,
        acquisitionValue?: number | null,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        amountOfFacades?: number | null,
        amountOfFloors?: number | null,
        amountOfHousings?: number | null,
        buildingState?: BuildingState | null,
        cadastralIncome?: number | null,
        constructionYear?: string | null,
        janitor?: boolean | null,
        jointOwnershipId?: string | null,
        notes?: string | null,
        propertyTax?: number | null,
        residenceName?: string | null,
        buildingSiteId?: string | null,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      owners?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leases?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      events?:  {
        __typename: "ModelUnitEventConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      unitAdvertisementId?: string | null,
      unitInventories?:  {
        __typename: "ModelUnitInventoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    unitId?: string | null,
    unread: boolean,
    updatedAt?: string | null,
    readers?: Array< string > | null,
    readId: string,
    clientId: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteTicketSubscriptionVariables = {
  filter?: ModelSubscriptionTicketFilterInput | null,
};

export type OnDeleteTicketSubscription = {
  onDeleteTicket?:  {
    __typename: "Ticket",
    id: string,
    assignedAt?: string | null,
    assignedTo?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    assignedToId?: string | null,
    attachment?:  {
      __typename: "ModelFileConnection",
      items:  Array< {
        __typename: "File",
        id: string,
        bucket: string,
        createdAt?: string | null,
        categoryId: string,
        foreignKey: string,
        foreignTableName: string,
        key: string,
        mimeType?: string | null,
        region: string,
        size?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        _ttl?: number | null,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    building?:  {
      __typename: "Building",
      id: string,
      name: string,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      acquisitionValue?: number | null,
      acquisitionAdditionalCostsValue?: number | null,
      acquisitionAdvertisedValue?: number | null,
      amountOfFacades?: number | null,
      amountOfFloors?: number | null,
      amountOfHousings?: number | null,
      buildingState?: BuildingState | null,
      cadastralIncome?: number | null,
      constructionYear?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      janitor?: boolean | null,
      jointOwnershipId?: string | null,
      notes?: string | null,
      owners?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      propertyTax?: number | null,
      residenceName?: string | null,
      buildingSiteId?: string | null,
      buildingSite?:  {
        __typename: "BuildingSite",
        id: string,
        name: string,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      units?:  {
        __typename: "ModelUnitConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      events?:  {
        __typename: "ModelBuildingEventConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      teams?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    buildingId?: string | null,
    closedAt?: string | null,
    contact?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    contactId: string,
    content: string,
    conversations?:  {
      __typename: "ModelTicketConnection",
      items:  Array< {
        __typename: "Ticket",
        id: string,
        assignedAt?: string | null,
        assignedToId?: string | null,
        buildingId?: string | null,
        closedAt?: string | null,
        contactId: string,
        content: string,
        createdAt: string,
        emailMessageId?: string | null,
        emailReferences?: Array< string | null > | null,
        parentId?: string | null,
        plannedAt?: string | null,
        referenceCode?: string | null,
        sourceType: TicketSourceType,
        status?: TicketStatus | null,
        subject: string,
        unitId?: string | null,
        unread: boolean,
        updatedAt?: string | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    createdAt: string,
    emailMessageId?: string | null,
    emailReferences?: Array< string | null > | null,
    parentId?: string | null,
    plannedAt?: string | null,
    referenceCode?: string | null,
    sourceType: TicketSourceType,
    status?: TicketStatus | null,
    subject: string,
    unit?:  {
      __typename: "Unit",
      id: string,
      acquisitionAdditionalCostsValue?: number | null,
      acquisitionAdvertisedValue?: number | null,
      acquisitionValue?: number | null,
      advertisedMonthlyCharges?: number | null,
      advertisedRentalPrice?: number | null,
      cadastralIncome?: number | null,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      floor?: number | null,
      jointOwnershipId?: string | null,
      managementDate: string,
      name: string,
      notes?: string | null,
      predictedPrice?: string | null,
      propertyTax?: number | null,
      publishAddress?: boolean | null,
      surface?: number | null,
      type: UnitType,
      buildingId: string,
      building?:  {
        __typename: "Building",
        id: string,
        name: string,
        addressId?: string | null,
        acquisitionValue?: number | null,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        amountOfFacades?: number | null,
        amountOfFloors?: number | null,
        amountOfHousings?: number | null,
        buildingState?: BuildingState | null,
        cadastralIncome?: number | null,
        constructionYear?: string | null,
        janitor?: boolean | null,
        jointOwnershipId?: string | null,
        notes?: string | null,
        propertyTax?: number | null,
        residenceName?: string | null,
        buildingSiteId?: string | null,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      owners?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leases?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      events?:  {
        __typename: "ModelUnitEventConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      unitAdvertisementId?: string | null,
      unitInventories?:  {
        __typename: "ModelUnitInventoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    unitId?: string | null,
    unread: boolean,
    updatedAt?: string | null,
    readers?: Array< string > | null,
    readId: string,
    clientId: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateUnitSubscriptionVariables = {
  filter?: ModelSubscriptionUnitFilterInput | null,
};

export type OnCreateUnitSubscription = {
  onCreateUnit?:  {
    __typename: "Unit",
    id: string,
    acquisitionAdditionalCostsValue?: number | null,
    acquisitionAdvertisedValue?: number | null,
    acquisitionValue?: number | null,
    advertisedMonthlyCharges?: number | null,
    advertisedRentalPrice?: number | null,
    cadastralIncome?: number | null,
    createdAt?: string | null,
    customValues?:  Array< {
      __typename: "CustomValue",
      name: string,
      value: string,
    } > | null,
    floor?: number | null,
    jointOwnershipId?: string | null,
    managementDate: string,
    name: string,
    notes?: string | null,
    predictedPrice?: string | null,
    propertyTax?: number | null,
    publishAddress?: boolean | null,
    surface?: number | null,
    type: UnitType,
    buildingId: string,
    building?:  {
      __typename: "Building",
      id: string,
      name: string,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      acquisitionValue?: number | null,
      acquisitionAdditionalCostsValue?: number | null,
      acquisitionAdvertisedValue?: number | null,
      amountOfFacades?: number | null,
      amountOfFloors?: number | null,
      amountOfHousings?: number | null,
      buildingState?: BuildingState | null,
      cadastralIncome?: number | null,
      constructionYear?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      janitor?: boolean | null,
      jointOwnershipId?: string | null,
      notes?: string | null,
      owners?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      propertyTax?: number | null,
      residenceName?: string | null,
      buildingSiteId?: string | null,
      buildingSite?:  {
        __typename: "BuildingSite",
        id: string,
        name: string,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      units?:  {
        __typename: "ModelUnitConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      events?:  {
        __typename: "ModelBuildingEventConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      teams?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    owners?:  {
      __typename: "ModelUnitOwnerConnection",
      items:  Array< {
        __typename: "UnitOwner",
        id: string,
        disabled?: boolean | null,
        ownerId: string,
        periodFrom?: string | null,
        periodTo?: string | null,
        stake: number,
        unitId: string,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    leases?:  {
      __typename: "ModelUnitLeaseConnection",
      items:  Array< {
        __typename: "UnitLease",
        id: string,
        allowChargeAdjustment?: boolean | null,
        authorizeProfessionalActivity?: boolean | null,
        chargesIndexation?: boolean | null,
        createdAt?: string | null,
        endDate: string,
        furnishedRental?: boolean | null,
        furnishedRentalInsuranceByTenant?: boolean | null,
        furnishedRentalRentalPricePercentage?: number | null,
        initialRentalPrice: number,
        indexation?: boolean | null,
        advancedIndexation?: boolean | null,
        indexType?: IndexType | null,
        baseYear?: number | null,
        baseIndexType?: BaseIndexType | null,
        baseIndexDate?: string | null,
        nextIndexationMonth?: string | null,
        nextIndexation?: boolean | null,
        leaseId: string,
        mainUnit: boolean,
        rentalPrice: number,
        signatureDate?: string | null,
        startDate: string,
        unitId: string,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    events?:  {
      __typename: "ModelUnitEventConnection",
      items:  Array< {
        __typename: "UnitEvent",
        id: string,
        unitId: string,
        type: UnitEventType,
        startDate: string,
        endDate: string,
        totalCost?: number | null,
        note?: string | null,
        writers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    unitAdvertisementId?: string | null,
    unitInventories?:  {
      __typename: "ModelUnitInventoryConnection",
      items:  Array< {
        __typename: "UnitInventory",
        id: string,
        privateBatthRoom?: boolean | null,
        createdAt?: string | null,
        deletedAt?: string | null,
        kitchenEquipment?: KitchenEquipment | null,
        roomName?: string | null,
        roomType: UnitInventoryRoomType,
        surface?: number | null,
        showSurface?: boolean | null,
        unitId: string,
        inside: boolean,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    readers?: Array< string > | null,
    readId: string,
    clientId: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateUnitSubscriptionVariables = {
  filter?: ModelSubscriptionUnitFilterInput | null,
};

export type OnUpdateUnitSubscription = {
  onUpdateUnit?:  {
    __typename: "Unit",
    id: string,
    acquisitionAdditionalCostsValue?: number | null,
    acquisitionAdvertisedValue?: number | null,
    acquisitionValue?: number | null,
    advertisedMonthlyCharges?: number | null,
    advertisedRentalPrice?: number | null,
    cadastralIncome?: number | null,
    createdAt?: string | null,
    customValues?:  Array< {
      __typename: "CustomValue",
      name: string,
      value: string,
    } > | null,
    floor?: number | null,
    jointOwnershipId?: string | null,
    managementDate: string,
    name: string,
    notes?: string | null,
    predictedPrice?: string | null,
    propertyTax?: number | null,
    publishAddress?: boolean | null,
    surface?: number | null,
    type: UnitType,
    buildingId: string,
    building?:  {
      __typename: "Building",
      id: string,
      name: string,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      acquisitionValue?: number | null,
      acquisitionAdditionalCostsValue?: number | null,
      acquisitionAdvertisedValue?: number | null,
      amountOfFacades?: number | null,
      amountOfFloors?: number | null,
      amountOfHousings?: number | null,
      buildingState?: BuildingState | null,
      cadastralIncome?: number | null,
      constructionYear?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      janitor?: boolean | null,
      jointOwnershipId?: string | null,
      notes?: string | null,
      owners?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      propertyTax?: number | null,
      residenceName?: string | null,
      buildingSiteId?: string | null,
      buildingSite?:  {
        __typename: "BuildingSite",
        id: string,
        name: string,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      units?:  {
        __typename: "ModelUnitConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      events?:  {
        __typename: "ModelBuildingEventConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      teams?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    owners?:  {
      __typename: "ModelUnitOwnerConnection",
      items:  Array< {
        __typename: "UnitOwner",
        id: string,
        disabled?: boolean | null,
        ownerId: string,
        periodFrom?: string | null,
        periodTo?: string | null,
        stake: number,
        unitId: string,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    leases?:  {
      __typename: "ModelUnitLeaseConnection",
      items:  Array< {
        __typename: "UnitLease",
        id: string,
        allowChargeAdjustment?: boolean | null,
        authorizeProfessionalActivity?: boolean | null,
        chargesIndexation?: boolean | null,
        createdAt?: string | null,
        endDate: string,
        furnishedRental?: boolean | null,
        furnishedRentalInsuranceByTenant?: boolean | null,
        furnishedRentalRentalPricePercentage?: number | null,
        initialRentalPrice: number,
        indexation?: boolean | null,
        advancedIndexation?: boolean | null,
        indexType?: IndexType | null,
        baseYear?: number | null,
        baseIndexType?: BaseIndexType | null,
        baseIndexDate?: string | null,
        nextIndexationMonth?: string | null,
        nextIndexation?: boolean | null,
        leaseId: string,
        mainUnit: boolean,
        rentalPrice: number,
        signatureDate?: string | null,
        startDate: string,
        unitId: string,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    events?:  {
      __typename: "ModelUnitEventConnection",
      items:  Array< {
        __typename: "UnitEvent",
        id: string,
        unitId: string,
        type: UnitEventType,
        startDate: string,
        endDate: string,
        totalCost?: number | null,
        note?: string | null,
        writers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    unitAdvertisementId?: string | null,
    unitInventories?:  {
      __typename: "ModelUnitInventoryConnection",
      items:  Array< {
        __typename: "UnitInventory",
        id: string,
        privateBatthRoom?: boolean | null,
        createdAt?: string | null,
        deletedAt?: string | null,
        kitchenEquipment?: KitchenEquipment | null,
        roomName?: string | null,
        roomType: UnitInventoryRoomType,
        surface?: number | null,
        showSurface?: boolean | null,
        unitId: string,
        inside: boolean,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    readers?: Array< string > | null,
    readId: string,
    clientId: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteUnitSubscriptionVariables = {
  filter?: ModelSubscriptionUnitFilterInput | null,
};

export type OnDeleteUnitSubscription = {
  onDeleteUnit?:  {
    __typename: "Unit",
    id: string,
    acquisitionAdditionalCostsValue?: number | null,
    acquisitionAdvertisedValue?: number | null,
    acquisitionValue?: number | null,
    advertisedMonthlyCharges?: number | null,
    advertisedRentalPrice?: number | null,
    cadastralIncome?: number | null,
    createdAt?: string | null,
    customValues?:  Array< {
      __typename: "CustomValue",
      name: string,
      value: string,
    } > | null,
    floor?: number | null,
    jointOwnershipId?: string | null,
    managementDate: string,
    name: string,
    notes?: string | null,
    predictedPrice?: string | null,
    propertyTax?: number | null,
    publishAddress?: boolean | null,
    surface?: number | null,
    type: UnitType,
    buildingId: string,
    building?:  {
      __typename: "Building",
      id: string,
      name: string,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      acquisitionValue?: number | null,
      acquisitionAdditionalCostsValue?: number | null,
      acquisitionAdvertisedValue?: number | null,
      amountOfFacades?: number | null,
      amountOfFloors?: number | null,
      amountOfHousings?: number | null,
      buildingState?: BuildingState | null,
      cadastralIncome?: number | null,
      constructionYear?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      janitor?: boolean | null,
      jointOwnershipId?: string | null,
      notes?: string | null,
      owners?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      propertyTax?: number | null,
      residenceName?: string | null,
      buildingSiteId?: string | null,
      buildingSite?:  {
        __typename: "BuildingSite",
        id: string,
        name: string,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      units?:  {
        __typename: "ModelUnitConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      events?:  {
        __typename: "ModelBuildingEventConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      teams?: Array< string > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    owners?:  {
      __typename: "ModelUnitOwnerConnection",
      items:  Array< {
        __typename: "UnitOwner",
        id: string,
        disabled?: boolean | null,
        ownerId: string,
        periodFrom?: string | null,
        periodTo?: string | null,
        stake: number,
        unitId: string,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    leases?:  {
      __typename: "ModelUnitLeaseConnection",
      items:  Array< {
        __typename: "UnitLease",
        id: string,
        allowChargeAdjustment?: boolean | null,
        authorizeProfessionalActivity?: boolean | null,
        chargesIndexation?: boolean | null,
        createdAt?: string | null,
        endDate: string,
        furnishedRental?: boolean | null,
        furnishedRentalInsuranceByTenant?: boolean | null,
        furnishedRentalRentalPricePercentage?: number | null,
        initialRentalPrice: number,
        indexation?: boolean | null,
        advancedIndexation?: boolean | null,
        indexType?: IndexType | null,
        baseYear?: number | null,
        baseIndexType?: BaseIndexType | null,
        baseIndexDate?: string | null,
        nextIndexationMonth?: string | null,
        nextIndexation?: boolean | null,
        leaseId: string,
        mainUnit: boolean,
        rentalPrice: number,
        signatureDate?: string | null,
        startDate: string,
        unitId: string,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    events?:  {
      __typename: "ModelUnitEventConnection",
      items:  Array< {
        __typename: "UnitEvent",
        id: string,
        unitId: string,
        type: UnitEventType,
        startDate: string,
        endDate: string,
        totalCost?: number | null,
        note?: string | null,
        writers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    unitAdvertisementId?: string | null,
    unitInventories?:  {
      __typename: "ModelUnitInventoryConnection",
      items:  Array< {
        __typename: "UnitInventory",
        id: string,
        privateBatthRoom?: boolean | null,
        createdAt?: string | null,
        deletedAt?: string | null,
        kitchenEquipment?: KitchenEquipment | null,
        roomName?: string | null,
        roomType: UnitInventoryRoomType,
        surface?: number | null,
        showSurface?: boolean | null,
        unitId: string,
        inside: boolean,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    readers?: Array< string > | null,
    readId: string,
    clientId: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateUnitEventSubscriptionVariables = {
  filter?: ModelSubscriptionUnitEventFilterInput | null,
};

export type OnCreateUnitEventSubscription = {
  onCreateUnitEvent?:  {
    __typename: "UnitEvent",
    id: string,
    unitId: string,
    type: UnitEventType,
    startDate: string,
    endDate: string,
    totalCost?: number | null,
    note?: string | null,
    writers?: Array< string > | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateUnitEventSubscriptionVariables = {
  filter?: ModelSubscriptionUnitEventFilterInput | null,
};

export type OnUpdateUnitEventSubscription = {
  onUpdateUnitEvent?:  {
    __typename: "UnitEvent",
    id: string,
    unitId: string,
    type: UnitEventType,
    startDate: string,
    endDate: string,
    totalCost?: number | null,
    note?: string | null,
    writers?: Array< string > | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteUnitEventSubscriptionVariables = {
  filter?: ModelSubscriptionUnitEventFilterInput | null,
};

export type OnDeleteUnitEventSubscription = {
  onDeleteUnitEvent?:  {
    __typename: "UnitEvent",
    id: string,
    unitId: string,
    type: UnitEventType,
    startDate: string,
    endDate: string,
    totalCost?: number | null,
    note?: string | null,
    writers?: Array< string > | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateUnitInventorySubscriptionVariables = {
  filter?: ModelSubscriptionUnitInventoryFilterInput | null,
};

export type OnCreateUnitInventorySubscription = {
  onCreateUnitInventory?:  {
    __typename: "UnitInventory",
    id: string,
    privateBatthRoom?: boolean | null,
    createdAt?: string | null,
    deletedAt?: string | null,
    kitchenEquipment?: KitchenEquipment | null,
    roomName?: string | null,
    roomType: UnitInventoryRoomType,
    surface?: number | null,
    showSurface?: boolean | null,
    unitId: string,
    inside: boolean,
    readId: string,
    clientId: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateUnitInventorySubscriptionVariables = {
  filter?: ModelSubscriptionUnitInventoryFilterInput | null,
};

export type OnUpdateUnitInventorySubscription = {
  onUpdateUnitInventory?:  {
    __typename: "UnitInventory",
    id: string,
    privateBatthRoom?: boolean | null,
    createdAt?: string | null,
    deletedAt?: string | null,
    kitchenEquipment?: KitchenEquipment | null,
    roomName?: string | null,
    roomType: UnitInventoryRoomType,
    surface?: number | null,
    showSurface?: boolean | null,
    unitId: string,
    inside: boolean,
    readId: string,
    clientId: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteUnitInventorySubscriptionVariables = {
  filter?: ModelSubscriptionUnitInventoryFilterInput | null,
};

export type OnDeleteUnitInventorySubscription = {
  onDeleteUnitInventory?:  {
    __typename: "UnitInventory",
    id: string,
    privateBatthRoom?: boolean | null,
    createdAt?: string | null,
    deletedAt?: string | null,
    kitchenEquipment?: KitchenEquipment | null,
    roomName?: string | null,
    roomType: UnitInventoryRoomType,
    surface?: number | null,
    showSurface?: boolean | null,
    unitId: string,
    inside: boolean,
    readId: string,
    clientId: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateUnitLeaseSubscriptionVariables = {
  filter?: ModelSubscriptionUnitLeaseFilterInput | null,
};

export type OnCreateUnitLeaseSubscription = {
  onCreateUnitLease?:  {
    __typename: "UnitLease",
    id: string,
    allowChargeAdjustment?: boolean | null,
    authorizeProfessionalActivity?: boolean | null,
    chargesIndexation?: boolean | null,
    createdAt?: string | null,
    endDate: string,
    furnishedRental?: boolean | null,
    furnishedRentalInsuranceByTenant?: boolean | null,
    furnishedRentalRentalPricePercentage?: number | null,
    initialRentalPrice: number,
    indexation?: boolean | null,
    advancedIndexation?: boolean | null,
    indexType?: IndexType | null,
    baseYear?: number | null,
    baseIndexType?: BaseIndexType | null,
    baseIndexDate?: string | null,
    nextIndexationMonth?: string | null,
    nextIndexation?: boolean | null,
    leaseId: string,
    mainUnit: boolean,
    rentalPrice: number,
    signatureDate?: string | null,
    startDate: string,
    unitId: string,
    unit?:  {
      __typename: "Unit",
      id: string,
      acquisitionAdditionalCostsValue?: number | null,
      acquisitionAdvertisedValue?: number | null,
      acquisitionValue?: number | null,
      advertisedMonthlyCharges?: number | null,
      advertisedRentalPrice?: number | null,
      cadastralIncome?: number | null,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      floor?: number | null,
      jointOwnershipId?: string | null,
      managementDate: string,
      name: string,
      notes?: string | null,
      predictedPrice?: string | null,
      propertyTax?: number | null,
      publishAddress?: boolean | null,
      surface?: number | null,
      type: UnitType,
      buildingId: string,
      building?:  {
        __typename: "Building",
        id: string,
        name: string,
        addressId?: string | null,
        acquisitionValue?: number | null,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        amountOfFacades?: number | null,
        amountOfFloors?: number | null,
        amountOfHousings?: number | null,
        buildingState?: BuildingState | null,
        cadastralIncome?: number | null,
        constructionYear?: string | null,
        janitor?: boolean | null,
        jointOwnershipId?: string | null,
        notes?: string | null,
        propertyTax?: number | null,
        residenceName?: string | null,
        buildingSiteId?: string | null,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      owners?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leases?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      events?:  {
        __typename: "ModelUnitEventConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      unitAdvertisementId?: string | null,
      unitInventories?:  {
        __typename: "ModelUnitInventoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    lease?:  {
      __typename: "Lease",
      id: string,
      advancedChargesInvoices?:  {
        __typename: "LeaseAdvancedChargesInvoice",
        communicationSettingsProfileId: string,
        invoiceSenderId: string,
        lastDraftInvoiceDate?: string | null,
        lastInvoiceDate?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        bankAccountId?: string | null,
      } | null,
      balance?: number | null,
      canBeExtended?: boolean | null,
      communicationSettingsProfileId: string,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      endDate: string,
      includeRealEstateInLeaseContract?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      invoiceSenderId: string,
      invoiceSender?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      inventoryOfFixturesExpert?: string | null,
      inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
      inventoryOfFixturesType?: InventoryOfFixturesType | null,
      ipiNumber?: string | null,
      language: Language,
      lastDraftInvoiceDate?: string | null,
      lastIndexationProcessDate?: string | null,
      lastInvoiceDate?: string | null,
      legalCompetentAuthority?: string | null,
      name: string,
      notes?: string | null,
      paymentFrequency: LeasePaymentFrequency,
      paymentInvoicePeriod: LeasePaymentInvoicePeriod,
      paymentInvoicePeriodCustomDay?: number | null,
      paymentOption?:  {
        __typename: "LeasePaymentOption",
        customerId?: string | null,
        enabled: boolean,
        mandateActivatedAt?: string | null,
        mandateStatus?: PaymentProviderMandateStatus | null,
        paymentMethodId?: string | null,
        qrType?: LeaseQrType | null,
      } | null,
      purchaseOrderNumber?: string | null,
      realEstateAgency?: string | null,
      realEstateTax?: number | null,
      remittanceInformation?: string | null,
      remittanceInformationType?: LeaseRemittanceType | null,
      rentalGuaranty?:  {
        __typename: "LeaseRentalGuaranty",
        amount: number,
        blockedAmount?: number | null,
        releasedAmount?: number | null,
        type: LeaseRentalGuarantyType,
        financialInstitution?: string | null,
      } | null,
      signatureDate?: string | null,
      startDate: string,
      nextIndexationMonth?: string | null,
      nextIndexation?: boolean | null,
      status: LeaseStatus,
      technicCommunicationSettingsProfileId: string,
      totalInitialRentalPrice: number,
      totalRentalPrice: number,
      type: LeaseType,
      subletting?: boolean | null,
      vatRateRentId?: string | null,
      vatRateRent?:  {
        __typename: "VatRate",
        id: string,
        country: string,
        label: string,
        value?: number | null,
        ownerId?: string | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      additionalClauses?:  {
        __typename: "ModelLeaseAdditionalClauseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      bankAccountId?: string | null,
      bankAccount?:  {
        __typename: "BankAccount",
        id: string,
        contactId: string,
        number: string,
        bicNumber?: string | null,
        bankName?: string | null,
        contactIds?: Array< string > | null,
        buildingIds?: Array< string > | null,
        holderName?: string | null,
        label?: string | null,
        disabled?: boolean | null,
        integrations?: Array< IntegrationName > | null,
        matchingRule?: BankAccountMatchingRule | null,
        balance?: number | null,
        balanceDate?: string | null,
        type: BankAccountType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contacts?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      files?:  {
        __typename: "ModelFileConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leaseActionHistories?:  {
        __typename: "ModelLeaseActionHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leasePriceHistories?:  {
        __typename: "ModelLeasePriceHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      signatureDocuments?:  {
        __typename: "ModelSignatureDocumentConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      variousOperations?:  {
        __typename: "ModelLeaseVariousOperationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    readers?: Array< string > | null,
    readId: string,
    clientId: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateUnitLeaseSubscriptionVariables = {
  filter?: ModelSubscriptionUnitLeaseFilterInput | null,
};

export type OnUpdateUnitLeaseSubscription = {
  onUpdateUnitLease?:  {
    __typename: "UnitLease",
    id: string,
    allowChargeAdjustment?: boolean | null,
    authorizeProfessionalActivity?: boolean | null,
    chargesIndexation?: boolean | null,
    createdAt?: string | null,
    endDate: string,
    furnishedRental?: boolean | null,
    furnishedRentalInsuranceByTenant?: boolean | null,
    furnishedRentalRentalPricePercentage?: number | null,
    initialRentalPrice: number,
    indexation?: boolean | null,
    advancedIndexation?: boolean | null,
    indexType?: IndexType | null,
    baseYear?: number | null,
    baseIndexType?: BaseIndexType | null,
    baseIndexDate?: string | null,
    nextIndexationMonth?: string | null,
    nextIndexation?: boolean | null,
    leaseId: string,
    mainUnit: boolean,
    rentalPrice: number,
    signatureDate?: string | null,
    startDate: string,
    unitId: string,
    unit?:  {
      __typename: "Unit",
      id: string,
      acquisitionAdditionalCostsValue?: number | null,
      acquisitionAdvertisedValue?: number | null,
      acquisitionValue?: number | null,
      advertisedMonthlyCharges?: number | null,
      advertisedRentalPrice?: number | null,
      cadastralIncome?: number | null,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      floor?: number | null,
      jointOwnershipId?: string | null,
      managementDate: string,
      name: string,
      notes?: string | null,
      predictedPrice?: string | null,
      propertyTax?: number | null,
      publishAddress?: boolean | null,
      surface?: number | null,
      type: UnitType,
      buildingId: string,
      building?:  {
        __typename: "Building",
        id: string,
        name: string,
        addressId?: string | null,
        acquisitionValue?: number | null,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        amountOfFacades?: number | null,
        amountOfFloors?: number | null,
        amountOfHousings?: number | null,
        buildingState?: BuildingState | null,
        cadastralIncome?: number | null,
        constructionYear?: string | null,
        janitor?: boolean | null,
        jointOwnershipId?: string | null,
        notes?: string | null,
        propertyTax?: number | null,
        residenceName?: string | null,
        buildingSiteId?: string | null,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      owners?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leases?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      events?:  {
        __typename: "ModelUnitEventConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      unitAdvertisementId?: string | null,
      unitInventories?:  {
        __typename: "ModelUnitInventoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    lease?:  {
      __typename: "Lease",
      id: string,
      advancedChargesInvoices?:  {
        __typename: "LeaseAdvancedChargesInvoice",
        communicationSettingsProfileId: string,
        invoiceSenderId: string,
        lastDraftInvoiceDate?: string | null,
        lastInvoiceDate?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        bankAccountId?: string | null,
      } | null,
      balance?: number | null,
      canBeExtended?: boolean | null,
      communicationSettingsProfileId: string,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      endDate: string,
      includeRealEstateInLeaseContract?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      invoiceSenderId: string,
      invoiceSender?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      inventoryOfFixturesExpert?: string | null,
      inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
      inventoryOfFixturesType?: InventoryOfFixturesType | null,
      ipiNumber?: string | null,
      language: Language,
      lastDraftInvoiceDate?: string | null,
      lastIndexationProcessDate?: string | null,
      lastInvoiceDate?: string | null,
      legalCompetentAuthority?: string | null,
      name: string,
      notes?: string | null,
      paymentFrequency: LeasePaymentFrequency,
      paymentInvoicePeriod: LeasePaymentInvoicePeriod,
      paymentInvoicePeriodCustomDay?: number | null,
      paymentOption?:  {
        __typename: "LeasePaymentOption",
        customerId?: string | null,
        enabled: boolean,
        mandateActivatedAt?: string | null,
        mandateStatus?: PaymentProviderMandateStatus | null,
        paymentMethodId?: string | null,
        qrType?: LeaseQrType | null,
      } | null,
      purchaseOrderNumber?: string | null,
      realEstateAgency?: string | null,
      realEstateTax?: number | null,
      remittanceInformation?: string | null,
      remittanceInformationType?: LeaseRemittanceType | null,
      rentalGuaranty?:  {
        __typename: "LeaseRentalGuaranty",
        amount: number,
        blockedAmount?: number | null,
        releasedAmount?: number | null,
        type: LeaseRentalGuarantyType,
        financialInstitution?: string | null,
      } | null,
      signatureDate?: string | null,
      startDate: string,
      nextIndexationMonth?: string | null,
      nextIndexation?: boolean | null,
      status: LeaseStatus,
      technicCommunicationSettingsProfileId: string,
      totalInitialRentalPrice: number,
      totalRentalPrice: number,
      type: LeaseType,
      subletting?: boolean | null,
      vatRateRentId?: string | null,
      vatRateRent?:  {
        __typename: "VatRate",
        id: string,
        country: string,
        label: string,
        value?: number | null,
        ownerId?: string | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      additionalClauses?:  {
        __typename: "ModelLeaseAdditionalClauseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      bankAccountId?: string | null,
      bankAccount?:  {
        __typename: "BankAccount",
        id: string,
        contactId: string,
        number: string,
        bicNumber?: string | null,
        bankName?: string | null,
        contactIds?: Array< string > | null,
        buildingIds?: Array< string > | null,
        holderName?: string | null,
        label?: string | null,
        disabled?: boolean | null,
        integrations?: Array< IntegrationName > | null,
        matchingRule?: BankAccountMatchingRule | null,
        balance?: number | null,
        balanceDate?: string | null,
        type: BankAccountType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contacts?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      files?:  {
        __typename: "ModelFileConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leaseActionHistories?:  {
        __typename: "ModelLeaseActionHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leasePriceHistories?:  {
        __typename: "ModelLeasePriceHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      signatureDocuments?:  {
        __typename: "ModelSignatureDocumentConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      variousOperations?:  {
        __typename: "ModelLeaseVariousOperationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    readers?: Array< string > | null,
    readId: string,
    clientId: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteUnitLeaseSubscriptionVariables = {
  filter?: ModelSubscriptionUnitLeaseFilterInput | null,
};

export type OnDeleteUnitLeaseSubscription = {
  onDeleteUnitLease?:  {
    __typename: "UnitLease",
    id: string,
    allowChargeAdjustment?: boolean | null,
    authorizeProfessionalActivity?: boolean | null,
    chargesIndexation?: boolean | null,
    createdAt?: string | null,
    endDate: string,
    furnishedRental?: boolean | null,
    furnishedRentalInsuranceByTenant?: boolean | null,
    furnishedRentalRentalPricePercentage?: number | null,
    initialRentalPrice: number,
    indexation?: boolean | null,
    advancedIndexation?: boolean | null,
    indexType?: IndexType | null,
    baseYear?: number | null,
    baseIndexType?: BaseIndexType | null,
    baseIndexDate?: string | null,
    nextIndexationMonth?: string | null,
    nextIndexation?: boolean | null,
    leaseId: string,
    mainUnit: boolean,
    rentalPrice: number,
    signatureDate?: string | null,
    startDate: string,
    unitId: string,
    unit?:  {
      __typename: "Unit",
      id: string,
      acquisitionAdditionalCostsValue?: number | null,
      acquisitionAdvertisedValue?: number | null,
      acquisitionValue?: number | null,
      advertisedMonthlyCharges?: number | null,
      advertisedRentalPrice?: number | null,
      cadastralIncome?: number | null,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      floor?: number | null,
      jointOwnershipId?: string | null,
      managementDate: string,
      name: string,
      notes?: string | null,
      predictedPrice?: string | null,
      propertyTax?: number | null,
      publishAddress?: boolean | null,
      surface?: number | null,
      type: UnitType,
      buildingId: string,
      building?:  {
        __typename: "Building",
        id: string,
        name: string,
        addressId?: string | null,
        acquisitionValue?: number | null,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        amountOfFacades?: number | null,
        amountOfFloors?: number | null,
        amountOfHousings?: number | null,
        buildingState?: BuildingState | null,
        cadastralIncome?: number | null,
        constructionYear?: string | null,
        janitor?: boolean | null,
        jointOwnershipId?: string | null,
        notes?: string | null,
        propertyTax?: number | null,
        residenceName?: string | null,
        buildingSiteId?: string | null,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      owners?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leases?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      events?:  {
        __typename: "ModelUnitEventConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      unitAdvertisementId?: string | null,
      unitInventories?:  {
        __typename: "ModelUnitInventoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    lease?:  {
      __typename: "Lease",
      id: string,
      advancedChargesInvoices?:  {
        __typename: "LeaseAdvancedChargesInvoice",
        communicationSettingsProfileId: string,
        invoiceSenderId: string,
        lastDraftInvoiceDate?: string | null,
        lastInvoiceDate?: string | null,
        paymentFrequency: LeasePaymentFrequency,
        paymentInvoicePeriod: LeasePaymentInvoicePeriod,
        paymentInvoicePeriodCustomDay?: number | null,
        remittanceInformation?: string | null,
        remittanceInformationType?: LeaseRemittanceType | null,
        bankAccountId?: string | null,
      } | null,
      balance?: number | null,
      canBeExtended?: boolean | null,
      communicationSettingsProfileId: string,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      endDate: string,
      includeRealEstateInLeaseContract?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      invoiceSenderId: string,
      invoiceSender?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      inventoryOfFixturesExpert?: string | null,
      inventoryOfFixturesMethod?: InventoryOfFixturesMethod | null,
      inventoryOfFixturesType?: InventoryOfFixturesType | null,
      ipiNumber?: string | null,
      language: Language,
      lastDraftInvoiceDate?: string | null,
      lastIndexationProcessDate?: string | null,
      lastInvoiceDate?: string | null,
      legalCompetentAuthority?: string | null,
      name: string,
      notes?: string | null,
      paymentFrequency: LeasePaymentFrequency,
      paymentInvoicePeriod: LeasePaymentInvoicePeriod,
      paymentInvoicePeriodCustomDay?: number | null,
      paymentOption?:  {
        __typename: "LeasePaymentOption",
        customerId?: string | null,
        enabled: boolean,
        mandateActivatedAt?: string | null,
        mandateStatus?: PaymentProviderMandateStatus | null,
        paymentMethodId?: string | null,
        qrType?: LeaseQrType | null,
      } | null,
      purchaseOrderNumber?: string | null,
      realEstateAgency?: string | null,
      realEstateTax?: number | null,
      remittanceInformation?: string | null,
      remittanceInformationType?: LeaseRemittanceType | null,
      rentalGuaranty?:  {
        __typename: "LeaseRentalGuaranty",
        amount: number,
        blockedAmount?: number | null,
        releasedAmount?: number | null,
        type: LeaseRentalGuarantyType,
        financialInstitution?: string | null,
      } | null,
      signatureDate?: string | null,
      startDate: string,
      nextIndexationMonth?: string | null,
      nextIndexation?: boolean | null,
      status: LeaseStatus,
      technicCommunicationSettingsProfileId: string,
      totalInitialRentalPrice: number,
      totalRentalPrice: number,
      type: LeaseType,
      subletting?: boolean | null,
      vatRateRentId?: string | null,
      vatRateRent?:  {
        __typename: "VatRate",
        id: string,
        country: string,
        label: string,
        value?: number | null,
        ownerId?: string | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      additionalClauses?:  {
        __typename: "ModelLeaseAdditionalClauseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      bankAccountId?: string | null,
      bankAccount?:  {
        __typename: "BankAccount",
        id: string,
        contactId: string,
        number: string,
        bicNumber?: string | null,
        bankName?: string | null,
        contactIds?: Array< string > | null,
        buildingIds?: Array< string > | null,
        holderName?: string | null,
        label?: string | null,
        disabled?: boolean | null,
        integrations?: Array< IntegrationName > | null,
        matchingRule?: BankAccountMatchingRule | null,
        balance?: number | null,
        balanceDate?: string | null,
        type: BankAccountType,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contacts?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      files?:  {
        __typename: "ModelFileConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leaseActionHistories?:  {
        __typename: "ModelLeaseActionHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leasePriceHistories?:  {
        __typename: "ModelLeasePriceHistoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      signatureDocuments?:  {
        __typename: "ModelSignatureDocumentConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      variousOperations?:  {
        __typename: "ModelLeaseVariousOperationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    readers?: Array< string > | null,
    readId: string,
    clientId: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateUnitOwnerSubscriptionVariables = {
  filter?: ModelSubscriptionUnitOwnerFilterInput | null,
};

export type OnCreateUnitOwnerSubscription = {
  onCreateUnitOwner?:  {
    __typename: "UnitOwner",
    id: string,
    disabled?: boolean | null,
    owner?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    ownerId: string,
    periodFrom?: string | null,
    periodTo?: string | null,
    stake: number,
    unit?:  {
      __typename: "Unit",
      id: string,
      acquisitionAdditionalCostsValue?: number | null,
      acquisitionAdvertisedValue?: number | null,
      acquisitionValue?: number | null,
      advertisedMonthlyCharges?: number | null,
      advertisedRentalPrice?: number | null,
      cadastralIncome?: number | null,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      floor?: number | null,
      jointOwnershipId?: string | null,
      managementDate: string,
      name: string,
      notes?: string | null,
      predictedPrice?: string | null,
      propertyTax?: number | null,
      publishAddress?: boolean | null,
      surface?: number | null,
      type: UnitType,
      buildingId: string,
      building?:  {
        __typename: "Building",
        id: string,
        name: string,
        addressId?: string | null,
        acquisitionValue?: number | null,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        amountOfFacades?: number | null,
        amountOfFloors?: number | null,
        amountOfHousings?: number | null,
        buildingState?: BuildingState | null,
        cadastralIncome?: number | null,
        constructionYear?: string | null,
        janitor?: boolean | null,
        jointOwnershipId?: string | null,
        notes?: string | null,
        propertyTax?: number | null,
        residenceName?: string | null,
        buildingSiteId?: string | null,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      owners?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leases?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      events?:  {
        __typename: "ModelUnitEventConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      unitAdvertisementId?: string | null,
      unitInventories?:  {
        __typename: "ModelUnitInventoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    unitId: string,
    readers?: Array< string > | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateUnitOwnerSubscriptionVariables = {
  filter?: ModelSubscriptionUnitOwnerFilterInput | null,
};

export type OnUpdateUnitOwnerSubscription = {
  onUpdateUnitOwner?:  {
    __typename: "UnitOwner",
    id: string,
    disabled?: boolean | null,
    owner?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    ownerId: string,
    periodFrom?: string | null,
    periodTo?: string | null,
    stake: number,
    unit?:  {
      __typename: "Unit",
      id: string,
      acquisitionAdditionalCostsValue?: number | null,
      acquisitionAdvertisedValue?: number | null,
      acquisitionValue?: number | null,
      advertisedMonthlyCharges?: number | null,
      advertisedRentalPrice?: number | null,
      cadastralIncome?: number | null,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      floor?: number | null,
      jointOwnershipId?: string | null,
      managementDate: string,
      name: string,
      notes?: string | null,
      predictedPrice?: string | null,
      propertyTax?: number | null,
      publishAddress?: boolean | null,
      surface?: number | null,
      type: UnitType,
      buildingId: string,
      building?:  {
        __typename: "Building",
        id: string,
        name: string,
        addressId?: string | null,
        acquisitionValue?: number | null,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        amountOfFacades?: number | null,
        amountOfFloors?: number | null,
        amountOfHousings?: number | null,
        buildingState?: BuildingState | null,
        cadastralIncome?: number | null,
        constructionYear?: string | null,
        janitor?: boolean | null,
        jointOwnershipId?: string | null,
        notes?: string | null,
        propertyTax?: number | null,
        residenceName?: string | null,
        buildingSiteId?: string | null,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      owners?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leases?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      events?:  {
        __typename: "ModelUnitEventConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      unitAdvertisementId?: string | null,
      unitInventories?:  {
        __typename: "ModelUnitInventoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    unitId: string,
    readers?: Array< string > | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteUnitOwnerSubscriptionVariables = {
  filter?: ModelSubscriptionUnitOwnerFilterInput | null,
};

export type OnDeleteUnitOwnerSubscription = {
  onDeleteUnitOwner?:  {
    __typename: "UnitOwner",
    id: string,
    disabled?: boolean | null,
    owner?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    ownerId: string,
    periodFrom?: string | null,
    periodTo?: string | null,
    stake: number,
    unit?:  {
      __typename: "Unit",
      id: string,
      acquisitionAdditionalCostsValue?: number | null,
      acquisitionAdvertisedValue?: number | null,
      acquisitionValue?: number | null,
      advertisedMonthlyCharges?: number | null,
      advertisedRentalPrice?: number | null,
      cadastralIncome?: number | null,
      createdAt?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      floor?: number | null,
      jointOwnershipId?: string | null,
      managementDate: string,
      name: string,
      notes?: string | null,
      predictedPrice?: string | null,
      propertyTax?: number | null,
      publishAddress?: boolean | null,
      surface?: number | null,
      type: UnitType,
      buildingId: string,
      building?:  {
        __typename: "Building",
        id: string,
        name: string,
        addressId?: string | null,
        acquisitionValue?: number | null,
        acquisitionAdditionalCostsValue?: number | null,
        acquisitionAdvertisedValue?: number | null,
        amountOfFacades?: number | null,
        amountOfFloors?: number | null,
        amountOfHousings?: number | null,
        buildingState?: BuildingState | null,
        cadastralIncome?: number | null,
        constructionYear?: string | null,
        janitor?: boolean | null,
        jointOwnershipId?: string | null,
        notes?: string | null,
        propertyTax?: number | null,
        residenceName?: string | null,
        buildingSiteId?: string | null,
        readers?: Array< string > | null,
        teams?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      owners?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      leases?:  {
        __typename: "ModelUnitLeaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      events?:  {
        __typename: "ModelUnitEventConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      unitAdvertisementId?: string | null,
      unitInventories?:  {
        __typename: "ModelUnitInventoryConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    unitId: string,
    readers?: Array< string > | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateTeamSubscriptionVariables = {
  filter?: ModelSubscriptionTeamFilterInput | null,
};

export type OnCreateTeamSubscription = {
  onCreateTeam?:  {
    __typename: "Team",
    id: string,
    name: string,
    parentId?: string | null,
    children?:  {
      __typename: "ModelTeamConnection",
      items:  Array< {
        __typename: "Team",
        id: string,
        name: string,
        parentId?: string | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    users?:  {
      __typename: "ModelUserTeamConnection",
      items:  Array< {
        __typename: "UserTeam",
        id: string,
        userId: string,
        teamId: string,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateTeamSubscriptionVariables = {
  filter?: ModelSubscriptionTeamFilterInput | null,
};

export type OnUpdateTeamSubscription = {
  onUpdateTeam?:  {
    __typename: "Team",
    id: string,
    name: string,
    parentId?: string | null,
    children?:  {
      __typename: "ModelTeamConnection",
      items:  Array< {
        __typename: "Team",
        id: string,
        name: string,
        parentId?: string | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    users?:  {
      __typename: "ModelUserTeamConnection",
      items:  Array< {
        __typename: "UserTeam",
        id: string,
        userId: string,
        teamId: string,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteTeamSubscriptionVariables = {
  filter?: ModelSubscriptionTeamFilterInput | null,
};

export type OnDeleteTeamSubscription = {
  onDeleteTeam?:  {
    __typename: "Team",
    id: string,
    name: string,
    parentId?: string | null,
    children?:  {
      __typename: "ModelTeamConnection",
      items:  Array< {
        __typename: "Team",
        id: string,
        name: string,
        parentId?: string | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    users?:  {
      __typename: "ModelUserTeamConnection",
      items:  Array< {
        __typename: "UserTeam",
        id: string,
        userId: string,
        teamId: string,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateUserSubscriptionVariables = {
  filter?: ModelSubscriptionUserFilterInput | null,
};

export type OnCreateUserSubscription = {
  onCreateUser?:  {
    __typename: "User",
    id: string,
    email: string,
    firstName?: string | null,
    lastName?: string | null,
    cognitoSub?: string | null,
    googleSub?: string | null,
    facebookSub?: string | null,
    rootUser?: boolean | null,
    refreshToken?: boolean | null,
    teams?:  {
      __typename: "ModelUserTeamConnection",
      items:  Array< {
        __typename: "UserTeam",
        id: string,
        userId: string,
        teamId: string,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    userRoleId?: string | null,
    userRole?:  {
      __typename: "UserRole",
      id: string,
      name: string,
      userRights?:  Array< {
        __typename: "UserRight",
        access?: Array< UserRightAccessType > | null,
        section: UserRightSection,
      } > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    contactId?: string | null,
    contact?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    status: UserStatus,
    readId: string,
    clientId: string,
    _ttl?: number | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateUserSubscriptionVariables = {
  filter?: ModelSubscriptionUserFilterInput | null,
};

export type OnUpdateUserSubscription = {
  onUpdateUser?:  {
    __typename: "User",
    id: string,
    email: string,
    firstName?: string | null,
    lastName?: string | null,
    cognitoSub?: string | null,
    googleSub?: string | null,
    facebookSub?: string | null,
    rootUser?: boolean | null,
    refreshToken?: boolean | null,
    teams?:  {
      __typename: "ModelUserTeamConnection",
      items:  Array< {
        __typename: "UserTeam",
        id: string,
        userId: string,
        teamId: string,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    userRoleId?: string | null,
    userRole?:  {
      __typename: "UserRole",
      id: string,
      name: string,
      userRights?:  Array< {
        __typename: "UserRight",
        access?: Array< UserRightAccessType > | null,
        section: UserRightSection,
      } > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    contactId?: string | null,
    contact?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    status: UserStatus,
    readId: string,
    clientId: string,
    _ttl?: number | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteUserSubscriptionVariables = {
  filter?: ModelSubscriptionUserFilterInput | null,
};

export type OnDeleteUserSubscription = {
  onDeleteUser?:  {
    __typename: "User",
    id: string,
    email: string,
    firstName?: string | null,
    lastName?: string | null,
    cognitoSub?: string | null,
    googleSub?: string | null,
    facebookSub?: string | null,
    rootUser?: boolean | null,
    refreshToken?: boolean | null,
    teams?:  {
      __typename: "ModelUserTeamConnection",
      items:  Array< {
        __typename: "UserTeam",
        id: string,
        userId: string,
        teamId: string,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    userRoleId?: string | null,
    userRole?:  {
      __typename: "UserRole",
      id: string,
      name: string,
      userRights?:  Array< {
        __typename: "UserRight",
        access?: Array< UserRightAccessType > | null,
        section: UserRightSection,
      } > | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    contactId?: string | null,
    contact?:  {
      __typename: "Contact",
      id: string,
      createdAt?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      companyName?: string | null,
      commercialName?: string | null,
      communicationSettingsProfileId?: string | null,
      customValues?:  Array< {
        __typename: "CustomValue",
        name: string,
        value: string,
      } > | null,
      businessNumber?: string | null,
      types: Array< ContactType >,
      vat?: string | null,
      emails?:  Array< {
        __typename: "Email",
        address: string,
        isPrimary: boolean,
        label?: string | null,
      } > | null,
      email?: string | null,
      birthDate?: string | null,
      birthPlace?: string | null,
      nationalRegister?: string | null,
      ipiNumber?: string | null,
      insuranceCompany?: string | null,
      insuranceContractNumber?: string | null,
      judicialDistrict?: string | null,
      civility?: CivilityType | null,
      addressId?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        status?: AddressStatus | null,
        street: string,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        countryCode: string,
        isPrimary: boolean,
        label?: string | null,
        number: string,
      } > | null,
      language?: string | null,
      notes?: string | null,
      profileType: ContactProfileType,
      jointOwners?:  Array< {
        __typename: "JointOwner",
        contactId: string,
        contactPerson?: boolean | null,
      } > | null,
      hoaFunds?:  Array< {
        __typename: "ContactHoaFund",
        archivedAt?: string | null,
        id: string,
        kind: HoaFundKind,
        name: string,
      } > | null,
      agencyRateDisabled?: boolean | null,
      attachStatementSupportingDocuments?: boolean | null,
      status?: ContactStatus | null,
      leases?:  {
        __typename: "ModelLeaseContactConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      buildings?:  {
        __typename: "ModelBuildingOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      units?:  {
        __typename: "ModelUnitOwnerConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sendInvitation: boolean,
      peppolProperties?:  {
        __typename: "ContactPeppolProperties",
        isRegistered: boolean,
        mustSend: boolean,
      } | null,
      integrations?:  {
        __typename: "ContactIntegrations",
      } | null,
      readers?: Array< string > | null,
      readId: string,
      clientId: string,
      sourceEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      foreignEntityRelations?:  {
        __typename: "ModelEntityRelationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    status: UserStatus,
    readId: string,
    clientId: string,
    _ttl?: number | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateUserRoleSubscriptionVariables = {
  filter?: ModelSubscriptionUserRoleFilterInput | null,
};

export type OnCreateUserRoleSubscription = {
  onCreateUserRole?:  {
    __typename: "UserRole",
    id: string,
    name: string,
    userRights?:  Array< {
      __typename: "UserRight",
      access?: Array< UserRightAccessType > | null,
      section: UserRightSection,
    } > | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateUserRoleSubscriptionVariables = {
  filter?: ModelSubscriptionUserRoleFilterInput | null,
};

export type OnUpdateUserRoleSubscription = {
  onUpdateUserRole?:  {
    __typename: "UserRole",
    id: string,
    name: string,
    userRights?:  Array< {
      __typename: "UserRight",
      access?: Array< UserRightAccessType > | null,
      section: UserRightSection,
    } > | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteUserRoleSubscriptionVariables = {
  filter?: ModelSubscriptionUserRoleFilterInput | null,
};

export type OnDeleteUserRoleSubscription = {
  onDeleteUserRole?:  {
    __typename: "UserRole",
    id: string,
    name: string,
    userRights?:  Array< {
      __typename: "UserRight",
      access?: Array< UserRightAccessType > | null,
      section: UserRightSection,
    } > | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateUserTeamSubscriptionVariables = {
  filter?: ModelSubscriptionUserTeamFilterInput | null,
};

export type OnCreateUserTeamSubscription = {
  onCreateUserTeam?:  {
    __typename: "UserTeam",
    id: string,
    userId: string,
    teamId: string,
    team?:  {
      __typename: "Team",
      id: string,
      name: string,
      parentId?: string | null,
      children?:  {
        __typename: "ModelTeamConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      users?:  {
        __typename: "ModelUserTeamConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    user?:  {
      __typename: "User",
      id: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      cognitoSub?: string | null,
      googleSub?: string | null,
      facebookSub?: string | null,
      rootUser?: boolean | null,
      refreshToken?: boolean | null,
      teams?:  {
        __typename: "ModelUserTeamConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      userRoleId?: string | null,
      userRole?:  {
        __typename: "UserRole",
        id: string,
        name: string,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contactId?: string | null,
      contact?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      status: UserStatus,
      readId: string,
      clientId: string,
      _ttl?: number | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateUserTeamSubscriptionVariables = {
  filter?: ModelSubscriptionUserTeamFilterInput | null,
};

export type OnUpdateUserTeamSubscription = {
  onUpdateUserTeam?:  {
    __typename: "UserTeam",
    id: string,
    userId: string,
    teamId: string,
    team?:  {
      __typename: "Team",
      id: string,
      name: string,
      parentId?: string | null,
      children?:  {
        __typename: "ModelTeamConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      users?:  {
        __typename: "ModelUserTeamConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    user?:  {
      __typename: "User",
      id: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      cognitoSub?: string | null,
      googleSub?: string | null,
      facebookSub?: string | null,
      rootUser?: boolean | null,
      refreshToken?: boolean | null,
      teams?:  {
        __typename: "ModelUserTeamConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      userRoleId?: string | null,
      userRole?:  {
        __typename: "UserRole",
        id: string,
        name: string,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contactId?: string | null,
      contact?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      status: UserStatus,
      readId: string,
      clientId: string,
      _ttl?: number | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteUserTeamSubscriptionVariables = {
  filter?: ModelSubscriptionUserTeamFilterInput | null,
};

export type OnDeleteUserTeamSubscription = {
  onDeleteUserTeam?:  {
    __typename: "UserTeam",
    id: string,
    userId: string,
    teamId: string,
    team?:  {
      __typename: "Team",
      id: string,
      name: string,
      parentId?: string | null,
      children?:  {
        __typename: "ModelTeamConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      users?:  {
        __typename: "ModelUserTeamConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      readId: string,
      clientId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    user?:  {
      __typename: "User",
      id: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      cognitoSub?: string | null,
      googleSub?: string | null,
      facebookSub?: string | null,
      rootUser?: boolean | null,
      refreshToken?: boolean | null,
      teams?:  {
        __typename: "ModelUserTeamConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      userRoleId?: string | null,
      userRole?:  {
        __typename: "UserRole",
        id: string,
        name: string,
        readId: string,
        clientId: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      contactId?: string | null,
      contact?:  {
        __typename: "Contact",
        id: string,
        createdAt?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        companyName?: string | null,
        commercialName?: string | null,
        communicationSettingsProfileId?: string | null,
        businessNumber?: string | null,
        types: Array< ContactType >,
        vat?: string | null,
        email?: string | null,
        birthDate?: string | null,
        birthPlace?: string | null,
        nationalRegister?: string | null,
        ipiNumber?: string | null,
        insuranceCompany?: string | null,
        insuranceContractNumber?: string | null,
        judicialDistrict?: string | null,
        civility?: CivilityType | null,
        addressId?: string | null,
        language?: string | null,
        notes?: string | null,
        profileType: ContactProfileType,
        agencyRateDisabled?: boolean | null,
        attachStatementSupportingDocuments?: boolean | null,
        status?: ContactStatus | null,
        sendInvitation: boolean,
        readers?: Array< string > | null,
        readId: string,
        clientId: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      status: UserStatus,
      readId: string,
      clientId: string,
      _ttl?: number | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    readId: string,
    clientId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export enum HoaFundKind {
  RESERVE = "RESERVE",
  WORKING_CAPITAL = "WORKING_CAPITAL",
}

export enum RecurringPaymentPeriodicity {
  MONTHLY = "MONTHLY",
  QUARTERLY = "QUARTERLY",
}

export enum RecurringPaymentTemplateStatus {
  ACTIVE = "ACTIVE",
  ENDED = "ENDED",
}

export enum RecurringPaymentFailureReason {
  AMOUNT_NOT_POSITIVE = "AMOUNT_NOT_POSITIVE",
  BENEFICIARY_ACCOUNT_NOT_ELIGIBLE = "BENEFICIARY_ACCOUNT_NOT_ELIGIBLE",
  BENEFICIARY_IBAN_NOT_SAFE = "BENEFICIARY_IBAN_NOT_SAFE",
  END_DATE_BEFORE_START = "END_DATE_BEFORE_START",
  FIRST_PERIOD_IN_THE_PAST = "FIRST_PERIOD_IN_THE_PAST",
  FIRST_PERIOD_NOT_MONTH_START = "FIRST_PERIOD_NOT_MONTH_START",
  FUND_ACCOUNT_DUPLICATE = "FUND_ACCOUNT_DUPLICATE",
  FUND_ACCOUNT_NOT_ELIGIBLE = "FUND_ACCOUNT_NOT_ELIGIBLE",
  FUND_ACCOUNT_REQUIRES_SINGLE_OWNER = "FUND_ACCOUNT_REQUIRES_SINGLE_OWNER",
  FUND_DUPLICATE = "FUND_DUPLICATE",
  FUND_UNKNOWN = "FUND_UNKNOWN",
  GENERATION_DAY_OUT_OF_RANGE = "GENERATION_DAY_OUT_OF_RANGE",
  NOT_FOUND = "NOT_FOUND",
  SOURCE_ACCOUNT_NOT_ELIGIBLE = "SOURCE_ACCOUNT_NOT_ELIGIBLE",
  SPLIT_REQUIRES_TWO_FUNDS = "SPLIT_REQUIRES_TWO_FUNDS",
  TEMPLATE_ENDED = "TEMPLATE_ENDED",
  UNIT_NOT_IN_HOA_BUILDING = "UNIT_NOT_IN_HOA_BUILDING",
  VERSION_ALREADY_IN_FORCE = "VERSION_ALREADY_IN_FORCE",
}

export type RecurringPaymentTemplateDTO = {
  __typename: "RecurringPaymentTemplate",
  id: string,
  amountVersions: Array<RecurringPaymentAmountVersionDTO>,
  bankAccountId: string,
  bankAccount?: BankAccountDTO | null,
  beneficiaryBankAccountId: string,
  beneficiaryBankAccount?: BankAccountDTO | null,
  beneficiaryContactId: string,
  beneficiaryContact?: ContactDTO | null,
  createdBy?: string | null,
  endDate?: string | null,
  endedAt?: string | null,
  endedBy?: string | null,
  firstPeriodFrom: string,
  funds?: Array<RecurringPaymentFundDTO> | null,
  generationDay: number,
  lastGeneratedPeriodFrom?: string | null,
  name: string,
  periodicity: RecurringPaymentPeriodicity,
  remittanceInformation?: string | null,
  splitTransfers: boolean,
  status: RecurringPaymentTemplateStatus,
  unitId?: string | null,
  unit?: UnitDTO | null,
  readId: string,
  clientId: string,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type RecurringPaymentAmountVersionDTO = {
  __typename: "RecurringPaymentAmountVersion",
  amounts?: Array<RecurringPaymentFundAmountDTO> | null,
  createdAt: string,
  createdBy?: string | null,
  effectiveFrom: string,
  note?: string | null,
  reserveFundAmount?: number | null,
  workingCapitalAmount?: number | null,
};

export type RecurringPaymentAmountVersionInput = {
  amounts?: Array<RecurringPaymentFundAmountInput> | null,
  createdAt: string,
  createdBy?: string | null,
  effectiveFrom: string,
  note?: string | null,
  reserveFundAmount?: number | null,
  workingCapitalAmount?: number | null,
};

export type RecurringPaymentFundAmountDTO = {
  __typename: "RecurringPaymentFundAmount",
  amount: number,
  fundId: string,
};

export type RecurringPaymentFundAmountInput = {
  amount: number,
  fundId: string,
};

export type RecurringPaymentFundDTO = {
  __typename: "RecurringPaymentFund",
  accountLabelId?: string | null,
  fundId: string,
  remittanceInformation?: string | null,
};

export type RecurringPaymentFundInput = {
  accountLabelId?: string | null,
  fundId: string,
  remittanceInformation?: string | null,
};

export type CreateRecurringPaymentTemplateInput = {
  id?: string | null,
  amountVersions: Array<RecurringPaymentAmountVersionInput>,
  bankAccountId: string,
  beneficiaryBankAccountId: string,
  beneficiaryContactId: string,
  createdBy?: string | null,
  endDate?: string | null,
  endedAt?: string | null,
  endedBy?: string | null,
  firstPeriodFrom: string,
  funds?: Array<RecurringPaymentFundInput> | null,
  generationDay: number,
  lastGeneratedPeriodFrom?: string | null,
  name: string,
  periodicity: RecurringPaymentPeriodicity,
  remittanceInformation?: string | null,
  splitTransfers: boolean,
  status: RecurringPaymentTemplateStatus,
  unitId?: string | null,
  readId: string,
  clientId: string,
  _version?: number | null,
};

export type UpdateRecurringPaymentTemplateInput = {
  id: string,
  amountVersions?: Array<RecurringPaymentAmountVersionInput> | null,
  bankAccountId?: string | null,
  beneficiaryBankAccountId?: string | null,
  beneficiaryContactId?: string | null,
  createdBy?: string | null,
  endDate?: string | null,
  endedAt?: string | null,
  endedBy?: string | null,
  firstPeriodFrom?: string | null,
  funds?: Array<RecurringPaymentFundInput> | null,
  generationDay?: number | null,
  lastGeneratedPeriodFrom?: string | null,
  name?: string | null,
  periodicity?: RecurringPaymentPeriodicity | null,
  remittanceInformation?: string | null,
  splitTransfers?: boolean | null,
  status?: RecurringPaymentTemplateStatus | null,
  unitId?: string | null,
  readId?: string | null,
  clientId?: string | null,
  _version?: number | null,
};

export type ModelRecurringPaymentTemplateConditionInput = {
  status?: { eq?: RecurringPaymentTemplateStatus | null, ne?: RecurringPaymentTemplateStatus | null } | null,
  and?: Array< ModelRecurringPaymentTemplateConditionInput | null > | null,
  or?: Array< ModelRecurringPaymentTemplateConditionInput | null > | null,
  not?: ModelRecurringPaymentTemplateConditionInput | null,
};

export type CreateRecurringPaymentTemplateMutationVariables = {
  input: CreateRecurringPaymentTemplateInput,
  condition?: ModelRecurringPaymentTemplateConditionInput | null,
};

export type CreateRecurringPaymentTemplateMutation = {
  createRecurringPaymentTemplate?: RecurringPaymentTemplateDTO | null,
};

export type UpdateRecurringPaymentTemplateMutationVariables = {
  input: UpdateRecurringPaymentTemplateInput,
  condition?: ModelRecurringPaymentTemplateConditionInput | null,
};

export type UpdateRecurringPaymentTemplateMutation = {
  updateRecurringPaymentTemplate?: RecurringPaymentTemplateDTO | null,
};

export enum FeeArrearsStatus {
  OPEN = "OPEN",
  SETTLED = "SETTLED",
}


export type FeeArrearsDTO = {
  __typename: "FeeArrears",
  id: string,
  accumulatedFrom?: Array<FeeArrearsAccumulationDTO | null> | null,
  amount: number,
  bankAccountId: string,
  bankAccount?: BankAccountDTO | null,
  openedAt?: string | null,
  originalAmount: number,
  originPaymentOrderId: string,
  originPaymentOrder?: PaymentOrderDTO | null,
  ownerContactId: string,
  ownerContact?: ContactDTO | null,
  servedBy?: Array<FeeArrearsServingDTO | null> | null,
  settledAt?: string | null,
  status: FeeArrearsStatus,
  readId: string,
  clientId: string,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type FeeArrearsAccumulationDTO = {
  __typename: "FeeArrearsAccumulation",
  accumulatedAt: string,
  amount: number,
  paymentOrderId: string,
};

export type FeeArrearsAccumulationInput = {
  accumulatedAt: string,
  amount: number,
  paymentOrderId: string,
};

export type FeeArrearsServingDTO = {
  __typename: "FeeArrearsServing",
  amount: number,
  paymentOrderId: string,
  servedAt: string,
};

export type FeeArrearsServingInput = {
  amount: number,
  paymentOrderId: string,
  servedAt: string,
};

export type CreateFeeArrearsInput = {
  id?: string | null,
  accumulatedFrom?: Array<FeeArrearsAccumulationInput | null> | null,
  amount: number,
  bankAccountId: string,
  openedAt?: string | null,
  originalAmount: number,
  originPaymentOrderId: string,
  ownerContactId: string,
  servedBy?: Array<FeeArrearsServingInput | null> | null,
  settledAt?: string | null,
  status: FeeArrearsStatus,
  readId: string,
  clientId: string,
  _version?: number | null,
};

export type UpdateFeeArrearsInput = {
  id: string,
  accumulatedFrom?: Array<FeeArrearsAccumulationInput | null> | null,
  amount?: number | null,
  bankAccountId?: string | null,
  openedAt?: string | null,
  originalAmount?: number | null,
  originPaymentOrderId?: string | null,
  ownerContactId?: string | null,
  servedBy?: Array<FeeArrearsServingInput | null> | null,
  settledAt?: string | null,
  status?: FeeArrearsStatus | null,
  readId?: string | null,
  clientId?: string | null,
  _version?: number | null,
};

export type ModelFeeArrearsConditionInput = {
  status?: { eq?: FeeArrearsStatus | null, ne?: FeeArrearsStatus | null } | null,
  and?: Array< ModelFeeArrearsConditionInput | null > | null,
  or?: Array< ModelFeeArrearsConditionInput | null > | null,
  not?: ModelFeeArrearsConditionInput | null,
};

export type CreateFeeArrearsMutationVariables = {
  input: CreateFeeArrearsInput,
  condition?: ModelFeeArrearsConditionInput | null,
};

export type CreateFeeArrearsMutation = {
  createFeeArrears?: FeeArrearsDTO | null,
};

export type UpdateFeeArrearsMutationVariables = {
  input: UpdateFeeArrearsInput,
  condition?: ModelFeeArrearsConditionInput | null,
};

export type UpdateFeeArrearsMutation = {
  updateFeeArrears?: FeeArrearsDTO | null,
};

export enum PaymentRunTier {
  OBLIGATION = "OBLIGATION",
  FEES = "FEES",
  PAYOUT = "PAYOUT",
}

export enum PaymentRunRowKind {
  FEE_ARREARS = "FEE_ARREARS",
  ORDER = "ORDER",
}

export enum PaymentRunRowStatus {
  CONFIRMATION_OVERDUE = "CONFIRMATION_OVERDUE",
  HELD = "HELD",
  PAY_NOW = "PAY_NOW",
  REDUCED = "REDUCED",
}

export enum PaymentRunVerdict {
  COVERS_EVERYTHING = "COVERS_EVERYTHING",
  REDUCED = "REDUCED",
  SHORT = "SHORT",
}

export enum UpdateLeaseBillingItemStatus {
  OK = "OK",
  STALE = "STALE",
  VERSION_CONFLICT = "VERSION_CONFLICT",
  LOCKED_FIELD = "LOCKED_FIELD",
  DUPLICATE = "DUPLICATE",
  INVALID_APPLIES_FROM = "INVALID_APPLIES_FROM",
  DRAFT_DOCUMENT_PENDING = "DRAFT_DOCUMENT_PENDING",
}

export enum LeaseBillingItemCorrectionChoice {
  AUTO = "AUTO",
  MANUAL = "MANUAL",
}

export enum ChargeDocumentGenre {
  ACCOUNT_POSITION = "ACCOUNT_POSITION",
  AG_MINUTES = "AG_MINUTES",
  BALANCE_SHEET = "BALANCE_SHEET",
  CREDIT_NOTE = "CREDIT_NOTE",
  EXPENSE_ADVANCE = "EXPENSE_ADVANCE",
  FUND_CALL = "FUND_CALL",
  INTERIM_UTILITY = "INTERIM_UTILITY",
  METERING_STATEMENT = "METERING_STATEMENT",
  REMINDER = "REMINDER",
  SUPPLIER_INVOICE = "SUPPLIER_INVOICE",
  SYNDIC_STATEMENT = "SYNDIC_STATEMENT",
  UNCLASSIFIED = "UNCLASSIFIED",
}


export enum ChargeDuplicateReason {
  FALLBACK_KEY_COLLISION = "FALLBACK_KEY_COLLISION",
  NEAR_DATE_SAME_AMOUNT = "NEAR_DATE_SAME_AMOUNT",
  SAME_NUMBER_DIFFERENT_FIGURES = "SAME_NUMBER_DIFFERENT_FIGURES",
}


export enum ChargeEnvelopeChannel {
  API = "API",
  DROP = "DROP",
  EMAIL = "EMAIL",
  UBL = "UBL",
}


export enum ChargePageQualityKind {
  NATIVE_GARBAGE = "NATIVE_GARBAGE",
  NATIVE_OK = "NATIVE_OK",
  NO_TEXT = "NO_TEXT",
}


export enum ChargeRenderingReason {
  IDENTITY_KEY = "IDENTITY_KEY",
  REMINDER = "REMINDER",
}


export enum ChargeRenderingSource {
  NATIVE_PDF = "NATIVE_PDF",
  SCAN = "SCAN",
  UBL = "UBL",
}


export enum ChargeSectionSplitSource {
  LLM = "LLM",
  RULE = "RULE",
  USER = "USER",
}


export enum ChargeSectionState {
  AFFECTED = "AFFECTED",
  AWAITING_AFFECTATION = "AWAITING_AFFECTATION",
  AWAITING_VALIDATION = "AWAITING_VALIDATION",
  CLASSIFYING = "CLASSIFYING",
  DUPLICATE_CHECK = "DUPLICATE_CHECK",
  EXTRACTING = "EXTRACTING",
  INGESTED = "INGESTED",
  STRUCTURING = "STRUCTURING",
  UNREADABLE = "UNREADABLE",
  VALIDATED = "VALIDATED",
}


export enum PdfEncryption {
  NONE = "NONE",
  OWNER_PASSWORD = "OWNER_PASSWORD",
  USER_PASSWORD = "USER_PASSWORD",
}


export enum ChargeReadFailure {
  PASSWORD_PROTECTED = "PASSWORD_PROTECTED",
  UNREADABLE = "UNREADABLE",
}


export enum UnlockChargeEnvelopeOutcome {
  UNLOCKED = "UNLOCKED",
  UNREADABLE = "UNREADABLE",
  WRONG_PASSWORD = "WRONG_PASSWORD",
}


export enum ChargeSetAsideReason {
  EXACT_DUPLICATE = "EXACT_DUPLICATE",
  IDENTITY_DUPLICATE = "IDENTITY_DUPLICATE",
}


export enum ChargeSplitRule {
  EMAIL_HEADER = "EMAIL_HEADER",
  ISSUER_CHANGE = "ISSUER_CHANGE",
  KNOWN_BUNDLE = "KNOWN_BUNDLE",
  LLM_ARBITRATION = "LLM_ARBITRATION",
  PAGE_NUMBER_RESTART = "PAGE_NUMBER_RESTART",
  REPEATED_INVOICE_HEADER = "REPEATED_INVOICE_HEADER",
  SECTION_TITLE = "SECTION_TITLE",
}


export type ChargePageRangeDTO = {
  __typename: "ChargePageRange",
  from: number,
  to: number,
};

export type ChargePageQualityDTO = {
  __typename: "ChargePageQuality",
  alphaRatio: number,
  averageFontSize?: number | null,
  dictionaryHits: number,
  kind: ChargePageQualityKind,
  page: number,
};

export type ChargeSplitCutDTO = {
  __typename: "ChargeSplitCut",
  afterPage: number,
  reason: string,
  rule: ChargeSplitRule,
  score: number,
};

export type ChargeSplitProposalDTO = {
  __typename: "ChargeSplitProposal",
  ambiguousBoundaries?: Array<number | null> | null,
  autoApplied: boolean,
  cuts: Array<ChargeSplitCutDTO | null>,
  proposedAt: string,
  source: ChargeSectionSplitSource,
};

export type ChargeGenreCandidateDTO = {
  __typename: "ChargeGenreCandidate",
  genre: ChargeDocumentGenre,
  reasons: Array<string | null>,
  score: number,
};

export type ChargeIdentityValueDTO = {
  __typename: "ChargeIdentityValue",
  field: string,
  value?: string | null,
};

export type ChargeDocumentIdentityDTO = {
  __typename: "ChargeDocumentIdentity",
  documentNumber?: string | null,
  grossTotal: number,
  issuer: string,
  source: ChargeRenderingSource,
  values?: Array<ChargeIdentityValueDTO | null> | null,
};

export type ChargeRenderingDifferenceDTO = {
  __typename: "ChargeRenderingDifference",
  field: string,
  renderingValue?: string | null,
  survivorValue?: string | null,
};

export type ChargeSectionRenderingDTO = {
  __typename: "ChargeSectionRendering",
  attachedAt: string,
  differences?: Array<ChargeRenderingDifferenceDTO | null> | null,
  envelopeId: string,
  reason: ChargeRenderingReason,
  sectionId: string,
  source: ChargeRenderingSource,
};

export type ChargeDuplicateCandidateDTO = {
  __typename: "ChargeDuplicateCandidate",
  reason: ChargeDuplicateReason,
  sectionId: string,
};

export type ChargeEnvelopeDTO = {
  __typename: "ChargeEnvelope",
  id: string,
  channel: ChargeEnvelopeChannel,
  decryptedS3Key?: string | null,
  duplicateOfEnvelopeId?: string | null,
  encryption?: PdfEncryption | null,
  fileHash?: string | null,
  fileId: string,
  file?: FileDTO | null,
  importRunId?: string | null,
  mimeType: string,
  originalFileName: string,
  pageQuality?: Array<ChargePageQualityDTO | null> | null,
  pages?: number | null,
  readFailure?: ChargeReadFailure | null,
  receivedAt: string,
  s3Key: string,
  setAsideReason?: ChargeSetAsideReason | null,
  splitProposal?: ChargeSplitProposalDTO | null,
  readId: string,
  clientId: string,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type ChargeSectionDTO = {
  __typename: "ChargeSection",
  id: string,
  attachedToSectionId?: string | null,
  chargeId?: string | null,
  checkpoints?: ChargeCheckpointsDTO | null,
  duplicateCandidates?: Array<ChargeDuplicateCandidateDTO | null> | null,
  envelopeId: string,
  excludedPages?: Array<number | null> | null,
  fallbackIdentityKey?: string | null,
  genre?: ChargeDocumentGenre | null,
  genreCandidates?: Array<ChargeGenreCandidateDTO | null> | null,
  genreSubKind?: string | null,
  identity?: ChargeDocumentIdentityDTO | null,
  identityKey?: string | null,
  index: number,
  issueDate?: string | null,
  issuerDateKey?: string | null,
  issuerNumberKey?: string | null,
  readFailure?: ChargeReadFailure | null,
  pageRange?: ChargePageRangeDTO | null,
  renderings?: Array<ChargeSectionRenderingDTO | null> | null,
  resolvedAliases?: Array<string | null> | null,
  setAsideReason?: ChargeSetAsideReason | null,
  splitSource: ChargeSectionSplitSource,
  state: ChargeSectionState,
  valuesFromSectionId?: string | null,
  readId: string,
  clientId: string,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type ChargePageRangeInput = {
  from: number,
  to: number,
};

export type ChargePageQualityInput = {
  alphaRatio: number,
  averageFontSize?: number | null,
  dictionaryHits: number,
  kind: ChargePageQualityKind,
  page: number,
};

export type ChargeSplitCutInput = {
  afterPage: number,
  reason: string,
  rule: ChargeSplitRule,
  score: number,
};

export type ChargeSplitProposalInput = {
  ambiguousBoundaries?: Array<number | null> | null,
  autoApplied: boolean,
  cuts: Array<ChargeSplitCutInput | null>,
  proposedAt: string,
  source: ChargeSectionSplitSource,
};

export type ChargeGenreCandidateInput = {
  genre: ChargeDocumentGenre,
  reasons: Array<string | null>,
  score: number,
};

export type ChargeIdentityValueInput = {
  field: string,
  value?: string | null,
};

export type ChargeDocumentIdentityInput = {
  documentNumber?: string | null,
  grossTotal: number,
  issuer: string,
  source: ChargeRenderingSource,
  values?: Array<ChargeIdentityValueInput | null> | null,
};

export type ChargeRenderingDifferenceInput = {
  field: string,
  renderingValue?: string | null,
  survivorValue?: string | null,
};

export type ChargeSectionRenderingInput = {
  attachedAt: string,
  differences?: Array<ChargeRenderingDifferenceInput | null> | null,
  envelopeId: string,
  reason: ChargeRenderingReason,
  sectionId: string,
  source: ChargeRenderingSource,
};

export type ChargeDuplicateCandidateInput = {
  reason: ChargeDuplicateReason,
  sectionId: string,
};

export type CreateChargeEnvelopeInput = {
  id?: string | null,
  channel: ChargeEnvelopeChannel,
  decryptedS3Key?: string | null,
  duplicateOfEnvelopeId?: string | null,
  encryption?: PdfEncryption | null,
  fileHash?: string | null,
  fileId: string,
  importRunId?: string | null,
  mimeType: string,
  originalFileName: string,
  pageQuality?: Array<ChargePageQualityInput | null> | null,
  pages?: number | null,
  readFailure?: ChargeReadFailure | null,
  receivedAt: string,
  s3Key: string,
  setAsideReason?: ChargeSetAsideReason | null,
  splitProposal?: ChargeSplitProposalInput | null,
  readId: string,
  clientId: string,
  _version?: number | null,
};

export type UpdateChargeEnvelopeInput = {
  id: string,
  channel?: ChargeEnvelopeChannel | null,
  decryptedS3Key?: string | null,
  duplicateOfEnvelopeId?: string | null,
  encryption?: PdfEncryption | null,
  fileHash?: string | null,
  fileId?: string | null,
  importRunId?: string | null,
  mimeType?: string | null,
  originalFileName?: string | null,
  pageQuality?: Array<ChargePageQualityInput | null> | null,
  pages?: number | null,
  readFailure?: ChargeReadFailure | null,
  receivedAt?: string | null,
  s3Key?: string | null,
  setAsideReason?: ChargeSetAsideReason | null,
  splitProposal?: ChargeSplitProposalInput | null,
  readId?: string | null,
  clientId?: string | null,
  _version?: number | null,
};

export type CreateChargeSectionInput = {
  id?: string | null,
  attachedToSectionId?: string | null,
  chargeId?: string | null,
  checkpoints?: ChargeCheckpointsInput | null,
  duplicateCandidates?: Array<ChargeDuplicateCandidateInput | null> | null,
  envelopeId: string,
  excludedPages?: Array<number | null> | null,
  fallbackIdentityKey?: string | null,
  genre?: ChargeDocumentGenre | null,
  genreCandidates?: Array<ChargeGenreCandidateInput | null> | null,
  genreSubKind?: string | null,
  identity?: ChargeDocumentIdentityInput | null,
  identityKey?: string | null,
  index: number,
  issueDate?: string | null,
  issuerDateKey?: string | null,
  issuerNumberKey?: string | null,
  readFailure?: ChargeReadFailure | null,
  pageRange?: ChargePageRangeInput | null,
  renderings?: Array<ChargeSectionRenderingInput | null> | null,
  resolvedAliases?: Array<string | null> | null,
  setAsideReason?: ChargeSetAsideReason | null,
  splitSource: ChargeSectionSplitSource,
  state: ChargeSectionState,
  valuesFromSectionId?: string | null,
  readId: string,
  clientId: string,
  _version?: number | null,
};

export type UpdateChargeSectionInput = {
  id: string,
  attachedToSectionId?: string | null,
  chargeId?: string | null,
  checkpoints?: ChargeCheckpointsInput | null,
  duplicateCandidates?: Array<ChargeDuplicateCandidateInput | null> | null,
  envelopeId?: string | null,
  excludedPages?: Array<number | null> | null,
  fallbackIdentityKey?: string | null,
  genre?: ChargeDocumentGenre | null,
  genreCandidates?: Array<ChargeGenreCandidateInput | null> | null,
  genreSubKind?: string | null,
  identity?: ChargeDocumentIdentityInput | null,
  identityKey?: string | null,
  index?: number | null,
  issueDate?: string | null,
  issuerDateKey?: string | null,
  issuerNumberKey?: string | null,
  readFailure?: ChargeReadFailure | null,
  pageRange?: ChargePageRangeInput | null,
  renderings?: Array<ChargeSectionRenderingInput | null> | null,
  resolvedAliases?: Array<string | null> | null,
  setAsideReason?: ChargeSetAsideReason | null,
  splitSource?: ChargeSectionSplitSource | null,
  state?: ChargeSectionState | null,
  valuesFromSectionId?: string | null,
  readId?: string | null,
  clientId?: string | null,
  _version?: number | null,
};

export type CreateChargeEnvelopeMutationVariables = {
  input: CreateChargeEnvelopeInput,
};

export type CreateChargeEnvelopeMutation = {
  createChargeEnvelope?: ChargeEnvelopeDTO | null,
};

export type UpdateChargeEnvelopeMutationVariables = {
  input: UpdateChargeEnvelopeInput,
};

export type UpdateChargeEnvelopeMutation = {
  updateChargeEnvelope?: ChargeEnvelopeDTO | null,
};

export type CreateChargeSectionMutationVariables = {
  input: CreateChargeSectionInput,
};

export type CreateChargeSectionMutation = {
  createChargeSection?: ChargeSectionDTO | null,
};

export type UpdateChargeSectionMutationVariables = {
  input: UpdateChargeSectionInput,
};

export type UpdateChargeSectionMutation = {
  updateChargeSection?: ChargeSectionDTO | null,
};


export enum ExtractionMethod {
  FINGERPRINT = "FINGERPRINT",
  LLM = "LLM",
  TEXT = "TEXT",
  UBL = "UBL",
  VISION = "VISION",
}


export enum LearningEventKind {
  ACCOUNT = "ACCOUNT",
  GENRE = "GENRE",
  LOT = "LOT",
  METER = "METER",
  PAYMENT_MODE = "PAYMENT_MODE",
  SENDER = "SENDER",
  TENANT_SHARE = "TENANT_SHARE",
  UNIT = "UNIT",
  VAT_RATE = "VAT_RATE",
  VAT_REGIME = "VAT_REGIME",
  VCS_RULE = "VCS_RULE",
}


export type ExtractionEvidenceDTO = {
  __typename: "ExtractionEvidence",
  bbox?: Array<number | null> | null,
  field: string,
  method: ExtractionMethod,
  page: number,
  quote: string,
  rawConfidence: number,
};

export type ExtractionEvidenceInput = {
  bbox?: Array<number | null> | null,
  field: string,
  method: ExtractionMethod,
  page: number,
  quote: string,
  rawConfidence: number,
  _version?: number | null,
};

export type DocumentExtractionDTO = {
  __typename: "DocumentExtraction",
  id: string,
  corrected?: string | null,
  createdBy: string,
  evidence?: Array<ExtractionEvidenceDTO | null> | null,
  flags?: Array<string | null> | null,
  raw: string,
  reasons?: Array<string | null> | null,
  score: number,
  sectionId: string,
  version: number,
  readId: string,
  clientId: string,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type CreateDocumentExtractionInput = {
  id?: string | null,
  corrected?: string | null,
  createdBy: string,
  evidence?: Array<ExtractionEvidenceInput | null> | null,
  flags?: Array<string | null> | null,
  raw: string,
  reasons?: Array<string | null> | null,
  score: number,
  sectionId: string,
  version: number,
  readId: string,
  clientId: string,
  _version?: number | null,
};

export type CreateDocumentExtractionMutationVariables = {
  input: CreateDocumentExtractionInput,
};

export type CreateDocumentExtractionMutation = {
  createDocumentExtraction?: DocumentExtractionDTO | null,
};

export type LearningEventDTO = {
  __typename: "LearningEvent",
  id: string,
  at: string,
  field: string,
  from?: string | null,
  kind: LearningEventKind,
  layoutId?: string | null,
  senderId?: string | null,
  to: string,
  userId: string,
  readId: string,
  clientId: string,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type CreateLearningEventInput = {
  id?: string | null,
  at: string,
  field: string,
  from?: string | null,
  kind: LearningEventKind,
  layoutId?: string | null,
  senderId?: string | null,
  to: string,
  userId: string,
  readId: string,
  clientId: string,
  _version?: number | null,
};

export type CreateLearningEventMutationVariables = {
  input: CreateLearningEventInput,
};

export type CreateLearningEventMutation = {
  createLearningEvent?: LearningEventDTO | null,
};


export enum CauseCandidateReason {
  ALIAS_CONFIRMED_ONCE = "ALIAS_CONFIRMED_ONCE",
  SAME_IBAN = "SAME_IBAN",
  SAME_VAT = "SAME_VAT",
  SIMILAR_NAME = "SIMILAR_NAME",
}


export enum ChargeCauseKey {
  AUTO_CREATED_SUPPLIER = "AUTO_CREATED_SUPPLIER",
  IBAN_UNCONFIRMED = "IBAN_UNCONFIRMED",
  LOT_UNMAPPED = "LOT_UNMAPPED",
  METER_UNMAPPED = "METER_UNMAPPED",
  ONE_BY_ONE = "ONE_BY_ONE",
  UNKNOWN_SENDER = "UNKNOWN_SENDER",
}





export type ChargeCheckpointsDTO = {
  __typename: "ChargeCheckpoints",
  allocate?: ChargeCheckpointState | null,
  pay: ChargeCheckpointState,
  payReasons?: Array< ChargeSettlementIssue > | null,
  read?: ChargeCheckpointState | null,
  resolve?: ChargeCheckpointState | null,
  sort?: ChargeCheckpointState | null,
  tenant?: ChargeCheckpointState | null,
};

export type ChargeCheckpointsInput = {
  allocate?: ChargeCheckpointState | null,
  pay: ChargeCheckpointState,
  payReasons?: Array< ChargeSettlementIssue > | null,
  read?: ChargeCheckpointState | null,
  resolve?: ChargeCheckpointState | null,
  sort?: ChargeCheckpointState | null,
  tenant?: ChargeCheckpointState | null,
};

export type CauseCandidateDTO = {
  __typename: "CauseCandidate",
  reason: CauseCandidateReason,
  targetId: string,
};

export type CauseCandidateInput = {
  reason: CauseCandidateReason,
  targetId: string,
};

export type CauseDistinctValueDTO = {
  __typename: "CauseDistinctValue",
  candidates: Array<CauseCandidateDTO | null>,
  display: string,
  sectionIds: Array<string | null>,
  value: string,
};

export type CauseDistinctValueInput = {
  candidates: Array<CauseCandidateInput | null>,
  display: string,
  sectionIds: Array<string | null>,
  value: string,
};

export type ImportRunDTO = {
  __typename: "ImportRun",
  id: string,
  channel: ChargeEnvelopeChannel,
  files: number,
  finishedAt?: string | null,
  handled: number,
  needsYou: number,
  reviewEverything: boolean,
  sections: number,
  setAside: number,
  startedAt: string,
  readId: string,
  clientId: string,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type CreateImportRunInput = {
  id?: string | null,
  channel: ChargeEnvelopeChannel,
  files: number,
  finishedAt?: string | null,
  handled: number,
  needsYou: number,
  reviewEverything: boolean,
  sections: number,
  setAside: number,
  startedAt: string,
  readId: string,
  clientId: string,
  _version?: number | null,
};

export type UpdateImportRunInput = {
  id: string,
  channel?: ChargeEnvelopeChannel | null,
  files?: number | null,
  finishedAt?: string | null,
  handled?: number | null,
  needsYou?: number | null,
  reviewEverything?: boolean | null,
  sections?: number | null,
  setAside?: number | null,
  startedAt?: string | null,
  readId?: string | null,
  clientId?: string | null,
  _version?: number | null,
};

export type CreateImportRunMutationVariables = {
  input: CreateImportRunInput,
};

export type CreateImportRunMutation = {
  createImportRun?: ImportRunDTO | null,
};

export type UpdateImportRunMutationVariables = {
  input: UpdateImportRunInput,
};

export type UpdateImportRunMutation = {
  updateImportRun?: ImportRunDTO | null,
};

export type CauseDTO = {
  __typename: "Cause",
  id: string,
  distinctValues: Array<CauseDistinctValueDTO | null>,
  importRunId: string,
  key: ChargeCauseKey,
  readId: string,
  clientId: string,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type CreateCauseInput = {
  id?: string | null,
  distinctValues: Array<CauseDistinctValueInput | null>,
  importRunId: string,
  key: ChargeCauseKey,
  readId: string,
  clientId: string,
  _version?: number | null,
};

export type UpdateCauseInput = {
  id: string,
  distinctValues?: Array<CauseDistinctValueInput | null> | null,
  importRunId?: string | null,
  key?: ChargeCauseKey | null,
  readId?: string | null,
  clientId?: string | null,
  _version?: number | null,
};

export type CreateCauseMutationVariables = {
  input: CreateCauseInput,
};

export type CreateCauseMutation = {
  createCause?: CauseDTO | null,
};

export type UpdateCauseMutationVariables = {
  input: UpdateCauseInput,
};

export type UpdateCauseMutation = {
  updateCause?: CauseDTO | null,
};

export type EntityAliasDTO = {
  __typename: "EntityAlias",
  id: string,
  confirmations: number,
  confirmedBy?: string | null,
  key: string,
  kind: EntityAliasKind,
  lastSeenAt: string,
  lookupKey: string,
  printedValue?: string | null,
  senderKeyType?: EntityAliasSenderKeyType | null,
  source: RegistrySource,
  targetId: string,
  readId: string,
  clientId: string,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type CreateEntityAliasInput = {
  id?: string | null,
  confirmations: number,
  confirmedBy?: string | null,
  key: string,
  kind: EntityAliasKind,
  lastSeenAt: string,
  lookupKey: string,
  printedValue?: string | null,
  senderKeyType?: EntityAliasSenderKeyType | null,
  source: RegistrySource,
  targetId: string,
  readId: string,
  clientId: string,
  _version?: number | null,
};

export type UpdateEntityAliasInput = {
  id: string,
  confirmations?: number | null,
  confirmedBy?: string | null,
  key?: string | null,
  kind?: EntityAliasKind | null,
  lastSeenAt?: string | null,
  lookupKey?: string | null,
  printedValue?: string | null,
  senderKeyType?: EntityAliasSenderKeyType | null,
  source?: RegistrySource | null,
  targetId?: string | null,
  readId?: string | null,
  clientId?: string | null,
  _version?: number | null,
};

export type CreateEntityAliasMutationVariables = {
  input: CreateEntityAliasInput,
};

export type CreateEntityAliasMutation = {
  createEntityAlias?: EntityAliasDTO | null,
};

export type UpdateEntityAliasMutationVariables = {
  input: UpdateEntityAliasInput,
};

export type UpdateEntityAliasMutation = {
  updateEntityAlias?: EntityAliasDTO | null,
};

export enum CauseDecisionKind {
  CREATE = "CREATE",
  MATCH = "MATCH",
  SKIP = "SKIP",
}


export enum ImportRunUndoRefusalReason {
  ALREADY_PAID_RECONCILED = "ALREADY_PAID_RECONCILED",
  PAYMENT_RUN = "PAYMENT_RUN",
  PERIOD_CLOSED = "PERIOD_CLOSED",
  STATEMENT_FLAGGED = "STATEMENT_FLAGGED",
}


export type ResolveCauseInput = {
  causeId: string,
  decision: CauseDecisionKind,
  targetId?: string | null,
  value: string,
};

export type ResolveCauseResult = {
  __typename: "ResolveCauseResult",
  createdSupplierPaymentHeld: boolean,
  remainingValues: number,
  resolvedSectionIds: Array<string >,
};

export type ResolveCauseMutationVariables = {
  input: ResolveCauseInput,
};

export type ResolveCauseMutation = {
  resolveCause?: ResolveCauseResult | null,
};

export type UndoImportRunInput = {
  importRunId: string,
};

export type UndoImportRunRefusal = {
  __typename: "UndoImportRunRefusal",
  reasons: Array<ImportRunUndoRefusalReason >,
  sectionId: string,
};

export type UndoImportRunResult = {
  __typename: "UndoImportRunResult",
  refused: Array<UndoImportRunRefusal >,
  revertedSectionIds: Array<string >,
};

export type UndoImportRunMutationVariables = {
  input: UndoImportRunInput,
};

export type UndoImportRunMutation = {
  undoImportRun?: UndoImportRunResult | null,
};

export type UnlockChargeEnvelopeInput = {
  envelopeId: string,
  password: string,
};

export type UnlockChargeEnvelopeResult = {
  __typename: "UnlockChargeEnvelopeResult",
  outcome: UnlockChargeEnvelopeOutcome,
};

export type UnlockChargeEnvelopeMutationVariables = {
  input: UnlockChargeEnvelopeInput,
};

export type UnlockChargeEnvelopeMutation = {
  unlockChargeEnvelope?: UnlockChargeEnvelopeResult | null,
};

export type ImportRunCheckpointCounts = {
  __typename: "ImportRunCheckpointCounts",
  allocate: number,
  pay: number,
  read: number,
  resolve: number,
  sort: number,
  tenant: number,
};

export type ImportRunReceiptFile = {
  __typename: "ImportRunReceiptFile",
  envelopeId: string,
  fileId: string,
  fileName: string,
};

export type ImportRunReceiptDocument = {
  __typename: "ImportRunReceiptDocument",
  file: ImportRunReceiptFile,
  pageFrom?: number | null,
  pageTo?: number | null,
  sectionId: string,
};

export type ImportRunReceiptSetAsideFile = {
  __typename: "ImportRunReceiptSetAsideFile",
  file: ImportRunReceiptFile,
  original?: ImportRunReceiptFile | null,
};

export type ImportRunReceiptValue = {
  __typename: "ImportRunReceiptValue",
  candidates: Array<CauseCandidateDTO >,
  display: string,
  documents: Array<ImportRunReceiptDocument >,
  maskedIban?: string | null,
  sectionIds: Array<string >,
  totalAmount?: number | null,
  value: string,
  vatNumber?: string | null,
};

export type ImportRunReceiptCause = {
  __typename: "ImportRunReceiptCause",
  blockedByCheckpoint: ImportRunCheckpointCounts,
  distinctValues: Array<ImportRunReceiptValue >,
  documentCount: number,
  id: string,
  key: ChargeCauseKey,
  valueCount: number,
};

export type ImportRunReceipt = {
  __typename: "ImportRunReceipt",
  causes: Array<ImportRunReceiptCause >,
  channel: ChargeEnvelopeChannel,
  files: number,
  finishedAt?: string | null,
  handled: number,
  importRunId: string,
  needsYou: number,
  reviewEverything: boolean,
  sections: number,
  setAside: number,
  startedAt: string,
};

export type ImportRunReceiptQueryVariables = {
  documentsOfCause?: ChargeCauseKey | null,
  importRunId: string,
};

export type ImportRunReceiptQuery = {
  importRunReceipt?: ImportRunReceipt | null,
};

export type ImportRunSetAsideFilesQueryVariables = {
  importRunId: string,
};

export type ImportRunSetAsideFilesQuery = {
  importRunSetAsideFiles?: Array<ImportRunReceiptSetAsideFile > | null,
};

export enum BankAccountIbanRole {
  ACP_FUND = "ACP_FUND",
  AGENCY = "AGENCY",
  OWNER_REFUND = "OWNER_REFUND",
  SUPPLIER = "SUPPLIER",
  SYNDIC = "SYNDIC",
  THIRD_PARTY_REFUND = "THIRD_PARTY_REFUND",
}

export enum EntityAliasKind {
  ACCOUNT_LABEL = "ACCOUNT_LABEL",
  ACP = "ACP",
  ACP_CODE = "ACP_CODE",
  BUILDING = "BUILDING",
  CADASTRAL_PARCEL = "CADASTRAL_PARCEL",
  CONTACT = "CONTACT",
  LOT = "LOT",
  METER = "METER",
  PAYER_REF = "PAYER_REF",
  SENDER = "SENDER",
  UNIT = "UNIT",
}

export enum EntityAliasSenderKeyType {
  BCE = "BCE",
  BRAND = "BRAND",
  EMAIL_DOMAIN = "EMAIL_DOMAIN",
  VAT = "VAT",
}

export enum RegistrySource {
  DISPUTED = "DISPUTED",
  LEARNED = "LEARNED",
  USER_CONFIRMED = "USER_CONFIRMED",
}

export enum SenderRuleIdentifierKind {
  EAN = "EAN",
  METER = "METER",
}

export enum SenderRuleKind {
  ACCOUNT_MAPPING = "ACCOUNT_MAPPING",
  D4_PRIVATE_ANSWER = "D4_PRIVATE_ANSWER",
  PAYMENT_TERMS_FALLBACK = "PAYMENT_TERMS_FALLBACK",
  RECOVERABILITY_OVERRIDE = "RECOVERABILITY_OVERRIDE",
  REMINDER_FEE_SCHEDULE = "REMINDER_FEE_SCHEDULE",
  ROUNDING = "ROUNDING",
  USUAL_VAT_RATE = "USUAL_VAT_RATE",
  VCS_ENCODES_INVOICE_NUMBER = "VCS_ENCODES_INVOICE_NUMBER",
}

export type SenderRuleScopeDTO = {
  __typename: "SenderRuleScope",
  accountClass?: number | null,
  identifierKind?: SenderRuleIdentifierKind | null,
  identifierValue?: string | null,
  labelKey?: string | null,
  ownerId?: string | null,
};

export type SenderRuleScopeInput = {
  accountClass?: number | null,
  identifierKind?: SenderRuleIdentifierKind | null,
  identifierValue?: string | null,
  labelKey?: string | null,
  ownerId?: string | null,
};

export type SenderRuleValueDTO = {
  __typename: "SenderRuleValue",
  accountLabelId?: string | null,
  encodesInvoiceNumber?: boolean | null,
  paymentOnReceipt?: boolean | null,
  paymentTermDays?: number | null,
  privateExpense?: boolean | null,
  recoverabilityMode?: PostingTenantShareMode | null,
  recoverabilityPercentage?: number | null,
  reminderFees?: Array< number > | null,
  roundingPrecision?: number | null,
  vatRateValues?: Array< number > | null,
};

export type SenderRuleValueInput = {
  accountLabelId?: string | null,
  encodesInvoiceNumber?: boolean | null,
  paymentOnReceipt?: boolean | null,
  paymentTermDays?: number | null,
  privateExpense?: boolean | null,
  recoverabilityMode?: PostingTenantShareMode | null,
  recoverabilityPercentage?: number | null,
  reminderFees?: Array< number > | null,
  roundingPrecision?: number | null,
  vatRateValues?: Array< number > | null,
};

export type AcpSyndicChangeDTO = {
  __typename: "AcpSyndicChange",
  changedAt: string,
  changedBy?: string | null,
  previousSyndicContactId?: string | null,
  previousValidFrom?: string | null,
  syndicContactId?: string | null,
  validFrom?: string | null,
};

export type AcpSyndicChangeInput = {
  changedAt: string,
  changedBy?: string | null,
  previousSyndicContactId?: string | null,
  previousValidFrom?: string | null,
  syndicContactId?: string | null,
  validFrom?: string | null,
};

export type AcpSyndicEraDTO = {
  __typename: "AcpSyndicEra",
  syndicContactId: string,
  validFrom: string,
  validTo?: string | null,
};

export type AcpSyndicEraInput = {
  syndicContactId: string,
  validFrom: string,
  validTo?: string | null,
};

export type SenderRuleDTO = {
  __typename: "SenderRule",
  id: string,
  senderId: string,
  sender?: ContactDTO | null,
  kind: SenderRuleKind,
  scope?: SenderRuleScopeDTO | null,
  value: SenderRuleValueDTO,
  source: RegistrySource,
  confirmations: number,
  updatedBy?: string | null,
  readId: string,
  clientId: string,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type DeleteEntityAliasInput = {
  id: string,
  _version?: number | null,
};

export type CreateSenderRuleInput = {
  id?: string | null,
  senderId: string,
  kind: SenderRuleKind,
  scope?: SenderRuleScopeInput | null,
  value: SenderRuleValueInput,
  source: RegistrySource,
  confirmations: number,
  updatedBy?: string | null,
  readId: string,
  clientId: string,
  _version?: number | null,
};

export type UpdateSenderRuleInput = {
  id: string,
  senderId?: string | null,
  kind?: SenderRuleKind | null,
  scope?: SenderRuleScopeInput | null,
  value?: SenderRuleValueInput | null,
  source?: RegistrySource | null,
  confirmations?: number | null,
  updatedBy?: string | null,
  readId?: string | null,
  clientId?: string | null,
  _version?: number | null,
};

export type DeleteSenderRuleInput = {
  id: string,
  _version?: number | null,
};

export type ChangeSupplierPaymentModeInput = {
  mode?: SupplierPaymentMode | null,
  ownerId?: string | null,
  supplierId: string,
};

export type SetDefaultBankAccountInput = {
  bankAccountId: string,
};

export type RetargetSenderAliasInput = {
  contactId: string,
  id: string,
  keyType: EntityAliasSenderKeyType,
  printedValue: string,
};

export type SaveSenderRuleInput = {
  kind: SenderRuleKind,
  scope?: SenderRuleScopeInput | null,
  senderId: string,
  value: SenderRuleValueInput,
};

export type SenderAliasInput = {
  contactId: string,
  keyType: EntityAliasSenderKeyType,
  printedValue: string,
};
